/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/*! jQuery UI - v1.14.0 - 2024-08-05
* https://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-patch.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright OpenJS Foundation and other contributors; Licensed MIT */

!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)}(function(V){"use strict";V.ui=V.ui||{};V.ui.version="1.14.0";var n,s,k,x,o,a,r,l,h,i,E=0,N=Array.prototype.hasOwnProperty,c=Array.prototype.slice;V.cleanData=(n=V.cleanData,function(t){for(var e,i,s=0;null!=(i=t[s]);s++)(e=V._data(i,"events"))&&e.remove&&V(i).triggerHandler("remove");n(t)}),V.widget=function(t,i,e){var s,n,o,a={},r=t.split(".")[0],l=r+"-"+(t=t.split(".")[1]);return e||(e=i,i=V.Widget),Array.isArray(e)&&(e=V.extend.apply(null,[{}].concat(e))),V.expr.pseudos[l.toLowerCase()]=function(t){return!!V.data(t,l)},V[r]=V[r]||{},s=V[r][t],n=V[r][t]=function(t,e){if(!this||!this._createWidget)return new n(t,e);arguments.length&&this._createWidget(t,e)},V.extend(n,s,{version:e.version,_proto:V.extend({},e),_childConstructors:[]}),(o=new i).options=V.widget.extend({},o.options),V.each(e,function(e,s){function n(){return i.prototype[e].apply(this,arguments)}function o(t){return i.prototype[e].apply(this,t)}a[e]="function"!=typeof s?s:function(){var t,e=this._super,i=this._superApply;return this._super=n,this._superApply=o,t=s.apply(this,arguments),this._super=e,this._superApply=i,t}}),n.prototype=V.widget.extend(o,{widgetEventPrefix:s&&o.widgetEventPrefix||t},a,{constructor:n,namespace:r,widgetName:t,widgetFullName:l}),s?(V.each(s._childConstructors,function(t,e){var i=e.prototype;V.widget(i.namespace+"."+i.widgetName,n,e._proto)}),delete s._childConstructors):i._childConstructors.push(n),V.widget.bridge(t,n),n},V.widget.extend=function(t){for(var e,i,s=c.call(arguments,1),n=0,o=s.length;n<o;n++)for(e in s[n])i=s[n][e],N.call(s[n],e)&&void 0!==i&&(V.isPlainObject(i)?t[e]=V.isPlainObject(t[e])?V.widget.extend({},t[e],i):V.widget.extend({},i):t[e]=i);return t},V.widget.bridge=function(o,e){var a=e.prototype.widgetFullName||o;V.fn[o]=function(i){var t="string"==typeof i,s=c.call(arguments,1),n=this;return t?this.length||"instance"!==i?this.each(function(){var t,e=V.data(this,a);return"instance"===i?(n=e,!1):e?"function"!=typeof e[i]||"_"===i.charAt(0)?V.error("no such method '"+i+"' for "+o+" widget instance"):(t=e[i].apply(e,s))!==e&&void 0!==t?(n=t&&t.jquery?n.pushStack(t.get()):t,!1):void 0:V.error("cannot call methods on "+o+" prior to initialization; attempted to call method '"+i+"'")}):n=void 0:(s.length&&(i=V.widget.extend.apply(null,[i].concat(s))),this.each(function(){var t=V.data(this,a);t?(t.option(i||{}),t._init&&t._init()):V.data(this,a,new e(i,this))})),n}},V.Widget=function(){},V.Widget._childConstructors=[],V.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(t,e){e=V(e||this.defaultElement||this)[0],this.element=V(e),this.uuid=E++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=V(),this.hoverable=V(),this.focusable=V(),this.classesElementLookup={},e!==this&&(V.data(e,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===e&&this.destroy()}}),this.document=V(e.style?e.ownerDocument:e.document||e),this.window=V(this.document[0].defaultView||this.document[0].parentWindow)),this.options=V.widget.extend({},this.options,this._getCreateOptions(),t),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:V.noop,_create:V.noop,_init:V.noop,destroy:function(){var i=this;this._destroy(),V.each(this.classesElementLookup,function(t,e){i._removeClass(e,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:V.noop,widget:function(){return this.element},option:function(t,e){var i,s,n,o=t;if(0===arguments.length)return V.widget.extend({},this.options);if("string"==typeof t)if(o={},t=(i=t.split(".")).shift(),i.length){for(s=o[t]=V.widget.extend({},this.options[t]),n=0;n<i.length-1;n++)s[i[n]]=s[i[n]]||{},s=s[i[n]];if(t=i.pop(),1===arguments.length)return void 0===s[t]?null:s[t];s[t]=e}else{if(1===arguments.length)return void 0===this.options[t]?null:this.options[t];o[t]=e}return this._setOptions(o),this},_setOptions:function(t){for(var e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(t){var e,i,s;for(e in t)s=this.classesElementLookup[e],t[e]!==this.options.classes[e]&&s&&s.length&&(i=V(s.get()),this._removeClass(s,e),i.addClass(this._classes({element:i,keys:e,classes:t,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(n){var o=[],a=this;function t(t,e){for(var i,s=0;s<t.length;s++)i=a.classesElementLookup[t[s]]||V(),i=n.add?(function(){var i=[];n.element.each(function(t,e){V.map(a.classesElementLookup,function(t){return t}).some(function(t){return t.is(e)})||i.push(e)}),a._on(V(i),{remove:"_untrackClassesElement"})}(),V(V.uniqueSort(i.get().concat(n.element.get())))):V(i.not(n.element).get()),a.classesElementLookup[t[s]]=i,o.push(t[s]),e&&n.classes[t[s]]&&o.push(n.classes[t[s]])}return(n=V.extend({element:this.element,classes:this.options.classes||{}},n)).keys&&t(n.keys.match(/\S+/g)||[],!0),n.extra&&t(n.extra.match(/\S+/g)||[]),o.join(" ")},_untrackClassesElement:function(i){var s=this;V.each(s.classesElementLookup,function(t,e){-1!==V.inArray(i.target,e)&&(s.classesElementLookup[t]=V(e.not(i.target).get()))}),this._off(V(i.target))},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){var n="string"==typeof t||null===t,e={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s="boolean"==typeof s?s:i};return e.element.toggleClass(this._classes(e),s),this},_on:function(n,o,t){var a,r=this;"boolean"!=typeof n&&(t=o,o=n,n=!1),t?(o=a=V(o),this.bindings=this.bindings.add(o)):(t=o,o=this.element,a=this.widget()),V.each(t,function(t,e){function i(){if(n||!0!==r.options.disabled&&!V(this).hasClass("ui-state-disabled"))return("string"==typeof e?r[e]:e).apply(r,arguments)}"string"!=typeof e&&(i.guid=e.guid=e.guid||i.guid||V.guid++);var t=t.match(/^([\w:-]*)\s*(.*)$/),s=t[1]+r.eventNamespace,t=t[2];t?a.on(s,t,i):o.on(s,i)})},_off:function(t,e){e=(e||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,t.off(e),this.bindings=V(this.bindings.not(t).get()),this.focusable=V(this.focusable.not(t).get()),this.hoverable=V(this.hoverable.not(t).get())},_delay:function(t,e){var i=this;return setTimeout(function(){return("string"==typeof t?i[t]:t).apply(i,arguments)},e||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){this._addClass(V(t.currentTarget),null,"ui-state-hover")},mouseleave:function(t){this._removeClass(V(t.currentTarget),null,"ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){this._addClass(V(t.currentTarget),null,"ui-state-focus")},focusout:function(t){this._removeClass(V(t.currentTarget),null,"ui-state-focus")}})},_trigger:function(t,e,i){var s,n,o=this.options[t];if(i=i||{},(e=V.Event(e)).type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),e.target=this.element[0],n=e.originalEvent)for(s in n)s in e||(e[s]=n[s]);return this.element.trigger(e,i),!("function"==typeof o&&!1===o.apply(this.element[0],[e].concat(i))||e.isDefaultPrevented())}},V.each({show:"fadeIn",hide:"fadeOut"},function(o,a){V.Widget.prototype["_"+o]=function(e,t,i){var s,n=(t="string"==typeof t?{effect:t}:t)?!0!==t&&"number"!=typeof t&&t.effect||a:o;"number"==typeof(t=t||{})?t={duration:t}:!0===t&&(t={}),s=!V.isEmptyObject(t),t.complete=i,t.delay&&e.delay(t.delay),s&&V.effects&&V.effects.effect[n]?e[o](t):n!==o&&e[n]?e[n](t.duration,t.easing,i):e.queue(function(t){V(this)[o](),i&&i.call(e[0]),t()})}}),V.widget;function C(t,e,i){return[parseFloat(t[0])*(h.test(t[0])?e/100:1),parseFloat(t[1])*(h.test(t[1])?i/100:1)]}function D(t,e){return parseInt(V.css(t,e),10)||0}function I(t){return null!=t&&t===t.window}k=Math.max,x=Math.abs,o=/left|center|right/,a=/top|center|bottom/,r=/[\+\-]\d+(\.[\d]+)?%?/,l=/^\w+/,h=/%$/,i=V.fn.position,V.position={scrollbarWidth:function(){var t,e,i;return void 0!==s?s:(i=(e=V("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>")).children()[0],V("body").append(e),t=i.offsetWidth,e.css("overflow","scroll"),t===(i=i.offsetWidth)&&(i=e[0].clientWidth),e.remove(),s=t-i)},getScrollInfo:function(t){var e=t.isWindow||t.isDocument?"":t.element.css("overflow-x"),i=t.isWindow||t.isDocument?"":t.element.css("overflow-y"),e="scroll"===e||"auto"===e&&t.width<t.element[0].scrollWidth;return{width:"scroll"===i||"auto"===i&&t.height<t.element[0].scrollHeight?V.position.scrollbarWidth():0,height:e?V.position.scrollbarWidth():0}},getWithinInfo:function(t){var e=V(t||window),i=I(e[0]),s=!!e[0]&&9===e[0].nodeType;return{element:e,isWindow:i,isDocument:s,offset:!i&&!s?V(t).offset():{left:0,top:0},scrollLeft:e.scrollLeft(),scrollTop:e.scrollTop(),width:e.outerWidth(),height:e.outerHeight()}}},V.fn.position=function(u){var d,p,f,g,m,_,v,b,y,w,t,e;return u&&u.of?(_="string"==typeof(u=V.extend({},u)).of?V(document).find(u.of):V(u.of),v=V.position.getWithinInfo(u.within),b=V.position.getScrollInfo(v),y=(u.collision||"flip").split(" "),w={},e=9===(e=(t=_)[0]).nodeType?{width:t.width(),height:t.height(),offset:{top:0,left:0}}:I(e)?{width:t.width(),height:t.height(),offset:{top:t.scrollTop(),left:t.scrollLeft()}}:e.preventDefault?{width:0,height:0,offset:{top:e.pageY,left:e.pageX}}:{width:t.outerWidth(),height:t.outerHeight(),offset:t.offset()},_[0].preventDefault&&(u.at="left top"),p=e.width,f=e.height,m=V.extend({},g=e.offset),V.each(["my","at"],function(){var t,e,i=(u[this]||"").split(" ");(i=1===i.length?o.test(i[0])?i.concat(["center"]):a.test(i[0])?["center"].concat(i):["center","center"]:i)[0]=o.test(i[0])?i[0]:"center",i[1]=a.test(i[1])?i[1]:"center",t=r.exec(i[0]),e=r.exec(i[1]),w[this]=[t?t[0]:0,e?e[0]:0],u[this]=[l.exec(i[0])[0],l.exec(i[1])[0]]}),1===y.length&&(y[1]=y[0]),"right"===u.at[0]?m.left+=p:"center"===u.at[0]&&(m.left+=p/2),"bottom"===u.at[1]?m.top+=f:"center"===u.at[1]&&(m.top+=f/2),d=C(w.at,p,f),m.left+=d[0],m.top+=d[1],this.each(function(){var i,t,a=V(this),r=a.outerWidth(),l=a.outerHeight(),e=D(this,"marginLeft"),s=D(this,"marginTop"),n=r+e+D(this,"marginRight")+b.width,o=l+s+D(this,"marginBottom")+b.height,h=V.extend({},m),c=C(w.my,a.outerWidth(),a.outerHeight());"right"===u.my[0]?h.left-=r:"center"===u.my[0]&&(h.left-=r/2),"bottom"===u.my[1]?h.top-=l:"center"===u.my[1]&&(h.top-=l/2),h.left+=c[0],h.top+=c[1],i={marginLeft:e,marginTop:s},V.each(["left","top"],function(t,e){V.ui.position[y[t]]&&V.ui.position[y[t]][e](h,{targetWidth:p,targetHeight:f,elemWidth:r,elemHeight:l,collisionPosition:i,collisionWidth:n,collisionHeight:o,offset:[d[0]+c[0],d[1]+c[1]],my:u.my,at:u.at,within:v,elem:a})}),u.using&&(t=function(t){var e=g.left-h.left,i=e+p-r,s=g.top-h.top,n=s+f-l,o={target:{element:_,left:g.left,top:g.top,width:p,height:f},element:{element:a,left:h.left,top:h.top,width:r,height:l},horizontal:i<0?"left":0<e?"right":"center",vertical:n<0?"top":0<s?"bottom":"middle"};p<r&&x(e+i)<p&&(o.horizontal="center"),f<l&&x(s+n)<f&&(o.vertical="middle"),k(x(e),x(i))>k(x(s),x(n))?o.important="horizontal":o.important="vertical",u.using.call(this,t,o)}),a.offset(V.extend(h,{using:t}))})):i.apply(this,arguments)},V.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,s=s.width,o=t.left-e.collisionPosition.marginLeft,a=n-o,r=o+e.collisionWidth-s-n;e.collisionWidth>s?0<a&&r<=0?(i=t.left+a+e.collisionWidth-s-n,t.left+=a-i):t.left=!(0<r&&a<=0)&&r<a?n+s-e.collisionWidth:n:0<a?t.left+=a:0<r?t.left-=r:t.left=k(t.left-o,t.left)},top:function(t,e){var i,s=e.within,s=s.isWindow?s.scrollTop:s.offset.top,n=e.within.height,o=t.top-e.collisionPosition.marginTop,a=s-o,r=o+e.collisionHeight-n-s;e.collisionHeight>n?0<a&&r<=0?(i=t.top+a+e.collisionHeight-n-s,t.top+=a-i):t.top=!(0<r&&a<=0)&&r<a?s+n-e.collisionHeight:s:0<a?t.top+=a:0<r?t.top-=r:t.top=k(t.top-o,t.top)}},flip:{left:function(t,e){var i=e.within,s=i.offset.left+i.scrollLeft,n=i.width,i=i.isWindow?i.scrollLeft:i.offset.left,o=t.left-e.collisionPosition.marginLeft,a=o-i,o=o+e.collisionWidth-n-i,r="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,l="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,h=-2*e.offset[0];a<0?((n=t.left+r+l+h+e.collisionWidth-n-s)<0||n<x(a))&&(t.left+=r+l+h):0<o&&(0<(s=t.left-e.collisionPosition.marginLeft+r+l+h-i)||x(s)<o)&&(t.left+=r+l+h)},top:function(t,e){var i=e.within,s=i.offset.top+i.scrollTop,n=i.height,i=i.isWindow?i.scrollTop:i.offset.top,o=t.top-e.collisionPosition.marginTop,a=o-i,o=o+e.collisionHeight-n-i,r="top"===e.my[1]?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,l="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,h=-2*e.offset[1];a<0?((n=t.top+r+l+h+e.collisionHeight-n-s)<0||n<x(a))&&(t.top+=r+l+h):0<o&&(0<(s=t.top-e.collisionPosition.marginTop+r+l+h-i)||x(s)<o)&&(t.top+=r+l+h)}},flipfit:{left:function(){V.ui.position.flip.left.apply(this,arguments),V.ui.position.fit.left.apply(this,arguments)},top:function(){V.ui.position.flip.top.apply(this,arguments),V.ui.position.fit.top.apply(this,arguments)}}};V.ui.position,V.extend(V.expr.pseudos,{data:V.expr.createPseudo(function(e){return function(t){return!!V.data(t,e)}})}),V.fn.extend({disableSelection:(t="onselectstart"in document.createElement("div")?"selectstart":"mousedown",function(){return this.on(t+".ui-disableSelection",function(t){t.preventDefault()})}),enableSelection:function(){return this.off(".ui-disableSelection")}});var t,u=V,d={},W=d.toString,F=/^([\-+])=\s*(\d+\.?\d*)/,L=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16),t[4]?(parseInt(t[4],16)/255).toFixed(2):1]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16),t[4]?(parseInt(t[4]+t[4],16)/255).toFixed(2):1]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],p=u.Color=function(t,e,i,s){return new u.Color.fn.parse(t,e,i,s)},f={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},R={byte:{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},g=u.each;function m(t){return null==t?t+"":"object"==typeof t?d[W.call(t)]||"object":typeof t}function _(t,e,i){var s=R[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),s.mod?(t+s.mod)%s.mod:Math.min(s.max,Math.max(0,t)))}function Y(s){var n=p(),o=n._rgba=[];return s=s.toLowerCase(),g(L,function(t,e){var i=e.re.exec(s),i=i&&e.parse(i),e=e.space||"rgba";if(i)return i=n[e](i),n[f[e].cache]=i[f[e].cache],o=n._rgba=i._rgba,!1}),o.length?("0,0,0,0"===o.join()&&u.extend(o,y.transparent),n):y[s]}function v(t,e,i){return 6*(i=(i+1)%1)<1?t+(e-t)*i*6:2*i<1?e:3*i<2?t+(e-t)*(2/3-i)*6:t}g(f,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),u.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(t,e){d["[object "+e+"]"]=e.toLowerCase()}),(p.fn=u.extend(p.prototype,{parse:function(n,t,e,i){if(void 0===n)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=u(n).css(t),t=void 0);var o=this,s=m(n),a=this._rgba=[];return void 0!==t&&(n=[n,t,e,i],s="array"),"string"===s?this.parse(Y(n)||y._default):"array"===s?(g(f.rgba.props,function(t,e){a[e.idx]=_(n[e.idx],e)}),this):"object"===s?(n instanceof p?g(f,function(t,e){n[e.cache]&&(o[e.cache]=n[e.cache].slice())}):g(f,function(t,i){var s=i.cache;g(i.props,function(t,e){if(!o[s]&&i.to){if("alpha"===t||null==n[t])return;o[s]=i.to(o._rgba)}o[s][e.idx]=_(n[t],e,!0)}),o[s]&&u.inArray(null,o[s].slice(0,3))<0&&(null==o[s][3]&&(o[s][3]=1),i.from)&&(o._rgba=i.from(o[s]))}),this):void 0},is:function(t){var n=p(t),o=!0,a=this;return g(f,function(t,e){var i,s=n[e.cache];return s&&(i=a[e.cache]||e.to&&e.to(a._rgba)||[],g(e.props,function(t,e){if(null!=s[e.idx])return o=s[e.idx]===i[e.idx]})),o}),o},_space:function(){var i=[],s=this;return g(f,function(t,e){s[e.cache]&&i.push(t)}),i.pop()},transition:function(t,a){var t=(h=p(t))._space(),e=f[t],i=0===this.alpha()?p("transparent"):this,r=i[e.cache]||e.to(i._rgba),l=r.slice(),h=h[e.cache];return g(e.props,function(t,e){var i=e.idx,s=r[i],n=h[i],o=R[e.type]||{};null!==n&&(null===s?l[i]=n:(o.mod&&(n-s>o.mod/2?s+=o.mod:s-n>o.mod/2&&(s-=o.mod)),l[i]=_((n-s)*a+s,e)))}),this[t](l)},blend:function(t){var e,i,s;return 1===this._rgba[3]?this:(e=this._rgba.slice(),i=e.pop(),s=p(t)._rgba,p(u.map(e,function(t,e){return(1-i)*s[e]+i*t})))},toRgbaString:function(){var t="rgba(",e=u.map(this._rgba,function(t,e){return null!=t?t:2<e?1:0});return 1===e[3]&&(e.pop(),t="rgb("),t+e.join(", ")+")"},toHslaString:function(){var t="hsla(",e=u.map(this.hsla(),function(t,e){return null==t&&(t=2<e?1:0),t=e&&e<3?Math.round(100*t)+"%":t});return 1===e[3]&&(e.pop(),t="hsl("),t+e.join(", ")+")"},toHexString:function(t){var e=this._rgba.slice(),i=e.pop();return t&&e.push(~~(255*i)),"#"+u.map(e,function(t){return("0"+(t||0).toString(16)).substr(-2)}).join("")},toString:function(){return this.toRgbaString()}})).parse.prototype=p.fn,f.hsla.to=function(t){var e,i,s,n,o,a,r,l;return null==t[0]||null==t[1]||null==t[2]?[null,null,null,t[3]]:(e=t[0]/255,i=t[1]/255,s=t[2]/255,t=t[3],n=(l=Math.max(e,i,s))-(r=Math.min(e,i,s)),a=.5*(o=l+r),r=r===l?0:e===l?60*(i-s)/n+360:i===l?60*(s-e)/n+120:60*(e-i)/n+240,l=0==n?0:a<=.5?n/o:n/(2-o),[Math.round(r)%360,l,a,null==t?1:t])},f.hsla.from=function(t){var e,i,s;return null==t[0]||null==t[1]||null==t[2]?[null,null,null,t[3]]:(e=t[0]/360,s=t[1],i=t[2],t=t[3],s=2*i-(i=i<=.5?i*(1+s):i+s-i*s),[Math.round(255*v(s,i,e+1/3)),Math.round(255*v(s,i,e)),Math.round(255*v(s,i,e-1/3)),t])},g(f,function(r,t){var e=t.props,o=t.cache,a=t.to,l=t.from;p.fn[r]=function(t){var i,s,n;return a&&!this[o]&&(this[o]=a(this._rgba)),void 0===t?this[o].slice():(i=m(t),s="array"===i||"object"===i?t:arguments,n=this[o].slice(),g(e,function(t,e){t=s["object"===i?t:e.idx];null==t&&(t=n[e.idx]),n[e.idx]=_(t,e)}),l?((t=p(l(n)))[o]=n,t):p(n))},g(e,function(o,a){p.fn[o]||(p.fn[o]=function(t){var e=m(t),i="alpha"===o?this._hsla?"hsla":"rgba":r,s=this[i](),n=s[a.idx];return"undefined"===e?n:("function"===e&&(e=m(t=t.call(this,n))),null==t&&a.empty?this:("string"===e&&(e=F.exec(t))&&(t=n+parseFloat(e[2])*("+"===e[1]?1:-1)),s[a.idx]=t,this[i](s)))})})}),(p.hook=function(t){t=t.split(" ");g(t,function(t,s){u.cssHooks[s]={set:function(t,e){var i;"transparent"===e||"string"===m(e)&&!(i=Y(e))||(e=(e=p(i||e)).toRgbaString()),t.style[s]=e}},u.fx.step[s]=function(t){t.colorInit||(t.start=p(t.elem,s),t.end=p(t.end),t.colorInit=!0),u.cssHooks[s].set(t.elem,t.start.transition(t.end,t.pos))}})})("backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor"),u.cssHooks.borderColor={expand:function(i){var s={};return g(["Top","Right","Bottom","Left"],function(t,e){s["border"+e+"Color"]=i}),s}};var B,j,q,K,U,X,$,G,Q,b,y=u.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"},w="ui-effects-",e="ui-effects-style",T="ui-effects-animated";function J(t){for(var e,i=t.ownerDocument.defaultView.getComputedStyle(t),s={},n=i.length;n--;)"string"==typeof i[e=i[n]]&&(s[e.replace(/-([\da-z])/gi,function(t,e){return e.toUpperCase()})]=i[e]);return s}function P(t,e,i,s){return t={effect:t=V.isPlainObject(t)?(e=t).effect:t},"function"==typeof(e=null==e?{}:e)&&(s=e,i=null,e={}),"number"!=typeof e&&!V.fx.speeds[e]||(s=i,i=e,e={}),"function"==typeof i&&(s=i,i=null),e&&V.extend(t,e),i=i||e.duration,t.duration=V.fx.off?0:"number"==typeof i?i:i in V.fx.speeds?V.fx.speeds[i]:V.fx.speeds._default,t.complete=s||e.complete,t}function M(t){return!t||"number"==typeof t||V.fx.speeds[t]||"string"==typeof t&&!V.effects.effect[t]||"function"==typeof t||"object"==typeof t&&!t.effect}function Z(t,e){var i=e.outerWidth(),e=e.outerHeight(),t=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/.exec(t)||["",0,i,e,0];return{top:parseFloat(t[1])||0,right:"auto"===t[2]?i:parseFloat(t[2]),bottom:"auto"===t[3]?e:parseFloat(t[3]),left:parseFloat(t[4])||0}}V.effects={effect:{}},K=["add","remove","toggle"],U={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1},V.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(t,e){V.fx.step[e]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(u.style(t.elem,e,t.end),t.setAttr=!0)}}),V.effects.animateClass=function(n,t,e,i){var o=V.speed(t,e,i);return this.queue(function(){var i=V(this),t=i.attr("class")||"",e=(e=o.children?i.find("*").addBack():i).map(function(){return{el:V(this),start:J(this)}}),s=function(){V.each(K,function(t,e){n[e]&&i[e+"Class"](n[e])})};s(),e=e.map(function(){return this.end=J(this.el[0]),this.diff=function(t,e){var i,s,n={};for(i in e)s=e[i],t[i]===s||U[i]||!V.fx.step[i]&&isNaN(parseFloat(s))||(n[i]=s);return n}(this.start,this.end),this}),i.attr("class",t),e=e.map(function(){var t=this,e=V.Deferred(),i=V.extend({},o,{queue:!1,complete:function(){e.resolve(t)}});return this.el.animate(this.diff,i),e.promise()}),V.when.apply(V,e.get()).done(function(){s(),V.each(arguments,function(){var e=this.el;V.each(this.diff,function(t){e.css(t,"")})}),o.complete.call(i[0])})})},V.fn.extend({addClass:(q=V.fn.addClass,function(t,e,i,s){return e?V.effects.animateClass.call(this,{add:t},e,i,s):q.apply(this,arguments)}),removeClass:(j=V.fn.removeClass,function(t,e,i,s){return 1<arguments.length?V.effects.animateClass.call(this,{remove:t},e,i,s):j.apply(this,arguments)}),toggleClass:(B=V.fn.toggleClass,function(t,e,i,s,n){return"boolean"==typeof e||void 0===e?i?V.effects.animateClass.call(this,e?{add:t}:{remove:t},i,s,n):B.apply(this,arguments):V.effects.animateClass.call(this,{toggle:t},e,i,s)}),switchClass:function(t,e,i,s,n){return V.effects.animateClass.call(this,{add:e,remove:t},i,s,n)}}),V.expr&&V.expr.pseudos&&V.expr.pseudos.animated&&(V.expr.pseudos.animated=(X=V.expr.pseudos.animated,function(t){return!!V(t).data(T)||X(t)})),!0===V.uiBackCompat&&V.extend(V.effects,{save:function(t,e){for(var i=0,s=e.length;i<s;i++)null!==e[i]&&t.data(w+e[i],t[0].style[e[i]])},restore:function(t,e){for(var i,s=0,n=e.length;s<n;s++)null!==e[s]&&(i=t.data(w+e[s]),t.css(e[s],i))},setMode:function(t,e){return e="toggle"===e?t.is(":hidden")?"show":"hide":e},createWrapper:function(i){if(i.parent().is(".ui-effects-wrapper"))return i.parent();var s={width:i.outerWidth(!0),height:i.outerHeight(!0),float:i.css("float")},t=V("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),e={width:i.width(),height:i.height()},n=document.activeElement;try{n.id}catch(t){n=document.body}return i.wrap(t),i[0]!==n&&!V.contains(i[0],n)||V(n).trigger("focus"),t=i.parent(),"static"===i.css("position")?(t.css({position:"relative"}),i.css({position:"relative"})):(V.extend(s,{position:i.css("position"),zIndex:i.css("z-index")}),V.each(["top","left","bottom","right"],function(t,e){s[e]=i.css(e),isNaN(parseInt(s[e],10))&&(s[e]="auto")}),i.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),i.css(e),t.css(s).show()},removeWrapper:function(t){var e=document.activeElement;return t.parent().is(".ui-effects-wrapper")&&(t.parent().replaceWith(t),t[0]!==e&&!V.contains(t[0],e)||V(e).trigger("focus")),t}}),V.extend(V.effects,{version:"1.14.0",define:function(t,e,i){return i||(i=e,e="effect"),V.effects.effect[t]=i,V.effects.effect[t].mode=e,i},scaledDimensions:function(t,e,i){var s;return 0===e?{height:0,width:0,outerHeight:0,outerWidth:0}:(s="horizontal"!==i?(e||100)/100:1,i="vertical"!==i?(e||100)/100:1,{height:t.height()*i,width:t.width()*s,outerHeight:t.outerHeight()*i,outerWidth:t.outerWidth()*s})},clipToBox:function(t){return{width:t.clip.right-t.clip.left,height:t.clip.bottom-t.clip.top,left:t.clip.left,top:t.clip.top}},unshift:function(t,e,i){var s=t.queue();1<e&&s.splice.apply(s,[1,0].concat(s.splice(e,i))),t.dequeue()},saveStyle:function(t){t.data(e,t[0].style.cssText)},restoreStyle:function(t){t[0].style.cssText=t.data(e)||"",t.removeData(e)},mode:function(t,e){t=t.is(":hidden");return"toggle"===e&&(e=t?"show":"hide"),e=(t?"hide"===e:"show"===e)?"none":e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createPlaceholder:function(t){var e,i=t.css("position"),s=t.position();return t.css({marginTop:t.css("marginTop"),marginBottom:t.css("marginBottom"),marginLeft:t.css("marginLeft"),marginRight:t.css("marginRight")}).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()),/^(static|relative)/.test(i)&&(i="absolute",e=V("<"+t[0].nodeName+">").insertAfter(t).css({display:/^(inline|ruby)/.test(t.css("display"))?"inline-block":"block",visibility:"hidden",marginTop:t.css("marginTop"),marginBottom:t.css("marginBottom"),marginLeft:t.css("marginLeft"),marginRight:t.css("marginRight"),float:t.css("float")}).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).addClass("ui-effects-placeholder"),t.data(w+"placeholder",e)),t.css({position:i,left:s.left,top:s.top}),e},removePlaceholder:function(t){var e=w+"placeholder",i=t.data(e);i&&(i.remove(),t.removeData(e))},cleanUp:function(t){V.effects.restoreStyle(t),V.effects.removePlaceholder(t)},setTransition:function(s,t,n,o){return o=o||{},V.each(t,function(t,e){var i=s.cssUnit(e);0<i[0]&&(o[e]=i[0]*n+i[1])}),o}}),V.fn.extend({effect:function(){function t(t){var e=V(this),i=V.effects.mode(e,r)||o;e.data(T,!0),l.push(i),o&&("show"===i||i===o&&"hide"===i)&&e.show(),o&&"none"===i||V.effects.saveStyle(e),"function"==typeof t&&t()}var s=P.apply(this,arguments),n=V.effects.effect[s.effect],o=n.mode,e=s.queue,i=e||"fx",a=s.complete,r=s.mode,l=[];return V.fx.off||!n?r?this[r](s.duration,a):this.each(function(){a&&a.call(this)}):!1===e?this.each(t).each(h):this.queue(i,t).queue(i,h);function h(t){var e=V(this);function i(){"function"==typeof a&&a.call(e[0]),"function"==typeof t&&t()}s.mode=l.shift(),!0!==V.uiBackCompat||o?"none"===s.mode?(e[r](),i()):n.call(e[0],s,function(){e.removeData(T),V.effects.cleanUp(e),"hide"===s.mode&&e.hide(),i()}):(e.is(":hidden")?"hide"===r:"show"===r)?(e[r](),i()):n.call(e[0],s,i)}},show:(Q=V.fn.show,function(t){return M(t)?Q.apply(this,arguments):((t=P.apply(this,arguments)).mode="show",this.effect.call(this,t))}),hide:(G=V.fn.hide,function(t){return M(t)?G.apply(this,arguments):((t=P.apply(this,arguments)).mode="hide",this.effect.call(this,t))}),toggle:($=V.fn.toggle,function(t){return M(t)||"boolean"==typeof t?$.apply(this,arguments):((t=P.apply(this,arguments)).mode="toggle",this.effect.call(this,t))}),cssUnit:function(t){var i=this.css(t),s=[];return V.each(["em","px","%","pt"],function(t,e){0<i.indexOf(e)&&(s=[parseFloat(i),e])}),s},cssClip:function(t){return t?this.css("clip","rect("+t.top+"px "+t.right+"px "+t.bottom+"px "+t.left+"px)"):Z(this.css("clip"),this)},transfer:function(t,e){var i=V(this),s=V(t.to),n="fixed"===s.css("position"),o=V("body"),a=n?o.scrollTop():0,o=n?o.scrollLeft():0,r=s.offset(),r={top:r.top-a,left:r.left-o,height:s.innerHeight(),width:s.innerWidth()},s=i.offset(),l=V("<div class='ui-effects-transfer'></div>");l.appendTo("body").addClass(t.className).css({top:s.top-a,left:s.left-o,height:i.innerHeight(),width:i.innerWidth(),position:n?"fixed":"absolute"}).animate(r,t.duration,t.easing,function(){l.remove(),"function"==typeof e&&e()})}}),V.fx.step.clip=function(t){t.clipInit||(t.start=V(t.elem).cssClip(),"string"==typeof t.end&&(t.end=Z(t.end,t.elem)),t.clipInit=!0),V(t.elem).cssClip({top:t.pos*(t.end.top-t.start.top)+t.start.top,right:t.pos*(t.end.right-t.start.right)+t.start.right,bottom:t.pos*(t.end.bottom-t.start.bottom)+t.start.bottom,left:t.pos*(t.end.left-t.start.left)+t.start.left})},b={},V.each(["Quad","Cubic","Quart","Quint","Expo"],function(e,t){b[t]=function(t){return Math.pow(t,e+2)}}),V.extend(b,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;t<((e=Math.pow(2,--i))-1)/11;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),V.each(b,function(t,e){V.easing["easeIn"+t]=e,V.easing["easeOut"+t]=function(t){return 1-e(1-t)},V.easing["easeInOut"+t]=function(t){return t<.5?e(2*t)/2:1-e(-2*t+2)/2}});var tt,et,S,it=V.effects,st=(V.effects.define("blind","hide",function(t,e){var i={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},s=V(this),n=t.direction||"up",o=s.cssClip(),a={clip:V.extend({},o)},r=V.effects.createPlaceholder(s);a.clip[i[n][0]]=a.clip[i[n][1]],"show"===t.mode&&(s.cssClip(a.clip),r&&r.css(V.effects.clipToBox(a)),a.clip=o),r&&r.animate(V.effects.clipToBox(a),t.duration,t.easing),s.animate(a,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("bounce",function(t,e){var i,s,n=V(this),o=t.mode,a="hide"===o,o="show"===o,r=t.direction||"up",l=t.distance,h=t.times||5,c=2*h+(o||a?1:0),u=t.duration/c,d=t.easing,p="up"===r||"down"===r?"top":"left",f="up"===r||"left"===r,g=0,t=n.queue().length;for(V.effects.createPlaceholder(n),r=n.css(p),l=l||n["top"==p?"outerHeight":"outerWidth"]()/3,o&&((s={opacity:1})[p]=r,n.css("opacity",0).css(p,f?2*-l:2*l).animate(s,u,d)),a&&(l/=Math.pow(2,h-1)),(s={})[p]=r;g<h;g++)(i={})[p]=(f?"-=":"+=")+l,n.animate(i,u,d).animate(s,u,d),l=a?2*l:l/2;a&&((i={opacity:0})[p]=(f?"-=":"+=")+l,n.animate(i,u,d)),n.queue(e),V.effects.unshift(n,t,1+c)}),V.effects.define("clip","hide",function(t,e){var i={},s=V(this),n=t.direction||"vertical",o="both"===n,a=o||"horizontal"===n,o=o||"vertical"===n,n=s.cssClip();i.clip={top:o?(n.bottom-n.top)/2:n.top,right:a?(n.right-n.left)/2:n.right,bottom:o?(n.bottom-n.top)/2:n.bottom,left:a?(n.right-n.left)/2:n.left},V.effects.createPlaceholder(s),"show"===t.mode&&(s.cssClip(i.clip),i.clip=n),s.animate(i,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("drop","hide",function(t,e){var i,s=V(this),n="show"===t.mode,o=t.direction||"left",a="up"===o||"down"===o?"top":"left",o="up"===o||"left"===o?"-=":"+=",r="+="==o?"-=":"+=",l={opacity:0};V.effects.createPlaceholder(s),i=t.distance||s["top"==a?"outerHeight":"outerWidth"](!0)/2,l[a]=o+i,n&&(s.css(l),l[a]=r+i,l.opacity=1),s.animate(l,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("explode","hide",function(t,e){var i,s,n,o,a,r,l=t.pieces?Math.round(Math.sqrt(t.pieces)):3,h=l,c=V(this),u="show"===t.mode,d=c.show().css("visibility","hidden").offset(),p=Math.ceil(c.outerWidth()/h),f=Math.ceil(c.outerHeight()/l),g=[];function m(){g.push(this),g.length===l*h&&(c.css({visibility:"visible"}),V(g).remove(),e())}for(i=0;i<l;i++)for(o=d.top+i*f,r=i-(l-1)/2,s=0;s<h;s++)n=d.left+s*p,a=s-(h-1)/2,c.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-s*p,top:-i*f}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:p,height:f,left:n+(u?a*p:0),top:o+(u?r*f:0),opacity:u?0:1}).animate({left:n+(u?0:a*p),top:o+(u?0:r*f),opacity:u?1:0},t.duration||500,t.easing,m)}),V.effects.define("fade","toggle",function(t,e){var i="show"===t.mode;V(this).css("opacity",i?0:1).animate({opacity:i?1:0},{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("fold","hide",function(e,t){var i=V(this),s=e.mode,n="show"===s,s="hide"===s,o=e.size||15,a=/([0-9]+)%/.exec(o),r=!!e.horizFirst?["right","bottom"]:["bottom","right"],l=e.duration/2,h=V.effects.createPlaceholder(i),c=i.cssClip(),u={clip:V.extend({},c)},d={clip:V.extend({},c)},p=[c[r[0]],c[r[1]]],f=i.queue().length;a&&(o=parseInt(a[1],10)/100*p[s?0:1]),u.clip[r[0]]=o,d.clip[r[0]]=o,d.clip[r[1]]=0,n&&(i.cssClip(d.clip),h&&h.css(V.effects.clipToBox(d)),d.clip=c),i.queue(function(t){h&&h.animate(V.effects.clipToBox(u),l,e.easing).animate(V.effects.clipToBox(d),l,e.easing),t()}).animate(u,l,e.easing).animate(d,l,e.easing).queue(t),V.effects.unshift(i,f,4)}),V.effects.define("highlight","show",function(t,e){var i=V(this),s={backgroundColor:i.css("backgroundColor")};"hide"===t.mode&&(s.opacity=0),V.effects.saveStyle(i),i.css({backgroundImage:"none",backgroundColor:t.color||"#ffff99"}).animate(s,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("size",function(s,e){var n,i=V(this),t=["fontSize"],o=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],a=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],r=s.mode,l="effect"!==r,h=s.scale||"both",c=s.origin||["middle","center"],u=i.css("position"),d=i.position(),p=V.effects.scaledDimensions(i),f=s.from||p,g=s.to||V.effects.scaledDimensions(i,0);V.effects.createPlaceholder(i),"show"===r&&(r=f,f=g,g=r),n={from:{y:f.height/p.height,x:f.width/p.width},to:{y:g.height/p.height,x:g.width/p.width}},"box"!==h&&"both"!==h||(n.from.y!==n.to.y&&(f=V.effects.setTransition(i,o,n.from.y,f),g=V.effects.setTransition(i,o,n.to.y,g)),n.from.x!==n.to.x&&(f=V.effects.setTransition(i,a,n.from.x,f),g=V.effects.setTransition(i,a,n.to.x,g))),"content"!==h&&"both"!==h||n.from.y!==n.to.y&&(f=V.effects.setTransition(i,t,n.from.y,f),g=V.effects.setTransition(i,t,n.to.y,g)),c&&(r=V.effects.getBaseline(c,p),f.top=(p.outerHeight-f.outerHeight)*r.y+d.top,f.left=(p.outerWidth-f.outerWidth)*r.x+d.left,g.top=(p.outerHeight-g.outerHeight)*r.y+d.top,g.left=(p.outerWidth-g.outerWidth)*r.x+d.left),delete f.outerHeight,delete f.outerWidth,i.css(f),"content"!==h&&"both"!==h||(o=o.concat(["marginTop","marginBottom"]).concat(t),a=a.concat(["marginLeft","marginRight"]),i.find("*[width]").each(function(){var t=V(this),e=V.effects.scaledDimensions(t),i={height:e.height*n.from.y,width:e.width*n.from.x,outerHeight:e.outerHeight*n.from.y,outerWidth:e.outerWidth*n.from.x},e={height:e.height*n.to.y,width:e.width*n.to.x,outerHeight:e.height*n.to.y,outerWidth:e.width*n.to.x};n.from.y!==n.to.y&&(i=V.effects.setTransition(t,o,n.from.y,i),e=V.effects.setTransition(t,o,n.to.y,e)),n.from.x!==n.to.x&&(i=V.effects.setTransition(t,a,n.from.x,i),e=V.effects.setTransition(t,a,n.to.x,e)),l&&V.effects.saveStyle(t),t.css(i),t.animate(e,s.duration,s.easing,function(){l&&V.effects.restoreStyle(t)})})),i.animate(g,{queue:!1,duration:s.duration,easing:s.easing,complete:function(){var t=i.offset();0===g.opacity&&i.css("opacity",f.opacity),l||(i.css("position","static"===u?"relative":u).offset(t),V.effects.saveStyle(i)),e()}})}),V.effects.define("scale",function(t,e){var i=V(this),s=t.mode,s=parseInt(t.percent,10)||(0===parseInt(t.percent,10)||"effect"!==s?0:100),i=V.extend(!0,{from:V.effects.scaledDimensions(i),to:V.effects.scaledDimensions(i,s,t.direction||"both"),origin:t.origin||["middle","center"]},t);t.fade&&(i.from.opacity=1,i.to.opacity=0),V.effects.effect.size.call(this,i,e)}),V.effects.define("puff","hide",function(t,e){t=V.extend(!0,{},t,{fade:!0,percent:parseInt(t.percent,10)||150});V.effects.effect.scale.call(this,t,e)}),V.effects.define("pulsate","show",function(t,e){var i=V(this),s=t.mode,n="show"===s,o=2*(t.times||5)+(n||"hide"===s?1:0),a=t.duration/o,r=0,l=1,s=i.queue().length;for(!n&&i.is(":visible")||(i.css("opacity",0).show(),r=1);l<o;l++)i.animate({opacity:r},a,t.easing),r=1-r;i.animate({opacity:r},a,t.easing),i.queue(e),V.effects.unshift(i,s,1+o)}),V.effects.define("shake",function(t,e){var i=1,s=V(this),n=t.direction||"left",o=t.distance||20,a=t.times||3,r=2*a+1,l=Math.round(t.duration/r),h="up"===n||"down"===n?"top":"left",n="up"===n||"left"===n,c={},u={},d={},p=s.queue().length;for(V.effects.createPlaceholder(s),c[h]=(n?"-=":"+=")+o,u[h]=(n?"+=":"-=")+2*o,d[h]=(n?"-=":"+=")+2*o,s.animate(c,l,t.easing);i<a;i++)s.animate(u,l,t.easing).animate(d,l,t.easing);s.animate(u,l,t.easing).animate(c,l/2,t.easing).queue(e),V.effects.unshift(s,p,1+r)}),V.effects.define("slide","show",function(t,e){var i,s,n=V(this),o={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},a=t.mode,r=t.direction||"left",l="up"===r||"down"===r?"top":"left",h="up"===r||"left"===r,c=t.distance||n["top"==l?"outerHeight":"outerWidth"](!0),u={};V.effects.createPlaceholder(n),i=n.cssClip(),s=n.position()[l],u[l]=(h?-1:1)*c+s,u.clip=n.cssClip(),u.clip[o[r][1]]=u.clip[o[r][0]],"show"===a&&(n.cssClip(u.clip),n.css(l,u[l]),u.clip=i,u[l]=s),n.animate(u,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),it=!0===V.uiBackCompat?V.effects.define("transfer",function(t,e){V(this).transfer(t,e)}):it,V.ui.focusable=function(t,e){var i,s,n,o=t.nodeName.toLowerCase();return"area"===o?(n=(i=t.parentNode).name,!(!t.href||!n||"map"!==i.nodeName.toLowerCase())&&0<(i=V("img[usemap='#"+n+"']")).length&&i.is(":visible")):(/^(input|select|textarea|button|object)$/.test(o)?(s=!t.disabled)&&(n=V(t).closest("fieldset")[0])&&(s=!n.disabled):s="a"===o&&t.href||e,s&&V(t).is(":visible")&&"visible"===V(t).css("visibility"))},V.extend(V.expr.pseudos,{focusable:function(t){return V.ui.focusable(t,null!=V.attr(t,"tabindex"))}}),V.ui.focusable,V.ui.formResetMixin={_formResetHandler:function(){var e=V(this);setTimeout(function(){var t=e.data("ui-form-reset-instances");V.each(t,function(){this.refresh()})})},_bindFormResetHandler:function(){var t;this.form=V(this.element.prop("form")),this.form.length&&((t=this.form.data("ui-form-reset-instances")||[]).length||this.form.on("reset.ui-form-reset",this._formResetHandler),t.push(this),this.form.data("ui-form-reset-instances",t))},_unbindFormResetHandler:function(){var t;this.form.length&&((t=this.form.data("ui-form-reset-instances")).splice(V.inArray(this,t),1),t.length?this.form.data("ui-form-reset-instances",t):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset"))}},V.escapeSelector||(V.escapeSelector=function(t){return CSS.escape(t+"")}),V.fn.even&&V.fn.odd||V.fn.extend({even:function(){return this.filter(function(t){return t%2==0})},odd:function(){return this.filter(function(t){return t%2==1})}}),V.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},V.fn.labels=function(){var t,e,i;return this.length?this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(e=this.eq(0).parents("label"),(t=this.attr("id"))&&(i=(i=this.eq(0).parents().last()).add((i.length?i:this).siblings()),t="label[for='"+CSS.escape(t)+"']",e=e.add(i.find(t).addBack(t))),this.pushStack(e)):this.pushStack([])},V.fn.scrollParent=function(t){var e=this.css("position"),i="absolute"===e,s=t?/(auto|scroll|hidden)/:/(auto|scroll)/,t=this.parents().filter(function(){var t=V(this);return(!i||"static"!==t.css("position"))&&s.test(t.css("overflow")+t.css("overflow-y")+t.css("overflow-x"))}).eq(0);return"fixed"!==e&&t.length?t:V(this[0].ownerDocument||document)},V.extend(V.expr.pseudos,{tabbable:function(t){var e=V.attr(t,"tabindex"),i=null!=e;return(!i||0<=e)&&V.ui.focusable(t,i)}}),V.fn.extend({uniqueId:(tt=0,function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++tt)})}),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&V(this).removeAttr("id")})}}),V.widget("ui.accordion",{version:"1.14.0",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:function(t){return t.find("> li > :first-child").add(t.find("> :not(li)").filter(function(t){return t%2==0}))},heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var t=this.options;this.prevShow=this.prevHide=V(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),t.collapsible||!1!==t.active&&null!=t.active||(t.active=0),this._processPanels(),t.active<0&&(t.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():V()}},_createIcons:function(){var t,e=this.options.icons;e&&(t=V("<span>"),this._addClass(t,"ui-accordion-header-icon","ui-icon "+e.header),t.prependTo(this.headers),t=this.active.children(".ui-accordion-header-icon"),this._removeClass(t,e.header)._addClass(t,null,e.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){"active"===t?this._activate(e):("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||!1!==this.options.active||this._activate(0),"icons"===t&&(this._destroyIcons(),e)&&this._createIcons())},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t)},_keydown:function(t){if(!t.altKey&&!t.ctrlKey){var e=V.ui.keyCode,i=this.headers.length,s=this.headers.index(t.target),n=!1;switch(t.keyCode){case e.RIGHT:case e.DOWN:n=this.headers[(s+1)%i];break;case e.LEFT:case e.UP:n=this.headers[(s-1+i)%i];break;case e.SPACE:case e.ENTER:this._eventHandler(t);break;case e.HOME:n=this.headers[0];break;case e.END:n=this.headers[i-1]}n&&(V(t.target).attr("tabIndex",-1),V(n).attr("tabIndex",0),V(n).trigger("focus"),t.preventDefault())}},_panelKeyDown:function(t){t.keyCode===V.ui.keyCode.UP&&t.ctrlKey&&V(t.currentTarget).prev().trigger("focus")},refresh:function(){var t=this.options;this._processPanels(),!1===t.active&&!0===t.collapsible||!this.headers.length?(t.active=!1,this.active=V()):!1===t.active?this._activate(0):this.active.length&&!V.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(t.active=!1,this.active=V()):this._activate(Math.max(0,t.active-1)):t.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var t=this.headers,e=this.panels;"function"==typeof this.options.header?this.headers=this.options.header(this.element):this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),e&&(this._off(t.not(this.headers)),this._off(e.not(this.panels)))},_refresh:function(){var i,t=this.options,e=t.heightStyle,s=this.element.parent();this.active=this._findActive(t.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var t=V(this),e=t.uniqueId().attr("id"),i=t.next(),s=i.uniqueId().attr("id");t.attr("aria-controls",s),i.attr("aria-labelledby",e)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(t.event),"fill"===e?(i=s.height(),this.element.siblings(":visible").each(function(){var t=V(this),e=t.css("position");"absolute"!==e&&"fixed"!==e&&(i-=t.outerHeight(!0))}),this.headers.each(function(){i-=V(this).outerHeight(!0)}),this.headers.next().each(function(){V(this).height(Math.max(0,i-V(this).innerHeight()+V(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.headers.next().each(function(){var t=V(this).is(":visible");t||V(this).show(),i=Math.max(i,V(this).css("height","").height()),t||V(this).hide()}).height(i))},_activate:function(t){t=this._findActive(t)[0];t!==this.active[0]&&(t=t||this.active[0],this._eventHandler({target:t,currentTarget:t,preventDefault:V.noop}))},_findActive:function(t){return"number"==typeof t?this.headers.eq(t):V()},_setupEvents:function(t){var i={keydown:"_keydown"};t&&V.each(t.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(t){var e=this.options,i=this.active,s=V(t.currentTarget),n=s[0]===i[0],o=n&&e.collapsible,a=o?V():s.next(),r=i.next(),r={oldHeader:i,oldPanel:r,newHeader:o?V():s,newPanel:a};t.preventDefault(),n&&!e.collapsible||!1===this._trigger("beforeActivate",t,r)||(e.active=!o&&this.headers.index(s),this.active=n?V():s,this._toggle(r),this._removeClass(i,"ui-accordion-header-active","ui-state-active"),e.icons&&(a=i.children(".ui-accordion-header-icon"),this._removeClass(a,null,e.icons.activeHeader)._addClass(a,null,e.icons.header)),n)||(this._removeClass(s,"ui-accordion-header-collapsed")._addClass(s,"ui-accordion-header-active","ui-state-active"),e.icons&&(t=s.children(".ui-accordion-header-icon"),this._removeClass(t,null,e.icons.header)._addClass(t,null,e.icons.activeHeader)),this._addClass(s.next(),"ui-accordion-content-active"))},_toggle:function(t){var e=t.newPanel,i=this.prevShow.length?this.prevShow:t.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=e,this.prevHide=i,this.options.animate?this._animate(e,i,t):(i.hide(),e.show(),this._toggleComplete(t)),i.attr({"aria-hidden":"true"}),i.prev().attr({"aria-selected":"false","aria-expanded":"false"}),e.length&&i.length?i.prev().attr({tabIndex:-1,"aria-expanded":"false"}):e.length&&this.headers.filter(function(){return 0===parseInt(V(this).attr("tabIndex"),10)}).attr("tabIndex",-1),e.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(t,i,e){function s(){o._toggleComplete(e)}var n,o=this,a=0,r=t.css("box-sizing"),l=t.length&&(!i.length||t.index()<i.index()),h=this.options.animate||{},l=l&&h.down||h,c=(c="string"==typeof l?l:c)||l.easing||h.easing,u=(u="number"==typeof l?l:u)||l.duration||h.duration;return i.length?t.length?(n=t.show().outerHeight(),i.animate(this.hideProps,{duration:u,easing:c,step:function(t,e){e.now=Math.round(t)}}),void t.hide().animate(this.showProps,{duration:u,easing:c,complete:s,step:function(t,e){e.now=Math.round(t),"height"!==e.prop?"content-box"===r&&(a+=e.now):"content"!==o.options.heightStyle&&(e.now=Math.round(n-i.outerHeight()-a),a=0)}})):i.animate(this.hideProps,u,c,s):t.animate(this.showProps,u,c,s)},_toggleComplete:function(t){var e=t.oldPanel,i=e.prev();this._removeClass(e,"ui-accordion-content-active"),this._removeClass(i,"ui-accordion-header-active")._addClass(i,"ui-accordion-header-collapsed"),this._trigger("activate",null,t)}}),V.widget("ui.menu",{version:"1.14.0",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.lastMousePosition={x:null,y:null},this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(t){t.preventDefault(),this._activateItem(t)},"click .ui-menu-item":function(t){var e=V(t.target),i=V(this.document[0].activeElement);!this.mouseHandled&&e.not(".ui-state-disabled").length&&(this.select(t),t.isPropagationStopped()||(this.mouseHandled=!0),e.has(".ui-menu").length?this.expand(t):!this.element.is(":focus")&&i.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active)&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer))},"mouseenter .ui-menu-item":"_activateItem","mousemove .ui-menu-item":"_activateItem",mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this._menuItems().first();e||this.focus(t,i)},blur:function(t){this._delay(function(){V.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(t)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){this._closeOnDocumentClick(t)&&this.collapseAll(t,!0),this.mouseHandled=!1}})},_activateItem:function(t){var e,i;this.previousFilter||t.clientX===this.lastMousePosition.x&&t.clientY===this.lastMousePosition.y||(this.lastMousePosition={x:t.clientX,y:t.clientY},e=V(t.target).closest(".ui-menu-item"),i=V(t.currentTarget),e[0]!==i[0])||i.is(".ui-state-active")||(this._removeClass(i.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(t,i))},_destroy:function(){var t=this.element.find(".ui-menu-item").removeAttr("role aria-disabled").children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),t.children().each(function(){var t=V(this);t.data("ui-menu-submenu-caret")&&t.remove()})},_keydown:function(t){var e,i,s,n=!0;switch(t.keyCode){case V.ui.keyCode.PAGE_UP:this.previousPage(t);break;case V.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case V.ui.keyCode.HOME:this._move("first","first",t);break;case V.ui.keyCode.END:this._move("last","last",t);break;case V.ui.keyCode.UP:this.previous(t);break;case V.ui.keyCode.DOWN:this.next(t);break;case V.ui.keyCode.LEFT:this.collapse(t);break;case V.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(t);break;case V.ui.keyCode.ENTER:case V.ui.keyCode.SPACE:this._activate(t);break;case V.ui.keyCode.ESCAPE:this.collapse(t);break;default:e=this.previousFilter||"",s=n=!1,i=96<=t.keyCode&&t.keyCode<=105?(t.keyCode-96).toString():String.fromCharCode(t.keyCode),clearTimeout(this.filterTimer),i===e?s=!0:i=e+i,e=this._filterMenuItems(i),(e=s&&-1!==e.index(this.active.next())?this.active.nextAll(".ui-menu-item"):e).length||(i=String.fromCharCode(t.keyCode),e=this._filterMenuItems(i)),e.length?(this.focus(t,e),this.previousFilter=i,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}n&&t.preventDefault()},_activate:function(t){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var t,e,s=this,n=this.options.icons.submenu,i=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),t=i.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var t=V(this),e=t.prev(),i=V("<span>").data("ui-menu-submenu-caret",!0);s._addClass(i,"ui-menu-icon","ui-icon "+n),e.attr("aria-haspopup","true").prepend(i),t.attr("aria-labelledby",e.attr("id"))}),this._addClass(t,"ui-menu","ui-widget ui-widget-content ui-front"),(t=i.add(this.element).find(this.options.items)).not(".ui-menu-item").each(function(){var t=V(this);s._isDivider(t)&&s._addClass(t,"ui-menu-divider","ui-widget-content")}),e=(i=t.not(".ui-menu-item, .ui-menu-divider")).children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(i,"ui-menu-item")._addClass(e,"ui-menu-item-wrapper"),t.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!V.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){var i;"icons"===t&&(i=this.element.find(".ui-menu-icon"),this._removeClass(i,null,this.options.icons.submenu)._addClass(i,null,e.submenu)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",String(t)),this._toggleClass(null,"ui-state-disabled",!!t)},focus:function(t,e){var i;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),i=this.active.children(".ui-menu-item-wrapper"),this._addClass(i,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",i.attr("id")),i=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(i,null,"ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),(i=e.children(".ui-menu")).length&&t&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(t){var e,i,s;this._hasScroll()&&(e=parseFloat(V.css(this.activeMenu[0],"borderTopWidth"))||0,i=parseFloat(V.css(this.activeMenu[0],"paddingTop"))||0,e=t.offset().top-this.activeMenu.offset().top-e-i,i=this.activeMenu.scrollTop(),s=this.activeMenu.height(),t=t.outerHeight(),e<0?this.activeMenu.scrollTop(i+e):s<e+t&&this.activeMenu.scrollTop(i+e-s+t))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",t,{item:this.active}),this.active=null)},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(t){var e=V.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden","true"),t.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(e)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var t=i?this.element:V(e&&e.target).closest(this.element.find(".ui-menu"));t.length||(t=this.element),this._close(t),this.blur(e),this._removeClass(t.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=t},i?0:this.delay)},_close:function(t){(t=t||(this.active?this.active.parent():this.element)).find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(t){return!V(t.target).closest(".ui-menu").length},_isDivider:function(t){return!/[^\-\u2014\u2013\s]/.test(t.text())},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this._menuItems(this.active.children(".ui-menu")).first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_menuItems:function(t){return(t||this.element).find(this.options.items).filter(".ui-menu-item")},_move:function(t,e,i){var s;(s=this.active?"first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").last():this.active[t+"All"](".ui-menu-item").first():s)&&s.length&&this.active||(s=this._menuItems(this.activeMenu)[e]()),this.focus(i,s)},nextPage:function(t){var e,i,s;this.active?this.isLastItem()||(this._hasScroll()?(i=this.active.offset().top,s=this.element.innerHeight(),0===V.fn.jquery.indexOf("3.2.")&&(s+=this.element[0].offsetHeight-this.element.outerHeight()),this.active.nextAll(".ui-menu-item").each(function(){return(e=V(this)).offset().top-i-s<0}),this.focus(t,e)):this.focus(t,this._menuItems(this.activeMenu)[this.active?"last":"first"]())):this.next(t)},previousPage:function(t){var e,i,s;this.active?this.isFirstItem()||(this._hasScroll()?(i=this.active.offset().top,s=this.element.innerHeight(),0===V.fn.jquery.indexOf("3.2.")&&(s+=this.element[0].offsetHeight-this.element.outerHeight()),this.active.prevAll(".ui-menu-item").each(function(){return 0<(e=V(this)).offset().top-i+s}),this.focus(t,e)):this.focus(t,this._menuItems(this.activeMenu).first())):this.next(t)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(t){this.active=this.active||V(t.target).closest(".ui-menu-item");var e={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(t,!0),this._trigger("select",t,e)},_filterMenuItems:function(t){var t=t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),e=new RegExp("^"+t,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return e.test(String.prototype.trim.call(V(this).children(".ui-menu-item-wrapper").text()))})}}),V.widget("ui.autocomplete",{version:"1.14.0",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,liveRegionTimer:null,_create:function(){var i,s,n,t=this.element[0].nodeName.toLowerCase(),e="textarea"===t,t="input"===t;this.isMultiLine=e||!t&&"true"===this.element.prop("contentEditable"),this.valueMethod=this.element[e||t?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(t){if(this.element.prop("readOnly"))s=n=i=!0;else{s=n=i=!1;var e=V.ui.keyCode;switch(t.keyCode){case e.PAGE_UP:i=!0,this._move("previousPage",t);break;case e.PAGE_DOWN:i=!0,this._move("nextPage",t);break;case e.UP:i=!0,this._keyEvent("previous",t);break;case e.DOWN:i=!0,this._keyEvent("next",t);break;case e.ENTER:this.menu.active&&(i=!0,t.preventDefault(),this.menu.select(t));break;case e.TAB:this.menu.active&&this.menu.select(t);break;case e.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(t),t.preventDefault());break;default:s=!0,this._searchTimeout(t)}}},keypress:function(t){if(i)i=!1,this.isMultiLine&&!this.menu.element.is(":visible")||t.preventDefault();else if(!s){var e=V.ui.keyCode;switch(t.keyCode){case e.PAGE_UP:this._move("previousPage",t);break;case e.PAGE_DOWN:this._move("nextPage",t);break;case e.UP:this._keyEvent("previous",t);break;case e.DOWN:this._keyEvent("next",t)}}},input:function(t){n?(n=!1,t.preventDefault()):this._searchTimeout(t)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){clearTimeout(this.searching),this.close(t),this._change(t)}}),this._initSource(),this.menu=V("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault()},menufocus:function(t,e){var i,s;this.isNewMenu&&(this.isNewMenu=!1,t.originalEvent)&&/^mouse/.test(t.originalEvent.type)?(this.menu.blur(),this.document.one("mousemove",function(){V(t.target).trigger(t.originalEvent)})):(s=e.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",t,{item:s})&&t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(s.value),(i=e.item.attr("aria-label")||s.value)&&String.prototype.trim.call(i).length&&(clearTimeout(this.liveRegionTimer),this.liveRegionTimer=this._delay(function(){this.liveRegion.html(V("<div>").text(i))},100)))},menuselect:function(t,e){var e=e.item.data("ui-autocomplete-item"),i=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.trigger("focus"),this.previous=i),!1!==this._trigger("select",t,{item:e})&&this._value(e.value),this.term=this._value(),this.close(t),this.selectedItem=e}}),this.liveRegion=V("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(t){var e=this.menu.element[0];return t.target===this.element[0]||t.target===e||V.contains(e,t.target)},_closeOnClickOutside:function(t){this._isEventTargetInWidget(t)||this.close()},_appendTo:function(){var t=this.options.appendTo;return t=(t=(t=t&&(t.jquery||t.nodeType?V(t):this.document.find(t).eq(0)))&&t[0]?t:this.element.closest(".ui-front, dialog")).length?t:this.document[0].body},_initSource:function(){var i,s,n=this;Array.isArray(this.options.source)?(i=this.options.source,this.source=function(t,e){e(V.ui.autocomplete.filter(i,t.term))}):"string"==typeof this.options.source?(s=this.options.source,this.source=function(t,e){n.xhr&&n.xhr.abort(),n.xhr=V.ajax({url:s,data:t,dataType:"json",success:function(t){e(t)},error:function(){e([])}})}):this.source=this.options.source},_searchTimeout:function(s){clearTimeout(this.searching),this.searching=this._delay(function(){var t=this.term===this._value(),e=this.menu.element.is(":visible"),i=s.altKey||s.ctrlKey||s.metaKey||s.shiftKey;t&&(e||i)||(this.selectedItem=null,this.search(null,s))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):!1!==this._trigger("search",e)?this._search(t):void 0},_search:function(t){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var e=++this.requestIndex;return function(t){e===this.requestIndex&&this.__response(t),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")}.bind(this)},__response:function(t){t=t&&this._normalize(t),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:V.map(t,function(t){return"string"==typeof t?{label:t,value:t}:V.extend({},t,{label:t.label||t.value,value:t.value||t.label})})},_suggest:function(t){var e=this.menu.element.empty();this._renderMenu(e,t),this.isNewMenu=!0,this.menu.refresh(),e.show(),this._resizeMenu(),e.position(V.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(i,t){var s=this;V.each(t,function(t,e){s._renderItemData(i,e)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(t,e){return V("<li>").append(V("<div>").text(e.label)).appendTo(t)},_move:function(t,e){this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this.isMultiLine||this._value(this.term),this.menu.blur()):this.menu[t](e):this.search(null,e)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){this.isMultiLine&&!this.menu.element.is(":visible")||(this._move(t,e),e.preventDefault())}}),V.extend(V.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,e){var i=new RegExp(V.ui.autocomplete.escapeRegex(e),"i");return V.grep(t,function(t){return i.test(t.label||t.value||t)})}}),V.widget("ui.autocomplete",V.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(1<t?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(t){var e;this._superApply(arguments),this.options.disabled||this.cancelSearch||(e=t&&t.length?this.options.messages.results(t.length):this.options.messages.noResults,clearTimeout(this.liveRegionTimer),this.liveRegionTimer=this._delay(function(){this.liveRegion.html(V("<div>").text(e))},100))}}),V.ui.autocomplete,/ui-corner-([a-z]){2,6}/g);V.widget("ui.controlgroup",{version:"1.14.0",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var o=this,a=[];V.each(this.options.items,function(s,t){var e,n={};t&&("controlgroupLabel"===s?((e=o.element.find(t)).each(function(){var t=V(this);t.children(".ui-controlgroup-label-contents").length||t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),o._addClass(e,null,"ui-widget ui-widget-content ui-state-default"),a=a.concat(e.get())):V.fn[s]&&(n=o["_"+s+"Options"]?o["_"+s+"Options"]("middle"):{classes:{}},o.element.find(t).each(function(){var t=V(this),e=t[s]("instance"),i=V.widget.extend({},n);"button"===s&&t.parent(".ui-spinner").length||((e=e||t[s]()[s]("instance"))&&(i.classes=o._resolveClassesValues(i.classes,e)),t[s](i),i=t[s]("widget"),V.data(i[0],"ui-controlgroup-data",e||t[s]("instance")),a.push(i[0]))})))}),this.childWidgets=V(V.uniqueSort(a)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(e){this.childWidgets.each(function(){var t=V(this).data("ui-controlgroup-data");t&&t[e]&&t[e]()})},_updateCornerClass:function(t,e){e=this._buildSimpleOptions(e,"label").classes.label;this._removeClass(t,null,"ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all"),this._addClass(t,null,e)},_buildSimpleOptions:function(t,e){var i="vertical"===this.options.direction,s={classes:{}};return s.classes[e]={middle:"",first:"ui-corner-"+(i?"top":"left"),last:"ui-corner-"+(i?"bottom":"right"),only:"ui-corner-all"}[t],s},_spinnerOptions:function(t){t=this._buildSimpleOptions(t,"ui-spinner");return t.classes["ui-spinner-up"]="",t.classes["ui-spinner-down"]="",t},_buttonOptions:function(t){return this._buildSimpleOptions(t,"ui-button")},_checkboxradioOptions:function(t){return this._buildSimpleOptions(t,"ui-checkboxradio-label")},_selectmenuOptions:function(t){var e="vertical"===this.options.direction;return{width:e&&"auto",classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(e?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(e?"top":"left")},last:{"ui-selectmenu-button-open":e?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(e?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[t]}},_resolveClassesValues:function(i,s){var n={};return V.each(i,function(t){var e=s.options.classes[t]||"",e=String.prototype.trim.call(e.replace(st,""));n[t]=(e+" "+i[t]).replace(/\s+/g," ")}),n},_setOption:function(t,e){"direction"===t&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(t,e),"disabled"===t?this._callChildMethod(e?"disable":"enable"):this.refresh()},refresh:function(){var n,o=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),n=this.childWidgets,(n=this.options.onlyVisible?n.filter(":visible"):n).length&&(V.each(["first","last"],function(t,e){var i,s=n[e]().data("ui-controlgroup-data");s&&o["_"+s.widgetName+"Options"]?((i=o["_"+s.widgetName+"Options"](1===n.length?"only":e)).classes=o._resolveClassesValues(i.classes,s),s.element[s.widgetName](i)):o._updateCornerClass(n[e](),e)}),this._callChildMethod("refresh"))}}),V.widget("ui.checkboxradio",[V.ui.formResetMixin,{version:"1.14.0",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var t,e=this._super()||{};return this._readType(),t=this.element.labels(),this.label=V(t[t.length-1]),this.label.length||V.error("No label found for checkboxradio widget"),this.originalLabel="",(t=this.label.contents().not(this.element[0])).length&&(this.originalLabel+=t.clone().wrapAll("<div></div>").parent().html()),this.originalLabel&&(e.label=this.originalLabel),null!=(t=this.element[0].disabled)&&(e.disabled=t),e},_create:function(){var t=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),t&&this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var t=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===t&&/radio|checkbox/.test(this.type)||V.error("Can't create checkboxradio on element.nodeName="+t+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var t=this.element[0].name,e="input[name='"+CSS.escape(t)+"']";return t?(this.form.length?V(this.form[0].elements).filter(e):V(e).filter(function(){return 0===V(V(this).prop("form")).length})).not(this.element):V([])},_toggleClasses:function(){var t=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",t)._toggleClass(this.icon,null,"ui-icon-blank",!t),"radio"===this.type&&this._getRadioGroup().each(function(){var t=V(this).checkboxradio("instance");t&&t._removeClass(t.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(t,e){"label"===t&&!e||(this._super(t,e),"disabled"===t?(this._toggleClass(this.label,null,"ui-state-disabled",e),this.element[0].disabled=e):this.refresh())},_updateIcon:function(t){var e="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=V("<span>"),this.iconSpace=V("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(e+=t?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,t?"ui-icon-blank":"ui-icon-check")):e+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",e),t||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){var t=this.label.contents().not(this.element[0]);this.icon&&(t=t.not(this.icon[0])),(t=this.iconSpace?t.not(this.iconSpace[0]):t).remove(),this.label.append(this.options.label)},refresh:function(){var t=this.element[0].checked,e=this.element[0].disabled;this._updateIcon(t),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),null!==this.options.label&&this._updateLabel(),e!==this.options.disabled&&this._setOptions({disabled:e})}}]),V.ui.checkboxradio,V.widget("ui.button",{version:"1.14.0",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var t,e=this._super()||{};return this.isInput=this.element.is("input"),null!=(t=this.element[0].disabled)&&(e.disabled=t),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(e.label=this.originalLabel),e},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(t){t.keyCode===V.ui.keyCode.SPACE&&(t.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(t,e){var t="iconPosition"!==t,i=t?this.options.iconPosition:e,s="top"===i||"bottom"===i;this.icon?t&&this._removeClass(this.icon,null,this.options.icon):(this.icon=V("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),t&&this._addClass(this.icon,null,e),this._attachIcon(i),s?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=V("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(i))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")},_attachIconSpace:function(t){this.icon[/^(?:end|bottom)/.test(t)?"before":"after"](this.iconSpace)},_attachIcon:function(t){this.element[/^(?:end|bottom)/.test(t)?"append":"prepend"](this.icon)},_setOptions:function(t){var e=(void 0===t.showLabel?this.options:t).showLabel,i=(void 0===t.icon?this.options:t).icon;e||i||(t.showLabel=!0),this._super(t)},_setOption:function(t,e){"icon"===t&&(e?this._updateIcon(t,e):this.icon&&(this.icon.remove(),this.iconSpace)&&this.iconSpace.remove()),"iconPosition"===t&&this._updateIcon(t,e),"showLabel"===t&&(this._toggleClass("ui-button-icon-only",null,!e),this._updateTooltip()),"label"===t&&(this.isInput?this.element.val(e):(this.element.html(e),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(t,e),"disabled"===t&&(this._toggleClass(null,"ui-state-disabled",e),this.element[0].disabled=e)&&this.element.trigger("blur")},refresh:function(){var t=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOptions({disabled:t}),this._updateTooltip()}}),!0===V.uiBackCompat&&(V.widget("ui.button",V.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(t,e){"text"===t?this._super("showLabel",e):("showLabel"===t&&(this.options.text=e),"icon"===t&&(this.options.icons.primary=e),"icons"===t&&(e.primary?(this._super("icon",e.primary),this._super("iconPosition","beginning")):e.secondary&&(this._super("icon",e.secondary),this._super("iconPosition","end"))),this._superApply(arguments))}}),V.fn.button=(et=V.fn.button,function(i){var t="string"==typeof i,s=Array.prototype.slice.call(arguments,1),n=this;return t?this.length||"instance"!==i?this.each(function(){var t,e=V(this).attr("type"),e=V.data(this,"ui-"+("checkbox"!==e&&"radio"!==e?"button":"checkboxradio"));return"instance"===i?(n=e,!1):e?"function"!=typeof e[i]||"_"===i.charAt(0)?V.error("no such method '"+i+"' for button widget instance"):(t=e[i].apply(e,s))!==e&&void 0!==t?(n=t&&t.jquery?n.pushStack(t.get()):t,!1):void 0:V.error("cannot call methods on button prior to initialization; attempted to call method '"+i+"'")}):n=void 0:(s.length&&(i=V.widget.extend.apply(null,[i].concat(s))),this.each(function(){var t=V(this).attr("type"),t="checkbox"!==t&&"radio"!==t?"button":"checkboxradio",e=V.data(this,"ui-"+t);e?(e.option(i||{}),e._init&&e._init()):"button"==t?et.call(V(this),i):V(this).checkboxradio(V.extend({icon:!1},i))})),n}),V.fn.buttonset=function(){return V.ui.controlgroup||V.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))}),V.ui.button;function nt(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:"",selectMonthLabel:"Select month",selectYearLabel:"Select year"},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,onUpdateDatepicker:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},V.extend(this._defaults,this.regional[""]),this.regional.en=V.extend(!0,{},this.regional[""]),this.regional["en-US"]=V.extend(!0,{},this.regional.en),this.dpDiv=ot(V("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function ot(t){var e="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.on("mouseout",e,function(){V(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&V(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&V(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",e,at)}function at(){V.datepicker._isDisabledDatepicker((S.inline?S.dpDiv.parent():S.input)[0])||(V(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),V(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&V(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&V(this).addClass("ui-datepicker-next-hover"))}function H(t,e){for(var i in V.extend(t,e),e)null==e[i]&&(t[i]=e[i])}V.extend(V.ui,{datepicker:{version:"1.14.0"}}),V.extend(nt.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return H(this._defaults,t||{}),this},_attachDatepicker:function(t,e){var i,s=t.nodeName.toLowerCase(),n="div"===s||"span"===s;t.id||(this.uuid+=1,t.id="dp"+this.uuid),(i=this._newInst(V(t),n)).settings=V.extend({},e||{}),"input"===s?this._connectDatepicker(t,i):n&&this._inlineDatepicker(t,i)},_newInst:function(t,e){return{id:t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1"),input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:e,dpDiv:e?ot(V("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,e){var i=V(t);e.append=V([]),e.trigger=V([]),i.hasClass(this.markerClassName)||(this._attachments(i,e),i.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(e),V.data(t,"datepicker",e),e.settings.disabled&&this._disableDatepicker(t))},_attachments:function(t,e){var i,s=this._get(e,"appendText"),n=this._get(e,"isRTL");e.append&&e.append.remove(),s&&(e.append=V("<span>").addClass(this._appendClass).text(s),t[n?"before":"after"](e.append)),t.off("focus",this._showDatepicker),e.trigger&&e.trigger.remove(),"focus"!==(s=this._get(e,"showOn"))&&"both"!==s||t.on("focus",this._showDatepicker),"button"!==s&&"both"!==s||(s=this._get(e,"buttonText"),i=this._get(e,"buttonImage"),this._get(e,"buttonImageOnly")?e.trigger=V("<img>").addClass(this._triggerClass).attr({src:i,alt:s,title:s}):(e.trigger=V("<button type='button'>").addClass(this._triggerClass),i?e.trigger.html(V("<img>").attr({src:i,alt:s,title:s})):e.trigger.text(s)),t[n?"before":"after"](e.trigger),e.trigger.on("click",function(){return V.datepicker._datepickerShowing&&V.datepicker._lastInput===t[0]?V.datepicker._hideDatepicker():(V.datepicker._datepickerShowing&&V.datepicker._lastInput!==t[0]&&V.datepicker._hideDatepicker(),V.datepicker._showDatepicker(t[0])),!1}))},_autoSize:function(t){var e,i,s,n,o,a;this._get(t,"autoSize")&&!t.inline&&(o=new Date(2009,11,20),(a=this._get(t,"dateFormat")).match(/[DM]/)&&(o.setMonth((e=function(t){for(n=s=i=0;n<t.length;n++)t[n].length>i&&(i=t[n].length,s=n);return s})(this._get(t,a.match(/MM/)?"monthNames":"monthNamesShort"))),o.setDate(e(this._get(t,a.match(/DD/)?"dayNames":"dayNamesShort"))+20-o.getDay())),t.input.attr("size",this._formatDate(t,o).length))},_inlineDatepicker:function(t,e){var i=V(t);i.hasClass(this.markerClassName)||(i.addClass(this.markerClassName).append(e.dpDiv),V.data(t,"datepicker",e),this._setDate(e,this._getDefaultDate(e),!0),this._updateDatepicker(e),this._updateAlternate(e),e.settings.disabled&&this._disableDatepicker(t),e.dpDiv.css("display","block"))},_dialogDatepicker:function(t,e,i,s,n){var o,a=this._dialogInst;return a||(this.uuid+=1,o="dp"+this.uuid,this._dialogInput=V("<input type='text' id='"+o+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),V("body").append(this._dialogInput),(a=this._dialogInst=this._newInst(this._dialogInput,!1)).settings={},V.data(this._dialogInput[0],"datepicker",a)),H(a.settings,s||{}),e=e&&e.constructor===Date?this._formatDate(a,e):e,this._dialogInput.val(e),this._pos=n?n.length?n:[n.pageX,n.pageY]:null,this._pos||(o=document.documentElement.clientWidth,s=document.documentElement.clientHeight,e=document.documentElement.scrollLeft||document.body.scrollLeft,n=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[o/2-100+e,s/2-150+n]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),a.settings.onSelect=i,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),V.blockUI&&V.blockUI(this.dpDiv),V.data(this._dialogInput[0],"datepicker",a),this},_destroyDatepicker:function(t){var e,i=V(t),s=V.data(t,"datepicker");i.hasClass(this.markerClassName)&&(e=t.nodeName.toLowerCase(),V.removeData(t,"datepicker"),"input"===e?(s.append.remove(),s.trigger.remove(),i.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):"div"!==e&&"span"!==e||i.removeClass(this.markerClassName).empty(),V.datepicker._hideDatepicker(),S===s)&&(S=null,this._curInst=null)},_enableDatepicker:function(e){var t,i=V(e),s=V.data(e,"datepicker");i.hasClass(this.markerClassName)&&("input"===(t=e.nodeName.toLowerCase())?(e.disabled=!1,s.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==t&&"span"!==t||((s=i.children("."+this._inlineClass)).children().removeClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=V.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var t,i=V(e),s=V.data(e,"datepicker");i.hasClass(this.markerClassName)&&("input"===(t=e.nodeName.toLowerCase())?(e.disabled=!0,s.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==t&&"span"!==t||((s=i.children("."+this._inlineClass)).children().addClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=V.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(t)for(var e=0;e<this._disabledInputs.length;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(t){try{return V.data(t,"datepicker")}catch(t){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(t,e,i){var s,n,o=this._getInst(t);if(2===arguments.length&&"string"==typeof e)return"defaults"===e?V.extend({},V.datepicker._defaults):o?"all"===e?V.extend({},o.settings):this._get(o,e):null;s=e||{},"string"==typeof e&&((s={})[e]=i),o&&(this._curInst===o&&this._hideDatepicker(),e=this._getDateDatepicker(t,!0),i=this._getMinMaxDate(o,"min"),n=this._getMinMaxDate(o,"max"),H(o.settings,s),null!==i&&void 0!==s.dateFormat&&void 0===s.minDate&&(o.settings.minDate=this._formatDate(o,i)),null!==n&&void 0!==s.dateFormat&&void 0===s.maxDate&&(o.settings.maxDate=this._formatDate(o,n)),"disabled"in s&&(s.disabled?this._disableDatepicker(t):this._enableDatepicker(t)),this._attachments(V(t),o),this._autoSize(o),this._setDate(o,e),this._updateAlternate(o),this._updateDatepicker(o))},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){t=this._getInst(t);t&&this._updateDatepicker(t)},_setDateDatepicker:function(t,e){t=this._getInst(t);t&&(this._setDate(t,e),this._updateDatepicker(t),this._updateAlternate(t))},_getDateDatepicker:function(t,e){t=this._getInst(t);return t&&!t.inline&&this._setDateFromField(t,e),t?this._getDate(t):null},_doKeyDown:function(t){var e,i,s=V.datepicker._getInst(t.target),n=!0,o=s.dpDiv.is(".ui-datepicker-rtl");if(s._keyEvent=!0,V.datepicker._datepickerShowing)switch(t.keyCode){case 9:V.datepicker._hideDatepicker(),n=!1;break;case 13:return(i=V("td."+V.datepicker._dayOverClass+":not(."+V.datepicker._currentClass+")",s.dpDiv))[0]&&V.datepicker._selectDay(t.target,s.selectedMonth,s.selectedYear,i[0]),(i=V.datepicker._get(s,"onSelect"))?(e=V.datepicker._formatDate(s),i.apply(s.input?s.input[0]:null,[e,s])):V.datepicker._hideDatepicker(),!1;case 27:V.datepicker._hideDatepicker();break;case 33:V.datepicker._adjustDate(t.target,t.ctrlKey?-V.datepicker._get(s,"stepBigMonths"):-V.datepicker._get(s,"stepMonths"),"M");break;case 34:V.datepicker._adjustDate(t.target,t.ctrlKey?+V.datepicker._get(s,"stepBigMonths"):+V.datepicker._get(s,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&V.datepicker._clearDate(t.target),n=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&V.datepicker._gotoToday(t.target),n=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,o?1:-1,"D"),n=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&V.datepicker._adjustDate(t.target,t.ctrlKey?-V.datepicker._get(s,"stepBigMonths"):-V.datepicker._get(s,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,-7,"D"),n=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,o?-1:1,"D"),n=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&V.datepicker._adjustDate(t.target,t.ctrlKey?+V.datepicker._get(s,"stepBigMonths"):+V.datepicker._get(s,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,7,"D"),n=t.ctrlKey||t.metaKey;break;default:n=!1}else 36===t.keyCode&&t.ctrlKey?V.datepicker._showDatepicker(this):n=!1;n&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var e,i=V.datepicker._getInst(t.target);if(V.datepicker._get(i,"constrainInput"))return i=V.datepicker._possibleChars(V.datepicker._get(i,"dateFormat")),e=String.fromCharCode(null==t.charCode?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||e<" "||!i||-1<i.indexOf(e)},_doKeyUp:function(t){t=V.datepicker._getInst(t.target);if(t.input.val()!==t.lastVal)try{V.datepicker.parseDate(V.datepicker._get(t,"dateFormat"),t.input?t.input.val():null,V.datepicker._getFormatConfig(t))&&(V.datepicker._setDateFromField(t),V.datepicker._updateAlternate(t),V.datepicker._updateDatepicker(t))}catch(t){}return!0},_showDatepicker:function(t){var e,i,s,n;"input"!==(t=t.target||t).nodeName.toLowerCase()&&(t=V("input",t.parentNode)[0]),V.datepicker._isDisabledDatepicker(t)||V.datepicker._lastInput===t||(n=V.datepicker._getInst(t),V.datepicker._curInst&&V.datepicker._curInst!==n&&(V.datepicker._curInst.dpDiv.stop(!0,!0),n)&&V.datepicker._datepickerShowing&&V.datepicker._hideDatepicker(V.datepicker._curInst.input[0]),!1===(i=(i=V.datepicker._get(n,"beforeShow"))?i.apply(t,[t,n]):{}))||(H(n.settings,i),n.lastVal=null,V.datepicker._lastInput=t,V.datepicker._setDateFromField(n),V.datepicker._inDialog&&(t.value=""),V.datepicker._pos||(V.datepicker._pos=V.datepicker._findPos(t),V.datepicker._pos[1]+=t.offsetHeight),e=!1,V(t).parents().each(function(){return!(e|="fixed"===V(this).css("position"))}),i={left:V.datepicker._pos[0],top:V.datepicker._pos[1]},V.datepicker._pos=null,n.dpDiv.empty(),n.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),V.datepicker._updateDatepicker(n),i=V.datepicker._checkOffset(n,i,e),n.dpDiv.css({position:V.datepicker._inDialog&&V.blockUI?"static":e?"fixed":"absolute",display:"none",left:i.left+"px",top:i.top+"px"}),n.inline)||(i=V.datepicker._get(n,"showAnim"),s=V.datepicker._get(n,"duration"),n.dpDiv.css("z-index",function(t){for(var e;t.length&&t[0]!==document;){if(("absolute"===(e=t.css("position"))||"relative"===e||"fixed"===e)&&(e=parseInt(t.css("zIndex"),10),!isNaN(e))&&0!==e)return e;t=t.parent()}return 0}(V(t))+1),V.datepicker._datepickerShowing=!0,V.effects&&V.effects.effect[i]?n.dpDiv.show(i,V.datepicker._get(n,"showOptions"),s):n.dpDiv[i||"show"](i?s:null),V.datepicker._shouldFocusInput(n)&&n.input.trigger("focus"),V.datepicker._curInst=n)},_updateDatepicker:function(t){this.maxRows=4,(S=t).dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t);var e,i=this._getNumberOfMonths(t),s=i[1],n=t.dpDiv.find("."+this._dayOverClass+" a"),o=V.datepicker._get(t,"onUpdateDatepicker");0<n.length&&at.apply(n.get(0)),t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),1<s&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",17*s+"em"),t.dpDiv[(1!==i[0]||1!==i[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===V.datepicker._curInst&&V.datepicker._datepickerShowing&&V.datepicker._shouldFocusInput(t)&&t.input.trigger("focus"),t.yearshtml&&(e=t.yearshtml,setTimeout(function(){e===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year").first().replaceWith(t.yearshtml),e=t.yearshtml=null},0)),o&&o.apply(t.input?t.input[0]:null,[t])},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")},_checkOffset:function(t,e,i){var s=t.dpDiv.outerWidth(),n=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,a=t.input?t.input.outerHeight():0,r=document.documentElement.clientWidth+(i?0:V(document).scrollLeft()),l=document.documentElement.clientHeight+(i?0:V(document).scrollTop());return e.left-=this._get(t,"isRTL")?s-o:0,e.left-=i&&e.left===t.input.offset().left?V(document).scrollLeft():0,e.top-=i&&e.top===t.input.offset().top+a?V(document).scrollTop():0,e.left-=Math.min(e.left,e.left+s>r&&s<r?Math.abs(e.left+s-r):0),e.top-=Math.min(e.top,e.top+n>l&&n<l?Math.abs(n+a):0),e},_findPos:function(t){for(var e=this._getInst(t),i=this._get(e,"isRTL");t&&("hidden"===t.type||1!==t.nodeType||V.expr.pseudos.hidden(t));)t=t[i?"previousSibling":"nextSibling"];return[(e=V(t).offset()).left,e.top]},_hideDatepicker:function(t){var e,i,s=this._curInst;!s||t&&s!==V.data(t,"datepicker")||this._datepickerShowing&&(t=this._get(s,"showAnim"),i=this._get(s,"duration"),e=function(){V.datepicker._tidyDialog(s)},V.effects&&V.effects.effect[t]?s.dpDiv.hide(t,V.datepicker._get(s,"showOptions"),i,e):s.dpDiv["slideDown"===t?"slideUp":"fadeIn"===t?"fadeOut":"hide"](t?i:null,e),t||e(),this._datepickerShowing=!1,(i=this._get(s,"onClose"))&&i.apply(s.input?s.input[0]:null,[s.input?s.input.val():"",s]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),V.blockUI)&&(V.unblockUI(),V("body").append(this.dpDiv)),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(t){var e;V.datepicker._curInst&&(t=V(t.target),e=V.datepicker._getInst(t[0]),!(t[0].id===V.datepicker._mainDivId||0!==t.parents("#"+V.datepicker._mainDivId).length||t.hasClass(V.datepicker.markerClassName)||t.closest("."+V.datepicker._triggerClass).length||!V.datepicker._datepickerShowing||V.datepicker._inDialog&&V.blockUI)||t.hasClass(V.datepicker.markerClassName)&&V.datepicker._curInst!==e)&&V.datepicker._hideDatepicker()},_adjustDate:function(t,e,i){var t=V(t),s=this._getInst(t[0]);this._isDisabledDatepicker(t[0])||(this._adjustInstDate(s,e,i),this._updateDatepicker(s))},_gotoToday:function(t){var e,t=V(t),i=this._getInst(t[0]);this._get(i,"gotoCurrent")&&i.currentDay?(i.selectedDay=i.currentDay,i.drawMonth=i.selectedMonth=i.currentMonth,i.drawYear=i.selectedYear=i.currentYear):(e=new Date,i.selectedDay=e.getDate(),i.drawMonth=i.selectedMonth=e.getMonth(),i.drawYear=i.selectedYear=e.getFullYear()),this._notifyChange(i),this._adjustDate(t)},_selectMonthYear:function(t,e,i){var t=V(t),s=this._getInst(t[0]);s["selected"+("M"===i?"Month":"Year")]=s["draw"+("M"===i?"Month":"Year")]=parseInt(e.options[e.selectedIndex].value,10),this._notifyChange(s),this._adjustDate(t)},_selectDay:function(t,e,i,s){var n=V(t);V(s).hasClass(this._unselectableClass)||this._isDisabledDatepicker(n[0])||((n=this._getInst(n[0])).selectedDay=n.currentDay=parseInt(V("a",s).attr("data-date")),n.selectedMonth=n.currentMonth=e,n.selectedYear=n.currentYear=i,this._selectDate(t,this._formatDate(n,n.currentDay,n.currentMonth,n.currentYear)))},_clearDate:function(t){t=V(t);this._selectDate(t,"")},_selectDate:function(t,e){var i,t=V(t),t=this._getInst(t[0]);e=null!=e?e:this._formatDate(t),t.input&&t.input.val(e),this._updateAlternate(t),(i=this._get(t,"onSelect"))?i.apply(t.input?t.input[0]:null,[e,t]):t.input&&t.input.trigger("change"),t.inline?this._updateDatepicker(t):(this._hideDatepicker(),this._lastInput=t.input[0],"object"!=typeof t.input[0]&&t.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(t){var e,i,s=this._get(t,"altField");s&&(i=this._get(t,"altFormat")||this._get(t,"dateFormat"),e=this._getDate(t),i=this.formatDate(i,e,this._getFormatConfig(t)),V(document).find(s).val(i))},noWeekends:function(t){t=t.getDay();return[0<t&&t<6,""]},iso8601Week:function(t){var e,t=new Date(t.getTime());return t.setDate(t.getDate()+4-(t.getDay()||7)),e=t.getTime(),t.setMonth(0),t.setDate(1),Math.floor(Math.round((e-t)/864e5)/7)+1},parseDate:function(e,n,t){if(null==e||null==n)throw"Invalid arguments";if(""===(n="object"==typeof n?n.toString():n+""))return null;for(var i,s,o=0,a=(t?t.shortYearCutoff:null)||this._defaults.shortYearCutoff,a="string"!=typeof a?a:(new Date).getFullYear()%100+parseInt(a,10),r=(t?t.dayNamesShort:null)||this._defaults.dayNamesShort,l=(t?t.dayNames:null)||this._defaults.dayNames,h=(t?t.monthNamesShort:null)||this._defaults.monthNamesShort,c=(t?t.monthNames:null)||this._defaults.monthNames,u=-1,d=-1,p=-1,f=-1,g=!1,m=function(t){t=y+1<e.length&&e.charAt(y+1)===t;return t&&y++,t},_=function(t){var e=m(t),e="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,t=new RegExp("^\\d{"+("y"===t?e:1)+","+e+"}"),e=n.substring(o).match(t);if(e)return o+=e[0].length,parseInt(e[0],10);throw"Missing number at position "+o},v=function(t,e,i){var s=-1,t=V.map(m(t)?i:e,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(V.each(t,function(t,e){var i=e[1];if(n.substr(o,i.length).toLowerCase()===i.toLowerCase())return s=e[0],o+=i.length,!1}),-1!==s)return s+1;throw"Unknown name at position "+o},b=function(){if(n.charAt(o)!==e.charAt(y))throw"Unexpected literal at position "+o;o++},y=0;y<e.length;y++)if(g)"'"!==e.charAt(y)||m("'")?b():g=!1;else switch(e.charAt(y)){case"d":p=_("d");break;case"D":v("D",r,l);break;case"o":f=_("o");break;case"m":d=_("m");break;case"M":d=v("M",h,c);break;case"y":u=_("y");break;case"@":u=(s=new Date(_("@"))).getFullYear(),d=s.getMonth()+1,p=s.getDate();break;case"!":u=(s=new Date((_("!")-this._ticksTo1970)/1e4)).getFullYear(),d=s.getMonth()+1,p=s.getDate();break;case"'":m("'")?b():g=!0;break;default:b()}if(o<n.length&&(t=n.substr(o),!/^\s+/.test(t)))throw"Extra/unparsed characters found in date: "+t;if(-1===u?u=(new Date).getFullYear():u<100&&(u+=(new Date).getFullYear()-(new Date).getFullYear()%100+(u<=a?0:-100)),-1<f)for(d=1,p=f;;){if(p<=(i=this._getDaysInMonth(u,d-1)))break;d++,p-=i}if((s=this._daylightSavingAdjust(new Date(u,d-1,p))).getFullYear()!==u||s.getMonth()+1!==d||s.getDate()!==p)throw"Invalid date";return s},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(e,t,i){if(!t)return"";function s(t,e,i){var s=""+e;if(c(t))for(;s.length<i;)s="0"+s;return s}function n(t,e,i,s){return(c(t)?s:i)[e]}var o,a=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,r=(i?i.dayNames:null)||this._defaults.dayNames,l=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,h=(i?i.monthNames:null)||this._defaults.monthNames,c=function(t){t=o+1<e.length&&e.charAt(o+1)===t;return t&&o++,t},u="",d=!1;if(t)for(o=0;o<e.length;o++)if(d)"'"!==e.charAt(o)||c("'")?u+=e.charAt(o):d=!1;else switch(e.charAt(o)){case"d":u+=s("d",t.getDate(),2);break;case"D":u+=n("D",t.getDay(),a,r);break;case"o":u+=s("o",Math.round((new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()-new Date(t.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=s("m",t.getMonth()+1,2);break;case"M":u+=n("M",t.getMonth(),l,h);break;case"y":u+=c("y")?t.getFullYear():(t.getFullYear()%100<10?"0":"")+t.getFullYear()%100;break;case"@":u+=t.getTime();break;case"!":u+=1e4*t.getTime()+this._ticksTo1970;break;case"'":c("'")?u+="'":d=!0;break;default:u+=e.charAt(o)}return u},_possibleChars:function(e){for(var t="",i=!1,s=function(t){t=n+1<e.length&&e.charAt(n+1)===t;return t&&n++,t},n=0;n<e.length;n++)if(i)"'"!==e.charAt(n)||s("'")?t+=e.charAt(n):i=!1;else switch(e.charAt(n)){case"d":case"m":case"y":case"@":t+="0123456789";break;case"D":case"M":return null;case"'":s("'")?t+="'":i=!0;break;default:t+=e.charAt(n)}return t},_get:function(t,e){return(void 0!==t.settings[e]?t.settings:this._defaults)[e]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),o=n,a=this._getFormatConfig(t);try{o=this.parseDate(i,s,a)||n}catch(t){s=e?"":s}t.selectedDay=o.getDate(),t.drawMonth=t.selectedMonth=o.getMonth(),t.drawYear=t.selectedYear=o.getFullYear(),t.currentDay=s?o.getDate():0,t.currentMonth=s?o.getMonth():0,t.currentYear=s?o.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(r,t,e){var i,s=null==t||""===t?e:"string"==typeof t?function(t){try{return V.datepicker.parseDate(V.datepicker._get(r,"dateFormat"),t,V.datepicker._getFormatConfig(r))}catch(t){}for(var e=(t.toLowerCase().match(/^c/)?V.datepicker._getDate(r):null)||new Date,i=e.getFullYear(),s=e.getMonth(),n=e.getDate(),o=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,a=o.exec(t);a;){switch(a[2]||"d"){case"d":case"D":n+=parseInt(a[1],10);break;case"w":case"W":n+=7*parseInt(a[1],10);break;case"m":case"M":s+=parseInt(a[1],10),n=Math.min(n,V.datepicker._getDaysInMonth(i,s));break;case"y":case"Y":i+=parseInt(a[1],10),n=Math.min(n,V.datepicker._getDaysInMonth(i,s))}a=o.exec(t)}return new Date(i,s,n)}(t):"number"==typeof t?isNaN(t)?e:(s=t,(i=new Date).setDate(i.getDate()+s),i):new Date(t.getTime());return(s=s&&"Invalid Date"===s.toString()?e:s)&&(s.setHours(0),s.setMinutes(0),s.setSeconds(0),s.setMilliseconds(0)),this._daylightSavingAdjust(s)},_daylightSavingAdjust:function(t){return t?(t.setHours(12<t.getHours()?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,o=t.selectedYear,e=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=e.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=e.getMonth(),t.drawYear=t.selectedYear=t.currentYear=e.getFullYear(),n===t.selectedMonth&&o===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){return!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay))},_attachHandlers:function(t){var e=this._get(t,"stepMonths"),i="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){V.datepicker._adjustDate(i,-e,"M")},next:function(){V.datepicker._adjustDate(i,+e,"M")},hide:function(){V.datepicker._hideDatepicker()},today:function(){V.datepicker._gotoToday(i)},selectDay:function(){return V.datepicker._selectDay(i,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return V.datepicker._selectMonthYear(i,this,"M"),!1},selectYear:function(){return V.datepicker._selectMonthYear(i,this,"Y"),!1}};V(this).on(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,o,N,W,F,L,a,r,R,l,h,c,u,d,p,f,g,m,_,Y,v,b,B,y,j,q,w,k,x,C=new Date,K=this._daylightSavingAdjust(new Date(C.getFullYear(),C.getMonth(),C.getDate())),D=this._get(t,"isRTL"),C=this._get(t,"showButtonPanel"),I=this._get(t,"hideIfNoPrevNext"),T=this._get(t,"navigationAsDateFormat"),P=this._getNumberOfMonths(t),M=this._get(t,"showCurrentAtPos"),S=this._get(t,"stepMonths"),U=1!==P[0]||1!==P[1],H=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),z=this._getMinMaxDate(t,"min"),O=this._getMinMaxDate(t,"max"),A=t.drawMonth-M,E=t.drawYear;if(A<0&&(A+=12,E--),O)for(e=this._daylightSavingAdjust(new Date(O.getFullYear(),O.getMonth()-P[0]*P[1]+1,O.getDate())),e=z&&e<z?z:e;this._daylightSavingAdjust(new Date(E,A,1))>e;)--A<0&&(A=11,E--);for(t.drawMonth=A,t.drawYear=E,M=this._get(t,"prevText"),M=T?this.formatDate(M,this._daylightSavingAdjust(new Date(E,A-S,1)),this._getFormatConfig(t)):M,i=this._canAdjustMonth(t,-1,E,A)?V("<a>").attr({class:"ui-datepicker-prev ui-corner-all","data-handler":"prev","data-event":"click",title:M}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(D?"e":"w")).text(M))[0].outerHTML:I?"":V("<a>").attr({class:"ui-datepicker-prev ui-corner-all ui-state-disabled",title:M}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(D?"e":"w")).text(M))[0].outerHTML,M=this._get(t,"nextText"),M=T?this.formatDate(M,this._daylightSavingAdjust(new Date(E,A+S,1)),this._getFormatConfig(t)):M,s=this._canAdjustMonth(t,1,E,A)?V("<a>").attr({class:"ui-datepicker-next ui-corner-all","data-handler":"next","data-event":"click",title:M}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(D?"w":"e")).text(M))[0].outerHTML:I?"":V("<a>").attr({class:"ui-datepicker-next ui-corner-all ui-state-disabled",title:M}).append(V("<span>").attr("class","ui-icon ui-icon-circle-triangle-"+(D?"w":"e")).text(M))[0].outerHTML,S=this._get(t,"currentText"),I=this._get(t,"gotoCurrent")&&t.currentDay?H:K,S=T?this.formatDate(S,I,this._getFormatConfig(t)):S,M="",t.inline||(M=V("<button>").attr({type:"button",class:"ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all","data-handler":"hide","data-event":"click"}).text(this._get(t,"closeText"))[0].outerHTML),T="",C&&(T=V("<div class='ui-datepicker-buttonpane ui-widget-content'>").append(D?M:"").append(this._isInRange(t,I)?V("<button>").attr({type:"button",class:"ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all","data-handler":"today","data-event":"click"}).text(S):"").append(D?"":M)[0].outerHTML),n=parseInt(this._get(t,"firstDay"),10),n=isNaN(n)?0:n,o=this._get(t,"showWeek"),N=this._get(t,"dayNames"),W=this._get(t,"dayNamesMin"),F=this._get(t,"monthNames"),L=this._get(t,"monthNamesShort"),a=this._get(t,"beforeShowDay"),r=this._get(t,"showOtherMonths"),R=this._get(t,"selectOtherMonths"),l=this._getDefaultDate(t),h="",u=0;u<P[0];u++){for(d="",this.maxRows=4,p=0;p<P[1];p++){if(f=this._daylightSavingAdjust(new Date(E,A,t.selectedDay)),g=" ui-corner-all",m="",U){if(m+="<div class='ui-datepicker-group",1<P[1])switch(p){case 0:m+=" ui-datepicker-group-first",g=" ui-corner-"+(D?"right":"left");break;case P[1]-1:m+=" ui-datepicker-group-last",g=" ui-corner-"+(D?"left":"right");break;default:m+=" ui-datepicker-group-middle",g=""}m+="'>"}for(m+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+g+"'>"+(/all|left/.test(g)&&0===u?D?s:i:"")+(/all|right/.test(g)&&0===u?D?i:s:"")+this._generateMonthYearHeader(t,A,E,z,O,0<u||0<p,F,L)+"</div><table class='ui-datepicker-calendar'><thead><tr>",_=o?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",c=0;c<7;c++)_+="<th scope='col'"+(5<=(c+n+6)%7?" class='ui-datepicker-week-end'":"")+"><span title='"+N[Y=(c+n)%7]+"'>"+W[Y]+"</span></th>";for(m+=_+"</tr></thead><tbody>",b=this._getDaysInMonth(E,A),E===t.selectedYear&&A===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,b)),v=(this._getFirstDayOfMonth(E,A)-n+7)%7,b=Math.ceil((v+b)/7),B=U&&this.maxRows>b?this.maxRows:b,this.maxRows=B,y=this._daylightSavingAdjust(new Date(E,A,1-v)),j=0;j<B;j++){for(m+="<tr>",q=o?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(y)+"</td>":"",c=0;c<7;c++)w=a?a.apply(t.input?t.input[0]:null,[y]):[!0,""],x=(k=y.getMonth()!==A)&&!R||!w[0]||z&&y<z||O&&O<y,q+="<td class='"+(5<=(c+n+6)%7?" ui-datepicker-week-end":"")+(k?" ui-datepicker-other-month":"")+(y.getTime()===f.getTime()&&A===t.selectedMonth&&t._keyEvent||l.getTime()===y.getTime()&&l.getTime()===f.getTime()?" "+this._dayOverClass:"")+(x?" "+this._unselectableClass+" ui-state-disabled":"")+(k&&!r?"":" "+w[1]+(y.getTime()===H.getTime()?" "+this._currentClass:"")+(y.getTime()===K.getTime()?" ui-datepicker-today":""))+"'"+(k&&!r||!w[2]?"":" title='"+w[2].replace(/'/g,"&#39;")+"'")+(x?"":" data-handler='selectDay' data-event='click' data-month='"+y.getMonth()+"' data-year='"+y.getFullYear()+"'")+">"+(k&&!r?"&#xa0;":x?"<span class='ui-state-default'>"+y.getDate()+"</span>":"<a class='ui-state-default"+(y.getTime()===K.getTime()?" ui-state-highlight":"")+(y.getTime()===H.getTime()?" ui-state-active":"")+(k?" ui-priority-secondary":"")+"' href='#' aria-current='"+(y.getTime()===H.getTime()?"true":"false")+"' data-date='"+y.getDate()+"'>"+y.getDate()+"</a>")+"</td>",y.setDate(y.getDate()+1),y=this._daylightSavingAdjust(y);m+=q+"</tr>"}11<++A&&(A=0,E++),d+=m+="</tbody></table>"+(U?"</div>"+(0<P[0]&&p===P[1]-1?"<div class='ui-datepicker-row-break'></div>":""):"")}h+=d}return h+=T,t._keyEvent=!1,h},_generateMonthYearHeader:function(t,e,i,s,n,o,a,r){var l,h,c,u,d,p,f=this._get(t,"changeMonth"),g=this._get(t,"changeYear"),m=this._get(t,"showMonthAfterYear"),_=this._get(t,"selectMonthLabel"),v=this._get(t,"selectYearLabel"),b="<div class='ui-datepicker-title'>",y="";if(o||!f)y+="<span class='ui-datepicker-month'>"+a[e]+"</span>";else{for(l=s&&s.getFullYear()===i,h=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' aria-label='"+_+"' data-handler='selectMonth' data-event='change'>",c=0;c<12;c++)(!l||c>=s.getMonth())&&(!h||c<=n.getMonth())&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+r[c]+"</option>");y+="</select>"}if(m||(b+=y+(!o&&f&&g?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",o||!g)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(a=this._get(t,"yearRange").split(":"),u=(new Date).getFullYear(),d=(_=function(t){t=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?u+parseInt(t,10):parseInt(t,10);return isNaN(t)?u:t})(a[0]),p=Math.max(d,_(a[1]||"")),d=s?Math.max(d,s.getFullYear()):d,p=n?Math.min(p,n.getFullYear()):p,t.yearshtml+="<select class='ui-datepicker-year' aria-label='"+v+"' data-handler='selectYear' data-event='change'>";d<=p;d++)t.yearshtml+="<option value='"+d+"'"+(d===i?" selected='selected'":"")+">"+d+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),m&&(b+=(!o&&f&&g?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.selectedYear+("Y"===i?e:0),n=t.selectedMonth+("M"===i?e:0),e=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),s=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,e)));t.selectedDay=s.getDate(),t.drawMonth=t.selectedMonth=s.getMonth(),t.drawYear=t.selectedYear=s.getFullYear(),"M"!==i&&"Y"!==i||this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),t=this._getMinMaxDate(t,"max"),i=i&&e<i?i:e;return t&&t<i?t:i},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){t=this._get(t,"numberOfMonths");return null==t?[1,1]:"number"==typeof t?[1,t]:t},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),i=this._daylightSavingAdjust(new Date(i,s+(e<0?e:n[0]*n[1]),1));return e<0&&i.setDate(this._getDaysInMonth(i.getFullYear(),i.getMonth())),this._isInRange(t,i)},_isInRange:function(t,e){var i,s=this._getMinMaxDate(t,"min"),n=this._getMinMaxDate(t,"max"),o=null,a=null,t=this._get(t,"yearRange");return t&&(t=t.split(":"),i=(new Date).getFullYear(),o=parseInt(t[0],10),a=parseInt(t[1],10),t[0].match(/[+\-].*/)&&(o+=i),t[1].match(/[+\-].*/))&&(a+=i),(!s||e.getTime()>=s.getTime())&&(!n||e.getTime()<=n.getTime())&&(!o||e.getFullYear()>=o)&&(!a||e.getFullYear()<=a)},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return{shortYearCutoff:"string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);s=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),s,this._getFormatConfig(t))}}),V.fn.datepicker=function(t){if(!this.length)return this;V.datepicker.initialized||(V(document).on("mousedown",V.datepicker._checkExternalClick),V.datepicker.initialized=!0),0===V("#"+V.datepicker._mainDivId).length&&V("body").append(V.datepicker.dpDiv);var e=Array.prototype.slice.call(arguments,1);return"string"==typeof t&&("isDisabled"===t||"getDate"===t||"widget"===t)||"option"===t&&2===arguments.length&&"string"==typeof arguments[1]?V.datepicker["_"+t+"Datepicker"].apply(V.datepicker,[this[0]].concat(e)):this.each(function(){"string"==typeof t?V.datepicker["_"+t+"Datepicker"].apply(V.datepicker,[this].concat(e)):V.datepicker._attachDatepicker(this,t)})},V.datepicker=new nt,V.datepicker.initialized=!1,V.datepicker.uuid=(new Date).getTime(),V.datepicker.version="1.14.0";V.datepicker;var z=!1;V(document).on("mouseup",function(){z=!1}),V.widget("ui.mouse",{version:"1.14.0",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(t){if(!0===V.data(t.target,e.widgetName+".preventClickEvent"))return V.removeData(t.target,e.widgetName+".preventClickEvent"),t.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(t){var e,i,s;if(!z)return this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(t),i=1===(this._mouseDownEvent=t).which,s="string"==typeof(e=this).options.cancel&&V(t.target).closest(this.options.cancel).length,i&&!s&&this._mouseCapture(t)&&(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){e.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=!1!==this._mouseStart(t),!this._mouseStarted)?t.preventDefault():(!0===V.data(t.target,this.widgetName+".preventClickEvent")&&V.removeData(t.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return e._mouseMove(t)},this._mouseUpDelegate=function(t){return e._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),t.preventDefault(),z=!0)),!0},_mouseMove:function(t){if(this._mouseMoved&&!t.which)if(t.originalEvent.altKey||t.originalEvent.ctrlKey||t.originalEvent.metaKey||t.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(t);return(t.which||t.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=!1!==this._mouseStart(this._mouseDownEvent,t),this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&V.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,z=!1,t.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),V.ui.plugin={add:function(t,e,i){var s,n=V.ui[t].prototype;for(s in i)n.plugins[s]=n.plugins[s]||[],n.plugins[s].push([e,i[s]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;n<o.length;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}},V.widget("ui.draggable",V.ui.mouse,{version:"1.14.0",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){(this.helper||this.element).is(".ui-draggable-dragging")?this.destroyOnClear=!0:(this._removeHandleClassName(),this._mouseDestroy())},_mouseCapture:function(t){var e=this.options;return!(this.helper||e.disabled||0<V(t.target).closest(".ui-resizable-handle").length||(this.handle=this._getHandle(t),!this.handle)||(this._blurActiveElement(t),this._blockFrames(!0===e.iframeFix?"iframe":e.iframeFix),0))},_blockFrames:function(t){this.iframeBlocks=this.document.find(t).map(function(){var t=V(this);return V("<div>").css("position","absolute").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(t){var e=this.document[0].activeElement;V(t.target).closest(e).length||V(e).trigger("blur")},_mouseStart:function(t){var e=this.options;return this.helper=this._createHelper(t),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),V.ui.ddmanager&&(V.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=0<this.helper.parents().filter(function(){return"fixed"===V(this).css("position")}).length,this.positionAbs=this.element.offset(),this._refreshOffsets(t),this.originalPosition=this.position=this._generatePosition(t,!1),this.originalPageX=t.pageX,this.originalPageY=t.pageY,e.cursorAt&&this._adjustOffsetFromHelper(e.cursorAt),this._setContainment(),!1===this._trigger("start",t)?(this._clear(),!1):(this._cacheHelperProportions(),V.ui.ddmanager&&!e.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this._mouseDrag(t,!0),V.ui.ddmanager&&V.ui.ddmanager.dragStart(this,t),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(t,e){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(t,!0),this.positionAbs=this._convertPositionTo("absolute"),!e){e=this._uiHash();if(!1===this._trigger("drag",t,e))return this._mouseUp(new V.Event("mouseup",t)),!1;this.position=e.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",V.ui.ddmanager&&V.ui.ddmanager.drag(this,t),!1},_mouseStop:function(t){var e=this,i=!1;return V.ui.ddmanager&&!this.options.dropBehaviour&&(i=V.ui.ddmanager.drop(this,t)),this.dropped&&(i=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!i||"valid"===this.options.revert&&i||!0===this.options.revert||"function"==typeof this.options.revert&&this.options.revert.call(this.element,i)?V(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){!1!==e._trigger("stop",t)&&e._clear()}):!1!==this._trigger("stop",t)&&this._clear(),!1},_mouseUp:function(t){return this._unblockFrames(),V.ui.ddmanager&&V.ui.ddmanager.dragStop(this,t),this.handleElement.is(t.target)&&this.element.trigger("focus"),V.ui.mouse.prototype._mouseUp.call(this,t)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new V.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(t){return!this.options.handle||!!V(t.target).closest(this.element.find(this.options.handle)).length},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(t){var e=this.options,i="function"==typeof e.helper,t=i?V(e.helper.apply(this.element[0],[t])):"clone"===e.helper?this.element.clone().removeAttr("id"):this.element;return t.parents("body").length||t.appendTo("parent"===e.appendTo?this.element[0].parentNode:e.appendTo),i&&t[0]===this.element[0]&&this._setPositionRelative(),t[0]===this.element[0]||/(fixed|absolute)/.test(t.css("position"))||t.css("position","absolute"),t},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),"left"in(t=Array.isArray(t)?{left:+t[0],top:+t[1]||0}:t)&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var t=this.offsetParent.offset(),e=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==e&&V.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),{top:(t=this._isRootNode(this.offsetParent[0])?{top:0,left:0}:t).top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){var t,e;return"relative"!==this.cssPosition?{top:0,left:0}:(t=this.element.position(),e=this._isRootNode(this.scrollParent[0]),{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())})},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,e=this.options,i=this.document[0];this.relativeContainer=null,e.containment?"window"===e.containment?this.containment=[V(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,V(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,V(window).scrollLeft()+V(window).width()-this.helperProportions.width-this.margins.left,V(window).scrollTop()+(V(window).height()||i.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]:"document"===e.containment?this.containment=[0,0,V(i).width()-this.helperProportions.width-this.margins.left,(V(i).height()||i.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]:e.containment.constructor===Array?this.containment=e.containment:("parent"===e.containment&&(e.containment=this.helper[0].parentNode),(e=(i=V(e.containment))[0])&&(t=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(t?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(t?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i)):this.containment=null},_convertPositionTo:function(t,e){e=e||this.position;var t="absolute"===t?1:-1,i=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*t+this.offset.parent.top*t-("fixed"===this.cssPosition?-this.offset.scroll.top:i?0:this.offset.scroll.top)*t,left:e.left+this.offset.relative.left*t+this.offset.parent.left*t-("fixed"===this.cssPosition?-this.offset.scroll.left:i?0:this.offset.scroll.left)*t}},_generatePosition:function(t,e){var i,s=this.options,n=this._isRootNode(this.scrollParent[0]),o=t.pageX,a=t.pageY;return n&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),{top:(a=e&&(this.containment&&(i=this.relativeContainer?(e=this.relativeContainer.offset(),[this.containment[0]+e.left,this.containment[1]+e.top,this.containment[2]+e.left,this.containment[3]+e.top]):this.containment,t.pageX-this.offset.click.left<i[0]&&(o=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(a=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(o=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3])&&(a=i[3]+this.offset.click.top),s.grid&&(e=s.grid[1]?this.originalPageY+Math.round((a-this.originalPageY)/s.grid[1])*s.grid[1]:this.originalPageY,a=!i||e-this.offset.click.top>=i[1]||e-this.offset.click.top>i[3]?e:e-this.offset.click.top>=i[1]?e-s.grid[1]:e+s.grid[1],t=s.grid[0]?this.originalPageX+Math.round((o-this.originalPageX)/s.grid[0])*s.grid[0]:this.originalPageX,o=!i||t-this.offset.click.left>=i[0]||t-this.offset.click.left>i[2]?t:t-this.offset.click.left>=i[0]?t-s.grid[0]:t+s.grid[0]),"y"===s.axis&&(o=this.originalPageX),"x"===s.axis)?this.originalPageY:a)-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:n?0:this.offset.scroll.top),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:n?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(t,e,i){return i=i||this._uiHash(),V.ui.plugin.call(this,t,[e,i,this],!0),/^(drag|start|stop)/.test(t)&&(this.positionAbs=this._convertPositionTo("absolute"),i.offset=this.positionAbs),V.Widget.prototype._trigger.call(this,t,e,i)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),V.ui.plugin.add("draggable","connectToSortable",{start:function(e,t,i){var s=V.extend({},t,{item:i.element});i.sortables=[],V(i.options.connectToSortable).each(function(){var t=V(this).sortable("instance");t&&!t.options.disabled&&(i.sortables.push(t),t.refreshPositions(),t._trigger("activate",e,s))})},stop:function(e,t,i){var s=V.extend({},t,{item:i.element});i.cancelHelperRemoval=!1,V.each(i.sortables,function(){var t=this;t.isOver?(t.isOver=0,i.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,s))})},drag:function(i,s,n){V.each(n.sortables,function(){var t=!1,e=this;e.positionAbs=n.positionAbs,e.helperProportions=n.helperProportions,e.offset.click=n.offset.click,e._intersectsWith(e.containerCache)&&(t=!0,V.each(n.sortables,function(){return this.positionAbs=n.positionAbs,this.helperProportions=n.helperProportions,this.offset.click=n.offset.click,t=this!==e&&this._intersectsWith(this.containerCache)&&V.contains(e.element[0],this.element[0])?!1:t})),t?(e.isOver||(e.isOver=1,n._parent=s.helper.parent(),e.currentItem=s.helper.appendTo(e.element).data("ui-sortable-item",!0),e.options._helper=e.options.helper,e.options.helper=function(){return s.helper[0]},i.target=e.currentItem[0],e._mouseCapture(i,!0),e._mouseStart(i,!0,!0),e.offset.click.top=n.offset.click.top,e.offset.click.left=n.offset.click.left,e.offset.parent.left-=n.offset.parent.left-e.offset.parent.left,e.offset.parent.top-=n.offset.parent.top-e.offset.parent.top,n._trigger("toSortable",i),n.dropped=e.element,V.each(n.sortables,function(){this.refreshPositions()}),n.currentItem=n.element,e.fromOutside=n),e.currentItem&&(e._mouseDrag(i),s.position=e.position)):e.isOver&&(e.isOver=0,e.cancelHelperRemoval=!0,e.options._revert=e.options.revert,e.options.revert=!1,e._trigger("out",i,e._uiHash(e)),e._mouseStop(i,!0),e.options.revert=e.options._revert,e.options.helper=e.options._helper,e.placeholder&&e.placeholder.remove(),s.helper.appendTo(n._parent),n._refreshOffsets(i),s.position=n._generatePosition(i,!0),n._trigger("fromSortable",i),n.dropped=!1,V.each(n.sortables,function(){this.refreshPositions()}))})}}),V.ui.plugin.add("draggable","cursor",{start:function(t,e,i){var s=V("body"),i=i.options;s.css("cursor")&&(i._cursor=s.css("cursor")),s.css("cursor",i.cursor)},stop:function(t,e,i){i=i.options;i._cursor&&V("body").css("cursor",i._cursor)}}),V.ui.plugin.add("draggable","opacity",{start:function(t,e,i){e=V(e.helper),i=i.options;e.css("opacity")&&(i._opacity=e.css("opacity")),e.css("opacity",i.opacity)},stop:function(t,e,i){i=i.options;i._opacity&&V(e.helper).css("opacity",i._opacity)}}),V.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(t,e,i){var s=i.options,n=!1,o=i.scrollParentNotHidden[0],a=i.document[0];o!==a&&"HTML"!==o.tagName?(s.axis&&"x"===s.axis||(i.overflowOffset.top+o.offsetHeight-t.pageY<s.scrollSensitivity?o.scrollTop=n=o.scrollTop+s.scrollSpeed:t.pageY-i.overflowOffset.top<s.scrollSensitivity&&(o.scrollTop=n=o.scrollTop-s.scrollSpeed)),s.axis&&"y"===s.axis||(i.overflowOffset.left+o.offsetWidth-t.pageX<s.scrollSensitivity?o.scrollLeft=n=o.scrollLeft+s.scrollSpeed:t.pageX-i.overflowOffset.left<s.scrollSensitivity&&(o.scrollLeft=n=o.scrollLeft-s.scrollSpeed))):(s.axis&&"x"===s.axis||(t.pageY-V(a).scrollTop()<s.scrollSensitivity?n=V(a).scrollTop(V(a).scrollTop()-s.scrollSpeed):V(window).height()-(t.pageY-V(a).scrollTop())<s.scrollSensitivity&&(n=V(a).scrollTop(V(a).scrollTop()+s.scrollSpeed))),s.axis&&"y"===s.axis||(t.pageX-V(a).scrollLeft()<s.scrollSensitivity?n=V(a).scrollLeft(V(a).scrollLeft()-s.scrollSpeed):V(window).width()-(t.pageX-V(a).scrollLeft())<s.scrollSensitivity&&(n=V(a).scrollLeft(V(a).scrollLeft()+s.scrollSpeed)))),!1!==n&&V.ui.ddmanager&&!s.dropBehaviour&&V.ui.ddmanager.prepareOffsets(i,t)}}),V.ui.plugin.add("draggable","snap",{start:function(t,e,i){var s=i.options;i.snapElements=[],V(s.snap.constructor!==String?s.snap.items||":data(ui-draggable)":s.snap).each(function(){var t=V(this),e=t.offset();this!==i.element[0]&&i.snapElements.push({item:this,width:t.outerWidth(),height:t.outerHeight(),top:e.top,left:e.left})})},drag:function(t,e,i){for(var s,n,o,a,r,l,h,c,u,d=i.options,p=d.snapTolerance,f=e.offset.left,g=f+i.helperProportions.width,m=e.offset.top,_=m+i.helperProportions.height,v=i.snapElements.length-1;0<=v;v--)l=(r=i.snapElements[v].left-i.margins.left)+i.snapElements[v].width,c=(h=i.snapElements[v].top-i.margins.top)+i.snapElements[v].height,g<r-p||l+p<f||_<h-p||c+p<m||!V.contains(i.snapElements[v].item.ownerDocument,i.snapElements[v].item)?(i.snapElements[v].snapping&&i.options.snap.release&&i.options.snap.release.call(i.element,t,V.extend(i._uiHash(),{snapItem:i.snapElements[v].item})),i.snapElements[v].snapping=!1):("inner"!==d.snapMode&&(s=Math.abs(h-_)<=p,n=Math.abs(c-m)<=p,o=Math.abs(r-g)<=p,a=Math.abs(l-f)<=p,s&&(e.position.top=i._convertPositionTo("relative",{top:h-i.helperProportions.height,left:0}).top),n&&(e.position.top=i._convertPositionTo("relative",{top:c,left:0}).top),o&&(e.position.left=i._convertPositionTo("relative",{top:0,left:r-i.helperProportions.width}).left),a)&&(e.position.left=i._convertPositionTo("relative",{top:0,left:l}).left),u=s||n||o||a,"outer"!==d.snapMode&&(s=Math.abs(h-m)<=p,n=Math.abs(c-_)<=p,o=Math.abs(r-f)<=p,a=Math.abs(l-g)<=p,s&&(e.position.top=i._convertPositionTo("relative",{top:h,left:0}).top),n&&(e.position.top=i._convertPositionTo("relative",{top:c-i.helperProportions.height,left:0}).top),o&&(e.position.left=i._convertPositionTo("relative",{top:0,left:r}).left),a)&&(e.position.left=i._convertPositionTo("relative",{top:0,left:l-i.helperProportions.width}).left),!i.snapElements[v].snapping&&(s||n||o||a||u)&&i.options.snap.snap&&i.options.snap.snap.call(i.element,t,V.extend(i._uiHash(),{snapItem:i.snapElements[v].item})),i.snapElements[v].snapping=s||n||o||a||u)}}),V.ui.plugin.add("draggable","stack",{start:function(t,e,i){var s,i=i.options,i=V.makeArray(V(i.stack)).sort(function(t,e){return(parseInt(V(t).css("zIndex"),10)||0)-(parseInt(V(e).css("zIndex"),10)||0)});i.length&&(s=parseInt(V(i[0]).css("zIndex"),10)||0,V(i).each(function(t){V(this).css("zIndex",s+t)}),this.css("zIndex",s+i.length))}}),V.ui.plugin.add("draggable","zIndex",{start:function(t,e,i){e=V(e.helper),i=i.options;e.css("zIndex")&&(i._zIndex=e.css("zIndex")),e.css("zIndex",i.zIndex)},stop:function(t,e,i){i=i.options;i._zIndex&&V(e.helper).css("zIndex",i._zIndex)}}),V.ui.draggable,V.widget("ui.resizable",V.ui.mouse,{version:"1.14.0",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(t){return parseFloat(t)||0},_isNumber:function(t){return!isNaN(parseFloat(t))},_hasScroll:function(t,e){if("hidden"===V(t).css("overflow"))return!1;var e=e&&"left"===e?"scrollLeft":"scrollTop",i=!1;if(0<t[e])return!0;try{t[e]=1,i=0<t[e],t[e]=0}catch(t){}return i},_create:function(){var t,e=this.options,i=this;this._addClass("ui-resizable"),V.extend(this,{_aspectRatio:!!e.aspectRatio,aspectRatio:e.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:e.helper||e.ghost||e.animate?e.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(V("<div class='ui-wrapper'></div>").css({overflow:"hidden",position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,t={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(t),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this._proportionallyResize()),this._setupHandles(),e.autoHide&&V(this.element).on("mouseenter",function(){e.disabled||(i._removeClass("ui-resizable-autohide"),i._handles.show())}).on("mouseleave",function(){e.disabled||i.resizing||(i._addClass("ui-resizable-autohide"),i._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy(),this._addedHandles.remove();function t(t){V(t).removeData("resizable").removeData("ui-resizable").off(".resizable")}var e;return this.elementIsWrapper&&(t(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),t(this.originalElement),this},_setOption:function(t,e){switch(this._super(t,e),t){case"handles":this._removeHandles(),this._setupHandles();break;case"aspectRatio":this._aspectRatio=!!e}},_setupHandles:function(){var t,e,i,s,n,o=this.options,a=this;if(this.handles=o.handles||(V(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=V(),this._addedHandles=V(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),i=this.handles.split(","),this.handles={},e=0;e<i.length;e++)s="ui-resizable-"+(t=String.prototype.trim.call(i[e])),n=V("<div>"),this._addClass(n,"ui-resizable-handle "+s),n.css({zIndex:o.zIndex}),this.handles[t]=".ui-resizable-"+t,this.element.children(this.handles[t]).length||(this.element.append(n),this._addedHandles=this._addedHandles.add(n));this._renderAxis=function(t){var e,i,s;for(e in t=t||this.element,this.handles)this.handles[e].constructor===String?this.handles[e]=this.element.children(this.handles[e]).first().show():(this.handles[e].jquery||this.handles[e].nodeType)&&(this.handles[e]=V(this.handles[e]),this._on(this.handles[e],{mousedown:a._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(s=V(this.handles[e],this.element),s=/sw|ne|nw|se|n|s/.test(e)?s.outerHeight():s.outerWidth(),i=["padding",/ne|nw|n/.test(e)?"Top":/se|sw|s/.test(e)?"Bottom":/^e$/.test(e)?"Right":"Left"].join(""),t.css(i,s),this._proportionallyResize()),this._handles=this._handles.add(this.handles[e])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){a.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),a.axis=n&&n[1]?n[1]:"se")}),o.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._addedHandles.remove()},_mouseCapture:function(t){var e,i,s=!1;for(e in this.handles)(i=V(this.handles[e])[0])!==t.target&&!V.contains(i,t.target)||(s=!0);return!this.options.disabled&&s},_mouseStart:function(t){var e,i,s=this.options,n=this.element;return this.resizing=!0,this._renderProxy(),e=this._num(this.helper.css("left")),i=this._num(this.helper.css("top")),s.containment&&(e+=V(s.containment).scrollLeft()||0,i+=V(s.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:e,top:i},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:n.width(),height:n.height()},this.originalSize=this._helper?{width:n.outerWidth(),height:n.outerHeight()}:{width:n.width(),height:n.height()},this.sizeDiff={width:n.outerWidth()-n.width(),height:n.outerHeight()-n.height()},this.originalPosition={left:e,top:i},this.originalMousePosition={left:t.pageX,top:t.pageY},this.aspectRatio="number"==typeof s.aspectRatio?s.aspectRatio:this.originalSize.width/this.originalSize.height||1,n=V(".ui-resizable-"+this.axis).css("cursor"),V("body").css("cursor","auto"===n?this.axis+"-resize":n),this._addClass("ui-resizable-resizing"),this._propagate("start",t),!0},_mouseDrag:function(t){var e=this.originalMousePosition,i=this.axis,s=t.pageX-e.left||0,e=t.pageY-e.top||0,i=this._change[i];return this._updatePrevProperties(),i&&(i=i.apply(this,[t,s,e]),this._updateVirtualBoundaries(t.shiftKey),(this._aspectRatio||t.shiftKey)&&(i=this._updateRatio(i,t)),i=this._respectSize(i,t),this._updateCache(i),this._propagate("resize",t),s=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),V.isEmptyObject(s)||(this._updatePrevProperties(),this._trigger("resize",t,this.ui()),this._applyChanges())),!1},_mouseStop:function(t){this.resizing=!1;var e,i,s,n=this.options,o=this;return this._helper&&(i=(e=(i=this._proportionallyResizeElements).length&&/textarea/i.test(i[0].nodeName))&&this._hasScroll(i[0],"left")?0:o.sizeDiff.height,e=e?0:o.sizeDiff.width,e={width:o.helper.width()-e,height:o.helper.height()-i},i=parseFloat(o.element.css("left"))+(o.position.left-o.originalPosition.left)||null,s=parseFloat(o.element.css("top"))+(o.position.top-o.originalPosition.top)||null,n.animate||this.element.css(V.extend(e,{top:s,left:i})),o.helper.height(o.size.height),o.helper.width(o.size.width),this._helper)&&!n.animate&&this._proportionallyResize(),V("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",t),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var t={};return this.position.top!==this.prevPosition.top&&(t.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(t.left=this.position.left+"px"),this.helper.css(t),this.size.width!==this.prevSize.width&&(t.width=this.size.width+"px",this.helper.width(t.width)),this.size.height!==this.prevSize.height&&(t.height=this.size.height+"px",this.helper.height(t.height)),t},_updateVirtualBoundaries:function(t){var e,i,s,n=this.options,n={minWidth:this._isNumber(n.minWidth)?n.minWidth:0,maxWidth:this._isNumber(n.maxWidth)?n.maxWidth:1/0,minHeight:this._isNumber(n.minHeight)?n.minHeight:0,maxHeight:this._isNumber(n.maxHeight)?n.maxHeight:1/0};(this._aspectRatio||t)&&(t=n.minHeight*this.aspectRatio,i=n.minWidth/this.aspectRatio,e=n.maxHeight*this.aspectRatio,s=n.maxWidth/this.aspectRatio,n.minWidth<t&&(n.minWidth=t),n.minHeight<i&&(n.minHeight=i),e<n.maxWidth&&(n.maxWidth=e),s<n.maxHeight)&&(n.maxHeight=s),this._vBoundaries=n},_updateCache:function(t){this.offset=this.helper.offset(),this._isNumber(t.left)&&(this.position.left=t.left),this._isNumber(t.top)&&(this.position.top=t.top),this._isNumber(t.height)&&(this.size.height=t.height),this._isNumber(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,i=this.size,s=this.axis;return this._isNumber(t.height)?t.width=t.height*this.aspectRatio:this._isNumber(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===s&&(t.left=e.left+(i.width-t.width),t.top=null),"nw"===s&&(t.top=e.top+(i.height-t.height),t.left=e.left+(i.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,i=this.axis,s=this._isNumber(t.width)&&e.maxWidth&&e.maxWidth<t.width,n=this._isNumber(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=this._isNumber(t.width)&&e.minWidth&&e.minWidth>t.width,a=this._isNumber(t.height)&&e.minHeight&&e.minHeight>t.height,r=this.originalPosition.left+this.originalSize.width,l=this.originalPosition.top+this.originalSize.height,h=/sw|nw|w/.test(i),i=/nw|ne|n/.test(i);return o&&(t.width=e.minWidth),a&&(t.height=e.minHeight),s&&(t.width=e.maxWidth),n&&(t.height=e.maxHeight),o&&h&&(t.left=r-e.minWidth),s&&h&&(t.left=r-e.maxWidth),a&&i&&(t.top=l-e.minHeight),n&&i&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_getPaddingPlusBorderDimensions:function(t){for(var e=0,i=[],s=[t.css("borderTopWidth"),t.css("borderRightWidth"),t.css("borderBottomWidth"),t.css("borderLeftWidth")],n=[t.css("paddingTop"),t.css("paddingRight"),t.css("paddingBottom"),t.css("paddingLeft")];e<4;e++)i[e]=parseFloat(s[e])||0,i[e]+=parseFloat(n[e])||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var t,e=0,i=this.helper||this.element;e<this._proportionallyResizeElements.length;e++)t=this._proportionallyResizeElements[e],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(t)),t.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var t=this.element,e=this.options;this.elementOffset=t.offset(),this._helper?(this.helper=this.helper||V("<div></div>").css({overflow:"hidden"}),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++e.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize;return{left:this.originalPosition.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize;return{top:this.originalPosition.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(t,e,i){return V.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[t,e,i]))},sw:function(t,e,i){return V.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[t,e,i]))},ne:function(t,e,i){return V.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[t,e,i]))},nw:function(t,e,i){return V.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[t,e,i]))}},_propagate:function(t,e){V.ui.plugin.call(this,t,[e,this.ui()]),"resize"!==t&&this._trigger(t,e,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),V.ui.plugin.add("resizable","animate",{stop:function(e){var i=V(this).resizable("instance"),t=i.options,s=i._proportionallyResizeElements,n=s.length&&/textarea/i.test(s[0].nodeName),o=n&&i._hasScroll(s[0],"left")?0:i.sizeDiff.height,n=n?0:i.sizeDiff.width,n={width:i.size.width-n,height:i.size.height-o},o=parseFloat(i.element.css("left"))+(i.position.left-i.originalPosition.left)||null,a=parseFloat(i.element.css("top"))+(i.position.top-i.originalPosition.top)||null;i.element.animate(V.extend(n,a&&o?{top:a,left:o}:{}),{duration:t.animateDuration,easing:t.animateEasing,step:function(){var t={width:parseFloat(i.element.css("width")),height:parseFloat(i.element.css("height")),top:parseFloat(i.element.css("top")),left:parseFloat(i.element.css("left"))};s&&s.length&&V(s[0]).css({width:t.width,height:t.height}),i._updateCache(t),i._propagate("resize",e)}})}}),V.ui.plugin.add("resizable","containment",{start:function(){var i,s,t,e,n=V(this).resizable("instance"),o=n.options,a=n.element,o=o.containment,a=o instanceof V?o.get(0):/parent/.test(o)?a.parent().get(0):o;a&&(n.containerElement=V(a),/document/.test(o)||o===document?(n.containerOffset={left:0,top:0},n.containerPosition={left:0,top:0},n.parentData={element:V(document),left:0,top:0,width:V(document).width(),height:V(document).height()||document.body.parentNode.scrollHeight}):(i=V(a),s=[],V(["Top","Right","Left","Bottom"]).each(function(t,e){s[t]=n._num(i.css("padding"+e))}),n.containerOffset=i.offset(),n.containerPosition=i.position(),n.containerSize={height:i.innerHeight()-s[3],width:i.innerWidth()-s[1]},o=n.containerOffset,e=n.containerSize.height,t=n.containerSize.width,t=n._hasScroll(a,"left")?a.scrollWidth:t,e=n._hasScroll(a)?a.scrollHeight:e,n.parentData={element:a,left:o.left,top:o.top,width:t,height:e}))},resize:function(t){var e=V(this).resizable("instance"),i=e.options,s=e.containerOffset,n=e.position,t=e._aspectRatio||t.shiftKey,o={top:0,left:0},a=e.containerElement,r=!0;a[0]!==document&&/static/.test(a.css("position"))&&(o=s),n.left<(e._helper?s.left:0)&&(e.size.width=e.size.width+(e._helper?e.position.left-s.left:e.position.left-o.left),t&&(e.size.height=e.size.width/e.aspectRatio,r=!1),e.position.left=i.helper?s.left:0),n.top<(e._helper?s.top:0)&&(e.size.height=e.size.height+(e._helper?e.position.top-s.top:e.position.top),t&&(e.size.width=e.size.height*e.aspectRatio,r=!1),e.position.top=e._helper?s.top:0),a=e.containerElement.get(0)===e.element.parent().get(0),i=/relative|absolute/.test(e.containerElement.css("position")),a&&i?(e.offset.left=e.parentData.left+e.position.left,e.offset.top=e.parentData.top+e.position.top):(e.offset.left=e.element.offset().left,e.offset.top=e.element.offset().top),n=Math.abs(e.sizeDiff.width+(e._helper?e.offset.left-o.left:e.offset.left-s.left)),a=Math.abs(e.sizeDiff.height+(e._helper?e.offset.top-o.top:e.offset.top-s.top)),n+e.size.width>=e.parentData.width&&(e.size.width=e.parentData.width-n,t)&&(e.size.height=e.size.width/e.aspectRatio,r=!1),a+e.size.height>=e.parentData.height&&(e.size.height=e.parentData.height-a,t)&&(e.size.width=e.size.height*e.aspectRatio,r=!1),r||(e.position.left=e.prevPosition.left,e.position.top=e.prevPosition.top,e.size.width=e.prevSize.width,e.size.height=e.prevSize.height)},stop:function(){var t=V(this).resizable("instance"),e=t.options,i=t.containerOffset,s=t.containerPosition,n=t.containerElement,o=V(t.helper),a=o.offset(),r=o.outerWidth()-t.sizeDiff.width,o=o.outerHeight()-t.sizeDiff.height;t._helper&&!e.animate&&/relative/.test(n.css("position"))&&V(this).css({left:a.left-s.left-i.left,width:r,height:o}),t._helper&&!e.animate&&/static/.test(n.css("position"))&&V(this).css({left:a.left-s.left-i.left,width:r,height:o})}}),V.ui.plugin.add("resizable","alsoResize",{start:function(){var t=V(this).resizable("instance").options;V(t.alsoResize).each(function(){var t=V(this);t.data("ui-resizable-alsoresize",{width:parseFloat(t.css("width")),height:parseFloat(t.css("height")),left:parseFloat(t.css("left")),top:parseFloat(t.css("top"))})})},resize:function(t,i){var e=V(this).resizable("instance"),s=e.options,n=e.originalSize,o=e.originalPosition,a={height:e.size.height-n.height||0,width:e.size.width-n.width||0,top:e.position.top-o.top||0,left:e.position.left-o.left||0};V(s.alsoResize).each(function(){var t=V(this),s=V(this).data("ui-resizable-alsoresize"),n={},e=t.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];V.each(e,function(t,e){var i=(s[e]||0)+(a[e]||0);i&&0<=i&&(n[e]=i||null)}),t.css(n)})},stop:function(){V(this).removeData("ui-resizable-alsoresize")}}),V.ui.plugin.add("resizable","ghost",{start:function(){var t=V(this).resizable("instance"),e=t.size;t.ghost=t.originalElement.clone(),t.ghost.css({opacity:.25,display:"block",position:"relative",height:e.height,width:e.width,margin:0,left:0,top:0}),t._addClass(t.ghost,"ui-resizable-ghost"),!0===V.uiBackCompat&&"string"==typeof t.options.ghost&&t.ghost.addClass(this.options.ghost),t.ghost.appendTo(t.helper)},resize:function(){var t=V(this).resizable("instance");t.ghost&&t.ghost.css({position:"relative",height:t.size.height,width:t.size.width})},stop:function(){var t=V(this).resizable("instance");t.ghost&&t.helper&&t.helper.get(0).removeChild(t.ghost.get(0))}}),V.ui.plugin.add("resizable","grid",{resize:function(){var t,e=V(this).resizable("instance"),i=e.options,s=e.size,n=e.originalSize,o=e.originalPosition,a=e.axis,r="number"==typeof i.grid?[i.grid,i.grid]:i.grid,l=r[0]||1,h=r[1]||1,c=Math.round((s.width-n.width)/l)*l,s=Math.round((s.height-n.height)/h)*h,u=n.width+c,d=n.height+s,p=i.maxWidth&&i.maxWidth<u,f=i.maxHeight&&i.maxHeight<d,g=i.minWidth&&i.minWidth>u,m=i.minHeight&&i.minHeight>d;i.grid=r,g&&(u+=l),m&&(d+=h),p&&(u-=l),f&&(d-=h),/^(se|s|e)$/.test(a)?(e.size.width=u,e.size.height=d):/^(ne)$/.test(a)?(e.size.width=u,e.size.height=d,e.position.top=o.top-s):/^(sw)$/.test(a)?(e.size.width=u,e.size.height=d,e.position.left=o.left-c):((d-h<=0||u-l<=0)&&(t=e._getPaddingPlusBorderDimensions(this)),0<d-h?(e.size.height=d,e.position.top=o.top-s):(d=h-t.height,e.size.height=d,e.position.top=o.top+n.height-d),0<u-l?(e.size.width=u,e.position.left=o.left-c):(u=l-t.width,e.size.width=u,e.position.left=o.left+n.width-u))}}),V.ui.resizable,V.widget("ui.dialog",{version:"1.14.0",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(t){var e=V(this).css(t).offset().top;e<0&&V(this).css("top",t.top-e)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&V.fn.draggable&&this._makeDraggable(),this.options.resizable&&V.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var t=this.options.appendTo;return t&&(t.jquery||t.nodeType)?V(t):this.document.find(t||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),(t=e.parent.children().eq(e.index)).length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog},disable:V.noop,enable:V.noop,close:function(t){var e=this;this._isOpen&&!1!==this._trigger("beforeClose",t)&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||V(this.document[0].activeElement).trigger("blur"),this._hide(this.uiDialog,this.options.hide,function(){e._trigger("close",t)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(t,e){var i=!1,s=this.uiDialog.siblings(".ui-front:visible").map(function(){return+V(this).css("z-index")}).get(),s=Math.max.apply(null,s);return s>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",s+1),i=!0),i&&!e&&this._trigger("focus",t),i},open:function(){var t=this;this._isOpen?this._moveToTop()&&this._focusTabbable():(this._isOpen=!0,this.opener=V(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){t._focusTabbable(),t._trigger("focus")}),this._makeFocusTarget(),this._trigger("open"))},_focusTabbable:function(){var t=this._focusedElement;(t=(t=(t=(t=(t=t||this.element.find("[autofocus]")).length?t:this.element.find(":tabbable")).length?t:this.uiDialogButtonPane.find(":tabbable")).length?t:this.uiDialogTitlebarClose.filter(":tabbable")).length?t:this.uiDialog).eq(0).trigger("focus")},_restoreTabbableFocus:function(){var t=this.document[0].activeElement;this.uiDialog[0]===t||V.contains(this.uiDialog[0],t)||this._focusTabbable()},_keepFocus:function(t){t.preventDefault(),this._restoreTabbableFocus()},_createWrapper:function(){this.uiDialog=V("<div>").hide().attr({tabIndex:-1,role:"dialog","aria-modal":this.options.modal?"true":null}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(t){var e,i,s;this.options.closeOnEscape&&!t.isDefaultPrevented()&&t.keyCode&&t.keyCode===V.ui.keyCode.ESCAPE?(t.preventDefault(),this.close(t)):t.keyCode!==V.ui.keyCode.TAB||t.isDefaultPrevented()||(e=this.uiDialog.find(":tabbable"),i=e.first(),s=e.last(),t.target!==s[0]&&t.target!==this.uiDialog[0]||t.shiftKey?t.target!==i[0]&&t.target!==this.uiDialog[0]||!t.shiftKey||(this._delay(function(){s.trigger("focus")}),t.preventDefault()):(this._delay(function(){i.trigger("focus")}),t.preventDefault()))},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var t;this.uiDialogTitlebar=V("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(t){V(t.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=V("<button type='button'></button>").button({label:V("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}}),t=V("<span>").uniqueId().prependTo(this.uiDialogTitlebar),this._addClass(t,"ui-dialog-title"),this._title(t),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":t.attr("id")})},_title:function(t){this.options.title?t.text(this.options.title):t.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=V("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=V("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var s=this,t=this.options.buttons;this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),V.isEmptyObject(t)||Array.isArray(t)&&!t.length?this._removeClass(this.uiDialog,"ui-dialog-buttons"):(V.each(t,function(t,e){var i;e=V.extend({type:"button"},e="function"==typeof e?{click:e,text:t}:e),i=e.click,t={icon:e.icon,iconPosition:e.iconPosition,showLabel:e.showLabel,icons:e.icons,text:e.text},delete e.click,delete e.icon,delete e.iconPosition,delete e.showLabel,delete e.icons,"boolean"==typeof e.text&&delete e.text,V("<button></button>",e).button(t).appendTo(s.uiButtonSet).on("click",function(){i.apply(s.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog))},_makeDraggable:function(){var n=this,o=this.options;function a(t){return{position:t.position,offset:t.offset}}this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(t,e){n._addClass(V(this),"ui-dialog-dragging"),n._blockFrames(),n._trigger("dragStart",t,a(e))},drag:function(t,e){n._trigger("drag",t,a(e))},stop:function(t,e){var i=e.offset.left-n.document.scrollLeft(),s=e.offset.top-n.document.scrollTop();o.position={my:"left top",at:"left"+(0<=i?"+":"")+i+" top"+(0<=s?"+":"")+s,of:n.window},n._removeClass(V(this),"ui-dialog-dragging"),n._unblockFrames(),n._trigger("dragStop",t,a(e))}})},_makeResizable:function(){var n=this,o=this.options,t=o.resizable,e=this.uiDialog.css("position"),t="string"==typeof t?t:"n,e,s,w,se,sw,ne,nw";function a(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}}this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:o.maxWidth,maxHeight:o.maxHeight,minWidth:o.minWidth,minHeight:this._minHeight(),handles:t,start:function(t,e){n._addClass(V(this),"ui-dialog-resizing"),n._blockFrames(),n._trigger("resizeStart",t,a(e))},resize:function(t,e){n._trigger("resize",t,a(e))},stop:function(t,e){var i=n.uiDialog.offset(),s=i.left-n.document.scrollLeft(),i=i.top-n.document.scrollTop();o.height=n.uiDialog.height(),o.width=n.uiDialog.width(),o.position={my:"left top",at:"left"+(0<=s?"+":"")+s+" top"+(0<=i?"+":"")+i,of:n.window},n._removeClass(V(this),"ui-dialog-resizing"),n._unblockFrames(),n._trigger("resizeStop",t,a(e))}}).css("position",e)},_trackFocus:function(){this._on(this.widget(),{focusin:function(t){this._makeFocusTarget(),this._focusedElement=V(t.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var t=this._trackingInstances(),e=V.inArray(this,t);-1!==e&&t.splice(e,1)},_trackingInstances:function(){var t=this.document.data("ui-dialog-instances");return t||this.document.data("ui-dialog-instances",t=[]),t},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(t){var i=this,s=!1,n={};V.each(t,function(t,e){i._setOption(t,e),t in i.sizeRelatedOptions&&(s=!0),t in i.resizableRelatedOptions&&(n[t]=e)}),s&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",n)},_setOption:function(t,e){var i,s=this.uiDialog;"disabled"!==t&&(this._super(t,e),"appendTo"===t&&this.uiDialog.appendTo(this._appendTo()),"buttons"===t&&this._createButtons(),"closeText"===t&&this.uiDialogTitlebarClose.button({label:V("<a>").text(""+this.options.closeText).html()}),"draggable"===t&&((i=s.is(":data(ui-draggable)"))&&!e&&s.draggable("destroy"),!i)&&e&&this._makeDraggable(),"position"===t&&this._position(),"resizable"===t&&((i=s.is(":data(ui-resizable)"))&&!e&&s.resizable("destroy"),i&&"string"==typeof e&&s.resizable("option","handles",e),i||!1===e||this._makeResizable()),"title"===t&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")),"modal"===t)&&s.attr("aria-modal",e?"true":null)},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var t=V(this);return V("<div>").css({position:"absolute",width:t.outerWidth(),height:t.outerHeight()}).appendTo(t.parent()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(t){return!!V(t.target).closest(".ui-dialog").length||!!V(t.target).closest(".ui-datepicker").length},_createOverlay:function(){var i;this.options.modal&&(i=!0,this._delay(function(){i=!1}),this.document.data("ui-dialog-overlays")||this.document.on("focusin.ui-dialog",function(t){var e;i||(e=this._trackingInstances()[0])._allowInteraction(t)||(t.preventDefault(),e._focusTabbable())}.bind(this)),this.overlay=V("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1))},_destroyOverlay:function(){var t;this.options.modal&&this.overlay&&((t=this.document.data("ui-dialog-overlays")-1)?this.document.data("ui-dialog-overlays",t):(this.document.off("focusin.ui-dialog"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null)}}),!0===V.uiBackCompat&&V.widget("ui.dialog",V.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(t,e){"dialogClass"===t&&this.uiDialog.removeClass(this.options.dialogClass).addClass(e),this._superApply(arguments)}}),V.ui.dialog;function rt(t,e,i){return e<=t&&t<e+i}V.widget("ui.droppable",{version:"1.14.0",widgetEventPrefix:"drop",options:{accept:"*",addClasses:!0,greedy:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var t,e=this.options,i=e.accept;this.isover=!1,this.isout=!0,this.accept="function"==typeof i?i:function(t){return t.is(i)},this.proportions=function(){if(!arguments.length)return t=t||{width:this.element[0].offsetWidth,height:this.element[0].offsetHeight};t=arguments[0]},this._addToManager(e.scope),e.addClasses&&this._addClass("ui-droppable")},_addToManager:function(t){V.ui.ddmanager.droppables[t]=V.ui.ddmanager.droppables[t]||[],V.ui.ddmanager.droppables[t].push(this)},_splice:function(t){for(var e=0;e<t.length;e++)t[e]===this&&t.splice(e,1)},_destroy:function(){var t=V.ui.ddmanager.droppables[this.options.scope];this._splice(t)},_setOption:function(t,e){var i;"accept"===t?this.accept="function"==typeof e?e:function(t){return t.is(e)}:"scope"===t&&(i=V.ui.ddmanager.droppables[this.options.scope],this._splice(i),this._addToManager(e)),this._super(t,e)},_activate:function(t){var e=V.ui.ddmanager.current;this._addActiveClass(),e&&this._trigger("activate",t,this.ui(e))},_deactivate:function(t){var e=V.ui.ddmanager.current;this._removeActiveClass(),e&&this._trigger("deactivate",t,this.ui(e))},_over:function(t){var e=V.ui.ddmanager.current;e&&(e.currentItem||e.element)[0]!==this.element[0]&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this._addHoverClass(),this._trigger("over",t,this.ui(e)))},_out:function(t){var e=V.ui.ddmanager.current;e&&(e.currentItem||e.element)[0]!==this.element[0]&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this._removeHoverClass(),this._trigger("out",t,this.ui(e)))},_drop:function(e,t){var i=t||V.ui.ddmanager.current,s=!1;return!(!i||(i.currentItem||i.element)[0]===this.element[0]||(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var t=V(this).droppable("instance");if(t.options.greedy&&!t.options.disabled&&t.options.scope===i.options.scope&&t.accept.call(t.element[0],i.currentItem||i.element)&&V.ui.intersect(i,V.extend(t,{offset:t.element.offset()}),t.options.tolerance,e))return!(s=!0)}),s)||!this.accept.call(this.element[0],i.currentItem||i.element))&&(this._removeActiveClass(),this._removeHoverClass(),this._trigger("drop",e,this.ui(i)),this.element)},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}},_addHoverClass:function(){this._addClass("ui-droppable-hover")},_removeHoverClass:function(){this._removeClass("ui-droppable-hover")},_addActiveClass:function(){this._addClass("ui-droppable-active")},_removeActiveClass:function(){this._removeClass("ui-droppable-active")}}),V.ui.intersect=function(t,e,i,s){if(!e.offset)return!1;var n=(t.positionAbs||t.position.absolute).left+t.margins.left,o=(t.positionAbs||t.position.absolute).top+t.margins.top,a=n+t.helperProportions.width,r=o+t.helperProportions.height,l=e.offset.left,h=e.offset.top,c=l+e.proportions().width,u=h+e.proportions().height;switch(i){case"fit":return l<=n&&a<=c&&h<=o&&r<=u;case"intersect":return l<n+t.helperProportions.width/2&&a-t.helperProportions.width/2<c&&h<o+t.helperProportions.height/2&&r-t.helperProportions.height/2<u;case"pointer":return rt(s.pageY,h,e.proportions().height)&&rt(s.pageX,l,e.proportions().width);case"touch":return(h<=o&&o<=u||h<=r&&r<=u||o<h&&u<r)&&(l<=n&&n<=c||l<=a&&a<=c||n<l&&c<a);default:return!1}},V.ui.ddmanager={current:null,droppables:{default:[]},prepareOffsets:function(t,e){var i,s,n=V.ui.ddmanager.droppables[t.options.scope]||[],o=e?e.type:null,a=(t.currentItem||t.element).find(":data(ui-droppable)").addBack();t:for(i=0;i<n.length;i++)if(!(n[i].options.disabled||t&&!n[i].accept.call(n[i].element[0],t.currentItem||t.element))){for(s=0;s<a.length;s++)if(a[s]===n[i].element[0]){n[i].proportions().height=0;continue t}n[i].visible="none"!==n[i].element.css("display"),n[i].visible&&("mousedown"===o&&n[i]._activate.call(n[i],e),n[i].offset=n[i].element.offset(),n[i].proportions({width:n[i].element[0].offsetWidth,height:n[i].element[0].offsetHeight}))}},drop:function(t,e){var i=!1;return V.each((V.ui.ddmanager.droppables[t.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&V.ui.intersect(t,this,this.options.tolerance,e)&&(i=this._drop.call(this,e)||i),!this.options.disabled)&&this.visible&&this.accept.call(this.element[0],t.currentItem||t.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,e))}),i},dragStart:function(t,e){t.element.parentsUntil("body").on("scroll.droppable",function(){t.options.refreshPositions||V.ui.ddmanager.prepareOffsets(t,e)})},drag:function(n,o){n.options.refreshPositions&&V.ui.ddmanager.prepareOffsets(n,o),V.each(V.ui.ddmanager.droppables[n.options.scope]||[],function(){var t,e,i,s;this.options.disabled||this.greedyChild||!this.visible||(s=!(s=V.ui.intersect(n,this,this.options.tolerance,o))&&this.isover?"isout":s&&!this.isover?"isover":null)&&(this.options.greedy&&(e=this.options.scope,(i=this.element.parents(":data(ui-droppable)").filter(function(){return V(this).droppable("instance").options.scope===e})).length)&&((t=V(i[0]).droppable("instance")).greedyChild="isover"===s),t&&"isover"===s&&(t.isover=!1,t.isout=!0,t._out.call(t,o)),this[s]=!0,this["isout"===s?"isover":"isout"]=!1,this["isover"===s?"_over":"_out"].call(this,o),t)&&"isout"===s&&(t.isout=!1,t.isover=!0,t._over.call(t,o))})},dragStop:function(t,e){t.element.parentsUntil("body").off("scroll.droppable"),t.options.refreshPositions||V.ui.ddmanager.prepareOffsets(t,e)}},!0===V.uiBackCompat&&V.widget("ui.droppable",V.ui.droppable,{options:{hoverClass:!1,activeClass:!1},_addActiveClass:function(){this._super(),this.options.activeClass&&this.element.addClass(this.options.activeClass)},_removeActiveClass:function(){this._super(),this.options.activeClass&&this.element.removeClass(this.options.activeClass)},_addHoverClass:function(){this._super(),this.options.hoverClass&&this.element.addClass(this.options.hoverClass)},_removeHoverClass:function(){this._super(),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass)}});V.ui.droppable,V.widget("ui.progressbar",{version:"1.14.0",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.attr({role:"progressbar","aria-valuemin":this.min}),this._addClass("ui-progressbar","ui-widget ui-widget-content"),this.valueDiv=V("<div>").appendTo(this.element),this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header"),this._refreshValue()},_destroy:function(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"),this.valueDiv.remove()},value:function(t){if(void 0===t)return this.options.value;this.options.value=this._constrainedValue(t),this._refreshValue()},_constrainedValue:function(t){return void 0===t&&(t=this.options.value),this.indeterminate=!1===t,"number"!=typeof t&&(t=0),!this.indeterminate&&Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var t=this.options.value,e=this._percentage();this.valueDiv.toggle(this.indeterminate||t>this.min).width(e.toFixed(0)+"%"),this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,t===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=V("<div>").appendTo(this.valueDiv),this._addClass(this.overlayDiv,"ui-progressbar-overlay"))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":t}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==t&&(this.oldValue=t,this._trigger("change")),t===this.options.max&&this._trigger("complete")}}),V.widget("ui.selectable",V.ui.mouse,{version:"1.14.0",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var i=this;this._addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){i.elementPos=V(i.element[0]).offset(),i.selectees=V(i.options.filter,i.element[0]),i._addClass(i.selectees,"ui-selectee"),i.selectees.each(function(){var t=V(this),e=t.offset(),e={left:e.left-i.elementPos.left,top:e.top-i.elementPos.top};V.data(this,"selectable-item",{element:this,$element:t,left:e.left,top:e.top,right:e.left+t.outerWidth(),bottom:e.top+t.outerHeight(),startselected:!1,selected:t.hasClass("ui-selected"),selecting:t.hasClass("ui-selecting"),unselecting:t.hasClass("ui-unselecting")})})},this.refresh(),this._mouseInit(),this.helper=V("<div>"),this._addClass(this.helper,"ui-selectable-helper")},_destroy:function(){this.selectees.removeData("selectable-item"),this._mouseDestroy()},_mouseStart:function(i){var s=this,t=this.options;this.opos=[i.pageX,i.pageY],this.elementPos=V(this.element[0]).offset(),this.options.disabled||(this.selectees=V(t.filter,this.element[0]),this._trigger("start",i),V(t.appendTo).append(this.helper),this.helper.css({left:i.pageX,top:i.pageY,width:0,height:0}),t.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var t=V.data(this,"selectable-item");t.startselected=!0,i.metaKey||i.ctrlKey||(s._removeClass(t.$element,"ui-selected"),t.selected=!1,s._addClass(t.$element,"ui-unselecting"),t.unselecting=!0,s._trigger("unselecting",i,{unselecting:t.element}))}),V(i.target).parents().addBack().each(function(){var t,e=V.data(this,"selectable-item");if(e)return t=!i.metaKey&&!i.ctrlKey||!e.$element.hasClass("ui-selected"),s._removeClass(e.$element,t?"ui-unselecting":"ui-selected")._addClass(e.$element,t?"ui-selecting":"ui-unselecting"),e.unselecting=!t,e.selecting=t,(e.selected=t)?s._trigger("selecting",i,{selecting:e.element}):s._trigger("unselecting",i,{unselecting:e.element}),!1}))},_mouseDrag:function(s){var t,n,o,a,r,l,h;if(this.dragged=!0,!this.options.disabled)return o=(n=this).options,a=this.opos[0],r=this.opos[1],l=s.pageX,h=s.pageY,l<a&&(t=l,l=a,a=t),h<r&&(t=h,h=r,r=t),this.helper.css({left:a,top:r,width:l-a,height:h-r}),this.selectees.each(function(){var t=V.data(this,"selectable-item"),e=!1,i={};t&&t.element!==n.element[0]&&(i.left=t.left+n.elementPos.left,i.right=t.right+n.elementPos.left,i.top=t.top+n.elementPos.top,i.bottom=t.bottom+n.elementPos.top,"touch"===o.tolerance?e=!(l<i.left||i.right<a||h<i.top||i.bottom<r):"fit"===o.tolerance&&(e=a<i.left&&i.right<l&&r<i.top&&i.bottom<h),e?(t.selected&&(n._removeClass(t.$element,"ui-selected"),t.selected=!1),t.unselecting&&(n._removeClass(t.$element,"ui-unselecting"),t.unselecting=!1),t.selecting||(n._addClass(t.$element,"ui-selecting"),t.selecting=!0,n._trigger("selecting",s,{selecting:t.element}))):(t.selecting&&((s.metaKey||s.ctrlKey)&&t.startselected?(n._removeClass(t.$element,"ui-selecting"),t.selecting=!1,n._addClass(t.$element,"ui-selected"),t.selected=!0):(n._removeClass(t.$element,"ui-selecting"),t.selecting=!1,t.startselected&&(n._addClass(t.$element,"ui-unselecting"),t.unselecting=!0),n._trigger("unselecting",s,{unselecting:t.element}))),!t.selected||s.metaKey||s.ctrlKey||t.startselected||(n._removeClass(t.$element,"ui-selected"),t.selected=!1,n._addClass(t.$element,"ui-unselecting"),t.unselecting=!0,n._trigger("unselecting",s,{unselecting:t.element}))))}),!1},_mouseStop:function(e){var i=this;return this.dragged=!1,V(".ui-unselecting",this.element[0]).each(function(){var t=V.data(this,"selectable-item");i._removeClass(t.$element,"ui-unselecting"),t.unselecting=!1,t.startselected=!1,i._trigger("unselected",e,{unselected:t.element})}),V(".ui-selecting",this.element[0]).each(function(){var t=V.data(this,"selectable-item");i._removeClass(t.$element,"ui-selecting")._addClass(t.$element,"ui-selected"),t.selecting=!1,t.selected=!0,t.startselected=!0,i._trigger("selected",e,{selected:t.element})}),this._trigger("stop",e),this.helper.remove(),!1}}),V.widget("ui.selectmenu",[V.ui.formResetMixin,{version:"1.14.0",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:!1,change:null,close:null,focus:null,open:null,select:null},_create:function(){var t=this.element.uniqueId().attr("id");this.ids={element:t,button:t+"-button",menu:t+"-menu"},this._drawButton(),this._drawMenu(),this._bindFormResetHandler(),this._rendered=!1,this.menuItems=V()},_drawButton:function(){var t,e=this,i=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);this.labels=this.element.labels().attr("for",this.ids.button),this._on(this.labels,{click:function(t){this.button.trigger("focus"),t.preventDefault()}}),this.element.hide(),this.button=V("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element),this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget"),t=V("<span>").appendTo(this.button),this._addClass(t,"ui-selectmenu-icon","ui-icon "+this.options.icons.button),this.buttonItem=this._renderButtonItem(i).appendTo(this.button),!1!==this.options.width&&this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one("focusin",function(){e._rendered||e._refreshMenu()})},_drawMenu:function(){var i=this;this.menu=V("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu}),this.menuWrap=V("<div>").append(this.menu),this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front"),this.menuWrap.appendTo(this._appendTo()),this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function(t,e){t.preventDefault(),i._select(e.item.data("ui-selectmenu-item"),t)},focus:function(t,e){e=e.item.data("ui-selectmenu-item");null!=i.focusIndex&&e.index!==i.focusIndex&&(i._trigger("focus",t,{item:e}),i.isOpen||i._select(e,t)),i.focusIndex=e.index,i.button.attr("aria-activedescendant",i.menuItems.eq(e.index).attr("id"))}}).menu("instance"),this.menuInstance._off(this.menu,"mouseleave"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item")||{})),null===this.options.width&&this._resizeButton()},_refreshMenu:function(){var t=this.element.find("option");this.menu.empty(),this._parseOptions(t),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"),this._rendered=!0,t.length&&(t=this._getSelectedItem(),this.menuInstance.focus(null,t),this._setAria(t.data("ui-selectmenu-item")),this._setOption("disabled",this.element.prop("disabled")))},open:function(t){this.options.disabled||(this._rendered?(this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.menuItems.length&&(this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger("open",t)))},_position:function(){this.menuWrap.position(V.extend({of:this.button},this.options.position))},close:function(t){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger("close",t))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderButtonItem:function(t){var e=V("<span>");return this._setText(e,t.label),this._addClass(e,"ui-selectmenu-text"),e},_renderMenu:function(s,t){var n=this,o="";V.each(t,function(t,e){var i;e.optgroup!==o&&(i=V("<li>",{text:e.optgroup}),n._addClass(i,"ui-selectmenu-optgroup","ui-menu-divider"+(e.element.parent("optgroup").prop("disabled")?" ui-state-disabled":"")),i.appendTo(s),o=e.optgroup),n._renderItemData(s,e)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-selectmenu-item",e)},_renderItem:function(t,e){var i=V("<li>"),s=V("<div>",{title:e.element.attr("title")});return e.disabled&&this._addClass(i,null,"ui-state-disabled"),e.hidden?i.prop("hidden",!0):this._setText(s,e.label),i.append(s).appendTo(t)},_setText:function(t,e){e?t.text(e):t.html("&#160;")},_move:function(t,e){var i,s=".ui-menu-item";this.isOpen?i=this.menuItems.eq(this.focusIndex).parent("li"):(i=this.menuItems.eq(this.element[0].selectedIndex).parent("li"),s+=":not(.ui-state-disabled)"),(i="first"===t||"last"===t?i["first"===t?"prevAll":"nextAll"](s).eq(-1):i[t+"All"](s).eq(0)).length&&this.menuInstance.focus(e,i)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li")},_toggle:function(t){this[this.isOpen?"close":"open"](t)},_setSelection:function(){var t;this.range&&((t=window.getSelection()).removeAllRanges(),t.addRange(this.range))},_documentClick:{mousedown:function(t){!this.isOpen||V(t.target).closest(".ui-selectmenu-menu, #"+CSS.escape(this.ids.button)).length||this.close(t)}},_buttonEvents:{mousedown:function(){var t=window.getSelection();t.rangeCount&&(this.range=t.getRangeAt(0))},click:function(t){this._setSelection(),this._toggle(t)},keydown:function(t){var e=!0;switch(t.keyCode){case V.ui.keyCode.TAB:case V.ui.keyCode.ESCAPE:this.close(t),e=!1;break;case V.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(t);break;case V.ui.keyCode.UP:t.altKey?this._toggle(t):this._move("prev",t);break;case V.ui.keyCode.DOWN:t.altKey?this._toggle(t):this._move("next",t);break;case V.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(t):this._toggle(t);break;case V.ui.keyCode.LEFT:this._move("prev",t);break;case V.ui.keyCode.RIGHT:this._move("next",t);break;case V.ui.keyCode.HOME:case V.ui.keyCode.PAGE_UP:this._move("first",t);break;case V.ui.keyCode.END:case V.ui.keyCode.PAGE_DOWN:this._move("last",t);break;default:this.menu.trigger(t),e=!1}e&&t.preventDefault()}},_selectFocusedItem:function(t){var e=this.menuItems.eq(this.focusIndex).parent("li");e.hasClass("ui-state-disabled")||this._select(e.data("ui-selectmenu-item"),t)},_select:function(t,e){var i=this.element[0].selectedIndex;this.element[0].selectedIndex=t.index,this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(t)),this._setAria(t),this._trigger("select",e,{item:t}),t.index!==i&&this._trigger("change",e,{item:t}),this.close(e)},_setAria:function(t){t=this.menuItems.eq(t.index).attr("id");this.button.attr({"aria-labelledby":t,"aria-activedescendant":t}),this.menu.attr("aria-activedescendant",t)},_setOption:function(t,e){var i;"icons"===t&&(i=this.button.find("span.ui-icon"),this._removeClass(i,null,this.options.icons.button)._addClass(i,null,e.button)),this._super(t,e),"appendTo"===t&&this.menuWrap.appendTo(this._appendTo()),"width"===t&&this._resizeButton()},_setOptionDisabled:function(t){this._super(t),this.menuInstance.option("disabled",t),this.button.attr("aria-disabled",t),this._toggleClass(this.button,null,"ui-state-disabled",t),this.element.prop("disabled",t),t?(this.button.attr("tabindex",-1),this.close()):this.button.attr("tabindex",0)},_appendTo:function(){var t=this.options.appendTo;return t=(t=(t=t&&(t.jquery||t.nodeType?V(t):this.document.find(t).eq(0)))&&t[0]?t:this.element.closest(".ui-front, dialog")).length?t:this.document[0].body},_toggleAttr:function(){this.button.attr("aria-expanded",this.isOpen),this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen),this.menu.attr("aria-hidden",!this.isOpen)},_resizeButton:function(){var t=this.options.width;!1===t?this.button.css("width",""):(null===t&&(t=this.element.show().outerWidth(),this.element.hide()),this.button.outerWidth(t))},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width("").outerWidth()))},_getCreateOptions:function(){var t=this._super();return t.disabled=this.element.prop("disabled"),t},_parseOptions:function(t){var i=this,s=[];t.each(function(t,e){s.push(i._parseOption(V(e),t))}),this.items=s},_parseOption:function(t,e){var i=t.parent("optgroup");return{element:t,index:e,value:t.val(),label:t.text(),hidden:i.prop("hidden")||t.prop("hidden"),optgroup:i.attr("label")||"",disabled:i.prop("disabled")||t.prop("disabled")}},_destroy:function(){this._unbindFormResetHandler(),this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.labels.attr("for",this.ids.element)}}]),V.widget("ui.slider",V.ui.mouse,{version:"1.14.0",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,e=this.options,i=this.element.find(".ui-slider-handle"),s=[],n=e.values&&e.values.length||1;for(i.length>n&&(i.slice(n).remove(),i=i.slice(0,n)),t=i.length;t<n;t++)s.push("<span tabindex='0'></span>");this.handles=i.add(V(s.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(t){V(this).data("ui-slider-handle-index",t).attr("tabIndex",0)})},_createRange:function(){var t=this.options;t.range?(!0===t.range&&(t.values?t.values.length&&2!==t.values.length?t.values=[t.values[0],t.values[0]]:Array.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=V("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),"min"!==t.range&&"max"!==t.range||this._addClass(this.range,"ui-slider-range-"+t.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(t){var i,s,n,o,e,a,r=this,l=this.options;return!l.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e),s=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var e=Math.abs(i-r.values(t));(e<s||s===e&&(t===r._lastChangedValue||r.values(t)===l.min))&&(s=e,n=V(this),o=t)}),!1!==this._start(t,o))&&(this._mouseSliding=!0,this._handleIndex=o,this._addClass(n,null,"ui-state-active"),n.trigger("focus"),e=n.offset(),a=!V(t.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=a?{left:0,top:0}:{left:t.pageX-e.left-n.width()/2,top:t.pageY-e.top-n.height()/2-(parseInt(n.css("borderTopWidth"),10)||0)-(parseInt(n.css("borderBottomWidth"),10)||0)+(parseInt(n.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(t,o,i),this._animateOff=!0)},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},e=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,e),!1},_mouseStop:function(t){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,t="horizontal"===this.orientation?(e=this.elementSize.width,t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),t=t/e;return(t=1<t?1:t)<0&&(t=0),"vertical"===this.orientation&&(t=1-t),e=this._valueMax()-this._valueMin(),t=this._valueMin()+t*e,this._trimAlignValue(t)},_uiHash:function(t,e,i){var s={handle:this.handles[t],handleIndex:t,value:void 0!==e?e:this.value()};return this._hasMultipleValues()&&(s.value=void 0!==e?e:this.values(t),s.values=i||this.values()),s},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(t,e){return this._trigger("start",t,this._uiHash(e))},_slide:function(t,e,i){var s,n=this.value(),o=this.values();this._hasMultipleValues()&&(s=this.values(e?0:1),n=this.values(e),2===this.options.values.length&&!0===this.options.range&&(i=0===e?Math.min(s,i):Math.max(s,i)),o[e]=i),i!==n&&!1!==this._trigger("slide",t,this._uiHash(e,i,o))&&(this._hasMultipleValues()?this.values(e,i):this.value(i))},_stop:function(t,e){this._trigger("stop",t,this._uiHash(e))},_change:function(t,e){this._keySliding||this._mouseSliding||(this._lastChangedValue=e,this._trigger("change",t,this._uiHash(e)))},value:function(t){if(!arguments.length)return this._value();this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0)},values:function(t,e){var i,s,n;if(1<arguments.length)this.options.values[t]=this._trimAlignValue(e),this._refreshValue(),this._change(null,t);else{if(!arguments.length)return this._values();if(!Array.isArray(t))return this._hasMultipleValues()?this._values(t):this.value();for(i=this.options.values,s=t,n=0;n<i.length;n+=1)i[n]=this._trimAlignValue(s[n]),this._change(null,n);this._refreshValue()}},_setOption:function(t,e){var i,s=0;switch("range"===t&&!0===this.options.range&&("min"===e?(this.options.value=this._values(0),this.options.values=null):"max"===e&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),Array.isArray(this.options.values)&&(s=this.options.values.length),this._super(t,e),t){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(e),this.handles.css("horizontal"===e?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),i=s-1;0<=i;i--)this._change(null,i);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(t){this._super(t),this._toggleClass(null,"ui-state-disabled",!!t)},_value:function(){var t=this.options.value;return this._trimAlignValue(t)},_values:function(t){var e,i;if(arguments.length)return t=this.options.values[t],this._trimAlignValue(t);if(this._hasMultipleValues()){for(e=this.options.values.slice(),i=0;i<e.length;i+=1)e[i]=this._trimAlignValue(e[i]);return e}return[]},_trimAlignValue:function(t){var e,i;return t<=this._valueMin()?this._valueMin():t>=this._valueMax()?this._valueMax():(e=0<this.options.step?this.options.step:1,i=t-(t=(t-this._valueMin())%e),2*Math.abs(t)>=e&&(i+=0<t?e:-e),parseFloat(i.toFixed(5)))},_calculateNewMax:function(){var t=this.options.max,e=this._valueMin(),i=this.options.step;(t=Math.round((t-e)/i)*i+e)>this.options.max&&(t-=i),this.max=parseFloat(t.toFixed(this._precision()))},_precision:function(){var t=this._precisionOf(this.options.step);return t=null!==this.options.min?Math.max(t,this._precisionOf(this.options.min)):t},_precisionOf:function(t){var t=t.toString(),e=t.indexOf(".");return-1===e?0:t.length-e-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(t){"vertical"===t&&this.range.css({width:"",left:""}),"horizontal"===t&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var e,i,t,s,n,o=this.options.range,a=this.options,r=this,l=!this._animateOff&&a.animate,h={};this._hasMultipleValues()?this.handles.each(function(t){i=(r.values(t)-r._valueMin())/(r._valueMax()-r._valueMin())*100,h["horizontal"===r.orientation?"left":"bottom"]=i+"%",V(this).stop(1,1)[l?"animate":"css"](h,a.animate),!0===r.options.range&&("horizontal"===r.orientation?(0===t&&r.range.stop(1,1)[l?"animate":"css"]({left:i+"%"},a.animate),1===t&&r.range[l?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:a.animate})):(0===t&&r.range.stop(1,1)[l?"animate":"css"]({bottom:i+"%"},a.animate),1===t&&r.range[l?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:a.animate}))),e=i}):(t=this.value(),s=this._valueMin(),n=this._valueMax(),i=n!==s?(t-s)/(n-s)*100:0,h["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[l?"animate":"css"](h,a.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:i+"%"},a.animate),"max"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:100-i+"%"},a.animate),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:i+"%"},a.animate),"max"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:100-i+"%"},a.animate))},_handleEvents:{keydown:function(t){var e,i,s,n=V(t.target).data("ui-slider-handle-index");switch(t.keyCode){case V.ui.keyCode.HOME:case V.ui.keyCode.END:case V.ui.keyCode.PAGE_UP:case V.ui.keyCode.PAGE_DOWN:case V.ui.keyCode.UP:case V.ui.keyCode.RIGHT:case V.ui.keyCode.DOWN:case V.ui.keyCode.LEFT:if(t.preventDefault(),this._keySliding||(this._keySliding=!0,this._addClass(V(t.target),null,"ui-state-active"),!1!==this._start(t,n)))break;return}switch(s=this.options.step,e=i=this._hasMultipleValues()?this.values(n):this.value(),t.keyCode){case V.ui.keyCode.HOME:i=this._valueMin();break;case V.ui.keyCode.END:i=this._valueMax();break;case V.ui.keyCode.PAGE_UP:i=this._trimAlignValue(e+(this._valueMax()-this._valueMin())/this.numPages);break;case V.ui.keyCode.PAGE_DOWN:i=this._trimAlignValue(e-(this._valueMax()-this._valueMin())/this.numPages);break;case V.ui.keyCode.UP:case V.ui.keyCode.RIGHT:if(e===this._valueMax())return;i=this._trimAlignValue(e+s);break;case V.ui.keyCode.DOWN:case V.ui.keyCode.LEFT:if(e===this._valueMin())return;i=this._trimAlignValue(e-s)}this._slide(t,n,i)},keyup:function(t){var e=V(t.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(t,e),this._change(t,e),this._removeClass(V(t.target),null,"ui-state-active"))}}}),V.widget("ui.sortable",V.ui.mouse,{version:"1.14.0",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return e<=t&&t<e+i},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){var t=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),V.each(this.items,function(){t._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var t=this.items.length-1;0<=t;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(t,e){var i=null,s=!1,n=this;return!(this.reverting||this.options.disabled||"static"===this.options.type||(this._refreshItems(t),V(t.target).parents().each(function(){if(V.data(this,n.widgetName+"-item")===n)return i=V(this),!1}),!(i=V.data(t.target,n.widgetName+"-item")===n?V(t.target):i))||(this.options.handle&&!e&&(V(this.options.handle,i).find("*").addBack().each(function(){this===t.target&&(s=!0)}),!s)||(this.currentItem=i,this._removeCurrentsFromItems(),0)))},_mouseStart:function(t,e,i){var s,n,o=this.options;if((this.currentContainer=this).refreshPositions(),this.appendTo=V("parent"!==o.appendTo?o.appendTo:this.currentItem.parent()),this.helper=this._createHelper(t),this._cacheHelperProportions(),this._cacheMargins(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},V.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),this.scrollParent=this.placeholder.scrollParent(),V.extend(this.offset,{parent:this._getParentOffset()}),o.containment&&this._setContainment(),o.cursor&&"auto"!==o.cursor&&(n=this.document.find("body"),this._storedStylesheet=V("<style>*{ cursor: "+o.cursor+" !important; }</style>").appendTo(n)),o.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",o.zIndex)),o.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",o.opacity)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",t,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!i)for(s=this.containers.length-1;0<=s;s--)this.containers[s]._trigger("activate",t,this._uiHash(this));return V.ui.ddmanager&&(V.ui.ddmanager.current=this),V.ui.ddmanager&&!o.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this.helper.parent().is(this.appendTo)||(this.helper.detach().appendTo(this.appendTo),this.offset.parent=this._getParentOffset()),this.position=this.originalPosition=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,this.lastPositionAbs=this.positionAbs=this._convertPositionTo("absolute"),this._mouseDrag(t),!0},_scroll:function(t){var e=this.options,i=!1;return this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-t.pageY<e.scrollSensitivity?this.scrollParent[0].scrollTop=i=this.scrollParent[0].scrollTop+e.scrollSpeed:t.pageY-this.overflowOffset.top<e.scrollSensitivity&&(this.scrollParent[0].scrollTop=i=this.scrollParent[0].scrollTop-e.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-t.pageX<e.scrollSensitivity?this.scrollParent[0].scrollLeft=i=this.scrollParent[0].scrollLeft+e.scrollSpeed:t.pageX-this.overflowOffset.left<e.scrollSensitivity&&(this.scrollParent[0].scrollLeft=i=this.scrollParent[0].scrollLeft-e.scrollSpeed)):(t.pageY-this.document.scrollTop()<e.scrollSensitivity?i=this.document.scrollTop(this.document.scrollTop()-e.scrollSpeed):this.window.height()-(t.pageY-this.document.scrollTop())<e.scrollSensitivity&&(i=this.document.scrollTop(this.document.scrollTop()+e.scrollSpeed)),t.pageX-this.document.scrollLeft()<e.scrollSensitivity?i=this.document.scrollLeft(this.document.scrollLeft()-e.scrollSpeed):this.window.width()-(t.pageX-this.document.scrollLeft())<e.scrollSensitivity&&(i=this.document.scrollLeft(this.document.scrollLeft()+e.scrollSpeed))),i},_mouseDrag:function(t){var e,i,s,n,o=this.options;for(this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),o.scroll&&!1!==this._scroll(t)&&(this._refreshItemPositions(!0),V.ui.ddmanager)&&!o.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this.dragDirection={vertical:this._getDragVerticalDirection(),horizontal:this._getDragHorizontalDirection()},e=this.items.length-1;0<=e;e--)if(s=(i=this.items[e]).item[0],(n=this._intersectsWithPointer(i))&&i.instance===this.currentContainer&&!(s===this.currentItem[0]||this.placeholder[1===n?"next":"prev"]()[0]===s||V.contains(this.placeholder[0],s)||"semi-dynamic"===this.options.type&&V.contains(this.element[0],s))){if(this.direction=1===n?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(i))break;this._rearrange(t,i),this._trigger("change",t,this._uiHash());break}return this._contactContainers(t),V.ui.ddmanager&&V.ui.ddmanager.drag(this,t),this._trigger("sort",t,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(t,e){var i,s,n,o;if(t)return V.ui.ddmanager&&!this.options.dropBehaviour&&V.ui.ddmanager.drop(this,t),this.options.revert?(s=(i=this).placeholder.offset(),o={},(n=this.options.axis)&&"x"!==n||(o.left=s.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),n&&"y"!==n||(o.top=s.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,V(this.helper).animate(o,parseInt(this.options.revert,10)||500,function(){i._clear(t)})):this._clear(t,e),!1},cancel:function(){if(this.dragging){this._mouseUp(new V.Event("mouseup",{target:null})),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var t=this.containers.length-1;0<=t;t--)this.containers[t]._trigger("deactivate",null,this._uiHash(this)),this.containers[t].containerCache.over&&(this.containers[t]._trigger("out",null,this._uiHash(this)),this.containers[t].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),V.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?V(this.domPosition.prev).after(this.currentItem):V(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var t=this._getItemsAsjQuery(e&&e.connected),i=[];return e=e||{},V(t).each(function(){var t=(V(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);t&&i.push((e.key||t[1]+"[]")+"="+(e.key&&e.expression?t[1]:t[2]))}),!i.length&&e.key&&i.push(e.key+"="),i.join("&")},toArray:function(t){var e=this._getItemsAsjQuery(t&&t.connected),i=[];return t=t||{},e.each(function(){i.push(V(t.item||this).attr(t.attribute||"id")||"")}),i},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,h="x"===this.options.axis||r<s+h&&s+h<l,c="y"===this.options.axis||o<e+c&&e+c<a;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?h&&c:o<e+this.helperProportions.width/2&&i-this.helperProportions.width/2<a&&r<s+this.helperProportions.height/2&&n-this.helperProportions.height/2<l},_intersectsWithPointer:function(t){var e="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),t="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width);return!(!e||!t)&&(e=this.dragDirection.vertical,t=this.dragDirection.horizontal,this.floating?"right"===t||"down"===e?2:1:e&&("down"===e?2:1))},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),t=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),i=this.dragDirection.vertical,s=this.dragDirection.horizontal;return this.floating&&s?"right"===s&&t||"left"===s&&!t:i&&("down"===i&&e||"up"===i&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!=t&&(0<t?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!=t&&(0<t?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(t){var e,i,s,n,o=[],a=[],r=this._connectWith();if(r&&t)for(e=r.length-1;0<=e;e--)for(i=(s=V(r[e],this.document[0])).length-1;0<=i;i--)(n=V.data(s[i],this.widgetFullName))&&n!==this&&!n.options.disabled&&a.push(["function"==typeof n.options.items?n.options.items.call(n.element):V(n.options.items,n.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),n]);function l(){o.push(this)}for(a.push(["function"==typeof this.options.items?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):V(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),e=a.length-1;0<=e;e--)a[e][0].each(l);return V(o)},_removeCurrentsFromItems:function(){var i=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=V.grep(this.items,function(t){for(var e=0;e<i.length;e++)if(i[e]===t.item[0])return!1;return!0})},_refreshItems:function(t){this.items=[],this.containers=[this];var e,i,s,n,o,a,r,l,h=this.items,c=[["function"==typeof this.options.items?this.options.items.call(this.element[0],t,{item:this.currentItem}):V(this.options.items,this.element),this]],u=this._connectWith();if(u&&this.ready)for(e=u.length-1;0<=e;e--)for(i=(s=V(u[e],this.document[0])).length-1;0<=i;i--)(n=V.data(s[i],this.widgetFullName))&&n!==this&&!n.options.disabled&&(c.push(["function"==typeof n.options.items?n.options.items.call(n.element[0],t,{item:this.currentItem}):V(n.options.items,n.element),n]),this.containers.push(n));for(e=c.length-1;0<=e;e--)for(o=c[e][1],l=(a=c[e][i=0]).length;i<l;i++)(r=V(a[i])).data(this.widgetName+"-item",o),h.push({item:r,instance:o,width:0,height:0,left:0,top:0})},_refreshItemPositions:function(t){for(var e,i,s=this.items.length-1;0<=s;s--)e=this.items[s],this.currentContainer&&e.instance!==this.currentContainer&&e.item[0]!==this.currentItem[0]||(i=this.options.toleranceElement?V(this.options.toleranceElement,e.item):e.item,t||(e.width=i.outerWidth(),e.height=i.outerHeight()),i=i.offset(),e.left=i.left,e.top=i.top)},refreshPositions:function(t){var e,i;if(this.floating=!!this.items.length&&("x"===this.options.axis||this._isFloating(this.items[0].item)),this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset()),this._refreshItemPositions(t),this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(e=this.containers.length-1;0<=e;e--)i=this.containers[e].element.offset(),this.containers[e].containerCache.left=i.left,this.containers[e].containerCache.top=i.top,this.containers[e].containerCache.width=this.containers[e].element.outerWidth(),this.containers[e].containerCache.height=this.containers[e].element.outerHeight();return this},_createPlaceholder:function(i){var s,n,o=(i=i||this).options;o.placeholder&&o.placeholder.constructor!==String||(s=o.placeholder,n=i.currentItem[0].nodeName.toLowerCase(),o.placeholder={element:function(){var t=V("<"+n+">",i.document[0]);return i._addClass(t,"ui-sortable-placeholder",s||i.currentItem[0].className)._removeClass(t,"ui-sortable-helper"),"tbody"===n?i._createTrPlaceholder(i.currentItem.find("tr").eq(0),V("<tr>",i.document[0]).appendTo(t)):"tr"===n?i._createTrPlaceholder(i.currentItem,t):"img"===n&&t.attr("src",i.currentItem.attr("src")),s||t.css("visibility","hidden"),t},update:function(t,e){s&&!o.forcePlaceholderSize||(e.height()&&(!o.forcePlaceholderSize||"tbody"!==n&&"tr"!==n)||e.height(i.currentItem.innerHeight()-parseInt(i.currentItem.css("paddingTop")||0,10)-parseInt(i.currentItem.css("paddingBottom")||0,10)),e.width())||e.width(i.currentItem.innerWidth()-parseInt(i.currentItem.css("paddingLeft")||0,10)-parseInt(i.currentItem.css("paddingRight")||0,10))}}),i.placeholder=V(o.placeholder.element.call(i.element,i.currentItem)),i.currentItem.after(i.placeholder),o.placeholder.update(i,i.placeholder)},_createTrPlaceholder:function(t,e){var i=this;t.children().each(function(){V("<td>&#160;</td>",i.document[0]).attr("colspan",V(this).attr("colspan")||1).appendTo(e)})},_contactContainers:function(t){for(var e,i,s,n,o,a,r,l,h,c=null,u=null,d=this.containers.length-1;0<=d;d--)V.contains(this.currentItem[0],this.containers[d].element[0])||(this._intersectsWith(this.containers[d].containerCache)?c&&V.contains(this.containers[d].element[0],c.element[0])||(c=this.containers[d],u=d):this.containers[d].containerCache.over&&(this.containers[d]._trigger("out",t,this._uiHash(this)),this.containers[d].containerCache.over=0));if(c)if(1===this.containers.length)this.containers[u].containerCache.over||(this.containers[u]._trigger("over",t,this._uiHash(this)),this.containers[u].containerCache.over=1);else{for(i=1e4,s=null,n=(l=c.floating||this._isFloating(this.currentItem))?"left":"top",o=l?"width":"height",h=l?"pageX":"pageY",e=this.items.length-1;0<=e;e--)V.contains(this.containers[u].element[0],this.items[e].item[0])&&this.items[e].item[0]!==this.currentItem[0]&&(a=this.items[e].item.offset()[n],r=!1,t[h]-a>this.items[e][o]/2&&(r=!0),Math.abs(t[h]-a)<i)&&(i=Math.abs(t[h]-a),s=this.items[e],this.direction=r?"up":"down");(s||this.options.dropOnEmpty)&&(this.currentContainer===this.containers[u]?this.currentContainer.containerCache.over||(this.containers[u]._trigger("over",t,this._uiHash()),this.currentContainer.containerCache.over=1):(s?this._rearrange(t,s,null,!0):this._rearrange(t,null,this.containers[u].element,!0),this._trigger("change",t,this._uiHash()),this.containers[u]._trigger("change",t,this._uiHash(this)),this.currentContainer=this.containers[u],this.options.placeholder.update(this.currentContainer,this.placeholder),this.scrollParent=this.placeholder.scrollParent(),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this.containers[u]._trigger("over",t,this._uiHash(this)),this.containers[u].containerCache.over=1))}},_createHelper:function(t){var e=this.options,t="function"==typeof e.helper?V(e.helper.apply(this.element[0],[t,this.currentItem])):"clone"===e.helper?this.currentItem.clone():this.currentItem;return t.parents("body").length||this.appendTo[0].appendChild(t[0]),t[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),t[0].style.width&&!e.forceHelperSize||t.width(this.currentItem.width()),t[0].style.height&&!e.forceHelperSize||t.height(this.currentItem.height()),t},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),"left"in(t=Array.isArray(t)?{left:+t[0],top:+t[1]||0}:t)&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var t=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),{top:(t=this.offsetParent[0]===this.document[0].body?{top:0,left:0}:t).top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){var t;return"relative"===this.cssPosition?{top:(t=this.currentItem.position()).top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}:{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,e,i=this.options;"parent"===i.containment&&(i.containment=this.helper[0].parentNode),"document"!==i.containment&&"window"!==i.containment||(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===i.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===i.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(i.containment)||(t=V(i.containment)[0],i=V(i.containment).offset(),e="hidden"!==V(t).css("overflow"),this.containment=[i.left+(parseInt(V(t).css("borderLeftWidth"),10)||0)+(parseInt(V(t).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(V(t).css("borderTopWidth"),10)||0)+(parseInt(V(t).css("paddingTop"),10)||0)-this.margins.top,i.left+(e?Math.max(t.scrollWidth,t.offsetWidth):t.offsetWidth)-(parseInt(V(t).css("borderLeftWidth"),10)||0)-(parseInt(V(t).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(e?Math.max(t.scrollHeight,t.offsetHeight):t.offsetHeight)-(parseInt(V(t).css("borderTopWidth"),10)||0)-(parseInt(V(t).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(t,e){e=e||this.position;var t="absolute"===t?1:-1,i="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,s=/(html|body)/i.test(i[0].tagName);return{top:e.top+this.offset.relative.top*t+this.offset.parent.top*t-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():s?0:i.scrollTop())*t,left:e.left+this.offset.relative.left*t+this.offset.parent.left*t-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():s?0:i.scrollLeft())*t}},_generatePosition:function(t){var e=this.options,i=t.pageX,s=t.pageY,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(t.pageX-this.offset.click.left<this.containment[0]&&(i=this.containment[0]+this.offset.click.left),t.pageY-this.offset.click.top<this.containment[1]&&(s=this.containment[1]+this.offset.click.top),t.pageX-this.offset.click.left>this.containment[2]&&(i=this.containment[2]+this.offset.click.left),t.pageY-this.offset.click.top>this.containment[3])&&(s=this.containment[3]+this.offset.click.top),e.grid)&&(t=this.originalPageY+Math.round((s-this.originalPageY)/e.grid[1])*e.grid[1],s=!this.containment||t-this.offset.click.top>=this.containment[1]&&t-this.offset.click.top<=this.containment[3]?t:t-this.offset.click.top>=this.containment[1]?t-e.grid[1]:t+e.grid[1],t=this.originalPageX+Math.round((i-this.originalPageX)/e.grid[0])*e.grid[0],i=!this.containment||t-this.offset.click.left>=this.containment[0]&&t-this.offset.click.left<=this.containment[2]?t:t-this.offset.click.left>=this.containment[0]?t-e.grid[0]:t+e.grid[0]),{top:s-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop()),left:i-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){this.reverting=!1;var i,s=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(i in this._storedCSS)"auto"!==this._storedCSS[i]&&"static"!==this._storedCSS[i]||(this._storedCSS[i]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();function n(e,i,s){return function(t){s._trigger(e,t,i._uiHash(i))}}for(this.fromOutside&&!e&&s.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||s.push(function(t){this._trigger("update",t,this._uiHash())}),this===this.currentContainer||e||(s.push(function(t){this._trigger("remove",t,this._uiHash())}),s.push(function(e){return function(t){e._trigger("receive",t,this._uiHash(this))}}.call(this,this.currentContainer)),s.push(function(e){return function(t){e._trigger("update",t,this._uiHash(this))}}.call(this,this.currentContainer))),i=this.containers.length-1;0<=i;i--)e||s.push(n("deactivate",this,this.containers[i])),this.containers[i].containerCache.over&&(s.push(n("out",this,this.containers[i])),this.containers[i].containerCache.over=0);if(this._storedStylesheet&&(this._storedStylesheet.remove(),this._storedStylesheet=null),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(i=0;i<s.length;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){!1===V.Widget.prototype._trigger.apply(this,arguments)&&this.cancel()},_uiHash:function(t){var e=t||this;return{helper:e.helper,placeholder:e.placeholder||V([]),position:e.position,originalPosition:e.originalPosition,offset:e.positionAbs,item:e.currentItem,sender:t?t.element:null}}});function O(e){return function(){var t=this.element.val();e.apply(this,arguments),this._refresh(),t!==this.element.val()&&this._trigger("change")}}V.widget("ui.spinner",{version:"1.14.0",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var s=this._super(),n=this.element;return V.each(["min","max","step"],function(t,e){var i=n.attr(e);null!=i&&i.length&&(s[e]=i)}),s},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t)},mousewheel:function(t,e){var i=this.document[0].activeElement;if(this.element[0]===i&&e){if(!this.spinning&&!this._start(t))return!1;this._spin((0<e?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(t){var e;e=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),t.preventDefault(),function(){this.element[0]!==this.document[0].activeElement&&(this.element.trigger("focus"),this.previous=e)}.call(this),!1!==this._start(t)&&this._repeat(null,V(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(t){if(V(t.currentTarget).hasClass("ui-state-active"))return!1!==this._start(t)&&void this._repeat(null,V(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseleave .ui-spinner-button":"_stop"},_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent().append("<a></a><a></a>")},_draw:function(){this._enhance(),this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content"),this._addClass("ui-spinner-input"),this.element.attr("role","spinbutton"),this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",!0).button({classes:{"ui-button":""}}),this._removeClass(this.buttons,"ui-corner-all"),this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up"),this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down"),this.buttons.first().button({icon:this.options.icons.up,showLabel:!1}),this.buttons.last().button({icon:this.options.icons.down,showLabel:!1}),this.buttons.height()>Math.ceil(.5*this.uiSpinner.height())&&0<this.uiSpinner.height()&&this.uiSpinner.height(this.uiSpinner.height())},_keydown:function(t){var e=this.options,i=V.ui.keyCode;switch(t.keyCode){case i.UP:return this._repeat(null,1,t),!0;case i.DOWN:return this._repeat(null,-1,t),!0;case i.PAGE_UP:return this._repeat(null,e.page,t),!0;case i.PAGE_DOWN:return this._repeat(null,-e.page,t),!0}return!1},_start:function(t){return!(!this.spinning&&!1===this._trigger("start",t))&&(this.counter||(this.counter=1),this.spinning=!0)},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&!1===this._trigger("spin",e,{value:i})||(this._value(i),this.counter++)},_increment:function(t){var e=this.options.incremental;return e?"function"==typeof e?e(t):Math.floor(t*t*t/5e4-t*t/500+17*t/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return t=null!==this.options.min?Math.max(t,this._precisionOf(this.options.min)):t},_precisionOf:function(t){var t=t.toString(),e=t.indexOf(".");return-1===e?0:t.length-e-1},_adjustValue:function(t){var e=this.options,i=null!==e.min?e.min:0,s=t-i;return t=i+Math.round(s/e.step)*e.step,t=parseFloat(t.toFixed(this._precision())),null!==e.max&&t>e.max?e.max:null!==e.min&&t<e.min?e.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){var i;"culture"===t||"numberFormat"===t?(i=this._parse(this.element.val()),this.options[t]=e,this.element.val(this._format(i))):("max"!==t&&"min"!==t&&"step"!==t||"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(i=this.buttons.first().find(".ui-icon"),this._removeClass(i,null,this.options.icons.up),this._addClass(i,null,e.up),i=this.buttons.last().find(".ui-icon"),this._removeClass(i,null,this.options.icons.down),this._addClass(i,null,e.down)),this._super(t,e))},_setOptionDisabled:function(t){this._super(t),this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!t),this.element.prop("disabled",!!t),this.buttons.button(t?"disable":"enable")},_setOptions:O(function(t){this._super(t)}),_parse:function(t){return""===(t="string"==typeof t&&""!==t?window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t:t)||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},isValid:function(){var t=this.value();return null!==t&&t===this._adjustValue(t)},_value:function(t,e){var i;""!==t&&null!==(i=this._parse(t))&&(e||(i=this._adjustValue(i)),t=this._format(i)),this.element.val(t),this._refresh()},_destroy:function(){this.element.prop("disabled",!1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:O(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:O(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:O(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:O(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){if(!arguments.length)return this._parse(this.element.val());O(this._value).call(this,t)},widget:function(){return this.uiSpinner}}),!0===V.uiBackCompat&&V.widget("ui.spinner",V.ui.spinner,{_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())},_uiSpinnerHtml:function(){return"<span>"},_buttonHtml:function(){return"<a></a><a></a>"}});var A;V.ui.spinner,V.widget("ui.tabs",{version:"1.14.0",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:(A=/#.*$/,function(t){var e=t.href.replace(A,""),i=location.href.replace(A,"");try{e=decodeURIComponent(e)}catch(t){}try{i=decodeURIComponent(i)}catch(t){}return 1<t.hash.length&&e===i}),_create:function(){var e=this,t=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,t.collapsible),this._processTabs(),t.active=this._initialActive(),Array.isArray(t.disabled)&&(t.disabled=V.uniqueSort(t.disabled.concat(V.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),!1!==this.options.active&&this.anchors.length?this.active=this._findActive(t.active):this.active=V(),this._refresh(),this.active.length&&this.load(t.active)},_initialActive:function(){var i=this.options.active,t=this.options.collapsible,s=location.hash.substring(1);return null===i&&(s&&this.tabs.each(function(t,e){if(V(e).attr("aria-controls")===s)return i=t,!1}),null!==(i=null===i?this.tabs.index(this.tabs.filter(".ui-tabs-active")):i)&&-1!==i||(i=!!this.tabs.length&&0)),!1!==i&&-1===(i=this.tabs.index(this.tabs.eq(i)))&&(i=!t&&0),i=!t&&!1===i&&this.anchors.length?0:i},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):V()}},_tabKeydown:function(t){var e=V(this.document[0].activeElement).closest("li"),i=this.tabs.index(e),s=!0;if(!this._handlePageNav(t)){switch(t.keyCode){case V.ui.keyCode.RIGHT:case V.ui.keyCode.DOWN:i++;break;case V.ui.keyCode.UP:case V.ui.keyCode.LEFT:s=!1,i--;break;case V.ui.keyCode.END:i=this.anchors.length-1;break;case V.ui.keyCode.HOME:i=0;break;case V.ui.keyCode.SPACE:return t.preventDefault(),clearTimeout(this.activating),void this._activate(i);case V.ui.keyCode.ENTER:return t.preventDefault(),clearTimeout(this.activating),void this._activate(i!==this.options.active&&i);default:return}t.preventDefault(),clearTimeout(this.activating),i=this._focusNextTab(i,s),t.ctrlKey||t.metaKey||(e.attr("aria-selected","false"),this.tabs.eq(i).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",i)},this.delay))}},_panelKeydown:function(t){this._handlePageNav(t)||t.ctrlKey&&t.keyCode===V.ui.keyCode.UP&&(t.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(t){return t.altKey&&t.keyCode===V.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):t.altKey&&t.keyCode===V.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(t,e){var i=this.tabs.length-1;for(;-1!==V.inArray(t=(t=i<t?0:t)<0?i:t,this.options.disabled);)t=e?t+1:t-1;return t},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).trigger("focus"),t},_setOption:function(t,e){"active"===t?this._activate(e):(this._super(t,e),"collapsible"===t&&(this._toggleClass("ui-tabs-collapsible",null,e),e||!1!==this.options.active||this._activate(0)),"event"===t&&this._setupEvents(e),"heightStyle"===t&&this._setupHeightStyle(e))},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var t=this.options,e=this.tablist.children(":has(a[href])");t.disabled=V.map(e.filter(".ui-state-disabled"),function(t){return e.index(t)}),this._processTabs(),!1!==t.active&&this.anchors.length?this.active.length&&!V.contains(this.tablist[0],this.active[0])?this.tabs.length===t.disabled.length?(t.active=!1,this.active=V()):this._activate(this._findNextTab(Math.max(0,t.active-1),!1)):t.active=this.tabs.index(this.active):(t.active=!1,this.active=V()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var l=this,t=this.tabs,e=this.anchors,i=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(t){V(this).is(".ui-state-disabled")&&t.preventDefault()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return V("a",this)[0]}).attr({tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=V(),this.anchors.each(function(t,e){var i,s,n,o=V(e).uniqueId().attr("id"),a=V(e).closest("li"),r=a.attr("aria-controls");l._isLocal(e)?(n=(i=e.hash).substring(1),s=l.element.find(l._sanitizeSelector(i))):(n=a.attr("aria-controls")||V({}).uniqueId()[0].id,(s=l.element.find(i="#"+n)).length||(s=l._createPanel(n)).insertAfter(l.panels[t-1]||l.tablist),s.attr("aria-live","polite")),s.length&&(l.panels=l.panels.add(s)),r&&a.data("ui-tabs-aria-controls",r),a.attr({"aria-controls":n,"aria-labelledby":o}),s.attr("aria-labelledby",o)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),t&&(this._off(t.not(this.tabs)),this._off(e.not(this.anchors)),this._off(i.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(t){return V("<div>").attr("id",t).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(t){var e,i;for(Array.isArray(t)&&(t.length?t.length===this.anchors.length&&(t=!0):t=!1),i=0;e=this.tabs[i];i++)e=V(e),!0===t||-1!==V.inArray(i,t)?(e.attr("aria-disabled","true"),this._addClass(e,null,"ui-state-disabled")):(e.removeAttr("aria-disabled"),this._removeClass(e,null,"ui-state-disabled"));this.options.disabled=t,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!0===t)},_setupEvents:function(t){var i={};t&&V.each(t.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(t){t.preventDefault()}}),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(t){var i,e=this.element.parent();"fill"===t?(i=e.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var t=V(this),e=t.css("position");"absolute"!==e&&"fixed"!==e&&(i-=t.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=V(this).outerHeight(!0)}),this.panels.each(function(){V(this).height(Math.max(0,i-V(this).innerHeight()+V(this).height()))}).css("overflow","auto")):"auto"===t&&(i=0,this.panels.each(function(){i=Math.max(i,V(this).height("").height())}).height(i))},_eventHandler:function(t){var e=this.options,i=this.active,s=V(t.currentTarget).closest("li"),n=s[0]===i[0],o=n&&e.collapsible,a=o?V():this._getPanelForTab(s),r=i.length?this._getPanelForTab(i):V(),i={oldTab:i,oldPanel:r,newTab:o?V():s,newPanel:a};t.preventDefault(),s.hasClass("ui-state-disabled")||s.hasClass("ui-tabs-loading")||this.running||n&&!e.collapsible||!1===this._trigger("beforeActivate",t,i)||(e.active=!o&&this.tabs.index(s),this.active=n?V():s,this.xhr&&this.xhr.abort(),r.length||a.length||V.error("jQuery UI Tabs: Mismatching fragment identifier."),a.length&&this.load(this.tabs.index(s),t),this._toggle(t,i))},_toggle:function(t,e){var i=this,s=e.newPanel,n=e.oldPanel;function o(){i.running=!1,i._trigger("activate",t,e)}function a(){i._addClass(e.newTab.closest("li"),"ui-tabs-active","ui-state-active"),s.length&&i.options.show?i._show(s,i.options.show,o):(s.show(),o())}this.running=!0,n.length&&this.options.hide?this._hide(n,this.options.hide,function(){i._removeClass(e.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),a()}):(this._removeClass(e.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),n.hide(),a()),n.attr("aria-hidden","true"),e.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),s.length&&n.length?e.oldTab.attr("tabIndex",-1):s.length&&this.tabs.filter(function(){return 0===V(this).attr("tabIndex")}).attr("tabIndex",-1),s.attr("aria-hidden","false"),e.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(t){var t=this._findActive(t);t[0]!==this.active[0]&&(t=(t=t.length?t:this.active).find(".ui-tabs-anchor")[0],this._eventHandler({target:t,currentTarget:t,preventDefault:V.noop}))},_findActive:function(t){return!1===t?V():this.tabs.eq(t)},_getIndex:function(t){return t="string"==typeof t?this.anchors.index(this.anchors.filter("[href$='"+CSS.escape(t)+"']")):t},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){V.data(this,"ui-tabs-destroy")?V(this).remove():V(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var t=V(this),e=t.data("ui-tabs-aria-controls");e?t.attr("aria-controls",e).removeData("ui-tabs-aria-controls"):t.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var t=this.options.disabled;!1!==t&&(t=void 0!==i&&(i=this._getIndex(i),Array.isArray(t)?V.map(t,function(t){return t!==i?t:null}):V.map(this.tabs,function(t,e){return e!==i?e:null})),this._setOptionDisabled(t))},disable:function(t){var e=this.options.disabled;if(!0!==e){if(void 0===t)e=!0;else{if(t=this._getIndex(t),-1!==V.inArray(t,e))return;e=Array.isArray(e)?V.merge([t],e).sort():[t]}this._setOptionDisabled(e)}},load:function(t,s){t=this._getIndex(t);function n(t,e){"abort"===e&&o.panels.stop(!1,!0),o._removeClass(i,"ui-tabs-loading"),a.removeAttr("aria-busy"),t===o.xhr&&delete o.xhr}var o=this,i=this.tabs.eq(t),t=i.find(".ui-tabs-anchor"),a=this._getPanelForTab(i),r={tab:i,panel:a};this._isLocal(t[0])||(this.xhr=V.ajax(this._ajaxSettings(t,s,r)),"canceled"!==this.xhr.statusText&&(this._addClass(i,"ui-tabs-loading"),a.attr("aria-busy","true"),this.xhr.done(function(t,e,i){a.html(t),o._trigger("load",s,r),n(i,e)}).fail(function(t,e){n(t,e)})))},_ajaxSettings:function(t,i,s){var n=this;return{url:t.attr("href"),beforeSend:function(t,e){return n._trigger("beforeLoad",i,V.extend({jqXHR:t,ajaxSettings:e},s))}}},_getPanelForTab:function(t){t=V(t).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+t))}}),!0===V.uiBackCompat&&V.widget("ui.tabs",V.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}}),V.ui.tabs,V.widget("ui.tooltip",{version:"1.14.0",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function(){var t=V(this).attr("title");return V("<a>").text(t).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,track:!1,close:null,open:null},_addDescribedBy:function(t,e){var i=(t.attr("aria-describedby")||"").split(/\s+/);i.push(e),t.data("ui-tooltip-id",e).attr("aria-describedby",String.prototype.trim.call(i.join(" ")))},_removeDescribedBy:function(t){var e=t.data("ui-tooltip-id"),i=(t.attr("aria-describedby")||"").split(/\s+/),e=V.inArray(e,i);-1!==e&&i.splice(e,1),t.removeData("ui-tooltip-id"),(i=String.prototype.trim.call(i.join(" ")))?t.attr("aria-describedby",i):t.removeAttr("aria-describedby")},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.liveRegion=V("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this.disabledTitles=V([])},_setOption:function(t,e){var i=this;this._super(t,e),"content"===t&&V.each(this.tooltips,function(t,e){i._updateContent(e.element)})},_setOptionDisabled:function(t){this[t?"_disable":"_enable"]()},_disable:function(){var s=this;V.each(this.tooltips,function(t,e){var i=V.Event("blur");i.target=i.currentTarget=e.element[0],s.close(i,!0)}),this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var t=V(this);if(t.is("[title]"))return t.data("ui-tooltip-title",t.attr("title")).removeAttr("title")}))},_enable:function(){this.disabledTitles.each(function(){var t=V(this);t.data("ui-tooltip-title")&&t.attr("title",t.data("ui-tooltip-title"))}),this.disabledTitles=V([])},open:function(t){var i=this,e=V(t?t.target:this.element).closest(this.options.items);e.length&&!e.data("ui-tooltip-id")&&(e.attr("title")&&e.data("ui-tooltip-title",e.attr("title")),e.data("ui-tooltip-open",!0),t&&"mouseover"===t.type&&e.parents().each(function(){var t,e=V(this);e.data("ui-tooltip-open")&&((t=V.Event("blur")).target=t.currentTarget=this,i.close(t,!0)),e.attr("title")&&(e.uniqueId(),i.parents[this.id]={element:this,title:e.attr("title")},e.attr("title",""))}),this._registerCloseHandlers(t,e),this._updateContent(e,t))},_updateContent:function(e,i){var t=this.options.content,s=this,n=i?i.type:null;if("string"==typeof t||t.nodeType||t.jquery)return this._open(i,e,t);(t=t.call(e[0],function(t){e.data("ui-tooltip-open")&&(i&&(i.type=n),s._open(i,e,t))}))&&this._open(i,e,t)},_open:function(t,e,i){var s,n,o,a=V.extend({},this.options.position);function r(t){a.of=t,s.is(":hidden")||s.position(a)}i&&((o=this._find(e))?o.tooltip.find(".ui-tooltip-content").html(i):(e.is("[title]")&&(t&&"mouseover"===t.type?e.attr("title",""):e.removeAttr("title")),o=this._tooltip(e),s=o.tooltip,this._addDescribedBy(e,s.attr("id")),s.find(".ui-tooltip-content").html(i),this.liveRegion.children().hide(),(o=V("<div>").html(s.find(".ui-tooltip-content").html())).removeAttr("name").find("[name]").removeAttr("name"),o.removeAttr("id").find("[id]").removeAttr("id"),o.appendTo(this.liveRegion),this.options.track&&t&&/^mouse/.test(t.type)?(this._on(this.document,{mousemove:r}),r(t)):s.position(V.extend({of:e},this.options.position)),s.hide(),this._show(s,this.options.show),this.options.track&&this.options.show&&this.options.show.delay&&(n=this.delayedShow=setInterval(function(){s.is(":visible")&&(r(a.of),clearInterval(n))},13)),this._trigger("open",t,{tooltip:s})))},_registerCloseHandlers:function(t,e){var i={keyup:function(t){t.keyCode===V.ui.keyCode.ESCAPE&&((t=V.Event(t)).currentTarget=e[0],this.close(t,!0))}};e[0]!==this.element[0]&&(i.remove=function(){var t=this._find(e);t&&this._removeTooltip(t.tooltip)}),t&&"mouseover"!==t.type||(i.mouseleave="close"),t&&"focusin"!==t.type||(i.focusout="close"),this._on(!0,e,i)},close:function(t){var e,i=this,s=V(t?t.currentTarget:this.element),n=this._find(s);n?(e=n.tooltip,n.closing||(clearInterval(this.delayedShow),s.data("ui-tooltip-title")&&!s.attr("title")&&s.attr("title",s.data("ui-tooltip-title")),this._removeDescribedBy(s),n.hiding=!0,e.stop(!0),this._hide(e,this.options.hide,function(){i._removeTooltip(V(this))}),s.removeData("ui-tooltip-open"),this._off(s,"mouseleave focusout keyup"),s[0]!==this.element[0]&&this._off(s,"remove"),this._off(this.document,"mousemove"),t&&"mouseleave"===t.type&&V.each(this.parents,function(t,e){V(e.element).attr("title",e.title),delete i.parents[t]}),n.closing=!0,this._trigger("close",t,{tooltip:e}),n.hiding)||(n.closing=!1)):s.removeData("ui-tooltip-open")},_tooltip:function(t){var e=V("<div>").attr("role","tooltip"),i=V("<div>").appendTo(e),s=e.uniqueId().attr("id");return this._addClass(i,"ui-tooltip-content"),this._addClass(e,"ui-tooltip","ui-widget ui-widget-content"),e.appendTo(this._appendTo(t)),this.tooltips[s]={element:t,tooltip:e}},_find:function(t){t=t.data("ui-tooltip-id");return t?this.tooltips[t]:null},_removeTooltip:function(t){clearInterval(this.delayedShow),t.remove(),delete this.tooltips[t.attr("id")]},_appendTo:function(t){t=t.closest(".ui-front, dialog");return t=t.length?t:this.document[0].body},_destroy:function(){var s=this;V.each(this.tooltips,function(t,e){var i=V.Event("blur"),e=e.element;i.target=i.currentTarget=e[0],s.close(i,!0),V("#"+t).remove(),e.data("ui-tooltip-title")&&(e.attr("title")||e.attr("title",e.data("ui-tooltip-title")),e.removeData("ui-tooltip-title"))}),this.liveRegion.remove()}}),!0===V.uiBackCompat&&V.widget("ui.tooltip",V.ui.tooltip,{options:{tooltipClass:null},_tooltip:function(){var t=this._superApply(arguments);return this.options.tooltipClass&&t.tooltip.addClass(this.options.tooltipClass),t}}),V.ui.tooltip});
/*!
 * ApexCharts v3.49.1
 * (c) 2018-2024 ApexCharts
 * Released under the MIT License.
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).ApexCharts=e()}(this,(function(){"use strict";function t(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(t);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,a)}return i}function e(e){for(var i=1;i<arguments.length;i++){var a=null!=arguments[i]?arguments[i]:{};i%2?t(Object(a),!0).forEach((function(t){o(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):t(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}function i(t){return i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i(t)}function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){for(var i=0;i<e.length;i++){var a=e[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(t,a.key,a)}}function r(t,e,i){return e&&s(t.prototype,e),i&&s(t,i),t}function o(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function n(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&h(t,e)}function l(t){return l=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},l(t)}function h(t,e){return h=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},h(t,e)}function c(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function d(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var i,a=l(t);if(e){var s=l(this).constructor;i=Reflect.construct(a,arguments,s)}else i=a.apply(this,arguments);return function(t,e){if(e&&("object"==typeof e||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return c(t)}(this,i)}}function g(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var i=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==i)return;var a,s,r=[],o=!0,n=!1;try{for(i=i.call(t);!(o=(a=i.next()).done)&&(r.push(a.value),!e||r.length!==e);o=!0);}catch(t){n=!0,s=t}finally{try{o||null==i.return||i.return()}finally{if(n)throw s}}return r}(t,e)||p(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(t){return function(t){if(Array.isArray(t))return f(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||p(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function p(t,e){if(t){if("string"==typeof t)return f(t,e);var i=Object.prototype.toString.call(t).slice(8,-1);return"Object"===i&&t.constructor&&(i=t.constructor.name),"Map"===i||"Set"===i?Array.from(t):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?f(t,e):void 0}}function f(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,a=new Array(e);i<e;i++)a[i]=t[i];return a}var x=function(){function t(){a(this,t)}return r(t,[{key:"shadeRGBColor",value:function(t,e){var i=e.split(","),a=t<0?0:255,s=t<0?-1*t:t,r=parseInt(i[0].slice(4),10),o=parseInt(i[1],10),n=parseInt(i[2],10);return"rgb("+(Math.round((a-r)*s)+r)+","+(Math.round((a-o)*s)+o)+","+(Math.round((a-n)*s)+n)+")"}},{key:"shadeHexColor",value:function(t,e){var i=parseInt(e.slice(1),16),a=t<0?0:255,s=t<0?-1*t:t,r=i>>16,o=i>>8&255,n=255&i;return"#"+(16777216+65536*(Math.round((a-r)*s)+r)+256*(Math.round((a-o)*s)+o)+(Math.round((a-n)*s)+n)).toString(16).slice(1)}},{key:"shadeColor",value:function(e,i){return t.isColorHex(i)?this.shadeHexColor(e,i):this.shadeRGBColor(e,i)}}],[{key:"bind",value:function(t,e){return function(){return t.apply(e,arguments)}}},{key:"isObject",value:function(t){return t&&"object"===i(t)&&!Array.isArray(t)&&null!=t}},{key:"is",value:function(t,e){return Object.prototype.toString.call(e)==="[object "+t+"]"}},{key:"listToArray",value:function(t){var e,i=[];for(e=0;e<t.length;e++)i[e]=t[e];return i}},{key:"extend",value:function(t,e){var i=this;"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),i=1;i<arguments.length;i++){var a=arguments[i];if(null!=a)for(var s in a)a.hasOwnProperty(s)&&(e[s]=a[s])}return e});var a=Object.assign({},t);return this.isObject(t)&&this.isObject(e)&&Object.keys(e).forEach((function(s){i.isObject(e[s])&&s in t?a[s]=i.extend(t[s],e[s]):Object.assign(a,o({},s,e[s]))})),a}},{key:"extendArray",value:function(e,i){var a=[];return e.map((function(e){a.push(t.extend(i,e))})),e=a}},{key:"monthMod",value:function(t){return t%12}},{key:"clone",value:function(e){if(t.is("Array",e)){for(var a=[],s=0;s<e.length;s++)a[s]=this.clone(e[s]);return a}if(t.is("Null",e))return null;if(t.is("Date",e))return e;if("object"===i(e)){var r={};for(var o in e)e.hasOwnProperty(o)&&(r[o]=this.clone(e[o]));return r}return e}},{key:"log10",value:function(t){return Math.log(t)/Math.LN10}},{key:"roundToBase10",value:function(t){return Math.pow(10,Math.floor(Math.log10(t)))}},{key:"roundToBase",value:function(t,e){return Math.pow(e,Math.floor(Math.log(t)/Math.log(e)))}},{key:"parseNumber",value:function(t){return null===t?t:parseFloat(t)}},{key:"stripNumber",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2;return Number.isInteger(t)?t:parseFloat(t.toPrecision(e))}},{key:"randomId",value:function(){return(Math.random()+1).toString(36).substring(4)}},{key:"noExponents",value:function(t){var e=String(t).split(/[eE]/);if(1===e.length)return e[0];var i="",a=t<0?"-":"",s=e[0].replace(".",""),r=Number(e[1])+1;if(r<0){for(i=a+"0.";r++;)i+="0";return i+s.replace(/^-/,"")}for(r-=s.length;r--;)i+="0";return s+i}},{key:"getDimensions",value:function(t){var e=getComputedStyle(t,null),i=t.clientHeight,a=t.clientWidth;return i-=parseFloat(e.paddingTop)+parseFloat(e.paddingBottom),[a-=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight),i]}},{key:"getBoundingClientRect",value:function(t){var e=t.getBoundingClientRect();return{top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:t.clientWidth,height:t.clientHeight,x:e.left,y:e.top}}},{key:"getLargestStringFromArr",value:function(t){return t.reduce((function(t,e){return Array.isArray(e)&&(e=e.reduce((function(t,e){return t.length>e.length?t:e}))),t.length>e.length?t:e}),0)}},{key:"hexToRgba",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"#999999",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.6;"#"!==t.substring(0,1)&&(t="#999999");var i=t.replace("#","");i=i.match(new RegExp("(.{"+i.length/3+"})","g"));for(var a=0;a<i.length;a++)i[a]=parseInt(1===i[a].length?i[a]+i[a]:i[a],16);return void 0!==e&&i.push(e),"rgba("+i.join(",")+")"}},{key:"getOpacityFromRGBA",value:function(t){return parseFloat(t.replace(/^.*,(.+)\)/,"$1"))}},{key:"rgb2hex",value:function(t){return(t=t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i))&&4===t.length?"#"+("0"+parseInt(t[1],10).toString(16)).slice(-2)+("0"+parseInt(t[2],10).toString(16)).slice(-2)+("0"+parseInt(t[3],10).toString(16)).slice(-2):""}},{key:"isColorHex",value:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t)}},{key:"getPolygonPos",value:function(t,e){for(var i=[],a=2*Math.PI/e,s=0;s<e;s++){var r={};r.x=t*Math.sin(s*a),r.y=-t*Math.cos(s*a),i.push(r)}return i}},{key:"polarToCartesian",value:function(t,e,i,a){var s=(a-90)*Math.PI/180;return{x:t+i*Math.cos(s),y:e+i*Math.sin(s)}}},{key:"escapeString",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"x",i=t.toString().slice();return i=i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi,e)}},{key:"negToZero",value:function(t){return t<0?0:t}},{key:"moveIndexInArray",value:function(t,e,i){if(i>=t.length)for(var a=i-t.length+1;a--;)t.push(void 0);return t.splice(i,0,t.splice(e,1)[0]),t}},{key:"extractNumber",value:function(t){return parseFloat(t.replace(/[^\d.]*/g,""))}},{key:"findAncestor",value:function(t,e){for(;(t=t.parentElement)&&!t.classList.contains(e););return t}},{key:"setELstyles",value:function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t.style.key=e[i])}},{key:"isNumber",value:function(t){return!isNaN(t)&&parseFloat(Number(t))===t&&!isNaN(parseInt(t,10))}},{key:"isFloat",value:function(t){return Number(t)===t&&t%1!=0}},{key:"isSafari",value:function(){return/^((?!chrome|android).)*safari/i.test(navigator.userAgent)}},{key:"isFirefox",value:function(){return navigator.userAgent.toLowerCase().indexOf("firefox")>-1}},{key:"isIE11",value:function(){if(-1!==window.navigator.userAgent.indexOf("MSIE")||window.navigator.appVersion.indexOf("Trident/")>-1)return!0}},{key:"isIE",value:function(){var t=window.navigator.userAgent,e=t.indexOf("MSIE ");if(e>0)return parseInt(t.substring(e+5,t.indexOf(".",e)),10);if(t.indexOf("Trident/")>0){var i=t.indexOf("rv:");return parseInt(t.substring(i+3,t.indexOf(".",i)),10)}var a=t.indexOf("Edge/");return a>0&&parseInt(t.substring(a+5,t.indexOf(".",a)),10)}},{key:"getGCD",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:7,a=Math.pow(10,i-Math.floor(Math.log10(Math.max(t,e))));for(t=Math.round(Math.abs(t)*a),e=Math.round(Math.abs(e)*a);e;){var s=e;e=t%e,t=s}return t/a}},{key:"getPrimeFactors",value:function(t){for(var e=[],i=2;t>=2;)t%i==0?(e.push(i),t/=i):i++;return e}},{key:"mod",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:7,a=Math.pow(10,i-Math.floor(Math.log10(Math.max(t,e))));return(t=Math.round(Math.abs(t)*a))%(e=Math.round(Math.abs(e)*a))/a}}]),t}(),b=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.setEasingFunctions()}return r(t,[{key:"setEasingFunctions",value:function(){var t;if(!this.w.globals.easing){switch(this.w.config.chart.animations.easing){case"linear":t="-";break;case"easein":t="<";break;case"easeout":t=">";break;case"easeinout":default:t="<>";break;case"swing":t=function(t){var e=1.70158;return(t-=1)*t*((e+1)*t+e)+1};break;case"bounce":t=function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375};break;case"elastic":t=function(t){return t===!!t?t:Math.pow(2,-10*t)*Math.sin((t-.075)*(2*Math.PI)/.3)+1}}this.w.globals.easing=t}}},{key:"animateLine",value:function(t,e,i,a){t.attr(e).animate(a).attr(i)}},{key:"animateMarker",value:function(t,e,i,a,s,r){e||(e=0),t.attr({r:e,width:e,height:e}).animate(a,s).attr({r:i,width:i.width,height:i.height}).afterAll((function(){r()}))}},{key:"animateCircle",value:function(t,e,i,a,s){t.attr({r:e.r,cx:e.cx,cy:e.cy}).animate(a,s).attr({r:i.r,cx:i.cx,cy:i.cy})}},{key:"animateRect",value:function(t,e,i,a,s){t.attr(e).animate(a).attr(i).afterAll((function(){return s()}))}},{key:"animatePathsGradually",value:function(t){var e=t.el,i=t.realIndex,a=t.j,s=t.fill,r=t.pathFrom,o=t.pathTo,n=t.speed,l=t.delay,h=this.w,c=0;h.config.chart.animations.animateGradually.enabled&&(c=h.config.chart.animations.animateGradually.delay),h.config.chart.animations.dynamicAnimation.enabled&&h.globals.dataChanged&&"bar"!==h.config.chart.type&&(c=0),this.morphSVG(e,i,a,"line"!==h.config.chart.type||h.globals.comboCharts?s:"stroke",r,o,n,l*c)}},{key:"showDelayedElements",value:function(){this.w.globals.delayedElements.forEach((function(t){var e=t.el;e.classList.remove("apexcharts-element-hidden"),e.classList.add("apexcharts-hidden-element-shown")}))}},{key:"animationCompleted",value:function(t){var e=this.w;e.globals.animationEnded||(e.globals.animationEnded=!0,this.showDelayedElements(),"function"==typeof e.config.chart.events.animationEnd&&e.config.chart.events.animationEnd(this.ctx,{el:t,w:e}))}},{key:"morphSVG",value:function(t,e,i,a,s,r,o,n){var l=this,h=this.w;s||(s=t.attr("pathFrom")),r||(r=t.attr("pathTo"));var c=function(t){return"radar"===h.config.chart.type&&(o=1),"M 0 ".concat(h.globals.gridHeight)};(!s||s.indexOf("undefined")>-1||s.indexOf("NaN")>-1)&&(s=c()),(!r||r.indexOf("undefined")>-1||r.indexOf("NaN")>-1)&&(r=c()),h.globals.shouldAnimate||(o=1),t.plot(s).animate(1,h.globals.easing,n).plot(s).animate(o,h.globals.easing,n).plot(r).afterAll((function(){x.isNumber(i)?i===h.globals.series[h.globals.maxValsInArrayIndex].length-2&&h.globals.shouldAnimate&&l.animationCompleted(t):"none"!==a&&h.globals.shouldAnimate&&(!h.globals.comboCharts&&e===h.globals.series.length-1||h.globals.comboCharts)&&l.animationCompleted(t),l.showDelayedElements()}))}}]),t}(),v=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"getDefaultFilter",value:function(t,e){var i=this.w;t.unfilter(!0),(new window.SVG.Filter).size("120%","180%","-5%","-40%"),"none"!==i.config.states.normal.filter?this.applyFilter(t,e,i.config.states.normal.filter.type,i.config.states.normal.filter.value):i.config.chart.dropShadow.enabled&&this.dropShadow(t,i.config.chart.dropShadow,e)}},{key:"addNormalFilter",value:function(t,e){var i=this.w;i.config.chart.dropShadow.enabled&&!t.node.classList.contains("apexcharts-marker")&&this.dropShadow(t,i.config.chart.dropShadow,e)}},{key:"addLightenFilter",value:function(t,e,i){var a=this,s=this.w,r=i.intensity;t.unfilter(!0);new window.SVG.Filter;t.filter((function(t){var i=s.config.chart.dropShadow;(i.enabled?a.addShadow(t,e,i):t).componentTransfer({rgb:{type:"linear",slope:1.5,intercept:r}})})),t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)}},{key:"addDarkenFilter",value:function(t,e,i){var a=this,s=this.w,r=i.intensity;t.unfilter(!0);new window.SVG.Filter;t.filter((function(t){var i=s.config.chart.dropShadow;(i.enabled?a.addShadow(t,e,i):t).componentTransfer({rgb:{type:"linear",slope:r}})})),t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)}},{key:"applyFilter",value:function(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:.5;switch(i){case"none":this.addNormalFilter(t,e);break;case"lighten":this.addLightenFilter(t,e,{intensity:a});break;case"darken":this.addDarkenFilter(t,e,{intensity:a})}}},{key:"addShadow",value:function(t,e,i){var a,s=this.w,r=i.blur,o=i.top,n=i.left,l=i.color,h=i.opacity;if((null===(a=s.config.chart.dropShadow.enabledOnSeries)||void 0===a?void 0:a.length)>0&&-1===s.config.chart.dropShadow.enabledOnSeries.indexOf(e))return t;var c=t.flood(Array.isArray(l)?l[e]:l,h).composite(t.sourceAlpha,"in").offset(n,o).gaussianBlur(r).merge(t.source);return t.blend(t.source,c)}},{key:"dropShadow",value:function(t,e){var i,a,s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=e.top,o=e.left,n=e.blur,l=e.color,h=e.opacity,c=e.noUserSpaceOnUse,d=this.w;if(t.unfilter(!0),x.isIE()&&"radialBar"===d.config.chart.type)return t;if((null===(i=d.config.chart.dropShadow.enabledOnSeries)||void 0===i?void 0:i.length)>0&&-1===(null===(a=d.config.chart.dropShadow.enabledOnSeries)||void 0===a?void 0:a.indexOf(s)))return t;return l=Array.isArray(l)?l[s]:l,t.filter((function(t){var e=null;e=x.isSafari()||x.isFirefox()||x.isIE()?t.flood(l,h).composite(t.sourceAlpha,"in").offset(o,r).gaussianBlur(n):t.flood(l,h).composite(t.sourceAlpha,"in").offset(o,r).gaussianBlur(n).merge(t.source),t.blend(t.source,e)})),c||t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node),t}},{key:"setSelectionFilter",value:function(t,e,i){var a=this.w;if(void 0!==a.globals.selectedDataPoints[e]&&a.globals.selectedDataPoints[e].indexOf(i)>-1){t.node.setAttribute("selected",!0);var s=a.config.states.active.filter;"none"!==s&&this.applyFilter(t,e,s.type,s.value)}}},{key:"_scaleFilterSize",value:function(t){!function(e){for(var i in e)e.hasOwnProperty(i)&&t.setAttribute(i,e[i])}({width:"200%",height:"200%",x:"-50%",y:"-50%"})}}]),t}(),m=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"roundPathCorners",value:function(t,e){function i(t,e,i){var s=e.x-t.x,r=e.y-t.y,o=Math.sqrt(s*s+r*r);return a(t,e,Math.min(1,i/o))}function a(t,e,i){return{x:t.x+(e.x-t.x)*i,y:t.y+(e.y-t.y)*i}}function s(t,e){t.length>2&&(t[t.length-2]=e.x,t[t.length-1]=e.y)}function r(t){return{x:parseFloat(t[t.length-2]),y:parseFloat(t[t.length-1])}}t.indexOf("NaN")>-1&&(t="");var o=t.split(/[,\s]/).reduce((function(t,e){var i=e.match("([a-zA-Z])(.+)");return i?(t.push(i[1]),t.push(i[2])):t.push(e),t}),[]).reduce((function(t,e){return parseFloat(e)==e&&t.length?t[t.length-1].push(e):t.push([e]),t}),[]),n=[];if(o.length>1){var l=r(o[0]),h=null;"Z"==o[o.length-1][0]&&o[0].length>2&&(h=["L",l.x,l.y],o[o.length-1]=h),n.push(o[0]);for(var c=1;c<o.length;c++){var d=n[n.length-1],g=o[c],u=g==h?o[1]:o[c+1];if(u&&d&&d.length>2&&"L"==g[0]&&u.length>2&&"L"==u[0]){var p,f,x=r(d),b=r(g),v=r(u);p=i(b,x,e),f=i(b,v,e),s(g,p),g.origPoint=b,n.push(g);var m=a(p,b,.5),y=a(b,f,.5),w=["C",m.x,m.y,y.x,y.y,f.x,f.y];w.origPoint=b,n.push(w)}else n.push(g)}if(h){var k=r(n[n.length-1]);n.push(["Z"]),s(n[0],k)}}else n=o;return n.reduce((function(t,e){return t+e.join(" ")+" "}),"")}},{key:"drawLine",value:function(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"#a8a8a8",r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,o=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,n=arguments.length>7&&void 0!==arguments[7]?arguments[7]:"butt";return this.w.globals.dom.Paper.line().attr({x1:t,y1:e,x2:i,y2:a,stroke:s,"stroke-dasharray":r,"stroke-width":o,"stroke-linecap":n})}},{key:"drawRect",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"#fefefe",o=arguments.length>6&&void 0!==arguments[6]?arguments[6]:1,n=arguments.length>7&&void 0!==arguments[7]?arguments[7]:null,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:null,h=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,c=this.w.globals.dom.Paper.rect();return c.attr({x:t,y:e,width:i>0?i:0,height:a>0?a:0,rx:s,ry:s,opacity:o,"stroke-width":null!==n?n:0,stroke:null!==l?l:"none","stroke-dasharray":h}),c.node.setAttribute("fill",r),c}},{key:"drawPolygon",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#e1e1e1",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"none";return this.w.globals.dom.Paper.polygon(t).attr({fill:a,stroke:e,"stroke-width":i})}},{key:"drawCircle",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;t<0&&(t=0);var i=this.w.globals.dom.Paper.circle(2*t);return null!==e&&i.attr(e),i}},{key:"drawPath",value:function(t){var e=t.d,i=void 0===e?"":e,a=t.stroke,s=void 0===a?"#a8a8a8":a,r=t.strokeWidth,o=void 0===r?1:r,n=t.fill,l=t.fillOpacity,h=void 0===l?1:l,c=t.strokeOpacity,d=void 0===c?1:c,g=t.classes,u=t.strokeLinecap,p=void 0===u?null:u,f=t.strokeDashArray,x=void 0===f?0:f,b=this.w;return null===p&&(p=b.config.stroke.lineCap),(i.indexOf("undefined")>-1||i.indexOf("NaN")>-1)&&(i="M 0 ".concat(b.globals.gridHeight)),b.globals.dom.Paper.path(i).attr({fill:n,"fill-opacity":h,stroke:s,"stroke-opacity":d,"stroke-linecap":p,"stroke-width":o,"stroke-dasharray":x,class:g})}},{key:"group",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=this.w.globals.dom.Paper.group();return null!==t&&e.attr(t),e}},{key:"move",value:function(t,e){var i=["M",t,e].join(" ");return i}},{key:"line",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=null;return null===i?a=[" L",t,e].join(" "):"H"===i?a=[" H",t].join(" "):"V"===i&&(a=[" V",e].join(" ")),a}},{key:"curve",value:function(t,e,i,a,s,r){var o=["C",t,e,i,a,s,r].join(" ");return o}},{key:"quadraticCurve",value:function(t,e,i,a){return["Q",t,e,i,a].join(" ")}},{key:"arc",value:function(t,e,i,a,s,r,o){var n="A";arguments.length>7&&void 0!==arguments[7]&&arguments[7]&&(n="a");var l=[n,t,e,i,a,s,r,o].join(" ");return l}},{key:"renderPaths",value:function(t){var i,a=t.j,s=t.realIndex,r=t.pathFrom,o=t.pathTo,n=t.stroke,l=t.strokeWidth,h=t.strokeLinecap,c=t.fill,d=t.animationDelay,g=t.initialSpeed,u=t.dataChangeSpeed,p=t.className,f=t.shouldClipToGrid,x=void 0===f||f,m=t.bindEventsOnPaths,y=void 0===m||m,w=t.drawShadow,k=void 0===w||w,A=this.w,S=new v(this.ctx),C=new b(this.ctx),L=this.w.config.chart.animations.enabled,P=L&&this.w.config.chart.animations.dynamicAnimation.enabled,M=!!(L&&!A.globals.resized||P&&A.globals.dataChanged&&A.globals.shouldAnimate);M?i=r:(i=o,A.globals.animationEnded=!0);var I=A.config.stroke.dashArray,T=0;T=Array.isArray(I)?I[s]:A.config.stroke.dashArray;var z=this.drawPath({d:i,stroke:n,strokeWidth:l,fill:c,fillOpacity:1,classes:p,strokeLinecap:h,strokeDashArray:T});if(z.attr("index",s),x&&z.attr({"clip-path":"url(#gridRectMask".concat(A.globals.cuid,")")}),"none"!==A.config.states.normal.filter.type)S.getDefaultFilter(z,s);else if(A.config.chart.dropShadow.enabled&&k){var X=A.config.chart.dropShadow;S.dropShadow(z,X,s)}y&&(z.node.addEventListener("mouseenter",this.pathMouseEnter.bind(this,z)),z.node.addEventListener("mouseleave",this.pathMouseLeave.bind(this,z)),z.node.addEventListener("mousedown",this.pathMouseDown.bind(this,z))),z.attr({pathTo:o,pathFrom:r});var E={el:z,j:a,realIndex:s,pathFrom:r,pathTo:o,fill:c,strokeWidth:l,delay:d};return!L||A.globals.resized||A.globals.dataChanged?!A.globals.resized&&A.globals.dataChanged||C.showDelayedElements():C.animatePathsGradually(e(e({},E),{},{speed:g})),A.globals.dataChanged&&P&&M&&C.animatePathsGradually(e(e({},E),{},{speed:u})),z}},{key:"drawPattern",value:function(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"#a8a8a8",s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0;return this.w.globals.dom.Paper.pattern(e,i,(function(r){"horizontalLines"===t?r.line(0,0,i,0).stroke({color:a,width:s+1}):"verticalLines"===t?r.line(0,0,0,e).stroke({color:a,width:s+1}):"slantedLines"===t?r.line(0,0,e,i).stroke({color:a,width:s}):"squares"===t?r.rect(e,i).fill("none").stroke({color:a,width:s}):"circles"===t&&r.circle(e).fill("none").stroke({color:a,width:s})}))}},{key:"drawGradient",value:function(t,e,i,a,s){var r,o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,n=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,l=arguments.length>7&&void 0!==arguments[7]?arguments[7]:null,h=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,c=this.w;e.length<9&&0===e.indexOf("#")&&(e=x.hexToRgba(e,a)),i.length<9&&0===i.indexOf("#")&&(i=x.hexToRgba(i,s));var d=0,g=1,u=1,p=null;null!==n&&(d=void 0!==n[0]?n[0]/100:0,g=void 0!==n[1]?n[1]/100:1,u=void 0!==n[2]?n[2]/100:1,p=void 0!==n[3]?n[3]/100:null);var f=!("donut"!==c.config.chart.type&&"pie"!==c.config.chart.type&&"polarArea"!==c.config.chart.type&&"bubble"!==c.config.chart.type);if(r=null===l||0===l.length?c.globals.dom.Paper.gradient(f?"radial":"linear",(function(t){t.at(d,e,a),t.at(g,i,s),t.at(u,i,s),null!==p&&t.at(p,e,a)})):c.globals.dom.Paper.gradient(f?"radial":"linear",(function(t){(Array.isArray(l[h])?l[h]:l).forEach((function(e){t.at(e.offset/100,e.color,e.opacity)}))})),f){var b=c.globals.gridWidth/2,v=c.globals.gridHeight/2;"bubble"!==c.config.chart.type?r.attr({gradientUnits:"userSpaceOnUse",cx:b,cy:v,r:o}):r.attr({cx:.5,cy:.5,r:.8,fx:.2,fy:.2})}else"vertical"===t?r.from(0,0).to(0,1):"diagonal"===t?r.from(0,0).to(1,1):"horizontal"===t?r.from(0,1).to(1,1):"diagonal2"===t&&r.from(1,0).to(0,1);return r}},{key:"getTextBasedOnMaxWidth",value:function(t){var e=t.text,i=t.maxWidth,a=t.fontSize,s=t.fontFamily,r=this.getTextRects(e,a,s),o=r.width/e.length,n=Math.floor(i/o);return i<r.width?e.slice(0,n-3)+"...":e}},{key:"drawText",value:function(t){var i=this,a=t.x,s=t.y,r=t.text,o=t.textAnchor,n=t.fontSize,l=t.fontFamily,h=t.fontWeight,c=t.foreColor,d=t.opacity,g=t.maxWidth,u=t.cssClass,p=void 0===u?"":u,f=t.isPlainText,x=void 0===f||f,b=t.dominantBaseline,v=void 0===b?"auto":b,m=this.w;void 0===r&&(r="");var y=r;o||(o="start"),c&&c.length||(c=m.config.chart.foreColor),l=l||m.config.chart.fontFamily,h=h||"regular";var w,k={maxWidth:g,fontSize:n=n||"11px",fontFamily:l};return Array.isArray(r)?w=m.globals.dom.Paper.text((function(t){for(var a=0;a<r.length;a++)y=r[a],g&&(y=i.getTextBasedOnMaxWidth(e({text:r[a]},k))),0===a?t.tspan(y):t.tspan(y).newLine()})):(g&&(y=this.getTextBasedOnMaxWidth(e({text:r},k))),w=x?m.globals.dom.Paper.plain(r):m.globals.dom.Paper.text((function(t){return t.tspan(y)}))),w.attr({x:a,y:s,"text-anchor":o,"dominant-baseline":v,"font-size":n,"font-family":l,"font-weight":h,fill:c,class:"apexcharts-text "+p}),w.node.style.fontFamily=l,w.node.style.opacity=d,w}},{key:"createGroupWithAttributes",value:function(t,e,i,a){var s=this.group();return i.forEach((function(t){return s.add(t)})),s.attr({class:a.class?a.class:"",cy:e,cx:t}),s}},{key:"drawPlus",value:function(t,e,i,a){var s=i/2,r=this.drawLine(t,e-s,t,e+s,a.pointStrokeColor,a.pointStrokeDashArray,a.pointStrokeWidth,a.pointStrokeLineCap),o=this.drawLine(t-s,e,t+s,e,a.pointStrokeColor,a.pointStrokeDashArray,a.pointStrokeWidth,a.pointStrokeLineCap);return this.createGroupWithAttributes(t,e,[r,o],a)}},{key:"drawX",value:function(t,e,i,a){var s=i/2,r=this.drawLine(t-s,e-s,t+s,e+s,a.pointStrokeColor,a.pointStrokeDashArray,a.pointStrokeWidth,a.pointStrokeLineCap),o=this.drawLine(t-s,e+s,t+s,e-s,a.pointStrokeColor,a.pointStrokeDashArray,a.pointStrokeWidth,a.pointStrokeLineCap);return this.createGroupWithAttributes(t,e,[r,o],a)}},{key:"drawMarker",value:function(t,e,i){t=t||0;var a=i.pSize||0,s=null;if("X"===(null==i?void 0:i.shape)||"x"===(null==i?void 0:i.shape))s=this.drawX(t,e,a,i);else if("plus"===(null==i?void 0:i.shape)||"+"===(null==i?void 0:i.shape))s=this.drawPlus(t,e,a,i);else if("square"===i.shape||"rect"===i.shape){var r=void 0===i.pRadius?a/2:i.pRadius;null!==e&&a||(a=0,r=0);var o=1.2*a+r,n=this.drawRect(o,o,o,o,r);n.attr({x:t-o/2,y:e-o/2,cx:t,cy:e,class:i.class?i.class:"",fill:i.pointFillColor,"fill-opacity":i.pointFillOpacity?i.pointFillOpacity:1,stroke:i.pointStrokeColor,"stroke-width":i.pointStrokeWidth?i.pointStrokeWidth:0,"stroke-opacity":i.pointStrokeOpacity?i.pointStrokeOpacity:1}),s=n}else"circle"!==i.shape&&i.shape||(x.isNumber(e)||(a=0,e=0),s=this.drawCircle(a,{cx:t,cy:e,class:i.class?i.class:"",stroke:i.pointStrokeColor,fill:i.pointFillColor,"fill-opacity":i.pointFillOpacity?i.pointFillOpacity:1,"stroke-width":i.pointStrokeWidth?i.pointStrokeWidth:0,"stroke-opacity":i.pointStrokeOpacity?i.pointStrokeOpacity:1}));return s}},{key:"pathMouseEnter",value:function(t,e){var i=this.w,a=new v(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10);if("function"==typeof i.config.chart.events.dataPointMouseEnter&&i.config.chart.events.dataPointMouseEnter(e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}),this.ctx.events.fireEvent("dataPointMouseEnter",[e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}]),("none"===i.config.states.active.filter.type||"true"!==t.node.getAttribute("selected"))&&"none"!==i.config.states.hover.filter.type&&!i.globals.isTouchDevice){var o=i.config.states.hover.filter;a.applyFilter(t,s,o.type,o.value)}}},{key:"pathMouseLeave",value:function(t,e){var i=this.w,a=new v(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10);"function"==typeof i.config.chart.events.dataPointMouseLeave&&i.config.chart.events.dataPointMouseLeave(e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}),this.ctx.events.fireEvent("dataPointMouseLeave",[e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}]),"none"!==i.config.states.active.filter.type&&"true"===t.node.getAttribute("selected")||"none"!==i.config.states.hover.filter.type&&a.getDefaultFilter(t,s)}},{key:"pathMouseDown",value:function(t,e){var i=this.w,a=new v(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10),o="false";if("true"===t.node.getAttribute("selected")){if(t.node.setAttribute("selected","false"),i.globals.selectedDataPoints[s].indexOf(r)>-1){var n=i.globals.selectedDataPoints[s].indexOf(r);i.globals.selectedDataPoints[s].splice(n,1)}}else{if(!i.config.states.active.allowMultipleDataPointsSelection&&i.globals.selectedDataPoints.length>0){i.globals.selectedDataPoints=[];var l=i.globals.dom.Paper.select(".apexcharts-series path").members,h=i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members,c=function(t){Array.prototype.forEach.call(t,(function(t){t.node.setAttribute("selected","false"),a.getDefaultFilter(t,s)}))};c(l),c(h)}t.node.setAttribute("selected","true"),o="true",void 0===i.globals.selectedDataPoints[s]&&(i.globals.selectedDataPoints[s]=[]),i.globals.selectedDataPoints[s].push(r)}if("true"===o){var d=i.config.states.active.filter;if("none"!==d)a.applyFilter(t,s,d.type,d.value);else if("none"!==i.config.states.hover.filter&&!i.globals.isTouchDevice){var g=i.config.states.hover.filter;a.applyFilter(t,s,g.type,g.value)}}else if("none"!==i.config.states.active.filter.type)if("none"===i.config.states.hover.filter.type||i.globals.isTouchDevice)a.getDefaultFilter(t,s);else{g=i.config.states.hover.filter;a.applyFilter(t,s,g.type,g.value)}"function"==typeof i.config.chart.events.dataPointSelection&&i.config.chart.events.dataPointSelection(e,this.ctx,{selectedDataPoints:i.globals.selectedDataPoints,seriesIndex:s,dataPointIndex:r,w:i}),e&&this.ctx.events.fireEvent("dataPointSelection",[e,this.ctx,{selectedDataPoints:i.globals.selectedDataPoints,seriesIndex:s,dataPointIndex:r,w:i}])}},{key:"rotateAroundCenter",value:function(t){var e={};return t&&"function"==typeof t.getBBox&&(e=t.getBBox()),{x:e.x+e.width/2,y:e.y+e.height/2}}},{key:"getTextRects",value:function(t,e,i,a){var s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=this.w,o=this.drawText({x:-200,y:-200,text:t,textAnchor:"start",fontSize:e,fontFamily:i,foreColor:"#fff",opacity:0});a&&o.attr("transform",a),r.globals.dom.Paper.add(o);var n=o.bbox();return s||(n=o.node.getBoundingClientRect()),o.remove(),{width:n.width,height:n.height}}},{key:"placeTextWithEllipsis",value:function(t,e,i){if("function"==typeof t.getComputedTextLength&&(t.textContent=e,e.length>0&&t.getComputedTextLength()>=i/1.1)){for(var a=e.length-3;a>0;a-=3)if(t.getSubStringLength(0,a)<=i/1.1)return void(t.textContent=e.substring(0,a)+"...");t.textContent="."}}}],[{key:"setAttrs",value:function(t,e){for(var i in e)e.hasOwnProperty(i)&&t.setAttribute(i,e[i])}}]),t}(),y=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"getStackedSeriesTotals",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=this.w,i=[];if(0===e.globals.series.length)return i;for(var a=0;a<e.globals.series[e.globals.maxValsInArrayIndex].length;a++){for(var s=0,r=0;r<e.globals.series.length;r++)void 0!==e.globals.series[r][a]&&-1===t.indexOf(r)&&(s+=e.globals.series[r][a]);i.push(s)}return i}},{key:"getSeriesTotalByIndex",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return null===t?this.w.config.series.reduce((function(t,e){return t+e}),0):this.w.globals.series[t].reduce((function(t,e){return t+e}),0)}},{key:"getStackedSeriesTotalsByGroups",value:function(){var t=this,e=this.w,i=[];return e.globals.seriesGroups.forEach((function(a){var s=[];e.config.series.forEach((function(t,i){a.indexOf(e.globals.seriesNames[i])>-1&&s.push(i)}));var r=e.globals.series.map((function(t,e){return-1===s.indexOf(e)?e:-1})).filter((function(t){return-1!==t}));i.push(t.getStackedSeriesTotals(r))})),i}},{key:"setSeriesYAxisMappings",value:function(){var t=this.w.globals,e=this.w.config,i=[],a=[],s=[],r=t.series.length>e.yaxis.length||e.yaxis.some((function(t){return Array.isArray(t.seriesName)}));e.series.forEach((function(t,e){s.push(e),a.push(null)})),e.yaxis.forEach((function(t,e){i[e]=[]}));var o=[];e.yaxis.forEach((function(t,a){var n=!1;if(t.seriesName){var l=[];Array.isArray(t.seriesName)?l=t.seriesName:l.push(t.seriesName),l.forEach((function(t){e.series.forEach((function(e,o){if(e.name===t){var l=o;a===o||r?!r||s.indexOf(o)>-1?i[a].push([a,o]):console.warn("Series '"+e.name+"' referenced more than once in what looks like the new style. That is, when using either seriesName: [], or when there are more series than yaxes."):(i[o].push([o,a]),l=a),n=!0,-1!==(l=s.indexOf(l))&&s.splice(l,1)}}))}))}n||o.push(a)})),i=i.map((function(t,e){var i=[];return t.forEach((function(t){a[t[1]]=t[0],i.push(t[1])})),i}));for(var n=e.yaxis.length-1,l=0;l<o.length&&(n=o[l],i[n]=[],s);l++){var h=s[0];s.shift(),i[n].push(h),a[h]=n}s.forEach((function(t){i[n].push(t),a[t]=n})),t.seriesYAxisMap=i.map((function(t){return t})),t.seriesYAxisReverseMap=a.map((function(t){return t})),t.seriesYAxisMap.forEach((function(t,i){t.forEach((function(t){e.series[t]&&void 0===e.series[t].group&&(e.series[t].group="apexcharts-axis-".concat(i.toString()))}))}))}},{key:"isSeriesNull",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return 0===(null===t?this.w.config.series.filter((function(t){return null!==t})):this.w.config.series[t].data.filter((function(t){return null!==t}))).length}},{key:"seriesHaveSameValues",value:function(t){return this.w.globals.series[t].every((function(t,e,i){return t===i[0]}))}},{key:"getCategoryLabels",value:function(t){var e=this.w,i=t.slice();return e.config.xaxis.convertedCatToNumeric&&(i=t.map((function(t,i){return e.config.xaxis.labels.formatter(t-e.globals.minX+1)}))),i}},{key:"getLargestSeries",value:function(){var t=this.w;t.globals.maxValsInArrayIndex=t.globals.series.map((function(t){return t.length})).indexOf(Math.max.apply(Math,t.globals.series.map((function(t){return t.length}))))}},{key:"getLargestMarkerSize",value:function(){var t=this.w,e=0;return t.globals.markers.size.forEach((function(t){e=Math.max(e,t)})),t.config.markers.discrete&&t.config.markers.discrete.length&&t.config.markers.discrete.forEach((function(t){e=Math.max(e,t.size)})),e>0&&(e+=t.config.markers.hover.sizeOffset+1),t.globals.markers.largestSize=e,e}},{key:"getSeriesTotals",value:function(){var t=this.w;t.globals.seriesTotals=t.globals.series.map((function(t,e){var i=0;if(Array.isArray(t))for(var a=0;a<t.length;a++)i+=t[a];else i+=t;return i}))}},{key:"getSeriesTotalsXRange",value:function(t,e){var i=this.w;return i.globals.series.map((function(a,s){for(var r=0,o=0;o<a.length;o++)i.globals.seriesX[s][o]>t&&i.globals.seriesX[s][o]<e&&(r+=a[o]);return r}))}},{key:"getPercentSeries",value:function(){var t=this.w;t.globals.seriesPercent=t.globals.series.map((function(e,i){var a=[];if(Array.isArray(e))for(var s=0;s<e.length;s++){var r=t.globals.stackedSeriesTotals[s],o=0;r&&(o=100*e[s]/r),a.push(o)}else{var n=100*e/t.globals.seriesTotals.reduce((function(t,e){return t+e}),0);a.push(n)}return a}))}},{key:"getCalculatedRatios",value:function(){var t,e,i,a=this,s=this.w,r=s.globals,o=[],n=0,l=[],h=.1,c=0;if(r.yRange=[],r.isMultipleYAxis)for(var d=0;d<r.minYArr.length;d++)r.yRange.push(Math.abs(r.minYArr[d]-r.maxYArr[d])),l.push(0);else r.yRange.push(Math.abs(r.minY-r.maxY));r.xRange=Math.abs(r.maxX-r.minX),r.zRange=Math.abs(r.maxZ-r.minZ);for(var g=0;g<r.yRange.length;g++)o.push(r.yRange[g]/r.gridHeight);if(e=r.xRange/r.gridWidth,t=r.yRange/r.gridWidth,i=r.xRange/r.gridHeight,(n=r.zRange/r.gridHeight*16)||(n=1),r.minY!==Number.MIN_VALUE&&0!==Math.abs(r.minY)&&(r.hasNegs=!0),s.globals.seriesYAxisReverseMap.length>0){var u=function(t,e){var i=s.config.yaxis[s.globals.seriesYAxisReverseMap[e]],r=t<0?-1:1;return t=Math.abs(t),i.logarithmic&&(t=a.getBaseLog(i.logBase,t)),-r*t/o[e]};if(r.isMultipleYAxis){l=[];for(var p=0;p<o.length;p++)l.push(u(r.minYArr[p],p))}else(l=[]).push(u(r.minY,0)),r.minY!==Number.MIN_VALUE&&0!==Math.abs(r.minY)&&(h=-r.minY/t,c=r.minX/e)}else(l=[]).push(0),h=0,c=0;return{yRatio:o,invertedYRatio:t,zRatio:n,xRatio:e,invertedXRatio:i,baseLineInvertedY:h,baseLineY:l,baseLineX:c}}},{key:"getLogSeries",value:function(t){var e=this,i=this.w;return i.globals.seriesLog=t.map((function(t,a){var s=i.globals.seriesYAxisReverseMap[a];return i.config.yaxis[s]&&i.config.yaxis[s].logarithmic?t.map((function(t){return null===t?null:e.getLogVal(i.config.yaxis[s].logBase,t,a)})):t})),i.globals.invalidLogScale?t:i.globals.seriesLog}},{key:"getBaseLog",value:function(t,e){return Math.log(e)/Math.log(t)}},{key:"getLogVal",value:function(t,e,i){if(e<=0)return 0;var a=this.w,s=0===a.globals.minYArr[i]?-1:this.getBaseLog(t,a.globals.minYArr[i]),r=(0===a.globals.maxYArr[i]?0:this.getBaseLog(t,a.globals.maxYArr[i]))-s;return e<1?e/r:(this.getBaseLog(t,e)-s)/r}},{key:"getLogYRatios",value:function(t){var e=this,i=this.w,a=this.w.globals;return a.yLogRatio=t.slice(),a.logYRange=a.yRange.map((function(t,s){var r=i.globals.seriesYAxisReverseMap[s];if(i.config.yaxis[r]&&e.w.config.yaxis[r].logarithmic){var o,n=-Number.MAX_VALUE,l=Number.MIN_VALUE;return a.seriesLog.forEach((function(t,e){t.forEach((function(t){i.config.yaxis[e]&&i.config.yaxis[e].logarithmic&&(n=Math.max(t,n),l=Math.min(t,l))}))})),o=Math.pow(a.yRange[s],Math.abs(l-n)/a.yRange[s]),a.yLogRatio[s]=o/a.gridHeight,o}})),a.invalidLogScale?t.slice():a.yLogRatio}},{key:"drawSeriesByGroup",value:function(t,e,i,a){var s=this.w,r=[];return t.series.length>0&&e.forEach((function(e){var o=[],n=[];t.i.forEach((function(i,a){s.config.series[i].group===e&&(o.push(t.series[a]),n.push(i))})),o.length>0&&r.push(a.draw(o,i,n))})),r}}],[{key:"checkComboSeries",value:function(t,e){var i=!1,a=0,s=0;return void 0===e&&(e="line"),t.length&&void 0!==t[0].type&&t.forEach((function(t){"bar"!==t.type&&"column"!==t.type&&"candlestick"!==t.type&&"boxPlot"!==t.type||a++,void 0!==t.type&&t.type!==e&&s++})),s>0&&(i=!0),{comboBarCount:a,comboCharts:i}}},{key:"extendArrayProps",value:function(t,e,i){var a,s,r,o,n,l;(null!==(a=e)&&void 0!==a&&a.yaxis&&(e=t.extendYAxis(e,i)),null!==(s=e)&&void 0!==s&&s.annotations)&&(e.annotations.yaxis&&(e=t.extendYAxisAnnotations(e)),null!==(r=e)&&void 0!==r&&null!==(o=r.annotations)&&void 0!==o&&o.xaxis&&(e=t.extendXAxisAnnotations(e)),null!==(n=e)&&void 0!==n&&null!==(l=n.annotations)&&void 0!==l&&l.points&&(e=t.extendPointAnnotations(e)));return e}}]),t}(),w=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e}return r(t,[{key:"setOrientations",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.w;if("vertical"===t.label.orientation){var a=null!==e?e:0,s=i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a,"']"));if(null!==s){var r=s.getBoundingClientRect();s.setAttribute("x",parseFloat(s.getAttribute("x"))-r.height+4),"top"===t.label.position?s.setAttribute("y",parseFloat(s.getAttribute("y"))+r.width):s.setAttribute("y",parseFloat(s.getAttribute("y"))-r.width);var o=this.annoCtx.graphics.rotateAroundCenter(s),n=o.x,l=o.y;s.setAttribute("transform","rotate(-90 ".concat(n," ").concat(l,")"))}}}},{key:"addBackgroundToAnno",value:function(t,e){var i=this.w;if(!t||void 0===e.label.text||void 0!==e.label.text&&!String(e.label.text).trim())return null;var a=i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(),s=t.getBoundingClientRect(),r=e.label.style.padding.left,o=e.label.style.padding.right,n=e.label.style.padding.top,l=e.label.style.padding.bottom;"vertical"===e.label.orientation&&(n=e.label.style.padding.left,l=e.label.style.padding.right,r=e.label.style.padding.top,o=e.label.style.padding.bottom);var h=s.left-a.left-r,c=s.top-a.top-n,d=this.annoCtx.graphics.drawRect(h-i.globals.barPadForNumericAxis,c,s.width+r+o,s.height+n+l,e.label.borderRadius,e.label.style.background,1,e.label.borderWidth,e.label.borderColor,0);return e.id&&d.node.classList.add(e.id),d}},{key:"annotationsBackground",value:function(){var t=this,e=this.w,i=function(i,a,s){var r=e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations .apexcharts-").concat(s,"-annotation-label[rel='").concat(a,"']"));if(r){var o=r.parentNode,n=t.addBackgroundToAnno(r,i);n&&(o.insertBefore(n.node,r),i.label.mouseEnter&&n.node.addEventListener("mouseenter",i.label.mouseEnter.bind(t,i)),i.label.mouseLeave&&n.node.addEventListener("mouseleave",i.label.mouseLeave.bind(t,i)),i.label.click&&n.node.addEventListener("click",i.label.click.bind(t,i)))}};e.config.annotations.xaxis.map((function(t,e){i(t,e,"xaxis")})),e.config.annotations.yaxis.map((function(t,e){i(t,e,"yaxis")})),e.config.annotations.points.map((function(t,e){i(t,e,"point")}))}},{key:"getY1Y2",value:function(t,e){var i,a="y1"===t?e.y:e.y2,s=!1,r=this.w;if(this.annoCtx.invertAxis){var o=r.globals.labels;r.config.xaxis.convertedCatToNumeric&&(o=r.globals.categoryLabels);var n=o.indexOf(a),l=r.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child("+(n+1)+")");i=l?parseFloat(l.getAttribute("y")):(r.globals.gridHeight/o.length-1)*(n+1)-r.globals.barHeight,void 0!==e.seriesIndex&&r.globals.barHeight&&(i=i-r.globals.barHeight/2*(r.globals.series.length-1)+r.globals.barHeight*e.seriesIndex)}else{var h,c=r.globals.seriesYAxisMap[e.yAxisIndex][0];if(r.config.yaxis[e.yAxisIndex].logarithmic)h=(a=new y(this.annoCtx.ctx).getLogVal(r.config.yaxis[e.yAxisIndex].logBase,a,c))/r.globals.yLogRatio[c];else h=(a-r.globals.minYArr[c])/(r.globals.yRange[c]/r.globals.gridHeight);h>r.globals.gridHeight?(h=r.globals.gridHeight,s=!0):h<0&&(h=0,s=!0),i=r.globals.gridHeight-h,!e.marker||void 0!==e.y&&null!==e.y||(i=0),r.config.yaxis[e.yAxisIndex]&&r.config.yaxis[e.yAxisIndex].reversed&&(i=h)}return"string"==typeof a&&a.indexOf("px")>-1&&(i=parseFloat(a)),{yP:i,clipped:s}}},{key:"getX1X2",value:function(t,e){var i,a="x1"===t?e.x:e.x2,s=this.w,r=this.annoCtx.invertAxis?s.globals.minY:s.globals.minX,o=this.annoCtx.invertAxis?s.globals.maxY:s.globals.maxX,n=this.annoCtx.invertAxis?s.globals.yRange[0]:s.globals.xRange,l=!1;return i=this.annoCtx.inversedReversedAxis?(o-a)/(n/s.globals.gridWidth):(a-r)/(n/s.globals.gridWidth),"category"!==s.config.xaxis.type&&!s.config.xaxis.convertedCatToNumeric||this.annoCtx.invertAxis||s.globals.dataFormatXNumeric||s.config.chart.sparkline.enabled||(i=this.getStringX(a)),"string"==typeof a&&a.indexOf("px")>-1&&(i=parseFloat(a)),null==a&&e.marker&&(i=s.globals.gridWidth),void 0!==e.seriesIndex&&s.globals.barWidth&&!this.annoCtx.invertAxis&&(i=i-s.globals.barWidth/2*(s.globals.series.length-1)+s.globals.barWidth*e.seriesIndex),i>s.globals.gridWidth?(i=s.globals.gridWidth,l=!0):i<0&&(i=0,l=!0),{x:i,clipped:l}}},{key:"getStringX",value:function(t){var e=this.w,i=t;e.config.xaxis.convertedCatToNumeric&&e.globals.categoryLabels.length&&(t=e.globals.categoryLabels.indexOf(t)+1);var a=e.globals.labels.indexOf(t),s=e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child("+(a+1)+")");return s&&(i=parseFloat(s.getAttribute("x"))),i}}]),t}(),k=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e,this.invertAxis=this.annoCtx.invertAxis,this.helpers=new w(this.annoCtx)}return r(t,[{key:"addXaxisAnnotation",value:function(t,e,i){var a,s=this.w,r=this.helpers.getX1X2("x1",t),o=r.x,n=r.clipped,l=!0,h=t.label.text,c=t.strokeDashArray;if(x.isNumber(o)){if(null===t.x2||void 0===t.x2){if(!n){var d=this.annoCtx.graphics.drawLine(o+t.offsetX,0+t.offsetY,o+t.offsetX,s.globals.gridHeight+t.offsetY,t.borderColor,c,t.borderWidth);e.appendChild(d.node),t.id&&d.node.classList.add(t.id)}}else{var g=this.helpers.getX1X2("x2",t);if(a=g.x,l=g.clipped,!n||!l){if(a<o){var u=o;o=a,a=u}var p=this.annoCtx.graphics.drawRect(o+t.offsetX,0+t.offsetY,a-o,s.globals.gridHeight+t.offsetY,0,t.fillColor,t.opacity,1,t.borderColor,c);p.node.classList.add("apexcharts-annotation-rect"),p.attr("clip-path","url(#gridRectMask".concat(s.globals.cuid,")")),e.appendChild(p.node),t.id&&p.node.classList.add(t.id)}}if(!n||!l){var f=this.annoCtx.graphics.getTextRects(h,parseFloat(t.label.style.fontSize)),b="top"===t.label.position?4:"center"===t.label.position?s.globals.gridHeight/2+("vertical"===t.label.orientation?f.width/2:0):s.globals.gridHeight,v=this.annoCtx.graphics.drawText({x:o+t.label.offsetX,y:b+t.label.offsetY-("vertical"===t.label.orientation?"top"===t.label.position?f.width/2-12:-f.width/2:0),text:h,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});v.attr({rel:i}),e.appendChild(v.node),this.annoCtx.helpers.setOrientations(t,i)}}}},{key:"drawXAxisAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-xaxis-annotations"});return e.config.annotations.xaxis.map((function(e,a){t.addXaxisAnnotation(e,i.node,a)})),i}}]),t}(),A=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.months31=[1,3,5,7,8,10,12],this.months30=[2,4,6,9,11],this.daysCntOfYear=[0,31,59,90,120,151,181,212,243,273,304,334]}return r(t,[{key:"isValidDate",value:function(t){return"number"!=typeof t&&!isNaN(this.parseDate(t))}},{key:"getTimeStamp",value:function(t){return Date.parse(t)?this.w.config.xaxis.labels.datetimeUTC?new Date(new Date(t).toISOString().substr(0,25)).getTime():new Date(t).getTime():t}},{key:"getDate",value:function(t){return this.w.config.xaxis.labels.datetimeUTC?new Date(new Date(t).toUTCString()):new Date(t)}},{key:"parseDate",value:function(t){var e=Date.parse(t);if(!isNaN(e))return this.getTimeStamp(t);var i=Date.parse(t.replace(/-/g,"/").replace(/[a-z]+/gi," "));return i=this.getTimeStamp(i)}},{key:"parseDateWithTimezone",value:function(t){return Date.parse(t.replace(/-/g,"/").replace(/[a-z]+/gi," "))}},{key:"formatDate",value:function(t,e){var i=this.w.globals.locale,a=this.w.config.xaxis.labels.datetimeUTC,s=["\0"].concat(u(i.months)),r=["\x01"].concat(u(i.shortMonths)),o=["\x02"].concat(u(i.days)),n=["\x03"].concat(u(i.shortDays));function l(t,e){var i=t+"";for(e=e||2;i.length<e;)i="0"+i;return i}var h=a?t.getUTCFullYear():t.getFullYear();e=(e=(e=e.replace(/(^|[^\\])yyyy+/g,"$1"+h)).replace(/(^|[^\\])yy/g,"$1"+h.toString().substr(2,2))).replace(/(^|[^\\])y/g,"$1"+h);var c=(a?t.getUTCMonth():t.getMonth())+1;e=(e=(e=(e=e.replace(/(^|[^\\])MMMM+/g,"$1"+s[0])).replace(/(^|[^\\])MMM/g,"$1"+r[0])).replace(/(^|[^\\])MM/g,"$1"+l(c))).replace(/(^|[^\\])M/g,"$1"+c);var d=a?t.getUTCDate():t.getDate();e=(e=(e=(e=e.replace(/(^|[^\\])dddd+/g,"$1"+o[0])).replace(/(^|[^\\])ddd/g,"$1"+n[0])).replace(/(^|[^\\])dd/g,"$1"+l(d))).replace(/(^|[^\\])d/g,"$1"+d);var g=a?t.getUTCHours():t.getHours(),p=g>12?g-12:0===g?12:g;e=(e=(e=(e=e.replace(/(^|[^\\])HH+/g,"$1"+l(g))).replace(/(^|[^\\])H/g,"$1"+g)).replace(/(^|[^\\])hh+/g,"$1"+l(p))).replace(/(^|[^\\])h/g,"$1"+p);var f=a?t.getUTCMinutes():t.getMinutes();e=(e=e.replace(/(^|[^\\])mm+/g,"$1"+l(f))).replace(/(^|[^\\])m/g,"$1"+f);var x=a?t.getUTCSeconds():t.getSeconds();e=(e=e.replace(/(^|[^\\])ss+/g,"$1"+l(x))).replace(/(^|[^\\])s/g,"$1"+x);var b=a?t.getUTCMilliseconds():t.getMilliseconds();e=e.replace(/(^|[^\\])fff+/g,"$1"+l(b,3)),b=Math.round(b/10),e=e.replace(/(^|[^\\])ff/g,"$1"+l(b)),b=Math.round(b/10);var v=g<12?"AM":"PM";e=(e=(e=e.replace(/(^|[^\\])f/g,"$1"+b)).replace(/(^|[^\\])TT+/g,"$1"+v)).replace(/(^|[^\\])T/g,"$1"+v.charAt(0));var m=v.toLowerCase();e=(e=e.replace(/(^|[^\\])tt+/g,"$1"+m)).replace(/(^|[^\\])t/g,"$1"+m.charAt(0));var y=-t.getTimezoneOffset(),w=a||!y?"Z":y>0?"+":"-";if(!a){var k=(y=Math.abs(y))%60;w+=l(Math.floor(y/60))+":"+l(k)}e=e.replace(/(^|[^\\])K/g,"$1"+w);var A=(a?t.getUTCDay():t.getDay())+1;return e=(e=(e=(e=(e=e.replace(new RegExp(o[0],"g"),o[A])).replace(new RegExp(n[0],"g"),n[A])).replace(new RegExp(s[0],"g"),s[c])).replace(new RegExp(r[0],"g"),r[c])).replace(/\\(.)/g,"$1")}},{key:"getTimeUnitsfromTimestamp",value:function(t,e,i){var a=this.w;void 0!==a.config.xaxis.min&&(t=a.config.xaxis.min),void 0!==a.config.xaxis.max&&(e=a.config.xaxis.max);var s=this.getDate(t),r=this.getDate(e),o=this.formatDate(s,"yyyy MM dd HH mm ss fff").split(" "),n=this.formatDate(r,"yyyy MM dd HH mm ss fff").split(" ");return{minMillisecond:parseInt(o[6],10),maxMillisecond:parseInt(n[6],10),minSecond:parseInt(o[5],10),maxSecond:parseInt(n[5],10),minMinute:parseInt(o[4],10),maxMinute:parseInt(n[4],10),minHour:parseInt(o[3],10),maxHour:parseInt(n[3],10),minDate:parseInt(o[2],10),maxDate:parseInt(n[2],10),minMonth:parseInt(o[1],10)-1,maxMonth:parseInt(n[1],10)-1,minYear:parseInt(o[0],10),maxYear:parseInt(n[0],10)}}},{key:"isLeapYear",value:function(t){return t%4==0&&t%100!=0||t%400==0}},{key:"calculcateLastDaysOfMonth",value:function(t,e,i){return this.determineDaysOfMonths(t,e)-i}},{key:"determineDaysOfYear",value:function(t){var e=365;return this.isLeapYear(t)&&(e=366),e}},{key:"determineRemainingDaysOfYear",value:function(t,e,i){var a=this.daysCntOfYear[e]+i;return e>1&&this.isLeapYear()&&a++,a}},{key:"determineDaysOfMonths",value:function(t,e){var i=30;switch(t=x.monthMod(t),!0){case this.months30.indexOf(t)>-1:2===t&&(i=this.isLeapYear(e)?29:28);break;case this.months31.indexOf(t)>-1:default:i=31}return i}}]),t}(),S=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.tooltipKeyFormat="dd MMM"}return r(t,[{key:"xLabelFormat",value:function(t,e,i,a){var s=this.w;if("datetime"===s.config.xaxis.type&&void 0===s.config.xaxis.labels.formatter&&void 0===s.config.tooltip.x.formatter){var r=new A(this.ctx);return r.formatDate(r.getDate(e),s.config.tooltip.x.format)}return t(e,i,a)}},{key:"defaultGeneralFormatter",value:function(t){return Array.isArray(t)?t.map((function(t){return t})):t}},{key:"defaultYFormatter",value:function(t,e,i){var a=this.w;if(x.isNumber(t))if(0!==a.globals.yValueDecimal)t=t.toFixed(void 0!==e.decimalsInFloat?e.decimalsInFloat:a.globals.yValueDecimal);else{var s=t.toFixed(0);t=t==s?s:t.toFixed(1)}return t}},{key:"setLabelFormatters",value:function(){var t=this,e=this.w;return e.globals.xaxisTooltipFormatter=function(e){return t.defaultGeneralFormatter(e)},e.globals.ttKeyFormatter=function(e){return t.defaultGeneralFormatter(e)},e.globals.ttZFormatter=function(t){return t},e.globals.legendFormatter=function(e){return t.defaultGeneralFormatter(e)},void 0!==e.config.xaxis.labels.formatter?e.globals.xLabelFormatter=e.config.xaxis.labels.formatter:e.globals.xLabelFormatter=function(t){if(x.isNumber(t)){if(!e.config.xaxis.convertedCatToNumeric&&"numeric"===e.config.xaxis.type){if(x.isNumber(e.config.xaxis.decimalsInFloat))return t.toFixed(e.config.xaxis.decimalsInFloat);var i=e.globals.maxX-e.globals.minX;return i>0&&i<100?t.toFixed(1):t.toFixed(0)}if(e.globals.isBarHorizontal)if(e.globals.maxY-e.globals.minYArr<4)return t.toFixed(1);return t.toFixed(0)}return t},"function"==typeof e.config.tooltip.x.formatter?e.globals.ttKeyFormatter=e.config.tooltip.x.formatter:e.globals.ttKeyFormatter=e.globals.xLabelFormatter,"function"==typeof e.config.xaxis.tooltip.formatter&&(e.globals.xaxisTooltipFormatter=e.config.xaxis.tooltip.formatter),(Array.isArray(e.config.tooltip.y)||void 0!==e.config.tooltip.y.formatter)&&(e.globals.ttVal=e.config.tooltip.y),void 0!==e.config.tooltip.z.formatter&&(e.globals.ttZFormatter=e.config.tooltip.z.formatter),void 0!==e.config.legend.formatter&&(e.globals.legendFormatter=e.config.legend.formatter),e.config.yaxis.forEach((function(i,a){void 0!==i.labels.formatter?e.globals.yLabelFormatters[a]=i.labels.formatter:e.globals.yLabelFormatters[a]=function(s){return e.globals.xyCharts?Array.isArray(s)?s.map((function(e){return t.defaultYFormatter(e,i,a)})):t.defaultYFormatter(s,i,a):s}})),e.globals}},{key:"heatmapLabelFormatters",value:function(){var t=this.w;if("heatmap"===t.config.chart.type){t.globals.yAxisScale[0].result=t.globals.seriesNames.slice();var e=t.globals.seriesNames.reduce((function(t,e){return t.length>e.length?t:e}),0);t.globals.yAxisScale[0].niceMax=e,t.globals.yAxisScale[0].niceMin=e}}}]),t}(),C=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"getLabel",value:function(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"12px",o=!(arguments.length>6&&void 0!==arguments[6])||arguments[6],n=this.w,l=void 0===t[a]?"":t[a],h=l,c=n.globals.xLabelFormatter,d=n.config.xaxis.labels.formatter,g=!1,u=new S(this.ctx),p=l;o&&(h=u.xLabelFormat(c,l,p,{i:a,dateFormatter:new A(this.ctx).formatDate,w:n}),void 0!==d&&(h=d(l,t[a],{i:a,dateFormatter:new A(this.ctx).formatDate,w:n})));var f,x;e.length>0?(f=e[a].unit,x=null,e.forEach((function(t){"month"===t.unit?x="year":"day"===t.unit?x="month":"hour"===t.unit?x="day":"minute"===t.unit&&(x="hour")})),g=x===f,i=e[a].position,h=e[a].value):"datetime"===n.config.xaxis.type&&void 0===d&&(h=""),void 0===h&&(h=""),h=Array.isArray(h)?h:h.toString();var b=new m(this.ctx),v={};v=n.globals.rotateXLabels&&o?b.getTextRects(h,parseInt(r,10),null,"rotate(".concat(n.config.xaxis.labels.rotate," 0 0)"),!1):b.getTextRects(h,parseInt(r,10));var y=!n.config.xaxis.labels.showDuplicates&&this.ctx.timeScale;return!Array.isArray(h)&&("NaN"===String(h)||s.indexOf(h)>=0&&y)&&(h=""),{x:i,text:h,textRect:v,isBold:g}}},{key:"checkLabelBasedOnTickamount",value:function(t,e,i){var a=this.w,s=a.config.xaxis.tickAmount;return"dataPoints"===s&&(s=Math.round(a.globals.gridWidth/120)),s>i||t%Math.round(i/(s+1))==0||(e.text=""),e}},{key:"checkForOverflowingLabels",value:function(t,e,i,a,s){var r=this.w;if(0===t&&r.globals.skipFirstTimelinelabel&&(e.text=""),t===i-1&&r.globals.skipLastTimelinelabel&&(e.text=""),r.config.xaxis.labels.hideOverlappingLabels&&a.length>0){var o=s[s.length-1];e.x<o.textRect.width/(r.globals.rotateXLabels?Math.abs(r.config.xaxis.labels.rotate)/12:1.01)+o.x&&(e.text="")}return e}},{key:"checkForReversedLabels",value:function(t,e){var i=this.w;return i.config.yaxis[t]&&i.config.yaxis[t].reversed&&e.reverse(),e}},{key:"yAxisAllSeriesCollapsed",value:function(t){var e=this.w.globals;return!e.seriesYAxisMap[t].some((function(t){return-1===e.collapsedSeriesIndices.indexOf(t)}))}},{key:"translateYAxisIndex",value:function(t){var e=this.w,i=e.globals,a=e.config.yaxis;return i.series.length>a.length||a.some((function(t){return Array.isArray(t.seriesName)}))?t:i.seriesYAxisReverseMap[t]}},{key:"isYAxisHidden",value:function(t){var e=this.w,i=e.config.yaxis[t];if(!i.show||this.yAxisAllSeriesCollapsed(t))return!0;if(!i.showForNullSeries){var a=e.globals.seriesYAxisMap[t],s=new y(this.ctx);return a.every((function(t){return s.isSeriesNull(t)}))}return!1}},{key:"getYAxisForeColor",value:function(t,e){var i=this.w;return Array.isArray(t)&&i.globals.yAxisScale[e]&&this.ctx.theme.pushExtraColors(t,i.globals.yAxisScale[e].result.length,!1),t}},{key:"drawYAxisTicks",value:function(t,e,i,a,s,r,o){var n=this.w,l=new m(this.ctx),h=n.globals.translateY+n.config.yaxis[s].labels.offsetY;if(n.globals.isBarHorizontal?h=0:"heatmap"===n.config.chart.type&&(h+=r/2),a.show&&e>0){!0===n.config.yaxis[s].opposite&&(t+=a.width);for(var c=e;c>=0;c--){var d=l.drawLine(t+i.offsetX-a.width+a.offsetX,h+a.offsetY,t+i.offsetX+a.offsetX,h+a.offsetY,a.color);o.add(d),h+=r}}}}]),t}(),L=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e,this.helpers=new w(this.annoCtx),this.axesUtils=new C(this.annoCtx)}return r(t,[{key:"addYaxisAnnotation",value:function(t,e,i){var a,s=this.w,r=t.strokeDashArray,o=this.helpers.getY1Y2("y1",t),n=o.yP,l=o.clipped,h=!0,c=!1,d=t.label.text;if(null===t.y2||void 0===t.y2){if(!l){c=!0;var g=this.annoCtx.graphics.drawLine(0+t.offsetX,n+t.offsetY,this._getYAxisAnnotationWidth(t),n+t.offsetY,t.borderColor,r,t.borderWidth);e.appendChild(g.node),t.id&&g.node.classList.add(t.id)}}else{if(a=(o=this.helpers.getY1Y2("y2",t)).yP,h=o.clipped,a>n){var u=n;n=a,a=u}if(!l||!h){c=!0;var p=this.annoCtx.graphics.drawRect(0+t.offsetX,a+t.offsetY,this._getYAxisAnnotationWidth(t),n-a,0,t.fillColor,t.opacity,1,t.borderColor,r);p.node.classList.add("apexcharts-annotation-rect"),p.attr("clip-path","url(#gridRectMask".concat(s.globals.cuid,")")),e.appendChild(p.node),t.id&&p.node.classList.add(t.id)}}if(c){var f="right"===t.label.position?s.globals.gridWidth:"center"===t.label.position?s.globals.gridWidth/2:0,x=this.annoCtx.graphics.drawText({x:f+t.label.offsetX,y:(null!=a?a:n)+t.label.offsetY-3,text:d,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});x.attr({rel:i}),e.appendChild(x.node)}}},{key:"_getYAxisAnnotationWidth",value:function(t){var e=this.w;e.globals.gridWidth;return(t.width.indexOf("%")>-1?e.globals.gridWidth*parseInt(t.width,10)/100:parseInt(t.width,10))+t.offsetX}},{key:"drawYAxisAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-yaxis-annotations"});return e.config.annotations.yaxis.forEach((function(e,a){e.yAxisIndex=t.axesUtils.translateYAxisIndex(e.yAxisIndex),t.axesUtils.isYAxisHidden(e.yAxisIndex)&&t.axesUtils.yAxisAllSeriesCollapsed(e.yAxisIndex)||t.addYaxisAnnotation(e,i.node,a)})),i}}]),t}(),P=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e,this.helpers=new w(this.annoCtx)}return r(t,[{key:"addPointAnnotation",value:function(t,e,i){if(!(this.w.globals.collapsedSeriesIndices.indexOf(t.seriesIndex)>-1)){var a=this.helpers.getX1X2("x1",t),s=a.x,r=a.clipped,o=(a=this.helpers.getY1Y2("y1",t)).yP,n=a.clipped;if(x.isNumber(s)&&!n&&!r){var l={pSize:t.marker.size,pointStrokeWidth:t.marker.strokeWidth,pointFillColor:t.marker.fillColor,pointStrokeColor:t.marker.strokeColor,shape:t.marker.shape,pRadius:t.marker.radius,class:"apexcharts-point-annotation-marker ".concat(t.marker.cssClass," ").concat(t.id?t.id:"")},h=this.annoCtx.graphics.drawMarker(s+t.marker.offsetX,o+t.marker.offsetY,l);e.appendChild(h.node);var c=t.label.text?t.label.text:"",d=this.annoCtx.graphics.drawText({x:s+t.label.offsetX,y:o+t.label.offsetY-t.marker.size-parseFloat(t.label.style.fontSize)/1.6,text:c,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-point-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});if(d.attr({rel:i}),e.appendChild(d.node),t.customSVG.SVG){var g=this.annoCtx.graphics.group({class:"apexcharts-point-annotations-custom-svg "+t.customSVG.cssClass});g.attr({transform:"translate(".concat(s+t.customSVG.offsetX,", ").concat(o+t.customSVG.offsetY,")")}),g.node.innerHTML=t.customSVG.SVG,e.appendChild(g.node)}if(t.image.path){var u=t.image.width?t.image.width:20,p=t.image.height?t.image.height:20;h=this.annoCtx.addImage({x:s+t.image.offsetX-u/2,y:o+t.image.offsetY-p/2,width:u,height:p,path:t.image.path,appendTo:".apexcharts-point-annotations"})}t.mouseEnter&&h.node.addEventListener("mouseenter",t.mouseEnter.bind(this,t)),t.mouseLeave&&h.node.addEventListener("mouseleave",t.mouseLeave.bind(this,t)),t.click&&h.node.addEventListener("click",t.click.bind(this,t))}}}},{key:"drawPointAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-point-annotations"});return e.config.annotations.points.map((function(e,a){t.addPointAnnotation(e,i.node,a)})),i}}]),t}();var M={name:"en",options:{months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],toolbar:{exportToSVG:"Download SVG",exportToPNG:"Download PNG",exportToCSV:"Download CSV",menu:"Menu",selection:"Selection",selectionZoom:"Selection Zoom",zoomIn:"Zoom In",zoomOut:"Zoom Out",pan:"Panning",reset:"Reset Zoom"}}},I=function(){function t(){a(this,t),this.yAxis={show:!0,showAlways:!1,showForNullSeries:!0,seriesName:void 0,opposite:!1,reversed:!1,logarithmic:!1,logBase:10,tickAmount:void 0,stepSize:void 0,forceNiceScale:!1,max:void 0,min:void 0,floating:!1,decimalsInFloat:void 0,labels:{show:!0,minWidth:0,maxWidth:160,offsetX:0,offsetY:0,align:void 0,rotate:0,padding:20,style:{colors:[],fontSize:"11px",fontWeight:400,fontFamily:void 0,cssClass:""},formatter:void 0},axisBorder:{show:!1,color:"#e0e0e0",width:1,offsetX:0,offsetY:0},axisTicks:{show:!1,color:"#e0e0e0",width:6,offsetX:0,offsetY:0},title:{text:void 0,rotate:-90,offsetY:0,offsetX:0,style:{color:void 0,fontSize:"11px",fontWeight:900,fontFamily:void 0,cssClass:""}},tooltip:{enabled:!1,offsetX:0},crosshairs:{show:!0,position:"front",stroke:{color:"#b6b6b6",width:1,dashArray:0}}},this.pointAnnotation={id:void 0,x:0,y:null,yAxisIndex:0,seriesIndex:void 0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,marker:{size:4,fillColor:"#fff",strokeWidth:2,strokeColor:"#333",shape:"circle",offsetX:0,offsetY:0,radius:2,cssClass:""},label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"middle",offsetX:0,offsetY:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}},customSVG:{SVG:void 0,cssClass:void 0,offsetX:0,offsetY:0},image:{path:void 0,width:20,height:20,offsetX:0,offsetY:0}},this.yAxisAnnotation={id:void 0,y:0,y2:null,strokeDashArray:1,fillColor:"#c2c2c2",borderColor:"#c2c2c2",borderWidth:1,opacity:.3,offsetX:0,offsetY:0,width:"100%",yAxisIndex:0,label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"end",position:"right",offsetX:0,offsetY:-3,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}}},this.xAxisAnnotation={id:void 0,x:0,x2:null,strokeDashArray:1,fillColor:"#c2c2c2",borderColor:"#c2c2c2",borderWidth:1,opacity:.3,offsetX:0,offsetY:0,label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"middle",orientation:"vertical",position:"top",offsetX:0,offsetY:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}}},this.text={x:0,y:0,text:"",textAnchor:"start",foreColor:void 0,fontSize:"13px",fontFamily:void 0,fontWeight:400,appendTo:".apexcharts-annotations",backgroundColor:"transparent",borderColor:"#c2c2c2",borderRadius:0,borderWidth:0,paddingLeft:4,paddingRight:4,paddingTop:2,paddingBottom:2}}return r(t,[{key:"init",value:function(){return{annotations:{yaxis:[this.yAxisAnnotation],xaxis:[this.xAxisAnnotation],points:[this.pointAnnotation],texts:[],images:[],shapes:[]},chart:{animations:{enabled:!0,easing:"easeinout",speed:800,animateGradually:{delay:150,enabled:!0},dynamicAnimation:{enabled:!0,speed:350}},background:"transparent",locales:[M],defaultLocale:"en",dropShadow:{enabled:!1,enabledOnSeries:void 0,top:2,left:2,blur:4,color:"#000",opacity:.35},events:{animationEnd:void 0,beforeMount:void 0,mounted:void 0,updated:void 0,click:void 0,mouseMove:void 0,mouseLeave:void 0,xAxisLabelClick:void 0,legendClick:void 0,markerClick:void 0,selection:void 0,dataPointSelection:void 0,dataPointMouseEnter:void 0,dataPointMouseLeave:void 0,beforeZoom:void 0,beforeResetZoom:void 0,zoomed:void 0,scrolled:void 0,brushScrolled:void 0},foreColor:"#373d3f",fontFamily:"Helvetica, Arial, sans-serif",height:"auto",parentHeightOffset:15,redrawOnParentResize:!0,redrawOnWindowResize:!0,id:void 0,group:void 0,nonce:void 0,offsetX:0,offsetY:0,selection:{enabled:!1,type:"x",fill:{color:"#24292e",opacity:.1},stroke:{width:1,color:"#24292e",opacity:.4,dashArray:3},xaxis:{min:void 0,max:void 0},yaxis:{min:void 0,max:void 0}},sparkline:{enabled:!1},brush:{enabled:!1,autoScaleYaxis:!0,target:void 0,targets:void 0},stacked:!1,stackOnlyBar:!0,stackType:"normal",toolbar:{show:!0,offsetX:0,offsetY:0,tools:{download:!0,selection:!0,zoom:!0,zoomin:!0,zoomout:!0,pan:!0,reset:!0,customIcons:[]},export:{csv:{filename:void 0,columnDelimiter:",",headerCategory:"category",headerValue:"value",dateFormatter:function(t){return new Date(t).toDateString()}},png:{filename:void 0},svg:{filename:void 0}},autoSelected:"zoom"},type:"line",width:"100%",zoom:{enabled:!0,type:"x",autoScaleYaxis:!1,zoomedArea:{fill:{color:"#90CAF9",opacity:.4},stroke:{color:"#0D47A1",opacity:.4,width:1}}}},plotOptions:{line:{isSlopeChart:!1},area:{fillTo:"origin"},bar:{horizontal:!1,columnWidth:"70%",barHeight:"70%",distributed:!1,borderRadius:0,borderRadiusApplication:"around",borderRadiusWhenStacked:"last",rangeBarOverlap:!0,rangeBarGroupRows:!1,hideZeroBarsWhenGrouped:!1,isDumbbell:!1,dumbbellColors:void 0,isFunnel:!1,isFunnel3d:!0,colors:{ranges:[],backgroundBarColors:[],backgroundBarOpacity:1,backgroundBarRadius:0},dataLabels:{position:"top",maxItems:100,hideOverflowingLabels:!0,orientation:"horizontal",total:{enabled:!1,formatter:void 0,offsetX:0,offsetY:0,style:{color:"#373d3f",fontSize:"12px",fontFamily:void 0,fontWeight:600}}}},bubble:{zScaling:!0,minBubbleRadius:void 0,maxBubbleRadius:void 0},candlestick:{colors:{upward:"#00B746",downward:"#EF403C"},wick:{useFillColor:!0}},boxPlot:{colors:{upper:"#00E396",lower:"#008FFB"}},heatmap:{radius:2,enableShades:!0,shadeIntensity:.5,reverseNegativeShade:!1,distributed:!1,useFillColorAsStroke:!1,colorScale:{inverse:!1,ranges:[],min:void 0,max:void 0}},treemap:{enableShades:!0,shadeIntensity:.5,distributed:!1,reverseNegativeShade:!1,useFillColorAsStroke:!1,borderRadius:4,dataLabels:{format:"scale"},colorScale:{inverse:!1,ranges:[],min:void 0,max:void 0}},radialBar:{inverseOrder:!1,startAngle:0,endAngle:360,offsetX:0,offsetY:0,hollow:{margin:5,size:"50%",background:"transparent",image:void 0,imageWidth:150,imageHeight:150,imageOffsetX:0,imageOffsetY:0,imageClipped:!0,position:"front",dropShadow:{enabled:!1,top:0,left:0,blur:3,color:"#000",opacity:.5}},track:{show:!0,startAngle:void 0,endAngle:void 0,background:"#f2f2f2",strokeWidth:"97%",opacity:1,margin:5,dropShadow:{enabled:!1,top:0,left:0,blur:3,color:"#000",opacity:.5}},dataLabels:{show:!0,name:{show:!0,fontSize:"16px",fontFamily:void 0,fontWeight:600,color:void 0,offsetY:0,formatter:function(t){return t}},value:{show:!0,fontSize:"14px",fontFamily:void 0,fontWeight:400,color:void 0,offsetY:16,formatter:function(t){return t+"%"}},total:{show:!1,label:"Total",fontSize:"16px",fontWeight:600,fontFamily:void 0,color:void 0,formatter:function(t){return t.globals.seriesTotals.reduce((function(t,e){return t+e}),0)/t.globals.series.length+"%"}}},barLabels:{enabled:!1,margin:5,useSeriesColors:!0,fontFamily:void 0,fontWeight:600,fontSize:"16px",formatter:function(t){return t},onClick:void 0}},pie:{customScale:1,offsetX:0,offsetY:0,startAngle:0,endAngle:360,expandOnClick:!0,dataLabels:{offset:0,minAngleToShowLabel:10},donut:{size:"65%",background:"transparent",labels:{show:!1,name:{show:!0,fontSize:"16px",fontFamily:void 0,fontWeight:600,color:void 0,offsetY:-10,formatter:function(t){return t}},value:{show:!0,fontSize:"20px",fontFamily:void 0,fontWeight:400,color:void 0,offsetY:10,formatter:function(t){return t}},total:{show:!1,showAlways:!1,label:"Total",fontSize:"16px",fontWeight:400,fontFamily:void 0,color:void 0,formatter:function(t){return t.globals.seriesTotals.reduce((function(t,e){return t+e}),0)}}}}},polarArea:{rings:{strokeWidth:1,strokeColor:"#e8e8e8"},spokes:{strokeWidth:1,connectorColors:"#e8e8e8"}},radar:{size:void 0,offsetX:0,offsetY:0,polygons:{strokeWidth:1,strokeColors:"#e8e8e8",connectorColors:"#e8e8e8",fill:{colors:void 0}}}},colors:void 0,dataLabels:{enabled:!0,enabledOnSeries:void 0,formatter:function(t){return null!==t?t:""},textAnchor:"middle",distributed:!1,offsetX:0,offsetY:0,style:{fontSize:"12px",fontFamily:void 0,fontWeight:600,colors:void 0},background:{enabled:!0,foreColor:"#fff",borderRadius:2,padding:4,opacity:.9,borderWidth:1,borderColor:"#fff",dropShadow:{enabled:!1,top:1,left:1,blur:1,color:"#000",opacity:.45}},dropShadow:{enabled:!1,top:1,left:1,blur:1,color:"#000",opacity:.45}},fill:{type:"solid",colors:void 0,opacity:.85,gradient:{shade:"dark",type:"horizontal",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:1,stops:[0,50,100],colorStops:[]},image:{src:[],width:void 0,height:void 0},pattern:{style:"squares",width:6,height:6,strokeWidth:2}},forecastDataPoints:{count:0,fillOpacity:.5,strokeWidth:void 0,dashArray:4},grid:{show:!0,borderColor:"#e0e0e0",strokeDashArray:0,position:"back",xaxis:{lines:{show:!1}},yaxis:{lines:{show:!0}},row:{colors:void 0,opacity:.5},column:{colors:void 0,opacity:.5},padding:{top:0,right:10,bottom:0,left:12}},labels:[],legend:{show:!0,showForSingleSeries:!1,showForNullSeries:!0,showForZeroSeries:!0,floating:!1,position:"bottom",horizontalAlign:"center",inverseOrder:!1,fontSize:"12px",fontFamily:void 0,fontWeight:400,width:void 0,height:void 0,formatter:void 0,tooltipHoverFormatter:void 0,offsetX:-20,offsetY:4,customLegendItems:[],labels:{colors:void 0,useSeriesColors:!1},markers:{width:12,height:12,strokeWidth:0,fillColors:void 0,strokeColor:"#fff",radius:12,customHTML:void 0,offsetX:0,offsetY:0,onClick:void 0},itemMargin:{horizontal:5,vertical:2},onItemClick:{toggleDataSeries:!0},onItemHover:{highlightDataSeries:!0}},markers:{discrete:[],size:0,colors:void 0,strokeColors:"#fff",strokeWidth:2,strokeOpacity:.9,strokeDashArray:0,fillOpacity:1,shape:"circle",width:8,height:8,radius:2,offsetX:0,offsetY:0,onClick:void 0,onDblClick:void 0,showNullDataPoints:!0,hover:{size:void 0,sizeOffset:3}},noData:{text:void 0,align:"center",verticalAlign:"middle",offsetX:0,offsetY:0,style:{color:void 0,fontSize:"14px",fontFamily:void 0}},responsive:[],series:void 0,states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"lighten",value:.1}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"darken",value:.5}}},title:{text:void 0,align:"left",margin:5,offsetX:0,offsetY:0,floating:!1,style:{fontSize:"14px",fontWeight:900,fontFamily:void 0,color:void 0}},subtitle:{text:void 0,align:"left",margin:5,offsetX:0,offsetY:30,floating:!1,style:{fontSize:"12px",fontWeight:400,fontFamily:void 0,color:void 0}},stroke:{show:!0,curve:"smooth",lineCap:"butt",width:2,colors:void 0,dashArray:0,fill:{type:"solid",colors:void 0,opacity:.85,gradient:{shade:"dark",type:"horizontal",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:1,stops:[0,50,100],colorStops:[]}}},tooltip:{enabled:!0,enabledOnSeries:void 0,shared:!0,hideEmptySeries:!1,followCursor:!1,intersect:!1,inverseOrder:!1,custom:void 0,fillSeriesColor:!1,theme:"light",cssClass:"",style:{fontSize:"12px",fontFamily:void 0},onDatasetHover:{highlightDataSeries:!1},x:{show:!0,format:"dd MMM",formatter:void 0},y:{formatter:void 0,title:{formatter:function(t){return t?t+": ":""}}},z:{formatter:void 0,title:"Size: "},marker:{show:!0,fillColors:void 0},items:{display:"flex"},fixed:{enabled:!1,position:"topRight",offsetX:0,offsetY:0}},xaxis:{type:"category",categories:[],convertedCatToNumeric:!1,offsetX:0,offsetY:0,overwriteCategories:void 0,labels:{show:!0,rotate:-45,rotateAlways:!1,hideOverlappingLabels:!0,trim:!1,minHeight:void 0,maxHeight:120,showDuplicates:!0,style:{colors:[],fontSize:"12px",fontWeight:400,fontFamily:void 0,cssClass:""},offsetX:0,offsetY:0,format:void 0,formatter:void 0,datetimeUTC:!0,datetimeFormatter:{year:"yyyy",month:"MMM 'yy",day:"dd MMM",hour:"HH:mm",minute:"HH:mm:ss",second:"HH:mm:ss"}},group:{groups:[],style:{colors:[],fontSize:"12px",fontWeight:400,fontFamily:void 0,cssClass:""}},axisBorder:{show:!0,color:"#e0e0e0",width:"100%",height:1,offsetX:0,offsetY:0},axisTicks:{show:!0,color:"#e0e0e0",height:6,offsetX:0,offsetY:0},stepSize:void 0,tickAmount:void 0,tickPlacement:"on",min:void 0,max:void 0,range:void 0,floating:!1,decimalsInFloat:void 0,position:"bottom",title:{text:void 0,offsetX:0,offsetY:0,style:{color:void 0,fontSize:"12px",fontWeight:900,fontFamily:void 0,cssClass:""}},crosshairs:{show:!0,width:1,position:"back",opacity:.9,stroke:{color:"#b6b6b6",width:1,dashArray:3},fill:{type:"solid",color:"#B1B9C4",gradient:{colorFrom:"#D8E3F0",colorTo:"#BED1E6",stops:[0,100],opacityFrom:.4,opacityTo:.5}},dropShadow:{enabled:!1,left:0,top:0,blur:1,opacity:.4}},tooltip:{enabled:!0,offsetY:0,formatter:void 0,style:{fontSize:"12px",fontFamily:void 0}}},yaxis:this.yAxis,theme:{mode:"light",palette:"palette1",monochrome:{enabled:!1,color:"#008FFB",shadeTo:"light",shadeIntensity:.65}}}}}]),t}(),T=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.graphics=new m(this.ctx),this.w.globals.isBarHorizontal&&(this.invertAxis=!0),this.helpers=new w(this),this.xAxisAnnotations=new k(this),this.yAxisAnnotations=new L(this),this.pointsAnnotations=new P(this),this.w.globals.isBarHorizontal&&this.w.config.yaxis[0].reversed&&(this.inversedReversedAxis=!0),this.xDivision=this.w.globals.gridWidth/this.w.globals.dataPoints}return r(t,[{key:"drawAxesAnnotations",value:function(){var t=this.w;if(t.globals.axisCharts){for(var e=this.yAxisAnnotations.drawYAxisAnnotations(),i=this.xAxisAnnotations.drawXAxisAnnotations(),a=this.pointsAnnotations.drawPointAnnotations(),s=t.config.chart.animations.enabled,r=[e,i,a],o=[i.node,e.node,a.node],n=0;n<3;n++)t.globals.dom.elGraphical.add(r[n]),!s||t.globals.resized||t.globals.dataChanged||"scatter"!==t.config.chart.type&&"bubble"!==t.config.chart.type&&t.globals.dataPoints>1&&o[n].classList.add("apexcharts-element-hidden"),t.globals.delayedElements.push({el:o[n],index:0});this.helpers.annotationsBackground()}}},{key:"drawImageAnnos",value:function(){var t=this;this.w.config.annotations.images.map((function(e,i){t.addImage(e,i)}))}},{key:"drawTextAnnos",value:function(){var t=this;this.w.config.annotations.texts.map((function(e,i){t.addText(e,i)}))}},{key:"addXaxisAnnotation",value:function(t,e,i){this.xAxisAnnotations.addXaxisAnnotation(t,e,i)}},{key:"addYaxisAnnotation",value:function(t,e,i){this.yAxisAnnotations.addYaxisAnnotation(t,e,i)}},{key:"addPointAnnotation",value:function(t,e,i){this.pointsAnnotations.addPointAnnotation(t,e,i)}},{key:"addText",value:function(t,e){var i=t.x,a=t.y,s=t.text,r=t.textAnchor,o=t.foreColor,n=t.fontSize,l=t.fontFamily,h=t.fontWeight,c=t.cssClass,d=t.backgroundColor,g=t.borderWidth,u=t.strokeDashArray,p=t.borderRadius,f=t.borderColor,x=t.appendTo,b=void 0===x?".apexcharts-svg":x,v=t.paddingLeft,m=void 0===v?4:v,y=t.paddingRight,w=void 0===y?4:y,k=t.paddingBottom,A=void 0===k?2:k,S=t.paddingTop,C=void 0===S?2:S,L=this.w,P=this.graphics.drawText({x:i,y:a,text:s,textAnchor:r||"start",fontSize:n||"12px",fontWeight:h||"regular",fontFamily:l||L.config.chart.fontFamily,foreColor:o||L.config.chart.foreColor,cssClass:c}),M=L.globals.dom.baseEl.querySelector(b);M&&M.appendChild(P.node);var I=P.bbox();if(s){var T=this.graphics.drawRect(I.x-m,I.y-C,I.width+m+w,I.height+A+C,p,d||"transparent",1,g,f,u);M.insertBefore(T.node,P.node)}}},{key:"addImage",value:function(t,e){var i=this.w,a=t.path,s=t.x,r=void 0===s?0:s,o=t.y,n=void 0===o?0:o,l=t.width,h=void 0===l?20:l,c=t.height,d=void 0===c?20:c,g=t.appendTo,u=void 0===g?".apexcharts-svg":g,p=i.globals.dom.Paper.image(a);p.size(h,d).move(r,n);var f=i.globals.dom.baseEl.querySelector(u);return f&&f.appendChild(p.node),p}},{key:"addXaxisAnnotationExternal",value:function(t,e,i){return this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"xaxis",contextMethod:i.addXaxisAnnotation}),i}},{key:"addYaxisAnnotationExternal",value:function(t,e,i){return this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"yaxis",contextMethod:i.addYaxisAnnotation}),i}},{key:"addPointAnnotationExternal",value:function(t,e,i){return void 0===this.invertAxis&&(this.invertAxis=i.w.globals.isBarHorizontal),this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"point",contextMethod:i.addPointAnnotation}),i}},{key:"addAnnotationExternal",value:function(t){var e=t.params,i=t.pushToMemory,a=t.context,s=t.type,r=t.contextMethod,o=a,n=o.w,l=n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations")),h=l.childNodes.length+1,c=new I,d=Object.assign({},"xaxis"===s?c.xAxisAnnotation:"yaxis"===s?c.yAxisAnnotation:c.pointAnnotation),g=x.extend(d,e);switch(s){case"xaxis":this.addXaxisAnnotation(g,l,h);break;case"yaxis":this.addYaxisAnnotation(g,l,h);break;case"point":this.addPointAnnotation(g,l,h)}var u=n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations .apexcharts-").concat(s,"-annotation-label[rel='").concat(h,"']")),p=this.helpers.addBackgroundToAnno(u,g);return p&&l.insertBefore(p.node,u),i&&n.globals.memory.methodsToExec.push({context:o,id:g.id?g.id:x.randomId(),method:r,label:"addAnnotation",params:e}),a}},{key:"clearAnnotations",value:function(t){var e=t.w,i=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");e.globals.memory.methodsToExec.map((function(t,i){"addText"!==t.label&&"addAnnotation"!==t.label||e.globals.memory.methodsToExec.splice(i,1)})),i=x.listToArray(i),Array.prototype.forEach.call(i,(function(t){for(;t.firstChild;)t.removeChild(t.firstChild)}))}},{key:"removeAnnotation",value:function(t,e){var i=t.w,a=i.globals.dom.baseEl.querySelectorAll(".".concat(e));a&&(i.globals.memory.methodsToExec.map((function(t,a){t.id===e&&i.globals.memory.methodsToExec.splice(a,1)})),Array.prototype.forEach.call(a,(function(t){t.parentElement.removeChild(t)})))}}]),t}(),z=function(t){var e,i=t.isTimeline,a=t.ctx,s=t.seriesIndex,r=t.dataPointIndex,o=t.y1,n=t.y2,l=t.w,h=l.globals.seriesRangeStart[s][r],c=l.globals.seriesRangeEnd[s][r],d=l.globals.labels[r],g=l.config.series[s].name?l.config.series[s].name:"",u=l.globals.ttKeyFormatter,p=l.config.tooltip.y.title.formatter,f={w:l,seriesIndex:s,dataPointIndex:r,start:h,end:c};("function"==typeof p&&(g=p(g,f)),null!==(e=l.config.series[s].data[r])&&void 0!==e&&e.x&&(d=l.config.series[s].data[r].x),i)||"datetime"===l.config.xaxis.type&&(d=new S(a).xLabelFormat(l.globals.ttKeyFormatter,d,d,{i:void 0,dateFormatter:new A(a).formatDate,w:l}));"function"==typeof u&&(d=u(d,f)),Number.isFinite(o)&&Number.isFinite(n)&&(h=o,c=n);var x="",b="",v=l.globals.colors[s];if(void 0===l.config.tooltip.x.formatter)if("datetime"===l.config.xaxis.type){var m=new A(a);x=m.formatDate(m.getDate(h),l.config.tooltip.x.format),b=m.formatDate(m.getDate(c),l.config.tooltip.x.format)}else x=h,b=c;else x=l.config.tooltip.x.formatter(h),b=l.config.tooltip.x.formatter(c);return{start:h,end:c,startVal:x,endVal:b,ylabel:d,color:v,seriesName:g}},X=function(t){var e=t.color,i=t.seriesName,a=t.ylabel,s=t.start,r=t.end,o=t.seriesIndex,n=t.dataPointIndex,l=t.ctx.tooltip.tooltipLabels.getFormatters(o);s=l.yLbFormatter(s),r=l.yLbFormatter(r);var h=l.yLbFormatter(t.w.globals.series[o][n]),c='<span class="value start-value">\n  '.concat(s,'\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r,"\n  </span>");return'<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: '+e+'">'+(i||"")+'</span></div><div> <span class="category">'+a+": </span> "+(t.w.globals.comboCharts?"rangeArea"===t.w.config.series[o].type||"rangeBar"===t.w.config.series[o].type?c:"<span>".concat(h,"</span>"):c)+" </div></div>"},E=function(){function t(e){a(this,t),this.opts=e}return r(t,[{key:"hideYAxis",value:function(){this.opts.yaxis[0].show=!1,this.opts.yaxis[0].title.text="",this.opts.yaxis[0].axisBorder.show=!1,this.opts.yaxis[0].axisTicks.show=!1,this.opts.yaxis[0].floating=!0}},{key:"line",value:function(){return{chart:{animations:{easing:"swing"}},dataLabels:{enabled:!1},stroke:{width:5,curve:"straight"},markers:{size:0,hover:{sizeOffset:6}},xaxis:{crosshairs:{width:1}}}}},{key:"sparkline",value:function(t){this.hideYAxis();return x.extend(t,{grid:{show:!1,padding:{left:0,right:0,top:0,bottom:0}},legend:{show:!1},xaxis:{labels:{show:!1},tooltip:{enabled:!1},axisBorder:{show:!1},axisTicks:{show:!1}},chart:{toolbar:{show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!1}})}},{key:"slope",value:function(){return this.hideYAxis(),{chart:{toolbar:{show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!0,formatter:function(t,e){var i=e.w.config.series[e.seriesIndex].name;return null!==t?i+": "+t:""},background:{enabled:!1},offsetX:-5},grid:{xaxis:{lines:{show:!0}},yaxis:{lines:{show:!1}}},xaxis:{position:"top",labels:{style:{fontSize:14,fontWeight:900}},tooltip:{enabled:!1},crosshairs:{show:!1}},markers:{size:8,hover:{sizeOffset:1}},legend:{show:!1},tooltip:{shared:!1,intersect:!0,followCursor:!0},stroke:{width:5,curve:"straight"}}}},{key:"bar",value:function(){return{chart:{stacked:!1,animations:{easing:"swing"}},plotOptions:{bar:{dataLabels:{position:"center"}}},dataLabels:{style:{colors:["#fff"]},background:{enabled:!1}},stroke:{width:0,lineCap:"round"},fill:{opacity:.85},legend:{markers:{shape:"square",radius:2,size:8}},tooltip:{shared:!1,intersect:!0},xaxis:{tooltip:{enabled:!1},tickPlacement:"between",crosshairs:{width:"barWidth",position:"back",fill:{type:"gradient"},dropShadow:{enabled:!1},stroke:{width:0}}}}}},{key:"funnel",value:function(){return this.hideYAxis(),e(e({},this.bar()),{},{chart:{animations:{easing:"linear",speed:800,animateGradually:{enabled:!1}}},plotOptions:{bar:{horizontal:!0,borderRadiusApplication:"around",borderRadius:0,dataLabels:{position:"center"}}},grid:{show:!1,padding:{left:0,right:0}},xaxis:{labels:{show:!1},tooltip:{enabled:!1},axisBorder:{show:!1},axisTicks:{show:!1}}})}},{key:"candlestick",value:function(){var t=this;return{stroke:{width:1,colors:["#333"]},fill:{opacity:1},dataLabels:{enabled:!1},tooltip:{shared:!0,custom:function(e){var i=e.seriesIndex,a=e.dataPointIndex,s=e.w;return t._getBoxTooltip(s,i,a,["Open","High","","Low","Close"],"candlestick")}},states:{active:{filter:{type:"none"}}},xaxis:{crosshairs:{width:1}}}}},{key:"boxPlot",value:function(){var t=this;return{chart:{animations:{dynamicAnimation:{enabled:!1}}},stroke:{width:1,colors:["#24292e"]},dataLabels:{enabled:!1},tooltip:{shared:!0,custom:function(e){var i=e.seriesIndex,a=e.dataPointIndex,s=e.w;return t._getBoxTooltip(s,i,a,["Minimum","Q1","Median","Q3","Maximum"],"boxPlot")}},markers:{size:5,strokeWidth:1,strokeColors:"#111"},xaxis:{crosshairs:{width:1}}}}},{key:"rangeBar",value:function(){return{chart:{animations:{animateGradually:!1}},stroke:{width:0,lineCap:"square"},plotOptions:{bar:{borderRadius:0,dataLabels:{position:"center"}}},dataLabels:{enabled:!1,formatter:function(t,e){e.ctx;var i=e.seriesIndex,a=e.dataPointIndex,s=e.w,r=function(){var t=s.globals.seriesRangeStart[i][a];return s.globals.seriesRangeEnd[i][a]-t};return s.globals.comboCharts?"rangeBar"===s.config.series[i].type||"rangeArea"===s.config.series[i].type?r():t:r()},background:{enabled:!1},style:{colors:["#fff"]}},markers:{size:10},tooltip:{shared:!1,followCursor:!0,custom:function(t){return t.w.config.plotOptions&&t.w.config.plotOptions.bar&&t.w.config.plotOptions.bar.horizontal?function(t){var i=z(e(e({},t),{},{isTimeline:!0})),a=i.color,s=i.seriesName,r=i.ylabel,o=i.startVal,n=i.endVal;return X(e(e({},t),{},{color:a,seriesName:s,ylabel:r,start:o,end:n}))}(t):function(t){var i=z(t),a=i.color,s=i.seriesName,r=i.ylabel,o=i.start,n=i.end;return X(e(e({},t),{},{color:a,seriesName:s,ylabel:r,start:o,end:n}))}(t)}},xaxis:{tickPlacement:"between",tooltip:{enabled:!1},crosshairs:{stroke:{width:0}}}}}},{key:"dumbbell",value:function(t){var e,i;return null!==(e=t.plotOptions.bar)&&void 0!==e&&e.barHeight||(t.plotOptions.bar.barHeight=2),null!==(i=t.plotOptions.bar)&&void 0!==i&&i.columnWidth||(t.plotOptions.bar.columnWidth=2),t}},{key:"area",value:function(){return{stroke:{width:4,fill:{type:"solid",gradient:{inverseColors:!1,shade:"light",type:"vertical",opacityFrom:.65,opacityTo:.5,stops:[0,100,100]}}},fill:{type:"gradient",gradient:{inverseColors:!1,shade:"light",type:"vertical",opacityFrom:.65,opacityTo:.5,stops:[0,100,100]}},markers:{size:0,hover:{sizeOffset:6}},tooltip:{followCursor:!1}}}},{key:"rangeArea",value:function(){return{stroke:{curve:"straight",width:0},fill:{type:"solid",opacity:.6},markers:{size:0},states:{hover:{filter:{type:"none"}},active:{filter:{type:"none"}}},tooltip:{intersect:!1,shared:!0,followCursor:!0,custom:function(t){return function(t){var i=z(t),a=i.color,s=i.seriesName,r=i.ylabel,o=i.start,n=i.end;return X(e(e({},t),{},{color:a,seriesName:s,ylabel:r,start:o,end:n}))}(t)}}}}},{key:"brush",value:function(t){return x.extend(t,{chart:{toolbar:{autoSelected:"selection",show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!1},stroke:{width:1},tooltip:{enabled:!1},xaxis:{tooltip:{enabled:!1}}})}},{key:"stacked100",value:function(t){t.dataLabels=t.dataLabels||{},t.dataLabels.formatter=t.dataLabels.formatter||void 0;var e=t.dataLabels.formatter;return t.yaxis.forEach((function(e,i){t.yaxis[i].min=0,t.yaxis[i].max=100})),"bar"===t.chart.type&&(t.dataLabels.formatter=e||function(t){return"number"==typeof t&&t?t.toFixed(0)+"%":t}),t}},{key:"stackedBars",value:function(){var t=this.bar();return e(e({},t),{},{plotOptions:e(e({},t.plotOptions),{},{bar:e(e({},t.plotOptions.bar),{},{borderRadiusApplication:"end",borderRadiusWhenStacked:"last"})})})}},{key:"convertCatToNumeric",value:function(t){return t.xaxis.convertedCatToNumeric=!0,t}},{key:"convertCatToNumericXaxis",value:function(t,e,i){t.xaxis.type="numeric",t.xaxis.labels=t.xaxis.labels||{},t.xaxis.labels.formatter=t.xaxis.labels.formatter||function(t){return x.isNumber(t)?Math.floor(t):t};var a=t.xaxis.labels.formatter,s=t.xaxis.categories&&t.xaxis.categories.length?t.xaxis.categories:t.labels;return i&&i.length&&(s=i.map((function(t){return Array.isArray(t)?t:String(t)}))),s&&s.length&&(t.xaxis.labels.formatter=function(t){return x.isNumber(t)?a(s[Math.floor(t)-1]):a(t)}),t.xaxis.categories=[],t.labels=[],t.xaxis.tickAmount=t.xaxis.tickAmount||"dataPoints",t}},{key:"bubble",value:function(){return{dataLabels:{style:{colors:["#fff"]}},tooltip:{shared:!1,intersect:!0},xaxis:{crosshairs:{width:0}},fill:{type:"solid",gradient:{shade:"light",inverse:!0,shadeIntensity:.55,opacityFrom:.4,opacityTo:.8}}}}},{key:"scatter",value:function(){return{dataLabels:{enabled:!1},tooltip:{shared:!1,intersect:!0},markers:{size:6,strokeWidth:1,hover:{sizeOffset:2}}}}},{key:"heatmap",value:function(){return{chart:{stacked:!1},fill:{opacity:1},dataLabels:{style:{colors:["#fff"]}},stroke:{colors:["#fff"]},tooltip:{followCursor:!0,marker:{show:!1},x:{show:!1}},legend:{position:"top",markers:{shape:"square",size:10,offsetY:2}},grid:{padding:{right:20}}}}},{key:"treemap",value:function(){return{chart:{zoom:{enabled:!1}},dataLabels:{style:{fontSize:14,fontWeight:600,colors:["#fff"]}},stroke:{show:!0,width:2,colors:["#fff"]},legend:{show:!1},fill:{gradient:{stops:[0,100]}},tooltip:{followCursor:!0,x:{show:!1}},grid:{padding:{left:0,right:0}},xaxis:{crosshairs:{show:!1},tooltip:{enabled:!1}}}}},{key:"pie",value:function(){return{chart:{toolbar:{show:!1}},plotOptions:{pie:{donut:{labels:{show:!1}}}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},style:{colors:["#fff"]},background:{enabled:!1},dropShadow:{enabled:!0}},stroke:{colors:["#fff"]},fill:{opacity:1,gradient:{shade:"light",stops:[0,100]}},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"}}}},{key:"donut",value:function(){return{chart:{toolbar:{show:!1}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},style:{colors:["#fff"]},background:{enabled:!1},dropShadow:{enabled:!0}},stroke:{colors:["#fff"]},fill:{opacity:1,gradient:{shade:"light",shadeIntensity:.35,stops:[80,100],opacityFrom:1,opacityTo:1}},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"}}}},{key:"polarArea",value:function(){return{chart:{toolbar:{show:!1}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},enabled:!1},stroke:{show:!0,width:2},fill:{opacity:.7},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"}}}},{key:"radar",value:function(){return this.opts.yaxis[0].labels.offsetY=this.opts.yaxis[0].labels.offsetY?this.opts.yaxis[0].labels.offsetY:6,{dataLabels:{enabled:!1,style:{fontSize:"11px"}},stroke:{width:2},markers:{size:3,strokeWidth:1,strokeOpacity:1},fill:{opacity:.2},tooltip:{shared:!1,intersect:!0,followCursor:!0},grid:{show:!1},xaxis:{labels:{formatter:function(t){return t},style:{colors:["#a8a8a8"],fontSize:"11px"}},tooltip:{enabled:!1},crosshairs:{show:!1}}}}},{key:"radialBar",value:function(){return{chart:{animations:{dynamicAnimation:{enabled:!0,speed:800}},toolbar:{show:!1}},fill:{gradient:{shade:"dark",shadeIntensity:.4,inverseColors:!1,type:"diagonal2",opacityFrom:1,opacityTo:1,stops:[70,98,100]}},legend:{show:!1,position:"right"},tooltip:{enabled:!1,fillSeriesColor:!0}}}},{key:"_getBoxTooltip",value:function(t,e,i,a,s){var r=t.globals.seriesCandleO[e][i],o=t.globals.seriesCandleH[e][i],n=t.globals.seriesCandleM[e][i],l=t.globals.seriesCandleL[e][i],h=t.globals.seriesCandleC[e][i];return t.config.series[e].type&&t.config.series[e].type!==s?'<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name?t.config.series[e].name:"series-"+(e+1),": <strong>").concat(t.globals.series[e][i],"</strong>\n        </div>"):'<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type,'">')+"<div>".concat(a[0],': <span class="value">')+r+"</span></div>"+"<div>".concat(a[1],': <span class="value">')+o+"</span></div>"+(n?"<div>".concat(a[2],': <span class="value">')+n+"</span></div>":"")+"<div>".concat(a[3],': <span class="value">')+l+"</span></div>"+"<div>".concat(a[4],': <span class="value">')+h+"</span></div></div>"}}]),t}(),Y=function(){function t(e){a(this,t),this.opts=e}return r(t,[{key:"init",value:function(t){var e=t.responsiveOverride,a=this.opts,s=new I,r=new E(a);this.chartType=a.chart.type,a=this.extendYAxis(a),a=this.extendAnnotations(a);var o=s.init(),n={};if(a&&"object"===i(a)){var l,h,c,d,g,u,p,f,b,v,m={};m=-1!==["line","area","bar","candlestick","boxPlot","rangeBar","rangeArea","bubble","scatter","heatmap","treemap","pie","polarArea","donut","radar","radialBar"].indexOf(a.chart.type)?r[a.chart.type]():r.line(),null!==(l=a.plotOptions)&&void 0!==l&&null!==(h=l.bar)&&void 0!==h&&h.isFunnel&&(m=r.funnel()),a.chart.stacked&&"bar"===a.chart.type&&(m=r.stackedBars()),null!==(c=a.chart.brush)&&void 0!==c&&c.enabled&&(m=r.brush(m)),null!==(d=a.plotOptions)&&void 0!==d&&null!==(g=d.line)&&void 0!==g&&g.isSlopeChart&&(m=r.slope()),a.chart.stacked&&"100%"===a.chart.stackType&&(a=r.stacked100(a)),null!==(u=a.plotOptions)&&void 0!==u&&null!==(p=u.bar)&&void 0!==p&&p.isDumbbell&&(a=r.dumbbell(a)),this.checkForDarkTheme(window.Apex),this.checkForDarkTheme(a),a.xaxis=a.xaxis||window.Apex.xaxis||{},e||(a.xaxis.convertedCatToNumeric=!1),(null!==(f=(a=this.checkForCatToNumericXAxis(this.chartType,m,a)).chart.sparkline)&&void 0!==f&&f.enabled||null!==(b=window.Apex.chart)&&void 0!==b&&null!==(v=b.sparkline)&&void 0!==v&&v.enabled)&&(m=r.sparkline(m)),n=x.extend(o,m)}var y=x.extend(n,window.Apex);return o=x.extend(y,a),o=this.handleUserInputErrors(o)}},{key:"checkForCatToNumericXAxis",value:function(t,e,i){var a,s,r=new E(i),o=("bar"===t||"boxPlot"===t)&&(null===(a=i.plotOptions)||void 0===a||null===(s=a.bar)||void 0===s?void 0:s.horizontal),n="pie"===t||"polarArea"===t||"donut"===t||"radar"===t||"radialBar"===t||"heatmap"===t,l="datetime"!==i.xaxis.type&&"numeric"!==i.xaxis.type,h=i.xaxis.tickPlacement?i.xaxis.tickPlacement:e.xaxis&&e.xaxis.tickPlacement;return o||n||!l||"between"===h||(i=r.convertCatToNumeric(i)),i}},{key:"extendYAxis",value:function(t,e){var i=new I;(void 0===t.yaxis||!t.yaxis||Array.isArray(t.yaxis)&&0===t.yaxis.length)&&(t.yaxis={}),t.yaxis.constructor!==Array&&window.Apex.yaxis&&window.Apex.yaxis.constructor!==Array&&(t.yaxis=x.extend(t.yaxis,window.Apex.yaxis)),t.yaxis.constructor!==Array?t.yaxis=[x.extend(i.yAxis,t.yaxis)]:t.yaxis=x.extendArray(t.yaxis,i.yAxis);var a=!1;t.yaxis.forEach((function(t){t.logarithmic&&(a=!0)}));var s=t.series;return e&&!s&&(s=e.config.series),a&&s.length!==t.yaxis.length&&s.length&&(t.yaxis=s.map((function(e,a){if(e.name||(s[a].name="series-".concat(a+1)),t.yaxis[a])return t.yaxis[a].seriesName=s[a].name,t.yaxis[a];var r=x.extend(i.yAxis,t.yaxis[0]);return r.show=!1,r}))),a&&s.length>1&&s.length!==t.yaxis.length&&console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"),t}},{key:"extendAnnotations",value:function(t){return void 0===t.annotations&&(t.annotations={},t.annotations.yaxis=[],t.annotations.xaxis=[],t.annotations.points=[]),t=this.extendYAxisAnnotations(t),t=this.extendXAxisAnnotations(t),t=this.extendPointAnnotations(t)}},{key:"extendYAxisAnnotations",value:function(t){var e=new I;return t.annotations.yaxis=x.extendArray(void 0!==t.annotations.yaxis?t.annotations.yaxis:[],e.yAxisAnnotation),t}},{key:"extendXAxisAnnotations",value:function(t){var e=new I;return t.annotations.xaxis=x.extendArray(void 0!==t.annotations.xaxis?t.annotations.xaxis:[],e.xAxisAnnotation),t}},{key:"extendPointAnnotations",value:function(t){var e=new I;return t.annotations.points=x.extendArray(void 0!==t.annotations.points?t.annotations.points:[],e.pointAnnotation),t}},{key:"checkForDarkTheme",value:function(t){t.theme&&"dark"===t.theme.mode&&(t.tooltip||(t.tooltip={}),"light"!==t.tooltip.theme&&(t.tooltip.theme="dark"),t.chart.foreColor||(t.chart.foreColor="#f6f7f8"),t.chart.background||(t.chart.background="#424242"),t.theme.palette||(t.theme.palette="palette4"))}},{key:"handleUserInputErrors",value:function(t){var e=t;if(e.tooltip.shared&&e.tooltip.intersect)throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");if("bar"===e.chart.type&&e.plotOptions.bar.horizontal){if(e.yaxis.length>1)throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");e.yaxis[0].reversed&&(e.yaxis[0].opposite=!0),e.xaxis.tooltip.enabled=!1,e.yaxis[0].tooltip.enabled=!1,e.chart.zoom.enabled=!1}return"bar"!==e.chart.type&&"rangeBar"!==e.chart.type||e.tooltip.shared&&"barWidth"===e.xaxis.crosshairs.width&&e.series.length>1&&(e.xaxis.crosshairs.width="tickWidth"),"candlestick"!==e.chart.type&&"boxPlot"!==e.chart.type||e.yaxis[0].reversed&&(console.warn("Reversed y-axis in ".concat(e.chart.type," chart is not supported.")),e.yaxis[0].reversed=!1),e}}]),t}(),F=function(){function t(){a(this,t)}return r(t,[{key:"initGlobalVars",value:function(t){t.series=[],t.seriesCandleO=[],t.seriesCandleH=[],t.seriesCandleM=[],t.seriesCandleL=[],t.seriesCandleC=[],t.seriesRangeStart=[],t.seriesRangeEnd=[],t.seriesRange=[],t.seriesPercent=[],t.seriesGoals=[],t.seriesX=[],t.seriesZ=[],t.seriesNames=[],t.seriesTotals=[],t.seriesLog=[],t.seriesColors=[],t.stackedSeriesTotals=[],t.seriesXvalues=[],t.seriesYvalues=[],t.labels=[],t.hasXaxisGroups=!1,t.groups=[],t.barGroups=[],t.lineGroups=[],t.areaGroups=[],t.hasSeriesGroups=!1,t.seriesGroups=[],t.categoryLabels=[],t.timescaleLabels=[],t.noLabelsProvided=!1,t.resizeTimer=null,t.selectionResizeTimer=null,t.delayedElements=[],t.pointsArray=[],t.dataLabelsRects=[],t.isXNumeric=!1,t.skipLastTimelinelabel=!1,t.skipFirstTimelinelabel=!1,t.isDataXYZ=!1,t.isMultiLineX=!1,t.isMultipleYAxis=!1,t.maxY=-Number.MAX_VALUE,t.minY=Number.MIN_VALUE,t.minYArr=[],t.maxYArr=[],t.maxX=-Number.MAX_VALUE,t.minX=Number.MAX_VALUE,t.initialMaxX=-Number.MAX_VALUE,t.initialMinX=Number.MAX_VALUE,t.maxDate=0,t.minDate=Number.MAX_VALUE,t.minZ=Number.MAX_VALUE,t.maxZ=-Number.MAX_VALUE,t.minXDiff=Number.MAX_VALUE,t.yAxisScale=[],t.xAxisScale=null,t.xAxisTicksPositions=[],t.yLabelsCoords=[],t.yTitleCoords=[],t.barPadForNumericAxis=0,t.padHorizontal=0,t.xRange=0,t.yRange=[],t.zRange=0,t.dataPoints=0,t.xTickAmount=0,t.multiAxisTickAmount=0}},{key:"globalVars",value:function(t){return{chartID:null,cuid:null,events:{beforeMount:[],mounted:[],updated:[],clicked:[],selection:[],dataPointSelection:[],zoomed:[],scrolled:[]},colors:[],clientX:null,clientY:null,fill:{colors:[]},stroke:{colors:[]},dataLabels:{style:{colors:[]}},radarPolygons:{fill:{colors:[]}},markers:{colors:[],size:t.markers.size,largestSize:0},animationEnded:!1,isTouchDevice:"ontouchstart"in window||navigator.msMaxTouchPoints,isDirty:!1,isExecCalled:!1,initialConfig:null,initialSeries:[],lastXAxis:[],lastYAxis:[],columnSeries:null,labels:[],timescaleLabels:[],noLabelsProvided:!1,allSeriesCollapsed:!1,collapsedSeries:[],collapsedSeriesIndices:[],ancillaryCollapsedSeries:[],ancillaryCollapsedSeriesIndices:[],risingSeries:[],dataFormatXNumeric:!1,capturedSeriesIndex:-1,capturedDataPointIndex:-1,selectedDataPoints:[],goldenPadding:35,invalidLogScale:!1,ignoreYAxisIndexes:[],maxValsInArrayIndex:0,radialSize:0,selection:void 0,zoomEnabled:"zoom"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.zoom&&t.chart.zoom.enabled,panEnabled:"pan"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.pan,selectionEnabled:"selection"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.selection,yaxis:null,mousedown:!1,lastClientPosition:{},visibleXRange:void 0,yValueDecimal:0,total:0,SVGNS:"http://www.w3.org/2000/svg",svgWidth:0,svgHeight:0,noData:!1,locale:{},dom:{},memory:{methodsToExec:[]},shouldAnimate:!0,skipLastTimelinelabel:!1,skipFirstTimelinelabel:!1,delayedElements:[],axisCharts:!0,isDataXYZ:!1,isSlopeChart:t.plotOptions.line.isSlopeChart,resized:!1,resizeTimer:null,comboCharts:!1,dataChanged:!1,previousPaths:[],allSeriesHasEqualX:!0,pointsArray:[],dataLabelsRects:[],lastDrawnDataLabelsIndexes:[],hasNullValues:!1,easing:null,zoomed:!1,gridWidth:0,gridHeight:0,rotateXLabels:!1,defaultLabels:!1,xLabelFormatter:void 0,yLabelFormatters:[],xaxisTooltipFormatter:void 0,ttKeyFormatter:void 0,ttVal:void 0,ttZFormatter:void 0,LINE_HEIGHT_RATIO:1.618,xAxisLabelsHeight:0,xAxisGroupLabelsHeight:0,xAxisLabelsWidth:0,yAxisLabelsWidth:0,scaleX:1,scaleY:1,translateX:0,translateY:0,translateYAxisX:[],yAxisWidths:[],translateXAxisY:0,translateXAxisX:0,tooltip:null,niceScaleAllowedMagMsd:[[1,1,2,5,5,5,10,10,10,10,10],[1,1,2,5,5,5,10,10,10,10,10]],niceScaleDefaultTicks:[1,2,4,4,6,6,6,6,6,6,6,6,6,6,6,6,6,6,12,12,12,12,12,12,12,12,12,24],seriesYAxisMap:[],seriesYAxisReverseMap:[]}}},{key:"init",value:function(t){var e=this.globalVars(t);return this.initGlobalVars(e),e.initialConfig=x.extend({},t),e.initialSeries=x.clone(t.series),e.lastXAxis=x.clone(e.initialConfig.xaxis),e.lastYAxis=x.clone(e.initialConfig.yaxis),e}}]),t}(),R=function(){function t(e){a(this,t),this.opts=e}return r(t,[{key:"init",value:function(){var t=new Y(this.opts).init({responsiveOverride:!1});return{config:t,globals:(new F).init(t)}}}]),t}(),H=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.opts=null,this.seriesIndex=0}return r(t,[{key:"clippedImgArea",value:function(t){var e=this.w,i=e.config,a=parseInt(e.globals.gridWidth,10),s=parseInt(e.globals.gridHeight,10),r=a>s?a:s,o=t.image,n=0,l=0;void 0===t.width&&void 0===t.height?void 0!==i.fill.image.width&&void 0!==i.fill.image.height?(n=i.fill.image.width+1,l=i.fill.image.height):(n=r+1,l=r):(n=t.width,l=t.height);var h=document.createElementNS(e.globals.SVGNS,"pattern");m.setAttrs(h,{id:t.patternID,patternUnits:t.patternUnits?t.patternUnits:"userSpaceOnUse",width:n+"px",height:l+"px"});var c=document.createElementNS(e.globals.SVGNS,"image");h.appendChild(c),c.setAttributeNS(window.SVG.xlink,"href",o),m.setAttrs(c,{x:0,y:0,preserveAspectRatio:"none",width:n+"px",height:l+"px"}),c.style.opacity=t.opacity,e.globals.dom.elDefs.node.appendChild(h)}},{key:"getSeriesIndex",value:function(t){var e=this.w,i=e.config.chart.type;return("bar"===i||"rangeBar"===i)&&e.config.plotOptions.bar.distributed||"heatmap"===i||"treemap"===i?this.seriesIndex=t.seriesNumber:this.seriesIndex=t.seriesNumber%e.globals.series.length,this.seriesIndex}},{key:"fillPath",value:function(t){var e=this.w;this.opts=t;var i,a,s,r=this.w.config;this.seriesIndex=this.getSeriesIndex(t);var o=this.getFillColors()[this.seriesIndex];void 0!==e.globals.seriesColors[this.seriesIndex]&&(o=e.globals.seriesColors[this.seriesIndex]),"function"==typeof o&&(o=o({seriesIndex:this.seriesIndex,dataPointIndex:t.dataPointIndex,value:t.value,w:e}));var n=t.fillType?t.fillType:this.getFillType(this.seriesIndex),l=Array.isArray(r.fill.opacity)?r.fill.opacity[this.seriesIndex]:r.fill.opacity;t.color&&(o=t.color),o||(o="#fff",console.warn("undefined color - ApexCharts"));var h=o;if(-1===o.indexOf("rgb")?o.length<9&&(h=x.hexToRgba(o,l)):o.indexOf("rgba")>-1&&(l=x.getOpacityFromRGBA(o)),t.opacity&&(l=t.opacity),"pattern"===n&&(a=this.handlePatternFill({fillConfig:t.fillConfig,patternFill:a,fillColor:o,fillOpacity:l,defaultColor:h})),"gradient"===n&&(s=this.handleGradientFill({fillConfig:t.fillConfig,fillColor:o,fillOpacity:l,i:this.seriesIndex})),"image"===n){var c=r.fill.image.src,d=t.patternID?t.patternID:"";this.clippedImgArea({opacity:l,image:Array.isArray(c)?t.seriesNumber<c.length?c[t.seriesNumber]:c[0]:c,width:t.width?t.width:void 0,height:t.height?t.height:void 0,patternUnits:t.patternUnits,patternID:"pattern".concat(e.globals.cuid).concat(t.seriesNumber+1).concat(d)}),i="url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber+1).concat(d,")")}else i="gradient"===n?s:"pattern"===n?a:h;return t.solid&&(i=h),i}},{key:"getFillType",value:function(t){var e=this.w;return Array.isArray(e.config.fill.type)?e.config.fill.type[t]:e.config.fill.type}},{key:"getFillColors",value:function(){var t=this.w,e=t.config,i=this.opts,a=[];return t.globals.comboCharts?"line"===t.config.series[this.seriesIndex].type?Array.isArray(t.globals.stroke.colors)?a=t.globals.stroke.colors:a.push(t.globals.stroke.colors):Array.isArray(t.globals.fill.colors)?a=t.globals.fill.colors:a.push(t.globals.fill.colors):"line"===e.chart.type?Array.isArray(t.globals.stroke.colors)?a=t.globals.stroke.colors:a.push(t.globals.stroke.colors):Array.isArray(t.globals.fill.colors)?a=t.globals.fill.colors:a.push(t.globals.fill.colors),void 0!==i.fillColors&&(a=[],Array.isArray(i.fillColors)?a=i.fillColors.slice():a.push(i.fillColors)),a}},{key:"handlePatternFill",value:function(t){var e=t.fillConfig,i=t.patternFill,a=t.fillColor,s=t.fillOpacity,r=t.defaultColor,o=this.w.config.fill;e&&(o=e);var n=this.opts,l=new m(this.ctx),h=Array.isArray(o.pattern.strokeWidth)?o.pattern.strokeWidth[this.seriesIndex]:o.pattern.strokeWidth,c=a;Array.isArray(o.pattern.style)?i=void 0!==o.pattern.style[n.seriesNumber]?l.drawPattern(o.pattern.style[n.seriesNumber],o.pattern.width,o.pattern.height,c,h,s):r:i=l.drawPattern(o.pattern.style,o.pattern.width,o.pattern.height,c,h,s);return i}},{key:"handleGradientFill",value:function(t){var i=t.fillColor,a=t.fillOpacity,s=t.fillConfig,r=t.i,o=this.w.config.fill;s&&(o=e(e({},o),s));var n,l=this.opts,h=new m(this.ctx),c=new x,d=o.gradient.type,g=i,u=void 0===o.gradient.opacityFrom?a:Array.isArray(o.gradient.opacityFrom)?o.gradient.opacityFrom[r]:o.gradient.opacityFrom;g.indexOf("rgba")>-1&&(u=x.getOpacityFromRGBA(g));var p=void 0===o.gradient.opacityTo?a:Array.isArray(o.gradient.opacityTo)?o.gradient.opacityTo[r]:o.gradient.opacityTo;if(void 0===o.gradient.gradientToColors||0===o.gradient.gradientToColors.length)n="dark"===o.gradient.shade?c.shadeColor(-1*parseFloat(o.gradient.shadeIntensity),i.indexOf("rgb")>-1?x.rgb2hex(i):i):c.shadeColor(parseFloat(o.gradient.shadeIntensity),i.indexOf("rgb")>-1?x.rgb2hex(i):i);else if(o.gradient.gradientToColors[l.seriesNumber]){var f=o.gradient.gradientToColors[l.seriesNumber];n=f,f.indexOf("rgba")>-1&&(p=x.getOpacityFromRGBA(f))}else n=i;if(o.gradient.gradientFrom&&(g=o.gradient.gradientFrom),o.gradient.gradientTo&&(n=o.gradient.gradientTo),o.gradient.inverseColors){var b=g;g=n,n=b}return g.indexOf("rgb")>-1&&(g=x.rgb2hex(g)),n.indexOf("rgb")>-1&&(n=x.rgb2hex(n)),h.drawGradient(d,g,n,u,p,l.size,o.gradient.stops,o.gradient.colorStops,r)}}]),t}(),D=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"setGlobalMarkerSize",value:function(){var t=this.w;if(t.globals.markers.size=Array.isArray(t.config.markers.size)?t.config.markers.size:[t.config.markers.size],t.globals.markers.size.length>0){if(t.globals.markers.size.length<t.globals.series.length+1)for(var e=0;e<=t.globals.series.length;e++)void 0===t.globals.markers.size[e]&&t.globals.markers.size.push(t.globals.markers.size[0])}else t.globals.markers.size=t.config.series.map((function(e){return t.config.markers.size}))}},{key:"plotChartMarkers",value:function(t,e,i,a){var s,r=arguments.length>4&&void 0!==arguments[4]&&arguments[4],o=this.w,n=e,l=t,h=null,c=new m(this.ctx),d=o.config.markers.discrete&&o.config.markers.discrete.length;if((o.globals.markers.size[e]>0||r||d)&&(h=c.group({class:r||d?"":"apexcharts-series-markers"})).attr("clip-path","url(#gridRectMarkerMask".concat(o.globals.cuid,")")),Array.isArray(l.x))for(var g=0;g<l.x.length;g++){var u=i;1===i&&0===g&&(u=0),1===i&&1===g&&(u=1);var p="apexcharts-marker";if("line"!==o.config.chart.type&&"area"!==o.config.chart.type||o.globals.comboCharts||o.config.tooltip.intersect||(p+=" no-pointer-events"),(Array.isArray(o.config.markers.size)?o.globals.markers.size[e]>0:o.config.markers.size>0)||r||d){x.isNumber(l.y[g])?p+=" w".concat(x.randomId()):p="apexcharts-nullpoint";var f=this.getMarkerConfig({cssClass:p,seriesIndex:e,dataPointIndex:u});o.config.series[n].data[u]&&(o.config.series[n].data[u].fillColor&&(f.pointFillColor=o.config.series[n].data[u].fillColor),o.config.series[n].data[u].strokeColor&&(f.pointStrokeColor=o.config.series[n].data[u].strokeColor)),a&&(f.pSize=a),(l.x[g]<-o.globals.markers.largestSize||l.x[g]>o.globals.gridWidth+o.globals.markers.largestSize||l.y[g]<-o.globals.markers.largestSize||l.y[g]>o.globals.gridHeight+o.globals.markers.largestSize)&&(f.pSize=0),(s=c.drawMarker(l.x[g],l.y[g],f)).attr("rel",u),s.attr("j",u),s.attr("index",e),s.node.setAttribute("default-marker-size",f.pSize),new v(this.ctx).setSelectionFilter(s,e,u),this.addEvents(s),h&&h.add(s)}else void 0===o.globals.pointsArray[e]&&(o.globals.pointsArray[e]=[]),o.globals.pointsArray[e].push([l.x[g],l.y[g]])}return h}},{key:"getMarkerConfig",value:function(t){var e=t.cssClass,i=t.seriesIndex,a=t.dataPointIndex,s=void 0===a?null:a,r=t.finishRadius,o=void 0===r?null:r,n=this.w,l=this.getMarkerStyle(i),h=n.globals.markers.size[i],c=n.config.markers;return null!==s&&c.discrete.length&&c.discrete.map((function(t){t.seriesIndex===i&&t.dataPointIndex===s&&(l.pointStrokeColor=t.strokeColor,l.pointFillColor=t.fillColor,h=t.size,l.pointShape=t.shape)})),{pSize:null===o?h:o,pRadius:c.radius,width:Array.isArray(c.width)?c.width[i]:c.width,height:Array.isArray(c.height)?c.height[i]:c.height,pointStrokeWidth:Array.isArray(c.strokeWidth)?c.strokeWidth[i]:c.strokeWidth,pointStrokeColor:l.pointStrokeColor,pointFillColor:l.pointFillColor,shape:l.pointShape||(Array.isArray(c.shape)?c.shape[i]:c.shape),class:e,pointStrokeOpacity:Array.isArray(c.strokeOpacity)?c.strokeOpacity[i]:c.strokeOpacity,pointStrokeDashArray:Array.isArray(c.strokeDashArray)?c.strokeDashArray[i]:c.strokeDashArray,pointFillOpacity:Array.isArray(c.fillOpacity)?c.fillOpacity[i]:c.fillOpacity,seriesIndex:i}}},{key:"addEvents",value:function(t){var e=this.w,i=new m(this.ctx);t.node.addEventListener("mouseenter",i.pathMouseEnter.bind(this.ctx,t)),t.node.addEventListener("mouseleave",i.pathMouseLeave.bind(this.ctx,t)),t.node.addEventListener("mousedown",i.pathMouseDown.bind(this.ctx,t)),t.node.addEventListener("click",e.config.markers.onClick),t.node.addEventListener("dblclick",e.config.markers.onDblClick),t.node.addEventListener("touchstart",i.pathMouseDown.bind(this.ctx,t),{passive:!0})}},{key:"getMarkerStyle",value:function(t){var e=this.w,i=e.globals.markers.colors,a=e.config.markers.strokeColor||e.config.markers.strokeColors;return{pointStrokeColor:Array.isArray(a)?a[t]:a,pointFillColor:Array.isArray(i)?i[t]:i}}}]),t}(),O=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled}return r(t,[{key:"draw",value:function(t,e,i){var a=this.w,s=new m(this.ctx),r=i.realIndex,o=i.pointsPos,n=i.zRatio,l=i.elParent,h=s.group({class:"apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)});if(h.attr("clip-path","url(#gridRectMarkerMask".concat(a.globals.cuid,")")),Array.isArray(o.x))for(var c=0;c<o.x.length;c++){var d=e+1,g=!0;0===e&&0===c&&(d=0),0===e&&1===c&&(d=1);var u=0,p=a.globals.markers.size[r];if(n!==1/0){var f=a.config.plotOptions.bubble;p=a.globals.seriesZ[r][d],f.zScaling&&(p/=n),f.minBubbleRadius&&p<f.minBubbleRadius&&(p=f.minBubbleRadius),f.maxBubbleRadius&&p>f.maxBubbleRadius&&(p=f.maxBubbleRadius)}a.config.chart.animations.enabled||(u=p);var x=o.x[c],b=o.y[c];if(u=u||0,null!==b&&void 0!==a.globals.series[r][d]||(g=!1),g){var v=this.drawPoint(x,b,u,p,r,d,e);h.add(v)}l.add(h)}}},{key:"drawPoint",value:function(t,e,i,a,s,r,o){var n=this.w,l=s,h=new b(this.ctx),c=new v(this.ctx),d=new H(this.ctx),g=new D(this.ctx),u=new m(this.ctx),p=g.getMarkerConfig({cssClass:"apexcharts-marker",seriesIndex:l,dataPointIndex:r,finishRadius:"bubble"===n.config.chart.type||n.globals.comboCharts&&n.config.series[s]&&"bubble"===n.config.series[s].type?a:null});a=p.pSize;var f,x=d.fillPath({seriesNumber:s,dataPointIndex:r,color:p.pointFillColor,patternUnits:"objectBoundingBox",value:n.globals.series[s][o]});if("circle"===p.shape?f=u.drawCircle(i):"square"!==p.shape&&"rect"!==p.shape||(f=u.drawRect(0,0,p.width-p.pointStrokeWidth/2,p.height-p.pointStrokeWidth/2,p.pRadius)),n.config.series[l].data[r]&&n.config.series[l].data[r].fillColor&&(x=n.config.series[l].data[r].fillColor),f.attr({x:t-p.width/2-p.pointStrokeWidth/2,y:e-p.height/2-p.pointStrokeWidth/2,cx:t,cy:e,fill:x,"fill-opacity":p.pointFillOpacity,stroke:p.pointStrokeColor,r:a,"stroke-width":p.pointStrokeWidth,"stroke-dasharray":p.pointStrokeDashArray,"stroke-opacity":p.pointStrokeOpacity}),n.config.chart.dropShadow.enabled){var y=n.config.chart.dropShadow;c.dropShadow(f,y,s)}if(!this.initialAnim||n.globals.dataChanged||n.globals.resized)n.globals.animationEnded=!0;else{var w=n.config.chart.animations.speed;h.animateMarker(f,0,"circle"===p.shape?a:{width:p.width,height:p.height},w,n.globals.easing,(function(){window.setTimeout((function(){h.animationCompleted(f)}),100)}))}if(n.globals.dataChanged&&"circle"===p.shape)if(this.dynamicAnim){var k,A,S,C,L=n.config.chart.animations.dynamicAnimation.speed;null!=(C=n.globals.previousPaths[s]&&n.globals.previousPaths[s][o])&&(k=C.x,A=C.y,S=void 0!==C.r?C.r:a);for(var P=0;P<n.globals.collapsedSeries.length;P++)n.globals.collapsedSeries[P].index===s&&(L=1,a=0);0===t&&0===e&&(a=0),h.animateCircle(f,{cx:k,cy:A,r:S},{cx:t,cy:e,r:a},L,n.globals.easing)}else f.attr({r:a});return f.attr({rel:r,j:r,index:s,"default-marker-size":a}),c.setSelectionFilter(f,s,r),g.addEvents(f),f.node.classList.add("apexcharts-marker"),f}},{key:"centerTextInBubble",value:function(t){var e=this.w;return{y:t+=parseInt(e.config.dataLabels.style.fontSize,10)/4}}}]),t}(),N=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"dataLabelsCorrection",value:function(t,e,i,a,s,r,o){var n=this.w,l=!1,h=new m(this.ctx).getTextRects(i,o),c=h.width,d=h.height;e<0&&(e=0),e>n.globals.gridHeight+d&&(e=n.globals.gridHeight+d/2),void 0===n.globals.dataLabelsRects[a]&&(n.globals.dataLabelsRects[a]=[]),n.globals.dataLabelsRects[a].push({x:t,y:e,width:c,height:d});var g=n.globals.dataLabelsRects[a].length-2,u=void 0!==n.globals.lastDrawnDataLabelsIndexes[a]?n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length-1]:0;if(void 0!==n.globals.dataLabelsRects[a][g]){var p=n.globals.dataLabelsRects[a][u];(t>p.x+p.width||e>p.y+p.height||e+d<p.y||t+c<p.x)&&(l=!0)}return(0===s||r)&&(l=!0),{x:t,y:e,textRects:h,drawnextLabel:l}}},{key:"drawDataLabel",value:function(t){var e=this,i=t.type,a=t.pos,s=t.i,r=t.j,o=t.isRangeStart,n=t.strokeWidth,l=void 0===n?2:n,h=this.w,c=new m(this.ctx),d=h.config.dataLabels,g=0,u=0,p=r,f=null;if(-1!==h.globals.collapsedSeriesIndices.indexOf(s)||!d.enabled||!Array.isArray(a.x))return f;f=c.group({class:"apexcharts-data-labels"});for(var x=0;x<a.x.length;x++)if(g=a.x[x]+d.offsetX,u=a.y[x]+d.offsetY+l,!isNaN(g)){1===r&&0===x&&(p=0),1===r&&1===x&&(p=1);var b=h.globals.series[s][p];"rangeArea"===i&&(b=o?h.globals.seriesRangeStart[s][p]:h.globals.seriesRangeEnd[s][p]);var v="",y=function(t){return h.config.dataLabels.formatter(t,{ctx:e.ctx,seriesIndex:s,dataPointIndex:p,w:h})};if("bubble"===h.config.chart.type)v=y(b=h.globals.seriesZ[s][p]),u=a.y[x],u=new O(this.ctx).centerTextInBubble(u,s,p).y;else void 0!==b&&(v=y(b));var w=h.config.dataLabels.textAnchor;h.globals.isSlopeChart&&(w=0===p?"end":p===h.config.series[s].data.length-1?"start":"middle"),this.plotDataLabelsText({x:g,y:u,text:v,i:s,j:p,parent:f,offsetCorrection:!0,dataLabelsConfig:h.config.dataLabels,textAnchor:w})}return f}},{key:"plotDataLabelsText",value:function(t){var e=this.w,i=new m(this.ctx),a=t.x,s=t.y,r=t.i,o=t.j,n=t.text,l=t.textAnchor,h=t.fontSize,c=t.parent,d=t.dataLabelsConfig,g=t.color,u=t.alwaysDrawDataLabel,p=t.offsetCorrection;if(!(Array.isArray(e.config.dataLabels.enabledOnSeries)&&e.config.dataLabels.enabledOnSeries.indexOf(r)<0)){var f={x:a,y:s,drawnextLabel:!0,textRects:null};p&&(f=this.dataLabelsCorrection(a,s,n,r,o,u,parseInt(d.style.fontSize,10))),e.globals.zoomed||(a=f.x,s=f.y),f.textRects&&(a<-20-f.textRects.width||a>e.globals.gridWidth+f.textRects.width+30)&&(n="");var x=e.globals.dataLabels.style.colors[r];(("bar"===e.config.chart.type||"rangeBar"===e.config.chart.type)&&e.config.plotOptions.bar.distributed||e.config.dataLabels.distributed)&&(x=e.globals.dataLabels.style.colors[o]),"function"==typeof x&&(x=x({series:e.globals.series,seriesIndex:r,dataPointIndex:o,w:e})),g&&(x=g);var b=d.offsetX,y=d.offsetY;if("bar"!==e.config.chart.type&&"rangeBar"!==e.config.chart.type||(b=0,y=0),e.globals.isSlopeChart&&(0!==o&&(b=-2*d.offsetX+5),0!==o&&o!==e.config.series[r].data.length-1&&(b=0)),f.drawnextLabel){var w=i.drawText({width:100,height:parseInt(d.style.fontSize,10),x:a+b,y:s+y,foreColor:x,textAnchor:l||d.textAnchor,text:n,fontSize:h||d.style.fontSize,fontFamily:d.style.fontFamily,fontWeight:d.style.fontWeight||"normal"});if(w.attr({class:"apexcharts-datalabel",cx:a,cy:s}),d.dropShadow.enabled){var k=d.dropShadow;new v(this.ctx).dropShadow(w,k)}c.add(w),void 0===e.globals.lastDrawnDataLabelsIndexes[r]&&(e.globals.lastDrawnDataLabelsIndexes[r]=[]),e.globals.lastDrawnDataLabelsIndexes[r].push(o)}}}},{key:"addBackgroundToDataLabel",value:function(t,e){var i=this.w,a=i.config.dataLabels.background,s=a.padding,r=a.padding/2,o=e.width,n=e.height,l=new m(this.ctx).drawRect(e.x-s,e.y-r/2,o+2*s,n+r,a.borderRadius,"transparent"===i.config.chart.background?"#fff":i.config.chart.background,a.opacity,a.borderWidth,a.borderColor);a.dropShadow.enabled&&new v(this.ctx).dropShadow(l,a.dropShadow);return l}},{key:"dataLabelsBackground",value:function(){var t=this.w;if("bubble"!==t.config.chart.type)for(var e=t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"),i=0;i<e.length;i++){var a=e[i],s=a.getBBox(),r=null;if(s.width&&s.height&&(r=this.addBackgroundToDataLabel(a,s)),r){a.parentNode.insertBefore(r.node,a);var o=a.getAttribute("fill");t.config.chart.animations.enabled&&!t.globals.resized&&!t.globals.dataChanged?r.animate().attr({fill:o}):r.attr({fill:o}),a.setAttribute("fill",t.config.dataLabels.background.foreColor)}}}},{key:"bringForward",value:function(){for(var t=this.w,e=t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"),i=t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"),a=0;a<e.length;a++)i&&i.insertBefore(e[a],i.nextSibling)}}]),t}(),W=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.legendInactiveClass="legend-mouseover-inactive"}return r(t,[{key:"getAllSeriesEls",value:function(){return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series")}},{key:"getSeriesByName",value:function(t){return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(x.escapeString(t),"']"))}},{key:"isSeriesHidden",value:function(t){var e=this.getSeriesByName(t),i=parseInt(e.getAttribute("data:realIndex"),10);return{isHidden:e.classList.contains("apexcharts-series-collapsed"),realIndex:i}}},{key:"addCollapsedClassToSeries",value:function(t,e){var i=this.w;function a(i){for(var a=0;a<i.length;a++)i[a].index===e&&t.node.classList.add("apexcharts-series-collapsed")}a(i.globals.collapsedSeries),a(i.globals.ancillaryCollapsedSeries)}},{key:"toggleSeries",value:function(t){var e=this.isSeriesHidden(t);return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,e.isHidden),e.isHidden}},{key:"showSeries",value:function(t){var e=this.isSeriesHidden(t);e.isHidden&&this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,!0)}},{key:"hideSeries",value:function(t){var e=this.isSeriesHidden(t);e.isHidden||this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,!1)}},{key:"resetSeries",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=this.w,s=x.clone(a.globals.initialSeries);a.globals.previousPaths=[],i?(a.globals.collapsedSeries=[],a.globals.ancillaryCollapsedSeries=[],a.globals.collapsedSeriesIndices=[],a.globals.ancillaryCollapsedSeriesIndices=[]):s=this.emptyCollapsedSeries(s),a.config.series=s,t&&(e&&(a.globals.zoomed=!1,this.ctx.updateHelpers.revertDefaultAxisMinMax()),this.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled))}},{key:"emptyCollapsedSeries",value:function(t){for(var e=this.w,i=0;i<t.length;i++)e.globals.collapsedSeriesIndices.indexOf(i)>-1&&(t[i].data=[]);return t}},{key:"toggleSeriesOnHover",value:function(t,e){var i=this.w;e||(e=t.target);var a=i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis");if("mousemove"===t.type){var s=parseInt(e.getAttribute("rel"),10)-1,r=null,o=null,n=null;if(i.globals.axisCharts||"radialBar"===i.config.chart.type)if(i.globals.axisCharts){r=i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s,"']")),o=i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s,"']"));var l=i.globals.seriesYAxisReverseMap[s];n=i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(l,"']"))}else r=i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s+1,"']"));else r=i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s+1,"'] path"));for(var h=0;h<a.length;h++)a[h].classList.add(this.legendInactiveClass);null!==r&&(i.globals.axisCharts||r.parentNode.classList.remove(this.legendInactiveClass),r.classList.remove(this.legendInactiveClass),null!==o&&o.classList.remove(this.legendInactiveClass),null!==n&&n.classList.remove(this.legendInactiveClass))}else if("mouseout"===t.type)for(var c=0;c<a.length;c++)a[c].classList.remove(this.legendInactiveClass)}},{key:"highlightRangeInSeries",value:function(t,e){var i=this,a=this.w,s=a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"),r=function(t){for(var e=0;e<s.length;e++)s[e].classList[t](i.legendInactiveClass)};if("mousemove"===t.type){var o=parseInt(e.getAttribute("rel"),10)-1;r("add"),function(t){for(var e=0;e<s.length;e++){var a=parseInt(s[e].getAttribute("val"),10);a>=t.from&&a<=t.to&&s[e].classList.remove(i.legendInactiveClass)}}(a.config.plotOptions.heatmap.colorScale.ranges[o])}else"mouseout"===t.type&&r("remove")}},{key:"getActiveConfigSeriesIndex",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"asc",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],i=this.w,a=0;if(i.config.series.length>1)for(var s=i.config.series.map((function(t,a){return t.data&&t.data.length>0&&-1===i.globals.collapsedSeriesIndices.indexOf(a)&&(!i.globals.comboCharts||0===e.length||e.length&&e.indexOf(i.config.series[a].type)>-1)?a:-1})),r="asc"===t?0:s.length-1;"asc"===t?r<s.length:r>=0;"asc"===t?r++:r--)if(-1!==s[r]){a=s[r];break}return a}},{key:"getBarSeriesIndices",value:function(){return this.w.globals.comboCharts?this.w.config.series.map((function(t,e){return"bar"===t.type||"column"===t.type?e:-1})).filter((function(t){return-1!==t})):this.w.config.series.map((function(t,e){return e}))}},{key:"getPreviousPaths",value:function(){var t=this.w;function e(e,i,a){for(var s=e[i].childNodes,r={type:a,paths:[],realIndex:e[i].getAttribute("data:realIndex")},o=0;o<s.length;o++)if(s[o].hasAttribute("pathTo")){var n=s[o].getAttribute("pathTo");r.paths.push({d:n})}t.globals.previousPaths.push(r)}t.globals.previousPaths=[];["line","area","bar","rangebar","rangeArea","candlestick","radar"].forEach((function(i){for(var a,s=(a=i,t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a,"-series .apexcharts-series"))),r=0;r<s.length;r++)e(s,r,i)})),this.handlePrevBubbleScatterPaths("bubble"),this.handlePrevBubbleScatterPaths("scatter");var i=t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type," .apexcharts-series"));if(i.length>0)for(var a=function(e){for(var i=t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type," .apexcharts-series[data\\:realIndex='").concat(e,"'] rect")),a=[],s=function(t){var e=function(e){return i[t].getAttribute(e)},s={x:parseFloat(e("x")),y:parseFloat(e("y")),width:parseFloat(e("width")),height:parseFloat(e("height"))};a.push({rect:s,color:i[t].getAttribute("color")})},r=0;r<i.length;r++)s(r);t.globals.previousPaths.push(a)},s=0;s<i.length;s++)a(s);t.globals.axisCharts||(t.globals.previousPaths=t.globals.series)}},{key:"handlePrevBubbleScatterPaths",value:function(t){var e=this.w,i=e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t,"-series .apexcharts-series"));if(i.length>0)for(var a=0;a<i.length;a++){for(var s=e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t,"-series .apexcharts-series[data\\:realIndex='").concat(a,"'] circle")),r=[],o=0;o<s.length;o++)r.push({x:s[o].getAttribute("cx"),y:s[o].getAttribute("cy"),r:s[o].getAttribute("r")});e.globals.previousPaths.push(r)}}},{key:"clearPreviousPaths",value:function(){var t=this.w;t.globals.previousPaths=[],t.globals.allSeriesCollapsed=!1}},{key:"handleNoData",value:function(){var t=this.w,e=t.config.noData,i=new m(this.ctx),a=t.globals.svgWidth/2,s=t.globals.svgHeight/2,r="middle";if(t.globals.noData=!0,t.globals.animationEnded=!0,"left"===e.align?(a=10,r="start"):"right"===e.align&&(a=t.globals.svgWidth-10,r="end"),"top"===e.verticalAlign?s=50:"bottom"===e.verticalAlign&&(s=t.globals.svgHeight-50),a+=e.offsetX,s=s+parseInt(e.style.fontSize,10)+2+e.offsetY,void 0!==e.text&&""!==e.text){var o=i.drawText({x:a,y:s,text:e.text,textAnchor:r,fontSize:e.style.fontSize,fontFamily:e.style.fontFamily,foreColor:e.style.color,opacity:1,class:"apexcharts-text-nodata"});t.globals.dom.Paper.add(o)}}},{key:"setNullSeriesToZeroValues",value:function(t){for(var e=this.w,i=0;i<t.length;i++)if(0===t[i].length)for(var a=0;a<t[e.globals.maxValsInArrayIndex].length;a++)t[i].push(0);return t}},{key:"hasAllSeriesEqualX",value:function(){for(var t=!0,e=this.w,i=this.filteredSeriesX(),a=0;a<i.length-1;a++)if(i[a][0]!==i[a+1][0]){t=!1;break}return e.globals.allSeriesHasEqualX=t,t}},{key:"filteredSeriesX",value:function(){var t=this.w.globals.seriesX.map((function(t){return t.length>0?t:[]}));return t}}]),t}(),B=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.twoDSeries=[],this.threeDSeries=[],this.twoDSeriesX=[],this.seriesGoals=[],this.coreUtils=new y(this.ctx)}return r(t,[{key:"isMultiFormat",value:function(){return this.isFormatXY()||this.isFormat2DArray()}},{key:"isFormatXY",value:function(){var t=this.w.config.series.slice(),e=new W(this.ctx);if(this.activeSeriesIndex=e.getActiveConfigSeriesIndex(),void 0!==t[this.activeSeriesIndex].data&&t[this.activeSeriesIndex].data.length>0&&null!==t[this.activeSeriesIndex].data[0]&&void 0!==t[this.activeSeriesIndex].data[0].x&&null!==t[this.activeSeriesIndex].data[0])return!0}},{key:"isFormat2DArray",value:function(){var t=this.w.config.series.slice(),e=new W(this.ctx);if(this.activeSeriesIndex=e.getActiveConfigSeriesIndex(),void 0!==t[this.activeSeriesIndex].data&&t[this.activeSeriesIndex].data.length>0&&void 0!==t[this.activeSeriesIndex].data[0]&&null!==t[this.activeSeriesIndex].data[0]&&t[this.activeSeriesIndex].data[0].constructor===Array)return!0}},{key:"handleFormat2DArray",value:function(t,e){for(var i=this.w.config,a=this.w.globals,s="boxPlot"===i.chart.type||"boxPlot"===i.series[e].type,r=0;r<t[e].data.length;r++)if(void 0!==t[e].data[r][1]&&(Array.isArray(t[e].data[r][1])&&4===t[e].data[r][1].length&&!s?this.twoDSeries.push(x.parseNumber(t[e].data[r][1][3])):t[e].data[r].length>=5?this.twoDSeries.push(x.parseNumber(t[e].data[r][4])):this.twoDSeries.push(x.parseNumber(t[e].data[r][1])),a.dataFormatXNumeric=!0),"datetime"===i.xaxis.type){var o=new Date(t[e].data[r][0]);o=new Date(o).getTime(),this.twoDSeriesX.push(o)}else this.twoDSeriesX.push(t[e].data[r][0]);for(var n=0;n<t[e].data.length;n++)void 0!==t[e].data[n][2]&&(this.threeDSeries.push(t[e].data[n][2]),a.isDataXYZ=!0)}},{key:"handleFormatXY",value:function(t,e){var i=this.w.config,a=this.w.globals,s=new A(this.ctx),r=e;a.collapsedSeriesIndices.indexOf(e)>-1&&(r=this.activeSeriesIndex);for(var o=0;o<t[e].data.length;o++)void 0!==t[e].data[o].y&&(Array.isArray(t[e].data[o].y)?this.twoDSeries.push(x.parseNumber(t[e].data[o].y[t[e].data[o].y.length-1])):this.twoDSeries.push(x.parseNumber(t[e].data[o].y))),void 0!==t[e].data[o].goals&&Array.isArray(t[e].data[o].goals)?(void 0===this.seriesGoals[e]&&(this.seriesGoals[e]=[]),this.seriesGoals[e].push(t[e].data[o].goals)):(void 0===this.seriesGoals[e]&&(this.seriesGoals[e]=[]),this.seriesGoals[e].push(null));for(var n=0;n<t[r].data.length;n++){var l="string"==typeof t[r].data[n].x,h=Array.isArray(t[r].data[n].x),c=!h&&!!s.isValidDate(t[r].data[n].x);if(l||c)if(l||i.xaxis.convertedCatToNumeric){var d=a.isBarHorizontal&&a.isRangeData;"datetime"!==i.xaxis.type||d?(this.fallbackToCategory=!0,this.twoDSeriesX.push(t[r].data[n].x),isNaN(t[r].data[n].x)||"category"===this.w.config.xaxis.type||"string"==typeof t[r].data[n].x||(a.isXNumeric=!0)):this.twoDSeriesX.push(s.parseDate(t[r].data[n].x))}else"datetime"===i.xaxis.type?this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())):(a.dataFormatXNumeric=!0,a.isXNumeric=!0,this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));else h?(this.fallbackToCategory=!0,this.twoDSeriesX.push(t[r].data[n].x)):(a.isXNumeric=!0,a.dataFormatXNumeric=!0,this.twoDSeriesX.push(t[r].data[n].x))}if(t[e].data[0]&&void 0!==t[e].data[0].z){for(var g=0;g<t[e].data.length;g++)this.threeDSeries.push(t[e].data[g].z);a.isDataXYZ=!0}}},{key:"handleRangeData",value:function(t,e){var i=this.w.globals,a={};return this.isFormat2DArray()?a=this.handleRangeDataFormat("array",t,e):this.isFormatXY()&&(a=this.handleRangeDataFormat("xy",t,e)),i.seriesRangeStart.push(void 0===a.start?[]:a.start),i.seriesRangeEnd.push(void 0===a.end?[]:a.end),i.seriesRange.push(a.rangeUniques),i.seriesRange.forEach((function(t,e){t&&t.forEach((function(t,e){t.y.forEach((function(e,i){for(var a=0;a<t.y.length;a++)if(i!==a){var s=e.y1,r=e.y2,o=t.y[a].y1;s<=t.y[a].y2&&o<=r&&(t.overlaps.indexOf(e.rangeName)<0&&t.overlaps.push(e.rangeName),t.overlaps.indexOf(t.y[a].rangeName)<0&&t.overlaps.push(t.y[a].rangeName))}}))}))})),a}},{key:"handleCandleStickBoxData",value:function(t,e){var i=this.w.globals,a={};return this.isFormat2DArray()?a=this.handleCandleStickBoxDataFormat("array",t,e):this.isFormatXY()&&(a=this.handleCandleStickBoxDataFormat("xy",t,e)),i.seriesCandleO[e]=a.o,i.seriesCandleH[e]=a.h,i.seriesCandleM[e]=a.m,i.seriesCandleL[e]=a.l,i.seriesCandleC[e]=a.c,a}},{key:"handleRangeDataFormat",value:function(t,e,i){var a=[],s=[],r=e[i].data.filter((function(t,e,i){return e===i.findIndex((function(e){return e.x===t.x}))})).map((function(t,e){return{x:t.x,overlaps:[],y:[]}}));if("array"===t)for(var o=0;o<e[i].data.length;o++)Array.isArray(e[i].data[o])?(a.push(e[i].data[o][1][0]),s.push(e[i].data[o][1][1])):(a.push(e[i].data[o]),s.push(e[i].data[o]));else if("xy"===t)for(var n=function(t){var o=Array.isArray(e[i].data[t].y),n=x.randomId(),l=e[i].data[t].x,h={y1:o?e[i].data[t].y[0]:e[i].data[t].y,y2:o?e[i].data[t].y[1]:e[i].data[t].y,rangeName:n};e[i].data[t].rangeName=n;var c=r.findIndex((function(t){return t.x===l}));r[c].y.push(h),a.push(h.y1),s.push(h.y2)},l=0;l<e[i].data.length;l++)n(l);return{start:a,end:s,rangeUniques:r}}},{key:"handleCandleStickBoxDataFormat",value:function(t,e,i){var a=this.w,s="boxPlot"===a.config.chart.type||"boxPlot"===a.config.series[i].type,r=[],o=[],n=[],l=[],h=[];if("array"===t)if(s&&6===e[i].data[0].length||!s&&5===e[i].data[0].length)for(var c=0;c<e[i].data.length;c++)r.push(e[i].data[c][1]),o.push(e[i].data[c][2]),s?(n.push(e[i].data[c][3]),l.push(e[i].data[c][4]),h.push(e[i].data[c][5])):(l.push(e[i].data[c][3]),h.push(e[i].data[c][4]));else for(var d=0;d<e[i].data.length;d++)Array.isArray(e[i].data[d][1])&&(r.push(e[i].data[d][1][0]),o.push(e[i].data[d][1][1]),s?(n.push(e[i].data[d][1][2]),l.push(e[i].data[d][1][3]),h.push(e[i].data[d][1][4])):(l.push(e[i].data[d][1][2]),h.push(e[i].data[d][1][3])));else if("xy"===t)for(var g=0;g<e[i].data.length;g++)Array.isArray(e[i].data[g].y)&&(r.push(e[i].data[g].y[0]),o.push(e[i].data[g].y[1]),s?(n.push(e[i].data[g].y[2]),l.push(e[i].data[g].y[3]),h.push(e[i].data[g].y[4])):(l.push(e[i].data[g].y[2]),h.push(e[i].data[g].y[3])));return{o:r,h:o,m:n,l:l,c:h}}},{key:"parseDataAxisCharts",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.ctx,a=this.w.config,s=this.w.globals,r=new A(i),o=a.labels.length>0?a.labels.slice():a.xaxis.categories.slice();s.isRangeBar="rangeBar"===a.chart.type&&s.isBarHorizontal,s.hasXaxisGroups="category"===a.xaxis.type&&a.xaxis.group.groups.length>0,s.hasXaxisGroups&&(s.groups=a.xaxis.group.groups),t.forEach((function(t,e){void 0!==t.name?s.seriesNames.push(t.name):s.seriesNames.push("series-"+parseInt(e+1,10))})),this.coreUtils.setSeriesYAxisMappings();var n=[],l=u(new Set(a.series.map((function(t){return t.group}))));a.series.forEach((function(t,e){var i=l.indexOf(t.group);n[i]||(n[i]=[]),n[i].push(s.seriesNames[e])})),s.seriesGroups=n;for(var h=function(){for(var t=0;t<o.length;t++)if("string"==typeof o[t]){if(!r.isValidDate(o[t]))throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");e.twoDSeriesX.push(r.parseDate(o[t]))}else e.twoDSeriesX.push(o[t])},c=0;c<t.length;c++){if(this.twoDSeries=[],this.twoDSeriesX=[],this.threeDSeries=[],void 0===t[c].data)return void console.error("It is a possibility that you may have not included 'data' property in series.");if("rangeBar"!==a.chart.type&&"rangeArea"!==a.chart.type&&"rangeBar"!==t[c].type&&"rangeArea"!==t[c].type||(s.isRangeData=!0,"rangeBar"!==a.chart.type&&"rangeArea"!==a.chart.type||this.handleRangeData(t,c)),this.isMultiFormat())this.isFormat2DArray()?this.handleFormat2DArray(t,c):this.isFormatXY()&&this.handleFormatXY(t,c),"candlestick"!==a.chart.type&&"candlestick"!==t[c].type&&"boxPlot"!==a.chart.type&&"boxPlot"!==t[c].type||this.handleCandleStickBoxData(t,c),s.series.push(this.twoDSeries),s.labels.push(this.twoDSeriesX),s.seriesX.push(this.twoDSeriesX),s.seriesGoals=this.seriesGoals,c!==this.activeSeriesIndex||this.fallbackToCategory||(s.isXNumeric=!0);else{"datetime"===a.xaxis.type?(s.isXNumeric=!0,h(),s.seriesX.push(this.twoDSeriesX)):"numeric"===a.xaxis.type&&(s.isXNumeric=!0,o.length>0&&(this.twoDSeriesX=o,s.seriesX.push(this.twoDSeriesX))),s.labels.push(this.twoDSeriesX);var d=t[c].data.map((function(t){return x.parseNumber(t)}));s.series.push(d)}s.seriesZ.push(this.threeDSeries),void 0!==t[c].color?s.seriesColors.push(t[c].color):s.seriesColors.push(void 0)}return this.w}},{key:"parseDataNonAxisCharts",value:function(t){var e=this.w.globals,i=this.w.config;e.series=t.slice(),e.seriesNames=i.labels.slice();for(var a=0;a<e.series.length;a++)void 0===e.seriesNames[a]&&e.seriesNames.push("series-"+(a+1));return this.w}},{key:"handleExternalLabelsData",value:function(t){var e=this.w.config,i=this.w.globals;if(e.xaxis.categories.length>0)i.labels=e.xaxis.categories;else if(e.labels.length>0)i.labels=e.labels.slice();else if(this.fallbackToCategory){if(i.labels=i.labels[0],i.seriesRange.length&&(i.seriesRange.map((function(t){t.forEach((function(t){i.labels.indexOf(t.x)<0&&t.x&&i.labels.push(t.x)}))})),i.labels=Array.from(new Set(i.labels.map(JSON.stringify)),JSON.parse)),e.xaxis.convertedCatToNumeric)new E(e).convertCatToNumericXaxis(e,this.ctx,i.seriesX[0]),this._generateExternalLabels(t)}else this._generateExternalLabels(t)}},{key:"_generateExternalLabels",value:function(t){var e=this.w.globals,i=this.w.config,a=[];if(e.axisCharts){if(e.series.length>0)if(this.isFormatXY())for(var s=i.series.map((function(t,e){return t.data.filter((function(t,e,i){return i.findIndex((function(e){return e.x===t.x}))===e}))})),r=s.reduce((function(t,e,i,a){return a[t].length>e.length?t:i}),0),o=0;o<s[r].length;o++)a.push(o+1);else for(var n=0;n<e.series[e.maxValsInArrayIndex].length;n++)a.push(n+1);e.seriesX=[];for(var l=0;l<t.length;l++)e.seriesX.push(a);this.w.globals.isBarHorizontal||(e.isXNumeric=!0)}if(0===a.length){a=e.axisCharts?[]:e.series.map((function(t,e){return e+1}));for(var h=0;h<t.length;h++)e.seriesX.push(a)}e.labels=a,i.xaxis.convertedCatToNumeric&&(e.categoryLabels=a.map((function(t){return i.xaxis.labels.formatter(t)}))),e.noLabelsProvided=!0}},{key:"parseData",value:function(t){var e=this.w,i=e.config,a=e.globals;if(this.excludeCollapsedSeriesInYAxis(),this.fallbackToCategory=!1,this.ctx.core.resetGlobals(),this.ctx.core.isMultipleY(),a.axisCharts?(this.parseDataAxisCharts(t),this.coreUtils.getLargestSeries()):this.parseDataNonAxisCharts(t),i.chart.stacked){var s=new W(this.ctx);a.series=s.setNullSeriesToZeroValues(a.series)}this.coreUtils.getSeriesTotals(),a.axisCharts&&(a.stackedSeriesTotals=this.coreUtils.getStackedSeriesTotals(),a.stackedSeriesTotalsByGroups=this.coreUtils.getStackedSeriesTotalsByGroups()),this.coreUtils.getPercentSeries(),a.dataFormatXNumeric||a.isXNumeric&&("numeric"!==i.xaxis.type||0!==i.labels.length||0!==i.xaxis.categories.length)||this.handleExternalLabelsData(t);for(var r=this.coreUtils.getCategoryLabels(a.labels),o=0;o<r.length;o++)if(Array.isArray(r[o])){a.isMultiLineX=!0;break}}},{key:"excludeCollapsedSeriesInYAxis",value:function(){var t=this.w,e=[];t.globals.seriesYAxisMap.forEach((function(i,a){var s=0;i.forEach((function(e){-1!==t.globals.collapsedSeriesIndices.indexOf(e)&&s++})),s>0&&s==i.length&&e.push(a)})),t.globals.ignoreYAxisIndexes=e.map((function(t){return t}))}}]),t}(),G=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"scaleSvgNode",value:function(t,e){var i=parseFloat(t.getAttributeNS(null,"width")),a=parseFloat(t.getAttributeNS(null,"height"));t.setAttributeNS(null,"width",i*e),t.setAttributeNS(null,"height",a*e),t.setAttributeNS(null,"viewBox","0 0 "+i+" "+a)}},{key:"fixSvgStringForIe11",value:function(t){if(!x.isIE11())return t.replace(/&nbsp;/g,"&#160;");var e=0,i=t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g,(function(t){return 2===++e?'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"':t}));return i=(i=i.replace(/xmlns:NS\d+=""/g,"")).replace(/NS\d+:(\w+:\w+=")/g,"$1")}},{key:"getSvgString",value:function(t){null==t&&(t=1);var e=this.w.globals.dom.Paper.svg();if(1!==t){var i=this.w.globals.dom.Paper.node.cloneNode(!0);this.scaleSvgNode(i,t),e=(new XMLSerializer).serializeToString(i)}return this.fixSvgStringForIe11(e)}},{key:"cleanup",value:function(){var t=this.w,e=t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"),i=t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");Array.prototype.forEach.call(a,(function(t){t.setAttribute("width",0)})),e&&e[0]&&(e[0].setAttribute("x",-500),e[0].setAttribute("x1",-500),e[0].setAttribute("x2",-500)),i&&i[0]&&(i[0].setAttribute("y",-100),i[0].setAttribute("y1",-100),i[0].setAttribute("y2",-100))}},{key:"svgUrl",value:function(){this.cleanup();var t=this.getSvgString(),e=new Blob([t],{type:"image/svg+xml;charset=utf-8"});return URL.createObjectURL(e)}},{key:"dataURI",value:function(t){var e=this;return new Promise((function(i){var a=e.w,s=t?t.scale||t.width/a.globals.svgWidth:1;e.cleanup();var r=document.createElement("canvas");r.width=a.globals.svgWidth*s,r.height=parseInt(a.globals.dom.elWrap.style.height,10)*s;var o="transparent"===a.config.chart.background?"#fff":a.config.chart.background,n=r.getContext("2d");n.fillStyle=o,n.fillRect(0,0,r.width*s,r.height*s);var l=e.getSvgString(s);if(window.canvg&&x.isIE11()){var h=window.canvg.Canvg.fromString(n,l,{ignoreClear:!0,ignoreDimensions:!0});h.start();var c=r.msToBlob();h.stop(),i({blob:c})}else{var d="data:image/svg+xml,"+encodeURIComponent(l),g=new Image;g.crossOrigin="anonymous",g.onload=function(){if(n.drawImage(g,0,0),r.msToBlob){var t=r.msToBlob();i({blob:t})}else{var e=r.toDataURL("image/png");i({imgURI:e})}},g.src=d}}))}},{key:"exportToSVG",value:function(){this.triggerDownload(this.svgUrl(),this.w.config.chart.toolbar.export.svg.filename,".svg")}},{key:"exportToPng",value:function(){var t=this;this.dataURI().then((function(e){var i=e.imgURI,a=e.blob;a?navigator.msSaveOrOpenBlob(a,t.w.globals.chartID+".png"):t.triggerDownload(i,t.w.config.chart.toolbar.export.png.filename,".png")}))}},{key:"exportToCSV",value:function(t){var e=this,i=t.series,a=t.fileName,s=t.columnDelimiter,r=void 0===s?",":s,o=t.lineDelimiter,n=void 0===o?"\n":o,l=this.w;i||(i=l.config.series);var h,c,d=[],g=[],p="",f=l.globals.series.map((function(t,e){return-1===l.globals.collapsedSeriesIndices.indexOf(e)?t:[]})),b=function(t){return"datetime"===l.config.xaxis.type&&String(t).length>=10},v=Math.max.apply(Math,u(i.map((function(t){return t.data?t.data.length:0})))),m=new B(this.ctx),y=new C(this.ctx),w=function(t){var i="";if(l.globals.axisCharts){if("category"===l.config.xaxis.type||l.config.xaxis.convertedCatToNumeric)if(l.globals.isBarHorizontal){var a=l.globals.yLabelFormatters[0],s=new W(e.ctx).getActiveConfigSeriesIndex();i=a(l.globals.labels[t],{seriesIndex:s,dataPointIndex:t,w:l})}else i=y.getLabel(l.globals.labels,l.globals.timescaleLabels,0,t).text;"datetime"===l.config.xaxis.type&&(l.config.xaxis.categories.length?i=l.config.xaxis.categories[t]:l.config.labels.length&&(i=l.config.labels[t]))}else i=l.config.labels[t];return null===i?"nullvalue":(Array.isArray(i)&&(i=i.join(" ")),x.isNumber(i)?i:i.split(r).join(""))},k=function(t,e){if(d.length&&0===e&&g.push(d.join(r)),t.data){t.data=t.data.length&&t.data||u(Array(v)).map((function(){return""}));for(var a=0;a<t.data.length;a++){d=[];var s=w(a);if("nullvalue"!==s){if(s||(m.isFormatXY()?s=i[e].data[a].x:m.isFormat2DArray()&&(s=i[e].data[a]?i[e].data[a][0]:"")),0===e){d.push(b(s)?l.config.chart.toolbar.export.csv.dateFormatter(s):x.isNumber(s)?s:s.split(r).join(""));for(var o=0;o<l.globals.series.length;o++){var n;if(m.isFormatXY())d.push(null===(n=i[o].data[a])||void 0===n?void 0:n.y);else d.push(f[o][a])}}("candlestick"===l.config.chart.type||t.type&&"candlestick"===t.type)&&(d.pop(),d.push(l.globals.seriesCandleO[e][a]),d.push(l.globals.seriesCandleH[e][a]),d.push(l.globals.seriesCandleL[e][a]),d.push(l.globals.seriesCandleC[e][a])),("boxPlot"===l.config.chart.type||t.type&&"boxPlot"===t.type)&&(d.pop(),d.push(l.globals.seriesCandleO[e][a]),d.push(l.globals.seriesCandleH[e][a]),d.push(l.globals.seriesCandleM[e][a]),d.push(l.globals.seriesCandleL[e][a]),d.push(l.globals.seriesCandleC[e][a])),"rangeBar"===l.config.chart.type&&(d.pop(),d.push(l.globals.seriesRangeStart[e][a]),d.push(l.globals.seriesRangeEnd[e][a])),d.length&&g.push(d.join(r))}}}};d.push(l.config.chart.toolbar.export.csv.headerCategory),"boxPlot"===l.config.chart.type?(d.push("minimum"),d.push("q1"),d.push("median"),d.push("q3"),d.push("maximum")):"candlestick"===l.config.chart.type?(d.push("open"),d.push("high"),d.push("low"),d.push("close")):"rangeBar"===l.config.chart.type?(d.push("minimum"),d.push("maximum")):i.map((function(t,e){var i=(t.name?t.name:"series-".concat(e))+"";l.globals.axisCharts&&d.push(i.split(r).join("")?i.split(r).join(""):"series-".concat(e))})),l.globals.axisCharts||(d.push(l.config.chart.toolbar.export.csv.headerValue),g.push(d.join(r))),l.globals.allSeriesHasEqualX||!l.globals.axisCharts||l.config.xaxis.categories.length||l.config.labels.length?i.map((function(t,e){l.globals.axisCharts?k(t,e):((d=[]).push(l.globals.labels[e].split(r).join("")),d.push(f[e]),g.push(d.join(r)))})):(h=new Set,c={},i.forEach((function(t,e){null==t||t.data.forEach((function(t){var a,s;if(m.isFormatXY())a=t.x,s=t.y;else{if(!m.isFormat2DArray())return;a=t[0],s=t[1]}c[a]||(c[a]=Array(i.length).fill("")),c[a][e]=s,h.add(a)}))})),d.length&&g.push(d.join(r)),Array.from(h).sort().forEach((function(t){g.push([b(t)&&"datetime"===l.config.xaxis.type?l.config.chart.toolbar.export.csv.dateFormatter(t):x.isNumber(t)?t:t.split(r).join(""),c[t].join(r)])}))),p+=g.join(n),this.triggerDownload("data:text/csv; charset=utf-8,"+encodeURIComponent("\ufeff"+p),a||l.config.chart.toolbar.export.csv.filename,".csv")}},{key:"triggerDownload",value:function(t,e,i){var a=document.createElement("a");a.href=t,a.download=(e||this.w.globals.chartID)+i,document.body.appendChild(a),a.click(),document.body.removeChild(a)}}]),t}(),V=function(){function t(e,i){a(this,t),this.ctx=e,this.elgrid=i,this.w=e.w;var s=this.w;this.axesUtils=new C(e),this.xaxisLabels=s.globals.labels.slice(),s.globals.timescaleLabels.length>0&&!s.globals.isBarHorizontal&&(this.xaxisLabels=s.globals.timescaleLabels.slice()),s.config.xaxis.overwriteCategories&&(this.xaxisLabels=s.config.xaxis.overwriteCategories),this.drawnLabels=[],this.drawnLabelsRects=[],"top"===s.config.xaxis.position?this.offY=0:this.offY=s.globals.gridHeight,this.offY=this.offY+s.config.xaxis.axisBorder.offsetY,this.isCategoryBarHorizontal="bar"===s.config.chart.type&&s.config.plotOptions.bar.horizontal,this.xaxisFontSize=s.config.xaxis.labels.style.fontSize,this.xaxisFontFamily=s.config.xaxis.labels.style.fontFamily,this.xaxisForeColors=s.config.xaxis.labels.style.colors,this.xaxisBorderWidth=s.config.xaxis.axisBorder.width,this.isCategoryBarHorizontal&&(this.xaxisBorderWidth=s.config.yaxis[0].axisBorder.width.toString()),this.xaxisBorderWidth.indexOf("%")>-1?this.xaxisBorderWidth=s.globals.gridWidth*parseInt(this.xaxisBorderWidth,10)/100:this.xaxisBorderWidth=parseInt(this.xaxisBorderWidth,10),this.xaxisBorderHeight=s.config.xaxis.axisBorder.height,this.yaxis=s.config.yaxis[0]}return r(t,[{key:"drawXaxis",value:function(){var t=this.w,e=new m(this.ctx),i=e.group({class:"apexcharts-xaxis",transform:"translate(".concat(t.config.xaxis.offsetX,", ").concat(t.config.xaxis.offsetY,")")}),a=e.group({class:"apexcharts-xaxis-texts-g",transform:"translate(".concat(t.globals.translateXAxisX,", ").concat(t.globals.translateXAxisY,")")});i.add(a);for(var s=[],r=0;r<this.xaxisLabels.length;r++)s.push(this.xaxisLabels[r]);if(this.drawXAxisLabelAndGroup(!0,e,a,s,t.globals.isXNumeric,(function(t,e){return e})),t.globals.hasXaxisGroups){var o=t.globals.groups;s=[];for(var n=0;n<o.length;n++)s.push(o[n].title);var l={};t.config.xaxis.group.style&&(l.xaxisFontSize=t.config.xaxis.group.style.fontSize,l.xaxisFontFamily=t.config.xaxis.group.style.fontFamily,l.xaxisForeColors=t.config.xaxis.group.style.colors,l.fontWeight=t.config.xaxis.group.style.fontWeight,l.cssClass=t.config.xaxis.group.style.cssClass),this.drawXAxisLabelAndGroup(!1,e,a,s,!1,(function(t,e){return o[t].cols*e}),l)}if(void 0!==t.config.xaxis.title.text){var h=e.group({class:"apexcharts-xaxis-title"}),c=e.drawText({x:t.globals.gridWidth/2+t.config.xaxis.title.offsetX,y:this.offY+parseFloat(this.xaxisFontSize)+("bottom"===t.config.xaxis.position?t.globals.xAxisLabelsHeight:-t.globals.xAxisLabelsHeight-10)+t.config.xaxis.title.offsetY,text:t.config.xaxis.title.text,textAnchor:"middle",fontSize:t.config.xaxis.title.style.fontSize,fontFamily:t.config.xaxis.title.style.fontFamily,fontWeight:t.config.xaxis.title.style.fontWeight,foreColor:t.config.xaxis.title.style.color,cssClass:"apexcharts-xaxis-title-text "+t.config.xaxis.title.style.cssClass});h.add(c),i.add(h)}if(t.config.xaxis.axisBorder.show){var d=t.globals.barPadForNumericAxis,g=e.drawLine(t.globals.padHorizontal+t.config.xaxis.axisBorder.offsetX-d,this.offY,this.xaxisBorderWidth+d,this.offY,t.config.xaxis.axisBorder.color,0,this.xaxisBorderHeight);this.elgrid&&this.elgrid.elGridBorders&&t.config.grid.show?this.elgrid.elGridBorders.add(g):i.add(g)}return i}},{key:"drawXAxisLabelAndGroup",value:function(t,e,i,a,s,r){var o,n=this,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:{},h=[],c=[],d=this.w,g=l.xaxisFontSize||this.xaxisFontSize,u=l.xaxisFontFamily||this.xaxisFontFamily,p=l.xaxisForeColors||this.xaxisForeColors,f=l.fontWeight||d.config.xaxis.labels.style.fontWeight,x=l.cssClass||d.config.xaxis.labels.style.cssClass,b=d.globals.padHorizontal,v=a.length,m="category"===d.config.xaxis.type?d.globals.dataPoints:v;if(0===m&&v>m&&(m=v),s){var y=m>1?m-1:m;o=d.globals.gridWidth/Math.min(y,v-1),b=b+r(0,o)/2+d.config.xaxis.labels.offsetX}else o=d.globals.gridWidth/m,b=b+r(0,o)+d.config.xaxis.labels.offsetX;for(var w=function(s){var l=b-r(s,o)/2+d.config.xaxis.labels.offsetX;0===s&&1===v&&o/2===b&&1===m&&(l=d.globals.gridWidth/2);var y=n.axesUtils.getLabel(a,d.globals.timescaleLabels,l,s,h,g,t),w=28;d.globals.rotateXLabels&&t&&(w=22),d.config.xaxis.title.text&&"top"===d.config.xaxis.position&&(w+=parseFloat(d.config.xaxis.title.style.fontSize)+2),t||(w=w+parseFloat(g)+(d.globals.xAxisLabelsHeight-d.globals.xAxisGroupLabelsHeight)+(d.globals.rotateXLabels?10:0)),y=void 0!==d.config.xaxis.tickAmount&&"dataPoints"!==d.config.xaxis.tickAmount&&"datetime"!==d.config.xaxis.type?n.axesUtils.checkLabelBasedOnTickamount(s,y,v):n.axesUtils.checkForOverflowingLabels(s,y,v,h,c);if(d.config.xaxis.labels.show){var k=e.drawText({x:y.x,y:n.offY+d.config.xaxis.labels.offsetY+w-("top"===d.config.xaxis.position?d.globals.xAxisHeight+d.config.xaxis.axisTicks.height-2:0),text:y.text,textAnchor:"middle",fontWeight:y.isBold?600:f,fontSize:g,fontFamily:u,foreColor:Array.isArray(p)?t&&d.config.xaxis.convertedCatToNumeric?p[d.globals.minX+s-1]:p[s]:p,isPlainText:!1,cssClass:(t?"apexcharts-xaxis-label ":"apexcharts-xaxis-group-label ")+x});if(i.add(k),k.on("click",(function(t){if("function"==typeof d.config.chart.events.xAxisLabelClick){var e=Object.assign({},d,{labelIndex:s});d.config.chart.events.xAxisLabelClick(t,n.ctx,e)}})),t){var A=document.createElementNS(d.globals.SVGNS,"title");A.textContent=Array.isArray(y.text)?y.text.join(" "):y.text,k.node.appendChild(A),""!==y.text&&(h.push(y.text),c.push(y))}}s<v-1&&(b+=r(s+1,o))},k=0;k<=v-1;k++)w(k)}},{key:"drawXaxisInversed",value:function(t){var e,i,a=this,s=this.w,r=new m(this.ctx),o=s.config.yaxis[0].opposite?s.globals.translateYAxisX[t]:0,n=r.group({class:"apexcharts-yaxis apexcharts-xaxis-inversed",rel:t}),l=r.group({class:"apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",transform:"translate("+o+", 0)"});n.add(l);var h=[];if(s.config.yaxis[t].show)for(var c=0;c<this.xaxisLabels.length;c++)h.push(this.xaxisLabels[c]);e=s.globals.gridHeight/h.length,i=-e/2.2;var d=s.globals.yLabelFormatters[0],g=s.config.yaxis[0].labels;if(g.show)for(var u=function(o){var n=void 0===h[o]?"":h[o];n=d(n,{seriesIndex:t,dataPointIndex:o,w:s});var c=a.axesUtils.getYAxisForeColor(g.style.colors,t),u=0;Array.isArray(n)&&(u=n.length/2*parseInt(g.style.fontSize,10));var p=g.offsetX-15,f="end";a.yaxis.opposite&&(f="start"),"left"===s.config.yaxis[0].labels.align?(p=g.offsetX,f="start"):"center"===s.config.yaxis[0].labels.align?(p=g.offsetX,f="middle"):"right"===s.config.yaxis[0].labels.align&&(f="end");var x=r.drawText({x:p,y:i+e+g.offsetY-u,text:n,textAnchor:f,foreColor:Array.isArray(c)?c[o]:c,fontSize:g.style.fontSize,fontFamily:g.style.fontFamily,fontWeight:g.style.fontWeight,isPlainText:!1,cssClass:"apexcharts-yaxis-label "+g.style.cssClass,maxWidth:g.maxWidth});l.add(x),x.on("click",(function(t){if("function"==typeof s.config.chart.events.xAxisLabelClick){var e=Object.assign({},s,{labelIndex:o});s.config.chart.events.xAxisLabelClick(t,a.ctx,e)}}));var b=document.createElementNS(s.globals.SVGNS,"title");if(b.textContent=Array.isArray(n)?n.join(" "):n,x.node.appendChild(b),0!==s.config.yaxis[t].labels.rotate){var v=r.rotateAroundCenter(x.node);x.node.setAttribute("transform","rotate(".concat(s.config.yaxis[t].labels.rotate," 0 ").concat(v.y,")"))}i+=e},p=0;p<=h.length-1;p++)u(p);if(void 0!==s.config.yaxis[0].title.text){var f=r.group({class:"apexcharts-yaxis-title apexcharts-xaxis-title-inversed",transform:"translate("+o+", 0)"}),x=r.drawText({x:s.config.yaxis[0].title.offsetX,y:s.globals.gridHeight/2+s.config.yaxis[0].title.offsetY,text:s.config.yaxis[0].title.text,textAnchor:"middle",foreColor:s.config.yaxis[0].title.style.color,fontSize:s.config.yaxis[0].title.style.fontSize,fontWeight:s.config.yaxis[0].title.style.fontWeight,fontFamily:s.config.yaxis[0].title.style.fontFamily,cssClass:"apexcharts-yaxis-title-text "+s.config.yaxis[0].title.style.cssClass});f.add(x),n.add(f)}var b=0;this.isCategoryBarHorizontal&&s.config.yaxis[0].opposite&&(b=s.globals.gridWidth);var v=s.config.xaxis.axisBorder;if(v.show){var y=r.drawLine(s.globals.padHorizontal+v.offsetX+b,1+v.offsetY,s.globals.padHorizontal+v.offsetX+b,s.globals.gridHeight+v.offsetY,v.color,0);this.elgrid&&this.elgrid.elGridBorders&&s.config.grid.show?this.elgrid.elGridBorders.add(y):n.add(y)}return s.config.yaxis[0].axisTicks.show&&this.axesUtils.drawYAxisTicks(b,h.length,s.config.yaxis[0].axisBorder,s.config.yaxis[0].axisTicks,0,e,n),n}},{key:"drawXaxisTicks",value:function(t,e,i){var a=this.w,s=t;if(!(t<0||t-2>a.globals.gridWidth)){var r=this.offY+a.config.xaxis.axisTicks.offsetY;if(e=e+r+a.config.xaxis.axisTicks.height,"top"===a.config.xaxis.position&&(e=r-a.config.xaxis.axisTicks.height),a.config.xaxis.axisTicks.show){var o=new m(this.ctx).drawLine(t+a.config.xaxis.axisTicks.offsetX,r+a.config.xaxis.offsetY,s+a.config.xaxis.axisTicks.offsetX,e+a.config.xaxis.offsetY,a.config.xaxis.axisTicks.color);i.add(o),o.node.classList.add("apexcharts-xaxis-tick")}}}},{key:"getXAxisTicksPositions",value:function(){var t=this.w,e=[],i=this.xaxisLabels.length,a=t.globals.padHorizontal;if(t.globals.timescaleLabels.length>0)for(var s=0;s<i;s++)a=this.xaxisLabels[s].position,e.push(a);else for(var r=i,o=0;o<r;o++){var n=r;t.globals.isXNumeric&&"bar"!==t.config.chart.type&&(n-=1),a+=t.globals.gridWidth/n,e.push(a)}return e}},{key:"xAxisLabelCorrections",value:function(){var t=this.w,e=new m(this.ctx),i=t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"),s=t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"),r=t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");if(t.globals.rotateXLabels||t.config.xaxis.labels.rotateAlways)for(var o=0;o<a.length;o++){var n=e.rotateAroundCenter(a[o]);n.y=n.y-1,n.x=n.x+1,a[o].setAttribute("transform","rotate(".concat(t.config.xaxis.labels.rotate," ").concat(n.x," ").concat(n.y,")")),a[o].setAttribute("text-anchor","end");i.setAttribute("transform","translate(0, ".concat(-10,")"));var l=a[o].childNodes;t.config.xaxis.labels.trim&&Array.prototype.forEach.call(l,(function(i){e.placeTextWithEllipsis(i,i.textContent,t.globals.xAxisLabelsHeight-("bottom"===t.config.legend.position?20:10))}))}else!function(){for(var i=t.globals.gridWidth/(t.globals.labels.length+1),s=0;s<a.length;s++){var r=a[s].childNodes;t.config.xaxis.labels.trim&&"datetime"!==t.config.xaxis.type&&Array.prototype.forEach.call(r,(function(t){e.placeTextWithEllipsis(t,t.textContent,i)}))}}();if(s.length>0){var h=s[s.length-1].getBBox(),c=s[0].getBBox();h.x<-20&&s[s.length-1].parentNode.removeChild(s[s.length-1]),c.x+c.width>t.globals.gridWidth&&!t.globals.isBarHorizontal&&s[0].parentNode.removeChild(s[0]);for(var d=0;d<r.length;d++)e.placeTextWithEllipsis(r[d],r[d].textContent,t.config.yaxis[0].labels.maxWidth-(t.config.yaxis[0].title.text?2*parseFloat(t.config.yaxis[0].title.style.fontSize):0)-15)}}}]),t}(),j=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.xaxisLabels=i.globals.labels.slice(),this.axesUtils=new C(e),this.isRangeBar=i.globals.seriesRange.length&&i.globals.isBarHorizontal,i.globals.timescaleLabels.length>0&&(this.xaxisLabels=i.globals.timescaleLabels.slice())}return r(t,[{key:"drawGridArea",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=this.w,i=new m(this.ctx);null===t&&(t=i.group({class:"apexcharts-grid"}));var a=i.drawLine(e.globals.padHorizontal,1,e.globals.padHorizontal,e.globals.gridHeight,"transparent"),s=i.drawLine(e.globals.padHorizontal,e.globals.gridHeight,e.globals.gridWidth,e.globals.gridHeight,"transparent");return t.add(s),t.add(a),t}},{key:"drawGrid",value:function(){var t=null;return this.w.globals.axisCharts&&(t=this.renderGrid(),this.drawGridArea(t.el)),t}},{key:"createGridMask",value:function(){var t=this.w,e=t.globals,i=new m(this.ctx),a=Array.isArray(t.config.stroke.width)?0:t.config.stroke.width;if(Array.isArray(t.config.stroke.width)){var s=0;t.config.stroke.width.forEach((function(t){s=Math.max(s,t)})),a=s}e.dom.elGridRectMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elGridRectMask.setAttribute("id","gridRectMask".concat(e.cuid)),e.dom.elGridRectMarkerMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elGridRectMarkerMask.setAttribute("id","gridRectMarkerMask".concat(e.cuid)),e.dom.elForecastMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elForecastMask.setAttribute("id","forecastMask".concat(e.cuid)),e.dom.elNonForecastMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elNonForecastMask.setAttribute("id","nonForecastMask".concat(e.cuid));var r=t.config.chart.type,o=0,n=0;("bar"===r||"rangeBar"===r||"candlestick"===r||"boxPlot"===r||t.globals.comboBarCount>0)&&t.globals.isXNumeric&&!t.globals.isBarHorizontal&&(o=t.config.grid.padding.left,n=t.config.grid.padding.right,e.barPadForNumericAxis>o&&(o=e.barPadForNumericAxis,n=e.barPadForNumericAxis)),e.dom.elGridRect=i.drawRect(-a/2-o-2,-a/2-2,e.gridWidth+a+n+o+4,e.gridHeight+a+4,0,"#fff");var l=t.globals.markers.largestSize+1;e.dom.elGridRectMarker=i.drawRect(2*-l,2*-l,e.gridWidth+4*l,e.gridHeight+4*l,0,"#fff"),e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node),e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);var h=e.dom.baseEl.querySelector("defs");h.appendChild(e.dom.elGridRectMask),h.appendChild(e.dom.elForecastMask),h.appendChild(e.dom.elNonForecastMask),h.appendChild(e.dom.elGridRectMarkerMask)}},{key:"_drawGridLines",value:function(t){var e=t.i,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.xCount,n=t.parent,l=this.w;if(!(0===e&&l.globals.skipFirstTimelinelabel||e===o-1&&l.globals.skipLastTimelinelabel&&!l.config.xaxis.labels.formatter||"radar"===l.config.chart.type)){l.config.grid.xaxis.lines.show&&this._drawGridLine({i:e,x1:i,y1:a,x2:s,y2:r,xCount:o,parent:n});var h=0;if(l.globals.hasXaxisGroups&&"between"===l.config.xaxis.tickPlacement){var c=l.globals.groups;if(c){for(var d=0,g=0;d<e&&g<c.length;g++)d+=c[g].cols;d===e&&(h=.6*l.globals.xAxisLabelsHeight)}}new V(this.ctx).drawXaxisTicks(i,h,l.globals.dom.elGraphical)}}},{key:"_drawGridLine",value:function(t){var e=t.i,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.xCount,n=t.parent,l=this.w,h=!1,c=n.node.classList.contains("apexcharts-gridlines-horizontal"),d=l.config.grid.strokeDashArray,g=l.globals.barPadForNumericAxis;(0===a&&0===r||0===i&&0===s)&&(h=!0),a===l.globals.gridHeight&&r===l.globals.gridHeight&&(h=!0),!l.globals.isBarHorizontal||0!==e&&e!==o-1||(h=!0);var u=new m(this).drawLine(i-(c?g:0),a,s+(c?g:0),r,l.config.grid.borderColor,d);u.node.classList.add("apexcharts-gridline"),h&&l.config.grid.show?this.elGridBorders.add(u):n.add(u)}},{key:"_drawGridBandRect",value:function(t){var e=t.c,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.type,n=this.w,l=new m(this.ctx),h=n.globals.barPadForNumericAxis;if("column"!==o||"datetime"!==n.config.xaxis.type){var c=n.config.grid[o].colors[e],d=l.drawRect(i-("row"===o?h:0),a,s+("row"===o?2*h:0),r,0,c,n.config.grid[o].opacity);this.elg.add(d),d.attr("clip-path","url(#gridRectMask".concat(n.globals.cuid,")")),d.node.classList.add("apexcharts-grid-".concat(o))}}},{key:"_drawXYLines",value:function(t){var e=this,i=t.xCount,a=t.tickAmount,s=this.w;if(s.config.grid.xaxis.lines.show||s.config.xaxis.axisTicks.show){var r,o=s.globals.padHorizontal,n=s.globals.gridHeight;s.globals.timescaleLabels.length?function(t){for(var a=t.xC,s=t.x1,r=t.y1,o=t.x2,n=t.y2,l=0;l<a;l++)s=e.xaxisLabels[l].position,o=e.xaxisLabels[l].position,e._drawGridLines({i:l,x1:s,y1:r,x2:o,y2:n,xCount:i,parent:e.elgridLinesV})}({xC:i,x1:o,y1:0,x2:r,y2:n}):(s.globals.isXNumeric&&(i=s.globals.xAxisScale.result.length),function(t){for(var a=t.xC,r=t.x1,o=t.y1,n=t.x2,l=t.y2,h=0;h<a+(s.globals.isXNumeric?0:1);h++)0===h&&1===a&&1===s.globals.dataPoints&&(n=r=s.globals.gridWidth/2),e._drawGridLines({i:h,x1:r,y1:o,x2:n,y2:l,xCount:i,parent:e.elgridLinesV}),n=r+=s.globals.gridWidth/(s.globals.isXNumeric?a-1:a)}({xC:i,x1:o,y1:0,x2:r,y2:n}))}if(s.config.grid.yaxis.lines.show){var l=0,h=0,c=s.globals.gridWidth,d=a+1;this.isRangeBar&&(d=s.globals.labels.length);for(var g=0;g<d+(this.isRangeBar?1:0);g++)this._drawGridLine({i:g,xCount:d+(this.isRangeBar?1:0),x1:0,y1:l,x2:c,y2:h,parent:this.elgridLinesH}),h=l+=s.globals.gridHeight/(this.isRangeBar?d:a)}}},{key:"_drawInvertedXYLines",value:function(t){var e=t.xCount,i=this.w;if(i.config.grid.xaxis.lines.show||i.config.xaxis.axisTicks.show)for(var a,s=i.globals.padHorizontal,r=i.globals.gridHeight,o=0;o<e+1;o++){i.config.grid.xaxis.lines.show&&this._drawGridLine({i:o,xCount:e+1,x1:s,y1:0,x2:a,y2:r,parent:this.elgridLinesV}),new V(this.ctx).drawXaxisTicks(s,0,i.globals.dom.elGraphical),a=s+=i.globals.gridWidth/e}if(i.config.grid.yaxis.lines.show)for(var n=0,l=0,h=i.globals.gridWidth,c=0;c<i.globals.dataPoints+1;c++)this._drawGridLine({i:c,xCount:i.globals.dataPoints+1,x1:0,y1:n,x2:h,y2:l,parent:this.elgridLinesH}),l=n+=i.globals.gridHeight/i.globals.dataPoints}},{key:"renderGrid",value:function(){var t=this.w,e=t.globals,i=new m(this.ctx);this.elg=i.group({class:"apexcharts-grid"}),this.elgridLinesH=i.group({class:"apexcharts-gridlines-horizontal"}),this.elgridLinesV=i.group({class:"apexcharts-gridlines-vertical"}),this.elGridBorders=i.group({class:"apexcharts-grid-borders"}),this.elg.add(this.elgridLinesH),this.elg.add(this.elgridLinesV),t.config.grid.show||(this.elgridLinesV.hide(),this.elgridLinesH.hide(),this.elGridBorders.hide());for(var a=0;a<e.seriesYAxisMap.length&&-1!==e.ignoreYAxisIndexes.indexOf(a);)a++;a===e.seriesYAxisMap.length&&(a=0);var s,r=e.yAxisScale[a].result.length-1;if(!e.isBarHorizontal||this.isRangeBar){var o,n,l;if(s=this.xaxisLabels.length,this.isRangeBar)r=e.labels.length,t.config.xaxis.tickAmount&&t.config.xaxis.labels.formatter&&(s=t.config.xaxis.tickAmount),(null===(o=e.yAxisScale)||void 0===o||null===(n=o[a])||void 0===n||null===(l=n.result)||void 0===l?void 0:l.length)>0&&"datetime"!==t.config.xaxis.type&&(s=e.yAxisScale[a].result.length-1);this._drawXYLines({xCount:s,tickAmount:r})}else s=r,r=e.xTickAmount,this._drawInvertedXYLines({xCount:s,tickAmount:r});return this.drawGridBands(s,r),{el:this.elg,elGridBorders:this.elGridBorders,xAxisTickWidth:e.gridWidth/s}}},{key:"drawGridBands",value:function(t,e){var i=this.w;if(void 0!==i.config.grid.row.colors&&i.config.grid.row.colors.length>0)for(var a=0,s=i.globals.gridHeight/e,r=i.globals.gridWidth,o=0,n=0;o<e;o++,n++)n>=i.config.grid.row.colors.length&&(n=0),this._drawGridBandRect({c:n,x1:0,y1:a,x2:r,y2:s,type:"row"}),a+=i.globals.gridHeight/e;if(void 0!==i.config.grid.column.colors&&i.config.grid.column.colors.length>0)for(var l=i.globals.isBarHorizontal||"on"!==i.config.xaxis.tickPlacement||"category"!==i.config.xaxis.type&&!i.config.xaxis.convertedCatToNumeric?t:t-1,h=i.globals.padHorizontal,c=i.globals.padHorizontal+i.globals.gridWidth/l,d=i.globals.gridHeight,g=0,u=0;g<t;g++,u++)u>=i.config.grid.column.colors.length&&(u=0),this._drawGridBandRect({c:u,x1:h,y1:0,x2:c,y2:d,type:"column"}),h+=i.globals.gridWidth/l}}]),t}(),_=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"niceScale",value:function(t,e){var i,a,s,r,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,n=1e-11,l=this.w,h=l.globals;h.isBarHorizontal?(i=l.config.xaxis,a=Math.max((h.svgWidth-100)/25,2)):(i=l.config.yaxis[o],a=Math.max((h.svgHeight-100)/15,2)),s=void 0!==i.min&&null!==i.min,r=void 0!==i.max&&null!==i.min;var c=void 0!==i.stepSize&&null!==i.stepSize,d=void 0!==i.tickAmount&&null!==i.tickAmount,g=d?i.tickAmount:i.forceNiceScale?h.niceScaleDefaultTicks[Math.min(Math.round(a/2),h.niceScaleDefaultTicks.length-1)]:10;if(h.isMultipleYAxis&&!d&&h.multiAxisTickAmount>0&&(g=h.multiAxisTickAmount,d=!0),g="dataPoints"===g?h.dataPoints-1:Math.abs(Math.round(g)),(t===Number.MIN_VALUE&&0===e||!x.isNumber(t)&&!x.isNumber(e)||t===Number.MIN_VALUE&&e===-Number.MAX_VALUE)&&(t=x.isNumber(i.min)?i.min:0,e=x.isNumber(i.max)?i.max:t+g,h.allSeriesCollapsed=!1),t>e){console.warn("axis.min cannot be greater than axis.max: swapping min and max");var u=e;e=t,t=u}else t===e&&(t=0===t?0:t-1,e=0===e?2:e+1);var p=[];g<1&&(g=1);var f=g,b=Math.abs(e-t);if(i.forceNiceScale){!s&&t>0&&t/b<.15&&(t=0,s=!0),!r&&e<0&&-e/b<.15&&(e=0,r=!0),b=Math.abs(e-t)}var v=b/f,m=v,y=Math.floor(Math.log10(m)),w=Math.pow(10,y),k=Math.ceil(m/w);if(v=m=(k=h.niceScaleAllowedMagMsd[0===h.yValueDecimal?0:1][k])*w,h.isBarHorizontal&&i.stepSize&&"datetime"!==i.type?(v=i.stepSize,c=!0):c&&(v=i.stepSize),c&&i.forceNiceScale){var A=Math.floor(Math.log10(v));v*=Math.pow(10,y-A)}if(s&&r){var S=b/f;if(d)if(c)if(0!=x.mod(b,v)){var C=x.getGCD(v,S);v=S/C<10?C:S}else 0==x.mod(v,S)?v=S:(S=v,d=!1);else v=S;else if(c)0==x.mod(b,v)?S=v:v=S;else if(0==x.mod(b,v))S=v;else{S=b/(f=Math.ceil(b/v));var L=x.getGCD(b,v);b/L<a&&(S=L),v=S}f=Math.round(b/v)}else{if(s||r){if(r)if(d)t=e-v*f;else{var P=t;t=v*Math.floor(t/v),Math.abs(e-t)/x.getGCD(b,v)>a&&(t=e-v*g,t+=v*Math.floor((P-t)/v))}else if(s)if(d)e=t+v*f;else{var M=e;e=v*Math.ceil(e/v),Math.abs(e-t)/x.getGCD(b,v)>a&&(e=t+v*g,e+=v*Math.ceil((M-e)/v))}}else if(d){var I=v/(e-t>e?1:2),T=I*Math.floor(t/I);Math.abs(T-t)<=I/2?e=(t=T)+v*f:t=(e=I*Math.ceil(e/I))-v*f}else t=v*Math.floor(t/v),e=v*Math.ceil(e/v);b=Math.abs(e-t),v=x.getGCD(b,v),f=Math.round(b/v)}if(d||s||r||(f=Math.ceil((b-n)/(v+n)))>16&&x.getPrimeFactors(f).length<2&&f++,!d&&i.forceNiceScale&&0===h.yValueDecimal&&f>b&&(f=b,v=Math.round(b/f)),f>a&&(!d&&!c||i.forceNiceScale)){var z=x.getPrimeFactors(f),X=z.length-1,E=f;t:for(var Y=0;Y<X;Y++)for(var F=0;F<=X-Y;F++){for(var R=Math.min(F+Y,X),H=E,D=1,O=F;O<=R;O++)D*=z[O];if((H/=D)<a){E=H;break t}}v=E===f?b:b/E,f=Math.round(b/v)}h.isMultipleYAxis&&0==h.multiAxisTickAmount&&h.ignoreYAxisIndexes.indexOf(o)<0&&(h.multiAxisTickAmount=f);var N=t-v,W=v*n;do{N+=v,p.push(x.stripNumber(N,7))}while(e-N>W);return{result:p,niceMin:p[0],niceMax:p[p.length-1]}}},{key:"linearScale",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:void 0,r=Math.abs(e-t);"dataPoints"===(i=this._adjustTicksForSmallRange(i,a,r))&&(i=this.w.globals.dataPoints-1),s||(s=r/i),i===Number.MAX_VALUE&&(i=5,s=1);for(var o=[],n=t;i>=0;)o.push(n),n+=s,i-=1;return{result:o,niceMin:o[0],niceMax:o[o.length-1]}}},{key:"logarithmicScaleNice",value:function(t,e,i){e<=0&&(e=Math.max(t,i)),t<=0&&(t=Math.min(e,i));for(var a=[],s=Math.ceil(Math.log(e)/Math.log(i)+1),r=Math.floor(Math.log(t)/Math.log(i));r<s;r++)a.push(Math.pow(i,r));return{result:a,niceMin:a[0],niceMax:a[a.length-1]}}},{key:"logarithmicScale",value:function(t,e,i){e<=0&&(e=Math.max(t,i)),t<=0&&(t=Math.min(e,i));for(var a=[],s=Math.log(e)/Math.log(i),r=Math.log(t)/Math.log(i),o=s-r,n=Math.round(o),l=o/n,h=0,c=r;h<n;h++,c+=l)a.push(Math.pow(i,c));return a.push(Math.pow(i,s)),{result:a,niceMin:t,niceMax:e}}},{key:"_adjustTicksForSmallRange",value:function(t,e,i){var a=t;if(void 0!==e&&this.w.config.yaxis[e].labels.formatter&&void 0===this.w.config.yaxis[e].tickAmount){var s=Number(this.w.config.yaxis[e].labels.formatter(1));x.isNumber(s)&&0===this.w.globals.yValueDecimal&&(a=Math.ceil(i))}return a<t?a:t}},{key:"setYScaleForIndex",value:function(t,e,i){var a=this.w.globals,s=this.w.config,r=a.isBarHorizontal?s.xaxis:s.yaxis[t];void 0===a.yAxisScale[t]&&(a.yAxisScale[t]=[]);var o=Math.abs(i-e);r.logarithmic&&o<=5&&(a.invalidLogScale=!0),r.logarithmic&&o>5?(a.allSeriesCollapsed=!1,a.yAxisScale[t]=r.forceNiceScale?this.logarithmicScaleNice(e,i,r.logBase):this.logarithmicScale(e,i,r.logBase)):i!==-Number.MAX_VALUE&&x.isNumber(i)&&e!==Number.MAX_VALUE&&x.isNumber(e)?(a.allSeriesCollapsed=!1,a.yAxisScale[t]=this.niceScale(e,i,t)):a.yAxisScale[t]=this.niceScale(Number.MIN_VALUE,0,t)}},{key:"setXScale",value:function(t,e){var i=this.w,a=i.globals,s=Math.abs(e-t);return e!==-Number.MAX_VALUE&&x.isNumber(e)?a.xAxisScale=this.linearScale(t,e,i.config.xaxis.tickAmount?i.config.xaxis.tickAmount:s<10&&s>1?s+1:10,0,i.config.xaxis.stepSize):a.xAxisScale=this.linearScale(0,10,10),a.xAxisScale}},{key:"setSeriesYAxisMappings",value:function(){var t=this.w.globals,e=this.w.config;t.minYArr,t.maxYArr;var i=[],a=[],s=[],r=t.series.length>e.yaxis.length||e.yaxis.some((function(t){return Array.isArray(t.seriesName)}));e.series.forEach((function(t,e){s.push(e),a.push(null)})),e.yaxis.forEach((function(t,e){i[e]=[]}));var o=[];e.yaxis.forEach((function(t,a){var n=!1;if(t.seriesName){var l=[];Array.isArray(t.seriesName)?l=t.seriesName:l.push(t.seriesName),l.forEach((function(t){e.series.forEach((function(e,o){if(e.name===t){var l=o;a===o||r?!r||s.indexOf(o)>-1?i[a].push([a,o]):console.warn("Series '"+e.name+"' referenced more than once in what looks like the new style. That is, when using either seriesName: [], or when there are more series than yaxes."):(i[o].push([o,a]),l=a),n=!0,-1!==(l=s.indexOf(l))&&s.splice(l,1)}}))}))}n||o.push(a)})),i=i.map((function(t,e){var i=[];return t.forEach((function(t){a[t[1]]=t[0],i.push(t[1])})),i}));for(var n=e.yaxis.length-1,l=0;l<o.length&&(n=o[l],i[n]=[],s);l++){var h=s[0];s.shift(),i[n].push(h),a[h]=n}s.forEach((function(t){i[n].push(t),a[t]=n})),t.seriesYAxisMap=i.map((function(t){return t})),t.seriesYAxisReverseMap=a.map((function(t){return t}))}},{key:"scaleMultipleYAxes",value:function(){var t=this,e=this.w.config,i=this.w.globals;this.setSeriesYAxisMappings();var a=i.seriesYAxisMap,s=i.minYArr,r=i.maxYArr;i.allSeriesCollapsed=!0,i.barGroups=[],a.forEach((function(a,o){var n=[];a.forEach((function(t){var i=e.series[t].group;n.indexOf(i)<0&&n.push(i)})),a.length>0?function(){var l,h,c=Number.MAX_VALUE,d=-Number.MAX_VALUE,g=c,u=d;if(e.chart.stacked)!function(){var t=i.seriesX[a[0]],s=[],r=[],p=[];n.forEach((function(){s.push(t.map((function(){return Number.MIN_VALUE}))),r.push(t.map((function(){return Number.MIN_VALUE}))),p.push(t.map((function(){return Number.MIN_VALUE})))}));for(var f=function(t){!l&&e.series[a[t]].type&&(l=e.series[a[t]].type);var c=a[t];h=e.series[c].group?e.series[c].group:"axis-".concat(o),!(i.collapsedSeriesIndices.indexOf(c)<0&&i.ancillaryCollapsedSeriesIndices.indexOf(c)<0)||(i.allSeriesCollapsed=!1,n.forEach((function(t,a){if(e.series[c].group===t)for(var o=0;o<i.series[c].length;o++){var n=i.series[c][o];n>=0?r[a][o]+=n:p[a][o]+=n,s[a][o]+=n,g=Math.min(g,n),u=Math.max(u,n)}}))),"bar"!==l&&"column"!==l||i.barGroups.push(h)},x=0;x<a.length;x++)f(x);l||(l=e.chart.type),"bar"===l||"column"===l?n.forEach((function(t,e){c=Math.min(c,Math.min.apply(null,p[e])),d=Math.max(d,Math.max.apply(null,r[e]))})):(n.forEach((function(t,e){g=Math.min(g,Math.min.apply(null,s[e])),u=Math.max(u,Math.max.apply(null,s[e]))})),c=g,d=u),c===Number.MIN_VALUE&&d===Number.MIN_VALUE&&(d=-Number.MAX_VALUE)}();else for(var p=0;p<a.length;p++){var f=a[p];c=Math.min(c,s[f]),d=Math.max(d,r[f]),!(i.collapsedSeriesIndices.indexOf(f)<0&&i.ancillaryCollapsedSeriesIndices.indexOf(f)<0)||(i.allSeriesCollapsed=!1)}void 0!==e.yaxis[o].min&&(c="function"==typeof e.yaxis[o].min?e.yaxis[o].min(c):e.yaxis[o].min),void 0!==e.yaxis[o].max&&(d="function"==typeof e.yaxis[o].max?e.yaxis[o].max(d):e.yaxis[o].max),i.barGroups=i.barGroups.filter((function(t,e,i){return i.indexOf(t)===e})),t.setYScaleForIndex(o,c,d),a.forEach((function(t){s[t]=i.yAxisScale[o].niceMin,r[t]=i.yAxisScale[o].niceMax}))}():t.setYScaleForIndex(o,0,-Number.MAX_VALUE)}))}}]),t}(),U=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.scales=new _(e)}return r(t,[{key:"init",value:function(){this.setYRange(),this.setXRange(),this.setZRange()}},{key:"getMinYMaxY",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:-Number.MAX_VALUE,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,s=this.w.config,r=this.w.globals,o=-Number.MAX_VALUE,n=Number.MIN_VALUE;null===a&&(a=t+1);var l=0,h=0,c=void 0;if(r.seriesX.length>=a){var d,g;l=0,h=(c=u(new Set((d=[]).concat.apply(d,u(r.seriesX.slice(t,a)))))).length-1;var p=null===(g=r.brushSource)||void 0===g?void 0:g.w.config.chart.brush;if(s.chart.zoom.enabled&&s.chart.zoom.autoScaleYaxis||null!=p&&p.enabled&&null!=p&&p.autoScaleYaxis){if(s.xaxis.min)for(l=0;l<h&&c[l]<s.xaxis.min;l++);if(s.xaxis.max)for(;h>l&&c[h]>s.xaxis.max;h--);}}var f=r.series,b=f,v=f;"candlestick"===s.chart.type?(b=r.seriesCandleL,v=r.seriesCandleH):"boxPlot"===s.chart.type?(b=r.seriesCandleO,v=r.seriesCandleC):r.isRangeData&&(b=r.seriesRangeStart,v=r.seriesRangeEnd);for(var m=t;m<a;m++){r.dataPoints=Math.max(r.dataPoints,f[m].length);var y=s.series[m].type;r.categoryLabels.length&&(r.dataPoints=r.categoryLabels.filter((function(t){return void 0!==t})).length),r.labels.length&&"datetime"!==s.xaxis.type&&0!==r.series.reduce((function(t,e){return t+e.length}),0)&&(r.dataPoints=Math.max(r.dataPoints,r.labels.length)),c||(l=0,h=r.series[m].length);for(var w=l;w<=h&&w<r.series[m].length;w++){var k=f[m][w];if(null!==k&&x.isNumber(k)){switch(void 0!==v[m][w]&&(o=Math.max(o,v[m][w]),e=Math.min(e,v[m][w])),void 0!==b[m][w]&&(e=Math.min(e,b[m][w]),i=Math.max(i,b[m][w])),y){case"candlestick":void 0!==r.seriesCandleC[m][w]&&(o=Math.max(o,r.seriesCandleH[m][w]),e=Math.min(e,r.seriesCandleL[m][w]));break;case"boxPlot":void 0!==r.seriesCandleC[m][w]&&(o=Math.max(o,r.seriesCandleC[m][w]),e=Math.min(e,r.seriesCandleO[m][w]))}y&&"candlestick"!==y&&"boxPlot"!==y&&"rangeArea"!==y&&"rangeBar"!==y&&(o=Math.max(o,r.series[m][w]),e=Math.min(e,r.series[m][w])),i=o,r.seriesGoals[m]&&r.seriesGoals[m][w]&&Array.isArray(r.seriesGoals[m][w])&&r.seriesGoals[m][w].forEach((function(t){n!==Number.MIN_VALUE&&(n=Math.min(n,t.value),e=n),o=Math.max(o,t.value),i=o})),x.isFloat(k)&&(k=x.noExponents(k),r.yValueDecimal=Math.max(r.yValueDecimal,k.toString().split(".")[1].length)),n>b[m][w]&&b[m][w]<0&&(n=b[m][w])}else r.hasNullValues=!0}"bar"!==y&&"column"!==y||(n<0&&o<0&&(o=0,i=Math.max(i,0)),n===Number.MIN_VALUE&&(n=0,e=Math.min(e,0)))}return"rangeBar"===s.chart.type&&r.seriesRangeStart.length&&r.isBarHorizontal&&(n=e),"bar"===s.chart.type&&(n<0&&o<0&&(o=0),n===Number.MIN_VALUE&&(n=0)),{minY:n,maxY:o,lowestY:e,highestY:i}}},{key:"setYRange",value:function(){var t=this.w.globals,e=this.w.config;t.maxY=-Number.MAX_VALUE,t.minY=Number.MIN_VALUE;var i,a=Number.MAX_VALUE;if(t.isMultipleYAxis){a=Number.MAX_VALUE;for(var s=0;s<t.series.length;s++)i=this.getMinYMaxY(s),t.minYArr[s]=i.lowestY,t.maxYArr[s]=i.highestY,a=Math.min(a,i.lowestY)}if(i=this.getMinYMaxY(0,a,null,t.series.length),"bar"===e.chart.type?(t.minY=i.minY,t.maxY=i.maxY):(t.minY=i.lowestY,t.maxY=i.highestY),a=i.lowestY,e.chart.stacked&&this._setStackedMinMax(),"line"===e.chart.type||"area"===e.chart.type||"scatter"===e.chart.type||"candlestick"===e.chart.type||"boxPlot"===e.chart.type||"rangeBar"===e.chart.type&&!t.isBarHorizontal?t.minY===Number.MIN_VALUE&&a!==-Number.MAX_VALUE&&a!==t.maxY&&(t.minY=a):t.minY=i.minY,e.yaxis.forEach((function(e,i){void 0!==e.max&&("number"==typeof e.max?t.maxYArr[i]=e.max:"function"==typeof e.max&&(t.maxYArr[i]=e.max(t.isMultipleYAxis?t.maxYArr[i]:t.maxY)),t.maxY=t.maxYArr[i]),void 0!==e.min&&("number"==typeof e.min?t.minYArr[i]=e.min:"function"==typeof e.min&&(t.minYArr[i]=e.min(t.isMultipleYAxis?t.minYArr[i]===Number.MIN_VALUE?0:t.minYArr[i]:t.minY)),t.minY=t.minYArr[i])})),t.isBarHorizontal){["min","max"].forEach((function(i){void 0!==e.xaxis[i]&&"number"==typeof e.xaxis[i]&&("min"===i?t.minY=e.xaxis[i]:t.maxY=e.xaxis[i])}))}return t.isMultipleYAxis?(this.scales.scaleMultipleYAxes(),t.minY=a):(this.scales.setYScaleForIndex(0,t.minY,t.maxY),t.minY=t.yAxisScale[0].niceMin,t.maxY=t.yAxisScale[0].niceMax,t.minYArr[0]=t.minY,t.maxYArr[0]=t.maxY),t.barGroups=[],t.lineGroups=[],t.areaGroups=[],e.series.forEach((function(i){switch(i.type||e.chart.type){case"bar":case"column":t.barGroups.push(i.group);break;case"line":t.lineGroups.push(i.group);break;case"area":t.areaGroups.push(i.group)}})),t.barGroups=t.barGroups.filter((function(t,e,i){return i.indexOf(t)===e})),t.lineGroups=t.lineGroups.filter((function(t,e,i){return i.indexOf(t)===e})),t.areaGroups=t.areaGroups.filter((function(t,e,i){return i.indexOf(t)===e})),{minY:t.minY,maxY:t.maxY,minYArr:t.minYArr,maxYArr:t.maxYArr,yAxisScale:t.yAxisScale}}},{key:"setXRange",value:function(){var t=this.w.globals,e=this.w.config,i="numeric"===e.xaxis.type||"datetime"===e.xaxis.type||"category"===e.xaxis.type&&!t.noLabelsProvided||t.noLabelsProvided||t.isXNumeric;if(t.isXNumeric&&function(){for(var e=0;e<t.series.length;e++)if(t.labels[e])for(var i=0;i<t.labels[e].length;i++)null!==t.labels[e][i]&&x.isNumber(t.labels[e][i])&&(t.maxX=Math.max(t.maxX,t.labels[e][i]),t.initialMaxX=Math.max(t.maxX,t.labels[e][i]),t.minX=Math.min(t.minX,t.labels[e][i]),t.initialMinX=Math.min(t.minX,t.labels[e][i]))}(),t.noLabelsProvided&&0===e.xaxis.categories.length&&(t.maxX=t.labels[t.labels.length-1],t.initialMaxX=t.labels[t.labels.length-1],t.minX=1,t.initialMinX=1),t.isXNumeric||t.noLabelsProvided||t.dataFormatXNumeric){var a;if(void 0===e.xaxis.tickAmount?(a=Math.round(t.svgWidth/150),"numeric"===e.xaxis.type&&t.dataPoints<30&&(a=t.dataPoints-1),a>t.dataPoints&&0!==t.dataPoints&&(a=t.dataPoints-1)):"dataPoints"===e.xaxis.tickAmount?(t.series.length>1&&(a=t.series[t.maxValsInArrayIndex].length-1),t.isXNumeric&&(a=t.maxX-t.minX-1)):a=e.xaxis.tickAmount,t.xTickAmount=a,void 0!==e.xaxis.max&&"number"==typeof e.xaxis.max&&(t.maxX=e.xaxis.max),void 0!==e.xaxis.min&&"number"==typeof e.xaxis.min&&(t.minX=e.xaxis.min),void 0!==e.xaxis.range&&(t.minX=t.maxX-e.xaxis.range),t.minX!==Number.MAX_VALUE&&t.maxX!==-Number.MAX_VALUE)if(e.xaxis.convertedCatToNumeric&&!t.dataFormatXNumeric){for(var s=[],r=t.minX-1;r<t.maxX;r++)s.push(r+1);t.xAxisScale={result:s,niceMin:s[0],niceMax:s[s.length-1]}}else t.xAxisScale=this.scales.setXScale(t.minX,t.maxX);else t.xAxisScale=this.scales.linearScale(0,a,a,0,e.xaxis.stepSize),t.noLabelsProvided&&t.labels.length>0&&(t.xAxisScale=this.scales.linearScale(1,t.labels.length,a-1,0,e.xaxis.stepSize),t.seriesX=t.labels.slice());i&&(t.labels=t.xAxisScale.result.slice())}return t.isBarHorizontal&&t.labels.length&&(t.xTickAmount=t.labels.length),this._handleSingleDataPoint(),this._getMinXDiff(),{minX:t.minX,maxX:t.maxX}}},{key:"setZRange",value:function(){var t=this.w.globals;if(t.isDataXYZ)for(var e=0;e<t.series.length;e++)if(void 0!==t.seriesZ[e])for(var i=0;i<t.seriesZ[e].length;i++)null!==t.seriesZ[e][i]&&x.isNumber(t.seriesZ[e][i])&&(t.maxZ=Math.max(t.maxZ,t.seriesZ[e][i]),t.minZ=Math.min(t.minZ,t.seriesZ[e][i]))}},{key:"_handleSingleDataPoint",value:function(){var t=this.w.globals,e=this.w.config;if(t.minX===t.maxX){var i=new A(this.ctx);if("datetime"===e.xaxis.type){var a=i.getDate(t.minX);e.xaxis.labels.datetimeUTC?a.setUTCDate(a.getUTCDate()-2):a.setDate(a.getDate()-2),t.minX=new Date(a).getTime();var s=i.getDate(t.maxX);e.xaxis.labels.datetimeUTC?s.setUTCDate(s.getUTCDate()+2):s.setDate(s.getDate()+2),t.maxX=new Date(s).getTime()}else("numeric"===e.xaxis.type||"category"===e.xaxis.type&&!t.noLabelsProvided)&&(t.minX=t.minX-2,t.initialMinX=t.minX,t.maxX=t.maxX+2,t.initialMaxX=t.maxX)}}},{key:"_getMinXDiff",value:function(){var t=this.w.globals;t.isXNumeric&&t.seriesX.forEach((function(e,i){1===e.length&&e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length-1]);var a=e.slice();a.sort((function(t,e){return t-e})),a.forEach((function(e,i){if(i>0){var s=e-a[i-1];s>0&&(t.minXDiff=Math.min(s,t.minXDiff))}})),1!==t.dataPoints&&t.minXDiff!==Number.MAX_VALUE||(t.minXDiff=.5)}))}},{key:"_setStackedMinMax",value:function(){var t=this,e=this.w.globals;if(e.series.length){var i=e.seriesGroups;i.length||(i=[this.w.globals.seriesNames.map((function(t){return t}))]);var a={},s={};i.forEach((function(i){a[i]=[],s[i]=[],t.w.config.series.map((function(t,a){return i.indexOf(e.seriesNames[a])>-1?a:null})).filter((function(t){return null!==t})).forEach((function(r){for(var o=0;o<e.series[e.maxValsInArrayIndex].length;o++){var n,l,h,c;void 0===a[i][o]&&(a[i][o]=0,s[i][o]=0),(t.w.config.chart.stacked&&!e.comboCharts||t.w.config.chart.stacked&&e.comboCharts&&(!t.w.config.chart.stackOnlyBar||"bar"===(null===(n=t.w.config.series)||void 0===n||null===(l=n[r])||void 0===l?void 0:l.type)||"column"===(null===(h=t.w.config.series)||void 0===h||null===(c=h[r])||void 0===c?void 0:c.type)))&&null!==e.series[r][o]&&x.isNumber(e.series[r][o])&&(e.series[r][o]>0?a[i][o]+=parseFloat(e.series[r][o])+1e-4:s[i][o]+=parseFloat(e.series[r][o]))}}))})),Object.entries(a).forEach((function(t){var i=g(t,1)[0];a[i].forEach((function(t,r){e.maxY=Math.max(e.maxY,a[i][r]),e.minY=Math.min(e.minY,s[i][r])}))}))}}}]),t}(),q=function(){function t(e,i){a(this,t),this.ctx=e,this.elgrid=i,this.w=e.w;var s=this.w;this.xaxisFontSize=s.config.xaxis.labels.style.fontSize,this.axisFontFamily=s.config.xaxis.labels.style.fontFamily,this.xaxisForeColors=s.config.xaxis.labels.style.colors,this.isCategoryBarHorizontal="bar"===s.config.chart.type&&s.config.plotOptions.bar.horizontal,this.xAxisoffX=0,"bottom"===s.config.xaxis.position&&(this.xAxisoffX=s.globals.gridHeight),this.drawnLabels=[],this.axesUtils=new C(e)}return r(t,[{key:"drawYaxis",value:function(t){var e=this,i=this.w,a=new m(this.ctx),s=i.config.yaxis[t].labels.style,r=s.fontSize,o=s.fontFamily,n=s.fontWeight,l=a.group({class:"apexcharts-yaxis",rel:t,transform:"translate("+i.globals.translateYAxisX[t]+", 0)"});if(this.axesUtils.isYAxisHidden(t))return l;var h=a.group({class:"apexcharts-yaxis-texts-g"});l.add(h);var c=i.globals.yAxisScale[t].result.length-1,d=i.globals.gridHeight/c,g=i.globals.yLabelFormatters[t],u=i.globals.yAxisScale[t].result.slice();u=this.axesUtils.checkForReversedLabels(t,u);var p="";if(i.config.yaxis[t].labels.show){var f=i.globals.translateY+i.config.yaxis[t].labels.offsetY;i.globals.isBarHorizontal?f=0:"heatmap"===i.config.chart.type&&(f-=d/2),f+=parseInt(i.config.yaxis[t].labels.style.fontSize,10)/3;for(var x=function(l){var x=u[l];x=g(x,l,i);var b=i.config.yaxis[t].labels.padding;i.config.yaxis[t].opposite&&0!==i.config.yaxis.length&&(b*=-1);var v="end";i.config.yaxis[t].opposite&&(v="start"),"left"===i.config.yaxis[t].labels.align?v="start":"center"===i.config.yaxis[t].labels.align?v="middle":"right"===i.config.yaxis[t].labels.align&&(v="end");var m=e.axesUtils.getYAxisForeColor(s.colors,t),y=a.drawText({x:b,y:f,text:x,textAnchor:v,fontSize:r,fontFamily:o,fontWeight:n,maxWidth:i.config.yaxis[t].labels.maxWidth,foreColor:Array.isArray(m)?m[l]:m,isPlainText:!1,cssClass:"apexcharts-yaxis-label "+s.cssClass});l===c&&(p=y),h.add(y);var w=document.createElementNS(i.globals.SVGNS,"title");if(w.textContent=Array.isArray(x)?x.join(" "):x,y.node.appendChild(w),0!==i.config.yaxis[t].labels.rotate){var k=a.rotateAroundCenter(p.node),A=a.rotateAroundCenter(y.node);y.node.setAttribute("transform","rotate(".concat(i.config.yaxis[t].labels.rotate," ").concat(k.x," ").concat(A.y,")"))}f+=d},b=c;b>=0;b--)x(b)}if(void 0!==i.config.yaxis[t].title.text){var v=a.group({class:"apexcharts-yaxis-title"}),y=0;i.config.yaxis[t].opposite&&(y=i.globals.translateYAxisX[t]);var w=a.drawText({x:y,y:i.globals.gridHeight/2+i.globals.translateY+i.config.yaxis[t].title.offsetY,text:i.config.yaxis[t].title.text,textAnchor:"end",foreColor:i.config.yaxis[t].title.style.color,fontSize:i.config.yaxis[t].title.style.fontSize,fontWeight:i.config.yaxis[t].title.style.fontWeight,fontFamily:i.config.yaxis[t].title.style.fontFamily,cssClass:"apexcharts-yaxis-title-text "+i.config.yaxis[t].title.style.cssClass});v.add(w),l.add(v)}var k=i.config.yaxis[t].axisBorder,A=31+k.offsetX;if(i.config.yaxis[t].opposite&&(A=-31-k.offsetX),k.show){var S=a.drawLine(A,i.globals.translateY+k.offsetY-2,A,i.globals.gridHeight+i.globals.translateY+k.offsetY+2,k.color,0,k.width);l.add(S)}return i.config.yaxis[t].axisTicks.show&&this.axesUtils.drawYAxisTicks(A,c,k,i.config.yaxis[t].axisTicks,t,d,l),l}},{key:"drawYaxisInversed",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-xaxis apexcharts-yaxis-inversed"}),s=i.group({class:"apexcharts-xaxis-texts-g",transform:"translate(".concat(e.globals.translateXAxisX,", ").concat(e.globals.translateXAxisY,")")});a.add(s);var r=e.globals.yAxisScale[t].result.length-1,o=e.globals.gridWidth/r+.1,n=o+e.config.xaxis.labels.offsetX,l=e.globals.xLabelFormatter,h=e.globals.yAxisScale[t].result.slice(),c=e.globals.timescaleLabels;c.length>0&&(this.xaxisLabels=c.slice(),r=(h=c.slice()).length),h=this.axesUtils.checkForReversedLabels(t,h);var d=c.length;if(e.config.xaxis.labels.show)for(var g=d?0:r;d?g<d:g>=0;d?g++:g--){var u=h[g];u=l(u,g,e);var p=e.globals.gridWidth+e.globals.padHorizontal-(n-o+e.config.xaxis.labels.offsetX);if(c.length){var f=this.axesUtils.getLabel(h,c,p,g,this.drawnLabels,this.xaxisFontSize);p=f.x,u=f.text,this.drawnLabels.push(f.text),0===g&&e.globals.skipFirstTimelinelabel&&(u=""),g===h.length-1&&e.globals.skipLastTimelinelabel&&(u="")}var x=i.drawText({x:p,y:this.xAxisoffX+e.config.xaxis.labels.offsetY+30-("top"===e.config.xaxis.position?e.globals.xAxisHeight+e.config.xaxis.axisTicks.height-2:0),text:u,textAnchor:"middle",foreColor:Array.isArray(this.xaxisForeColors)?this.xaxisForeColors[t]:this.xaxisForeColors,fontSize:this.xaxisFontSize,fontFamily:this.xaxisFontFamily,fontWeight:e.config.xaxis.labels.style.fontWeight,isPlainText:!1,cssClass:"apexcharts-xaxis-label "+e.config.xaxis.labels.style.cssClass});s.add(x),x.tspan(u);var b=document.createElementNS(e.globals.SVGNS,"title");b.textContent=u,x.node.appendChild(b),n+=o}return this.inversedYAxisTitleText(a),this.inversedYAxisBorder(a),a}},{key:"inversedYAxisBorder",value:function(t){var e=this.w,i=new m(this.ctx),a=e.config.xaxis.axisBorder;if(a.show){var s=0;"bar"===e.config.chart.type&&e.globals.isXNumeric&&(s-=15);var r=i.drawLine(e.globals.padHorizontal+s+a.offsetX,this.xAxisoffX,e.globals.gridWidth,this.xAxisoffX,a.color,0,a.height);this.elgrid&&this.elgrid.elGridBorders&&e.config.grid.show?this.elgrid.elGridBorders.add(r):t.add(r)}}},{key:"inversedYAxisTitleText",value:function(t){var e=this.w,i=new m(this.ctx);if(void 0!==e.config.xaxis.title.text){var a=i.group({class:"apexcharts-xaxis-title apexcharts-yaxis-title-inversed"}),s=i.drawText({x:e.globals.gridWidth/2+e.config.xaxis.title.offsetX,y:this.xAxisoffX+parseFloat(this.xaxisFontSize)+parseFloat(e.config.xaxis.title.style.fontSize)+e.config.xaxis.title.offsetY+20,text:e.config.xaxis.title.text,textAnchor:"middle",fontSize:e.config.xaxis.title.style.fontSize,fontFamily:e.config.xaxis.title.style.fontFamily,fontWeight:e.config.xaxis.title.style.fontWeight,foreColor:e.config.xaxis.title.style.color,cssClass:"apexcharts-xaxis-title-text "+e.config.xaxis.title.style.cssClass});a.add(s),t.add(a)}}},{key:"yAxisTitleRotate",value:function(t,e){var i=this.w,a=new m(this.ctx),s={width:0,height:0},r={width:0,height:0},o=i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-texts-g"));null!==o&&(s=o.getBoundingClientRect());var n=i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-title text"));if(null!==n&&(r=n.getBoundingClientRect()),null!==n){var l=this.xPaddingForYAxisTitle(t,s,r,e);n.setAttribute("x",l.xPos-(e?10:0))}if(null!==n){var h=a.rotateAroundCenter(n);n.setAttribute("transform","rotate(".concat(e?-1*i.config.yaxis[t].title.rotate:i.config.yaxis[t].title.rotate," ").concat(h.x," ").concat(h.y,")"))}}},{key:"xPaddingForYAxisTitle",value:function(t,e,i,a){var s=this.w,r=0,o=0,n=10;return void 0===s.config.yaxis[t].title.text||t<0?{xPos:o,padd:0}:(a?(o=e.width+s.config.yaxis[t].title.offsetX+i.width/2+n/2,0===(r+=1)&&(o-=n/2)):(o=-1*e.width+s.config.yaxis[t].title.offsetX+n/2+i.width/2,s.globals.isBarHorizontal&&(n=25,o=-1*e.width-s.config.yaxis[t].title.offsetX-n)),{xPos:o,padd:n})}},{key:"setYAxisXPosition",value:function(t,e){var i=this.w,a=0,s=0,r=18,o=1;i.config.yaxis.length>1&&(this.multipleYs=!0),i.config.yaxis.map((function(n,l){var h=i.globals.ignoreYAxisIndexes.indexOf(l)>-1||!n.show||n.floating||0===t[l].width,c=t[l].width+e[l].width;n.opposite?i.globals.isBarHorizontal?(s=i.globals.gridWidth+i.globals.translateX-1,i.globals.translateYAxisX[l]=s-n.labels.offsetX):(s=i.globals.gridWidth+i.globals.translateX+o,h||(o=o+c+20),i.globals.translateYAxisX[l]=s-n.labels.offsetX+20):(a=i.globals.translateX-r,h||(r=r+c+20),i.globals.translateYAxisX[l]=a+n.labels.offsetX)}))}},{key:"setYAxisTextAlignments",value:function(){var t=this.w,e=t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");(e=x.listToArray(e)).forEach((function(e,i){var a=t.config.yaxis[i];if(a&&!a.floating&&void 0!==a.labels.align){var s=t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i,"'] .apexcharts-yaxis-texts-g")),r=t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i,"'] .apexcharts-yaxis-label"));r=x.listToArray(r);var o=s.getBoundingClientRect();"left"===a.labels.align?(r.forEach((function(t,e){t.setAttribute("text-anchor","start")})),a.opposite||s.setAttribute("transform","translate(-".concat(o.width,", 0)"))):"center"===a.labels.align?(r.forEach((function(t,e){t.setAttribute("text-anchor","middle")})),s.setAttribute("transform","translate(".concat(o.width/2*(a.opposite?1:-1),", 0)"))):"right"===a.labels.align&&(r.forEach((function(t,e){t.setAttribute("text-anchor","end")})),a.opposite&&s.setAttribute("transform","translate(".concat(o.width,", 0)")))}}))}}]),t}(),Z=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.documentEvent=x.bind(this.documentEvent,this)}return r(t,[{key:"addEventListener",value:function(t,e){var i=this.w;i.globals.events.hasOwnProperty(t)?i.globals.events[t].push(e):i.globals.events[t]=[e]}},{key:"removeEventListener",value:function(t,e){var i=this.w;if(i.globals.events.hasOwnProperty(t)){var a=i.globals.events[t].indexOf(e);-1!==a&&i.globals.events[t].splice(a,1)}}},{key:"fireEvent",value:function(t,e){var i=this.w;if(i.globals.events.hasOwnProperty(t)){e&&e.length||(e=[]);for(var a=i.globals.events[t],s=a.length,r=0;r<s;r++)a[r].apply(null,e)}}},{key:"setupEventHandlers",value:function(){var t=this,e=this.w,i=this.ctx,a=e.globals.dom.baseEl.querySelector(e.globals.chartClass);this.ctx.eventList.forEach((function(t){a.addEventListener(t,(function(t){var a=Object.assign({},e,{seriesIndex:e.globals.axisCharts?e.globals.capturedSeriesIndex:0,dataPointIndex:e.globals.capturedDataPointIndex});"mousemove"===t.type||"touchmove"===t.type?"function"==typeof e.config.chart.events.mouseMove&&e.config.chart.events.mouseMove(t,i,a):"mouseleave"===t.type||"touchleave"===t.type?"function"==typeof e.config.chart.events.mouseLeave&&e.config.chart.events.mouseLeave(t,i,a):("mouseup"===t.type&&1===t.which||"touchend"===t.type)&&("function"==typeof e.config.chart.events.click&&e.config.chart.events.click(t,i,a),i.ctx.events.fireEvent("click",[t,i,a]))}),{capture:!1,passive:!0})})),this.ctx.eventList.forEach((function(i){e.globals.dom.baseEl.addEventListener(i,t.documentEvent,{passive:!0})})),this.ctx.core.setupBrushHandler()}},{key:"documentEvent",value:function(t){var e=this.w,i=t.target.className;if("click"===t.type){var a=e.globals.dom.baseEl.querySelector(".apexcharts-menu");a&&a.classList.contains("apexcharts-menu-open")&&"apexcharts-menu-icon"!==i&&a.classList.remove("apexcharts-menu-open")}e.globals.clientX="touchmove"===t.type?t.touches[0].clientX:t.clientX,e.globals.clientY="touchmove"===t.type?t.touches[0].clientY:t.clientY}}]),t}(),$=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"setCurrentLocaleValues",value:function(t){var e=this.w.config.chart.locales;window.Apex.chart&&window.Apex.chart.locales&&window.Apex.chart.locales.length>0&&(e=this.w.config.chart.locales.concat(window.Apex.chart.locales));var i=e.filter((function(e){return e.name===t}))[0];if(!i)throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");var a=x.extend(M,i);this.w.globals.locale=a.options}}]),t}(),J=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawAxis",value:function(t,e){var i,a,s=this,r=this.w.globals,o=this.w.config,n=new V(this.ctx,e),l=new q(this.ctx,e);r.axisCharts&&"radar"!==t&&(r.isBarHorizontal?(a=l.drawYaxisInversed(0),i=n.drawXaxisInversed(0),r.dom.elGraphical.add(i),r.dom.elGraphical.add(a)):(i=n.drawXaxis(),r.dom.elGraphical.add(i),o.yaxis.map((function(t,e){if(-1===r.ignoreYAxisIndexes.indexOf(e)&&(a=l.drawYaxis(e),r.dom.Paper.add(a),"back"===s.w.config.grid.position)){var i=r.dom.Paper.children()[1];i.remove(),r.dom.Paper.add(i)}}))))}}]),t}(),Q=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawXCrosshairs",value:function(){var t=this.w,e=new m(this.ctx),i=new v(this.ctx),a=t.config.xaxis.crosshairs.fill.gradient,s=t.config.xaxis.crosshairs.dropShadow,r=t.config.xaxis.crosshairs.fill.type,o=a.colorFrom,n=a.colorTo,l=a.opacityFrom,h=a.opacityTo,c=a.stops,d=s.enabled,g=s.left,u=s.top,p=s.blur,f=s.color,b=s.opacity,y=t.config.xaxis.crosshairs.fill.color;if(t.config.xaxis.crosshairs.show){"gradient"===r&&(y=e.drawGradient("vertical",o,n,l,h,null,c,null));var w=e.drawRect();1===t.config.xaxis.crosshairs.width&&(w=e.drawLine());var k=t.globals.gridHeight;(!x.isNumber(k)||k<0)&&(k=0);var A=t.config.xaxis.crosshairs.width;(!x.isNumber(A)||A<0)&&(A=0),w.attr({class:"apexcharts-xcrosshairs",x:0,y:0,y2:k,width:A,height:k,fill:y,filter:"none","fill-opacity":t.config.xaxis.crosshairs.opacity,stroke:t.config.xaxis.crosshairs.stroke.color,"stroke-width":t.config.xaxis.crosshairs.stroke.width,"stroke-dasharray":t.config.xaxis.crosshairs.stroke.dashArray}),d&&(w=i.dropShadow(w,{left:g,top:u,blur:p,color:f,opacity:b})),t.globals.dom.elGraphical.add(w)}}},{key:"drawYCrosshairs",value:function(){var t=this.w,e=new m(this.ctx),i=t.config.yaxis[0].crosshairs,a=t.globals.barPadForNumericAxis;if(t.config.yaxis[0].crosshairs.show){var s=e.drawLine(-a,0,t.globals.gridWidth+a,0,i.stroke.color,i.stroke.dashArray,i.stroke.width);s.attr({class:"apexcharts-ycrosshairs"}),t.globals.dom.elGraphical.add(s)}var r=e.drawLine(-a,0,t.globals.gridWidth+a,0,i.stroke.color,0,0);r.attr({class:"apexcharts-ycrosshairs-hidden"}),t.globals.dom.elGraphical.add(r)}}]),t}(),K=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"checkResponsiveConfig",value:function(t){var e=this,i=this.w,a=i.config;if(0!==a.responsive.length){var s=a.responsive.slice();s.sort((function(t,e){return t.breakpoint>e.breakpoint?1:e.breakpoint>t.breakpoint?-1:0})).reverse();var r=new Y({}),o=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},a=s[0].breakpoint,o=window.innerWidth>0?window.innerWidth:screen.width;if(o>a){var n=x.clone(i.globals.initialConfig);n.series=x.clone(i.config.series);var l=y.extendArrayProps(r,n,i);t=x.extend(l,t),t=x.extend(i.config,t),e.overrideResponsiveOptions(t)}else for(var h=0;h<s.length;h++)if(o<s[h].breakpoint){var c=y.extendArrayProps(r,s[h].options,i);t=x.extend(c,t),t=x.extend(i.config,t),e.overrideResponsiveOptions(t)}};if(t){var n=y.extendArrayProps(r,t,i);n=x.extend(i.config,n),o(n=x.extend(n,t))}else o({})}}},{key:"overrideResponsiveOptions",value:function(t){var e=new Y(t).init({responsiveOverride:!0});this.w.config=e}}]),t}(),tt=function(){function t(e){a(this,t),this.ctx=e,this.colors=[],this.w=e.w;var i=this.w;this.isColorFn=!1,this.isHeatmapDistributed="treemap"===i.config.chart.type&&i.config.plotOptions.treemap.distributed||"heatmap"===i.config.chart.type&&i.config.plotOptions.heatmap.distributed,this.isBarDistributed=i.config.plotOptions.bar.distributed&&("bar"===i.config.chart.type||"rangeBar"===i.config.chart.type)}return r(t,[{key:"init",value:function(){this.setDefaultColors()}},{key:"setDefaultColors",value:function(){var t,e=this,i=this.w,a=new x;if(i.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(i.config.theme.mode)),void 0===i.config.colors||0===(null===(t=i.config.colors)||void 0===t?void 0:t.length)?i.globals.colors=this.predefined():(i.globals.colors=i.config.colors,Array.isArray(i.config.colors)&&i.config.colors.length>0&&"function"==typeof i.config.colors[0]&&(i.globals.colors=i.config.series.map((function(t,a){var s=i.config.colors[a];return s||(s=i.config.colors[0]),"function"==typeof s?(e.isColorFn=!0,s({value:i.globals.axisCharts?i.globals.series[a][0]?i.globals.series[a][0]:0:i.globals.series[a],seriesIndex:a,dataPointIndex:a,w:i})):s})))),i.globals.seriesColors.map((function(t,e){t&&(i.globals.colors[e]=t)})),i.config.theme.monochrome.enabled){var s=[],r=i.globals.series.length;(this.isBarDistributed||this.isHeatmapDistributed)&&(r=i.globals.series[0].length*i.globals.series.length);for(var o=i.config.theme.monochrome.color,n=1/(r/i.config.theme.monochrome.shadeIntensity),l=i.config.theme.monochrome.shadeTo,h=0,c=0;c<r;c++){var d=void 0;"dark"===l?(d=a.shadeColor(-1*h,o),h+=n):(d=a.shadeColor(h,o),h+=n),s.push(d)}i.globals.colors=s.slice()}var g=i.globals.colors.slice();this.pushExtraColors(i.globals.colors);["fill","stroke"].forEach((function(t){void 0===i.config[t].colors?i.globals[t].colors=e.isColorFn?i.config.colors:g:i.globals[t].colors=i.config[t].colors.slice(),e.pushExtraColors(i.globals[t].colors)})),void 0===i.config.dataLabels.style.colors?i.globals.dataLabels.style.colors=g:i.globals.dataLabels.style.colors=i.config.dataLabels.style.colors.slice(),this.pushExtraColors(i.globals.dataLabels.style.colors,50),void 0===i.config.plotOptions.radar.polygons.fill.colors?i.globals.radarPolygons.fill.colors=["dark"===i.config.theme.mode?"#424242":"none"]:i.globals.radarPolygons.fill.colors=i.config.plotOptions.radar.polygons.fill.colors.slice(),this.pushExtraColors(i.globals.radarPolygons.fill.colors,20),void 0===i.config.markers.colors?i.globals.markers.colors=g:i.globals.markers.colors=i.config.markers.colors.slice(),this.pushExtraColors(i.globals.markers.colors)}},{key:"pushExtraColors",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=this.w,s=e||a.globals.series.length;if(null===i&&(i=this.isBarDistributed||this.isHeatmapDistributed||"heatmap"===a.config.chart.type&&a.config.plotOptions.heatmap.colorScale.inverse),i&&a.globals.series.length&&(s=a.globals.series[a.globals.maxValsInArrayIndex].length*a.globals.series.length),t.length<s)for(var r=s-t.length,o=0;o<r;o++)t.push(t[o])}},{key:"updateThemeOptions",value:function(t){t.chart=t.chart||{},t.tooltip=t.tooltip||{};var e=t.theme.mode||"light",i=t.theme.palette?t.theme.palette:"dark"===e?"palette4":"palette1",a=t.chart.foreColor?t.chart.foreColor:"dark"===e?"#f6f7f8":"#373d3f";return t.tooltip.theme=e,t.chart.foreColor=a,t.theme.palette=i,t}},{key:"predefined",value:function(){switch(this.w.config.theme.palette){case"palette1":default:this.colors=["#008FFB","#00E396","#FEB019","#FF4560","#775DD0"];break;case"palette2":this.colors=["#3f51b5","#03a9f4","#4caf50","#f9ce1d","#FF9800"];break;case"palette3":this.colors=["#33b2df","#546E7A","#d4526e","#13d8aa","#A5978B"];break;case"palette4":this.colors=["#4ecdc4","#c7f464","#81D4FA","#fd6a6a","#546E7A"];break;case"palette5":this.colors=["#2b908f","#f9a3a4","#90ee7e","#fa4443","#69d2e7"];break;case"palette6":this.colors=["#449DD1","#F86624","#EA3546","#662E9B","#C5D86D"];break;case"palette7":this.colors=["#D7263D","#1B998B","#2E294E","#F46036","#E2C044"];break;case"palette8":this.colors=["#662E9B","#F86624","#F9C80E","#EA3546","#43BCCD"];break;case"palette9":this.colors=["#5C4742","#A5978B","#8D5B4C","#5A2A27","#C4BBAF"];break;case"palette10":this.colors=["#A300D6","#7D02EB","#5653FE","#2983FF","#00B1F2"]}return this.colors}}]),t}(),et=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"draw",value:function(){this.drawTitleSubtitle("title"),this.drawTitleSubtitle("subtitle")}},{key:"drawTitleSubtitle",value:function(t){var e=this.w,i="title"===t?e.config.title:e.config.subtitle,a=e.globals.svgWidth/2,s=i.offsetY,r="middle";if("left"===i.align?(a=10,r="start"):"right"===i.align&&(a=e.globals.svgWidth-10,r="end"),a+=i.offsetX,s=s+parseInt(i.style.fontSize,10)+i.margin/2,void 0!==i.text){var o=new m(this.ctx).drawText({x:a,y:s,text:i.text,textAnchor:r,fontSize:i.style.fontSize,fontFamily:i.style.fontFamily,fontWeight:i.style.fontWeight,foreColor:i.style.color,opacity:1});o.node.setAttribute("class","apexcharts-".concat(t,"-text")),e.globals.dom.Paper.add(o)}}}]),t}(),it=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"getTitleSubtitleCoords",value:function(t){var e=this.w,i=0,a=0,s="title"===t?e.config.title.floating:e.config.subtitle.floating,r=e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t,"-text"));if(null!==r&&!s){var o=r.getBoundingClientRect();i=o.width,a=e.globals.axisCharts?o.height+5:o.height}return{width:i,height:a}}},{key:"getLegendsRect",value:function(){var t=this.w,e=t.globals.dom.elLegendWrap;t.config.legend.height||"top"!==t.config.legend.position&&"bottom"!==t.config.legend.position||(e.style.maxHeight=t.globals.svgHeight/2+"px");var i=Object.assign({},x.getBoundingClientRect(e));return null!==e&&!t.config.legend.floating&&t.config.legend.show?this.dCtx.lgRect={x:i.x,y:i.y,height:i.height,width:0===i.height?0:i.width}:this.dCtx.lgRect={x:0,y:0,height:0,width:0},"left"!==t.config.legend.position&&"right"!==t.config.legend.position||1.5*this.dCtx.lgRect.width>t.globals.svgWidth&&(this.dCtx.lgRect.width=t.globals.svgWidth/1.5),this.dCtx.lgRect}},{key:"getDatalabelsRect",value:function(){var t=this,e=this.w,i=[];e.config.series.forEach((function(s,r){s.data.forEach((function(s,o){var n;n=e.globals.series[r][o],a=e.config.dataLabels.formatter(n,{ctx:t.dCtx.ctx,seriesIndex:r,dataPointIndex:o,w:e}),i.push(a)}))}));var a=x.getLargestStringFromArr(i),s=new m(this.dCtx.ctx),r=e.config.dataLabels.style,o=s.getTextRects(a,parseInt(r.fontSize),r.fontFamily);return{width:1.05*o.width,height:o.height}}},{key:"getLargestStringFromMultiArr",value:function(t,e){var i=t;if(this.w.globals.isMultiLineX){var a=e.map((function(t,e){return Array.isArray(t)?t.length:1})),s=Math.max.apply(Math,u(a));i=e[a.indexOf(s)]}return i}}]),t}(),at=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"getxAxisLabelsCoords",value:function(){var t,e=this.w,i=e.globals.labels.slice();if(e.config.xaxis.convertedCatToNumeric&&0===i.length&&(i=e.globals.categoryLabels),e.globals.timescaleLabels.length>0){var a=this.getxAxisTimeScaleLabelsCoords();t={width:a.width,height:a.height},e.globals.rotateXLabels=!1}else{this.dCtx.lgWidthForSideLegends="left"!==e.config.legend.position&&"right"!==e.config.legend.position||e.config.legend.floating?0:this.dCtx.lgRect.width;var s=e.globals.xLabelFormatter,r=x.getLargestStringFromArr(i),o=this.dCtx.dimHelpers.getLargestStringFromMultiArr(r,i);e.globals.isBarHorizontal&&(o=r=e.globals.yAxisScale[0].result.reduce((function(t,e){return t.length>e.length?t:e}),0));var n=new S(this.dCtx.ctx),l=r;r=n.xLabelFormat(s,r,l,{i:void 0,dateFormatter:new A(this.dCtx.ctx).formatDate,w:e}),o=n.xLabelFormat(s,o,l,{i:void 0,dateFormatter:new A(this.dCtx.ctx).formatDate,w:e}),(e.config.xaxis.convertedCatToNumeric&&void 0===r||""===String(r).trim())&&(o=r="1");var h=new m(this.dCtx.ctx),c=h.getTextRects(r,e.config.xaxis.labels.style.fontSize),d=c;if(r!==o&&(d=h.getTextRects(o,e.config.xaxis.labels.style.fontSize)),(t={width:c.width>=d.width?c.width:d.width,height:c.height>=d.height?c.height:d.height}).width*i.length>e.globals.svgWidth-this.dCtx.lgWidthForSideLegends-this.dCtx.yAxisWidth-this.dCtx.gridPad.left-this.dCtx.gridPad.right&&0!==e.config.xaxis.labels.rotate||e.config.xaxis.labels.rotateAlways){if(!e.globals.isBarHorizontal){e.globals.rotateXLabels=!0;var g=function(t){return h.getTextRects(t,e.config.xaxis.labels.style.fontSize,e.config.xaxis.labels.style.fontFamily,"rotate(".concat(e.config.xaxis.labels.rotate," 0 0)"),!1)};c=g(r),r!==o&&(d=g(o)),t.height=(c.height>d.height?c.height:d.height)/1.5,t.width=c.width>d.width?c.width:d.width}}else e.globals.rotateXLabels=!1}return e.config.xaxis.labels.show||(t={width:0,height:0}),{width:t.width,height:t.height}}},{key:"getxAxisGroupLabelsCoords",value:function(){var t,e=this.w;if(!e.globals.hasXaxisGroups)return{width:0,height:0};var i,a=(null===(t=e.config.xaxis.group.style)||void 0===t?void 0:t.fontSize)||e.config.xaxis.labels.style.fontSize,s=e.globals.groups.map((function(t){return t.title})),r=x.getLargestStringFromArr(s),o=this.dCtx.dimHelpers.getLargestStringFromMultiArr(r,s),n=new m(this.dCtx.ctx),l=n.getTextRects(r,a),h=l;return r!==o&&(h=n.getTextRects(o,a)),i={width:l.width>=h.width?l.width:h.width,height:l.height>=h.height?l.height:h.height},e.config.xaxis.labels.show||(i={width:0,height:0}),{width:i.width,height:i.height}}},{key:"getxAxisTitleCoords",value:function(){var t=this.w,e=0,i=0;if(void 0!==t.config.xaxis.title.text){var a=new m(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text,t.config.xaxis.title.style.fontSize);e=a.width,i=a.height}return{width:e,height:i}}},{key:"getxAxisTimeScaleLabelsCoords",value:function(){var t,e=this.w;this.dCtx.timescaleLabels=e.globals.timescaleLabels.slice();var i=this.dCtx.timescaleLabels.map((function(t){return t.value})),a=i.reduce((function(t,e){return void 0===t?(console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"),0):t.length>e.length?t:e}),0);return 1.05*(t=new m(this.dCtx.ctx).getTextRects(a,e.config.xaxis.labels.style.fontSize)).width*i.length>e.globals.gridWidth&&0!==e.config.xaxis.labels.rotate&&(e.globals.overlappingXLabels=!0),t}},{key:"additionalPaddingXLabels",value:function(t){var e=this,i=this.w,a=i.globals,s=i.config,r=s.xaxis.type,o=t.width;a.skipLastTimelinelabel=!1,a.skipFirstTimelinelabel=!1;var n=i.config.yaxis[0].opposite&&i.globals.isBarHorizontal,l=function(t,n){s.yaxis.length>1&&function(t){return-1!==a.collapsedSeriesIndices.indexOf(t)}(n)||function(t){if(e.dCtx.timescaleLabels&&e.dCtx.timescaleLabels.length){var n=e.dCtx.timescaleLabels[0],l=e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length-1].position+o/1.75-e.dCtx.yAxisWidthRight,h=n.position-o/1.75+e.dCtx.yAxisWidthLeft,c="right"===i.config.legend.position&&e.dCtx.lgRect.width>0?e.dCtx.lgRect.width:0;l>a.svgWidth-a.translateX-c&&(a.skipLastTimelinelabel=!0),h<-(t.show&&!t.floating||"bar"!==s.chart.type&&"candlestick"!==s.chart.type&&"rangeBar"!==s.chart.type&&"boxPlot"!==s.chart.type?10:o/1.75)&&(a.skipFirstTimelinelabel=!0)}else"datetime"===r?e.dCtx.gridPad.right<o&&!a.rotateXLabels&&(a.skipLastTimelinelabel=!0):"datetime"!==r&&e.dCtx.gridPad.right<o/2-e.dCtx.yAxisWidthRight&&!a.rotateXLabels&&!i.config.xaxis.labels.trim&&("between"!==i.config.xaxis.tickPlacement||i.globals.isBarHorizontal)&&(e.dCtx.xPadRight=o/2+1)}(t)};s.yaxis.forEach((function(t,i){n?(e.dCtx.gridPad.left<o&&(e.dCtx.xPadLeft=o/2+1),e.dCtx.xPadRight=o/2+1):l(t,i)}))}}]),t}(),st=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"getyAxisLabelsCoords",value:function(){var t=this,e=this.w,i=[],a=10,s=new C(this.dCtx.ctx);return e.config.yaxis.map((function(r,o){var n={seriesIndex:o,dataPointIndex:-1,w:e},l=e.globals.yAxisScale[o],h=0;if(!s.isYAxisHidden(o)&&r.labels.show&&void 0!==r.labels.minWidth&&(h=r.labels.minWidth),!s.isYAxisHidden(o)&&r.labels.show&&l.result.length){var c=e.globals.yLabelFormatters[o],d=l.niceMin===Number.MIN_VALUE?0:l.niceMin,g=l.result.reduce((function(t,e){var i,a;return(null===(i=String(c(t,n)))||void 0===i?void 0:i.length)>(null===(a=String(c(e,n)))||void 0===a?void 0:a.length)?t:e}),d),u=g=c(g,n);if(void 0!==g&&0!==g.length||(g=l.niceMax),e.globals.isBarHorizontal){a=0;var p=e.globals.labels.slice();g=x.getLargestStringFromArr(p),g=c(g,{seriesIndex:o,dataPointIndex:-1,w:e}),u=t.dCtx.dimHelpers.getLargestStringFromMultiArr(g,p)}var f=new m(t.dCtx.ctx),b="rotate(".concat(r.labels.rotate," 0 0)"),v=f.getTextRects(g,r.labels.style.fontSize,r.labels.style.fontFamily,b,!1),y=v;g!==u&&(y=f.getTextRects(u,r.labels.style.fontSize,r.labels.style.fontFamily,b,!1)),i.push({width:(h>y.width||h>v.width?h:y.width>v.width?y.width:v.width)+a,height:y.height>v.height?y.height:v.height})}else i.push({width:0,height:0})})),i}},{key:"getyAxisTitleCoords",value:function(){var t=this,e=this.w,i=[];return e.config.yaxis.map((function(e,a){if(e.show&&void 0!==e.title.text){var s=new m(t.dCtx.ctx),r="rotate(".concat(e.title.rotate," 0 0)"),o=s.getTextRects(e.title.text,e.title.style.fontSize,e.title.style.fontFamily,r,!1);i.push({width:o.width,height:o.height})}else i.push({width:0,height:0})})),i}},{key:"getTotalYAxisWidth",value:function(){var t=this.w,e=0,i=0,a=0,s=t.globals.yAxisScale.length>1?10:0,r=new C(this.dCtx.ctx),o=function(o,n){var l=t.config.yaxis[n].floating,h=0;o.width>0&&!l?(h=o.width+s,function(e){return t.globals.ignoreYAxisIndexes.indexOf(e)>-1}(n)&&(h=h-o.width-s)):h=l||r.isYAxisHidden(n)?0:5,t.config.yaxis[n].opposite?a+=h:i+=h,e+=h};return t.globals.yLabelsCoords.map((function(t,e){o(t,e)})),t.globals.yTitleCoords.map((function(t,e){o(t,e)})),t.globals.isBarHorizontal&&!t.config.yaxis[0].floating&&(e=t.globals.yLabelsCoords[0].width+t.globals.yTitleCoords[0].width+15),this.dCtx.yAxisWidthLeft=i,this.dCtx.yAxisWidthRight=a,e}}]),t}(),rt=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"gridPadForColumnsInNumericAxis",value:function(t){var e=this.w,i=e.config,a=e.globals;if(a.noData||a.collapsedSeries.length+a.ancillaryCollapsedSeries.length===i.series.length)return 0;var s=function(t){return"bar"===t||"rangeBar"===t||"candlestick"===t||"boxPlot"===t},r=i.chart.type,o=0,n=s(r)?i.series.length:1;if(a.comboBarCount>0&&(n=a.comboBarCount),a.collapsedSeries.forEach((function(t){s(t.type)&&(n-=1)})),i.chart.stacked&&(n=1),(s(r)||a.comboBarCount>0)&&a.isXNumeric&&!a.isBarHorizontal&&n>0){var l,h,c=Math.abs(a.initialMaxX-a.initialMinX);c<=3&&(c=a.dataPoints),l=c/t,a.minXDiff&&a.minXDiff/l>0&&(h=a.minXDiff/l),h>t/2&&(h/=2),(o=h*parseInt(i.plotOptions.bar.columnWidth,10)/100)<1&&(o=1),a.barPadForNumericAxis=o}return o}},{key:"gridPadFortitleSubtitle",value:function(){var t=this,e=this.w,i=e.globals,a=this.dCtx.isSparkline||!e.globals.axisCharts?0:10;["title","subtitle"].forEach((function(i){void 0!==e.config[i].text?a+=e.config[i].margin:a+=t.dCtx.isSparkline||!e.globals.axisCharts?0:5})),!e.config.legend.show||"bottom"!==e.config.legend.position||e.config.legend.floating||e.globals.axisCharts||(a+=10);var s=this.dCtx.dimHelpers.getTitleSubtitleCoords("title"),r=this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");i.gridHeight=i.gridHeight-s.height-r.height-a,i.translateY=i.translateY+s.height+r.height+a}},{key:"setGridXPosForDualYAxis",value:function(t,e){var i=this.w,a=new C(this.dCtx.ctx);i.config.yaxis.map((function(s,r){-1!==i.globals.ignoreYAxisIndexes.indexOf(r)||s.floating||a.isYAxisHidden(r)||(s.opposite&&(i.globals.translateX=i.globals.translateX-(e[r].width+t[r].width)-parseInt(i.config.yaxis[r].labels.style.fontSize,10)/1.2-12),i.globals.translateX<2&&(i.globals.translateX=2))}))}}]),t}(),ot=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.lgRect={},this.yAxisWidth=0,this.yAxisWidthLeft=0,this.yAxisWidthRight=0,this.xAxisHeight=0,this.isSparkline=this.w.config.chart.sparkline.enabled,this.dimHelpers=new it(this),this.dimYAxis=new st(this),this.dimXAxis=new at(this),this.dimGrid=new rt(this),this.lgWidthForSideLegends=0,this.gridPad=this.w.config.grid.padding,this.xPadRight=0,this.xPadLeft=0}return r(t,[{key:"plotCoords",value:function(){var t=this,e=this.w,i=e.globals;this.lgRect=this.dimHelpers.getLegendsRect(),this.datalabelsCoords={width:0,height:0};var a=Array.isArray(e.config.stroke.width)?Math.max.apply(Math,u(e.config.stroke.width)):e.config.stroke.width;this.isSparkline&&((e.config.markers.discrete.length>0||e.config.markers.size>0)&&Object.entries(this.gridPad).forEach((function(e){var i=g(e,2),a=i[0],s=i[1];t.gridPad[a]=Math.max(s,t.w.globals.markers.largestSize/1.5)})),this.gridPad.top=Math.max(a/2,this.gridPad.top),this.gridPad.bottom=Math.max(a/2,this.gridPad.bottom)),i.axisCharts?this.setDimensionsForAxisCharts():this.setDimensionsForNonAxisCharts(),this.dimGrid.gridPadFortitleSubtitle(),i.gridHeight=i.gridHeight-this.gridPad.top-this.gridPad.bottom,i.gridWidth=i.gridWidth-this.gridPad.left-this.gridPad.right-this.xPadRight-this.xPadLeft;var s=this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);i.gridWidth=i.gridWidth-2*s,i.translateX=i.translateX+this.gridPad.left+this.xPadLeft+(s>0?s:0),i.translateY=i.translateY+this.gridPad.top}},{key:"setDimensionsForAxisCharts",value:function(){var t=this,e=this.w,i=e.globals,a=this.dimYAxis.getyAxisLabelsCoords(),s=this.dimYAxis.getyAxisTitleCoords();i.isSlopeChart&&(this.datalabelsCoords=this.dimHelpers.getDatalabelsRect()),e.globals.yLabelsCoords=[],e.globals.yTitleCoords=[],e.config.yaxis.map((function(t,i){e.globals.yLabelsCoords.push({width:a[i].width,index:i}),e.globals.yTitleCoords.push({width:s[i].width,index:i})})),this.yAxisWidth=this.dimYAxis.getTotalYAxisWidth();var r=this.dimXAxis.getxAxisLabelsCoords(),o=this.dimXAxis.getxAxisGroupLabelsCoords(),n=this.dimXAxis.getxAxisTitleCoords();this.conditionalChecksForAxisCoords(r,n,o),i.translateXAxisY=e.globals.rotateXLabels?this.xAxisHeight/8:-4,i.translateXAxisX=e.globals.rotateXLabels&&e.globals.isXNumeric&&e.config.xaxis.labels.rotate<=-45?-this.xAxisWidth/4:0,e.globals.isBarHorizontal&&(i.rotateXLabels=!1,i.translateXAxisY=parseInt(e.config.xaxis.labels.style.fontSize,10)/1.5*-1),i.translateXAxisY=i.translateXAxisY+e.config.xaxis.labels.offsetY,i.translateXAxisX=i.translateXAxisX+e.config.xaxis.labels.offsetX;var l=this.yAxisWidth,h=this.xAxisHeight;i.xAxisLabelsHeight=this.xAxisHeight-n.height,i.xAxisGroupLabelsHeight=i.xAxisLabelsHeight-r.height,i.xAxisLabelsWidth=this.xAxisWidth,i.xAxisHeight=this.xAxisHeight;var c=10;("radar"===e.config.chart.type||this.isSparkline)&&(l=0,h=i.goldenPadding),this.isSparkline&&(this.lgRect={height:0,width:0}),(this.isSparkline||"treemap"===e.config.chart.type)&&(l=0,h=0,c=0),this.isSparkline||this.dimXAxis.additionalPaddingXLabels(r);var d=function(){i.translateX=l+t.datalabelsCoords.width,i.gridHeight=i.svgHeight-t.lgRect.height-h-(t.isSparkline||"treemap"===e.config.chart.type?0:e.globals.rotateXLabels?10:15),i.gridWidth=i.svgWidth-l-2*t.datalabelsCoords.width};switch("top"===e.config.xaxis.position&&(c=i.xAxisHeight-e.config.xaxis.axisTicks.height-5),e.config.legend.position){case"bottom":i.translateY=c,d();break;case"top":i.translateY=this.lgRect.height+c,d();break;case"left":i.translateY=c,i.translateX=this.lgRect.width+l+this.datalabelsCoords.width,i.gridHeight=i.svgHeight-h-12,i.gridWidth=i.svgWidth-this.lgRect.width-l-2*this.datalabelsCoords.width;break;case"right":i.translateY=c,i.translateX=l+this.datalabelsCoords.width,i.gridHeight=i.svgHeight-h-12,i.gridWidth=i.svgWidth-this.lgRect.width-l-2*this.datalabelsCoords.width-5;break;default:throw new Error("Legend position not supported")}this.dimGrid.setGridXPosForDualYAxis(s,a),new q(this.ctx).setYAxisXPosition(a,s)}},{key:"setDimensionsForNonAxisCharts",value:function(){var t=this.w,e=t.globals,i=t.config,a=0;t.config.legend.show&&!t.config.legend.floating&&(a=20);var s="pie"===i.chart.type||"polarArea"===i.chart.type||"donut"===i.chart.type?"pie":"radialBar",r=i.plotOptions[s].offsetY,o=i.plotOptions[s].offsetX;if(!i.legend.show||i.legend.floating)return e.gridHeight=e.svgHeight-i.grid.padding.left+i.grid.padding.right,e.gridWidth=Math.min(e.svgWidth,e.gridHeight),e.translateY=r,void(e.translateX=o+(e.svgWidth-e.gridWidth)/2);switch(i.legend.position){case"bottom":e.gridHeight=e.svgHeight-this.lgRect.height-e.goldenPadding,e.gridWidth=e.svgWidth,e.translateY=r-10,e.translateX=o+(e.svgWidth-e.gridWidth)/2;break;case"top":e.gridHeight=e.svgHeight-this.lgRect.height-e.goldenPadding,e.gridWidth=e.svgWidth,e.translateY=this.lgRect.height+r+10,e.translateX=o+(e.svgWidth-e.gridWidth)/2;break;case"left":e.gridWidth=e.svgWidth-this.lgRect.width-a,e.gridHeight="auto"!==i.chart.height?e.svgHeight:e.gridWidth,e.translateY=r,e.translateX=o+this.lgRect.width+a;break;case"right":e.gridWidth=e.svgWidth-this.lgRect.width-a-5,e.gridHeight="auto"!==i.chart.height?e.svgHeight:e.gridWidth,e.translateY=r,e.translateX=o+10;break;default:throw new Error("Legend position not supported")}}},{key:"conditionalChecksForAxisCoords",value:function(t,e,i){var a=this.w,s=a.globals.hasXaxisGroups?2:1,r=i.height+t.height+e.height,o=a.globals.isMultiLineX?1.2:a.globals.LINE_HEIGHT_RATIO,n=a.globals.rotateXLabels?22:10,l=a.globals.rotateXLabels&&"bottom"===a.config.legend.position?10:0;this.xAxisHeight=r*o+s*n+l,this.xAxisWidth=t.width,this.xAxisHeight-e.height>a.config.xaxis.labels.maxHeight&&(this.xAxisHeight=a.config.xaxis.labels.maxHeight),a.config.xaxis.labels.minHeight&&this.xAxisHeight<a.config.xaxis.labels.minHeight&&(this.xAxisHeight=a.config.xaxis.labels.minHeight),a.config.xaxis.floating&&(this.xAxisHeight=0);var h=0,c=0;a.config.yaxis.forEach((function(t){h+=t.labels.minWidth,c+=t.labels.maxWidth})),this.yAxisWidth<h&&(this.yAxisWidth=h),this.yAxisWidth>c&&(this.yAxisWidth=c)}}]),t}(),nt=function(){function t(e){a(this,t),this.w=e.w,this.lgCtx=e}return r(t,[{key:"getLegendStyles",value:function(){var t,e,i,a=document.createElement("style");a.setAttribute("type","text/css");var s=(null===(t=this.lgCtx.ctx)||void 0===t||null===(e=t.opts)||void 0===e||null===(i=e.chart)||void 0===i?void 0:i.nonce)||this.w.config.chart.nonce;s&&a.setAttribute("nonce",s);var r=document.createTextNode("\n      .apexcharts-legend {\n        display: flex;\n        overflow: auto;\n        padding: 0 10px;\n      }\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\n        flex-wrap: wrap\n      }\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        flex-direction: column;\n        bottom: 0;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        justify-content: flex-start;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\n        justify-content: center;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\n        justify-content: flex-end;\n      }\n      .apexcharts-legend-series {\n        cursor: pointer;\n        line-height: normal;\n      }\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{\n        display: flex;\n        align-items: center;\n      }\n      .apexcharts-legend-text {\n        position: relative;\n        font-size: 14px;\n      }\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\n        pointer-events: none;\n      }\n      .apexcharts-legend-marker {\n        position: relative;\n        display: inline-block;\n        cursor: pointer;\n        margin-right: 3px;\n        border-style: solid;\n      }\n\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\n        display: inline-block;\n      }\n      .apexcharts-legend-series.apexcharts-no-click {\n        cursor: auto;\n      }\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\n        display: none !important;\n      }\n      .apexcharts-inactive-legend {\n        opacity: 0.45;\n      }");return a.appendChild(r),a}},{key:"getLegendBBox",value:function(){var t=this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(),e=t.width;return{clwh:t.height,clww:e}}},{key:"appendToForeignObject",value:function(){this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles())}},{key:"toggleDataSeries",value:function(t,e){var i=this,a=this.w;if(a.globals.axisCharts||"radialBar"===a.config.chart.type){a.globals.resized=!0;var s=null,r=null;if(a.globals.risingSeries=[],a.globals.axisCharts?(s=a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t,"']")),r=parseInt(s.getAttribute("data:realIndex"),10)):(s=a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t+1,"']")),r=parseInt(s.getAttribute("rel"),10)-1),e)[{cs:a.globals.collapsedSeries,csi:a.globals.collapsedSeriesIndices},{cs:a.globals.ancillaryCollapsedSeries,csi:a.globals.ancillaryCollapsedSeriesIndices}].forEach((function(t){i.riseCollapsedSeries(t.cs,t.csi,r)}));else this.hideSeries({seriesEl:s,realIndex:r})}else{var o=a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t+1,"'] path")),n=a.config.chart.type;if("pie"===n||"polarArea"===n||"donut"===n){var l=a.config.plotOptions.pie.donut.labels;new m(this.lgCtx.ctx).pathMouseDown(o.members[0],null),this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node,l)}o.fire("click")}}},{key:"hideSeries",value:function(t){var e=t.seriesEl,i=t.realIndex,a=this.w,s=a.globals,r=x.clone(a.config.series);if(s.axisCharts){var o=a.config.yaxis[s.seriesYAxisReverseMap[i]];if(o&&o.show&&o.showAlways)s.ancillaryCollapsedSeriesIndices.indexOf(i)<0&&(s.ancillaryCollapsedSeries.push({index:i,data:r[i].data.slice(),type:e.parentNode.className.baseVal.split("-")[1]}),s.ancillaryCollapsedSeriesIndices.push(i));else if(s.collapsedSeriesIndices.indexOf(i)<0){s.collapsedSeries.push({index:i,data:r[i].data.slice(),type:e.parentNode.className.baseVal.split("-")[1]}),s.collapsedSeriesIndices.push(i);var n=s.risingSeries.indexOf(i);s.risingSeries.splice(n,1)}}else s.collapsedSeries.push({index:i,data:r[i]}),s.collapsedSeriesIndices.push(i);for(var l=e.childNodes,h=0;h<l.length;h++)l[h].classList.contains("apexcharts-series-markers-wrap")&&(l[h].classList.contains("apexcharts-hide")?l[h].classList.remove("apexcharts-hide"):l[h].classList.add("apexcharts-hide"));s.allSeriesCollapsed=s.collapsedSeries.length+s.ancillaryCollapsedSeries.length===a.config.series.length,r=this._getSeriesBasedOnCollapsedState(r),this.lgCtx.ctx.updateHelpers._updateSeries(r,a.config.chart.animations.dynamicAnimation.enabled)}},{key:"riseCollapsedSeries",value:function(t,e,i){var a=this.w,s=x.clone(a.config.series);if(t.length>0){for(var r=0;r<t.length;r++)t[r].index===i&&(a.globals.axisCharts?(s[i].data=t[r].data.slice(),t.splice(r,1),e.splice(r,1),a.globals.risingSeries.push(i)):(s[i]=t[r].data,t.splice(r,1),e.splice(r,1),a.globals.risingSeries.push(i)));s=this._getSeriesBasedOnCollapsedState(s),this.lgCtx.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled)}}},{key:"_getSeriesBasedOnCollapsedState",value:function(t){var e=this.w,i=0;return e.globals.axisCharts?t.forEach((function(a,s){e.globals.collapsedSeriesIndices.indexOf(s)<0&&e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)<0||(t[s].data=[],i++)})):t.forEach((function(a,s){!e.globals.collapsedSeriesIndices.indexOf(s)<0&&(t[s]=0,i++)})),e.globals.allSeriesCollapsed=i===t.length,t}}]),t}(),lt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.onLegendClick=this.onLegendClick.bind(this),this.onLegendHovered=this.onLegendHovered.bind(this),this.isBarsDistributed="bar"===this.w.config.chart.type&&this.w.config.plotOptions.bar.distributed&&1===this.w.config.series.length,this.legendHelpers=new nt(this)}return r(t,[{key:"init",value:function(){var t=this.w,e=t.globals,i=t.config;if((i.legend.showForSingleSeries&&1===e.series.length||this.isBarsDistributed||e.series.length>1||!e.axisCharts)&&i.legend.show){for(;e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);this.drawLegends(),x.isIE11()?document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()):this.legendHelpers.appendToForeignObject(),"bottom"===i.legend.position||"top"===i.legend.position?this.legendAlignHorizontal():"right"!==i.legend.position&&"left"!==i.legend.position||this.legendAlignVertical()}}},{key:"drawLegends",value:function(){var t=this,e=this.w,i=e.config.legend.fontFamily,a=e.globals.seriesNames,s=e.globals.colors.slice();if("heatmap"===e.config.chart.type){var r=e.config.plotOptions.heatmap.colorScale.ranges;a=r.map((function(t){return t.name?t.name:t.from+" - "+t.to})),s=r.map((function(t){return t.color}))}else this.isBarsDistributed&&(a=e.globals.labels.slice());e.config.legend.customLegendItems.length&&(a=e.config.legend.customLegendItems);for(var o=e.globals.legendFormatter,n=e.config.legend.inverseOrder,l=n?a.length-1:0;n?l>=0:l<=a.length-1;n?l--:l++){var h,c=o(a[l],{seriesIndex:l,w:e}),d=!1,g=!1;if(e.globals.collapsedSeries.length>0)for(var u=0;u<e.globals.collapsedSeries.length;u++)e.globals.collapsedSeries[u].index===l&&(d=!0);if(e.globals.ancillaryCollapsedSeriesIndices.length>0)for(var p=0;p<e.globals.ancillaryCollapsedSeriesIndices.length;p++)e.globals.ancillaryCollapsedSeriesIndices[p]===l&&(g=!0);var f=document.createElement("span");f.classList.add("apexcharts-legend-marker");var b=e.config.legend.markers.offsetX,v=e.config.legend.markers.offsetY,w=e.config.legend.markers.height,k=e.config.legend.markers.width,A=e.config.legend.markers.strokeWidth,S=e.config.legend.markers.strokeColor,C=e.config.legend.markers.radius,L=f.style;L.background=s[l],L.color=s[l],L.setProperty("background",s[l],"important"),e.config.legend.markers.fillColors&&e.config.legend.markers.fillColors[l]&&(L.background=e.config.legend.markers.fillColors[l]),void 0!==e.globals.seriesColors[l]&&(L.background=e.globals.seriesColors[l],L.color=e.globals.seriesColors[l]),L.height=Array.isArray(w)?parseFloat(w[l])+"px":parseFloat(w)+"px",L.width=Array.isArray(k)?parseFloat(k[l])+"px":parseFloat(k)+"px",L.left=(Array.isArray(b)?parseFloat(b[l]):parseFloat(b))+"px",L.top=(Array.isArray(v)?parseFloat(v[l]):parseFloat(v))+"px",L.borderWidth=Array.isArray(A)?A[l]:A,L.borderColor=Array.isArray(S)?S[l]:S,L.borderRadius=Array.isArray(C)?parseFloat(C[l])+"px":parseFloat(C)+"px",e.config.legend.markers.customHTML&&(Array.isArray(e.config.legend.markers.customHTML)?e.config.legend.markers.customHTML[l]&&(f.innerHTML=e.config.legend.markers.customHTML[l]()):f.innerHTML=e.config.legend.markers.customHTML()),m.setAttrs(f,{rel:l+1,"data:collapsed":d||g}),(d||g)&&f.classList.add("apexcharts-inactive-legend");var P=document.createElement("div"),M=document.createElement("span");M.classList.add("apexcharts-legend-text"),M.innerHTML=Array.isArray(c)?c.join(" "):c;var I=e.config.legend.labels.useSeriesColors?e.globals.colors[l]:Array.isArray(e.config.legend.labels.colors)?null===(h=e.config.legend.labels.colors)||void 0===h?void 0:h[l]:e.config.legend.labels.colors;I||(I=e.config.chart.foreColor),M.style.color=I,M.style.fontSize=parseFloat(e.config.legend.fontSize)+"px",M.style.fontWeight=e.config.legend.fontWeight,M.style.fontFamily=i||e.config.chart.fontFamily,m.setAttrs(M,{rel:l+1,i:l,"data:default-text":encodeURIComponent(c),"data:collapsed":d||g}),P.appendChild(f),P.appendChild(M);var T=new y(this.ctx);if(!e.config.legend.showForZeroSeries)0===T.getSeriesTotalByIndex(l)&&T.seriesHaveSameValues(l)&&!T.isSeriesNull(l)&&-1===e.globals.collapsedSeriesIndices.indexOf(l)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(l)&&P.classList.add("apexcharts-hidden-zero-series");e.config.legend.showForNullSeries||T.isSeriesNull(l)&&-1===e.globals.collapsedSeriesIndices.indexOf(l)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(l)&&P.classList.add("apexcharts-hidden-null-series"),e.globals.dom.elLegendWrap.appendChild(P),e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)),e.globals.dom.elLegendWrap.classList.add("apx-legend-position-"+e.config.legend.position),P.classList.add("apexcharts-legend-series"),P.style.margin="".concat(e.config.legend.itemMargin.vertical,"px ").concat(e.config.legend.itemMargin.horizontal,"px"),e.globals.dom.elLegendWrap.style.width=e.config.legend.width?e.config.legend.width+"px":"",e.globals.dom.elLegendWrap.style.height=e.config.legend.height?e.config.legend.height+"px":"",m.setAttrs(P,{rel:l+1,seriesName:x.escapeString(a[l]),"data:collapsed":d||g}),(d||g)&&P.classList.add("apexcharts-inactive-legend"),e.config.legend.onItemClick.toggleDataSeries||P.classList.add("apexcharts-no-click")}e.globals.dom.elWrap.addEventListener("click",t.onLegendClick,!0),e.config.legend.onItemHover.highlightDataSeries&&0===e.config.legend.customLegendItems.length&&(e.globals.dom.elWrap.addEventListener("mousemove",t.onLegendHovered,!0),e.globals.dom.elWrap.addEventListener("mouseout",t.onLegendHovered,!0))}},{key:"setLegendWrapXY",value:function(t,e){var i=this.w,a=i.globals.dom.elLegendWrap,s=a.getBoundingClientRect(),r=0,o=0;if("bottom"===i.config.legend.position)o+=i.globals.svgHeight-s.height/2;else if("top"===i.config.legend.position){var n=new ot(this.ctx),l=n.dimHelpers.getTitleSubtitleCoords("title").height,h=n.dimHelpers.getTitleSubtitleCoords("subtitle").height;o=o+(l>0?l-10:0)+(h>0?h-10:0)}a.style.position="absolute",r=r+t+i.config.legend.offsetX,o=o+e+i.config.legend.offsetY,a.style.left=r+"px",a.style.top=o+"px","bottom"===i.config.legend.position?(a.style.top="auto",a.style.bottom=5-i.config.legend.offsetY+"px"):"right"===i.config.legend.position&&(a.style.left="auto",a.style.right=25+i.config.legend.offsetX+"px");["width","height"].forEach((function(t){a.style[t]&&(a.style[t]=parseInt(i.config.legend[t],10)+"px")}))}},{key:"legendAlignHorizontal",value:function(){var t=this.w;t.globals.dom.elLegendWrap.style.right=0;var e=this.legendHelpers.getLegendBBox(),i=new ot(this.ctx),a=i.dimHelpers.getTitleSubtitleCoords("title"),s=i.dimHelpers.getTitleSubtitleCoords("subtitle"),r=0;"bottom"===t.config.legend.position?r=-e.clwh/1.8:"top"===t.config.legend.position&&(r=a.height+s.height+t.config.title.margin+t.config.subtitle.margin-10),this.setLegendWrapXY(20,r)}},{key:"legendAlignVertical",value:function(){var t=this.w,e=this.legendHelpers.getLegendBBox(),i=0;"left"===t.config.legend.position&&(i=20),"right"===t.config.legend.position&&(i=t.globals.svgWidth-e.clww-10),this.setLegendWrapXY(i,20)}},{key:"onLegendHovered",value:function(t){var e=this.w,i=t.target.classList.contains("apexcharts-legend-series")||t.target.classList.contains("apexcharts-legend-text")||t.target.classList.contains("apexcharts-legend-marker");if("heatmap"===e.config.chart.type||this.isBarsDistributed){if(i){var a=parseInt(t.target.getAttribute("rel"),10)-1;this.ctx.events.fireEvent("legendHover",[this.ctx,a,this.w]),new W(this.ctx).highlightRangeInSeries(t,t.target)}}else!t.target.classList.contains("apexcharts-inactive-legend")&&i&&new W(this.ctx).toggleSeriesOnHover(t,t.target)}},{key:"onLegendClick",value:function(t){var e=this.w;if(!e.config.legend.customLegendItems.length&&(t.target.classList.contains("apexcharts-legend-series")||t.target.classList.contains("apexcharts-legend-text")||t.target.classList.contains("apexcharts-legend-marker"))){var i=parseInt(t.target.getAttribute("rel"),10)-1,a="true"===t.target.getAttribute("data:collapsed"),s=this.w.config.chart.events.legendClick;"function"==typeof s&&s(this.ctx,i,this.w),this.ctx.events.fireEvent("legendClick",[this.ctx,i,this.w]);var r=this.w.config.legend.markers.onClick;"function"==typeof r&&t.target.classList.contains("apexcharts-legend-marker")&&(r(this.ctx,i,this.w),this.ctx.events.fireEvent("legendMarkerClick",[this.ctx,i,this.w])),"treemap"!==e.config.chart.type&&"heatmap"!==e.config.chart.type&&!this.isBarsDistributed&&e.config.legend.onItemClick.toggleDataSeries&&this.legendHelpers.toggleDataSeries(i,a)}}}]),t}(),ht=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.ev=this.w.config.chart.events,this.selectedClass="apexcharts-selected",this.localeValues=this.w.globals.locale.toolbar,this.minX=i.globals.minX,this.maxX=i.globals.maxX}return r(t,[{key:"createToolbar",value:function(){var t=this,e=this.w,i=function(){return document.createElement("div")},a=i();if(a.setAttribute("class","apexcharts-toolbar"),a.style.top=e.config.chart.toolbar.offsetY+"px",a.style.right=3-e.config.chart.toolbar.offsetX+"px",e.globals.dom.elWrap.appendChild(a),this.elZoom=i(),this.elZoomIn=i(),this.elZoomOut=i(),this.elPan=i(),this.elSelection=i(),this.elZoomReset=i(),this.elMenuIcon=i(),this.elMenu=i(),this.elCustomIcons=[],this.t=e.config.chart.toolbar.tools,Array.isArray(this.t.customIcons))for(var s=0;s<this.t.customIcons.length;s++)this.elCustomIcons.push(i());var r=[],o=function(i,a,s){var o=i.toLowerCase();t.t[o]&&e.config.chart.zoom.enabled&&r.push({el:a,icon:"string"==typeof t.t[o]?t.t[o]:s,title:t.localeValues[i],class:"apexcharts-".concat(o,"-icon")})};o("zoomIn",this.elZoomIn,'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'),o("zoomOut",this.elZoomOut,'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');var n=function(i){t.t[i]&&e.config.chart[i].enabled&&r.push({el:"zoom"===i?t.elZoom:t.elSelection,icon:"string"==typeof t.t[i]?t.t[i]:"zoom"===i?'<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>':'<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',title:t.localeValues["zoom"===i?"selectionZoom":"selection"],class:e.globals.isTouchDevice?"apexcharts-element-hidden":"apexcharts-".concat(i,"-icon")})};n("zoom"),n("selection"),this.t.pan&&e.config.chart.zoom.enabled&&r.push({el:this.elPan,icon:"string"==typeof this.t.pan?this.t.pan:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',title:this.localeValues.pan,class:e.globals.isTouchDevice?"apexcharts-element-hidden":"apexcharts-pan-icon"}),o("reset",this.elZoomReset,'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),this.t.download&&r.push({el:this.elMenuIcon,icon:"string"==typeof this.t.download?this.t.download:'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',title:this.localeValues.menu,class:"apexcharts-menu-icon"});for(var l=0;l<this.elCustomIcons.length;l++)r.push({el:this.elCustomIcons[l],icon:this.t.customIcons[l].icon,title:this.t.customIcons[l].title,index:this.t.customIcons[l].index,class:"apexcharts-toolbar-custom-icon "+this.t.customIcons[l].class});r.forEach((function(t,e){t.index&&x.moveIndexInArray(r,e,t.index)}));for(var h=0;h<r.length;h++)m.setAttrs(r[h].el,{class:r[h].class,title:r[h].title}),r[h].el.innerHTML=r[h].icon,a.appendChild(r[h].el);this._createHamburgerMenu(a),e.globals.zoomEnabled?this.elZoom.classList.add(this.selectedClass):e.globals.panEnabled?this.elPan.classList.add(this.selectedClass):e.globals.selectionEnabled&&this.elSelection.classList.add(this.selectedClass),this.addToolbarEventListeners()}},{key:"_createHamburgerMenu",value:function(t){this.elMenuItems=[],t.appendChild(this.elMenu),m.setAttrs(this.elMenu,{class:"apexcharts-menu"});for(var e=[{name:"exportSVG",title:this.localeValues.exportToSVG},{name:"exportPNG",title:this.localeValues.exportToPNG},{name:"exportCSV",title:this.localeValues.exportToCSV}],i=0;i<e.length;i++)this.elMenuItems.push(document.createElement("div")),this.elMenuItems[i].innerHTML=e[i].title,m.setAttrs(this.elMenuItems[i],{class:"apexcharts-menu-item ".concat(e[i].name),title:e[i].title}),this.elMenu.appendChild(this.elMenuItems[i])}},{key:"addToolbarEventListeners",value:function(){var t=this;this.elZoomReset.addEventListener("click",this.handleZoomReset.bind(this)),this.elSelection.addEventListener("click",this.toggleZoomSelection.bind(this,"selection")),this.elZoom.addEventListener("click",this.toggleZoomSelection.bind(this,"zoom")),this.elZoomIn.addEventListener("click",this.handleZoomIn.bind(this)),this.elZoomOut.addEventListener("click",this.handleZoomOut.bind(this)),this.elPan.addEventListener("click",this.togglePanning.bind(this)),this.elMenuIcon.addEventListener("click",this.toggleMenu.bind(this)),this.elMenuItems.forEach((function(e){e.classList.contains("exportSVG")?e.addEventListener("click",t.handleDownload.bind(t,"svg")):e.classList.contains("exportPNG")?e.addEventListener("click",t.handleDownload.bind(t,"png")):e.classList.contains("exportCSV")&&e.addEventListener("click",t.handleDownload.bind(t,"csv"))}));for(var e=0;e<this.t.customIcons.length;e++)this.elCustomIcons[e].addEventListener("click",this.t.customIcons[e].click.bind(this,this.ctx,this.ctx.w))}},{key:"toggleZoomSelection",value:function(t){this.ctx.getSyncedCharts().forEach((function(e){e.ctx.toolbar.toggleOtherControls();var i="selection"===t?e.ctx.toolbar.elSelection:e.ctx.toolbar.elZoom,a="selection"===t?"selectionEnabled":"zoomEnabled";e.w.globals[a]=!e.w.globals[a],i.classList.contains(e.ctx.toolbar.selectedClass)?i.classList.remove(e.ctx.toolbar.selectedClass):i.classList.add(e.ctx.toolbar.selectedClass)}))}},{key:"getToolbarIconsReference",value:function(){var t=this.w;this.elZoom||(this.elZoom=t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")),this.elPan||(this.elPan=t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")),this.elSelection||(this.elSelection=t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"))}},{key:"enableZoomPanFromToolbar",value:function(t){this.toggleOtherControls(),"pan"===t?this.w.globals.panEnabled=!0:this.w.globals.zoomEnabled=!0;var e="pan"===t?this.elPan:this.elZoom,i="pan"===t?this.elZoom:this.elPan;e&&e.classList.add(this.selectedClass),i&&i.classList.remove(this.selectedClass)}},{key:"togglePanning",value:function(){this.ctx.getSyncedCharts().forEach((function(t){t.ctx.toolbar.toggleOtherControls(),t.w.globals.panEnabled=!t.w.globals.panEnabled,t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass)?t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass):t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass)}))}},{key:"toggleOtherControls",value:function(){var t=this,e=this.w;e.globals.panEnabled=!1,e.globals.zoomEnabled=!1,e.globals.selectionEnabled=!1,this.getToolbarIconsReference(),[this.elPan,this.elSelection,this.elZoom].forEach((function(e){e&&e.classList.remove(t.selectedClass)}))}},{key:"handleZoomIn",value:function(){var t=this.w;t.globals.isRangeBar&&(this.minX=t.globals.minY,this.maxX=t.globals.maxY);var e=(this.minX+this.maxX)/2,i=(this.minX+e)/2,a=(this.maxX+e)/2,s=this._getNewMinXMaxX(i,a);t.globals.disableZoomIn||this.zoomUpdateOptions(s.minX,s.maxX)}},{key:"handleZoomOut",value:function(){var t=this.w;if(t.globals.isRangeBar&&(this.minX=t.globals.minY,this.maxX=t.globals.maxY),!("datetime"===t.config.xaxis.type&&new Date(this.minX).getUTCFullYear()<1e3)){var e=(this.minX+this.maxX)/2,i=this.minX-(e-this.minX),a=this.maxX-(e-this.maxX),s=this._getNewMinXMaxX(i,a);t.globals.disableZoomOut||this.zoomUpdateOptions(s.minX,s.maxX)}}},{key:"_getNewMinXMaxX",value:function(t,e){var i=this.w.config.xaxis.convertedCatToNumeric;return{minX:i?Math.floor(t):t,maxX:i?Math.floor(e):e}}},{key:"zoomUpdateOptions",value:function(t,e){var i=this.w;if(void 0!==t||void 0!==e){if(!(i.config.xaxis.convertedCatToNumeric&&(t<1&&(t=1,e=i.globals.dataPoints),e-t<2))){var a={min:t,max:e},s=this.getBeforeZoomRange(a);s&&(a=s.xaxis);var r={xaxis:a},o=x.clone(i.globals.initialConfig.yaxis);i.config.chart.group||(r.yaxis=o),this.w.globals.zoomed=!0,this.ctx.updateHelpers._updateOptions(r,!1,this.w.config.chart.animations.dynamicAnimation.enabled),this.zoomCallback(a,o)}}else this.handleZoomReset()}},{key:"zoomCallback",value:function(t,e){"function"==typeof this.ev.zoomed&&this.ev.zoomed(this.ctx,{xaxis:t,yaxis:e})}},{key:"getBeforeZoomRange",value:function(t,e){var i=null;return"function"==typeof this.ev.beforeZoom&&(i=this.ev.beforeZoom(this,{xaxis:t,yaxis:e})),i}},{key:"toggleMenu",value:function(){var t=this;window.setTimeout((function(){t.elMenu.classList.contains("apexcharts-menu-open")?t.elMenu.classList.remove("apexcharts-menu-open"):t.elMenu.classList.add("apexcharts-menu-open")}),0)}},{key:"handleDownload",value:function(t){var e=this.w,i=new G(this.ctx);switch(t){case"svg":i.exportToSVG(this.ctx);break;case"png":i.exportToPng(this.ctx);break;case"csv":i.exportToCSV({series:e.config.series,columnDelimiter:e.config.chart.toolbar.export.csv.columnDelimiter})}}},{key:"handleZoomReset",value:function(t){this.ctx.getSyncedCharts().forEach((function(t){var e=t.w;if(e.globals.lastXAxis.min=e.globals.initialConfig.xaxis.min,e.globals.lastXAxis.max=e.globals.initialConfig.xaxis.max,t.updateHelpers.revertDefaultAxisMinMax(),"function"==typeof e.config.chart.events.beforeResetZoom){var i=e.config.chart.events.beforeResetZoom(t,e);i&&t.updateHelpers.revertDefaultAxisMinMax(i)}"function"==typeof e.config.chart.events.zoomed&&t.ctx.toolbar.zoomCallback({min:e.config.xaxis.min,max:e.config.xaxis.max}),e.globals.zoomed=!1;var a=t.ctx.series.emptyCollapsedSeries(x.clone(e.globals.initialSeries));t.updateHelpers._updateSeries(a,e.config.chart.animations.dynamicAnimation.enabled)}))}},{key:"destroy",value:function(){this.elZoom=null,this.elZoomIn=null,this.elZoomOut=null,this.elPan=null,this.elSelection=null,this.elZoomReset=null,this.elMenuIcon=null}}]),t}(),ct=function(t){n(i,t);var e=d(i);function i(t){var s;return a(this,i),(s=e.call(this,t)).ctx=t,s.w=t.w,s.dragged=!1,s.graphics=new m(s.ctx),s.eventList=["mousedown","mouseleave","mousemove","touchstart","touchmove","mouseup","touchend"],s.clientX=0,s.clientY=0,s.startX=0,s.endX=0,s.dragX=0,s.startY=0,s.endY=0,s.dragY=0,s.moveDirection="none",s}return r(i,[{key:"init",value:function(t){var e=this,i=t.xyRatios,a=this.w,s=this;this.xyRatios=i,this.zoomRect=this.graphics.drawRect(0,0,0,0),this.selectionRect=this.graphics.drawRect(0,0,0,0),this.gridRect=a.globals.dom.baseEl.querySelector(".apexcharts-grid"),this.zoomRect.node.classList.add("apexcharts-zoom-rect"),this.selectionRect.node.classList.add("apexcharts-selection-rect"),a.globals.dom.elGraphical.add(this.zoomRect),a.globals.dom.elGraphical.add(this.selectionRect),"x"===a.config.chart.selection.type?this.slDraggableRect=this.selectionRect.draggable({minX:0,minY:0,maxX:a.globals.gridWidth,maxY:a.globals.gridHeight}).on("dragmove",this.selectionDragging.bind(this,"dragging")):"y"===a.config.chart.selection.type?this.slDraggableRect=this.selectionRect.draggable({minX:0,maxX:a.globals.gridWidth}).on("dragmove",this.selectionDragging.bind(this,"dragging")):this.slDraggableRect=this.selectionRect.draggable().on("dragmove",this.selectionDragging.bind(this,"dragging")),this.preselectedSelection(),this.hoverArea=a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass," .apexcharts-svg")),this.hoverArea.classList.add("apexcharts-zoomable"),this.eventList.forEach((function(t){e.hoverArea.addEventListener(t,s.svgMouseEvents.bind(s,i),{capture:!1,passive:!0})}))}},{key:"destroy",value:function(){this.slDraggableRect&&(this.slDraggableRect.draggable(!1),this.slDraggableRect.off(),this.selectionRect.off()),this.selectionRect=null,this.zoomRect=null,this.gridRect=null}},{key:"svgMouseEvents",value:function(t,e){var i=this.w,a=this,s=this.ctx.toolbar,r=i.globals.zoomEnabled?i.config.chart.zoom.type:i.config.chart.selection.type,o=i.config.chart.toolbar.autoSelected;if(e.shiftKey?(this.shiftWasPressed=!0,s.enableZoomPanFromToolbar("pan"===o?"zoom":"pan")):this.shiftWasPressed&&(s.enableZoomPanFromToolbar(o),this.shiftWasPressed=!1),e.target){var n,l=e.target.classList;if(e.target.parentNode&&null!==e.target.parentNode&&(n=e.target.parentNode.classList),!(l.contains("apexcharts-selection-rect")||l.contains("apexcharts-legend-marker")||l.contains("apexcharts-legend-text")||n&&n.contains("apexcharts-toolbar"))){if(a.clientX="touchmove"===e.type||"touchstart"===e.type?e.touches[0].clientX:"touchend"===e.type?e.changedTouches[0].clientX:e.clientX,a.clientY="touchmove"===e.type||"touchstart"===e.type?e.touches[0].clientY:"touchend"===e.type?e.changedTouches[0].clientY:e.clientY,"mousedown"===e.type&&1===e.which){var h=a.gridRect.getBoundingClientRect();a.startX=a.clientX-h.left,a.startY=a.clientY-h.top,a.dragged=!1,a.w.globals.mousedown=!0}if(("mousemove"===e.type&&1===e.which||"touchmove"===e.type)&&(a.dragged=!0,i.globals.panEnabled?(i.globals.selection=null,a.w.globals.mousedown&&a.panDragging({context:a,zoomtype:r,xyRatios:t})):(a.w.globals.mousedown&&i.globals.zoomEnabled||a.w.globals.mousedown&&i.globals.selectionEnabled)&&(a.selection=a.selectionDrawing({context:a,zoomtype:r}))),"mouseup"===e.type||"touchend"===e.type||"mouseleave"===e.type){var c=a.gridRect.getBoundingClientRect();a.w.globals.mousedown&&(a.endX=a.clientX-c.left,a.endY=a.clientY-c.top,a.dragX=Math.abs(a.endX-a.startX),a.dragY=Math.abs(a.endY-a.startY),(i.globals.zoomEnabled||i.globals.selectionEnabled)&&a.selectionDrawn({context:a,zoomtype:r}),i.globals.panEnabled&&i.config.xaxis.convertedCatToNumeric&&a.delayedPanScrolled()),i.globals.zoomEnabled&&a.hideSelectionRect(this.selectionRect),a.dragged=!1,a.w.globals.mousedown=!1}this.makeSelectionRectDraggable()}}}},{key:"makeSelectionRectDraggable",value:function(){var t=this.w;if(this.selectionRect){var e=this.selectionRect.node.getBoundingClientRect();e.width>0&&e.height>0&&this.slDraggableRect.selectize({points:"l, r",pointSize:8,pointType:"rect"}).resize({constraint:{minX:0,minY:0,maxX:t.globals.gridWidth,maxY:t.globals.gridHeight}}).on("resizing",this.selectionDragging.bind(this,"resizing"))}}},{key:"preselectedSelection",value:function(){var t=this.w,e=this.xyRatios;if(!t.globals.zoomEnabled)if(void 0!==t.globals.selection&&null!==t.globals.selection)this.drawSelectionRect(t.globals.selection);else if(void 0!==t.config.chart.selection.xaxis.min&&void 0!==t.config.chart.selection.xaxis.max){var i=(t.config.chart.selection.xaxis.min-t.globals.minX)/e.xRatio,a=t.globals.gridWidth-(t.globals.maxX-t.config.chart.selection.xaxis.max)/e.xRatio-i;t.globals.isRangeBar&&(i=(t.config.chart.selection.xaxis.min-t.globals.yAxisScale[0].niceMin)/e.invertedYRatio,a=(t.config.chart.selection.xaxis.max-t.config.chart.selection.xaxis.min)/e.invertedYRatio);var s={x:i,y:0,width:a,height:t.globals.gridHeight,translateX:0,translateY:0,selectionEnabled:!0};this.drawSelectionRect(s),this.makeSelectionRectDraggable(),"function"==typeof t.config.chart.events.selection&&t.config.chart.events.selection(this.ctx,{xaxis:{min:t.config.chart.selection.xaxis.min,max:t.config.chart.selection.xaxis.max},yaxis:{}})}}},{key:"drawSelectionRect",value:function(t){var e=t.x,i=t.y,a=t.width,s=t.height,r=t.translateX,o=void 0===r?0:r,n=t.translateY,l=void 0===n?0:n,h=this.w,c=this.zoomRect,d=this.selectionRect;if(this.dragged||null!==h.globals.selection){var g={transform:"translate("+o+", "+l+")"};h.globals.zoomEnabled&&this.dragged&&(a<0&&(a=1),c.attr({x:e,y:i,width:a,height:s,fill:h.config.chart.zoom.zoomedArea.fill.color,"fill-opacity":h.config.chart.zoom.zoomedArea.fill.opacity,stroke:h.config.chart.zoom.zoomedArea.stroke.color,"stroke-width":h.config.chart.zoom.zoomedArea.stroke.width,"stroke-opacity":h.config.chart.zoom.zoomedArea.stroke.opacity}),m.setAttrs(c.node,g)),h.globals.selectionEnabled&&(d.attr({x:e,y:i,width:a>0?a:0,height:s>0?s:0,fill:h.config.chart.selection.fill.color,"fill-opacity":h.config.chart.selection.fill.opacity,stroke:h.config.chart.selection.stroke.color,"stroke-width":h.config.chart.selection.stroke.width,"stroke-dasharray":h.config.chart.selection.stroke.dashArray,"stroke-opacity":h.config.chart.selection.stroke.opacity}),m.setAttrs(d.node,g))}}},{key:"hideSelectionRect",value:function(t){t&&t.attr({x:0,y:0,width:0,height:0})}},{key:"selectionDrawing",value:function(t){var e=t.context,i=t.zoomtype,a=this.w,s=e,r=this.gridRect.getBoundingClientRect(),o=s.startX-1,n=s.startY,l=!1,h=!1,c=s.clientX-r.left-o,d=s.clientY-r.top-n,g={};return Math.abs(c+o)>a.globals.gridWidth?c=a.globals.gridWidth-o:s.clientX-r.left<0&&(c=o),o>s.clientX-r.left&&(l=!0,c=Math.abs(c)),n>s.clientY-r.top&&(h=!0,d=Math.abs(d)),g="x"===i?{x:l?o-c:o,y:0,width:c,height:a.globals.gridHeight}:"y"===i?{x:0,y:h?n-d:n,width:a.globals.gridWidth,height:d}:{x:l?o-c:o,y:h?n-d:n,width:c,height:d},s.drawSelectionRect(g),s.selectionDragging("resizing"),g}},{key:"selectionDragging",value:function(t,e){var i=this,a=this.w,s=this.xyRatios,r=this.selectionRect,o=0;"resizing"===t&&(o=30);var n=function(t){return parseFloat(r.node.getAttribute(t))},l={x:n("x"),y:n("y"),width:n("width"),height:n("height")};a.globals.selection=l,"function"==typeof a.config.chart.events.selection&&a.globals.selectionEnabled&&(clearTimeout(this.w.globals.selectionResizeTimer),this.w.globals.selectionResizeTimer=window.setTimeout((function(){var t,e,o,n,l=i.gridRect.getBoundingClientRect(),h=r.node.getBoundingClientRect();a.globals.isRangeBar?(t=a.globals.yAxisScale[0].niceMin+(h.left-l.left)*s.invertedYRatio,e=a.globals.yAxisScale[0].niceMin+(h.right-l.left)*s.invertedYRatio,o=0,n=1):(t=a.globals.xAxisScale.niceMin+(h.left-l.left)*s.xRatio,e=a.globals.xAxisScale.niceMin+(h.right-l.left)*s.xRatio,o=a.globals.yAxisScale[0].niceMin+(l.bottom-h.bottom)*s.yRatio[0],n=a.globals.yAxisScale[0].niceMax-(h.top-l.top)*s.yRatio[0]);var c={xaxis:{min:t,max:e},yaxis:{min:o,max:n}};a.config.chart.events.selection(i.ctx,c),a.config.chart.brush.enabled&&void 0!==a.config.chart.events.brushScrolled&&a.config.chart.events.brushScrolled(i.ctx,c)}),o))}},{key:"selectionDrawn",value:function(t){var e=t.context,i=t.zoomtype,a=this.w,s=e,r=this.xyRatios,o=this.ctx.toolbar;if(s.startX>s.endX){var n=s.startX;s.startX=s.endX,s.endX=n}if(s.startY>s.endY){var l=s.startY;s.startY=s.endY,s.endY=l}var h=void 0,c=void 0;a.globals.isRangeBar?(h=a.globals.yAxisScale[0].niceMin+s.startX*r.invertedYRatio,c=a.globals.yAxisScale[0].niceMin+s.endX*r.invertedYRatio):(h=a.globals.xAxisScale.niceMin+s.startX*r.xRatio,c=a.globals.xAxisScale.niceMin+s.endX*r.xRatio);var d=[],g=[];if(a.config.yaxis.forEach((function(t,e){if(a.globals.seriesYAxisMap[e].length>0){var i=a.globals.seriesYAxisMap[e][0];d.push(a.globals.yAxisScale[e].niceMax-r.yRatio[i]*s.startY),g.push(a.globals.yAxisScale[e].niceMax-r.yRatio[i]*s.endY)}})),s.dragged&&(s.dragX>10||s.dragY>10)&&h!==c)if(a.globals.zoomEnabled){var u=x.clone(a.globals.initialConfig.yaxis),p=x.clone(a.globals.initialConfig.xaxis);if(a.globals.zoomed=!0,a.config.xaxis.convertedCatToNumeric&&(h=Math.floor(h),c=Math.floor(c),h<1&&(h=1,c=a.globals.dataPoints),c-h<2&&(c=h+1)),"xy"!==i&&"x"!==i||(p={min:h,max:c}),"xy"!==i&&"y"!==i||u.forEach((function(t,e){u[e].min=g[e],u[e].max=d[e]})),o){var f=o.getBeforeZoomRange(p,u);f&&(p=f.xaxis?f.xaxis:p,u=f.yaxis?f.yaxis:u)}var b={xaxis:p};a.config.chart.group||(b.yaxis=u),s.ctx.updateHelpers._updateOptions(b,!1,s.w.config.chart.animations.dynamicAnimation.enabled),"function"==typeof a.config.chart.events.zoomed&&o.zoomCallback(p,u)}else if(a.globals.selectionEnabled){var v,m=null;v={min:h,max:c},"xy"!==i&&"y"!==i||(m=x.clone(a.config.yaxis)).forEach((function(t,e){m[e].min=g[e],m[e].max=d[e]})),a.globals.selection=s.selection,"function"==typeof a.config.chart.events.selection&&a.config.chart.events.selection(s.ctx,{xaxis:v,yaxis:m})}}},{key:"panDragging",value:function(t){var e=t.context,i=this.w,a=e;if(void 0!==i.globals.lastClientPosition.x){var s=i.globals.lastClientPosition.x-a.clientX,r=i.globals.lastClientPosition.y-a.clientY;Math.abs(s)>Math.abs(r)&&s>0?this.moveDirection="left":Math.abs(s)>Math.abs(r)&&s<0?this.moveDirection="right":Math.abs(r)>Math.abs(s)&&r>0?this.moveDirection="up":Math.abs(r)>Math.abs(s)&&r<0&&(this.moveDirection="down")}i.globals.lastClientPosition={x:a.clientX,y:a.clientY};var o=i.globals.isRangeBar?i.globals.minY:i.globals.minX,n=i.globals.isRangeBar?i.globals.maxY:i.globals.maxX;i.config.xaxis.convertedCatToNumeric||a.panScrolled(o,n)}},{key:"delayedPanScrolled",value:function(){var t=this.w,e=t.globals.minX,i=t.globals.maxX,a=(t.globals.maxX-t.globals.minX)/2;"left"===this.moveDirection?(e=t.globals.minX+a,i=t.globals.maxX+a):"right"===this.moveDirection&&(e=t.globals.minX-a,i=t.globals.maxX-a),e=Math.floor(e),i=Math.floor(i),this.updateScrolledChart({xaxis:{min:e,max:i}},e,i)}},{key:"panScrolled",value:function(t,e){var i=this.w,a=this.xyRatios,s=x.clone(i.globals.initialConfig.yaxis),r=a.xRatio,o=i.globals.minX,n=i.globals.maxX;i.globals.isRangeBar&&(r=a.invertedYRatio,o=i.globals.minY,n=i.globals.maxY),"left"===this.moveDirection?(t=o+i.globals.gridWidth/15*r,e=n+i.globals.gridWidth/15*r):"right"===this.moveDirection&&(t=o-i.globals.gridWidth/15*r,e=n-i.globals.gridWidth/15*r),i.globals.isRangeBar||(t<i.globals.initialMinX||e>i.globals.initialMaxX)&&(t=o,e=n);var l={xaxis:{min:t,max:e}};i.config.chart.group||(l.yaxis=s),this.updateScrolledChart(l,t,e)}},{key:"updateScrolledChart",value:function(t,e,i){var a=this.w;this.ctx.updateHelpers._updateOptions(t,!1,!1),"function"==typeof a.config.chart.events.scrolled&&a.config.chart.events.scrolled(this.ctx,{xaxis:{min:e,max:i}})}}]),i}(ht),dt=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e,this.ctx=e.ctx}return r(t,[{key:"getNearestValues",value:function(t){var e=t.hoverArea,i=t.elGrid,a=t.clientX,s=t.clientY,r=this.w,o=i.getBoundingClientRect(),n=o.width,l=o.height,h=n/(r.globals.dataPoints-1),c=l/r.globals.dataPoints,d=this.hasBars();!r.globals.comboCharts&&!d||r.config.xaxis.convertedCatToNumeric||(h=n/r.globals.dataPoints);var g=a-o.left-r.globals.barPadForNumericAxis,u=s-o.top;g<0||u<0||g>n||u>l?(e.classList.remove("hovering-zoom"),e.classList.remove("hovering-pan")):r.globals.zoomEnabled?(e.classList.remove("hovering-pan"),e.classList.add("hovering-zoom")):r.globals.panEnabled&&(e.classList.remove("hovering-zoom"),e.classList.add("hovering-pan"));var p=Math.round(g/h),f=Math.floor(u/c);d&&!r.config.xaxis.convertedCatToNumeric&&(p=Math.ceil(g/h),p-=1);var b=null,v=null,m=r.globals.seriesXvalues.map((function(t){return t.filter((function(t){return x.isNumber(t)}))})),y=r.globals.seriesYvalues.map((function(t){return t.filter((function(t){return x.isNumber(t)}))}));if(r.globals.isXNumeric){var w=this.ttCtx.getElGrid().getBoundingClientRect(),k=g*(w.width/n),A=u*(w.height/l);b=(v=this.closestInMultiArray(k,A,m,y)).index,p=v.j,null!==b&&(m=r.globals.seriesXvalues[b],p=(v=this.closestInArray(k,m)).index)}return r.globals.capturedSeriesIndex=null===b?-1:b,(!p||p<1)&&(p=0),r.globals.isBarHorizontal?r.globals.capturedDataPointIndex=f:r.globals.capturedDataPointIndex=p,{capturedSeries:b,j:r.globals.isBarHorizontal?f:p,hoverX:g,hoverY:u}}},{key:"closestInMultiArray",value:function(t,e,i,a){var s=this.w,r=0,o=null,n=-1;s.globals.series.length>1?r=this.getFirstActiveXArray(i):o=0;var l=i[r][0],h=Math.abs(t-l);if(i.forEach((function(e){e.forEach((function(e,i){var a=Math.abs(t-e);a<=h&&(h=a,n=i)}))})),-1!==n){var c=a[r][n],d=Math.abs(e-c);o=r,a.forEach((function(t,i){var a=Math.abs(e-t[n]);a<=d&&(d=a,o=i)}))}return{index:o,j:n}}},{key:"getFirstActiveXArray",value:function(t){for(var e=this.w,i=0,a=t.map((function(t,e){return t.length>0?e:-1})),s=0;s<a.length;s++)if(-1!==a[s]&&-1===e.globals.collapsedSeriesIndices.indexOf(s)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)){i=a[s];break}return i}},{key:"closestInArray",value:function(t,e){for(var i=e[0],a=null,s=Math.abs(t-i),r=0;r<e.length;r++){var o=Math.abs(t-e[r]);o<s&&(s=o,a=r)}return{index:a}}},{key:"isXoverlap",value:function(t){var e=[],i=this.w.globals.seriesX.filter((function(t){return void 0!==t[0]}));if(i.length>0)for(var a=0;a<i.length-1;a++)void 0!==i[a][t]&&void 0!==i[a+1][t]&&i[a][t]!==i[a+1][t]&&e.push("unEqual");return 0===e.length}},{key:"isInitialSeriesSameLen",value:function(){for(var t=!0,e=this.w.globals.initialSeries,i=0;i<e.length-1;i++)if(e[i].data.length!==e[i+1].data.length){t=!1;break}return t}},{key:"getBarsHeight",value:function(t){return u(t).reduce((function(t,e){return t+e.getBBox().height}),0)}},{key:"getElMarkers",value:function(t){return"number"==typeof t?this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t,"'] .apexcharts-series-markers-wrap > *")):this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *")}},{key:"getAllMarkers",value:function(){var t=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");(t=u(t)).sort((function(t,e){var i=Number(t.getAttribute("data:realIndex")),a=Number(e.getAttribute("data:realIndex"));return a<i?1:a>i?-1:0}));var e=[];return t.forEach((function(t){e.push(t.querySelector(".apexcharts-marker"))})),e}},{key:"hasMarkers",value:function(t){return this.getElMarkers(t).length>0}},{key:"getElBars",value:function(){return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series")}},{key:"hasBars",value:function(){return this.getElBars().length>0}},{key:"getHoverMarkerSize",value:function(t){var e=this.w,i=e.config.markers.hover.size;return void 0===i&&(i=e.globals.markers.size[t]+e.config.markers.hover.sizeOffset),i}},{key:"toggleAllTooltipSeriesGroups",value:function(t){var e=this.w,i=this.ttCtx;0===i.allTooltipSeriesGroups.length&&(i.allTooltipSeriesGroups=e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));for(var a=i.allTooltipSeriesGroups,s=0;s<a.length;s++)"enable"===t?(a[s].classList.add("apexcharts-active"),a[s].style.display=e.config.tooltip.items.display):(a[s].classList.remove("apexcharts-active"),a[s].style.display="none")}}]),t}(),gt=function(){function t(e){a(this,t),this.w=e.w,this.ctx=e.ctx,this.ttCtx=e,this.tooltipUtil=new dt(e)}return r(t,[{key:"drawSeriesTexts",value:function(t){var e=t.shared,i=void 0===e||e,a=t.ttItems,s=t.i,r=void 0===s?0:s,o=t.j,n=void 0===o?null:o,l=t.y1,h=t.y2,c=t.e,d=this.w;void 0!==d.config.tooltip.custom?this.handleCustomTooltip({i:r,j:n,y1:l,y2:h,w:d}):this.toggleActiveInactiveSeries(i);var g=this.getValuesToPrint({i:r,j:n});this.printLabels({i:r,j:n,values:g,ttItems:a,shared:i,e:c});var u=this.ttCtx.getElTooltip();this.ttCtx.tooltipRect.ttWidth=u.getBoundingClientRect().width,this.ttCtx.tooltipRect.ttHeight=u.getBoundingClientRect().height}},{key:"printLabels",value:function(t){var i,a=this,s=t.i,r=t.j,o=t.values,n=t.ttItems,l=t.shared,h=t.e,c=this.w,d=[],g=function(t){return c.globals.seriesGoals[t]&&c.globals.seriesGoals[t][r]&&Array.isArray(c.globals.seriesGoals[t][r])},u=o.xVal,p=o.zVal,f=o.xAxisTTVal,x="",b=c.globals.colors[s];null!==r&&c.config.plotOptions.bar.distributed&&(b=c.globals.colors[r]);for(var v=function(t,o){var v=a.getFormatters(s);x=a.getSeriesName({fn:v.yLbTitleFormatter,index:s,seriesIndex:s,j:r}),"treemap"===c.config.chart.type&&(x=v.yLbTitleFormatter(String(c.config.series[s].data[r].x),{series:c.globals.series,seriesIndex:s,dataPointIndex:r,w:c}));var m=c.config.tooltip.inverseOrder?o:t;if(c.globals.axisCharts){var y=function(t){var e,i,a,s;return c.globals.isRangeData?v.yLbFormatter(null===(e=c.globals.seriesRangeStart)||void 0===e||null===(i=e[t])||void 0===i?void 0:i[r],{series:c.globals.seriesRangeStart,seriesIndex:t,dataPointIndex:r,w:c})+" - "+v.yLbFormatter(null===(a=c.globals.seriesRangeEnd)||void 0===a||null===(s=a[t])||void 0===s?void 0:s[r],{series:c.globals.seriesRangeEnd,seriesIndex:t,dataPointIndex:r,w:c}):v.yLbFormatter(c.globals.series[t][r],{series:c.globals.series,seriesIndex:t,dataPointIndex:r,w:c})};if(l)v=a.getFormatters(m),x=a.getSeriesName({fn:v.yLbTitleFormatter,index:m,seriesIndex:s,j:r}),b=c.globals.colors[m],i=y(m),g(m)&&(d=c.globals.seriesGoals[m][r].map((function(t){return{attrs:t,val:v.yLbFormatter(t.value,{seriesIndex:m,dataPointIndex:r,w:c})}})));else{var w,k=null==h||null===(w=h.target)||void 0===w?void 0:w.getAttribute("fill");k&&(b=-1!==k.indexOf("url")?document.querySelector(k.substr(4).slice(0,-1)).childNodes[0].getAttribute("stroke"):k),i=y(s),g(s)&&Array.isArray(c.globals.seriesGoals[s][r])&&(d=c.globals.seriesGoals[s][r].map((function(t){return{attrs:t,val:v.yLbFormatter(t.value,{seriesIndex:s,dataPointIndex:r,w:c})}})))}}null===r&&(i=v.yLbFormatter(c.globals.series[s],e(e({},c),{},{seriesIndex:s,dataPointIndex:s}))),a.DOMHandling({i:s,t:m,j:r,ttItems:n,values:{val:i,goalVals:d,xVal:u,xAxisTTVal:f,zVal:p},seriesName:x,shared:l,pColor:b})},m=0,y=c.globals.series.length-1;m<c.globals.series.length;m++,y--)v(m,y)}},{key:"getFormatters",value:function(t){var e,i=this.w,a=i.globals.yLabelFormatters[t];return void 0!==i.globals.ttVal?Array.isArray(i.globals.ttVal)?(a=i.globals.ttVal[t]&&i.globals.ttVal[t].formatter,e=i.globals.ttVal[t]&&i.globals.ttVal[t].title&&i.globals.ttVal[t].title.formatter):(a=i.globals.ttVal.formatter,"function"==typeof i.globals.ttVal.title.formatter&&(e=i.globals.ttVal.title.formatter)):e=i.config.tooltip.y.title.formatter,"function"!=typeof a&&(a=i.globals.yLabelFormatters[0]?i.globals.yLabelFormatters[0]:function(t){return t}),"function"!=typeof e&&(e=function(t){return t}),{yLbFormatter:a,yLbTitleFormatter:e}}},{key:"getSeriesName",value:function(t){var e=t.fn,i=t.index,a=t.seriesIndex,s=t.j,r=this.w;return e(String(r.globals.seriesNames[i]),{series:r.globals.series,seriesIndex:a,dataPointIndex:s,w:r})}},{key:"DOMHandling",value:function(t){t.i;var e=t.t,i=t.j,a=t.ttItems,s=t.values,r=t.seriesName,o=t.shared,n=t.pColor,l=this.w,h=this.ttCtx,c=s.val,d=s.goalVals,g=s.xVal,u=s.xAxisTTVal,p=s.zVal,f=null;f=a[e].children,l.config.tooltip.fillSeriesColor&&(a[e].style.backgroundColor=n,f[0].style.display="none"),h.showTooltipTitle&&(null===h.tooltipTitle&&(h.tooltipTitle=l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")),h.tooltipTitle.innerHTML=g),h.isXAxisTooltipEnabled&&(h.xaxisTooltipText.innerHTML=""!==u?u:g);var x=a[e].querySelector(".apexcharts-tooltip-text-y-label");x&&(x.innerHTML=r||"");var b=a[e].querySelector(".apexcharts-tooltip-text-y-value");b&&(b.innerHTML=void 0!==c?c:""),f[0]&&f[0].classList.contains("apexcharts-tooltip-marker")&&(l.config.tooltip.marker.fillColors&&Array.isArray(l.config.tooltip.marker.fillColors)&&(n=l.config.tooltip.marker.fillColors[e]),f[0].style.backgroundColor=n),l.config.tooltip.marker.show||(f[0].style.display="none");var v=a[e].querySelector(".apexcharts-tooltip-text-goals-label"),m=a[e].querySelector(".apexcharts-tooltip-text-goals-value");if(d.length&&l.globals.seriesGoals[e]){var y=function(){var t="<div >",e="<div>";d.forEach((function(i,a){t+=' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor,'; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name,"</div>"),e+="<div>".concat(i.val,"</div>")})),v.innerHTML=t+"</div>",m.innerHTML=e+"</div>"};o?l.globals.seriesGoals[e][i]&&Array.isArray(l.globals.seriesGoals[e][i])?y():(v.innerHTML="",m.innerHTML=""):y()}else v.innerHTML="",m.innerHTML="";null!==p&&(a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML=l.config.tooltip.z.title,a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML=void 0!==p?p:"");if(o&&f[0]){if(l.config.tooltip.hideEmptySeries){var w=a[e].querySelector(".apexcharts-tooltip-marker"),k=a[e].querySelector(".apexcharts-tooltip-text");0==parseFloat(c)?(w.style.display="none",k.style.display="none"):(w.style.display="block",k.style.display="block")}null==c||l.globals.ancillaryCollapsedSeriesIndices.indexOf(e)>-1||l.globals.collapsedSeriesIndices.indexOf(e)>-1?f[0].parentNode.style.display="none":f[0].parentNode.style.display=l.config.tooltip.items.display}}},{key:"toggleActiveInactiveSeries",value:function(t){var e=this.w;if(t)this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");else{this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");var i=e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");i&&(i.classList.add("apexcharts-active"),i.style.display=e.config.tooltip.items.display)}}},{key:"getValuesToPrint",value:function(t){var e=t.i,i=t.j,a=this.w,s=this.ctx.series.filteredSeriesX(),r="",o="",n=null,l=null,h={series:a.globals.series,seriesIndex:e,dataPointIndex:i,w:a},c=a.globals.ttZFormatter;null===i?l=a.globals.series[e]:a.globals.isXNumeric&&"treemap"!==a.config.chart.type?(r=s[e][i],0===s[e].length&&(r=s[this.tooltipUtil.getFirstActiveXArray(s)][i])):r=void 0!==a.globals.labels[i]?a.globals.labels[i]:"";var d=r;a.globals.isXNumeric&&"datetime"===a.config.xaxis.type?r=new S(this.ctx).xLabelFormat(a.globals.ttKeyFormatter,d,d,{i:void 0,dateFormatter:new A(this.ctx).formatDate,w:this.w}):r=a.globals.isBarHorizontal?a.globals.yLabelFormatters[0](d,h):a.globals.xLabelFormatter(d,h);return void 0!==a.config.tooltip.x.formatter&&(r=a.globals.ttKeyFormatter(d,h)),a.globals.seriesZ.length>0&&a.globals.seriesZ[e].length>0&&(n=c(a.globals.seriesZ[e][i],a)),o="function"==typeof a.config.xaxis.tooltip.formatter?a.globals.xaxisTooltipFormatter(d,h):r,{val:Array.isArray(l)?l.join(" "):l,xVal:Array.isArray(r)?r.join(" "):r,xAxisTTVal:Array.isArray(o)?o.join(" "):o,zVal:n}}},{key:"handleCustomTooltip",value:function(t){var e=t.i,i=t.j,a=t.y1,s=t.y2,r=t.w,o=this.ttCtx.getElTooltip(),n=r.config.tooltip.custom;Array.isArray(n)&&n[e]&&(n=n[e]),o.innerHTML=n({ctx:this.ctx,series:r.globals.series,seriesIndex:e,dataPointIndex:i,y1:a,y2:s,w:r})}}]),t}(),ut=function(){function t(e){a(this,t),this.ttCtx=e,this.ctx=e.ctx,this.w=e.w}return r(t,[{key:"moveXCrosshairs",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.ttCtx,a=this.w,s=i.getElXCrosshairs(),r=t-i.xcrosshairsWidth/2,o=a.globals.labels.slice().length;if(null!==e&&(r=a.globals.gridWidth/o*e),null===s||a.globals.isBarHorizontal||(s.setAttribute("x",r),s.setAttribute("x1",r),s.setAttribute("x2",r),s.setAttribute("y2",a.globals.gridHeight),s.classList.add("apexcharts-active")),r<0&&(r=0),r>a.globals.gridWidth&&(r=a.globals.gridWidth),i.isXAxisTooltipEnabled){var n=r;"tickWidth"!==a.config.xaxis.crosshairs.width&&"barWidth"!==a.config.xaxis.crosshairs.width||(n=r+i.xcrosshairsWidth/2),this.moveXAxisTooltip(n)}}},{key:"moveYCrosshairs",value:function(t){var e=this.ttCtx;null!==e.ycrosshairs&&m.setAttrs(e.ycrosshairs,{y1:t,y2:t}),null!==e.ycrosshairsHidden&&m.setAttrs(e.ycrosshairsHidden,{y1:t,y2:t})}},{key:"moveXAxisTooltip",value:function(t){var e=this.w,i=this.ttCtx;if(null!==i.xaxisTooltip&&0!==i.xcrosshairsWidth){i.xaxisTooltip.classList.add("apexcharts-active");var a=i.xaxisOffY+e.config.xaxis.tooltip.offsetY+e.globals.translateY+1+e.config.xaxis.offsetY;if(t-=i.xaxisTooltip.getBoundingClientRect().width/2,!isNaN(t)){t+=e.globals.translateX;var s;s=new m(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML),i.xaxisTooltipText.style.minWidth=s.width+"px",i.xaxisTooltip.style.left=t+"px",i.xaxisTooltip.style.top=a+"px"}}}},{key:"moveYAxisTooltip",value:function(t){var e=this.w,i=this.ttCtx;null===i.yaxisTTEls&&(i.yaxisTTEls=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));var a=parseInt(i.ycrosshairsHidden.getAttribute("y1"),10),s=e.globals.translateY+a,r=i.yaxisTTEls[t].getBoundingClientRect().height,o=e.globals.translateYAxisX[t]-2;e.config.yaxis[t].opposite&&(o-=26),s-=r/2,-1===e.globals.ignoreYAxisIndexes.indexOf(t)?(i.yaxisTTEls[t].classList.add("apexcharts-active"),i.yaxisTTEls[t].style.top=s+"px",i.yaxisTTEls[t].style.left=o+e.config.yaxis[t].tooltip.offsetX+"px"):i.yaxisTTEls[t].classList.remove("apexcharts-active")}},{key:"moveTooltip",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=this.w,s=this.ttCtx,r=s.getElTooltip(),o=s.tooltipRect,n=null!==i?parseFloat(i):1,l=parseFloat(t)+n+5,h=parseFloat(e)+n/2;if(l>a.globals.gridWidth/2&&(l=l-o.ttWidth-n-10),l>a.globals.gridWidth-o.ttWidth-10&&(l=a.globals.gridWidth-o.ttWidth),l<-20&&(l=-20),a.config.tooltip.followCursor){var c=s.getElGrid().getBoundingClientRect();(l=s.e.clientX-c.left)>a.globals.gridWidth/2&&(l-=s.tooltipRect.ttWidth),(h=s.e.clientY+a.globals.translateY-c.top)>a.globals.gridHeight/2&&(h-=s.tooltipRect.ttHeight)}else a.globals.isBarHorizontal||o.ttHeight/2+h>a.globals.gridHeight&&(h=a.globals.gridHeight-o.ttHeight+a.globals.translateY);isNaN(l)||(l+=a.globals.translateX,r.style.left=l+"px",r.style.top=h+"px")}},{key:"moveMarkers",value:function(t,e){var i=this.w,a=this.ttCtx;if(i.globals.markers.size[t]>0)for(var s=i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t,"'] .apexcharts-marker")),r=0;r<s.length;r++)parseInt(s[r].getAttribute("rel"),10)===e&&(a.marker.resetPointsSize(),a.marker.enlargeCurrentPoint(e,s[r]));else a.marker.resetPointsSize(),this.moveDynamicPointOnHover(e,t)}},{key:"moveDynamicPointOnHover",value:function(t,e){var i,a,s=this.w,r=this.ttCtx,o=s.globals.pointsArray,n=r.tooltipUtil.getHoverMarkerSize(e),l=s.config.series[e].type;if(!l||"column"!==l&&"candlestick"!==l&&"boxPlot"!==l){i=o[e][t][0],a=o[e][t][1]?o[e][t][1]:0;var h=s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e,"'] .apexcharts-series-markers circle"));h&&a<s.globals.gridHeight&&a>0&&(h.setAttribute("r",n),h.setAttribute("cx",i),h.setAttribute("cy",a)),this.moveXCrosshairs(i),r.fixedTooltip||this.moveTooltip(i,a,n)}}},{key:"moveDynamicPointsOnHover",value:function(t){var e,i=this.ttCtx,a=i.w,s=0,r=0,o=a.globals.pointsArray;e=new W(this.ctx).getActiveConfigSeriesIndex("asc",["line","area","scatter","bubble"]);var n=i.tooltipUtil.getHoverMarkerSize(e);o[e]&&(s=o[e][t][0],r=o[e][t][1]);var l=i.tooltipUtil.getAllMarkers();if(null!==l)for(var h=0;h<a.globals.series.length;h++){var c=o[h];if(a.globals.comboCharts&&void 0===c&&l.splice(h,0,null),c&&c.length){var d=o[h][t][1],g=void 0;if(l[h].setAttribute("cx",s),"rangeArea"===a.config.chart.type&&!a.globals.comboCharts){var u=t+a.globals.series[h].length;g=o[h][u][1],d-=Math.abs(d-g)/2}null!==d&&!isNaN(d)&&d<a.globals.gridHeight+n&&d+n>0?(l[h]&&l[h].setAttribute("r",n),l[h]&&l[h].setAttribute("cy",d)):l[h]&&l[h].setAttribute("r",0)}}this.moveXCrosshairs(s),i.fixedTooltip||this.moveTooltip(s,r||a.globals.gridHeight,n)}},{key:"moveStickyTooltipOverBars",value:function(t,e){var i=this.w,a=this.ttCtx,s=i.globals.columnSeries?i.globals.columnSeries.length:i.globals.series.length,r=s>=2&&s%2==0?Math.floor(s/2):Math.floor(s/2)+1;i.globals.isBarHorizontal&&(r=new W(this.ctx).getActiveConfigSeriesIndex("desc")+1);var o=i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r,"'] path[j='").concat(t,"'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r,"'] path[j='").concat(t,"'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r,"'] path[j='").concat(t,"'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r,"'] path[j='").concat(t,"']"));o||"number"!=typeof e||(o=i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e,"'] path[j='").concat(t,"'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e,"'] path[j='").concat(t,"'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e,"'] path[j='").concat(t,"'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e,"'] path[j='").concat(t,"']")));var n=o?parseFloat(o.getAttribute("cx")):0,l=o?parseFloat(o.getAttribute("cy")):0,h=o?parseFloat(o.getAttribute("barWidth")):0,c=a.getElGrid().getBoundingClientRect(),d=o&&(o.classList.contains("apexcharts-candlestick-area")||o.classList.contains("apexcharts-boxPlot-area"));i.globals.isXNumeric?(o&&!d&&(n-=s%2!=0?h/2:0),o&&d&&i.globals.comboCharts&&(n-=h/2)):i.globals.isBarHorizontal||(n=a.xAxisTicksPositions[t-1]+a.dataPointsDividedWidth/2,isNaN(n)&&(n=a.xAxisTicksPositions[t]-a.dataPointsDividedWidth/2)),i.globals.isBarHorizontal?l-=a.tooltipRect.ttHeight:i.config.tooltip.followCursor?l=a.e.clientY-c.top-a.tooltipRect.ttHeight/2:l+a.tooltipRect.ttHeight+15>i.globals.gridHeight&&(l=i.globals.gridHeight),i.globals.isBarHorizontal||this.moveXCrosshairs(n),a.fixedTooltip||this.moveTooltip(n,l||i.globals.gridHeight)}}]),t}(),pt=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e,this.ctx=e.ctx,this.tooltipPosition=new ut(e)}return r(t,[{key:"drawDynamicPoints",value:function(){var t=this.w,e=new m(this.ctx),i=new D(this.ctx),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");a=u(a),t.config.chart.stacked&&a.sort((function(t,e){return parseFloat(t.getAttribute("data:realIndex"))-parseFloat(e.getAttribute("data:realIndex"))}));for(var s=0;s<a.length;s++){var r=a[s].querySelector(".apexcharts-series-markers-wrap");if(null!==r){var o=void 0,n="apexcharts-marker w".concat((Math.random()+1).toString(36).substring(4));"line"!==t.config.chart.type&&"area"!==t.config.chart.type||t.globals.comboCharts||t.config.tooltip.intersect||(n+=" no-pointer-events");var l=i.getMarkerConfig({cssClass:n,seriesIndex:Number(r.getAttribute("data:realIndex"))});(o=e.drawMarker(0,0,l)).node.setAttribute("default-marker-size",0);var h=document.createElementNS(t.globals.SVGNS,"g");h.classList.add("apexcharts-series-markers"),h.appendChild(o.node),r.appendChild(h)}}}},{key:"enlargeCurrentPoint",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,s=this.w;"bubble"!==s.config.chart.type&&this.newPointSize(t,e);var r=e.getAttribute("cx"),o=e.getAttribute("cy");if(null!==i&&null!==a&&(r=i,o=a),this.tooltipPosition.moveXCrosshairs(r),!this.fixedTooltip){if("radar"===s.config.chart.type){var n=this.ttCtx.getElGrid().getBoundingClientRect();r=this.ttCtx.e.clientX-n.left}this.tooltipPosition.moveTooltip(r,o,s.config.markers.hover.size)}}},{key:"enlargePoints",value:function(t){for(var e=this.w,i=this,a=this.ttCtx,s=t,r=e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"),o=e.config.markers.hover.size,n=0;n<r.length;n++){var l=r[n].getAttribute("rel"),h=r[n].getAttribute("index");if(void 0===o&&(o=e.globals.markers.size[h]+e.config.markers.hover.sizeOffset),s===parseInt(l,10)){i.newPointSize(s,r[n]);var c=r[n].getAttribute("cx"),d=r[n].getAttribute("cy");i.tooltipPosition.moveXCrosshairs(c),a.fixedTooltip||i.tooltipPosition.moveTooltip(c,d,o)}else i.oldPointSize(r[n])}}},{key:"newPointSize",value:function(t,e){var i=this.w,a=i.config.markers.hover.size,s=0===t?e.parentNode.firstChild:e.parentNode.lastChild;if("0"!==s.getAttribute("default-marker-size")){var r=parseInt(s.getAttribute("index"),10);void 0===a&&(a=i.globals.markers.size[r]+i.config.markers.hover.sizeOffset),a<0&&(a=0),s.setAttribute("r",a)}}},{key:"oldPointSize",value:function(t){var e=parseFloat(t.getAttribute("default-marker-size"));t.setAttribute("r",e)}},{key:"resetPointsSize",value:function(){for(var t=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"),e=0;e<t.length;e++){var i=parseFloat(t[e].getAttribute("default-marker-size"));x.isNumber(i)&&i>=0?t[e].setAttribute("r",i):t[e].setAttribute("r",0)}}}]),t}(),ft=function(){function t(e){a(this,t),this.w=e.w;var i=this.w;this.ttCtx=e,this.isVerticalGroupedRangeBar=!i.globals.isBarHorizontal&&"rangeBar"===i.config.chart.type&&i.config.plotOptions.bar.rangeBarGroupRows}return r(t,[{key:"getAttr",value:function(t,e){return parseFloat(t.target.getAttribute(e))}},{key:"handleHeatTreeTooltip",value:function(t){var e=t.e,i=t.opt,a=t.x,s=t.y,r=t.type,o=this.ttCtx,n=this.w;if(e.target.classList.contains("apexcharts-".concat(r,"-rect"))){var l=this.getAttr(e,"i"),h=this.getAttr(e,"j"),c=this.getAttr(e,"cx"),d=this.getAttr(e,"cy"),g=this.getAttr(e,"width"),u=this.getAttr(e,"height");if(o.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:l,j:h,shared:!1,e:e}),n.globals.capturedSeriesIndex=l,n.globals.capturedDataPointIndex=h,a=c+o.tooltipRect.ttWidth/2+g,s=d+o.tooltipRect.ttHeight/2-u/2,o.tooltipPosition.moveXCrosshairs(c+g/2),a>n.globals.gridWidth/2&&(a=c-o.tooltipRect.ttWidth/2+g),o.w.config.tooltip.followCursor){var p=n.globals.dom.elWrap.getBoundingClientRect();a=n.globals.clientX-p.left-(a>n.globals.gridWidth/2?o.tooltipRect.ttWidth:0),s=n.globals.clientY-p.top-(s>n.globals.gridHeight/2?o.tooltipRect.ttHeight:0)}}return{x:a,y:s}}},{key:"handleMarkerTooltip",value:function(t){var e,i,a=t.e,s=t.opt,r=t.x,o=t.y,n=this.w,l=this.ttCtx;if(a.target.classList.contains("apexcharts-marker")){var h=parseInt(s.paths.getAttribute("cx"),10),c=parseInt(s.paths.getAttribute("cy"),10),d=parseFloat(s.paths.getAttribute("val"));if(i=parseInt(s.paths.getAttribute("rel"),10),e=parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"),10)-1,l.intersect){var g=x.findAncestor(s.paths,"apexcharts-series");g&&(e=parseInt(g.getAttribute("data:realIndex"),10))}if(l.tooltipLabels.drawSeriesTexts({ttItems:s.ttItems,i:e,j:i,shared:!l.showOnIntersect&&n.config.tooltip.shared,e:a}),"mouseup"===a.type&&l.markerClick(a,e,i),n.globals.capturedSeriesIndex=e,n.globals.capturedDataPointIndex=i,r=h,o=c+n.globals.translateY-1.4*l.tooltipRect.ttHeight,l.w.config.tooltip.followCursor){var u=l.getElGrid().getBoundingClientRect();o=l.e.clientY+n.globals.translateY-u.top}d<0&&(o=c),l.marker.enlargeCurrentPoint(i,s.paths,r,o)}return{x:r,y:o}}},{key:"handleBarTooltip",value:function(t){var e,i,a=t.e,s=t.opt,r=this.w,o=this.ttCtx,n=o.getElTooltip(),l=0,h=0,c=0,d=this.getBarTooltipXY({e:a,opt:s});e=d.i;var g=d.barHeight,u=d.j;r.globals.capturedSeriesIndex=e,r.globals.capturedDataPointIndex=u,r.globals.isBarHorizontal&&o.tooltipUtil.hasBars()||!r.config.tooltip.shared?(h=d.x,c=d.y,i=Array.isArray(r.config.stroke.width)?r.config.stroke.width[e]:r.config.stroke.width,l=h):r.globals.comboCharts||r.config.tooltip.shared||(l/=2),isNaN(c)&&(c=r.globals.svgHeight-o.tooltipRect.ttHeight);var p=parseInt(s.paths.parentNode.getAttribute("data:realIndex"),10),f=r.globals.isMultipleYAxis?r.config.yaxis[p]&&r.config.yaxis[p].reversed:r.config.yaxis[0].reversed;if(h+o.tooltipRect.ttWidth>r.globals.gridWidth&&!f?h-=o.tooltipRect.ttWidth:h<0&&(h=0),o.w.config.tooltip.followCursor){var x=o.getElGrid().getBoundingClientRect();c=o.e.clientY-x.top}null===o.tooltip&&(o.tooltip=r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")),r.config.tooltip.shared||(r.globals.comboBarCount>0?o.tooltipPosition.moveXCrosshairs(l+i/2):o.tooltipPosition.moveXCrosshairs(l)),!o.fixedTooltip&&(!r.config.tooltip.shared||r.globals.isBarHorizontal&&o.tooltipUtil.hasBars())&&(f&&(h-=o.tooltipRect.ttWidth)<0&&(h=0),!f||r.globals.isBarHorizontal&&o.tooltipUtil.hasBars()||(c=c+g-2*(r.globals.series[e][u]<0?g:0)),c=c+r.globals.translateY-o.tooltipRect.ttHeight/2,n.style.left=h+r.globals.translateX+"px",n.style.top=c+"px")}},{key:"getBarTooltipXY",value:function(t){var e=this,i=t.e,a=t.opt,s=this.w,r=null,o=this.ttCtx,n=0,l=0,h=0,c=0,d=0,g=i.target.classList;if(g.contains("apexcharts-bar-area")||g.contains("apexcharts-candlestick-area")||g.contains("apexcharts-boxPlot-area")||g.contains("apexcharts-rangebar-area")){var u=i.target,p=u.getBoundingClientRect(),f=a.elGrid.getBoundingClientRect(),x=p.height;d=p.height;var b=p.width,v=parseInt(u.getAttribute("cx"),10),m=parseInt(u.getAttribute("cy"),10);c=parseFloat(u.getAttribute("barWidth"));var y="touchmove"===i.type?i.touches[0].clientX:i.clientX;r=parseInt(u.getAttribute("j"),10),n=parseInt(u.parentNode.getAttribute("rel"),10)-1;var w=u.getAttribute("data-range-y1"),k=u.getAttribute("data-range-y2");s.globals.comboCharts&&(n=parseInt(u.parentNode.getAttribute("data:realIndex"),10));var A=function(t){return s.globals.isXNumeric?v-b/2:e.isVerticalGroupedRangeBar?v+b/2:v-o.dataPointsDividedWidth+b/2},S=function(){return m-o.dataPointsDividedHeight+x/2-o.tooltipRect.ttHeight/2};o.tooltipLabels.drawSeriesTexts({ttItems:a.ttItems,i:n,j:r,y1:w?parseInt(w,10):null,y2:k?parseInt(k,10):null,shared:!o.showOnIntersect&&s.config.tooltip.shared,e:i}),s.config.tooltip.followCursor?s.globals.isBarHorizontal?(l=y-f.left+15,h=S()):(l=A(),h=i.clientY-f.top-o.tooltipRect.ttHeight/2-15):s.globals.isBarHorizontal?((l=v)<o.xyRatios.baseLineInvertedY&&(l=v-o.tooltipRect.ttWidth),h=S()):(l=A(),h=m)}return{x:l,y:h,barHeight:d,barWidth:c,i:n,j:r}}}]),t}(),xt=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e}return r(t,[{key:"drawXaxisTooltip",value:function(){var t=this.w,e=this.ttCtx,i="bottom"===t.config.xaxis.position;e.xaxisOffY=i?t.globals.gridHeight+1:-t.globals.xAxisHeight-t.config.xaxis.axisTicks.height+3;var a=i?"apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom":"apexcharts-xaxistooltip apexcharts-xaxistooltip-top",s=t.globals.dom.elWrap;e.isXAxisTooltipEnabled&&(null===t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip")&&(e.xaxisTooltip=document.createElement("div"),e.xaxisTooltip.setAttribute("class",a+" apexcharts-theme-"+t.config.tooltip.theme),s.appendChild(e.xaxisTooltip),e.xaxisTooltipText=document.createElement("div"),e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"),e.xaxisTooltipText.style.fontFamily=t.config.xaxis.tooltip.style.fontFamily||t.config.chart.fontFamily,e.xaxisTooltipText.style.fontSize=t.config.xaxis.tooltip.style.fontSize,e.xaxisTooltip.appendChild(e.xaxisTooltipText)))}},{key:"drawYaxisTooltip",value:function(){for(var t=this.w,e=this.ttCtx,i=0;i<t.config.yaxis.length;i++){var a=t.config.yaxis[i].opposite||t.config.yaxis[i].crosshairs.opposite;e.yaxisOffX=a?t.globals.gridWidth+1:1;var s="apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i,a?" apexcharts-yaxistooltip-right":" apexcharts-yaxistooltip-left"),r=t.globals.dom.elWrap;null===t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i))&&(e.yaxisTooltip=document.createElement("div"),e.yaxisTooltip.setAttribute("class",s+" apexcharts-theme-"+t.config.tooltip.theme),r.appendChild(e.yaxisTooltip),0===i&&(e.yaxisTooltipText=[]),e.yaxisTooltipText[i]=document.createElement("div"),e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"),e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]))}}},{key:"setXCrosshairWidth",value:function(){var t=this.w,e=this.ttCtx,i=e.getElXCrosshairs();if(e.xcrosshairsWidth=parseInt(t.config.xaxis.crosshairs.width,10),t.globals.comboCharts){var a=t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");if(null!==a&&"barWidth"===t.config.xaxis.crosshairs.width){var s=parseFloat(a.getAttribute("barWidth"));e.xcrosshairsWidth=s}else if("tickWidth"===t.config.xaxis.crosshairs.width){var r=t.globals.labels.length;e.xcrosshairsWidth=t.globals.gridWidth/r}}else if("tickWidth"===t.config.xaxis.crosshairs.width){var o=t.globals.labels.length;e.xcrosshairsWidth=t.globals.gridWidth/o}else if("barWidth"===t.config.xaxis.crosshairs.width){var n=t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");if(null!==n){var l=parseFloat(n.getAttribute("barWidth"));e.xcrosshairsWidth=l}else e.xcrosshairsWidth=1}t.globals.isBarHorizontal&&(e.xcrosshairsWidth=0),null!==i&&e.xcrosshairsWidth>0&&i.setAttribute("width",e.xcrosshairsWidth)}},{key:"handleYCrosshair",value:function(){var t=this.w,e=this.ttCtx;e.ycrosshairs=t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"),e.ycrosshairsHidden=t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden")}},{key:"drawYaxisTooltipText",value:function(t,e,i){var a=this.ttCtx,s=this.w,r=s.globals,o=r.seriesYAxisMap[t];if(a.yaxisTooltips[t]&&o.length>0){var n=r.yLabelFormatters[t],l=a.getElGrid().getBoundingClientRect(),h=o[0];i.yRatio.length>1&&function(t){throw new TypeError('"'+t+'" is read-only')}("translationsIndex");var c=(e-l.top)*i.yRatio[0],d=r.maxYArr[h]-r.minYArr[h],g=r.minYArr[h]+(d-c);s.config.yaxis[t].reversed&&(g=r.maxYArr[h]-(d-c)),a.tooltipPosition.moveYCrosshairs(e-l.top),a.yaxisTooltipText[t].innerHTML=n(g),a.tooltipPosition.moveYAxisTooltip(t)}}}]),t}(),bt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.tConfig=i.config.tooltip,this.tooltipUtil=new dt(this),this.tooltipLabels=new gt(this),this.tooltipPosition=new ut(this),this.marker=new pt(this),this.intersect=new ft(this),this.axesTooltip=new xt(this),this.showOnIntersect=this.tConfig.intersect,this.showTooltipTitle=this.tConfig.x.show,this.fixedTooltip=this.tConfig.fixed.enabled,this.xaxisTooltip=null,this.yaxisTTEls=null,this.isBarShared=!i.globals.isBarHorizontal&&this.tConfig.shared,this.lastHoverTime=Date.now()}return r(t,[{key:"getElTooltip",value:function(t){return t||(t=this),t.w.globals.dom.baseEl?t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip"):null}},{key:"getElXCrosshairs",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs")}},{key:"getElGrid",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid")}},{key:"drawTooltip",value:function(t){var e=this.w;this.xyRatios=t,this.isXAxisTooltipEnabled=e.config.xaxis.tooltip.enabled&&e.globals.axisCharts,this.yaxisTooltips=e.config.yaxis.map((function(t,i){return!!(t.show&&t.tooltip.enabled&&e.globals.axisCharts)})),this.allTooltipSeriesGroups=[],e.globals.axisCharts||(this.showTooltipTitle=!1);var i=document.createElement("div");if(i.classList.add("apexcharts-tooltip"),e.config.tooltip.cssClass&&i.classList.add(e.config.tooltip.cssClass),i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)),e.globals.dom.elWrap.appendChild(i),e.globals.axisCharts){this.axesTooltip.drawXaxisTooltip(),this.axesTooltip.drawYaxisTooltip(),this.axesTooltip.setXCrosshairWidth(),this.axesTooltip.handleYCrosshair();var a=new V(this.ctx);this.xAxisTicksPositions=a.getXAxisTicksPositions()}if(!e.globals.comboCharts&&!this.tConfig.intersect&&"rangeBar"!==e.config.chart.type||this.tConfig.shared||(this.showOnIntersect=!0),0!==e.config.markers.size&&0!==e.globals.markers.largestSize||this.marker.drawDynamicPoints(this),e.globals.collapsedSeries.length!==e.globals.series.length){this.dataPointsDividedHeight=e.globals.gridHeight/e.globals.dataPoints,this.dataPointsDividedWidth=e.globals.gridWidth/e.globals.dataPoints,this.showTooltipTitle&&(this.tooltipTitle=document.createElement("div"),this.tooltipTitle.classList.add("apexcharts-tooltip-title"),this.tooltipTitle.style.fontFamily=this.tConfig.style.fontFamily||e.config.chart.fontFamily,this.tooltipTitle.style.fontSize=this.tConfig.style.fontSize,i.appendChild(this.tooltipTitle));var s=e.globals.series.length;(e.globals.xyCharts||e.globals.comboCharts)&&this.tConfig.shared&&(s=this.showOnIntersect?1:e.globals.series.length),this.legendLabels=e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"),this.ttItems=this.createTTElements(s),this.addSVGEvents()}}},{key:"createTTElements",value:function(t){for(var e=this,i=this.w,a=[],s=this.getElTooltip(),r=function(r){var o=document.createElement("div");o.classList.add("apexcharts-tooltip-series-group"),o.style.order=i.config.tooltip.inverseOrder?t-r:r+1,e.tConfig.shared&&e.tConfig.enabledOnSeries&&Array.isArray(e.tConfig.enabledOnSeries)&&e.tConfig.enabledOnSeries.indexOf(r)<0&&o.classList.add("apexcharts-tooltip-series-group-hidden");var n=document.createElement("span");n.classList.add("apexcharts-tooltip-marker"),n.style.backgroundColor=i.globals.colors[r],o.appendChild(n);var l=document.createElement("div");l.classList.add("apexcharts-tooltip-text"),l.style.fontFamily=e.tConfig.style.fontFamily||i.config.chart.fontFamily,l.style.fontSize=e.tConfig.style.fontSize,["y","goals","z"].forEach((function(t){var e=document.createElement("div");e.classList.add("apexcharts-tooltip-".concat(t,"-group"));var i=document.createElement("span");i.classList.add("apexcharts-tooltip-text-".concat(t,"-label")),e.appendChild(i);var a=document.createElement("span");a.classList.add("apexcharts-tooltip-text-".concat(t,"-value")),e.appendChild(a),l.appendChild(e)})),o.appendChild(l),s.appendChild(o),a.push(o)},o=0;o<t;o++)r(o);return a}},{key:"addSVGEvents",value:function(){var t=this.w,e=t.config.chart.type,i=this.getElTooltip(),a=!("bar"!==e&&"candlestick"!==e&&"boxPlot"!==e&&"rangeBar"!==e),s="area"===e||"line"===e||"scatter"===e||"bubble"===e||"radar"===e,r=t.globals.dom.Paper.node,o=this.getElGrid();o&&(this.seriesBound=o.getBoundingClientRect());var n,l=[],h=[],c={hoverArea:r,elGrid:o,tooltipEl:i,tooltipY:l,tooltipX:h,ttItems:this.ttItems};if(t.globals.axisCharts&&(s?n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker"):a?n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area"):"heatmap"!==e&&"treemap"!==e||(n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")),n&&n.length))for(var d=0;d<n.length;d++)l.push(n[d].getAttribute("cy")),h.push(n[d].getAttribute("cx"));if(t.globals.xyCharts&&!this.showOnIntersect||t.globals.comboCharts&&!this.showOnIntersect||a&&this.tooltipUtil.hasBars()&&this.tConfig.shared)this.addPathsEventListeners([r],c);else if(a&&!t.globals.comboCharts||s&&this.showOnIntersect)this.addDatapointEventsListeners(c);else if(!t.globals.axisCharts||"heatmap"===e||"treemap"===e){var g=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");this.addPathsEventListeners(g,c)}if(this.showOnIntersect){var u=t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");u.length>0&&this.addPathsEventListeners(u,c),this.tooltipUtil.hasBars()&&!this.tConfig.shared&&this.addDatapointEventsListeners(c)}}},{key:"drawFixedTooltipRect",value:function(){var t=this.w,e=this.getElTooltip(),i=e.getBoundingClientRect(),a=i.width+10,s=i.height+10,r=this.tConfig.fixed.offsetX,o=this.tConfig.fixed.offsetY,n=this.tConfig.fixed.position.toLowerCase();return n.indexOf("right")>-1&&(r=r+t.globals.svgWidth-a+10),n.indexOf("bottom")>-1&&(o=o+t.globals.svgHeight-s-10),e.style.left=r+"px",e.style.top=o+"px",{x:r,y:o,ttWidth:a,ttHeight:s}}},{key:"addDatapointEventsListeners",value:function(t){var e=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");this.addPathsEventListeners(e,t)}},{key:"addPathsEventListeners",value:function(t,e){for(var i=this,a=function(a){var s={paths:t[a],tooltipEl:e.tooltipEl,tooltipY:e.tooltipY,tooltipX:e.tooltipX,elGrid:e.elGrid,hoverArea:e.hoverArea,ttItems:e.ttItems};["mousemove","mouseup","touchmove","mouseout","touchend"].map((function(e){return t[a].addEventListener(e,i.onSeriesHover.bind(i,s),{capture:!1,passive:!0})}))},s=0;s<t.length;s++)a(s)}},{key:"onSeriesHover",value:function(t,e){var i=this,a=Date.now()-this.lastHoverTime;a>=100?this.seriesHover(t,e):(clearTimeout(this.seriesHoverTimeout),this.seriesHoverTimeout=setTimeout((function(){i.seriesHover(t,e)}),100-a))}},{key:"seriesHover",value:function(t,e){var i=this;this.lastHoverTime=Date.now();var a=[],s=this.w;s.config.chart.group&&(a=this.ctx.getGroupedCharts()),s.globals.axisCharts&&(s.globals.minX===-1/0&&s.globals.maxX===1/0||0===s.globals.dataPoints)||(a.length?a.forEach((function(a){var s=i.getElTooltip(a),r={paths:t.paths,tooltipEl:s,tooltipY:t.tooltipY,tooltipX:t.tooltipX,elGrid:t.elGrid,hoverArea:t.hoverArea,ttItems:a.w.globals.tooltip.ttItems};a.w.globals.minX===i.w.globals.minX&&a.w.globals.maxX===i.w.globals.maxX&&a.w.globals.tooltip.seriesHoverByContext({chartCtx:a,ttCtx:a.w.globals.tooltip,opt:r,e:e})})):this.seriesHoverByContext({chartCtx:this.ctx,ttCtx:this.w.globals.tooltip,opt:t,e:e}))}},{key:"seriesHoverByContext",value:function(t){var e=t.chartCtx,i=t.ttCtx,a=t.opt,s=t.e,r=e.w,o=this.getElTooltip();if(o){if(i.tooltipRect={x:0,y:0,ttWidth:o.getBoundingClientRect().width,ttHeight:o.getBoundingClientRect().height},i.e=s,i.tooltipUtil.hasBars()&&!r.globals.comboCharts&&!i.isBarShared)if(this.tConfig.onDatasetHover.highlightDataSeries)new W(e).toggleSeriesOnHover(s,s.target.parentNode);i.fixedTooltip&&i.drawFixedTooltipRect(),r.globals.axisCharts?i.axisChartsTooltips({e:s,opt:a,tooltipRect:i.tooltipRect}):i.nonAxisChartsTooltips({e:s,opt:a,tooltipRect:i.tooltipRect})}}},{key:"axisChartsTooltips",value:function(t){var e,i,a=t.e,s=t.opt,r=this.w,o=s.elGrid.getBoundingClientRect(),n="touchmove"===a.type?a.touches[0].clientX:a.clientX,l="touchmove"===a.type?a.touches[0].clientY:a.clientY;if(this.clientY=l,this.clientX=n,r.globals.capturedSeriesIndex=-1,r.globals.capturedDataPointIndex=-1,l<o.top||l>o.top+o.height)this.handleMouseOut(s);else{if(Array.isArray(this.tConfig.enabledOnSeries)&&!r.config.tooltip.shared){var h=parseInt(s.paths.getAttribute("index"),10);if(this.tConfig.enabledOnSeries.indexOf(h)<0)return void this.handleMouseOut(s)}var c=this.getElTooltip(),d=this.getElXCrosshairs(),g=r.globals.xyCharts||"bar"===r.config.chart.type&&!r.globals.isBarHorizontal&&this.tooltipUtil.hasBars()&&this.tConfig.shared||r.globals.comboCharts&&this.tooltipUtil.hasBars();if("mousemove"===a.type||"touchmove"===a.type||"mouseup"===a.type){if(r.globals.collapsedSeries.length+r.globals.ancillaryCollapsedSeries.length===r.globals.series.length)return;null!==d&&d.classList.add("apexcharts-active");var u=this.yaxisTooltips.filter((function(t){return!0===t}));if(null!==this.ycrosshairs&&u.length&&this.ycrosshairs.classList.add("apexcharts-active"),g&&!this.showOnIntersect)this.handleStickyTooltip(a,n,l,s);else if("heatmap"===r.config.chart.type||"treemap"===r.config.chart.type){var p=this.intersect.handleHeatTreeTooltip({e:a,opt:s,x:e,y:i,type:r.config.chart.type});e=p.x,i=p.y,c.style.left=e+"px",c.style.top=i+"px"}else this.tooltipUtil.hasBars()&&this.intersect.handleBarTooltip({e:a,opt:s}),this.tooltipUtil.hasMarkers()&&this.intersect.handleMarkerTooltip({e:a,opt:s,x:e,y:i});if(this.yaxisTooltips.length)for(var f=0;f<r.config.yaxis.length;f++)this.axesTooltip.drawYaxisTooltipText(f,l,this.xyRatios);s.tooltipEl.classList.add("apexcharts-active")}else"mouseout"!==a.type&&"touchend"!==a.type||this.handleMouseOut(s)}}},{key:"nonAxisChartsTooltips",value:function(t){var e=t.e,i=t.opt,a=t.tooltipRect,s=this.w,r=i.paths.getAttribute("rel"),o=this.getElTooltip(),n=s.globals.dom.elWrap.getBoundingClientRect();if("mousemove"===e.type||"touchmove"===e.type){o.classList.add("apexcharts-active"),this.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:parseInt(r,10)-1,shared:!1});var l=s.globals.clientX-n.left-a.ttWidth/2,h=s.globals.clientY-n.top-a.ttHeight-10;if(o.style.left=l+"px",o.style.top=h+"px",s.config.legend.tooltipHoverFormatter){var c=r-1,d=(0,s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"),{seriesIndex:c,dataPointIndex:c,w:s});this.legendLabels[c].innerHTML=d}}else"mouseout"!==e.type&&"touchend"!==e.type||(o.classList.remove("apexcharts-active"),s.config.legend.tooltipHoverFormatter&&this.legendLabels.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)})))}},{key:"handleStickyTooltip",value:function(t,e,i,a){var s=this.w,r=this.tooltipUtil.getNearestValues({context:this,hoverArea:a.hoverArea,elGrid:a.elGrid,clientX:e,clientY:i}),o=r.j,n=r.capturedSeries;s.globals.collapsedSeriesIndices.includes(n)&&(n=null);var l=a.elGrid.getBoundingClientRect();if(r.hoverX<0||r.hoverX>l.width)this.handleMouseOut(a);else if(null!==n)this.handleStickyCapturedSeries(t,n,a,o);else if(this.tooltipUtil.isXoverlap(o)||s.globals.isBarHorizontal){var h=s.globals.series.findIndex((function(t,e){return!s.globals.collapsedSeriesIndices.includes(e)}));this.create(t,this,h,o,a.ttItems)}}},{key:"handleStickyCapturedSeries",value:function(t,e,i,a){var s=this.w;if(!this.tConfig.shared&&null===s.globals.series[e][a])return void this.handleMouseOut(i);if(void 0!==s.globals.series[e][a])this.tConfig.shared&&this.tooltipUtil.isXoverlap(a)&&this.tooltipUtil.isInitialSeriesSameLen()?this.create(t,this,e,a,i.ttItems):this.create(t,this,e,a,i.ttItems,!1);else if(this.tooltipUtil.isXoverlap(a)){var r=s.globals.series.findIndex((function(t,e){return!s.globals.collapsedSeriesIndices.includes(e)}));this.create(t,this,r,a,i.ttItems)}}},{key:"deactivateHoverFilter",value:function(){for(var t=this.w,e=new m(this.ctx),i=t.globals.dom.Paper.select(".apexcharts-bar-area"),a=0;a<i.length;a++)e.pathMouseLeave(i[a])}},{key:"handleMouseOut",value:function(t){var e=this.w,i=this.getElXCrosshairs();if(t.tooltipEl.classList.remove("apexcharts-active"),this.deactivateHoverFilter(),"bubble"!==e.config.chart.type&&this.marker.resetPointsSize(),null!==i&&i.classList.remove("apexcharts-active"),null!==this.ycrosshairs&&this.ycrosshairs.classList.remove("apexcharts-active"),this.isXAxisTooltipEnabled&&this.xaxisTooltip.classList.remove("apexcharts-active"),this.yaxisTooltips.length){null===this.yaxisTTEls&&(this.yaxisTTEls=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));for(var a=0;a<this.yaxisTTEls.length;a++)this.yaxisTTEls[a].classList.remove("apexcharts-active")}e.config.legend.tooltipHoverFormatter&&this.legendLabels.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)}))}},{key:"markerClick",value:function(t,e,i){var a=this.w;"function"==typeof a.config.chart.events.markerClick&&a.config.chart.events.markerClick(t,this.ctx,{seriesIndex:e,dataPointIndex:i,w:a}),this.ctx.events.fireEvent("markerClick",[t,this.ctx,{seriesIndex:e,dataPointIndex:i,w:a}])}},{key:"create",value:function(t,i,a,s,r){var o,n,l,h,c,d,g,u,p,f,x,b,v,y,w,k,A=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,S=this.w,C=i;"mouseup"===t.type&&this.markerClick(t,a,s),null===A&&(A=this.tConfig.shared);var L=this.tooltipUtil.hasMarkers(a),P=this.tooltipUtil.getElBars();if(S.config.legend.tooltipHoverFormatter){var M=S.config.legend.tooltipHoverFormatter,I=Array.from(this.legendLabels);I.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)}));for(var T=0;T<I.length;T++){var z=I[T],X=parseInt(z.getAttribute("i"),10),E=decodeURIComponent(z.getAttribute("data:default-text")),Y=M(E,{seriesIndex:A?X:a,dataPointIndex:s,w:S});if(A)z.innerHTML=S.globals.collapsedSeriesIndices.indexOf(X)<0?Y:E;else if(z.innerHTML=X===a?Y:E,a===X)break}}var F=e(e({ttItems:r,i:a,j:s},void 0!==(null===(o=S.globals.seriesRange)||void 0===o||null===(n=o[a])||void 0===n||null===(l=n[s])||void 0===l||null===(h=l.y[0])||void 0===h?void 0:h.y1)&&{y1:null===(c=S.globals.seriesRange)||void 0===c||null===(d=c[a])||void 0===d||null===(g=d[s])||void 0===g||null===(u=g.y[0])||void 0===u?void 0:u.y1}),void 0!==(null===(p=S.globals.seriesRange)||void 0===p||null===(f=p[a])||void 0===f||null===(x=f[s])||void 0===x||null===(b=x.y[0])||void 0===b?void 0:b.y2)&&{y2:null===(v=S.globals.seriesRange)||void 0===v||null===(y=v[a])||void 0===y||null===(w=y[s])||void 0===w||null===(k=w.y[0])||void 0===k?void 0:k.y2});if(A){if(C.tooltipLabels.drawSeriesTexts(e(e({},F),{},{shared:!this.showOnIntersect&&this.tConfig.shared})),L)S.globals.markers.largestSize>0?C.marker.enlargePoints(s):C.tooltipPosition.moveDynamicPointsOnHover(s);else if(this.tooltipUtil.hasBars()&&(this.barSeriesHeight=this.tooltipUtil.getBarsHeight(P),this.barSeriesHeight>0)){var R=new m(this.ctx),H=S.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(s,"']"));this.deactivateHoverFilter(),this.tooltipPosition.moveStickyTooltipOverBars(s,a);for(var D=0;D<H.length;D++)R.pathMouseEnter(H[D])}}else C.tooltipLabels.drawSeriesTexts(e({shared:!1},F)),this.tooltipUtil.hasBars()&&C.tooltipPosition.moveStickyTooltipOverBars(s,a),L&&C.tooltipPosition.moveMarkers(a,s)}}]),t}(),vt=function(){function t(e){a(this,t),this.w=e.w,this.barCtx=e,this.totalFormatter=this.w.config.plotOptions.bar.dataLabels.total.formatter,this.totalFormatter||(this.totalFormatter=this.w.config.dataLabels.formatter)}return r(t,[{key:"handleBarDataLabels",value:function(t){var e,i,a=t.x,s=t.y,r=t.y1,o=t.y2,n=t.i,l=t.j,h=t.realIndex,c=t.columnGroupIndex,d=t.series,g=t.barHeight,u=t.barWidth,p=t.barXPosition,f=t.barYPosition,x=t.visibleSeries,b=t.renderedPath,v=this.w,y=new m(this.barCtx.ctx),w=Array.isArray(this.barCtx.strokeWidth)?this.barCtx.strokeWidth[h]:this.barCtx.strokeWidth;v.globals.isXNumeric&&!v.globals.isBarHorizontal?(e=a+parseFloat(u*(x+1)),i=s+parseFloat(g*(x+1))-w):(e=a+parseFloat(u*x),i=s+parseFloat(g*x));var k,A=null,S=a,C=s,L={},P=v.config.dataLabels,M=this.barCtx.barOptions.dataLabels,I=this.barCtx.barOptions.dataLabels.total;void 0!==f&&this.barCtx.isRangeBar&&(i=f,C=f),void 0!==p&&this.barCtx.isVerticalGroupedRangeBar&&(e=p,S=p);var T=P.offsetX,z=P.offsetY,X={width:0,height:0};if(v.config.dataLabels.enabled){var E=this.barCtx.series[n][l];X=y.getTextRects(v.globals.yLabelFormatters[0](E),parseFloat(P.style.fontSize))}var Y={x:a,y:s,i:n,j:l,realIndex:h,columnGroupIndex:c,renderedPath:b,bcx:e,bcy:i,barHeight:g,barWidth:u,textRects:X,strokeWidth:w,dataLabelsX:S,dataLabelsY:C,dataLabelsConfig:P,barDataLabelsConfig:M,barTotalDataLabelsConfig:I,offX:T,offY:z};return L=this.barCtx.isHorizontal?this.calculateBarsDataLabelsPosition(Y):this.calculateColumnsDataLabelsPosition(Y),b.attr({cy:L.bcy,cx:L.bcx,j:l,val:d[n][l],barHeight:g,barWidth:u}),k=this.drawCalculatedDataLabels({x:L.dataLabelsX,y:L.dataLabelsY,val:this.barCtx.isRangeBar?[r,o]:d[n][l],i:h,j:l,barWidth:u,barHeight:g,textRects:X,dataLabelsConfig:P}),v.config.chart.stacked&&I.enabled&&(A=this.drawTotalDataLabels({x:L.totalDataLabelsX,y:L.totalDataLabelsY,barWidth:u,barHeight:g,realIndex:h,textAnchor:L.totalDataLabelsAnchor,val:this.getStackedTotalDataLabel({realIndex:h,j:l}),dataLabelsConfig:P,barTotalDataLabelsConfig:I})),{dataLabels:k,totalDataLabels:A}}},{key:"getStackedTotalDataLabel",value:function(t){var i=t.realIndex,a=t.j,s=this.w,r=this.barCtx.stackedSeriesTotals[a];return this.totalFormatter&&(r=this.totalFormatter(r,e(e({},s),{},{seriesIndex:i,dataPointIndex:a,w:s}))),r}},{key:"calculateColumnsDataLabelsPosition",value:function(t){var e,i,a=this.w,s=t.i,r=t.j,o=t.realIndex,n=t.columnGroupIndex,l=t.y,h=t.bcx,c=t.barWidth,d=t.barHeight,g=t.textRects,u=t.dataLabelsX,p=t.dataLabelsY,f=t.dataLabelsConfig,x=t.barDataLabelsConfig,b=t.barTotalDataLabelsConfig,v=t.strokeWidth,y=t.offX,w=t.offY,k=h;d=Math.abs(d);var A="vertical"===a.config.plotOptions.bar.dataLabels.orientation,S=this.barCtx.barHelpers.getZeroValueEncounters({i:s,j:r}).zeroEncounters;h=h-v/2+n*c;var C=a.globals.gridWidth/a.globals.dataPoints;if(this.barCtx.isVerticalGroupedRangeBar?u+=c/2:(u=a.globals.isXNumeric?h-c/2+y:h-C+c/2+y,S>0&&a.config.plotOptions.bar.hideZeroBarsWhenGrouped&&(u-=c*S)),A){u=u+g.height/2-v/2-2}var L=this.barCtx.series[s][r]<0,P=l;switch(this.barCtx.isReversed&&(P=l+(L?d:-d),l-=d),x.position){case"center":p=A?L?P-d/2+w:P+d/2-w:L?P-d/2+g.height/2+w:P+d/2+g.height/2-w;break;case"bottom":p=A?L?P-d+w:P+d-w:L?P-d+g.height+v+w:P+d-g.height/2+v-w;break;case"top":p=A?L?P+w:P-w:L?P-g.height/2-w:P+g.height+w}if(this.barCtx.lastActiveBarSerieIndex===o&&b.enabled){var M=new m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({realIndex:o,j:r}),f.fontSize);e=L?P-M.height/2-w-b.offsetY+18:P+M.height+w+b.offsetY-18,i=k+(a.globals.isXNumeric?c*(a.globals.barGroups.length-1)-c/2:-(c*a.globals.barGroups.length-c/2-2*v))+b.offsetX}return a.config.chart.stacked||(p<0?p=0+v:p+g.height/3>a.globals.gridHeight&&(p=a.globals.gridHeight-v)),{bcx:h,bcy:l,dataLabelsX:u,dataLabelsY:p,totalDataLabelsX:i,totalDataLabelsY:e,totalDataLabelsAnchor:"middle"}}},{key:"calculateBarsDataLabelsPosition",value:function(t){var e=this.w,i=t.x,a=t.i,s=t.j,r=t.realIndex,o=t.columnGroupIndex,n=t.bcy,l=t.barHeight,h=t.barWidth,c=t.textRects,d=t.dataLabelsX,g=t.strokeWidth,u=t.dataLabelsConfig,p=t.barDataLabelsConfig,f=t.barTotalDataLabelsConfig,x=t.offX,b=t.offY,v=e.globals.gridHeight/e.globals.dataPoints;h=Math.abs(h);var y,w,k=(n+=o*l)-(this.barCtx.isRangeBar?0:v)+l/2+c.height/2+b-3,A="start",S=this.barCtx.series[a][s]<0,C=i;switch(this.barCtx.isReversed&&(C=i+(S?-h:h),i=e.globals.gridWidth-h,A=S?"start":"end"),p.position){case"center":d=S?C+h/2-x:Math.max(c.width/2,C-h/2)+x;break;case"bottom":d=S?C+h-g-Math.round(c.width/2)-x:C-h+g+Math.round(c.width/2)+x;break;case"top":d=S?C-g+Math.round(c.width/2)-x:C-g-Math.round(c.width/2)+x}if(this.barCtx.lastActiveBarSerieIndex===r&&f.enabled){var L=new m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({realIndex:r,j:s}),u.fontSize);S?(y=C-g-x-f.offsetX,A="end"):y=C+x+f.offsetX+(this.barCtx.isReversed?-(h+g):g),w=k-c.height/2+L.height/2+f.offsetY+g}return e.config.chart.stacked||(d<0?d=d+c.width+g:d+c.width/2>e.globals.gridWidth&&(d=e.globals.gridWidth-c.width-g)),{bcx:i,bcy:n,dataLabelsX:d,dataLabelsY:k,totalDataLabelsX:y,totalDataLabelsY:w,totalDataLabelsAnchor:A}}},{key:"drawCalculatedDataLabels",value:function(t){var i=t.x,a=t.y,s=t.val,r=t.i,o=t.j,n=t.textRects,l=t.barHeight,h=t.barWidth,c=t.dataLabelsConfig,d=this.w,g="rotate(0)";"vertical"===d.config.plotOptions.bar.dataLabels.orientation&&(g="rotate(-90, ".concat(i,", ").concat(a,")"));var u=new N(this.barCtx.ctx),p=new m(this.barCtx.ctx),f=c.formatter,x=null,b=d.globals.collapsedSeriesIndices.indexOf(r)>-1;if(c.enabled&&!b){x=p.group({class:"apexcharts-data-labels",transform:g});var v="";void 0!==s&&(v=f(s,e(e({},d),{},{seriesIndex:r,dataPointIndex:o,w:d}))),!s&&d.config.plotOptions.bar.hideZeroBarsWhenGrouped&&(v="");var y=d.globals.series[r][o]<0,w=d.config.plotOptions.bar.dataLabels.position;if("vertical"===d.config.plotOptions.bar.dataLabels.orientation&&("top"===w&&(c.textAnchor=y?"end":"start"),"center"===w&&(c.textAnchor="middle"),"bottom"===w&&(c.textAnchor=y?"end":"start")),this.barCtx.isRangeBar&&this.barCtx.barOptions.dataLabels.hideOverflowingLabels)h<p.getTextRects(v,parseFloat(c.style.fontSize)).width&&(v="");d.config.chart.stacked&&this.barCtx.barOptions.dataLabels.hideOverflowingLabels&&(this.barCtx.isHorizontal?n.width/1.6>Math.abs(h)&&(v=""):n.height/1.6>Math.abs(l)&&(v=""));var k=e({},c);this.barCtx.isHorizontal&&s<0&&("start"===c.textAnchor?k.textAnchor="end":"end"===c.textAnchor&&(k.textAnchor="start")),u.plotDataLabelsText({x:i,y:a,text:v,i:r,j:o,parent:x,dataLabelsConfig:k,alwaysDrawDataLabel:!0,offsetCorrection:!0})}return x}},{key:"drawTotalDataLabels",value:function(t){var e,i=t.x,a=t.y,s=t.val,r=t.barWidth,o=t.barHeight,n=t.realIndex,l=t.textAnchor,h=t.barTotalDataLabelsConfig,c=this.w,d=new m(this.barCtx.ctx);return h.enabled&&void 0!==i&&void 0!==a&&this.barCtx.lastActiveBarSerieIndex===n&&(e=d.drawText({x:i-(!c.globals.isBarHorizontal&&c.globals.barGroups.length?r*(c.globals.barGroups.length-1)/2:0),y:a-(c.globals.isBarHorizontal&&c.globals.barGroups.length?o*(c.globals.barGroups.length-1)/2:0),foreColor:h.style.color,text:s,textAnchor:l,fontFamily:h.style.fontFamily,fontSize:h.style.fontSize,fontWeight:h.style.fontWeight})),e}}]),t}(),mt=function(){function t(e){a(this,t),this.w=e.w,this.barCtx=e}return r(t,[{key:"initVariables",value:function(t){var e=this.w;this.barCtx.series=t,this.barCtx.totalItems=0,this.barCtx.seriesLen=0,this.barCtx.visibleI=-1,this.barCtx.visibleItems=1;for(var i=0;i<t.length;i++)if(t[i].length>0&&(this.barCtx.seriesLen=this.barCtx.seriesLen+1,this.barCtx.totalItems+=t[i].length),e.globals.isXNumeric)for(var a=0;a<t[i].length;a++)e.globals.seriesX[i][a]>e.globals.minX&&e.globals.seriesX[i][a]<e.globals.maxX&&this.barCtx.visibleItems++;else this.barCtx.visibleItems=e.globals.dataPoints;0===this.barCtx.seriesLen&&(this.barCtx.seriesLen=1),this.barCtx.zeroSerieses=[],e.globals.comboCharts||this.checkZeroSeries({series:t})}},{key:"initialPositions",value:function(){var t,e,i,a,s,r,o,n,l=this.w,h=l.globals.dataPoints;this.barCtx.isRangeBar&&(h=l.globals.labels.length);var c=this.barCtx.seriesLen;if(l.config.plotOptions.bar.rangeBarGroupRows&&(c=1),this.barCtx.isHorizontal)s=(i=l.globals.gridHeight/h)/c,l.globals.isXNumeric&&(s=(i=l.globals.gridHeight/this.barCtx.totalItems)/this.barCtx.seriesLen),s=s*parseInt(this.barCtx.barOptions.barHeight,10)/100,-1===String(this.barCtx.barOptions.barHeight).indexOf("%")&&(s=parseInt(this.barCtx.barOptions.barHeight,10)),n=this.barCtx.baseLineInvertedY+l.globals.padHorizontal+(this.barCtx.isReversed?l.globals.gridWidth:0)-(this.barCtx.isReversed?2*this.barCtx.baseLineInvertedY:0),this.barCtx.isFunnel&&(n=l.globals.gridWidth/2),e=(i-s*this.barCtx.seriesLen)/2;else{if(a=l.globals.gridWidth/this.barCtx.visibleItems,l.config.xaxis.convertedCatToNumeric&&(a=l.globals.gridWidth/l.globals.dataPoints),r=a/c*parseInt(this.barCtx.barOptions.columnWidth,10)/100,l.globals.isXNumeric){var d=this.barCtx.xRatio;l.globals.minXDiff&&.5!==l.globals.minXDiff&&l.globals.minXDiff/d>0&&(a=l.globals.minXDiff/d),(r=a/c*parseInt(this.barCtx.barOptions.columnWidth,10)/100)<1&&(r=1)}-1===String(this.barCtx.barOptions.columnWidth).indexOf("%")&&(r=parseInt(this.barCtx.barOptions.columnWidth,10)),o=l.globals.gridHeight-this.barCtx.baseLineY[this.barCtx.translationsIndex]-(this.barCtx.isReversed?l.globals.gridHeight:0)+(this.barCtx.isReversed?2*this.barCtx.baseLineY[this.barCtx.translationsIndex]:0),t=l.globals.padHorizontal+(a-r*this.barCtx.seriesLen)/2}return l.globals.barHeight=s,l.globals.barWidth=r,{x:t,y:e,yDivision:i,xDivision:a,barHeight:s,barWidth:r,zeroH:o,zeroW:n}}},{key:"initializeStackedPrevVars",value:function(t){t.w.globals.seriesGroups.forEach((function(e){t[e]||(t[e]={}),t[e].prevY=[],t[e].prevX=[],t[e].prevYF=[],t[e].prevXF=[],t[e].prevYVal=[],t[e].prevXVal=[]}))}},{key:"initializeStackedXYVars",value:function(t){t.w.globals.seriesGroups.forEach((function(e){t[e]||(t[e]={}),t[e].xArrj=[],t[e].xArrjF=[],t[e].xArrjVal=[],t[e].yArrj=[],t[e].yArrjF=[],t[e].yArrjVal=[]}))}},{key:"getPathFillColor",value:function(t,e,i,a){var s,r,o,n,l=this.w,h=new H(this.barCtx.ctx),c=null,d=this.barCtx.barOptions.distributed?i:e;this.barCtx.barOptions.colors.ranges.length>0&&this.barCtx.barOptions.colors.ranges.map((function(a){t[e][i]>=a.from&&t[e][i]<=a.to&&(c=a.color)}));return l.config.series[e].data[i]&&l.config.series[e].data[i].fillColor&&(c=l.config.series[e].data[i].fillColor),h.fillPath({seriesNumber:this.barCtx.barOptions.distributed?d:a,dataPointIndex:i,color:c,value:t[e][i],fillConfig:null===(s=l.config.series[e].data[i])||void 0===s?void 0:s.fill,fillType:null!==(r=l.config.series[e].data[i])&&void 0!==r&&null!==(o=r.fill)&&void 0!==o&&o.type?null===(n=l.config.series[e].data[i])||void 0===n?void 0:n.fill.type:Array.isArray(l.config.fill.type)?l.config.fill.type[e]:l.config.fill.type})}},{key:"getStrokeWidth",value:function(t,e,i){var a=0,s=this.w;return void 0===this.barCtx.series[t][e]||null===this.barCtx.series[t][e]?this.barCtx.isNullValue=!0:this.barCtx.isNullValue=!1,s.config.stroke.show&&(this.barCtx.isNullValue||(a=Array.isArray(this.barCtx.strokeWidth)?this.barCtx.strokeWidth[i]:this.barCtx.strokeWidth)),a}},{key:"shouldApplyRadius",value:function(t){var e=this.w,i=!1;return e.config.plotOptions.bar.borderRadius>0&&(e.config.chart.stacked&&"last"===e.config.plotOptions.bar.borderRadiusWhenStacked?this.barCtx.lastActiveBarSerieIndex===t&&(i=!0):i=!0),i}},{key:"barBackground",value:function(t){var e=t.j,i=t.i,a=t.x1,s=t.x2,r=t.y1,o=t.y2,n=t.elSeries,l=this.w,h=new m(this.barCtx.ctx),c=new W(this.barCtx.ctx).getActiveConfigSeriesIndex();if(this.barCtx.barOptions.colors.backgroundBarColors.length>0&&c===i){e>=this.barCtx.barOptions.colors.backgroundBarColors.length&&(e%=this.barCtx.barOptions.colors.backgroundBarColors.length);var d=this.barCtx.barOptions.colors.backgroundBarColors[e],g=h.drawRect(void 0!==a?a:0,void 0!==r?r:0,void 0!==s?s:l.globals.gridWidth,void 0!==o?o:l.globals.gridHeight,this.barCtx.barOptions.colors.backgroundBarRadius,d,this.barCtx.barOptions.colors.backgroundBarOpacity);n.add(g),g.node.classList.add("apexcharts-backgroundBar")}}},{key:"getColumnPaths",value:function(t){var e,i=t.barWidth,a=t.barXPosition,s=t.y1,r=t.y2,o=t.strokeWidth,n=t.seriesGroup,l=t.realIndex,h=t.i,c=t.j,d=t.w,g=new m(this.barCtx.ctx);(o=Array.isArray(o)?o[l]:o)||(o=0);var u=i,p=a;null!==(e=d.config.series[l].data[c])&&void 0!==e&&e.columnWidthOffset&&(p=a-d.config.series[l].data[c].columnWidthOffset/2,u=i+d.config.series[l].data[c].columnWidthOffset);var f=o/2,x=p+f,b=p+u-f;s+=.001-f,r+=.001+f;var v=g.move(x,s),y=g.move(x,s),w=g.line(b,s);if(d.globals.previousPaths.length>0&&(y=this.barCtx.getPreviousPath(l,c,!1)),v=v+g.line(x,r)+g.line(b,r)+g.line(b,s)+("around"===d.config.plotOptions.bar.borderRadiusApplication?" Z":" z"),y=y+g.line(x,s)+w+w+w+w+w+g.line(x,s)+("around"===d.config.plotOptions.bar.borderRadiusApplication?" Z":" z"),this.shouldApplyRadius(l)&&(v=g.roundPathCorners(v,d.config.plotOptions.bar.borderRadius)),d.config.chart.stacked){var k=this.barCtx;(k=this.barCtx[n]).yArrj.push(r-f),k.yArrjF.push(Math.abs(s-r+o)),k.yArrjVal.push(this.barCtx.series[h][c])}return{pathTo:v,pathFrom:y}}},{key:"getBarpaths",value:function(t){var e,i=t.barYPosition,a=t.barHeight,s=t.x1,r=t.x2,o=t.strokeWidth,n=t.seriesGroup,l=t.realIndex,h=t.i,c=t.j,d=t.w,g=new m(this.barCtx.ctx);(o=Array.isArray(o)?o[l]:o)||(o=0);var u=i,p=a;null!==(e=d.config.series[l].data[c])&&void 0!==e&&e.barHeightOffset&&(u=i-d.config.series[l].data[c].barHeightOffset/2,p=a+d.config.series[l].data[c].barHeightOffset);var f=o/2,x=u+f,b=u+p-f;s+=.001-f,r+=.001+f;var v=g.move(s,x),y=g.move(s,x);d.globals.previousPaths.length>0&&(y=this.barCtx.getPreviousPath(l,c,!1));var w=g.line(s,b);if(v=v+g.line(r,x)+g.line(r,b)+w+("around"===d.config.plotOptions.bar.borderRadiusApplication?" Z":" z"),y=y+g.line(s,x)+w+w+w+w+w+g.line(s,x)+("around"===d.config.plotOptions.bar.borderRadiusApplication?" Z":" z"),this.shouldApplyRadius(l)&&(v=g.roundPathCorners(v,d.config.plotOptions.bar.borderRadius)),d.config.chart.stacked){var k=this.barCtx;(k=this.barCtx[n]).xArrj.push(r+f),k.xArrjF.push(Math.abs(s-r)),k.xArrjVal.push(this.barCtx.series[h][c])}return{pathTo:v,pathFrom:y}}},{key:"checkZeroSeries",value:function(t){for(var e=t.series,i=this.w,a=0;a<e.length;a++){for(var s=0,r=0;r<e[i.globals.maxValsInArrayIndex].length;r++)s+=e[a][r];0===s&&this.barCtx.zeroSerieses.push(a)}}},{key:"getXForValue",value:function(t,e){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2]?e:null;return null!=t&&(i=e+t/this.barCtx.invertedYRatio-2*(this.barCtx.isReversed?t/this.barCtx.invertedYRatio:0)),i}},{key:"getYForValue",value:function(t,e,i){var a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3]?e:null;return null!=t&&(a=e-t/this.barCtx.yRatio[i]+2*(this.barCtx.isReversed?t/this.barCtx.yRatio[i]:0)),a}},{key:"getGoalValues",value:function(t,i,a,s,r,n){var l=this,h=this.w,c=[],d=function(e,s){var r;c.push((o(r={},t,"x"===t?l.getXForValue(e,i,!1):l.getYForValue(e,a,n,!1)),o(r,"attrs",s),r))};if(h.globals.seriesGoals[s]&&h.globals.seriesGoals[s][r]&&Array.isArray(h.globals.seriesGoals[s][r])&&h.globals.seriesGoals[s][r].forEach((function(t){d(t.value,t)})),this.barCtx.barOptions.isDumbbell&&h.globals.seriesRange.length){var g=this.barCtx.barOptions.dumbbellColors?this.barCtx.barOptions.dumbbellColors:h.globals.colors,u={strokeHeight:"x"===t?0:h.globals.markers.size[s],strokeWidth:"x"===t?h.globals.markers.size[s]:0,strokeDashArray:0,strokeLineCap:"round",strokeColor:Array.isArray(g[s])?g[s][0]:g[s]};d(h.globals.seriesRangeStart[s][r],u),d(h.globals.seriesRangeEnd[s][r],e(e({},u),{},{strokeColor:Array.isArray(g[s])?g[s][1]:g[s]}))}return c}},{key:"drawGoalLine",value:function(t){var e=t.barXPosition,i=t.barYPosition,a=t.goalX,s=t.goalY,r=t.barWidth,o=t.barHeight,n=new m(this.barCtx.ctx),l=n.group({className:"apexcharts-bar-goals-groups"});l.node.classList.add("apexcharts-element-hidden"),this.barCtx.w.globals.delayedElements.push({el:l.node}),l.attr("clip-path","url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid,")"));var h=null;return this.barCtx.isHorizontal?Array.isArray(a)&&a.forEach((function(t){if(t.x>=-1&&t.x<=n.w.globals.gridWidth+1){var e=void 0!==t.attrs.strokeHeight?t.attrs.strokeHeight:o/2,a=i+e+o/2;h=n.drawLine(t.x,a-2*e,t.x,a,t.attrs.strokeColor?t.attrs.strokeColor:void 0,t.attrs.strokeDashArray,t.attrs.strokeWidth?t.attrs.strokeWidth:2,t.attrs.strokeLineCap),l.add(h)}})):Array.isArray(s)&&s.forEach((function(t){if(t.y>=-1&&t.y<=n.w.globals.gridHeight+1){var i=void 0!==t.attrs.strokeWidth?t.attrs.strokeWidth:r/2,a=e+i+r/2;h=n.drawLine(a-2*i,t.y,a,t.y,t.attrs.strokeColor?t.attrs.strokeColor:void 0,t.attrs.strokeDashArray,t.attrs.strokeHeight?t.attrs.strokeHeight:2,t.attrs.strokeLineCap),l.add(h)}})),l}},{key:"drawBarShadow",value:function(t){var e=t.prevPaths,i=t.currPaths,a=t.color,s=this.w,r=e.x,o=e.x1,n=e.barYPosition,l=i.x,h=i.x1,c=i.barYPosition,d=n+i.barHeight,g=new m(this.barCtx.ctx),u=new x,p=g.move(o,d)+g.line(r,d)+g.line(l,c)+g.line(h,c)+g.line(o,d)+("around"===s.config.plotOptions.bar.borderRadiusApplication?" Z":" z");return g.drawPath({d:p,fill:u.shadeColor(.5,x.rgb2hex(a)),stroke:"none",strokeWidth:0,fillOpacity:1,classes:"apexcharts-bar-shadows"})}},{key:"getZeroValueEncounters",value:function(t){var e,i=t.i,a=t.j,s=this.w,r=0,o=0;return(s.config.plotOptions.bar.horizontal?s.globals.series.map((function(t,e){return e})):(null===(e=s.globals.columnSeries)||void 0===e?void 0:e.i.map((function(t){return t})))||[]).forEach((function(t){var e=s.globals.seriesPercent[t][a];e&&r++,t<i&&0===e&&o++})),{nonZeroColumns:r,zeroEncounters:o}}},{key:"getGroupIndex",value:function(t){var e=this.w,i=e.globals.seriesGroups.findIndex((function(i){return i.indexOf(e.globals.seriesNames[t])>-1})),a=this.barCtx.columnGroupIndices,s=a.indexOf(i);return s<0&&(a.push(i),s=a.length-1),{groupIndex:i,columnGroupIndex:s}}}]),t}(),yt=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w;var s=this.w;this.barOptions=s.config.plotOptions.bar,this.isHorizontal=this.barOptions.horizontal,this.strokeWidth=s.config.stroke.width,this.isNullValue=!1,this.isRangeBar=s.globals.seriesRange.length&&this.isHorizontal,this.isVerticalGroupedRangeBar=!s.globals.isBarHorizontal&&s.globals.seriesRange.length&&s.config.plotOptions.bar.rangeBarGroupRows,this.isFunnel=this.barOptions.isFunnel,this.xyRatios=i,null!==this.xyRatios&&(this.xRatio=i.xRatio,this.yRatio=i.yRatio,this.invertedXRatio=i.invertedXRatio,this.invertedYRatio=i.invertedYRatio,this.baseLineY=i.baseLineY,this.baseLineInvertedY=i.baseLineInvertedY),this.yaxisIndex=0,this.translationsIndex=0,this.seriesLen=0,this.pathArr=[];var r=new W(this.ctx);this.lastActiveBarSerieIndex=r.getActiveConfigSeriesIndex("desc",["bar","column"]),this.columnGroupIndices=[];var o=r.getBarSeriesIndices(),n=new y(this.ctx);this.stackedSeriesTotals=n.getStackedSeriesTotals(this.w.config.series.map((function(t,e){return-1===o.indexOf(e)?e:-1})).filter((function(t){return-1!==t}))),this.barHelpers=new mt(this)}return r(t,[{key:"draw",value:function(t,i){var a=this.w,s=new m(this.ctx),r=new y(this.ctx,a);t=r.getLogSeries(t),this.series=t,this.yRatio=r.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t);var o=s.group({class:"apexcharts-bar-series apexcharts-plot-series"});a.config.dataLabels.enabled&&this.totalItems>this.barOptions.dataLabels.maxItems&&console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");for(var n=0,l=0;n<t.length;n++,l++){var h,c,d,g,u=void 0,p=void 0,f=[],b=[],v=a.globals.comboCharts?i[n]:n,w=this.barHelpers.getGroupIndex(v).columnGroupIndex,k=s.group({class:"apexcharts-series",rel:n+1,seriesName:x.escapeString(a.globals.seriesNames[v]),"data:realIndex":v});this.ctx.series.addCollapsedClassToSeries(k,v),t[n].length>0&&(this.visibleI=this.visibleI+1);var A=0,S=0;this.yRatio.length>1&&(this.yaxisIndex=a.globals.seriesYAxisReverseMap[v],this.translationsIndex=v);var C=this.translationsIndex;this.isReversed=a.config.yaxis[this.yaxisIndex]&&a.config.yaxis[this.yaxisIndex].reversed;var L=this.barHelpers.initialPositions();p=L.y,A=L.barHeight,c=L.yDivision,g=L.zeroW,u=L.x,S=L.barWidth,h=L.xDivision,d=L.zeroH,this.horizontal||b.push(u+S/2);var P=s.group({class:"apexcharts-datalabels","data:realIndex":v});a.globals.delayedElements.push({el:P.node}),P.node.classList.add("apexcharts-element-hidden");var M=s.group({class:"apexcharts-bar-goals-markers"}),I=s.group({class:"apexcharts-bar-shadows"});a.globals.delayedElements.push({el:I.node}),I.node.classList.add("apexcharts-element-hidden");for(var T=0;T<t[n].length;T++){var z=this.barHelpers.getStrokeWidth(n,T,v),X=null,E={indexes:{i:n,j:T,realIndex:v,translationsIndex:C,bc:l},x:u,y:p,strokeWidth:z,elSeries:k};this.isHorizontal?(X=this.drawBarPaths(e(e({},E),{},{barHeight:A,zeroW:g,yDivision:c})),S=this.series[n][T]/this.invertedYRatio):(X=this.drawColumnPaths(e(e({},E),{},{xDivision:h,barWidth:S,zeroH:d})),A=this.series[n][T]/this.yRatio[C]);var Y=this.barHelpers.getPathFillColor(t,n,T,v);if(this.isFunnel&&this.barOptions.isFunnel3d&&this.pathArr.length&&T>0){var F=this.barHelpers.drawBarShadow({color:"string"==typeof Y&&-1===(null==Y?void 0:Y.indexOf("url"))?Y:x.hexToRgba(a.globals.colors[n]),prevPaths:this.pathArr[this.pathArr.length-1],currPaths:X});F&&I.add(F)}this.pathArr.push(X);var R=this.barHelpers.drawGoalLine({barXPosition:X.barXPosition,barYPosition:X.barYPosition,goalX:X.goalX,goalY:X.goalY,barHeight:A,barWidth:S});R&&M.add(R),p=X.y,u=X.x,T>0&&b.push(u+S/2),f.push(p),this.renderSeries({realIndex:v,pathFill:Y,j:T,i:n,columnGroupIndex:w,pathFrom:X.pathFrom,pathTo:X.pathTo,strokeWidth:z,elSeries:k,x:u,y:p,series:t,barHeight:X.barHeight?X.barHeight:A,barWidth:X.barWidth?X.barWidth:S,elDataLabelsWrap:P,elGoalsMarkers:M,elBarShadows:I,visibleSeries:this.visibleI,type:"bar"})}a.globals.seriesXvalues[v]=b,a.globals.seriesYvalues[v]=f,o.add(k)}return o}},{key:"renderSeries",value:function(t){var e=t.realIndex,i=t.pathFill,a=t.lineFill,s=t.j,r=t.i,o=t.columnGroupIndex,n=t.pathFrom,l=t.pathTo,h=t.strokeWidth,c=t.elSeries,d=t.x,g=t.y,u=t.y1,p=t.y2,f=t.series,x=t.barHeight,b=t.barWidth,y=t.barXPosition,w=t.barYPosition,k=t.elDataLabelsWrap,A=t.elGoalsMarkers,S=t.elBarShadows,C=t.visibleSeries,L=t.type,P=this.w,M=new m(this.ctx);if(!a){var I="function"==typeof P.globals.stroke.colors[e]?function(t){var e,i=P.config.stroke.colors;return Array.isArray(i)&&i.length>0&&((e=i[t])||(e=""),"function"==typeof e)?e({value:P.globals.series[t][s],dataPointIndex:s,w:P}):e}(e):P.globals.stroke.colors[e];a=this.barOptions.distributed?P.globals.stroke.colors[s]:I}P.config.series[r].data[s]&&P.config.series[r].data[s].strokeColor&&(a=P.config.series[r].data[s].strokeColor),this.isNullValue&&(i="none");var T=s/P.config.chart.animations.animateGradually.delay*(P.config.chart.animations.speed/P.globals.dataPoints)/2.4,z=M.renderPaths({i:r,j:s,realIndex:e,pathFrom:n,pathTo:l,stroke:a,strokeWidth:h,strokeLineCap:P.config.stroke.lineCap,fill:i,animationDelay:T,initialSpeed:P.config.chart.animations.speed,dataChangeSpeed:P.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-".concat(L,"-area")});z.attr("clip-path","url(#gridRectMask".concat(P.globals.cuid,")"));var X=P.config.forecastDataPoints;X.count>0&&s>=P.globals.dataPoints-X.count&&(z.node.setAttribute("stroke-dasharray",X.dashArray),z.node.setAttribute("stroke-width",X.strokeWidth),z.node.setAttribute("fill-opacity",X.fillOpacity)),void 0!==u&&void 0!==p&&(z.attr("data-range-y1",u),z.attr("data-range-y2",p)),new v(this.ctx).setSelectionFilter(z,e,s),c.add(z);var E=new vt(this).handleBarDataLabels({x:d,y:g,y1:u,y2:p,i:r,j:s,series:f,realIndex:e,columnGroupIndex:o,barHeight:x,barWidth:b,barXPosition:y,barYPosition:w,renderedPath:z,visibleSeries:C});return null!==E.dataLabels&&k.add(E.dataLabels),E.totalDataLabels&&k.add(E.totalDataLabels),c.add(k),A&&c.add(A),S&&c.add(S),c}},{key:"drawBarPaths",value:function(t){var e,i=t.indexes,a=t.barHeight,s=t.strokeWidth,r=t.zeroW,o=t.x,n=t.y,l=t.yDivision,h=t.elSeries,c=this.w,d=i.i,g=i.j;if(c.globals.isXNumeric)e=(n=(c.globals.seriesX[d][g]-c.globals.minX)/this.invertedXRatio-a)+a*this.visibleI;else if(c.config.plotOptions.bar.hideZeroBarsWhenGrouped){var u=0,p=0;c.globals.seriesPercent.forEach((function(t,e){t[g]&&u++,e<d&&0===t[g]&&p++})),u>0&&(a=this.seriesLen*a/u),e=n+a*this.visibleI,e-=a*p}else e=n+a*this.visibleI;this.isFunnel&&(r-=(this.barHelpers.getXForValue(this.series[d][g],r)-r)/2),o=this.barHelpers.getXForValue(this.series[d][g],r);var f=this.barHelpers.getBarpaths({barYPosition:e,barHeight:a,x1:r,x2:o,strokeWidth:s,series:this.series,realIndex:i.realIndex,i:d,j:g,w:c});return c.globals.isXNumeric||(n+=l),this.barHelpers.barBackground({j:g,i:d,y1:e-a*this.visibleI,y2:a*this.seriesLen,elSeries:h}),{pathTo:f.pathTo,pathFrom:f.pathFrom,x1:r,x:o,y:n,goalX:this.barHelpers.getGoalValues("x",r,null,d,g),barYPosition:e,barHeight:a}}},{key:"drawColumnPaths",value:function(t){var e,i=t.indexes,a=t.x,s=t.y,r=t.xDivision,o=t.barWidth,n=t.zeroH,l=t.strokeWidth,h=t.elSeries,c=this.w,d=i.realIndex,g=i.translationsIndex,u=i.i,p=i.j,f=i.bc;if(c.globals.isXNumeric){var x=this.getBarXForNumericXAxis({x:a,j:p,realIndex:d,barWidth:o});a=x.x,e=x.barXPosition}else if(c.config.plotOptions.bar.hideZeroBarsWhenGrouped){var b=this.barHelpers.getZeroValueEncounters({i:u,j:p}),v=b.nonZeroColumns,m=b.zeroEncounters;v>0&&(o=this.seriesLen*o/v),e=a+o*this.visibleI,e-=o*m}else e=a+o*this.visibleI;s=this.barHelpers.getYForValue(this.series[u][p],n,g);var y=this.barHelpers.getColumnPaths({barXPosition:e,barWidth:o,y1:n,y2:s,strokeWidth:l,series:this.series,realIndex:d,i:u,j:p,w:c});return c.globals.isXNumeric||(a+=r),this.barHelpers.barBackground({bc:f,j:p,i:u,x1:e-l/2-o*this.visibleI,x2:o*this.seriesLen+l/2,elSeries:h}),{pathTo:y.pathTo,pathFrom:y.pathFrom,x:a,y:s,goalY:this.barHelpers.getGoalValues("y",null,n,u,p,g),barXPosition:e,barWidth:o}}},{key:"getBarXForNumericXAxis",value:function(t){var e=t.x,i=t.barWidth,a=t.realIndex,s=t.j,r=this.w,o=a;return r.globals.seriesX[a].length||(o=r.globals.maxValsInArrayIndex),r.globals.seriesX[o][s]&&(e=(r.globals.seriesX[o][s]-r.globals.minX)/this.xRatio-i*this.seriesLen/2),{barXPosition:e+i*this.visibleI,x:e}}},{key:"getPreviousPath",value:function(t,e){for(var i,a=this.w,s=0;s<a.globals.previousPaths.length;s++){var r=a.globals.previousPaths[s];r.paths&&r.paths.length>0&&parseInt(r.realIndex,10)===parseInt(t,10)&&void 0!==a.globals.previousPaths[s].paths[e]&&(i=a.globals.previousPaths[s].paths[e].d)}return i}}]),t}(),wt=function(t){n(s,t);var i=d(s);function s(){return a(this,s),i.apply(this,arguments)}return r(s,[{key:"draw",value:function(t,i){var a=this,s=this.w;this.graphics=new m(this.ctx),this.bar=new yt(this.ctx,this.xyRatios);var r=new y(this.ctx,s);t=r.getLogSeries(t),this.yRatio=r.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t),"100%"===s.config.chart.stackType&&(t=s.globals.comboCharts?i.map((function(t){return s.globals.seriesPercent[t]})):s.globals.seriesPercent.slice()),this.series=t,this.barHelpers.initializeStackedPrevVars(this);for(var o=this.graphics.group({class:"apexcharts-bar-series apexcharts-plot-series"}),n=0,l=0,h=function(r,h){var c=void 0,d=void 0,g=void 0,u=void 0,p=s.globals.comboCharts?i[r]:r,f=a.barHelpers.getGroupIndex(p),b=f.groupIndex,v=f.columnGroupIndex;a.groupCtx=a[s.globals.seriesGroups[b]];var m=[],y=[],w=0;a.yRatio.length>1&&(a.yaxisIndex=s.globals.seriesYAxisReverseMap[p][0],w=p),a.isReversed=s.config.yaxis[a.yaxisIndex]&&s.config.yaxis[a.yaxisIndex].reversed;var k=a.graphics.group({class:"apexcharts-series",seriesName:x.escapeString(s.globals.seriesNames[p]),rel:r+1,"data:realIndex":p});a.ctx.series.addCollapsedClassToSeries(k,p);var A=a.graphics.group({class:"apexcharts-datalabels","data:realIndex":p}),S=a.graphics.group({class:"apexcharts-bar-goals-markers"}),C=0,L=0,P=a.initialPositions(n,l,c,d,g,u,w);l=P.y,C=P.barHeight,d=P.yDivision,u=P.zeroW,n=P.x,L=P.barWidth,c=P.xDivision,g=P.zeroH,s.globals.barHeight=C,s.globals.barWidth=L,a.barHelpers.initializeStackedXYVars(a),1===a.groupCtx.prevY.length&&a.groupCtx.prevY[0].every((function(t){return isNaN(t)}))&&(a.groupCtx.prevY[0]=a.groupCtx.prevY[0].map((function(){return g})),a.groupCtx.prevYF[0]=a.groupCtx.prevYF[0].map((function(){return 0})));for(var M=0;M<s.globals.dataPoints;M++){var I=a.barHelpers.getStrokeWidth(r,M,p),T={indexes:{i:r,j:M,realIndex:p,translationsIndex:w,bc:h},strokeWidth:I,x:n,y:l,elSeries:k,columnGroupIndex:v,seriesGroup:s.globals.seriesGroups[b]},z=null;a.isHorizontal?(z=a.drawStackedBarPaths(e(e({},T),{},{zeroW:u,barHeight:C,yDivision:d})),L=a.series[r][M]/a.invertedYRatio):(z=a.drawStackedColumnPaths(e(e({},T),{},{xDivision:c,barWidth:L,zeroH:g})),C=a.series[r][M]/a.yRatio[w]);var X=a.barHelpers.drawGoalLine({barXPosition:z.barXPosition,barYPosition:z.barYPosition,goalX:z.goalX,goalY:z.goalY,barHeight:C,barWidth:L});X&&S.add(X),l=z.y,n=z.x,m.push(n),y.push(l);var E=a.barHelpers.getPathFillColor(t,r,M,p);k=a.renderSeries({realIndex:p,pathFill:E,j:M,i:r,columnGroupIndex:v,pathFrom:z.pathFrom,pathTo:z.pathTo,strokeWidth:I,elSeries:k,x:n,y:l,series:t,barHeight:C,barWidth:L,elDataLabelsWrap:A,elGoalsMarkers:S,type:"bar",visibleSeries:0})}s.globals.seriesXvalues[p]=m,s.globals.seriesYvalues[p]=y,a.groupCtx.prevY.push(a.groupCtx.yArrj),a.groupCtx.prevYF.push(a.groupCtx.yArrjF),a.groupCtx.prevYVal.push(a.groupCtx.yArrjVal),a.groupCtx.prevX.push(a.groupCtx.xArrj),a.groupCtx.prevXF.push(a.groupCtx.xArrjF),a.groupCtx.prevXVal.push(a.groupCtx.xArrjVal),o.add(k)},c=0,d=0;c<t.length;c++,d++)h(c,d);return o}},{key:"initialPositions",value:function(t,e,i,a,s,r,o){var n,l,h=this.w;if(this.isHorizontal){a=h.globals.gridHeight/h.globals.dataPoints;var c=h.config.plotOptions.bar.barHeight;n=-1===String(c).indexOf("%")?parseInt(c,10):a*parseInt(c,10)/100,r=h.globals.padHorizontal+(this.isReversed?h.globals.gridWidth-this.baseLineInvertedY:this.baseLineInvertedY),e=(a-n)/2}else{l=i=h.globals.gridWidth/h.globals.dataPoints;var d=h.config.plotOptions.bar.columnWidth;h.globals.isXNumeric&&h.globals.dataPoints>1?l=(i=h.globals.minXDiff/this.xRatio)*parseInt(this.barOptions.columnWidth,10)/100:-1===String(d).indexOf("%")?l=parseInt(d,10):l*=parseInt(d,10)/100,s=h.globals.gridHeight-this.baseLineY[o]-(this.isReversed?h.globals.gridHeight:0),t=h.globals.padHorizontal+(i-l)/2}var g=h.globals.barGroups.length||1;return{x:t,y:e,yDivision:a,xDivision:i,barHeight:n/g,barWidth:l/g,zeroH:s,zeroW:r}}},{key:"drawStackedBarPaths",value:function(t){for(var e,i=t.indexes,a=t.barHeight,s=t.strokeWidth,r=t.zeroW,o=t.x,n=t.y,l=t.columnGroupIndex,h=t.seriesGroup,c=t.yDivision,d=t.elSeries,g=this.w,u=n+l*a,p=i.i,f=i.j,x=i.realIndex,b=i.translationsIndex,v=0,m=0;m<this.groupCtx.prevXF.length;m++)v+=this.groupCtx.prevXF[m][f];var y;if((y=h.indexOf(g.config.series[x].name))>0){var w=r;this.groupCtx.prevXVal[y-1][f]<0?w=this.series[p][f]>=0?this.groupCtx.prevX[y-1][f]+v-2*(this.isReversed?v:0):this.groupCtx.prevX[y-1][f]:this.groupCtx.prevXVal[y-1][f]>=0&&(w=this.series[p][f]>=0?this.groupCtx.prevX[y-1][f]:this.groupCtx.prevX[y-1][f]-v+2*(this.isReversed?v:0)),e=w}else e=r;o=null===this.series[p][f]?e:e+this.series[p][f]/this.invertedYRatio-2*(this.isReversed?this.series[p][f]/this.invertedYRatio:0);var k=this.barHelpers.getBarpaths({barYPosition:u,barHeight:a,x1:e,x2:o,strokeWidth:s,series:this.series,realIndex:i.realIndex,seriesGroup:h,i:p,j:f,w:g});return this.barHelpers.barBackground({j:f,i:p,y1:u,y2:a,elSeries:d}),n+=c,{pathTo:k.pathTo,pathFrom:k.pathFrom,goalX:this.barHelpers.getGoalValues("x",r,null,p,f,b),barXPosition:e,barYPosition:u,x:o,y:n}}},{key:"drawStackedColumnPaths",value:function(t){var e=t.indexes,i=t.x,a=t.y,s=t.xDivision,r=t.barWidth,o=t.zeroH,n=t.columnGroupIndex,l=t.seriesGroup,h=t.elSeries,c=this.w,d=e.i,g=e.j,u=e.bc,p=e.realIndex,f=e.translationsIndex;if(c.globals.isXNumeric){var x=c.globals.seriesX[p][g];x||(x=0),i=(x-c.globals.minX)/this.xRatio-r/2*c.globals.barGroups.length}for(var b,v=i+n*r,m=0,y=0;y<this.groupCtx.prevYF.length;y++)m+=isNaN(this.groupCtx.prevYF[y][g])?0:this.groupCtx.prevYF[y][g];var w=d;if(l&&(w=l.indexOf(c.globals.seriesNames[p])),w>0&&!c.globals.isXNumeric||w>0&&c.globals.isXNumeric&&c.globals.seriesX[p-1][g]===c.globals.seriesX[p][g]){var k,A,S,C=Math.min(this.yRatio.length+1,p+1);if(void 0!==this.groupCtx.prevY[w-1]&&this.groupCtx.prevY[w-1].length)for(var L=1;L<C;L++){var P;if(!isNaN(null===(P=this.groupCtx.prevY[w-L])||void 0===P?void 0:P[g])){S=this.groupCtx.prevY[w-L][g];break}}for(var M=1;M<C;M++){var I,T;if((null===(I=this.groupCtx.prevYVal[w-M])||void 0===I?void 0:I[g])<0){A=this.series[d][g]>=0?S-m+2*(this.isReversed?m:0):S;break}if((null===(T=this.groupCtx.prevYVal[w-M])||void 0===T?void 0:T[g])>=0){A=this.series[d][g]>=0?S:S+m-2*(this.isReversed?m:0);break}}void 0===A&&(A=c.globals.gridHeight),b=null!==(k=this.groupCtx.prevYF[0])&&void 0!==k&&k.every((function(t){return 0===t}))&&this.groupCtx.prevYF.slice(1,w).every((function(t){return t.every((function(t){return isNaN(t)}))}))?o:A}else b=o;a=this.series[d][g]?b-this.series[d][g]/this.yRatio[f]+2*(this.isReversed?this.series[d][g]/this.yRatio[f]:0):b;var z=this.barHelpers.getColumnPaths({barXPosition:v,barWidth:r,y1:b,y2:a,yRatio:this.yRatio[f],strokeWidth:this.strokeWidth,series:this.series,seriesGroup:l,realIndex:e.realIndex,i:d,j:g,w:c});return this.barHelpers.barBackground({bc:u,j:g,i:d,x1:v,x2:r,elSeries:h}),i+=s,{pathTo:z.pathTo,pathFrom:z.pathFrom,goalY:this.barHelpers.getGoalValues("y",null,o,d,g),barXPosition:v,x:c.globals.isXNumeric?i-s:i,y:a}}}]),s}(yt),kt=function(t){n(s,t);var i=d(s);function s(){return a(this,s),i.apply(this,arguments)}return r(s,[{key:"draw",value:function(t,i,a){var s=this,r=this.w,o=new m(this.ctx),n=r.globals.comboCharts?i:r.config.chart.type,l=new H(this.ctx);this.candlestickOptions=this.w.config.plotOptions.candlestick,this.boxOptions=this.w.config.plotOptions.boxPlot,this.isHorizontal=r.config.plotOptions.bar.horizontal;var h=new y(this.ctx,r);t=h.getLogSeries(t),this.series=t,this.yRatio=h.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t);for(var c=o.group({class:"apexcharts-".concat(n,"-series apexcharts-plot-series")}),d=function(i){s.isBoxPlot="boxPlot"===r.config.chart.type||"boxPlot"===r.config.series[i].type;var n,h,d,g,u=void 0,p=void 0,f=[],b=[],v=r.globals.comboCharts?a[i]:i,m=s.barHelpers.getGroupIndex(v).columnGroupIndex,y=o.group({class:"apexcharts-series",seriesName:x.escapeString(r.globals.seriesNames[v]),rel:i+1,"data:realIndex":v});s.ctx.series.addCollapsedClassToSeries(y,v),t[i].length>0&&(s.visibleI=s.visibleI+1);var w,k,A=0;s.yRatio.length>1&&(s.yaxisIndex=r.globals.seriesYAxisReverseMap[v][0],A=v);var S=s.barHelpers.initialPositions();p=S.y,w=S.barHeight,h=S.yDivision,g=S.zeroW,u=S.x,k=S.barWidth,n=S.xDivision,d=S.zeroH,b.push(u+k/2);for(var C=o.group({class:"apexcharts-datalabels","data:realIndex":v}),L=function(a){var o=s.barHelpers.getStrokeWidth(i,a,v),c=null,x={indexes:{i:i,j:a,realIndex:v,translationsIndex:A},x:u,y:p,strokeWidth:o,elSeries:y};c=s.isHorizontal?s.drawHorizontalBoxPaths(e(e({},x),{},{yDivision:h,barHeight:w,zeroW:g})):s.drawVerticalBoxPaths(e(e({},x),{},{xDivision:n,barWidth:k,zeroH:d})),p=c.y,u=c.x,a>0&&b.push(u+k/2),f.push(p),c.pathTo.forEach((function(e,n){var h=!s.isBoxPlot&&s.candlestickOptions.wick.useFillColor?c.color[n]:r.globals.stroke.colors[i],d=l.fillPath({seriesNumber:v,dataPointIndex:a,color:c.color[n],value:t[i][a]});s.renderSeries({realIndex:v,pathFill:d,lineFill:h,j:a,i:i,pathFrom:c.pathFrom,pathTo:e,strokeWidth:o,elSeries:y,x:u,y:p,series:t,columnGroupIndex:m,barHeight:w,barWidth:k,elDataLabelsWrap:C,visibleSeries:s.visibleI,type:r.config.chart.type})}))},P=0;P<r.globals.dataPoints;P++)L(P);r.globals.seriesXvalues[v]=b,r.globals.seriesYvalues[v]=f,c.add(y)},g=0;g<t.length;g++)d(g);return c}},{key:"drawVerticalBoxPaths",value:function(t){var e=t.indexes,i=t.x;t.y;var a=t.xDivision,s=t.barWidth,r=t.zeroH,o=t.strokeWidth,n=this.w,l=new m(this.ctx),h=e.i,c=e.j,d=!0,g=n.config.plotOptions.candlestick.colors.upward,u=n.config.plotOptions.candlestick.colors.downward,p="";this.isBoxPlot&&(p=[this.boxOptions.colors.lower,this.boxOptions.colors.upper]);var f=this.yRatio[e.translationsIndex],x=e.realIndex,b=this.getOHLCValue(x,c),v=r,y=r;b.o>b.c&&(d=!1);var w=Math.min(b.o,b.c),k=Math.max(b.o,b.c),A=b.m;n.globals.isXNumeric&&(i=(n.globals.seriesX[x][c]-n.globals.minX)/this.xRatio-s/2);var S=i+s*this.visibleI;void 0===this.series[h][c]||null===this.series[h][c]?(w=r,k=r):(w=r-w/f,k=r-k/f,v=r-b.h/f,y=r-b.l/f,A=r-b.m/f);var C=l.move(S,r),L=l.move(S+s/2,w);return n.globals.previousPaths.length>0&&(L=this.getPreviousPath(x,c,!0)),C=this.isBoxPlot?[l.move(S,w)+l.line(S+s/2,w)+l.line(S+s/2,v)+l.line(S+s/4,v)+l.line(S+s-s/4,v)+l.line(S+s/2,v)+l.line(S+s/2,w)+l.line(S+s,w)+l.line(S+s,A)+l.line(S,A)+l.line(S,w+o/2),l.move(S,A)+l.line(S+s,A)+l.line(S+s,k)+l.line(S+s/2,k)+l.line(S+s/2,y)+l.line(S+s-s/4,y)+l.line(S+s/4,y)+l.line(S+s/2,y)+l.line(S+s/2,k)+l.line(S,k)+l.line(S,A)+"z"]:[l.move(S,k)+l.line(S+s/2,k)+l.line(S+s/2,v)+l.line(S+s/2,k)+l.line(S+s,k)+l.line(S+s,w)+l.line(S+s/2,w)+l.line(S+s/2,y)+l.line(S+s/2,w)+l.line(S,w)+l.line(S,k-o/2)],L+=l.move(S,w),n.globals.isXNumeric||(i+=a),{pathTo:C,pathFrom:L,x:i,y:k,barXPosition:S,color:this.isBoxPlot?p:d?[g]:[u]}}},{key:"drawHorizontalBoxPaths",value:function(t){var e=t.indexes;t.x;var i=t.y,a=t.yDivision,s=t.barHeight,r=t.zeroW,o=t.strokeWidth,n=this.w,l=new m(this.ctx),h=e.i,c=e.j,d=this.boxOptions.colors.lower;this.isBoxPlot&&(d=[this.boxOptions.colors.lower,this.boxOptions.colors.upper]);var g=this.invertedYRatio,u=e.realIndex,p=this.getOHLCValue(u,c),f=r,x=r,b=Math.min(p.o,p.c),v=Math.max(p.o,p.c),y=p.m;n.globals.isXNumeric&&(i=(n.globals.seriesX[u][c]-n.globals.minX)/this.invertedXRatio-s/2);var w=i+s*this.visibleI;void 0===this.series[h][c]||null===this.series[h][c]?(b=r,v=r):(b=r+b/g,v=r+v/g,f=r+p.h/g,x=r+p.l/g,y=r+p.m/g);var k=l.move(r,w),A=l.move(b,w+s/2);return n.globals.previousPaths.length>0&&(A=this.getPreviousPath(u,c,!0)),k=[l.move(b,w)+l.line(b,w+s/2)+l.line(f,w+s/2)+l.line(f,w+s/2-s/4)+l.line(f,w+s/2+s/4)+l.line(f,w+s/2)+l.line(b,w+s/2)+l.line(b,w+s)+l.line(y,w+s)+l.line(y,w)+l.line(b+o/2,w),l.move(y,w)+l.line(y,w+s)+l.line(v,w+s)+l.line(v,w+s/2)+l.line(x,w+s/2)+l.line(x,w+s-s/4)+l.line(x,w+s/4)+l.line(x,w+s/2)+l.line(v,w+s/2)+l.line(v,w)+l.line(y,w)+"z"],A+=l.move(b,w),n.globals.isXNumeric||(i+=a),{pathTo:k,pathFrom:A,x:v,y:i,barYPosition:w,color:d}}},{key:"getOHLCValue",value:function(t,e){var i=this.w;return{o:this.isBoxPlot?i.globals.seriesCandleH[t][e]:i.globals.seriesCandleO[t][e],h:this.isBoxPlot?i.globals.seriesCandleO[t][e]:i.globals.seriesCandleH[t][e],m:i.globals.seriesCandleM[t][e],l:this.isBoxPlot?i.globals.seriesCandleC[t][e]:i.globals.seriesCandleL[t][e],c:this.isBoxPlot?i.globals.seriesCandleL[t][e]:i.globals.seriesCandleC[t][e]}}}]),s}(yt),At=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"checkColorRange",value:function(){var t=this.w,e=!1,i=t.config.plotOptions[t.config.chart.type];return i.colorScale.ranges.length>0&&i.colorScale.ranges.map((function(t,i){t.from<=0&&(e=!0)})),e}},{key:"getShadeColor",value:function(t,e,i,a){var s=this.w,r=1,o=s.config.plotOptions[t].shadeIntensity,n=this.determineColor(t,e,i);s.globals.hasNegs||a?r=s.config.plotOptions[t].reverseNegativeShade?n.percent<0?n.percent/100*(1.25*o):(1-n.percent/100)*(1.25*o):n.percent<=0?1-(1+n.percent/100)*o:(1-n.percent/100)*o:(r=1-n.percent/100,"treemap"===t&&(r=(1-n.percent/100)*(1.25*o)));var l=n.color,h=new x;return s.config.plotOptions[t].enableShades&&(l="dark"===this.w.config.theme.mode?x.hexToRgba(h.shadeColor(-1*r,n.color),s.config.fill.opacity):x.hexToRgba(h.shadeColor(r,n.color),s.config.fill.opacity)),{color:l,colorProps:n}}},{key:"determineColor",value:function(t,e,i){var a=this.w,s=a.globals.series[e][i],r=a.config.plotOptions[t],o=r.colorScale.inverse?i:e;r.distributed&&"treemap"===a.config.chart.type&&(o=i);var n=a.globals.colors[o],l=null,h=Math.min.apply(Math,u(a.globals.series[e])),c=Math.max.apply(Math,u(a.globals.series[e]));r.distributed||"heatmap"!==t||(h=a.globals.minY,c=a.globals.maxY),void 0!==r.colorScale.min&&(h=r.colorScale.min<a.globals.minY?r.colorScale.min:a.globals.minY,c=r.colorScale.max>a.globals.maxY?r.colorScale.max:a.globals.maxY);var d=Math.abs(c)+Math.abs(h),g=100*s/(0===d?d-1e-6:d);r.colorScale.ranges.length>0&&r.colorScale.ranges.map((function(t,e){if(s>=t.from&&s<=t.to){n=t.color,l=t.foreColor?t.foreColor:null,h=t.from,c=t.to;var i=Math.abs(c)+Math.abs(h);g=100*s/(0===i?i-1e-6:i)}}));return{color:n,foreColor:l,percent:g}}},{key:"calculateDataLabels",value:function(t){var e=t.text,i=t.x,a=t.y,s=t.i,r=t.j,o=t.colorProps,n=t.fontSize,l=this.w.config.dataLabels,h=new m(this.ctx),c=new N(this.ctx),d=null;if(l.enabled){d=h.group({class:"apexcharts-data-labels"});var g=l.offsetX,u=l.offsetY,p=i+g,f=a+parseFloat(l.style.fontSize)/3+u;c.plotDataLabelsText({x:p,y:f,text:e,i:s,j:r,color:o.foreColor,parent:d,fontSize:n,dataLabelsConfig:l})}return d}},{key:"addListeners",value:function(t){var e=new m(this.ctx);t.node.addEventListener("mouseenter",e.pathMouseEnter.bind(this,t)),t.node.addEventListener("mouseleave",e.pathMouseLeave.bind(this,t)),t.node.addEventListener("mousedown",e.pathMouseDown.bind(this,t))}}]),t}(),St=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w,this.xRatio=i.xRatio,this.yRatio=i.yRatio,this.dynamicAnim=this.w.config.chart.animations.dynamicAnimation,this.helpers=new At(e),this.rectRadius=this.w.config.plotOptions.heatmap.radius,this.strokeWidth=this.w.config.stroke.show?this.w.config.stroke.width:0}return r(t,[{key:"draw",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-heatmap"});a.attr("clip-path","url(#gridRectMask".concat(e.globals.cuid,")"));var s=e.globals.gridWidth/e.globals.dataPoints,r=e.globals.gridHeight/e.globals.series.length,o=0,n=!1;this.negRange=this.helpers.checkColorRange();var l=t.slice();e.config.yaxis[0].reversed&&(n=!0,l.reverse());for(var h=n?0:l.length-1;n?h<l.length:h>=0;n?h++:h--){var c=i.group({class:"apexcharts-series apexcharts-heatmap-series",seriesName:x.escapeString(e.globals.seriesNames[h]),rel:h+1,"data:realIndex":h});if(this.ctx.series.addCollapsedClassToSeries(c,h),e.config.chart.dropShadow.enabled){var d=e.config.chart.dropShadow;new v(this.ctx).dropShadow(c,d,h)}for(var g=0,u=e.config.plotOptions.heatmap.shadeIntensity,p=0;p<l[h].length;p++){var f=this.helpers.getShadeColor(e.config.chart.type,h,p,this.negRange),b=f.color,y=f.colorProps;if("image"===e.config.fill.type)b=new H(this.ctx).fillPath({seriesNumber:h,dataPointIndex:p,opacity:e.globals.hasNegs?y.percent<0?1-(1+y.percent/100):u+y.percent/100:y.percent/100,patternID:x.randomId(),width:e.config.fill.image.width?e.config.fill.image.width:s,height:e.config.fill.image.height?e.config.fill.image.height:r});var w=this.rectRadius,k=i.drawRect(g,o,s,r,w);if(k.attr({cx:g,cy:o}),k.node.classList.add("apexcharts-heatmap-rect"),c.add(k),k.attr({fill:b,i:h,index:h,j:p,val:t[h][p],"stroke-width":this.strokeWidth,stroke:e.config.plotOptions.heatmap.useFillColorAsStroke?b:e.globals.stroke.colors[0],color:b}),this.helpers.addListeners(k),e.config.chart.animations.enabled&&!e.globals.dataChanged){var A=1;e.globals.resized||(A=e.config.chart.animations.speed),this.animateHeatMap(k,g,o,s,r,A)}if(e.globals.dataChanged){var S=1;if(this.dynamicAnim.enabled&&e.globals.shouldAnimate){S=this.dynamicAnim.speed;var C=e.globals.previousPaths[h]&&e.globals.previousPaths[h][p]&&e.globals.previousPaths[h][p].color;C||(C="rgba(255, 255, 255, 0)"),this.animateHeatColor(k,x.isColorHex(C)?C:x.rgb2hex(C),x.isColorHex(b)?b:x.rgb2hex(b),S)}}var L=(0,e.config.dataLabels.formatter)(e.globals.series[h][p],{value:e.globals.series[h][p],seriesIndex:h,dataPointIndex:p,w:e}),P=this.helpers.calculateDataLabels({text:L,x:g+s/2,y:o+r/2,i:h,j:p,colorProps:y,series:l});null!==P&&c.add(P),g+=s}o+=r,a.add(c)}var M=e.globals.yAxisScale[0].result.slice();return e.config.yaxis[0].reversed?M.unshift(""):M.push(""),e.globals.yAxisScale[0].result=M,a}},{key:"animateHeatMap",value:function(t,e,i,a,s,r){var o=new b(this.ctx);o.animateRect(t,{x:e+a/2,y:i+s/2,width:0,height:0},{x:e,y:i,width:a,height:s},r,(function(){o.animationCompleted(t)}))}},{key:"animateHeatColor",value:function(t,e,i,a){t.attr({fill:e}).animate(a).attr({fill:i})}}]),t}(),Ct=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawYAxisTexts",value:function(t,e,i,a){var s=this.w,r=s.config.yaxis[0],o=s.globals.yLabelFormatters[0];return new m(this.ctx).drawText({x:t+r.labels.offsetX,y:e+r.labels.offsetY,text:o(a,i),textAnchor:"middle",fontSize:r.labels.style.fontSize,fontFamily:r.labels.style.fontFamily,foreColor:Array.isArray(r.labels.style.colors)?r.labels.style.colors[i]:r.labels.style.colors})}}]),t}(),Lt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.chartType=this.w.config.chart.type,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled,this.animBeginArr=[0],this.animDur=0,this.donutDataLabels=this.w.config.plotOptions.pie.donut.labels,this.lineColorArr=void 0!==i.globals.stroke.colors?i.globals.stroke.colors:i.globals.colors,this.defaultSize=Math.min(i.globals.gridWidth,i.globals.gridHeight),this.centerY=this.defaultSize/2,this.centerX=i.globals.gridWidth/2,"radialBar"===i.config.chart.type?this.fullAngle=360:this.fullAngle=Math.abs(i.config.plotOptions.pie.endAngle-i.config.plotOptions.pie.startAngle),this.initialAngle=i.config.plotOptions.pie.startAngle%this.fullAngle,i.globals.radialSize=this.defaultSize/2.05-i.config.stroke.width-(i.config.chart.sparkline.enabled?0:i.config.chart.dropShadow.blur),this.donutSize=i.globals.radialSize*parseInt(i.config.plotOptions.pie.donut.size,10)/100,this.maxY=0,this.sliceLabels=[],this.sliceSizes=[],this.prevSectorAngleArr=[]}return r(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new m(this.ctx);if(this.ret=a.group({class:"apexcharts-pie"}),i.globals.noData)return this.ret;for(var s=0,r=0;r<t.length;r++)s+=x.negToZero(t[r]);var o=[],n=a.group();0===s&&(s=1e-5),t.forEach((function(t){e.maxY=Math.max(e.maxY,t)})),i.config.yaxis[0].max&&(this.maxY=i.config.yaxis[0].max),"back"===i.config.grid.position&&"polarArea"===this.chartType&&this.drawPolarElements(this.ret);for(var l=0;l<t.length;l++){var h=this.fullAngle*x.negToZero(t[l])/s;o.push(h),"polarArea"===this.chartType?(o[l]=this.fullAngle/t.length,this.sliceSizes.push(i.globals.radialSize*t[l]/this.maxY)):this.sliceSizes.push(i.globals.radialSize)}if(i.globals.dataChanged){for(var c,d=0,g=0;g<i.globals.previousPaths.length;g++)d+=x.negToZero(i.globals.previousPaths[g]);for(var u=0;u<i.globals.previousPaths.length;u++)c=this.fullAngle*x.negToZero(i.globals.previousPaths[u])/d,this.prevSectorAngleArr.push(c)}this.donutSize<0&&(this.donutSize=0);var p=i.config.plotOptions.pie.customScale,f=i.globals.gridWidth/2,b=i.globals.gridHeight/2,v=f-i.globals.gridWidth/2*p,y=b-i.globals.gridHeight/2*p;if("donut"===this.chartType){var w=a.drawCircle(this.donutSize);w.attr({cx:this.centerX,cy:this.centerY,fill:i.config.plotOptions.pie.donut.background?i.config.plotOptions.pie.donut.background:"transparent"}),n.add(w)}var k=this.drawArcs(o,t);if(this.sliceLabels.forEach((function(t){k.add(t)})),n.attr({transform:"translate(".concat(v,", ").concat(y,") scale(").concat(p,")")}),n.add(k),this.ret.add(n),this.donutDataLabels.show){var A=this.renderInnerDataLabels(this.donutDataLabels,{hollowSize:this.donutSize,centerX:this.centerX,centerY:this.centerY,opacity:this.donutDataLabels.show,translateX:v,translateY:y});this.ret.add(A)}return"front"===i.config.grid.position&&"polarArea"===this.chartType&&this.drawPolarElements(this.ret),this.ret}},{key:"drawArcs",value:function(t,e){var i=this.w,a=new v(this.ctx),s=new m(this.ctx),r=new H(this.ctx),o=s.group({class:"apexcharts-slices"}),n=this.initialAngle,l=this.initialAngle,h=this.initialAngle,c=this.initialAngle;this.strokeWidth=i.config.stroke.show?i.config.stroke.width:0;for(var d=0;d<t.length;d++){var g=s.group({class:"apexcharts-series apexcharts-pie-series",seriesName:x.escapeString(i.globals.seriesNames[d]),rel:d+1,"data:realIndex":d});o.add(g),l=c,h=(n=h)+t[d],c=l+this.prevSectorAngleArr[d];var u=h<n?this.fullAngle+h-n:h-n,p=r.fillPath({seriesNumber:d,size:this.sliceSizes[d],value:e[d]}),f=this.getChangedPath(l,c),b=s.drawPath({d:f,stroke:Array.isArray(this.lineColorArr)?this.lineColorArr[d]:this.lineColorArr,strokeWidth:0,fill:p,fillOpacity:i.config.fill.opacity,classes:"apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(),"-slice-").concat(d)});if(b.attr({index:0,j:d}),a.setSelectionFilter(b,0,d),i.config.chart.dropShadow.enabled){var y=i.config.chart.dropShadow;a.dropShadow(b,y,d)}this.addListeners(b,this.donutDataLabels),m.setAttrs(b.node,{"data:angle":u,"data:startAngle":n,"data:strokeWidth":this.strokeWidth,"data:value":e[d]});var w={x:0,y:0};"pie"===this.chartType||"polarArea"===this.chartType?w=x.polarToCartesian(this.centerX,this.centerY,i.globals.radialSize/1.25+i.config.plotOptions.pie.dataLabels.offset,(n+u/2)%this.fullAngle):"donut"===this.chartType&&(w=x.polarToCartesian(this.centerX,this.centerY,(i.globals.radialSize+this.donutSize)/2+i.config.plotOptions.pie.dataLabels.offset,(n+u/2)%this.fullAngle)),g.add(b);var k=0;if(!this.initialAnim||i.globals.resized||i.globals.dataChanged?this.animBeginArr.push(0):(0===(k=u/this.fullAngle*i.config.chart.animations.speed)&&(k=1),this.animDur=k+this.animDur,this.animBeginArr.push(this.animDur)),this.dynamicAnim&&i.globals.dataChanged?this.animatePaths(b,{size:this.sliceSizes[d],endAngle:h,startAngle:n,prevStartAngle:l,prevEndAngle:c,animateStartingPos:!0,i:d,animBeginArr:this.animBeginArr,shouldSetPrevPaths:!0,dur:i.config.chart.animations.dynamicAnimation.speed}):this.animatePaths(b,{size:this.sliceSizes[d],endAngle:h,startAngle:n,i:d,totalItems:t.length-1,animBeginArr:this.animBeginArr,dur:k}),i.config.plotOptions.pie.expandOnClick&&"polarArea"!==this.chartType&&b.node.addEventListener("mouseup",this.pieClicked.bind(this,d)),void 0!==i.globals.selectedDataPoints[0]&&i.globals.selectedDataPoints[0].indexOf(d)>-1&&this.pieClicked(d),i.config.dataLabels.enabled){var A=w.x,S=w.y,C=100*u/this.fullAngle+"%";if(0!==u&&i.config.plotOptions.pie.dataLabels.minAngleToShowLabel<t[d]){var L=i.config.dataLabels.formatter;void 0!==L&&(C=L(i.globals.seriesPercent[d][0],{seriesIndex:d,w:i}));var P=i.globals.dataLabels.style.colors[d],M=s.group({class:"apexcharts-datalabels"}),I=s.drawText({x:A,y:S,text:C,textAnchor:"middle",fontSize:i.config.dataLabels.style.fontSize,fontFamily:i.config.dataLabels.style.fontFamily,fontWeight:i.config.dataLabels.style.fontWeight,foreColor:P});if(M.add(I),i.config.dataLabels.dropShadow.enabled){var T=i.config.dataLabels.dropShadow;a.dropShadow(I,T)}I.node.classList.add("apexcharts-pie-label"),i.config.chart.animations.animate&&!1===i.globals.resized&&(I.node.classList.add("apexcharts-pie-label-delay"),I.node.style.animationDelay=i.config.chart.animations.speed/940+"s"),this.sliceLabels.push(M)}}}return o}},{key:"addListeners",value:function(t,e){var i=new m(this.ctx);t.node.addEventListener("mouseenter",i.pathMouseEnter.bind(this,t)),t.node.addEventListener("mouseleave",i.pathMouseLeave.bind(this,t)),t.node.addEventListener("mouseleave",this.revertDataLabelsInner.bind(this,t.node,e)),t.node.addEventListener("mousedown",i.pathMouseDown.bind(this,t)),this.donutDataLabels.total.showAlways||(t.node.addEventListener("mouseenter",this.printDataLabelsInner.bind(this,t.node,e)),t.node.addEventListener("mousedown",this.printDataLabelsInner.bind(this,t.node,e)))}},{key:"animatePaths",value:function(t,e){var i=this.w,a=e.endAngle<e.startAngle?this.fullAngle+e.endAngle-e.startAngle:e.endAngle-e.startAngle,s=a,r=e.startAngle,o=e.startAngle;void 0!==e.prevStartAngle&&void 0!==e.prevEndAngle&&(r=e.prevEndAngle,s=e.prevEndAngle<e.prevStartAngle?this.fullAngle+e.prevEndAngle-e.prevStartAngle:e.prevEndAngle-e.prevStartAngle),e.i===i.config.series.length-1&&(a+o>this.fullAngle?e.endAngle=e.endAngle-(a+o):a+o<this.fullAngle&&(e.endAngle=e.endAngle+(this.fullAngle-(a+o)))),a===this.fullAngle&&(a=this.fullAngle-.01),this.animateArc(t,r,o,a,s,e)}},{key:"animateArc",value:function(t,e,i,a,s,r){var o,n=this,l=this.w,h=new b(this.ctx),c=r.size;(isNaN(e)||isNaN(s))&&(e=i,s=a,r.dur=0);var d=a,g=i,u=e<i?this.fullAngle+e-i:e-i;l.globals.dataChanged&&r.shouldSetPrevPaths&&r.prevEndAngle&&(o=n.getPiePath({me:n,startAngle:r.prevStartAngle,angle:r.prevEndAngle<r.prevStartAngle?this.fullAngle+r.prevEndAngle-r.prevStartAngle:r.prevEndAngle-r.prevStartAngle,size:c}),t.attr({d:o})),0!==r.dur?t.animate(r.dur,l.globals.easing,r.animBeginArr[r.i]).afterAll((function(){"pie"!==n.chartType&&"donut"!==n.chartType&&"polarArea"!==n.chartType||this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({"stroke-width":n.strokeWidth}),r.i===l.config.series.length-1&&h.animationCompleted(t)})).during((function(l){d=u+(a-u)*l,r.animateStartingPos&&(d=s+(a-s)*l,g=e-s+(i-(e-s))*l),o=n.getPiePath({me:n,startAngle:g,angle:d,size:c}),t.node.setAttribute("data:pathOrig",o),t.attr({d:o})})):(o=n.getPiePath({me:n,startAngle:g,angle:a,size:c}),r.isTrack||(l.globals.animationEnded=!0),t.node.setAttribute("data:pathOrig",o),t.attr({d:o,"stroke-width":n.strokeWidth}))}},{key:"pieClicked",value:function(t){var e,i=this.w,a=this,s=a.sliceSizes[t]+(i.config.plotOptions.pie.expandOnClick?4:0),r=i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(),"-slice-").concat(t)).members[0];if("true"!==r.attr("data:pieClicked")){var o=i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");Array.prototype.forEach.call(o,(function(t){t.setAttribute("data:pieClicked","false");var e=t.getAttribute("data:pathOrig");e&&t.setAttribute("d",e)})),i.globals.capturedDataPointIndex=t,r.attr("data:pieClicked","true");var n=parseInt(r.attr("data:startAngle"),10),l=parseInt(r.attr("data:angle"),10);e=a.getPiePath({me:a,startAngle:n,angle:l,size:s}),360!==l&&r.plot(e)}else{r.attr({"data:pieClicked":"false"}),this.revertDataLabelsInner(r.node,this.donutDataLabels);var h=r.attr("data:pathOrig");r.attr({d:h})}}},{key:"getChangedPath",value:function(t,e){var i="";return this.dynamicAnim&&this.w.globals.dataChanged&&(i=this.getPiePath({me:this,startAngle:t,angle:e-t,size:this.size})),i}},{key:"getPiePath",value:function(t){var e,i=t.me,a=t.startAngle,s=t.angle,r=t.size,o=new m(this.ctx),n=a,l=Math.PI*(n-90)/180,h=s+a;Math.ceil(h)>=this.fullAngle+this.w.config.plotOptions.pie.startAngle%this.fullAngle&&(h=this.fullAngle+this.w.config.plotOptions.pie.startAngle%this.fullAngle-.01),Math.ceil(h)>this.fullAngle&&(h-=this.fullAngle);var c=Math.PI*(h-90)/180,d=i.centerX+r*Math.cos(l),g=i.centerY+r*Math.sin(l),u=i.centerX+r*Math.cos(c),p=i.centerY+r*Math.sin(c),f=x.polarToCartesian(i.centerX,i.centerY,i.donutSize,h),b=x.polarToCartesian(i.centerX,i.centerY,i.donutSize,n),v=s>180?1:0,y=["M",d,g,"A",r,r,0,v,1,u,p];return e="donut"===i.chartType?[].concat(y,["L",f.x,f.y,"A",i.donutSize,i.donutSize,0,v,0,b.x,b.y,"L",d,g,"z"]).join(" "):"pie"===i.chartType||"polarArea"===i.chartType?[].concat(y,["L",i.centerX,i.centerY,"L",d,g]).join(" "):[].concat(y).join(" "),o.roundPathCorners(e,2*this.strokeWidth)}},{key:"drawPolarElements",value:function(t){var e=this.w,i=new _(this.ctx),a=new m(this.ctx),s=new Ct(this.ctx),r=a.group(),o=a.group(),n=i.niceScale(0,Math.ceil(this.maxY),0),l=n.result.reverse(),h=n.result.length;this.maxY=n.niceMax;for(var c=e.globals.radialSize,d=c/(h-1),g=0;g<h-1;g++){var u=a.drawCircle(c);if(u.attr({cx:this.centerX,cy:this.centerY,fill:"none","stroke-width":e.config.plotOptions.polarArea.rings.strokeWidth,stroke:e.config.plotOptions.polarArea.rings.strokeColor}),e.config.yaxis[0].show){var p=s.drawYAxisTexts(this.centerX,this.centerY-c+parseInt(e.config.yaxis[0].labels.style.fontSize,10)/2,g,l[g]);o.add(p)}r.add(u),c-=d}this.drawSpokes(t),t.add(r),t.add(o)}},{key:"renderInnerDataLabels",value:function(t,e){var i=this.w,a=new m(this.ctx),s=a.group({class:"apexcharts-datalabels-group",transform:"translate(".concat(e.translateX?e.translateX:0,", ").concat(e.translateY?e.translateY:0,") scale(").concat(i.config.plotOptions.pie.customScale,")")}),r=t.total.show;s.node.style.opacity=e.opacity;var o,n,l=e.centerX,h=e.centerY;o=void 0===t.name.color?i.globals.colors[0]:t.name.color;var c=t.name.fontSize,d=t.name.fontFamily,g=t.name.fontWeight;n=void 0===t.value.color?i.config.chart.foreColor:t.value.color;var u=t.value.formatter,p="",f="";if(r?(o=t.total.color,c=t.total.fontSize,d=t.total.fontFamily,g=t.total.fontWeight,f=t.total.label,p=t.total.formatter(i)):1===i.globals.series.length&&(p=u(i.globals.series[0],i),f=i.globals.seriesNames[0]),f&&(f=t.name.formatter(f,t.total.show,i)),t.name.show){var x=a.drawText({x:l,y:h+parseFloat(t.name.offsetY),text:f,textAnchor:"middle",foreColor:o,fontSize:c,fontWeight:g,fontFamily:d});x.node.classList.add("apexcharts-datalabel-label"),s.add(x)}if(t.value.show){var b=t.name.show?parseFloat(t.value.offsetY)+16:t.value.offsetY,v=a.drawText({x:l,y:h+b,text:p,textAnchor:"middle",foreColor:n,fontWeight:t.value.fontWeight,fontSize:t.value.fontSize,fontFamily:t.value.fontFamily});v.node.classList.add("apexcharts-datalabel-value"),s.add(v)}return s}},{key:"printInnerLabels",value:function(t,e,i,a){var s,r=this.w;a?s=void 0===t.name.color?r.globals.colors[parseInt(a.parentNode.getAttribute("rel"),10)-1]:t.name.color:r.globals.series.length>1&&t.total.show&&(s=t.total.color);var o=r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"),n=r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");i=(0,t.value.formatter)(i,r),a||"function"!=typeof t.total.formatter||(i=t.total.formatter(r));var l=e===t.total.label;e=t.name.formatter(e,l,r),null!==o&&(o.textContent=e),null!==n&&(n.textContent=i),null!==o&&(o.style.fill=s)}},{key:"printDataLabelsInner",value:function(t,e){var i=this.w,a=t.getAttribute("data:value"),s=i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"),10)-1];i.globals.series.length>1&&this.printInnerLabels(e,s,a,t);var r=i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");null!==r&&(r.style.opacity=1)}},{key:"drawSpokes",value:function(t){var e=this,i=this.w,a=new m(this.ctx),s=i.config.plotOptions.polarArea.spokes;if(0!==s.strokeWidth){for(var r=[],o=360/i.globals.series.length,n=0;n<i.globals.series.length;n++)r.push(x.polarToCartesian(this.centerX,this.centerY,i.globals.radialSize,i.config.plotOptions.pie.startAngle+o*n));r.forEach((function(i,r){var o=a.drawLine(i.x,i.y,e.centerX,e.centerY,Array.isArray(s.connectorColors)?s.connectorColors[r]:s.connectorColors);t.add(o)}))}}},{key:"revertDataLabelsInner",value:function(t,e,i){var a=this,s=this.w,r=s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"),o=!1,n=s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"),l=function(t){var i=t.makeSliceOut,s=t.printLabel;Array.prototype.forEach.call(n,(function(t){"true"===t.getAttribute("data:pieClicked")&&(i&&(o=!0),s&&a.printDataLabelsInner(t,e))}))};if(l({makeSliceOut:!0,printLabel:!1}),e.total.show&&s.globals.series.length>1)o&&!e.total.showAlways?l({makeSliceOut:!1,printLabel:!0}):this.printInnerLabels(e,e.total.label,e.total.formatter(s));else if(l({makeSliceOut:!1,printLabel:!0}),!o)if(s.globals.selectedDataPoints.length&&s.globals.series.length>1)if(s.globals.selectedDataPoints[0].length>0){var h=s.globals.selectedDataPoints[0],c=s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(),"-slice-").concat(h));this.printDataLabelsInner(c,e)}else r&&s.globals.selectedDataPoints.length&&0===s.globals.selectedDataPoints[0].length&&(r.style.opacity=0);else r&&s.globals.series.length>1&&(r.style.opacity=0)}}]),t}(),Pt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.chartType=this.w.config.chart.type,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled,this.animDur=0;var i=this.w;this.graphics=new m(this.ctx),this.lineColorArr=void 0!==i.globals.stroke.colors?i.globals.stroke.colors:i.globals.colors,this.defaultSize=i.globals.svgHeight<i.globals.svgWidth?i.globals.gridHeight+1.5*i.globals.goldenPadding:i.globals.gridWidth,this.isLog=i.config.yaxis[0].logarithmic,this.logBase=i.config.yaxis[0].logBase,this.coreUtils=new y(this.ctx),this.maxValue=this.isLog?this.coreUtils.getLogVal(this.logBase,i.globals.maxY,0):i.globals.maxY,this.minValue=this.isLog?this.coreUtils.getLogVal(this.logBase,this.w.globals.minY,0):i.globals.minY,this.polygons=i.config.plotOptions.radar.polygons,this.strokeWidth=i.config.stroke.show?i.config.stroke.width:0,this.size=this.defaultSize/2.1-this.strokeWidth-i.config.chart.dropShadow.blur,i.config.xaxis.labels.show&&(this.size=this.size-i.globals.xAxisLabelsWidth/1.75),void 0!==i.config.plotOptions.radar.size&&(this.size=i.config.plotOptions.radar.size),this.dataRadiusOfPercent=[],this.dataRadius=[],this.angleArr=[],this.yaxisLabelsTextsPos=[]}return r(t,[{key:"draw",value:function(t){var i=this,a=this.w,s=new H(this.ctx),r=[],o=new N(this.ctx);t.length&&(this.dataPointsLen=t[a.globals.maxValsInArrayIndex].length),this.disAngle=2*Math.PI/this.dataPointsLen;var n=a.globals.gridWidth/2,l=a.globals.gridHeight/2,h=n+a.config.plotOptions.radar.offsetX,c=l+a.config.plotOptions.radar.offsetY,d=this.graphics.group({class:"apexcharts-radar-series apexcharts-plot-series",transform:"translate(".concat(h||0,", ").concat(c||0,")")}),g=[],u=null,p=null;if(this.yaxisLabels=this.graphics.group({class:"apexcharts-yaxis"}),t.forEach((function(t,n){var l=t.length===a.globals.dataPoints,h=i.graphics.group().attr({class:"apexcharts-series","data:longestSeries":l,seriesName:x.escapeString(a.globals.seriesNames[n]),rel:n+1,"data:realIndex":n});i.dataRadiusOfPercent[n]=[],i.dataRadius[n]=[],i.angleArr[n]=[],t.forEach((function(t,e){var a=Math.abs(i.maxValue-i.minValue);t-=i.minValue,i.isLog&&(t=i.coreUtils.getLogVal(i.logBase,t,0)),i.dataRadiusOfPercent[n][e]=t/a,i.dataRadius[n][e]=i.dataRadiusOfPercent[n][e]*i.size,i.angleArr[n][e]=e*i.disAngle})),g=i.getDataPointsPos(i.dataRadius[n],i.angleArr[n]);var c=i.createPaths(g,{x:0,y:0});u=i.graphics.group({class:"apexcharts-series-markers-wrap apexcharts-element-hidden"}),p=i.graphics.group({class:"apexcharts-datalabels","data:realIndex":n}),a.globals.delayedElements.push({el:u.node,index:n});var d={i:n,realIndex:n,animationDelay:n,initialSpeed:a.config.chart.animations.speed,dataChangeSpeed:a.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-radar",shouldClipToGrid:!1,bindEventsOnPaths:!1,stroke:a.globals.stroke.colors[n],strokeLineCap:a.config.stroke.lineCap},f=null;a.globals.previousPaths.length>0&&(f=i.getPreviousPath(n));for(var b=0;b<c.linePathsTo.length;b++){var m=i.graphics.renderPaths(e(e({},d),{},{pathFrom:null===f?c.linePathsFrom[b]:f,pathTo:c.linePathsTo[b],strokeWidth:Array.isArray(i.strokeWidth)?i.strokeWidth[n]:i.strokeWidth,fill:"none",drawShadow:!1}));h.add(m);var y=s.fillPath({seriesNumber:n}),w=i.graphics.renderPaths(e(e({},d),{},{pathFrom:null===f?c.areaPathsFrom[b]:f,pathTo:c.areaPathsTo[b],strokeWidth:0,fill:y,drawShadow:!1}));if(a.config.chart.dropShadow.enabled){var k=new v(i.ctx),A=a.config.chart.dropShadow;k.dropShadow(w,Object.assign({},A,{noUserSpaceOnUse:!0}),n)}h.add(w)}t.forEach((function(t,s){var r=new D(i.ctx).getMarkerConfig({cssClass:"apexcharts-marker",seriesIndex:n,dataPointIndex:s}),l=i.graphics.drawMarker(g[s].x,g[s].y,r);l.attr("rel",s),l.attr("j",s),l.attr("index",n),l.node.setAttribute("default-marker-size",r.pSize);var c=i.graphics.group({class:"apexcharts-series-markers"});c&&c.add(l),u.add(c),h.add(u);var d=a.config.dataLabels;if(d.enabled){var f=d.formatter(a.globals.series[n][s],{seriesIndex:n,dataPointIndex:s,w:a});o.plotDataLabelsText({x:g[s].x,y:g[s].y,text:f,textAnchor:"middle",i:n,j:n,parent:p,offsetCorrection:!1,dataLabelsConfig:e({},d)})}h.add(p)})),r.push(h)})),this.drawPolygons({parent:d}),a.config.xaxis.labels.show){var f=this.drawXAxisTexts();d.add(f)}return r.forEach((function(t){d.add(t)})),d.add(this.yaxisLabels),d}},{key:"drawPolygons",value:function(t){for(var e=this,i=this.w,a=t.parent,s=new Ct(this.ctx),r=i.globals.yAxisScale[0].result.reverse(),o=r.length,n=[],l=this.size/(o-1),h=0;h<o;h++)n[h]=l*h;n.reverse();var c=[],d=[];n.forEach((function(t,i){var a=x.getPolygonPos(t,e.dataPointsLen),s="";a.forEach((function(t,a){if(0===i){var r=e.graphics.drawLine(t.x,t.y,0,0,Array.isArray(e.polygons.connectorColors)?e.polygons.connectorColors[a]:e.polygons.connectorColors);d.push(r)}0===a&&e.yaxisLabelsTextsPos.push({x:t.x,y:t.y}),s+=t.x+","+t.y+" "})),c.push(s)})),c.forEach((function(t,s){var r=e.polygons.strokeColors,o=e.polygons.strokeWidth,n=e.graphics.drawPolygon(t,Array.isArray(r)?r[s]:r,Array.isArray(o)?o[s]:o,i.globals.radarPolygons.fill.colors[s]);a.add(n)})),d.forEach((function(t){a.add(t)})),i.config.yaxis[0].show&&this.yaxisLabelsTextsPos.forEach((function(t,i){var a=s.drawYAxisTexts(t.x,t.y,i,r[i]);e.yaxisLabels.add(a)}))}},{key:"drawXAxisTexts",value:function(){var t=this,i=this.w,a=i.config.xaxis.labels,s=this.graphics.group({class:"apexcharts-xaxis"}),r=x.getPolygonPos(this.size,this.dataPointsLen);return i.globals.labels.forEach((function(o,n){var l=i.config.xaxis.labels.formatter,h=new N(t.ctx);if(r[n]){var c=t.getTextPos(r[n],t.size),d=l(o,{seriesIndex:-1,dataPointIndex:n,w:i});h.plotDataLabelsText({x:c.newX,y:c.newY,text:d,textAnchor:c.textAnchor,i:n,j:n,parent:s,color:Array.isArray(a.style.colors)&&a.style.colors[n]?a.style.colors[n]:"#a8a8a8",dataLabelsConfig:e({textAnchor:c.textAnchor,dropShadow:{enabled:!1}},a),offsetCorrection:!1})}})),s}},{key:"createPaths",value:function(t,e){var i=this,a=[],s=[],r=[],o=[];if(t.length){s=[this.graphics.move(e.x,e.y)],o=[this.graphics.move(e.x,e.y)];var n=this.graphics.move(t[0].x,t[0].y),l=this.graphics.move(t[0].x,t[0].y);t.forEach((function(e,a){n+=i.graphics.line(e.x,e.y),l+=i.graphics.line(e.x,e.y),a===t.length-1&&(n+="Z",l+="Z")})),a.push(n),r.push(l)}return{linePathsFrom:s,linePathsTo:a,areaPathsFrom:o,areaPathsTo:r}}},{key:"getTextPos",value:function(t,e){var i="middle",a=t.x,s=t.y;return Math.abs(t.x)>=10?t.x>0?(i="start",a+=10):t.x<0&&(i="end",a-=10):i="middle",Math.abs(t.y)>=e-10&&(t.y<0?s-=10:t.y>0&&(s+=10)),{textAnchor:i,newX:a,newY:s}}},{key:"getPreviousPath",value:function(t){for(var e=this.w,i=null,a=0;a<e.globals.previousPaths.length;a++){var s=e.globals.previousPaths[a];s.paths.length>0&&parseInt(s.realIndex,10)===parseInt(t,10)&&void 0!==e.globals.previousPaths[a].paths[0]&&(i=e.globals.previousPaths[a].paths[0].d)}return i}},{key:"getDataPointsPos",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.dataPointsLen;t=t||[],e=e||[];for(var a=[],s=0;s<i;s++){var r={};r.x=t[s]*Math.sin(e[s]),r.y=-t[s]*Math.cos(e[s]),a.push(r)}return a}}]),t}(),Mt=function(t){n(i,t);var e=d(i);function i(t){var s;a(this,i),(s=e.call(this,t)).ctx=t,s.w=t.w,s.animBeginArr=[0],s.animDur=0;var r=s.w;return s.startAngle=r.config.plotOptions.radialBar.startAngle,s.endAngle=r.config.plotOptions.radialBar.endAngle,s.totalAngle=Math.abs(r.config.plotOptions.radialBar.endAngle-r.config.plotOptions.radialBar.startAngle),s.trackStartAngle=r.config.plotOptions.radialBar.track.startAngle,s.trackEndAngle=r.config.plotOptions.radialBar.track.endAngle,s.barLabels=s.w.config.plotOptions.radialBar.barLabels,s.donutDataLabels=s.w.config.plotOptions.radialBar.dataLabels,s.radialDataLabels=s.donutDataLabels,s.trackStartAngle||(s.trackStartAngle=s.startAngle),s.trackEndAngle||(s.trackEndAngle=s.endAngle),360===s.endAngle&&(s.endAngle=359.99),s.margin=parseInt(r.config.plotOptions.radialBar.track.margin,10),s.onBarLabelClick=s.onBarLabelClick.bind(c(s)),s}return r(i,[{key:"draw",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-radialbar"});if(e.globals.noData)return a;var s=i.group(),r=this.defaultSize/2,o=e.globals.gridWidth/2,n=this.defaultSize/2.05;e.config.chart.sparkline.enabled||(n=n-e.config.stroke.width-e.config.chart.dropShadow.blur);var l=e.globals.fill.colors;if(e.config.plotOptions.radialBar.track.show){var h=this.drawTracks({size:n,centerX:o,centerY:r,colorArr:l,series:t});s.add(h)}var c=this.drawArcs({size:n,centerX:o,centerY:r,colorArr:l,series:t}),d=360;e.config.plotOptions.radialBar.startAngle<0&&(d=this.totalAngle);var g=(360-d)/360;if(e.globals.radialSize=n-n*g,this.radialDataLabels.value.show){var u=Math.max(this.radialDataLabels.value.offsetY,this.radialDataLabels.name.offsetY);e.globals.radialSize+=u*g}return s.add(c.g),"front"===e.config.plotOptions.radialBar.hollow.position&&(c.g.add(c.elHollow),c.dataLabels&&c.g.add(c.dataLabels)),a.add(s),a}},{key:"drawTracks",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-tracks"}),s=new v(this.ctx),r=new H(this.ctx),o=this.getStrokeWidth(t);t.size=t.size-o/2;for(var n=0;n<t.series.length;n++){var l=i.group({class:"apexcharts-radialbar-track apexcharts-track"});a.add(l),l.attr({rel:n+1}),t.size=t.size-o-this.margin;var h=e.config.plotOptions.radialBar.track,c=r.fillPath({seriesNumber:0,size:t.size,fillColors:Array.isArray(h.background)?h.background[n]:h.background,solid:!0}),d=this.trackStartAngle,g=this.trackEndAngle;Math.abs(g)+Math.abs(d)>=360&&(g=360-Math.abs(this.startAngle)-.1);var u=i.drawPath({d:"",stroke:c,strokeWidth:o*parseInt(h.strokeWidth,10)/100,fill:"none",strokeOpacity:h.opacity,classes:"apexcharts-radialbar-area"});if(h.dropShadow.enabled){var p=h.dropShadow;s.dropShadow(u,p)}l.add(u),u.attr("id","apexcharts-radialbarTrack-"+n),this.animatePaths(u,{centerX:t.centerX,centerY:t.centerY,endAngle:g,startAngle:d,size:t.size,i:n,totalItems:2,animBeginArr:0,dur:0,isTrack:!0,easing:e.globals.easing})}return a}},{key:"drawArcs",value:function(t){var e=this.w,i=new m(this.ctx),a=new H(this.ctx),s=new v(this.ctx),r=i.group(),o=this.getStrokeWidth(t);t.size=t.size-o/2;var n=e.config.plotOptions.radialBar.hollow.background,l=t.size-o*t.series.length-this.margin*t.series.length-o*parseInt(e.config.plotOptions.radialBar.track.strokeWidth,10)/100/2,h=l-e.config.plotOptions.radialBar.hollow.margin;void 0!==e.config.plotOptions.radialBar.hollow.image&&(n=this.drawHollowImage(t,r,l,n));var c=this.drawHollow({size:h,centerX:t.centerX,centerY:t.centerY,fill:n||"transparent"});if(e.config.plotOptions.radialBar.hollow.dropShadow.enabled){var d=e.config.plotOptions.radialBar.hollow.dropShadow;s.dropShadow(c,d)}var g=1;!this.radialDataLabels.total.show&&e.globals.series.length>1&&(g=0);var u=null;this.radialDataLabels.show&&(u=this.renderInnerDataLabels(this.radialDataLabels,{hollowSize:l,centerX:t.centerX,centerY:t.centerY,opacity:g})),"back"===e.config.plotOptions.radialBar.hollow.position&&(r.add(c),u&&r.add(u));var p=!1;e.config.plotOptions.radialBar.inverseOrder&&(p=!0);for(var f=p?t.series.length-1:0;p?f>=0:f<t.series.length;p?f--:f++){var b=i.group({class:"apexcharts-series apexcharts-radial-series",seriesName:x.escapeString(e.globals.seriesNames[f])});r.add(b),b.attr({rel:f+1,"data:realIndex":f}),this.ctx.series.addCollapsedClassToSeries(b,f),t.size=t.size-o-this.margin;var y=a.fillPath({seriesNumber:f,size:t.size,value:t.series[f]}),w=this.startAngle,k=void 0,A=x.negToZero(t.series[f]>100?100:t.series[f])/100,S=Math.round(this.totalAngle*A)+this.startAngle,C=void 0;e.globals.dataChanged&&(k=this.startAngle,C=Math.round(this.totalAngle*x.negToZero(e.globals.previousPaths[f])/100)+k),Math.abs(S)+Math.abs(w)>=360&&(S-=.01),Math.abs(C)+Math.abs(k)>=360&&(C-=.01);var L=S-w,P=Array.isArray(e.config.stroke.dashArray)?e.config.stroke.dashArray[f]:e.config.stroke.dashArray,M=i.drawPath({d:"",stroke:y,strokeWidth:o,fill:"none",fillOpacity:e.config.fill.opacity,classes:"apexcharts-radialbar-area apexcharts-radialbar-slice-"+f,strokeDashArray:P});if(m.setAttrs(M.node,{"data:angle":L,"data:value":t.series[f]}),e.config.chart.dropShadow.enabled){var I=e.config.chart.dropShadow;s.dropShadow(M,I,f)}if(s.setSelectionFilter(M,0,f),this.addListeners(M,this.radialDataLabels),b.add(M),M.attr({index:0,j:f}),this.barLabels.enabled){var T=x.polarToCartesian(t.centerX,t.centerY,t.size,w),z=this.barLabels.formatter(e.globals.seriesNames[f],{seriesIndex:f,w:e}),X=["apexcharts-radialbar-label"];this.barLabels.onClick||X.push("apexcharts-no-click");var E=this.barLabels.useSeriesColors?e.globals.colors[f]:e.config.chart.foreColor;E||(E=e.config.chart.foreColor);var Y=T.x-this.barLabels.margin,F=T.y,R=i.drawText({x:Y,y:F,text:z,textAnchor:"end",dominantBaseline:"middle",fontFamily:this.barLabels.fontFamily,fontWeight:this.barLabels.fontWeight,fontSize:this.barLabels.fontSize,foreColor:E,cssClass:X.join(" ")});R.on("click",this.onBarLabelClick),R.attr({rel:f+1}),0!==w&&R.attr({"transform-origin":"".concat(Y," ").concat(F),transform:"rotate(".concat(w," 0 0)")}),b.add(R)}var D=0;!this.initialAnim||e.globals.resized||e.globals.dataChanged||(D=e.config.chart.animations.speed),e.globals.dataChanged&&(D=e.config.chart.animations.dynamicAnimation.speed),this.animDur=D/(1.2*t.series.length)+this.animDur,this.animBeginArr.push(this.animDur),this.animatePaths(M,{centerX:t.centerX,centerY:t.centerY,endAngle:S,startAngle:w,prevEndAngle:C,prevStartAngle:k,size:t.size,i:f,totalItems:2,animBeginArr:this.animBeginArr,dur:D,shouldSetPrevPaths:!0,easing:e.globals.easing})}return{g:r,elHollow:c,dataLabels:u}}},{key:"drawHollow",value:function(t){var e=new m(this.ctx).drawCircle(2*t.size);return e.attr({class:"apexcharts-radialbar-hollow",cx:t.centerX,cy:t.centerY,r:t.size,fill:t.fill}),e}},{key:"drawHollowImage",value:function(t,e,i,a){var s=this.w,r=new H(this.ctx),o=x.randomId(),n=s.config.plotOptions.radialBar.hollow.image;if(s.config.plotOptions.radialBar.hollow.imageClipped)r.clippedImgArea({width:i,height:i,image:n,patternID:"pattern".concat(s.globals.cuid).concat(o)}),a="url(#pattern".concat(s.globals.cuid).concat(o,")");else{var l=s.config.plotOptions.radialBar.hollow.imageWidth,h=s.config.plotOptions.radialBar.hollow.imageHeight;if(void 0===l&&void 0===h){var c=s.globals.dom.Paper.image(n).loaded((function(e){this.move(t.centerX-e.width/2+s.config.plotOptions.radialBar.hollow.imageOffsetX,t.centerY-e.height/2+s.config.plotOptions.radialBar.hollow.imageOffsetY)}));e.add(c)}else{var d=s.globals.dom.Paper.image(n).loaded((function(e){this.move(t.centerX-l/2+s.config.plotOptions.radialBar.hollow.imageOffsetX,t.centerY-h/2+s.config.plotOptions.radialBar.hollow.imageOffsetY),this.size(l,h)}));e.add(d)}}return a}},{key:"getStrokeWidth",value:function(t){var e=this.w;return t.size*(100-parseInt(e.config.plotOptions.radialBar.hollow.size,10))/100/(t.series.length+1)-this.margin}},{key:"onBarLabelClick",value:function(t){var e=parseInt(t.target.getAttribute("rel"),10)-1,i=this.barLabels.onClick,a=this.w;i&&i(a.globals.seriesNames[e],{w:a,seriesIndex:e})}}]),i}(Lt),It=function(t){n(s,t);var i=d(s);function s(){return a(this,s),i.apply(this,arguments)}return r(s,[{key:"draw",value:function(t,i){var a=this.w,s=new m(this.ctx);this.rangeBarOptions=this.w.config.plotOptions.rangeBar,this.series=t,this.seriesRangeStart=a.globals.seriesRangeStart,this.seriesRangeEnd=a.globals.seriesRangeEnd,this.barHelpers.initVariables(t);for(var r=s.group({class:"apexcharts-rangebar-series apexcharts-plot-series"}),n=0;n<t.length;n++){var l,h,c,d,g=void 0,u=void 0,p=a.globals.comboCharts?i[n]:n,f=this.barHelpers.getGroupIndex(p).columnGroupIndex,b=s.group({class:"apexcharts-series",seriesName:x.escapeString(a.globals.seriesNames[p]),rel:n+1,"data:realIndex":p});this.ctx.series.addCollapsedClassToSeries(b,p),t[n].length>0&&(this.visibleI=this.visibleI+1);var v=0,y=0,w=0;this.yRatio.length>1&&(this.yaxisIndex=a.globals.seriesYAxisReverseMap[p][0],w=p);var k=this.barHelpers.initialPositions();u=k.y,d=k.zeroW,g=k.x,y=k.barWidth,v=k.barHeight,l=k.xDivision,h=k.yDivision,c=k.zeroH;for(var A=s.group({class:"apexcharts-datalabels","data:realIndex":p}),S=s.group({class:"apexcharts-rangebar-goals-markers"}),C=0;C<a.globals.dataPoints;C++){var L,P=this.barHelpers.getStrokeWidth(n,C,p),M=this.seriesRangeStart[n][C],I=this.seriesRangeEnd[n][C],T=null,z=null,X=null,E={x:g,y:u,strokeWidth:P,elSeries:b},Y=this.seriesLen;if(a.config.plotOptions.bar.rangeBarGroupRows&&(Y=1),void 0===a.config.series[n].data[C])break;if(this.isHorizontal){X=u+v*this.visibleI;var F=(h-v*Y)/2;if(a.config.series[n].data[C].x){var R=this.detectOverlappingBars({i:n,j:C,barYPosition:X,srty:F,barHeight:v,yDivision:h,initPositions:k});v=R.barHeight,X=R.barYPosition}y=(T=this.drawRangeBarPaths(e({indexes:{i:n,j:C,realIndex:p},barHeight:v,barYPosition:X,zeroW:d,yDivision:h,y1:M,y2:I},E))).barWidth}else{a.globals.isXNumeric&&(g=(a.globals.seriesX[n][C]-a.globals.minX)/this.xRatio-y/2),z=g+y*this.visibleI;var H=(l-y*Y)/2;if(a.config.series[n].data[C].x){var D=this.detectOverlappingBars({i:n,j:C,barXPosition:z,srtx:H,barWidth:y,xDivision:l,initPositions:k});y=D.barWidth,z=D.barXPosition}v=(T=this.drawRangeColumnPaths(e({indexes:{i:n,j:C,realIndex:p,translationsIndex:w},barWidth:y,barXPosition:z,zeroH:c,xDivision:l},E))).barHeight}var O=this.barHelpers.drawGoalLine({barXPosition:T.barXPosition,barYPosition:X,goalX:T.goalX,goalY:T.goalY,barHeight:v,barWidth:y});O&&S.add(O),u=T.y,g=T.x;var N=this.barHelpers.getPathFillColor(t,n,C,p),W=a.globals.stroke.colors[p];this.renderSeries((o(L={realIndex:p,pathFill:N,lineFill:W,j:C,i:n,x:g,y:u,y1:M,y2:I,pathFrom:T.pathFrom,pathTo:T.pathTo,strokeWidth:P,elSeries:b,series:t,barHeight:v,barWidth:y,barXPosition:z,barYPosition:X},"barWidth",y),o(L,"columnGroupIndex",f),o(L,"elDataLabelsWrap",A),o(L,"elGoalsMarkers",S),o(L,"visibleSeries",this.visibleI),o(L,"type","rangebar"),L))}r.add(b)}return r}},{key:"detectOverlappingBars",value:function(t){var e=t.i,i=t.j,a=t.barYPosition,s=t.barXPosition,r=t.srty,o=t.srtx,n=t.barHeight,l=t.barWidth,h=t.yDivision,c=t.xDivision,d=t.initPositions,g=this.w,u=[],p=g.config.series[e].data[i].rangeName,f=g.config.series[e].data[i].x,x=Array.isArray(f)?f.join(" "):f,b=g.globals.labels.map((function(t){return Array.isArray(t)?t.join(" "):t})).indexOf(x),v=g.globals.seriesRange[e].findIndex((function(t){return t.x===x&&t.overlaps.length>0}));return this.isHorizontal?(a=g.config.plotOptions.bar.rangeBarGroupRows?r+h*b:r+n*this.visibleI+h*b,v>-1&&!g.config.plotOptions.bar.rangeBarOverlap&&(u=g.globals.seriesRange[e][v].overlaps).indexOf(p)>-1&&(a=(n=d.barHeight/u.length)*this.visibleI+h*(100-parseInt(this.barOptions.barHeight,10))/100/2+n*(this.visibleI+u.indexOf(p))+h*b)):(b>-1&&!g.globals.timescaleLabels.length&&(s=g.config.plotOptions.bar.rangeBarGroupRows?o+c*b:o+l*this.visibleI+c*b),v>-1&&!g.config.plotOptions.bar.rangeBarOverlap&&(u=g.globals.seriesRange[e][v].overlaps).indexOf(p)>-1&&(s=(l=d.barWidth/u.length)*this.visibleI+c*(100-parseInt(this.barOptions.barWidth,10))/100/2+l*(this.visibleI+u.indexOf(p))+c*b)),{barYPosition:a,barXPosition:s,barHeight:n,barWidth:l}}},{key:"drawRangeColumnPaths",value:function(t){var e=t.indexes,i=t.x,a=t.xDivision,s=t.barWidth,r=t.barXPosition,o=t.zeroH,n=this.w,l=e.i,h=e.j,c=e.realIndex,d=e.translationsIndex,g=this.yRatio[d],u=this.getRangeValue(c,h),p=Math.min(u.start,u.end),f=Math.max(u.start,u.end);void 0===this.series[l][h]||null===this.series[l][h]?p=o:(p=o-p/g,f=o-f/g);var x=Math.abs(f-p),b=this.barHelpers.getColumnPaths({barXPosition:r,barWidth:s,y1:p,y2:f,strokeWidth:this.strokeWidth,series:this.seriesRangeEnd,realIndex:c,i:c,j:h,w:n});if(n.globals.isXNumeric){var v=this.getBarXForNumericXAxis({x:i,j:h,realIndex:c,barWidth:s});i=v.x,r=v.barXPosition}else i+=a;return{pathTo:b.pathTo,pathFrom:b.pathFrom,barHeight:x,x:i,y:u.start<0&&u.end<0?p:f,goalY:this.barHelpers.getGoalValues("y",null,o,l,h,d),barXPosition:r}}},{key:"drawRangeBarPaths",value:function(t){var e=t.indexes,i=t.y,a=t.y1,s=t.y2,r=t.yDivision,o=t.barHeight,n=t.barYPosition,l=t.zeroW,h=this.w,c=e.realIndex,d=e.j,g=l+a/this.invertedYRatio,u=l+s/this.invertedYRatio,p=this.getRangeValue(c,d),f=Math.abs(u-g),x=this.barHelpers.getBarpaths({barYPosition:n,barHeight:o,x1:g,x2:u,strokeWidth:this.strokeWidth,series:this.seriesRangeEnd,i:c,realIndex:c,j:d,w:h});return h.globals.isXNumeric||(i+=r),{pathTo:x.pathTo,pathFrom:x.pathFrom,barWidth:f,x:p.start<0&&p.end<0?g:u,goalX:this.barHelpers.getGoalValues("x",l,null,c,d),y:i}}},{key:"getRangeValue",value:function(t,e){var i=this.w;return{start:i.globals.seriesRangeStart[t][e],end:i.globals.seriesRangeEnd[t][e]}}}]),s}(yt),Tt=function(){function t(e){a(this,t),this.w=e.w,this.lineCtx=e}return r(t,[{key:"sameValueSeriesFix",value:function(t,e){var i=this.w;if(("gradient"===i.config.fill.type||"gradient"===i.config.fill.type[t])&&new y(this.lineCtx.ctx,i).seriesHaveSameValues(t)){var a=e[t].slice();a[a.length-1]=a[a.length-1]+1e-6,e[t]=a}return e}},{key:"calculatePoints",value:function(t){var e=t.series,i=t.realIndex,a=t.x,s=t.y,r=t.i,o=t.j,n=t.prevY,l=this.w,h=[],c=[];if(0===o){var d=this.lineCtx.categoryAxisCorrection+l.config.markers.offsetX;l.globals.isXNumeric&&(d=(l.globals.seriesX[i][0]-l.globals.minX)/this.lineCtx.xRatio+l.config.markers.offsetX),h.push(d),c.push(x.isNumber(e[r][0])?n+l.config.markers.offsetY:null),h.push(a+l.config.markers.offsetX),c.push(x.isNumber(e[r][o+1])?s+l.config.markers.offsetY:null)}else h.push(a+l.config.markers.offsetX),c.push(x.isNumber(e[r][o+1])?s+l.config.markers.offsetY:null);return{x:h,y:c}}},{key:"checkPreviousPaths",value:function(t){for(var e=t.pathFromLine,i=t.pathFromArea,a=t.realIndex,s=this.w,r=0;r<s.globals.previousPaths.length;r++){var o=s.globals.previousPaths[r];("line"===o.type||"area"===o.type)&&o.paths.length>0&&parseInt(o.realIndex,10)===parseInt(a,10)&&("line"===o.type?(this.lineCtx.appendPathFrom=!1,e=s.globals.previousPaths[r].paths[0].d):"area"===o.type&&(this.lineCtx.appendPathFrom=!1,i=s.globals.previousPaths[r].paths[0].d,s.config.stroke.show&&s.globals.previousPaths[r].paths[1]&&(e=s.globals.previousPaths[r].paths[1].d)))}return{pathFromLine:e,pathFromArea:i}}},{key:"determineFirstPrevY",value:function(t){var e,i,a,s=t.i,r=t.realIndex,o=t.series,n=t.prevY,l=t.lineYPosition,h=t.translationsIndex,c=this.w,d=c.config.chart.stacked&&!c.globals.comboCharts||c.config.chart.stacked&&c.globals.comboCharts&&(!this.w.config.chart.stackOnlyBar||"bar"===(null===(e=this.w.config.series[r])||void 0===e?void 0:e.type)||"column"===(null===(i=this.w.config.series[r])||void 0===i?void 0:i.type));if(void 0!==(null===(a=o[s])||void 0===a?void 0:a[0]))n=(l=d&&s>0?this.lineCtx.prevSeriesY[s-1][0]:this.lineCtx.zeroY)-o[s][0]/this.lineCtx.yRatio[h]+2*(this.lineCtx.isReversed?o[s][0]/this.lineCtx.yRatio[h]:0);else if(d&&s>0&&void 0===o[s][0])for(var g=s-1;g>=0;g--)if(null!==o[g][0]&&void 0!==o[g][0]){n=l=this.lineCtx.prevSeriesY[g][0];break}return{prevY:n,lineYPosition:l}}}]),t}(),zt=function(t){for(var e,i,a,s,r=function(t){for(var e=[],i=t[0],a=t[1],s=e[0]=Yt(i,a),r=1,o=t.length-1;r<o;r++)i=a,a=t[r+1],e[r]=.5*(s+(s=Yt(i,a)));return e[r]=s,e}(t),o=t.length-1,n=[],l=0;l<o;l++)a=Yt(t[l],t[l+1]),Math.abs(a)<1e-6?r[l]=r[l+1]=0:(s=(e=r[l]/a)*e+(i=r[l+1]/a)*i)>9&&(s=3*a/Math.sqrt(s),r[l]=s*e,r[l+1]=s*i);for(var h=0;h<=o;h++)s=(t[Math.min(o,h+1)][0]-t[Math.max(0,h-1)][0])/(6*(1+r[h]*r[h])),n.push([s||0,r[h]*s||0]);return n},Xt=function(t){var e=zt(t),i=t[1],a=t[0],s=[],r=e[1],o=e[0];s.push(a,[a[0]+o[0],a[1]+o[1],i[0]-r[0],i[1]-r[1],i[0],i[1]]);for(var n=2,l=e.length;n<l;n++){var h=t[n],c=e[n];s.push([h[0]-c[0],h[1]-c[1],h[0],h[1]])}return s},Et=function(t,e,i){var a=t.slice(e,i);if(e){if(i-e>1&&a[1].length<6){var s=a[0].length;a[1]=[2*a[0][s-2]-a[0][s-4],2*a[0][s-1]-a[0][s-3]].concat(a[1])}a[0]=a[0].slice(-2)}return a};function Yt(t,e){return(e[1]-t[1])/(e[0]-t[0])}var Ft=function(){function t(e,i,s){a(this,t),this.ctx=e,this.w=e.w,this.xyRatios=i,this.pointsChart=!("bubble"!==this.w.config.chart.type&&"scatter"!==this.w.config.chart.type)||s,this.scatter=new O(this.ctx),this.noNegatives=this.w.globals.minX===Number.MAX_VALUE,this.lineHelpers=new Tt(this),this.markers=new D(this.ctx),this.prevSeriesY=[],this.categoryAxisCorrection=0,this.yaxisIndex=0}return r(t,[{key:"draw",value:function(t,i,a,s){var r,o=this.w,n=new m(this.ctx),l=o.globals.comboCharts?i:o.config.chart.type,h=n.group({class:"apexcharts-".concat(l,"-series apexcharts-plot-series")}),c=new y(this.ctx,o);this.yRatio=this.xyRatios.yRatio,this.zRatio=this.xyRatios.zRatio,this.xRatio=this.xyRatios.xRatio,this.baseLineY=this.xyRatios.baseLineY,t=c.getLogSeries(t),this.yRatio=c.getLogYRatios(this.yRatio),this.prevSeriesY=[];for(var d=[],g=0;g<t.length;g++){t=this.lineHelpers.sameValueSeriesFix(g,t);var u=o.globals.comboCharts?a[g]:g,p=this.yRatio.length>1?u:0;this._initSerieVariables(t,g,u);var f=[],x=[],b=[],v=o.globals.padHorizontal+this.categoryAxisCorrection;this.ctx.series.addCollapsedClassToSeries(this.elSeries,u),o.globals.isXNumeric&&o.globals.seriesX.length>0&&(v=(o.globals.seriesX[u][0]-o.globals.minX)/this.xRatio),b.push(v);var w,k=v,A=void 0,S=k,C=this.zeroY,L=this.zeroY;C=this.lineHelpers.determineFirstPrevY({i:g,realIndex:u,series:t,prevY:C,lineYPosition:0,translationsIndex:p}).prevY,"monotoneCubic"===o.config.stroke.curve&&null===t[g][0]?f.push(null):f.push(C),w=C;"rangeArea"===l&&(A=L=this.lineHelpers.determineFirstPrevY({i:g,realIndex:u,series:s,prevY:L,lineYPosition:0,translationsIndex:p}).prevY,x.push(null!==f[0]?L:null));var P=this._calculatePathsFrom({type:l,series:t,i:g,realIndex:u,translationsIndex:p,prevX:S,prevY:C,prevY2:L}),M=[f[0]],I=[x[0]],T={type:l,series:t,realIndex:u,translationsIndex:p,i:g,x:v,y:1,pX:k,pY:w,pathsFrom:P,linePaths:[],areaPaths:[],seriesIndex:a,lineYPosition:0,xArrj:b,yArrj:f,y2Arrj:x,seriesRangeEnd:s},z=this._iterateOverDataPoints(e(e({},T),{},{iterations:"rangeArea"===l?t[g].length-1:void 0,isRangeStart:!0}));if("rangeArea"===l){for(var X=this._calculatePathsFrom({series:s,i:g,realIndex:u,prevX:S,prevY:L}),E=this._iterateOverDataPoints(e(e({},T),{},{series:s,xArrj:[v],yArrj:M,y2Arrj:I,pY:A,areaPaths:z.areaPaths,pathsFrom:X,iterations:s[g].length-1,isRangeStart:!1})),Y=z.linePaths.length/2,F=0;F<Y;F++)z.linePaths[F]=E.linePaths[F+Y]+z.linePaths[F];z.linePaths.splice(Y),z.pathFromLine=E.pathFromLine+z.pathFromLine}else z.pathFromArea+=n.line(0,this.zeroY);this._handlePaths({type:l,realIndex:u,i:g,paths:z}),this.elSeries.add(this.elPointsMain),this.elSeries.add(this.elDataLabelsWrap),d.push(this.elSeries)}if(void 0!==(null===(r=o.config.series[0])||void 0===r?void 0:r.zIndex)&&d.sort((function(t,e){return Number(t.node.getAttribute("zIndex"))-Number(e.node.getAttribute("zIndex"))})),o.config.chart.stacked)for(var R=d.length-1;R>=0;R--)h.add(d[R]);else for(var H=0;H<d.length;H++)h.add(d[H]);return h}},{key:"_initSerieVariables",value:function(t,e,i){var a=this.w,s=new m(this.ctx);this.xDivision=a.globals.gridWidth/(a.globals.dataPoints-("on"===a.config.xaxis.tickPlacement?1:0)),this.strokeWidth=Array.isArray(a.config.stroke.width)?a.config.stroke.width[i]:a.config.stroke.width;var r=0;this.yRatio.length>1&&(this.yaxisIndex=a.globals.seriesYAxisReverseMap[i],r=i),this.isReversed=a.config.yaxis[this.yaxisIndex]&&a.config.yaxis[this.yaxisIndex].reversed,this.zeroY=a.globals.gridHeight-this.baseLineY[r]-(this.isReversed?a.globals.gridHeight:0)+(this.isReversed?2*this.baseLineY[r]:0),this.areaBottomY=this.zeroY,(this.zeroY>a.globals.gridHeight||"end"===a.config.plotOptions.area.fillTo)&&(this.areaBottomY=a.globals.gridHeight),this.categoryAxisCorrection=this.xDivision/2,this.elSeries=s.group({class:"apexcharts-series",zIndex:void 0!==a.config.series[i].zIndex?a.config.series[i].zIndex:i,seriesName:x.escapeString(a.globals.seriesNames[i])}),this.elPointsMain=s.group({class:"apexcharts-series-markers-wrap","data:realIndex":i}),this.elDataLabelsWrap=s.group({class:"apexcharts-datalabels","data:realIndex":i});var o=t[e].length===a.globals.dataPoints;this.elSeries.attr({"data:longestSeries":o,rel:e+1,"data:realIndex":i}),this.appendPathFrom=!0}},{key:"_calculatePathsFrom",value:function(t){var e,i,a,s,r=t.type,o=t.series,n=t.i,l=t.realIndex,h=t.translationsIndex,c=t.prevX,d=t.prevY,g=t.prevY2,u=this.w,p=new m(this.ctx);if(null===o[n][0]){for(var f=0;f<o[n].length;f++)if(null!==o[n][f]){c=this.xDivision*f,d=this.zeroY-o[n][f]/this.yRatio[h],e=p.move(c,d),i=p.move(c,this.areaBottomY);break}}else e=p.move(c,d),"rangeArea"===r&&(e=p.move(c,g)+p.line(c,d)),i=p.move(c,this.areaBottomY)+p.line(c,d);if(a=p.move(0,this.zeroY)+p.line(0,this.zeroY),s=p.move(0,this.zeroY)+p.line(0,this.zeroY),u.globals.previousPaths.length>0){var x=this.lineHelpers.checkPreviousPaths({pathFromLine:a,pathFromArea:s,realIndex:l});a=x.pathFromLine,s=x.pathFromArea}return{prevX:c,prevY:d,linePath:e,areaPath:i,pathFromLine:a,pathFromArea:s}}},{key:"_handlePaths",value:function(t){var i=t.type,a=t.realIndex,s=t.i,r=t.paths,o=this.w,n=new m(this.ctx),l=new H(this.ctx);this.prevSeriesY.push(r.yArrj),o.globals.seriesXvalues[a]=r.xArrj,o.globals.seriesYvalues[a]=r.yArrj;var h=o.config.forecastDataPoints;if(h.count>0&&"rangeArea"!==i){var c=o.globals.seriesXvalues[a][o.globals.seriesXvalues[a].length-h.count-1],d=n.drawRect(c,0,o.globals.gridWidth,o.globals.gridHeight,0);o.globals.dom.elForecastMask.appendChild(d.node);var g=n.drawRect(0,0,c,o.globals.gridHeight,0);o.globals.dom.elNonForecastMask.appendChild(g.node)}this.pointsChart||o.globals.delayedElements.push({el:this.elPointsMain.node,index:a});var u={i:s,realIndex:a,animationDelay:s,initialSpeed:o.config.chart.animations.speed,dataChangeSpeed:o.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-".concat(i)};if("area"===i)for(var p=l.fillPath({seriesNumber:a}),f=0;f<r.areaPaths.length;f++){var x=n.renderPaths(e(e({},u),{},{pathFrom:r.pathFromArea,pathTo:r.areaPaths[f],stroke:"none",strokeWidth:0,strokeLineCap:null,fill:p}));this.elSeries.add(x)}if(o.config.stroke.show&&!this.pointsChart){var b=null;if("line"===i)b=l.fillPath({seriesNumber:a,i:s});else if("solid"===o.config.stroke.fill.type)b=o.globals.stroke.colors[a];else{var v=o.config.fill;o.config.fill=o.config.stroke.fill,b=l.fillPath({seriesNumber:a,i:s}),o.config.fill=v}for(var y=0;y<r.linePaths.length;y++){var w=b;"rangeArea"===i&&(w=l.fillPath({seriesNumber:a}));var k=e(e({},u),{},{pathFrom:r.pathFromLine,pathTo:r.linePaths[y],stroke:b,strokeWidth:this.strokeWidth,strokeLineCap:o.config.stroke.lineCap,fill:"rangeArea"===i?w:"none"}),A=n.renderPaths(k);if(this.elSeries.add(A),A.attr("fill-rule","evenodd"),h.count>0&&"rangeArea"!==i){var S=n.renderPaths(k);S.node.setAttribute("stroke-dasharray",h.dashArray),h.strokeWidth&&S.node.setAttribute("stroke-width",h.strokeWidth),this.elSeries.add(S),S.attr("clip-path","url(#forecastMask".concat(o.globals.cuid,")")),A.attr("clip-path","url(#nonForecastMask".concat(o.globals.cuid,")"))}}}}},{key:"_iterateOverDataPoints",value:function(t){var e,i,a=this,s=t.type,r=t.series,o=t.iterations,n=t.realIndex,l=t.translationsIndex,h=t.i,c=t.x,d=t.y,g=t.pX,u=t.pY,p=t.pathsFrom,f=t.linePaths,b=t.areaPaths,v=t.seriesIndex,y=t.lineYPosition,w=t.xArrj,k=t.yArrj,A=t.y2Arrj,S=t.isRangeStart,C=t.seriesRangeEnd,L=this.w,P=new m(this.ctx),M=this.yRatio,I=p.prevY,T=p.linePath,z=p.areaPath,X=p.pathFromLine,E=p.pathFromArea,Y=x.isNumber(L.globals.minYArr[n])?L.globals.minYArr[n]:L.globals.minY;o||(o=L.globals.dataPoints>1?L.globals.dataPoints-1:L.globals.dataPoints);var F=function(t,e){return e-t/M[l]+2*(a.isReversed?t/M[l]:0)},R=d,H=L.config.chart.stacked&&!L.globals.comboCharts||L.config.chart.stacked&&L.globals.comboCharts&&(!this.w.config.chart.stackOnlyBar||"bar"===(null===(e=this.w.config.series[n])||void 0===e?void 0:e.type)||"column"===(null===(i=this.w.config.series[n])||void 0===i?void 0:i.type)),D=L.config.stroke.curve;Array.isArray(D)&&(D=Array.isArray(v)?D[v[h]]:D[h]);for(var O,N=0,W=0;W<o;W++){var B=void 0===r[h][W+1]||null===r[h][W+1];if(L.globals.isXNumeric){var G=L.globals.seriesX[n][W+1];void 0===L.globals.seriesX[n][W+1]&&(G=L.globals.seriesX[n][o-1]),c=(G-L.globals.minX)/this.xRatio}else c+=this.xDivision;if(H)if(h>0&&L.globals.collapsedSeries.length<L.config.series.length-1){y=this.prevSeriesY[function(t){for(var e=t;e>0;e--){if(!(L.globals.collapsedSeriesIndices.indexOf((null==v?void 0:v[e])||e)>-1))return e;e--}return 0}(h-1)][W+1]}else y=this.zeroY;else y=this.zeroY;B?d=F(Y,y):(d=F(r[h][W+1],y),"rangeArea"===s&&(R=F(C[h][W+1],y))),w.push(c),!B||"smooth"!==L.config.stroke.curve&&"monotoneCubic"!==L.config.stroke.curve?(k.push(d),A.push(R)):(k.push(null),A.push(null));var V=this.lineHelpers.calculatePoints({series:r,x:c,y:d,realIndex:n,i:h,j:W,prevY:I}),j=this._createPaths({type:s,series:r,i:h,realIndex:n,j:W,x:c,y:d,y2:R,xArrj:w,yArrj:k,y2Arrj:A,pX:g,pY:u,pathState:N,segmentStartX:O,linePath:T,areaPath:z,linePaths:f,areaPaths:b,curve:D,isRangeStart:S});b=j.areaPaths,f=j.linePaths,g=j.pX,u=j.pY,N=j.pathState,O=j.segmentStartX,z=j.areaPath,T=j.linePath,!this.appendPathFrom||"monotoneCubic"===D&&"rangeArea"===s||(X+=P.line(c,this.zeroY),E+=P.line(c,this.zeroY)),this.handleNullDataPoints(r,V,h,W,n),this._handleMarkersAndLabels({type:s,pointsPos:V,i:h,j:W,realIndex:n,isRangeStart:S})}return{yArrj:k,xArrj:w,pathFromArea:E,areaPaths:b,pathFromLine:X,linePaths:f,linePath:T,areaPath:z}}},{key:"_handleMarkersAndLabels",value:function(t){var e=t.type,i=t.pointsPos,a=t.isRangeStart,s=t.i,r=t.j,o=t.realIndex,n=this.w,l=new N(this.ctx);if(this.pointsChart)this.scatter.draw(this.elSeries,r,{realIndex:o,pointsPos:i,zRatio:this.zRatio,elParent:this.elPointsMain});else{n.globals.series[s].length>1&&this.elPointsMain.node.classList.add("apexcharts-element-hidden");var h=this.markers.plotChartMarkers(i,o,r+1);null!==h&&this.elPointsMain.add(h)}var c=l.drawDataLabel({type:e,isRangeStart:a,pos:i,i:o,j:r+1});null!==c&&this.elDataLabelsWrap.add(c)}},{key:"_createPaths",value:function(t){var e=t.type,i=t.series,a=t.i;t.realIndex;var s=t.j,r=t.x,o=t.y,n=t.xArrj,l=t.yArrj,h=t.y2,c=t.y2Arrj,d=t.pX,g=t.pY,u=t.pathState,p=t.segmentStartX,f=t.linePath,x=t.areaPath,b=t.linePaths,v=t.areaPaths,y=t.curve,w=t.isRangeStart;this.w;var k,A=new m(this.ctx),S=this.areaBottomY,C="rangeArea"===e,L="rangeArea"===e&&w;switch(y){case"monotoneCubic":var P=w?l:c;switch(u){case 0:if(null===P[s+1])break;u=1;case 1:if(!(C?n.length===i[a].length:s===i[a].length-2))break;case 2:var M=w?n:n.slice().reverse(),I=w?P:P.slice().reverse(),T=(k=I,M.map((function(t,e){return[t,k[e]]})).filter((function(t){return null!==t[1]}))),z=T.length>1?Xt(T):T,X=[];C&&(L?v=T:X=v.reverse());var E=0,Y=0;if(function(t,e){for(var i=function(t){var e=[],i=0;return t.forEach((function(t){null!==t?i++:i>0&&(e.push(i),i=0)})),i>0&&e.push(i),e}(t),a=[],s=0,r=0;s<i.length;r+=i[s++])a[s]=Et(e,r,r+i[s]);return a}(I,z).forEach((function(t){E++;var e=function(t){for(var e="",i=0;i<t.length;i++){var a=t[i],s=a.length;s>4?(e+="C".concat(a[0],", ").concat(a[1]),e+=", ".concat(a[2],", ").concat(a[3]),e+=", ".concat(a[4],", ").concat(a[5])):s>2&&(e+="S".concat(a[0],", ").concat(a[1]),e+=", ".concat(a[2],", ").concat(a[3]))}return e}(t),i=Y,a=(Y+=t.length)-1;L?f=A.move(T[i][0],T[i][1])+e:C?f=A.move(X[i][0],X[i][1])+A.line(T[i][0],T[i][1])+e+A.line(X[a][0],X[a][1]):(f=A.move(T[i][0],T[i][1])+e,x=f+A.line(T[a][0],S)+A.line(T[i][0],S)+"z",v.push(x)),b.push(f)})),C&&E>1&&!L){var F=b.slice(E).reverse();b.splice(E),F.forEach((function(t){return b.push(t)}))}u=0}break;case"smooth":var R=.35*(r-d);if(null===i[a][s])u=0;else switch(u){case 0:if(p=d,f=L?A.move(d,c[s])+A.line(d,g):A.move(d,g),x=A.move(d,g),u=1,s<i[a].length-2){var H=A.curve(d+R,g,r-R,o,r,o);f+=H,x+=H;break}case 1:if(null===i[a][s+1])f+=L?A.line(d,h):A.move(d,g),x+=A.line(d,S)+A.line(p,S)+"z",b.push(f),v.push(x);else{var D=A.curve(d+R,g,r-R,o,r,o);f+=D,x+=D,s>=i[a].length-2&&(L&&(f+=A.curve(r,o,r,o,r,h)+A.move(r,h)),x+=A.curve(r,o,r,o,r,S)+A.line(p,S)+"z",b.push(f),v.push(x))}}d=r,g=o;break;default:var O=function(t,e,i){var a=[];switch(t){case"stepline":a=A.line(e,null,"H")+A.line(null,i,"V");break;case"linestep":a=A.line(null,i,"V")+A.line(e,null,"H");break;case"straight":a=A.line(e,i)}return a};if(null===i[a][s])u=0;else switch(u){case 0:if(p=d,f=L?A.move(d,c[s])+A.line(d,g):A.move(d,g),x=A.move(d,g),u=1,s<i[a].length-2){var N=O(y,r,o);f+=N,x+=N;break}case 1:if(null===i[a][s+1])f+=L?A.line(d,h):A.move(d,g),x+=A.line(d,S)+A.line(p,S)+"z",b.push(f),v.push(x);else{var W=O(y,r,o);f+=W,x+=W,s>=i[a].length-2&&(L&&(f+=A.line(r,h)),x+=A.line(r,S)+A.line(p,S)+"z",b.push(f),v.push(x))}}d=r,g=o}return{linePaths:b,areaPaths:v,pX:d,pY:g,pathState:u,segmentStartX:p,linePath:f,areaPath:x}}},{key:"handleNullDataPoints",value:function(t,e,i,a,s){var r=this.w;if(null===t[i][a]&&r.config.markers.showNullDataPoints||1===t[i].length){var o=this.strokeWidth-r.config.markers.strokeWidth/2;o>0||(o=0);var n=this.markers.plotChartMarkers(e,s,a+1,o,!0);null!==n&&this.elPointsMain.add(n)}}}]),t}();window.TreemapSquared={},window.TreemapSquared.generate=function(){function t(e,i,a,s){this.xoffset=e,this.yoffset=i,this.height=s,this.width=a,this.shortestEdge=function(){return Math.min(this.height,this.width)},this.getCoordinates=function(t){var e,i=[],a=this.xoffset,s=this.yoffset,o=r(t)/this.height,n=r(t)/this.width;if(this.width>=this.height)for(e=0;e<t.length;e++)i.push([a,s,a+o,s+t[e]/o]),s+=t[e]/o;else for(e=0;e<t.length;e++)i.push([a,s,a+t[e]/n,s+n]),a+=t[e]/n;return i},this.cutArea=function(e){var i;if(this.width>=this.height){var a=e/this.height,s=this.width-a;i=new t(this.xoffset+a,this.yoffset,s,this.height)}else{var r=e/this.width,o=this.height-r;i=new t(this.xoffset,this.yoffset+r,this.width,o)}return i}}function e(e,a,s,o,n){o=void 0===o?0:o,n=void 0===n?0:n;var l=i(function(t,e){var i,a=[],s=e/r(t);for(i=0;i<t.length;i++)a[i]=t[i]*s;return a}(e,a*s),[],new t(o,n,a,s),[]);return function(t){var e,i,a=[];for(e=0;e<t.length;e++)for(i=0;i<t[e].length;i++)a.push(t[e][i]);return a}(l)}function i(t,e,s,o){var n,l,h;if(0!==t.length)return n=s.shortestEdge(),function(t,e,i){var s;if(0===t.length)return!0;(s=t.slice()).push(e);var r=a(t,i),o=a(s,i);return r>=o}(e,l=t[0],n)?(e.push(l),i(t.slice(1),e,s,o)):(h=s.cutArea(r(e),o),o.push(s.getCoordinates(e)),i(t,[],h,o)),o;o.push(s.getCoordinates(e))}function a(t,e){var i=Math.min.apply(Math,t),a=Math.max.apply(Math,t),s=r(t);return Math.max(Math.pow(e,2)*a/Math.pow(s,2),Math.pow(s,2)/(Math.pow(e,2)*i))}function s(t){return t&&t.constructor===Array}function r(t){var e,i=0;for(e=0;e<t.length;e++)i+=t[e];return i}function o(t){var e,i=0;if(s(t[0]))for(e=0;e<t.length;e++)i+=o(t[e]);else i=r(t);return i}return function t(i,a,r,n,l){n=void 0===n?0:n,l=void 0===l?0:l;var h,c,d=[],g=[];if(s(i[0])){for(c=0;c<i.length;c++)d[c]=o(i[c]);for(h=e(d,a,r,n,l),c=0;c<i.length;c++)g.push(t(i[c],h[c][2]-h[c][0],h[c][3]-h[c][1],h[c][0],h[c][1]))}else g=e(i,a,r,n,l);return g}}();var Rt,Ht,Dt=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w,this.strokeWidth=this.w.config.stroke.width,this.helpers=new At(e),this.dynamicAnim=this.w.config.chart.animations.dynamicAnimation,this.labels=[]}return r(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new m(this.ctx),s=new H(this.ctx),r=a.group({class:"apexcharts-treemap"});if(i.globals.noData)return r;var o=[];return t.forEach((function(t){var e=t.map((function(t){return Math.abs(t)}));o.push(e)})),this.negRange=this.helpers.checkColorRange(),i.config.series.forEach((function(t,i){t.data.forEach((function(t){Array.isArray(e.labels[i])||(e.labels[i]=[]),e.labels[i].push(t.x)}))})),window.TreemapSquared.generate(o,i.globals.gridWidth,i.globals.gridHeight).forEach((function(o,n){var l=a.group({class:"apexcharts-series apexcharts-treemap-series",seriesName:x.escapeString(i.globals.seriesNames[n]),rel:n+1,"data:realIndex":n});if(i.config.chart.dropShadow.enabled){var h=i.config.chart.dropShadow;new v(e.ctx).dropShadow(r,h,n)}var c=a.group({class:"apexcharts-data-labels"});o.forEach((function(r,o){var h=r[0],c=r[1],d=r[2],g=r[3],u=a.drawRect(h,c,d-h,g-c,i.config.plotOptions.treemap.borderRadius,"#fff",1,e.strokeWidth,i.config.plotOptions.treemap.useFillColorAsStroke?f:i.globals.stroke.colors[n]);u.attr({cx:h,cy:c,index:n,i:n,j:o,width:d-h,height:g-c});var p=e.helpers.getShadeColor(i.config.chart.type,n,o,e.negRange),f=p.color;void 0!==i.config.series[n].data[o]&&i.config.series[n].data[o].fillColor&&(f=i.config.series[n].data[o].fillColor);var x=s.fillPath({color:f,seriesNumber:n,dataPointIndex:o});u.node.classList.add("apexcharts-treemap-rect"),u.attr({fill:x}),e.helpers.addListeners(u);var b={x:h+(d-h)/2,y:c+(g-c)/2,width:0,height:0},v={x:h,y:c,width:d-h,height:g-c};if(i.config.chart.animations.enabled&&!i.globals.dataChanged){var m=1;i.globals.resized||(m=i.config.chart.animations.speed),e.animateTreemap(u,b,v,m)}if(i.globals.dataChanged){var y=1;e.dynamicAnim.enabled&&i.globals.shouldAnimate&&(y=e.dynamicAnim.speed,i.globals.previousPaths[n]&&i.globals.previousPaths[n][o]&&i.globals.previousPaths[n][o].rect&&(b=i.globals.previousPaths[n][o].rect),e.animateTreemap(u,b,v,y))}var w=e.getFontSize(r),k=i.config.dataLabels.formatter(e.labels[n][o],{value:i.globals.series[n][o],seriesIndex:n,dataPointIndex:o,w:i});"truncate"===i.config.plotOptions.treemap.dataLabels.format&&(w=parseInt(i.config.dataLabels.style.fontSize,10),k=e.truncateLabels(k,w,h,c,d,g));var A=e.helpers.calculateDataLabels({text:k,x:(h+d)/2,y:(c+g)/2+e.strokeWidth/2+w/3,i:n,j:o,colorProps:p,fontSize:w,series:t});i.config.dataLabels.enabled&&A&&e.rotateToFitLabel(A,w,k,h,c,d,g),l.add(u),null!==A&&l.add(A)})),l.add(c),r.add(l)})),r}},{key:"getFontSize",value:function(t){var e=this.w;var i,a,s,r,o=function t(e){var i,a=0;if(Array.isArray(e[0]))for(i=0;i<e.length;i++)a+=t(e[i]);else for(i=0;i<e.length;i++)a+=e[i].length;return a}(this.labels)/function t(e){var i,a=0;if(Array.isArray(e[0]))for(i=0;i<e.length;i++)a+=t(e[i]);else for(i=0;i<e.length;i++)a+=1;return a}(this.labels);return i=t[2]-t[0],a=t[3]-t[1],s=i*a,r=Math.pow(s,.5),Math.min(r/o,parseInt(e.config.dataLabels.style.fontSize,10))}},{key:"rotateToFitLabel",value:function(t,e,i,a,s,r,o){var n=new m(this.ctx),l=n.getTextRects(i,e);if(l.width+this.w.config.stroke.width+5>r-a&&l.width<=o-s){var h=n.rotateAroundCenter(t.node);t.node.setAttribute("transform","rotate(-90 ".concat(h.x," ").concat(h.y,") translate(").concat(l.height/3,")"))}}},{key:"truncateLabels",value:function(t,e,i,a,s,r){var o=new m(this.ctx),n=o.getTextRects(t,e).width+this.w.config.stroke.width+5>s-i&&r-a>s-i?r-a:s-i,l=o.getTextBasedOnMaxWidth({text:t,maxWidth:n,fontSize:e});return t.length!==l.length&&n/e<5?"":l}},{key:"animateTreemap",value:function(t,e,i,a){var s=new b(this.ctx);s.animateRect(t,{x:e.x,y:e.y,width:e.width,height:e.height},{x:i.x,y:i.y,width:i.width,height:i.height},a,(function(){s.animationCompleted(t)}))}}]),t}(),Ot=86400,Nt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.timeScaleArray=[],this.utc=this.w.config.xaxis.labels.datetimeUTC}return r(t,[{key:"calculateTimeScaleTicks",value:function(t,i){var a=this,s=this.w;if(s.globals.allSeriesCollapsed)return s.globals.labels=[],s.globals.timescaleLabels=[],[];var r=new A(this.ctx),o=(i-t)/864e5;this.determineInterval(o),s.globals.disableZoomIn=!1,s.globals.disableZoomOut=!1,o<.00011574074074074075?s.globals.disableZoomIn=!0:o>5e4&&(s.globals.disableZoomOut=!0);var n=r.getTimeUnitsfromTimestamp(t,i,this.utc),l=s.globals.gridWidth/o,h=l/24,c=h/60,d=c/60,g=Math.floor(24*o),u=Math.floor(1440*o),p=Math.floor(o*Ot),f=Math.floor(o),x=Math.floor(o/30),b=Math.floor(o/365),v={minMillisecond:n.minMillisecond,minSecond:n.minSecond,minMinute:n.minMinute,minHour:n.minHour,minDate:n.minDate,minMonth:n.minMonth,minYear:n.minYear},m={firstVal:v,currentMillisecond:v.minMillisecond,currentSecond:v.minSecond,currentMinute:v.minMinute,currentHour:v.minHour,currentMonthDate:v.minDate,currentDate:v.minDate,currentMonth:v.minMonth,currentYear:v.minYear,daysWidthOnXAxis:l,hoursWidthOnXAxis:h,minutesWidthOnXAxis:c,secondsWidthOnXAxis:d,numberOfSeconds:p,numberOfMinutes:u,numberOfHours:g,numberOfDays:f,numberOfMonths:x,numberOfYears:b};switch(this.tickInterval){case"years":this.generateYearScale(m);break;case"months":case"half_year":this.generateMonthScale(m);break;case"months_days":case"months_fortnight":case"days":case"week_days":this.generateDayScale(m);break;case"hours":this.generateHourScale(m);break;case"minutes_fives":case"minutes":this.generateMinuteScale(m);break;case"seconds_tens":case"seconds_fives":case"seconds":this.generateSecondScale(m)}var y=this.timeScaleArray.map((function(t){var i={position:t.position,unit:t.unit,year:t.year,day:t.day?t.day:1,hour:t.hour?t.hour:0,month:t.month+1};return"month"===t.unit?e(e({},i),{},{day:1,value:t.value+1}):"day"===t.unit||"hour"===t.unit?e(e({},i),{},{value:t.value}):"minute"===t.unit?e(e({},i),{},{value:t.value,minute:t.value}):"second"===t.unit?e(e({},i),{},{value:t.value,minute:t.minute,second:t.second}):t}));return y.filter((function(t){var e=1,i=Math.ceil(s.globals.gridWidth/120),r=t.value;void 0!==s.config.xaxis.tickAmount&&(i=s.config.xaxis.tickAmount),y.length>i&&(e=Math.floor(y.length/i));var o=!1,n=!1;switch(a.tickInterval){case"years":"year"===t.unit&&(o=!0);break;case"half_year":e=7,"year"===t.unit&&(o=!0);break;case"months":e=1,"year"===t.unit&&(o=!0);break;case"months_fortnight":e=15,"year"!==t.unit&&"month"!==t.unit||(o=!0),30===r&&(n=!0);break;case"months_days":e=10,"month"===t.unit&&(o=!0),30===r&&(n=!0);break;case"week_days":e=8,"month"===t.unit&&(o=!0);break;case"days":e=1,"month"===t.unit&&(o=!0);break;case"hours":"day"===t.unit&&(o=!0);break;case"minutes_fives":case"seconds_fives":r%5!=0&&(n=!0);break;case"seconds_tens":r%10!=0&&(n=!0)}if("hours"===a.tickInterval||"minutes_fives"===a.tickInterval||"seconds_tens"===a.tickInterval||"seconds_fives"===a.tickInterval){if(!n)return!0}else if((r%e==0||o)&&!n)return!0}))}},{key:"recalcDimensionsBasedOnFormat",value:function(t,e){var i=this.w,a=this.formatDates(t),s=this.removeOverlappingTS(a);i.globals.timescaleLabels=s.slice(),new ot(this.ctx).plotCoords()}},{key:"determineInterval",value:function(t){var e=24*t,i=60*e;switch(!0){case t/365>5:this.tickInterval="years";break;case t>800:this.tickInterval="half_year";break;case t>180:this.tickInterval="months";break;case t>90:this.tickInterval="months_fortnight";break;case t>60:this.tickInterval="months_days";break;case t>30:this.tickInterval="week_days";break;case t>2:this.tickInterval="days";break;case e>2.4:this.tickInterval="hours";break;case i>15:this.tickInterval="minutes_fives";break;case i>5:this.tickInterval="minutes";break;case i>1:this.tickInterval="seconds_tens";break;case 60*i>20:this.tickInterval="seconds_fives";break;default:this.tickInterval="seconds"}}},{key:"generateYearScale",value:function(t){var e=t.firstVal,i=t.currentMonth,a=t.currentYear,s=t.daysWidthOnXAxis,r=t.numberOfYears,o=e.minYear,n=0,l=new A(this.ctx),h="year";if(e.minDate>1||e.minMonth>0){var c=l.determineRemainingDaysOfYear(e.minYear,e.minMonth,e.minDate);n=(l.determineDaysOfYear(e.minYear)-c+1)*s,o=e.minYear+1,this.timeScaleArray.push({position:n,value:o,unit:h,year:o,month:x.monthMod(i+1)})}else 1===e.minDate&&0===e.minMonth&&this.timeScaleArray.push({position:n,value:o,unit:h,year:a,month:x.monthMod(i+1)});for(var d=o,g=n,u=0;u<r;u++)d++,g=l.determineDaysOfYear(d-1)*s+g,this.timeScaleArray.push({position:g,value:d,unit:h,year:d,month:1})}},{key:"generateMonthScale",value:function(t){var e=t.firstVal,i=t.currentMonthDate,a=t.currentMonth,s=t.currentYear,r=t.daysWidthOnXAxis,o=t.numberOfMonths,n=a,l=0,h=new A(this.ctx),c="month",d=0;if(e.minDate>1){l=(h.determineDaysOfMonths(a+1,e.minYear)-i+1)*r,n=x.monthMod(a+1);var g=s+d,u=x.monthMod(n),p=n;0===n&&(c="year",p=g,u=1,g+=d+=1),this.timeScaleArray.push({position:l,value:p,unit:c,year:g,month:u})}else this.timeScaleArray.push({position:l,value:n,unit:c,year:s,month:x.monthMod(a)});for(var f=n+1,b=l,v=0,m=1;v<o;v++,m++){0===(f=x.monthMod(f))?(c="year",d+=1):c="month";var y=this._getYear(s,f,d);b=h.determineDaysOfMonths(f,y)*r+b;var w=0===f?y:f;this.timeScaleArray.push({position:b,value:w,unit:c,year:y,month:0===f?1:f}),f++}}},{key:"generateDayScale",value:function(t){var e=t.firstVal,i=t.currentMonth,a=t.currentYear,s=t.hoursWidthOnXAxis,r=t.numberOfDays,o=new A(this.ctx),n="day",l=e.minDate+1,h=l,c=function(t,e,i){return t>o.determineDaysOfMonths(e+1,i)?(h=1,n="month",g=e+=1,e):e},d=(24-e.minHour)*s,g=l,u=c(h,i,a);0===e.minHour&&1===e.minDate?(d=0,g=x.monthMod(e.minMonth),n="month",h=e.minDate):1!==e.minDate&&0===e.minHour&&0===e.minMinute&&(d=0,l=e.minDate,g=l,u=c(h=l,i,a)),this.timeScaleArray.push({position:d,value:g,unit:n,year:this._getYear(a,u,0),month:x.monthMod(u),day:h});for(var p=d,f=0;f<r;f++){n="day",u=c(h+=1,u,this._getYear(a,u,0));var b=this._getYear(a,u,0);p=24*s+p;var v=1===h?x.monthMod(u):h;this.timeScaleArray.push({position:p,value:v,unit:n,year:b,month:x.monthMod(u),day:v})}}},{key:"generateHourScale",value:function(t){var e=t.firstVal,i=t.currentDate,a=t.currentMonth,s=t.currentYear,r=t.minutesWidthOnXAxis,o=t.numberOfHours,n=new A(this.ctx),l="hour",h=function(t,e){return t>n.determineDaysOfMonths(e+1,s)&&(f=1,e+=1),{month:e,date:f}},c=function(t,e){return t>n.determineDaysOfMonths(e+1,s)?e+=1:e},d=60-(e.minMinute+e.minSecond/60),g=d*r,u=e.minHour+1,p=u;60===d&&(g=0,p=u=e.minHour);var f=i;p>=24&&(p=0,f+=1,l="day");var b=h(f,a).month;b=c(f,b),this.timeScaleArray.push({position:g,value:u,unit:l,day:f,hour:p,year:s,month:x.monthMod(b)}),p++;for(var v=g,m=0;m<o;m++){if(l="hour",p>=24)p=0,l="day",b=h(f+=1,b).month,b=c(f,b);var y=this._getYear(s,b,0);v=60*r+v;var w=0===p?f:p;this.timeScaleArray.push({position:v,value:w,unit:l,hour:p,day:f,year:y,month:x.monthMod(b)}),p++}}},{key:"generateMinuteScale",value:function(t){for(var e=t.currentMillisecond,i=t.currentSecond,a=t.currentMinute,s=t.currentHour,r=t.currentDate,o=t.currentMonth,n=t.currentYear,l=t.minutesWidthOnXAxis,h=t.secondsWidthOnXAxis,c=t.numberOfMinutes,d=a+1,g=r,u=o,p=n,f=s,b=(60-i-e/1e3)*h,v=0;v<c;v++)d>=60&&(d=0,24===(f+=1)&&(f=0)),this.timeScaleArray.push({position:b,value:d,unit:"minute",hour:f,minute:d,day:g,year:this._getYear(p,u,0),month:x.monthMod(u)}),b+=l,d++}},{key:"generateSecondScale",value:function(t){for(var e=t.currentMillisecond,i=t.currentSecond,a=t.currentMinute,s=t.currentHour,r=t.currentDate,o=t.currentMonth,n=t.currentYear,l=t.secondsWidthOnXAxis,h=t.numberOfSeconds,c=i+1,d=a,g=r,u=o,p=n,f=s,b=(1e3-e)/1e3*l,v=0;v<h;v++)c>=60&&(c=0,++d>=60&&(d=0,24===++f&&(f=0))),this.timeScaleArray.push({position:b,value:c,unit:"second",hour:f,minute:d,second:c,day:g,year:this._getYear(p,u,0),month:x.monthMod(u)}),b+=l,c++}},{key:"createRawDateString",value:function(t,e){var i=t.year;return 0===t.month&&(t.month=1),i+="-"+("0"+t.month.toString()).slice(-2),"day"===t.unit?i+="day"===t.unit?"-"+("0"+e).slice(-2):"-01":i+="-"+("0"+(t.day?t.day:"1")).slice(-2),"hour"===t.unit?i+="hour"===t.unit?"T"+("0"+e).slice(-2):"T00":i+="T"+("0"+(t.hour?t.hour:"0")).slice(-2),"minute"===t.unit?i+=":"+("0"+e).slice(-2):i+=":"+(t.minute?("0"+t.minute).slice(-2):"00"),"second"===t.unit?i+=":"+("0"+e).slice(-2):i+=":00",this.utc&&(i+=".000Z"),i}},{key:"formatDates",value:function(t){var e=this,i=this.w;return t.map((function(t){var a=t.value.toString(),s=new A(e.ctx),r=e.createRawDateString(t,a),o=s.getDate(s.parseDate(r));if(e.utc||(o=s.getDate(s.parseDateWithTimezone(r))),void 0===i.config.xaxis.labels.format){var n="dd MMM",l=i.config.xaxis.labels.datetimeFormatter;"year"===t.unit&&(n=l.year),"month"===t.unit&&(n=l.month),"day"===t.unit&&(n=l.day),"hour"===t.unit&&(n=l.hour),"minute"===t.unit&&(n=l.minute),"second"===t.unit&&(n=l.second),a=s.formatDate(o,n)}else a=s.formatDate(o,i.config.xaxis.labels.format);return{dateString:r,position:t.position,value:a,unit:t.unit,year:t.year,month:t.month}}))}},{key:"removeOverlappingTS",value:function(t){var e,i=this,a=new m(this.ctx),s=!1;t.length>0&&t[0].value&&t.every((function(e){return e.value.length===t[0].value.length}))&&(s=!0,e=a.getTextRects(t[0].value).width);var r=0,o=t.map((function(o,n){if(n>0&&i.w.config.xaxis.labels.hideOverlappingLabels){var l=s?e:a.getTextRects(t[r].value).width,h=t[r].position;return o.position>h+l+10?(r=n,o):null}return o}));return o=o.filter((function(t){return null!==t}))}},{key:"_getYear",value:function(t,e,i){return t+Math.floor(e/12)+i}}]),t}(),Wt=function(){function t(e,i){a(this,t),this.ctx=i,this.w=i.w,this.el=e}return r(t,[{key:"setupElements",value:function(){var t=this.w.globals,e=this.w.config,i=e.chart.type;t.axisCharts=["line","area","bar","rangeBar","rangeArea","candlestick","boxPlot","scatter","bubble","radar","heatmap","treemap"].indexOf(i)>-1,t.xyCharts=["line","area","bar","rangeBar","rangeArea","candlestick","boxPlot","scatter","bubble"].indexOf(i)>-1,t.isBarHorizontal=("bar"===e.chart.type||"rangeBar"===e.chart.type||"boxPlot"===e.chart.type)&&e.plotOptions.bar.horizontal,t.chartClass=".apexcharts"+t.chartID,t.dom.baseEl=this.el,t.dom.elWrap=document.createElement("div"),m.setAttrs(t.dom.elWrap,{id:t.chartClass.substring(1),class:"apexcharts-canvas "+t.chartClass.substring(1)}),this.el.appendChild(t.dom.elWrap),t.dom.Paper=new window.SVG.Doc(t.dom.elWrap),t.dom.Paper.attr({class:"apexcharts-svg","xmlns:data":"ApexChartsNS",transform:"translate(".concat(e.chart.offsetX,", ").concat(e.chart.offsetY,")")}),t.dom.Paper.node.style.background="dark"!==e.theme.mode||e.chart.background?e.chart.background:"rgba(0, 0, 0, 0.8)",this.setSVGDimensions(),t.dom.elLegendForeign=document.createElementNS(t.SVGNS,"foreignObject"),m.setAttrs(t.dom.elLegendForeign,{x:0,y:0,width:t.svgWidth,height:t.svgHeight}),t.dom.elLegendWrap=document.createElement("div"),t.dom.elLegendWrap.classList.add("apexcharts-legend"),t.dom.elLegendWrap.setAttribute("xmlns","http://www.w3.org/1999/xhtml"),t.dom.elLegendForeign.appendChild(t.dom.elLegendWrap),t.dom.Paper.node.appendChild(t.dom.elLegendForeign),t.dom.elGraphical=t.dom.Paper.group().attr({class:"apexcharts-inner apexcharts-graphical"}),t.dom.elDefs=t.dom.Paper.defs(),t.dom.Paper.add(t.dom.elGraphical),t.dom.elGraphical.add(t.dom.elDefs)}},{key:"plotChartType",value:function(t,e){var i=this.w,a=i.config,s=i.globals,r={series:[],i:[]},o={series:[],i:[]},n={series:[],i:[]},l={series:[],i:[]},h={series:[],i:[]},c={series:[],i:[]},d={series:[],i:[]},g={series:[],i:[]},p={series:[],seriesRangeEnd:[],i:[]},f=void 0!==a.chart.type?a.chart.type:"line",x=null,b=0;s.series.forEach((function(e,a){var u=t[a].type||f;switch(u){case"column":case"bar":h.series.push(e),h.i.push(a),i.globals.columnSeries=h;break;case"area":o.series.push(e),o.i.push(a);break;case"line":r.series.push(e),r.i.push(a);break;case"scatter":n.series.push(e),n.i.push(a);break;case"bubble":l.series.push(e),l.i.push(a);break;case"candlestick":c.series.push(e),c.i.push(a);break;case"boxPlot":d.series.push(e),d.i.push(a);break;case"rangeBar":g.series.push(e),g.i.push(a);break;case"rangeArea":p.series.push(s.seriesRangeStart[a]),p.seriesRangeEnd.push(s.seriesRangeEnd[a]),p.i.push(a);break;case"heatmap":case"treemap":case"pie":case"donut":case"polarArea":case"radialBar":case"radar":x=u;break;default:console.warn("You have specified an unrecognized series type (",u,").")}f!==u&&"scatter"!==u&&b++})),b>0&&(null!==x&&console.warn("Chart or series type ",x," can not appear with other chart or series types."),h.series.length>0&&a.plotOptions.bar.horizontal&&(b-=h.length,h={series:[],i:[]},i.globals.columnSeries={series:[],i:[]},console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"))),s.comboCharts||(s.comboCharts=b>0);var v=new Ft(this.ctx,e),m=new kt(this.ctx,e);this.ctx.pie=new Lt(this.ctx);var w=new Mt(this.ctx);this.ctx.rangeBar=new It(this.ctx,e);var k=new Pt(this.ctx),A=[];if(s.comboCharts){var S,C,L=new y(this.ctx);if(o.series.length>0)(S=A).push.apply(S,u(L.drawSeriesByGroup(o,s.areaGroups,"area",v)));if(h.series.length>0)if(i.config.chart.stacked){var P=new wt(this.ctx,e);A.push(P.draw(h.series,h.i))}else this.ctx.bar=new yt(this.ctx,e),A.push(this.ctx.bar.draw(h.series,h.i));if(p.series.length>0&&A.push(v.draw(p.series,"rangeArea",p.i,p.seriesRangeEnd)),r.series.length>0)(C=A).push.apply(C,u(L.drawSeriesByGroup(r,s.lineGroups,"line",v)));if(c.series.length>0&&A.push(m.draw(c.series,"candlestick",c.i)),d.series.length>0&&A.push(m.draw(d.series,"boxPlot",d.i)),g.series.length>0&&A.push(this.ctx.rangeBar.draw(g.series,g.i)),n.series.length>0){var M=new Ft(this.ctx,e,!0);A.push(M.draw(n.series,"scatter",n.i))}if(l.series.length>0){var I=new Ft(this.ctx,e,!0);A.push(I.draw(l.series,"bubble",l.i))}}else switch(a.chart.type){case"line":A=v.draw(s.series,"line");break;case"area":A=v.draw(s.series,"area");break;case"bar":if(a.chart.stacked)A=new wt(this.ctx,e).draw(s.series);else this.ctx.bar=new yt(this.ctx,e),A=this.ctx.bar.draw(s.series);break;case"candlestick":A=new kt(this.ctx,e).draw(s.series,"candlestick");break;case"boxPlot":A=new kt(this.ctx,e).draw(s.series,a.chart.type);break;case"rangeBar":A=this.ctx.rangeBar.draw(s.series);break;case"rangeArea":A=v.draw(s.seriesRangeStart,"rangeArea",void 0,s.seriesRangeEnd);break;case"heatmap":A=new St(this.ctx,e).draw(s.series);break;case"treemap":A=new Dt(this.ctx,e).draw(s.series);break;case"pie":case"donut":case"polarArea":A=this.ctx.pie.draw(s.series);break;case"radialBar":A=w.draw(s.series);break;case"radar":A=k.draw(s.series);break;default:A=v.draw(s.series)}return A}},{key:"setSVGDimensions",value:function(){var t=this.w.globals,e=this.w.config;t.svgWidth=e.chart.width,t.svgHeight=e.chart.height;var i=x.getDimensions(this.el),a=e.chart.width.toString().split(/[0-9]+/g).pop();"%"===a?x.isNumber(i[0])&&(0===i[0].width&&(i=x.getDimensions(this.el.parentNode)),t.svgWidth=i[0]*parseInt(e.chart.width,10)/100):"px"!==a&&""!==a||(t.svgWidth=parseInt(e.chart.width,10));var s=e.chart.height.toString().split(/[0-9]+/g).pop();if("auto"!==t.svgHeight&&""!==t.svgHeight)if("%"===s){var r=x.getDimensions(this.el.parentNode);t.svgHeight=r[1]*parseInt(e.chart.height,10)/100}else t.svgHeight=parseInt(e.chart.height,10);else t.axisCharts?t.svgHeight=t.svgWidth/1.61:t.svgHeight=t.svgWidth/1.2;if(t.svgWidth<0&&(t.svgWidth=0),t.svgHeight<0&&(t.svgHeight=0),m.setAttrs(t.dom.Paper.node,{width:t.svgWidth,height:t.svgHeight}),"%"!==s){var o=e.chart.sparkline.enabled?0:t.axisCharts?e.chart.parentHeightOffset:0;t.dom.Paper.node.parentNode.parentNode.style.minHeight=t.svgHeight+o+"px"}t.dom.elWrap.style.width=t.svgWidth+"px",t.dom.elWrap.style.height=t.svgHeight+"px"}},{key:"shiftGraphPosition",value:function(){var t=this.w.globals,e=t.translateY,i={transform:"translate("+t.translateX+", "+e+")"};m.setAttrs(t.dom.elGraphical.node,i)}},{key:"resizeNonAxisCharts",value:function(){var t=this.w,e=t.globals,i=0,a=t.config.chart.sparkline.enabled?1:15;a+=t.config.grid.padding.bottom,"top"!==t.config.legend.position&&"bottom"!==t.config.legend.position||!t.config.legend.show||t.config.legend.floating||(i=new lt(this.ctx).legendHelpers.getLegendBBox().clwh+10);var s=t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"),r=2.05*t.globals.radialSize;if(s&&!t.config.chart.sparkline.enabled&&0!==t.config.plotOptions.radialBar.startAngle){var o=x.getBoundingClientRect(s);r=o.bottom;var n=o.bottom-o.top;r=Math.max(2.05*t.globals.radialSize,n)}var l=r+e.translateY+i+a;e.dom.elLegendForeign&&e.dom.elLegendForeign.setAttribute("height",l),t.config.chart.height&&String(t.config.chart.height).indexOf("%")>0||(e.dom.elWrap.style.height=l+"px",m.setAttrs(e.dom.Paper.node,{height:l}),e.dom.Paper.node.parentNode.parentNode.style.minHeight=l+"px")}},{key:"coreCalculations",value:function(){new U(this.ctx).init()}},{key:"resetGlobals",value:function(){var t=this,e=function(){return t.w.config.series.map((function(t){return[]}))},i=new F,a=this.w.globals;i.initGlobalVars(a),a.seriesXvalues=e(),a.seriesYvalues=e()}},{key:"isMultipleY",value:function(){if(this.w.config.yaxis.constructor===Array&&this.w.config.yaxis.length>1)return this.w.globals.isMultipleYAxis=!0,!0}},{key:"xySettings",value:function(){var t=null,e=this.w;if(e.globals.axisCharts){if("back"===e.config.xaxis.crosshairs.position)new Q(this.ctx).drawXCrosshairs();if("back"===e.config.yaxis[0].crosshairs.position)new Q(this.ctx).drawYCrosshairs();if("datetime"===e.config.xaxis.type&&void 0===e.config.xaxis.labels.formatter){this.ctx.timeScale=new Nt(this.ctx);var i=[];isFinite(e.globals.minX)&&isFinite(e.globals.maxX)&&!e.globals.isBarHorizontal?i=this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX,e.globals.maxX):e.globals.isBarHorizontal&&(i=this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY,e.globals.maxY)),this.ctx.timeScale.recalcDimensionsBasedOnFormat(i)}t=new y(this.ctx).getCalculatedRatios()}return t}},{key:"updateSourceChart",value:function(t){this.ctx.w.globals.selection=void 0,this.ctx.updateHelpers._updateOptions({chart:{selection:{xaxis:{min:t.w.globals.minX,max:t.w.globals.maxX}}}},!1,!1)}},{key:"setupBrushHandler",value:function(){var t=this,e=this.w;if(e.config.chart.brush.enabled&&"function"!=typeof e.config.chart.events.selection){var i=Array.isArray(e.config.chart.brush.targets)?e.config.chart.brush.targets:[e.config.chart.brush.target];i.forEach((function(e){var i=ApexCharts.getChartByID(e);i.w.globals.brushSource=t.ctx,"function"!=typeof i.w.config.chart.events.zoomed&&(i.w.config.chart.events.zoomed=function(){t.updateSourceChart(i)}),"function"!=typeof i.w.config.chart.events.scrolled&&(i.w.config.chart.events.scrolled=function(){t.updateSourceChart(i)})})),e.config.chart.events.selection=function(t,e){i.forEach((function(t){ApexCharts.getChartByID(t).ctx.updateHelpers._updateOptions({xaxis:{min:e.xaxis.min,max:e.xaxis.max}},!1,!1,!1,!1)}))}}}}]),t}(),Bt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"_updateOptions",value:function(t){var e=this,a=arguments.length>1&&void 0!==arguments[1]&&arguments[1],s=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];return new Promise((function(n){var l=[e.ctx];r&&(l=e.ctx.getSyncedCharts()),e.ctx.w.globals.isExecCalled&&(l=[e.ctx],e.ctx.w.globals.isExecCalled=!1),l.forEach((function(r,h){var c=r.w;if(c.globals.shouldAnimate=s,a||(c.globals.resized=!0,c.globals.dataChanged=!0,s&&r.series.getPreviousPaths()),t&&"object"===i(t)&&(r.config=new Y(t),t=y.extendArrayProps(r.config,t,c),r.w.globals.chartID!==e.ctx.w.globals.chartID&&delete t.series,c.config=x.extend(c.config,t),o&&(c.globals.lastXAxis=t.xaxis?x.clone(t.xaxis):[],c.globals.lastYAxis=t.yaxis?x.clone(t.yaxis):[],c.globals.initialConfig=x.extend({},c.config),c.globals.initialSeries=x.clone(c.config.series),t.series))){for(var d=0;d<c.globals.collapsedSeriesIndices.length;d++){var g=c.config.series[c.globals.collapsedSeriesIndices[d]];c.globals.collapsedSeries[d].data=c.globals.axisCharts?g.data.slice():g}for(var u=0;u<c.globals.ancillaryCollapsedSeriesIndices.length;u++){var p=c.config.series[c.globals.ancillaryCollapsedSeriesIndices[u]];c.globals.ancillaryCollapsedSeries[u].data=c.globals.axisCharts?p.data.slice():p}r.series.emptyCollapsedSeries(c.config.series)}return r.update(t).then((function(){h===l.length-1&&n(r)}))}))}))}},{key:"_updateSeries",value:function(t,e){var i=this,a=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return new Promise((function(s){var r,o=i.w;return o.globals.shouldAnimate=e,o.globals.dataChanged=!0,e&&i.ctx.series.getPreviousPaths(),o.globals.axisCharts?(0===(r=t.map((function(t,e){return i._extendSeries(t,e)}))).length&&(r=[{data:[]}]),o.config.series=r):o.config.series=t.slice(),a&&(o.globals.initialConfig.series=x.clone(o.config.series),o.globals.initialSeries=x.clone(o.config.series)),i.ctx.update().then((function(){s(i.ctx)}))}))}},{key:"_extendSeries",value:function(t,i){var a=this.w,s=a.config.series[i];return e(e({},a.config.series[i]),{},{name:t.name?t.name:null==s?void 0:s.name,color:t.color?t.color:null==s?void 0:s.color,type:t.type?t.type:null==s?void 0:s.type,group:t.group?t.group:null==s?void 0:s.group,data:t.data?t.data:null==s?void 0:s.data,zIndex:void 0!==t.zIndex?t.zIndex:i})}},{key:"toggleDataPointSelection",value:function(t,e){var i=this.w,a=null,s=".apexcharts-series[data\\:realIndex='".concat(t,"']");return i.globals.axisCharts?a=i.globals.dom.Paper.select("".concat(s," path[j='").concat(e,"'], ").concat(s," circle[j='").concat(e,"'], ").concat(s," rect[j='").concat(e,"']")).members[0]:void 0===e&&(a=i.globals.dom.Paper.select("".concat(s," path[j='").concat(t,"']")).members[0],"pie"!==i.config.chart.type&&"polarArea"!==i.config.chart.type&&"donut"!==i.config.chart.type||this.ctx.pie.pieClicked(t)),a?(new m(this.ctx).pathMouseDown(a,null),a.node?a.node:null):(console.warn("toggleDataPointSelection: Element not found"),null)}},{key:"forceXAxisUpdate",value:function(t){var e=this.w;if(["min","max"].forEach((function(i){void 0!==t.xaxis[i]&&(e.config.xaxis[i]=t.xaxis[i],e.globals.lastXAxis[i]=t.xaxis[i])})),t.xaxis.categories&&t.xaxis.categories.length&&(e.config.xaxis.categories=t.xaxis.categories),e.config.xaxis.convertedCatToNumeric){var i=new E(t);t=i.convertCatToNumericXaxis(t,this.ctx)}return t}},{key:"forceYAxisUpdate",value:function(t){return t.chart&&t.chart.stacked&&"100%"===t.chart.stackType&&(Array.isArray(t.yaxis)?t.yaxis.forEach((function(e,i){t.yaxis[i].min=0,t.yaxis[i].max=100})):(t.yaxis.min=0,t.yaxis.max=100)),t}},{key:"revertDefaultAxisMinMax",value:function(t){var e=this,i=this.w,a=i.globals.lastXAxis,s=i.globals.lastYAxis;t&&t.xaxis&&(a=t.xaxis),t&&t.yaxis&&(s=t.yaxis),i.config.xaxis.min=a.min,i.config.xaxis.max=a.max;var r=function(t){void 0!==s[t]&&(i.config.yaxis[t].min=s[t].min,i.config.yaxis[t].max=s[t].max)};i.config.yaxis.map((function(t,a){i.globals.zoomed||void 0!==s[a]?r(a):void 0!==e.ctx.opts.yaxis[a]&&(t.min=e.ctx.opts.yaxis[a].min,t.max=e.ctx.opts.yaxis[a].max)}))}}]),t}();Rt="undefined"!=typeof window?window:void 0,Ht=function(t,e){var a=(void 0!==this?this:t).SVG=function(t){if(a.supported)return t=new a.Doc(t),a.parser.draw||a.prepare(),t};if(a.ns="http://www.w3.org/2000/svg",a.xmlns="http://www.w3.org/2000/xmlns/",a.xlink="http://www.w3.org/1999/xlink",a.svgjs="http://svgjs.dev",a.supported=!0,!a.supported)return!1;a.did=1e3,a.eid=function(t){return"Svgjs"+d(t)+a.did++},a.create=function(t){var i=e.createElementNS(this.ns,t);return i.setAttribute("id",this.eid(t)),i},a.extend=function(){var t,e;e=(t=[].slice.call(arguments)).pop();for(var i=t.length-1;i>=0;i--)if(t[i])for(var s in e)t[i].prototype[s]=e[s];a.Set&&a.Set.inherit&&a.Set.inherit()},a.invent=function(t){var e="function"==typeof t.create?t.create:function(){this.constructor.call(this,a.create(t.create))};return t.inherit&&(e.prototype=new t.inherit),t.extend&&a.extend(e,t.extend),t.construct&&a.extend(t.parent||a.Container,t.construct),e},a.adopt=function(e){return e?e.instance?e.instance:((i="svg"==e.nodeName?e.parentNode instanceof t.SVGElement?new a.Nested:new a.Doc:"linearGradient"==e.nodeName?new a.Gradient("linear"):"radialGradient"==e.nodeName?new a.Gradient("radial"):a[d(e.nodeName)]?new(a[d(e.nodeName)]):new a.Element(e)).type=e.nodeName,i.node=e,e.instance=i,i instanceof a.Doc&&i.namespace().defs(),i.setData(JSON.parse(e.getAttribute("svgjs:data"))||{}),i):null;var i},a.prepare=function(){var t=e.getElementsByTagName("body")[0],i=(t?new a.Doc(t):a.adopt(e.documentElement).nested()).size(2,0);a.parser={body:t||e.documentElement,draw:i.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,poly:i.polyline().node,path:i.path().node,native:a.create("svg")}},a.parser={native:a.create("svg")},e.addEventListener("DOMContentLoaded",(function(){a.parser.draw||a.prepare()}),!1),a.regex={numberAndUnit:/^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,hex:/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,rgb:/rgb\((\d+),(\d+),(\d+)\)/,reference:/#([a-z0-9\-_]+)/i,transforms:/\)\s*,?\s*/,whitespace:/\s/g,isHex:/^#[a-f0-9]{3,6}$/i,isRgb:/^rgb\(/,isCss:/[^:]+:[^;]+;?/,isBlank:/^(\s+)?$/,isNumber:/^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,isPercent:/^-?[\d\.]+%$/,isImage:/\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,delimiter:/[\s,]+/,hyphen:/([^e])\-/gi,pathLetters:/[MLHVCSQTAZ]/gi,isPathLetter:/[MLHVCSQTAZ]/i,numbersWithDots:/((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,dots:/\./g},a.utils={map:function(t,e){for(var i=t.length,a=[],s=0;s<i;s++)a.push(e(t[s]));return a},filter:function(t,e){for(var i=t.length,a=[],s=0;s<i;s++)e(t[s])&&a.push(t[s]);return a},filterSVGElements:function(e){return this.filter(e,(function(e){return e instanceof t.SVGElement}))}},a.defaults={attrs:{"fill-opacity":1,"stroke-opacity":1,"stroke-width":0,"stroke-linejoin":"miter","stroke-linecap":"butt",fill:"#000000",stroke:"#000000",opacity:1,x:0,y:0,cx:0,cy:0,width:0,height:0,r:0,rx:0,ry:0,offset:0,"stop-opacity":1,"stop-color":"#000000","font-size":16,"font-family":"Helvetica, Arial, sans-serif","text-anchor":"start"}},a.Color=function(t){var e,s;this.r=0,this.g=0,this.b=0,t&&("string"==typeof t?a.regex.isRgb.test(t)?(e=a.regex.rgb.exec(t.replace(a.regex.whitespace,"")),this.r=parseInt(e[1]),this.g=parseInt(e[2]),this.b=parseInt(e[3])):a.regex.isHex.test(t)&&(e=a.regex.hex.exec(4==(s=t).length?["#",s.substring(1,2),s.substring(1,2),s.substring(2,3),s.substring(2,3),s.substring(3,4),s.substring(3,4)].join(""):s),this.r=parseInt(e[1],16),this.g=parseInt(e[2],16),this.b=parseInt(e[3],16)):"object"===i(t)&&(this.r=t.r,this.g=t.g,this.b=t.b))},a.extend(a.Color,{toString:function(){return this.toHex()},toHex:function(){return"#"+g(this.r)+g(this.g)+g(this.b)},toRgb:function(){return"rgb("+[this.r,this.g,this.b].join()+")"},brightness:function(){return this.r/255*.3+this.g/255*.59+this.b/255*.11},morph:function(t){return this.destination=new a.Color(t),this},at:function(t){return this.destination?(t=t<0?0:t>1?1:t,new a.Color({r:~~(this.r+(this.destination.r-this.r)*t),g:~~(this.g+(this.destination.g-this.g)*t),b:~~(this.b+(this.destination.b-this.b)*t)})):this}}),a.Color.test=function(t){return t+="",a.regex.isHex.test(t)||a.regex.isRgb.test(t)},a.Color.isRgb=function(t){return t&&"number"==typeof t.r&&"number"==typeof t.g&&"number"==typeof t.b},a.Color.isColor=function(t){return a.Color.isRgb(t)||a.Color.test(t)},a.Array=function(t,e){0==(t=(t||[]).valueOf()).length&&e&&(t=e.valueOf()),this.value=this.parse(t)},a.extend(a.Array,{toString:function(){return this.value.join(" ")},valueOf:function(){return this.value},parse:function(t){return t=t.valueOf(),Array.isArray(t)?t:this.split(t)}}),a.PointArray=function(t,e){a.Array.call(this,t,e||[[0,0]])},a.PointArray.prototype=new a.Array,a.PointArray.prototype.constructor=a.PointArray;for(var s={M:function(t,e,i){return e.x=i.x=t[0],e.y=i.y=t[1],["M",e.x,e.y]},L:function(t,e){return e.x=t[0],e.y=t[1],["L",t[0],t[1]]},H:function(t,e){return e.x=t[0],["H",t[0]]},V:function(t,e){return e.y=t[0],["V",t[0]]},C:function(t,e){return e.x=t[4],e.y=t[5],["C",t[0],t[1],t[2],t[3],t[4],t[5]]},Q:function(t,e){return e.x=t[2],e.y=t[3],["Q",t[0],t[1],t[2],t[3]]},S:function(t,e){return e.x=t[2],e.y=t[3],["S",t[0],t[1],t[2],t[3]]},Z:function(t,e,i){return e.x=i.x,e.y=i.y,["Z"]}},r="mlhvqtcsaz".split(""),o=0,n=r.length;o<n;++o)s[r[o]]=function(t){return function(e,i,a){if("H"==t)e[0]=e[0]+i.x;else if("V"==t)e[0]=e[0]+i.y;else if("A"==t)e[5]=e[5]+i.x,e[6]=e[6]+i.y;else for(var r=0,o=e.length;r<o;++r)e[r]=e[r]+(r%2?i.y:i.x);if(s&&"function"==typeof s[t])return s[t](e,i,a)}}(r[o].toUpperCase());a.PathArray=function(t,e){a.Array.call(this,t,e||[["M",0,0]])},a.PathArray.prototype=new a.Array,a.PathArray.prototype.constructor=a.PathArray,a.extend(a.PathArray,{toString:function(){return function(t){for(var e=0,i=t.length,a="";e<i;e++)a+=t[e][0],null!=t[e][1]&&(a+=t[e][1],null!=t[e][2]&&(a+=" ",a+=t[e][2],null!=t[e][3]&&(a+=" ",a+=t[e][3],a+=" ",a+=t[e][4],null!=t[e][5]&&(a+=" ",a+=t[e][5],a+=" ",a+=t[e][6],null!=t[e][7]&&(a+=" ",a+=t[e][7])))));return a+" "}(this.value)},move:function(t,e){var i=this.bbox();return i.x,i.y,this},at:function(t){if(!this.destination)return this;for(var e=this.value,i=this.destination.value,s=[],r=new a.PathArray,o=0,n=e.length;o<n;o++){s[o]=[e[o][0]];for(var l=1,h=e[o].length;l<h;l++)s[o][l]=e[o][l]+(i[o][l]-e[o][l])*t;"A"===s[o][0]&&(s[o][4]=+(0!=s[o][4]),s[o][5]=+(0!=s[o][5]))}return r.value=s,r},parse:function(t){if(t instanceof a.PathArray)return t.valueOf();var e,i={M:2,L:2,H:1,V:1,C:6,S:4,Q:4,T:2,A:7,Z:0};t="string"==typeof t?t.replace(a.regex.numbersWithDots,h).replace(a.regex.pathLetters," $& ").replace(a.regex.hyphen,"$1 -").trim().split(a.regex.delimiter):t.reduce((function(t,e){return[].concat.call(t,e)}),[]);var r=[],o=new a.Point,n=new a.Point,l=0,c=t.length;do{a.regex.isPathLetter.test(t[l])?(e=t[l],++l):"M"==e?e="L":"m"==e&&(e="l"),r.push(s[e].call(null,t.slice(l,l+=i[e.toUpperCase()]).map(parseFloat),o,n))}while(c>l);return r},bbox:function(){return a.parser.draw||a.prepare(),a.parser.path.setAttribute("d",this.toString()),a.parser.path.getBBox()}}),a.Number=a.invent({create:function(t,e){this.value=0,this.unit=e||"","number"==typeof t?this.value=isNaN(t)?0:isFinite(t)?t:t<0?-34e37:34e37:"string"==typeof t?(e=t.match(a.regex.numberAndUnit))&&(this.value=parseFloat(e[1]),"%"==e[5]?this.value/=100:"s"==e[5]&&(this.value*=1e3),this.unit=e[5]):t instanceof a.Number&&(this.value=t.valueOf(),this.unit=t.unit)},extend:{toString:function(){return("%"==this.unit?~~(1e8*this.value)/1e6:"s"==this.unit?this.value/1e3:this.value)+this.unit},toJSON:function(){return this.toString()},valueOf:function(){return this.value},plus:function(t){return t=new a.Number(t),new a.Number(this+t,this.unit||t.unit)},minus:function(t){return t=new a.Number(t),new a.Number(this-t,this.unit||t.unit)},times:function(t){return t=new a.Number(t),new a.Number(this*t,this.unit||t.unit)},divide:function(t){return t=new a.Number(t),new a.Number(this/t,this.unit||t.unit)},to:function(t){var e=new a.Number(this);return"string"==typeof t&&(e.unit=t),e},morph:function(t){return this.destination=new a.Number(t),t.relative&&(this.destination.value+=this.value),this},at:function(t){return this.destination?new a.Number(this.destination).minus(this).times(t).plus(this):this}}}),a.Element=a.invent({create:function(t){this._stroke=a.defaults.attrs.stroke,this._event=null,this.dom={},(this.node=t)&&(this.type=t.nodeName,this.node.instance=this,this._stroke=t.getAttribute("stroke")||this._stroke)},extend:{x:function(t){return this.attr("x",t)},y:function(t){return this.attr("y",t)},cx:function(t){return null==t?this.x()+this.width()/2:this.x(t-this.width()/2)},cy:function(t){return null==t?this.y()+this.height()/2:this.y(t-this.height()/2)},move:function(t,e){return this.x(t).y(e)},center:function(t,e){return this.cx(t).cy(e)},width:function(t){return this.attr("width",t)},height:function(t){return this.attr("height",t)},size:function(t,e){var i=u(this,t,e);return this.width(new a.Number(i.width)).height(new a.Number(i.height))},clone:function(t){this.writeDataToDom();var e=x(this.node.cloneNode(!0));return t?t.add(e):this.after(e),e},remove:function(){return this.parent()&&this.parent().removeElement(this),this},replace:function(t){return this.after(t).remove(),t},addTo:function(t){return t.put(this)},putIn:function(t){return t.add(this)},id:function(t){return this.attr("id",t)},show:function(){return this.style("display","")},hide:function(){return this.style("display","none")},visible:function(){return"none"!=this.style("display")},toString:function(){return this.attr("id")},classes:function(){var t=this.attr("class");return null==t?[]:t.trim().split(a.regex.delimiter)},hasClass:function(t){return-1!=this.classes().indexOf(t)},addClass:function(t){if(!this.hasClass(t)){var e=this.classes();e.push(t),this.attr("class",e.join(" "))}return this},removeClass:function(t){return this.hasClass(t)&&this.attr("class",this.classes().filter((function(e){return e!=t})).join(" ")),this},toggleClass:function(t){return this.hasClass(t)?this.removeClass(t):this.addClass(t)},reference:function(t){return a.get(this.attr(t))},parent:function(e){var i=this;if(!i.node.parentNode)return null;if(i=a.adopt(i.node.parentNode),!e)return i;for(;i&&i.node instanceof t.SVGElement;){if("string"==typeof e?i.matches(e):i instanceof e)return i;if(!i.node.parentNode||"#document"==i.node.parentNode.nodeName)return null;i=a.adopt(i.node.parentNode)}},doc:function(){return this instanceof a.Doc?this:this.parent(a.Doc)},parents:function(t){var e=[],i=this;do{if(!(i=i.parent(t))||!i.node)break;e.push(i)}while(i.parent);return e},matches:function(t){return function(t,e){return(t.matches||t.matchesSelector||t.msMatchesSelector||t.mozMatchesSelector||t.webkitMatchesSelector||t.oMatchesSelector).call(t,e)}(this.node,t)},native:function(){return this.node},svg:function(t){var i=e.createElementNS("http://www.w3.org/2000/svg","svg");if(!(t&&this instanceof a.Parent))return i.appendChild(t=e.createElementNS("http://www.w3.org/2000/svg","svg")),this.writeDataToDom(),t.appendChild(this.node.cloneNode(!0)),i.innerHTML.replace(/^<svg>/,"").replace(/<\/svg>$/,"");i.innerHTML="<svg>"+t.replace(/\n/,"").replace(/<([\w:-]+)([^<]+?)\/>/g,"<$1$2></$1>")+"</svg>";for(var s=0,r=i.firstChild.childNodes.length;s<r;s++)this.node.appendChild(i.firstChild.firstChild);return this},writeDataToDom:function(){return(this.each||this.lines)&&(this.each?this:this.lines()).each((function(){this.writeDataToDom()})),this.node.removeAttribute("svgjs:data"),Object.keys(this.dom).length&&this.node.setAttribute("svgjs:data",JSON.stringify(this.dom)),this},setData:function(t){return this.dom=t,this},is:function(t){return function(t,e){return t instanceof e}(this,t)}}}),a.easing={"-":function(t){return t},"<>":function(t){return-Math.cos(t*Math.PI)/2+.5},">":function(t){return Math.sin(t*Math.PI/2)},"<":function(t){return 1-Math.cos(t*Math.PI/2)}},a.morph=function(t){return function(e,i){return new a.MorphObj(e,i).at(t)}},a.Situation=a.invent({create:function(t){this.init=!1,this.reversed=!1,this.reversing=!1,this.duration=new a.Number(t.duration).valueOf(),this.delay=new a.Number(t.delay).valueOf(),this.start=+new Date+this.delay,this.finish=this.start+this.duration,this.ease=t.ease,this.loop=0,this.loops=!1,this.animations={},this.attrs={},this.styles={},this.transforms=[],this.once={}}}),a.FX=a.invent({create:function(t){this._target=t,this.situations=[],this.active=!1,this.situation=null,this.paused=!1,this.lastPos=0,this.pos=0,this.absPos=0,this._speed=1},extend:{animate:function(t,e,s){"object"===i(t)&&(e=t.ease,s=t.delay,t=t.duration);var r=new a.Situation({duration:t||1e3,delay:s||0,ease:a.easing[e||"-"]||e});return this.queue(r),this},target:function(t){return t&&t instanceof a.Element?(this._target=t,this):this._target},timeToAbsPos:function(t){return(t-this.situation.start)/(this.situation.duration/this._speed)},absPosToTime:function(t){return this.situation.duration/this._speed*t+this.situation.start},startAnimFrame:function(){this.stopAnimFrame(),this.animationFrame=t.requestAnimationFrame(function(){this.step()}.bind(this))},stopAnimFrame:function(){t.cancelAnimationFrame(this.animationFrame)},start:function(){return!this.active&&this.situation&&(this.active=!0,this.startCurrent()),this},startCurrent:function(){return this.situation.start=+new Date+this.situation.delay/this._speed,this.situation.finish=this.situation.start+this.situation.duration/this._speed,this.initAnimations().step()},queue:function(t){return("function"==typeof t||t instanceof a.Situation)&&this.situations.push(t),this.situation||(this.situation=this.situations.shift()),this},dequeue:function(){return this.stop(),this.situation=this.situations.shift(),this.situation&&(this.situation instanceof a.Situation?this.start():this.situation.call(this)),this},initAnimations:function(){var t,e=this.situation;if(e.init)return this;for(var i in e.animations){t=this.target()[i](),Array.isArray(t)||(t=[t]),Array.isArray(e.animations[i])||(e.animations[i]=[e.animations[i]]);for(var s=t.length;s--;)e.animations[i][s]instanceof a.Number&&(t[s]=new a.Number(t[s])),e.animations[i][s]=t[s].morph(e.animations[i][s])}for(var i in e.attrs)e.attrs[i]=new a.MorphObj(this.target().attr(i),e.attrs[i]);for(var i in e.styles)e.styles[i]=new a.MorphObj(this.target().style(i),e.styles[i]);return e.initialTransformation=this.target().matrixify(),e.init=!0,this},clearQueue:function(){return this.situations=[],this},clearCurrent:function(){return this.situation=null,this},stop:function(t,e){var i=this.active;return this.active=!1,e&&this.clearQueue(),t&&this.situation&&(!i&&this.startCurrent(),this.atEnd()),this.stopAnimFrame(),this.clearCurrent()},after:function(t){var e=this.last();return this.target().on("finished.fx",(function i(a){a.detail.situation==e&&(t.call(this,e),this.off("finished.fx",i))})),this._callStart()},during:function(t){var e=this.last(),i=function(i){i.detail.situation==e&&t.call(this,i.detail.pos,a.morph(i.detail.pos),i.detail.eased,e)};return this.target().off("during.fx",i).on("during.fx",i),this.after((function(){this.off("during.fx",i)})),this._callStart()},afterAll:function(t){var e=function e(i){t.call(this),this.off("allfinished.fx",e)};return this.target().off("allfinished.fx",e).on("allfinished.fx",e),this._callStart()},last:function(){return this.situations.length?this.situations[this.situations.length-1]:this.situation},add:function(t,e,i){return this.last()[i||"animations"][t]=e,this._callStart()},step:function(t){var e,i,a;t||(this.absPos=this.timeToAbsPos(+new Date)),!1!==this.situation.loops?(e=Math.max(this.absPos,0),i=Math.floor(e),!0===this.situation.loops||i<this.situation.loops?(this.pos=e-i,a=this.situation.loop,this.situation.loop=i):(this.absPos=this.situation.loops,this.pos=1,a=this.situation.loop-1,this.situation.loop=this.situation.loops),this.situation.reversing&&(this.situation.reversed=this.situation.reversed!=Boolean((this.situation.loop-a)%2))):(this.absPos=Math.min(this.absPos,1),this.pos=this.absPos),this.pos<0&&(this.pos=0),this.situation.reversed&&(this.pos=1-this.pos);var s=this.situation.ease(this.pos);for(var r in this.situation.once)r>this.lastPos&&r<=s&&(this.situation.once[r].call(this.target(),this.pos,s),delete this.situation.once[r]);return this.active&&this.target().fire("during",{pos:this.pos,eased:s,fx:this,situation:this.situation}),this.situation?(this.eachAt(),1==this.pos&&!this.situation.reversed||this.situation.reversed&&0==this.pos?(this.stopAnimFrame(),this.target().fire("finished",{fx:this,situation:this.situation}),this.situations.length||(this.target().fire("allfinished"),this.situations.length||(this.target().off(".fx"),this.active=!1)),this.active?this.dequeue():this.clearCurrent()):!this.paused&&this.active&&this.startAnimFrame(),this.lastPos=s,this):this},eachAt:function(){var t,e=this,i=this.target(),s=this.situation;for(var r in s.animations)t=[].concat(s.animations[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),i[r].apply(i,t);for(var r in s.attrs)t=[r].concat(s.attrs[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),i.attr.apply(i,t);for(var r in s.styles)t=[r].concat(s.styles[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),i.style.apply(i,t);if(s.transforms.length){t=s.initialTransformation,r=0;for(var o=s.transforms.length;r<o;r++){var n=s.transforms[r];n instanceof a.Matrix?t=n.relative?t.multiply((new a.Matrix).morph(n).at(s.ease(this.pos))):t.morph(n).at(s.ease(this.pos)):(n.relative||n.undo(t.extract()),t=t.multiply(n.at(s.ease(this.pos))))}i.matrix(t)}return this},once:function(t,e,i){var a=this.last();return i||(t=a.ease(t)),a.once[t]=e,this},_callStart:function(){return setTimeout(function(){this.start()}.bind(this),0),this}},parent:a.Element,construct:{animate:function(t,e,i){return(this.fx||(this.fx=new a.FX(this))).animate(t,e,i)},delay:function(t){return(this.fx||(this.fx=new a.FX(this))).delay(t)},stop:function(t,e){return this.fx&&this.fx.stop(t,e),this},finish:function(){return this.fx&&this.fx.finish(),this}}}),a.MorphObj=a.invent({create:function(t,e){return a.Color.isColor(e)?new a.Color(t).morph(e):a.regex.delimiter.test(t)?a.regex.pathLetters.test(t)?new a.PathArray(t).morph(e):new a.Array(t).morph(e):a.regex.numberAndUnit.test(e)?new a.Number(t).morph(e):(this.value=t,void(this.destination=e))},extend:{at:function(t,e){return e<1?this.value:this.destination},valueOf:function(){return this.value}}}),a.extend(a.FX,{attr:function(t,e,a){if("object"===i(t))for(var s in t)this.attr(s,t[s]);else this.add(t,e,"attrs");return this},plot:function(t,e,i,a){return 4==arguments.length?this.plot([t,e,i,a]):this.add("plot",new(this.target().morphArray)(t))}}),a.Box=a.invent({create:function(t,e,s,r){if(!("object"!==i(t)||t instanceof a.Element))return a.Box.call(this,null!=t.left?t.left:t.x,null!=t.top?t.top:t.y,t.width,t.height);var o;4==arguments.length&&(this.x=t,this.y=e,this.width=s,this.height=r),null==(o=this).x&&(o.x=0,o.y=0,o.width=0,o.height=0),o.w=o.width,o.h=o.height,o.x2=o.x+o.width,o.y2=o.y+o.height,o.cx=o.x+o.width/2,o.cy=o.y+o.height/2}}),a.BBox=a.invent({create:function(t){if(a.Box.apply(this,[].slice.call(arguments)),t instanceof a.Element){var i;try{if(!e.documentElement.contains){for(var s=t.node;s.parentNode;)s=s.parentNode;if(s!=e)throw new Error("Element not in the dom")}i=t.node.getBBox()}catch(e){if(t instanceof a.Shape){a.parser.draw||a.prepare();var r=t.clone(a.parser.draw.instance).show();r&&r.node&&"function"==typeof r.node.getBBox&&(i=r.node.getBBox()),r&&"function"==typeof r.remove&&r.remove()}else i={x:t.node.clientLeft,y:t.node.clientTop,width:t.node.clientWidth,height:t.node.clientHeight}}a.Box.call(this,i)}},inherit:a.Box,parent:a.Element,construct:{bbox:function(){return new a.BBox(this)}}}),a.BBox.prototype.constructor=a.BBox,a.Matrix=a.invent({create:function(t){var e=f([1,0,0,1,0,0]);t=null===t?e:t instanceof a.Element?t.matrixify():"string"==typeof t?f(t.split(a.regex.delimiter).map(parseFloat)):6==arguments.length?f([].slice.call(arguments)):Array.isArray(t)?f(t):t&&"object"===i(t)?t:e;for(var s=v.length-1;s>=0;--s)this[v[s]]=null!=t[v[s]]?t[v[s]]:e[v[s]]},extend:{extract:function(){var t=p(this,0,1);p(this,1,0);var e=180/Math.PI*Math.atan2(t.y,t.x)-90;return{x:this.e,y:this.f,transformedX:(this.e*Math.cos(e*Math.PI/180)+this.f*Math.sin(e*Math.PI/180))/Math.sqrt(this.a*this.a+this.b*this.b),transformedY:(this.f*Math.cos(e*Math.PI/180)+this.e*Math.sin(-e*Math.PI/180))/Math.sqrt(this.c*this.c+this.d*this.d),rotation:e,a:this.a,b:this.b,c:this.c,d:this.d,e:this.e,f:this.f,matrix:new a.Matrix(this)}},clone:function(){return new a.Matrix(this)},morph:function(t){return this.destination=new a.Matrix(t),this},multiply:function(t){return new a.Matrix(this.native().multiply(function(t){return t instanceof a.Matrix||(t=new a.Matrix(t)),t}(t).native()))},inverse:function(){return new a.Matrix(this.native().inverse())},translate:function(t,e){return new a.Matrix(this.native().translate(t||0,e||0))},native:function(){for(var t=a.parser.native.createSVGMatrix(),e=v.length-1;e>=0;e--)t[v[e]]=this[v[e]];return t},toString:function(){return"matrix("+b(this.a)+","+b(this.b)+","+b(this.c)+","+b(this.d)+","+b(this.e)+","+b(this.f)+")"}},parent:a.Element,construct:{ctm:function(){return new a.Matrix(this.node.getCTM())},screenCTM:function(){if(this instanceof a.Nested){var t=this.rect(1,1),e=t.node.getScreenCTM();return t.remove(),new a.Matrix(e)}return new a.Matrix(this.node.getScreenCTM())}}}),a.Point=a.invent({create:function(t,e){var a;a=Array.isArray(t)?{x:t[0],y:t[1]}:"object"===i(t)?{x:t.x,y:t.y}:null!=t?{x:t,y:null!=e?e:t}:{x:0,y:0},this.x=a.x,this.y=a.y},extend:{clone:function(){return new a.Point(this)},morph:function(t,e){return this.destination=new a.Point(t,e),this}}}),a.extend(a.Element,{point:function(t,e){return new a.Point(t,e).transform(this.screenCTM().inverse())}}),a.extend(a.Element,{attr:function(t,e,s){if(null==t){for(t={},s=(e=this.node.attributes).length-1;s>=0;s--)t[e[s].nodeName]=a.regex.isNumber.test(e[s].nodeValue)?parseFloat(e[s].nodeValue):e[s].nodeValue;return t}if("object"===i(t))for(var r in t)this.attr(r,t[r]);else if(null===e)this.node.removeAttribute(t);else{if(null==e)return null==(e=this.node.getAttribute(t))?a.defaults.attrs[t]:a.regex.isNumber.test(e)?parseFloat(e):e;"stroke-width"==t?this.attr("stroke",parseFloat(e)>0?this._stroke:null):"stroke"==t&&(this._stroke=e),"fill"!=t&&"stroke"!=t||(a.regex.isImage.test(e)&&(e=this.doc().defs().image(e,0,0)),e instanceof a.Image&&(e=this.doc().defs().pattern(0,0,(function(){this.add(e)})))),"number"==typeof e?e=new a.Number(e):a.Color.isColor(e)?e=new a.Color(e):Array.isArray(e)&&(e=new a.Array(e)),"leading"==t?this.leading&&this.leading(e):"string"==typeof s?this.node.setAttributeNS(s,t,e.toString()):this.node.setAttribute(t,e.toString()),!this.rebuild||"font-size"!=t&&"x"!=t||this.rebuild(t,e)}return this}}),a.extend(a.Element,{transform:function(t,e){var s;return"object"!==i(t)?(s=new a.Matrix(this).extract(),"string"==typeof t?s[t]:s):(s=new a.Matrix(this),e=!!e||!!t.relative,null!=t.a&&(s=e?s.multiply(new a.Matrix(t)):new a.Matrix(t)),this.attr("transform",s))}}),a.extend(a.Element,{untransform:function(){return this.attr("transform",null)},matrixify:function(){return(this.attr("transform")||"").split(a.regex.transforms).slice(0,-1).map((function(t){var e=t.trim().split("(");return[e[0],e[1].split(a.regex.delimiter).map((function(t){return parseFloat(t)}))]})).reduce((function(t,e){return"matrix"==e[0]?t.multiply(f(e[1])):t[e[0]].apply(t,e[1])}),new a.Matrix)},toParent:function(t){if(this==t)return this;var e=this.screenCTM(),i=t.screenCTM().inverse();return this.addTo(t).untransform().transform(i.multiply(e)),this},toDoc:function(){return this.toParent(this.doc())}}),a.Transformation=a.invent({create:function(t,e){if(arguments.length>1&&"boolean"!=typeof e)return this.constructor.call(this,[].slice.call(arguments));if(Array.isArray(t))for(var a=0,s=this.arguments.length;a<s;++a)this[this.arguments[a]]=t[a];else if(t&&"object"===i(t))for(a=0,s=this.arguments.length;a<s;++a)this[this.arguments[a]]=t[this.arguments[a]];this.inversed=!1,!0===e&&(this.inversed=!0)}}),a.Translate=a.invent({parent:a.Matrix,inherit:a.Transformation,create:function(t,e){this.constructor.apply(this,[].slice.call(arguments))},extend:{arguments:["transformedX","transformedY"],method:"translate"}}),a.extend(a.Element,{style:function(t,e){if(0==arguments.length)return this.node.style.cssText||"";if(arguments.length<2)if("object"===i(t))for(var s in t)this.style(s,t[s]);else{if(!a.regex.isCss.test(t))return this.node.style[c(t)];for(t=t.split(/\s*;\s*/).filter((function(t){return!!t})).map((function(t){return t.split(/\s*:\s*/)}));e=t.pop();)this.style(e[0],e[1])}else this.node.style[c(t)]=null===e||a.regex.isBlank.test(e)?"":e;return this}}),a.Parent=a.invent({create:function(t){this.constructor.call(this,t)},inherit:a.Element,extend:{children:function(){return a.utils.map(a.utils.filterSVGElements(this.node.childNodes),(function(t){return a.adopt(t)}))},add:function(t,e){return null==e?this.node.appendChild(t.node):t.node!=this.node.childNodes[e]&&this.node.insertBefore(t.node,this.node.childNodes[e]),this},put:function(t,e){return this.add(t,e),t},has:function(t){return this.index(t)>=0},index:function(t){return[].slice.call(this.node.childNodes).indexOf(t.node)},get:function(t){return a.adopt(this.node.childNodes[t])},first:function(){return this.get(0)},last:function(){return this.get(this.node.childNodes.length-1)},each:function(t,e){for(var i=this.children(),s=0,r=i.length;s<r;s++)i[s]instanceof a.Element&&t.apply(i[s],[s,i]),e&&i[s]instanceof a.Container&&i[s].each(t,e);return this},removeElement:function(t){return this.node.removeChild(t.node),this},clear:function(){for(;this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);return delete this._defs,this},defs:function(){return this.doc().defs()}}}),a.extend(a.Parent,{ungroup:function(t,e){return 0===e||this instanceof a.Defs||this.node==a.parser.draw||(t=t||(this instanceof a.Doc?this:this.parent(a.Parent)),e=e||1/0,this.each((function(){return this instanceof a.Defs?this:this instanceof a.Parent?this.ungroup(t,e-1):this.toParent(t)})),this.node.firstChild||this.remove()),this},flatten:function(t,e){return this.ungroup(t,e)}}),a.Container=a.invent({create:function(t){this.constructor.call(this,t)},inherit:a.Parent}),a.ViewBox=a.invent({parent:a.Container,construct:{}}),["click","dblclick","mousedown","mouseup","mouseover","mouseout","mousemove","touchstart","touchmove","touchleave","touchend","touchcancel"].forEach((function(t){a.Element.prototype[t]=function(e){return a.on(this.node,t,e),this}})),a.listeners=[],a.handlerMap=[],a.listenerId=0,a.on=function(t,e,i,s,r){var o=i.bind(s||t.instance||t),n=(a.handlerMap.indexOf(t)+1||a.handlerMap.push(t))-1,l=e.split(".")[0],h=e.split(".")[1]||"*";a.listeners[n]=a.listeners[n]||{},a.listeners[n][l]=a.listeners[n][l]||{},a.listeners[n][l][h]=a.listeners[n][l][h]||{},i._svgjsListenerId||(i._svgjsListenerId=++a.listenerId),a.listeners[n][l][h][i._svgjsListenerId]=o,t.addEventListener(l,o,r||{passive:!1})},a.off=function(t,e,i){var s=a.handlerMap.indexOf(t),r=e&&e.split(".")[0],o=e&&e.split(".")[1],n="";if(-1!=s)if(i){if("function"==typeof i&&(i=i._svgjsListenerId),!i)return;a.listeners[s][r]&&a.listeners[s][r][o||"*"]&&(t.removeEventListener(r,a.listeners[s][r][o||"*"][i],!1),delete a.listeners[s][r][o||"*"][i])}else if(o&&r){if(a.listeners[s][r]&&a.listeners[s][r][o]){for(var l in a.listeners[s][r][o])a.off(t,[r,o].join("."),l);delete a.listeners[s][r][o]}}else if(o)for(var h in a.listeners[s])for(var n in a.listeners[s][h])o===n&&a.off(t,[h,o].join("."));else if(r){if(a.listeners[s][r]){for(var n in a.listeners[s][r])a.off(t,[r,n].join("."));delete a.listeners[s][r]}}else{for(var h in a.listeners[s])a.off(t,h);delete a.listeners[s],delete a.handlerMap[s]}},a.extend(a.Element,{on:function(t,e,i,s){return a.on(this.node,t,e,i,s),this},off:function(t,e){return a.off(this.node,t,e),this},fire:function(e,i){return e instanceof t.Event?this.node.dispatchEvent(e):this.node.dispatchEvent(e=new a.CustomEvent(e,{detail:i,cancelable:!0})),this._event=e,this},event:function(){return this._event}}),a.Defs=a.invent({create:"defs",inherit:a.Container}),a.G=a.invent({create:"g",inherit:a.Container,extend:{x:function(t){return null==t?this.transform("x"):this.transform({x:t-this.x()},!0)}},construct:{group:function(){return this.put(new a.G)}}}),a.Doc=a.invent({create:function(t){t&&("svg"==(t="string"==typeof t?e.getElementById(t):t).nodeName?this.constructor.call(this,t):(this.constructor.call(this,a.create("svg")),t.appendChild(this.node),this.size("100%","100%")),this.namespace().defs())},inherit:a.Container,extend:{namespace:function(){return this.attr({xmlns:a.ns,version:"1.1"}).attr("xmlns:xlink",a.xlink,a.xmlns).attr("xmlns:svgjs",a.svgjs,a.xmlns)},defs:function(){var t;return this._defs||((t=this.node.getElementsByTagName("defs")[0])?this._defs=a.adopt(t):this._defs=new a.Defs,this.node.appendChild(this._defs.node)),this._defs},parent:function(){return this.node.parentNode&&"#document"!=this.node.parentNode.nodeName?this.node.parentNode:null},remove:function(){return this.parent()&&this.parent().removeChild(this.node),this},clear:function(){for(;this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);return delete this._defs,a.parser.draw&&!a.parser.draw.parentNode&&this.node.appendChild(a.parser.draw),this},clone:function(t){this.writeDataToDom();var e=this.node,i=x(e.cloneNode(!0));return t?(t.node||t).appendChild(i.node):e.parentNode.insertBefore(i.node,e.nextSibling),i}}}),a.extend(a.Element,{}),a.Gradient=a.invent({create:function(t){this.constructor.call(this,a.create(t+"Gradient")),this.type=t},inherit:a.Container,extend:{at:function(t,e,i){return this.put(new a.Stop).update(t,e,i)},update:function(t){return this.clear(),"function"==typeof t&&t.call(this,this),this},fill:function(){return"url(#"+this.id()+")"},toString:function(){return this.fill()},attr:function(t,e,i){return"transform"==t&&(t="gradientTransform"),a.Container.prototype.attr.call(this,t,e,i)}},construct:{gradient:function(t,e){return this.defs().gradient(t,e)}}}),a.extend(a.Gradient,a.FX,{from:function(t,e){return"radial"==(this._target||this).type?this.attr({fx:new a.Number(t),fy:new a.Number(e)}):this.attr({x1:new a.Number(t),y1:new a.Number(e)})},to:function(t,e){return"radial"==(this._target||this).type?this.attr({cx:new a.Number(t),cy:new a.Number(e)}):this.attr({x2:new a.Number(t),y2:new a.Number(e)})}}),a.extend(a.Defs,{gradient:function(t,e){return this.put(new a.Gradient(t)).update(e)}}),a.Stop=a.invent({create:"stop",inherit:a.Element,extend:{update:function(t){return("number"==typeof t||t instanceof a.Number)&&(t={offset:arguments[0],color:arguments[1],opacity:arguments[2]}),null!=t.opacity&&this.attr("stop-opacity",t.opacity),null!=t.color&&this.attr("stop-color",t.color),null!=t.offset&&this.attr("offset",new a.Number(t.offset)),this}}}),a.Pattern=a.invent({create:"pattern",inherit:a.Container,extend:{fill:function(){return"url(#"+this.id()+")"},update:function(t){return this.clear(),"function"==typeof t&&t.call(this,this),this},toString:function(){return this.fill()},attr:function(t,e,i){return"transform"==t&&(t="patternTransform"),a.Container.prototype.attr.call(this,t,e,i)}},construct:{pattern:function(t,e,i){return this.defs().pattern(t,e,i)}}}),a.extend(a.Defs,{pattern:function(t,e,i){return this.put(new a.Pattern).update(i).attr({x:0,y:0,width:t,height:e,patternUnits:"userSpaceOnUse"})}}),a.Shape=a.invent({create:function(t){this.constructor.call(this,t)},inherit:a.Element}),a.Symbol=a.invent({create:"symbol",inherit:a.Container,construct:{symbol:function(){return this.put(new a.Symbol)}}}),a.Use=a.invent({create:"use",inherit:a.Shape,extend:{element:function(t,e){return this.attr("href",(e||"")+"#"+t,a.xlink)}},construct:{use:function(t,e){return this.put(new a.Use).element(t,e)}}}),a.Rect=a.invent({create:"rect",inherit:a.Shape,construct:{rect:function(t,e){return this.put(new a.Rect).size(t,e)}}}),a.Circle=a.invent({create:"circle",inherit:a.Shape,construct:{circle:function(t){return this.put(new a.Circle).rx(new a.Number(t).divide(2)).move(0,0)}}}),a.extend(a.Circle,a.FX,{rx:function(t){return this.attr("r",t)},ry:function(t){return this.rx(t)}}),a.Ellipse=a.invent({create:"ellipse",inherit:a.Shape,construct:{ellipse:function(t,e){return this.put(new a.Ellipse).size(t,e).move(0,0)}}}),a.extend(a.Ellipse,a.Rect,a.FX,{rx:function(t){return this.attr("rx",t)},ry:function(t){return this.attr("ry",t)}}),a.extend(a.Circle,a.Ellipse,{x:function(t){return null==t?this.cx()-this.rx():this.cx(t+this.rx())},y:function(t){return null==t?this.cy()-this.ry():this.cy(t+this.ry())},cx:function(t){return null==t?this.attr("cx"):this.attr("cx",t)},cy:function(t){return null==t?this.attr("cy"):this.attr("cy",t)},width:function(t){return null==t?2*this.rx():this.rx(new a.Number(t).divide(2))},height:function(t){return null==t?2*this.ry():this.ry(new a.Number(t).divide(2))},size:function(t,e){var i=u(this,t,e);return this.rx(new a.Number(i.width).divide(2)).ry(new a.Number(i.height).divide(2))}}),a.Line=a.invent({create:"line",inherit:a.Shape,extend:{array:function(){return new a.PointArray([[this.attr("x1"),this.attr("y1")],[this.attr("x2"),this.attr("y2")]])},plot:function(t,e,i,s){return null==t?this.array():(t=void 0!==e?{x1:t,y1:e,x2:i,y2:s}:new a.PointArray(t).toLine(),this.attr(t))},move:function(t,e){return this.attr(this.array().move(t,e).toLine())},size:function(t,e){var i=u(this,t,e);return this.attr(this.array().size(i.width,i.height).toLine())}},construct:{line:function(t,e,i,s){return a.Line.prototype.plot.apply(this.put(new a.Line),null!=t?[t,e,i,s]:[0,0,0,0])}}}),a.Polyline=a.invent({create:"polyline",inherit:a.Shape,construct:{polyline:function(t){return this.put(new a.Polyline).plot(t||new a.PointArray)}}}),a.Polygon=a.invent({create:"polygon",inherit:a.Shape,construct:{polygon:function(t){return this.put(new a.Polygon).plot(t||new a.PointArray)}}}),a.extend(a.Polyline,a.Polygon,{array:function(){return this._array||(this._array=new a.PointArray(this.attr("points")))},plot:function(t){return null==t?this.array():this.clear().attr("points","string"==typeof t?t:this._array=new a.PointArray(t))},clear:function(){return delete this._array,this},move:function(t,e){return this.attr("points",this.array().move(t,e))},size:function(t,e){var i=u(this,t,e);return this.attr("points",this.array().size(i.width,i.height))}}),a.extend(a.Line,a.Polyline,a.Polygon,{morphArray:a.PointArray,x:function(t){return null==t?this.bbox().x:this.move(t,this.bbox().y)},y:function(t){return null==t?this.bbox().y:this.move(this.bbox().x,t)},width:function(t){var e=this.bbox();return null==t?e.width:this.size(t,e.height)},height:function(t){var e=this.bbox();return null==t?e.height:this.size(e.width,t)}}),a.Path=a.invent({create:"path",inherit:a.Shape,extend:{morphArray:a.PathArray,array:function(){return this._array||(this._array=new a.PathArray(this.attr("d")))},plot:function(t){return null==t?this.array():this.clear().attr("d","string"==typeof t?t:this._array=new a.PathArray(t))},clear:function(){return delete this._array,this}},construct:{path:function(t){return this.put(new a.Path).plot(t||new a.PathArray)}}}),a.Image=a.invent({create:"image",inherit:a.Shape,extend:{load:function(e){if(!e)return this;var i=this,s=new t.Image;return a.on(s,"load",(function(){a.off(s);var t=i.parent(a.Pattern);null!==t&&(0==i.width()&&0==i.height()&&i.size(s.width,s.height),t&&0==t.width()&&0==t.height()&&t.size(i.width(),i.height()),"function"==typeof i._loaded&&i._loaded.call(i,{width:s.width,height:s.height,ratio:s.width/s.height,url:e}))})),a.on(s,"error",(function(t){a.off(s),"function"==typeof i._error&&i._error.call(i,t)})),this.attr("href",s.src=this.src=e,a.xlink)},loaded:function(t){return this._loaded=t,this},error:function(t){return this._error=t,this}},construct:{image:function(t,e,i){return this.put(new a.Image).load(t).size(e||0,i||e||0)}}}),a.Text=a.invent({create:function(){this.constructor.call(this,a.create("text")),this.dom.leading=new a.Number(1.3),this._rebuild=!0,this._build=!1,this.attr("font-family",a.defaults.attrs["font-family"])},inherit:a.Shape,extend:{x:function(t){return null==t?this.attr("x"):this.attr("x",t)},text:function(t){if(void 0===t){t="";for(var e=this.node.childNodes,i=0,s=e.length;i<s;++i)0!=i&&3!=e[i].nodeType&&1==a.adopt(e[i]).dom.newLined&&(t+="\n"),t+=e[i].textContent;return t}if(this.clear().build(!0),"function"==typeof t)t.call(this,this);else{i=0;for(var r=(t=t.split("\n")).length;i<r;i++)this.tspan(t[i]).newLine()}return this.build(!1).rebuild()},size:function(t){return this.attr("font-size",t).rebuild()},leading:function(t){return null==t?this.dom.leading:(this.dom.leading=new a.Number(t),this.rebuild())},lines:function(){var t=(this.textPath&&this.textPath()||this).node,e=a.utils.map(a.utils.filterSVGElements(t.childNodes),(function(t){return a.adopt(t)}));return new a.Set(e)},rebuild:function(t){if("boolean"==typeof t&&(this._rebuild=t),this._rebuild){var e=this,i=0,s=this.dom.leading*new a.Number(this.attr("font-size"));this.lines().each((function(){this.dom.newLined&&(e.textPath()||this.attr("x",e.attr("x")),"\n"==this.text()?i+=s:(this.attr("dy",s+i),i=0))})),this.fire("rebuild")}return this},build:function(t){return this._build=!!t,this},setData:function(t){return this.dom=t,this.dom.leading=new a.Number(t.leading||1.3),this}},construct:{text:function(t){return this.put(new a.Text).text(t)},plain:function(t){return this.put(new a.Text).plain(t)}}}),a.Tspan=a.invent({create:"tspan",inherit:a.Shape,extend:{text:function(t){return null==t?this.node.textContent+(this.dom.newLined?"\n":""):("function"==typeof t?t.call(this,this):this.plain(t),this)},dx:function(t){return this.attr("dx",t)},dy:function(t){return this.attr("dy",t)},newLine:function(){var t=this.parent(a.Text);return this.dom.newLined=!0,this.dy(t.dom.leading*t.attr("font-size")).attr("x",t.x())}}}),a.extend(a.Text,a.Tspan,{plain:function(t){return!1===this._build&&this.clear(),this.node.appendChild(e.createTextNode(t)),this},tspan:function(t){var e=(this.textPath&&this.textPath()||this).node,i=new a.Tspan;return!1===this._build&&this.clear(),e.appendChild(i.node),i.text(t)},clear:function(){for(var t=(this.textPath&&this.textPath()||this).node;t.hasChildNodes();)t.removeChild(t.lastChild);return this},length:function(){return this.node.getComputedTextLength()}}),a.TextPath=a.invent({create:"textPath",inherit:a.Parent,parent:a.Text,construct:{morphArray:a.PathArray,array:function(){var t=this.track();return t?t.array():null},plot:function(t){var e=this.track(),i=null;return e&&(i=e.plot(t)),null==t?i:this},track:function(){var t=this.textPath();if(t)return t.reference("href")},textPath:function(){if(this.node.firstChild&&"textPath"==this.node.firstChild.nodeName)return a.adopt(this.node.firstChild)}}}),a.Nested=a.invent({create:function(){this.constructor.call(this,a.create("svg")),this.style("overflow","visible")},inherit:a.Container,construct:{nested:function(){return this.put(new a.Nested)}}});var l={stroke:["color","width","opacity","linecap","linejoin","miterlimit","dasharray","dashoffset"],fill:["color","opacity","rule"],prefix:function(t,e){return"color"==e?t:t+"-"+e}};function h(t,e,i,s){return i+s.replace(a.regex.dots," .")}function c(t){return t.toLowerCase().replace(/-(.)/g,(function(t,e){return e.toUpperCase()}))}function d(t){return t.charAt(0).toUpperCase()+t.slice(1)}function g(t){var e=t.toString(16);return 1==e.length?"0"+e:e}function u(t,e,i){if(null==e||null==i){var a=t.bbox();null==e?e=a.width/a.height*i:null==i&&(i=a.height/a.width*e)}return{width:e,height:i}}function p(t,e,i){return{x:e*t.a+i*t.c+0,y:e*t.b+i*t.d+0}}function f(t){return{a:t[0],b:t[1],c:t[2],d:t[3],e:t[4],f:t[5]}}function x(e){for(var i=e.childNodes.length-1;i>=0;i--)e.childNodes[i]instanceof t.SVGElement&&x(e.childNodes[i]);return a.adopt(e).id(a.eid(e.nodeName))}function b(t){return Math.abs(t)>1e-37?t:0}["fill","stroke"].forEach((function(t){var e={};e[t]=function(e){if(void 0===e)return this;if("string"==typeof e||a.Color.isRgb(e)||e&&"function"==typeof e.fill)this.attr(t,e);else for(var i=l[t].length-1;i>=0;i--)null!=e[l[t][i]]&&this.attr(l.prefix(t,l[t][i]),e[l[t][i]]);return this},a.extend(a.Element,a.FX,e)})),a.extend(a.Element,a.FX,{translate:function(t,e){return this.transform({x:t,y:e})},matrix:function(t){return this.attr("transform",new a.Matrix(6==arguments.length?[].slice.call(arguments):t))},opacity:function(t){return this.attr("opacity",t)},dx:function(t){return this.x(new a.Number(t).plus(this instanceof a.FX?0:this.x()),!0)},dy:function(t){return this.y(new a.Number(t).plus(this instanceof a.FX?0:this.y()),!0)}}),a.extend(a.Path,{length:function(){return this.node.getTotalLength()},pointAt:function(t){return this.node.getPointAtLength(t)}}),a.Set=a.invent({create:function(t){Array.isArray(t)?this.members=t:this.clear()},extend:{add:function(){for(var t=[].slice.call(arguments),e=0,i=t.length;e<i;e++)this.members.push(t[e]);return this},remove:function(t){var e=this.index(t);return e>-1&&this.members.splice(e,1),this},each:function(t){for(var e=0,i=this.members.length;e<i;e++)t.apply(this.members[e],[e,this.members]);return this},clear:function(){return this.members=[],this},length:function(){return this.members.length},has:function(t){return this.index(t)>=0},index:function(t){return this.members.indexOf(t)},get:function(t){return this.members[t]},first:function(){return this.get(0)},last:function(){return this.get(this.members.length-1)},valueOf:function(){return this.members}},construct:{set:function(t){return new a.Set(t)}}}),a.FX.Set=a.invent({create:function(t){this.set=t}}),a.Set.inherit=function(){var t=[];for(var e in a.Shape.prototype)"function"==typeof a.Shape.prototype[e]&&"function"!=typeof a.Set.prototype[e]&&t.push(e);for(var e in t.forEach((function(t){a.Set.prototype[t]=function(){for(var e=0,i=this.members.length;e<i;e++)this.members[e]&&"function"==typeof this.members[e][t]&&this.members[e][t].apply(this.members[e],arguments);return"animate"==t?this.fx||(this.fx=new a.FX.Set(this)):this}})),t=[],a.FX.prototype)"function"==typeof a.FX.prototype[e]&&"function"!=typeof a.FX.Set.prototype[e]&&t.push(e);t.forEach((function(t){a.FX.Set.prototype[t]=function(){for(var e=0,i=this.set.members.length;e<i;e++)this.set.members[e].fx[t].apply(this.set.members[e].fx,arguments);return this}}))},a.extend(a.Element,{}),a.extend(a.Element,{remember:function(t,e){if("object"===i(arguments[0]))for(var a in t)this.remember(a,t[a]);else{if(1==arguments.length)return this.memory()[t];this.memory()[t]=e}return this},forget:function(){if(0==arguments.length)this._memory={};else for(var t=arguments.length-1;t>=0;t--)delete this.memory()[arguments[t]];return this},memory:function(){return this._memory||(this._memory={})}}),a.get=function(t){var i=e.getElementById(function(t){var e=(t||"").toString().match(a.regex.reference);if(e)return e[1]}(t)||t);return a.adopt(i)},a.select=function(t,i){return new a.Set(a.utils.map((i||e).querySelectorAll(t),(function(t){return a.adopt(t)})))},a.extend(a.Parent,{select:function(t){return a.select(t,this.node)}});var v="abcdef".split("");if("function"!=typeof t.CustomEvent){var m=function(t,i){i=i||{bubbles:!1,cancelable:!1,detail:void 0};var a=e.createEvent("CustomEvent");return a.initCustomEvent(t,i.bubbles,i.cancelable,i.detail),a};m.prototype=t.Event.prototype,a.CustomEvent=m}else a.CustomEvent=t.CustomEvent;return a},"function"==typeof define&&define.amd?define((function(){return Ht(Rt,Rt.document)})):"object"===("undefined"==typeof exports?"undefined":i(exports))&&"undefined"!=typeof module?module.exports=Rt.document?Ht(Rt,Rt.document):function(t){return Ht(t,t.document)}:Rt.SVG=Ht(Rt,Rt.document),
/*! svg.filter.js - v2.0.2 - 2016-02-24
  * https://github.com/wout/svg.filter.js
  * Copyright (c) 2016 Wout Fierens; Licensed MIT */
function(){SVG.Filter=SVG.invent({create:"filter",inherit:SVG.Parent,extend:{source:"SourceGraphic",sourceAlpha:"SourceAlpha",background:"BackgroundImage",backgroundAlpha:"BackgroundAlpha",fill:"FillPaint",stroke:"StrokePaint",autoSetIn:!0,put:function(t,e){return this.add(t,e),!t.attr("in")&&this.autoSetIn&&t.attr("in",this.source),t.attr("result")||t.attr("result",t),t},blend:function(t,e,i){return this.put(new SVG.BlendEffect(t,e,i))},colorMatrix:function(t,e){return this.put(new SVG.ColorMatrixEffect(t,e))},convolveMatrix:function(t){return this.put(new SVG.ConvolveMatrixEffect(t))},componentTransfer:function(t){return this.put(new SVG.ComponentTransferEffect(t))},composite:function(t,e,i){return this.put(new SVG.CompositeEffect(t,e,i))},flood:function(t,e){return this.put(new SVG.FloodEffect(t,e))},offset:function(t,e){return this.put(new SVG.OffsetEffect(t,e))},image:function(t){return this.put(new SVG.ImageEffect(t))},merge:function(){var t=[void 0];for(var e in arguments)t.push(arguments[e]);return this.put(new(SVG.MergeEffect.bind.apply(SVG.MergeEffect,t)))},gaussianBlur:function(t,e){return this.put(new SVG.GaussianBlurEffect(t,e))},morphology:function(t,e){return this.put(new SVG.MorphologyEffect(t,e))},diffuseLighting:function(t,e,i){return this.put(new SVG.DiffuseLightingEffect(t,e,i))},displacementMap:function(t,e,i,a,s){return this.put(new SVG.DisplacementMapEffect(t,e,i,a,s))},specularLighting:function(t,e,i,a){return this.put(new SVG.SpecularLightingEffect(t,e,i,a))},tile:function(){return this.put(new SVG.TileEffect)},turbulence:function(t,e,i,a,s){return this.put(new SVG.TurbulenceEffect(t,e,i,a,s))},toString:function(){return"url(#"+this.attr("id")+")"}}}),SVG.extend(SVG.Defs,{filter:function(t){var e=this.put(new SVG.Filter);return"function"==typeof t&&t.call(e,e),e}}),SVG.extend(SVG.Container,{filter:function(t){return this.defs().filter(t)}}),SVG.extend(SVG.Element,SVG.G,SVG.Nested,{filter:function(t){return this.filterer=t instanceof SVG.Element?t:this.doc().filter(t),this.doc()&&this.filterer.doc()!==this.doc()&&this.doc().defs().add(this.filterer),this.attr("filter",this.filterer),this.filterer},unfilter:function(t){return this.filterer&&!0===t&&this.filterer.remove(),delete this.filterer,this.attr("filter",null)}}),SVG.Effect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Element,extend:{in:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in")+'"]').get(0)||this.attr("in"):this.attr("in",t)},result:function(t){return null==t?this.attr("result"):this.attr("result",t)},toString:function(){return this.result()}}}),SVG.ParentEffect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Parent,extend:{in:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in")+'"]').get(0)||this.attr("in"):this.attr("in",t)},result:function(t){return null==t?this.attr("result"):this.attr("result",t)},toString:function(){return this.result()}}});var t={blend:function(t,e){return this.parent()&&this.parent().blend(this,t,e)},colorMatrix:function(t,e){return this.parent()&&this.parent().colorMatrix(t,e).in(this)},convolveMatrix:function(t){return this.parent()&&this.parent().convolveMatrix(t).in(this)},componentTransfer:function(t){return this.parent()&&this.parent().componentTransfer(t).in(this)},composite:function(t,e){return this.parent()&&this.parent().composite(this,t,e)},flood:function(t,e){return this.parent()&&this.parent().flood(t,e)},offset:function(t,e){return this.parent()&&this.parent().offset(t,e).in(this)},image:function(t){return this.parent()&&this.parent().image(t)},merge:function(){return this.parent()&&this.parent().merge.apply(this.parent(),[this].concat(arguments))},gaussianBlur:function(t,e){return this.parent()&&this.parent().gaussianBlur(t,e).in(this)},morphology:function(t,e){return this.parent()&&this.parent().morphology(t,e).in(this)},diffuseLighting:function(t,e,i){return this.parent()&&this.parent().diffuseLighting(t,e,i).in(this)},displacementMap:function(t,e,i,a){return this.parent()&&this.parent().displacementMap(this,t,e,i,a)},specularLighting:function(t,e,i,a){return this.parent()&&this.parent().specularLighting(t,e,i,a).in(this)},tile:function(){return this.parent()&&this.parent().tile().in(this)},turbulence:function(t,e,i,a,s){return this.parent()&&this.parent().turbulence(t,e,i,a,s).in(this)}};SVG.extend(SVG.Effect,t),SVG.extend(SVG.ParentEffect,t),SVG.ChildEffect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Element,extend:{in:function(t){this.attr("in",t)}}});var e={blend:function(t,e,i){this.attr({in:t,in2:e,mode:i||"normal"})},colorMatrix:function(t,e){"matrix"==t&&(e=s(e)),this.attr({type:t,values:void 0===e?null:e})},convolveMatrix:function(t){t=s(t),this.attr({order:Math.sqrt(t.split(" ").length),kernelMatrix:t})},composite:function(t,e,i){this.attr({in:t,in2:e,operator:i})},flood:function(t,e){this.attr("flood-color",t),null!=e&&this.attr("flood-opacity",e)},offset:function(t,e){this.attr({dx:t,dy:e})},image:function(t){this.attr("href",t,SVG.xlink)},displacementMap:function(t,e,i,a,s){this.attr({in:t,in2:e,scale:i,xChannelSelector:a,yChannelSelector:s})},gaussianBlur:function(t,e){null!=t||null!=e?this.attr("stdDeviation",function(t){if(!Array.isArray(t))return t;for(var e=0,i=t.length,a=[];e<i;e++)a.push(t[e]);return a.join(" ")}(Array.prototype.slice.call(arguments))):this.attr("stdDeviation","0 0")},morphology:function(t,e){this.attr({operator:t,radius:e})},tile:function(){},turbulence:function(t,e,i,a,s){this.attr({numOctaves:e,seed:i,stitchTiles:a,baseFrequency:t,type:s})}},i={merge:function(){var t;if(arguments[0]instanceof SVG.Set){var e=this;arguments[0].each((function(t){this instanceof SVG.MergeNode?e.put(this):(this instanceof SVG.Effect||this instanceof SVG.ParentEffect)&&e.put(new SVG.MergeNode(this))}))}else{t=Array.isArray(arguments[0])?arguments[0]:arguments;for(var i=0;i<t.length;i++)t[i]instanceof SVG.MergeNode?this.put(t[i]):this.put(new SVG.MergeNode(t[i]))}},componentTransfer:function(t){if(this.rgb=new SVG.Set,["r","g","b","a"].forEach(function(t){this[t]=new(SVG["Func"+t.toUpperCase()])("identity"),this.rgb.add(this[t]),this.node.appendChild(this[t].node)}.bind(this)),t)for(var e in t.rgb&&(["r","g","b"].forEach(function(e){this[e].attr(t.rgb)}.bind(this)),delete t.rgb),t)this[e].attr(t[e])},diffuseLighting:function(t,e,i){this.attr({surfaceScale:t,diffuseConstant:e,kernelUnitLength:i})},specularLighting:function(t,e,i,a){this.attr({surfaceScale:t,diffuseConstant:e,specularExponent:i,kernelUnitLength:a})}},a={distantLight:function(t,e){this.attr({azimuth:t,elevation:e})},pointLight:function(t,e,i){this.attr({x:t,y:e,z:i})},spotLight:function(t,e,i,a,s,r){this.attr({x:t,y:e,z:i,pointsAtX:a,pointsAtY:s,pointsAtZ:r})},mergeNode:function(t){this.attr("in",t)}};function s(t){return Array.isArray(t)&&(t=new SVG.Array(t)),t.toString().replace(/^\s+/,"").replace(/\s+$/,"").replace(/\s+/g," ")}function r(){var t=function(){};for(var e in"function"==typeof arguments[arguments.length-1]&&(t=arguments[arguments.length-1],Array.prototype.splice.call(arguments,arguments.length-1,1)),arguments)for(var i in arguments[e])t(arguments[e][i],i,arguments[e])}["r","g","b","a"].forEach((function(t){a["Func"+t.toUpperCase()]=function(t){switch(this.attr("type",t),t){case"table":this.attr("tableValues",arguments[1]);break;case"linear":this.attr("slope",arguments[1]),this.attr("intercept",arguments[2]);break;case"gamma":this.attr("amplitude",arguments[1]),this.attr("exponent",arguments[2]),this.attr("offset",arguments[2])}}})),r(e,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i+"Effect"]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments),this.result(this.attr("id")+"Out")},inherit:SVG.Effect,extend:{}})})),r(i,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i+"Effect"]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments),this.result(this.attr("id")+"Out")},inherit:SVG.ParentEffect,extend:{}})})),r(a,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments)},inherit:SVG.ChildEffect,extend:{}})})),SVG.extend(SVG.MergeEffect,{in:function(t){return t instanceof SVG.MergeNode?this.add(t,0):this.add(new SVG.MergeNode(t),0),this}}),SVG.extend(SVG.CompositeEffect,SVG.BlendEffect,SVG.DisplacementMapEffect,{in2:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in2")+'"]').get(0)||this.attr("in2"):this.attr("in2",t)}}),SVG.filter={sepiatone:[.343,.669,.119,0,0,.249,.626,.13,0,0,.172,.334,.111,0,0,0,0,0,1,0]}}.call(void 0),function(){function t(t,s,r,o,n,l,h){for(var c=t.slice(s,r||h),d=o.slice(n,l||h),g=0,u={pos:[0,0],start:[0,0]},p={pos:[0,0],start:[0,0]};;){if(c[g]=e.call(u,c[g]),d[g]=e.call(p,d[g]),c[g][0]!=d[g][0]||"M"==c[g][0]||"A"==c[g][0]&&(c[g][4]!=d[g][4]||c[g][5]!=d[g][5])?(Array.prototype.splice.apply(c,[g,1].concat(a.call(u,c[g]))),Array.prototype.splice.apply(d,[g,1].concat(a.call(p,d[g])))):(c[g]=i.call(u,c[g]),d[g]=i.call(p,d[g])),++g==c.length&&g==d.length)break;g==c.length&&c.push(["C",u.pos[0],u.pos[1],u.pos[0],u.pos[1],u.pos[0],u.pos[1]]),g==d.length&&d.push(["C",p.pos[0],p.pos[1],p.pos[0],p.pos[1],p.pos[0],p.pos[1]])}return{start:c,dest:d}}function e(t){switch(t[0]){case"z":case"Z":t[0]="L",t[1]=this.start[0],t[2]=this.start[1];break;case"H":t[0]="L",t[2]=this.pos[1];break;case"V":t[0]="L",t[2]=t[1],t[1]=this.pos[0];break;case"T":t[0]="Q",t[3]=t[1],t[4]=t[2],t[1]=this.reflection[1],t[2]=this.reflection[0];break;case"S":t[0]="C",t[6]=t[4],t[5]=t[3],t[4]=t[2],t[3]=t[1],t[2]=this.reflection[1],t[1]=this.reflection[0]}return t}function i(t){var e=t.length;return this.pos=[t[e-2],t[e-1]],-1!="SCQT".indexOf(t[0])&&(this.reflection=[2*this.pos[0]-t[e-4],2*this.pos[1]-t[e-3]]),t}function a(t){var e=[t];switch(t[0]){case"M":return this.pos=this.start=[t[1],t[2]],e;case"L":t[5]=t[3]=t[1],t[6]=t[4]=t[2],t[1]=this.pos[0],t[2]=this.pos[1];break;case"Q":t[6]=t[4],t[5]=t[3],t[4]=1*t[4]/3+2*t[2]/3,t[3]=1*t[3]/3+2*t[1]/3,t[2]=1*this.pos[1]/3+2*t[2]/3,t[1]=1*this.pos[0]/3+2*t[1]/3;break;case"A":e=function(t,e){var i,a,s,r,o,n,l,h,c,d,g,u,p,f,x,b,v,m,y,w,k,A,S,C,L,P,M=Math.abs(e[1]),I=Math.abs(e[2]),T=e[3]%360,z=e[4],X=e[5],E=e[6],Y=e[7],F=new SVG.Point(t),R=new SVG.Point(E,Y),H=[];if(0===M||0===I||F.x===R.x&&F.y===R.y)return[["C",F.x,F.y,R.x,R.y,R.x,R.y]];i=new SVG.Point((F.x-R.x)/2,(F.y-R.y)/2).transform((new SVG.Matrix).rotate(T)),(a=i.x*i.x/(M*M)+i.y*i.y/(I*I))>1&&(M*=a=Math.sqrt(a),I*=a);s=(new SVG.Matrix).rotate(T).scale(1/M,1/I).rotate(-T),F=F.transform(s),R=R.transform(s),r=[R.x-F.x,R.y-F.y],n=r[0]*r[0]+r[1]*r[1],o=Math.sqrt(n),r[0]/=o,r[1]/=o,l=n<4?Math.sqrt(1-n/4):0,z===X&&(l*=-1);h=new SVG.Point((R.x+F.x)/2+l*-r[1],(R.y+F.y)/2+l*r[0]),c=new SVG.Point(F.x-h.x,F.y-h.y),d=new SVG.Point(R.x-h.x,R.y-h.y),g=Math.acos(c.x/Math.sqrt(c.x*c.x+c.y*c.y)),c.y<0&&(g*=-1);u=Math.acos(d.x/Math.sqrt(d.x*d.x+d.y*d.y)),d.y<0&&(u*=-1);X&&g>u&&(u+=2*Math.PI);!X&&g<u&&(u-=2*Math.PI);for(f=Math.ceil(2*Math.abs(g-u)/Math.PI),b=[],v=g,p=(u-g)/f,x=4*Math.tan(p/4)/3,k=0;k<=f;k++)y=Math.cos(v),m=Math.sin(v),w=new SVG.Point(h.x+y,h.y+m),b[k]=[new SVG.Point(w.x+x*m,w.y-x*y),w,new SVG.Point(w.x-x*m,w.y+x*y)],v+=p;for(b[0][0]=b[0][1].clone(),b[b.length-1][2]=b[b.length-1][1].clone(),s=(new SVG.Matrix).rotate(T).scale(M,I).rotate(-T),k=0,A=b.length;k<A;k++)b[k][0]=b[k][0].transform(s),b[k][1]=b[k][1].transform(s),b[k][2]=b[k][2].transform(s);for(k=1,A=b.length;k<A;k++)S=(w=b[k-1][2]).x,C=w.y,L=(w=b[k][0]).x,P=w.y,E=(w=b[k][1]).x,Y=w.y,H.push(["C",S,C,L,P,E,Y]);return H}(this.pos,t),t=e[0]}return t[0]="C",this.pos=[t[5],t[6]],this.reflection=[2*t[5]-t[3],2*t[6]-t[4]],e}function s(t,e){if(!1===e)return!1;for(var i=e,a=t.length;i<a;++i)if("M"==t[i][0])return i;return!1}SVG.extend(SVG.PathArray,{morph:function(e){for(var i=this.value,a=this.parse(e),r=0,o=0,n=!1,l=!1;!1!==r||!1!==o;){var h;n=s(i,!1!==r&&r+1),l=s(a,!1!==o&&o+1),!1===r&&(r=0==(h=new SVG.PathArray(c.start).bbox()).height||0==h.width?i.push(i[0])-1:i.push(["M",h.x+h.width/2,h.y+h.height/2])-1),!1===o&&(o=0==(h=new SVG.PathArray(c.dest).bbox()).height||0==h.width?a.push(a[0])-1:a.push(["M",h.x+h.width/2,h.y+h.height/2])-1);var c=t(i,r,n,a,o,l);i=i.slice(0,r).concat(c.start,!1===n?[]:i.slice(n)),a=a.slice(0,o).concat(c.dest,!1===l?[]:a.slice(l)),r=!1!==n&&r+c.start.length,o=!1!==l&&o+c.dest.length}return this.value=i,this.destination=new SVG.PathArray,this.destination.value=a,this}})}(),
/*! svg.draggable.js - v2.2.2 - 2019-01-08
  * https://github.com/svgdotjs/svg.draggable.js
  * Copyright (c) 2019 Wout Fierens; Licensed MIT */
function(){function t(t){t.remember("_draggable",this),this.el=t}t.prototype.init=function(t,e){var i=this;this.constraint=t,this.value=e,this.el.on("mousedown.drag",(function(t){i.start(t)})),this.el.on("touchstart.drag",(function(t){i.start(t)}))},t.prototype.transformPoint=function(t,e){var i=(t=t||window.event).changedTouches&&t.changedTouches[0]||t;return this.p.x=i.clientX-(e||0),this.p.y=i.clientY,this.p.matrixTransform(this.m)},t.prototype.getBBox=function(){var t=this.el.bbox();return this.el instanceof SVG.Nested&&(t=this.el.rbox()),(this.el instanceof SVG.G||this.el instanceof SVG.Use||this.el instanceof SVG.Nested)&&(t.x=this.el.x(),t.y=this.el.y()),t},t.prototype.start=function(t){if("click"!=t.type&&"mousedown"!=t.type&&"mousemove"!=t.type||1==(t.which||t.buttons)){var e=this;if(this.el.fire("beforedrag",{event:t,handler:this}),!this.el.event().defaultPrevented){t.preventDefault(),t.stopPropagation(),this.parent=this.parent||this.el.parent(SVG.Nested)||this.el.parent(SVG.Doc),this.p=this.parent.node.createSVGPoint(),this.m=this.el.node.getScreenCTM().inverse();var i,a=this.getBBox();if(this.el instanceof SVG.Text)switch(i=this.el.node.getComputedTextLength(),this.el.attr("text-anchor")){case"middle":i/=2;break;case"start":i=0}this.startPoints={point:this.transformPoint(t,i),box:a,transform:this.el.transform()},SVG.on(window,"mousemove.drag",(function(t){e.drag(t)})),SVG.on(window,"touchmove.drag",(function(t){e.drag(t)})),SVG.on(window,"mouseup.drag",(function(t){e.end(t)})),SVG.on(window,"touchend.drag",(function(t){e.end(t)})),this.el.fire("dragstart",{event:t,p:this.startPoints.point,m:this.m,handler:this})}}},t.prototype.drag=function(t){var e=this.getBBox(),i=this.transformPoint(t),a=this.startPoints.box.x+i.x-this.startPoints.point.x,s=this.startPoints.box.y+i.y-this.startPoints.point.y,r=this.constraint,o=i.x-this.startPoints.point.x,n=i.y-this.startPoints.point.y;if(this.el.fire("dragmove",{event:t,p:i,m:this.m,handler:this}),this.el.event().defaultPrevented)return i;if("function"==typeof r){var l=r.call(this.el,a,s,this.m);"boolean"==typeof l&&(l={x:l,y:l}),!0===l.x?this.el.x(a):!1!==l.x&&this.el.x(l.x),!0===l.y?this.el.y(s):!1!==l.y&&this.el.y(l.y)}else"object"==typeof r&&(null!=r.minX&&a<r.minX?o=(a=r.minX)-this.startPoints.box.x:null!=r.maxX&&a>r.maxX-e.width&&(o=(a=r.maxX-e.width)-this.startPoints.box.x),null!=r.minY&&s<r.minY?n=(s=r.minY)-this.startPoints.box.y:null!=r.maxY&&s>r.maxY-e.height&&(n=(s=r.maxY-e.height)-this.startPoints.box.y),null!=r.snapToGrid&&(a-=a%r.snapToGrid,s-=s%r.snapToGrid,o-=o%r.snapToGrid,n-=n%r.snapToGrid),this.el instanceof SVG.G?this.el.matrix(this.startPoints.transform).transform({x:o,y:n},!0):this.el.move(a,s));return i},t.prototype.end=function(t){var e=this.drag(t);this.el.fire("dragend",{event:t,p:e,m:this.m,handler:this}),SVG.off(window,"mousemove.drag"),SVG.off(window,"touchmove.drag"),SVG.off(window,"mouseup.drag"),SVG.off(window,"touchend.drag")},SVG.extend(SVG.Element,{draggable:function(e,i){"function"!=typeof e&&"object"!=typeof e||(i=e,e=!0);var a=this.remember("_draggable")||new t(this);return(e=void 0===e||e)?a.init(i||{},e):(this.off("mousedown.drag"),this.off("touchstart.drag")),this}})}.call(void 0),function(){function t(t){this.el=t,t.remember("_selectHandler",this),this.pointSelection={isSelected:!1},this.rectSelection={isSelected:!1},this.pointsList={lt:[0,0],rt:["width",0],rb:["width","height"],lb:[0,"height"],t:["width",0],r:["width","height"],b:["width","height"],l:[0,"height"]},this.pointCoord=function(t,e,i){var a="string"!=typeof t?t:e[t];return i?a/2:a},this.pointCoords=function(t,e){var i=this.pointsList[t];return{x:this.pointCoord(i[0],e,"t"===t||"b"===t),y:this.pointCoord(i[1],e,"r"===t||"l"===t)}}}t.prototype.init=function(t,e){var i=this.el.bbox();this.options={};var a=this.el.selectize.defaults.points;for(var s in this.el.selectize.defaults)this.options[s]=this.el.selectize.defaults[s],void 0!==e[s]&&(this.options[s]=e[s]);var r=["points","pointsExclude"];for(var s in r){var o=this.options[r[s]];"string"==typeof o?o=o.length>0?o.split(/\s*,\s*/i):[]:"boolean"==typeof o&&"points"===r[s]&&(o=o?a:[]),this.options[r[s]]=o}this.options.points=[a,this.options.points].reduce((function(t,e){return t.filter((function(t){return e.indexOf(t)>-1}))})),this.options.points=[this.options.points,this.options.pointsExclude].reduce((function(t,e){return t.filter((function(t){return e.indexOf(t)<0}))})),this.parent=this.el.parent(),this.nested=this.nested||this.parent.group(),this.nested.matrix(new SVG.Matrix(this.el).translate(i.x,i.y)),this.options.deepSelect&&-1!==["line","polyline","polygon"].indexOf(this.el.type)?this.selectPoints(t):this.selectRect(t),this.observe(),this.cleanup()},t.prototype.selectPoints=function(t){return this.pointSelection.isSelected=t,this.pointSelection.set||(this.pointSelection.set=this.parent.set(),this.drawPoints()),this},t.prototype.getPointArray=function(){var t=this.el.bbox();return this.el.array().valueOf().map((function(e){return[e[0]-t.x,e[1]-t.y]}))},t.prototype.drawPoints=function(){for(var t=this,e=this.getPointArray(),i=0,a=e.length;i<a;++i){var s=function(e){return function(i){(i=i||window.event).preventDefault?i.preventDefault():i.returnValue=!1,i.stopPropagation();var a=i.pageX||i.touches[0].pageX,s=i.pageY||i.touches[0].pageY;t.el.fire("point",{x:a,y:s,i:e,event:i})}}(i),r=this.drawPoint(e[i][0],e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints+"_point").on("touchstart",s).on("mousedown",s);this.pointSelection.set.add(r)}},t.prototype.drawPoint=function(t,e){var i=this.options.pointType;switch(i){case"circle":return this.drawCircle(t,e);case"rect":return this.drawRect(t,e);default:if("function"==typeof i)return i.call(this,t,e);throw new Error("Unknown "+i+" point type!")}},t.prototype.drawCircle=function(t,e){return this.nested.circle(this.options.pointSize).center(t,e)},t.prototype.drawRect=function(t,e){return this.nested.rect(this.options.pointSize,this.options.pointSize).center(t,e)},t.prototype.updatePointSelection=function(){var t=this.getPointArray();this.pointSelection.set.each((function(e){this.cx()===t[e][0]&&this.cy()===t[e][1]||this.center(t[e][0],t[e][1])}))},t.prototype.updateRectSelection=function(){var t=this,e=this.el.bbox();if(this.rectSelection.set.get(0).attr({width:e.width,height:e.height}),this.options.points.length&&this.options.points.map((function(i,a){var s=t.pointCoords(i,e);t.rectSelection.set.get(a+1).center(s.x,s.y)})),this.options.rotationPoint){var i=this.rectSelection.set.length();this.rectSelection.set.get(i-1).center(e.width/2,20)}},t.prototype.selectRect=function(t){var e=this,i=this.el.bbox();function a(t){return function(i){(i=i||window.event).preventDefault?i.preventDefault():i.returnValue=!1,i.stopPropagation();var a=i.pageX||i.touches[0].pageX,s=i.pageY||i.touches[0].pageY;e.el.fire(t,{x:a,y:s,event:i})}}if(this.rectSelection.isSelected=t,this.rectSelection.set=this.rectSelection.set||this.parent.set(),this.rectSelection.set.get(0)||this.rectSelection.set.add(this.nested.rect(i.width,i.height).addClass(this.options.classRect)),this.options.points.length&&this.rectSelection.set.length()<2){this.options.points.map((function(t,s){var r=e.pointCoords(t,i),o=e.drawPoint(r.x,r.y).attr("class",e.options.classPoints+"_"+t).on("mousedown",a(t)).on("touchstart",a(t));e.rectSelection.set.add(o)})),this.rectSelection.set.each((function(){this.addClass(e.options.classPoints)}))}if(this.options.rotationPoint&&(this.options.points&&!this.rectSelection.set.get(9)||!this.options.points&&!this.rectSelection.set.get(1))){var s=function(t){(t=t||window.event).preventDefault?t.preventDefault():t.returnValue=!1,t.stopPropagation();var i=t.pageX||t.touches[0].pageX,a=t.pageY||t.touches[0].pageY;e.el.fire("rot",{x:i,y:a,event:t})},r=this.drawPoint(i.width/2,20).attr("class",this.options.classPoints+"_rot").on("touchstart",s).on("mousedown",s);this.rectSelection.set.add(r)}},t.prototype.handler=function(){var t=this.el.bbox();this.nested.matrix(new SVG.Matrix(this.el).translate(t.x,t.y)),this.rectSelection.isSelected&&this.updateRectSelection(),this.pointSelection.isSelected&&this.updatePointSelection()},t.prototype.observe=function(){var t=this;if(MutationObserver)if(this.rectSelection.isSelected||this.pointSelection.isSelected)this.observerInst=this.observerInst||new MutationObserver((function(){t.handler()})),this.observerInst.observe(this.el.node,{attributes:!0});else try{this.observerInst.disconnect(),delete this.observerInst}catch(t){}else this.el.off("DOMAttrModified.select"),(this.rectSelection.isSelected||this.pointSelection.isSelected)&&this.el.on("DOMAttrModified.select",(function(){t.handler()}))},t.prototype.cleanup=function(){!this.rectSelection.isSelected&&this.rectSelection.set&&(this.rectSelection.set.each((function(){this.remove()})),this.rectSelection.set.clear(),delete this.rectSelection.set),!this.pointSelection.isSelected&&this.pointSelection.set&&(this.pointSelection.set.each((function(){this.remove()})),this.pointSelection.set.clear(),delete this.pointSelection.set),this.pointSelection.isSelected||this.rectSelection.isSelected||(this.nested.remove(),delete this.nested)},SVG.extend(SVG.Element,{selectize:function(e,i){return"object"==typeof e&&(i=e,e=!0),(this.remember("_selectHandler")||new t(this)).init(void 0===e||e,i||{}),this}}),SVG.Element.prototype.selectize.defaults={points:["lt","rt","rb","lb","t","r","b","l"],pointsExclude:[],classRect:"svg_select_boundingRect",classPoints:"svg_select_points",pointSize:7,rotationPoint:!0,deepSelect:!1,pointType:"circle"}}(),function(){(function(){function t(t){t.remember("_resizeHandler",this),this.el=t,this.parameters={},this.lastUpdateCall=null,this.p=t.doc().node.createSVGPoint()}t.prototype.transformPoint=function(t,e,i){return this.p.x=t-(this.offset.x-window.pageXOffset),this.p.y=e-(this.offset.y-window.pageYOffset),this.p.matrixTransform(i||this.m)},t.prototype._extractPosition=function(t){return{x:null!=t.clientX?t.clientX:t.touches[0].clientX,y:null!=t.clientY?t.clientY:t.touches[0].clientY}},t.prototype.init=function(t){var e=this;if(this.stop(),"stop"!==t){for(var i in this.options={},this.el.resize.defaults)this.options[i]=this.el.resize.defaults[i],void 0!==t[i]&&(this.options[i]=t[i]);this.el.on("lt.resize",(function(t){e.resize(t||window.event)})),this.el.on("rt.resize",(function(t){e.resize(t||window.event)})),this.el.on("rb.resize",(function(t){e.resize(t||window.event)})),this.el.on("lb.resize",(function(t){e.resize(t||window.event)})),this.el.on("t.resize",(function(t){e.resize(t||window.event)})),this.el.on("r.resize",(function(t){e.resize(t||window.event)})),this.el.on("b.resize",(function(t){e.resize(t||window.event)})),this.el.on("l.resize",(function(t){e.resize(t||window.event)})),this.el.on("rot.resize",(function(t){e.resize(t||window.event)})),this.el.on("point.resize",(function(t){e.resize(t||window.event)})),this.update()}},t.prototype.stop=function(){return this.el.off("lt.resize"),this.el.off("rt.resize"),this.el.off("rb.resize"),this.el.off("lb.resize"),this.el.off("t.resize"),this.el.off("r.resize"),this.el.off("b.resize"),this.el.off("l.resize"),this.el.off("rot.resize"),this.el.off("point.resize"),this},t.prototype.resize=function(t){var e=this;this.m=this.el.node.getScreenCTM().inverse(),this.offset={x:window.pageXOffset,y:window.pageYOffset};var i=this._extractPosition(t.detail.event);if(this.parameters={type:this.el.type,p:this.transformPoint(i.x,i.y),x:t.detail.x,y:t.detail.y,box:this.el.bbox(),rotation:this.el.transform().rotation},"text"===this.el.type&&(this.parameters.fontSize=this.el.attr()["font-size"]),void 0!==t.detail.i){var a=this.el.array().valueOf();this.parameters.i=t.detail.i,this.parameters.pointCoords=[a[t.detail.i][0],a[t.detail.i][1]]}switch(t.type){case"lt":this.calc=function(t,e){var i=this.snapToGrid(t,e);if(this.parameters.box.width-i[0]>0&&this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x+i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize-i[0]);i=this.checkAspectRatio(i),this.el.move(this.parameters.box.x+i[0],this.parameters.box.y+i[1]).size(this.parameters.box.width-i[0],this.parameters.box.height-i[1])}};break;case"rt":this.calc=function(t,e){var i=this.snapToGrid(t,e,2);if(this.parameters.box.width+i[0]>0&&this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x-i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize+i[0]);i=this.checkAspectRatio(i,!0),this.el.move(this.parameters.box.x,this.parameters.box.y+i[1]).size(this.parameters.box.width+i[0],this.parameters.box.height-i[1])}};break;case"rb":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.width+i[0]>0&&this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x-i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize+i[0]);i=this.checkAspectRatio(i),this.el.move(this.parameters.box.x,this.parameters.box.y).size(this.parameters.box.width+i[0],this.parameters.box.height+i[1])}};break;case"lb":this.calc=function(t,e){var i=this.snapToGrid(t,e,1);if(this.parameters.box.width-i[0]>0&&this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x+i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize-i[0]);i=this.checkAspectRatio(i,!0),this.el.move(this.parameters.box.x+i[0],this.parameters.box.y).size(this.parameters.box.width-i[0],this.parameters.box.height+i[1])}};break;case"t":this.calc=function(t,e){var i=this.snapToGrid(t,e,2);if(this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y+i[1]).height(this.parameters.box.height-i[1])}};break;case"r":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.width+i[0]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y).width(this.parameters.box.width+i[0])}};break;case"b":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y).height(this.parameters.box.height+i[1])}};break;case"l":this.calc=function(t,e){var i=this.snapToGrid(t,e,1);if(this.parameters.box.width-i[0]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x+i[0],this.parameters.box.y).width(this.parameters.box.width-i[0])}};break;case"rot":this.calc=function(t,e){var i=t+this.parameters.p.x,a=e+this.parameters.p.y,s=Math.atan2(this.parameters.p.y-this.parameters.box.y-this.parameters.box.height/2,this.parameters.p.x-this.parameters.box.x-this.parameters.box.width/2),r=Math.atan2(a-this.parameters.box.y-this.parameters.box.height/2,i-this.parameters.box.x-this.parameters.box.width/2),o=this.parameters.rotation+180*(r-s)/Math.PI+this.options.snapToAngle/2;this.el.center(this.parameters.box.cx,this.parameters.box.cy).rotate(o-o%this.options.snapToAngle,this.parameters.box.cx,this.parameters.box.cy)};break;case"point":this.calc=function(t,e){var i=this.snapToGrid(t,e,this.parameters.pointCoords[0],this.parameters.pointCoords[1]),a=this.el.array().valueOf();a[this.parameters.i][0]=this.parameters.pointCoords[0]+i[0],a[this.parameters.i][1]=this.parameters.pointCoords[1]+i[1],this.el.plot(a)}}this.el.fire("resizestart",{dx:this.parameters.x,dy:this.parameters.y,event:t}),SVG.on(window,"touchmove.resize",(function(t){e.update(t||window.event)})),SVG.on(window,"touchend.resize",(function(){e.done()})),SVG.on(window,"mousemove.resize",(function(t){e.update(t||window.event)})),SVG.on(window,"mouseup.resize",(function(){e.done()}))},t.prototype.update=function(t){if(t){var e=this._extractPosition(t),i=this.transformPoint(e.x,e.y),a=i.x-this.parameters.p.x,s=i.y-this.parameters.p.y;this.lastUpdateCall=[a,s],this.calc(a,s),this.el.fire("resizing",{dx:a,dy:s,event:t})}else this.lastUpdateCall&&this.calc(this.lastUpdateCall[0],this.lastUpdateCall[1])},t.prototype.done=function(){this.lastUpdateCall=null,SVG.off(window,"mousemove.resize"),SVG.off(window,"mouseup.resize"),SVG.off(window,"touchmove.resize"),SVG.off(window,"touchend.resize"),this.el.fire("resizedone")},t.prototype.snapToGrid=function(t,e,i,a){var s;return void 0!==a?s=[(i+t)%this.options.snapToGrid,(a+e)%this.options.snapToGrid]:(i=null==i?3:i,s=[(this.parameters.box.x+t+(1&i?0:this.parameters.box.width))%this.options.snapToGrid,(this.parameters.box.y+e+(2&i?0:this.parameters.box.height))%this.options.snapToGrid]),t<0&&(s[0]-=this.options.snapToGrid),e<0&&(s[1]-=this.options.snapToGrid),t-=Math.abs(s[0])<this.options.snapToGrid/2?s[0]:s[0]-(t<0?-this.options.snapToGrid:this.options.snapToGrid),e-=Math.abs(s[1])<this.options.snapToGrid/2?s[1]:s[1]-(e<0?-this.options.snapToGrid:this.options.snapToGrid),this.constraintToBox(t,e,i,a)},t.prototype.constraintToBox=function(t,e,i,a){var s,r,o=this.options.constraint||{};return void 0!==a?(s=i,r=a):(s=this.parameters.box.x+(1&i?0:this.parameters.box.width),r=this.parameters.box.y+(2&i?0:this.parameters.box.height)),void 0!==o.minX&&s+t<o.minX&&(t=o.minX-s),void 0!==o.maxX&&s+t>o.maxX&&(t=o.maxX-s),void 0!==o.minY&&r+e<o.minY&&(e=o.minY-r),void 0!==o.maxY&&r+e>o.maxY&&(e=o.maxY-r),[t,e]},t.prototype.checkAspectRatio=function(t,e){if(!this.options.saveAspectRatio)return t;var i=t.slice(),a=this.parameters.box.width/this.parameters.box.height,s=this.parameters.box.width+t[0],r=this.parameters.box.height-t[1],o=s/r;return o<a?(i[1]=s/a-this.parameters.box.height,e&&(i[1]=-i[1])):o>a&&(i[0]=this.parameters.box.width-r*a,e&&(i[0]=-i[0])),i},SVG.extend(SVG.Element,{resize:function(e){return(this.remember("_resizeHandler")||new t(this)).init(e||{}),this}}),SVG.Element.prototype.resize.defaults={snapToAngle:.1,snapToGrid:1,constraint:{},saveAspectRatio:!1}}).call(this)}(),void 0===window.Apex&&(window.Apex={});var Gt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"initModules",value:function(){this.ctx.publicMethods=["updateOptions","updateSeries","appendData","appendSeries","isSeriesHidden","toggleSeries","showSeries","hideSeries","setLocale","resetSeries","zoomX","toggleDataPointSelection","dataURI","exportToCSV","addXaxisAnnotation","addYaxisAnnotation","addPointAnnotation","clearAnnotations","removeAnnotation","paper","destroy"],this.ctx.eventList=["click","mousedown","mousemove","mouseleave","touchstart","touchmove","touchleave","mouseup","touchend"],this.ctx.animations=new b(this.ctx),this.ctx.axes=new J(this.ctx),this.ctx.core=new Wt(this.ctx.el,this.ctx),this.ctx.config=new Y({}),this.ctx.data=new B(this.ctx),this.ctx.grid=new j(this.ctx),this.ctx.graphics=new m(this.ctx),this.ctx.coreUtils=new y(this.ctx),this.ctx.crosshairs=new Q(this.ctx),this.ctx.events=new Z(this.ctx),this.ctx.exports=new G(this.ctx),this.ctx.localization=new $(this.ctx),this.ctx.options=new I,this.ctx.responsive=new K(this.ctx),this.ctx.series=new W(this.ctx),this.ctx.theme=new tt(this.ctx),this.ctx.formatters=new S(this.ctx),this.ctx.titleSubtitle=new et(this.ctx),this.ctx.legend=new lt(this.ctx),this.ctx.toolbar=new ht(this.ctx),this.ctx.tooltip=new bt(this.ctx),this.ctx.dimensions=new ot(this.ctx),this.ctx.updateHelpers=new Bt(this.ctx),this.ctx.zoomPanSelection=new ct(this.ctx),this.ctx.w.globals.tooltip=new bt(this.ctx)}}]),t}(),Vt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"clear",value:function(t){var e=t.isUpdating;this.ctx.zoomPanSelection&&this.ctx.zoomPanSelection.destroy(),this.ctx.toolbar&&this.ctx.toolbar.destroy(),this.ctx.animations=null,this.ctx.axes=null,this.ctx.annotations=null,this.ctx.core=null,this.ctx.data=null,this.ctx.grid=null,this.ctx.series=null,this.ctx.responsive=null,this.ctx.theme=null,this.ctx.formatters=null,this.ctx.titleSubtitle=null,this.ctx.legend=null,this.ctx.dimensions=null,this.ctx.options=null,this.ctx.crosshairs=null,this.ctx.zoomPanSelection=null,this.ctx.updateHelpers=null,this.ctx.toolbar=null,this.ctx.localization=null,this.ctx.w.globals.tooltip=null,this.clearDomElements({isUpdating:e})}},{key:"killSVG",value:function(t){t.each((function(t,e){this.removeClass("*"),this.off(),this.stop()}),!0),t.ungroup(),t.clear()}},{key:"clearDomElements",value:function(t){var e=this,i=t.isUpdating,a=this.w.globals.dom.Paper.node;a.parentNode&&a.parentNode.parentNode&&!i&&(a.parentNode.parentNode.style.minHeight="unset");var s=this.w.globals.dom.baseEl;s&&this.ctx.eventList.forEach((function(t){s.removeEventListener(t,e.ctx.events.documentEvent)}));var r=this.w.globals.dom;if(null!==this.ctx.el)for(;this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);this.killSVG(r.Paper),r.Paper.remove(),r.elWrap=null,r.elGraphical=null,r.elLegendWrap=null,r.elLegendForeign=null,r.baseEl=null,r.elGridRect=null,r.elGridRectMask=null,r.elGridRectMarkerMask=null,r.elForecastMask=null,r.elNonForecastMask=null,r.elDefs=null}}]),t}(),jt=new WeakMap;var _t=function(){function t(e,i){a(this,t),this.opts=i,this.ctx=this,this.w=new R(i).init(),this.el=e,this.w.globals.cuid=x.randomId(),this.w.globals.chartID=this.w.config.chart.id?x.escapeString(this.w.config.chart.id):this.w.globals.cuid,new Gt(this).initModules(),this.create=x.bind(this.create,this),this.windowResizeHandler=this._windowResizeHandler.bind(this),this.parentResizeHandler=this._parentResizeCallback.bind(this)}return r(t,[{key:"render",value:function(){var t=this;return new Promise((function(e,i){if(null!==t.el){void 0===Apex._chartInstances&&(Apex._chartInstances=[]),t.w.config.chart.id&&Apex._chartInstances.push({id:t.w.globals.chartID,group:t.w.config.chart.group,chart:t}),t.setLocale(t.w.config.chart.defaultLocale);var a=t.w.config.chart.events.beforeMount;"function"==typeof a&&a(t,t.w),t.events.fireEvent("beforeMount",[t,t.w]),window.addEventListener("resize",t.windowResizeHandler),function(t,e){var i=!1;if(t.nodeType!==Node.DOCUMENT_FRAGMENT_NODE){var a=t.getBoundingClientRect();"none"!==t.style.display&&0!==a.width||(i=!0)}var s=new ResizeObserver((function(a){i&&e.call(t,a),i=!0}));t.nodeType===Node.DOCUMENT_FRAGMENT_NODE?Array.from(t.children).forEach((function(t){return s.observe(t)})):s.observe(t),jt.set(e,s)}(t.el.parentNode,t.parentResizeHandler);var s=t.el.getRootNode&&t.el.getRootNode(),r=x.is("ShadowRoot",s),o=t.el.ownerDocument,n=r?s.getElementById("apexcharts-css"):o.getElementById("apexcharts-css");if(!n){var l;(n=document.createElement("style")).id="apexcharts-css",n.textContent='@keyframes opaque {\n  0% {\n      opacity: 0\n  }\n\n  to {\n      opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n  0%,to {\n      opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0,0,0,.5);\n  box-shadow: 0 0 1px rgba(255,255,255,.5);\n  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\n.legend-mouseover-inactive {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255,255,255,.96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30,30,30,.8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0,0,0,.7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,.apexcharts-tooltip-text-y-value,.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,.apexcharts-tooltip-text-goals-value:empty,.apexcharts-tooltip-text-y-label:empty,.apexcharts-tooltip-text-y-value:empty,.apexcharts-tooltip-text-z-value:empty,.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  border-radius: 50%\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0!important\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_boundingRect,.svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_boundingRect,.apexcharts-selection-rect+g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_points_l,.apexcharts-selection-rect+g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,.apexcharts-pan-icon,.apexcharts-reset-icon,.apexcharts-selection-icon,.apexcharts-toolbar-custom-icon,.apexcharts-zoom-icon,.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,.apexcharts-reset-icon svg,.apexcharts-zoom-icon svg,.apexcharts-zoomin-icon svg,.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,.apexcharts-theme-dark .apexcharts-pan-icon svg,.apexcharts-theme-dark .apexcharts-reset-icon svg,.apexcharts-theme-dark .apexcharts-selection-icon svg,.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,.apexcharts-theme-dark .apexcharts-zoom-icon svg,.apexcharts-theme-dark .apexcharts-zoomin-icon svg,.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,.apexcharts-theme-light .apexcharts-reset-icon:hover svg,.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,.apexcharts-reset-icon,.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0,0,0,.7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n      opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,.apexcharts-datalabel.apexcharts-element-hidden,.apexcharts-hide .apexcharts-series-points {\n  display: none;\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n.apexcharts-datalabel,.apexcharts-datalabel-label,.apexcharts-datalabel-value,.apexcharts-datalabels,.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-radialbar-label {\n  cursor: pointer;\n}\n\n.apexcharts-annotation-rect,.apexcharts-area-series .apexcharts-area,.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-gridline,.apexcharts-line,.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-point-annotation-label,.apexcharts-radar-series path,.apexcharts-radar-series polygon,.apexcharts-toolbar svg,.apexcharts-tooltip .apexcharts-marker,.apexcharts-xaxis-annotation-label,.apexcharts-yaxis-annotation-label,.apexcharts-zoom-rect {\n  pointer-events: none\n}\n\n.apexcharts-marker {\n  transition: .15s ease all\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,.resize-triggers,.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers{\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows{\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers{\n  pointer-events: none\n}';var h=(null===(l=t.opts.chart)||void 0===l?void 0:l.nonce)||t.w.config.chart.nonce;h&&n.setAttribute("nonce",h),r?s.prepend(n):o.head.appendChild(n)}var c=t.create(t.w.config.series,{});if(!c)return e(t);t.mount(c).then((function(){"function"==typeof t.w.config.chart.events.mounted&&t.w.config.chart.events.mounted(t,t.w),t.events.fireEvent("mounted",[t,t.w]),e(c)})).catch((function(t){i(t)}))}else i(new Error("Element not found"))}))}},{key:"create",value:function(t,e){var i=this.w;new Gt(this).initModules();var a=this.w.globals;(a.noData=!1,a.animationEnded=!1,this.responsive.checkResponsiveConfig(e),i.config.xaxis.convertedCatToNumeric)&&new E(i.config).convertCatToNumericXaxis(i.config,this.ctx);if(null===this.el)return a.animationEnded=!0,null;if(this.core.setupElements(),"treemap"===i.config.chart.type&&(i.config.grid.show=!1,i.config.yaxis[0].show=!1),0===a.svgWidth)return a.animationEnded=!0,null;var s=y.checkComboSeries(t,i.config.chart.type);a.comboCharts=s.comboCharts,a.comboBarCount=s.comboBarCount;var r=t.every((function(t){return t.data&&0===t.data.length}));(0===t.length||r&&a.collapsedSeries.length<1)&&this.series.handleNoData(),this.events.setupEventHandlers(),this.data.parseData(t),this.theme.init(),new D(this).setGlobalMarkerSize(),this.formatters.setLabelFormatters(),this.titleSubtitle.draw(),a.noData&&a.collapsedSeries.length!==a.series.length&&!i.config.legend.showForSingleSeries||this.legend.init(),this.series.hasAllSeriesEqualX(),a.axisCharts&&(this.core.coreCalculations(),"category"!==i.config.xaxis.type&&this.formatters.setLabelFormatters(),this.ctx.toolbar.minX=i.globals.minX,this.ctx.toolbar.maxX=i.globals.maxX),this.formatters.heatmapLabelFormatters(),new y(this).getLargestMarkerSize(),this.dimensions.plotCoords();var o=this.core.xySettings();this.grid.createGridMask();var n=this.core.plotChartType(t,o),l=new N(this);return l.bringForward(),i.config.dataLabels.background.enabled&&l.dataLabelsBackground(),this.core.shiftGraphPosition(),{elGraph:n,xyRatios:o,dimensions:{plot:{left:i.globals.translateX,top:i.globals.translateY,width:i.globals.gridWidth,height:i.globals.gridHeight}}}}},{key:"mount",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,i=this,a=i.w;return new Promise((function(s,r){if(null===i.el)return r(new Error("Not enough data to display or target element not found"));(null===e||a.globals.allSeriesCollapsed)&&i.series.handleNoData(),i.grid=new j(i);var o,n,l=i.grid.drawGrid();(i.annotations=new T(i),i.annotations.drawImageAnnos(),i.annotations.drawTextAnnos(),"back"===a.config.grid.position)&&(l&&a.globals.dom.elGraphical.add(l.el),null!=l&&null!==(o=l.elGridBorders)&&void 0!==o&&o.node&&a.globals.dom.elGraphical.add(l.elGridBorders));if(Array.isArray(e.elGraph))for(var h=0;h<e.elGraph.length;h++)a.globals.dom.elGraphical.add(e.elGraph[h]);else a.globals.dom.elGraphical.add(e.elGraph);"front"===a.config.grid.position&&(l&&a.globals.dom.elGraphical.add(l.el),null!=l&&null!==(n=l.elGridBorders)&&void 0!==n&&n.node&&a.globals.dom.elGraphical.add(l.elGridBorders));"front"===a.config.xaxis.crosshairs.position&&i.crosshairs.drawXCrosshairs(),"front"===a.config.yaxis[0].crosshairs.position&&i.crosshairs.drawYCrosshairs(),"treemap"!==a.config.chart.type&&i.axes.drawAxis(a.config.chart.type,l);var c=new V(t.ctx,l),d=new q(t.ctx,l);if(null!==l&&(c.xAxisLabelCorrections(l.xAxisTickWidth),d.setYAxisTextAlignments(),a.config.yaxis.map((function(t,e){-1===a.globals.ignoreYAxisIndexes.indexOf(e)&&d.yAxisTitleRotate(e,t.opposite)}))),i.annotations.drawAxesAnnotations(),!a.globals.noData){if(a.config.tooltip.enabled&&!a.globals.noData&&i.w.globals.tooltip.drawTooltip(e.xyRatios),a.globals.axisCharts&&(a.globals.isXNumeric||a.config.xaxis.convertedCatToNumeric||a.globals.isRangeBar))(a.config.chart.zoom.enabled||a.config.chart.selection&&a.config.chart.selection.enabled||a.config.chart.pan&&a.config.chart.pan.enabled)&&i.zoomPanSelection.init({xyRatios:e.xyRatios});else{var g=a.config.chart.toolbar.tools;["zoom","zoomin","zoomout","selection","pan","reset"].forEach((function(t){g[t]=!1}))}a.config.chart.toolbar.show&&!a.globals.allSeriesCollapsed&&i.toolbar.createToolbar()}a.globals.memory.methodsToExec.length>0&&a.globals.memory.methodsToExec.forEach((function(t){t.method(t.params,!1,t.context)})),a.globals.axisCharts||a.globals.noData||i.core.resizeNonAxisCharts(),s(i)}))}},{key:"destroy",value:function(){var t,e;window.removeEventListener("resize",this.windowResizeHandler),this.el.parentNode,t=this.parentResizeHandler,(e=jt.get(t))&&(e.disconnect(),jt.delete(t));var i=this.w.config.chart.id;i&&Apex._chartInstances.forEach((function(t,e){t.id===x.escapeString(i)&&Apex._chartInstances.splice(e,1)})),new Vt(this.ctx).clear({isUpdating:!1})}},{key:"updateOptions",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],s=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],r=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],o=this.w;return o.globals.selection=void 0,t.series&&(this.series.resetSeries(!1,!0,!1),t.series.length&&t.series[0].data&&(t.series=t.series.map((function(t,i){return e.updateHelpers._extendSeries(t,i)}))),this.updateHelpers.revertDefaultAxisMinMax()),t.xaxis&&(t=this.updateHelpers.forceXAxisUpdate(t)),t.yaxis&&(t=this.updateHelpers.forceYAxisUpdate(t)),o.globals.collapsedSeriesIndices.length>0&&this.series.clearPreviousPaths(),t.theme&&(t=this.theme.updateThemeOptions(t)),this.updateHelpers._updateOptions(t,i,a,s,r)}},{key:"updateSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];return this.series.resetSeries(!1),this.updateHelpers.revertDefaultAxisMinMax(),this.updateHelpers._updateSeries(t,e,i)}},{key:"appendSeries",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=this.w.config.series.slice();return a.push(t),this.series.resetSeries(!1),this.updateHelpers.revertDefaultAxisMinMax(),this.updateHelpers._updateSeries(a,e,i)}},{key:"appendData",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this;i.w.globals.dataChanged=!0,i.series.getPreviousPaths();for(var a=i.w.config.series.slice(),s=0;s<a.length;s++)if(null!==t[s]&&void 0!==t[s])for(var r=0;r<t[s].data.length;r++)a[s].data.push(t[s].data[r]);return i.w.config.series=a,e&&(i.w.globals.initialSeries=x.clone(i.w.config.series)),this.update()}},{key:"update",value:function(t){var e=this;return new Promise((function(i,a){new Vt(e.ctx).clear({isUpdating:!0});var s=e.create(e.w.config.series,t);if(!s)return i(e);e.mount(s).then((function(){"function"==typeof e.w.config.chart.events.updated&&e.w.config.chart.events.updated(e,e.w),e.events.fireEvent("updated",[e,e.w]),e.w.globals.isDirty=!0,i(e)})).catch((function(t){a(t)}))}))}},{key:"getSyncedCharts",value:function(){var t=this.getGroupedCharts(),e=[this];return t.length&&(e=[],t.forEach((function(t){e.push(t)}))),e}},{key:"getGroupedCharts",value:function(){var t=this;return Apex._chartInstances.filter((function(t){if(t.group)return!0})).map((function(e){return t.w.config.chart.group===e.group?e.chart:t}))}},{key:"toggleSeries",value:function(t){return this.series.toggleSeries(t)}},{key:"highlightSeriesOnLegendHover",value:function(t,e){return this.series.toggleSeriesOnHover(t,e)}},{key:"showSeries",value:function(t){this.series.showSeries(t)}},{key:"hideSeries",value:function(t){this.series.hideSeries(t)}},{key:"isSeriesHidden",value:function(t){this.series.isSeriesHidden(t)}},{key:"resetSeries",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.series.resetSeries(t,e)}},{key:"addEventListener",value:function(t,e){this.events.addEventListener(t,e)}},{key:"removeEventListener",value:function(t,e){this.events.removeEventListener(t,e)}},{key:"addXaxisAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addXaxisAnnotationExternal(t,e,a)}},{key:"addYaxisAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addYaxisAnnotationExternal(t,e,a)}},{key:"addPointAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addPointAnnotationExternal(t,e,a)}},{key:"clearAnnotations",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:void 0,e=this;t&&(e=t),e.annotations.clearAnnotations(e)}},{key:"removeAnnotation",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0,i=this;e&&(i=e),i.annotations.removeAnnotation(i,t)}},{key:"getChartArea",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner")}},{key:"getSeriesTotalXRange",value:function(t,e){return this.coreUtils.getSeriesTotalsXRange(t,e)}},{key:"getHighestValueInSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return new U(this.ctx).getMinYMaxY(t).highestY}},{key:"getLowestValueInSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return new U(this.ctx).getMinYMaxY(t).lowestY}},{key:"getSeriesTotal",value:function(){return this.w.globals.seriesTotals}},{key:"toggleDataPointSelection",value:function(t,e){return this.updateHelpers.toggleDataPointSelection(t,e)}},{key:"zoomX",value:function(t,e){this.ctx.toolbar.zoomUpdateOptions(t,e)}},{key:"setLocale",value:function(t){this.localization.setCurrentLocaleValues(t)}},{key:"dataURI",value:function(t){return new G(this.ctx).dataURI(t)}},{key:"exportToCSV",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return new G(this.ctx).exportToCSV(t)}},{key:"paper",value:function(){return this.w.globals.dom.Paper}},{key:"_parentResizeCallback",value:function(){this.w.globals.animationEnded&&this.w.config.chart.redrawOnParentResize&&this._windowResize()}},{key:"_windowResize",value:function(){var t=this;clearTimeout(this.w.globals.resizeTimer),this.w.globals.resizeTimer=window.setTimeout((function(){t.w.globals.resized=!0,t.w.globals.dataChanged=!1,t.ctx.update()}),150)}},{key:"_windowResizeHandler",value:function(){var t=this.w.config.chart.redrawOnWindowResize;"function"==typeof t&&(t=t()),t&&this._windowResize()}}],[{key:"getChartByID",value:function(t){var e=x.escapeString(t);if(Apex._chartInstances){var i=Apex._chartInstances.filter((function(t){return t.id===e}))[0];return i&&i.chart}}},{key:"initOnLoad",value:function(){for(var e=document.querySelectorAll("[data-apexcharts]"),i=0;i<e.length;i++){new t(e[i],JSON.parse(e[i].getAttribute("data-options"))).render()}}},{key:"exec",value:function(t,e){var i=this.getChartByID(t);if(i){i.w.globals.isExecCalled=!0;var a=null;if(-1!==i.publicMethods.indexOf(e)){for(var s=arguments.length,r=new Array(s>2?s-2:0),o=2;o<s;o++)r[o-2]=arguments[o];a=i[e].apply(i,r)}return a}}},{key:"merge",value:function(t,e){return x.extend(t,e)}}]),t}();return _t}));

!function(e,t){if("object"==typeof exports&&"object"==typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var n=t();for(var o in n)("object"==typeof exports?exports:e)[o]=n[o]}}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var i=t[o]={i:o,l:!1,exports:{}};return e[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(o,i,function(t){return e[t]}.bind(null,i));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="/",n(n.s=1)}([function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){n(2),e.exports=n(6)},function(e,t,n){(function(o,i){var r,a;function s(e){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(o,i){"object"==s(t)&&void 0!==e?i():void 0===(a="function"==typeof(r=i)?r.call(t,n,t,e):r)||(e.exports=a)}(0,(function(){"use strict";function e(e){var t=this.constructor;return this.then((function(n){return t.resolve(e()).then((function(){return n}))}),(function(n){return t.resolve(e()).then((function(){return t.reject(n)}))}))}function t(){}function n(e){if(!(this instanceof n))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],d(e,this)}function r(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,n._immediateFn((function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var o;try{o=n(e._value)}catch(e){return void c(t.promise,e)}a(t.promise,o)}else(1===e._state?a:c)(t.promise,e._value)}))):e._deferreds.push(t)}function a(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==s(t)||"function"==typeof t)){var o=t.then;if(t instanceof n)return e._state=3,e._value=t,void l(e);if("function"==typeof o)return void d(function(e,t){return function(){e.apply(t,arguments)}}(o,t),e)}e._state=1,e._value=t,l(e)}catch(t){c(e,t)}}function c(e,t){e._state=2,e._value=t,l(e)}function l(e){2===e._state&&0===e._deferreds.length&&n._immediateFn((function(){e._handled||n._unhandledRejectionFn(e._value)}));for(var t=0,o=e._deferreds.length;o>t;t++)r(e,e._deferreds[t]);e._deferreds=null}function d(e,t){var n=!1;try{e((function(e){n||(n=!0,a(t,e))}),(function(e){n||(n=!0,c(t,e))}))}catch(e){if(n)return;n=!0,c(t,e)}}var u=setTimeout;n.prototype.catch=function(e){return this.then(null,e)},n.prototype.then=function(e,n){var o=new this.constructor(t);return r(this,new function(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}(e,n,o)),o},n.prototype.finally=e,n.all=function(e){return new n((function(t,n){function o(e,a){try{if(a&&("object"==s(a)||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void c.call(a,(function(t){o(e,t)}),n)}i[e]=a,0==--r&&t(i)}catch(e){n(e)}}if(!e||void 0===e.length)throw new TypeError("Promise.all accepts an array");var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var r=i.length,a=0;i.length>a;a++)o(a,i[a])}))},n.resolve=function(e){return e&&"object"==s(e)&&e.constructor===n?e:new n((function(t){t(e)}))},n.reject=function(e){return new n((function(t,n){n(e)}))},n.race=function(e){return new n((function(t,n){for(var o=0,i=e.length;i>o;o++)e[o].then(t,n)}))},n._immediateFn="function"==typeof o&&function(e){o(e)}||function(e){u(e,0)},n._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var f=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==i)return i;throw Error("unable to locate global object")}();"Promise"in f?f.Promise.prototype.finally||(f.Promise.prototype.finally=e):f.Promise=n}))}).call(this,n(3).setImmediate,n(0))},function(e,t,n){(function(e){var o=void 0!==e&&e||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function r(e,t){this._id=e,this._clearFn=t}t.setTimeout=function(){return new r(i.call(setTimeout,o,arguments),clearTimeout)},t.setInterval=function(){return new r(i.call(setInterval,o,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(o,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout((function(){e._onTimeout&&e._onTimeout()}),t))},n(4),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(this,n(0))},function(e,t,n){(function(e,t){!function(e,n){"use strict";if(!e.setImmediate){var o,i,r,a,s,c=1,l={},d=!1,u=e.document,f=Object.getPrototypeOf&&Object.getPrototypeOf(e);f=f&&f.setTimeout?f:e,"[object process]"==={}.toString.call(e.process)?o=function(e){t.nextTick((function(){h(e)}))}:!function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?e.MessageChannel?((r=new MessageChannel).port1.onmessage=function(e){h(e.data)},o=function(e){r.port2.postMessage(e)}):u&&"onreadystatechange"in u.createElement("script")?(i=u.documentElement,o=function(e){var t=u.createElement("script");t.onreadystatechange=function(){h(e),t.onreadystatechange=null,i.removeChild(t),t=null},i.appendChild(t)}):o=function(e){setTimeout(h,0,e)}:(a="setImmediate$"+Math.random()+"$",s=function(t){t.source===e&&"string"==typeof t.data&&0===t.data.indexOf(a)&&h(+t.data.slice(a.length))},e.addEventListener?e.addEventListener("message",s,!1):e.attachEvent("onmessage",s),o=function(t){e.postMessage(a+t,"*")}),f.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var i={callback:e,args:t};return l[c]=i,o(c),c++},f.clearImmediate=p}function p(e){delete l[e]}function h(e){if(d)setTimeout(h,0,e);else{var t=l[e];if(t){d=!0;try{!function(e){var t=e.callback,n=e.args;switch(n.length){case 0:t();break;case 1:t(n[0]);break;case 2:t(n[0],n[1]);break;case 3:t(n[0],n[1],n[2]);break;default:t.apply(void 0,n)}}(t)}finally{p(e),d=!1}}}}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,n(0),n(5))},function(e,t){var n,o,i=e.exports={};function r(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function s(e){if(n===setTimeout)return setTimeout(e,0);if((n===r||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:r}catch(e){n=r}try{o="function"==typeof clearTimeout?clearTimeout:a}catch(e){o=a}}();var c,l=[],d=!1,u=-1;function f(){d&&c&&(d=!1,c.length?l=c.concat(l):u=-1,l.length&&p())}function p(){if(!d){var e=s(f);d=!0;for(var t=l.length;t;){for(c=l,l=[];++u<t;)c&&c[u].run();u=-1,t=l.length}c=null,d=!1,function(e){if(o===clearTimeout)return clearTimeout(e);if((o===a||!o)&&clearTimeout)return o=clearTimeout,clearTimeout(e);try{o(e)}catch(t){try{return o.call(null,e)}catch(t){return o.call(this,e)}}}(e)}}function h(e,t){this.fun=e,this.array=t}function m(){}i.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];l.push(new h(e,t)),1!==l.length||d||s(p)},h.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=m,i.addListener=m,i.once=m,i.off=m,i.removeListener=m,i.removeAllListeners=m,i.emit=m,i.prependListener=m,i.prependOnceListener=m,i.listeners=function(e){return[]},i.binding=function(e){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(e){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(e,t,n){"use strict";n.r(t),n.d(t,"getInstance",(function(){return w}));var o={ASM:"asm",WASM:"ems",JS_WORKER:"jsworker",THREADED_WASM:"wasm-threads"};function i(e,t){if("string"!=typeof e||!t)return e;var n=t.substr(0,t.lastIndexOf("/"));return/^(\/|%2F|[a-z0-9-]+:)/i.test(e)?e:n+"/"+e}function r(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,o)}return n}function a(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?r(Object(n),!0).forEach((function(t){s(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):r(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function s(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var c={},l=0;window.isPdfjs=!0,"undefined"==typeof console&&(window.console={log:function(){},warn:function(){},error:function(){}});var d=function(){for(var e=1;e<arguments.length;e++)for(var t=Object.keys(arguments[e]),n=0;n<t.length;n++)arguments[0][t[n]]=arguments[e][t[n]];return arguments[0]},u=function(e){var t=[];return e.forEach((function(e){t.push(e)})),t},f=function(e,t){var n;try{n=new CustomEvent(e,{detail:t,bubbles:!0,cancelable:!0})}catch(o){(n=document.createEvent("Event")).initEvent(e,!0,!0),n.detail=t}return n};window.PDFNet&&!c.skipPDFNetWebViewerWarning&&console.warn("PDFNet.js and WebViewer.js have been included in the same context. See https://www.pdftron.com/kb_same_context for an explanation of why this could be an error in your application.");var p=new Map,h=new Map;c.WebViewer=function(e,t){var n=this;if(h.get(t))throw new Error("Two instances of WebViewer were created on the same HTML element. Please create a new element for each instance of WebViewer");h.set(t,!0);t.addEventListener("ready",(function e(){p.get(t).instance=n.getCompleteInstance(),t.removeEventListener("ready",e)})),this._validateOptions(e);var o=e.webviewerServerURL||e.pdftronServer;e.fullAPI&&o&&(e.forceClientSideInit||console.warn("The fullAPI and webviewerServerURL options have both been set so the forceClientSideInit option is now enabled. This means that WebViewer will switch to client side rendering and processing to allow use of the full API."),e.forceClientSideInit=!0),this.options=d({},c.WebViewer.Options,e);var i=this.options.path.length-1;i>0&&"/"!==this.options.path[i]&&(this.options.path+="/"),this.options.uiPath=this.options.path+this.options.uiPath,t||console.error("ViewerElement is not defined. This may be caused by calling the WebViewer constructor before the DOM is loaded, or an invalid selector. Please see http://r.pdftron.com/guides/quick-start for an example."),this.element=t,this.element.style.overflow="hidden";var r=this;this.messageHandler=function(t){if("requestl"===t.data&&t.source&&t.source.postMessage({type:"responsel",value:e.l||e.licenseKey},"*"),"requestConfig"===t.data.type&&t.data.id===r.id&&t.source){var n=e.config?r._correctRelativePath(e.config):"";t.source.postMessage({type:"responseConfig",value:n},"*")}},window.addEventListener("message",this.messageHandler,!1),this.options.autoCreate&&this.create()};var m={licenseKey:void 0,enableAzureWorkaround:!1,isAdminUser:!1,isReadOnly:!1};c.WebViewer.prototype={version:"8.7.5",create:function(){if(this.options.initialDoc){var e=this._correctRelativePath(this.options.initialDoc);e=encodeURIComponent(JSON.stringify(e)),this.options.initialDoc=e}this._create()},_create:function(){this.id=++l,void 0===this._trigger&&(this._trigger=function(e,t){var n=f(e,t);this.element.dispatchEvent(n)});var e=this.options.type.replace(" ","").split(",");e.length<1&&(e[0]="html5"),this._createViewer(e)},_validateOptions:function(e){for(var t=Object.keys(e),n=0;n<t.length;n++){var o=t[n];o in d({},m,c.WebViewer.Options)||console.warn("".concat(o," is not a valid option name. See http://r.pdftron.com/api/options_anchor for all available options."))}var i=e.webviewerServerURL||e.pdftronServer;!e.enableRedaction||e.fullAPI||i||console.warn("FullAPI or WebViewer Server is needed to apply redactions")},_notSupportedMobile:function(){var e=document.createElement("div");e.id="webviewer-browser-unsupported",e.textContent="PDF document viewing is not supported by this browser.",this.element.appendChild(e)},_createViewer:function(e){var t,n=this;if(n.selectedType=null,this.isMobileDevice()){if(this.options.documentType&&"xod"!==this.options.documentType&&!this._testWebAssembly())return void this._notSupportedMobile();if(e=Array("html5Mobile"),n.selectedType="html5Mobile",this.options.mobileRedirect)return t=this.options.uiPath+this._getHTML5OptionsURL(),void(window.location=t)}for(var o=!1,i=!1,r=0;r<e.length;r++){if("html5mobile"===e[r].toLowerCase()){if(this.options.documentType&&"xod"!==this.options.documentType&&!this._testWebAssembly())continue;if(o=!0,n._testHTML5()){if(this.options.mobileRedirect)return n.selectedType="html5Mobile",t=this.options.uiPath+this._getHTML5OptionsURL(),void(window.location=t);if(this.options.xdomainProxyUrl||n.isSameOrigin(decodeURIComponent(n.options.initialDoc))||n._testCORS()){n.selectedType="html5Mobile";break}i=!0}}if("html5"===e[r].toLowerCase()&&(o=!0,n._testHTML5())){var a=n.isSameOrigin(decodeURIComponent(n.options.initialDoc));if(this.options.xdomainProxyUrl||a||n._testCORS()){n.selectedType="html5";break}i=!0}}if("html5"===n.selectedType)n._createHTML5();else if("html5Mobile"===n.selectedType)n._createHTML5Mobile();else{var s;if(i?s="This browser does not support cross origin requests. Please configure xdomain to support CORS.":o&&(s="Please use an HTML5 compatible browser."),s){var c=document.createElement("div");c.id="webviewer-browser-unsupported",c.textContent=s,n.element.appendChild(c)}}},_viewerLoaded:function(e){this._trigger("ready");try{var t=e.contentWindow;if(t.postMessage({type:"viewerLoaded"},"*"),void 0!==this.options.encryption){var n=decodeURIComponent(this.options.initialDoc);this.options.initialDoc&&(n=JSON.parse(n));var o={decrypt:t.Core.Encryption.decrypt,decryptOptions:this.options.encryption,documentId:this.options.documentId,extension:"xod"};this.getInstance().loadDocument(n,o)}}catch(e){console.warn("Viewer is on a different domain, the promise from WebViewer function is rejected and API functions will not work because of cross domain permissions. See http://r.pdftron.com/kb_cross_origin for more information.")}},_getHTML5OptionsURL:function(){var e,t,n,o=this.options,i=o.webviewerServerURL||o.pdftronServer,r="";if(o.initialDoc&&(r+="#d=".concat(o.initialDoc)),void 0===o.backendType&&(o.backendType=o.pdfBackend),o.documentType&&"xod"===o.documentType&&(e=o.documentType),o.preloadWorker&&"xod"===o.preloadWorker&&(e=o.preloadWorker),o.extension&&(e=o.extension),e&&(r+="&extension=".concat(e)),o.documentType&&"xod"!==o.documentType&&(t=o.documentType),o.preloadWorker&&"xod"!==o.preloadWorker&&(t=o.preloadWorker),t&&(r+="&preloadWorker=".concat(t)),o.backendType&&(r+="&pdf=".concat(o.backendType,"&office=").concat(o.backendType,"&legacyOffice=").concat(o.backendType)),o.filename&&(r+="&filename=".concat(o.filename)),void 0!==o.streaming&&(r+="&streaming=".concat(o.streaming)),o.externalPath){var a=this._correctRelativePath(o.externalPath);a=encodeURIComponent(a),r+="&p=".concat(a)}if(o.encryption&&(r+="&auto_load=false"),o.enableAnnotations&&(r+="&a=1"),o.disabledElements){var s=encodeURIComponent(o.disabledElements.join(","));r+="&disabledElements=".concat(s)}if(o.serverUrl){var c=this._correctRelativePath(o.serverUrl);c=encodeURIComponent(c),r+="&server_url=".concat(c)}if(o.serverUrlHeaders&&(r+="&serverUrlHeaders=".concat(JSON.stringify(o.serverUrlHeaders))),o.documentId&&(r+="&did=".concat(o.documentId)),o.css){var l=this._correctRelativePath(o.css);l=encodeURIComponent(l),r+="&css=".concat(l)}if(o.disableI18n&&(r+="&disableI18n=1"),o.enableOfflineMode&&(r+="&offline=1"),o.startOffline&&(r+="&startOffline=1"),(o.enableReadOnlyMode||o.isReadOnly)&&(r+="&readonly=1"),o.hideAnnotationPanel&&(r+="&hideAnnotationPanel=1"),o.disableToolGroupReordering&&(r+="&disableToolGroupReordering=1"),void 0!==o.annotationUser&&(r+="&user=".concat(o.annotationUser)),void 0===o.annotationAdmin&&void 0===o.isAdminUser||(r+="&admin=".concat(o.annotationAdmin||o.isAdminUser?1:0)),void 0!==o.custom&&(r+="&custom=".concat(encodeURIComponent(o.custom))),void 0===o.showLocalFilePicker&&void 0===o.enableFilePicker||(r+="&filepicker=".concat(o.showLocalFilePicker||o.enableFilePicker?1:0)),void 0!==o.fullAPI){if(o.fullAPI)throw new Error('"fullAPI" is not a valid constuctor option for PDF.js Express. Please make sure you are referring to the proper documentation (https://pdfjs.express/documentation)');r+="&pdfnet=".concat(o.fullAPI?1:0)}(void 0!==o.enableRedaction&&(r+="&enableRedaction=".concat(o.enableRedaction?1:0)),void 0!==o.disableVirtualDisplayMode&&(r+="&disableVirtualDisplayMode=".concat(o.disableVirtualDisplayMode?1:0)),void 0!==o.enableMeasurement&&(r+="&enableMeasurement=".concat(o.enableMeasurement?1:0)),void 0!==o.showToolbarControl&&(r+="&toolbar=".concat(o.showToolbarControl?"true":"false")),void 0!==o.showPageHistoryButtons&&(r+="&pageHistory=".concat(o.showPageHistoryButtons?1:0)),void 0!==o.notesInLeftPanel&&(r+="&notesInLeftPanel=".concat(o.notesInLeftPanel?1:0)),void 0!==o.xdomainProxyUrl)&&(n="string"==typeof o.xdomainProxyUrl?{url:o.xdomainProxyUrl}:o.xdomainProxyUrl,r+="&xdomain_urls=".concat(encodeURIComponent(JSON.stringify(n))));return(o.azureWorkaround||o.enableAzureWorkaround)&&(r+="&azureWorkaround=1"),o.enableOptimizedWorkers||(r+="&enableOptimizedWorkers=0"),o.useDownloader||(r+="&useDownloader=0"),o.disableWebsockets&&(r+="&disableWebsockets=1"),o.disableStreaming&&(r+="&disableStreaming=1"),o.forceClientSideInit&&(r+="&forceClientSideInit=1"),o.loadAsPDF&&(r+="&loadAsPDF=1"),void 0!==o.workerTransportPromise&&(r+="&useSharedWorker=".concat(o.workerTransportPromise?"true":"false")),void 0!==i&&i&&(r+="&webviewerServerURL=".concat(encodeURIComponent(i))),o.fallbackToClientSide&&(r+="&fallbackToClientSide=1"),void 0!==o.singleServerMode&&(r+="&singleServerMode=".concat(o.singleServerMode?"true":"false")),void 0!==o.accessibleMode&&(r+="&accessibleMode=".concat(o.accessibleMode?1:0)),o.disableLogs&&(r+="&disableLogs=1"),o.enableViewStateAnnotations&&(r+="&enableViewStateAnnotations=1"),o.disableFlattenedAnnotations&&(r+="&disableFlattenedAnnotations=1"),o.highContrastMode&&(r+="&highContrastMode=1"),void 0!==o.selectAnnotationOnCreation&&(r+="&selectAnnotationOnCreation=".concat(o.selectAnnotationOnCreation?1:0)),void 0!==o.autoFocusNoteOnAnnotationSelection&&(r+="&autoFocusNoteOnAnnotationSelection=".concat(o.autoFocusNoteOnAnnotationSelection?1:0)),r+="&id=".concat(this.id),(r+="&basePath=".concat(encodeURIComponent(window.location.pathname))).length>0&&"&"===r[0]&&(r="#".concat(r.slice(1))),r+="&webViewerJSVersion=".concat(this.version)},setInstanceData:function(e){p.set(this.element,{iframe:e,l:this.options.l||this.options.licenseKey,workerTransportPromise:this.options.workerTransportPromise})},_createHTML5:function(){var e=this,t=this.options.uiPath+this._getHTML5OptionsURL(),n=document.createElement("iframe");this.setInstanceData(n),n.id="webviewer-".concat(this.id),n.src=t,n.title="webviewer",n.frameBorder=0,n.width="100%",n.height="100%",n.setAttribute("allowfullscreen",!0),n.setAttribute("webkitallowfullscreen",!0),n.setAttribute("mozallowfullscreen",!0),this.iframe=n,this.options.backgroundColor&&n.setAttribute("data-bgcolor",this.options.backgroundColor),this.options.assetPath&&n.setAttribute("data-assetpath",encodeURIComponent(this.options.assetPath)),this.element.appendChild(n);window.addEventListener("message",(function t(n){if("viewerLoaded"===n.data.type&&n.data.id===e.id)try{e.instance=e.iframe.contentWindow.instance}catch(e){}finally{window.removeEventListener("message",t),e._viewerLoaded(e.iframe)}}))},_createHTML5Mobile:function(){var e=this,t=this.options.uiPath+this._getHTML5OptionsURL(),n=document.createElement("iframe");this.setInstanceData(n),n.id="webviewer-".concat(this.id),n.src=t,n.frameborder=0,this.options.assetPath&&n.setAttribute("data-assetpath",encodeURIComponent(this.options.assetPath)),n.style.width="100%",n.style.height="100%",this.iframe=n,this.element.appendChild(n);window.addEventListener("message",(function t(n){if("viewerLoaded"===n.data.type&&n.data.id===e.id)try{e.instance=e.iframe.contentWindow.instance}catch(e){}finally{window.removeEventListener("message",t),e._viewerLoaded(e.iframe)}}))},dispose:function(){var e=this;return new Promise((function(t){p.delete(e.element),h.delete(e.element),window.removeEventListener("message",e.messageHandler),e.iframe.removeEventListener("load",e.loadListener),e.iframe=null,console.clear(),e.instance.Core.documentViewer.closeDocument().then((function(){t()}))}))},getInstance:function(){return this.instance},setCompleteInstance:function(e){this.completeInstance=e},getCompleteInstance:function(){return this.completeInstance},_correctRelativePath:function(e){var t=window.location.pathname;return Array.isArray(e)?e.map((function(e){return i(e,t)})):i(e,t)},_testHTML5:function(){try{var e=document.createElement("canvas");return e&&e.getContext("2d")}catch(e){return!1}},_testWebAssembly:function(){return!(!window.WebAssembly||!window.WebAssembly.validate)},_testCORS:function(){return"XMLHttpRequest"in window&&"withCredentials"in new XMLHttpRequest},isIE:function(){var e=navigator.userAgent.toLowerCase(),t=/(msie) ([\w.]+)/.exec(e)||/(trident)(?:.*? rv:([\w.]+)|)/.exec(e);return t?parseInt(t[2],10):t},isMobileDevice:function(){return!this.isIE()&&(0===this.scrollbarWidth()&&navigator.userAgent.match(/Edge/i)||navigator.userAgent.match(/Android/i)||navigator.userAgent.match(/webOS/i)||navigator.userAgent.match(/iPhone/i)||navigator.userAgent.match(/iPod/i)||navigator.userAgent.match(/iPad/i)||navigator.userAgent.match(/Touch/i)||navigator.userAgent.match(/IEMobile/i)||navigator.userAgent.match(/Silk/i))},scrollbarWidth:function(){var e=document.createElement("div");e.style.cssText="width:100px;height:100px;overflow:scroll !important;position:absolute;top:-9999px",document.body.appendChild(e);var t=e.offsetWidth-e.clientWidth;return document.body.removeChild(e),t},isSameOrigin:function(e){var t=window.location,n=document.createElement("a");n.href=e,""===n.host&&(n.href=n.href);var o=window.location.port,i=n.port;return"http:"===n.protocol?(i=i||"80",o=o||"80"):"https:"===n.protocol&&(i=i||"443",o=o||"443"),n.hostname===t.hostname&&n.protocol===t.protocol&&i===o}},c.WebViewer.Options={initialDoc:void 0,annotationAdmin:void 0,isAdminUser:void 0,annotationUser:void 0,assetPath:void 0,autoCreate:!0,autoFocusNoteOnAnnotationSelection:!0,azureWorkaround:!1,additionalTranslations:void 0,enableAzureWorkaround:!1,enableOptimizedWorkers:!0,backgroundColor:void 0,backendType:void 0,css:void 0,config:void 0,custom:void 0,documentId:void 0,documentType:void 0,preloadWorker:void 0,extension:void 0,enableAnnotations:!0,filename:void 0,disableI18n:!1,disabledElements:void 0,disableWebsockets:!1,enableOfflineMode:!1,enableReadOnlyMode:!1,isReadOnly:!1,enableRedaction:!1,disableVirtualDisplayMode:!1,enableMeasurement:!1,encryption:void 0,externalPath:void 0,hideAnnotationPanel:!1,disableToolGroupReordering:!1,uiPath:"./ui/index.html",l:void 0,licenseKey:void 0,mobileRedirect:!1,path:"",pdfBackend:void 0,webviewerServerURL:void 0,fallbackToClientSide:!1,singleServerMode:!1,fullAPI:!1,preloadPDFWorker:!0,serverUrl:void 0,serverUrlHeaders:void 0,showLocalFilePicker:!1,enableFilePicker:!1,showPageHistoryButtons:!0,showToolbarControl:void 0,startOffline:!1,streaming:void 0,type:"html5",useDownloader:!0,workerTransportPromise:void 0,xdomainProxyUrl:void 0,ui:void 0,forceClientSideInit:!1,loadAsPDF:!1,accessibleMode:void 0,disableLogs:!1,enableViewStateAnnotations:!1,highContrastMode:!1,selectAnnotationOnCreation:!1,notesInLeftPanel:!1,documentXFDFRetriever:void 0,disableFlattenedAnnotations:!1,disableStreaming:!1};var v=function(e,t){return new Promise((function(n,o){e.l=e.l||e.licenseKey,e.azureWorkaround=e.azureWorkaround||e.enableAzureWorkaround,e.annotationAdmin=e.annotationAdmin||e.isAdminUser,e.enableReadOnlyMode=e.enableReadOnlyMode||e.isReadOnly,e.showLocalFilePicker=e.showLocalFilePicker||e.enableFilePicker;t.addEventListener("ready",(function r(){t.removeEventListener("ready",r);try{var c=t.querySelector("iframe").contentWindow;if(void 0===c.Tools)throw new Error("Viewer isn't instantiated correctly. It could be caused by the 'path' option in the WebViewer constructor not being defined correctly. The 'path' option should be relative to the HTML file you're loading the script on and the lib folder needs to be publicly accessible.");var l=i.getInstance(),u={iframeWindow:c,dispose:i.dispose.bind(i)},f=d({},l,a(s({},l.UI_NAMESPACE_KEY,a(a({},l[l.UI_NAMESPACE_KEY]),u)),u));i.setCompleteInstance(f);var p=Promise.resolve();if(e.documentXFDFRetriever&&(p=f[l.CORE_NAMESPACE_KEY].documentViewer.setDocumentXFDFRetriever(e.documentXFDFRetriever)),e.additionalTranslations){var h=e.additionalTranslations;f[l.UI_NAMESPACE_KEY].setTranslations(h.language,h.translations)}p.then((function(){n(f)}))}catch(t){if("config"in e&&""!==e.config)return n();o("Viewer is on a different domain, the promise from WebViewer function is rejected and API functions will not work because of cross domain permissions. See https://www.pdftron.com/kb_cross_origin for more information.")}}));var i=new c.WebViewer(e,t)}))},b=function(e){for(var t=u(p),n=0;n<t.length;n++){var o=t[n];if(o.iframe===e)return o}return null};v.l=function(e){var t=b(e);return t&&t.l},v.workerTransportPromise=function(e){var t=b(e);return t&&t.workerTransportPromise},v.WorkerTypes={ALL:"all",OFFICE:"office",LEGACY_OFFICE:"legacyOffice",PDF:"pdf",CONTENT_EDIT:"contentEdit"},v.BackendTypes=o;var w=function(e){var t=u(p);if(!t.length||!t.filter((function(e){return e.instance})).length)return console.warn("WebViewer.getInstance() was called before any instances were available"),null;if(t.length>1&&!e)throw new Error("More than one instance of WebViewer was found, and no element was passed into getInstance(). Please specify which instance you want to get.");return e?(p.get(e)||{}).instance:(t[0]||{}).instance};v.getInstance=w,window.WebViewer=v;t.default=v}])}));
/*!
 * elFinder - file manager for web
 * Version 2.1.65 (2024-01-05)
 * http://elfinder.org
 * 
 * Copyright 2009-2024, Studio 42
 * Licensed under a 3-clauses BSD license
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery', 'jquery-ui'], factory);
    } else if (typeof exports !== 'undefined') {
        // CommonJS
        var $, ui;
        try {
            $ = require('jquery');
            ui = require('jquery-ui');
        } catch (e) { }
        module.exports = factory($, ui);
    } else {
        // Browser globals (Note: root is window)
        factory(root.jQuery, root.jQuery.ui, true);
    }
}(this, function ($, _ui, toGlobal) {
    toGlobal = toGlobal || false;


    /*
     * File: /js/elFinder.js
     */

    /**
     * @class elFinder - file manager for web
     *
     * @author Dmitry (dio) Levashov
     **/
    var elFinder = function (elm, opts, bootCallback) {
        //this.time('load');
        var self = this,

            /**
             * Objects array of jQuery.Deferred that calls before elFinder boot up
             * 
             * @type Array
             */
            dfrdsBeforeBootup = [],

            /**
             * Plugin name to check for conflicts with bootstrap etc
             *
             * @type Array
             **/
            conflictChecks = ['button', 'tooltip'],

            /**
             * Node on which elfinder creating
             *
             * @type jQuery
             **/
            node = $(elm),

            /**
             * Object of events originally registered in this node
             * 
             * @type Object
             */
            prevEvents = $.extend(true, {}, $._data(node.get(0), 'events')),

            /**
             * Store node contents.
             *
             * @see this.destroy
             * @type jQuery
             **/
            prevContent = $('<div></div>').append(node.contents()).attr('class', node.attr('class') || '').attr('style', node.attr('style') || ''),

            /**
             * Instance ID. Required to get/set cookie
             *
             * @type String
             **/
            id = node.attr('id') || node.attr('id', 'elfauto' + $('.elfinder').length).attr('id'),

            /**
             * Events namespace
             *
             * @type String
             **/
            namespace = 'elfinder-' + id,

            /**
             * Mousedown event
             *
             * @type String
             **/
            mousedown = 'mousedown.' + namespace,

            /**
             * Keydown event
             *
             * @type String
             **/
            keydown = 'keydown.' + namespace,

            /**
             * Keypress event
             *
             * @type String
             **/
            keypress = 'keypress.' + namespace,

            /**
             * Keypup event
             *
             * @type String
             **/
            keyup = 'keyup.' + namespace,

            /**
             * Is shortcuts/commands enabled
             *
             * @type Boolean
             **/
            enabled = false,

            /**
             * Store enabled value before ajax request
             *
             * @type Boolean
             **/
            prevEnabled = false,

            /**
             * List of build-in events which mapped into methods with same names
             *
             * @type Array
             **/
            events = ['enable', 'disable', 'load', 'open', 'reload', 'select', 'add', 'remove', 'change', 'dblclick', 'getfile', 'lockfiles', 'unlockfiles', 'selectfiles', 'unselectfiles', 'dragstart', 'dragstop', 'search', 'searchend', 'viewchange'],

            /**
             * Rules to validate data from backend
             *
             * @type Object
             **/
            rules = {},

            /**
             * Current working directory hash
             *
             * @type String
             **/
            cwd = '',

            /**
             * Current working directory options default
             *
             * @type Object
             **/
            cwdOptionsDefault = {
                path: '',
                url: '',
                tmbUrl: '',
                disabled: [],
                separator: '/',
                archives: [],
                extract: [],
                copyOverwrite: true,
                uploadOverwrite: true,
                uploadMaxSize: 0,
                jpgQuality: 100,
                tmbCrop: false,
                tmbReqCustomData: false,
                tmb: false // old API
            },

            /**
             * Current working directory options
             *
             * @type Object
             **/
            cwdOptions = {},

            /**
             * Files/dirs cache
             *
             * @type Object
             **/
            files = {},

            /**
             * Hidden Files/dirs cache
             *
             * @type Object
             **/
            hiddenFiles = {},

            /**
             * Files/dirs hash cache of each dirs
             *
             * @type Object
             **/
            ownFiles = {},

            /**
             * Selected files hashes
             *
             * @type Array
             **/
            selected = [],

            /**
             * Events listeners
             *
             * @type Object
             **/
            listeners = {},

            /**
             * Shortcuts
             *
             * @type Object
             **/
            shortcuts = {},

            /**
             * Buffer for copied files
             *
             * @type Array
             **/
            clipboard = [],

            /**
             * Copied/cuted files hashes
             * Prevent from remove its from cache.
             * Required for dispaly correct files names in error messages
             *
             * @type Object
             **/
            remember = {},

            /**
             * Queue for 'open' requests
             *
             * @type Array
             **/
            queue = [],

            /**
             * Queue for only cwd requests e.g. `tmb`
             *
             * @type Array
             **/
            cwdQueue = [],

            /**
             * Commands prototype
             *
             * @type Object
             **/
            base = new self.command(self),

            /**
             * elFinder node width
             *
             * @type String
             * @default "auto"
             **/
            width = 'auto',

            /**
             * elFinder node height
             * Number: pixcel or String: Number + "%"
             *
             * @type Number | String
             * @default 400
             **/
            height = 400,

            /**
             * Base node object or selector
             * Element which is the reference of the height percentage
             *
             * @type Object|String
             * @default null | $(window) (if height is percentage)
             **/
            heightBase = null,

            /**
             * MIME type list(Associative array) handled as a text file
             * 
             * @type Object|null
             */
            textMimes = null,

            /**
             * elfinder path for sound played on remove
             * @type String
             * @default ./sounds/
             **/
            soundPath = 'sounds/',

            /**
             * JSON.stringify of previous fm.sorters
             * @type String
             */
            prevSorterStr = '',

            /**
             * Map table of file extention to MIME-Type
             * @type Object
             */
            extToMimeTable,

            /**
             * Disabled page unload function
             * @type Boolean
             */
            diableUnloadCheck = false,

            beeper = $(document.createElement('audio')).hide().appendTo('body')[0],

            syncInterval,
            autoSyncStop = 0,

            uiCmdMapPrev = '',

            gcJobRes = null,

            open = function (data) {
                // NOTES: Do not touch data object

                var volumeid, contextmenu, emptyDirs = {}, stayDirs = {},
                    rmClass, hashes, calc, gc, collapsed, prevcwd, sorterStr, diff;

                if (self.api >= 2.1) {
                    // support volume driver option `uiCmdMap`
                    self.commandMap = (data.options.uiCmdMap && Object.keys(data.options.uiCmdMap).length) ? data.options.uiCmdMap : {};
                    if (uiCmdMapPrev !== JSON.stringify(self.commandMap)) {
                        uiCmdMapPrev = JSON.stringify(self.commandMap);
                    }
                } else {
                    self.options.sync = 0;
                }

                if (data.init) {
                    // init - reset cache
                    files = {};
                    ownFiles = {};
                } else {
                    // remove only files from prev cwd
                    // and collapsed directory (included 100+ directories) to empty for perfomance tune in DnD
                    prevcwd = cwd;
                    rmClass = 'elfinder-subtree-loaded ' + self.res('class', 'navexpand');
                    collapsed = self.res('class', 'navcollapse');
                    hashes = Object.keys(files);
                    calc = function (i) {
                        if (!files[i]) {
                            return true;
                        }

                        var isDir = (files[i].mime === 'directory'),
                            phash = files[i].phash,
                            pnav;

                        if (
                            (!isDir
                                || emptyDirs[phash]
                                || (!stayDirs[phash]
                                    && self.navHash2Elm(files[i].hash).is(':hidden')
                                    && self.navHash2Elm(phash).next('.elfinder-navbar-subtree').children().length > 100
                                )
                            )
                            && (isDir || phash !== cwd)
                            && !remember[i]
                        ) {
                            if (isDir && !emptyDirs[phash]) {
                                emptyDirs[phash] = true;
                                self.navHash2Elm(phash)
                                    .removeClass(rmClass)
                                    .next('.elfinder-navbar-subtree').empty();
                            }
                            deleteCache(files[i]);
                        } else if (isDir) {
                            stayDirs[phash] = true;
                        }
                    };
                    gc = function () {
                        if (hashes.length) {
                            gcJobRes && gcJobRes._abort();
                            gcJobRes = self.asyncJob(calc, hashes, {
                                interval: 20,
                                numPerOnce: 100
                            }).done(function () {
                                var hd = self.storage('hide') || { items: {} };
                                if (Object.keys(hiddenFiles).length) {
                                    $.each(hiddenFiles, function (h) {
                                        if (!hd.items[h]) {
                                            delete hiddenFiles[h];
                                        }
                                    });
                                }
                            });
                        }
                    };

                    self.trigger('filesgc').one('filesgc', function () {
                        hashes = [];
                    });

                    self.one('opendone', function () {
                        if (prevcwd !== cwd) {
                            if (!node.data('lazycnt')) {
                                gc();
                            } else {
                                self.one('lazydone', gc);
                            }
                        }
                    });
                }

                self.sorters = {};
                cwd = data.cwd.hash;
                cache(data.files);
                if (!files[cwd]) {
                    cache([data.cwd]);
                } else {
                    diff = self.diff([data.cwd], true);
                    if (diff.changed.length) {
                        cache(diff.changed, 'change');
                        self.change({ changed: diff.changed });
                    }
                }
                data.changed && data.changed.length && cache(data.changed, 'change');

                // trigger event 'sorterupdate'
                sorterStr = JSON.stringify(self.sorters);
                if (prevSorterStr !== sorterStr) {
                    self.trigger('sorterupdate');
                    prevSorterStr = sorterStr;
                }

                self.lastDir(cwd);

                self.autoSync();
            },

            /**
             * Store info about files/dirs in "files" object.
             *
             * @param  Array  files
             * @param  String data type
             * @return void
             **/
            cache = function (data, type) {
                var type = type || 'files',
                    keeps = ['sizeInfo', 'encoding'],
                    defsorter = { name: true, perm: true, date: true, size: true, kind: true },
                    sorterChk = !self.sorters._checked && (type === 'files'),
                    l = data.length,
                    setSorter = function (file) {
                        var f = file || {},
                            sorters = [];
                        $.each(self.sortRules, function (key) {
                            if (defsorter[key] || typeof f[key] !== 'undefined' || (key === 'mode' && typeof f.perm !== 'undefined')) {
                                sorters.push(key);
                            }
                        });
                        self.sorters = self.arrayFlip(sorters, true);
                        self.sorters._checked = true;
                    },
                    changedParents = {},
                    hideData = self.storage('hide') || {},
                    hides = hideData.items || {},
                    f, i, i1, keepProp, parents, hidden;

                for (i = 0; i < l; i++) {
                    f = Object.assign({}, data[i]);
                    hidden = (!hideData.show && hides[f.hash]) ? true : false;
                    if (f.name && f.hash && f.mime) {
                        if (!hidden) {
                            if (sorterChk && f.phash === cwd) {
                                setSorter(f);
                                sorterChk = false;
                            }

                            if (f.phash && (type === 'add' || (type === 'change' && (!files[f.hash] || f.size !== files[f.hash])))) {
                                if (parents = self.parents(f.phash)) {
                                    $.each(parents, function () {
                                        changedParents[this] = true;
                                    });
                                }
                            }
                        }

                        if (files[f.hash]) {
                            for (i1 = 0; i1 < keeps.length; i1++) {
                                if (files[f.hash][keeps[i1]] && !f[keeps[i1]]) {
                                    f[keeps[i1]] = files[f.hash][keeps[i1]];
                                }
                            }
                            if (f.sizeInfo && !f.size) {
                                f.size = f.sizeInfo.size;
                            }
                            deleteCache(files[f.hash], true);
                        }
                        if (hides[f.hash]) {
                            hiddenFiles[f.hash] = f;
                        }
                        if (hidden) {
                            l--;
                            data.splice(i--, 1);
                        } else {
                            files[f.hash] = f;
                            if (f.mime === 'directory' && !ownFiles[f.hash]) {
                                ownFiles[f.hash] = {};
                            }
                            if (f.phash) {
                                if (!ownFiles[f.phash]) {
                                    ownFiles[f.phash] = {};
                                }
                                ownFiles[f.phash][f.hash] = true;
                            }
                        }
                    }
                }
                // delete sizeInfo cache
                $.each(Object.keys(changedParents), function () {
                    var target = files[this];
                    if (target && target.sizeInfo) {
                        delete target.sizeInfo;
                    }
                });

                // for empty folder
                sorterChk && setSorter();
            },

            /**
             * Delete file object from files caches
             * 
             * @param  Array  removed hashes
             * @return void
             */
            remove = function (removed) {
                var l = removed.length,
                    roots = {},
                    rm = function (hash) {
                        var file = files[hash], i;
                        if (file) {
                            if (file.mime === 'directory') {
                                if (roots[hash]) {
                                    delete self.roots[roots[hash]];
                                }
                                // restore stats of deleted root parent directory
                                $.each(self.leafRoots, function (phash, roots) {
                                    var idx, pdir;
                                    if ((idx = $.inArray(hash, roots)) !== -1) {
                                        if (roots.length === 1) {
                                            if ((pdir = Object.assign({}, files[phash])) && pdir._realStats) {
                                                $.each(pdir._realStats, function (k, v) {
                                                    pdir[k] = v;
                                                });
                                                remove(files[phash]._realStats);
                                                self.change({ changed: [pdir] });
                                            }
                                            delete self.leafRoots[phash];
                                        } else {
                                            self.leafRoots[phash].splice(idx, 1);
                                        }
                                    }
                                });
                                if (self.searchStatus.state < 2) {
                                    $.each(files, function (h, f) {
                                        f.phash == hash && rm(h);
                                    });
                                }
                            }
                            if (file.phash) {
                                if (parents = self.parents(file.phash)) {
                                    $.each(parents, function () {
                                        changedParents[this] = true;
                                    });
                                }
                            }
                            deleteCache(files[hash]);
                        }
                    },
                    changedParents = {},
                    parents;

                $.each(self.roots, function (k, v) {
                    roots[v] = k;
                });
                while (l--) {
                    rm(removed[l]);
                }
                // delete sizeInfo cache
                $.each(Object.keys(changedParents), function () {
                    var target = files[this];
                    if (target && target.sizeInfo) {
                        delete target.sizeInfo;
                    }
                });
            },

            /**
             * Update file object in files caches
             * 
             * @param  Array  changed file objects
             * @return void
             * @deprecated should be use `cache(updatesArrayData, 'change');`
             */
            change = function (changed) {
                $.each(changed, function (i, file) {
                    var hash = file.hash;
                    if (files[hash]) {
                        $.each(Object.keys(files[hash]), function (i, v) {
                            if (typeof file[v] === 'undefined') {
                                delete files[hash][v];
                            }
                        });
                    }
                    files[hash] = files[hash] ? Object.assign(files[hash], file) : file;
                });
            },

            /**
             * Delete cache data of files, ownFiles and self.optionsByHashes
             * 
             * @param  Object  file
             * @param  Boolean update
             * @return void
             */
            deleteCache = function (file, update) {
                var hash = file.hash,
                    phash = file.phash;

                if (phash && ownFiles[phash]) {
                    delete ownFiles[phash][hash];
                }
                if (!update) {
                    ownFiles[hash] && delete ownFiles[hash];
                    self.optionsByHashes[hash] && delete self.optionsByHashes[hash];
                }
                delete files[hash];
            },

            /**
             * Maximum number of concurrent connections on request
             * 
             * @type Number
             */
            requestMaxConn,

            /**
             * Current number of connections
             * 
             * @type Number
             */
            requestCnt = 0,

            /**
             * Queue waiting for connection
             * 
             * @type Array
             */
            requestQueue = [],

            /**
             * Current open command instance
             * 
             * @type Object
             */
            currentOpenCmd = null,

            /**
             * Exec shortcut
             *
             * @param  jQuery.Event  keydown/keypress event
             * @return void
             */
            execShortcut = function (e) {
                var code = e.keyCode,
                    ctrlKey = !!(e.ctrlKey || e.metaKey),
                    isMousedown = e.type === 'mousedown',
                    ddm;

                !isMousedown && (self.keyState.keyCode = code);
                self.keyState.ctrlKey = ctrlKey;
                self.keyState.shiftKey = e.shiftKey;
                self.keyState.metaKey = e.metaKey;
                self.keyState.altKey = e.altKey;
                if (isMousedown) {
                    return;
                } else if (e.type === 'keyup') {
                    self.keyState.keyCode = null;
                    return;
                }

                if (enabled) {

                    $.each(shortcuts, function (i, shortcut) {
                        if (shortcut.type == e.type
                            && shortcut.keyCode == code
                            && shortcut.shiftKey == e.shiftKey
                            && shortcut.ctrlKey == ctrlKey
                            && shortcut.altKey == e.altKey) {
                            e.preventDefault();
                            e.stopPropagation();
                            shortcut.callback(e, self);
                            self.debug('shortcut-exec', i + ' : ' + shortcut.description);
                        }
                    });

                    // prevent tab out of elfinder
                    if (code == $.ui.keyCode.TAB && !$(e.target).is(':input')) {
                        e.preventDefault();
                    }

                    // cancel any actions by [Esc] key
                    if (e.type === 'keydown' && code == $.ui.keyCode.ESCAPE) {
                        // copy or cut 
                        if (!node.find('.ui-widget:visible').length) {
                            self.clipboard().length && self.clipboard([]);
                        }
                        // dragging
                        if ($.ui.ddmanager) {
                            ddm = $.ui.ddmanager.current;
                            ddm && ddm.helper && ddm.cancel();
                        }
                        // button menus
                        self.toHide(node.find('.ui-widget.elfinder-button-menu.elfinder-frontmost:visible'));
                        // trigger keydownEsc
                        self.trigger('keydownEsc', e);
                    }

                }
            },
            date = new Date(),
            utc,
            i18n,
            inFrame = (window.parent !== window),
            parentIframe = (function () {
                var pifm, ifms;
                if (inFrame) {
                    try {
                        ifms = $('iframe', window.parent.document);
                        if (ifms.length) {
                            $.each(ifms, function (i, ifm) {
                                if (ifm.contentWindow === window) {
                                    pifm = $(ifm);
                                    return false;
                                }
                            });
                        }
                    } catch (e) { }
                }
                return pifm;
            })(),
            /**
             * elFinder boot up function
             * 
             * @type Function
             */
            bootUp,
            /**
             * Original function of XMLHttpRequest.prototype.send
             * 
             * @type Function
             */
            savedXhrSend;

        // opts must be an object
        if (!opts) {
            opts = {};
        }

        // set UA.Angle, UA.Rotated for mobile devices
        if (self.UA.Mobile) {
            $(window).on('orientationchange.' + namespace, function () {
                var a = ((screen && screen.orientation && screen.orientation.angle) || window.orientation || 0) + 0;
                if (a === -90) {
                    a = 270;
                }
                self.UA.Angle = a;
                self.UA.Rotated = a % 180 === 0 ? false : true;
            }).trigger('orientationchange.' + namespace);
        }

        // check opt.bootCallback
        if (opts.bootCallback && typeof opts.bootCallback === 'function') {
            (function () {
                var func = bootCallback,
                    opFunc = opts.bootCallback;
                bootCallback = function (fm, extraObj) {
                    func && typeof func === 'function' && func.call(this, fm, extraObj);
                    opFunc.call(this, fm, extraObj);
                };
            })();
        }
        delete opts.bootCallback;

        /**
         * Protocol version
         *
         * @type String
         **/
        this.api = null;

        /**
         * elFinder use new api
         *
         * @type Boolean
         **/
        this.newAPI = false;

        /**
         * elFinder use old api
         *
         * @type Boolean
         **/
        this.oldAPI = false;

        /**
         * Net drivers names
         *
         * @type Array
         **/
        this.netDrivers = [];

        /**
         * Base URL of elfFinder library starting from Manager HTML
         * 
         * @type String
         */
        this.baseUrl = '';

        /**
         * Base URL of i18n js files
         * baseUrl + "js/i18n/" when empty value
         * 
         * @type String
         */
        this.i18nBaseUrl = '';

        /**
         * Base URL of worker js files
         * baseUrl + "js/worker/" when empty value
         * 
         * @type String
         */
        this.workerBaseUrl = '';

        /**
         * Is elFinder CSS loaded
         * 
         * @type Boolean
         */
        this.cssloaded = false;

        /**
         * Current theme object
         * 
         * @type Object|Null
         */
        this.theme = null;

        this.mimesCanMakeEmpty = {};

        /**
         * Callback function at boot up that option specified at elFinder starting
         * 
         * @type Function
         */
        this.bootCallback;

        /**
         * Callback function at reload(restart) elFinder 
         * 
         * @type Function
         */
        this.reloadCallback;

        /**
         * ID. Required to create unique cookie name
         *
         * @type String
         **/
        this.id = id;

        /**
         * Method to store/fetch data
         *
         * @type Function
         **/
        this.storage = (function () {
            try {
                if ('localStorage' in window && window.localStorage !== null) {
                    if (self.UA.Safari) {
                        // check for Mac/iOS safari private browsing mode
                        window.localStorage.setItem('elfstoragecheck', 1);
                        window.localStorage.removeItem('elfstoragecheck');
                    }
                    return self.localStorage;
                } else {
                    return self.cookie;
                }
            } catch (e) {
                return self.cookie;
            }
        })();

        /**
         * Set pause page unload check function or Get state
         *
         * @param      Boolean   state   To set state
         * @param      Boolean   keep    Keep disabled
         * @return     Boolean|void
         */
        this.pauseUnloadCheck = function (state, keep) {
            if (typeof state === 'undefined') {
                return diableUnloadCheck;
            } else {
                diableUnloadCheck = !!state;
                if (state && !keep) {
                    requestAnimationFrame(function () {
                        diableUnloadCheck = false;
                    });
                }
            }
        };

        /**
         * Configuration options
         *
         * @type Object
         **/
        //this.options = $.extend(true, {}, this._options, opts);
        this.options = Object.assign({}, this._options);

        // for old type configuration
        if (opts.uiOptions) {
            if (opts.uiOptions.toolbar && Array.isArray(opts.uiOptions.toolbar)) {
                if ($.isPlainObject(opts.uiOptions.toolbar[opts.uiOptions.toolbar.length - 1])) {
                    self.options.uiOptions.toolbarExtra = Object.assign(self.options.uiOptions.toolbarExtra || {}, opts.uiOptions.toolbar.pop());
                }
            }
        }

        // Overwrite if opts value is an array
        (function () {
            var arrOv = function (obj, base) {
                if ($.isPlainObject(obj)) {
                    $.each(obj, function (k, v) {
                        if ($.isPlainObject(v)) {
                            if (!base[k]) {
                                base[k] = {};
                            }
                            arrOv(v, base[k]);
                        } else {
                            base[k] = v;
                        }
                    });
                }
            };
            arrOv(opts, self.options);
        })();

        // join toolbarExtra to toolbar
        this.options.uiOptions.toolbar.push(this.options.uiOptions.toolbarExtra);
        delete this.options.uiOptions.toolbarExtra;

        /**
         * Arrays that has to unbind events
         * 
         * @type Object
         */
        this.toUnbindEvents = {};

        /**
         * Attach listener to events
         * To bind to multiply events at once, separate events names by space
         * 
         * @param  String  event(s) name(s)
         * @param  Object  event handler or {done: handler}
         * @param  Boolean priority first
         * @return elFinder
         */
        this.bind = function (event, callback, priorityFirst) {
            var i, len;

            if (callback && (typeof callback === 'function' || typeof callback.done === 'function')) {
                event = ('' + event).toLowerCase().replace(/^\s+|\s+$/g, '').split(/\s+/);

                len = event.length;
                for (i = 0; i < len; i++) {
                    if (listeners[event[i]] === void (0)) {
                        listeners[event[i]] = [];
                    }
                    listeners[event[i]][priorityFirst ? 'unshift' : 'push'](callback);
                }
            }
            return this;
        };

        /**
         * Remove event listener if exists
         * To un-bind to multiply events at once, separate events names by space
         *
         * @param  String    event(s) name(s)
         * @param  Function  callback
         * @return elFinder
         */
        this.unbind = function (event, callback) {
            var i, len, l, ci;

            event = ('' + event).toLowerCase().split(/\s+/);

            len = event.length;
            for (i = 0; i < len; i++) {
                if (l = listeners[event[i]]) {
                    ci = $.inArray(callback, l);
                    ci > -1 && l.splice(ci, 1);
                }
            }

            callback = null;
            return this;
        };

        /**
         * Fire event - send notification to all event listeners
         * In the callback `this` becames an event object
         *
         * @param  String   event type
         * @param  Object   data to send across event
         * @param  Boolean  allow modify data (call by reference of data) default: true
         * @return elFinder
         */
        this.trigger = function (evType, data, allowModify) {
            var type = evType.toLowerCase(),
                isopen = (type === 'open'),
                dataIsObj = (typeof data === 'object'),
                handlers = listeners[type] || [],
                dones = [],
                i, l, jst, event;

            this.debug('event-' + type, data);

            if (!dataIsObj || typeof allowModify === 'undefined') {
                allowModify = true;
            }
            if (l = handlers.length) {
                event = $.Event(type);
                if (data) {
                    data._getEvent = function () {
                        return event;
                    };
                }
                if (allowModify) {
                    event.data = data;
                }

                for (i = 0; i < l; i++) {
                    if (!handlers[i]) {
                        // probably un-binded this handler
                        continue;
                    }

                    // handler is $.Deferred(), call all functions upon completion
                    if (handlers[i].done) {
                        dones.push(handlers[i].done);
                        continue;
                    }

                    // set `event.data` only callback has argument
                    if (handlers[i].length) {
                        if (!allowModify) {
                            // to avoid data modifications. remember about "sharing" passing arguments in js :) 
                            if (typeof jst === 'undefined') {
                                try {
                                    jst = JSON.stringify(data);
                                } catch (e) {
                                    jst = false;
                                }
                            }
                            event.data = jst ? JSON.parse(jst) : data;
                        }
                    }

                    try {
                        if (handlers[i].call(event, event, this) === false || event.isDefaultPrevented()) {
                            this.debug('event-stoped', event.type);
                            break;
                        }
                    } catch (ex) {
                        window.console && window.console.log && window.console.log(ex);
                    }

                }

                // call done functions
                if (l = dones.length) {
                    for (i = 0; i < l; i++) {
                        try {
                            if (dones[i].call(event, event, this) === false || event.isDefaultPrevented()) {
                                this.debug('event-stoped', event.type + '(done)');
                                break;
                            }
                        } catch (ex) {
                            window.console && window.console.log && window.console.log(ex);
                        }
                    }
                }

                if (this.toUnbindEvents[type] && this.toUnbindEvents[type].length) {
                    $.each(this.toUnbindEvents[type], function (i, v) {
                        self.unbind(v.type, v.callback);
                    });
                    delete this.toUnbindEvents[type];
                }
            }
            return this;
        };

        /**
         * Get event listeners
         *
         * @param  String   event type
         * @return Array    listed event functions
         */
        this.getListeners = function (event) {
            return event ? listeners[event.toLowerCase()] : listeners;
        };

        // set fm.baseUrl
        this.baseUrl = (function () {
            var myTag, base, baseUrl;

            if (self.options.baseUrl) {
                return self.options.baseUrl;
            } else {
                baseUrl = '';
                myTag = null;
                $('head > script').each(function () {
                    if (this.src && this.src.match(/js\/elfinder(?:-[a-z0-9_-]+)?\.(?:min|full)\.js(?:$|\?)/i)) {
                        myTag = $(this);
                        return false;
                    }
                });
                if (myTag) {
                    baseUrl = myTag.attr('src').replace(/js\/[^\/]+$/, '');
                    if (!baseUrl.match(/^(https?\/\/|\/)/)) {
                        // check <base> tag
                        if (base = $('head > base[href]').attr('href')) {
                            baseUrl = base.replace(/\/$/, '') + '/' + baseUrl;
                        }
                    }
                }
                if (baseUrl !== '') {
                    self.options.baseUrl = baseUrl;
                } else {
                    if (!self.options.baseUrl) {
                        self.options.baseUrl = './';
                    }
                    baseUrl = self.options.baseUrl;
                }
                return baseUrl;
            }
        })();

        this.i18nBaseUrl = (this.options.i18nBaseUrl || this.baseUrl + 'js/i18n').replace(/\/$/, '') + '/';
        this.workerBaseUrl = (this.options.workerBaseUrl || this.baseUrl + 'js/worker').replace(/\/$/, '') + '/';

        this.options.maxErrorDialogs = Math.max(1, parseInt(this.options.maxErrorDialogs || 5));

        // set dispInlineRegex
        cwdOptionsDefault.dispInlineRegex = this.options.dispInlineRegex;

        // auto load required CSS
        if (this.options.cssAutoLoad) {
            (function () {
                var baseUrl = self.baseUrl,
                    myCss = $('head > link[href$="css/elfinder.min.css"],link[href$="css/elfinder.full.css"]:first').length,
                    rmTag = function () {
                        if (node.data('cssautoloadHide')) {
                            node.data('cssautoloadHide').remove();
                            node.removeData('cssautoloadHide');
                        }
                    },
                    loaded = function () {
                        if (!self.cssloaded) {
                            rmTag();
                            self.cssloaded = true;
                            self.trigger('cssloaded');
                        }
                    };

                if (!myCss) {
                    // to request CSS auto loading
                    self.cssloaded = null;
                }

                // additional CSS files
                if (Array.isArray(self.options.cssAutoLoad)) {
                    if (!self.options.themes.default) {
                        // set as default theme
                        self.options.themes = Object.assign({
                            'default': {
                                'name': 'default',
                                'cssurls': self.options.cssAutoLoad
                            }
                        }, self.options.themes);
                        if (!self.options.theme) {
                            self.options.theme = 'default';
                        }
                    } else {
                        if (self.cssloaded === true) {
                            self.loadCss(self.options.cssAutoLoad);
                        } else {
                            self.bind('cssloaded', function () {
                                self.loadCss(self.options.cssAutoLoad);
                            });
                        }
                    }
                }

                // try to load main css
                if (self.cssloaded === null) {
                    // hide elFinder node while css loading
                    node.addClass('elfinder')
                        .data('cssautoloadHide', $('<style>.elfinder{visibility:hidden;overflow:hidden}</style>'));
                    $('head').append(node.data('cssautoloadHide'));

                    // set default theme
                    if (!self.options.themes.default) {
                        self.options.themes = Object.assign({
                            'default': {
                                'name': 'default',
                                'cssurls': 'css/theme.css',
                                'author': 'elFinder Project',
                                'license': '3-clauses BSD'
                            }
                        }, self.options.themes);
                        if (!self.options.theme) {
                            self.options.theme = 'default';
                        }
                    }

                    // Delay 'visibility' check it required for browsers such as Safari
                    requestAnimationFrame(function () {
                        if (node.css('visibility') === 'hidden') {
                            // load CSS
                            self.loadCss([baseUrl + 'css/elfinder.min.css'], {
                                dfd: $.Deferred().done(function () {
                                    loaded();
                                }).fail(function () {
                                    rmTag();
                                    if (!self.cssloaded) {
                                        self.cssloaded = false;
                                        self.bind('init', function () {
                                            if (!self.cssloaded) {
                                                self.error(['errRead', 'CSS (elfinder.min)']);
                                            }
                                        });
                                    }
                                })
                            });
                        } else {
                            loaded();
                        }
                    });
                }
            })();
        }

        // load theme if exists
        (function () {
            var theme,
                themes = self.options.themes,
                ids = Object.keys(themes || {});
            if (ids.length) {
                theme = self.storage('theme') || self.options.theme;
                if (!themes[theme]) {
                    theme = ids[0];
                }
                if (self.cssloaded) {
                    self.changeTheme(theme);
                } else {
                    self.bind('cssloaded', function () {
                        self.changeTheme(theme);
                    });
                }
            }
        })();

        /**
         * Volume option to set the properties of the root Stat
         * 
         * @type Object
         */
        this.optionProperties = {
            icon: void (0),
            csscls: void (0),
            tmbUrl: void (0),
            uiCmdMap: {},
            netkey: void (0),
            disabled: []
        };

        if (!inFrame && !this.options.enableAlways && $('body').children().length === 2) { // only node and beeper
            this.options.enableAlways = true;
        }

        // make options.debug
        if (this.options.debug === true) {
            this.options.debug = 'all';
        } else if (Array.isArray(this.options.debug)) {
            (function () {
                var d = {};
                $.each(self.options.debug, function () {
                    d[this] = true;
                });
                self.options.debug = d;
            })();
        } else {
            this.options.debug = false;
        }

        /**
         * Original functions evacuated by conflict check
         * 
         * @type Object
         */
        this.noConflicts = {};

        /**
         * Check and save conflicts with bootstrap etc
         * 
         * @type Function
         */
        this.noConflict = function () {
            $.each(conflictChecks, function (i, p) {
                if ($.fn[p] && typeof $.fn[p].noConflict === 'function') {
                    self.noConflicts[p] = $.fn[p].noConflict();
                }
            });
        };
        // do check conflict
        this.noConflict();

        /**
         * Is elFinder over CORS
         *
         * @type Boolean
         **/
        this.isCORS = false;

        // configure for CORS
        (function () {
            if (typeof self.options.cors !== 'undefined' && self.options.cors !== null) {
                self.isCORS = self.options.cors ? true : false;
            } else {
                var parseUrl = document.createElement('a'),
                    parseUploadUrl,
                    selfProtocol = window.location.protocol,
                    portReg = function (protocol) {
                        protocol = (!protocol || protocol === ':') ? selfProtocol : protocol;
                        return protocol === 'https:' ? /\:443$/ : /\:80$/;
                    },
                    selfHost = window.location.host.replace(portReg(selfProtocol), '');
                parseUrl.href = opts.url;
                if (opts.urlUpload && (opts.urlUpload !== opts.url)) {
                    parseUploadUrl = document.createElement('a');
                    parseUploadUrl.href = opts.urlUpload;
                }
                if (selfHost !== parseUrl.host.replace(portReg(parseUrl.protocol), '')
                    || (parseUrl.protocol !== ':' && parseUrl.protocol !== '' && (selfProtocol !== parseUrl.protocol))
                    || (parseUploadUrl &&
                        (selfHost !== parseUploadUrl.host.replace(portReg(parseUploadUrl.protocol), '')
                            || (parseUploadUrl.protocol !== ':' && parseUploadUrl.protocol !== '' && (selfProtocol !== parseUploadUrl.protocol))
                        )
                    )
                ) {
                    self.isCORS = true;
                }
            }
            if (self.isCORS) {
                if (!$.isPlainObject(self.options.customHeaders)) {
                    self.options.customHeaders = {};
                }
                if (!$.isPlainObject(self.options.xhrFields)) {
                    self.options.xhrFields = {};
                }
                self.options.requestType = 'post';
                self.options.customHeaders['X-Requested-With'] = 'XMLHttpRequest';
                self.options.xhrFields['withCredentials'] = true;
            }
        })();

        /**
         * Ajax request type
         *
         * @type String
         * @default "get"
         **/
        this.requestType = /^(get|post)$/i.test(this.options.requestType) ? this.options.requestType.toLowerCase() : 'get';

        // set `requestMaxConn` by option
        requestMaxConn = Math.max(parseInt(this.options.requestMaxConn), 1);

        /**
         * Custom data that given as options
         * 
         * @type Object
         * @default {}
         */
        this.optsCustomData = $.isPlainObject(this.options.customData) ? this.options.customData : {};

        /**
         * Any data to send across every ajax request
         *
         * @type Object
         * @default {}
         **/
        this.customData = Object.assign({}, this.optsCustomData);

        /**
         * Previous custom data from connector
         * 
         * @type Object|null
         */
        this.prevCustomData = null;

        /**
         * Any custom headers to send across every ajax request
         *
         * @type Object
         * @default {}
        */
        this.customHeaders = $.isPlainObject(this.options.customHeaders) ? this.options.customHeaders : {};

        /**
         * Any custom xhrFields to send across every ajax request
         *
         * @type Object
         * @default {}
         */
        this.xhrFields = $.isPlainObject(this.options.xhrFields) ? this.options.xhrFields : {};

        /**
         * Replace XMLHttpRequest.prototype.send to extended function for 3rd party libs XHR request etc.
         * 
         * @type Function
         */
        this.replaceXhrSend = function () {
            if (!savedXhrSend) {
                savedXhrSend = XMLHttpRequest.prototype.send;
            }
            XMLHttpRequest.prototype.send = function () {
                var xhr = this;
                // set request headers
                if (self.customHeaders) {
                    $.each(self.customHeaders, function (key) {
                        xhr.setRequestHeader(key, this);
                    });
                }
                // set xhrFields
                if (self.xhrFields) {
                    $.each(self.xhrFields, function (key) {
                        if (key in xhr) {
                            xhr[key] = this;
                        }
                    });
                }
                return savedXhrSend.apply(this, arguments);
            };
        };

        /**
         * Restore saved original XMLHttpRequest.prototype.send
         * 
         * @type Function
         */
        this.restoreXhrSend = function () {
            savedXhrSend && (XMLHttpRequest.prototype.send = savedXhrSend);
        };

        /**
         * command names for into queue for only cwd requests
         * these commands aborts before `open` request
         *
         * @type Array
         * @default ['tmb', 'parents']
         */
        this.abortCmdsOnOpen = this.options.abortCmdsOnOpen || ['tmb', 'parents'];

        /**
         * ui.nav id prefix
         * 
         * @type String
         */
        this.navPrefix = 'nav' + (elFinder.prototype.uniqueid ? elFinder.prototype.uniqueid : '') + '-';

        /**
         * ui.cwd id prefix
         * 
         * @type String
         */
        this.cwdPrefix = elFinder.prototype.uniqueid ? ('cwd' + elFinder.prototype.uniqueid + '-') : '';

        // Increment elFinder.prototype.uniqueid
        ++elFinder.prototype.uniqueid;

        /**
         * URL to upload files
         *
         * @type String
         **/
        this.uploadURL = opts.urlUpload || opts.url;

        /**
         * Events namespace
         *
         * @type String
         **/
        this.namespace = namespace;

        /**
         * Today timestamp
         *
         * @type Number
         **/
        this.today = (new Date(date.getFullYear(), date.getMonth(), date.getDate())).getTime() / 1000;

        /**
         * Yesterday timestamp
         *
         * @type Number
         **/
        this.yesterday = this.today - 86400;

        utc = this.options.UTCDate ? 'UTC' : '';

        this.getHours = 'get' + utc + 'Hours';
        this.getMinutes = 'get' + utc + 'Minutes';
        this.getSeconds = 'get' + utc + 'Seconds';
        this.getDate = 'get' + utc + 'Date';
        this.getDay = 'get' + utc + 'Day';
        this.getMonth = 'get' + utc + 'Month';
        this.getFullYear = 'get' + utc + 'FullYear';

        /**
         * elFinder node z-index (auto detect on elFinder load)
         *
         * @type null | Number
         **/
        this.zIndex;

        /**
         * Current search status
         * 
         * @type Object
         */
        this.searchStatus = {
            state: 0, // 0: search ended, 1: search started, 2: in search result
            query: '',
            target: '',
            mime: '',
            mixed: false, // in multi volumes search: false or Array that target volume ids
            ininc: false // in incremental search
        };

        /**
         * Interface language
         *
         * @type String
         * @default "en"
         **/
        this.lang = this.storage('lang') || this.options.lang;
        if (this.lang === 'jp') {
            this.lang = this.options.lang = 'ja';
        }

        this.viewType = this.storage('view') || this.options.defaultView || 'icons';

        this.sortType = this.storage('sortType') || this.options.sortType || 'name';

        this.sortOrder = this.storage('sortOrder') || this.options.sortOrder || 'asc';

        this.sortStickFolders = this.storage('sortStickFolders');
        if (this.sortStickFolders === null) {
            this.sortStickFolders = !!this.options.sortStickFolders;
        } else {
            this.sortStickFolders = !!this.sortStickFolders;
        }

        this.sortAlsoTreeview = this.storage('sortAlsoTreeview');
        if (this.sortAlsoTreeview === null || this.options.sortAlsoTreeview === null) {
            this.sortAlsoTreeview = !!this.options.sortAlsoTreeview;
        } else {
            this.sortAlsoTreeview = !!this.sortAlsoTreeview;
        }

        this.sortRules = $.extend(true, {}, this._sortRules, this.options.sortRules);

        $.each(this.sortRules, function (name, method) {
            if (typeof method != 'function') {
                delete self.sortRules[name];
            }
        });

        this.compare = $.proxy(this.compare, this);

        /**
         * Delay in ms before open notification dialog
         *
         * @type Number
         * @default 500
         **/
        this.notifyDelay = this.options.notifyDelay > 0 ? parseInt(this.options.notifyDelay) : 500;

        /**
         * Dragging UI Helper object
         *
         * @type jQuery | null
         **/
        this.draggingUiHelper = null;

        /**
         * Base droppable options
         *
         * @type Object
         **/
        this.droppable = {
            greedy: true,
            tolerance: 'pointer',
            accept: '.elfinder-cwd-file-wrapper,.elfinder-navbar-dir,.elfinder-cwd-file,.elfinder-cwd-filename',
            hoverClass: this.res('class', 'adroppable'),
            classes: { // Deprecated hoverClass jQueryUI>=1.12.0
                'ui-droppable-hover': this.res('class', 'adroppable')
            },
            autoDisable: true, // elFinder original, see jquery.elfinder.js
            drop: function (e, ui) {
                var dst = $(this),
                    targets = $.grep(ui.helper.data('files') || [], function (h) { return h ? true : false; }),
                    result = [],
                    dups = [],
                    faults = [],
                    isCopy = ui.helper.hasClass('elfinder-drag-helper-plus'),
                    c = 'class',
                    cnt, hash, i, h;

                if (typeof e.button === 'undefined' || ui.helper.data('namespace') !== namespace || !self.insideWorkzone(e.pageX, e.pageY)) {
                    return false;
                }
                if (dst.hasClass(self.res(c, 'cwdfile'))) {
                    hash = self.cwdId2Hash(dst.attr('id'));
                } else if (dst.hasClass(self.res(c, 'navdir'))) {
                    hash = self.navId2Hash(dst.attr('id'));
                } else {
                    hash = cwd;
                }

                cnt = targets.length;

                while (cnt--) {
                    h = targets[cnt];
                    // ignore drop into itself or in own location
                    if (h != hash && files[h].phash != hash) {
                        result.push(h);
                    } else {
                        ((isCopy && h !== hash && files[hash].write) ? dups : faults).push(h);
                    }
                }

                if (faults.length) {
                    return false;
                }

                ui.helper.data('droped', true);

                if (dups.length) {
                    ui.helper.hide();
                    self.exec('duplicate', dups, { _userAction: true });
                }

                if (result.length) {
                    ui.helper.hide();
                    self.clipboard(result, !isCopy);
                    self.exec('paste', hash, { _userAction: true }, hash).always(function () {
                        self.clipboard([]);
                        self.trigger('unlockfiles', { files: targets });
                    });
                    self.trigger('drop', { files: targets });
                }
            }
        };

        /**
         * Return true if filemanager is active
         *
         * @return Boolean
         **/
        this.enabled = function () {
            return enabled && this.visible();
        };

        /**
         * Return true if filemanager is visible
         *
         * @return Boolean
         **/
        this.visible = function () {
            return node[0].elfinder && node.is(':visible');
        };

        /**
         * Return file is root?
         * 
         * @param  Object  target file object
         * @return Boolean
         */
        this.isRoot = function (file) {
            return (file.isroot || !file.phash) ? true : false;
        };

        /**
         * Return root dir hash for current working directory
         * 
         * @param  String   target hash
         * @param  Boolean  include fake parent (optional)
         * @return String
         */
        this.root = function (hash, fake) {
            hash = hash || cwd;
            var dir, i;

            if (!fake) {
                $.each(self.roots, function (id, rhash) {
                    if (hash.indexOf(id) === 0) {
                        dir = rhash;
                        return false;
                    }
                });
                if (dir) {
                    return dir;
                }
            }

            dir = files[hash];
            while (dir && dir.phash && (fake || !dir.isroot)) {
                dir = files[dir.phash];
            }
            if (dir) {
                return dir.hash;
            }

            while (i in files && files.hasOwnProperty(i)) {
                dir = files[i];
                if (dir.mime === 'directory' && !dir.phash && dir.read) {
                    return dir.hash;
                }
            }

            return '';
        };

        /**
         * Return current working directory info
         * 
         * @return Object
         */
        this.cwd = function () {
            return files[cwd] || {};
        };

        /**
         * Return required cwd option
         * 
         * @param  String  option name
         * @param  String  target hash (optional)
         * @return mixed
         */
        this.option = function (name, target) {
            var res, item;
            target = target || cwd;
            if (self.optionsByHashes[target] && typeof self.optionsByHashes[target][name] !== 'undefined') {
                return self.optionsByHashes[target][name];
            }
            if (self.hasVolOptions && cwd !== target && (!(item = self.file(target)) || item.phash !== cwd)) {
                res = '';
                $.each(self.volOptions, function (id, opt) {
                    if (target.indexOf(id) === 0) {
                        res = opt[name] || '';
                        return false;
                    }
                });
                return res;
            } else {
                return cwdOptions[name] || '';
            }
        };

        /**
         * Return disabled commands by each folder
         * 
         * @param  Array  target hashes
         * @return Array
         */
        this.getDisabledCmds = function (targets, flip) {
            var disabled = { 'hidden': true };
            if (!Array.isArray(targets)) {
                targets = [targets];
            }
            $.each(targets, function (i, h) {
                var disCmds = self.option('disabledFlip', h);
                if (disCmds) {
                    Object.assign(disabled, disCmds);
                }
            });
            return flip ? disabled : Object.keys(disabled);
        };

        /**
         * Return file data from current dir or tree by it's hash
         * 
         * @param  String  file hash
         * @return Object
         */
        this.file = function (hash, alsoHidden) {
            return hash ? (files[hash] || (alsoHidden ? hiddenFiles[hash] : void (0))) : void (0);
        };

        /**
         * Return all cached files
         * 
         * @param  String  parent hash
         * @return Object
         */
        this.files = function (phash) {
            var items = {};
            if (phash) {
                if (!ownFiles[phash]) {
                    return {};
                }
                $.each(ownFiles[phash], function (h) {
                    if (files[h]) {
                        items[h] = files[h];
                    } else {
                        delete ownFiles[phash][h];
                    }
                });
                return Object.assign({}, items);
            }
            return Object.assign({}, files);
        };

        /**
         * Return list of file parents hashes include file hash
         * 
         * @param  String  file hash
         * @return Array
         */
        this.parents = function (hash) {
            var parents = [],
                dir;

            while (hash && (dir = this.file(hash))) {
                parents.unshift(dir.hash);
                hash = dir.phash;
            }
            return parents;
        };

        this.path2array = function (hash, i18) {
            var file,
                path = [];

            while (hash) {
                if ((file = files[hash]) && file.hash) {
                    path.unshift(i18 && file.i18 ? file.i18 : file.name);
                    hash = file.isroot ? null : file.phash;
                } else {
                    path = [];
                    break;
                }
            }

            return path;
        };

        /**
         * Return file path or Get path async with jQuery.Deferred
         * 
         * @param  Object  file
         * @param  Boolean i18
         * @param  Object  asyncOpt
         * @return String|jQuery.Deferred
         */
        this.path = function (hash, i18, asyncOpt) {
            var path = files[hash] && files[hash].path
                ? files[hash].path
                : this.path2array(hash, i18).join(cwdOptions.separator);
            if (!asyncOpt || !files[hash]) {
                return path;
            } else {
                asyncOpt = Object.assign({ notify: { type: 'parents', cnt: 1, hideCnt: true } }, asyncOpt);

                var dfd = $.Deferred(),
                    notify = asyncOpt.notify,
                    noreq = false,
                    req = function () {
                        self.request({
                            data: { cmd: 'parents', target: files[hash].phash },
                            notify: notify,
                            preventFail: true
                        })
                            .done(done)
                            .fail(function () {
                                dfd.reject();
                            });
                    },
                    done = function () {
                        self.one('parentsdone', function () {
                            path = self.path(hash, i18);
                            if (path === '' && noreq) {
                                //retry with request
                                noreq = false;
                                req();
                            } else {
                                if (notify) {
                                    clearTimeout(ntftm);
                                    notify.cnt = -(parseInt(notify.cnt || 0));
                                    self.notify(notify);
                                }
                                dfd.resolve(path);
                            }
                        });
                    },
                    ntftm;

                if (path) {
                    return dfd.resolve(path);
                } else {
                    if (self.ui['tree']) {
                        // try as no request
                        if (notify) {
                            ntftm = setTimeout(function () {
                                self.notify(notify);
                            }, self.notifyDelay);
                        }
                        noreq = true;
                        done(true);
                    } else {
                        req();
                    }
                    return dfd;
                }
            }
        };

        /**
         * Return file url if set
         * 
         * @param  String  file hash
         * @param  Object  Options
         * @return String|Object of jQuery Deferred
         */
        this.url = function (hash, o) {
            var file = files[hash],
                opts = o || {},
                async = opts.async || false,
                temp = opts.temporary || false,
                onetm = (opts.onetime && self.option('onetimeUrl', hash)) || false,
                absurl = opts.absurl || false,
                dfrd = (async || onetm) ? $.Deferred() : null,
                filter = function (url) {
                    if (url && absurl) {
                        url = self.convAbsUrl(url);
                    }
                    return url;
                },
                getUrl = function (url) {
                    if (url) {
                        return filter(url);
                    }
                    if (file.url) {
                        return filter(file.url);
                    }

                    if (typeof baseUrl === 'undefined') {
                        baseUrl = getBaseUrl();
                    }

                    if (baseUrl) {
                        return filter(baseUrl + $.map(self.path2array(hash), function (n) { return encodeURIComponent(n); }).slice(1).join('/'));
                    }

                    var params = Object.assign({}, self.customData, {
                        cmd: 'file',
                        target: file.hash
                    });
                    if (self.oldAPI) {
                        params.cmd = 'open';
                        params.current = file.phash;
                    }
                    return filter(self.options.url + (self.options.url.indexOf('?') === -1 ? '?' : '&') + $.param(params, true));
                },
                getBaseUrl = function () {
                    return self.option('url', (!self.isRoot(file) && file.phash) || file.hash);
                },
                baseUrl, res;

            if (!file || !file.read) {
                return async ? dfrd.resolve('') : '';
            }

            if (onetm && (!file.url || file.url == '1') && !(baseUrl = getBaseUrl())) {
                async = true;
                this.request({
                    data: { cmd: 'url', target: hash, options: { onetime: 1 } },
                    preventDefault: true,
                    options: { async: async },
                    notify: { type: 'file', cnt: 1, hideCnt: true },
                    progressBar: opts.progressBar
                }).done(function (data) {
                    dfrd.resolve(filter(data.url || ''));
                }).fail(function () {
                    dfrd.resolve('');
                });
            } else {
                if (file.url == '1' || (temp && !file.url && !(baseUrl = getBaseUrl()))) {
                    this.request({
                        data: { cmd: 'url', target: hash, options: { temporary: temp ? 1 : 0 } },
                        preventDefault: true,
                        options: { async: async },
                        notify: async ? { type: temp ? 'file' : 'url', cnt: 1, hideCnt: true } : {},
                        progressBar: opts.progressBar
                    })
                        .done(function (data) {
                            file.url = data.url || '';
                        })
                        .fail(function () {
                            file.url = '';
                        })
                        .always(function () {
                            var url;
                            if (file.url && temp) {
                                url = file.url;
                                file.url = '1'; // restore
                            }
                            if (async) {
                                dfrd.resolve(getUrl(url));
                            } else {
                                return getUrl(url);
                            }
                        });
                } else {
                    if (async) {
                        dfrd.resolve(getUrl());
                    } else {
                        return getUrl();
                    }
                }
            }
            if (async) {
                return dfrd;
            }
        };

        /**
         * Return file url for the extarnal service
         *
         * @param      String  hash     The hash
         * @param      Object  options  The options
         * @return     Object  jQuery Deferred
         */
        this.forExternalUrl = function (hash, options) {
            var onetime = self.option('onetimeUrl', hash),
                opts = {
                    async: true,
                    absurl: true
                };

            opts[onetime ? 'onetime' : 'temporary'] = true;
            return self.url(hash, Object.assign({}, options, opts));
        };

        /**
         * Return file url for open in elFinder
         * 
         * @param  String  file hash
         * @param  Boolean for download link
         * @param      Object  requestOpts   The request options
         * @return String
         */
        this.openUrl = function (hash, download, callback, requestOpts) {
            var file = files[hash],
                url = '',
                onetimeSize = (requestOpts || {}).onetimeSize || (5 * 1024 * 1024);

            if (!file || !file.read) {
                return '';
            }

            if (!download || download === 'sameorigin') {
                if (file.url) {
                    if (file.url != 1) {
                        url = file.url;
                    }
                } else if (cwdOptions.url && file.hash.indexOf(self.cwd().volumeid) === 0) {
                    url = cwdOptions.url + $.map(this.path2array(hash), function (n) { return encodeURIComponent(n); }).slice(1).join('/');
                }
                if (!download || this.isSameOrigin(url)) {
                    if (url) {
                        url += (url.match(/\?/) ? '&' : '?') + '_'.repeat((url.match(/[\?&](_+)t=/g) || ['&t=']).sort().shift().match(/[\?&](_*)t=/)[1].length + 1) + 't=' + (file.ts || parseInt(+new Date() / 1000));
                        if (callback) {
                            callback(url);
                            return;
                        } else {
                            return url;
                        }
                    }
                }
            }

            if (callback && this.hasParrotHeaders()) {
                if (!requestOpts) {
                    requestOpts = {};
                } else {
                    delete requestOpts.onetimeSize;
                }
                if (!requestOpts.onetime && !requestOpts.temporary && file.size > onetimeSize) {
                    if (file.mime.match(/^video|audio/)) {
                        requestOpts.temporary = true;
                    } else {
                        requestOpts.onetime = true;
                    }
                }
                if (requestOpts.onetime || requestOpts.temporary) {
                    return this.url(file.hash, Object.assign({
                        async: true
                    }, requestOpts)).done(function (url) {
                        callback(url);
                    }).fail(function () {
                        callback('');
                    });
                } else {
                    return this.getContents(hash, 'blob', requestOpts).done(function (blob) {
                        url = (window.URL || window.webkitURL).createObjectURL(blob);
                        callback(url);
                    }).fail(function () {
                        callback('');
                    });
                }
            } else {
                url = this.options.url;
                url = url + (url.indexOf('?') === -1 ? '?' : '&')
                    + (this.oldAPI ? 'cmd=open&current=' + file.phash : 'cmd=file')
                    + '&target=' + file.hash
                    + '&_t=' + (file.ts || parseInt(+new Date() / 1000));

                if (download === true) {
                    url += '&download=1';
                }

                $.each(this.customData, function (key, val) {
                    url += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(val);
                });
                if (callback) {
                    callback(url);
                    return;
                } else {
                    return url;
                }
            }
        };

        /**
         * Return thumbnail url
         * 
         * @param  Object  file object
         * @return String
         */
        this.tmb = function (file) {
            var tmbUrl, tmbCrop,
                cls = 'elfinder-cwd-bgurl',
                url = '',
                cData = {},
                n = 0;

            if ($.isPlainObject(file)) {
                if (self.searchStatus.state && file.hash.indexOf(self.cwd().volumeid) !== 0) {
                    tmbUrl = self.option('tmbUrl', file.hash);
                    tmbCrop = self.option('tmbCrop', file.hash);
                } else {
                    tmbUrl = cwdOptions.tmbUrl;
                    tmbCrop = cwdOptions.tmbCrop;
                }
                if (tmbCrop) {
                    cls += ' elfinder-cwd-bgurl-crop';
                }
                if (tmbUrl === 'self' && file.mime.indexOf('image/') === 0) {
                    url = self.openUrl(file.hash);
                    cls += ' elfinder-cwd-bgself';
                } else if ((self.oldAPI || tmbUrl) && file && file.tmb && file.tmb != 1) {
                    url = tmbUrl + file.tmb;
                } else if (self.newAPI && file && file.tmb && file.tmb != 1) {
                    url = file.tmb;
                }
                if (url) {
                    if (tmbUrl !== 'self') {
                        if (file.ts) {
                            cData._t = file.ts;
                        }
                        if (cwdOptions.tmbReqCustomData && Object.keys(this.customData).length) {
                            cData = Object.assign(cData, this.customData);
                        }
                        if (Object.keys(cData).length) {
                            url += (url.match(/\?/) ? '&' : '?');
                            $.each(cData, function (key, val) {
                                url += ((n++ === 0) ? '' : '&') + encodeURIComponent(key) + '=' + encodeURIComponent(val);
                            });
                        }
                    }
                    return { url: url, className: cls };
                }
            }

            return false;
        };

        /**
         * Return selected files hashes
         *
         * @return Array
         **/
        this.selected = function () {
            return selected.slice(0);
        };

        /**
         * Return selected files info
         * 
         * @return Array
         */
        this.selectedFiles = function () {
            return $.map(selected, function (hash) { return files[hash] ? Object.assign({}, files[hash]) : null; });
        };

        /**
         * Return true if file with required name existsin required folder
         * 
         * @param  String  file name
         * @param  String  parent folder hash
         * @return Boolean
         */
        this.fileByName = function (name, phash) {
            var hash;

            for (hash in files) {
                if (files.hasOwnProperty(hash) && files[hash].phash == phash && files[hash].name == name) {
                    return files[hash];
                }
            }
        };

        /**
         * Valid data for required command based on rules
         * 
         * @param  String  command name
         * @param  Object  cammand's data
         * @return Boolean
         */
        this.validResponse = function (cmd, data) {
            return data.error || this.rules[this.rules[cmd] ? cmd : 'defaults'](data);
        };

        /**
         * Return bytes from ini formated size
         * 
         * @param  String  ini formated size
         * @return Integer
         */
        this.returnBytes = function (val) {
            var last;
            if (isNaN(val)) {
                if (!val) {
                    val = '';
                }
                // for ex. 1mb, 1KB
                val = val.replace(/b$/i, '');
                last = val.charAt(val.length - 1).toLowerCase();
                val = val.replace(/[tgmk]$/i, '');
                if (last == 't') {
                    val = val * 1024 * 1024 * 1024 * 1024;
                } else if (last == 'g') {
                    val = val * 1024 * 1024 * 1024;
                } else if (last == 'm') {
                    val = val * 1024 * 1024;
                } else if (last == 'k') {
                    val = val * 1024;
                }
                val = isNaN(val) ? 0 : parseInt(val);
            } else {
                val = parseInt(val);
                if (val < 1) val = 0;
            }
            return val;
        };

        /**
         * Process ajax request.
         * Fired events :
         * @todo
         * @example
         * @todo
         * @return $.Deferred
         */
        this.request = function (opts) {
            var self = this,
                o = this.options,
                dfrd = $.Deferred(),
                // request ID
                reqId = (+ new Date()).toString(16) + Math.floor(1000 * Math.random()).toString(16),
                // request data
                data = Object.assign({}, self.customData, { mimes: o.onlyMimes }, opts.data || opts),
                // command name
                cmd = data.cmd,
                // request type is binary
                isBinary = (opts.options || {}).dataType === 'binary',
                // current cmd is "open"
                isOpen = (!opts.asNotOpen && cmd === 'open'),
                // call default fail callback (display error dialog) ?
                deffail = !(isBinary || opts.preventDefault || opts.preventFail),
                // call default success callback ?
                defdone = !(isBinary || opts.preventDefault || opts.preventDone),
                // current progress of receive data
                prog = opts.progressVal || 20,
                // timer of fake progress
                progTm = null,
                // whether the notification dialog is currently displayed
                hasNotify = false,
                // options for notify dialog
                notify = !opts.progressBar ? (opts.notify ? Object.assign({ progress: prog * opts.notify.cnt }, opts.notify) : {}) : {},
                // make cancel button
                cancel = !!opts.cancel,
                // do not normalize data - return as is
                raw = isBinary || !!opts.raw,
                // sync files on request fail
                syncOnFail = opts.syncOnFail,
                // use lazy()
                lazy = !!opts.lazy,
                // prepare function before done()
                prepare = opts.prepare,
                // navigate option object when cmd done
                navigate = opts.navigate,
                // open notify dialog timeout
                timeout,
                // use browser cache
                useCache = (opts.options || {}).cache,
                // request options
                options = Object.assign({
                    url: o.url,
                    async: true,
                    type: this.requestType,
                    dataType: 'json',
                    cache: (self.api >= 2.1029), // api >= 2.1029 has unique request ID
                    data: data,
                    headers: this.customHeaders,
                    xhrFields: this.xhrFields,
                    progress: function (e) {
                        var p = e.loaded / e.total * 100;
                        progTm && clearTimeout(progTm);
                        if (opts.progressBar) {
                            try {
                                opts.progressBar.width(p + '%');
                            } catch (e) { }
                        } else {
                            if (hasNotify && notify.type) {
                                p = p * notify.cnt;
                                if (prog < p) {
                                    self.notify({
                                        type: notify.type,
                                        progress: p - prog,
                                        cnt: 0,
                                        hideCnt: notify.hideCnt
                                    });
                                    prog = p;
                                }
                            }
                        }
                        if (opts.progress) {
                            try {
                                opts.progress(e);
                            } catch (e) { }
                        }
                    }
                }, opts.options || {}),
                /**
                 * Default success handler. 
                 * Call default data handlers and fire event with command name.
                 *
                 * @param Object  normalized response data
                 * @return void
                 **/
                done = function (data) {
                    data.warning && self.error(data.warning);

                    if (isOpen) {
                        open(data);
                    } else {
                        self.updateCache(data);
                    }

                    self.lazy(function () {
                        // fire some event to update cache/ui
                        data.removed && data.removed.length && self.remove(data);
                        data.added && data.added.length && self.add(data);
                        data.changed && data.changed.length && self.change(data);
                    }).then(function () {
                        // fire event with command name
                        return self.lazy(function () {
                            self.trigger(cmd, data, false);
                        });
                    }).then(function () {
                        // fire event with command name + 'done'
                        return self.lazy(function () {
                            self.trigger(cmd + 'done');
                        });
                    }).then(function () {
                        // make toast message
                        if (data.toasts && Array.isArray(data.toasts)) {
                            $.each(data.toasts, function () {
                                this.msg && self.toast(this);
                            });
                        }
                        // force update content
                        data.sync && self.sync();
                    });
                },
                /**
                 * Request error handler. Reject dfrd with correct error message.
                 *
                 * @param jqxhr  request object
                 * @param String request status
                 * @return void
                 **/
                error = function (xhr, status) {
                    var error, data,
                        d = self.options.debug;

                    switch (status) {
                        case 'abort':
                            error = xhr.quiet ? '' : ['errConnect', 'errAbort'];
                            break;
                        case 'timeout':
                            error = ['errConnect', 'errTimeout'];
                            break;
                        case 'parsererror':
                            error = ['errResponse', 'errDataNotJSON'];
                            if (xhr.responseText) {
                                if (!cwd || (d && (d === 'all' || d['backend-error']))) {
                                    error.push(xhr.responseText);
                                }
                            }
                            break;
                        default:
                            if (xhr.responseText) {
                                // check responseText, Is that JSON?
                                try {
                                    data = JSON.parse(xhr.responseText);
                                    if (data && data.error) {
                                        error = data.error;
                                    }
                                } catch (e) { }
                            }
                            if (!error) {
                                if (xhr.status == 403) {
                                    error = ['errConnect', 'errAccess', 'HTTP error ' + xhr.status];
                                } else if (xhr.status == 404) {
                                    error = ['errConnect', 'errNotFound', 'HTTP error ' + xhr.status];
                                } else if (xhr.status >= 500) {
                                    error = ['errResponse', 'errServerError', 'HTTP error ' + xhr.status];
                                } else {
                                    if (xhr.status == 414 && options.type === 'get') {
                                        // retry by POST method
                                        options.type = 'post';
                                        self.abortXHR(xhr);
                                        dfrd.xhr = xhr = self.transport.send(options).fail(error).done(success);
                                        return;
                                    }
                                    error = xhr.quiet ? '' : ['errConnect', 'HTTP error ' + xhr.status];
                                }
                            }
                    }

                    self.trigger(cmd + 'done');
                    dfrd.reject({ error: error }, xhr, status);
                },
                /**
                 * Request success handler. Valid response data and reject/resolve dfrd.
                 *
                 * @param Object  response data
                 * @param String request status
                 * @return void
                 **/
                success = function (response) {
                    // Set currrent request command name
                    self.currentReqCmd = cmd;

                    response.debug && self.responseDebug(response);

                    self.setCustomHeaderByXhr(xhr);

                    if (raw) {
                        self.abortXHR(xhr);
                        response && response.debug && self.debug('backend-debug', response);
                        return dfrd.resolve(response);
                    }

                    if (!response) {
                        return dfrd.reject({ error: ['errResponse', 'errDataEmpty'] }, xhr, response);
                    } else if (!$.isPlainObject(response)) {
                        return dfrd.reject({ error: ['errResponse', 'errDataNotJSON'] }, xhr, response);
                    } else if (response.error) {
                        if (isOpen) {
                            // check leafRoots
                            $.each(self.leafRoots, function (phash, roots) {
                                self.leafRoots[phash] = $.grep(roots, function (h) { return h !== data.target; });
                            });
                        }
                        return dfrd.reject({ error: response.error }, xhr, response);
                    }

                    var resolve = function () {
                        var pushLeafRoots = function (name) {
                            if (self.leafRoots[data.target] && response[name]) {
                                $.each(self.leafRoots[data.target], function (i, h) {
                                    var root;
                                    if (root = self.file(h)) {
                                        response[name].push(root);
                                    }
                                });
                            }
                        },
                            setTextMimes = function () {
                                self.textMimes = {};
                                $.each(self.res('mimes', 'text'), function () {
                                    self.textMimes[this.toLowerCase()] = true;
                                });
                            },
                            actionTarget;

                        if (isOpen) {
                            pushLeafRoots('files');
                        } else if (cmd === 'tree') {
                            pushLeafRoots('tree');
                        }

                        response = self.normalize(response);

                        if (!self.validResponse(cmd, response)) {
                            return dfrd.reject({ error: (response.norError || 'errResponse') }, xhr, response);
                        }

                        if (isOpen) {
                            if (!self.api) {
                                self.api = response.api || 1;
                                if (self.api == '2.0' && typeof response.options.uploadMaxSize !== 'undefined') {
                                    self.api = '2.1';
                                }
                                self.newAPI = self.api >= 2;
                                self.oldAPI = !self.newAPI;
                            }

                            if (response.textMimes && Array.isArray(response.textMimes)) {
                                self.resources.mimes.text = response.textMimes;
                                setTextMimes();
                            }
                            !self.textMimes && setTextMimes();

                            if (response.options) {
                                cwdOptions = Object.assign({}, cwdOptionsDefault, response.options);
                            }

                            if (response.netDrivers) {
                                self.netDrivers = response.netDrivers;
                            }

                            if (response.maxTargets) {
                                self.maxTargets = response.maxTargets;
                            }

                            if (!!data.init) {
                                self.uplMaxSize = self.returnBytes(response.uplMaxSize);
                                self.uplMaxFile = !!response.uplMaxFile ? Math.min(parseInt(response.uplMaxFile), 50) : 20;
                            }
                        }

                        if (typeof prepare === 'function') {
                            prepare(response);
                        }

                        if (navigate) {
                            actionTarget = navigate.target || 'added';
                            if (response[actionTarget] && response[actionTarget].length) {
                                self.one(cmd + 'done', function () {
                                    var targets = response[actionTarget],
                                        newItems = self.findCwdNodes(targets),
                                        inCwdHashes = function () {
                                            var cwdHash = self.cwd().hash;
                                            return $.map(targets, function (f) { return (f.phash && cwdHash === f.phash) ? f.hash : null; });
                                        },
                                        hashes = inCwdHashes(),
                                        makeToast = function (t) {
                                            var node = void (0),
                                                data = t.action ? t.action.data : void (0),
                                                cmd, msg, done;
                                            if ((data || hashes.length) && t.action && (msg = t.action.msg) && (cmd = t.action.cmd) && (!t.action.cwdNot || t.action.cwdNot !== self.cwd().hash)) {
                                                done = t.action.done;
                                                data = t.action.data;
                                                node = $('<div></div>')
                                                    .append(
                                                        $('<button type="button" class="ui-button ui-widget ui-state-default ui-corner-all elfinder-tabstop"><span class="ui-button-text">'
                                                            + self.i18n(msg)
                                                            + '</span></button>')
                                                            .on('mouseenter mouseleave', function (e) {
                                                                $(this).toggleClass('ui-state-hover', e.type == 'mouseenter');
                                                            })
                                                            .on('click', function () {
                                                                self.exec(cmd, data || hashes, { _userAction: true, _currentType: 'toast', _currentNode: $(this) });
                                                                if (done) {
                                                                    self.one(cmd + 'done', function () {
                                                                        if (typeof done === 'function') {
                                                                            done();
                                                                        } else if (done === 'select') {
                                                                            self.trigger('selectfiles', { files: inCwdHashes() });
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                    );
                                            }
                                            delete t.action;
                                            t.extNode = node;
                                            return t;
                                        };

                                    if (!navigate.toast) {
                                        navigate.toast = {};
                                    }

                                    !navigate.noselect && self.trigger('selectfiles', { files: self.searchStatus.state > 1 ? $.map(targets, function (f) { return f.hash; }) : hashes });

                                    if (newItems.length) {
                                        if (!navigate.noscroll) {
                                            newItems.first().trigger('scrolltoview', { blink: false });
                                            self.resources.blink(newItems, 'lookme');
                                        }
                                        if ($.isPlainObject(navigate.toast.incwd)) {
                                            self.toast(makeToast(navigate.toast.incwd));
                                        }
                                    } else {
                                        if ($.isPlainObject(navigate.toast.inbuffer)) {
                                            self.toast(makeToast(navigate.toast.inbuffer));
                                        }
                                    }
                                });
                            }
                        }

                        dfrd.resolve(response);

                        response.debug && self.debug('backend-debug', response);
                    };
                    self.abortXHR(xhr);
                    lazy ? self.lazy(resolve) : resolve();
                },
                xhr, _xhr,
                xhrAbort = function (e) {
                    if (xhr && xhr.state() === 'pending') {
                        self.abortXHR(xhr, { quiet: true, abort: true });
                        if (!e || (e.type !== 'unload' && e.type !== 'destroy')) {
                            self.autoSync();
                        }
                    }
                },
                abort = function (e) {
                    self.trigger(cmd + 'done');
                    if (e.type == 'autosync') {
                        if (e.data.action != 'stop') return;
                    } else if (e.type != 'unload' && e.type != 'destroy' && e.type != 'openxhrabort') {
                        if (!e.data.added || !e.data.added.length) {
                            return;
                        }
                    }
                    xhrAbort(e);
                },
                request = function (mode) {
                    var queueAbort = function () {
                        syncOnFail = false;
                        dfrd.reject();
                    };

                    if (mode) {
                        if (mode === 'cmd') {
                            return cmd;
                        }
                    }

                    if (isOpen) {
                        if (currentOpenCmd && currentOpenCmd.state() === 'pending') {
                            if (currentOpenCmd._target === data.target) {
                                return dfrd.reject('openabort');
                            } else {
                                if (currentOpenCmd.xhr) {
                                    currentOpenCmd.xhr.queueAbort();
                                } else {
                                    currentOpenCmd.reject('openabort');
                                }
                            }
                        }
                        currentOpenCmd = dfrd;
                        currentOpenCmd._target = data.target;
                    }

                    dfrd.always(function () {
                        delete options.headers['X-elFinderReqid'];
                        if (isOpen) {
                            currentOpenCmd = null;
                        }
                    }).fail(function (error, xhr, response) {
                        var errData, errMsg;

                        if (isOpen && error === 'openabort') {
                            error = '';
                            syncOnFail = false;
                        }

                        errData = {
                            cmd: cmd,
                            err: error,
                            xhr: xhr,
                            rc: response
                        };

                        // unset this cmd queue when user canceling
                        // see notify : function - `cancel.reject(0);`
                        if (error === 0) {
                            if (requestQueue.length) {
                                requestQueue = $.grep(requestQueue, function (req) {
                                    return (req('cmd') === cmd) ? false : true;
                                });
                            }
                        }
                        // trigger "requestError" event
                        self.trigger('requestError', errData);
                        if (errData._getEvent && errData._getEvent().isDefaultPrevented()) {
                            deffail = false;
                            syncOnFail = false;
                            if (error) {
                                error.error = '';
                            }
                        }
                        // abort xhr
                        xhrAbort();
                        if (isOpen) {
                            openDir = self.file(data.target);
                            openDir && openDir.volumeid && self.isRoot(openDir) && delete self.volumeExpires[openDir.volumeid];
                        }
                        self.trigger(cmd + 'fail', response);
                        errMsg = (typeof error === 'object') ? error.error : error;
                        if (errMsg) {
                            deffail ? self.error(errMsg) : self.debug('error', self.i18n(errMsg));
                        }
                        syncOnFail && self.sync();
                    });

                    if (!cmd) {
                        syncOnFail = false;
                        return dfrd.reject({ error: 'errCmdReq' });
                    }

                    if (self.maxTargets && data.targets && data.targets.length > self.maxTargets) {
                        syncOnFail = false;
                        return dfrd.reject({ error: ['errMaxTargets', self.maxTargets] });
                    }

                    defdone && dfrd.done(done);

                    // quiet abort not completed "open" requests
                    if (isOpen) {
                        while ((_xhr = queue.pop())) {
                            _xhr.queueAbort();
                        }
                        if (cwd !== data.target) {
                            while ((_xhr = cwdQueue.pop())) {
                                _xhr.queueAbort();
                            }
                        }
                    }

                    // trigger abort autoSync for commands to add the item
                    if ($.inArray(cmd, (self.cmdsToAdd + ' autosync').split(' ')) !== -1) {
                        if (cmd !== 'autosync') {
                            self.autoSync('stop');
                            dfrd.always(function () {
                                self.autoSync();
                            });
                        }
                        self.trigger('openxhrabort');
                    }

                    delete options.preventFail;

                    if (self.api >= 2.1029) {
                        if (useCache) {
                            options.headers['X-elFinderReqid'] = reqId;
                        } else {
                            Object.assign(options.data, { reqid: reqId });
                        }
                    }

                    // function for set value of this syncOnFail
                    dfrd.syncOnFail = function (state) {
                        syncOnFail = !!state;
                    };

                    requestCnt++;

                    dfrd.xhr = xhr = self.transport.send(options).always(function () {
                        // set responseURL from native xhr object
                        if (options._xhr && typeof options._xhr.responseURL !== 'undefined') {
                            xhr.responseURL = options._xhr.responseURL || '';
                        }
                        --requestCnt;
                        if (requestQueue.length) {
                            requestQueue.shift()();
                        }
                    }).fail(error).done(success);

                    if (self.api >= 2.1029) {
                        xhr._requestId = reqId;
                    }

                    if (isOpen || (data.compare && cmd === 'info')) {
                        // regist function queueAbort
                        xhr.queueAbort = queueAbort;
                        // add autoSync xhr into queue
                        queue.unshift(xhr);
                        // bind abort()
                        data.compare && self.bind(self.cmdsToAdd + ' autosync openxhrabort', abort);
                        dfrd.always(function () {
                            var ndx = $.inArray(xhr, queue);
                            data.compare && self.unbind(self.cmdsToAdd + ' autosync openxhrabort', abort);
                            ndx !== -1 && queue.splice(ndx, 1);
                        });
                    } else if ($.inArray(cmd, self.abortCmdsOnOpen) !== -1) {
                        // regist function queueAbort
                        xhr.queueAbort = queueAbort;
                        // add "open" xhr, only cwd xhr into queue
                        cwdQueue.unshift(xhr);
                        dfrd.always(function () {
                            var ndx = $.inArray(xhr, cwdQueue);
                            ndx !== -1 && cwdQueue.splice(ndx, 1);
                        });
                    }

                    // abort pending xhr on window unload or elFinder destroy
                    self.bind('unload destroy', abort);
                    dfrd.always(function () {
                        self.unbind('unload destroy', abort);
                    });

                    return dfrd;
                },
                queueingRequest = function () {
                    // show notify
                    if (notify.type && notify.cnt) {
                        if (cancel) {
                            notify.cancel = dfrd;
                            opts.eachCancel && (notify.id = +new Date());
                        }
                        timeout = setTimeout(function () {
                            // start fake count up
                            progTm = setTimeout(progFakeUp, 1000);
                            self.notify(notify);
                            hasNotify = true;
                            dfrd.always(function () {
                                notify.cnt = -(parseInt(notify.cnt) || 0);
                                self.notify(notify);
                                hasNotify = false;
                            });
                        }, self.notifyDelay);

                        dfrd.always(function () {
                            clearTimeout(timeout);
                        });
                    }
                    // queueing
                    if (requestCnt < requestMaxConn) {
                        // do request
                        return request();
                    } else {
                        if (isOpen) {
                            requestQueue.unshift(request);
                        } else {
                            requestQueue.push(request);
                        }
                        return dfrd;
                    }
                },
                progFakeUp = function () {
                    var add;
                    if (hasNotify && progTm) {
                        add = 1 * notify.cnt;
                        progTm = null;
                        self.notify({
                            type: notify.type,
                            progress: add,
                            cnt: 0,
                            hideCnt: notify.hideCnt
                        });
                        prog += add;
                        if ((prog / notify.cnt) < 80) {
                            progTm = setTimeout(progFakeUp, 500);
                        }
                    }
                },
                bindData = { opts: opts, result: true },
                openDir;

            // prevent request initial request is completed
            if (!self.api && !data.init) {
                syncOnFail = false;
                return dfrd.reject();
            }

            // trigger "request.cmd" that callback be able to cancel request by substituting "false" for "event.data.result"
            self.trigger('request.' + cmd, bindData, true);

            if (!bindData.result) {
                self.trigger(cmd + 'done');
                return dfrd.reject();
            } else if (typeof bindData.result === 'object' && bindData.result.promise) {
                bindData.result
                    .done(queueingRequest)
                    .fail(function () {
                        self.trigger(cmd + 'done');
                        dfrd.reject();
                    });
                return dfrd;
            }

            return queueingRequest();
        };

        /**
         * Call cache()
         * Store info about files/dirs in "files" object.
         *
         * @param  Array  files
         * @param  String type
         * @return void
         */
        this.cache = function (dataArray, type) {
            if (!Array.isArray(dataArray)) {
                dataArray = [dataArray];
            }
            cache(dataArray, type);
        };

        /**
         * Update file object caches by respose data object
         * 
         * @param  Object  respose data object
         * @return void
         */
        this.updateCache = function (data) {
            if ($.isPlainObject(data)) {
                data.files && data.files.length && cache(data.files, 'files');
                data.tree && data.tree.length && cache(data.tree, 'tree');
                data.removed && data.removed.length && remove(data.removed);
                data.added && data.added.length && cache(data.added, 'add');
                data.changed && data.changed.length && cache(data.changed, 'change');
            }
        };

        /**
         * Compare current files cache with new files and return diff
         * 
         * @param  Array   new files
         * @param  String  target folder hash
         * @param  Array   exclude properties to compare
         * @return Object
         */
        this.diff = function (incoming, onlydir, excludeProps) {
            var raw = {},
                added = [],
                removed = [],
                changed = [],
                excludes = null,
                isChanged = function (hash) {
                    var l = changed.length;

                    while (l--) {
                        if (changed[l].hash == hash) {
                            return true;
                        }
                    }
                };

            $.each(incoming, function (i, f) {
                raw[f.hash] = f;
            });

            // make excludes object
            if (excludeProps && excludeProps.length) {
                excludes = {};
                $.each(excludeProps, function () {
                    excludes[this] = true;
                });
            }

            // find removed
            $.each(files, function (hash, f) {
                if (!raw[hash] && (!onlydir || f.phash === onlydir)) {
                    removed.push(hash);
                }
            });

            // compare files
            $.each(raw, function (hash, file) {
                var origin = files[hash],
                    orgKeys = {},
                    chkKeyLen;

                if (!origin) {
                    added.push(file);
                } else {
                    // make orgKeys object
                    $.each(Object.keys(origin), function () {
                        orgKeys[this] = true;
                    });
                    $.each(file, function (prop) {
                        delete orgKeys[prop];
                        if (!excludes || !excludes[prop]) {
                            if (file[prop] !== origin[prop]) {
                                changed.push(file);
                                orgKeys = {};
                                return false;
                            }
                        }
                    });
                    chkKeyLen = Object.keys(orgKeys).length;
                    if (chkKeyLen !== 0) {
                        if (excludes) {
                            $.each(orgKeys, function (prop) {
                                if (excludes[prop]) {
                                    --chkKeyLen;
                                }
                            });
                        }
                        (chkKeyLen !== 0) && changed.push(file);
                    }
                }
            });

            // parents of removed dirs mark as changed (required for tree correct work)
            $.each(removed, function (i, hash) {
                var file = files[hash],
                    phash = file.phash;

                if (phash
                    && file.mime == 'directory'
                    && $.inArray(phash, removed) === -1
                    && raw[phash]
                    && !isChanged(phash)) {
                    changed.push(raw[phash]);
                }
            });

            return {
                added: added,
                removed: removed,
                changed: changed
            };
        };

        /**
         * Sync Stopper
         * 
         * @type Boolean
         */
        this.syncStopper = false;

        /**
         * Sync content
         * 
         * @return jQuery.Deferred
         */
        this.sync = function (onlydir, polling) {
            if (this.syncStopper) {
                return $.Deferred().reject();
            }
            this.syncStopper = true;
            this.autoSync('stop');
            var self = this,
                compare = function () {
                    var c = '', cnt = 0, mtime = 0;
                    if (onlydir && polling) {
                        $.each(files, function (h, f) {
                            if (f.phash && f.phash === onlydir) {
                                ++cnt;
                                mtime = Math.max(mtime, f.ts);
                            }
                            c = cnt + ':' + mtime;
                        });
                    }
                    return c;
                },
                comp = compare(),
                dfrd = $.Deferred().always(function () { !reqFail && self.trigger('sync'); }),
                opts = [this.request({
                    data: { cmd: 'open', reload: 1, target: cwd, tree: (!onlydir && this.ui.tree) ? 1 : 0, compare: comp },
                    preventDefault: true
                })],
                exParents = function () {
                    var parents = [],
                        curRoot = self.file(self.root(cwd)),
                        curId = curRoot ? curRoot.volumeid : null,
                        phash = self.cwd().phash,
                        isroot, pdir;

                    while (phash) {
                        if (pdir = self.file(phash)) {
                            if (phash.indexOf(curId) !== 0) {
                                parents.push({ target: phash, cmd: 'tree' });
                                if (!self.isRoot(pdir)) {
                                    parents.push({ target: phash, cmd: 'parents' });
                                }
                                curRoot = self.file(self.root(phash));
                                curId = curRoot ? curRoot.volumeid : null;
                            }
                            phash = pdir.phash;
                        } else {
                            phash = null;
                        }
                    }
                    return parents;
                },
                reqFail;

            if (!onlydir && self.api >= 2) {
                (cwd !== this.root()) && opts.push(this.request({
                    data: { cmd: 'parents', target: cwd },
                    preventDefault: true
                }));
                $.each(exParents(), function (i, data) {
                    opts.push(self.request({
                        data: { cmd: data.cmd, target: data.target },
                        preventDefault: true
                    }));
                });
            }
            $.when.apply($, opts)
                .fail(function (error, xhr) {
                    reqFail = (xhr && xhr.status != 200);
                    if (!polling || $.inArray('errOpen', error) !== -1) {
                        dfrd.reject(error);
                        self.parseError(error) && self.request({
                            data: { cmd: 'open', target: (self.lastDir('') || self.root()), tree: 1, init: 1 },
                            notify: { type: 'open', cnt: 1, hideCnt: true }
                        });
                    } else {
                        dfrd.reject((error && xhr.status != 0) ? error : void 0);
                    }
                })
                .done(function (odata) {
                    var pdata, argLen, i;

                    if (odata.cwd.compare) {
                        if (comp === odata.cwd.compare) {
                            return dfrd.reject();
                        }
                    }

                    // for 2nd and more requests
                    pdata = { tree: [] };

                    // results marge of 2nd and more requests
                    argLen = arguments.length;
                    if (argLen > 1) {
                        for (i = 1; i < argLen; i++) {
                            if (arguments[i].tree && arguments[i].tree.length) {
                                pdata.tree.push.apply(pdata.tree, arguments[i].tree);
                            }
                        }
                    }

                    if (self.api < 2.1) {
                        if (!pdata.tree) {
                            pdata.tree = [];
                        }
                        pdata.tree.push(odata.cwd);
                    }

                    // data normalize
                    odata = self.normalize(odata);
                    if (!self.validResponse('open', odata)) {
                        return dfrd.reject((odata.norError || 'errResponse'));
                    }
                    pdata = self.normalize(pdata);
                    if (!self.validResponse('tree', pdata)) {
                        return dfrd.reject((pdata.norError || 'errResponse'));
                    }

                    var diff = self.diff(odata.files.concat(pdata && pdata.tree ? pdata.tree : []), onlydir);

                    diff.added.push(odata.cwd);

                    self.updateCache(diff);

                    // trigger events
                    diff.removed.length && self.remove(diff);
                    diff.added.length && self.add(diff);
                    diff.changed.length && self.change(diff);
                    return dfrd.resolve(diff);
                })
                .always(function () {
                    self.syncStopper = false;
                    self.autoSync();
                });

            return dfrd;
        };

        this.upload = function (files) {
            return this.transport.upload(files, this);
        };

        /**
         * Bind keybord shortcut to keydown event
         *
         * @example
         *    elfinder.shortcut({ 
         *       pattern : 'ctrl+a', 
         *       description : 'Select all files', 
         *       callback : function(e) { ... }, 
         *       keypress : true|false (bind to keypress instead of keydown) 
         *    })
         *
         * @param  Object  shortcut config
         * @return elFinder
         */
        this.shortcut = function (s) {
            var patterns, pattern, code, i, parts;

            if (this.options.allowShortcuts && s.pattern && typeof s.callback === 'function') {
                patterns = s.pattern.toUpperCase().split(/\s+/);

                for (i = 0; i < patterns.length; i++) {
                    pattern = patterns[i];
                    parts = pattern.split('+');
                    code = (code = parts.pop()).length == 1
                        ? (code > 0 ? code : code.charCodeAt(0))
                        : (code > 0 ? code : $.ui.keyCode[code]);

                    if (code && !shortcuts[pattern]) {
                        shortcuts[pattern] = {
                            keyCode: code,
                            altKey: $.inArray('ALT', parts) != -1,
                            ctrlKey: $.inArray('CTRL', parts) != -1,
                            shiftKey: $.inArray('SHIFT', parts) != -1,
                            type: s.type || 'keydown',
                            callback: s.callback,
                            description: s.description,
                            pattern: pattern
                        };
                    }
                }
            }
            return this;
        };

        /**
         * Registered shortcuts
         *
         * @type Object
         **/
        this.shortcuts = function () {
            var ret = [];

            $.each(shortcuts, function (i, s) {
                ret.push([s.pattern, self.i18n(s.description)]);
            });
            return ret;
        };

        /**
         * Get/set clipboard content.
         * Return new clipboard content.
         *
         * @example
         *   this.clipboard([]) - clean clipboard
         *   this.clipboard([{...}, {...}], true) - put 2 files in clipboard and mark it as cutted
         * 
         * @param  Array    new files hashes
         * @param  Boolean  cut files?
         * @return Array
         */
        this.clipboard = function (hashes, cut) {
            var map = function () { return $.map(clipboard, function (f) { return f.hash; }); };

            if (hashes !== void (0)) {
                clipboard.length && this.trigger('unlockfiles', { files: map() });
                remember = {};

                clipboard = $.map(hashes || [], function (hash) {
                    var file = files[hash];
                    if (file) {

                        remember[hash] = true;

                        return {
                            hash: hash,
                            phash: file.phash,
                            name: file.name,
                            mime: file.mime,
                            read: file.read,
                            locked: file.locked,
                            cut: !!cut
                        };
                    }
                    return null;
                });
                this.trigger('changeclipboard', { clipboard: clipboard.slice(0, clipboard.length) });
                cut && this.trigger('lockfiles', { files: map() });
            }

            // return copy of clipboard instead of refrence
            return clipboard.slice(0, clipboard.length);
        };

        /**
         * Return true if command enabled
         * 
         * @param  String       command name
         * @param  String|void  hash for check of own volume's disabled cmds
         * @return Boolean
         */
        this.isCommandEnabled = function (name, dstHash) {
            var disabled, cmd,
                cvid = self.cwd().volumeid || '';

            // In serach results use selected item hash to check
            if (!dstHash && self.searchStatus.state > 1 && self.selected().length) {
                dstHash = self.selected()[0];
            }
            if (dstHash && (!cvid || dstHash.indexOf(cvid) !== 0)) {
                disabled = self.option('disabledFlip', dstHash);
                //if (! disabled) {
                //	disabled = {};
                //}
            } else {
                disabled = cwdOptions.disabledFlip/* || {}*/;
            }
            cmd = this._commands[name];
            return cmd ? (cmd.alwaysEnabled || !disabled[name]) : false;
        };

        /**
         * Exec command and return result;
         *
         * @param  String         command name
         * @param  String|Array   usualy files hashes
         * @param  String|Array   command options
         * @param  String|void    hash for enabled check of own volume's disabled cmds
         * @return $.Deferred
         */
        this.exec = function (cmd, files, opts, dstHash) {
            var dfrd, resType;

            // apply commandMap for keyboard shortcut
            if (!dstHash && this.commandMap[cmd] && this.commandMap[cmd] !== 'hidden') {
                cmd = this.commandMap[cmd];
            }

            if (cmd === 'open') {
                if (this.searchStatus.state || this.searchStatus.ininc) {
                    this.trigger('searchend', { noupdate: true });
                }
                this.autoSync('stop');
            }
            if (!dstHash && files) {
                if ($.isArray(files)) {
                    if (files.length) {
                        dstHash = files[0];
                    }
                } else {
                    dstHash = files;
                }
            }
            dfrd = this._commands[cmd] && this.isCommandEnabled(cmd, dstHash)
                ? this._commands[cmd].exec(files, opts)
                : $.Deferred().reject('errUnknownCmd');

            resType = typeof dfrd;
            if (!(resType === 'object' && dfrd.promise)) {
                self.debug('warning', '"cmd.exec()" should be returned "$.Deferred" but cmd "' + cmd + '" returned "' + resType + '"');
                dfrd = $.Deferred().resolve();
            }

            this.trigger('exec', { dfrd: dfrd, cmd: cmd, files: files, opts: opts, dstHash: dstHash });
            return dfrd;
        };

        /**
         * Create and return dialog.
         *
         * @param  String|DOMElement  dialog content
         * @param  Object             dialog options
         * @return jQuery
         */
        this.dialog = function (content, options) {
            var dialog = $('<div></div>').append(content).appendTo(node).elfinderdialog(options, self),
                dnode = dialog.closest('.ui-dialog'),
                resize = function () {
                    !dialog.data('draged') && dialog.is(':visible') && dialog.elfinderdialog('posInit');
                };
            if (dnode.length) {
                self.bind('resize', resize);
                dnode.on('remove', function () {
                    self.unbind('resize', resize);
                });
            }
            return dialog;
        };

        /**
         * Create and return toast.
         *
         * @param  Object  toast options - see ui/toast.js
         * @return jQuery
         */
        this.toast = function (options) {
            return $('<div class="ui-front"></div>').appendTo(this.ui.toast).elfindertoast(options || {}, this);
        };

        /**
         * Return UI widget or node
         *
         * @param  String  ui name
         * @return jQuery
         */
        this.getUI = function (ui) {
            return ui ? (this.ui[ui] || $()) : node;
        };

        /**
         * Return elFinder.command instance or instances array
         *
         * @param  String  command name
         * @return Object | Array
         */
        this.getCommand = function (name) {
            return name === void (0) ? this._commands : this._commands[name];
        };

        /**
         * Resize elfinder node
         * 
         * @param  String|Number  width
         * @param  String|Number  height
         * @return void
         */
        this.resize = function (w, h) {
            var getMargin = function () {
                var m = node.outerHeight(true) - node.innerHeight(),
                    p = node;

                while (p.get(0) !== heightBase.get(0)) {
                    p = p.parent();
                    m += p.outerHeight(true) - p.innerHeight();
                    if (!p.parent().length) {
                        // reached the document
                        break;
                    }
                }
                return m;
            },
                fit = !node.hasClass('ui-resizable'),
                prv = node.data('resizeSize') || { w: 0, h: 0 },
                mt, size = {};

            if (heightBase && heightBase.data('resizeTm')) {
                clearTimeout(heightBase.data('resizeTm'));
            }

            if (!self.options.noResizeBySelf) {
                if (typeof h === 'string') {
                    if (mt = h.match(/^([0-9.]+)%$/)) {
                        // setup heightBase
                        if (!heightBase || !heightBase.length) {
                            heightBase = $(window);
                        }
                        if (!heightBase.data('marginToMyNode')) {
                            heightBase.data('marginToMyNode', getMargin());
                        }
                        if (!heightBase.data('fitToBaseFunc')) {
                            heightBase.data('fitToBaseFunc', function (e) {
                                var tm = heightBase.data('resizeTm');
                                e.preventDefault();
                                e.stopPropagation();
                                tm && cancelAnimationFrame(tm);
                                if (!node.hasClass('elfinder-fullscreen') && (!self.UA.Mobile || heightBase.data('rotated') !== self.UA.Rotated)) {
                                    heightBase.data('rotated', self.UA.Rotated);
                                    heightBase.data('resizeTm', requestAnimationFrame(function () {
                                        self.restoreSize();
                                    }));
                                }
                            });
                        }
                        if (typeof heightBase.data('rotated') === 'undefined') {
                            heightBase.data('rotated', self.UA.Rotated);
                        }
                        h = heightBase.height() * (mt[1] / 100) - heightBase.data('marginToMyNode');

                        heightBase.off('resize.' + self.namespace, heightBase.data('fitToBaseFunc'));
                        fit && heightBase.on('resize.' + self.namespace, heightBase.data('fitToBaseFunc'));
                    }
                }

                node.css({ width: w, height: parseInt(h) });
            }

            size.w = Math.round(node.width());
            size.h = Math.round(node.height());
            node.data('resizeSize', size);
            if (size.w !== prv.w || size.h !== prv.h) {
                node.trigger('resize');
                this.trigger('resize', { width: size.w, height: size.h });
            }
        };

        /**
         * Restore elfinder node size
         * 
         * @return elFinder
         */
        this.restoreSize = function () {
            this.resize(width, height);
        };

        this.show = function () {
            node.show();
            this.enable().trigger('show');
        };

        this.hide = function () {
            if (this.options.enableAlways) {
                prevEnabled = enabled;
                enabled = false;
            }
            this.disable();
            this.trigger('hide');
            node.hide();
        };

        /**
         * Lazy execution function
         * 
         * @param  Object  function
         * @param  Number  delay
         * @param  Object  options
         * @return Object  jQuery.Deferred
         */
        this.lazy = function (func, delay, opts) {
            var busy = function (state) {
                var cnt = node.data('lazycnt'),
                    repaint;

                if (state) {
                    repaint = node.data('lazyrepaint') ? false : opts.repaint;
                    if (!cnt) {
                        node.data('lazycnt', 1)
                            .addClass('elfinder-processing');
                    } else {
                        node.data('lazycnt', ++cnt);
                    }
                    if (repaint) {
                        node.data('lazyrepaint', true).css('display'); // force repaint
                    }
                } else {
                    if (cnt && cnt > 1) {
                        node.data('lazycnt', --cnt);
                    } else {
                        repaint = node.data('lazyrepaint');
                        node.data('lazycnt', 0)
                            .removeData('lazyrepaint')
                            .removeClass('elfinder-processing');
                        repaint && node.css('display'); // force repaint;
                        self.trigger('lazydone');
                    }
                }
            },
                dfd = $.Deferred(),
                callFunc = function () {
                    dfd.resolve(func.call(dfd));
                    busy(false);
                };

            delay = delay || 0;
            opts = opts || {};
            busy(true);

            if (delay) {
                setTimeout(callFunc, delay);
            } else {
                requestAnimationFrame(callFunc);
            }

            return dfd;
        };

        /**
         * Destroy this elFinder instance
         *
         * @return void
         **/
        this.destroy = function () {
            if (node && node[0].elfinder) {
                node.hasClass('elfinder-fullscreen') && self.toggleFullscreen(node);
                this.options.syncStart = false;
                this.autoSync('forcestop');
                this.trigger('destroy').disable();
                clipboard = [];
                selected = [];
                listeners = {};
                shortcuts = {};
                $(window).off('.' + namespace);
                $(document).off('.' + namespace);
                self.trigger = function () { };
                $(beeper).remove();
                node.off()
                    .removeData()
                    .empty()
                    .append(prevContent.contents())
                    .attr('class', prevContent.attr('class'))
                    .attr('style', prevContent.attr('style'));
                delete node[0].elfinder;
                // restore kept events
                $.each(prevEvents, function (n, arr) {
                    $.each(arr, function (i, o) {
                        node.on(o.type + (o.namespace ? '.' + o.namespace : ''), o.selector, o.handler);
                    });
                });
            }
        };

        /**
         * Start or stop auto sync
         * 
         * @param  String|Bool  stop
         * @return void
         */
        this.autoSync = function (mode) {
            var sync;
            if (self.options.sync >= 1000) {
                if (syncInterval) {
                    clearTimeout(syncInterval);
                    syncInterval = null;
                    self.trigger('autosync', { action: 'stop' });
                }

                if (mode === 'stop') {
                    ++autoSyncStop;
                } else {
                    autoSyncStop = Math.max(0, --autoSyncStop);
                }

                if (autoSyncStop || mode === 'forcestop' || !self.options.syncStart) {
                    return;
                }

                // run interval sync
                sync = function (start) {
                    var timeout;
                    if (cwdOptions.syncMinMs && (start || syncInterval)) {
                        start && self.trigger('autosync', { action: 'start' });
                        timeout = Math.max(self.options.sync, cwdOptions.syncMinMs);
                        syncInterval && clearTimeout(syncInterval);
                        syncInterval = setTimeout(function () {
                            var dosync = true, hash = cwd, cts;
                            if (cwdOptions.syncChkAsTs && files[hash] && (cts = files[hash].ts)) {
                                self.request({
                                    data: { cmd: 'info', targets: [hash], compare: cts, reload: 1 },
                                    preventDefault: true
                                })
                                    .done(function (data) {
                                        var ts;
                                        dosync = true;
                                        if (data.compare) {
                                            ts = data.compare;
                                            if (ts == cts) {
                                                dosync = false;
                                            }
                                        }
                                        if (dosync) {
                                            self.sync(hash).always(function () {
                                                if (ts) {
                                                    // update ts for cache clear etc.
                                                    files[hash].ts = ts;
                                                }
                                                sync();
                                            });
                                        } else {
                                            sync();
                                        }
                                    })
                                    .fail(function (error, xhr) {
                                        var err = self.parseError(error);
                                        if (err && xhr.status != 0) {
                                            self.error(err);
                                            if (Array.isArray(err) && $.inArray('errOpen', err) !== -1) {
                                                self.request({
                                                    data: { cmd: 'open', target: (self.lastDir('') || self.root()), tree: 1, init: 1 },
                                                    notify: { type: 'open', cnt: 1, hideCnt: true }
                                                });
                                            }
                                        } else {
                                            syncInterval = setTimeout(function () {
                                                sync();
                                            }, timeout);
                                        }
                                    });
                            } else {
                                self.sync(cwd, true).always(function () {
                                    sync();
                                });
                            }
                        }, timeout);
                    }
                };
                sync(true);
            }
        };

        /**
         * Return bool is inside work zone of specific point
         * 
         * @param  Number event.pageX
         * @param  Number event.pageY
         * @return Bool
         */
        this.insideWorkzone = function (x, y, margin) {
            var rectangle = this.getUI('workzone').data('rectangle');

            margin = margin || 1;
            if (x < rectangle.left + margin
                || x > rectangle.left + rectangle.width + margin
                || y < rectangle.top + margin
                || y > rectangle.top + rectangle.height + margin) {
                return false;
            }
            return true;
        };

        /**
         * Target ui node move to last of children of elFinder node fot to show front
         * 
         * @param  Object  target    Target jQuery node object
         */
        this.toFront = function (target) {
            var nodes = node.children('.ui-front').removeClass('elfinder-frontmost'),
                lastnode = nodes.last();
            nodes.css('z-index', '');
            $(target).addClass('ui-front elfinder-frontmost').css('z-index', lastnode.css('z-index') + 1);
        };

        /**
         * Remove class 'elfinder-frontmost' and hide() to target ui node
         *
         * @param      Object   target  Target jQuery node object
         * @param      Boolean  nohide  Do not hide
         */
        this.toHide = function (target, nohide) {
            var tgt = $(target),
                last;

            !nohide && tgt.hide();
            if (tgt.hasClass('elfinder-frontmost')) {
                tgt.removeClass('elfinder-frontmost');
                last = node.children('.ui-front:visible:not(.elfinder-frontmost)').last();
                if (last.length) {
                    requestAnimationFrame(function () {
                        if (!node.children('.elfinder-frontmost:visible').length) {
                            self.toFront(last);
                            last.trigger('frontmost');
                        }
                    });
                }
            }
        };

        /**
         * Return css object for maximize
         * 
         * @return Object
         */
        this.getMaximizeCss = function () {
            return {
                width: '100%',
                height: '100%',
                margin: 0,
                top: 0,
                left: 0,
                display: 'block',
                position: 'fixed',
                zIndex: Math.max(self.zIndex ? (self.zIndex + 1) : 0, 1000),
                maxWidth: '',
                maxHeight: ''
            };
        };

        // Closure for togglefullscreen
        (function () {
            // check is in iframe
            if (inFrame && self.UA.Fullscreen) {
                self.UA.Fullscreen = false;
                if (parentIframe && typeof parentIframe.attr('allowfullscreen') !== 'undefined') {
                    self.UA.Fullscreen = true;
                }
            }

            var orgStyle, bodyOvf, resizeTm, fullElm, exitFull, toFull, funcObj,
                cls = 'elfinder-fullscreen',
                clsN = 'elfinder-fullscreen-native',
                checkDialog = function () {
                    var t = 0,
                        l = 0;
                    $.each(node.children('.ui-dialog,.ui-draggable'), function (i, d) {
                        var $d = $(d),
                            pos = $d.position();

                        if (pos.top < 0) {
                            $d.css('top', t);
                            t += 20;
                        }
                        if (pos.left < 0) {
                            $d.css('left', l);
                            l += 20;
                        }
                    });
                },
                setFuncObj = function () {
                    var useFullscreen = self.storage('useFullscreen');
                    funcObj = self.UA.Fullscreen && (useFullscreen ? useFullscreen > 0 : self.options.commandsOptions.fullscreen.mode === 'screen') ? {
                        // native full screen mode

                        fullElm: function () {
                            return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || null;
                        },

                        exitFull: function () {
                            if (document.exitFullscreen) {
                                return document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                return document.webkitExitFullscreen();
                            } else if (document.mozCancelFullScreen) {
                                return document.mozCancelFullScreen();
                            } else if (document.msExitFullscreen) {
                                return document.msExitFullscreen();
                            }
                        },

                        toFull: function (elem) {
                            if (elem.requestFullscreen) {
                                return elem.requestFullscreen();
                            } else if (elem.webkitRequestFullscreen) {
                                return elem.webkitRequestFullscreen();
                            } else if (elem.mozRequestFullScreen) {
                                return elem.mozRequestFullScreen();
                            } else if (elem.msRequestFullscreen) {
                                return elem.msRequestFullscreen();
                            }
                            return false;
                        }
                    } : {
                        // node element maximize mode

                        fullElm: function () {
                            var full;
                            if (node.hasClass(cls)) {
                                return node.get(0);
                            } else {
                                full = node.find('.' + cls);
                                if (full.length) {
                                    return full.get(0);
                                }
                            }
                            return null;
                        },

                        exitFull: function () {
                            var elm;

                            $(window).off('resize.' + namespace, resize);
                            if (bodyOvf !== void (0)) {
                                $('body').css('overflow', bodyOvf);
                            }
                            bodyOvf = void (0);

                            if (orgStyle) {
                                elm = orgStyle.elm;
                                restoreStyle(elm);
                                $(elm).trigger('resize', { fullscreen: 'off' });
                            }

                            $(window).trigger('resize');
                        },

                        toFull: function (elem) {
                            bodyOvf = $('body').css('overflow') || '';
                            $('body').css('overflow', 'hidden');

                            $(elem).css(self.getMaximizeCss())
                                .addClass(cls)
                                .trigger('resize', { fullscreen: 'on' });

                            checkDialog();

                            $(window).on('resize.' + namespace, resize).trigger('resize');

                            return true;
                        }
                    };
                },
                restoreStyle = function (elem) {
                    if (orgStyle && orgStyle.elm == elem) {
                        $(elem).removeClass(cls + ' ' + clsN).attr('style', orgStyle.style);
                        orgStyle = null;
                    }
                },
                resize = function (e) {
                    var elm;
                    if (e.target === window) {
                        resizeTm && cancelAnimationFrame(resizeTm);
                        resizeTm = requestAnimationFrame(function () {
                            if (elm = funcObj.fullElm()) {
                                $(elm).trigger('resize', { fullscreen: 'on' });
                            }
                        });
                    }
                };

            setFuncObj();

            $(document).on('fullscreenchange.' + namespace + ' webkitfullscreenchange.' + namespace + ' mozfullscreenchange.' + namespace + ' MSFullscreenChange.' + namespace, function (e) {
                if (self.UA.Fullscreen) {
                    var elm = funcObj.fullElm(),
                        win = $(window);

                    resizeTm && cancelAnimationFrame(resizeTm);
                    if (elm === null) {
                        win.off('resize.' + namespace, resize);
                        if (orgStyle) {
                            elm = orgStyle.elm;
                            restoreStyle(elm);
                            $(elm).trigger('resize', { fullscreen: 'off' });
                        }
                    } else {
                        $(elm).addClass(cls + ' ' + clsN)
                            .attr('style', 'width:100%; height:100%; margin:0; padding:0;')
                            .trigger('resize', { fullscreen: 'on' });
                        win.on('resize.' + namespace, resize);
                        checkDialog();
                    }
                    win.trigger('resize');
                }
            });

            /**
             * Toggle Full Scrren Mode
             * 
             * @param  Object target
             * @param  Bool   full
             * @return Object | Null  DOM node object of current full scrren
             */
            self.toggleFullscreen = function (target, full) {
                var elm = $(target).get(0),
                    curElm = null;

                curElm = funcObj.fullElm();
                if (curElm) {
                    if (curElm == elm) {
                        if (full === true) {
                            return curElm;
                        }
                    } else {
                        if (full === false) {
                            return curElm;
                        }
                    }
                    funcObj.exitFull();
                    return null;
                } else {
                    if (full === false) {
                        return null;
                    }
                }

                setFuncObj();
                orgStyle = { elm: elm, style: $(elm).attr('style') };
                if (funcObj.toFull(elm) !== false) {
                    return elm;
                } else {
                    orgStyle = null;
                    return null;
                }
            };
        })();

        // Closure for toggleMaximize
        (function () {
            var cls = 'elfinder-maximized',
                resizeTm,
                resize = function (e) {
                    if (e.target === window && e.data && e.data.elm) {
                        var elm = e.data.elm;
                        resizeTm && cancelAnimationFrame(resizeTm);
                        resizeTm = requestAnimationFrame(function () {
                            elm.trigger('resize', { maximize: 'on' });
                        });
                    }
                },
                exitMax = function (elm) {
                    $(window).off('resize.' + namespace, resize);
                    $('body').css('overflow', elm.data('bodyOvf'));
                    elm.removeClass(cls)
                        .attr('style', elm.data('orgStyle'))
                        .removeData('bodyOvf')
                        .removeData('orgStyle');
                    elm.trigger('resize', { maximize: 'off' });
                },
                toMax = function (elm) {
                    elm.data('bodyOvf', $('body').css('overflow') || '')
                        .data('orgStyle', elm.attr('style'))
                        .addClass(cls)
                        .css(self.getMaximizeCss());
                    $('body').css('overflow', 'hidden');
                    $(window).on('resize.' + namespace, { elm: elm }, resize);
                    elm.trigger('resize', { maximize: 'on' });
                };

            /**
             * Toggle Maximize target node
             * 
             * @param  Object target
             * @param  Bool   max
             * @return void
             */
            self.toggleMaximize = function (target, max) {
                var elm = $(target),
                    maximized = elm.hasClass(cls);

                if (maximized) {
                    if (max === true) {
                        return;
                    }
                    exitMax(elm);
                } else {
                    if (max === false) {
                        return;
                    }
                    toMax(elm);
                }
            };
        })();

        /*************  init stuffs  ****************/
        Object.assign($.ui.keyCode, {
            'F1': 112,
            'F2': 113,
            'F3': 114,
            'F4': 115,
            'F5': 116,
            'F6': 117,
            'F7': 118,
            'F8': 119,
            'F9': 120,
            'F10': 121,
            'F11': 122,
            'F12': 123,
            'DIG0': 48,
            'DIG1': 49,
            'DIG2': 50,
            'DIG3': 51,
            'DIG4': 52,
            'DIG5': 53,
            'DIG6': 54,
            'DIG7': 55,
            'DIG8': 56,
            'DIG9': 57,
            'NUM0': 96,
            'NUM1': 97,
            'NUM2': 98,
            'NUM3': 99,
            'NUM4': 100,
            'NUM5': 101,
            'NUM6': 102,
            'NUM7': 103,
            'NUM8': 104,
            'NUM9': 105,
            'CONTEXTMENU': 93,
            'DOT': 190
        });

        this.dragUpload = false;
        this.xhrUpload = (typeof XMLHttpRequestUpload != 'undefined' || typeof XMLHttpRequestEventTarget != 'undefined') && typeof File != 'undefined' && typeof FormData != 'undefined';

        // configure transport object
        this.transport = {};

        if (typeof (this.options.transport) == 'object') {
            this.transport = this.options.transport;
            if (typeof (this.transport.init) == 'function') {
                this.transport.init(this);
            }
        }

        if (typeof (this.transport.send) != 'function') {
            this.transport.send = function (opts) {
                if (!self.UA.IE) {
                    // keep native xhr object for handling property responseURL
                    opts._xhr = new XMLHttpRequest();
                    opts.xhr = function () {
                        if (opts.progress) {
                            opts._xhr.addEventListener('progress', opts.progress);
                        }
                        return opts._xhr;
                    };
                }
                return $.ajax(opts);
            };
        }

        if (this.transport.upload == 'iframe') {
            this.transport.upload = $.proxy(this.uploads.iframe, this);
        } else if (typeof (this.transport.upload) == 'function') {
            this.dragUpload = !!this.options.dragUploadAllow;
        } else if (this.xhrUpload && !!this.options.dragUploadAllow) {
            this.transport.upload = $.proxy(this.uploads.xhr, this);
            this.dragUpload = true;
        } else {
            this.transport.upload = $.proxy(this.uploads.iframe, this);
        }

        /**
         * Decoding 'raw' string converted to unicode
         * 
         * @param  String str
         * @return String
         */
        this.decodeRawString = function (str) {
            var charCodes = function (str) {
                var i, len, arr;
                for (i = 0, len = str.length, arr = []; i < len; i++) {
                    arr.push(str.charCodeAt(i));
                }
                return arr;
            },
                scalarValues = function (arr) {
                    var scalars = [], i, len, c;
                    if (typeof arr === 'string') { arr = charCodes(arr); }
                    for (i = 0, len = arr.length; c = arr[i], i < len; i++) {
                        if (c >= 0xd800 && c <= 0xdbff) {
                            scalars.push((c & 1023) + 64 << 10 | arr[++i] & 1023);
                        } else {
                            scalars.push(c);
                        }
                    }
                    return scalars;
                },
                decodeUTF8 = function (arr) {
                    var i, len, c, str, char = String.fromCharCode;
                    for (i = 0, len = arr.length, str = ""; c = arr[i], i < len; i++) {
                        if (c <= 0x7f) {
                            str += char(c);
                        } else if (c <= 0xdf && c >= 0xc2) {
                            str += char((c & 31) << 6 | arr[++i] & 63);
                        } else if (c <= 0xef && c >= 0xe0) {
                            str += char((c & 15) << 12 | (arr[++i] & 63) << 6 | arr[++i] & 63);
                        } else if (c <= 0xf7 && c >= 0xf0) {
                            str += char(
                                0xd800 | ((c & 7) << 8 | (arr[++i] & 63) << 2 | arr[++i] >>> 4 & 3) - 64,
                                0xdc00 | (arr[i++] & 15) << 6 | arr[i] & 63
                            );
                        } else {
                            str += char(0xfffd);
                        }
                    }
                    return str;
                };

            return decodeUTF8(scalarValues(str));
        };

        /**
         * Gets target file contents by file.hash
         *
         * @param      String  hash          The hash
         * @param      String  responseType  'blob' or 'arraybuffer' (default)
         * @param      Object  requestOpts   The request options
         * @return     arraybuffer|blob  The contents.
         */
        this.getContents = function (hash, responseType, requestOpts) {
            var self = this,
                dfd = $.Deferred(),
                type = responseType || 'arraybuffer',
                url, req;

            dfd.fail(function () {
                req && req.state() === 'pending' && req.reject();
            });

            url = self.openUrl(hash);
            if (!self.isSameOrigin(url)) {
                url = self.openUrl(hash, true);
            }
            req = self.request(Object.assign({
                data: { cmd: 'get' },
                options: {
                    url: url,
                    type: 'get',
                    cache: true,
                    dataType: 'binary',
                    responseType: type,
                    processData: false
                },
                notify: {
                    type: 'file',
                    cnt: 1,
                    hideCnt: true
                },
                cancel: true
            }, requestOpts || {}))
                .fail(function () {
                    dfd.reject();
                })
                .done(function (data) {
                    dfd.resolve(data);
                });

            return dfd;
        };

        /**
         * Gets the binary by url.
         *
         * @param      {Object}    opts      The options
         * @param      {Function}  callback  The callback
         * @param      {Object}    requestOpts The request options
         * @return     arraybuffer|blob  The contents.
         */
        this.getBinaryByUrl = function (opts, callback, requestOpts) {
            var self = this,
                dfd = $.Deferred(),
                url, req;

            dfd.fail(function () {
                req && req.state() === 'pending' && req.reject();
            });

            req = self.request(Object.assign({
                data: { cmd: 'get' },
                options: Object.assign({
                    type: 'get',
                    cache: true,
                    dataType: 'binary',
                    responseType: 'blob',
                    processData: false
                }, opts)
            }, requestOpts || {}))
                .fail(function () {
                    dfd.reject();
                })
                .done(function (data) {
                    callback && callback(data);
                    dfd.resolve(data);
                });

            return dfd;
        };

        /**
         * Gets the mimetype.
         *
         * @param      {string}  name     The name
         * @param      {string}  orgMime  The organization mime
         * @return     {string}  The mimetype.
         */
        this.getMimetype = function (name, orgMime) {
            var mime = orgMime,
                ext, m;
            m = (name + '').match(/\.([^.]+)$/);
            if (m && (ext = m[1])) {
                if (!extToMimeTable) {
                    extToMimeTable = self.arrayFlip(self.mimeTypes);
                }
                if (!(mime = extToMimeTable[ext.toLowerCase()])) {
                    mime = orgMime;
                }
            }
            return mime;
        };

        /**
         * Supported check hash algorisms
         * 
         * @type Array
         */
        self.hashCheckers = [];

        /**
         * Closure of getContentsHashes()
         */
        (function (self) {
            var hashLibs = {};

            if (window.Worker && window.ArrayBuffer) {
                // make fm.hashCheckers
                if (self.options.cdns.sparkmd5) {
                    hashLibs.SparkMD5 = true;
                    self.hashCheckers.push('md5');
                }
                if (self.options.cdns.jssha) {
                    hashLibs.jsSHA = true;
                    self.hashCheckers = self.hashCheckers.concat(['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'sha3-224', 'sha3-256', 'sha3-384', 'sha3-512', 'shake128', 'shake256']);
                }
            }

            /**
             * Gets the contents hashes.
             *
             * @param      String  target      target file.hash
             * @param      Object  needHashes  need hash lib names
             * @param      Object  requestOpts The request options
             * @return     Object  hashes with lib name as key
             */
            self.getContentsHashes = function (target, needHashes, hashOpts, requestOpts) {
                var dfd = $.Deferred(),
                    needs = self.arrayFlip(needHashes || ['md5'], true),
                    libs = [],
                    jobs = [],
                    res = {},
                    opts = hashOpts ? hashOpts : {
                        shake128len: 256,
                        shake256len: 512
                    },
                    req;

                dfd.fail(function () {
                    req && req.reject();
                });

                if (Object.keys(hashLibs).length) {
                    req = self.getContents(target, 'arraybuffer', requestOpts).done(function (arrayBuffer) {
                        if (needs.md5 && hashLibs.SparkMD5) {
                            jobs.push((function () {
                                var job = $.Deferred();
                                try {
                                    var wk = self.getWorker();
                                    job.fail(function () {
                                        wk && wk.terminate();
                                    });
                                    wk.onmessage = function (ans) {
                                        wk && wk.terminate();
                                        if (ans.data.hash) {
                                            var f;
                                            res.md5 = ans.data.hash;
                                            if (f = self.file(target)) {
                                                f.md5 = res.md5;
                                            }
                                        } else if (ans.data.error) {
                                            res.md5 = ans.data.error;
                                        }
                                        dfd.notify(res);
                                        job.resolve();
                                    };
                                    wk.onerror = function (e) {
                                        job.reject();
                                    };
                                    wk.postMessage({
                                        scripts: [self.options.cdns.sparkmd5, self.getWorkerUrl('calcfilehash.js')],
                                        data: { type: 'md5', bin: arrayBuffer }
                                    });
                                    dfd.fail(function () {
                                        job.reject();
                                    });
                                } catch (e) {
                                    job.reject();
                                    delete hashLibs.SparkMD5;
                                }
                                return job;
                            })());
                        }
                        if (hashLibs.jsSHA) {
                            $.each(['1', '224', '256', '384', '512', '3-224', '3-256', '3-384', '3-512', 'ke128', 'ke256'], function (i, v) {
                                if (needs['sha' + v]) {
                                    jobs.push((function () {
                                        var job = $.Deferred();
                                        try {
                                            var wk = self.getWorker();
                                            job.fail(function () {
                                                wk && wk.terminate();
                                            });
                                            wk.onmessage = function (ans) {
                                                wk && wk.terminate();
                                                if (ans.data.hash) {
                                                    var f;
                                                    res['sha' + v] = ans.data.hash;
                                                    if (f = self.file(target)) {
                                                        f['sha' + v] = res['sha' + v];
                                                    }
                                                } else if (ans.data.error) {
                                                    res['sha' + v] = ans.data.error;
                                                }
                                                dfd.notify(res);
                                                job.resolve();
                                            };
                                            wk.onerror = function (e) {
                                                job.reject();
                                            };
                                            wk.postMessage({
                                                scripts: [self.options.cdns.jssha, self.getWorkerUrl('calcfilehash.js')],
                                                data: { type: v, bin: arrayBuffer, hashOpts: opts }
                                            });
                                            dfd.fail(function () {
                                                job.reject();
                                            });
                                        } catch (e) {
                                            job.reject();
                                            delete hashLibs.jsSHA;
                                        }
                                        return job;
                                    })());
                                }
                            });
                        }
                        if (jobs.length) {
                            $.when.apply(null, jobs).always(function () {
                                dfd.resolve(res);
                            });
                        } else {
                            dfd.reject();
                        }
                    }).fail(function () {
                        dfd.reject();
                    });
                } else {
                    dfd.reject();
                }

                return dfd;
            };
        })(this);

        /**
         * Parse error value to display
         *
         * @param  Mixed  error
         * @return Mixed  parsed error
         */
        this.parseError = function (error) {
            var arg = error;
            if ($.isPlainObject(arg)) {
                arg = arg.error;
            }
            return arg;
        };

        /**
         * Alias for this.trigger('error', {error : 'message'})
         *
         * @param  String  error message
         * @return elFinder
         **/
        this.error = function () {
            var arg = arguments[0],
                opts = arguments[1] || null,
                err;
            if (arguments.length == 1 && typeof (arg) === 'function') {
                return self.bind('error', arg);
            } else {
                err = this.parseError(arg);
                return (err === true || !err) ? this : self.trigger('error', { error: err, opts: opts });
            }
        };

        // create bind/trigger aliases for build-in events
        $.each(events, function (i, name) {
            self[name] = function () {
                var arg = arguments[0];
                return arguments.length == 1 && typeof (arg) == 'function'
                    ? self.bind(name, arg)
                    : self.trigger(name, $.isPlainObject(arg) ? arg : {});
            };
        });

        // bind core event handlers
        this
            .enable(function () {
                if (!enabled && self.api && self.visible() && self.ui.overlay.is(':hidden') && !node.children('.elfinder-dialog.' + self.res('class', 'editing') + ':visible').length) {
                    enabled = true;
                    document.activeElement && document.activeElement.blur();
                    node.removeClass('elfinder-disabled');
                }
            })
            .disable(function () {
                prevEnabled = enabled;
                enabled = false;
                node.addClass('elfinder-disabled');
            })
            .open(function () {
                selected = [];
            })
            .select(function (e) {
                var cnt = 0,
                    unselects = [];
                selected = $.grep(e.data.selected || e.data.value || [], function (hash) {
                    if (unselects.length || (self.maxTargets && ++cnt > self.maxTargets)) {
                        unselects.push(hash);
                        return false;
                    } else {
                        return files[hash] ? true : false;
                    }
                });
                if (unselects.length) {
                    self.trigger('unselectfiles', { files: unselects, inselect: true });
                    self.toast({ mode: 'warning', msg: self.i18n(['errMaxTargets', self.maxTargets]) });
                }
            })
            .error(function (e) {
                var opts = {
                    cssClass: 'elfinder-dialog-error',
                    title: self.i18n('error'),
                    resizable: false,
                    destroyOnClose: true,
                    buttons: {}
                },
                    node = self.getUI(),
                    cnt = node.children('.elfinder-dialog-error').length,
                    last, counter;

                if (cnt < self.options.maxErrorDialogs) {
                    opts.buttons[self.i18n(self.i18n('btnClose'))] = function () { $(this).elfinderdialog('close'); };

                    if (e.data.opts && $.isPlainObject(e.data.opts)) {
                        Object.assign(opts, e.data.opts);
                    }

                    self.dialog('<span class="elfinder-dialog-icon elfinder-dialog-icon-error"></span>' + self.i18n(e.data.error), opts);
                } else {
                    last = node.children('.elfinder-dialog-error:last').children('.ui-dialog-content:first');
                    counter = last.children('.elfinder-error-counter');
                    if (counter.length) {
                        counter.data('cnt', parseInt(counter.data('cnt')) + 1).html(self.i18n(['moreErrors', counter.data('cnt')]));
                    } else {
                        counter = $('<span class="elfinder-error-counter">' + self.i18n(['moreErrors', 1]) + '</span>').data('cnt', 1);
                        last.append('<br/>', counter);
                    }
                }
            })
            .bind('tmb', function (e) {
                $.each(e.data.images || [], function (hash, tmb) {
                    if (files[hash]) {
                        files[hash].tmb = tmb;
                    }
                });
            })
            .bind('searchstart', function (e) {
                Object.assign(self.searchStatus, e.data);
                self.searchStatus.state = 1;
            })
            .bind('search', function (e) {
                self.searchStatus.state = 2;
            })
            .bind('searchend', function () {
                self.searchStatus.state = 0;
                self.searchStatus.ininc = false;
                self.searchStatus.mixed = false;
            })
            .bind('canMakeEmptyFile', function (e) {
                var data = e.data,
                    obj = {};
                if (data && Array.isArray(data.mimes)) {
                    if (!data.unshift) {
                        obj = self.mimesCanMakeEmpty;
                    }
                    $.each(data.mimes, function () {
                        if (!obj[this]) {
                            obj[this] = self.mimeTypes[this];
                        }
                    });
                    if (data.unshift) {
                        self.mimesCanMakeEmpty = Object.assign(obj, self.mimesCanMakeEmpty);
                    }
                }
            })
            .bind('themechange', function () {
                requestAnimationFrame(function () {
                    self.trigger('uiresize');
                });
            })
            ;

        // We listen and emit a sound on delete according to option
        if (true === this.options.sound) {
            this.bind('playsound', function (e) {
                var play = beeper.canPlayType && beeper.canPlayType('audio/wav; codecs="1"'),
                    file = e.data && e.data.soundFile;

                play && file && play != '' && play != 'no' && $(beeper).html('<source src="' + soundPath + file + '" type="audio/wav">')[0].play();
            });
        }

        // bind external event handlers
        $.each(this.options.handlers, function (event, callback) {
            self.bind(event, callback);
        });

        /**
         * History object. Store visited folders
         *
         * @type Object
         **/
        this.history = new this.history(this);

        /**
         * Root hashed
         * 
         * @type Object
         */
        this.roots = {};

        /**
         * leaf roots
         * 
         * @type Object
         */
        this.leafRoots = {};

        this.volumeExpires = {};

        /**
         * Loaded commands
         *
         * @type Object
         **/
        this._commands = {};

        if (!Array.isArray(this.options.commands)) {
            this.options.commands = [];
        }

        if ($.inArray('*', this.options.commands) !== -1) {
            this.options.commands = Object.keys(this.commands);
        }

        /**
         * UI command map of cwd volume ( That volume driver option `uiCmdMap` )
         *
         * @type Object
         **/
        this.commandMap = {};

        /**
         * cwd options of each volume
         * key: volumeid
         * val: options object
         * 
         * @type Object
         */
        this.volOptions = {};

        /**
         * Has volOptions data
         * 
         * @type Boolean
         */
        this.hasVolOptions = false;

        /**
         * Hash of trash holders
         * key: trash folder hash
         * val: source volume hash
         * 
         * @type Object
         */
        this.trashes = {};

        /**
         * cwd options of each folder/file
         * key: hash
         * val: options object
         *
         * @type Object
         */
        this.optionsByHashes = {};

        /**
         * UI Auto Hide Functions
         * Each auto hide function mast be call to `fm.trigger('uiautohide')` at end of process
         *
         * @type Array
         **/
        this.uiAutoHide = [];

        // trigger `uiautohide`
        this.one('open', function () {
            if (self.uiAutoHide.length) {
                setTimeout(function () {
                    self.trigger('uiautohide');
                }, 500);
            }
        });

        // Auto Hide Functions sequential processing start
        this.bind('uiautohide', function () {
            if (self.uiAutoHide.length) {
                self.uiAutoHide.shift()();
            }
        });

        if (this.options.width) {
            width = this.options.width;
        }

        if (this.options.height) {
            height = this.options.height;
        }

        if (this.options.heightBase) {
            heightBase = $(this.options.heightBase);
        }

        if (this.options.soundPath) {
            soundPath = this.options.soundPath.replace(/\/+$/, '') + '/';
        } else {
            soundPath = this.baseUrl + soundPath;
        }

        if (this.options.parrotHeaders && Array.isArray(this.options.parrotHeaders) && this.options.parrotHeaders.length) {
            this.parrotHeaders = this.options.parrotHeaders;
            // check sessionStorage
            $.each(this.parrotHeaders, function (i, h) {
                var v = self.sessionStorage('core-ph:' + h);
                if (v) {
                    self.customHeaders[h] = v;
                }
            });
        } else {
            this.parrotHeaders = [];
        }

        self.one('opendone', function () {
            var tm;
            // attach events to document
            $(document)
                // disable elfinder on click outside elfinder
                .on('click.' + namespace, function (e) { enabled && !self.options.enableAlways && !$(e.target).closest(node).length && self.disable(); })
                // exec shortcuts
                .on(keydown + ' ' + keypress + ' ' + keyup + ' ' + mousedown, execShortcut);

            // attach events to window
            self.options.useBrowserHistory && $(window)
                .on('popstate.' + namespace, function (ev) {
                    var state = ev.originalEvent.state || {},
                        hasThash = state.thash ? true : false,
                        dialog = node.find('.elfinder-frontmost:visible'),
                        input = node.find('.elfinder-navbar-dir,.elfinder-cwd-filename').find('input,textarea'),
                        onOpen, toast;
                    if (!hasThash) {
                        state = { thash: self.cwd().hash };
                        // scroll to elFinder node
                        $('html,body').animate({ scrollTop: node.offset().top });
                    }
                    if (dialog.length || input.length) {
                        history.pushState(state, null, location.pathname + location.search + '#elf_' + state.thash);
                        if (dialog.length) {
                            if (!dialog.hasClass(self.res('class', 'preventback'))) {
                                if (dialog.hasClass('elfinder-contextmenu')) {
                                    $(document).trigger($.Event('keydown', { keyCode: $.ui.keyCode.ESCAPE, ctrlKey: false, shiftKey: false, altKey: false, metaKey: false }));
                                } else if (dialog.hasClass('elfinder-dialog')) {
                                    dialog.elfinderdialog('close');
                                } else {
                                    dialog.trigger('close');
                                }
                            }
                        } else {
                            input.trigger($.Event('keydown', { keyCode: $.ui.keyCode.ESCAPE, ctrlKey: false, shiftKey: false, altKey: false, metaKey: false }));
                        }
                    } else {
                        if (hasThash) {
                            !$.isEmptyObject(self.files()) && self.request({
                                data: { cmd: 'open', target: state.thash, onhistory: 1 },
                                notify: { type: 'open', cnt: 1, hideCnt: true },
                                syncOnFail: true
                            });
                        } else {
                            onOpen = function () {
                                toast.trigger('click');
                            };
                            self.one('open', onOpen, true);
                            toast = self.toast({
                                msg: self.i18n('pressAgainToExit'),
                                onHidden: function () {
                                    self.unbind('open', onOpen);
                                    history.pushState(state, null, location.pathname + location.search + '#elf_' + state.thash);
                                }
                            });
                        }
                    }
                });

            $(window).on('resize.' + namespace, function (e) {
                if (e.target === this) {
                    tm && cancelAnimationFrame(tm);
                    tm = requestAnimationFrame(function () {
                        var prv = node.data('resizeSize') || { w: 0, h: 0 },
                            size = { w: Math.round(node.width()), h: Math.round(node.height()) };
                        node.data('resizeSize', size);
                        if (size.w !== prv.w || size.h !== prv.h) {
                            node.trigger('resize');
                            self.trigger('resize', { width: size.w, height: size.h });
                        }
                    });
                }
            })
                .on('beforeunload.' + namespace, function (e) {
                    var msg, cnt;
                    if (!self.pauseUnloadCheck()) {
                        if (node.is(':visible')) {
                            if (self.ui.notify.children().length && $.inArray('hasNotifyDialog', self.options.windowCloseConfirm) !== -1) {
                                msg = self.i18n('ntfsmth');
                            } else if (node.find('.' + self.res('class', 'editing')).length && $.inArray('editingFile', self.options.windowCloseConfirm) !== -1) {
                                msg = self.i18n('editingFile');
                            } else if ((cnt = Object.keys(self.selected()).length) && $.inArray('hasSelectedItem', self.options.windowCloseConfirm) !== -1) {
                                msg = self.i18n('hasSelected', '' + cnt);
                            } else if ((cnt = Object.keys(self.clipboard()).length) && $.inArray('hasClipboardData', self.options.windowCloseConfirm) !== -1) {
                                msg = self.i18n('hasClipboard', '' + cnt);
                            }
                            if (msg) {
                                e.returnValue = msg;
                                return msg;
                            }
                        }
                        self.trigger('unload');
                    }
                });

            // bind window onmessage for CORS
            $(window).on('message.' + namespace, function (e) {
                var res = e.originalEvent || null,
                    obj, data;
                if (res && (self.convAbsUrl(self.options.url).indexOf(res.origin) === 0 || self.convAbsUrl(self.uploadURL).indexOf(res.origin) === 0)) {
                    try {
                        obj = JSON.parse(res.data);
                        data = obj.data || null;
                        if (data) {
                            if (data.error) {
                                if (obj.bind) {
                                    self.trigger(obj.bind + 'fail', data);
                                }
                                self.error(data.error);
                            } else {
                                data.warning && self.error(data.warning);
                                self.updateCache(data);
                                data.removed && data.removed.length && self.remove(data);
                                data.added && data.added.length && self.add(data);
                                data.changed && data.changed.length && self.change(data);
                                if (obj.bind) {
                                    self.trigger(obj.bind, data);
                                    self.trigger(obj.bind + 'done');
                                }
                                data.sync && self.sync();
                            }
                        }
                    } catch (e) {
                        self.sync();
                    }
                }
            });

            // elFinder enable always
            if (self.options.enableAlways) {
                $(window).on('focus.' + namespace, function (e) {
                    (e.target === this) && self.enable();
                });
                if (inFrame) {
                    $(window.top).on('focus.' + namespace, function () {
                        if (self.enable() && (!parentIframe || parentIframe.is(':visible'))) {
                            requestAnimationFrame(function () {
                                $(window).trigger('focus');
                            });
                        }
                    });
                }
            } else if (inFrame) {
                $(window).on('blur.' + namespace, function (e) {
                    enabled && e.target === this && self.disable();
                });
            }

            // return focus to the window on click (elFInder in the frame)
            if (inFrame) {
                node.on('click', function (e) {
                    $(window).trigger('focus');
                });
            }

            // elFinder to enable by mouse over
            if (self.options.enableByMouseOver) {
                node.on('mouseenter touchstart', function (e) {
                    (inFrame) && $(window).trigger('focus');
                    !self.enabled() && self.enable();
                });
            }

            // When the browser tab turn to foreground/background
            $(window).on('visibilitychange.' + namespace, function (e) {
                var background = document.hidden || document.webkitHidden || document.msHidden;
                // AutoSync turn On/Off
                if (self.options.syncStart) {
                    self.autoSync(background ? 'stop' : void (0));
                }
            });
        });

        // store instance in node
        node[0].elfinder = this;

        // auto load language file
        dfrdsBeforeBootup.push((function () {
            var lang = self.lang,
                langJs = self.i18nBaseUrl + 'elfinder.' + lang + '.js',
                dfd = $.Deferred().done(function () {
                    if (self.i18[lang]) {
                        self.lang = lang;
                    }
                    self.trigger('i18load');
                    i18n = self.lang === 'en'
                        ? self.i18['en']
                        : $.extend(true, {}, self.i18['en'], self.i18[self.lang]);
                });

            if (!self.i18[lang]) {
                self.lang = 'en';
                if (self.hasRequire) {
                    require([langJs], function () {
                        dfd.resolve();
                    }, function () {
                        dfd.resolve();
                    });
                } else {
                    self.loadScript([langJs], function () {
                        dfd.resolve();
                    }, {
                        loadType: 'tag',
                        error: function () {
                            dfd.resolve();
                        }
                    });
                }
            } else {
                dfd.resolve();
            }
            return dfd;
        })());

        // elFinder boot up function
        bootUp = function () {
            var columnNames;

            /**
             * i18 messages
             *
             * @type Object
             **/
            self.messages = i18n.messages;

            // check jquery ui
            if (!($.fn.selectable && $.fn.draggable && $.fn.droppable && $.fn.resizable && $.fn.button && $.fn.slider)) {
                return alert(self.i18n('errJqui'));
            }

            // check node
            if (!node.length) {
                return alert(self.i18n('errNode'));
            }
            // check connector url
            if (!self.options.url) {
                return alert(self.i18n('errURL'));
            }

            // column key/name map for fm.getColumnName()
            columnNames = Object.assign({
                name: self.i18n('name'),
                perm: self.i18n('perms'),
                date: self.i18n('modify'),
                size: self.i18n('size'),
                kind: self.i18n('kind'),
                modestr: self.i18n('mode'),
                modeoct: self.i18n('mode'),
                modeboth: self.i18n('mode')
            }, self.options.uiOptions.cwd.listView.columnsCustomName);

            /**
             * Gets the column name of cwd list view
             *
             * @param      String  key     The key
             * @return     String  The column name.
             */
            self.getColumnName = function (key) {
                var res = columnNames[key] || self.i18n(key);
                return typeof res === 'function' ? res() : res;
            };

            /**
             * Interface direction
             *
             * @type String
             * @default "ltr"
             **/
            self.direction = i18n.direction;

            /**
             * Date/time format
             *
             * @type String
             * @default "m.d.Y"
             **/
            self.dateFormat = self.options.dateFormat || i18n.dateFormat;

            /**
             * Date format like "Yesterday 10:20:12"
             *
             * @type String
             * @default "{day} {time}"
             **/
            self.fancyFormat = self.options.fancyDateFormat || i18n.fancyDateFormat;

            /**
             * Date format for if upload file has not original unique name
             * e.g. Clipboard image data, Image data taken with iOS
             *
             * @type String
             * @default "ymd-His"
             **/
            self.nonameDateFormat = (self.options.nonameDateFormat || i18n.nonameDateFormat).replace(/[\/\\]/g, '_');

            /**
             * Css classes 
             *
             * @type String
             **/
            self.cssClass = 'ui-helper-reset ui-helper-clearfix ui-widget ui-widget-content ui-corner-all elfinder elfinder-'
                + (self.direction == 'rtl' ? 'rtl' : 'ltr')
                + (self.UA.Touch ? (' elfinder-touch' + (self.options.resizable ? ' touch-punch' : '')) : '')
                + (self.UA.Mobile ? ' elfinder-mobile' : '')
                + (self.UA.iOS ? ' elfinder-ios' : '')
                + ' ' + self.options.cssClass;

            // prepare node
            node.addClass(self.cssClass)
                .on(mousedown, function () {
                    !enabled && self.enable();
                });

            // draggable closure
            (function () {
                var ltr, wzRect, wzBottom, wzBottom2, nodeStyle,
                    keyEvt = keydown + 'draggable' + ' keyup.' + namespace + 'draggable';

                /**
                 * Base draggable options
                 *
                 * @type Object
                 **/
                self.draggable = {
                    appendTo: node,
                    addClasses: false,
                    distance: 4,
                    revert: true,
                    refreshPositions: false,
                    cursor: 'crosshair',
                    cursorAt: { left: 50, top: 47 },
                    scroll: false,
                    start: function (e, ui) {
                        var helper = ui.helper,
                            targets = $.grep(helper.data('files') || [], function (h) {
                                if (h) {
                                    remember[h] = true;
                                    return true;
                                }
                                return false;
                            }),
                            locked = false,
                            cnt, h;

                        // fix node size
                        nodeStyle = node.attr('style');
                        node.width(node.width()).height(node.height());

                        // set var for drag()
                        ltr = (self.direction === 'ltr');
                        wzRect = self.getUI('workzone').data('rectangle');
                        wzBottom = wzRect.top + wzRect.height;
                        wzBottom2 = wzBottom - self.getUI('navdock').outerHeight(true);

                        self.draggingUiHelper = helper;
                        cnt = targets.length;
                        while (cnt--) {
                            h = targets[cnt];
                            if (files[h].locked) {
                                locked = true;
                                helper.data('locked', true);
                                break;
                            }
                        }
                        !locked && self.trigger('lockfiles', { files: targets });

                        helper.data('autoScrTm', setInterval(function () {
                            if (helper.data('autoScr')) {
                                self.autoScroll[helper.data('autoScr')](helper.data('autoScrVal'));
                            }
                        }, 50));
                    },
                    drag: function (e, ui) {
                        var helper = ui.helper,
                            autoScr, autoUp, bottom;

                        if ((autoUp = wzRect.top > e.pageY) || wzBottom2 < e.pageY) {
                            if (wzRect.cwdEdge > e.pageX) {
                                autoScr = (ltr ? 'navbar' : 'cwd') + (autoUp ? 'Up' : 'Down');
                            } else {
                                autoScr = (ltr ? 'cwd' : 'navbar') + (autoUp ? 'Up' : 'Down');
                            }
                            if (!autoUp) {
                                if (autoScr.substr(0, 3) === 'cwd') {
                                    if (wzBottom < e.pageY) {
                                        bottom = wzBottom;
                                    } else {
                                        autoScr = null;
                                    }
                                } else {
                                    bottom = wzBottom2;
                                }
                            }
                            if (autoScr) {
                                helper.data('autoScr', autoScr);
                                helper.data('autoScrVal', Math.pow((autoUp ? wzRect.top - e.pageY : e.pageY - bottom), 1.3));
                            }
                        }
                        if (!autoScr) {
                            if (helper.data('autoScr')) {
                                helper.data('refreshPositions', 1).data('autoScr', null);
                            }
                        }
                        if (helper.data('refreshPositions') && $(this).elfUiWidgetInstance('draggable')) {
                            if (helper.data('refreshPositions') > 0) {
                                $(this).draggable('option', { refreshPositions: true, elfRefresh: true });
                                helper.data('refreshPositions', -1);
                            } else {
                                $(this).draggable('option', { refreshPositions: false, elfRefresh: false });
                                helper.data('refreshPositions', null);
                            }
                        }
                    },
                    stop: function (e, ui) {
                        var helper = ui.helper,
                            files;

                        $(document).off(keyEvt);
                        $(this).elfUiWidgetInstance('draggable') && $(this).draggable('option', { refreshPositions: false });
                        self.draggingUiHelper = null;
                        self.trigger('focus').trigger('dragstop');
                        if (!helper.data('droped')) {
                            files = $.grep(helper.data('files') || [], function (h) { return h ? true : false; });
                            self.trigger('unlockfiles', { files: files });
                            self.trigger('selectfiles', { files: self.selected() });
                        }
                        self.enable();

                        // restore node style
                        node.attr('style', nodeStyle);

                        helper.data('autoScrTm') && clearInterval(helper.data('autoScrTm'));
                    },
                    helper: function (e, ui) {
                        var element = this.id ? $(this) : $(this).parents('[id]:first'),
                            helper = $('<div class="elfinder-drag-helper"><span class="elfinder-drag-helper-icon-status"></span></div>'),
                            icon = function (f) {
                                var mime = f.mime, i, tmb = self.tmb(f);
                                i = '<div class="elfinder-cwd-icon elfinder-cwd-icon-drag ' + self.mime2class(mime) + ' ui-corner-all"></div>';
                                if (tmb) {
                                    i = $(i).addClass(tmb.className).css('background-image', "url('" + tmb.url + "')").get(0).outerHTML;
                                } else if (f.icon) {
                                    i = $(i).css(self.getIconStyle(f, true)).get(0).outerHTML;
                                }
                                if (f.csscls) {
                                    i = '<div class="' + f.csscls + '">' + i + '</div>';
                                }
                                return i;
                            },
                            hashes, l, ctr;

                        self.draggingUiHelper && self.draggingUiHelper.stop(true, true);

                        self.trigger('dragstart', { target: element[0], originalEvent: e }, true);

                        hashes = element.hasClass(self.res('class', 'cwdfile'))
                            ? self.selected()
                            : [self.navId2Hash(element.attr('id'))];

                        helper.append(icon(files[hashes[0]])).data('files', hashes).data('locked', false).data('droped', false).data('namespace', namespace).data('dropover', 0);

                        if ((l = hashes.length) > 1) {
                            helper.append(icon(files[hashes[l - 1]]) + '<span class="elfinder-drag-num">' + l + '</span>');
                        }

                        $(document).on(keyEvt, function (e) {
                            if (self._commands.copy) {
                                var chk = (e.shiftKey || e.ctrlKey || e.metaKey);
                                if (ctr !== chk) {
                                    ctr = chk;
                                    if (helper.is(':visible') && helper.data('dropover') && !helper.data('droped')) {
                                        helper.toggleClass('elfinder-drag-helper-plus', helper.data('locked') ? true : ctr);
                                        self.trigger(ctr ? 'unlockfiles' : 'lockfiles', { files: hashes, helper: helper });
                                    }
                                }
                            }
                        });

                        return helper;
                    }
                };
            })();

            // in getFileCallback set - change default actions on double click/enter/ctrl+enter
            if (self.commands.getfile) {
                if (typeof (self.options.getFileCallback) == 'function') {
                    self.bind('dblclick', function (e) {
                        e.preventDefault();
                        self.exec('getfile').fail(function () {
                            self.exec('open', e.data && e.data.file ? [e.data.file] : void (0));
                        });
                    });
                    self.shortcut({
                        pattern: 'enter',
                        description: self.i18n('cmdgetfile'),
                        callback: function () { self.exec('getfile').fail(function () { self.exec(self.OS == 'mac' ? 'rename' : 'open'); }); }
                    })
                        .shortcut({
                            pattern: 'ctrl+enter',
                            description: self.i18n(self.OS == 'mac' ? 'cmdrename' : 'cmdopen'),
                            callback: function () { self.exec(self.OS == 'mac' ? 'rename' : 'open'); }
                        });
                } else {
                    self.options.getFileCallback = null;
                }
            }

            // load commands
            $.each(self.commands, function (name, cmd) {
                var proto = Object.assign({}, cmd.prototype),
                    extendsCmd, opts;
                if (typeof cmd === 'function' && !self._commands[name] && (cmd.prototype.forceLoad || $.inArray(name, self.options.commands) !== -1)) {
                    extendsCmd = cmd.prototype.extendsCmd || '';
                    if (extendsCmd) {
                        if (typeof self.commands[extendsCmd] === 'function') {
                            cmd.prototype = Object.assign({}, base, new self.commands[extendsCmd](), cmd.prototype);
                        } else {
                            return true;
                        }
                    } else {
                        cmd.prototype = Object.assign({}, base, cmd.prototype);
                    }
                    self._commands[name] = new cmd();
                    cmd.prototype = proto;
                    opts = self.options.commandsOptions[name] || {};
                    if (extendsCmd && self.options.commandsOptions[extendsCmd]) {
                        opts = $.extend(true, {}, self.options.commandsOptions[extendsCmd], opts);
                    }
                    self._commands[name].setup(name, opts);
                    // setup linked commands
                    if (self._commands[name].linkedCmds.length) {
                        $.each(self._commands[name].linkedCmds, function (i, n) {
                            var lcmd = self.commands[n];
                            if (typeof lcmd === 'function' && !self._commands[n]) {
                                lcmd.prototype = base;
                                self._commands[n] = new lcmd();
                                self._commands[n].setup(n, self.options.commandsOptions[n] || {});
                            }
                        });
                    }
                }
            });

            /**
             * UI nodes
             *
             * @type Object
             **/
            self.ui = {
                // container for nav panel and current folder container
                workzone: $('<div></div>').appendTo(node).elfinderworkzone(self),
                // contaainer for folders tree / places
                navbar: $('<div></div>').appendTo(node).elfindernavbar(self, self.options.uiOptions.navbar || {}),
                // container for for preview etc at below the navbar
                navdock: $('<div></div>').appendTo(node).elfindernavdock(self, self.options.uiOptions.navdock || {}),
                // contextmenu
                contextmenu: $('<div></div>').appendTo(node).elfindercontextmenu(self),
                // overlay
                overlay: $('<div></div>').appendTo(node).elfinderoverlay({
                    show: function () { self.disable(); },
                    hide: function () { prevEnabled && self.enable(); }
                }),
                // current folder container
                cwd: $('<div></div>').appendTo(node).elfindercwd(self, self.options.uiOptions.cwd || {}),
                // notification dialog window
                notify: self.dialog('', {
                    cssClass: 'elfinder-dialog-notify' + (self.options.notifyDialog.canClose ? '' : ' elfinder-titlebar-button-hide'),
                    position: self.options.notifyDialog.position,
                    absolute: true,
                    resizable: false,
                    autoOpen: false,
                    allowMinimize: true,
                    closeOnEscape: self.options.notifyDialog.canClose ? true : false,
                    title: '&nbsp;',
                    width: self.options.notifyDialog.width ? parseInt(self.options.notifyDialog.width) : null,
                    minHeight: null,
                    minimize: function () { self.ui.notify.trigger('minimize'); }
                }),
                statusbar: $('<div class="ui-widget-header ui-helper-clearfix ui-corner-bottom elfinder-statusbar"></div>').hide().appendTo(node),
                toast: $('<div class="elfinder-toast"></div>').appendTo(node),
                bottomtray: $('<div class="elfinder-bottomtray">').appendTo(node),
                progressbar: $('<div class="elfinder-ui-progressbar">').appendTo(node)
            };

            self.trigger('uiready');

            // load required ui
            $.each(self.options.ui || [], function (i, ui) {
                var name = 'elfinder' + ui,
                    opts = self.options.uiOptions[ui] || {};

                if (!self.ui[ui] && $.fn[name]) {
                    // regist to self.ui before make instance
                    self.ui[ui] = $('<' + (opts.tag || 'div') + '/>').appendTo(node);
                    self.ui[ui][name](self, opts);
                }
            });

            self.ui.progressbar.appendTo(self.ui.workzone);
            self.ui.notify.prev('.ui-dialog-titlebar').append('<div class="elfinder-ui-progressbar"></div>');

            // update size	
            self.resize(width, height);

            // make node resizable
            if (self.options.resizable) {
                node.resizable({
                    resize: function (e, ui) {
                        self.resize(ui.size.width, ui.size.height);
                    },
                    handles: 'se',
                    minWidth: 300,
                    minHeight: 200
                });
                if (self.UA.Touch) {
                    node.addClass('touch-punch');
                }
            }

            (function () {
                var navbar = self.getUI('navbar'),
                    cwd = self.getUI('cwd').parent();

                self.autoScroll = {
                    navbarUp: function (v) {
                        navbar.scrollTop(Math.max(0, navbar.scrollTop() - v));
                    },
                    navbarDown: function (v) {
                        navbar.scrollTop(navbar.scrollTop() + v);
                    },
                    cwdUp: function (v) {
                        cwd.scrollTop(Math.max(0, cwd.scrollTop() - v));
                    },
                    cwdDown: function (v) {
                        cwd.scrollTop(cwd.scrollTop() + v);
                    }
                };
            })();

            // Swipe on the touch devices to show/hide of toolbar or navbar
            if (self.UA.Touch) {
                (function () {
                    var lastX, lastY, nodeOffset, nodeWidth, nodeTop, navbarW, toolbarH,
                        navbar = self.getUI('navbar'),
                        toolbar = self.getUI('toolbar'),
                        moveEv = 'touchmove.stopscroll',
                        moveTm,
                        moveUpOn = function (e) {
                            var touches = e.originalEvent.touches || [{}],
                                y = touches[0].pageY || null;
                            if (!lastY || y < lastY) {
                                e.preventDefault();
                                moveTm && clearTimeout(moveTm);
                            }
                        },
                        moveDownOn = function (e) {
                            e.preventDefault();
                            moveTm && clearTimeout(moveTm);
                        },
                        moveOff = function () {
                            moveTm = setTimeout(function () {
                                node.off(moveEv);
                            }, 100);
                        },
                        handleW, handleH = 50;

                    navbar = navbar.children().length ? navbar : null;
                    toolbar = toolbar.length ? toolbar : null;
                    node.on('touchstart touchmove touchend', function (e) {
                        if (e.type === 'touchend') {
                            lastX = false;
                            lastY = false;
                            moveOff();
                            return;
                        }

                        var touches = e.originalEvent.touches || [{}],
                            x = touches[0].pageX || null,
                            y = touches[0].pageY || null,
                            ltr = (self.direction === 'ltr'),
                            navbarMode, treeWidth, swipeX, moveX, toolbarT, mode;

                        if (x === null || y === null || (e.type === 'touchstart' && touches.length > 1)) {
                            return;
                        }

                        if (e.type === 'touchstart') {
                            nodeOffset = node.offset();
                            nodeWidth = node.width();
                            if (navbar) {
                                lastX = false;
                                if (navbar.is(':hidden')) {
                                    if (!handleW) {
                                        handleW = Math.max(50, nodeWidth / 10);
                                    }
                                    if ((ltr ? (x - nodeOffset.left) : (nodeWidth + nodeOffset.left - x)) < handleW) {
                                        lastX = x;
                                    }
                                } else if (!e.originalEvent._preventSwipeX) {
                                    navbarW = navbar.width();
                                    if (ltr) {
                                        swipeX = (x < nodeOffset.left + navbarW);
                                    } else {
                                        swipeX = (x > nodeOffset.left + nodeWidth - navbarW);
                                    }
                                    if (swipeX) {
                                        handleW = Math.max(50, nodeWidth / 10);
                                        lastX = x;
                                    } else {
                                        lastX = false;
                                    }
                                }
                            }
                            if (toolbar) {
                                lastY = false;
                                if (!e.originalEvent._preventSwipeY) {
                                    toolbarH = toolbar.height();
                                    nodeTop = nodeOffset.top;
                                    if (y - nodeTop < (toolbar.is(':hidden') ? handleH : (toolbarH + 30))) {
                                        lastY = y;
                                        node.on(moveEv, toolbar.is(':hidden') ? moveDownOn : moveUpOn);
                                    }
                                }
                            }
                        } else {
                            if (navbar && lastX !== false) {
                                navbarMode = (ltr ? (lastX > x) : (lastX < x)) ? 'navhide' : 'navshow';
                                moveX = Math.abs(lastX - x);
                                if (navbarMode === 'navhide' && moveX > navbarW * 0.6
                                    || (moveX > (navbarMode === 'navhide' ? navbarW / 3 : 45)
                                        && (navbarMode === 'navshow'
                                            || (ltr ? x < nodeOffset.left + 20 : x > nodeOffset.left + nodeWidth - 20)
                                        ))
                                ) {
                                    self.getUI('navbar').trigger(navbarMode, { handleW: handleW });
                                    lastX = false;
                                }
                            }
                            if (toolbar && lastY !== false) {
                                toolbarT = toolbar.offset().top;
                                if (Math.abs(lastY - y) > Math.min(45, toolbarH / 3)) {
                                    mode = (lastY > y) ? 'slideUp' : 'slideDown';
                                    if (mode === 'slideDown' || toolbarT + 20 > y) {
                                        if (toolbar.is(mode === 'slideDown' ? ':hidden' : ':visible')) {
                                            toolbar.stop(true, true).trigger('toggle', { duration: 100, handleH: handleH });
                                        }
                                        lastY = false;
                                    }
                                }
                            }
                        }
                    });
                })();
            }

            if (self.dragUpload) {
                // add event listener for HTML5 DnD upload
                (function () {
                    var isin = function (e) {
                        return (e.target.nodeName !== 'TEXTAREA' && e.target.nodeName !== 'INPUT' && $(e.target).closest('div.ui-dialog-content').length === 0);
                    },
                        ent = 'native-drag-enter',
                        disable = 'native-drag-disable',
                        c = 'class',
                        navdir = self.res(c, 'navdir'),
                        droppable = self.res(c, 'droppable'),
                        dropover = self.res(c, 'adroppable'),
                        arrow = self.res(c, 'navarrow'),
                        clDropActive = self.res(c, 'adroppable'),
                        wz = self.getUI('workzone'),
                        ltr = (self.direction === 'ltr'),
                        clearTm = function () {
                            autoScrTm && cancelAnimationFrame(autoScrTm);
                            autoScrTm = null;
                        },
                        wzRect, autoScrFn, autoScrTm;

                    node.on('dragenter', function (e) {
                        clearTm();
                        if (isin(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            wzRect = wz.data('rectangle');
                        }
                    })
                        .on('dragleave', function (e) {
                            clearTm();
                            if (isin(e)) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        })
                        .on('dragover', function (e) {
                            var autoUp;
                            if (isin(e)) {
                                e.preventDefault();
                                e.stopPropagation();
                                e.originalEvent.dataTransfer.dropEffect = 'none';
                                if (!autoScrTm) {
                                    autoScrTm = requestAnimationFrame(function () {
                                        var wzBottom = wzRect.top + wzRect.height,
                                            wzBottom2 = wzBottom - self.getUI('navdock').outerHeight(true),
                                            fn;
                                        if ((autoUp = e.pageY < wzRect.top) || e.pageY > wzBottom2) {
                                            if (wzRect.cwdEdge > e.pageX) {
                                                fn = (ltr ? 'navbar' : 'cwd') + (autoUp ? 'Up' : 'Down');
                                            } else {
                                                fn = (ltr ? 'cwd' : 'navbar') + (autoUp ? 'Up' : 'Down');
                                            }
                                            if (!autoUp) {
                                                if (fn.substr(0, 3) === 'cwd') {
                                                    if (wzBottom < e.pageY) {
                                                        wzBottom2 = wzBottom;
                                                    } else {
                                                        fn = '';
                                                    }
                                                }
                                            }
                                            fn && self.autoScroll[fn](Math.pow((autoUp ? wzRect.top - e.pageY : e.pageY - wzBottom2), 1.3));
                                        }
                                        autoScrTm = null;
                                    });
                                }
                            } else {
                                clearTm();
                            }
                        })
                        .on('drop', function (e) {
                            clearTm();
                            if (isin(e)) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        });

                    node.on('dragenter', '.native-droppable', function (e) {
                        if (e.originalEvent.dataTransfer) {
                            var $elm = $(e.currentTarget),
                                id = e.currentTarget.id || null,
                                cwd = null,
                                elfFrom;
                            if (!id) { // target is cwd
                                cwd = self.cwd();
                                $elm.data(disable, false);
                                try {
                                    $.each(e.originalEvent.dataTransfer.types, function (i, v) {
                                        if (v.substr(0, 13) === 'elfinderfrom:') {
                                            elfFrom = v.substr(13).toLowerCase();
                                        }
                                    });
                                } catch (e) { }
                            }
                            if (!cwd || (cwd.write && (!elfFrom || elfFrom !== (window.location.href + cwd.hash).toLowerCase()))) {
                                e.preventDefault();
                                e.stopPropagation();
                                $elm.data(ent, true);
                                $elm.addClass(clDropActive);
                            } else {
                                $elm.data(disable, true);
                            }
                        }
                    })
                        .on('dragleave', '.native-droppable', function (e) {
                            if (e.originalEvent.dataTransfer) {
                                var $elm = $(e.currentTarget);
                                e.preventDefault();
                                e.stopPropagation();
                                if ($elm.data(ent)) {
                                    $elm.data(ent, false);
                                } else {
                                    $elm.removeClass(clDropActive);
                                }
                            }
                        })
                        .on('dragover', '.native-droppable', function (e) {
                            if (e.originalEvent.dataTransfer) {
                                var $elm = $(e.currentTarget);
                                e.preventDefault();
                                e.stopPropagation();
                                e.originalEvent.dataTransfer.dropEffect = $elm.data(disable) ? 'none' : 'copy';
                                $elm.data(ent, false);
                            }
                        })
                        .on('drop', '.native-droppable', function (e) {
                            if (e.originalEvent && e.originalEvent.dataTransfer) {
                                var $elm = $(e.currentTarget),
                                    id;
                                e.preventDefault();
                                e.stopPropagation();
                                $elm.removeClass(clDropActive);
                                if (e.currentTarget.id) {
                                    id = $elm.hasClass(navdir) ? self.navId2Hash(e.currentTarget.id) : self.cwdId2Hash(e.currentTarget.id);
                                } else {
                                    id = self.cwd().hash;
                                }
                                e.originalEvent._target = id;
                                self.exec('upload', { dropEvt: e.originalEvent, target: id }, void 0, id);
                            }
                        });
                })();
            }

            // trigger event cssloaded if cssAutoLoad disabled
            if (self.cssloaded === false) {
                self.cssloaded = true;
                self.trigger('cssloaded');
            }

            // calculate elFinder node z-index
            self.zIndexCalc();

            // send initial request and start to pray >_<
            self.trigger('init')
                .request({
                    data: { cmd: 'open', target: self.startDir(), init: 1, tree: 1 },
                    preventDone: true,
                    notify: { type: 'open', cnt: 1, hideCnt: true },
                    freeze: true
                })
                .fail(function () {
                    self.trigger('fail').disable().lastDir('');
                    listeners = {};
                    shortcuts = {};
                    $(document).add(node).off('.' + namespace);
                    self.trigger = function () { };
                })
                .done(function (data) {
                    var trashDisable = function (th) {
                        var src = self.file(self.trashes[th]),
                            d = self.options.debug,
                            error;

                        if (src && src.volumeid) {
                            delete self.volOptions[src.volumeid].trashHash;
                        }
                        self.trashes[th] = false;
                        self.debug('backend-error', 'Trash hash "' + th + '" was not found or not writable.');
                    },
                        toChkTh = {};

                    // regist rawStringDecoder
                    if (self.options.rawStringDecoder) {
                        self.registRawStringDecoder(self.options.rawStringDecoder);
                    }

                    // re-calculate elFinder node z-index
                    self.zIndexCalc();

                    self.load().debug('api', self.api);
                    // update ui's size after init
                    node.trigger('resize');
                    // initial open
                    open(data);
                    self.trigger('open', data, false);
                    self.trigger('opendone');

                    if (inFrame && self.options.enableAlways) {
                        $(window).trigger('focus');
                    }

                    // check self.trashes
                    $.each(self.trashes, function (th) {
                        var dir = self.file(th),
                            src;
                        if (!dir) {
                            toChkTh[th] = true;
                        } else if (dir.mime !== 'directory' || !dir.write) {
                            trashDisable(th);
                        }
                    });
                    if (Object.keys(toChkTh).length) {
                        self.request({
                            data: { cmd: 'info', targets: Object.keys(toChkTh) },
                            preventDefault: true
                        }).done(function (data) {
                            if (data && data.files) {
                                $.each(data.files, function (i, dir) {
                                    if (dir.mime === 'directory' && dir.write) {
                                        delete toChkTh[dir.hash];
                                    }
                                });
                            }
                        }).always(function () {
                            $.each(toChkTh, trashDisable);
                        });
                    }
                    // to enable / disable
                    self[self.options.enableAlways ? 'enable' : 'disable']();
                });

            // self.timeEnd('load');
            // End of bootUp()
        };

        // call bootCallback function with elFinder instance, extraObject - { dfrdsBeforeBootup: dfrdsBeforeBootup }
        if (bootCallback && typeof bootCallback === 'function') {
            self.bootCallback = bootCallback;
            bootCallback.call(node.get(0), self, { dfrdsBeforeBootup: dfrdsBeforeBootup });
        }

        // call dfrdsBeforeBootup functions then boot up elFinder
        $.when.apply(null, dfrdsBeforeBootup).done(function () {
            bootUp();
        }).fail(function (error) {
            self.error(error);
        });
    };

    //register elFinder to global scope
    if (typeof toGlobal === 'undefined' || toGlobal) {
        window.elFinder = elFinder;
    }

    /**
     * Prototype
     * 
     * @type  Object
     */
    elFinder.prototype = {

        uniqueid: 0,

        res: function (type, id) {
            return this.resources[type] && this.resources[type][id];
        },

        /**
         * User os. Required to bind native shortcuts for open/rename
         *
         * @type String
         **/
        OS: navigator.userAgent.indexOf('Mac') !== -1 ? 'mac' : navigator.userAgent.indexOf('Win') !== -1 ? 'win' : 'other',

        /**
         * User browser UA.
         * jQuery.browser: version deprecated: 1.3, removed: 1.9
         *
         * @type Object
         **/
        UA: (function () {
            var self = this,
                webkit = !document.unqueID && !window.opera && !window.sidebar && 'localStorage' in window && 'WebkitAppearance' in document.documentElement.style,
                chrome = webkit && window.chrome,
                /*setRotated = function() {
                    var a = ((screen && screen.orientation && screen.orientation.angle) || window.orientation || 0) + 0;
                    if (a === -90) {
                        a = 270;
                    }
                    UA.Angle = a;
                    UA.Rotated = a % 180 === 0? false : true;
                },*/
                UA = {
                    // Browser IE <= IE 6
                    ltIE6: typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
                    // Browser IE <= IE 7
                    ltIE7: typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
                    // Browser IE <= IE 8
                    ltIE8: typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
                    // Browser IE <= IE 9
                    ltIE9: document.uniqueID && document.documentMode <= 9,
                    // Browser IE <= IE 10
                    ltIE10: document.uniqueID && document.documentMode <= 10,
                    // Browser IE >= IE 11
                    gtIE11: document.uniqueID && document.documentMode >= 11,
                    IE: document.uniqueID,
                    Firefox: window.sidebar,
                    Opera: window.opera,
                    Webkit: webkit,
                    Chrome: chrome,
                    Edge: (chrome && window.msCredentials) ? true : false,
                    Safari: webkit && !window.chrome,
                    Mobile: typeof window.orientation != "undefined",
                    Touch: typeof window.ontouchstart != "undefined",
                    iOS: navigator.platform.match(/^iP(?:[ao]d|hone)/),
                    Mac: navigator.platform.match(/^Mac/),
                    Fullscreen: (typeof (document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen) !== 'undefined'),
                    Angle: 0,
                    Rotated: false,
                    CSS: (function () {
                        var aStyle = document.createElement('a').style,
                            pStyle = document.createElement('p').style,
                            css;
                        css = 'position:sticky;position:-webkit-sticky;';
                        css += 'width:-webkit-max-content;width:-moz-max-content;width:-ms-max-content;width:max-content;';
                        aStyle.cssText = css;
                        return {
                            positionSticky: aStyle.position.indexOf('sticky') !== -1,
                            widthMaxContent: aStyle.width.indexOf('max-content') !== -1,
                            flex: typeof pStyle.flex !== 'undefined'
                        };
                    })()
                };
            return UA;
        })(),

        /**
         * Is cookie enabled
         * 
         * @type Boolean
         */
        cookieEnabled: window.navigator.cookieEnabled,

        /**
         * Has RequireJS?
         * 
         * @type Boolean
         */
        hasRequire: (typeof define === 'function' && define.amd),

        /**
         * Current request command
         * 
         * @type  String
         */
        currentReqCmd: '',

        /**
         * Current keyboard state
         * 
         * @type  Object
         */
        keyState: {},

        /**
         * Internationalization object
         * 
         * @type  Object
         */
        i18: {
            en: {
                translator: '',
                language: 'English',
                direction: 'ltr',
                dateFormat: 'd.m.Y H:i',
                fancyDateFormat: '$1 H:i',
                nonameDateFormat: 'ymd-His',
                messages: {}
            },
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['msJan', 'msFeb', 'msMar', 'msApr', 'msMay', 'msJun', 'msJul', 'msAug', 'msSep', 'msOct', 'msNov', 'msDec'],

            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        },

        /**
         * File mimetype to kind mapping
         * 
         * @type  Object
         */
        kinds: {
            'unknown': 'Unknown',
            'directory': 'Folder',
            'group': 'Selects',
            'symlink': 'Alias',
            'symlink-broken': 'AliasBroken',
            'application/x-empty': 'TextPlain',
            'application/postscript': 'Postscript',
            'application/vnd.ms-office': 'MsOffice',
            'application/msword': 'MsWord',
            'application/vnd.ms-word': 'MsWord',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'MsWord',
            'application/vnd.ms-word.document.macroEnabled.12': 'MsWord',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'MsWord',
            'application/vnd.ms-word.template.macroEnabled.12': 'MsWord',
            'application/vnd.ms-excel': 'MsExcel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'MsExcel',
            'application/vnd.ms-excel.sheet.macroEnabled.12': 'MsExcel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'MsExcel',
            'application/vnd.ms-excel.template.macroEnabled.12': 'MsExcel',
            'application/vnd.ms-excel.sheet.binary.macroEnabled.12': 'MsExcel',
            'application/vnd.ms-excel.addin.macroEnabled.12': 'MsExcel',
            'application/vnd.ms-powerpoint': 'MsPP',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'MsPP',
            'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'MsPP',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'MsPP',
            'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': 'MsPP',
            'application/vnd.openxmlformats-officedocument.presentationml.template': 'MsPP',
            'application/vnd.ms-powerpoint.template.macroEnabled.12': 'MsPP',
            'application/vnd.ms-powerpoint.addin.macroEnabled.12': 'MsPP',
            'application/vnd.openxmlformats-officedocument.presentationml.slide': 'MsPP',
            'application/vnd.ms-powerpoint.slide.macroEnabled.12': 'MsPP',
            'application/pdf': 'PDF',
            'application/xml': 'XML',
            'application/vnd.oasis.opendocument.text': 'OO',
            'application/vnd.oasis.opendocument.text-template': 'OO',
            'application/vnd.oasis.opendocument.text-web': 'OO',
            'application/vnd.oasis.opendocument.text-master': 'OO',
            'application/vnd.oasis.opendocument.graphics': 'OO',
            'application/vnd.oasis.opendocument.graphics-template': 'OO',
            'application/vnd.oasis.opendocument.presentation': 'OO',
            'application/vnd.oasis.opendocument.presentation-template': 'OO',
            'application/vnd.oasis.opendocument.spreadsheet': 'OO',
            'application/vnd.oasis.opendocument.spreadsheet-template': 'OO',
            'application/vnd.oasis.opendocument.chart': 'OO',
            'application/vnd.oasis.opendocument.formula': 'OO',
            'application/vnd.oasis.opendocument.database': 'OO',
            'application/vnd.oasis.opendocument.image': 'OO',
            'application/vnd.openofficeorg.extension': 'OO',
            'application/x-shockwave-flash': 'AppFlash',
            'application/flash-video': 'Flash video',
            'application/x-bittorrent': 'Torrent',
            'application/javascript': 'JS',
            'application/rtf': 'RTF',
            'application/rtfd': 'RTF',
            'application/x-font-ttf': 'TTF',
            'application/x-font-otf': 'OTF',
            'application/x-rpm': 'RPM',
            'application/x-web-config': 'TextPlain',
            'application/xhtml+xml': 'HTML',
            'application/docbook+xml': 'DOCBOOK',
            'application/x-awk': 'AWK',
            'application/x-gzip': 'GZIP',
            'application/x-bzip2': 'BZIP',
            'application/x-xz': 'XZ',
            'application/zip': 'ZIP',
            'application/x-zip': 'ZIP',
            'application/x-rar': 'RAR',
            'application/x-tar': 'TAR',
            'application/x-7z-compressed': '7z',
            'application/x-jar': 'JAR',
            'text/plain': 'TextPlain',
            'text/x-php': 'PHP',
            'text/html': 'HTML',
            'text/javascript': 'JS',
            'text/css': 'CSS',
            'text/rtf': 'RTF',
            'text/rtfd': 'RTF',
            'text/x-c': 'C',
            'text/x-csrc': 'C',
            'text/x-chdr': 'CHeader',
            'text/x-c++': 'CPP',
            'text/x-c++src': 'CPP',
            'text/x-c++hdr': 'CPPHeader',
            'text/x-shellscript': 'Shell',
            'application/x-csh': 'Shell',
            'text/x-python': 'Python',
            'text/x-java': 'Java',
            'text/x-java-source': 'Java',
            'text/x-ruby': 'Ruby',
            'text/x-perl': 'Perl',
            'text/x-sql': 'SQL',
            'text/xml': 'XML',
            'text/x-comma-separated-values': 'CSV',
            'text/x-markdown': 'Markdown',
            'image/x-ms-bmp': 'BMP',
            'image/jpeg': 'JPEG',
            'image/gif': 'GIF',
            'image/png': 'PNG',
            'image/tiff': 'TIFF',
            'image/x-targa': 'TGA',
            'image/vnd.adobe.photoshop': 'PSD',
            'image/xbm': 'XBITMAP',
            'image/pxm': 'PXM',
            'audio/mpeg': 'AudioMPEG',
            'audio/midi': 'AudioMIDI',
            'audio/ogg': 'AudioOGG',
            'audio/mp4': 'AudioMPEG4',
            'audio/x-m4a': 'AudioMPEG4',
            'audio/wav': 'AudioWAV',
            'audio/x-mp3-playlist': 'AudioPlaylist',
            'video/x-dv': 'VideoDV',
            'video/mp4': 'VideoMPEG4',
            'video/mpeg': 'VideoMPEG',
            'video/x-msvideo': 'VideoAVI',
            'video/quicktime': 'VideoMOV',
            'video/x-ms-wmv': 'VideoWM',
            'video/x-flv': 'VideoFlash',
            'video/x-matroska': 'VideoMKV',
            'video/ogg': 'VideoOGG'
        },

        /**
         * File mimetype to file extention mapping
         * 
         * @type  Object
         * @see   elFinder.mimetypes.js
         */
        mimeTypes: {},

        /**
         * Ajax request data validation rules
         * 
         * @type  Object
         */
        rules: {
            defaults: function (data) {
                if (!data
                    || (data.added && !Array.isArray(data.added))
                    || (data.removed && !Array.isArray(data.removed))
                    || (data.changed && !Array.isArray(data.changed))) {
                    return false;
                }
                return true;
            },
            open: function (data) { return data && data.cwd && data.files && $.isPlainObject(data.cwd) && Array.isArray(data.files); },
            tree: function (data) { return data && data.tree && Array.isArray(data.tree); },
            parents: function (data) { return data && data.tree && Array.isArray(data.tree); },
            tmb: function (data) { return data && data.images && ($.isPlainObject(data.images) || Array.isArray(data.images)); },
            upload: function (data) { return data && ($.isPlainObject(data.added) || Array.isArray(data.added)); },
            search: function (data) { return data && data.files && Array.isArray(data.files); }
        },

        /**
         * Commands costructors
         *
         * @type Object
         */
        commands: {},

        /**
         * Commands to add the item (space delimited)
         * 
         * @type String
         */
        cmdsToAdd: 'archive duplicate extract mkdir mkfile paste rm upload',

        parseUploadData: function (text) {
            var self = this,
                data;

            if (!$.trim(text)) {
                return { error: ['errResponse', 'errDataEmpty'] };
            }

            try {
                data = JSON.parse(text);
            } catch (e) {
                return { error: ['errResponse', 'errDataNotJSON'] };
            }

            data = self.normalize(data);
            if (!self.validResponse('upload', data)) {
                return { error: (data.norError || ['errResponse']) };
            }
            data.removed = $.merge((data.removed || []), $.map(data.added || [], function (f) { return self.file(f.hash) ? f.hash : null; }));
            return data;

        },

        iframeCnt: 0,

        uploads: {
            // xhr muiti uploading flag
            xhrUploading: false,

            // Timer of request fail to sync
            failSyncTm: null,

            // current chunkfail requesting chunk
            chunkfailReq: {},

            // check file/dir exists
            checkExists: function (files, target, fm, isDir) {
                var dfrd = $.Deferred(),
                    names, renames = [], hashes = {}, chkFiles = [],
                    cancel = function () {
                        var i = files.length;
                        while (--i > -1) {
                            files[i]._remove = true;
                        }
                    },
                    resolve = function () {
                        dfrd.resolve(renames, hashes);
                    },
                    check = function () {
                        var existed = [], exists = [], i, c,
                            pathStr = target !== fm.cwd().hash ? fm.path(target, true) + fm.option('separator', target) : '',
                            confirm = function (ndx) {
                                var last = ndx == exists.length - 1,
                                    opts = {
                                        cssClass: 'elfinder-confirm-upload',
                                        title: fm.i18n('cmdupload'),
                                        text: ['errExists', pathStr + exists[ndx].name, 'confirmRepl'],
                                        all: !last,
                                        accept: {
                                            label: 'btnYes',
                                            callback: function (all) {
                                                !last && !all
                                                    ? confirm(++ndx)
                                                    : resolve();
                                            }
                                        },
                                        reject: {
                                            label: 'btnNo',
                                            callback: function (all) {
                                                var i;

                                                if (all) {
                                                    i = exists.length;
                                                    while (ndx < i--) {
                                                        files[exists[i].i]._remove = true;
                                                    }
                                                } else {
                                                    files[exists[ndx].i]._remove = true;
                                                }

                                                !last && !all
                                                    ? confirm(++ndx)
                                                    : resolve();
                                            }
                                        },
                                        cancel: {
                                            label: 'btnCancel',
                                            callback: function () {
                                                cancel();
                                                resolve();
                                            }
                                        },
                                        buttons: [
                                            {
                                                label: 'btnBackup',
                                                cssClass: 'elfinder-confirm-btn-backup',
                                                callback: function (all) {
                                                    var i;
                                                    if (all) {
                                                        i = exists.length;
                                                        while (ndx < i--) {
                                                            renames.push(exists[i].name);
                                                        }
                                                    } else {
                                                        renames.push(exists[ndx].name);
                                                    }
                                                    !last && !all
                                                        ? confirm(++ndx)
                                                        : resolve();
                                                }
                                            }
                                        ]
                                    };

                                if (!isDir) {
                                    opts.buttons.push({
                                        label: 'btnRename' + (last ? '' : 'All'),
                                        cssClass: 'elfinder-confirm-btn-rename',
                                        callback: function () {
                                            renames = null;
                                            resolve();
                                        }
                                    });
                                }
                                if (fm.iframeCnt > 0) {
                                    delete opts.reject;
                                }
                                fm.confirm(opts);
                            };

                        if (!fm.file(target).read) {
                            // for dropbox type
                            resolve();
                            return;
                        }

                        names = $.map(files, function (file, i) { return file.name && (!fm.UA.iOS || file.name !== 'image.jpg') ? { i: i, name: file.name } : null; });

                        fm.request({
                            data: { cmd: 'ls', target: target, intersect: $.map(names, function (item) { return item.name; }) },
                            notify: { type: 'preupload', cnt: 1, hideCnt: true },
                            preventDefault: true
                        })
                            .done(function (data) {
                                var existedArr, cwdItems;
                                if (data) {
                                    if (data.error) {
                                        cancel();
                                    } else {
                                        if (fm.options.overwriteUploadConfirm && fm.option('uploadOverwrite', target)) {
                                            if (data.list) {
                                                if (Array.isArray(data.list)) {
                                                    existed = data.list || [];
                                                } else {
                                                    existedArr = [];
                                                    existed = $.map(data.list, function (n) {
                                                        if (typeof n === 'string') {
                                                            return n;
                                                        } else {
                                                            // support to >=2.1.11 plugin Normalizer, Sanitizer
                                                            existedArr = existedArr.concat(n);
                                                            return false;
                                                        }
                                                    });
                                                    if (existedArr.length) {
                                                        existed = existed.concat(existedArr);
                                                    }
                                                    hashes = data.list;
                                                }
                                                exists = $.grep(names, function (name) {
                                                    return $.inArray(name.name, existed) !== -1 ? true : false;
                                                });
                                                if (exists.length && existed.length && target == fm.cwd().hash) {
                                                    cwdItems = $.map(fm.files(target), function (file) { return file.name; });
                                                    if ($.grep(existed, function (n) {
                                                        return $.inArray(n, cwdItems) === -1 ? true : false;
                                                    }).length) {
                                                        fm.sync();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                if (exists.length > 0) {
                                    confirm(0);
                                } else {
                                    resolve();
                                }
                            })
                            .fail(function (error) {
                                cancel();
                                resolve();
                                error && fm.error(error);
                            });
                    };
                if (fm.api >= 2.1 && typeof files[0] == 'object') {
                    check();
                } else {
                    resolve();
                }
                return dfrd;
            },

            // check droped contents
            checkFile: function (data, fm, target) {
                if (!!data.checked || data.type == 'files') {
                    return data.files;
                } else if (data.type == 'data') {
                    var dfrd = $.Deferred(),
                        scanDfd = $.Deferred(),
                        files = [],
                        paths = [],
                        dirctorys = [],
                        processing = 0,
                        items,
                        mkdirs = [],
                        cancel = false,
                        toArray = function (list) {
                            return Array.prototype.slice.call(list || [], 0);
                        },
                        doScan = function (items) {
                            var entry, readEntries,
                                excludes = fm.options.folderUploadExclude[fm.OS] || null,
                                length = items.length,
                                check = function () {
                                    if (--processing < 1 && scanDfd.state() === 'pending') {
                                        scanDfd.resolve();
                                    }
                                },
                                pushItem = function (file) {
                                    if (!excludes || !file.name.match(excludes)) {
                                        paths.push(entry.fullPath || '');
                                        files.push(file);
                                    }
                                    check();
                                },
                                readEntries = function (dirReader) {
                                    var entries = [],
                                        read = function () {
                                            dirReader.readEntries(function (results) {
                                                if (cancel || !results.length) {
                                                    for (var i = 0; i < entries.length; i++) {
                                                        if (cancel) {
                                                            scanDfd.reject();
                                                            break;
                                                        }
                                                        doScan([entries[i]]);
                                                    }
                                                    check();
                                                } else {
                                                    entries = entries.concat(toArray(results));
                                                    read();
                                                }
                                            }, check);
                                        };
                                    read();
                                };

                            processing++;
                            for (var i = 0; i < length; i++) {
                                if (cancel) {
                                    scanDfd.reject();
                                    break;
                                }
                                entry = items[i];
                                if (entry) {
                                    if (entry instanceof File) {
                                        pushItem(entry);
                                    } else if (entry.isFile) {
                                        processing++;
                                        entry.file(pushItem, check);
                                    } else if (entry.isDirectory) {
                                        if (fm.api >= 2.1) {
                                            processing++;
                                            mkdirs.push(entry.fullPath);
                                            readEntries(entry.createReader()); // Start reading dirs.
                                        }
                                    }
                                }
                            }
                            check();
                            return scanDfd;
                        }, hasDirs;

                    items = $.map(data.files.items, function (item) {
                        if (item.kind === 'file') {
                            return (item.getAsEntry ? item.getAsEntry() : item.webkitGetAsEntry()) || item.getAsFile();
                        } else {
                            return null;
                        }
                    });
                    $.each(items, function (i, item) {
                        if (item.isDirectory) {
                            hasDirs = true;
                            return false;
                        }
                    });
                    if (items.length > 0) {
                        fm.uploads.checkExists(items, target, fm, hasDirs).done(function (renames, hashes) {
                            var dfds = [];
                            if (fm.options.overwriteUploadConfirm && fm.option('uploadOverwrite', target)) {
                                if (renames === null) {
                                    data.overwrite = 0;
                                    renames = [];
                                }
                                items = $.grep(items, function (item) {
                                    var i, bak, hash, dfd, hi;
                                    if (item.isDirectory && renames.length) {
                                        i = $.inArray(item.name, renames);
                                        if (i !== -1) {
                                            renames.splice(i, 1);
                                            bak = fm.uniqueName(item.name + fm.options.backupSuffix, null, '');
                                            $.each(hashes, function (h, name) {
                                                if (item.name == name) {
                                                    hash = h;
                                                    return false;
                                                }
                                            });
                                            if (!hash) {
                                                hash = fm.fileByName(item.name, target).hash;
                                            }
                                            fm.lockfiles({ files: [hash] });
                                            dfd = fm.request({
                                                data: { cmd: 'rename', target: hash, name: bak },
                                                notify: { type: 'rename', cnt: 1 }
                                            })
                                                .fail(function () {
                                                    item._remove = true;
                                                    fm.sync();
                                                })
                                                .always(function () {
                                                    fm.unlockfiles({ files: [hash] });
                                                });
                                            dfds.push(dfd);
                                        }
                                    }
                                    return !item._remove ? true : false;
                                });
                            }
                            $.when.apply($, dfds).done(function () {
                                var notifyto, msg,
                                    id = +new Date();

                                if (items.length > 0) {
                                    msg = fm.escape(items[0].name);
                                    if (items.length > 1) {
                                        msg += ' ... ' + items.length + fm.i18n('items');
                                    }
                                    notifyto = setTimeout(function () {
                                        fm.notify({
                                            type: 'readdir',
                                            id: id,
                                            cnt: 1,
                                            hideCnt: true,
                                            msg: fm.i18n('ntfreaddir') + ' (' + msg + ')',
                                            cancel: function () {
                                                cancel = true;
                                            }
                                        });
                                    }, fm.options.notifyDelay);
                                    doScan(items).done(function () {
                                        notifyto && clearTimeout(notifyto);
                                        fm.notify({ type: 'readdir', id: id, cnt: -1 });
                                        if (cancel) {
                                            dfrd.reject();
                                        } else {
                                            dfrd.resolve([files, paths, renames, hashes, mkdirs]);
                                        }
                                    }).fail(function () {
                                        dfrd.reject();
                                    });
                                } else {
                                    dfrd.reject();
                                }
                            });
                        });
                        return dfrd.promise();
                    } else {
                        return dfrd.reject();
                    }
                } else {
                    var ret = [];
                    var check = [];
                    var str = data.files[0];
                    if (data.type == 'html') {
                        var tmp = $("<html></html>").append($.parseHTML(str.replace(/ src=/ig, ' _elfsrc='))),
                            atag;
                        $('img[_elfsrc]', tmp).each(function () {
                            var url, purl,
                                self = $(this),
                                pa = self.closest('a');
                            if (pa && pa.attr('href') && pa.attr('href').match(/\.(?:jpe?g|gif|bmp|png)/i)) {
                                purl = pa.attr('href');
                            }
                            url = self.attr('_elfsrc');
                            if (url) {
                                if (purl) {
                                    $.inArray(purl, ret) == -1 && ret.push(purl);
                                    $.inArray(url, check) == -1 && check.push(url);
                                } else {
                                    $.inArray(url, ret) == -1 && ret.push(url);
                                }
                            }
                            // Probably it's clipboard data
                            if (ret.length === 1 && ret[0].match(/^data:image\/png/)) {
                                data.clipdata = true;
                            }
                        });
                        atag = $('a[href]', tmp);
                        atag.each(function () {
                            var text, loc,
                                parseUrl = function (url) {
                                    var a = document.createElement('a');
                                    a.href = url;
                                    return a;
                                };
                            if (text = $(this).text()) {
                                loc = parseUrl($(this).attr('href'));
                                if (loc.href && loc.href.match(/^(?:ht|f)tp/i) && (atag.length === 1 || !loc.pathname.match(/(?:\.html?|\/[^\/.]*)$/i) || $.trim(text).match(/\.[a-z0-9-]{1,10}$/i))) {
                                    if ($.inArray(loc.href, ret) == -1 && $.inArray(loc.href, check) == -1) ret.push(loc.href);
                                }
                            }
                        });
                    } else {
                        var regex, m, url;
                        regex = /((?:ht|f)tps?:\/\/[-_.!~*\'()a-z0-9;/?:\@&=+\$,%#\*\[\]]+)/ig;
                        while (m = regex.exec(str)) {
                            url = m[1].replace(/&amp;/g, '&');
                            if ($.inArray(url, ret) == -1) ret.push(url);
                        }
                    }
                    return ret;
                }
            },

            // upload transport using XMLHttpRequest
            xhr: function (data, fm) {
                var self = fm ? fm : this,
                    node = self.getUI(),
                    xhr = new XMLHttpRequest(),
                    notifyto = null,
                    notifyto1 = null,
                    notifyto2 = null,
                    dataChecked = data.checked,
                    isDataType = (data.isDataType || data.type == 'data'),
                    target = (data.target || self.cwd().hash),
                    dropEvt = (data.dropEvt || null),
                    extraData = data.extraData || null,
                    chunkEnable = (self.option('uploadMaxConn', target) != -1),
                    multiMax = Math.min(5, Math.max(1, self.option('uploadMaxConn', target))),
                    retryWait = 10000, // 10 sec
                    retryMax = 30, // 10 sec * 30 = 300 secs (Max 5 mins)
                    retry = 0,
                    getFile = function (files) {
                        var dfd = $.Deferred(),
                            file;
                        if (files.promise) {
                            files.always(function (f) {
                                dfd.resolve(Array.isArray(f) && f.length ? (isDataType ? f[0][0] : f[0]) : {});
                            });
                        } else {
                            dfd.resolve(files.length ? (isDataType ? files[0][0] : files[0]) : {});
                        }
                        return dfd;
                    },
                    dfrd = $.Deferred()
                        .fail(function (err) {
                            var error = self.parseError(err),
                                userAbort;
                            if (error === 'userabort') {
                                userAbort = true;
                                error = void 0;
                            }
                            if (files && (self.uploads.xhrUploading || userAbort)) {
                                // send request om fail
                                getFile(files).done(function (file) {
                                    if (!userAbort) {
                                        triggerError(error, file);
                                    }
                                    if (!file._cid) {
                                        // send sync request
                                        self.uploads.failSyncTm && clearTimeout(self.uploads.failSyncTm);
                                        self.uploads.failSyncTm = setTimeout(function () {
                                            self.sync(target);
                                        }, 1000);
                                    } else if (!self.uploads.chunkfailReq[file._cid]) {
                                        // send chunkfail request
                                        self.uploads.chunkfailReq[file._cid] = true;
                                        setTimeout(function () {
                                            fm.request({
                                                data: {
                                                    cmd: 'upload',
                                                    target: target,
                                                    chunk: file._chunk,
                                                    cid: file._cid,
                                                    upload: ['chunkfail'],
                                                    mimes: 'chunkfail'
                                                },
                                                options: {
                                                    type: 'post',
                                                    url: self.uploadURL
                                                },
                                                preventDefault: true
                                            }).always(function () {
                                                delete self.uploads.chunkfailReq[file._chunk];
                                            });
                                        }, 1000);
                                    }
                                });
                            } else {
                                triggerError(error);
                            }
                            !userAbort && self.sync();
                            self.uploads.xhrUploading = false;
                            files = null;
                        })
                        .done(function (data) {
                            self.uploads.xhrUploading = false;
                            files = null;
                            if (data) {
                                self.currentReqCmd = 'upload';
                                data.warning && triggerError(data.warning);
                                self.updateCache(data);
                                data.removed && data.removed.length && self.remove(data);
                                data.added && data.added.length && self.add(data);
                                data.changed && data.changed.length && self.change(data);
                                self.trigger('upload', data, false);
                                self.trigger('uploaddone');
                                if (data.toasts && Array.isArray(data.toasts)) {
                                    $.each(data.toasts, function () {
                                        this.msg && self.toast(this);
                                    });
                                }
                                data.sync && self.sync();
                                if (data.debug) {
                                    self.responseDebug(data);
                                    fm.debug('backend-debug', data);
                                }
                            }
                        })
                        .always(function () {
                            self.abortXHR(xhr);
                            // unregist fnAbort function
                            node.off('uploadabort', fnAbort);
                            $(window).off('unload', fnAbort);
                            notifyto && clearTimeout(notifyto);
                            notifyto1 && clearTimeout(notifyto1);
                            notifyto2 && clearTimeout(notifyto2);
                            dataChecked && !data.multiupload && checkNotify() && self.notify({ type: 'upload', cnt: -cnt, progress: 0, size: 0 });
                            notifyto1 && uploadedNtf && self.notify({ type: 'chunkmerge', cnt: -cnt });
                            chunkMerge && notifyElm.children('.elfinder-notify-chunkmerge').length && self.notify({ type: 'chunkmerge', cnt: -1 });
                        }),
                    formData = new FormData(),
                    files = data.input ? data.input.files : self.uploads.checkFile(data, self, target),
                    cnt = data.checked ? (isDataType ? files[0].length : files.length) : files.length,
                    isChunked = false,
                    loaded = 0,
                    prev = 0,
                    filesize = 0,
                    notify = false,
                    notifyElm = self.ui.notify,
                    cancelBtn = true,
                    uploadedNtf = false,
                    abort = false,
                    checkNotify = function () {
                        if (!notify && (ntfUpload = notifyElm.children('.elfinder-notify-upload')).length) {
                            notify = true;
                        }
                        return notify;
                    },
                    fnAbort = function (e, error) {
                        abort = true;
                        self.abortXHR(xhr, { quiet: true, abort: true });
                        dfrd.reject(error);
                        if (checkNotify()) {
                            self.notify({ type: 'upload', cnt: ntfUpload.data('cnt') * -1, progress: 0, size: 0 });
                        }
                    },
                    cancelToggle = function (show, hasChunk) {
                        ntfUpload.children('.elfinder-notify-cancel')[show ? 'show' : 'hide']();
                        cancelBtn = show;
                    },
                    startNotify = function (size) {
                        if (!size) size = filesize;
                        return setTimeout(function () {
                            notify = true;
                            self.notify({
                                type: 'upload', cnt: cnt, progress: loaded - prev, size: size,
                                cancel: function () {
                                    node.trigger('uploadabort', 'userabort');
                                }
                            });
                            ntfUpload = notifyElm.children('.elfinder-notify-upload');
                            prev = loaded;
                            if (data.multiupload) {
                                cancelBtn && cancelToggle(true);
                            } else {
                                cancelToggle(cancelBtn && loaded < size);
                            }
                        }, self.options.notifyDelay);
                    },
                    doRetry = function () {
                        if (retry++ <= retryMax) {
                            if (checkNotify() && prev) {
                                self.notify({ type: 'upload', cnt: 0, progress: 0, size: prev });
                            }
                            self.abortXHR(xhr, { quiet: true });
                            prev = loaded = 0;
                            setTimeout(function () {
                                var reqId;
                                if (!abort) {
                                    xhr.open('POST', self.uploadURL, true);
                                    if (self.api >= 2.1029) {
                                        reqId = (+ new Date()).toString(16) + Math.floor(1000 * Math.random()).toString(16);
                                        (typeof formData['delete'] === 'function') && formData['delete']('reqid');
                                        formData.append('reqid', reqId);
                                        xhr._requestId = reqId;
                                    }
                                    xhr.send(formData);
                                }
                            }, retryWait);
                        } else {
                            node.trigger('uploadabort', ['errAbort', 'errTimeout']);
                        }
                    },
                    progress = function () {
                        var node;
                        if (notify) {
                            dfrd.notifyWith(ntfUpload, [{
                                cnt: ntfUpload.data('cnt'),
                                progress: ntfUpload.data('progress'),
                                total: ntfUpload.data('total')
                            }]);
                        }
                    },
                    triggerError = function (err, file, unite) {
                        err && self.trigger('xhruploadfail', { error: err, file: file });
                        if (unite) {
                            if (err) {
                                if (errCnt < self.options.maxErrorDialogs) {
                                    if (Array.isArray(err)) {
                                        errors = errors.concat(err);
                                    } else {
                                        errors.push(err);
                                    }
                                }
                                errCnt++;
                            }
                        } else {
                            if (err) {
                                self.error(err);
                            } else {
                                if (errors.length) {
                                    if (errCnt >= self.options.maxErrorDialogs) {
                                        errors = errors.concat('moreErrors', errCnt - self.options.maxErrorDialogs);
                                    }
                                    self.error(errors);
                                }
                                errors = [];
                                errCnt = 0;
                            }
                        }
                    },
                    errors = [],
                    errCnt = 0,
                    renames = (data.renames || null),
                    hashes = (data.hashes || null),
                    chunkMerge = false,
                    ntfUpload = $();

                // regist fnAbort function
                node.one('uploadabort', fnAbort);
                $(window).one('unload.' + fm.namespace, fnAbort);

                !chunkMerge && (prev = loaded);

                if (!isDataType && !cnt) {
                    return dfrd.reject(['errUploadNoFiles']);
                }

                xhr.addEventListener('error', function () {
                    if (xhr.status == 0) {
                        if (abort) {
                            dfrd.reject();
                        } else {
                            // ff bug while send zero sized file
                            // for safari - send directory
                            if (!isDataType && data.files && $.grep(data.files, function (f) { return !f.type && f.size === (self.UA.Safari ? 1802 : 0) ? true : false; }).length) {
                                dfrd.reject(['errAbort', 'errFolderUpload']);
                            } else if (data.input && $.grep(data.input.files, function (f) { return !f.type && f.size === (self.UA.Safari ? 1802 : 0) ? true : false; }).length) {
                                dfrd.reject(['errUploadNoFiles']);
                            } else {
                                doRetry();
                            }
                        }
                    } else {
                        node.trigger('uploadabort', 'errConnect');
                    }
                }, false);

                xhr.addEventListener('load', function (e) {
                    var status = xhr.status, res, curr = 0, error = '', errData, errObj;

                    self.setCustomHeaderByXhr(xhr);

                    if (status >= 400) {
                        if (status > 500) {
                            error = 'errResponse';
                        } else {
                            error = ['errResponse', 'errServerError'];
                        }
                    } else {
                        if (!xhr.responseText) {
                            error = ['errResponse', 'errDataEmpty'];
                        }
                    }

                    if (error) {
                        node.trigger('uploadabort');
                        getFile(files || {}).done(function (file) {
                            return dfrd.reject(file._cid ? null : error);
                        });
                    }

                    loaded = filesize;

                    if (checkNotify() && (curr = loaded - prev)) {
                        self.notify({ type: 'upload', cnt: 0, progress: curr, size: 0 });
                        progress();
                    }

                    res = self.parseUploadData(xhr.responseText);

                    // chunked upload commit
                    if (res._chunkmerged) {
                        formData = new FormData();
                        var _file = [{ _chunkmerged: res._chunkmerged, _name: res._name, _mtime: res._mtime }];
                        chunkMerge = true;
                        node.off('uploadabort', fnAbort);
                        notifyto2 = setTimeout(function () {
                            self.notify({ type: 'chunkmerge', cnt: 1 });
                        }, self.options.notifyDelay);
                        isDataType ? send(_file, files[1]) : send(_file);
                        return;
                    }

                    res._multiupload = data.multiupload ? true : false;
                    if (res.error) {
                        errData = {
                            cmd: 'upload',
                            err: res,
                            xhr: xhr,
                            rc: xhr.status
                        };
                        self.trigger('uploadfail', res);
                        // trigger "requestError" event
                        self.trigger('requestError', errData);
                        if (errData._getEvent && errData._getEvent().isDefaultPrevented()) {
                            res.error = '';
                        }
                        if (res._chunkfailure || res._multiupload) {
                            abort = true;
                            self.uploads.xhrUploading = false;
                            notifyto && clearTimeout(notifyto);
                            if (ntfUpload.length) {
                                self.notify({ type: 'upload', cnt: -cnt, progress: 0, size: 0 });
                                dfrd.reject(res);
                            } else {
                                // for multi connection
                                dfrd.reject();
                            }
                        } else {
                            dfrd.reject(res);
                        }
                    } else {
                        dfrd.resolve(res);
                    }
                }, false);

                xhr.upload.addEventListener('loadstart', function (e) {
                    if (!chunkMerge && e.lengthComputable) {
                        loaded = e.loaded;
                        retry && (loaded = 0);
                        filesize = e.total;
                        if (!loaded) {
                            loaded = parseInt(filesize * 0.05);
                        }
                        if (checkNotify()) {
                            self.notify({ type: 'upload', cnt: 0, progress: loaded - prev, size: data.multiupload ? 0 : filesize });
                            prev = loaded;
                            progress();
                        }
                    }
                }, false);

                xhr.upload.addEventListener('progress', function (e) {
                    var curr;

                    if (e.lengthComputable && !chunkMerge && xhr.readyState < 2) {

                        loaded = e.loaded;

                        // to avoid strange bug in safari (not in chrome) with drag&drop.
                        // bug: macos finder opened in any folder,
                        // reset safari cache (option+command+e), reload elfinder page,
                        // drop file from finder
                        // on first attempt request starts (progress callback called ones) but never ends.
                        // any next drop - successfull.
                        if (!data.checked && loaded > 0 && !notifyto) {
                            notifyto = startNotify(xhr._totalSize - loaded);
                        }

                        if (!filesize) {
                            filesize = e.total;
                            if (!loaded) {
                                loaded = parseInt(filesize * 0.05);
                            }
                        }

                        curr = loaded - prev;
                        if (checkNotify() && (curr / e.total) >= 0.05) {
                            self.notify({ type: 'upload', cnt: 0, progress: curr, size: 0 });
                            prev = loaded;
                            progress();
                        }

                        if (!uploadedNtf && loaded >= filesize && !isChunked) {
                            // Use "chunkmerge" for "server-in-process" notification
                            uploadedNtf = true;
                            notifyto1 = setTimeout(function () {
                                self.notify({ type: 'chunkmerge', cnt: cnt });
                            }, self.options.notifyDelay);
                        }

                        if (cancelBtn && !data.multiupload && loaded >= filesize) {
                            checkNotify() && cancelToggle(false);
                        }
                    }
                }, false);

                var send = function (files, paths) {
                    var size = 0,
                        fcnt = 1,
                        sfiles = [],
                        c = 0,
                        total = cnt,
                        maxFileSize,
                        totalSize = 0,
                        chunked = [],
                        chunkID = new Date().getTime().toString().substr(-9), // for take care of the 32bit backend system
                        BYTES_PER_CHUNK = Math.min((fm.uplMaxSize ? fm.uplMaxSize : 2097152) - 8190, fm.options.uploadMaxChunkSize), // uplMaxSize margin 8kb or options.uploadMaxChunkSize
                        blobSlice = chunkEnable ? false : '',
                        blobSize, blobMtime, blobName, i, start, end, chunks, blob, chunk, added, done, last, failChunk,
                        multi = function (files, num) {
                            var sfiles = [], cid, sfilesLen = 0, cancelChk, hasChunk;
                            if (!abort) {
                                while (files.length && sfiles.length < num) {
                                    sfiles.push(files.shift());
                                }
                                sfilesLen = sfiles.length;
                                if (sfilesLen) {
                                    cancelChk = sfilesLen;
                                    for (var i = 0; i < sfilesLen; i++) {
                                        if (abort) {
                                            break;
                                        }
                                        cid = isDataType ? (sfiles[i][0][0]._cid || null) : (sfiles[i][0]._cid || null);
                                        hasChunk = (hasChunk || cid) ? true : false;
                                        if (!!failChunk[cid]) {
                                            last--;
                                            continue;
                                        }
                                        fm.exec('upload', {
                                            type: data.type,
                                            isDataType: isDataType,
                                            files: sfiles[i],
                                            checked: true,
                                            target: target,
                                            dropEvt: dropEvt,
                                            renames: renames,
                                            hashes: hashes,
                                            multiupload: true,
                                            overwrite: data.overwrite === 0 ? 0 : void 0,
                                            clipdata: data.clipdata
                                        }, void 0, target)
                                            .fail(function (error) {
                                                if (error && error === 'No such command') {
                                                    abort = true;
                                                    fm.error(['errUpload', 'errPerm']);
                                                }
                                                if (cid) {
                                                    failChunk[cid] = true;
                                                }
                                            })
                                            .always(function (e) {
                                                if (e && e.added) added = $.merge(added, e.added);
                                                if (last <= ++done) {
                                                    fm.trigger('multiupload', { added: added });
                                                    notifyto && clearTimeout(notifyto);
                                                    if (checkNotify()) {
                                                        self.notify({ type: 'upload', cnt: -cnt, progress: 0, size: 0 });
                                                    }
                                                }
                                                if (files.length) {
                                                    multi(files, 1); // Next one
                                                } else {
                                                    if (--cancelChk <= 1) {
                                                        if (cancelBtn) {
                                                            cancelToggle(false, hasChunk);
                                                        }
                                                    }
                                                    dfrd.resolve();
                                                }
                                            });
                                    }
                                }
                            }
                            if (sfiles.length < 1 || abort) {
                                if (abort) {
                                    notifyto && clearTimeout(notifyto);
                                    if (cid) {
                                        failChunk[cid] = true;
                                    }
                                    dfrd.reject();
                                } else {
                                    dfrd.resolve();
                                    self.uploads.xhrUploading = false;
                                }
                            }
                        },
                        check = function () {
                            if (!self.uploads.xhrUploading) {
                                self.uploads.xhrUploading = true;
                                multi(sfiles, multiMax); // Max connection: 3
                            } else {
                                setTimeout(check, 100);
                            }
                        },
                        reqId, err;

                    if (!dataChecked && (isDataType || data.type == 'files')) {
                        if (!(maxFileSize = fm.option('uploadMaxSize', target))) {
                            maxFileSize = 0;
                        }
                        for (i = 0; i < files.length; i++) {
                            try {
                                blob = files[i];
                                blobSize = blob.size;
                                if (blobSlice === false) {
                                    blobSlice = '';
                                    if (self.api >= 2.1) {
                                        if ('slice' in blob) {
                                            blobSlice = 'slice';
                                        } else if ('mozSlice' in blob) {
                                            blobSlice = 'mozSlice';
                                        } else if ('webkitSlice' in blob) {
                                            blobSlice = 'webkitSlice';
                                        }
                                    }
                                }
                            } catch (e) {
                                cnt--;
                                total--;
                                continue;
                            }

                            // file size check
                            if ((maxFileSize && blobSize > maxFileSize) || (!blobSlice && fm.uplMaxSize && blobSize > fm.uplMaxSize)) {
                                triggerError(['errUploadFile', blob.name, 'errUploadFileSize'], blob, true);
                                cnt--;
                                total--;
                                continue;
                            }

                            // file mime check
                            if (blob.type && !self.uploadMimeCheck(blob.type, target)) {
                                triggerError(['errUploadFile', blob.name, 'errUploadMime', '(' + blob.type + ')'], blob, true);
                                cnt--;
                                total--;
                                continue;
                            }

                            if (blobSlice && blobSize > BYTES_PER_CHUNK) {
                                start = 0;
                                end = BYTES_PER_CHUNK;
                                chunks = -1;
                                total = Math.floor((blobSize - 1) / BYTES_PER_CHUNK);
                                blobMtime = blob.lastModified ? Math.round(blob.lastModified / 1000) : 0;
                                blobName = data.clipdata ? fm.date(fm.nonameDateFormat) + '.png' : blob.name;

                                totalSize += blobSize;
                                chunked[chunkID] = 0;
                                while (start < blobSize) {
                                    chunk = blob[blobSlice](start, end);
                                    chunk._chunk = blobName + '.' + (++chunks) + '_' + total + '.part';
                                    chunk._cid = chunkID;
                                    chunk._range = start + ',' + chunk.size + ',' + blobSize;
                                    chunk._mtime = blobMtime;
                                    chunked[chunkID]++;

                                    if (size) {
                                        c++;
                                    }
                                    if (typeof sfiles[c] == 'undefined') {
                                        sfiles[c] = [];
                                        if (isDataType) {
                                            sfiles[c][0] = [];
                                            sfiles[c][1] = [];
                                        }
                                    }
                                    size = BYTES_PER_CHUNK;
                                    fcnt = 1;
                                    if (isDataType) {
                                        sfiles[c][0].push(chunk);
                                        sfiles[c][1].push(paths[i]);
                                    } else {
                                        sfiles[c].push(chunk);
                                    }

                                    start = end;
                                    end = start + BYTES_PER_CHUNK;
                                }
                                if (chunk == null) {
                                    triggerError(['errUploadFile', blob.name, 'errUploadFileSize'], blob, true);
                                    cnt--;
                                    total--;
                                } else {
                                    total += chunks;
                                    size = 0;
                                    fcnt = 1;
                                    c++;
                                }
                                continue;
                            }
                            if ((fm.uplMaxSize && size + blobSize > fm.uplMaxSize) || fcnt > fm.uplMaxFile) {
                                size = 0;
                                fcnt = 1;
                                c++;
                            }
                            if (typeof sfiles[c] == 'undefined') {
                                sfiles[c] = [];
                                if (isDataType) {
                                    sfiles[c][0] = [];
                                    sfiles[c][1] = [];
                                }
                            }
                            if (isDataType) {
                                sfiles[c][0].push(blob);
                                sfiles[c][1].push(paths[i]);
                            } else {
                                sfiles[c].push(blob);
                            }
                            size += blobSize;
                            totalSize += blobSize;
                            fcnt++;
                        }

                        if (errors.length) {
                            triggerError();
                        }

                        if (sfiles.length == 0) {
                            // no data
                            data.checked = true;
                            return false;
                        }

                        if (sfiles.length > 1) {
                            // multi upload
                            notifyto = startNotify(totalSize);
                            added = [];
                            done = 0;
                            last = sfiles.length;
                            failChunk = [];
                            check();
                            return true;
                        }

                        // single upload
                        if (isDataType) {
                            files = sfiles[0][0];
                            paths = sfiles[0][1];
                        } else {
                            files = sfiles[0];
                        }
                    }

                    if (!dataChecked) {
                        if (!fm.UA.Safari || !data.files) {
                            notifyto = startNotify(totalSize);
                        } else {
                            xhr._totalSize = totalSize;
                        }
                    }

                    dataChecked = true;

                    if (!files.length) {
                        dfrd.reject(['errUploadNoFiles']);
                    }

                    xhr.open('POST', self.uploadURL, true);

                    // set request headers
                    if (fm.customHeaders) {
                        $.each(fm.customHeaders, function (key) {
                            xhr.setRequestHeader(key, this);
                        });
                    }

                    // set xhrFields
                    if (fm.xhrFields) {
                        $.each(fm.xhrFields, function (key) {
                            if (key in xhr) {
                                xhr[key] = this;
                            }
                        });
                    }

                    if (self.api >= 2.1029) {
                        // request ID
                        reqId = (+ new Date()).toString(16) + Math.floor(1000 * Math.random()).toString(16);
                        formData.append('reqid', reqId);
                        xhr._requestId = reqId;
                    }
                    formData.append('cmd', 'upload');
                    formData.append(self.newAPI ? 'target' : 'current', target);
                    if (renames && renames.length) {
                        $.each(renames, function (i, v) {
                            formData.append('renames[]', v);
                        });
                        formData.append('suffix', fm.options.backupSuffix);
                    }
                    if (hashes) {
                        $.each(hashes, function (i, v) {
                            formData.append('hashes[' + i + ']', v);
                        });
                    }
                    $.each(self.customData, function (key, val) {
                        formData.append(key, val);
                    });
                    $.each(self.options.onlyMimes, function (i, mime) {
                        formData.append('mimes[]', mime);
                    });

                    $.each(files, function (i, file) {
                        var name, relpath;
                        if (file._chunkmerged) {
                            formData.append('chunk', file._chunkmerged);
                            formData.append('upload[]', file._name);
                            formData.append('mtime[]', file._mtime);
                            data.clipdata && formData.append('overwrite', 0);
                            isChunked = true;
                        } else {
                            if (file._chunkfail) {
                                formData.append('upload[]', 'chunkfail');
                                formData.append('mimes', 'chunkfail');
                            } else {
                                if (data.clipdata) {
                                    if (!file._chunk) {
                                        data.overwrite = 0;
                                        name = fm.date(fm.nonameDateFormat) + '.png';
                                    }
                                } else {
                                    if (file.name) {
                                        name = file.name;
                                        if (fm.UA.iOS) {
                                            if (name.match(/^image\.jpe?g$/i)) {
                                                data.overwrite = 0;
                                                name = fm.date(fm.nonameDateFormat) + '.jpg';
                                            } else if (name.match(/^capturedvideo\.mov$/i)) {
                                                data.overwrite = 0;
                                                name = fm.date(fm.nonameDateFormat) + '.mov';
                                            }
                                        }
                                        relpath = (file.webkitRelativePath || file.relativePath || file._relativePath || '').replace(/[^\/]+$/, '');
                                        name = relpath + name;
                                    }
                                }
                                name ? formData.append('upload[]', file, name) : formData.append('upload[]', file);
                            }
                            if (file._chunk) {
                                formData.append('chunk', file._chunk);
                                formData.append('cid', file._cid);
                                formData.append('range', file._range);
                                formData.append('mtime[]', file._mtime);
                                isChunked = true;
                            } else {
                                formData.append('mtime[]', file.lastModified ? Math.round(file.lastModified / 1000) : 0);
                            }
                        }
                    });

                    if (isDataType) {
                        $.each(paths, function (i, path) {
                            formData.append('upload_path[]', path);
                        });
                    }

                    if (data.overwrite === 0) {
                        formData.append('overwrite', 0);
                    }

                    // send int value that which meta key was pressed when dropped  as `dropWith`
                    if (dropEvt) {
                        formData.append('dropWith', parseInt(
                            (dropEvt.altKey ? '1' : '0') +
                            (dropEvt.ctrlKey ? '1' : '0') +
                            (dropEvt.metaKey ? '1' : '0') +
                            (dropEvt.shiftKey ? '1' : '0'), 2));
                    }

                    // set extraData on current request
                    if (extraData) {
                        $.each(extraData, function (key, val) {
                            formData.append(key, val);
                        });
                    }

                    xhr.send(formData);

                    return true;
                };

                if (!isDataType) {
                    if (files.length > 0) {
                        if (!data.clipdata && renames == null) {
                            var mkdirs = [],
                                paths = [],
                                excludes = fm.options.folderUploadExclude[fm.OS] || null;
                            $.each(files, function (i, file) {
                                var relPath = file.webkitRelativePath || file.relativePath || '',
                                    idx, rootDir;
                                if (!relPath) {
                                    return false;
                                }
                                if (excludes && file.name.match(excludes)) {
                                    file._remove = true;
                                    relPath = void (0);
                                } else {
                                    // add '/' as prefix to make same to folder uploading with DnD, see #2607
                                    relPath = '/' + relPath.replace(/\/[^\/]*$/, '').replace(/^\//, '');
                                    if (relPath && $.inArray(relPath, mkdirs) === -1) {
                                        mkdirs.push(relPath);
                                        // checking the root directory to supports <input type="file" webkitdirectory> see #2378
                                        idx = relPath.substr(1).indexOf('/');
                                        if (idx !== -1 && (rootDir = relPath.substr(0, idx + 1)) && $.inArray(rootDir, mkdirs) === -1) {
                                            mkdirs.unshift(rootDir);
                                        }
                                    }
                                }
                                paths.push(relPath);
                            });
                            renames = [];
                            hashes = {};
                            if (mkdirs.length) {
                                (function () {
                                    var checkDirs = $.map(mkdirs, function (name) { return name.substr(1).indexOf('/') === -1 ? { name: name.substr(1) } : null; }),
                                        cancelDirs = [];
                                    fm.uploads.checkExists(checkDirs, target, fm, true).done(
                                        function (res, res2) {
                                            var dfds = [], dfd, bak, hash;
                                            if (fm.options.overwriteUploadConfirm && fm.option('uploadOverwrite', target)) {
                                                cancelDirs = $.map(checkDirs, function (dir) { return dir._remove ? dir.name : null; });
                                                checkDirs = $.grep(checkDirs, function (dir) { return !dir._remove ? true : false; });
                                            }
                                            if (cancelDirs.length) {
                                                $.each(paths.concat(), function (i, path) {
                                                    if ($.inArray(path, cancelDirs) === 0) {
                                                        files[i]._remove = true;
                                                        paths[i] = void (0);
                                                    }
                                                });
                                            }
                                            files = $.grep(files, function (file) { return file._remove ? false : true; });
                                            paths = $.grep(paths, function (path) { return path === void 0 ? false : true; });
                                            if (checkDirs.length) {
                                                dfd = $.Deferred();
                                                if (res.length) {
                                                    $.each(res, function (i, existName) {
                                                        // backup
                                                        bak = fm.uniqueName(existName + fm.options.backupSuffix, null, '');
                                                        $.each(res2, function (h, name) {
                                                            if (res[0] == name) {
                                                                hash = h;
                                                                return false;
                                                            }
                                                        });
                                                        if (!hash) {
                                                            hash = fm.fileByName(res[0], target).hash;
                                                        }
                                                        fm.lockfiles({ files: [hash] });
                                                        dfds.push(
                                                            fm.request({
                                                                data: { cmd: 'rename', target: hash, name: bak },
                                                                notify: { type: 'rename', cnt: 1 }
                                                            })
                                                                .fail(function (error) {
                                                                    dfrd.reject(error);
                                                                    fm.sync();
                                                                })
                                                                .always(function () {
                                                                    fm.unlockfiles({ files: [hash] });
                                                                })
                                                        );
                                                    });
                                                } else {
                                                    dfds.push(null);
                                                }

                                                $.when.apply($, dfds).done(function () {
                                                    // ensure directories
                                                    fm.request({
                                                        data: { cmd: 'mkdir', target: target, dirs: mkdirs },
                                                        notify: { type: 'mkdir', cnt: mkdirs.length },
                                                        preventFail: true
                                                    })
                                                        .fail(function (error) {
                                                            error = error || ['errUnknown'];
                                                            if (error[0] === 'errCmdParams') {
                                                                multiMax = 1;
                                                            } else {
                                                                multiMax = 0;
                                                                dfrd.reject(error);
                                                            }
                                                        })
                                                        .done(function (data) {
                                                            var rm = false;
                                                            if (!data.hashes) {
                                                                data.hashes = {};
                                                            }
                                                            paths = $.map(paths.concat(), function (p, i) {
                                                                if (p === '/') {
                                                                    return target;
                                                                } else {
                                                                    if (data.hashes[p]) {
                                                                        return data.hashes[p];
                                                                    } else {
                                                                        rm = true;
                                                                        files[i]._remove = true;
                                                                        return null;
                                                                    }
                                                                }
                                                            });
                                                            if (rm) {
                                                                files = $.grep(files, function (file) { return file._remove ? false : true; });
                                                            }
                                                        })
                                                        .always(function (data) {
                                                            if (multiMax) {
                                                                isDataType = true;
                                                                if (!send(files, paths)) {
                                                                    dfrd.reject();
                                                                }
                                                            }
                                                        });
                                                });
                                            } else {
                                                dfrd.reject();
                                            }
                                        }
                                    );
                                })();
                            } else {
                                fm.uploads.checkExists(files, target, fm).done(
                                    function (res, res2) {
                                        if (fm.options.overwriteUploadConfirm && fm.option('uploadOverwrite', target)) {
                                            hashes = res2;
                                            if (res === null) {
                                                data.overwrite = 0;
                                            } else {
                                                renames = res;
                                            }
                                            files = $.grep(files, function (file) { return !file._remove ? true : false; });
                                        }
                                        cnt = files.length;
                                        if (cnt > 0) {
                                            if (!send(files)) {
                                                dfrd.reject();
                                            }
                                        } else {
                                            dfrd.reject();
                                        }
                                    }
                                );
                            }
                        } else {
                            if (!send(files)) {
                                dfrd.reject();
                            }
                        }
                    } else {
                        dfrd.reject();
                    }
                } else {
                    if (dataChecked) {
                        send(files[0], files[1]);
                    } else {
                        files.done(function (result) { // result: [files, paths, renames, hashes, mkdirs]
                            renames = [];
                            cnt = result[0].length;
                            if (cnt) {
                                if (result[4] && result[4].length) {
                                    // ensure directories
                                    fm.request({
                                        data: { cmd: 'mkdir', target: target, dirs: result[4] },
                                        notify: { type: 'mkdir', cnt: result[4].length },
                                        preventFail: true
                                    })
                                        .fail(function (error) {
                                            error = error || ['errUnknown'];
                                            if (error[0] === 'errCmdParams') {
                                                multiMax = 1;
                                            } else {
                                                multiMax = 0;
                                                dfrd.reject(error);
                                            }
                                        })
                                        .done(function (data) {
                                            var rm = false;
                                            if (!data.hashes) {
                                                data.hashes = {};
                                            }
                                            result[1] = $.map(result[1], function (p, i) {
                                                result[0][i]._relativePath = p.replace(/^\//, '');
                                                p = p.replace(/\/[^\/]*$/, '');
                                                if (p === '') {
                                                    return target;
                                                } else {
                                                    if (data.hashes[p]) {
                                                        return data.hashes[p];
                                                    } else {
                                                        rm = true;
                                                        result[0][i]._remove = true;
                                                        return null;
                                                    }
                                                }
                                            });
                                            if (rm) {
                                                result[0] = $.grep(result[0], function (file) { return file._remove ? false : true; });
                                            }
                                        })
                                        .always(function (data) {
                                            if (multiMax) {
                                                renames = result[2];
                                                hashes = result[3];
                                                send(result[0], result[1]);
                                            }
                                        });
                                    return;
                                } else {
                                    result[1] = $.map(result[1], function () { return target; });
                                }
                                renames = result[2];
                                hashes = result[3];
                                send(result[0], result[1]);
                            } else {
                                dfrd.reject(['errUploadNoFiles']);
                            }
                        }).fail(function () {
                            dfrd.reject();
                        });
                    }
                }

                return dfrd;
            },

            // upload transport using iframe
            iframe: function (data, fm) {
                var self = fm ? fm : this,
                    input = data.input ? data.input : false,
                    files = !input ? self.uploads.checkFile(data, self) : false,
                    dfrd = $.Deferred()
                        .fail(function (error) {
                            error && self.error(error);
                        }),
                    name = 'iframe-' + fm.namespace + (++self.iframeCnt),
                    form = $('<form action="' + self.uploadURL + '" method="post" enctype="multipart/form-data" encoding="multipart/form-data" target="' + name + '" style="display:none"><input type="hidden" name="cmd" value="upload" /></form>'),
                    msie = this.UA.IE,
                    // clear timeouts, close notification dialog, remove form/iframe
                    onload = function () {
                        abortto && clearTimeout(abortto);
                        notifyto && clearTimeout(notifyto);
                        notify && self.notify({ type: 'upload', cnt: -cnt });

                        setTimeout(function () {
                            msie && $('<iframe src="javascript:false;"></iframe>').appendTo(form);
                            form.remove();
                            iframe.remove();
                        }, 100);
                    },
                    iframe = $('<iframe src="' + (msie ? 'javascript:false;' : 'about:blank') + '" name="' + name + '" style="position:absolute;left:-1000px;top:-1000px" ></iframe>')
                        .on('load', function () {
                            iframe.off('load')
                                .on('load', function () {
                                    onload();
                                    // data will be processed in callback response or window onmessage
                                    dfrd.resolve();
                                });

                            // notify dialog
                            notifyto = setTimeout(function () {
                                notify = true;
                                self.notify({ type: 'upload', cnt: cnt });
                            }, self.options.notifyDelay);

                            // emulate abort on timeout
                            if (self.options.iframeTimeout > 0) {
                                abortto = setTimeout(function () {
                                    onload();
                                    dfrd.reject(['errConnect', 'errTimeout']);
                                }, self.options.iframeTimeout);
                            }

                            form.submit();
                        }),
                    target = (data.target || self.cwd().hash),
                    names = [],
                    dfds = [],
                    renames = [],
                    hashes = {},
                    cnt, notify, notifyto, abortto;

                if (files && files.length) {
                    $.each(files, function (i, val) {
                        form.append('<input type="hidden" name="upload[]" value="' + val + '"/>');
                    });
                    cnt = 1;
                } else if (input && $(input).is(':file') && $(input).val()) {
                    if (fm.options.overwriteUploadConfirm && fm.option('uploadOverwrite', target)) {
                        names = input.files ? input.files : [{ name: $(input).val().replace(/^(?:.+[\\\/])?([^\\\/]+)$/, '$1') }];
                        //names = $.map(names, function(file){return file.name? { name: file.name } : null ;});
                        dfds.push(self.uploads.checkExists(names, target, self).done(
                            function (res, res2) {
                                hashes = res2;
                                if (res === null) {
                                    data.overwrite = 0;
                                } else {
                                    renames = res;
                                    cnt = $.grep(names, function (file) { return !file._remove ? true : false; }).length;
                                    if (cnt != names.length) {
                                        cnt = 0;
                                    }
                                }
                            }
                        ));
                    }
                    cnt = input.files ? input.files.length : 1;
                    form.append(input);
                } else {
                    return dfrd.reject();
                }

                $.when.apply($, dfds).done(function () {
                    if (cnt < 1) {
                        return dfrd.reject();
                    }
                    form.append('<input type="hidden" name="' + (self.newAPI ? 'target' : 'current') + '" value="' + target + '"/>')
                        .append('<input type="hidden" name="html" value="1"/>')
                        .append('<input type="hidden" name="node" value="' + self.id + '"/>')
                        .append($(input).attr('name', 'upload[]'));

                    if (renames.length > 0) {
                        $.each(renames, function (i, rename) {
                            form.append('<input type="hidden" name="renames[]" value="' + self.escape(rename) + '"/>');
                        });
                        form.append('<input type="hidden" name="suffix" value="' + fm.options.backupSuffix + '"/>');
                    }
                    if (hashes) {
                        $.each(renames, function (i, v) {
                            form.append('<input type="hidden" name="[' + i + ']" value="' + self.escape(v) + '"/>');
                        });
                    }

                    if (data.overwrite === 0) {
                        form.append('<input type="hidden" name="overwrite" value="0"/>');
                    }

                    $.each(self.options.onlyMimes || [], function (i, mime) {
                        form.append('<input type="hidden" name="mimes[]" value="' + self.escape(mime) + '"/>');
                    });

                    $.each(self.customData, function (key, val) {
                        form.append('<input type="hidden" name="' + key + '" value="' + self.escape(val) + '"/>');
                    });

                    form.appendTo('body');
                    iframe.appendTo('body');
                });

                return dfrd;
            }
        },


        /**
         * Bind callback to event(s) The callback is executed at most once per event.
         * To bind to multiply events at once, separate events names by space
         *
         * @param  String    event name
         * @param  Function  callback
         * @param  Boolan    priority first
         * @return elFinder
         */
        one: function (ev, callback, priorityFirst) {
            var self = this,
                event = ev.toLowerCase(),
                h = function (e, f) {
                    if (!self.toUnbindEvents[event]) {
                        self.toUnbindEvents[event] = [];
                    }
                    self.toUnbindEvents[event].push({
                        type: event,
                        callback: h
                    });
                    return (callback.done ? callback.done : callback).apply(this, arguments);
                };
            if (callback.done) {
                h = { done: h };
            }
            return this.bind(event, h, priorityFirst);
        },

        /**
         * Set/get data into/from localStorage
         *
         * @param  String       key
         * @param  String|void  value
         * @return String|null
         */
        localStorage: function (key, val) {
            var self = this,
                s = window.localStorage,
                oldkey = 'elfinder-' + (key || '') + this.id, // old key of elFinder < 2.1.6
                prefix = window.location.pathname + '-elfinder-',
                suffix = this.id,
                clrs = [],
                retval, oldval, t, precnt, sufcnt;

            // reset this node data
            if (typeof (key) === 'undefined') {
                precnt = prefix.length;
                sufcnt = suffix.length * -1;
                $.each(s, function (key) {
                    if (key.substr(0, precnt) === prefix && key.substr(sufcnt) === suffix) {
                        clrs.push(key);
                    }
                });
                $.each(clrs, function (i, key) {
                    s.removeItem(key);
                });
                return true;
            }

            // new key of elFinder >= 2.1.6
            key = prefix + key + suffix;

            if (val === null) {
                return s.removeItem(key);
            }

            if (val === void (0) && !(retval = s.getItem(key)) && (oldval = s.getItem(oldkey))) {
                val = oldval;
                s.removeItem(oldkey);
            }

            if (val !== void (0)) {
                t = typeof val;
                if (t !== 'string' && t !== 'number') {
                    val = JSON.stringify(val);
                }
                try {
                    s.setItem(key, val);
                } catch (e) {
                    try {
                        s.clear();
                        s.setItem(key, val);
                    } catch (e) {
                        self.debug('error', e.toString());
                    }
                }
                retval = s.getItem(key);
            }

            if (retval && (retval.substr(0, 1) === '{' || retval.substr(0, 1) === '[')) {
                try {
                    return JSON.parse(retval);
                } catch (e) { }
            }
            return retval;
        },

        /**
         * Set/get data into/from sessionStorage
         *
         * @param  String       key
         * @param  String|void  value
         * @return String|null
         */
        sessionStorage: function (key, val) {
            var self = this,
                s, retval, t;

            try {
                s = window.sessionStorage;
            } catch (e) { }

            if (!s) {
                return;
            }

            if (val === null) {
                return s.removeItem(key);
            }

            if (val !== void (0)) {
                t = typeof val;
                if (t !== 'string' && t !== 'number') {
                    val = JSON.stringify(val);
                }
                try {
                    s.setItem(key, val);
                } catch (e) {
                    try {
                        s.clear();
                        s.setItem(key, val);
                    } catch (e) {
                        self.debug('error', e.toString());
                    }
                }
            }
            retval = s.getItem(key);

            if (retval && (retval.substr(0, 1) === '{' || retval.substr(0, 1) === '[')) {
                try {
                    return JSON.parse(retval);
                } catch (e) { }
            }
            return retval;
        },

        /**
         * Get/set cookie
         *
         * @param  String       cookie name
         * @param  String|void  cookie value
         * @return String|null
         */
        cookie: function (name, value) {
            var d, o, c, i, retval, t;

            name = 'elfinder-' + name + this.id;

            if (value === void (0)) {
                if (this.cookieEnabled && document.cookie && document.cookie != '') {
                    c = document.cookie.split(';');
                    name += '=';
                    for (i = 0; i < c.length; i++) {
                        c[i] = $.trim(c[i]);
                        if (c[i].substring(0, name.length) == name) {
                            retval = decodeURIComponent(c[i].substring(name.length));
                            if (retval.substr(0, 1) === '{' || retval.substr(0, 1) === '[') {
                                try {
                                    return JSON.parse(retval);
                                } catch (e) { }
                            }
                            return retval;
                        }
                    }
                }
                return null;
            }

            if (!this.cookieEnabled) {
                return '';
            }

            o = Object.assign({}, this.options.cookie);
            if (value === null) {
                value = '';
                o.expires = -1;
            } else {
                t = typeof value;
                if (t !== 'string' && t !== 'number') {
                    value = JSON.stringify(value);
                }
            }
            if (typeof (o.expires) == 'number') {
                d = new Date();
                d.setTime(d.getTime() + (o.expires * 86400000));
                o.expires = d;
            }
            document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + o.expires.toUTCString() + (o.path ? '; path=' + o.path : '') + (o.domain ? '; domain=' + o.domain : '') + (o.secure ? '; secure' : '') + (o.samesite ? '; samesite=' + o.samesite : '');
            if (value && (value.substr(0, 1) === '{' || value.substr(0, 1) === '[')) {
                try {
                    return JSON.parse(value);
                } catch (e) { }
            }
            return value;
        },

        /**
         * Get start directory (by location.hash or last opened directory)
         * 
         * @return String
         */
        startDir: function () {
            var locHash = window.location.hash;
            if (locHash && locHash.match(/^#elf_/)) {
                return locHash.replace(/^#elf_/, '');
            } else if (this.options.startPathHash) {
                return this.options.startPathHash;
            } else {
                return this.lastDir();
            }
        },

        /**
         * Get/set last opened directory
         * 
         * @param  String|undefined  dir hash
         * @return String
         */
        lastDir: function (hash) {
            return this.options.rememberLastDir ? this.storage('lastdir', hash) : '';
        },

        /**
         * Node for escape html entities in texts
         * 
         * @type jQuery
         */
        _node: $('<span></c.length;>'),

        /**
         * Replace not html-safe symbols to html entities
         * 
         * @param  String  text to escape
         * @return String
         */
        escape: function (name) {
            return this._node.text(name).html().replace(/"/g, '&quot;').replace(/'/g, '&#039;');
        },

        /**
         * Cleanup ajax data.
         * For old api convert data into new api format
         * 
         * @param  String  command name
         * @param  Object  data from backend
         * @return Object
         */
        normalize: function (data) {
            var self = this,
                fileFilter = (function () {
                    var func, filter;
                    if (filter = self.options.fileFilter) {
                        if (typeof filter === 'function') {
                            func = function (file) {
                                return filter.call(self, file);
                            };
                        } else if (filter instanceof RegExp) {
                            func = function (file) {
                                return filter.test(file.name);
                            };
                        }
                    }
                    return func ? func : null;
                })(),
                chkCmdMap = function (opts) {
                    // Disable command to replace with other command
                    var disabled;
                    if (opts.uiCmdMap) {
                        if ($.isPlainObject(opts.uiCmdMap) && Object.keys(opts.uiCmdMap).length) {
                            if (!opts.disabledFlip) {
                                opts.disabledFlip = {};
                            }
                            disabled = opts.disabledFlip;
                            $.each(opts.uiCmdMap, function (f, t) {
                                if (t === 'hidden' && !disabled[f]) {
                                    opts.disabled.push(f);
                                    opts.disabledFlip[f] = true;
                                }
                            });
                        } else {
                            delete opts.uiCmdMap;
                        }
                    }
                },
                normalizeOptions = function (opts) {
                    var getType = function (v) {
                        var type = typeof v;
                        if (type === 'object' && Array.isArray(v)) {
                            type = 'array';
                        }
                        return type;
                    };
                    $.each(self.optionProperties, function (k, empty) {
                        if (empty !== void (0)) {
                            if (opts[k] && getType(opts[k]) !== getType(empty)) {
                                opts[k] = empty;
                            }
                        }
                    });
                    if (opts.disabled) {
                        opts.disabledFlip = self.arrayFlip(opts.disabled, true);
                        $.each(self.options.disabledCmdsRels, function (com, rels) {
                            var m, flg;
                            if (opts.disabledFlip[com]) {
                                flg = true;
                            } else if (m = com.match(/^([^&]+)&([^=]+)=(.*)$/)) {
                                if (opts.disabledFlip[m[1]] && opts[m[2]] == m[3]) {
                                    flg = true;
                                }
                            }
                            if (flg) {
                                $.each(rels, function (i, rel) {
                                    if (!opts.disabledFlip[rel]) {
                                        opts.disabledFlip[rel] = true;
                                        opts.disabled.push(rel);
                                    }
                                });
                            }
                        });
                    } else {
                        opts.disabledFlip = {};
                    }
                    return opts;
                },
                filter = function (file, asMap, type) {
                    var res = asMap ? file : true,
                        ign = asMap ? null : false,
                        vid, targetOptions, isRoot, rootNames;

                    if (file && file.hash && file.name && file.mime) {
                        if (file.mime === 'application/x-empty') {
                            file.mime = 'text/plain';
                        }

                        isRoot = self.isRoot(file);
                        if (isRoot && !file.volumeid) {
                            self.debug('warning', 'The volume root statuses requires `volumeid` property.');
                        }
                        if (isRoot || file.mime === 'directory') {
                            // Prevention of circular reference
                            if (file.phash) {
                                if (file.phash === file.hash) {
                                    error = error.concat(['Parent folder of "$1" is itself.', file.name]);
                                    return ign;
                                }
                                if (isRoot && file.volumeid && file.phash.indexOf(file.volumeid) === 0) {
                                    error = error.concat(['Parent folder of "$1" is inner itself.', file.name]);
                                    return ign;
                                }
                            }

                            // set options, tmbUrls for each volume
                            if (file.volumeid) {
                                vid = file.volumeid;

                                if (isRoot) {
                                    // make or update of leaf roots cache
                                    if (file.phash) {
                                        if (!self.leafRoots[file.phash]) {
                                            self.leafRoots[file.phash] = [file.hash];
                                        } else {
                                            if ($.inArray(file.hash, self.leafRoots[file.phash]) === -1) {
                                                self.leafRoots[file.phash].push(file.hash);
                                            }
                                        }
                                    }

                                    self.hasVolOptions = true;
                                    if (!self.volOptions[vid]) {
                                        self.volOptions[vid] = {
                                            // set dispInlineRegex
                                            dispInlineRegex: self.options.dispInlineRegex
                                        };
                                    }

                                    targetOptions = self.volOptions[vid];

                                    if (file.options) {
                                        // >= v.2.1.14 has file.options
                                        Object.assign(targetOptions, file.options);
                                    }

                                    // for compat <= v2.1.13
                                    if (file.disabled) {
                                        targetOptions.disabled = file.disabled;
                                        targetOptions.disabledFlip = self.arrayFlip(file.disabled, true);
                                    }
                                    if (file.tmbUrl) {
                                        targetOptions.tmbUrl = file.tmbUrl;
                                    }

                                    // '/' required at the end of url
                                    if (targetOptions.url && targetOptions.url.substr(-1) !== '/') {
                                        targetOptions.url += '/';
                                    }

                                    // check uiCmdMap
                                    chkCmdMap(targetOptions);

                                    // check trash bin hash
                                    if (targetOptions.trashHash) {
                                        if (self.trashes[targetOptions.trashHash] === false) {
                                            delete targetOptions.trashHash;
                                        } else {
                                            self.trashes[targetOptions.trashHash] = file.hash;
                                        }
                                    }

                                    // set immediate properties
                                    $.each(self.optionProperties, function (k) {
                                        if (targetOptions[k]) {
                                            file[k] = targetOptions[k];
                                        }
                                    });

                                    // regist fm.roots
                                    if (type !== 'cwd') {
                                        self.roots[vid] = file.hash;
                                    }

                                    // regist fm.volumeExpires
                                    if (file.expires) {
                                        self.volumeExpires[vid] = file.expires;
                                    }
                                }

                                if (prevId !== vid) {
                                    prevId = vid;
                                    i18nFolderName = self.option('i18nFolderName', vid);
                                }
                            }

                            // volume root i18n name
                            if (isRoot && !file.i18) {
                                name = 'volume_' + file.name,
                                    i18 = self.i18n(false, name);

                                if (name !== i18) {
                                    file.i18 = i18;
                                }
                            }

                            // i18nFolderName
                            if (i18nFolderName && !file.i18) {
                                name = 'folder_' + file.name,
                                    i18 = self.i18n(false, name);

                                if (name !== i18) {
                                    file.i18 = i18;
                                }
                            }

                            if (isRoot) {
                                if (rootNames = self.storage('rootNames')) {
                                    if (rootNames[file.hash]) {
                                        file._name = file.name;
                                        file._i18 = file.i18;
                                        file.name = rootNames[file.hash] = rootNames[file.hash];
                                        delete file.i18;
                                    }
                                    self.storage('rootNames', rootNames);
                                }
                            }

                            // lock trash bins holder
                            if (self.trashes[file.hash]) {
                                file.locked = true;
                            }
                        } else {
                            if (fileFilter) {
                                try {
                                    if (!fileFilter(file)) {
                                        return ign;
                                    }
                                } catch (e) {
                                    self.debug(e);
                                }
                            }
                            if (file.size == 0) {
                                file.mime = self.getMimetype(file.name, file.mime);
                            }
                        }

                        if (file.options) {
                            self.optionsByHashes[file.hash] = normalizeOptions(file.options);
                        }

                        delete file.options;

                        return res;
                    }
                    return ign;
                },
                getDescendants = function (hashes) {
                    var res = [];
                    $.each(self.files(), function (h, f) {
                        $.each(self.parents(h), function (i, ph) {
                            if ($.inArray(ph, hashes) !== -1 && $.inArray(h, hashes) === -1) {
                                res.push(h);
                                return false;
                            }
                        });
                    });
                    return res;
                },
                applyLeafRootStats = function (dataArr, type) {
                    $.each(dataArr, function (i, f) {
                        var pfile, done;
                        if (self.leafRoots[f.hash]) {
                            self.applyLeafRootStats(f);
                        }
                        // update leaf root parent stat
                        if (type !== 'change' && f.phash && self.isRoot(f) && (pfile = self.file(f.phash))) {
                            self.applyLeafRootStats(pfile);
                            // add to data.changed
                            if (!data.changed) {
                                data.changed = [pfile];
                            } else {
                                $.each(data.changed, function (i, f) {
                                    if (f.hash === pfile.hash) {
                                        data.changed[i] = pfile;
                                        done = true;
                                        return false;
                                    }
                                });
                                if (!done) {
                                    data.changed.push(pfile);
                                }
                            }
                        }
                    });
                },
                error = [],
                name, i18, i18nFolderName, prevId, cData;

            // set cunstom data
            if (data.customData && (!self.prevCustomData || (JSON.stringify(data.customData) !== JSON.stringify(self.prevCustomData)))) {
                self.prevCustomData = data.customData;
                try {
                    cData = JSON.parse(data.customData);
                    if ($.isPlainObject(cData)) {
                        self.prevCustomData = cData;
                        $.each(Object.keys(cData), function (i, key) {
                            if (cData[key] === null) {
                                delete cData[key];
                                delete self.optsCustomData[key];
                            }
                        });
                        self.customData = Object.assign({}, self.optsCustomData, cData);
                    }
                } catch (e) { }
            }

            if (data.options) {
                normalizeOptions(data.options);
            }

            if (data.cwd) {
                if (data.cwd.volumeid && data.options && Object.keys(data.options).length && self.isRoot(data.cwd)) {
                    self.hasVolOptions = true;
                    self.volOptions[data.cwd.volumeid] = data.options;
                }
                data.cwd = filter(data.cwd, true, 'cwd');
            }
            if (data.files) {
                data.files = $.grep(data.files, filter);
            }
            if (data.tree) {
                data.tree = $.grep(data.tree, filter);
            }
            if (data.added) {
                data.added = $.grep(data.added, filter);
            }
            if (data.changed) {
                data.changed = $.grep(data.changed, filter);
            }
            if (data.removed && data.removed.length && self.searchStatus.state === 2) {
                data.removed = data.removed.concat(getDescendants(data.removed));
            }
            if (data.api) {
                data.init = true;
            }

            if (Object.keys(self.leafRoots).length) {
                data.files && applyLeafRootStats(data.files);
                data.tree && applyLeafRootStats(data.tree);
                data.added && applyLeafRootStats(data.added);
                data.changed && applyLeafRootStats(data.changed, 'change');
            }

            // merge options that apply only to cwd
            if (data.cwd && data.cwd.options && data.options) {
                Object.assign(data.options, normalizeOptions(data.cwd.options));
            }

            // '/' required at the end of url
            if (data.options && data.options.url && data.options.url.substr(-1) !== '/') {
                data.options.url += '/';
            }

            // check error
            if (error.length) {
                data.norError = ['errResponse'].concat(error);
            }

            return data;
        },

        /**
         * Update sort options
         *
         * @param {String} sort type
         * @param {String} sort order
         * @param {Boolean} show folder first
         */
        setSort: function (type, order, stickFolders, alsoTreeview) {
            this.storage('sortType', (this.sortType = this.sortRules[type] ? type : 'name'));
            this.storage('sortOrder', (this.sortOrder = /asc|desc/.test(order) ? order : 'asc'));
            this.storage('sortStickFolders', (this.sortStickFolders = !!stickFolders) ? 1 : '');
            this.storage('sortAlsoTreeview', (this.sortAlsoTreeview = !!alsoTreeview) ? 1 : '');
            this.trigger('sortchange');
        },

        _sortRules: {
            name: function (file1, file2) {
                return elFinder.prototype.naturalCompare(file1.i18 || file1.name, file2.i18 || file2.name);
            },
            size: function (file1, file2) {
                var size1 = parseInt(file1.size) || 0,
                    size2 = parseInt(file2.size) || 0;

                return size1 === size2 ? 0 : size1 > size2 ? 1 : -1;
            },
            kind: function (file1, file2) {
                return elFinder.prototype.naturalCompare(file1.mime, file2.mime);
            },
            date: function (file1, file2) {
                var date1 = file1.ts || file1.date || 0,
                    date2 = file2.ts || file2.date || 0;

                return date1 === date2 ? 0 : date1 > date2 ? 1 : -1;
            },
            perm: function (file1, file2) {
                var val = function (file) { return (file.write ? 2 : 0) + (file.read ? 1 : 0); },
                    v1 = val(file1),
                    v2 = val(file2);
                return v1 === v2 ? 0 : v1 > v2 ? 1 : -1;
            },
            mode: function (file1, file2) {
                var v1 = file1.mode || (file1.perm || ''),
                    v2 = file2.mode || (file2.perm || '');
                return elFinder.prototype.naturalCompare(v1, v2);
            },
            owner: function (file1, file2) {
                var v1 = file1.owner || '',
                    v2 = file2.owner || '';
                return elFinder.prototype.naturalCompare(v1, v2);
            },
            group: function (file1, file2) {
                var v1 = file1.group || '',
                    v2 = file2.group || '';
                return elFinder.prototype.naturalCompare(v1, v2);
            }
        },

        /**
         * Valid sort rule names
         * 
         * @type Object
         */
        sorters: {},

        /**
         * Compare strings for natural sort
         *
         * @param  String
         * @param  String
         * @return Number
         */
        naturalCompare: function (a, b) {
            var self = elFinder.prototype.naturalCompare;
            if (typeof self.loc == 'undefined') {
                self.loc = (navigator.userLanguage || navigator.browserLanguage || navigator.language || 'en-US');
            }
            if (typeof self.sort == 'undefined') {
                if ('11'.localeCompare('2', self.loc, { numeric: true }) > 0) {
                    // Native support
                    if (window.Intl && window.Intl.Collator) {
                        self.sort = new Intl.Collator(self.loc, { numeric: true }).compare;
                    } else {
                        self.sort = function (a, b) {
                            return a.localeCompare(b, self.loc, { numeric: true });
                        };
                    }
                } else {
                    /*
                     * Edited for elFinder (emulates localeCompare() by numeric) by Naoki Sawada aka nao-pon
                     */
                    /*
                     * Huddle/javascript-natural-sort (https://github.com/Huddle/javascript-natural-sort)
                     */
                    /*
                     * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
                     * Author: Jim Palmer (based on chunking idea from Dave Koelle)
                     * http://opensource.org/licenses/mit-license.php
                     */
                    self.sort = function (a, b) {
                        var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
                            sre = /(^[ ]*|[ ]*$)/g,
                            dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
                            hre = /^0x[0-9a-f]+$/i,
                            ore = /^0/,
                            syre = /^[\x01\x21-\x2f\x3a-\x40\x5b-\x60\x7b-\x7e]/, // symbol first - (Naoki Sawada)
                            i = function (s) { return self.sort.insensitive && ('' + s).toLowerCase() || '' + s; },
                            // convert all to strings strip whitespace
                            // first character is "_", it's smallest - (Naoki Sawada)
                            x = i(a).replace(sre, '').replace(/^_/, "\x01") || '',
                            y = i(b).replace(sre, '').replace(/^_/, "\x01") || '',
                            // chunk/tokenize
                            xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
                            yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
                            // numeric, hex or date detection
                            xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
                            yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
                            oFxNcL, oFyNcL,
                            locRes = 0;

                        // first try and sort Hex codes or Dates
                        if (yD) {
                            if (xD < yD) return -1;
                            else if (xD > yD) return 1;
                        }
                        // natural sorting through split numeric strings and default strings
                        for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {

                            // find floats not starting with '0', string or 0 if not defined (Clint Priest)
                            oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
                            oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;

                            // handle numeric vs string comparison - number < string - (Kyle Adams)
                            // but symbol first < number - (Naoki Sawada)
                            if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
                                if (isNaN(oFxNcL) && (typeof oFxNcL !== 'string' || !oFxNcL.match(syre))) {
                                    return 1;
                                } else if (typeof oFyNcL !== 'string' || !oFyNcL.match(syre)) {
                                    return -1;
                                }
                            }

                            // use decimal number comparison if either value is string zero
                            if (parseInt(oFxNcL, 10) === 0) oFxNcL = 0;
                            if (parseInt(oFyNcL, 10) === 0) oFyNcL = 0;

                            // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
                            if (typeof oFxNcL !== typeof oFyNcL) {
                                oFxNcL += '';
                                oFyNcL += '';
                            }

                            // use locale sensitive sort for strings when case insensitive
                            // note: localeCompare interleaves uppercase with lowercase (e.g. A,a,B,b)
                            if (self.sort.insensitive && typeof oFxNcL === 'string' && typeof oFyNcL === 'string') {
                                locRes = oFxNcL.localeCompare(oFyNcL, self.loc);
                                if (locRes !== 0) return locRes;
                            }

                            if (oFxNcL < oFyNcL) return -1;
                            if (oFxNcL > oFyNcL) return 1;
                        }
                        return 0;
                    };
                    self.sort.insensitive = true;
                }
            }
            return self.sort(a, b);
        },

        /**
         * Compare files based on elFinder.sort
         *
         * @param  Object  file
         * @param  Object  file
         * @return Number
         */
        compare: function (file1, file2) {
            var self = this,
                type = self.sortType,
                asc = self.sortOrder == 'asc',
                stick = self.sortStickFolders,
                rules = self.sortRules,
                sort = rules[type],
                d1 = file1.mime == 'directory',
                d2 = file2.mime == 'directory',
                res;

            if (stick) {
                if (d1 && !d2) {
                    return -1;
                } else if (!d1 && d2) {
                    return 1;
                }
            }

            res = asc ? sort(file1, file2) : sort(file2, file1);

            return type !== 'name' && res === 0
                ? res = asc ? rules.name(file1, file2) : rules.name(file2, file1)
                : res;
        },

        /**
         * Sort files based on config
         *
         * @param  Array  files
         * @return Array
         */
        sortFiles: function (files) {
            return files.sort(this.compare);
        },

        /**
         * Open notification dialog 
         * and append/update message for required notification type.
         *
         * @param  Object  options
         * @example  
         * this.notify({
         *    type : 'copy',
         *    msg : 'Copy files', // not required for known types @see this.notifyType
         *    cnt : 3,
         *    hideCnt  : false,   // true for not show count
         *    progress : 10,      // progress bar percents (use cnt : 0 to update progress bar)
         *    cancel   : callback // callback function for cancel button
         * })
         * @return elFinder
         */
        notify: function (opts) {
            var self = this,
                type = opts.type,
                id = opts.id ? 'elfinder-notify-' + opts.id : '',
                msg = this.i18n((typeof opts.msg !== 'undefined') ? opts.msg : (this.messages['ntf' + type] ? 'ntf' + type : 'ntfsmth')),
                hiddens = this.arrayFlip(this.options.notifyDialog.hiddens || []),
                ndialog = this.ui.notify,
                dialog = ndialog.closest('.ui-dialog'),
                notify = ndialog.children('.elfinder-notify-' + type + (id ? ('.' + id) : '')),
                button = notify.children('div.elfinder-notify-cancel').children('button'),
                ntpl = '<div class="elfinder-notify elfinder-notify-{type}' + (id ? (' ' + id) : '') + '"><span class="elfinder-dialog-icon elfinder-dialog-icon-{type}"></span><span class="elfinder-notify-msg">{msg}</span> <span class="elfinder-notify-cnt"></span><div class="elfinder-notify-progressbar"><div class="elfinder-notify-progress"></div></div><div class="elfinder-notify-cancel"></div></div>',
                delta = opts.cnt + 0,
                size = (typeof opts.size != 'undefined') ? parseInt(opts.size) : null,
                progress = (typeof opts.progress != 'undefined' && opts.progress >= 0) ? opts.progress : null,
                fakeint = opts.fakeinterval || 200,
                cancel = opts.cancel,
                clhover = 'ui-state-hover',
                close = function () {
                    var prog = notify.find('.elfinder-notify-progress'),
                        rm = function () {
                            notify.remove();
                            if (!ndialog.children(dialog.data('minimized') ? void (0) : ':visible').length) {
                                if (dialog.data('minimized')) {
                                    dialog.data('minimized').hide();
                                } else {
                                    ndialog.elfinderdialog('close');
                                }
                            }
                            setProgressbar();
                        };
                    notify._esc && $(document).off('keydown', notify._esc);
                    if (notify.data('cur') < 100) {
                        prog.animate({
                            width: '100%'
                        }, 50, function () { requestAnimationFrame(function () { rm(); }); });
                    } else {
                        rm();
                    }
                },
                fakeUp = function (interval) {
                    var cur;
                    if (notify.length) {
                        cur = notify.data('cur') + 1;
                        if (cur <= 98) {
                            notify.find('.elfinder-notify-progress').width(cur + '%');
                            notify.data('cur', cur);
                            setProgressbar();
                            setTimeout(function () {
                                interval *= 1.05;
                                fakeUp(interval);
                            }, interval);
                        }
                    }
                },
                setProgressbar = function () {
                    var cnt = 0,
                        val = 0,
                        ntfs = ndialog.children('.elfinder-notify'),
                        w;
                    if (ntfs.length) {
                        ntfs.each(function () {
                            cnt++;
                            val += Math.min($(this).data('cur'), 100);
                        });
                        w = cnt ? Math.floor(val / (cnt * 100) * 100) + '%' : 0;
                        self.ui.progressbar.width(w);
                        if (dialog.data('minimized')) {
                            dialog.data('minimized').title(w);
                            dialog.data('minimized').dialog().children('.ui-dialog-titlebar').children('.elfinder-ui-progressbar').width(w);
                        }
                    } else {
                        self.ui.progressbar.width(0);
                        dialog.data('minimized') && dialog.data('minimized').hide();
                    }
                },
                cnt, total, prc;

            if (!type) {
                return this;
            }

            if (!notify.length) {
                notify = $(ntpl.replace(/\{type\}/g, type).replace(/\{msg\}/g, msg));
                if (hiddens[type]) {
                    notify.hide();
                } else {
                    ndialog.on('minimize', function (e) {
                        dialog.data('minimized') && setProgressbar();
                    });
                }
                notify.appendTo(ndialog).data('cnt', 0);

                if (progress != null) {
                    notify.data({ progress: 0, total: 0, cur: 0 });
                } else {
                    notify.data({ cur: 0 });
                    fakeUp(fakeint);
                }

                if (cancel) {
                    button = $('<span class="elfinder-notify-button ui-icon ui-icon-close" title="' + this.i18n('btnCancel') + '"></span>')
                        .on('mouseenter mouseleave', function (e) {
                            $(this).toggleClass(clhover, e.type === 'mouseenter');
                        });
                    notify.children('div.elfinder-notify-cancel').append(button);
                }
                ndialog.trigger('resize');
            } else if (typeof opts.msg !== 'undefined') {
                notify.children('span.elfinder-notify-msg').html(msg);
            }

            cnt = delta + parseInt(notify.data('cnt'));

            if (cnt > 0) {
                if (cancel && button.length) {
                    if (typeof cancel === 'function' || (typeof cancel === 'object' && cancel.promise)) {
                        notify._esc = function (e) {
                            if (e.type == 'keydown' && e.keyCode != $.ui.keyCode.ESCAPE) {
                                return;
                            }
                            e.preventDefault();
                            e.stopPropagation();
                            close();
                            if (cancel.promise) {
                                cancel.reject(0); // 0 is canceling flag
                            } else {
                                cancel(e);
                            }
                        };
                        button.on('click', function (e) {
                            notify._esc(e);
                        });
                        $(document).on('keydown.' + this.namespace, notify._esc);
                    }
                }

                !opts.hideCnt && notify.children('.elfinder-notify-cnt').text('(' + cnt + ')');
                if (delta > 0 && ndialog.is(':hidden') && !hiddens[type]) {
                    if (dialog.data('minimized')) {
                        dialog.data('minimized').show();
                    } else {
                        ndialog.elfinderdialog('open', this).height('auto');
                    }
                }
                notify.data('cnt', cnt);

                if ((progress != null)
                    && (total = notify.data('total')) >= 0
                    && (prc = notify.data('progress')) >= 0) {

                    total += size != null ? size : delta;
                    prc += progress;
                    (size == null && delta < 0) && (prc += delta * 100);
                    notify.data({ progress: prc, total: total });
                    if (size != null) {
                        prc *= 100;
                        total = Math.max(1, total);
                    }
                    progress = Math.min(parseInt(prc / total), 100);

                    notify.find('.elfinder-notify-progress')
                        .animate({
                            width: (progress < 100 ? progress : 100) + '%'
                        }, 20, function () {
                            notify.data('cur', progress);
                            setProgressbar();
                        });
                }

            } else {
                close();
            }

            return this;
        },

        /**
         * Open confirmation dialog 
         *
         * @param  Object  options
         * @example  
         * this.confirm({
         *    cssClass : 'elfinder-confirm-mydialog',
         *    title : 'Remove files',
         *    text  : 'Here is question text',
         *    accept : {  // accept callback - required
         *      label : 'Continue',
         *      callback : function(applyToAll) { fm.log('Ok') }
         *    },
         *    cancel : { // cancel callback - required
         *      label : 'Cancel',
         *      callback : function() { fm.log('Cancel')}
         *    },
         *    reject : { // reject callback - optionally
         *      label : 'No',
         *      callback : function(applyToAll) { fm.log('No')}
         *    },
         *    buttons : [ // additional buttons callback - optionally
         *      {
         *        label : 'Btn1',
         *        callback : function(applyToAll) { fm.log('Btn1')}
         *      }
         *    ],
         *    all : true  // display checkbox "Apply to all"
         * })
         * @return elFinder
         */
        confirm: function (opts) {
            var self = this,
                complete = false,
                options = {
                    cssClass: 'elfinder-dialog-confirm',
                    modal: true,
                    resizable: false,
                    title: this.i18n(opts.title || 'confirmReq'),
                    buttons: {},
                    close: function () {
                        !complete && opts.cancel.callback();
                        $(this).elfinderdialog('destroy');
                    }
                },
                apply = this.i18n('apllyAll'),
                label, checkbox, btnNum;

            if (opts.cssClass) {
                options.cssClass += ' ' + opts.cssClass;
            }
            options.buttons[this.i18n(opts.accept.label)] = function () {
                opts.accept.callback(!!(checkbox && checkbox.prop('checked')));
                complete = true;
                $(this).elfinderdialog('close');
            };
            options.buttons[this.i18n(opts.accept.label)]._cssClass = 'elfinder-confirm-accept';

            if (opts.reject) {
                options.buttons[this.i18n(opts.reject.label)] = function () {
                    opts.reject.callback(!!(checkbox && checkbox.prop('checked')));
                    complete = true;
                    $(this).elfinderdialog('close');
                };
                options.buttons[this.i18n(opts.reject.label)]._cssClass = 'elfinder-confirm-reject';
            }

            if (opts.buttons && opts.buttons.length > 0) {
                btnNum = 1;
                $.each(opts.buttons, function (i, v) {
                    options.buttons[self.i18n(v.label)] = function () {
                        v.callback(!!(checkbox && checkbox.prop('checked')));
                        complete = true;
                        $(this).elfinderdialog('close');
                    };
                    options.buttons[self.i18n(v.label)]._cssClass = 'elfinder-confirm-extbtn' + (btnNum++);
                    if (v.cssClass) {
                        options.buttons[self.i18n(v.label)]._cssClass += ' ' + v.cssClass;
                    }
                });
            }

            options.buttons[this.i18n(opts.cancel.label)] = function () {
                $(this).elfinderdialog('close');
            };
            options.buttons[this.i18n(opts.cancel.label)]._cssClass = 'elfinder-confirm-cancel';

            if (opts.all) {
                options.create = function () {
                    var base = $('<div class="elfinder-dialog-confirm-applyall"></div>');
                    checkbox = $('<input type="checkbox" />');
                    $(this).next().find('.ui-dialog-buttonset')
                        .prepend(base.append($('<label>' + apply + '</label>').prepend(checkbox)));
                };
            }

            if (opts.optionsCallback && typeof opts.optionsCallback === 'function') {
                opts.optionsCallback(options);
            }

            return this.dialog('<span class="elfinder-dialog-icon elfinder-dialog-icon-confirm"></span>' + this.i18n(opts.text), options);
        },

        /**
         * Create unique file name in required dir
         * 
         * @param  String  file name
         * @param  String  parent dir hash
         * @param  String  glue
         * @return String
         */
        uniqueName: function (prefix, phash, glue) {
            var i = 0, ext = '', p, name;

            prefix = this.i18n(false, prefix);
            phash = phash || this.cwd().hash;
            glue = (typeof glue === 'undefined') ? ' ' : glue;

            if (p = prefix.match(/^(.+)(\.[^.]+)$/)) {
                ext = p[2];
                prefix = p[1];
            }

            name = prefix + ext;

            if (!this.fileByName(name, phash)) {
                return name;
            }
            while (i < 10000) {
                name = prefix + glue + (++i) + ext;
                if (!this.fileByName(name, phash)) {
                    return name;
                }
            }
            return prefix + Math.random() + ext;
        },

        /**
         * Return message translated onto current language
         * Allowed accept HTML element that was wrapped in jQuery object
         * To be careful to XSS vulnerability of HTML element Ex. You should use `fm.escape(file.name)`
         *
         * @param  String|Array  message[s]|Object jQuery
         * @return String
         **/
        i18n: function () {
            var self = this,
                messages = this.messages,
                input = [],
                ignore = [],
                message = function (m) {
                    var file;
                    if (m.indexOf('#') === 0) {
                        if ((file = self.file(m.substr(1)))) {
                            return file.name;
                        }
                    }
                    return m;
                },
                i, j, m, escFunc, start = 0, isErr;

            if (arguments.length && arguments[0] === false) {
                escFunc = function (m) { return m; };
                start = 1;
            }
            for (i = start; i < arguments.length; i++) {
                m = arguments[i];

                if (Array.isArray(m)) {
                    for (j = 0; j < m.length; j++) {
                        if (m[j] instanceof jQuery) {
                            // jQuery object is HTML element
                            input.push(m[j]);
                        } else if (typeof m[j] !== 'undefined') {
                            input.push(message('' + m[j]));
                        }
                    }
                } else if (m instanceof jQuery) {
                    // jQuery object is HTML element
                    input.push(m[j]);
                } else if (typeof m !== 'undefined') {
                    input.push(message('' + m));
                }
            }

            for (i = 0; i < input.length; i++) {
                // dont translate placeholders
                if ($.inArray(i, ignore) !== -1) {
                    continue;
                }
                m = input[i];
                if (typeof m == 'string') {
                    isErr = !!(messages[m] && m.match(/^err/));
                    // translate message
                    m = messages[m] || (escFunc ? escFunc(m) : self.escape(m));
                    // replace placeholders in message
                    m = m.replace(/\$(\d+)/g, function (match, placeholder) {
                        var res;
                        placeholder = i + parseInt(placeholder);
                        if (placeholder > 0 && input[placeholder]) {
                            ignore.push(placeholder);
                        }
                        res = escFunc ? escFunc(input[placeholder]) : self.escape(input[placeholder]);
                        if (isErr) {
                            res = '<span class="elfinder-err-var elfinder-err-var' + placeholder + '">' + res + '</span>';
                        }
                        return res;
                    });
                } else {
                    // get HTML from jQuery object
                    m = m.get(0).outerHTML;
                }

                input[i] = m;
            }

            return $.grep(input, function (m, i) { return $.inArray(i, ignore) === -1 ? true : false; }).join('<br>');
        },

        /**
         * Get icon style from file.icon
         * 
         * @param  Object  elFinder file object
         * @return String|Object
         */
        getIconStyle: function (file, asObject) {
            var self = this,
                template = {
                    'background': 'url(\'{url}\') 0 0 no-repeat',
                    'background-size': 'contain'
                },
                style = '',
                cssObj = {},
                i = 0;
            if (file.icon) {
                style = 'style="';
                $.each(template, function (k, v) {
                    if (i++ === 0) {
                        v = v.replace('{url}', self.escape(file.icon));
                    }
                    if (asObject) {
                        cssObj[k] = v;
                    } else {
                        style += k + ':' + v + ';';
                    }
                });
                style += '"';
            }
            return asObject ? cssObj : style;
        },

        /**
         * Convert mimetype into css classes
         * 
         * @param  String  file mimetype
         * @return String
         */
        mime2class: function (mimeType) {
            var prefix = 'elfinder-cwd-icon-',
                mime = mimeType.toLowerCase(),
                isText = this.textMimes[mime];

            mime = mime.split('/');
            if (isText) {
                mime[0] += ' ' + prefix + 'text';
            } else if (mime[1] && mime[1].match(/\+xml$/)) {
                mime[0] += ' ' + prefix + 'xml';
            }

            return prefix + mime[0] + (mime[1] ? ' ' + prefix + mime[1].replace(/(\.|\+)/g, '-') : '');
        },

        /**
         * Return localized kind of file
         * 
         * @param  Object|String  file or file mimetype
         * @return String
         */
        mime2kind: function (f) {
            var isObj = typeof (f) == 'object' ? true : false,
                mime = isObj ? f.mime : f,
                kind;


            if (isObj && f.alias && mime != 'symlink-broken') {
                kind = 'Alias';
            } else if (this.kinds[mime]) {
                if (isObj && mime === 'directory' && (!f.phash || f.isroot)) {
                    kind = 'Root';
                } else {
                    kind = this.kinds[mime];
                }
            } else if (this.mimeTypes[mime]) {
                kind = this.mimeTypes[mime].toUpperCase();
                if (!this.messages['kind' + kind]) {
                    kind = null;
                }
            }
            if (!kind) {
                if (mime.indexOf('text') === 0) {
                    kind = 'Text';
                } else if (mime.indexOf('image') === 0) {
                    kind = 'Image';
                } else if (mime.indexOf('audio') === 0) {
                    kind = 'Audio';
                } else if (mime.indexOf('video') === 0) {
                    kind = 'Video';
                } else if (mime.indexOf('application') === 0) {
                    kind = 'App';
                } else {
                    kind = mime;
                }
            }

            return this.messages['kind' + kind] ? this.i18n('kind' + kind) : mime;
        },

        /**
         * Return boolean Is mime-type text file
         * 
         * @param  String  mime-type
         * @return Boolean
         */
        mimeIsText: function (mime) {
            return (this.textMimes[mime.toLowerCase()] || (mime.indexOf('text/') === 0 && mime.substr(5, 3) !== 'rtf') || mime.match(/^application\/.+\+xml$/)) ? true : false;
        },

        /**
         * Returns a date string formatted according to the given format string
         * 
         * @param  String  format string
         * @param  Object  Date object
         * @return String
         */
        date: function (format, date) {
            var self = this,
                output, d, dw, m, y, h, g, i, s;

            if (!date) {
                date = new Date();
            }

            h = date[self.getHours]();
            g = h > 12 ? h - 12 : h;
            i = date[self.getMinutes]();
            s = date[self.getSeconds]();
            d = date[self.getDate]();
            dw = date[self.getDay]();
            m = date[self.getMonth]() + 1;
            y = date[self.getFullYear]();

            output = format.replace(/[a-z]/gi, function (val) {
                switch (val) {
                    case 'd': return d > 9 ? d : '0' + d;
                    case 'j': return d;
                    case 'D': return self.i18n(self.i18.daysShort[dw]);
                    case 'l': return self.i18n(self.i18.days[dw]);
                    case 'm': return m > 9 ? m : '0' + m;
                    case 'n': return m;
                    case 'M': return self.i18n(self.i18.monthsShort[m - 1]);
                    case 'F': return self.i18n(self.i18.months[m - 1]);
                    case 'Y': return y;
                    case 'y': return ('' + y).substr(2);
                    case 'H': return h > 9 ? h : '0' + h;
                    case 'G': return h;
                    case 'g': return g;
                    case 'h': return g > 9 ? g : '0' + g;
                    case 'a': return h >= 12 ? 'pm' : 'am';
                    case 'A': return h >= 12 ? 'PM' : 'AM';
                    case 'i': return i > 9 ? i : '0' + i;
                    case 's': return s > 9 ? s : '0' + s;
                }
                return val;
            });

            return output;
        },

        /**
         * Return localized date
         * 
         * @param  Object  file object
         * @return String
         */
        formatDate: function (file, t) {
            var self = this,
                ts = t || file.ts,
                i18 = self.i18,
                date, format, output, d, dw, m, y, h, g, i, s;

            if (self.options.clientFormatDate && ts > 0) {

                date = new Date(ts * 1000);
                format = ts >= this.yesterday
                    ? this.fancyFormat
                    : this.dateFormat;

                output = self.date(format, date);

                return ts >= this.yesterday
                    ? output.replace('$1', this.i18n(ts >= this.today ? 'Today' : 'Yesterday'))
                    : output;
            } else if (file.date) {
                return file.date.replace(/([a-z]+)\s/i, function (a1, a2) { return self.i18n(a2) + ' '; });
            }

            return self.i18n('dateUnknown');
        },

        /**
         * Return localized number string
         * 
         * @param  Number
         * @return String
         */
        toLocaleString: function (num) {
            var v = new Number(num);
            if (v) {
                if (v.toLocaleString) {
                    return v.toLocaleString();
                } else {
                    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
                }
            }
            return num;
        },

        /**
         * Return css class marks file permissions
         * 
         * @param  Object  file 
         * @return String
         */
        perms2class: function (o) {
            var c = '';

            if (!o.read && !o.write) {
                c = 'elfinder-na';
            } else if (!o.read) {
                c = 'elfinder-wo';
            } else if (!o.write) {
                c = 'elfinder-ro';
            }

            if (o.type) {
                c += ' elfinder-' + this.escape(o.type);
            }

            return c;
        },

        /**
         * Return localized string with file permissions
         * 
         * @param  Object  file
         * @return String
         */
        formatPermissions: function (f) {
            var p = [];

            f.read && p.push(this.i18n('read'));
            f.write && p.push(this.i18n('write'));

            return p.length ? p.join(' ' + this.i18n('and') + ' ') : this.i18n('noaccess');
        },

        /**
         * Return formated file size
         * 
         * @param  Number  file size
         * @return String
         */
        formatSize: function (s) {
            var n = 1, u = 'b';

            if (s == 'unknown') {
                return this.i18n('unknown');
            }

            if (s > 1073741824) {
                n = 1073741824;
                u = 'GB';
            } else if (s > 1048576) {
                n = 1048576;
                u = 'MB';
            } else if (s > 1024) {
                n = 1024;
                u = 'KB';
            }
            s = s / n;
            return (s > 0 ? n >= 1048576 ? s.toFixed(2) : Math.round(s) : 0) + ' ' + u;
        },

        /**
         * Return formated file mode by options.fileModeStyle
         * 
         * @param  String  file mode
         * @param  String  format style
         * @return String
         */
        formatFileMode: function (p, style) {
            var i, o, s, b, sticy, suid, sgid, str, oct;

            if (!style) {
                style = this.options.fileModeStyle.toLowerCase();
            }
            p = $.trim(p);
            if (p.match(/[rwxs-]{9}$/i)) {
                str = p = p.substr(-9);
                if (style == 'string') {
                    return str;
                }
                oct = '';
                s = 0;
                for (i = 0; i < 7; i = i + 3) {
                    o = p.substr(i, 3);
                    b = 0;
                    if (o.match(/[r]/i)) {
                        b += 4;
                    }
                    if (o.match(/[w]/i)) {
                        b += 2;
                    }
                    if (o.match(/[xs]/i)) {
                        if (o.match(/[xs]/)) {
                            b += 1;
                        }
                        if (o.match(/[s]/i)) {
                            if (i == 0) {
                                s += 4;
                            } else if (i == 3) {
                                s += 2;
                            }
                        }
                    }
                    oct += b.toString(8);
                }
                if (s) {
                    oct = s.toString(8) + oct;
                }
            } else {
                p = parseInt(p, 8);
                oct = p ? p.toString(8) : '';
                if (!p || style == 'octal') {
                    return oct;
                }
                o = p.toString(8);
                s = 0;
                if (o.length > 3) {
                    o = o.substr(-4);
                    s = parseInt(o.substr(0, 1), 8);
                    o = o.substr(1);
                }
                sticy = ((s & 1) == 1); // not support
                sgid = ((s & 2) == 2);
                suid = ((s & 4) == 4);
                str = '';
                for (i = 0; i < 3; i++) {
                    if ((parseInt(o.substr(i, 1), 8) & 4) == 4) {
                        str += 'r';
                    } else {
                        str += '-';
                    }
                    if ((parseInt(o.substr(i, 1), 8) & 2) == 2) {
                        str += 'w';
                    } else {
                        str += '-';
                    }
                    if ((parseInt(o.substr(i, 1), 8) & 1) == 1) {
                        str += ((i == 0 && suid) || (i == 1 && sgid)) ? 's' : 'x';
                    } else {
                        str += '-';
                    }
                }
            }
            if (style == 'both') {
                return str + ' (' + oct + ')';
            } else if (style == 'string') {
                return str;
            } else {
                return oct;
            }
        },

        /**
         * Regist this.decodeRawString function
         * 
         * @return void
         */
        registRawStringDecoder: function (rawStringDecoder) {
            if (typeof rawStringDecoder === 'function') {
                this.decodeRawString = this.options.rawStringDecoder = rawStringDecoder;
            }
        },

        /**
         * Return boolean that uploadable MIME type into target folder
         * 
         * @param  String  mime    MIME type
         * @param  String  target  target folder hash
         * @return Bool
         */
        uploadMimeCheck: function (mime, target) {
            target = target || this.cwd().hash;
            var res = true, // default is allow
                mimeChecker = this.option('uploadMime', target),
                allow,
                deny,
                check = function (checker) {
                    var ret = false;
                    if (typeof checker === 'string' && checker.toLowerCase() === 'all') {
                        ret = true;
                    } else if (Array.isArray(checker) && checker.length) {
                        $.each(checker, function (i, v) {
                            v = v.toLowerCase();
                            if (v === 'all' || mime.indexOf(v) === 0) {
                                ret = true;
                                return false;
                            }
                        });
                    }
                    return ret;
                };
            if (mime && $.isPlainObject(mimeChecker)) {
                mime = mime.toLowerCase();
                allow = check(mimeChecker.allow);
                deny = check(mimeChecker.deny);
                if (mimeChecker.firstOrder === 'allow') {
                    res = false; // default is deny
                    if (!deny && allow === true) { // match only allow
                        res = true;
                    }
                } else {
                    res = true; // default is allow
                    if (deny === true && !allow) { // match only deny
                        res = false;
                    }
                }
            }
            return res;
        },

        /**
         * call chained sequence of async deferred functions
         * 
         * @param  Array   tasks async functions
         * @return Object  jQuery.Deferred
         */
        sequence: function (tasks) {
            var l = tasks.length,
                chain = function (task, idx) {
                    ++idx;
                    if (tasks[idx]) {
                        return chain(task.then(tasks[idx]), idx);
                    } else {
                        return task;
                    }
                };
            if (l > 1) {
                return chain(tasks[0](), 0);
            } else {
                return tasks[0]();
            }
        },

        /**
         * Reload contents of target URL for clear browser cache
         * 
         * @param  String  url target URL
         * @return Object  jQuery.Deferred
         */
        reloadContents: function (url) {
            var dfd = $.Deferred(),
                ifm;
            try {
                ifm = $('<iframe width="1" height="1" scrolling="no" frameborder="no" style="position:absolute; top:-1px; left:-1px" crossorigin="use-credentials">')
                    .attr('src', url)
                    .one('load', function () {
                        var ifm = $(this);
                        try {
                            this.contentDocument.location.reload(true);
                            ifm.one('load', function () {
                                ifm.remove();
                                dfd.resolve();
                            });
                        } catch (e) {
                            ifm.attr('src', '').attr('src', url).one('load', function () {
                                ifm.remove();
                                dfd.resolve();
                            });
                        }
                    })
                    .appendTo('body');
            } catch (e) {
                ifm && ifm.remove();
                dfd.reject();
            }
            return dfd;
        },

        /**
         * Make netmount option for OAuth2
         * 
         * @param  String   protocol
         * @param  String   name
         * @param  String   host
         * @param  Object   opts  Default {noOffline: false, root: 'root', pathI18n: 'folderId', folders: true}
                }
         * 
         * @return Object
         */
        makeNetmountOptionOauth: function (protocol, name, host, opt) {
            var noOffline = typeof opt === 'boolean' ? opt : null, // for backward compat
                opts = Object.assign({
                    noOffline: false,
                    root: 'root',
                    pathI18n: 'folderId',
                    folders: true
                }, (noOffline === null ? (opt || {}) : { noOffline: noOffline })),
                addFolders = function (fm, bro, folders) {
                    var self = this,
                        cnt = Object.keys($.isPlainObject(folders) ? folders : {}).length,
                        select;

                    bro.next().remove();
                    if (cnt) {
                        select = $('<select class="ui-corner-all elfinder-tabstop" style="max-width:200px;">').append(
                            $($.map(folders, function (n, i) { return '<option value="' + fm.escape((i + '').trim()) + '">' + fm.escape(n) + '</option>'; }).join(''))
                        ).on('change click', function (e) {
                            var node = $(this),
                                path = node.val(),
                                spn;
                            self.inputs.path.val(path);
                            if (opts.folders && (e.type === 'change' || node.data('current') !== path)) {
                                node.next().remove();
                                node.data('current', path);
                                if (path != opts.root) {
                                    spn = spinner();
                                    if (xhr && xhr.state() === 'pending') {
                                        fm.abortXHR(xhr, { quiet: true, abort: true });
                                    }
                                    node.after(spn);
                                    xhr = fm.request({
                                        data: { cmd: 'netmount', protocol: protocol, host: host, user: 'init', path: path, pass: 'folders' },
                                        preventDefault: true
                                    }).done(function (data) {
                                        addFolders.call(self, fm, node, data.folders);
                                    }).always(function () {
                                        fm.abortXHR(xhr, { quiet: true });
                                        spn.remove();
                                    }).xhr;
                                }
                            }
                        });
                        bro.after($('<div></div>').append(select))
                            .closest('.ui-dialog').trigger('tabstopsInit');
                        select.trigger('focus');
                    }
                },
                spinner = function () {
                    return $('<div class="elfinder-netmount-spinner"></div>').append('<span class="elfinder-spinner"></span>');
                },
                xhr;
            return {
                vars: {},
                name: name,
                inputs: {
                    offline: $('<input type="checkbox"/>').on('change', function () {
                        $(this).parents('table.elfinder-netmount-tb').find('select:first').trigger('change', 'reset');
                    }),
                    host: $('<span><span class="elfinder-spinner"></span></span><input type="hidden"/>'),
                    path: $('<input type="text" value="' + opts.root + '"/>'),
                    user: $('<input type="hidden"/>'),
                    pass: $('<input type="hidden"/>'),
                    mnt2res: $('<input type="hidden"/>')
                },
                select: function (fm, ev, d) {
                    var f = this.inputs,
                        oline = f.offline,
                        f0 = $(f.host[0]),
                        data = d || null;
                    this.vars.mbtn = f.host.closest('.ui-dialog').children('.ui-dialog-buttonpane:first').find('button.elfinder-btncnt-0');
                    if (!f0.data('inrequest')
                        && (f0.find('span.elfinder-spinner').length
                            || data === 'reset'
                            || (data === 'winfocus' && !f0.siblings('span.elfinder-button-icon-reload').length))
                    ) {
                        if (oline.parent().children().length === 1) {
                            f.path.parent().prev().html(fm.i18n(opts.pathI18n));
                            oline.attr('title', fm.i18n('offlineAccess'));
                            oline.uniqueId().after($('<label></label>').attr('for', oline.attr('id')).html(' ' + fm.i18n('offlineAccess')));
                        }
                        f0.data('inrequest', true).empty().addClass('elfinder-spinner')
                            .parent().find('span.elfinder-button-icon').remove();
                        fm.request({
                            data: { cmd: 'netmount', protocol: protocol, host: host, user: 'init', options: { id: fm.id, offline: oline.prop('checked') ? 1 : 0, pass: f.host[1].value } },
                            preventDefault: true
                        }).done(function (data) {
                            f0.removeClass("elfinder-spinner").html(data.body.replace(/\{msg:([^}]+)\}/g, function (whole, s1) { return fm.i18n(s1, host); }));
                        });
                        opts.noOffline && oline.closest('tr').hide();
                    } else {
                        oline.closest('tr')[(opts.noOffline || f.user.val()) ? 'hide' : 'show']();
                        f0.data('funcexpup') && f0.data('funcexpup')();
                    }
                    this.vars.mbtn[$(f.host[1]).val() ? 'show' : 'hide']();
                },
                done: function (fm, data) {
                    var f = this.inputs,
                        p = this.protocol,
                        f0 = $(f.host[0]),
                        f1 = $(f.host[1]),
                        expires = '&nbsp;',
                        vars = this.vars,
                        chk = function () {
                            if (vars.oauthW && !document.hasFocus() && --vars.chkCnt) {
                                p.trigger('change', 'winfocus');
                                vars.tm = setTimeout(chk, 3000);
                            }
                        },
                        btn;

                    opts.noOffline && f.offline.closest('tr').hide();
                    if (data.mode == 'makebtn') {
                        f0.removeClass('elfinder-spinner').removeData('expires').removeData('funcexpup');
                        btn = f.host.find('input').on('mouseenter mouseleave', function () { $(this).toggleClass('ui-state-hover'); });
                        if (data.url) {
                            btn.on('click', function () {
                                vars.tm && clearTimeout(vars.tm);
                                vars.oauthW = window.open(data.url);
                                // To correspond to safari, authentication tab sometimes not closing in CORS environment.
                                // This may be a safari bug and may improve in the future.
                                if ((fm.UA.iOS || fm.UA.Mac) && fm.isCORS && !vars.chkdone) {
                                    vars.chkCnt = 60;
                                    vars.tm = setTimeout(chk, 5000);
                                }
                            });
                        }
                        f1.val('');
                        f.path.val(opts.root).next().remove();
                        f.user.val('');
                        f.pass.val('');
                        !opts.noOffline && f.offline.closest('tr').show();
                        vars.mbtn.hide();
                    } else if (data.mode == 'folders') {
                        if (data.folders) {
                            addFolders.call(this, fm, f.path.nextAll(':last'), data.folders);
                        }
                    } else {
                        if (vars.oauthW) {
                            vars.tm && clearTimeout(vars.tm);
                            vars.oauthW.close();
                            delete vars.oauthW;
                            // The problem that Safari's authentication tab doesn't close only affects the first time.
                            vars.chkdone = true;
                        }
                        if (data.expires) {
                            expires = '()';
                            f0.data('expires', data.expires);
                        }
                        f0.html(host + expires).removeClass('elfinder-spinner');
                        if (data.expires) {
                            f0.data('funcexpup', function () {
                                var rem = Math.floor((f0.data('expires') - (+new Date()) / 1000) / 60);
                                if (rem < 3) {
                                    f0.parent().children('.elfinder-button-icon-reload').click();
                                } else {
                                    f0.text(f0.text().replace(/\(.*\)/, '(' + fm.i18n(['minsLeft', rem]) + ')'));
                                    setTimeout(function () {
                                        if (f0.is(':visible')) {
                                            f0.data('funcexpup')();
                                        }
                                    }, 60000);
                                }
                            });
                            f0.data('funcexpup')();
                        }
                        if (data.reset) {
                            p.trigger('change', 'reset');
                            return;
                        }
                        f0.parent().append($('<span class="elfinder-button-icon elfinder-button-icon-reload" title="' + fm.i18n('reAuth') + '">')
                            .on('click', function () {
                                f1.val('reauth');
                                p.trigger('change', 'reset');
                            }));
                        f1.val(protocol);
                        vars.mbtn.show();
                        if (data.folders) {
                            addFolders.call(this, fm, f.path, data.folders);
                        }
                        if (data.mnt2res) {
                            f.mnt2res.val('1');
                        }
                        f.user.val('done');
                        f.pass.val('done');
                        f.offline.closest('tr').hide();
                    }
                    f0.removeData('inrequest');
                },
                fail: function (fm, err) {
                    $(this.inputs.host[0]).removeData('inrequest');
                    this.protocol.trigger('change', 'reset');
                },
                integrateInfo: opts.integrate
            };
        },

        /**
         * Find cwd's nodes from files
         * 
         * @param  Array    files
         * @param  Object   opts   {firstOnly: true|false}
         */
        findCwdNodes: function (files, opts) {
            var self = this,
                cwd = this.getUI('cwd'),
                cwdHash = this.cwd().hash,
                newItem = $();

            opts = opts || {};

            $.each(files, function (i, f) {
                if (f.phash === cwdHash || self.searchStatus.state > 1) {
                    newItem = newItem.add(self.cwdHash2Elm(f.hash));
                    if (opts.firstOnly) {
                        return false;
                    }
                }
            });

            return newItem;
        },

        /**
         * Convert from relative URL to abstract URL based on current URL
         * 
         * @param  String  URL
         * @return String
         */
        convAbsUrl: function (url) {
            if (url.match(/^http/i)) {
                return url;
            }
            if (url.substr(0, 2) === '//') {
                return window.location.protocol + url;
            }
            var root = window.location.protocol + '//' + window.location.host,
                reg = /[^\/]+\/\.\.\//,
                ret;
            if (url.substr(0, 1) === '/') {
                ret = root + url;
            } else {
                ret = root + window.location.pathname.replace(/\/[^\/]+$/, '/') + url;
            }
            ret = ret.replace('/./', '/');
            while (reg.test(ret)) {
                ret = ret.replace(reg, '');
            }
            return ret;
        },

        /**
         * Is same origin to current site
         * 
         * @param  String  check url
         * @return Boolean
         */
        isSameOrigin: function (checkUrl) {
            var url;
            checkUrl = this.convAbsUrl(checkUrl);
            if (location.origin && window.URL) {
                try {
                    url = new URL(checkUrl);
                    return location.origin === url.origin;
                } catch (e) { }
            }
            url = document.createElement('a');
            url.href = checkUrl;
            return location.protocol === url.protocol && location.host === url.host && location.port && url.port;
        },

        navHash2Id: function (hash) {
            return this.navPrefix + hash;
        },

        navId2Hash: function (id) {
            return typeof (id) == 'string' ? id.substr(this.navPrefix.length) : false;
        },

        cwdHash2Id: function (hash) {
            return this.cwdPrefix + hash;
        },

        cwdId2Hash: function (id) {
            return typeof (id) == 'string' ? id.substr(this.cwdPrefix.length) : false;
        },

        /**
         * navHash to jQuery element object
         *
         * @param      String  hash    nav hash
         * @return     Object  jQuery element object
         */
        navHash2Elm: function (hash) {
            return $(document.getElementById(this.navHash2Id(hash)));
        },

        /**
         * cwdHash to jQuery element object
         *
         * @param      String  hash    cwd hash
         * @return     Object  jQuery element object
         */
        cwdHash2Elm: function (hash) {
            return $(document.getElementById(this.cwdHash2Id(hash)));
        },

        isInWindow: function (elem, nochkHide) {
            var elm, rect;
            if (!(elm = elem.get(0))) {
                return false;
            }
            if (!nochkHide && elm.offsetParent === null) {
                return false;
            }
            rect = elm.getBoundingClientRect();
            return document.elementFromPoint(rect.left, rect.top) ? true : false;
        },

        /**
         * calculate elFinder node z-index
         * 
         * @return void
         */
        zIndexCalc: function () {
            var self = this,
                node = this.getUI(),
                ni = node.css('z-index');
            if (ni && ni !== 'auto' && ni !== 'inherit') {
                self.zIndex = ni;
            } else {
                node.parents().each(function (i, n) {
                    var z = $(n).css('z-index');
                    if (z !== 'auto' && z !== 'inherit' && (z = parseInt(z))) {
                        self.zIndex = z;
                        return false;
                    }
                });
            }
        },

        /**
         * Load JavaScript files
         * 
         * @param  Array    urls      to load JavaScript file URLs
         * @param  Function callback  call back function on script loaded
         * @param  Object   opts      Additional options to $.ajax OR {loadType: 'tag'} to load by script tag
         * @param  Object   check     { obj: (Object)ParentObject, name: (String)"Attribute name", timeout: (Integer)milliseconds }
         * @return elFinder
         */
        loadScript: function (urls, callback, opts, check) {
            var defOpts = {
                dataType: 'script',
                cache: true
            },
                success, cnt, scripts = {}, results = {};

            opts = opts || {};
            if (opts.tryRequire && this.hasRequire) {
                require(urls, callback, opts.error);
            } else {
                success = function () {
                    var cnt, fi, hasError;
                    $.each(results, function (i, status) {
                        if (status !== 'success' && status !== 'notmodified') {
                            hasError = true;
                            return false;
                        }
                    });
                    if (!hasError) {
                        if (typeof callback === 'function') {
                            if (check) {
                                if (typeof check.obj[check.name] === 'undefined') {
                                    cnt = check.timeout ? (check.timeout / 10) : 1;
                                    fi = setInterval(function () {
                                        if (--cnt < 0 || typeof check.obj[check.name] !== 'undefined') {
                                            clearInterval(fi);
                                            callback();
                                        }
                                    }, 10);
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        }
                    } else {
                        if (opts.error && typeof opts.error === 'function') {
                            opts.error({ loadResults: results });
                        }
                    }
                };

                if (opts.loadType === 'tag') {
                    $('head > script').each(function () {
                        scripts[this.src] = this;
                    });
                    cnt = urls.length;
                    $.each(urls, function (i, url) {
                        var done = false,
                            script;

                        if (scripts[url]) {
                            results[i] = scripts[url]._error || 'success';
                            (--cnt < 1) && success();
                        } else {
                            script = document.createElement('script');
                            script.charset = opts.charset || 'UTF-8';
                            $('head').append(script);
                            script.onload = script.onreadystatechange = function () {
                                if (!done && (!this.readyState ||
                                    this.readyState === 'loaded' || this.readyState === 'complete')) {
                                    done = true;
                                    results[i] = 'success';
                                    (--cnt < 1) && success();
                                }
                            };
                            script.onerror = function (err) {
                                results[i] = script._error = (err && err.type) ? err.type : 'error';
                                (--cnt < 1) && success();
                            };
                            script.src = url;
                        }
                    });
                } else {
                    opts = $.isPlainObject(opts) ? Object.assign(defOpts, opts) : defOpts;
                    cnt = 0;
                    (function appendScript(d, status) {
                        if (d !== void (0)) {
                            results[cnt++] = status;
                        }
                        if (urls.length) {
                            $.ajax(Object.assign({}, opts, {
                                url: urls.shift(),
                                success: appendScript,
                                error: appendScript
                            }));
                        } else {
                            success();
                        }
                    })();
                }
            }
            return this;
        },

        /**
         * Load CSS files
         * 
         * @param  Array    to load CSS file URLs
         * @param  Object   options
         * @return elFinder
         */
        loadCss: function (urls, opts) {
            var self = this,
                clName, dfds;
            if (typeof urls === 'string') {
                urls = [urls];
            }
            if (opts) {
                if (opts.className) {
                    clName = opts.className;
                }
                if (opts.dfd && opts.dfd.promise) {
                    dfds = [];
                }
            }
            $.each(urls, function (i, url) {
                var link, df;
                url = self.convAbsUrl(url).replace(/^https?:/i, '');
                if (dfds) {
                    dfds[i] = $.Deferred();
                }
                if (!$('head > link[href="' + self.escape(url) + '"]').length) {
                    link = document.createElement('link');
                    link.type = 'text/css';
                    link.rel = 'stylesheet';
                    link.href = url;
                    if (clName) {
                        link.className = clName;
                    }
                    if (dfds) {
                        link.onload = function () {
                            dfds[i].resolve();
                        };
                        link.onerror = function () {
                            dfds[i].reject();
                        };
                    }
                    $('head').append(link);
                } else {
                    dfds && dfds[i].resolve();
                }
            });
            if (dfds) {
                $.when.apply(null, dfds).done(function () {
                    opts.dfd.resolve();
                }).fail(function () {
                    opts.dfd.reject();
                });
            }
            return this;
        },

        /**
         * Abortable async job performer
         * 
         * @param func Function
         * @param arr  Array
         * @param opts Object
         * 
         * @return Object $.Deferred that has an extended method _abort()
         */
        asyncJob: function (func, arr, opts) {
            var dfrd = $.Deferred(),
                abortFlg = false,
                parms = Object.assign({
                    interval: 0,
                    numPerOnce: 1
                }, opts || {}),
                resArr = [],
                vars = [],
                curVars = [],
                exec,
                tm;

            dfrd._abort = function (resolve) {
                tm && clearTimeout(tm);
                vars = [];
                abortFlg = true;
                if (dfrd.state() === 'pending') {
                    dfrd[resolve ? 'resolve' : 'reject'](resArr);
                }
            };

            dfrd.fail(function () {
                dfrd._abort();
            }).always(function () {
                dfrd._abort = function () { };
            });

            if (typeof func === 'function' && Array.isArray(arr)) {
                vars = arr.concat();
                exec = function () {
                    var i, len, res;
                    if (abortFlg) {
                        return;
                    }
                    curVars = vars.splice(0, parms.numPerOnce);
                    len = curVars.length;
                    for (i = 0; i < len; i++) {
                        if (abortFlg) {
                            break;
                        }
                        res = func(curVars[i]);
                        (res !== null) && resArr.push(res);
                    }
                    if (abortFlg) {
                        return;
                    }
                    if (vars.length) {
                        tm = setTimeout(exec, parms.interval);
                    } else {
                        dfrd.resolve(resArr);
                    }
                };
                if (vars.length) {
                    tm = setTimeout(exec, 0);
                } else {
                    dfrd.resolve(resArr);
                }
            } else {
                dfrd.reject();
            }
            return dfrd;
        },

        getSize: function (targets) {
            var self = this,
                reqs = [],
                tgtlen = targets.length,
                dfrd = $.Deferred().fail(function () {
                    $.each(reqs, function (i, req) {
                        if (req) {
                            req.syncOnFail && req.syncOnFail(false);
                            req.reject();
                        }
                    });
                }),
                getLeafRoots = function (file) {
                    var targets = [];
                    if (file.mime === 'directory') {
                        $.each(self.leafRoots, function (hash, roots) {
                            var phash;
                            if (hash === file.hash) {
                                targets.push.apply(targets, roots);
                            } else {
                                phash = (self.file(hash) || {}).phash;
                                while (phash) {
                                    if (phash === file.hash) {
                                        targets.push.apply(targets, roots);
                                    }
                                    phash = (self.file(phash) || {}).phash;
                                }
                            }
                        });
                    }
                    return targets;
                },
                checkPhash = function (hash) {
                    var dfd = $.Deferred(),
                        dir = self.file(hash),
                        target = dir ? dir.phash : hash;
                    if (target && !self.file(target)) {
                        self.request({
                            data: {
                                cmd: 'parents',
                                target: target
                            },
                            preventFail: true
                        }).done(function () {
                            self.one('parentsdone', function () {
                                dfd.resolve();
                            });
                        }).fail(function () {
                            dfd.resolve();
                        });
                    } else {
                        dfd.resolve();
                    }
                    return dfd;
                },
                cache = function () {
                    var dfd = $.Deferred(),
                        cnt = Object.keys(self.leafRoots).length;

                    if (cnt > 0) {
                        $.each(self.leafRoots, function (hash) {
                            checkPhash(hash).done(function () {
                                --cnt;
                                if (cnt < 1) {
                                    dfd.resolve();
                                }
                            });
                        });
                    } else {
                        dfd.resolve();
                    }
                    return dfd;
                };

            self.autoSync('stop');
            cache().done(function () {
                var files = [], grps = {}, dfds = [], cache = [], singles = {};

                $.each(targets, function () {
                    files.push.apply(files, getLeafRoots(self.file(this)));
                });
                targets.push.apply(targets, files);

                $.each(targets, function () {
                    var root = self.root(this),
                        file = self.file(this);
                    if (file && (file.sizeInfo || file.mime !== 'directory')) {
                        cache.push($.Deferred().resolve(file.sizeInfo ? file.sizeInfo : { size: file.size, dirCnt: 0, fileCnt: 1 }));
                    } else {
                        if (!grps[root]) {
                            grps[root] = [this.toString()];
                        } else {
                            grps[root].push(this.toString());
                        }
                    }
                });

                $.each(grps, function () {
                    var idx = dfds.length;
                    if (this.length === 1) {
                        singles[idx] = this[0];
                    }
                    dfds.push(self.request({
                        data: { cmd: 'size', targets: this },
                        preventDefault: true
                    }));
                });
                reqs.push.apply(reqs, dfds);
                dfds.push.apply(dfds, cache);

                $.when.apply($, dfds).fail(function () {
                    dfrd.reject();
                }).done(function () {
                    var cache = function (h, data) {
                        var file;
                        if (file = self.file(h)) {
                            file.sizeInfo = { isCache: true };
                            $.each(['size', 'dirCnt', 'fileCnt'], function () {
                                file.sizeInfo[this] = data[this] || 0;
                            });
                            file.size = parseInt(file.sizeInfo.size);
                            changed.push(file);
                        }
                    },
                        size = 0,
                        fileCnt = 0,
                        dirCnt = 0,
                        argLen = arguments.length,
                        cnts = [],
                        cntsTxt = '',
                        changed = [],
                        i, file, data;

                    for (i = 0; i < argLen; i++) {
                        data = arguments[i];
                        file = null;
                        if (!data.isCache) {
                            if (singles[i] && (file = self.file(singles[i]))) {
                                cache(singles[i], data);
                            } else if (data.sizes && $.isPlainObject(data.sizes)) {
                                $.each(data.sizes, function (h, sizeInfo) {
                                    cache(h, sizeInfo);
                                });
                            }
                        }
                        size += parseInt(data.size);
                        if (fileCnt !== false) {
                            if (typeof data.fileCnt === 'undefined') {
                                fileCnt = false;
                            } else {
                                fileCnt += parseInt(data.fileCnt || 0);
                            }
                        }
                        if (dirCnt !== false) {
                            if (typeof data.dirCnt === 'undefined') {
                                dirCnt = false;
                            } else {
                                dirCnt += parseInt(data.dirCnt || 0);
                            }
                        }
                    }
                    changed.length && self.change({ changed: changed });

                    if (dirCnt !== false) {
                        cnts.push(self.i18n('folders') + ': ' + (dirCnt - (tgtlen > 1 ? 0 : 1)));
                    }
                    if (fileCnt !== false) {
                        cnts.push(self.i18n('files') + ': ' + fileCnt);
                    }
                    if (cnts.length) {
                        cntsTxt = '<br>' + cnts.join(', ');
                    }
                    dfrd.resolve({
                        size: size,
                        fileCnt: fileCnt,
                        dirCnt: dirCnt,
                        formated: (size >= 0 ? self.formatSize(size) : self.i18n('unknown')) + cntsTxt
                    });
                });

                self.autoSync();
            });

            return dfrd;
        },

        /**
         * Worker Object URL for Blob URL of getWorker()
         */
        wkObjUrl: null,

        /**
         * Gets the web worker.
         *
         * @param      {Object}  options  The options
         * @return     {Worker}  The worker.
         */
        getWorker: function (options) {
            // for to make blob URL
            function woker() {
                self.onmessage = function (e) {
                    var d = e.data;
                    try {
                        self.data = d.data;
                        if (d.scripts) {
                            for (var i = 0; i < d.scripts.length; i++) {
                                importScripts(d.scripts[i]);
                            }
                        }
                        self.postMessage(self.res);
                    } catch (e) {
                        self.postMessage({ error: e.toString() });
                    }
                };
            }
            // get woker
            var wk;
            try {
                if (!this.wkObjUrl) {
                    this.wkObjUrl = (window.URL || window.webkitURL).createObjectURL(new Blob(
                        [woker.toString().replace(/\s+/g, ' ').replace(/ *([^\w]) */g, '$1').replace(/^function\b.+?\{|\}$/g, '')],
                        { type: 'text/javascript' }
                    ));
                }
                wk = new Worker(this.wkObjUrl, options);
            } catch (e) {
                this.debug('error', e.toString());
            }
            return wk;
        },

        /**
         * Get worker absolute URL by filename
         *
         * @param      {string}  filename  The filename
         * @return     {<type>}  The worker url.
         */
        getWorkerUrl: function (filename) {
            return this.convAbsUrl(this.workerBaseUrl + filename);
        },

        /**
         * Gets the theme object by settings of options.themes
         *
         * @param  String  themeid  The themeid
         * @return Object  jQuery.Deferred
         */
        getTheme: function (themeid) {
            var self = this,
                dfd = $.Deferred(),
                absUrl = function (url, base) {
                    if (!base) {
                        base = self.convAbsUrl(self.baseUrl);
                    }
                    if (Array.isArray(url)) {
                        return $.map(url, function (v) {
                            return absUrl(v, base);
                        });
                    } else {
                        return url.match(/^(?:http|\/\/)/i) ? url : base + url.replace(/^(?:\.\/|\/)/, '');
                    }
                },
                themeObj, m;
            if (themeid && (themeObj = self.options.themes[themeid])) {
                if (typeof themeObj === 'string') {
                    url = absUrl(themeObj);
                    if (m = url.match(/^(.+\/)[^/]+\.json$/i)) {
                        $.getJSON(url).done(function (data) {
                            themeObj = data;
                            themeObj.id = themeid;
                            if (themeObj.cssurls) {
                                themeObj.cssurls = absUrl(themeObj.cssurls, m[1]);
                            }
                            dfd.resolve(themeObj);
                        }).fail(function () {
                            dfd.reject();
                        });
                    } else {
                        dfd.resolve({
                            id: themeid,
                            name: themeid,
                            cssurls: [url]
                        });
                    }
                } else if ($.isPlainObject(themeObj) && themeObj.cssurls) {
                    themeObj.id = themeid;
                    themeObj.cssurls = absUrl(themeObj.cssurls);
                    if (!Array.isArray(themeObj.cssurls)) {
                        themeObj.cssurls = [themeObj.cssurls];
                    }
                    if (!themeObj.name) {
                        themeObj.name = themeid;
                    }
                    dfd.resolve(themeObj);
                } else {
                    dfd.reject();
                }
            } else {
                dfd.reject();
            }
            return dfd;
        },

        /**
         * Change current theme
         *
         * @param  String  themeid  The themeid
         * @return Object  this elFinder instance
         */
        changeTheme: function (themeid) {
            var self = this;
            if (themeid) {
                if (self.options.themes[themeid] && (!self.theme || self.theme.id !== themeid)) {
                    self.getTheme(themeid).done(function (themeObj) {
                        if (themeObj.cssurls) {
                            $('head>link.elfinder-theme-ext').remove();
                            self.loadCss(themeObj.cssurls, {
                                className: 'elfinder-theme-ext',
                                dfd: $.Deferred().done(function () {
                                    self.theme = themeObj;
                                    self.trigger && self.trigger('themechange');
                                })
                            });
                        }
                    });
                } else if (themeid === 'default' && self.theme && self.theme.id !== 'default') {
                    $('head>link.elfinder-theme-ext').remove();
                    self.theme = null;
                    self.trigger && self.trigger('themechange');
                }
            }
            return this;
        },

        /**
         * Apply leaf root stats to target directory
         *
         * @param      object     dir     object of target directory
         * @param      boolean    update  is force update
         * 
         * @return     boolean    dir object was chenged 
         */
        applyLeafRootStats: function (dir, update) {
            var self = this,
                prev = update ? dir : (self.file(dir.hash) || dir),
                prevTs = prev.ts,
                change = false;
            // backup original stats
            if (update || !dir._realStats) {
                dir._realStats = {
                    locked: dir.locked || 0,
                    dirs: dir.dirs || 0,
                    ts: dir.ts
                };
            }
            // set lock
            dir.locked = 1;
            if (!prev.locked) {
                change = true;
            }
            // has leaf root to `dirs: 1`
            dir.dirs = 1;
            if (!prev.dirs) {
                change = true;
            }
            // set ts
            $.each(self.leafRoots[dir.hash], function () {
                var f = self.file(this);
                if (f && f.ts && (dir.ts || 0) < f.ts) {
                    dir.ts = f.ts;
                }
            });
            if (prevTs !== dir.ts) {
                change = true;
            }

            return change;
        },

        /**
         * To aborted XHR object
         * 
         * @param Object xhr
         * @param Object opts
         * 
         * @return void
         */
        abortXHR: function (xhr, o) {
            var opts = o || {};

            if (xhr) {
                opts.quiet && (xhr.quiet = true);
                if (opts.abort && xhr._requestId) {
                    this.request({
                        data: {
                            cmd: 'abort',
                            id: xhr._requestId
                        },
                        preventDefault: true
                    });
                }
                xhr.abort();
                xhr = void 0;
            }
        },

        /**
         * Sets the custom header by xhr response header with options.parrotHeaders
         *
         * @param Object xhr
         * 
         * @return void
         */
        setCustomHeaderByXhr: function (xhr) {
            var self = this;
            if (xhr.getResponseHeader && self.parrotHeaders && self.parrotHeaders.length) {
                $.each(self.parrotHeaders, function (i, h) {
                    var val = xhr.getResponseHeader(h);
                    if (val) {
                        self.customHeaders[h] = val;
                        self.sessionStorage('core-ph:' + h, val);
                    } else if (typeof val === 'string') {
                        delete self.customHeaders[h];
                        self.sessionStorage('core-ph:' + h, null);
                    }
                });
            }
        },

        /**
         * Determines if parrot headers.
         *
         * @return     {boolean}  True if parrot headers, False otherwise.
         */
        hasParrotHeaders: function () {
            var res = false,
                phs = this.parrotHeaders;
            if (Object.keys(this.customHeaders).length) {
                for (var i = 0; i < phs.length; i++) {
                    if (this.customHeaders[phs[i]]) {
                        res = true;
                        break;
                    }
                }
            }
            return res;
        },

        /**
         * Gets the request identifier
         *
         * @return  String  The request identifier.
         */
        getRequestId: function () {
            return (+ new Date()).toString(16) + Math.floor(1000 * Math.random()).toString(16);
        },

        /**
         * Flip key and value of array or object
         * 
         * @param  Array | Object  { a: 1, b: 1, c: 2 }
         * @param  Mixed           Static value
         * @return Object          { 1: "b", 2: "c" }
         */
        arrayFlip: function (trans, val) {
            var key,
                tmpArr = {},
                isArr = $.isArray(trans);
            for (key in trans) {
                if (isArr || trans.hasOwnProperty(key)) {
                    tmpArr[trans[key]] = val || key;
                }
            }
            return tmpArr;
        },

        /**
         * Return array ["name without extention", "extention"]
         * 
         * @param String name
         * 
         * @return Array
         * 
         */
        splitFileExtention: function (name) {
            var m;
            if (m = name.match(/^(.+?)?\.((?:tar\.(?:gz|bz|bz2|z|lzo))|cpio\.gz|ps\.gz|xcf\.(?:gz|bz2)|[a-z0-9]{1,10})$/i)) {
                if (typeof m[1] === 'undefined') {
                    m[1] = '';
                }
                return [m[1], m[2]];
            } else {
                return [name, ''];
            }
        },

        /**
         * Slice the ArrayBuffer by sliceSize
         *
         * @param      arraybuffer  arrayBuffer  The array buffer
         * @param      Number       sliceSize    The slice size
         * @return     Array   Array of sleced arraybuffer
         */
        sliceArrayBuffer: function (arrayBuffer, sliceSize) {
            var segments = [],
                fi = 0;
            while (fi * sliceSize < arrayBuffer.byteLength) {
                segments.push(arrayBuffer.slice(fi * sliceSize, (fi + 1) * sliceSize));
                fi++;
            }
            return segments;
        },

        arrayBufferToBase64: function (ab) {
            if (!window.btoa) {
                return '';
            }
            var dView = new Uint8Array(ab), // Get a byte view
                arr = Array.prototype.slice.call(dView), // Create a normal array
                arr1 = arr.map(function (item) {
                    return String.fromCharCode(item); // Convert
                });
            return window.btoa(arr1.join('')); // Form a string
        },

        log: function (m) { window.console && window.console.log && window.console.log(m); return this; },

        debug: function (type, m) {
            var self = this,
                d = this.options.debug,
                tb = this.options.toastBackendWarn,
                tbOpts, showlog;

            if (type === 'backend-error') {
                if (!this.cwd().hash || (d && (d === 'all' || d['backend-error']))) {
                    m = Array.isArray(m) ? m : [m];
                    this.error(m);
                }
            } else if (type === 'backend-warning') {
                showlog = true;
                if (tb) {
                    tbOpts = $.isPlainObject(tb) ? tb : {};
                    $.each(Array.isArray(m) ? m : [m], function (i, m) {
                        self.toast(Object.assign({
                            mode: 'warning',
                            msg: m
                        }, tbOpts));
                    });
                }
            } else if (type === 'backend-debug') {
                this.trigger('backenddebug', m);
            }

            if (showlog || (d && (d === 'all' || d[type]))) {
                window.console && window.console.log && window.console.log('elfinder debug: [' + type + '] [' + this.id + ']', m);
            }

            return this;
        },

        /**
         * Parse response.debug and trigger debug
         *
         * @param      Object  response  The response
         */
        responseDebug: function (response) {
            var rd = response.debug,
                d;
            if (rd) {
                // set options.debug
                d = this.options.debug;
                if (!d || d !== 'all') {
                    if (!d) {
                        d = this.options.debug = {};
                    }
                    d['backend-error'] = true;
                    d['warning'] = true;
                }
                if (rd.mountErrors && (typeof rd.mountErrors === 'string' || (Array.isArray(rd.mountErrors) && rd.mountErrors.length))) {
                    this.debug('backend-error', rd.mountErrors);
                }
                if (rd.backendErrors && (typeof rd.backendErrors === 'string' || (Array.isArray(rd.backendErrors) && rd.backendErrors.length))) {
                    this.debug('backend-warning', rd.backendErrors);
                }
            }
        },

        time: function (l) { window.console && window.console.time && window.console.time(l); },
        timeEnd: function (l) { window.console && window.console.timeEnd && window.console.timeEnd(l); }


    };

    /**
     * for conpat ex. ie8...
     *
     * Object.keys() - JavaScript | MDN
     * https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
     */
    if (!Object.keys) {
        Object.keys = (function () {
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
                dontEnums = [
                    'toString',
                    'toLocaleString',
                    'valueOf',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'constructor'
                ],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) throw new TypeError('Object.keys called on non-object');

                var result = [];

                for (var prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) result.push(prop);
                }

                if (hasDontEnumBug) {
                    for (var i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                    }
                }
                return result;
            };
        })();
    }
    // Array.isArray
    if (!Array.isArray) {
        Array.isArray = function (arr) {
            return jQuery.isArray(arr);
        };
    }
    // Object.assign
    if (!Object.assign) {
        Object.assign = function () {
            return jQuery.extend.apply(null, arguments);
        };
    }
    // String.repeat
    if (!String.prototype.repeat) {
        String.prototype.repeat = function (count) {
            'use strict';
            if (this == null) {
                throw new TypeError('can\'t convert ' + this + ' to object');
            }
            var str = '' + this;
            count = +count;
            if (count != count) {
                count = 0;
            }
            if (count < 0) {
                throw new RangeError('repeat count must be non-negative');
            }
            if (count == Infinity) {
                throw new RangeError('repeat count must be less than infinity');
            }
            count = Math.floor(count);
            if (str.length == 0 || count == 0) {
                return '';
            }
            // Ensuring count is a 31-bit integer allows us to heavily optimize the
            // main part. But anyway, most current (August 2014) browsers can't handle
            // strings 1 << 28 chars or longer, so:
            if (str.length * count >= 1 << 28) {
                throw new RangeError('repeat count must not overflow maximum string size');
            }
            var rpt = '';
            for (var i = 0; i < count; i++) {
                rpt += str;
            }
            return rpt;
        };
    }
    // String.trim
    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
        };
    }
    // Array.apply
    (function () {
        try {
            Array.apply(null, {});
            return;
        } catch (e) { }

        var toString = Object.prototype.toString,
            arrayType = '[object Array]',
            _apply = Function.prototype.apply,
            slice = /*@cc_on @if (@_jscript_version <= 5.8)
			function () {
				var a = [], i = this.length;
				while (i-- > 0) a[i] = this[i];
				return a;
			}@else@*/Array.prototype.slice/*@end@*/;

        Function.prototype.apply = function apply(thisArg, argArray) {
            return _apply.call(this, thisArg,
                toString.call(argArray) === arrayType ? argArray : slice.call(argArray));
        };
    })();
    // Array.from
    if (!Array.from) {
        Array.from = function (obj) {
            return obj.length === 1 ? [obj[0]] : Array.apply(null, obj);
        };
    }
    // window.requestAnimationFrame and window.cancelAnimationFrame
    if (!window.cancelAnimationFrame) {
        // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
        // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
        // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
        // MIT license
        (function () {
            var lastTime = 0;
            var vendors = ['ms', 'moz', 'webkit', 'o'];
            for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
                window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
                window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
                    || window[vendors[x] + 'CancelRequestAnimationFrame'];
            }

            if (!window.requestAnimationFrame)
                window.requestAnimationFrame = function (callback, element) {
                    var currTime = new Date().getTime();
                    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                    var id = window.setTimeout(function () { callback(currTime + timeToCall); },
                        timeToCall);
                    lastTime = currTime + timeToCall;
                    return id;
                };

            if (!window.cancelAnimationFrame)
                window.cancelAnimationFrame = function (id) {
                    clearTimeout(id);
                };
        }());
    }


    /*
     * File: /js/elFinder.version.js
     */

    /**
     * Application version
     *
     * @type String
     **/
    elFinder.prototype.version = '2.1.65';



    /*
     * File: /js/jquery.elfinder.js
     */

    /*** jQuery UI droppable performance tune for elFinder ***/
    (function () {
        if ($.ui) {
            if ($.ui.ddmanager) {
                var origin = $.ui.ddmanager.prepareOffsets;
                $.ui.ddmanager.prepareOffsets = function (t, event) {
                    var isOutView = function (elem) {
                        if (elem.is(':hidden')) {
                            return true;
                        }
                        var rect = elem[0].getBoundingClientRect();
                        return document.elementFromPoint(rect.left, rect.top) || document.elementFromPoint(rect.left + rect.width, rect.top + rect.height) ? false : true;
                    };

                    if (event.type === 'mousedown' || t.options.elfRefresh) {
                        var i, d,
                            m = $.ui.ddmanager.droppables[t.options.scope] || [],
                            l = m.length;
                        for (i = 0; i < l; i++) {
                            d = m[i];
                            if (d.options.autoDisable && (!d.options.disabled || d.options.autoDisable > 1)) {
                                d.options.disabled = isOutView(d.element);
                                d.options.autoDisable = d.options.disabled ? 2 : 1;
                            }
                        }
                    }

                    // call origin function
                    return origin(t, event);
                };
            }
        }
    })();

    /**
    *
    * jquery.binarytransport
    *
    * @description. jQuery ajax transport for making binary data type requests.
    *
    */

    (function ($, undefined) {

        // use this transport for "binary" data type
        $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
            // check for conditions and support for blob / arraybuffer response type
            if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
                var callback;

                // Cross domain only allowed if supported through XMLHttpRequest
                return {
                    send: function (headers, complete) {
                        var i,
                            dataType = options.responseType || "blob",
                            xhr = options.xhr();

                        xhr.open(
                            options.type,
                            options.url,
                            options.async,
                            options.username,
                            options.password
                        );

                        // Apply custom fields if provided
                        if (options.xhrFields) {
                            for (i in options.xhrFields) {
                                xhr[i] = options.xhrFields[i];
                            }
                        }

                        // Override mime type if needed
                        if (options.mimeType && xhr.overrideMimeType) {
                            xhr.overrideMimeType(options.mimeType);
                        }

                        // X-Requested-With header
                        // For cross-domain requests, seeing as conditions for a preflight are
                        // akin to a jigsaw puzzle, we simply never set it to be sure.
                        // (it can always be set on a per-request basis or even using ajaxSetup)
                        // For same-domain requests, won't change header if already provided.
                        if (!options.crossDomain && !headers["X-Requested-With"]) {
                            headers["X-Requested-With"] = "XMLHttpRequest";
                        }

                        // Set headers
                        for (i in headers) {
                            xhr.setRequestHeader(i, headers[i]);
                        }

                        // Callback
                        callback = function (type) {
                            return function () {
                                if (callback) {
                                    callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;

                                    if (type === "abort") {
                                        xhr.abort();
                                    } else if (type === "error") {
                                        complete(
                                            xhr.status,
                                            xhr.statusText
                                        );
                                    } else {
                                        var data = {};
                                        data[options.dataType] = xhr.response;
                                        complete(
                                            xhr.status,
                                            xhr.statusText,
                                            data,
                                            xhr.getAllResponseHeaders()
                                        );
                                    }
                                }
                            };
                        };

                        // Listen to events
                        xhr.onload = callback();
                        xhr.onabort = xhr.onerror = xhr.ontimeout = callback("error");

                        // Create the abort callback
                        callback = callback("abort");

                        try {
                            xhr.responseType = dataType;
                            // Do send the request (this may raise an exception)
                            xhr.send(options.data || null);
                        } catch (e) {
                            if (callback) {
                                throw e;
                            }
                        }
                    },

                    abort: function () {
                        if (callback) {
                            callback();
                        }
                    }
                };
            }
        });
    })(window.jQuery);

    /*!
     * jQuery UI Touch Punch 0.2.3
     *
     * Copyright 2011–2014, Dave Furfero
     * Dual licensed under the MIT or GPL Version 2 licenses.
     *
     * Depends:
     *	jquery.ui.widget.js
     *	jquery.ui.mouse.js
     */
    (function ($) {

        // Detect touch support
        $.support.touch = 'ontouchend' in document;

        // Ignore browsers without touch support
        if (!$.support.touch) {
            return;
        }

        var mouseProto = $.ui.mouse.prototype,
            _mouseInit = mouseProto._mouseInit,
            _mouseDestroy = mouseProto._mouseDestroy,
            touchHandled,
            posX, posY;

        /**
         * Simulate a mouse event based on a corresponding touch event
         * @param {Object} event A touch event
         * @param {String} simulatedType The corresponding mouse event
         */
        function simulateMouseEvent(event, simulatedType) {

            // Ignore multi-touch events
            if (event.originalEvent.touches.length > 1) {
                return;
            }

            if (!$(event.currentTarget).hasClass('touch-punch-keep-default')) {
                event.preventDefault();
            }

            var touch = event.originalEvent.changedTouches[0],
                simulatedEvent = document.createEvent('MouseEvents');

            // Initialize the simulated mouse event using the touch event's coordinates
            simulatedEvent.initMouseEvent(
                simulatedType,	// type
                true,				// bubbles					  
                true,				// cancelable				  
                window,			// view						  
                1,				// detail					  
                touch.screenX,	// screenX					  
                touch.screenY,	// screenY					  
                touch.clientX,	// clientX					  
                touch.clientY,	// clientY					  
                false,			// ctrlKey					  
                false,			// altKey					  
                false,			// shiftKey					  
                false,			// metaKey					  
                0,				// button					  
                null				// relatedTarget			  
            );

            // Dispatch the simulated event to the target element
            event.target.dispatchEvent(simulatedEvent);
        }

        /**
         * Handle the jQuery UI widget's touchstart events
         * @param {Object} event The widget element's touchstart event
         */
        mouseProto._touchStart = function (event) {

            var self = this;

            // Ignore the event if another widget is already being handled
            if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
                return;
            }

            // Track element position to avoid "false" move
            posX = event.originalEvent.changedTouches[0].screenX.toFixed(0);
            posY = event.originalEvent.changedTouches[0].screenY.toFixed(0);

            // Set the flag to prevent other widgets from inheriting the touch event
            touchHandled = true;

            // Track movement to determine if interaction was a click
            self._touchMoved = false;

            // Simulate the mouseover event
            simulateMouseEvent(event, 'mouseover');

            // Simulate the mousemove event
            simulateMouseEvent(event, 'mousemove');

            // Simulate the mousedown event
            simulateMouseEvent(event, 'mousedown');
        };

        /**
         * Handle the jQuery UI widget's touchmove events
         * @param {Object} event The document's touchmove event
         */
        mouseProto._touchMove = function (event) {

            // Ignore event if not handled
            if (!touchHandled) {
                return;
            }

            // Ignore if it's a "false" move (position not changed)
            var x = event.originalEvent.changedTouches[0].screenX.toFixed(0);
            var y = event.originalEvent.changedTouches[0].screenY.toFixed(0);
            // Ignore if it's a "false" move (position not changed)
            if (Math.abs(posX - x) <= 4 && Math.abs(posY - y) <= 4) {
                return;
            }

            // Interaction was not a click
            this._touchMoved = true;

            // Simulate the mousemove event
            simulateMouseEvent(event, 'mousemove');
        };

        /**
         * Handle the jQuery UI widget's touchend events
         * @param {Object} event The document's touchend event
         */
        mouseProto._touchEnd = function (event) {

            // Ignore event if not handled
            if (!touchHandled) {
                return;
            }

            // Simulate the mouseup event
            simulateMouseEvent(event, 'mouseup');

            // Simulate the mouseout event
            simulateMouseEvent(event, 'mouseout');

            // If the touch interaction did not move, it should trigger a click
            if (!this._touchMoved) {

                // Simulate the click event
                simulateMouseEvent(event, 'click');
            }

            // Unset the flag to allow other widgets to inherit the touch event
            touchHandled = false;
            this._touchMoved = false;
        };

        /**
         * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
         * This method extends the widget with bound touch event handlers that
         * translate touch events to mouse events and pass them to the widget's
         * original mouse event handling methods.
         */
        mouseProto._mouseInit = function () {

            var self = this;

            if (self.element.hasClass('touch-punch')) {
                // Delegate the touch handlers to the widget's element
                self.element.on({
                    touchstart: $.proxy(self, '_touchStart'),
                    touchmove: $.proxy(self, '_touchMove'),
                    touchend: $.proxy(self, '_touchEnd')
                });
            }

            // Call the original $.ui.mouse init method
            _mouseInit.call(self);
        };

        /**
         * Remove the touch event handlers
         */
        mouseProto._mouseDestroy = function () {

            var self = this;

            if (self.element.hasClass('touch-punch')) {
                // Delegate the touch handlers to the widget's element
                self.element.off({
                    touchstart: $.proxy(self, '_touchStart'),
                    touchmove: $.proxy(self, '_touchMove'),
                    touchend: $.proxy(self, '_touchEnd')
                });
            }

            // Call the original $.ui.mouse destroy method
            _mouseDestroy.call(self);
        };

    })(jQuery);

    $.fn.elfinder = function (o, o2) {

        if (o === 'instance') {
            return this.getElFinder();
        } else if (o === 'ondemand') {

        }

        return this.each(function () {

            var cmd = typeof o === 'string' ? o : '',
                bootCallback = typeof o2 === 'function' ? o2 : void (0),
                elfinder = this.elfinder,
                opts, reloadCallback;

            if (!elfinder) {
                if ($.isPlainObject(o)) {
                    new elFinder(this, o, bootCallback);
                }
            } else {
                switch (cmd) {
                    case 'close':
                    case 'hide':
                        elfinder.hide();
                        break;

                    case 'open':
                    case 'show':
                        elfinder.show();
                        break;

                    case 'destroy':
                        elfinder.destroy();
                        break;

                    case 'reload':
                    case 'restart':
                        if (elfinder) {
                            opts = $.extend(true, elfinder.options, $.isPlainObject(o2) ? o2 : {});
                            bootCallback = elfinder.bootCallback;
                            if (elfinder.reloadCallback && typeof elfinder.reloadCallback === 'function') {
                                elfinder.reloadCallback(opts, bootCallback);
                            } else {
                                elfinder.destroy();
                                new elFinder(this, opts, bootCallback);
                            }
                        }
                        break;
                }
            }
        });
    };

    $.fn.getElFinder = function () {
        var instance;

        this.each(function () {
            if (this.elfinder) {
                instance = this.elfinder;
                return false;
            }
        });

        return instance;
    };

    $.fn.elfUiWidgetInstance = function (name) {
        try {
            return this[name]('instance');
        } catch (e) {
            // fallback for jQuery UI < 1.11
            var data = this.data('ui-' + name);
            if (data && typeof data === 'object' && data.widgetFullName === 'ui-' + name) {
                return data;
            }
            return null;
        }
    };

    // function scrollRight
    if (!$.fn.scrollRight) {
        $.fn.extend({
            scrollRight: function (val) {
                var node = this.get(0);
                if (val === undefined) {
                    return Math.max(0, node.scrollWidth - (node.scrollLeft + node.clientWidth));
                }
                return this.scrollLeft(node.scrollWidth - node.clientWidth - val);
            }
        });
    }

    // function scrollBottom
    if (!$.fn.scrollBottom) {
        $.fn.extend({
            scrollBottom: function (val) {
                var node = this.get(0);
                if (val === undefined) {
                    return Math.max(0, node.scrollHeight - (node.scrollTop + node.clientHeight));
                }
                return this.scrollTop(node.scrollHeight - node.clientHeight - val);
            }
        });
    }


    /*
     * File: /js/elFinder.mimetypes.js
     */

    elFinder.prototype.mimeTypes = { "application\/x-executable": "exe", "application\/x-jar": "jar", "application\/x-gzip": "gz", "application\/x-bzip2": "tbz", "application\/x-rar": "rar", "text\/x-php": "php", "text\/javascript": "js", "application\/rtfd": "rtfd", "text\/x-python": "py", "text\/x-ruby": "rb", "text\/x-shellscript": "sh", "text\/x-perl": "pl", "text\/xml": "xml", "text\/x-csrc": "c", "text\/x-chdr": "h", "text\/x-c++src": "cpp", "text\/x-c++hdr": "hh", "text\/x-markdown": "md", "text\/x-yaml": "yml", "image\/x-ms-bmp": "bmp", "image\/x-targa": "tga", "image\/xbm": "xbm", "image\/pxm": "pxm", "audio\/wav": "wav", "video\/x-dv": "dv", "video\/x-ms-wmv": "wm", "video\/ogg": "ogm", "video\/MP2T": "m2ts", "application\/x-mpegURL": "m3u8", "application\/dash+xml": "mpd", "application\/andrew-inset": "ez", "application\/applixware": "aw", "application\/atom+xml": "atom", "application\/atomcat+xml": "atomcat", "application\/atomsvc+xml": "atomsvc", "application\/ccxml+xml": "ccxml", "application\/cdmi-capability": "cdmia", "application\/cdmi-container": "cdmic", "application\/cdmi-domain": "cdmid", "application\/cdmi-object": "cdmio", "application\/cdmi-queue": "cdmiq", "application\/cu-seeme": "cu", "application\/davmount+xml": "davmount", "application\/docbook+xml": "dbk", "application\/dssc+der": "dssc", "application\/dssc+xml": "xdssc", "application\/ecmascript": "ecma", "application\/emma+xml": "emma", "application\/epub+zip": "epub", "application\/exi": "exi", "application\/font-tdpfr": "pfr", "application\/gml+xml": "gml", "application\/gpx+xml": "gpx", "application\/gxf": "gxf", "application\/hyperstudio": "stk", "application\/inkml+xml": "ink", "application\/ipfix": "ipfix", "application\/java-serialized-object": "ser", "application\/java-vm": "class", "application\/json": "json", "application\/jsonml+json": "jsonml", "application\/lost+xml": "lostxml", "application\/mac-binhex40": "hqx", "application\/mac-compactpro": "cpt", "application\/mads+xml": "mads", "application\/marc": "mrc", "application\/marcxml+xml": "mrcx", "application\/mathematica": "ma", "application\/mathml+xml": "mathml", "application\/mbox": "mbox", "application\/mediaservercontrol+xml": "mscml", "application\/metalink+xml": "metalink", "application\/metalink4+xml": "meta4", "application\/mets+xml": "mets", "application\/mods+xml": "mods", "application\/mp21": "m21", "application\/mp4": "mp4s", "application\/msword": "doc", "application\/mxf": "mxf", "application\/octet-stream": "bin", "application\/oda": "oda", "application\/oebps-package+xml": "opf", "application\/ogg": "ogx", "application\/omdoc+xml": "omdoc", "application\/onenote": "onetoc", "application\/oxps": "oxps", "application\/patch-ops-error+xml": "xer", "application\/pdf": "pdf", "application\/pgp-encrypted": "pgp", "application\/pgp-signature": "asc", "application\/pics-rules": "prf", "application\/pkcs10": "p10", "application\/pkcs7-mime": "p7m", "application\/pkcs7-signature": "p7s", "application\/pkcs8": "p8", "application\/pkix-attr-cert": "ac", "application\/pkix-cert": "cer", "application\/pkix-crl": "crl", "application\/pkix-pkipath": "pkipath", "application\/pkixcmp": "pki", "application\/pls+xml": "pls", "application\/postscript": "ai", "application\/prs.cww": "cww", "application\/pskc+xml": "pskcxml", "application\/rdf+xml": "rdf", "application\/reginfo+xml": "rif", "application\/relax-ng-compact-syntax": "rnc", "application\/resource-lists+xml": "rl", "application\/resource-lists-diff+xml": "rld", "application\/rls-services+xml": "rs", "application\/rpki-ghostbusters": "gbr", "application\/rpki-manifest": "mft", "application\/rpki-roa": "roa", "application\/rsd+xml": "rsd", "application\/rss+xml": "rss", "application\/rtf": "rtf", "application\/sbml+xml": "sbml", "application\/scvp-cv-request": "scq", "application\/scvp-cv-response": "scs", "application\/scvp-vp-request": "spq", "application\/scvp-vp-response": "spp", "application\/sdp": "sdp", "application\/set-payment-initiation": "setpay", "application\/set-registration-initiation": "setreg", "application\/shf+xml": "shf", "application\/smil+xml": "smi", "application\/sparql-query": "rq", "application\/sparql-results+xml": "srx", "application\/srgs": "gram", "application\/srgs+xml": "grxml", "application\/sru+xml": "sru", "application\/ssdl+xml": "ssdl", "application\/ssml+xml": "ssml", "application\/tei+xml": "tei", "application\/thraud+xml": "tfi", "application\/timestamped-data": "tsd", "application\/vnd.3gpp.pic-bw-large": "plb", "application\/vnd.3gpp.pic-bw-small": "psb", "application\/vnd.3gpp.pic-bw-var": "pvb", "application\/vnd.3gpp2.tcap": "tcap", "application\/vnd.3m.post-it-notes": "pwn", "application\/vnd.accpac.simply.aso": "aso", "application\/vnd.accpac.simply.imp": "imp", "application\/vnd.acucobol": "acu", "application\/vnd.acucorp": "atc", "application\/vnd.adobe.air-application-installer-package+zip": "air", "application\/vnd.adobe.formscentral.fcdt": "fcdt", "application\/vnd.adobe.fxp": "fxp", "application\/vnd.adobe.xdp+xml": "xdp", "application\/vnd.adobe.xfdf": "xfdf", "application\/vnd.ahead.space": "ahead", "application\/vnd.airzip.filesecure.azf": "azf", "application\/vnd.airzip.filesecure.azs": "azs", "application\/vnd.amazon.ebook": "azw", "application\/vnd.americandynamics.acc": "acc", "application\/vnd.amiga.ami": "ami", "application\/vnd.android.package-archive": "apk", "application\/vnd.anser-web-certificate-issue-initiation": "cii", "application\/vnd.anser-web-funds-transfer-initiation": "fti", "application\/vnd.antix.game-component": "atx", "application\/vnd.apple.installer+xml": "mpkg", "application\/vnd.aristanetworks.swi": "swi", "application\/vnd.astraea-software.iota": "iota", "application\/vnd.audiograph": "aep", "application\/vnd.blueice.multipass": "mpm", "application\/vnd.bmi": "bmi", "application\/vnd.businessobjects": "rep", "application\/vnd.chemdraw+xml": "cdxml", "application\/vnd.chipnuts.karaoke-mmd": "mmd", "application\/vnd.cinderella": "cdy", "application\/vnd.claymore": "cla", "application\/vnd.cloanto.rp9": "rp9", "application\/vnd.clonk.c4group": "c4g", "application\/vnd.cluetrust.cartomobile-config": "c11amc", "application\/vnd.cluetrust.cartomobile-config-pkg": "c11amz", "application\/vnd.commonspace": "csp", "application\/vnd.contact.cmsg": "cdbcmsg", "application\/vnd.cosmocaller": "cmc", "application\/vnd.crick.clicker": "clkx", "application\/vnd.crick.clicker.keyboard": "clkk", "application\/vnd.crick.clicker.palette": "clkp", "application\/vnd.crick.clicker.template": "clkt", "application\/vnd.crick.clicker.wordbank": "clkw", "application\/vnd.criticaltools.wbs+xml": "wbs", "application\/vnd.ctc-posml": "pml", "application\/vnd.cups-ppd": "ppd", "application\/vnd.curl.car": "car", "application\/vnd.curl.pcurl": "pcurl", "application\/vnd.dart": "dart", "application\/vnd.data-vision.rdz": "rdz", "application\/vnd.dece.data": "uvf", "application\/vnd.dece.ttml+xml": "uvt", "application\/vnd.dece.unspecified": "uvx", "application\/vnd.dece.zip": "uvz", "application\/vnd.denovo.fcselayout-link": "fe_launch", "application\/vnd.dna": "dna", "application\/vnd.dolby.mlp": "mlp", "application\/vnd.dpgraph": "dpg", "application\/vnd.dreamfactory": "dfac", "application\/vnd.ds-keypoint": "kpxx", "application\/vnd.dvb.ait": "ait", "application\/vnd.dvb.service": "svc", "application\/vnd.dynageo": "geo", "application\/vnd.ecowin.chart": "mag", "application\/vnd.enliven": "nml", "application\/vnd.epson.esf": "esf", "application\/vnd.epson.msf": "msf", "application\/vnd.epson.quickanime": "qam", "application\/vnd.epson.salt": "slt", "application\/vnd.epson.ssf": "ssf", "application\/vnd.eszigno3+xml": "es3", "application\/vnd.ezpix-album": "ez2", "application\/vnd.ezpix-package": "ez3", "application\/vnd.fdf": "fdf", "application\/vnd.fdsn.mseed": "mseed", "application\/vnd.fdsn.seed": "seed", "application\/vnd.flographit": "gph", "application\/vnd.fluxtime.clip": "ftc", "application\/vnd.framemaker": "fm", "application\/vnd.frogans.fnc": "fnc", "application\/vnd.frogans.ltf": "ltf", "application\/vnd.fsc.weblaunch": "fsc", "application\/vnd.fujitsu.oasys": "oas", "application\/vnd.fujitsu.oasys2": "oa2", "application\/vnd.fujitsu.oasys3": "oa3", "application\/vnd.fujitsu.oasysgp": "fg5", "application\/vnd.fujitsu.oasysprs": "bh2", "application\/vnd.fujixerox.ddd": "ddd", "application\/vnd.fujixerox.docuworks": "xdw", "application\/vnd.fujixerox.docuworks.binder": "xbd", "application\/vnd.fuzzysheet": "fzs", "application\/vnd.genomatix.tuxedo": "txd", "application\/vnd.geogebra.file": "ggb", "application\/vnd.geogebra.tool": "ggt", "application\/vnd.geometry-explorer": "gex", "application\/vnd.geonext": "gxt", "application\/vnd.geoplan": "g2w", "application\/vnd.geospace": "g3w", "application\/vnd.gmx": "gmx", "application\/vnd.google-earth.kml+xml": "kml", "application\/vnd.google-earth.kmz": "kmz", "application\/vnd.grafeq": "gqf", "application\/vnd.groove-account": "gac", "application\/vnd.groove-help": "ghf", "application\/vnd.groove-identity-message": "gim", "application\/vnd.groove-injector": "grv", "application\/vnd.groove-tool-message": "gtm", "application\/vnd.groove-tool-template": "tpl", "application\/vnd.groove-vcard": "vcg", "application\/vnd.hal+xml": "hal", "application\/vnd.handheld-entertainment+xml": "zmm", "application\/vnd.hbci": "hbci", "application\/vnd.hhe.lesson-player": "les", "application\/vnd.hp-hpgl": "hpgl", "application\/vnd.hp-hpid": "hpid", "application\/vnd.hp-hps": "hps", "application\/vnd.hp-jlyt": "jlt", "application\/vnd.hp-pcl": "pcl", "application\/vnd.hp-pclxl": "pclxl", "application\/vnd.hydrostatix.sof-data": "sfd-hdstx", "application\/vnd.ibm.minipay": "mpy", "application\/vnd.ibm.modcap": "afp", "application\/vnd.ibm.rights-management": "irm", "application\/vnd.ibm.secure-container": "sc", "application\/vnd.iccprofile": "icc", "application\/vnd.igloader": "igl", "application\/vnd.immervision-ivp": "ivp", "application\/vnd.immervision-ivu": "ivu", "application\/vnd.insors.igm": "igm", "application\/vnd.intercon.formnet": "xpw", "application\/vnd.intergeo": "i2g", "application\/vnd.intu.qbo": "qbo", "application\/vnd.intu.qfx": "qfx", "application\/vnd.ipunplugged.rcprofile": "rcprofile", "application\/vnd.irepository.package+xml": "irp", "application\/vnd.is-xpr": "xpr", "application\/vnd.isac.fcs": "fcs", "application\/vnd.jam": "jam", "application\/vnd.jcp.javame.midlet-rms": "rms", "application\/vnd.jisp": "jisp", "application\/vnd.joost.joda-archive": "joda", "application\/vnd.kahootz": "ktz", "application\/vnd.kde.karbon": "karbon", "application\/vnd.kde.kchart": "chrt", "application\/vnd.kde.kformula": "kfo", "application\/vnd.kde.kivio": "flw", "application\/vnd.kde.kontour": "kon", "application\/vnd.kde.kpresenter": "kpr", "application\/vnd.kde.kspread": "ksp", "application\/vnd.kde.kword": "kwd", "application\/vnd.kenameaapp": "htke", "application\/vnd.kidspiration": "kia", "application\/vnd.kinar": "kne", "application\/vnd.koan": "skp", "application\/vnd.kodak-descriptor": "sse", "application\/vnd.las.las+xml": "lasxml", "application\/vnd.llamagraphics.life-balance.desktop": "lbd", "application\/vnd.llamagraphics.life-balance.exchange+xml": "lbe", "application\/vnd.lotus-1-2-3": 123, "application\/vnd.lotus-approach": "apr", "application\/vnd.lotus-freelance": "pre", "application\/vnd.lotus-notes": "nsf", "application\/vnd.lotus-organizer": "org", "application\/vnd.lotus-screencam": "scm", "application\/vnd.lotus-wordpro": "lwp", "application\/vnd.macports.portpkg": "portpkg", "application\/vnd.mcd": "mcd", "application\/vnd.medcalcdata": "mc1", "application\/vnd.mediastation.cdkey": "cdkey", "application\/vnd.mfer": "mwf", "application\/vnd.mfmp": "mfm", "application\/vnd.micrografx.flo": "flo", "application\/vnd.micrografx.igx": "igx", "application\/vnd.mif": "mif", "application\/vnd.mobius.daf": "daf", "application\/vnd.mobius.dis": "dis", "application\/vnd.mobius.mbk": "mbk", "application\/vnd.mobius.mqy": "mqy", "application\/vnd.mobius.msl": "msl", "application\/vnd.mobius.plc": "plc", "application\/vnd.mobius.txf": "txf", "application\/vnd.mophun.application": "mpn", "application\/vnd.mophun.certificate": "mpc", "application\/vnd.mozilla.xul+xml": "xul", "application\/vnd.ms-artgalry": "cil", "application\/vnd.ms-cab-compressed": "cab", "application\/vnd.ms-excel": "xls", "application\/vnd.ms-excel.addin.macroenabled.12": "xlam", "application\/vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb", "application\/vnd.ms-excel.sheet.macroenabled.12": "xlsm", "application\/vnd.ms-excel.template.macroenabled.12": "xltm", "application\/vnd.ms-fontobject": "eot", "application\/vnd.ms-htmlhelp": "chm", "application\/vnd.ms-ims": "ims", "application\/vnd.ms-lrm": "lrm", "application\/vnd.ms-officetheme": "thmx", "application\/vnd.ms-outlook": "msg", "application\/vnd.ms-pki.seccat": "cat", "application\/vnd.ms-pki.stl": "stl", "application\/vnd.ms-powerpoint": "ppt", "application\/vnd.ms-powerpoint.addin.macroenabled.12": "ppam", "application\/vnd.ms-powerpoint.presentation.macroenabled.12": "pptm", "application\/vnd.ms-powerpoint.slide.macroenabled.12": "sldm", "application\/vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm", "application\/vnd.ms-powerpoint.template.macroenabled.12": "potm", "application\/vnd.ms-project": "mpp", "application\/vnd.ms-word.document.macroenabled.12": "docm", "application\/vnd.ms-word.template.macroenabled.12": "dotm", "application\/vnd.ms-works": "wps", "application\/vnd.ms-wpl": "wpl", "application\/vnd.ms-xpsdocument": "xps", "application\/vnd.mseq": "mseq", "application\/vnd.musician": "mus", "application\/vnd.muvee.style": "msty", "application\/vnd.mynfc": "taglet", "application\/vnd.neurolanguage.nlu": "nlu", "application\/vnd.nitf": "ntf", "application\/vnd.noblenet-directory": "nnd", "application\/vnd.noblenet-sealer": "nns", "application\/vnd.noblenet-web": "nnw", "application\/vnd.nokia.n-gage.data": "ngdat", "application\/vnd.nokia.n-gage.symbian.install": "n-gage", "application\/vnd.nokia.radio-preset": "rpst", "application\/vnd.nokia.radio-presets": "rpss", "application\/vnd.novadigm.edm": "edm", "application\/vnd.novadigm.edx": "edx", "application\/vnd.novadigm.ext": "ext", "application\/vnd.oasis.opendocument.chart": "odc", "application\/vnd.oasis.opendocument.chart-template": "otc", "application\/vnd.oasis.opendocument.database": "odb", "application\/vnd.oasis.opendocument.formula": "odf", "application\/vnd.oasis.opendocument.formula-template": "odft", "application\/vnd.oasis.opendocument.graphics": "odg", "application\/vnd.oasis.opendocument.graphics-template": "otg", "application\/vnd.oasis.opendocument.image": "odi", "application\/vnd.oasis.opendocument.image-template": "oti", "application\/vnd.oasis.opendocument.presentation": "odp", "application\/vnd.oasis.opendocument.presentation-template": "otp", "application\/vnd.oasis.opendocument.spreadsheet": "ods", "application\/vnd.oasis.opendocument.spreadsheet-template": "ots", "application\/vnd.oasis.opendocument.text": "odt", "application\/vnd.oasis.opendocument.text-master": "odm", "application\/vnd.oasis.opendocument.text-template": "ott", "application\/vnd.oasis.opendocument.text-web": "oth", "application\/vnd.olpc-sugar": "xo", "application\/vnd.oma.dd2+xml": "dd2", "application\/vnd.openofficeorg.extension": "oxt", "application\/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx", "application\/vnd.openxmlformats-officedocument.presentationml.slide": "sldx", "application\/vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx", "application\/vnd.openxmlformats-officedocument.presentationml.template": "potx", "application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx", "application\/vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx", "application\/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx", "application\/vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx", "application\/vnd.osgeo.mapguide.package": "mgp", "application\/vnd.osgi.dp": "dp", "application\/vnd.osgi.subsystem": "esa", "application\/vnd.palm": "pdb", "application\/vnd.pawaafile": "paw", "application\/vnd.pg.format": "str", "application\/vnd.pg.osasli": "ei6", "application\/vnd.picsel": "efif", "application\/vnd.pmi.widget": "wg", "application\/vnd.pocketlearn": "plf", "application\/vnd.powerbuilder6": "pbd", "application\/vnd.previewsystems.box": "box", "application\/vnd.proteus.magazine": "mgz", "application\/vnd.publishare-delta-tree": "qps", "application\/vnd.pvi.ptid1": "ptid", "application\/vnd.quark.quarkxpress": "qxd", "application\/vnd.realvnc.bed": "bed", "application\/vnd.recordare.musicxml": "mxl", "application\/vnd.recordare.musicxml+xml": "musicxml", "application\/vnd.rig.cryptonote": "cryptonote", "application\/vnd.rim.cod": "cod", "application\/vnd.rn-realmedia": "rm", "application\/vnd.rn-realmedia-vbr": "rmvb", "application\/vnd.route66.link66+xml": "link66", "application\/vnd.sailingtracker.track": "st", "application\/vnd.seemail": "see", "application\/vnd.sema": "sema", "application\/vnd.semd": "semd", "application\/vnd.semf": "semf", "application\/vnd.shana.informed.formdata": "ifm", "application\/vnd.shana.informed.formtemplate": "itp", "application\/vnd.shana.informed.interchange": "iif", "application\/vnd.shana.informed.package": "ipk", "application\/vnd.simtech-mindmapper": "twd", "application\/vnd.smaf": "mmf", "application\/vnd.smart.teacher": "teacher", "application\/vnd.solent.sdkm+xml": "sdkm", "application\/vnd.spotfire.dxp": "dxp", "application\/vnd.spotfire.sfs": "sfs", "application\/vnd.stardivision.calc": "sdc", "application\/vnd.stardivision.draw": "sda", "application\/vnd.stardivision.impress": "sdd", "application\/vnd.stardivision.math": "smf", "application\/vnd.stardivision.writer": "sdw", "application\/vnd.stardivision.writer-global": "sgl", "application\/vnd.stepmania.package": "smzip", "application\/vnd.stepmania.stepchart": "sm", "application\/vnd.sun.xml.calc": "sxc", "application\/vnd.sun.xml.calc.template": "stc", "application\/vnd.sun.xml.draw": "sxd", "application\/vnd.sun.xml.draw.template": "std", "application\/vnd.sun.xml.impress": "sxi", "application\/vnd.sun.xml.impress.template": "sti", "application\/vnd.sun.xml.math": "sxm", "application\/vnd.sun.xml.writer": "sxw", "application\/vnd.sun.xml.writer.global": "sxg", "application\/vnd.sun.xml.writer.template": "stw", "application\/vnd.sus-calendar": "sus", "application\/vnd.svd": "svd", "application\/vnd.symbian.install": "sis", "application\/vnd.syncml+xml": "xsm", "application\/vnd.syncml.dm+wbxml": "bdm", "application\/vnd.syncml.dm+xml": "xdm", "application\/vnd.tao.intent-module-archive": "tao", "application\/vnd.tcpdump.pcap": "pcap", "application\/vnd.tmobile-livetv": "tmo", "application\/vnd.trid.tpt": "tpt", "application\/vnd.triscape.mxs": "mxs", "application\/vnd.trueapp": "tra", "application\/vnd.ufdl": "ufd", "application\/vnd.uiq.theme": "utz", "application\/vnd.umajin": "umj", "application\/vnd.unity": "unityweb", "application\/vnd.uoml+xml": "uoml", "application\/vnd.vcx": "vcx", "application\/vnd.visio": "vsd", "application\/vnd.visionary": "vis", "application\/vnd.vsf": "vsf", "application\/vnd.wap.wbxml": "wbxml", "application\/vnd.wap.wmlc": "wmlc", "application\/vnd.wap.wmlscriptc": "wmlsc", "application\/vnd.webturbo": "wtb", "application\/vnd.wolfram.player": "nbp", "application\/vnd.wordperfect": "wpd", "application\/vnd.wqd": "wqd", "application\/vnd.wt.stf": "stf", "application\/vnd.xara": "xar", "application\/vnd.xfdl": "xfdl", "application\/vnd.yamaha.hv-dic": "hvd", "application\/vnd.yamaha.hv-script": "hvs", "application\/vnd.yamaha.hv-voice": "hvp", "application\/vnd.yamaha.openscoreformat": "osf", "application\/vnd.yamaha.openscoreformat.osfpvg+xml": "osfpvg", "application\/vnd.yamaha.smaf-audio": "saf", "application\/vnd.yamaha.smaf-phrase": "spf", "application\/vnd.yellowriver-custom-menu": "cmp", "application\/vnd.zul": "zir", "application\/vnd.zzazz.deck+xml": "zaz", "application\/voicexml+xml": "vxml", "application\/widget": "wgt", "application\/winhlp": "hlp", "application\/wsdl+xml": "wsdl", "application\/wspolicy+xml": "wspolicy", "application\/x-7z-compressed": "7z", "application\/x-abiword": "abw", "application\/x-ace-compressed": "ace", "application\/x-apple-diskimage": "dmg", "application\/x-authorware-bin": "aab", "application\/x-authorware-map": "aam", "application\/x-authorware-seg": "aas", "application\/x-bcpio": "bcpio", "application\/x-bittorrent": "torrent", "application\/x-blorb": "blb", "application\/x-bzip": "bz", "application\/x-cbr": "cbr", "application\/x-cdlink": "vcd", "application\/x-cfs-compressed": "cfs", "application\/x-chat": "chat", "application\/x-chess-pgn": "pgn", "application\/x-conference": "nsc", "application\/x-cpio": "cpio", "application\/x-csh": "csh", "application\/x-debian-package": "deb", "application\/x-dgc-compressed": "dgc", "application\/x-director": "dir", "application\/x-doom": "wad", "application\/x-dtbncx+xml": "ncx", "application\/x-dtbook+xml": "dtb", "application\/x-dtbresource+xml": "res", "application\/x-dvi": "dvi", "application\/x-envoy": "evy", "application\/x-eva": "eva", "application\/x-font-bdf": "bdf", "application\/x-font-ghostscript": "gsf", "application\/x-font-linux-psf": "psf", "application\/x-font-pcf": "pcf", "application\/x-font-snf": "snf", "application\/x-font-type1": "pfa", "application\/x-freearc": "arc", "application\/x-futuresplash": "spl", "application\/x-gca-compressed": "gca", "application\/x-glulx": "ulx", "application\/x-gnumeric": "gnumeric", "application\/x-gramps-xml": "gramps", "application\/x-gtar": "gtar", "application\/x-hdf": "hdf", "application\/x-install-instructions": "install", "application\/x-iso9660-image": "iso", "application\/x-java-jnlp-file": "jnlp", "application\/x-latex": "latex", "application\/x-lzh-compressed": "lzh", "application\/x-mie": "mie", "application\/x-mobipocket-ebook": "prc", "application\/x-ms-application": "application", "application\/x-ms-shortcut": "lnk", "application\/x-ms-wmd": "wmd", "application\/x-ms-wmz": "wmz", "application\/x-ms-xbap": "xbap", "application\/x-msaccess": "mdb", "application\/x-msbinder": "obd", "application\/x-mscardfile": "crd", "application\/x-msclip": "clp", "application\/x-msdownload": "dll", "application\/x-msmediaview": "mvb", "application\/x-msmetafile": "wmf", "application\/x-msmoney": "mny", "application\/x-mspublisher": "pub", "application\/x-msschedule": "scd", "application\/x-msterminal": "trm", "application\/x-mswrite": "wri", "application\/x-netcdf": "nc", "application\/x-nzb": "nzb", "application\/x-pkcs12": "p12", "application\/x-pkcs7-certificates": "p7b", "application\/x-pkcs7-certreqresp": "p7r", "application\/x-research-info-systems": "ris", "application\/x-shar": "shar", "application\/x-shockwave-flash": "swf", "application\/x-silverlight-app": "xap", "application\/x-sql": "sql", "application\/x-stuffit": "sit", "application\/x-stuffitx": "sitx", "application\/x-subrip": "srt", "application\/x-sv4cpio": "sv4cpio", "application\/x-sv4crc": "sv4crc", "application\/x-t3vm-image": "t3", "application\/x-tads": "gam", "application\/x-tar": "tar", "application\/x-tcl": "tcl", "application\/x-tex": "tex", "application\/x-tex-tfm": "tfm", "application\/x-texinfo": "texinfo", "application\/x-tgif": "obj", "application\/x-ustar": "ustar", "application\/x-wais-source": "src", "application\/x-x509-ca-cert": "der", "application\/x-xfig": "fig", "application\/x-xliff+xml": "xlf", "application\/x-xpinstall": "xpi", "application\/x-xz": "xz", "application\/x-zmachine": "z1", "application\/xaml+xml": "xaml", "application\/xcap-diff+xml": "xdf", "application\/xenc+xml": "xenc", "application\/xhtml+xml": "xhtml", "application\/xml": "xsl", "application\/xml-dtd": "dtd", "application\/xop+xml": "xop", "application\/xproc+xml": "xpl", "application\/xslt+xml": "xslt", "application\/xspf+xml": "xspf", "application\/xv+xml": "mxml", "application\/yang": "yang", "application\/yin+xml": "yin", "application\/zip": "zip", "audio\/adpcm": "adp", "audio\/basic": "au", "audio\/midi": "mid", "audio\/mp4": "m4a", "audio\/mpeg": "mpga", "audio\/ogg": "oga", "audio\/s3m": "s3m", "audio\/silk": "sil", "audio\/vnd.dece.audio": "uva", "audio\/vnd.digital-winds": "eol", "audio\/vnd.dra": "dra", "audio\/vnd.dts": "dts", "audio\/vnd.dts.hd": "dtshd", "audio\/vnd.lucent.voice": "lvp", "audio\/vnd.ms-playready.media.pya": "pya", "audio\/vnd.nuera.ecelp4800": "ecelp4800", "audio\/vnd.nuera.ecelp7470": "ecelp7470", "audio\/vnd.nuera.ecelp9600": "ecelp9600", "audio\/vnd.rip": "rip", "audio\/webm": "weba", "audio\/x-aac": "aac", "audio\/x-aiff": "aif", "audio\/x-caf": "caf", "audio\/x-flac": "flac", "audio\/x-matroska": "mka", "audio\/x-mpegurl": "m3u", "audio\/x-ms-wax": "wax", "audio\/x-ms-wma": "wma", "audio\/x-pn-realaudio": "ram", "audio\/x-pn-realaudio-plugin": "rmp", "audio\/xm": "xm", "chemical\/x-cdx": "cdx", "chemical\/x-cif": "cif", "chemical\/x-cmdf": "cmdf", "chemical\/x-cml": "cml", "chemical\/x-csml": "csml", "chemical\/x-xyz": "xyz", "font\/collection": "ttc", "font\/otf": "otf", "font\/ttf": "ttf", "font\/woff": "woff", "font\/woff2": "woff2", "image\/cgm": "cgm", "image\/g3fax": "g3", "image\/gif": "gif", "image\/ief": "ief", "image\/jpeg": "jpeg", "image\/ktx": "ktx", "image\/png": "png", "image\/prs.btif": "btif", "image\/sgi": "sgi", "image\/svg+xml": "svg", "image\/tiff": "tiff", "image\/vnd.adobe.photoshop": "psd", "image\/vnd.dece.graphic": "uvi", "image\/vnd.djvu": "djvu", "image\/vnd.dvb.subtitle": "sub", "image\/vnd.dwg": "dwg", "image\/vnd.dxf": "dxf", "image\/vnd.fastbidsheet": "fbs", "image\/vnd.fpx": "fpx", "image\/vnd.fst": "fst", "image\/vnd.fujixerox.edmics-mmr": "mmr", "image\/vnd.fujixerox.edmics-rlc": "rlc", "image\/vnd.ms-modi": "mdi", "image\/vnd.ms-photo": "wdp", "image\/vnd.net-fpx": "npx", "image\/vnd.wap.wbmp": "wbmp", "image\/vnd.xiff": "xif", "image\/webp": "webp", "image\/x-3ds": "3ds", "image\/x-cmu-raster": "ras", "image\/x-cmx": "cmx", "image\/x-freehand": "fh", "image\/x-icon": "ico", "image\/x-mrsid-image": "sid", "image\/x-pcx": "pcx", "image\/x-pict": "pic", "image\/x-portable-anymap": "pnm", "image\/x-portable-bitmap": "pbm", "image\/x-portable-graymap": "pgm", "image\/x-portable-pixmap": "ppm", "image\/x-rgb": "rgb", "image\/x-xpixmap": "xpm", "image\/x-xwindowdump": "xwd", "message\/rfc822": "eml", "model\/iges": "igs", "model\/mesh": "msh", "model\/vnd.collada+xml": "dae", "model\/vnd.dwf": "dwf", "model\/vnd.gdl": "gdl", "model\/vnd.gtw": "gtw", "model\/vnd.vtu": "vtu", "model\/vrml": "wrl", "model\/x3d+binary": "x3db", "model\/x3d+vrml": "x3dv", "model\/x3d+xml": "x3d", "text\/cache-manifest": "appcache", "text\/calendar": "ics", "text\/css": "css", "text\/csv": "csv", "text\/html": "html", "text\/n3": "n3", "text\/plain": "txt", "text\/prs.lines.tag": "dsc", "text\/richtext": "rtx", "text\/sgml": "sgml", "text\/tab-separated-values": "tsv", "text\/troff": "t", "text\/turtle": "ttl", "text\/uri-list": "uri", "text\/vcard": "vcard", "text\/vnd.curl": "curl", "text\/vnd.curl.dcurl": "dcurl", "text\/vnd.curl.mcurl": "mcurl", "text\/vnd.curl.scurl": "scurl", "text\/vnd.fly": "fly", "text\/vnd.fmi.flexstor": "flx", "text\/vnd.graphviz": "gv", "text\/vnd.in3d.3dml": "3dml", "text\/vnd.in3d.spot": "spot", "text\/vnd.sun.j2me.app-descriptor": "jad", "text\/vnd.wap.wml": "wml", "text\/vnd.wap.wmlscript": "wmls", "text\/x-asm": "s", "text\/x-c": "cc", "text\/x-fortran": "f", "text\/x-java-source": "java", "text\/x-nfo": "nfo", "text\/x-opml": "opml", "text\/x-pascal": "p", "text\/x-setext": "etx", "text\/x-sfv": "sfv", "text\/x-uuencode": "uu", "text\/x-vcalendar": "vcs", "text\/x-vcard": "vcf", "video\/3gpp": "3gp", "video\/3gpp2": "3g2", "video\/h261": "h261", "video\/h263": "h263", "video\/h264": "h264", "video\/jpeg": "jpgv", "video\/jpm": "jpm", "video\/mj2": "mj2", "video\/mp4": "mp4", "video\/mpeg": "mpeg", "video\/quicktime": "qt", "video\/vnd.dece.hd": "uvh", "video\/vnd.dece.mobile": "uvm", "video\/vnd.dece.pd": "uvp", "video\/vnd.dece.sd": "uvs", "video\/vnd.dece.video": "uvv", "video\/vnd.dvb.file": "dvb", "video\/vnd.fvt": "fvt", "video\/vnd.mpegurl": "mxu", "video\/vnd.ms-playready.media.pyv": "pyv", "video\/vnd.uvvu.mp4": "uvu", "video\/vnd.vivo": "viv", "video\/webm": "webm", "video\/x-f4v": "f4v", "video\/x-fli": "fli", "video\/x-flv": "flv", "video\/x-m4v": "m4v", "video\/x-matroska": "mkv", "video\/x-mng": "mng", "video\/x-ms-asf": "asf", "video\/x-ms-vob": "vob", "video\/x-ms-wmx": "wmx", "video\/x-ms-wvx": "wvx", "video\/x-msvideo": "avi", "video\/x-sgi-movie": "movie", "video\/x-smv": "smv", "x-conference\/x-cooltalk": "ice", "text\/x-sql": "sql", "image\/x-pixlr-data": "pxd", "image\/x-adobe-dng": "dng", "image\/x-sketch": "sketch", "image\/x-xcf": "xcf", "audio\/amr": "amr", "image\/vnd-ms.dds": "dds", "application\/plt": "plt", "application\/sat": "sat", "application\/step": "step", "text\/x-httpd-cgi": "cgi", "text\/x-asap": "asp", "text\/x-jsp": "jsp" };

    /*
     * File: /js/elFinder.options.js
     */

    /**
     * Default elFinder config
     *
     * @type  Object
     * @autor Dmitry (dio) Levashov
     */
    elFinder.prototype._options = {
        /**
         * URLs of 3rd party libraries CDN
         * 
         * @type Object
         */
        cdns: {
            // for editor etc.
            ace: 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.32.2',
            codemirror: 'https://cdnjs.cloudflare.com/ajax/libs/codemirror/6.65.7',
            ckeditor: 'https://cdnjs.cloudflare.com/ajax/libs/ckeditor/4.22.1', // last version of Open Source Project
            ckeditor5: 'https://cdn.ckeditor.com/ckeditor5/40.2.0',
            tinymce: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/6.8.2',
            simplemde: 'https://cdnjs.cloudflare.com/ajax/libs/simplemde/1.11.2',
            fabric: 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1',
            fabric16: 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/1.6.7',
            tui: 'https://uicdn.toast.com',
            // for quicklook etc.
            hls: 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.4.14/hls.min.js',
            dash: 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/4.7.3/dash.all.min.js',
            flv: 'https://cdnjs.cloudflare.com/ajax/libs/flv.js/1.6.2/flv.min.js',
            videojs: 'https://cdnjs.cloudflare.com/ajax/libs/video.js/8.8.0',
            prettify: 'https://cdn.jsdelivr.net/gh/google/code-prettify@e006587b4a893f0281e9dc9a53001c7ed584d4e7/loader/run_prettify.js',
            psd: 'https://cdnjs.cloudflare.com/ajax/libs/psd.js/3.4.0/psd.min.js',
            rar: 'https://cdn.jsdelivr.net/gh/nao-pon/rar.js@6cef13ec66dd67992fc7f3ea22f132d770ebaf8b/rar.min.js',
            zlibUnzip: 'https://cdn.jsdelivr.net/gh/imaya/zlib.js@0.3.1/bin/unzip.min.js', // need check unzipFiles() in quicklook.plugins.js when update
            zlibGunzip: 'https://cdn.jsdelivr.net/gh/imaya/zlib.js@0.3.1/bin/gunzip.min.js',
            bzip2: 'https://cdn.jsdelivr.net/gh/nao-pon/bzip2.js@0.8.0/bzip2.js',
            marked: 'https://cdnjs.cloudflare.com/ajax/libs/marked/11.1.0/marked.min.js',
            sparkmd5: 'https://cdnjs.cloudflare.com/ajax/libs/spark-md5/3.0.2/spark-md5.min.js',
            jssha: 'https://cdnjs.cloudflare.com/ajax/libs/jsSHA/3.3.1/sha.min.js',
            amr: 'https://cdn.jsdelivr.net/gh/yxl/opencore-amr-js@dcf3d2b5f384a1d9ded2a54e4c137a81747b222b/js/amrnb.js',
            tiff: 'https://cdn.jsdelivr.net/gh/seikichi/tiff.js@545ede3ee46b5a5bc5f06d65954e775aa2a64017/tiff.min.js'
        },

        /**
         * Connector url. Required!
         *
         * @type String
         */
        url: '',

        /**
         * Ajax request type.
         *
         * @type String
         * @default "get"
         */
        requestType: 'get',

        /**
         * Use CORS to connector url
         * 
         * @type Boolean|null  true|false|null(Auto detect)
         */
        cors: null,

        /**
         * Array of header names to return parrot out in HTTP headers received from the server
         * 
         * @type Array
         */
        parrotHeaders: [],

        /**
         * Maximum number of concurrent connections on request
         * 
         * @type Number
         * @default 3
         */
        requestMaxConn: 3,

        /**
         * Transport to send request to backend.
         * Required for future extensions using websockets/webdav etc.
         * Must be an object with "send" method.
         * transport.send must return $.Deferred() object
         *
         * @type Object
         * @default null
         * @example
         *  transport : {
         *    init : function(elfinderInstance) { },
         *    send : function(options) {
         *      var dfrd = $.Deferred();
         *      // connect to backend ...
         *      return dfrd;
         *    },
         *    upload : function(data) {
         *      var dfrd = $.Deferred();
         *      // upload ...
         *      return dfrd;
         *    }
         *    
         *  }
         **/
        transport: {},

        /**
         * URL to upload file to.
         * If not set - connector URL will be used
         *
         * @type String
         * @default  ''
         */
        urlUpload: '',

        /**
         * Allow to drag and drop to upload files
         *
         * @type Boolean|String
         * @default  'auto'
         */
        dragUploadAllow: 'auto',

        /**
         * Confirmation dialog displayed at the time of overwriting upload
         * 
         * @type Boolean
         * @default true
         */
        overwriteUploadConfirm: true,

        /**
         * Max size of chunked data of file upload
         * 
         * @type Number
         * @default  10485760(10MB)
         */
        uploadMaxChunkSize: 10485760,

        /**
         * Regular expression of file name to exclude when uploading folder
         * 
         * @type Object
         * @default { win: /^(?:desktop\.ini|thumbs\.db)$/i, mac: /^\.ds_store$/i }
         */
        folderUploadExclude: {
            win: /^(?:desktop\.ini|thumbs\.db)$/i,
            mac: /^\.ds_store$/i
        },

        /**
         * Timeout for upload using iframe
         *
         * @type Number
         * @default  0 - no timeout
         */
        iframeTimeout: 0,

        /**
         * Data to append to all requests and to upload files
         *
         * @type Object
         * @default  {}
         */
        customData: {},

        /**
         * Event listeners to bind on elFinder init
         *
         * @type Object
         * @default  {}
         */
        handlers: {},

        /**
         * Any custom headers to send across every ajax request
         *
         * @type Object
         * @default {}
         */
        customHeaders: {},

        /**
         * Any custom xhrFields to send across every ajax request
         *
         * @type Object
         * @default {}
         */
        xhrFields: {},

        /**
         * Interface language
         *
         * @type String
         * @default "en"
         */
        lang: 'en',

        /**
         * Base URL of elfFinder library starting from Manager HTML
         * Auto detect when empty value
         * 
         * @type String
         * @default ""
         */
        baseUrl: '',

        /**
         * Base URL of i18n js files
         * baseUrl + "js/i18n/" when empty value
         * 
         * @type String
         * @default ""
         */
        i18nBaseUrl: '',

        /**
         * Base URL of worker js files
         * baseUrl + "js/worker/" when empty value
         * 
         * @type String
         * @default ""
         */
        workerBaseUrl: '',

        /**
         * Auto load required CSS
         * `false` to disable this function or
         * CSS URL Array to load additional CSS files
         * 
         * @type Boolean|Array
         * @default true
         */
        cssAutoLoad: true,

        /**
         * Theme to load
         * {"themeid" : "Theme CSS URL"} or
         * {"themeid" : "Theme manifesto.json URL"} or
         * Theme manifesto.json Object
         * {
         *   "themeid" : {
         *     "name":"Theme Name",
         *     "cssurls":"Theme CSS URL",
         *     "author":"Author Name",
         *     "email":"Author Email",
         *     "license":"License",
         *     "link":"Web Site URL",
         *     "image":"Screen Shot URL",
         *     "description":"Description"
         *   }
         * }
         * 
         * @type Object
         */
        themes: {},

        /**
         * Theme id to initial theme
         * 
         * @type String|Null
         */
        theme: null,

        /**
         * Maximum value of error dialog open at the same time
         * 
         * @type Number
         */
        maxErrorDialogs: 5,

        /**
         * Additional css class for filemanager node.
         *
         * @type String
         */
        cssClass: '',

        /**
         * Active commands list. '*' means all of the commands that have been load.
         * If some required commands will be missed here, elFinder will add its
         *
         * @type Array
         */
        commands: ['*'],
        // Available commands list
        //commands : [
        //	'archive', 'back', 'chmod', 'colwidth', 'copy', 'cut', 'download', 'duplicate', 'edit', 'extract',
        //	'forward', 'fullscreen', 'getfile', 'help', 'home', 'info', 'mkdir', 'mkfile', 'netmount', 'netunmount',
        //	'open', 'opendir', 'paste', 'places', 'quicklook', 'reload', 'rename', 'resize', 'restore', 'rm',
        //	'search', 'sort', 'up', 'upload', 'view', 'zipdl'
        //],

        /**
         * Commands options.
         *
         * @type Object
         **/
        commandsOptions: {
            // // configure shortcuts of any command
            // // add `shortcuts` property into each command
            // any_command_name : {
            // 	shortcuts : [] // for disable this command's shortcuts
            // },
            // any_command_name : {
            // 	shortcuts : function(fm, shortcuts) {
            // 		// for add `CTRL + E` for this command action
            // 		shortcuts[0]['pattern'] += ' ctrl+e';
            // 		return shortcuts;
            // 	}
            // },
            // any_command_name : {
            // 	shortcuts : function(fm, shortcuts) {
            // 		// for full customize of this command's shortcuts
            // 		return [ { pattern: 'ctrl+e ctrl+down numpad_enter' + (fm.OS != 'mac' && ' enter') } ];
            // 	}
            // },
            // "getfile" command options.
            getfile: {
                onlyURL: false,
                // allow to return multiple files info
                multiple: false,
                // allow to return filers info
                folders: false,
                // action after callback (""/"close"/"destroy")
                oncomplete: '',
                // action when callback is fail (""/"close"/"destroy")
                onerror: '',
                // get path before callback call
                getPath: true,
                // get image sizes before callback call
                getImgSize: false
            },
            open: {
                // HTTP method that request to the connector when item URL is not valid URL.
                // If you set to "get" will be displayed request parameter in the browser's location field
                // so if you want to conceal its parameters should be given "post".
                // Nevertheless, please specify "get" if you want to enable the partial request by HTTP Range header.
                method: 'post',
                // Where to open into : 'window'(default), 'tab' or 'tabs'
                // 'tabs' opens in each tabs
                into: 'window',
                // Default command list of action when select file
                // String value that is 'Command Name' or 'Command Name1/CommandName2...'
                selectAction: 'open'
            },
            opennew: {
                // URL of to open elFinder manager
                // Default '' : Origin URL
                url: '',
                // Use search query of origin URL
                useOriginQuery: true
            },
            // "upload" command options.
            upload: {
                // Open elFinder upload dialog: 'button' OR Open system OS upload dialog: 'uploadbutton'
                ui: 'button'
            },
            // "download" command options.
            download: {
                // max request to download files when zipdl disabled
                maxRequests: 10,
                // minimum count of files to use zipdl
                minFilesZipdl: 2
            },
            // "quicklook" command options.
            quicklook: {
                autoplay: true,
                width: 450,
                height: 300,
                // ControlsList of HTML5 audio/video preview
                // see https://googlechrome.github.io/samples/media/controlslist.html
                mediaControlsList: '', // e.g. 'nodownload nofullscreen noremoteplayback'
                // Show toolbar of PDF preview (with <embed> tag)
                pdfToolbar: true,
                // Maximum lines to preview at initial
                textInitialLines: 100,
                // Maximum lines to preview by prettify
                prettifyMaxLines: 300,
                // quicklook window must be contained in elFinder node on window open (true|false)
                contain: false,
                // preview window into NavDock (0 : undocked | 1 : docked(show) | 2 : docked(hide))
                docked: 0,
                // Docked preview height ('auto' or Number of pixel) 'auto' is setted to the Navbar width
                dockHeight: 'auto',
                // media auto play when docked
                dockAutoplay: false,
                // Google Maps API key (Require Maps JavaScript API)
                googleMapsApiKey: '',
                // Google Maps API Options
                googleMapsOpts: {
                    maps: {},
                    kml: {
                        suppressInfoWindows: false,
                        preserveViewport: false
                    }
                },
                // ViewerJS (https://viewerjs.org/) Options
                // To enable this you need to place ViewerJS on the same server as elFinder and specify that URL in `url`.
                viewerjs: {
                    url: '', // Example '/ViewerJS/index.html'
                    mimes: ['application/pdf', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.presentation'],
                    pdfNative: true // Use Native PDF Viewer first
                },
                // MIME types to CAD-Files and 3D-Models online viewer on sharecad.org
                // Example ['image/vnd.dwg', 'image/vnd.dxf', 'model/vnd.dwf', 'application/vnd.hp-hpgl', 'application/plt', 'application/step', 'model/iges', 'application/vnd.ms-pki.stl', 'application/sat', 'image/cgm', 'application/x-msmetafile']
                sharecadMimes: [],
                // MIME types to use Google Docs online viewer
                // Example ['application/pdf', 'image/tiff', 'application/vnd.ms-office', 'application/msword', 'application/vnd.ms-word', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/postscript', 'application/rtf']
                googleDocsMimes: [],
                // MIME types to use Microsoft Office Online viewer
                // Example ['application/msword', 'application/vnd.ms-word', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.presentation']
                // These MIME types override "googleDocsMimes"
                officeOnlineMimes: [],
                // File size threshold when using the dim command for obtain the image size necessary to image preview
                getDimThreshold: '200K',
                // Max filesize to show filenames of the zip/tar/gzip/bzip file 
                unzipMaxSize: '50M',
                // MIME-Type regular expression that does not check empty files
                mimeRegexNotEmptyCheck: /^application\/vnd\.google-apps\./
            },
            // "edit" command options.
            edit: {
                // dialog width, integer(px) or integer+'%' (example: 650, '80%' ...)
                dialogWidth: void (0),
                // dialog height, integer(px) or integer+'%' (example: 650, '80%' ...)
                dialogHeight: void (0),
                // list of allowed mimetypes to edit of text files
                // if empty - any text files can be edited
                mimes: [],
                // MIME-types to unselected as default of "File types to enable with "New file"" in preferences
                mkfileHideMimes: [],
                // MIME-types of text file to make empty file
                makeTextMimes: ['text/plain', 'text/css', 'text/html'],
                // Use the editor stored in the browser
                // This value allowd overwrite with user preferences
                useStoredEditor: false,
                // Open the maximized editor window
                // This value allowd overwrite with user preferences
                editorMaximized: false,
                // edit files in wysisyg's
                editors: [
                    // {
                    // 	/**
                    // 	 * editor info
                    // 	 * @type  Object
                    // 	 */
                    // 	info : { name: 'Editor Name' },
                    // 	/**
                    // 	 * files mimetypes allowed to edit in current wysisyg
                    // 	 * @type  Array
                    // 	 */
                    // 	mimes : ['text/html'], 
                    // 	/**
                    // 	 * HTML element for editing area (optional for text editor)
                    // 	 * @type  String
                    // 	 */
                    // 	html : '<textarea></textarea>', 
                    // 	/**
                    // 	 * Initialize editing area node (optional for text editor)
                    // 	 * 
                    // 	 * @param  String  dialog DOM id
                    // 	 * @param  Object  target file object
                    // 	 * @param  String  target file content (text or Data URI Scheme(binary file))
                    // 	 * @param  Object  elFinder instance
                    // 	 * @type  Function
                    // 	 */
                    // 	init : function(id, file, content, fm) {
                    // 		$(this).attr('id', id + '-text').val(content);
                    // 	},
                    // 	/**
                    // 	 * Get edited contents (optional for text editor)
                    // 	 * @type  Function
                    // 	 */
                    // 	getContent : function() {
                    // 		return $(this).val();
                    // 	},
                    // 	/**
                    // 	 * Called when "edit" dialog loaded.
                    // 	 * Place to init wysisyg.
                    // 	 * Can return wysisyg instance
                    // 	 *
                    // 	 * @param  DOMElement  textarea node
                    // 	 * @return Object      editor instance|jQuery.Deferred(return instance on resolve())
                    // 	 */
                    // 	load : function(textarea) { },
                    // 	/**
                    // 	 * Called before "edit" dialog closed.
                    // 	 * Place to destroy wysisyg instance.
                    // 	 *
                    // 	 * @param  DOMElement  textarea node
                    // 	 * @param  Object      wysisyg instance (if was returned by "load" callback)
                    // 	 * @return void
                    // 	 */
                    // 	close : function(textarea, instance) { },
                    // 	/**
                    // 	 * Called before file content send to backend.
                    // 	 * Place to update textarea content if needed.
                    // 	 *
                    // 	 * @param  DOMElement  textarea node
                    // 	 * @param  Object      wysisyg instance (if was returned by "load" callback)
                    // 	 * @return void
                    // 	 */
                    // 	save : function(textarea, instance) {},
                    // 	/**
                    // 	 * Called after load() or save().
                    // 	 * Set focus to wysisyg editor.
                    // 	 *
                    // 	 * @param  DOMElement  textarea node
                    // 	 * @param  Object      wysisyg instance (if was returned by "load" callback)
                    // 	 * @return void
                    // 	 */
                    // 	focus : function(textarea, instance) {}
                    // 	/**
                    // 	 * Called after dialog resized..
                    // 	 *
                    // 	 * @param  DOMElement  textarea node
                    // 	 * @param  Object      wysisyg instance (if was returned by "load" callback)
                    // 	 * @param  Object      resize event object
                    // 	 * @param  Object      data object
                    // 	 * @return void
                    // 	 */
                    // 	resize : function(textarea, instance, event, data) {}
                    // 
                    // }
                ],
                // Character encodings of select box
                encodings: ['Big5', 'Big5-HKSCS', 'Cp437', 'Cp737', 'Cp775', 'Cp850', 'Cp852', 'Cp855', 'Cp857', 'Cp858',
                    'Cp862', 'Cp866', 'Cp874', 'EUC-CN', 'EUC-JP', 'EUC-KR', 'GB18030', 'ISO-2022-CN', 'ISO-2022-JP', 'ISO-2022-KR',
                    'ISO-8859-1', 'ISO-8859-2', 'ISO-8859-3', 'ISO-8859-4', 'ISO-8859-5', 'ISO-8859-6', 'ISO-8859-7',
                    'ISO-8859-8', 'ISO-8859-9', 'ISO-8859-13', 'ISO-8859-15', 'KOI8-R', 'KOI8-U', 'Shift-JIS',
                    'Windows-1250', 'Windows-1251', 'Windows-1252', 'Windows-1253', 'Windows-1254', 'Windows-1257'],
                // options for extra editors
                extraOptions: {
                    // upload command options
                    uploadOpts: {},
                    // TUI Image Editor's options
                    tuiImgEditOpts: {
                        // Path prefix of icon-a.svg, icon-b.svg, icon-c.svg and icon-d.svg in the Theme. 
                        // `iconsPath` MUST follow the same origin policy.
                        iconsPath: void (0), // default is "./img/tui-"
                        // Theme object
                        theme: {}
                    },
                    // Pixo image editor constructor options - https://pixoeditor.com/
                    // Require 'apikey' to enable it
                    pixo: {
                        apikey: ''
                    },
                    // Browsing manager URL for CKEditor, TinyMCE
                    // Uses self location with the empty value or not defined.
                    //managerUrl : 'elfinder.html'
                    managerUrl: null,
                    // CKEditor editor options
                    ckeditor: {},
                    // CKEditor 5 editor options
                    ckeditor5: {
                        // builds mode - 'classic', 'inline', 'balloon', 'balloon-block' or 'decoupled-document'
                        mode: 'decoupled-document'
                    },
                    // TinyMCE editor options
                    tinymce: {},
                    // Setting for Online-Convert.com
                    onlineConvert: {
                        maxSize: 100, // (MB) Max 100MB on free account
                        showLink: true // It must be enabled with free account
                    }
                }
            },
            fullscreen: {
                // fullscreen mode 'screen'(When the browser supports it) or 'window'
                mode: 'screen' // 'screen' or 'window'
            },
            search: {
                // Incremental search from the current view
                incsearch: {
                    enable: true, // is enable true or false
                    minlen: 1,    // minimum number of characters
                    wait: 500   // wait milliseconds
                },
                // Additional search types
                searchTypes: {
                    // "SearchMime" is implemented in default
                    SearchMime: {           // The key is search type that send to the connector
                        name: 'btnMime',    // Button text to be processed in i18n()
                        title: 'searchMime',// Button title to be processed in i18n()
                        incsearch: 'mime'   // Incremental search target filed name of the file object
                        // Or Callable function
                        /* incsearch function example
                        function(queryObject, cwdHashes, elFinderInstance) {
                            var q = queryObject.val;
                            var regex = queryObject.regex;
                            var matchedHashes = $.grep(cwdHashes, function(hash) {
                                var file = elFinderInstance.file(hash);
                                return (file && file.mime && file.mime.match(regex))? true : false;
                            });
                            return matchedHashes;
                        }
                        */
                    }
                }
            },
            // "info" command options.
            info: {
                // If the URL of the Directory is null,
                // it is assumed that the link destination is a URL to open the folder in elFinder
                nullUrlDirLinkSelf: true,
                // Information items to be hidden by default
                // These name are 'size', 'aliasfor', 'path', 'link', 'dim', 'modify', 'perms', 'locked', 'owner', 'group', 'perm' and your custom info items label
                hideItems: [],
                // Maximum file size (byte) to get file contents hash (md5, sha256 ...)
                showHashMaxsize: 104857600, // 100 MB
                // Array of hash algorisms to show on info dialog
                // These name are 'md5', 'sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'sha3-224', 'sha3-256', 'sha3-384', 'sha3-512', 'shake128' and 'shake256'
                showHashAlgorisms: ['md5', 'sha256'],
                // Options for fm.getContentsHashes()
                showHashOpts: {
                    shake128len: 256,
                    shake256len: 512
                },
                custom: {
                    // /**
                    //  * Example of custom info `desc`
                    //  */
                    // desc : {
                    // 	/**
                    // 	 * Lable (require)
                    // 	 * It is filtered by the `fm.i18n()`
                    // 	 * 
                    // 	 * @type String
                    // 	 */
                    // 	label : 'Description',
                    // 	
                    // 	/**
                    // 	 * Template (require)
                    // 	 * `{id}` is replaced in dialog.id
                    // 	 * 
                    // 	 * @type String
                    // 	 */
                    // 	tpl : '<div class="elfinder-info-desc"><span class="elfinder-spinner"></span></div>',
                    // 	
                    // 	/**
                    // 	 * Restricts to mimetypes (optional)
                    // 	 * Exact match or category match
                    // 	 * 
                    // 	 * @type Array
                    // 	 */
                    // 	mimes : ['text', 'image/jpeg', 'directory'],
                    // 	
                    // 	/**
                    // 	 * Restricts to file.hash (optional)
                    // 	 * 
                    // 	 * @ type Regex
                    // 	 */
                    // 	hashRegex : /^l\d+_/,
                    // 
                    // 	/**
                    // 	 * Request that asks for the description and sets the field (optional)
                    // 	 * 
                    // 	 * @type Function
                    // 	 */
                    // 	action : function(file, fm, dialog) {
                    // 		fm.request({
                    // 		data : { cmd : 'desc', target: file.hash },
                    // 			preventDefault: true,
                    // 		})
                    // 		.fail(function() {
                    // 			dialog.find('div.elfinder-info-desc').html(fm.i18n('unknown'));
                    // 		})
                    // 		.done(function(data) {
                    // 			dialog.find('div.elfinder-info-desc').html(data.desc);
                    // 		});
                    // 	}
                    // }
                }
            },
            mkdir: {
                // Enable automatic switching function ["New Folder" / "Into New Folder"] of toolbar buttton
                intoNewFolderToolbtn: false
            },
            resize: {
                // defalt status of snap to 8px grid of the jpeg image ("enable" or "disable")
                grid8px: 'disable',
                // Preset size array [width, height]
                presetSize: [[320, 240], [400, 400], [640, 480], [800, 600]],
                // File size (bytes) threshold when using the `dim` command for obtain the image size necessary to start editing
                getDimThreshold: 204800,
                // File size (bytes) to request to get substitute image (400px) with the `dim` command
                dimSubImgSize: 307200
            },
            rm: {
                // If trash is valid, items moves immediately to the trash holder without confirm.
                quickTrash: true,
                // Maximum wait seconds when checking the number of items to into the trash
                infoCheckWait: 10,
                // Maximum number of items that can be placed into the Trash at one time
                toTrashMaxItems: 1000
            },
            paste: {
                moveConfirm: false // Display confirmation dialog when moving items
            },
            help: {
                // Tabs to show
                view: ['about', 'shortcuts', 'help', 'integrations', 'debug'],
                // HTML source URL of the heip tab
                helpSource: ''
            },
            preference: {
                // dialog width
                width: 600,
                // dialog height
                height: 400,
                // tabs setting see preference.js : build()
                categories: null,
                // preference setting see preference.js : build()
                prefs: null,
                // language setting  see preference.js : build()
                langs: null,
                // Command list of action when select file
                // Array value are 'Command Name' or 'Command Name1/CommandName2...'
                selectActions: ['open', 'edit/download', 'resize/edit/download', 'download', 'quicklook']
            }
        },

        /**
         * Disabled commands relationship
         * 
         * @type Object
         */
        disabledCmdsRels: {
            'get': ['edit'],
            'rm': ['cut', 'empty'],
            'file&url=': ['download', 'zipdl'] // file command and volume options url is empty
        },

        /**
         * Callback for prepare boot up
         * 
         * - The this object in the function is an elFinder node
         * - The first parameter is elFinder Instance
         * - The second parameter is an object of other parameters
         *   For now it can use `dfrdsBeforeBootup` Array
         * 
         * @type Function
         * @default null
         * @return void
         */
        bootCallback: null,

        /**
         * Callback for "getfile" commands.
         * Required to use elFinder with WYSIWYG editors etc..
         *
         * @type Function
         * @default null (command not active)
         */
        getFileCallback: null,

        /**
         * Default directory view. icons/list
         *
         * @type String
         * @default "icons"
         */
        defaultView: 'icons',

        /**
         * Hash of default directory path to open
         * 
         * NOTE: This setting will be disabled if the target folder is specified in location.hash.
         * 
         * If you want to find the hash in Javascript
         * can be obtained with the following code. (In the case of a standard hashing method)
         * 
         * var volumeId = 'l1_'; // volume id
         * var path = 'path/to/target'; // without root path
         * //var path = 'path\\to\\target'; // use \ on windows server
         * var hash = volumeId + btoa(path).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '.').replace(/\.+$/, '');
         * 
         * @type String
         * @default ""
         */
        startPathHash: '',

        /**
         * Emit a sound when a file is deleted
         * Sounds are in sounds/ folder
         * 
         * @type Boolean
         * @default true
         */
        sound: true,

        /**
         * UI plugins to load.
         * Current dir ui and dialogs loads always.
         * Here set not required plugins as folders tree/toolbar/statusbar etc.
         *
         * @type Array
         * @default ['toolbar', 'places', 'tree', 'path', 'stat']
         * @full ['toolbar', 'places', 'tree', 'path', 'stat']
         */
        ui: ['toolbar', 'places', 'tree', 'path', 'stat'],

        /**
         * Some UI plugins options.
         * @type Object
         */
        uiOptions: {
            // toolbar configuration
            toolbar: [
                ['home', 'back', 'forward', 'up', 'reload'],
                ['netmount'],
                ['mkdir', 'mkfile', 'upload'],
                ['open', 'download', 'getfile'],
                ['undo', 'redo'],
                ['copy', 'cut', 'paste', 'rm', 'empty', 'hide'],
                ['duplicate', 'rename', 'edit', 'resize', 'chmod'],
                ['selectall', 'selectnone', 'selectinvert'],
                ['quicklook', 'info'],
                ['extract', 'archive'],
                ['search'],
                ['view', 'sort'],
                ['preference', 'help'],
                ['fullscreen']
            ],
            // toolbar extra options
            toolbarExtra: {
                // also displays the text label on the button (true / false / 'none')
                displayTextLabel: false,
                // Exclude `displayTextLabel` setting UA type
                labelExcludeUA: ['Mobile'],
                // auto hide on initial open
                autoHideUA: ['Mobile'],
                // Initial setting value of hide button in toolbar setting
                defaultHides: ['home', 'reload'],
                // show Preference button ('none', 'auto', 'always')
                // If you do not include 'preference' in the context menu you should specify 'auto' or 'always'
                showPreferenceButton: 'none',
                // show Preference button into contextmenu of the toolbar (true / false)
                preferenceInContextmenu: true
            },
            // directories tree options
            tree: {
                // set path info to attr title
                attrTitle: true,
                // expand current root on init
                openRootOnLoad: true,
                // expand current work directory on open
                openCwdOnOpen: true,
                // auto loading current directory parents and do expand their node.
                syncTree: true,
                // Maximum number of display of each child trees
                // The tree of directories with children exceeding this number will be split
                subTreeMax: 100,
                // Numbar of max connctions of subdirs request
                subdirsMaxConn: 2,
                // Number of max simultaneous processing directory of subdirs
                subdirsAtOnce: 5,
                // Durations of each animations
                durations: {
                    slideUpDown: 'fast',
                    autoScroll: 'fast'
                }
                // ,
                // /**
                //  * Add CSS class name to navbar directories (optional)
                //  * see: https://github.com/Studio-42/elFinder/pull/1061,
                //  *      https://github.com/Studio-42/elFinder/issues/1231
                //  * 
                //  * @type Function
                //  */
                // getClass: function(dir) {
                // 	// e.g. This adds the directory's name (lowercase) with prefix as a CSS class
                // 	return 'elfinder-tree-' + dir.name.replace(/[ "]/g, '').toLowerCase();
                // }
            },
            // navbar options
            navbar: {
                minWidth: 150,
                maxWidth: 500,
                // auto hide on initial open
                autoHideUA: [] // e.g. ['Mobile']
            },
            navdock: {
                // disabled navdock ui
                disabled: false,
                // percentage of initial maximum height to work zone
                initMaxHeight: '50%',
                // percentage of maximum height to work zone by user resize action
                maxHeight: '90%'
            },
            cwd: {
                // display parent folder with ".." name :)
                oldSchool: false,

                // fm.UA types array to show item select checkboxes e.g. ['All'] or ['Mobile'] etc. default: ['Touch']
                showSelectCheckboxUA: ['Touch'],

                // Enable dragout by dragstart with Alt key or Shift key
                metakeyDragout: true,

                // file info columns displayed
                listView: {
                    // name is always displayed, cols are ordered
                    // e.g. ['perm', 'date', 'size', 'kind', 'owner', 'group', 'mode']
                    // mode: 'mode'(by `fileModeStyle` setting), 'modestr'(rwxr-xr-x) , 'modeoct'(755), 'modeboth'(rwxr-xr-x (755))
                    // 'owner', 'group' and 'mode', It's necessary set volume driver option "statOwner" to `true`
                    // for custom, characters that can be used in the name is `a-z0-9_`
                    columns: ['perm', 'date', 'size', 'kind'],
                    // override this if you want custom columns name
                    // example
                    // columnsCustomName : {
                    //		date : 'Last modification',
                    // 		kind : 'Mime type'
                    // }
                    columnsCustomName: {},
                    // fixed list header colmun
                    fixedHeader: true
                },

                // icons view setting
                iconsView: {
                    // default icon size (0-3 in default CSS (cwd.css - elfinder-cwd-size[number]))
                    size: 0,
                    // number of maximum size (3 in default CSS (cwd.css - elfinder-cwd-size[number]))
                    // uses in preference.js
                    sizeMax: 3,
                    // Name of each size
                    sizeNames: {
                        0: 'viewSmall',
                        1: 'viewMedium',
                        2: 'viewLarge',
                        3: 'viewExtraLarge'
                    }
                },

                // /**
                //  * Add CSS class name to cwd directories (optional)
                //  * see: https://github.com/Studio-42/elFinder/pull/1061,
                //  *      https://github.com/Studio-42/elFinder/issues/1231
                //  * 
                //  * @type Function
                //  */
                // ,
                // getClass: function(file) {
                // 	// e.g. This adds the directory's name (lowercase) with prefix as a CSS class
                // 	return 'elfinder-cwd-' + file.name.replace(/[ "]/g, '').toLowerCase();
                //}

                //,
                //// Template placeholders replacement rules for overwrite. see ui/cwd.js replacement
                //replacement : {
                //	tooltip : function(f, fm) {
                //		var list = fm.viewType == 'list', // current view type
                //			query = fm.searchStatus.state == 2, // is in search results
                //			title = fm.formatDate(f) + (f.size > 0 ? ' ('+fm.formatSize(f.size)+')' : ''),
                //			info  = '';
                //		if (query && f.path) {
                //			info = fm.escape(f.path.replace(/\/[^\/]*$/, ''));
                //		} else {
                //			info = f.tooltip? fm.escape(f.tooltip).replace(/\r/g, '&#13;') : '';
                //		}
                //		if (list) {
                //			info += (info? '&#13;' : '') + fm.escape(f.name);
                //		}
                //		return info? info + '&#13;' + title : title;
                //	}
                //}
            },
            path: {
                // Move to head of work zone without UI navbar
                toWorkzoneWithoutNavbar: true
            },
            dialog: {
                // Enable to auto focusing on mouse over in the target form element
                focusOnMouseOver: true
            },
            toast: {
                animate: {
                    // to show
                    showMethod: 'fadeIn', // fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,    // milliseconds
                    showEasing: 'swing',  // swing and linear are built into jQuery
                    // timeout to hide
                    timeOut: 3000,
                    // to hide
                    hideMethod: 'fadeOut',
                    hideDuration: 1500,
                    hideEasing: 'swing'
                }
            }
        },

        /**
         * MIME regex of send HTTP header "Content-Disposition: inline" or allow preview in quicklook
         * This option will overwrite by connector configuration
         * 
         * @type String
         * @default '^(?:(?:image|video|audio)|text/plain|application/pdf$)'
         * @example
         *  dispInlineRegex : '.',  // is allow inline of all of MIME types
         *  dispInlineRegex : '$^', // is not allow inline of all of MIME types
         */
        dispInlineRegex: '^(?:(?:image|video|audio)|application/(?:x-mpegURL|dash\+xml)|(?:text/plain|application/pdf)$)',

        /**
         * Display only required files by types
         *
         * @type Array
         * @default []
         * @example
         *  onlyMimes : ["image"] - display all images
         *  onlyMimes : ["image/png", "application/x-shockwave-flash"] - display png and flash
         */
        onlyMimes: [],

        /**
         * Custom files sort rules.
         * All default rules (name/size/kind/date/perm/mode/owner/group) set in elFinder._sortRules
         *
         * @type {Object}
         * @example
         * sortRules : {
         *   name : function(file1, file2) { return file1.name.toLowerCase().localeCompare(file2.name.toLowerCase()); }
         * }
         */
        sortRules: {},

        /**
         * Default sort type.
         *
         * @type {String}
         */
        sortType: 'name',

        /**
         * Default sort order.
         *
         * @type {String}
         * @default "asc"
         */
        sortOrder: 'asc',

        /**
         * Display folders first?
         *
         * @type {Boolean}
         * @default true
         */
        sortStickFolders: true,

        /**
         * Sort also applies to the treeview (null: disable this feature)
         *
         * @type Boolean|null
         * @default false
         */
        sortAlsoTreeview: false,

        /**
         * If true - elFinder will formating dates itself, 
         * otherwise - backend date will be used.
         *
         * @type Boolean
         */
        clientFormatDate: true,

        /**
         * Show UTC dates.
         * Required set clientFormatDate to true
         *
         * @type Boolean
         */
        UTCDate: false,

        /**
         * File modification datetime format.
         * Value from selected language data  is used by default.
         * Set format here to overwrite it.
         *
         * @type String
         * @default  ""
         */
        dateFormat: '',

        /**
         * File modification datetime format in form "Yesterday 12:23:01".
         * Value from selected language data is used by default.
         * Set format here to overwrite it.
         * Use $1 for "Today"/"Yesterday" placeholder
         *
         * @type String
         * @default  ""
         * @example "$1 H:m:i"
         */
        fancyDateFormat: '',

        /**
         * Style of file mode at cwd-list, info dialog
         * 'string' (ex. rwxr-xr-x) or 'octal' (ex. 755) or 'both' (ex. rwxr-xr-x (755))
         * 
         * @type {String}
         * @default 'both'
         */
        fileModeStyle: 'both',

        /**
         * elFinder width
         *
         * @type String|Number
         * @default  "auto"
         */
        width: 'auto',

        /**
         * elFinder node height
         * Number: pixcel or String: Number + "%"
         *
         * @type Number | String
         * @default  400
         */
        height: 400,

        /**
         * Do not resize the elFinder node itself on resize parent node
         * Specify `true` when controlling with CSS such as Flexbox
         *
         * @type Boolean
         * @default false
         */
        noResizeBySelf: false,

        /**
         * Base node object or selector
         * Element which is the reference of the height percentage
         *
         * @type Object|String
         * @default null | $(window) (if height is percentage)
         **/
        heightBase: null,

        /**
         * Make elFinder resizable if jquery ui resizable available
         *
         * @type Boolean
         * @default  true
         */
        resizable: true,

        /**
         * Timeout before open notifications dialogs
         *
         * @type Number
         * @default  500 (.5 sec)
         */
        notifyDelay: 500,

        /**
         * Position CSS, Width of notifications dialogs
         *
         * @type Object
         * @default {position: {}, width : null} - Apply CSS definition
         * position: CSS object | null (null: position center & middle)
         */
        notifyDialog: { position: {}, width: null, canClose: false, hiddens: ['open'] },

        /**
         * Dialog contained in the elFinder node
         * 
         * @type Boolean
         * @default false
         */
        dialogContained: false,

        /**
         * Allow shortcuts
         *
         * @type Boolean
         * @default  true
         */
        allowShortcuts: true,

        /**
         * Remeber last opened dir to open it after reload or in next session
         *
         * @type Boolean
         * @default  true
         */
        rememberLastDir: true,

        /**
         * Clear historys(elFinder) on reload(not browser) function
         * Historys was cleared on Reload function on elFinder 2.0 (value is true)
         * 
         * @type Boolean
         * @default  false
         */
        reloadClearHistory: false,

        /**
         * Use browser native history with supported browsers
         *
         * @type Boolean
         * @default  true
         */
        useBrowserHistory: true,

        /**
         * Lazy load config.
         * How many files display at once?
         *
         * @type Number
         * @default  50
         */
        showFiles: 50,

        /**
         * Lazy load config.
         * Distance in px to cwd bottom edge to start display files
         *
         * @type Number
         * @default  50
         */
        showThreshold: 50,

        /**
         * Additional rule to valid new file name.
         * By default not allowed empty names or '..'
         * This setting does not have a sense of security.
         *
         * @type false|RegExp|function
         * @default  false
         * @example
         *  disable names with spaces:
         *  validName : /^[^\s]+$/,
         */
        validName: false,

        /**
         * Additional rule to filtering for browsing.
         * This setting does not have a sense of security.
         * 
         * The object `this` is elFinder instance object in this function
         *
         * @type false|RegExp|function
         * @default  false
         * @example
         *  show only png and jpg files:
         *  fileFilter : /.*\.(png|jpg)$/i,
         *  
         *  show only image type files:
         *  fileFilter : function(file) { return file.mime && file.mime.match(/^image\//i); },
         */
        fileFilter: false,

        /**
         * Backup name suffix.
         *
         * @type String
         * @default  "~"
         */
        backupSuffix: '~',

        /**
         * Sync content interval
         *
         * @type Number
         * @default  0 (do not sync)
         */
        sync: 0,

        /**
         * Sync start on load if sync value >= 1000
         *
         * @type     Bool
         * @default  true
         */
        syncStart: true,

        /**
         * How many thumbnails create in one request
         *
         * @type Number
         * @default  5
         */
        loadTmbs: 5,

        /**
         * Cookie option for browsersdoes not suppot localStorage
         *
         * @type Object
         */
        cookie: {
            expires: 30,
            domain: '',
            path: '/',
            secure: false,
            samesite: 'lax'
        },

        /**
         * Contextmenu config
         *
         * @type Object
         */
        contextmenu: {
            // navbarfolder menu
            navbar: ['open', 'opennew', 'download', '|', 'upload', 'mkdir', '|', 'copy', 'cut', 'paste', 'duplicate', '|', 'rm', 'empty', 'hide', '|', 'rename', '|', 'archive', '|', 'places', 'info', 'chmod', 'netunmount'],
            // current directory menu
            cwd: ['undo', 'redo', '|', 'back', 'up', 'reload', '|', 'upload', 'mkdir', 'mkfile', 'paste', '|', 'empty', 'hide', '|', 'view', 'sort', 'selectall', 'colwidth', '|', 'places', 'info', 'chmod', 'netunmount', '|', 'fullscreen', '|', 'preference'],
            // current directory file menu
            files: ['getfile', '|', 'open', 'opennew', 'download', 'opendir', 'quicklook', '|', 'upload', 'mkdir', '|', 'copy', 'cut', 'paste', 'duplicate', '|', 'rm', 'empty', 'hide', '|', 'rename', 'edit', 'resize', '|', 'archive', 'extract', '|', 'selectall', 'selectinvert', '|', 'places', 'info', 'chmod', 'netunmount']
        },

        /**
         * elFinder node enable always
         * This value will set to `true` if <body> has elFinder node only
         * 
         * @type     Bool
         * @default  false
         */
        enableAlways: false,

        /**
         * elFinder node enable by mouse over
         * 
         * @type     Bool
         * @default  true
         */
        enableByMouseOver: true,

        /**
         * Show window close confirm dialog
         * Value is which state to show
         * 'hasNotifyDialog', 'editingFile', 'hasSelectedItem' and 'hasClipboardData'
         * 
         * @type     Array
         * @default  ['hasNotifyDialog', 'editingFile']
         */
        windowCloseConfirm: ['hasNotifyDialog', 'editingFile'],

        /**
         * Function decoding 'raw' string converted to unicode
         * It is used instead of fm.decodeRawString(str)
         * 
         * @type Null|Function
         */
        rawStringDecoder: typeof Encoding === 'object' && typeof Encoding.convert === 'function' ? function (str) {
            return Encoding.convert(str, {
                to: 'UNICODE',
                type: 'string'
            });
        } : null,

        /**
         * Debug config
         *
         * @type Array|String('auto')|Boolean(true|false)
         */
        debug: ['error', 'warning', 'event-destroy'],

        /**
         * Show toast messeges of backend warning (if found data `debug.backendErrors` in backend results)
         *
         * @type Boolean|Object (toast options)
         */
        toastBackendWarn: true
    };


    /*
     * File: /js/elFinder.options.netmount.js
     */

    /**
     * Default elFinder config of commandsOptions.netmount
     *
     * @type  Object
     */

    elFinder.prototype._options.commandsOptions.netmount = {
        ftp: {
            name: 'FTP',
            inputs: {
                host: $('<input type="text"/>'),
                port: $('<input type="number" placeholder="21" class="elfinder-input-optional"/>'),
                path: $('<input type="text" value="/"/>'),
                user: $('<input type="text"/>'),
                pass: $('<input type="password" autocomplete="new-password"/>'),
                FTPS: $('<input type="checkbox" value="1" title="File Transfer Protocol over SSL/TLS"/>'),
                encoding: $('<input type="text" placeholder="Optional" class="elfinder-input-optional"/>'),
                locale: $('<input type="text" placeholder="Optional" class="elfinder-input-optional"/>')
            }
        },
        dropbox2: elFinder.prototype.makeNetmountOptionOauth('dropbox2', 'Dropbox', 'Dropbox', {
            noOffline: true,
            root: '/',
            pathI18n: 'path',
            integrate: {
                title: 'Dropbox.com',
                link: 'https://www.dropbox.com'
            }
        }),
        googledrive: elFinder.prototype.makeNetmountOptionOauth('googledrive', 'Google Drive', 'Google', {
            integrate: {
                title: 'Google Drive',
                link: 'https://www.google.com/drive/'
            }
        }),
        onedrive: elFinder.prototype.makeNetmountOptionOauth('onedrive', 'One Drive', 'OneDrive', {
            integrate: {
                title: 'Microsoft OneDrive',
                link: 'https://onedrive.live.com'
            }
        }),
        box: elFinder.prototype.makeNetmountOptionOauth('box', 'Box', 'Box', {
            noOffline: true,
            integrate: {
                title: 'Box.com',
                link: 'https://www.box.com'
            }
        })
    };


    /*
     * File: /js/elFinder.history.js
     */

    /**
     * @class elFinder.history
     * Store visited folders
     * and provide "back" and "forward" methods
     *
     * @author Dmitry (dio) Levashov
     */
    elFinder.prototype.history = function (fm) {
        var self = this,
            /**
             * Update history on "open" event?
             *
             * @type Boolean
             */
            update = true,
            /**
             * Directories hashes storage
             *
             * @type Array
             */
            history = [],
            /**
             * Current directory index in history
             *
             * @type Number
             */
            current,
            /**
             * Clear history
             *
             * @return void
             */
            reset = function () {
                history = [fm.cwd().hash];
                current = 0;
                update = true;
            },
            /**
             * Browser native history object
             */
            nativeHistory = (fm.options.useBrowserHistory && window.history && window.history.pushState) ? window.history : null,
            /**
             * Open prev/next folder
             *
             * @Boolen  open next folder?
             * @return jQuery.Deferred
             */
            go = function (fwd) {
                if ((fwd && self.canForward()) || (!fwd && self.canBack())) {
                    update = false;
                    return fm.exec('open', history[fwd ? ++current : --current]).fail(reset);
                }
                return $.Deferred().reject();
            },
            /**
             * Sets the native history.
             *
             * @param String thash target hash
             */
            setNativeHistory = function (thash) {
                if (nativeHistory && (!nativeHistory.state || nativeHistory.state.thash !== thash)) {
                    nativeHistory.pushState({ thash: thash }, null, location.pathname + location.search + (thash ? '#elf_' + thash : ''));
                }
            };

        /**
         * Return true if there is previous visited directories
         *
         * @return Boolen
         */
        this.canBack = function () {
            return current > 0;
        };

        /**
         * Return true if can go forward
         *
         * @return Boolen
         */
        this.canForward = function () {
            return current < history.length - 1;
        };

        /**
         * Go back
         *
         * @return void
         */
        this.back = go;

        /**
         * Go forward
         *
         * @return void
         */
        this.forward = function () {
            return go(true);
        };

        // bind to elfinder events
        fm.bind('init', function () {
            if (nativeHistory && !nativeHistory.state) {
                setNativeHistory(fm.startDir());
            }
        })
            .open(function () {
                var l = history.length,
                    cwd = fm.cwd().hash;

                if (update) {
                    current >= 0 && l > current + 1 && history.splice(current + 1);
                    history[history.length - 1] != cwd && history.push(cwd);
                    current = history.length - 1;
                }
                update = true;

                setNativeHistory(cwd);
            })
            .reload(fm.options.reloadClearHistory && reset);

    };


    /*
     * File: /js/elFinder.command.js
     */

    /**
     * elFinder command prototype
     *
     * @type  elFinder.command
     * @author  Dmitry (dio) Levashov
     */
    elFinder.prototype.command = function (fm) {
        /**
     * elFinder instance
     *
     * @type  elFinder
     */
        this.fm = fm;

        /**
         * Command name, same as class name
         *
         * @type  String
         */
        this.name = '';

        /**
         * Dialog class name
         *
         * @type  String
         */
        this.dialogClass = '';

        /**
         * Command icon class name with out 'elfinder-button-icon-'
         * Use this.name if it is empty
         *
         * @type  String
         */
        this.className = '';

        /**
         * Short command description
         *
         * @type  String
         */
        this.title = '';

        /**
         * Linked(Child) commands name
         * They are loaded together when tthis command is loaded.
         * 
         * @type  Array
         */
        this.linkedCmds = [];

        /**
         * Current command state
         *
         * @example
         * this.state = -1; // command disabled
         * this.state = 0;  // command enabled
         * this.state = 1;  // command active (for example "fullscreen" command while elfinder in fullscreen mode)
         * @default -1
         * @type  Number
         */
        this.state = -1;

        /**
         * If true, command can not be disabled by connector.
         * @see this.update()
         *
         * @type  Boolen
         */
        this.alwaysEnabled = false;

        /**
         * Do not change dirctory on removed current work directory
         * 
         * @type  Boolen
         */
        this.noChangeDirOnRemovedCwd = false;

        /**
         * If true, this means command was disabled by connector.
         * @see this.update()
         *
         * @type  Boolen
         */
        this._disabled = false;

        /**
         * If true, this command is disabled on serach results
         * 
         * @type  Boolean
         */
        this.disableOnSearch = false;

        /**
         * Call update() when event select fired
         * 
         * @type  Boolean
         */
        this.updateOnSelect = true;

        /**
         * Sync toolbar button title on change
         * 
         * @type  Boolean
         */
        this.syncTitleOnChange = false;

        /**
         * Keep display of the context menu when command execution
         * 
         * @type  Boolean
         */
        this.keepContextmenu = false;

        /**
         * elFinder events defaults handlers.
         * Inside handlers "this" is current command object
         *
         * @type  Object
         */
        this._handlers = {
            enable: function () { this.update(void (0), this.value); },
            disable: function () { this.update(-1, this.value); },
            'open reload load sync': function () {
                this._disabled = !(this.alwaysEnabled || this.fm.isCommandEnabled(this.name));
                this.update(void (0), this.value);
                this.change();
            }
        };

        /**
         * elFinder events handlers.
         * Inside handlers "this" is current command object
         *
         * @type  Object
         */
        this.handlers = {};

        /**
         * Shortcuts
         *
         * @type  Array
         */
        this.shortcuts = [];

        /**
         * Command options
         *
         * @type  Object
         */
        this.options = { ui: 'button' };

        /**
         * Callback functions on `change` event
         * 
         * @type  Array
         */
        this.listeners = [];

        /**
         * Prepare object -
         * bind events and shortcuts
         *
         * @return void
         */
        this.setup = function (name, opts) {
            var self = this,
                fm = this.fm,
                setCallback = function (s) {
                    var cb = s.callback || function (e) {
                        fm.exec(self.name, void (0), {
                            _userAction: true,
                            _currentType: 'shortcut'
                        });
                    };
                    s.callback = function (e) {
                        var enabled, checks = {};
                        if (self.enabled()) {
                            if (fm.searchStatus.state < 2) {
                                enabled = fm.isCommandEnabled(self.name);
                            } else {
                                $.each(fm.selected(), function (i, h) {
                                    if (fm.optionsByHashes[h]) {
                                        checks[h] = true;
                                    } else {
                                        $.each(fm.volOptions, function (id) {
                                            if (!checks[id] && h.indexOf(id) === 0) {
                                                checks[id] = true;
                                                return false;
                                            }
                                        });
                                    }
                                });
                                $.each(checks, function (h) {
                                    enabled = fm.isCommandEnabled(self.name, h);
                                    if (!enabled) {
                                        return false;
                                    }
                                });
                            }
                            if (enabled) {
                                self.event = e;
                                cb.call(self);
                                delete self.event;
                            }
                        }
                    };
                },
                i, s, sc;

            this.name = name;
            this.title = fm.messages['cmd' + name] ? fm.i18n('cmd' + name)
                : ((this.extendsCmd && fm.messages['cmd' + this.extendsCmd]) ? fm.i18n('cmd' + this.extendsCmd) : name);
            this.options = Object.assign({}, this.options, opts);
            this.listeners = [];
            this.dialogClass = 'elfinder-dialog-' + name;

            if (opts.shortcuts) {
                if (typeof opts.shortcuts === 'function') {
                    sc = opts.shortcuts(this.fm, this.shortcuts);
                } else if (Array.isArray(opts.shortcuts)) {
                    sc = opts.shortcuts;
                }
                this.shortcuts = sc || [];
            }

            if (this.updateOnSelect) {
                this._handlers.select = function () { this.update(void (0), this.value); };
            }

            $.each(Object.assign({}, self._handlers, self.handlers), function (cmd, handler) {
                fm.bind(cmd, $.proxy(handler, self));
            });

            for (i = 0; i < this.shortcuts.length; i++) {
                s = this.shortcuts[i];
                setCallback(s);
                !s.description && (s.description = this.title);
                fm.shortcut(s);
            }

            if (this.disableOnSearch) {
                fm.bind('search searchend', function () {
                    self._disabled = this.type === 'search' ? true : !(this.alwaysEnabled || fm.isCommandEnabled(name));
                    self.update(void (0), self.value);
                });
            }

            this.init();
        };

        /**
         * Command specific init stuffs
         *
         * @return void
         */
        this.init = function () { };

        /**
         * Exec command
         *
         * @param  Array         target files hashes
         * @param  Array|Object  command value
         * @return $.Deferred
         */
        this.exec = function (files, opts) {
            return $.Deferred().reject();
        };

        this.getUndo = function (opts, resData) {
            return false;
        };

        /**
         * Return true if command disabled.
         *
         * @return Boolen
         */
        this.disabled = function () {
            return this.state < 0;
        };

        /**
         * Return true if command enabled.
         *
         * @return Boolen
         */
        this.enabled = function () {
            return this.state > -1;
        };

        /**
         * Return true if command active.
         *
         * @return Boolen
         */
        this.active = function () {
            return this.state > 0;
        };

        /**
         * Return current command state.
         * Must be overloaded in most commands
         *
         * @return Number
         */
        this.getstate = function () {
            return -1;
        };

        /**
         * Update command state/value
         * and rize 'change' event if smth changed
         *
         * @param  Number  new state or undefined to auto update state
         * @param  mixed   new value
         * @return void
         */
        this.update = function (s, v) {
            var state = this.state,
                value = this.value;

            if (this._disabled && this.fm.searchStatus === 0) {
                this.state = -1;
            } else {
                this.state = s !== void (0) ? s : this.getstate();
            }

            this.value = v;

            if (state != this.state || value != this.value) {
                this.change();
            }
        };

        /**
         * Bind handler / fire 'change' event.
         *
         * @param  Function|undefined  event callback
         * @return void
         */
        this.change = function (c) {
            var cmd, i;

            if (typeof (c) === 'function') {
                this.listeners.push(c);
            } else {
                for (i = 0; i < this.listeners.length; i++) {
                    cmd = this.listeners[i];
                    try {
                        cmd(this.state, this.value);
                    } catch (e) {
                        this.fm.debug('error', e);
                    }
                }
            }
            return this;
        };


        /**
         * With argument check given files hashes and return list of existed files hashes.
         * Without argument return selected files hashes.
         *
         * @param  Array|String|void  hashes
         * @return Array
         */
        this.hashes = function (hashes) {
            return hashes
                ? $.grep(Array.isArray(hashes) ? hashes : [hashes], function (hash) { return fm.file(hash) ? true : false; })
                : fm.selected();
        };

        /**
         * Return only existed files from given fils hashes | selected files
         *
         * @param  Array|String|void  hashes
         * @return Array
         */
        this.files = function (hashes) {
            var fm = this.fm;

            return hashes
                ? $.map(Array.isArray(hashes) ? hashes : [hashes], function (hash) { return fm.file(hash) || null; })
                : fm.selectedFiles();
        };

        /**
         * Wrapper to fm.dialog()
         *
         * @param  String|DOMElement  content
         * @param  Object             options
         * @return Object             jQuery element object
         */
        this.fmDialog = function (content, options) {
            if (options.cssClass) {
                options.cssClass += ' ' + this.dialogClass;
            } else {
                options.cssClass = this.dialogClass;
            }
            return this.fm.dialog(content, options);
        };
    };


    /*
     * File: /js/elFinder.resources.js
     */

    /**
     * elFinder resources registry.
     * Store shared data
     *
     * @type Object
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.resources = {
        'class': {
            hover: 'ui-state-hover',
            active: 'ui-state-active',
            disabled: 'ui-state-disabled',
            draggable: 'ui-draggable',
            droppable: 'ui-droppable',
            adroppable: 'elfinder-droppable-active',
            cwdfile: 'elfinder-cwd-file',
            cwd: 'elfinder-cwd',
            tree: 'elfinder-tree',
            treeroot: 'elfinder-navbar-root',
            navdir: 'elfinder-navbar-dir',
            navdirwrap: 'elfinder-navbar-dir-wrapper',
            navarrow: 'elfinder-navbar-arrow',
            navsubtree: 'elfinder-navbar-subtree',
            navcollapse: 'elfinder-navbar-collapsed',
            navexpand: 'elfinder-navbar-expanded',
            treedir: 'elfinder-tree-dir',
            placedir: 'elfinder-place-dir',
            searchbtn: 'elfinder-button-search',
            editing: 'elfinder-to-editing',
            preventback: 'elfinder-prevent-back',
            tabstab: 'ui-state-default ui-tabs-tab ui-corner-top ui-tab',
            tabsactive: 'ui-tabs-active ui-state-active'
        },
        tpl: {
            perms: '<span class="elfinder-perms"></span>',
            lock: '<span class="elfinder-lock"></span>',
            symlink: '<span class="elfinder-symlink"></span>',
            navicon: '<span class="elfinder-nav-icon"></span>',
            navspinner: '<span class="elfinder-spinner elfinder-navbar-spinner"></span>',
            navdir: '<div class="elfinder-navbar-wrapper{root}"><span id="{id}" class="ui-corner-all elfinder-navbar-dir {cssclass}"{title}><span class="elfinder-navbar-arrow"></span><span class="elfinder-navbar-icon" {style}></span>{symlink}{permissions}{name}</span><div class="elfinder-navbar-subtree" style="display:none"></div></div>',
            placedir: '<div class="elfinder-navbar-wrapper"><span id="{id}" class="ui-corner-all elfinder-navbar-dir {cssclass}"{title}><span class="elfinder-navbar-arrow"></span><span class="elfinder-navbar-icon" {style}></span>{symlink}{permissions}{name}</span><div class="elfinder-navbar-subtree" style="display:none"></div></div>'

        },
        // mimes.text will be overwritten with connector config if `textMimes` is included in initial response
        // @see php/elFInder.class.php `public static $textMimes`
        mimes: {
            text: [
                'application/dash+xml',
                'application/docbook+xml',
                'application/javascript',
                'application/json',
                'application/plt',
                'application/sat',
                'application/sql',
                'application/step',
                'application/vnd.hp-hpgl',
                'application/x-awk',
                'application/x-config',
                'application/x-csh',
                'application/x-empty',
                'application/x-mpegurl',
                'application/x-perl',
                'application/x-php',
                'application/x-web-config',
                'application/xhtml+xml',
                'application/xml',
                'audio/x-mp3-playlist',
                'image/cgm',
                'image/svg+xml',
                'image/vnd.dxf',
                'model/iges'
            ]
        },

        mixin: {
            make: function () {
                var self = this,
                    fm = this.fm,
                    cmd = this.name,
                    req = this.requestCmd || cmd,
                    wz = fm.getUI('workzone'),
                    org = (this.origin && this.origin === 'navbar') ? 'tree' : 'cwd',
                    tree = (org === 'tree'),
                    find = tree ? 'navHash2Elm' : 'cwdHash2Elm',
                    tarea = (!tree && fm.storage('view') != 'list'),
                    sel = fm.selected(),
                    move = this.move || false,
                    empty = wz.hasClass('elfinder-cwd-wrapper-empty'),
                    unselect = function () {
                        requestAnimationFrame(function () {
                            input && input.trigger('blur');
                        });
                    },
                    rest = function () {
                        if (!overlay.is(':hidden')) {
                            overlay.elfinderoverlay('hide').off('click close', cancel);
                        }
                        if (nnode) {
                            pnode.removeClass('ui-front')
                                .css('position', '')
                                .off('unselect.' + fm.namespace, unselect);
                            if (tarea) {
                                nnode && nnode.css('max-height', '');
                            } else if (!tree) {
                                pnode.css('width', '')
                                    .parent('td').css('overflow', '');
                            }
                        }
                    }, colwidth,
                    dfrd = $.Deferred()
                        .fail(function (error) {
                            dstCls && dst.attr('class', dstCls);
                            empty && wz.addClass('elfinder-cwd-wrapper-empty');
                            if (sel) {
                                move && fm.trigger('unlockfiles', { files: sel });
                                fm.clipboard([]);
                                fm.trigger('selectfiles', { files: sel });
                            }
                            error && fm.error(error);
                        })
                        .always(function () {
                            rest();
                            cleanup();
                            fm.enable().unbind('open', openCallback).trigger('resMixinMake');
                        }),
                    id = 'tmp_' + parseInt(Math.random() * 100000),
                    phash = this.data && this.data.target ? this.data.target : (tree ? fm.file(sel[0]).hash : fm.cwd().hash),
                    date = new Date(),
                    file = {
                        hash: id,
                        phash: phash,
                        name: fm.uniqueName(this.prefix, phash),
                        mime: this.mime,
                        read: true,
                        write: true,
                        date: 'Today ' + date.getHours() + ':' + date.getMinutes(),
                        move: move
                    },
                    dum = fm.getUI(org).trigger('create.' + fm.namespace, file),
                    data = this.data || {},
                    node = fm[find](id),
                    nnode, pnode,
                    overlay = fm.getUI('overlay'),
                    cleanup = function () {
                        if (node && node.length) {
                            input.off();
                            node.hide();
                            fm.unselectfiles({ files: [id] }).unbind('resize', resize);
                            requestAnimationFrame(function () {
                                if (tree) {
                                    node.closest('.elfinder-navbar-wrapper').remove();
                                } else {
                                    node.remove();
                                }
                            });
                        }
                    },
                    cancel = function (e) {
                        if (!overlay.is(':hidden')) {
                            pnode.css('z-index', '');
                        }
                        if (!inError) {
                            cleanup();
                            dfrd.reject();
                            if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }
                    },
                    input = $(tarea ? '<textarea></textarea>' : '<input type="text"/>')
                        .on('keyup text', function () {
                            if (tarea) {
                                this.style.height = '1px';
                                this.style.height = this.scrollHeight + 'px';
                            } else if (colwidth) {
                                this.style.width = colwidth + 'px';
                                if (this.scrollWidth > colwidth) {
                                    this.style.width = this.scrollWidth + 10 + 'px';
                                }
                            }
                        })
                        .on('keydown', function (e) {
                            e.stopImmediatePropagation();
                            if (e.keyCode == $.ui.keyCode.ESCAPE) {
                                dfrd.reject();
                            } else if (e.keyCode == $.ui.keyCode.ENTER) {
                                e.preventDefault();
                                input.trigger('blur');
                            }
                        })
                        .on('mousedown click dblclick', function (e) {
                            e.stopPropagation();
                            if (e.type === 'dblclick') {
                                e.preventDefault();
                            }
                        })
                        .on('blur', function () {
                            var name = $.trim(input.val()),
                                parent = input.parent(),
                                valid = true,
                                cut;

                            if (!overlay.is(':hidden')) {
                                pnode.css('z-index', '');
                            }
                            if (name === '') {
                                return cancel();
                            }
                            if (!inError && parent.length) {

                                if (fm.options.validName && fm.options.validName.test) {
                                    try {
                                        valid = fm.options.validName.test(name);
                                    } catch (e) {
                                        valid = false;
                                    }
                                }
                                if (!name || name === '.' || name === '..' || !valid) {
                                    inError = true;
                                    fm.error(file.mime === 'directory' ? 'errInvDirname' : 'errInvName', { modal: true, close: function () { setTimeout(select, 120); } });
                                    return false;
                                }
                                if (fm.fileByName(name, phash)) {
                                    inError = true;
                                    fm.error(['errExists', name], { modal: true, close: function () { setTimeout(select, 120); } });
                                    return false;
                                }

                                cut = (sel && move) ? fm.exec('cut', sel) : null;

                                $.when(cut)
                                    .done(function () {
                                        var toast = {},
                                            nextAct = {};

                                        rest();
                                        input.hide().before($('<span>').text(name));

                                        fm.lockfiles({ files: [id] });

                                        fm.request({
                                            data: Object.assign({ cmd: req, name: name, target: phash }, data || {}),
                                            notify: { type: req, cnt: 1 },
                                            preventFail: true,
                                            syncOnFail: true,
                                            navigate: { toast: toast },
                                        })
                                            .fail(function (error) {
                                                fm.unlockfiles({ files: [id] });
                                                inError = true;
                                                input.show().prev().remove();
                                                fm.error(error, {
                                                    modal: true,
                                                    close: function () {
                                                        if (Array.isArray(error) && $.inArray('errUploadMime', error) !== -1) {
                                                            dfrd.notify('errUploadMime').reject();
                                                        } else {
                                                            setTimeout(select, 120);
                                                        }
                                                    }
                                                });
                                            })
                                            .done(function (data) {
                                                if (data && data.added && data.added[0]) {
                                                    var item = data.added[0],
                                                        dirhash = item.hash,
                                                        newItem = fm[find](dirhash),
                                                        acts = {
                                                            'directory': { cmd: 'open', msg: 'cmdopendir' },
                                                            'text': { cmd: 'edit', msg: 'cmdedit' },
                                                            'default': { cmd: 'open', msg: 'cmdopen' }
                                                        },
                                                        tmpMimes;
                                                    if (sel && move) {
                                                        fm.one(req + 'done', function () {
                                                            fm.exec('paste', dirhash);
                                                        });
                                                    }
                                                    if (!move) {
                                                        if (fm.mimeIsText(item.mime) && !fm.mimesCanMakeEmpty[item.mime] && fm.mimeTypes[item.mime]) {
                                                            fm.trigger('canMakeEmptyFile', { mimes: [item.mime], unshift: true });
                                                            tmpMimes = {};
                                                            tmpMimes[item.mime] = fm.mimeTypes[item.mime];
                                                            fm.storage('mkfileTextMimes', Object.assign(tmpMimes, fm.storage('mkfileTextMimes') || {}));
                                                        }
                                                        Object.assign(nextAct, nextAction || acts[item.mime] || acts[item.mime.split('/')[0]] || acts[(fm.mimesCanMakeEmpty[item.mime] || $.inArray(item.mime, fm.resources.mimes.text) !== -1) ? 'text' : 'none'] || acts['default']);
                                                        Object.assign(toast, nextAct.cmd ? {
                                                            incwd: { msg: fm.i18n(['complete', fm.i18n('cmd' + cmd)]), action: nextAct },
                                                            inbuffer: { msg: fm.i18n(['complete', fm.i18n('cmd' + cmd)]), action: nextAct }
                                                        } : {
                                                            inbuffer: { msg: fm.i18n(['complete', fm.i18n('cmd' + cmd)]) }
                                                        });
                                                    }
                                                }
                                                dfrd.resolve(data);
                                            });
                                    })
                                    .fail(function () {
                                        dfrd.reject();
                                    });
                            }
                        })
                        .on('dragenter dragleave dragover drop', function (e) {
                            // stop bubbling to prevent upload with native drop event
                            e.stopPropagation();
                        }),
                    select = function () {
                        var name = fm.splitFileExtention(input.val())[0];
                        if (!inError && fm.UA.Mobile && !fm.UA.iOS) { // since iOS has a bug? (z-index not effect) so disable it
                            overlay.on('click close', cancel).elfinderoverlay('show');
                            pnode.css('z-index', overlay.css('z-index') + 1);
                        }
                        inError = false;
                        !fm.enabled() && fm.enable();
                        input.trigger('focus').trigger('select');
                        input[0].setSelectionRange && input[0].setSelectionRange(0, name.length);
                    },
                    resize = function () {
                        node.trigger('scrolltoview', { blink: false });
                    },
                    openCallback = function () {
                        dfrd && (dfrd.state() === 'pending') && dfrd.reject();
                    },
                    inError = false,
                    nextAction,
                    // for tree
                    dst, dstCls, collapsed, expanded, arrow, subtree;

                if (!fm.isCommandEnabled(req, phash) || !node.length) {
                    return dfrd.reject();
                }

                if ($.isPlainObject(self.nextAction)) {
                    nextAction = Object.assign({}, self.nextAction);
                }

                if (tree) {
                    dst = fm[find](phash);
                    collapsed = fm.res('class', 'navcollapse');
                    expanded = fm.res('class', 'navexpand');
                    arrow = fm.res('class', 'navarrow');
                    subtree = fm.res('class', 'navsubtree');

                    node.closest('.' + subtree).show();
                    if (!dst.hasClass(collapsed)) {
                        dstCls = dst.attr('class');
                        dst.addClass(collapsed + ' ' + expanded + ' elfinder-subtree-loaded');
                    }
                    if (dst.is('.' + collapsed + ':not(.' + expanded + ')')) {
                        dst.children('.' + arrow).trigger('click').data('dfrd').done(function () {
                            if (input.val() === file.name) {
                                input.val(fm.uniqueName(self.prefix, phash)).trigger('select').trigger('focus');
                            }
                        });
                    }
                    nnode = node.contents().filter(function () { return this.nodeType == 3 && $(this).parent().attr('id') === fm.navHash2Id(file.hash); });
                    pnode = nnode.parent();
                    nnode.replaceWith(input.val(file.name));
                } else {
                    empty && wz.removeClass('elfinder-cwd-wrapper-empty');
                    nnode = node.find('.elfinder-cwd-filename');
                    pnode = nnode.parent();
                    if (tarea) {
                        nnode.css('max-height', 'none');
                    } else {
                        colwidth = pnode.width();
                        pnode.width(colwidth - 15)
                            .parent('td').css('overflow', 'visible');
                    }
                    nnode.empty().append(input.val(file.name));
                }
                pnode.addClass('ui-front')
                    .css('position', 'relative')
                    .on('unselect.' + fm.namespace, unselect);

                fm.bind('resize', resize).one('open', openCallback);

                input.trigger('keyup');
                select();

                return dfrd;

            }
        },
        blink: function (elm, mode) {
            var acts = {
                slowonce: function () { elm.hide().delay(250).fadeIn(750).delay(500).fadeOut(3500); },
                lookme: function () { elm.show().fadeOut(500).fadeIn(750); }
            }, func;
            mode = mode || 'slowonce';

            func = acts[mode] || acts['lookme'];

            elm.stop(true, true);
            func();
        }
    };


    /*
     * File: /js/jquery.dialogelfinder.js
     */

    /**
     * @class dialogelfinder - open elFinder in dialog window
     *
     * @param  Object  elFinder options with dialog options
     * @example
     * $(selector).dialogelfinder({
     *     // some elfinder options
     *     title          : 'My files', // dialog title, default = "Files"
     *     width          : 850,        // dialog width, default 840
     *     autoOpen       : false,      // if false - dialog will not be opened after init, default = true
     *     destroyOnClose : true        // destroy elFinder on close dialog, default = false
     * })
     * @author Dmitry (dio) Levashov
     **/
    $.fn.dialogelfinder = function (opts, opts2) {
        var position = 'elfinderPosition',
            destroy = 'elfinderDestroyOnClose',
            node, pos;

        if ($.isPlainObject(opts)) {
            this.not('.elfinder').each(function () {

                opts.handlers = opts.handlers || {};

                var node = $(this),
                    doc = $(document),
                    toolbar = $('<div class="ui-widget-header dialogelfinder-drag ui-corner-top">' + (opts.title || 'Files') + '</div>'),
                    button = $('<a href="#" class="dialogelfinder-drag-close ui-corner-all"><span class="ui-icon ui-icon-closethick"> </span></a>')
                        .appendTo(toolbar)
                        .on('click', function (e) {
                            e.preventDefault();
                            node.dialogelfinder('close');
                        }),
                    init = opts.handlers.init,
                    elfinder;

                opts.handlers.init = function (e, fm) {
                    node.prepend(toolbar);
                    init && init(e, fm);
                };

                elfinder = node.addClass('elfinder dialogelfinder touch-punch')
                    .css('position', 'absolute')
                    .hide()
                    .appendTo('body')
                    .draggable({
                        handle: '.dialogelfinder-drag',
                        containment: 'window',
                        stop: function () {
                            node.trigger('resize');
                            elfinder.trigger('resize');
                        }
                    })
                    .elfinder(opts, opts2)
                    .elfinder('instance');

                elfinder.reloadCallback = function (o, o2) {
                    elfinder.destroy();
                    o.handlers.init = init;
                    node.dialogelfinder(o, o2).dialogelfinder('open');
                };

                node.width(parseInt(node.width()) || 840) // fix width if set to "auto"
                    .data(destroy, !!opts.destroyOnClose)
                    .find('.elfinder-toolbar').removeClass('ui-corner-top');

                opts.position && node.data(position, opts.position);

                opts.autoOpen !== false && $(this).dialogelfinder('open');

            });
        } else {
            if (opts === 'open') {
                node = $(this);
                pos = node.data(position) || {
                    top: parseInt($(document).scrollTop() + ($(window).height() < node.height() ? 2 : ($(window).height() - node.height()) / 2)),
                    left: parseInt($(document).scrollLeft() + ($(window).width() < node.width() ? 2 : ($(window).width() - node.width()) / 2))
                };

                if (node.is(':hidden')) {
                    node.addClass('ui-front').css(pos).show().trigger('resize');

                    setTimeout(function () {
                        // fix resize icon position and make elfinder active
                        node.trigger('resize').trigger('mousedown');
                    }, 200);
                }
            } else if (opts === 'close') {
                node = $(this).removeClass('ui-front');

                if (node.is(':visible')) {
                    !!node.data(destroy)
                        ? node.elfinder('destroy').remove()
                        : node.elfinder('close');
                }
            } else if (opts === 'instance') {
                return $(this).getElFinder();
            }
        }

        return this;
    };


    /*
     * File: /js/i18n/elfinder.en.js
     */

    /**
     * English translation
     * @author Troex Nevelin <troex@fury.scancode.ru>
     * @author Naoki Sawada <hypweb+elfinder@gmail.com>
     * @version 2021-06-02
     */
    // elfinder.en.js is integrated into elfinder.(full|min).js by jake build
    if (typeof elFinder === 'function' && elFinder.prototype.i18) {
        elFinder.prototype.i18.en = {
            translator: 'Troex Nevelin &lt;troex@fury.scancode.ru&gt;, Naoki Sawada &lt;hypweb+elfinder@gmail.com&gt;',
            language: 'English',
            direction: 'ltr',
            dateFormat: 'M d, Y h:i A', // will show like: Aug 24, 2018 04:39 PM
            fancyDateFormat: '$1 h:i A', // will show like: Today 04:39 PM
            nonameDateFormat: 'ymd-His', // noname upload will show like: 180824-163916
            messages: {

                /********************************** errors **********************************/
                'error': 'Error',
                'errUnknown': 'Unknown error.',
                'errUnknownCmd': 'Unknown command.',
                'errJqui': 'Invalid jQuery UI configuration. Selectable, draggable and droppable components must be included.',
                'errNode': 'elFinder requires DOM Element to be created.',
                'errURL': 'Invalid elFinder configuration! URL option is not set.',
                'errAccess': 'Access denied.',
                'errConnect': 'Unable to connect to backend.',
                'errAbort': 'Connection aborted.',
                'errTimeout': 'Connection timeout.',
                'errNotFound': 'Backend not found.',
                'errResponse': 'Invalid backend response.',
                'errConf': 'Invalid backend configuration.',
                'errJSON': 'PHP JSON module not installed.',
                'errNoVolumes': 'Readable volumes not available.',
                'errCmdParams': 'Invalid parameters for command "$1".',
                'errDataNotJSON': 'Data is not JSON.',
                'errDataEmpty': 'Data is empty.',
                'errCmdReq': 'Backend request requires command name.',
                'errOpen': 'Unable to open "$1".',
                'errNotFolder': 'Object is not a folder.',
                'errNotFile': 'Object is not a file.',
                'errRead': 'Unable to read "$1".',
                'errWrite': 'Unable to write into "$1".',
                'errPerm': 'Permission denied.',
                'errLocked': '"$1" is locked and can not be renamed, moved or removed.',
                'errExists': 'Item named "$1" already exists.',
                'errInvName': 'Invalid file name.',
                'errInvDirname': 'Invalid folder name.',  // from v2.1.24 added 12.4.2017
                'errFolderNotFound': 'Folder not found.',
                'errFileNotFound': 'File not found.',
                'errTrgFolderNotFound': 'Target folder "$1" not found.',
                'errPopup': 'Browser prevented opening popup window. To open file enable it in browser options.',
                'errMkdir': 'Unable to create folder "$1".',
                'errMkfile': 'Unable to create file "$1".',
                'errRename': 'Unable to rename "$1".',
                'errCopyFrom': 'Copying files from volume "$1" not allowed.',
                'errCopyTo': 'Copying files to volume "$1" not allowed.',
                'errMkOutLink': 'Unable to create a link to outside the volume root.', // from v2.1 added 03.10.2015
                'errUpload': 'Upload error.',  // old name - errUploadCommon
                'errUploadFile': 'Unable to upload "$1".', // old name - errUpload
                'errUploadNoFiles': 'No files found for upload.',
                'errUploadTotalSize': 'Data exceeds the maximum allowed size.', // old name - errMaxSize
                'errUploadFileSize': 'File exceeds maximum allowed size.', //  old name - errFileMaxSize
                'errUploadMime': 'File type not allowed.',
                'errUploadTransfer': '"$1" transfer error.',
                'errUploadTemp': 'Unable to make temporary file for upload.', // from v2.1 added 26.09.2015
                'errNotReplace': 'Object "$1" already exists at this location and can not be replaced by object with another type.', // new
                'errReplace': 'Unable to replace "$1".',
                'errSave': 'Unable to save "$1".',
                'errCopy': 'Unable to copy "$1".',
                'errMove': 'Unable to move "$1".',
                'errCopyInItself': 'Unable to copy "$1" into itself.',
                'errRm': 'Unable to remove "$1".',
                'errTrash': 'Unable into trash.', // from v2.1.24 added 30.4.2017
                'errRmSrc': 'Unable remove source file(s).',
                'errExtract': 'Unable to extract files from "$1".',
                'errArchive': 'Unable to create archive.',
                'errArcType': 'Unsupported archive type.',
                'errNoArchive': 'File is not archive or has unsupported archive type.',
                'errCmdNoSupport': 'Backend does not support this command.',
                'errReplByChild': 'The folder "$1" can\'t be replaced by an item it contains.',
                'errArcSymlinks': 'For security reason denied to unpack archives contains symlinks or files with not allowed names.', // edited 24.06.2012
                'errArcMaxSize': 'Archive files exceeds maximum allowed size.',
                'errResize': 'Unable to resize "$1".',
                'errResizeDegree': 'Invalid rotate degree.',  // added 7.3.2013
                'errResizeRotate': 'Unable to rotate image.',  // added 7.3.2013
                'errResizeSize': 'Invalid image size.',  // added 7.3.2013
                'errResizeNoChange': 'Image size not changed.',  // added 7.3.2013
                'errUsupportType': 'Unsupported file type.',
                'errNotUTF8Content': 'File "$1" is not in UTF-8 and cannot be edited.',  // added 9.11.2011
                'errNetMount': 'Unable to mount "$1".', // added 17.04.2012
                'errNetMountNoDriver': 'Unsupported protocol.',     // added 17.04.2012
                'errNetMountFailed': 'Mount failed.',         // added 17.04.2012
                'errNetMountHostReq': 'Host required.', // added 18.04.2012
                'errSessionExpires': 'Your session has expired due to inactivity.',
                'errCreatingTempDir': 'Unable to create temporary directory: "$1"',
                'errFtpDownloadFile': 'Unable to download file from FTP: "$1"',
                'errFtpUploadFile': 'Unable to upload file to FTP: "$1"',
                'errFtpMkdir': 'Unable to create remote directory on FTP: "$1"',
                'errArchiveExec': 'Error while archiving files: "$1"',
                'errExtractExec': 'Error while extracting files: "$1"',
                'errNetUnMount': 'Unable to unmount.', // from v2.1 added 30.04.2012
                'errConvUTF8': 'Not convertible to UTF-8', // from v2.1 added 08.04.2014
                'errFolderUpload': 'Try the modern browser, If you\'d like to upload the folder.', // from v2.1 added 26.6.2015
                'errSearchTimeout': 'Timed out while searching "$1". Search result is partial.', // from v2.1 added 12.1.2016
                'errReauthRequire': 'Re-authorization is required.', // from v2.1.10 added 24.3.2016
                'errMaxTargets': 'Max number of selectable items is $1.', // from v2.1.17 added 17.10.2016
                'errRestore': 'Unable to restore from the trash. Can\'t identify the restore destination.', // from v2.1.24 added 3.5.2017
                'errEditorNotFound': 'Editor not found to this file type.', // from v2.1.25 added 23.5.2017
                'errServerError': 'Error occurred on the server side.', // from v2.1.25 added 16.6.2017
                'errEmpty': 'Unable to empty folder "$1".', // from v2.1.25 added 22.6.2017
                'moreErrors': 'There are $1 more errors.', // from v2.1.44 added 9.12.2018
                'errMaxMkdirs': 'You can create up to $1 folders at one time.', // from v2.1.58 added 20.6.2021

                /******************************* commands names ********************************/
                'cmdarchive': 'Create archive',
                'cmdback': 'Back',
                'cmdcopy': 'Copy',
                'cmdcut': 'Cut',
                'cmddownload': 'Download',
                'cmdduplicate': 'Duplicate',
                'cmdedit': 'Edit file',
                'cmdextract': 'Extract files from archive',
                'cmdforward': 'Forward',
                'cmdgetfile': 'Select files',
                'cmdhelp': 'About this software',
                'cmdhome': 'Root',
                'cmdinfo': 'Get info',
                'cmdmkdir': 'New folder',
                'cmdmkdirin': 'Into New Folder', // from v2.1.7 added 19.2.2016
                'cmdmkfile': 'New file',
                'cmdopen': 'Open',
                'cmdpaste': 'Paste',
                'cmdquicklook': 'Preview',
                'cmdreload': 'Reload',
                'cmdrename': 'Rename',
                'cmdrm': 'Delete',
                'cmdtrash': 'Into trash', //from v2.1.24 added 29.4.2017
                'cmdrestore': 'Restore', //from v2.1.24 added 3.5.2017
                'cmdsearch': 'Find files',
                'cmdup': 'Go to parent folder',
                'cmdupload': 'Upload files',
                'cmdview': 'View',
                'cmdresize': 'Resize & Rotate',
                'cmdsort': 'Sort',
                'cmdnetmount': 'Mount network volume', // added 18.04.2012
                'cmdnetunmount': 'Unmount', // from v2.1 added 30.04.2012
                'cmdplaces': 'To Places', // added 28.12.2014
                'cmdchmod': 'Change mode', // from v2.1 added 20.6.2015
                'cmdopendir': 'Open a folder', // from v2.1 added 13.1.2016
                'cmdcolwidth': 'Reset column width', // from v2.1.13 added 12.06.2016
                'cmdfullscreen': 'Full Screen', // from v2.1.15 added 03.08.2016
                'cmdmove': 'Move', // from v2.1.15 added 21.08.2016
                'cmdempty': 'Empty the folder', // from v2.1.25 added 22.06.2017
                'cmdundo': 'Undo', // from v2.1.27 added 31.07.2017
                'cmdredo': 'Redo', // from v2.1.27 added 31.07.2017
                'cmdpreference': 'Preferences', // from v2.1.27 added 03.08.2017
                'cmdselectall': 'Select all', // from v2.1.28 added 15.08.2017
                'cmdselectnone': 'Select none', // from v2.1.28 added 15.08.2017
                'cmdselectinvert': 'Invert selection', // from v2.1.28 added 15.08.2017
                'cmdopennew': 'Open in new window', // from v2.1.38 added 3.4.2018
                'cmdhide': 'Hide (Preference)', // from v2.1.41 added 24.7.2018

                /*********************************** buttons ***********************************/
                'btnClose': 'Close',
                'btnSave': 'Save',
                'btnRm': 'Remove',
                'btnApply': 'Apply',
                'btnCancel': 'Cancel',
                'btnNo': 'No',
                'btnYes': 'Yes',
                'btnMount': 'Mount',  // added 18.04.2012
                'btnApprove': 'Goto $1 & approve', // from v2.1 added 26.04.2012
                'btnUnmount': 'Unmount', // from v2.1 added 30.04.2012
                'btnConv': 'Convert', // from v2.1 added 08.04.2014
                'btnCwd': 'Here',      // from v2.1 added 22.5.2015
                'btnVolume': 'Volume',    // from v2.1 added 22.5.2015
                'btnAll': 'All',       // from v2.1 added 22.5.2015
                'btnMime': 'MIME Type', // from v2.1 added 22.5.2015
                'btnFileName': 'Filename',  // from v2.1 added 22.5.2015
                'btnSaveClose': 'Save & Close', // from v2.1 added 12.6.2015
                'btnBackup': 'Backup', // fromv2.1 added 28.11.2015
                'btnRename': 'Rename',      // from v2.1.24 added 6.4.2017
                'btnRenameAll': 'Rename(All)', // from v2.1.24 added 6.4.2017
                'btnPrevious': 'Prev ($1/$2)', // from v2.1.24 added 11.5.2017
                'btnNext': 'Next ($1/$2)', // from v2.1.24 added 11.5.2017
                'btnSaveAs': 'Save As', // from v2.1.25 added 24.5.2017

                /******************************** notifications ********************************/
                'ntfopen': 'Open folder',
                'ntffile': 'Open file',
                'ntfreload': 'Reload folder content',
                'ntfmkdir': 'Creating folder',
                'ntfmkfile': 'Creating files',
                'ntfrm': 'Delete items',
                'ntfcopy': 'Copy items',
                'ntfmove': 'Move items',
                'ntfprepare': 'Checking existing items',
                'ntfrename': 'Rename files',
                'ntfupload': 'Uploading files',
                'ntfdownload': 'Downloading files',
                'ntfsave': 'Save files',
                'ntfarchive': 'Creating archive',
                'ntfextract': 'Extracting files from archive',
                'ntfsearch': 'Searching files',
                'ntfresize': 'Resizing images',
                'ntfsmth': 'Doing something',
                'ntfloadimg': 'Loading image',
                'ntfnetmount': 'Mounting network volume', // added 18.04.2012
                'ntfnetunmount': 'Unmounting network volume', // from v2.1 added 30.04.2012
                'ntfdim': 'Acquiring image dimension', // added 20.05.2013
                'ntfreaddir': 'Reading folder infomation', // from v2.1 added 01.07.2013
                'ntfurl': 'Getting URL of link', // from v2.1 added 11.03.2014
                'ntfchmod': 'Changing file mode', // from v2.1 added 20.6.2015
                'ntfpreupload': 'Verifying upload file name', // from v2.1 added 31.11.2015
                'ntfzipdl': 'Creating a file for download', // from v2.1.7 added 23.1.2016
                'ntfparents': 'Getting path infomation', // from v2.1.17 added 2.11.2016
                'ntfchunkmerge': 'Processing the uploaded file', // from v2.1.17 added 2.11.2016
                'ntftrash': 'Doing throw in the trash', // from v2.1.24 added 2.5.2017
                'ntfrestore': 'Doing restore from the trash', // from v2.1.24 added 3.5.2017
                'ntfchkdir': 'Checking destination folder', // from v2.1.24 added 3.5.2017
                'ntfundo': 'Undoing previous operation', // from v2.1.27 added 31.07.2017
                'ntfredo': 'Redoing previous undone', // from v2.1.27 added 31.07.2017
                'ntfchkcontent': 'Checking contents', // from v2.1.41 added 3.8.2018

                /*********************************** volumes *********************************/
                'volume_Trash': 'Trash', //from v2.1.24 added 29.4.2017

                /************************************ dates **********************************/
                'dateUnknown': 'unknown',
                'Today': 'Today',
                'Yesterday': 'Yesterday',
                'msJan': 'Jan',
                'msFeb': 'Feb',
                'msMar': 'Mar',
                'msApr': 'Apr',
                'msMay': 'May',
                'msJun': 'Jun',
                'msJul': 'Jul',
                'msAug': 'Aug',
                'msSep': 'Sep',
                'msOct': 'Oct',
                'msNov': 'Nov',
                'msDec': 'Dec',
                'January': 'January',
                'February': 'February',
                'March': 'March',
                'April': 'April',
                'May': 'May',
                'June': 'June',
                'July': 'July',
                'August': 'August',
                'September': 'September',
                'October': 'October',
                'November': 'November',
                'December': 'December',
                'Sunday': 'Sunday',
                'Monday': 'Monday',
                'Tuesday': 'Tuesday',
                'Wednesday': 'Wednesday',
                'Thursday': 'Thursday',
                'Friday': 'Friday',
                'Saturday': 'Saturday',
                'Sun': 'Sun',
                'Mon': 'Mon',
                'Tue': 'Tue',
                'Wed': 'Wed',
                'Thu': 'Thu',
                'Fri': 'Fri',
                'Sat': 'Sat',

                /******************************** sort variants ********************************/
                'sortname': 'by name',
                'sortkind': 'by kind',
                'sortsize': 'by size',
                'sortdate': 'by date',
                'sortFoldersFirst': 'Folders first',
                'sortperm': 'by permission', // from v2.1.13 added 13.06.2016
                'sortmode': 'by mode',       // from v2.1.13 added 13.06.2016
                'sortowner': 'by owner',      // from v2.1.13 added 13.06.2016
                'sortgroup': 'by group',      // from v2.1.13 added 13.06.2016
                'sortAlsoTreeview': 'Also Treeview',  // from v2.1.15 added 01.08.2016

                /********************************** new items **********************************/
                'untitled file.txt': 'NewFile.txt', // added 10.11.2015
                'untitled folder': 'NewFolder',   // added 10.11.2015
                'Archive': 'NewArchive',  // from v2.1 added 10.11.2015
                'untitled file': 'NewFile.$1',  // from v2.1.41 added 6.8.2018
                'extentionfile': '$1: File',    // from v2.1.41 added 6.8.2018
                'extentiontype': '$1: $2',      // from v2.1.43 added 17.10.2018

                /********************************** messages **********************************/
                'confirmReq': 'Confirmation required',
                'confirmRm': 'Are you sure you want to permanently remove items?<br/>This cannot be undone!',
                'confirmRepl': 'Replace old file with new one? (If it contains folders, it will be merged. To backup and replace, select Backup.)',
                'confirmRest': 'Replace existing item with the item in trash?', // fromv2.1.24 added 5.5.2017
                'confirmConvUTF8': 'Not in UTF-8<br/>Convert to UTF-8?<br/>Contents become UTF-8 by saving after conversion.', // from v2.1 added 08.04.2014
                'confirmNonUTF8': 'Character encoding of this file couldn\'t be detected. It need to temporarily convert to UTF-8 for editting.<br/>Please select character encoding of this file.', // from v2.1.19 added 28.11.2016
                'confirmNotSave': 'It has been modified.<br/>Losing work if you do not save changes.', // from v2.1 added 15.7.2015
                'confirmTrash': 'Are you sure you want to move items to trash bin?', //from v2.1.24 added 29.4.2017
                'confirmMove': 'Are you sure you want to move items to "$1"?', //from v2.1.50 added 27.7.2019
                'apllyAll': 'Apply to all',
                'name': 'Name',
                'size': 'Size',
                'perms': 'Permissions',
                'modify': 'Modified',
                'kind': 'Kind',
                'read': 'read',
                'write': 'write',
                'noaccess': 'no access',
                'and': 'and',
                'unknown': 'unknown',
                'selectall': 'Select all items',
                'selectfiles': 'Select item(s)',
                'selectffile': 'Select first item',
                'selectlfile': 'Select last item',
                'viewlist': 'List view',
                'viewicons': 'Icons view',
                'viewSmall': 'Small icons', // from v2.1.39 added 22.5.2018
                'viewMedium': 'Medium icons', // from v2.1.39 added 22.5.2018
                'viewLarge': 'Large icons', // from v2.1.39 added 22.5.2018
                'viewExtraLarge': 'Extra large icons', // from v2.1.39 added 22.5.2018
                'places': 'Places',
                'calc': 'Calculate',
                'path': 'Path',
                'aliasfor': 'Alias for',
                'locked': 'Locked',
                'dim': 'Dimensions',
                'files': 'Files',
                'folders': 'Folders',
                'items': 'Items',
                'yes': 'yes',
                'no': 'no',
                'link': 'Link',
                'searcresult': 'Search results',
                'selected': 'selected items',
                'about': 'About',
                'shortcuts': 'Shortcuts',
                'help': 'Help',
                'webfm': 'Web file manager',
                'ver': 'Version',
                'protocolver': 'protocol version',
                'homepage': 'Project home',
                'docs': 'Documentation',
                'github': 'Fork us on GitHub',
                'twitter': 'Follow us on Twitter',
                'facebook': 'Join us on Facebook',
                'team': 'Team',
                'chiefdev': 'chief developer',
                'developer': 'developer',
                'contributor': 'contributor',
                'maintainer': 'maintainer',
                'translator': 'translator',
                'icons': 'Icons',
                'dontforget': 'and don\'t forget to take your towel',
                'shortcutsof': 'Shortcuts disabled',
                'dropFiles': 'Drop files here',
                'or': 'or',
                'selectForUpload': 'Select files',
                'moveFiles': 'Move items',
                'copyFiles': 'Copy items',
                'restoreFiles': 'Restore items', // from v2.1.24 added 5.5.2017
                'rmFromPlaces': 'Remove from places',
                'aspectRatio': 'Aspect ratio',
                'scale': 'Scale',
                'width': 'Width',
                'height': 'Height',
                'resize': 'Resize',
                'crop': 'Crop',
                'rotate': 'Rotate',
                'rotate-cw': 'Rotate 90 degrees CW',
                'rotate-ccw': 'Rotate 90 degrees CCW',
                'degree': '°',
                'netMountDialogTitle': 'Mount network volume', // added 18.04.2012
                'protocol': 'Protocol', // added 18.04.2012
                'host': 'Host', // added 18.04.2012
                'port': 'Port', // added 18.04.2012
                'user': 'User', // added 18.04.2012
                'pass': 'Password', // added 18.04.2012
                'confirmUnmount': 'Are you sure to unmount $1?',  // from v2.1 added 30.04.2012
                'dropFilesBrowser': 'Drop or Paste files from browser', // from v2.1 added 30.05.2012
                'dropPasteFiles': 'Drop files, Paste URLs or images(clipboard) here', // from v2.1 added 07.04.2014
                'encoding': 'Encoding', // from v2.1 added 19.12.2014
                'locale': 'Locale',   // from v2.1 added 19.12.2014
                'searchTarget': 'Target: $1',                // from v2.1 added 22.5.2015
                'searchMime': 'Search by input MIME Type', // from v2.1 added 22.5.2015
                'owner': 'Owner', // from v2.1 added 20.6.2015
                'group': 'Group', // from v2.1 added 20.6.2015
                'other': 'Other', // from v2.1 added 20.6.2015
                'execute': 'Execute', // from v2.1 added 20.6.2015
                'perm': 'Permission', // from v2.1 added 20.6.2015
                'mode': 'Mode', // from v2.1 added 20.6.2015
                'emptyFolder': 'Folder is empty', // from v2.1.6 added 30.12.2015
                'emptyFolderDrop': 'Folder is empty\\A Drop to add items', // from v2.1.6 added 30.12.2015
                'emptyFolderLTap': 'Folder is empty\\A Long tap to add items', // from v2.1.6 added 30.12.2015
                'quality': 'Quality', // from v2.1.6 added 5.1.2016
                'autoSync': 'Auto sync',  // from v2.1.6 added 10.1.2016
                'moveUp': 'Move up',  // from v2.1.6 added 18.1.2016
                'getLink': 'Get URL link', // from v2.1.7 added 9.2.2016
                'selectedItems': 'Selected items ($1)', // from v2.1.7 added 2.19.2016
                'folderId': 'Folder ID', // from v2.1.10 added 3.25.2016
                'offlineAccess': 'Allow offline access', // from v2.1.10 added 3.25.2016
                'reAuth': 'To re-authenticate', // from v2.1.10 added 3.25.2016
                'nowLoading': 'Now loading...', // from v2.1.12 added 4.26.2016
                'openMulti': 'Open multiple files', // from v2.1.12 added 5.14.2016
                'openMultiConfirm': 'You are trying to open the $1 files. Are you sure you want to open in browser?', // from v2.1.12 added 5.14.2016
                'emptySearch': 'Search results is empty in search target.', // from v2.1.12 added 5.16.2016
                'editingFile': 'It is editing a file.', // from v2.1.13 added 6.3.2016
                'hasSelected': 'You have selected $1 items.', // from v2.1.13 added 6.3.2016
                'hasClipboard': 'You have $1 items in the clipboard.', // from v2.1.13 added 6.3.2016
                'incSearchOnly': 'Incremental search is only from the current view.', // from v2.1.13 added 6.30.2016
                'reinstate': 'Reinstate', // from v2.1.15 added 3.8.2016
                'complete': '$1 complete', // from v2.1.15 added 21.8.2016
                'contextmenu': 'Context menu', // from v2.1.15 added 9.9.2016
                'pageTurning': 'Page turning', // from v2.1.15 added 10.9.2016
                'volumeRoots': 'Volume roots', // from v2.1.16 added 16.9.2016
                'reset': 'Reset', // from v2.1.16 added 1.10.2016
                'bgcolor': 'Background color', // from v2.1.16 added 1.10.2016
                'colorPicker': 'Color picker', // from v2.1.16 added 1.10.2016
                '8pxgrid': '8px Grid', // from v2.1.16 added 4.10.2016
                'enabled': 'Enabled', // from v2.1.16 added 4.10.2016
                'disabled': 'Disabled', // from v2.1.16 added 4.10.2016
                'emptyIncSearch': 'Search results is empty in current view.\\A Press [Enter] to expand search target.', // from v2.1.16 added 5.10.2016
                'emptyLetSearch': 'First letter search results is empty in current view.', // from v2.1.23 added 24.3.2017
                'textLabel': 'Text label', // from v2.1.17 added 13.10.2016
                'minsLeft': '$1 mins left', // from v2.1.17 added 13.11.2016
                'openAsEncoding': 'Reopen with selected encoding', // from v2.1.19 added 2.12.2016
                'saveAsEncoding': 'Save with the selected encoding', // from v2.1.19 added 2.12.2016
                'selectFolder': 'Select folder', // from v2.1.20 added 13.12.2016
                'firstLetterSearch': 'First letter search', // from v2.1.23 added 24.3.2017
                'presets': 'Presets', // from v2.1.25 added 26.5.2017
                'tooManyToTrash': 'It\'s too many items so it can\'t into trash.', // from v2.1.25 added 9.6.2017
                'TextArea': 'TextArea', // from v2.1.25 added 14.6.2017
                'folderToEmpty': 'Empty the folder "$1".', // from v2.1.25 added 22.6.2017
                'filderIsEmpty': 'There are no items in a folder "$1".', // from v2.1.25 added 22.6.2017
                'preference': 'Preference', // from v2.1.26 added 28.6.2017
                'language': 'Language', // from v2.1.26 added 28.6.2017
                'clearBrowserData': 'Initialize the settings saved in this browser', // from v2.1.26 added 28.6.2017
                'toolbarPref': 'Toolbar settings', // from v2.1.27 added 2.8.2017
                'charsLeft': '... $1 chars left.',  // from v2.1.29 added 30.8.2017
                'linesLeft': '... $1 lines left.',  // from v2.1.52 added 16.1.2020
                'sum': 'Sum', // from v2.1.29 added 28.9.2017
                'roughFileSize': 'Rough file size', // from v2.1.30 added 2.11.2017
                'autoFocusDialog': 'Focus on the element of dialog with mouseover',  // from v2.1.30 added 2.11.2017
                'select': 'Select', // from v2.1.30 added 23.11.2017
                'selectAction': 'Action when select file', // from v2.1.30 added 23.11.2017
                'useStoredEditor': 'Open with the editor used last time', // from v2.1.30 added 23.11.2017
                'selectinvert': 'Invert selection', // from v2.1.30 added 25.11.2017
                'renameMultiple': 'Are you sure you want to rename $1 selected items like $2?<br/>This cannot be undone!', // from v2.1.31 added 4.12.2017
                'batchRename': 'Batch rename', // from v2.1.31 added 8.12.2017
                'plusNumber': '+ Number', // from v2.1.31 added 8.12.2017
                'asPrefix': 'Add prefix', // from v2.1.31 added 8.12.2017
                'asSuffix': 'Add suffix', // from v2.1.31 added 8.12.2017
                'changeExtention': 'Change extention', // from v2.1.31 added 8.12.2017
                'columnPref': 'Columns settings (List view)', // from v2.1.32 added 6.2.2018
                'reflectOnImmediate': 'All changes will reflect immediately to the archive.', // from v2.1.33 added 2.3.2018
                'reflectOnUnmount': 'Any changes will not reflect until un-mount this volume.', // from v2.1.33 added 2.3.2018
                'unmountChildren': 'The following volume(s) mounted on this volume also unmounted. Are you sure to unmount it?', // from v2.1.33 added 5.3.2018
                'selectionInfo': 'Selection Info', // from v2.1.33 added 7.3.2018
                'hashChecker': 'Algorithms to show the file hash', // from v2.1.33 added 10.3.2018
                'infoItems': 'Info Items (Selection Info Panel)', // from v2.1.38 added 28.3.2018
                'pressAgainToExit': 'Press again to exit.', // from v2.1.38 added 1.4.2018
                'toolbar': 'Toolbar', // from v2.1.38 added 4.4.2018
                'workspace': 'Work Space', // from v2.1.38 added 4.4.2018
                'dialog': 'Dialog', // from v2.1.38 added 4.4.2018
                'all': 'All', // from v2.1.38 added 4.4.2018
                'iconSize': 'Icon Size (Icons view)', // from v2.1.39 added 7.5.2018
                'editorMaximized': 'Open the maximized editor window', // from v2.1.40 added 30.6.2018
                'editorConvNoApi': 'Because conversion by API is not currently available, please convert on the website.', //from v2.1.40 added 8.7.2018
                'editorConvNeedUpload': 'After conversion, you must be upload with the item URL or a downloaded file to save the converted file.', //from v2.1.40 added 8.7.2018
                'convertOn': 'Convert on the site of $1', // from v2.1.40 added 10.7.2018
                'integrations': 'Integrations', // from v2.1.40 added 11.7.2018
                'integrationWith': 'This elFinder has the following external services integrated. Please check the terms of use, privacy policy, etc. before using it.', // from v2.1.40 added 11.7.2018
                'showHidden': 'Show hidden items', // from v2.1.41 added 24.7.2018
                'hideHidden': 'Hide hidden items', // from v2.1.41 added 24.7.2018
                'toggleHidden': 'Show/Hide hidden items', // from v2.1.41 added 24.7.2018
                'makefileTypes': 'File types to enable with "New file"', // from v2.1.41 added 7.8.2018
                'typeOfTextfile': 'Type of the Text file', // from v2.1.41 added 7.8.2018
                'add': 'Add', // from v2.1.41 added 7.8.2018
                'theme': 'Theme', // from v2.1.43 added 19.10.2018
                'default': 'Default', // from v2.1.43 added 19.10.2018
                'description': 'Description', // from v2.1.43 added 19.10.2018
                'website': 'Website', // from v2.1.43 added 19.10.2018
                'author': 'Author', // from v2.1.43 added 19.10.2018
                'email': 'Email', // from v2.1.43 added 19.10.2018
                'license': 'License', // from v2.1.43 added 19.10.2018
                'exportToSave': 'This item can\'t be saved. To avoid losing the edits you need to export to your PC.', // from v2.1.44 added 1.12.2018
                'dblclickToSelect': 'Double click on the file to select it.', // from v2.1.47 added 22.1.2019
                'useFullscreen': 'Use fullscreen mode', // from v2.1.47 added 19.2.2019

                /********************************** mimetypes **********************************/
                'kindUnknown': 'Unknown',
                'kindRoot': 'Volume Root', // from v2.1.16 added 16.10.2016
                'kindFolder': 'Folder',
                'kindSelects': 'Selections', // from v2.1.29 added 29.8.2017
                'kindAlias': 'Alias',
                'kindAliasBroken': 'Broken alias',
                // applications
                'kindApp': 'Application',
                'kindPostscript': 'Postscript document',
                'kindMsOffice': 'Microsoft Office document',
                'kindMsWord': 'Microsoft Word document',
                'kindMsExcel': 'Microsoft Excel document',
                'kindMsPP': 'Microsoft Powerpoint presentation',
                'kindOO': 'Open Office document',
                'kindAppFlash': 'Flash application',
                'kindPDF': 'Portable Document Format (PDF)',
                'kindTorrent': 'Bittorrent file',
                'kind7z': '7z archive',
                'kindTAR': 'TAR archive',
                'kindGZIP': 'GZIP archive',
                'kindBZIP': 'BZIP archive',
                'kindXZ': 'XZ archive',
                'kindZIP': 'ZIP archive',
                'kindRAR': 'RAR archive',
                'kindJAR': 'Java JAR file',
                'kindTTF': 'True Type font',
                'kindOTF': 'Open Type font',
                'kindRPM': 'RPM package',
                // texts
                'kindText': 'Text document',
                'kindTextPlain': 'Plain text',
                'kindPHP': 'PHP source',
                'kindCSS': 'Cascading style sheet',
                'kindHTML': 'HTML document',
                'kindJS': 'Javascript source',
                'kindRTF': 'Rich Text Format',
                'kindC': 'C source',
                'kindCHeader': 'C header source',
                'kindCPP': 'C++ source',
                'kindCPPHeader': 'C++ header source',
                'kindShell': 'Unix shell script',
                'kindPython': 'Python source',
                'kindJava': 'Java source',
                'kindRuby': 'Ruby source',
                'kindPerl': 'Perl script',
                'kindSQL': 'SQL source',
                'kindXML': 'XML document',
                'kindAWK': 'AWK source',
                'kindCSV': 'Comma separated values',
                'kindDOCBOOK': 'Docbook XML document',
                'kindMarkdown': 'Markdown text', // added 20.7.2015
                // images
                'kindImage': 'Image',
                'kindBMP': 'BMP image',
                'kindJPEG': 'JPEG image',
                'kindGIF': 'GIF Image',
                'kindPNG': 'PNG Image',
                'kindTIFF': 'TIFF image',
                'kindTGA': 'TGA image',
                'kindPSD': 'Adobe Photoshop image',
                'kindXBITMAP': 'X bitmap image',
                'kindPXM': 'Pixelmator image',
                // media
                'kindAudio': 'Audio media',
                'kindAudioMPEG': 'MPEG audio',
                'kindAudioMPEG4': 'MPEG-4 audio',
                'kindAudioMIDI': 'MIDI audio',
                'kindAudioOGG': 'Ogg Vorbis audio',
                'kindAudioWAV': 'WAV audio',
                'AudioPlaylist': 'MP3 playlist',
                'kindVideo': 'Video media',
                'kindVideoDV': 'DV movie',
                'kindVideoMPEG': 'MPEG movie',
                'kindVideoMPEG4': 'MPEG-4 movie',
                'kindVideoAVI': 'AVI movie',
                'kindVideoMOV': 'Quick Time movie',
                'kindVideoWM': 'Windows Media movie',
                'kindVideoFlash': 'Flash movie',
                'kindVideoMKV': 'Matroska movie',
                'kindVideoOGG': 'Ogg movie'
            }
        };
    }



    /*
     * File: /js/ui/button.js
     */

    /**
     * @class  elFinder toolbar button widget.
     * If command has variants - create menu
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderbutton = function (cmd) {
        return this.each(function () {

            var c = 'class',
                fm = cmd.fm,
                disabled = fm.res(c, 'disabled'),
                active = fm.res(c, 'active'),
                hover = fm.res(c, 'hover'),
                item = 'elfinder-button-menu-item',
                selected = 'elfinder-button-menu-item-selected',
                menu,
                text = $('<span class="elfinder-button-text">' + cmd.title + '</span>'),
                prvCname = cmd.className ? cmd.className : cmd.name,
                button = $(this).addClass('ui-state-default elfinder-button')
                    .attr('title', cmd.title)
                    .append('<span class="elfinder-button-icon elfinder-button-icon-' + prvCname + '"></span>', text)
                    .on('mouseenter mouseleave', function (e) { !button.hasClass(disabled) && button[e.type == 'mouseleave' ? 'removeClass' : 'addClass'](hover); })
                    .on('click', function (e) {
                        if (!button.hasClass(disabled)) {
                            if (menu && cmd.variants.length >= 1) {
                                // close other menus
                                menu.is(':hidden') && fm.getUI().click();
                                e.stopPropagation();
                                menu.css(getMenuOffset()).slideToggle({
                                    duration: 100,
                                    done: function (e) {
                                        fm[menu.is(':visible') ? 'toFront' : 'toHide'](menu);
                                    }
                                });
                            } else {
                                fm.exec(cmd.name, getSelected(), { _userAction: true, _currentType: 'toolbar', _currentNode: button });
                            }

                        }
                    }),
                hideMenu = function () {
                    fm.toHide(menu);
                },
                getMenuOffset = function () {
                    var fmNode = fm.getUI(),
                        baseOffset = fmNode.offset(),
                        buttonOffset = button.offset();
                    return {
                        top: buttonOffset.top - baseOffset.top,
                        left: buttonOffset.left - baseOffset.left,
                        maxHeight: fmNode.height() - 40
                    };
                },
                getSelected = function () {
                    var sel = fm.selected(),
                        cwd;
                    if (!sel.length) {
                        if (cwd = fm.cwd()) {
                            sel = [fm.cwd().hash];
                        } else {
                            sel = void (0);
                        }
                    }
                    return sel;
                },
                tm;

            text.hide();

            // set self button object to cmd object
            cmd.button = button;

            // if command has variants create menu
            if (Array.isArray(cmd.variants)) {
                button.addClass('elfinder-menubutton');

                menu = $('<div class="ui-front ui-widget ui-widget-content elfinder-button-menu elfinder-button-' + prvCname + '-menu ui-corner-all"></div>')
                    .hide()
                    .appendTo(fm.getUI())
                    .on('mouseenter mouseleave', '.' + item, function () { $(this).toggleClass(hover); })
                    .on('click', '.' + item, function (e) {
                        var opts = $(this).data('value');
                        e.preventDefault();
                        e.stopPropagation();
                        button.removeClass(hover);
                        fm.toHide(menu);
                        if (typeof opts === 'undefined') {
                            opts = {};
                        }
                        if (typeof opts === 'object') {
                            opts._userAction = true;
                        }
                        fm.exec(cmd.name, getSelected(), opts);
                    })
                    .on('close', hideMenu);

                fm.bind('disable select', hideMenu).getUI().on('click', hideMenu);

                cmd.change(function () {
                    menu.html('');
                    $.each(cmd.variants, function (i, variant) {
                        menu.append($('<div class="' + item + '">' + variant[1] + '</div>').data('value', variant[0]).addClass(variant[0] == cmd.value ? selected : ''));
                    });
                });
            }

            cmd.change(function () {
                var cName;
                tm && cancelAnimationFrame(tm);
                tm = requestAnimationFrame(function () {
                    if (cmd.disabled()) {
                        button.removeClass(active + ' ' + hover).addClass(disabled);
                    } else {
                        button.removeClass(disabled);
                        button[cmd.active() ? 'addClass' : 'removeClass'](active);
                    }
                    if (cmd.syncTitleOnChange) {
                        cName = cmd.className ? cmd.className : cmd.name;
                        if (prvCname !== cName) {
                            button.children('.elfinder-button-icon').removeClass('elfinder-button-icon-' + prvCname).addClass('elfinder-button-icon-' + cName);
                            if (menu) {
                                menu.removeClass('elfinder-button-' + prvCname + '-menu').addClass('elfinder-button-' + cName + '-menu');
                            }
                            prvCname = cName;
                        }
                        text.html(cmd.title);
                        button.attr('title', cmd.title);
                    }
                });
            })
                .change();
        });
    };


    /*
     * File: /js/ui/contextmenu.js
     */

    /**
     * @class  elFinder contextmenu
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindercontextmenu = function (fm) {
        return this.each(function () {
            var self = $(this),
                cmItem = 'elfinder-contextmenu-item',
                smItem = 'elfinder-contextsubmenu-item',
                exIcon = 'elfinder-contextmenu-extra-icon',
                cHover = fm.res('class', 'hover'),
                dragOpt = {
                    distance: 8,
                    start: function () {
                        menu.data('drag', true).data('touching') && menu.find('.' + cHover).removeClass(cHover);
                    },
                    stop: function () {
                        menu.data('draged', true).removeData('drag');
                    }
                },
                menu = $(this).addClass('touch-punch ui-helper-reset ui-front ui-widget ui-state-default ui-corner-all elfinder-contextmenu elfinder-contextmenu-' + fm.direction)
                    .hide()
                    .on('touchstart', function (e) {
                        menu.data('touching', true).children().removeClass(cHover);
                    })
                    .on('touchend', function (e) {
                        menu.removeData('touching');
                    })
                    .on('mouseenter mouseleave', '.' + cmItem, function (e) {
                        $(this).toggleClass(cHover, (e.type === 'mouseenter' || (!menu.data('draged') && menu.data('submenuKeep')) ? true : false));
                        if (menu.data('draged') && menu.data('submenuKeep')) {
                            menu.find('.elfinder-contextmenu-sub:visible').parent().addClass(cHover);
                        }
                    })
                    .on('mouseenter mouseleave', '.' + exIcon, function (e) {
                        $(this).parent().toggleClass(cHover, e.type === 'mouseleave');
                    })
                    .on('mouseenter mouseleave', '.' + cmItem + ',.' + smItem, function (e) {
                        var setIndex = function (target, sub) {
                            $.each(sub ? subnodes : nodes, function (i, n) {
                                if (target[0] === n) {
                                    (sub ? subnodes : nodes)._cur = i;
                                    if (sub) {
                                        subselected = target;
                                    } else {
                                        selected = target;
                                    }
                                    return false;
                                }
                            });
                        };
                        if (e.originalEvent) {
                            var target = $(this),
                                unHover = function () {
                                    if (selected && !selected.children('div.elfinder-contextmenu-sub:visible').length) {
                                        selected.removeClass(cHover);
                                    }
                                };
                            if (e.type === 'mouseenter') {
                                // mouseenter
                                if (target.hasClass(smItem)) {
                                    // submenu
                                    if (subselected) {
                                        subselected.removeClass(cHover);
                                    }
                                    if (selected) {
                                        subnodes = selected.find('div.' + smItem);
                                    }
                                    setIndex(target, true);
                                } else {
                                    // menu
                                    unHover();
                                    setIndex(target);
                                }
                            } else {
                                // mouseleave
                                if (target.hasClass(smItem)) {
                                    //submenu
                                    subselected = null;
                                    subnodes = null;
                                } else {
                                    // menu
                                    unHover();
                                    (function (sel) {
                                        setTimeout(function () {
                                            if (sel === selected) {
                                                selected = null;
                                            }
                                        }, 250);
                                    })(selected);
                                }
                            }
                        }
                    })
                    .on('contextmenu', function () { return false; })
                    .on('mouseup', function () {
                        setTimeout(function () {
                            menu.removeData('draged');
                        }, 100);
                    })
                    .draggable(dragOpt),
                ltr = fm.direction === 'ltr',
                subpos = ltr ? 'left' : 'right',
                types = Object.assign({}, fm.options.contextmenu),
                tpl = '<div class="' + cmItem + '{className}"><span class="elfinder-button-icon {icon} elfinder-contextmenu-icon"{style}></span><span>{label}</span></div>',
                item = function (label, icon, callback, opts) {
                    var className = '',
                        style = '',
                        iconClass = '',
                        v, pos;
                    if (opts) {
                        if (opts.className) {
                            className = ' ' + opts.className;
                        }
                        if (opts.iconClass) {
                            iconClass = opts.iconClass;
                            icon = '';
                        }
                        if (opts.iconImg) {
                            v = opts.iconImg.split(/ +/);
                            pos = v[1] && v[2] ? fm.escape(v[1] + 'px ' + v[2] + 'px') : '';
                            style = ' style="background:url(\'' + fm.escape(v[0]) + '\') ' + (pos ? pos : '0 0') + ' no-repeat;' + (pos ? '' : 'posbackground-size:contain;') + '"';
                        }
                    }
                    return $(tpl.replace('{icon}', icon ? 'elfinder-button-icon-' + icon : (iconClass ? iconClass : ''))
                        .replace('{label}', label)
                        .replace('{style}', style)
                        .replace('{className}', className))
                        .on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            callback();
                        });
                },
                urlIcon = function (iconUrl) {
                    var v = iconUrl.split(/ +/),
                        pos = v[1] && v[2] ? (v[1] + 'px ' + v[2] + 'px') : '';
                    return {
                        backgroundImage: 'url("' + v[0] + '")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: pos ? pos : '',
                        backgroundSize: pos ? '' : 'contain'
                    };
                },
                base, cwd,
                nodes, selected, subnodes, subselected, autoSyncStop, subHoverTm,

                autoToggle = function () {
                    var evTouchStart = 'touchstart.contextmenuAutoToggle';
                    menu.data('hideTm') && clearTimeout(menu.data('hideTm'));
                    if (menu.is(':visible')) {
                        menu.on('touchstart', function (e) {
                            if (e.originalEvent.touches.length > 1) {
                                return;
                            }
                            menu.stop();
                            fm.toFront(menu);
                            menu.data('hideTm') && clearTimeout(menu.data('hideTm'));
                        })
                            .data('hideTm', setTimeout(function () {
                                if (menu.is(':visible')) {
                                    cwd.find('.elfinder-cwd-file').off(evTouchStart);
                                    cwd.find('.elfinder-cwd-file.ui-selected')
                                        .one(evTouchStart, function (e) {
                                            if (e.originalEvent.touches.length > 1) {
                                                return;
                                            }
                                            var tgt = $(e.target);
                                            if (menu.first().length && !tgt.is('input:checkbox') && !tgt.hasClass('elfinder-cwd-select')) {
                                                e.stopPropagation();
                                                //e.preventDefault();
                                                open(e.originalEvent.touches[0].pageX, e.originalEvent.touches[0].pageY);
                                                cwd.data('longtap', true)
                                                tgt.one('touchend', function () {
                                                    setTimeout(function () {
                                                        cwd.removeData('longtap');
                                                    }, 80);
                                                });
                                                return;
                                            }
                                            cwd.find('.elfinder-cwd-file').off(evTouchStart);
                                        })
                                        .one('unselect.' + fm.namespace, function () {
                                            cwd.find('.elfinder-cwd-file').off(evTouchStart);
                                        });
                                    menu.fadeOut({
                                        duration: 300,
                                        fail: function () {
                                            menu.css('opacity', '1').show();
                                        },
                                        done: function () {
                                            fm.toHide(menu);
                                        }
                                    });
                                }
                            }, 4500));
                    }
                },

                keyEvts = function (e) {
                    var code = e.keyCode,
                        ESC = $.ui.keyCode.ESCAPE,
                        ENT = $.ui.keyCode.ENTER,
                        LEFT = $.ui.keyCode.LEFT,
                        RIGHT = $.ui.keyCode.RIGHT,
                        UP = $.ui.keyCode.UP,
                        DOWN = $.ui.keyCode.DOWN,
                        subent = fm.direction === 'ltr' ? RIGHT : LEFT,
                        sublev = subent === RIGHT ? LEFT : RIGHT;

                    if ($.inArray(code, [ESC, ENT, LEFT, RIGHT, UP, DOWN]) !== -1) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        if (code == ESC || code === sublev) {
                            if (selected && subnodes && subselected) {
                                subselected.trigger('mouseleave').trigger('submenuclose');
                                selected.addClass(cHover);
                                subnodes = null;
                                subselected = null;
                            } else {
                                code == ESC && close();
                            }
                        } else if (code == UP || code == DOWN) {
                            if (subnodes) {
                                if (subselected) {
                                    subselected.trigger('mouseleave');
                                }
                                if (code == DOWN && (!subselected || subnodes.length <= ++subnodes._cur)) {
                                    subnodes._cur = 0;
                                } else if (code == UP && (!subselected || --subnodes._cur < 0)) {
                                    subnodes._cur = subnodes.length - 1;
                                }
                                subselected = subnodes.eq(subnodes._cur).trigger('mouseenter');
                            } else {
                                subnodes = null;
                                if (selected) {
                                    selected.trigger('mouseleave');
                                }
                                if (code == DOWN && (!selected || nodes.length <= ++nodes._cur)) {
                                    nodes._cur = 0;
                                } else if (code == UP && (!selected || --nodes._cur < 0)) {
                                    nodes._cur = nodes.length - 1;
                                }
                                selected = nodes.eq(nodes._cur).addClass(cHover);
                            }
                        } else if (selected && (code == ENT || code === subent)) {
                            if (selected.hasClass('elfinder-contextmenu-group')) {
                                if (subselected) {
                                    code == ENT && subselected.click();
                                } else {
                                    selected.trigger('mouseenter');
                                    subnodes = selected.find('div.' + smItem);
                                    subnodes._cur = 0;
                                    subselected = subnodes.first().addClass(cHover);
                                }
                            } else {
                                code == ENT && selected.click();
                            }
                        }
                    }
                },

                open = function (x, y, css) {
                    var width = menu.outerWidth(),
                        height = menu.outerHeight(),
                        bstyle = base.attr('style'),
                        bpos = base.offset(),
                        bwidth = base.width(),
                        bheight = base.height(),
                        mw = fm.UA.Mobile ? 40 : 2,
                        mh = fm.UA.Mobile ? 20 : 2,
                        x = x - (bpos ? bpos.left : 0),
                        y = y - (bpos ? bpos.top : 0),
                        css = Object.assign(css || {}, {
                            top: Math.max(0, y + mh + height < bheight ? y + mh : y - (y + height - bheight)),
                            left: Math.max(0, (x < width + mw || x + mw + width < bwidth) ? x + mw : x - mw - width),
                            opacity: '1'
                        }),
                        evts;

                    autoSyncStop = true;
                    fm.autoSync('stop');
                    base.width(bwidth);
                    menu.stop().removeAttr('style').css(css);
                    fm.toFront(menu);
                    menu.show();
                    base.attr('style', bstyle);

                    css[subpos] = parseInt(menu.width());
                    menu.find('.elfinder-contextmenu-sub').css(css);
                    if (fm.UA.iOS) {
                        $('div.elfinder div.overflow-scrolling-touch').css('-webkit-overflow-scrolling', 'auto');
                    }

                    selected = null;
                    subnodes = null;
                    subselected = null;
                    $(document).on('keydown.' + fm.namespace, keyEvts);
                    evts = $._data(document).events;
                    if (evts && evts.keydown) {
                        evts.keydown.unshift(evts.keydown.pop());
                    }

                    fm.UA.Mobile && autoToggle();

                    requestAnimationFrame(function () {
                        fm.getUI().one('click.' + fm.namespace, close);
                    });
                },

                close = function () {
                    fm.getUI().off('click.' + fm.namespace, close);
                    $(document).off('keydown.' + fm.namespace, keyEvts);

                    currentType = currentTargets = null;

                    if (menu.is(':visible') || menu.children().length) {
                        fm.toHide(menu.removeAttr('style').empty().removeData('submenuKeep'));
                        try {
                            if (!menu.draggable('instance')) {
                                menu.draggable(dragOpt);
                            }
                        } catch (e) {
                            if (!menu.hasClass('ui-draggable')) {
                                menu.draggable(dragOpt);
                            }
                        }
                        if (menu.data('prevNode')) {
                            menu.data('prevNode').after(menu);
                            menu.removeData('prevNode');
                        }
                        fm.trigger('closecontextmenu');
                        if (fm.UA.iOS) {
                            $('div.elfinder div.overflow-scrolling-touch').css('-webkit-overflow-scrolling', 'touch');
                        }
                    }

                    autoSyncStop && fm.searchStatus.state < 1 && !fm.searchStatus.ininc && fm.autoSync();
                    autoSyncStop = false;
                },

                create = function (type, targets) {
                    var sep = false,
                        insSep = false,
                        disabled = [],
                        isCwd = type === 'cwd',
                        selcnt = 0,
                        cmdMap;

                    currentType = type;
                    currentTargets = targets;

                    // get current uiCmdMap option
                    if (!(cmdMap = fm.option('uiCmdMap', isCwd ? void (0) : targets[0]))) {
                        cmdMap = {};
                    }

                    if (!isCwd) {
                        disabled = fm.getDisabledCmds(targets);
                    }

                    selcnt = fm.selected().length;
                    if (selcnt > 1) {
                        menu.append('<div class="ui-corner-top ui-widget-header elfinder-contextmenu-header"><span>'
                            + fm.i18n('selectedItems', '' + selcnt)
                            + '</span></div>');
                    }

                    nodes = $();
                    $.each(types[type] || [], function (i, name) {
                        var cmd, cmdName, useMap, node, submenu, hover;

                        if (name === '|') {
                            if (sep) {
                                insSep = true;
                            }
                            return;
                        }

                        if (cmdMap[name]) {
                            cmdName = cmdMap[name];
                            useMap = true;
                        } else {
                            cmdName = name;
                        }
                        cmd = fm.getCommand(cmdName);

                        if (cmd && !isCwd && (!fm.searchStatus.state || !cmd.disableOnSearch)) {
                            cmd.__disabled = cmd._disabled;
                            cmd._disabled = !(cmd.alwaysEnabled || (fm._commands[cmdName] ? $.inArray(name, disabled) === -1 && (!useMap || !disabled[cmdName]) : false));
                            $.each(cmd.linkedCmds, function (i, n) {
                                var c;
                                if (c = fm.getCommand(n)) {
                                    c.__disabled = c._disabled;
                                    c._disabled = !(c.alwaysEnabled || (fm._commands[n] ? !disabled[n] : false));
                                }
                            });
                        }

                        if (cmd && !cmd._disabled && cmd.getstate(targets) != -1) {
                            if (cmd.variants) {
                                if (!cmd.variants.length) {
                                    return;
                                }
                                node = item(cmd.title, cmd.className ? cmd.className : cmd.name, function () { }, cmd.contextmenuOpts);

                                submenu = $('<div class="ui-front ui-corner-all elfinder-contextmenu-sub"></div>')
                                    .hide()
                                    .css('max-height', fm.getUI().height() - 30)
                                    .appendTo(node.append('<span class="elfinder-contextmenu-arrow"></span>'));

                                hover = function (show) {
                                    if (!show) {
                                        submenu.hide();
                                    } else {
                                        var bstyle = base.attr('style');
                                        base.width(base.width());
                                        // top: '-1000px' to prevent visible scrollbar of window with the elFinder option `height: '100%'`
                                        submenu.css({ top: '-1000px', left: 'auto', right: 'auto' });
                                        var nodeOffset = node.offset(),
                                            nodeleft = nodeOffset.left,
                                            nodetop = nodeOffset.top,
                                            nodewidth = node.outerWidth(),
                                            width = submenu.outerWidth(true),
                                            height = submenu.outerHeight(true),
                                            baseOffset = base.offset(),
                                            wwidth = baseOffset.left + base.width(),
                                            wheight = baseOffset.top + base.height(),
                                            cltr = ltr,
                                            x = nodewidth,
                                            y, over;

                                        if (ltr) {
                                            over = (nodeleft + nodewidth + width) - wwidth;
                                            if (over > 10) {
                                                if (nodeleft > width - 5) {
                                                    x = x - 5;
                                                    cltr = false;
                                                } else {
                                                    if (!fm.UA.Mobile) {
                                                        x = nodewidth - over;
                                                    }
                                                }
                                            }
                                        } else {
                                            over = width - nodeleft;
                                            if (over > 0) {
                                                if ((nodeleft + nodewidth + width - 15) < wwidth) {
                                                    x = x - 5;
                                                    cltr = true;
                                                } else {
                                                    if (!fm.UA.Mobile) {
                                                        x = nodewidth - over;
                                                    }
                                                }
                                            }
                                        }
                                        over = (nodetop + 5 + height) - wheight;
                                        y = (over > 0 && nodetop < wheight) ? 5 - over : (over > 0 ? 30 - height : 5);

                                        menu.find('.elfinder-contextmenu-sub:visible').hide();
                                        submenu.css({
                                            top: y,
                                            left: cltr ? x : 'auto',
                                            right: cltr ? 'auto' : x,
                                            overflowY: 'auto'
                                        }).show();
                                        base.attr('style', bstyle);
                                    }
                                };

                                node.addClass('elfinder-contextmenu-group')
                                    .on('mouseleave', '.elfinder-contextmenu-sub', function (e) {
                                        if (!menu.data('draged')) {
                                            menu.removeData('submenuKeep');
                                        }
                                    })
                                    .on('submenuclose', '.elfinder-contextmenu-sub', function (e) {
                                        hover(false);
                                    })
                                    .on('click', '.' + smItem, function (e) {
                                        var opts, $this;
                                        e.stopPropagation();
                                        if (!menu.data('draged')) {
                                            $this = $(this);
                                            if (!cmd.keepContextmenu) {
                                                menu.hide();
                                            } else {
                                                $this.removeClass(cHover);
                                                node.addClass(cHover);
                                            }
                                            opts = $this.data('exec');
                                            if (typeof opts === 'undefined') {
                                                opts = {};
                                            }
                                            if (typeof opts === 'object') {
                                                opts._userAction = true;
                                                opts._currentType = type;
                                                opts._currentNode = $this;
                                            }
                                            !cmd.keepContextmenu && close();
                                            fm.exec(cmd.name, targets, opts);
                                        }
                                    })
                                    .on('touchend', function (e) {
                                        if (!menu.data('drag')) {
                                            hover(true);
                                            menu.data('submenuKeep', true);
                                        }
                                    })
                                    .on('mouseenter mouseleave', function (e) {
                                        if (!menu.data('touching')) {
                                            if (node.data('timer')) {
                                                clearTimeout(node.data('timer'));
                                                node.removeData('timer');
                                            }
                                            if (!$(e.target).closest('.elfinder-contextmenu-sub', menu).length) {
                                                if (e.type === 'mouseleave') {
                                                    if (!menu.data('submenuKeep')) {
                                                        node.data('timer', setTimeout(function () {
                                                            node.removeData('timer');
                                                            hover(false);
                                                        }, 250));
                                                    }
                                                } else {
                                                    node.data('timer', setTimeout(function () {
                                                        node.removeData('timer');
                                                        hover(true);
                                                    }, nodes.find('div.elfinder-contextmenu-sub:visible').length ? 250 : 0));
                                                }
                                            }
                                        }
                                    });

                                $.each(cmd.variants, function (i, variant) {
                                    var item = variant === '|' ? '<div class="elfinder-contextmenu-separator"></div>' :
                                        $('<div class="' + cmItem + ' ' + smItem + '"><span>' + variant[1] + '</span></div>').data('exec', variant[0]),
                                        iconClass, icon;
                                    if (typeof variant[2] !== 'undefined') {
                                        icon = $('<span></span>').addClass('elfinder-button-icon elfinder-contextmenu-icon');
                                        if (! /\//.test(variant[2])) {
                                            icon.addClass('elfinder-button-icon-' + variant[2]);
                                        } else {
                                            icon.css(urlIcon(variant[2]));
                                        }
                                        item.prepend(icon).addClass(smItem + '-icon');
                                    }
                                    submenu.append(item);
                                });

                            } else {
                                node = item(cmd.title, cmd.className ? cmd.className : cmd.name, function () {
                                    if (!menu.data('draged')) {
                                        !cmd.keepContextmenu && close();
                                        fm.exec(cmd.name, targets, { _userAction: true, _currentType: type, _currentNode: node });
                                    }
                                }, cmd.contextmenuOpts);
                                if (cmd.extra && cmd.extra.node) {
                                    $('<span class="elfinder-button-icon elfinder-button-icon-' + (cmd.extra.icon || '') + ' ' + exIcon + '"></span>')
                                        .append(cmd.extra.node).appendTo(node);
                                    $(cmd.extra.node).trigger('ready', { targets: targets });
                                } else {
                                    node.remove('.' + exIcon);
                                }
                            }

                            if (cmd.extendsCmd) {
                                node.children('span.elfinder-button-icon').addClass('elfinder-button-icon-' + cmd.extendsCmd);
                            }

                            if (insSep) {
                                menu.append('<div class="elfinder-contextmenu-separator"></div>');
                            }
                            menu.append(node);
                            sep = true;
                            insSep = false;
                        }

                        if (cmd && typeof cmd.__disabled !== 'undefined') {
                            cmd._disabled = cmd.__disabled;
                            delete cmd.__disabled;
                            $.each(cmd.linkedCmds, function (i, n) {
                                var c;
                                if (c = fm.getCommand(n)) {
                                    c._disabled = c.__disabled;
                                    delete c.__disabled;
                                }
                            });
                        }
                    });
                    nodes = menu.children('div.' + cmItem);
                },

                createFromRaw = function (raw) {
                    currentType = 'raw';
                    $.each(raw, function (i, data) {
                        var node;

                        if (data === '|') {
                            menu.append('<div class="elfinder-contextmenu-separator"></div>');
                        } else if (data.label && typeof data.callback == 'function') {
                            node = item(data.label, data.icon, function () {
                                if (!menu.data('draged')) {
                                    !data.remain && close();
                                    data.callback();
                                }
                            }, data.options || null);
                            menu.append(node);
                        }
                    });
                    nodes = menu.children('div.' + cmItem);
                },

                currentType = null,
                currentTargets = null;

            fm.one('load', function () {
                base = fm.getUI();
                cwd = fm.getUI('cwd');
                fm.bind('contextmenu', function (e) {
                    var data = e.data,
                        css = {},
                        prevNode;

                    if (data.type && data.type !== 'files') {
                        cwd.trigger('unselectall');
                    }
                    close();

                    if (data.type && data.targets) {
                        fm.trigger('contextmenucreate', data);
                        create(data.type, data.targets);
                        fm.trigger('contextmenucreatedone', data);
                    } else if (data.raw) {
                        createFromRaw(data.raw);
                    }

                    if (menu.children().length) {
                        prevNode = data.prevNode || null;
                        if (prevNode) {
                            menu.data('prevNode', menu.prev());
                            prevNode.after(menu);
                        }
                        if (data.fitHeight) {
                            css = { maxHeight: Math.min(fm.getUI().height(), $(window).height()), overflowY: 'auto' };
                            menu.draggable('destroy').removeClass('ui-draggable');
                        }
                        open(data.x, data.y, css);
                        // call opened callback function
                        if (data.opened && typeof data.opened === 'function') {
                            data.opened.call(menu);
                        }
                    }
                })
                    .one('destroy', function () { menu.remove(); })
                    .bind('disable', close)
                    .bind('select', function (e) {
                        (currentType === 'files' && (!e.data || e.data.selected.toString() !== currentTargets.toString())) && close();
                    });
            })
                .shortcut({
                    pattern: fm.OS === 'mac' ? 'ctrl+m' : 'contextmenu shift+f10',
                    description: 'contextmenu',
                    callback: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        $(document).one('contextmenu.' + fm.namespace, function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                        var sel = fm.selected(),
                            type, targets, pos, elm;

                        if (sel.length) {
                            type = 'files';
                            targets = sel;
                            elm = fm.cwdHash2Elm(sel[0]);
                        } else {
                            type = 'cwd';
                            targets = [fm.cwd().hash];
                            pos = fm.getUI('workzone').offset();
                        }
                        if (!elm || !elm.length) {
                            elm = fm.getUI('workzone');
                        }
                        pos = elm.offset();
                        pos.top += (elm.height() / 2);
                        pos.left += (elm.width() / 2);
                        fm.trigger('contextmenu', {
                            'type': type,
                            'targets': targets,
                            'x': pos.left,
                            'y': pos.top
                        });
                    }
                });

        });

    };


    /*
     * File: /js/ui/cwd.js
     */

    /**
     * elFinder current working directory ui.
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindercwd = function (fm, options) {
        this.not('.elfinder-cwd').each(function () {
            // fm.time('cwdLoad');

            var mobile = fm.UA.Mobile,
                list = fm.viewType == 'list',

                undef = 'undefined',
                /**
                 * Select event full name
                 *
                 * @type String
                 **/
                evtSelect = 'select.' + fm.namespace,

                /**
                 * Unselect event full name
                 *
                 * @type String
                 **/
                evtUnselect = 'unselect.' + fm.namespace,

                /**
                 * Disable event full name
                 *
                 * @type String
                 **/
                evtDisable = 'disable.' + fm.namespace,

                /**
                 * Disable event full name
                 *
                 * @type String
                 **/
                evtEnable = 'enable.' + fm.namespace,

                c = 'class',
                /**
                 * File css class
                 *
                 * @type String
                 **/
                clFile = fm.res(c, 'cwdfile'),

                /**
                 * Selected css class
                 *
                 * @type String
                 **/
                fileSelector = '.' + clFile,

                /**
                 * Selected css class
                 *
                 * @type String
                 **/
                clSelected = 'ui-selected',

                /**
                 * Disabled css class
                 *
                 * @type String
                 **/
                clDisabled = fm.res(c, 'disabled'),

                /**
                 * Draggable css class
                 *
                 * @type String
                 **/
                clDraggable = fm.res(c, 'draggable'),

                /**
                 * Droppable css class
                 *
                 * @type String
                 **/
                clDroppable = fm.res(c, 'droppable'),

                /**
                 * Hover css class
                 *
                 * @type String
                 **/
                clHover = fm.res(c, 'hover'),

                /**
                 * Active css class
                 *
                 * @type String
                 **/
                clActive = fm.res(c, 'active'),

                /**
                 * Hover css class
                 *
                 * @type String
                 **/
                clDropActive = fm.res(c, 'adroppable'),

                /**
                 * Css class for temporary nodes (for mkdir/mkfile) commands
                 *
                 * @type String
                 **/
                clTmp = clFile + '-tmp',

                /**
                 * Select checkbox css class
                 * 
                 * @type String
                 */
                clSelChk = 'elfinder-cwd-selectchk',

                /**
                 * Number of thumbnails to load in one request (new api only)
                 *
                 * @type Number
                 **/
                tmbNum = fm.options.loadTmbs > 0 ? fm.options.loadTmbs : 5,

                /**
                 * Current search query.
                 *
                 * @type String
                 */
                query = '',

                /**
                 * Currect clipboard(cut) hashes as object key
                 * 
                 * @type Object
                 */
                clipCuts = {},

                /**
                 * Parents hashes of cwd
                 *
                 * @type Array
                 */
                cwdParents = [],

                /**
                 * cwd current hashes
                 * 
                 * @type Array
                 */
                cwdHashes = [],

                /**
                 * incsearch current hashes
                 * 
                 * @type Array
                 */
                incHashes = void 0,

                /**
                 * Custom columns name and order
                 *
                 * @type Array
                 */
                customCols = [],

                /**
                 * Current clicked element id of first time for dblclick
                 * 
                 * @type String
                 */
                curClickId = '',

                /**
                 * Custom columns builder
                 *
                 * @type Function
                 */
                customColsBuild = function () {
                    var cols = '';
                    for (var i = 0; i < customCols.length; i++) {
                        cols += '<td class="elfinder-col-' + customCols[i] + '">{' + customCols[i] + '}</td>';
                    }
                    return cols;
                },

                /**
                 * Make template.row from customCols
                 *
                 * @type Function
                 */
                makeTemplateRow = function () {
                    return '<tr id="{id}" class="' + clFile + ' {permsclass} {dirclass}" title="{tooltip}"{css}><td class="elfinder-col-name"><div class="elfinder-cwd-file-wrapper"><span class="elfinder-cwd-icon {mime}"{style}></span>{marker}<span class="elfinder-cwd-filename">{name}</span></div>' + selectCheckbox + '</td>' + customColsBuild() + '</tr>';
                },

                selectCheckbox = ($.map(options.showSelectCheckboxUA, function (t) { return (fm.UA[t] || t.match(/^all$/i)) ? true : null; }).length) ? '<div class="elfinder-cwd-select"><input type="checkbox" class="' + clSelChk + '"></div>' : '',

                colResizing = false,

                colWidth = null,

                /**
                 * Table header height
                 */
                thHeight,

                /**
                 * File templates
                 *
                 * @type Object
                 **/
                templates = {
                    icon: '<div id="{id}" class="' + clFile + ' {permsclass} {dirclass} ui-corner-all" title="{tooltip}"><div class="elfinder-cwd-file-wrapper ui-corner-all"><div class="elfinder-cwd-icon {mime} ui-corner-all" unselectable="on"{style}></div>{marker}</div><div class="elfinder-cwd-filename" title="{nametitle}">{name}</div>' + selectCheckbox + '</div>',
                    row: ''
                },

                permsTpl = fm.res('tpl', 'perms'),

                lockTpl = fm.res('tpl', 'lock'),

                symlinkTpl = fm.res('tpl', 'symlink'),

                /**
                 * Template placeholders replacement rules
                 *
                 * @type Object
                 **/
                replacement = {
                    id: function (f) {
                        return fm.cwdHash2Id(f.hash);
                    },
                    name: function (f) {
                        var name = fm.escape(f.i18 || f.name);
                        !list && (name = name.replace(/([_.])/g, '&#8203;$1'));
                        return name;
                    },
                    nametitle: function (f) {
                        return fm.escape(f.i18 || f.name);
                    },
                    permsclass: function (f) {
                        return fm.perms2class(f);
                    },
                    perm: function (f) {
                        return fm.formatPermissions(f);
                    },
                    dirclass: function (f) {
                        var cName = f.mime == 'directory' ? 'directory' : '';
                        f.isroot && (cName += ' isroot');
                        f.csscls && (cName += ' ' + fm.escape(f.csscls));
                        options.getClass && (cName += ' ' + options.getClass(f));
                        return cName;
                    },
                    style: function (f) {
                        return f.icon ? fm.getIconStyle(f) : '';
                    },
                    mime: function (f) {
                        var cName = fm.mime2class(f.mime);
                        f.icon && (cName += ' elfinder-cwd-bgurl');
                        return cName;
                    },
                    size: function (f) {
                        return (f.mime === 'directory' && !f.size) ? '-' : fm.formatSize(f.size);
                    },
                    date: function (f) {
                        return fm.formatDate(f);
                    },
                    kind: function (f) {
                        return fm.mime2kind(f);
                    },
                    mode: function (f) {
                        return f.perm ? fm.formatFileMode(f.perm) : '';
                    },
                    modestr: function (f) {
                        return f.perm ? fm.formatFileMode(f.perm, 'string') : '';
                    },
                    modeoct: function (f) {
                        return f.perm ? fm.formatFileMode(f.perm, 'octal') : '';
                    },
                    modeboth: function (f) {
                        return f.perm ? fm.formatFileMode(f.perm, 'both') : '';
                    },
                    marker: function (f) {
                        return (f.alias || f.mime == 'symlink-broken' ? symlinkTpl : '') + (!f.read || !f.write ? permsTpl : '') + (f.locked ? lockTpl : '');
                    },
                    tooltip: function (f) {
                        var title = fm.formatDate(f) + (f.size > 0 ? ' (' + fm.formatSize(f.size) + ')' : ''),
                            info = '';
                        if (query && f.path) {
                            info = fm.escape(f.path.replace(/\/[^\/]*$/, ''));
                        } else {
                            info = f.tooltip ? fm.escape(f.tooltip).replace(/\r/g, '&#13;') : '';
                        }
                        if (list) {
                            info += (info ? '&#13;' : '') + fm.escape(f.i18 || f.name);
                        }
                        return info ? info + '&#13;' + title : title;
                    }
                },

                /**
                 * Type badge CSS added flag
                 * 
                 * @type Object
                 */
                addedBadges = {},

                /**
                 * Type badge style sheet element
                 * 
                 * @type Object
                 */
                addBadgeStyleSheet,

                /**
                 * Add type badge CSS into 'head'
                 * 
                 * @type Fundtion
                 */
                addBadgeStyle = function (mime, name) {
                    var sel, ext, type;
                    if (mime && !addedBadges[mime]) {
                        if (typeof addBadgeStyleSheet === 'undefined') {
                            if ($('#elfinderAddBadgeStyle' + fm.namespace).length) {
                                $('#elfinderAddBadgeStyle' + fm.namespace).remove();
                            }
                            addBadgeStyleSheet = $('<style id="addBadgeStyle' + fm.namespace + '"></style>').insertBefore($('head').children(':first')).get(0).sheet || null;
                        }
                        if (addBadgeStyleSheet) {
                            mime = mime.toLowerCase();
                            type = mime.split('/');
                            ext = fm.escape(fm.mimeTypes[mime] || (name.replace(/.bac?k$/i, '').match(/\.([^.]+)$/) || ['', ''])[1]);
                            if (ext) {
                                sel = '.elfinder-cwd-icon-' + type[0].replace(/(\.|\+)/g, '-');
                                if (typeof type[1] !== 'undefined') {
                                    sel += '.elfinder-cwd-icon-' + type[1].replace(/(\.|\+)/g, '-');
                                }
                                try {
                                    addBadgeStyleSheet.insertRule(sel + ':before{content:"' + ext.toLowerCase() + '"}', 0);
                                } catch (e) { }
                            }
                            addedBadges[mime] = true;
                        }
                    }
                },

                /**
                 * Return file html
                 *
                 * @param  Object  file info
                 * @return String
                 **/
                itemhtml = function (f) {
                    f.mime && f.mime !== 'directory' && !addedBadges[f.mime] && addBadgeStyle(f.mime, f.name);
                    return templates[list ? 'row' : 'icon']
                        .replace(/\{([a-z0-9_]+)\}/g, function (s, e) {
                            return replacement[e] ? replacement[e](f, fm) : (f[e] ? f[e] : '');
                        });
                },

                /**
                 * jQueery node that will be selected next
                 * 
                 * @type Object jQuery node
                 */
                selectedNext = $(),

                /**
                 * Flag. Required for msie to avoid unselect files on dragstart
                 *
                 * @type Boolean
                 **/
                selectLock = false,

                /**
                 * Move selection to prev/next file
                 *
                 * @param String  move direction
                 * @param Boolean append to current selection
                 * @return void
                 * @rise select			
                 */
                select = function (keyCode, append) {
                    var code = $.ui.keyCode,
                        prev = keyCode == code.LEFT || keyCode == code.UP,
                        sel = cwd.find('[id].' + clSelected),
                        selector = prev ? 'first:' : 'last',
                        s, n, sib, top, left;

                    function sibling(n, direction) {
                        return n[direction + 'All']('[id]:not(.' + clDisabled + '):not(.elfinder-cwd-parent):first');
                    }

                    if (sel.length) {
                        s = sel.filter(prev ? ':first' : ':last');
                        sib = sibling(s, prev ? 'prev' : 'next');

                        if (!sib.length) {
                            // there is no sibling on required side - do not move selection
                            n = s;
                        } else if (list || keyCode == code.LEFT || keyCode == code.RIGHT) {
                            // find real prevoius file
                            n = sib;
                        } else {
                            // find up/down side file in icons view
                            top = s.position().top;
                            left = s.position().left;

                            n = s;
                            if (prev) {
                                do {
                                    n = n.prev('[id]');
                                } while (n.length && !(n.position().top < top && n.position().left <= left));

                                if (n.hasClass(clDisabled)) {
                                    n = sibling(n, 'next');
                                }
                            } else {
                                do {
                                    n = n.next('[id]');
                                } while (n.length && !(n.position().top > top && n.position().left >= left));

                                if (n.hasClass(clDisabled)) {
                                    n = sibling(n, 'prev');
                                }
                                // there is row before last one - select last file
                                if (!n.length) {
                                    sib = cwd.find('[id]:not(.' + clDisabled + '):last');
                                    if (sib.position().top > top) {
                                        n = sib;
                                    }
                                }
                            }
                        }
                        // !append && unselectAll();
                    } else {
                        if (selectedNext.length) {
                            n = prev ? selectedNext.prev() : selectedNext;
                        } else {
                            // there are no selected file - select first/last one
                            n = cwd.find('[id]:not(.' + clDisabled + '):not(.elfinder-cwd-parent):' + (prev ? 'last' : 'first'));
                        }
                    }

                    if (n && n.length && !n.hasClass('elfinder-cwd-parent')) {
                        if (s && append) {
                            // append new files to selected
                            n = s.add(s[prev ? 'prevUntil' : 'nextUntil']('#' + n.attr('id'))).add(n);
                        } else {
                            // unselect selected files
                            sel.trigger(evtUnselect);
                        }
                        // select file(s)
                        n.trigger(evtSelect);
                        // set its visible
                        scrollToView(n.filter(prev ? ':first' : ':last'));
                        // update cache/view
                        trigger();
                    }
                },

                selectedFiles = {},

                selectFile = function (hash) {
                    fm.cwdHash2Elm(hash).trigger(evtSelect);
                },

                allSelected = false,

                selectAll = function () {
                    var phash = fm.cwd().hash;

                    selectCheckbox && selectAllCheckbox.find('input').prop('checked', true);
                    fm.lazy(function () {
                        var files;
                        if (fm.maxTargets && (incHashes || cwdHashes).length > fm.maxTargets) {
                            unselectAll({ notrigger: true });
                            files = $.map(incHashes || cwdHashes, function (hash) { return fm.file(hash) || null; });
                            files = files.slice(0, fm.maxTargets);
                            selectedFiles = {};
                            $.each(files, function (i, v) {
                                selectedFiles[v.hash] = true;
                                fm.cwdHash2Elm(v.hash).trigger(evtSelect);
                            });
                            fm.toast({ mode: 'warning', msg: fm.i18n(['errMaxTargets', fm.maxTargets]) });
                        } else {
                            cwd.find('[id]:not(.' + clSelected + '):not(.elfinder-cwd-parent)').trigger(evtSelect);
                            selectedFiles = fm.arrayFlip(incHashes || cwdHashes, true);
                        }
                        trigger();
                        selectCheckbox && selectAllCheckbox.data('pending', false);
                    }, 0, { repaint: true });
                },

                /**
                 * Unselect all files
                 *
                 * @param  Object  options
                 * @return void
                 */
                unselectAll = function (opts) {
                    var o = opts || {};
                    selectCheckbox && selectAllCheckbox.find('input').prop('checked', false);
                    if (Object.keys(selectedFiles).length) {
                        selectLock = false;
                        selectedFiles = {};
                        cwd.find('[id].' + clSelected).trigger(evtUnselect);
                        selectCheckbox && cwd.find('input:checkbox.' + clSelChk).prop('checked', false);
                    }
                    !o.notrigger && trigger();
                    selectCheckbox && selectAllCheckbox.data('pending', false);
                    cwd.removeClass('elfinder-cwd-allselected');
                },

                selectInvert = function () {
                    var invHashes = {};
                    if (allSelected) {
                        unselectAll();
                    } else if (!Object.keys(selectedFiles).length) {
                        selectAll();
                    } else {
                        $.each((incHashes || cwdHashes), function (i, h) {
                            var itemNode = fm.cwdHash2Elm(h);
                            if (!selectedFiles[h]) {
                                invHashes[h] = true;
                                itemNode.length && itemNode.trigger(evtSelect);
                            } else {
                                itemNode.length && itemNode.trigger(evtUnselect);
                            }
                        });
                        selectedFiles = invHashes;
                        trigger();
                    }
                },

                /**
                 * Return selected files hashes list
                 *
                 * @return Array
                 */
                selected = function () {
                    return Object.keys(selectedFiles);
                },

                /**
                 * Last selected node id
                 * 
                 * @type String|Void
                 */
                lastSelect = void 0,

                /**
                 * Fire elfinder "select" event and pass selected files to it
                 *
                 * @return void
                 */
                trigger = function () {
                    var selected = Object.keys(selectedFiles),
                        opts = {
                            selected: selected,
                            origin: 'cwd'
                        };

                    if (oldSchoolItem && (selected.length > 1 || selected[0] !== fm.cwdId2Hash(
                        oldSchoolItem.attr('id'))) && oldSchoolItem.hasClass(clSelected)) {
                        oldSchoolItem.trigger(evtUnselect);
                    }
                    allSelected = selected.length && (selected.length === (incHashes || cwdHashes).length) && (!fm.maxTargets || selected.length <= fm.maxTargets);
                    if (selectCheckbox) {
                        selectAllCheckbox.find('input').prop('checked', allSelected);
                        cwd[allSelected ? 'addClass' : 'removeClass']('elfinder-cwd-allselected');
                    }
                    if (allSelected) {
                        opts.selectall = true;
                    } else if (!selected.length) {
                        opts.unselectall = true;
                    }
                    fm.trigger('select', opts);
                },

                /**
                 * Scroll file to set it visible
                 *
                 * @param DOMElement  file/dir node
                 * @return void
                 */
                scrollToView = function (o, blink) {
                    if (!o.length) {
                        return;
                    }
                    var ftop = o.position().top,
                        fheight = o.outerHeight(true),
                        wtop = wrapper.scrollTop(),
                        wheight = wrapper.get(0).clientHeight,
                        thheight = tableHeader ? tableHeader.outerHeight(true) : 0;

                    if (ftop + thheight + fheight > wtop + wheight) {
                        wrapper.scrollTop(parseInt(ftop + thheight + fheight - wheight));
                    } else if (ftop < wtop) {
                        wrapper.scrollTop(ftop);
                    }
                    list && wrapper.scrollLeft(0);
                    !!blink && fm.resources.blink(o, 'lookme');
                },

                /**
                 * Files we get from server but not show yet
                 *
                 * @type Array
                 **/
                buffer = [],

                /**
                 * Extra data of buffer
                 *
                 * @type Object
                 **/
                bufferExt = {},

                /**
                 * Return index of elements with required hash in buffer 
                 *
                 * @param String  file hash
                 * @return Number
                 */
                index = function (hash) {
                    var l = buffer.length;

                    while (l--) {
                        if (buffer[l].hash == hash) {
                            return l;
                        }
                    }
                    return -1;
                },

                /**
                 * Scroll start event name
                 *
                 * @type String
                 **/
                scrollStartEvent = 'elfscrstart',

                /**
                 * Scroll stop event name
                 *
                 * @type String
                 **/
                scrollEvent = 'elfscrstop',

                scrolling = false,

                /**
                 * jQuery UI selectable option
                 * 
                 * @type Object
                 */
                selectableOption = {
                    disabled: true,
                    filter: '[id]:first',
                    stop: trigger,
                    delay: 250,
                    appendTo: 'body',
                    autoRefresh: false,
                    selected: function (e, ui) { $(ui.selected).trigger(evtSelect); },
                    unselected: function (e, ui) { $(ui.unselected).trigger(evtUnselect); }
                },

                /**
                 * hashes of items displayed in current view
                 * 
                 * @type Object  ItemHash => DomId
                 */
                inViewHashes = {},

                /**
                 * Processing when the current view is changed (On open, search, scroll, resize etc.)
                 * 
                 * @return void
                 */
                wrapperRepaint = function (init, recnt) {
                    if (!bufferExt.renderd) {
                        return;
                    }
                    var firstNode = (list ? cwd.find('tbody:first') : cwd).children('[id]' + (options.oldSchool ? ':not(.elfinder-cwd-parent)' : '') + ':first');
                    if (!firstNode.length) {
                        return;
                    }
                    var selectable = cwd.data('selectable'),
                        rec = (function () {
                            var wos = wrapper.offset(),
                                ww = wrapper.width(),
                                w = $(window),
                                x = firstNode.width() / 2,
                                l = Math.min(wos.left - w.scrollLeft() + (fm.direction === 'ltr' ? x : ww - x), wos.left + ww - 10),
                                t = wos.top - w.scrollTop() + 10 + (list ? thHeight : 0);
                            return { left: Math.max(0, Math.round(l)), top: Math.max(0, Math.round(t)) };
                        })(),
                        tgt = init ? firstNode : $(document.elementFromPoint(rec.left, rec.top)),
                        ids = {},
                        tmbs = {},
                        multi = 5,
                        cnt = Math.ceil((bufferExt.hpi ? Math.ceil((wz.data('rectangle').height / bufferExt.hpi) * 1.5) : showFiles) / multi),
                        chk = function () {
                            var id, hash, file, i;
                            for (i = 0; i < multi; i++) {
                                id = tgt.attr('id');
                                if (id) {
                                    bufferExt.getTmbs = [];
                                    hash = fm.cwdId2Hash(id);
                                    inViewHashes[hash] = id;
                                    // for tmbs
                                    if (bufferExt.attachTmbs[hash]) {
                                        tmbs[hash] = bufferExt.attachTmbs[hash];
                                    }
                                    // for selectable
                                    selectable && (ids[id] = true);
                                }
                                // next node
                                tgt = tgt.next();
                                if (!tgt.length) {
                                    break;
                                }
                            }
                        },
                        done = function () {
                            var idsArr;
                            if (cwd.data('selectable')) {
                                Object.assign(ids, selectedFiles);
                                idsArr = Object.keys(ids);
                                if (idsArr.length) {
                                    selectableOption.filter = '#' + idsArr.join(', #');
                                    cwd.selectable('enable').selectable('option', { filter: selectableOption.filter }).selectable('refresh');
                                }
                            }
                            if (Object.keys(tmbs).length) {
                                bufferExt.getTmbs = [];
                                attachThumbnails(tmbs);
                            }
                        },
                        setTarget = function () {
                            if (!tgt.hasClass(clFile)) {
                                tgt = tgt.closest(fileSelector);
                            }
                        },
                        arr, widget;

                    inViewHashes = {};
                    selectable && cwd.selectable('option', 'disabled');

                    if (tgt.length) {
                        if (!tgt.hasClass(clFile) && !tgt.closest(fileSelector).length) {
                            // dialog, serach button etc.
                            widget = fm.getUI().find('.ui-dialog:visible,.ui-widget:visible');
                            if (widget.length) {
                                widget.hide();
                                tgt = $(document.elementFromPoint(rec.left, rec.top));
                                widget.show();
                            } else {
                                widget = null;
                            }
                        }
                        setTarget();
                        if (!tgt.length) {
                            // try search 5px down
                            widget && widget.hide();
                            tgt = $(document.elementFromPoint(rec.left, rec.top + 5));
                            widget && widget.show();
                            setTarget();
                        }
                    }

                    if (tgt.length) {
                        if (tgt.attr('id')) {
                            if (init) {
                                for (var i = 0; i < cnt; i++) {
                                    chk();
                                    if (!tgt.length) {
                                        break;
                                    }
                                }
                                done();
                            } else {
                                bufferExt.repaintJob && bufferExt.repaintJob.state() === 'pending' && bufferExt.repaintJob.reject();
                                arr = new Array(cnt);
                                bufferExt.repaintJob = fm.asyncJob(function () {
                                    chk();
                                    if (!tgt.length) {
                                        done();
                                        bufferExt.repaintJob && bufferExt.repaintJob.state() === 'pending' && bufferExt.repaintJob.reject();
                                    }
                                }, arr).done(done);
                            }
                        }
                    } else if (init && bufferExt.renderd) {
                        // In initial request, cwd DOM not renderd so doing lazy check
                        recnt = recnt || 0;
                        if (recnt < 10) { // Prevent infinite loop
                            requestAnimationFrame(function () {
                                wrapperRepaint(init, ++recnt);
                            });
                        }
                    }
                },

                /**
                 * Item node of oldScholl ".."
                 */
                oldSchoolItem = null,

                /**
                 * display parent folder with ".." name
                 * 
                 * @param  String  phash
                 * @return void
                 */
                oldSchool = function (p) {
                    var phash = fm.cwd().phash,
                        pdir = fm.file(phash) || null,
                        set = function (pdir) {
                            if (pdir) {
                                oldSchoolItem = $(itemhtml($.extend(true, {}, pdir, { name: '..', i18: '..', mime: 'directory' })))
                                    .addClass('elfinder-cwd-parent')
                                    .on('dblclick', function () {
                                        fm.trigger('select', { selected: [phash] }).exec('open', phash);
                                    });
                                (list ? oldSchoolItem.children('td:first') : oldSchoolItem).children('.elfinder-cwd-select').remove();
                                if (fm.cwdHash2Elm(phash).length) {
                                    fm.cwdHash2Elm(phash).replaceWith(oldSchoolItem);
                                } else {
                                    (list ? cwd.find('tbody') : cwd).prepend(oldSchoolItem);
                                }
                                fm.draggingUiHelper && fm.draggingUiHelper.data('refreshPositions', 1);
                            }
                        };
                    if (pdir) {
                        set(pdir);
                    } else {
                        set({ hash: phash, read: true, write: true });
                        if (fm.getUI('tree').length) {
                            fm.one('parents', function () {
                                set(fm.file(phash) || null);
                                wrapper.trigger(scrollEvent);
                            });
                        } else {
                            fm.request({
                                data: { cmd: 'parents', target: fm.cwd().hash },
                                preventFail: true
                            })
                                .done(function (data) {
                                    set(fm.file(phash) || null);
                                    wrapper.trigger(scrollEvent);
                                });
                        }
                    }
                },

                showFiles = fm.options.showFiles,

                /**
                 * Cwd scroll event handler.
                 * Lazy load - append to cwd not shown files
                 *
                 * @return void
                 */
                render = function () {
                    if (bufferExt.rendering || (bufferExt.renderd && !buffer.length)) {
                        return;
                    }
                    var place = (list ? cwd.children('table').children('tbody') : cwd),
                        phash,
                        chk,
                        // created document fragment for jQuery >= 1.12, 2.2, 3.0
                        // see Studio-42/elFinder#1544 @ github
                        docFlag = $.htmlPrefilter ? true : false,
                        tempDom = docFlag ? $(document.createDocumentFragment()) : $('<div></div>'),
                        go = function (o) {
                            var over = o || null,
                                html = [],
                                dirs = false,
                                atmb = {},
                                stmb = (fm.option('tmbUrl') === 'self'),
                                init = bufferExt.renderd ? false : true,
                                files, locks, selected;

                            files = buffer.splice(0, showFiles + (over || 0) / (bufferExt.hpi || 1));
                            bufferExt.renderd += files.length;
                            if (!buffer.length) {
                                bottomMarker.hide();
                                wrapper.off(scrollEvent, render);
                            }

                            locks = [];
                            html = $.map(files, function (f) {
                                if (f.hash && f.name) {
                                    if (f.mime == 'directory') {
                                        dirs = true;
                                    }
                                    if ((f.tmb && (f.tmb != 1 || f.size > 0)) || (stmb && f.mime.indexOf('image/') === 0)) {
                                        atmb[f.hash] = f.tmb || 'self';
                                    }
                                    clipCuts[f.hash] && locks.push(f.hash);
                                    return itemhtml(f);
                                }
                                return null;
                            });

                            // html into temp node
                            tempDom.empty().append(html.join(''));

                            // make directory droppable
                            dirs && !mobile && makeDroppable(tempDom);

                            // check selected items
                            selected = [];
                            if (Object.keys(selectedFiles).length) {
                                tempDom.find('[id]:not(.' + clSelected + '):not(.elfinder-cwd-parent)').each(function () {
                                    selectedFiles[fm.cwdId2Hash(this.id)] && selected.push($(this));
                                });
                            }

                            // append to cwd
                            place.append(docFlag ? tempDom : tempDom.children());

                            // trigger select
                            if (selected.length) {
                                $.each(selected, function (i, n) { n.trigger(evtSelect); });
                                trigger();
                            }

                            locks.length && fm.trigger('lockfiles', { files: locks });
                            !bufferExt.hpi && bottomMarkerShow(place, files.length);

                            if (list) {
                                // show thead
                                cwd.find('thead').show();
                                // fixed table header
                                fixTableHeader({ fitWidth: !colWidth });
                            }

                            if (Object.keys(atmb).length) {
                                Object.assign(bufferExt.attachTmbs, atmb);
                            }

                            if (init) {
                                if (!mobile && !cwd.data('selectable')) {
                                    // make files selectable
                                    cwd.selectable(selectableOption).data('selectable', true);
                                }
                            }

                            !scrolling && wrapper.trigger(scrollEvent);
                        };

                    if (!bufferExt.renderd) {
                        // first time to go()
                        bufferExt.rendering = true;
                        // scroll top on dir load to avoid scroll after page reload
                        wrapper.scrollTop(0);
                        phash = fm.cwd().phash;
                        go();
                        if (options.oldSchool) {
                            if (phash && !query) {
                                oldSchool(phash);
                            } else {
                                oldSchoolItem = $();
                            }
                        }
                        if (list) {
                            colWidth && setColwidth();
                            fixTableHeader({ fitWidth: true });
                        }
                        bufferExt.itemH = (list ? place.find('tr:first') : place.find('[id]:first')).outerHeight(true);
                        fm.trigger('cwdrender');
                        bufferExt.rendering = false;
                        wrapperRepaint(true);
                    }
                    if (!bufferExt.rendering && buffer.length) {
                        // next go()
                        if ((chk = (wrapper.height() + wrapper.scrollTop() + fm.options.showThreshold + bufferExt.row) - (bufferExt.renderd * bufferExt.hpi)) > 0) {
                            bufferExt.rendering = true;
                            fm.lazy(function () {
                                go(chk);
                                bufferExt.rendering = false;
                            });
                        } else {
                            !fm.enabled() && resize();
                        }
                    } else {
                        resize();
                    }
                },

                // fixed table header jQuery object
                tableHeader = null,

                // Is UA support CSS sticky
                cssSticky = fm.UA.CSS.positionSticky && fm.UA.CSS.widthMaxContent,

                // To fixed table header colmun
                fixTableHeader = function (optsArg) {
                    thHeight = 0;
                    if (!options.listView.fixedHeader) {
                        return;
                    }
                    var setPos = function () {
                        var val, pos;
                        pos = (fm.direction === 'ltr') ? 'left' : 'right';
                        val = ((fm.direction === 'ltr') ? wrapper.scrollLeft() : table.outerWidth(true) - wrapper.width() - wrapper.scrollLeft()) * -1;
                        if (base.css(pos) !== val) {
                            base.css(pos, val);
                        }
                    },
                        opts = optsArg || {},
                        cnt, base, table, htable, thead, tbody, hheight, htr, btr, htd, btd, htw, btw, init;

                    tbody = cwd.find('tbody');
                    btr = tbody.children('tr:first');
                    if (btr.length && btr.is(':visible')) {
                        table = tbody.parent();
                        if (!tableHeader) {
                            init = true;
                            tbody.addClass('elfinder-cwd-fixheader');
                            thead = cwd.find('thead').attr('id', fm.namespace + '-cwd-thead');
                            htr = thead.children('tr:first');
                            hheight = htr.outerHeight(true);
                            cwd.css('margin-top', hheight - parseInt(table.css('padding-top')));
                            if (cssSticky) {
                                tableHeader = $('<div class="elfinder-table-header-sticky"></div>').addClass(cwd.attr('class')).append($('<table></table>').append(thead));
                                cwd.after(tableHeader);
                                wrapper.on('resize.fixheader', function (e) {
                                    e.stopPropagation();
                                    fixTableHeader({ fitWidth: true });
                                });
                            } else {
                                base = $('<div></div>').addClass(cwd.attr('class')).append($('<table></table>').append(thead));
                                tableHeader = $('<div></div>').addClass(wrapper.attr('class') + ' elfinder-cwd-fixheader')
                                    .removeClass('ui-droppable native-droppable')
                                    .css(wrapper.position())
                                    .css({ height: hheight, width: cwd.outerWidth() })
                                    .append(base);
                                if (fm.direction === 'rtl') {
                                    tableHeader.css('left', (wrapper.data('width') - wrapper.width()) + 'px');
                                }
                                setPos();
                                wrapper.after(tableHeader)
                                    .on('scroll.fixheader resize.fixheader', function (e) {
                                        setPos();
                                        if (e.type === 'resize') {
                                            e.stopPropagation();
                                            tableHeader.css(wrapper.position());
                                            wrapper.data('width', wrapper.css('overflow', 'hidden').width());
                                            wrapper.css('overflow', 'auto');
                                            fixTableHeader();
                                        }
                                    });
                            }
                        } else {
                            thead = $('#' + fm.namespace + '-cwd-thead');
                            htr = thead.children('tr:first');
                        }

                        if (init || opts.fitWidth || Math.abs(btr.outerWidth() - htr.outerWidth()) > 2) {
                            cnt = customCols.length + 1;
                            for (var i = 0; i < cnt; i++) {
                                htd = htr.children('td:eq(' + i + ')');
                                btd = btr.children('td:eq(' + i + ')');
                                htw = htd.width();
                                btw = btd.width();
                                if (typeof htd.data('delta') === 'undefined') {
                                    htd.data('delta', (htd.outerWidth() - htw) - (btd.outerWidth() - btw));
                                }
                                btw -= htd.data('delta');
                                if (!init && !opts.fitWidth && htw === btw) {
                                    break;
                                }
                                htd.css('width', btw + 'px');
                            }
                        }

                        if (!cssSticky) {
                            tableHeader.data('widthTimer') && cancelAnimationFrame(tableHeader.data('widthTimer'));
                            tableHeader.data('widthTimer', requestAnimationFrame(function () {
                                if (tableHeader) {
                                    tableHeader.css('width', mBoard.width() + 'px');
                                    if (fm.direction === 'rtl') {
                                        tableHeader.css('left', (wrapper.data('width') - wrapper.width()) + 'px');
                                    }
                                }
                            }));
                        }
                        thHeight = thead.height();
                    }
                },

                // Set colmun width
                setColwidth = function () {
                    if (list && colWidth) {
                        var cl = 'elfinder-cwd-colwidth',
                            first = cwd.find('tr[id]:first'),
                            former;
                        if (!first.hasClass(cl)) {
                            former = cwd.find('tr.' + cl);
                            former.removeClass(cl).find('td').css('width', '');
                            first.addClass(cl);
                            cwd.find('table:first').css('table-layout', 'fixed');
                            $.each($.merge(['name'], customCols), function (i, k) {
                                var w = colWidth[k] || first.find('td.elfinder-col-' + k).width();
                                first.find('td.elfinder-col-' + k).width(w);
                            });
                        }
                    }
                },

                /**
                 * Droppable options for cwd.
                 * Drop target is `wrapper`
                 * Do not add class on childs file over
                 *
                 * @type Object
                 */
                droppable = Object.assign({}, fm.droppable, {
                    over: function (e, ui) {
                        var dst = $(this),
                            helper = ui.helper,
                            ctr = fm._commands.copy && (e.shiftKey || e.ctrlKey || e.metaKey),
                            hash, status, inParent;
                        e.stopPropagation();
                        helper.data('dropover', helper.data('dropover') + 1);
                        dst.data('dropover', true);
                        helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus');
                        if (helper.data('namespace') !== fm.namespace || !fm.insideWorkzone(e.pageX, e.pageY)) {
                            dst.removeClass(clDropActive);
                            //helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus');
                            return;
                        }
                        if (dst.hasClass(fm.res(c, 'cwdfile'))) {
                            hash = fm.cwdId2Hash(dst.attr('id'));
                            dst.data('dropover', hash);
                        } else {
                            hash = fm.cwd().hash;
                            fm.cwd().write && dst.data('dropover', hash);
                        }
                        inParent = (fm.file(helper.data('files')[0]).phash === hash);
                        if (dst.data('dropover') === hash) {
                            $.each(helper.data('files'), function (i, h) {
                                if (h === hash || (inParent && !ctr && !helper.hasClass('elfinder-drag-helper-plus'))) {
                                    dst.removeClass(clDropActive);
                                    return false; // break $.each
                                }
                            });
                        } else {
                            dst.removeClass(clDropActive);
                        }
                        if (helper.data('locked') || inParent) {
                            status = 'elfinder-drag-helper-plus';
                        } else {
                            status = 'elfinder-drag-helper-move';
                            if (ctr) {
                                status += ' elfinder-drag-helper-plus';
                            }
                        }
                        dst.hasClass(clDropActive) && helper.addClass(status);
                        requestAnimationFrame(function () { dst.hasClass(clDropActive) && helper.addClass(status); });
                    },
                    out: function (e, ui) {
                        var helper = ui.helper;
                        e.stopPropagation();
                        helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus').data('dropover', Math.max(helper.data('dropover') - 1, 0));
                        $(this).removeData('dropover')
                            .removeClass(clDropActive);
                    },
                    deactivate: function () {
                        $(this).removeData('dropover')
                            .removeClass(clDropActive);
                    },
                    drop: function (e, ui) {
                        unselectAll({ notrigger: true });
                        fm.droppable.drop.call(this, e, ui);
                    }
                }),

                /**
                 * Make directory droppable
                 *
                 * @return void
                 */
                makeDroppable = function (place) {
                    place = place ? place : (list ? cwd.find('tbody') : cwd);
                    var targets = place.children('.directory:not(.' + clDroppable + ',.elfinder-na,.elfinder-ro)');

                    if (fm.isCommandEnabled('paste')) {
                        targets.droppable(droppable);
                    }
                    if (fm.isCommandEnabled('upload')) {
                        targets.addClass('native-droppable');
                    }

                    place.children('.isroot').each(function (i, n) {
                        var $n = $(n),
                            hash = fm.cwdId2Hash(n.id);

                        if (fm.isCommandEnabled('paste', hash)) {
                            if (!$n.hasClass(clDroppable + ',elfinder-na,elfinder-ro')) {
                                $n.droppable(droppable);
                            }
                        } else {
                            if ($n.hasClass(clDroppable)) {
                                $n.droppable('destroy');
                            }
                        }
                        if (fm.isCommandEnabled('upload', hash)) {
                            if (!$n.hasClass('native-droppable,elfinder-na,elfinder-ro')) {
                                $n.addClass('native-droppable');
                            }
                        } else {
                            if ($n.hasClass('native-droppable')) {
                                $n.removeClass('native-droppable');
                            }
                        }
                    });
                },

                /**
                 * Preload required thumbnails and on load add css to files.
                 * Return false if required file is not visible yet (in buffer) -
                 * required for old api to stop loading thumbnails.
                 *
                 * @param  Object  file hash -> thumbnail map
                 * @param  Bool    reload
                 * @return void
                 */
                attachThumbnails = function (tmbs, reload) {
                    var attach = function (node, tmb) {
                        $('<img/>')
                            .on('load', function () {
                                node.find('.elfinder-cwd-icon').addClass(tmb.className).css('background-image', "url('" + tmb.url + "')");
                            })
                            .attr('src', tmb.url);
                    },
                        chk = function (hash, tmb) {
                            var node = fm.cwdHash2Elm(hash),
                                file, tmbObj, reloads = [];

                            if (node.length) {
                                if (tmb != '1') {
                                    file = fm.file(hash);
                                    if (file.tmb !== tmb) {
                                        file.tmb = tmb;
                                    }
                                    tmbObj = fm.tmb(file);
                                    if (reload) {
                                        node.find('.elfinder-cwd-icon').addClass(tmbObj.className).css('background-image', "url('" + tmbObj.url + "')");
                                    } else {
                                        attach(node, tmbObj);
                                    }
                                    delete bufferExt.attachTmbs[hash];
                                } else {
                                    if (reload) {
                                        loadThumbnails([hash]);
                                    } else if (!bufferExt.tmbLoading[hash]) {
                                        bufferExt.getTmbs.push(hash);
                                    }
                                }
                            }
                        };

                    if ($.isPlainObject(tmbs) && Object.keys(tmbs).length) {
                        Object.assign(bufferExt.attachTmbs, tmbs);
                        $.each(tmbs, chk);
                        if (!reload && bufferExt.getTmbs.length && !Object.keys(bufferExt.tmbLoading).length) {
                            loadThumbnails();
                        }
                    }
                },

                /**
                 * Load thumbnails from backend.
                 *
                 * @param  Array|void reloads  hashes list for reload thumbnail items
                 * @return void
                 */
                loadThumbnails = function (reloads) {
                    var tmbs = [],
                        reload = false;

                    if (fm.oldAPI) {
                        fm.request({
                            data: { cmd: 'tmb', current: fm.cwd().hash },
                            preventFail: true
                        })
                            .done(function (data) {
                                if (data.images && Object.keys(data.images).length) {
                                    attachThumbnails(data.images);
                                }
                                if (data.tmb) {
                                    loadThumbnails();
                                }
                            });
                        return;
                    }

                    if (reloads) {
                        reload = true;
                        tmbs = reloads.splice(0, tmbNum);
                    } else {
                        tmbs = bufferExt.getTmbs.splice(0, tmbNum);
                    }
                    if (tmbs.length) {
                        if (reload || inViewHashes[tmbs[0]] || inViewHashes[tmbs[tmbs.length - 1]]) {
                            $.each(tmbs, function (i, h) {
                                bufferExt.tmbLoading[h] = true;
                            });
                            fm.request({
                                data: { cmd: 'tmb', targets: tmbs },
                                preventFail: true
                            })
                                .done(function (data) {
                                    var errs = [],
                                        resLen;
                                    if (data.images) {
                                        if (resLen = Object.keys(data.images).length) {
                                            if (resLen < tmbs.length) {
                                                $.each(tmbs, function (i, h) {
                                                    if (!data.images[h]) {
                                                        errs.push(h);
                                                    }
                                                });
                                            }
                                            attachThumbnails(data.images, reload);
                                        } else {
                                            errs = tmbs;
                                        }
                                        // unset error items from bufferExt.attachTmbs
                                        if (errs.length) {
                                            $.each(errs, function (i, h) {
                                                delete bufferExt.attachTmbs[h];
                                            });
                                        }
                                    }
                                    if (reload) {
                                        if (reloads.length) {
                                            loadThumbnails(reloads);
                                        }
                                    }
                                })
                                .always(function () {
                                    bufferExt.tmbLoading = {};
                                    if (!reload && bufferExt.getTmbs.length) {
                                        loadThumbnails();
                                    }
                                });
                        }
                    }
                },

                /**
                 * Add new files to cwd/buffer
                 *
                 * @param  Array  new files
                 * @return void
                 */
                add = function (files, mode) {
                    var place = list ? cwd.find('tbody') : cwd,
                        l = files.length,
                        atmb = {},
                        findNode = function (file) {
                            var pointer = cwd.find('[id]:first'), file2;

                            while (pointer.length) {
                                file2 = fm.file(fm.cwdId2Hash(pointer.attr('id')));
                                if (!pointer.hasClass('elfinder-cwd-parent') && file2 && fm.compare(file, file2) < 0) {
                                    return pointer;
                                }
                                pointer = pointer.next('[id]');
                            }
                        },
                        findIndex = function (file) {
                            var l = buffer.length, i;

                            for (i = 0; i < l; i++) {
                                if (fm.compare(file, buffer[i]) < 0) {
                                    return i;
                                }
                            }
                            return l || -1;
                        },
                        // created document fragment for jQuery >= 1.12, 2.2, 3.0
                        // see Studio-42/elFinder#1544 @ github
                        docFlag = $.htmlPrefilter ? true : false,
                        tempDom = docFlag ? $(document.createDocumentFragment()) : $('<div></div>'),
                        file, hash, node, nodes, ndx, stmb;

                    if (l > showFiles) {
                        // re-render for performance tune
                        content();
                        selectedFiles = fm.arrayFlip($.map(files, function (f) { return f.hash; }), true);
                        trigger();
                    } else {
                        // add the item immediately
                        l && wz.removeClass('elfinder-cwd-wrapper-empty');

                        // Self thumbnail
                        stmb = (fm.option('tmbUrl') === 'self');

                        while (l--) {
                            file = files[l];
                            hash = file.hash;

                            if (fm.cwdHash2Elm(hash).length) {
                                continue;
                            }

                            if ((node = findNode(file)) && !node.length) {
                                node = null;
                            }
                            if (!node && (ndx = findIndex(file)) >= 0) {
                                buffer.splice(ndx, 0, file);
                            } else {
                                tempDom.empty().append(itemhtml(file));
                                (file.mime === 'directory') && !mobile && makeDroppable(tempDom);
                                nodes = docFlag ? tempDom : tempDom.children();
                                if (node) {
                                    node.before(nodes);
                                } else {
                                    place.append(nodes);
                                }
                                ++bufferExt.renderd;
                            }

                            if (fm.cwdHash2Elm(hash).length) {
                                if ((file.tmb && (file.tmb != 1 || file.size > 0)) || (stmb && file.mime.indexOf('image/') === 0)) {
                                    atmb[hash] = file.tmb || 'self';
                                }
                            }
                        }

                        if (list) {
                            setColwidth();
                            fixTableHeader({ fitWidth: !colWidth });
                        }
                        bottomMarkerShow(place);
                        if (Object.keys(atmb).length) {
                            Object.assign(bufferExt.attachTmbs, atmb);
                            if (buffer.length < 1) {
                                loadThumbnails();
                            }
                        }
                    }
                },

                /**
                 * Remove files from cwd/buffer
                 *
                 * @param  Array  files hashes
                 * @return void
                 */
                remove = function (files) {
                    var l = files.length,
                        inSearch = fm.searchStatus.state > 1,
                        curCmd = fm.getCommand(fm.currentReqCmd) || {},
                        hash, n, ndx, found;

                    // removed cwd
                    if (!fm.cwd().hash && !curCmd.noChangeDirOnRemovedCwd) {
                        $.each(cwdParents.reverse(), function (i, h) {
                            if (fm.file(h)) {
                                found = true;
                                fm.one(fm.currentReqCmd + 'done', function () {
                                    !fm.cwd().hash && fm.exec('open', h);
                                });
                                return false;
                            }
                        });
                        // fallback to fm.roots[0]
                        !found && !fm.cwd().hash && fm.exec('open', fm.roots[Object.keys(fm.roots)[0]]);
                        return;
                    }

                    while (l--) {
                        hash = files[l];
                        if ((n = fm.cwdHash2Elm(hash)).length) {
                            try {
                                n.remove();
                                --bufferExt.renderd;
                            } catch (e) {
                                fm.debug('error', e);
                            }
                        } else if ((ndx = index(hash)) !== -1) {
                            buffer.splice(ndx, 1);
                        }
                        selectedFiles[hash] && delete selectedFiles[hash];
                        if (inSearch) {
                            if ((ndx = $.inArray(hash, cwdHashes)) !== -1) {
                                cwdHashes.splice(ndx, 1);
                            }
                        }
                    }

                    inSearch && fm.trigger('cwdhasheschange', cwdHashes);

                    if (list) {
                        setColwidth();
                        fixTableHeader({ fitWidth: !colWidth });
                    }
                },

                customColsNameBuild = function () {
                    var name = '',
                        customColsName = '';
                    for (var i = 0; i < customCols.length; i++) {
                        name = fm.getColumnName(customCols[i]);
                        customColsName += '<td class="elfinder-cwd-view-th-' + customCols[i] + ' sortable-item">' + name + '</td>';
                    }
                    return customColsName;
                },

                setItemBoxSize = function (boxSize) {
                    var place, elm;
                    if (!boxSize.height) {
                        place = (list ? cwd.find('tbody') : cwd);
                        elm = place.find(list ? 'tr:first' : '[id]:first');
                        boxSize.height = elm.outerHeight(true);
                        if (!list) {
                            boxSize.width = elm.outerWidth(true);
                        }
                    }
                },

                bottomMarkerShow = function (cur, cnt) {
                    var place = cur || (list ? cwd.find('tbody') : cwd),
                        boxSize = itemBoxSize[fm.viewType],
                        col = 1,
                        row;

                    if (buffer.length > 0) {
                        if (!bufferExt.hpi) {
                            setItemBoxSize(boxSize);
                            if (!list) {
                                col = Math.floor(place.width() / boxSize.width);
                                bufferExt.row = boxSize.height;
                                bufferExt.hpi = bufferExt.row / col;
                            } else {
                                bufferExt.row = bufferExt.hpi = boxSize.height;
                            }
                        } else if (!list) {
                            col = Math.floor(place.width() / boxSize.width);
                        }
                        row = Math.ceil((buffer.length + (cnt || 0)) / col);
                        if (list && tableHeader) {
                            ++row;
                        }
                        bottomMarker.css({ top: (bufferExt.row * row) + 'px' }).show();
                    }
                },

                wrapperContextMenu = {
                    contextmenu: function (e) {
                        e.preventDefault();
                        if (cwd.data('longtap') !== void (0)) {
                            e.stopPropagation();
                            return;
                        }
                        fm.trigger('contextmenu', {
                            'type': 'cwd',
                            'targets': [fm.cwd().hash],
                            'x': e.pageX,
                            'y': e.pageY
                        });
                    },
                    touchstart: function (e) {
                        if (e.originalEvent.touches.length > 1) {
                            return;
                        }
                        if (cwd.data('longtap') !== false) {
                            wrapper.data('touching', { x: e.originalEvent.touches[0].pageX, y: e.originalEvent.touches[0].pageY });
                            cwd.data('tmlongtap', setTimeout(function () {
                                // long tap
                                cwd.data('longtap', true);
                                fm.trigger('contextmenu', {
                                    'type': 'cwd',
                                    'targets': [fm.cwd().hash],
                                    'x': wrapper.data('touching').x,
                                    'y': wrapper.data('touching').y
                                });
                            }, 500));
                        }
                        cwd.data('longtap', null);
                    },
                    touchend: function (e) {
                        if (e.type === 'touchmove') {
                            if (!wrapper.data('touching') ||
                                (Math.abs(wrapper.data('touching').x - e.originalEvent.touches[0].pageX)
                                    + Math.abs(wrapper.data('touching').y - e.originalEvent.touches[0].pageY)) > 4) {
                                wrapper.data('touching', null);
                            }
                        } else {
                            setTimeout(function () {
                                cwd.removeData('longtap');
                            }, 80);
                        }
                        clearTimeout(cwd.data('tmlongtap'));
                    },
                    click: function (e) {
                        if (cwd.data('longtap')) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                },

                /**
                 * Update directory content
                 *
                 * @return void
                 */
                content = function () {
                    fm.lazy(function () {
                        var phash, emptyMethod, thtr;

                        wz.append(selectAllCheckbox).removeClass('elfinder-cwd-wrapper-empty elfinder-search-result elfinder-incsearch-result elfinder-letsearch-result');
                        if (fm.searchStatus.state > 1 || fm.searchStatus.ininc) {
                            wz.addClass('elfinder-search-result' + (fm.searchStatus.ininc ? ' elfinder-' + (query.substr(0, 1) === '/' ? 'let' : 'inc') + 'search-result' : ''));
                        }

                        // abort attachThumbJob
                        bufferExt.attachThumbJob && bufferExt.attachThumbJob._abort();

                        // destroy selectable for GC
                        cwd.data('selectable') && cwd.selectable('disable').selectable('destroy').removeData('selectable');

                        // notify cwd init
                        fm.trigger('cwdinit');

                        selectedNext = $();
                        try {
                            // to avoid problem with draggable
                            cwd.empty();
                        } catch (e) {
                            cwd.html('');
                        }

                        if (tableHeader) {
                            wrapper.off('scroll.fixheader resize.fixheader');
                            tableHeader.remove();
                            tableHeader = null;
                        }

                        cwd.removeClass('elfinder-cwd-view-icons elfinder-cwd-view-list')
                            .addClass('elfinder-cwd-view-' + (list ? 'list' : 'icons'))
                            .attr('style', '')
                            .css('height', 'auto');
                        bottomMarker.hide();

                        wrapper[list ? 'addClass' : 'removeClass']('elfinder-cwd-wrapper-list')._padding = parseInt(wrapper.css('padding-top')) + parseInt(wrapper.css('padding-bottom'));
                        if (fm.UA.iOS) {
                            wrapper.removeClass('overflow-scrolling-touch').addClass('overflow-scrolling-touch');
                        }

                        if (list) {
                            cwd.html('<table><thead></thead><tbody></tbody></table>');
                            thtr = $('<tr class="ui-state-default"><td class="elfinder-cwd-view-th-name">' + fm.getColumnName('name') + '</td>' + customColsNameBuild() + '</tr>');
                            cwd.find('thead').hide().append(thtr).find('td:first').append(selectAllCheckbox);
                            if ($.fn.sortable) {
                                thtr.addClass('touch-punch touch-punch-keep-default')
                                    .sortable({
                                        axis: 'x',
                                        distance: 8,
                                        items: '> .sortable-item',
                                        start: function (e, ui) {
                                            $(ui.item[0]).data('dragging', true);
                                            ui.placeholder
                                                .width(ui.helper.removeClass('ui-state-hover').width())
                                                .removeClass('ui-state-active')
                                                .addClass('ui-state-hover')
                                                .css('visibility', 'visible');
                                        },
                                        update: function (e, ui) {
                                            var target = $(ui.item[0]).attr('class').split(' ')[0].replace('elfinder-cwd-view-th-', ''),
                                                prev, done;
                                            customCols = $.map($(this).children(), function (n) {
                                                var name = $(n).attr('class').split(' ')[0].replace('elfinder-cwd-view-th-', '');
                                                if (!done) {
                                                    if (target === name) {
                                                        done = true;
                                                    } else {
                                                        prev = name;
                                                    }
                                                }
                                                return (name === 'name') ? null : name;
                                            });
                                            templates.row = makeTemplateRow();
                                            fm.storage('cwdCols', customCols);
                                            prev = '.elfinder-col-' + prev + ':first';
                                            target = '.elfinder-col-' + target + ':first';
                                            fm.lazy(function () {
                                                cwd.find('tbody tr').each(function () {
                                                    var $this = $(this);
                                                    $this.children(prev).after($this.children(target));
                                                });
                                            });
                                        },
                                        stop: function (e, ui) {
                                            setTimeout(function () {
                                                $(ui.item[0]).removeData('dragging');
                                            }, 100);
                                        }
                                    });
                            }

                            thtr.find('td').addClass('touch-punch').resizable({
                                handles: fm.direction === 'ltr' ? 'e' : 'w',
                                start: function (e, ui) {
                                    var target = cwd.find('td.elfinder-col-'
                                        + ui.element.attr('class').split(' ')[0].replace('elfinder-cwd-view-th-', '')
                                        + ':first');

                                    ui.element
                                        .data('dragging', true)
                                        .data('resizeTarget', target)
                                        .data('targetWidth', target.width());
                                    colResizing = true;
                                    if (cwd.find('table').css('table-layout') !== 'fixed') {
                                        cwd.find('tbody tr:first td').each(function () {
                                            $(this).width($(this).width());
                                        });
                                        cwd.find('table').css('table-layout', 'fixed');
                                    }
                                },
                                resize: function (e, ui) {
                                    ui.element.data('resizeTarget').width(ui.element.data('targetWidth') - (ui.originalSize.width - ui.size.width));
                                },
                                stop: function (e, ui) {
                                    colResizing = false;
                                    fixTableHeader({ fitWidth: true });
                                    colWidth = {};
                                    cwd.find('tbody tr:first td').each(function () {
                                        var name = $(this).attr('class').split(' ')[0].replace('elfinder-col-', '');
                                        colWidth[name] = $(this).width();
                                    });
                                    fm.storage('cwdColWidth', colWidth);
                                    setTimeout(function () {
                                        ui.element.removeData('dragging');
                                    }, 100);
                                }
                            })
                                .find('.ui-resizable-handle').addClass('ui-icon ui-icon-grip-dotted-vertical');
                        }

                        buffer = $.map(incHashes || cwdHashes, function (hash) { return fm.file(hash) || null; });

                        buffer = fm.sortFiles(buffer);

                        if (incHashes) {
                            incHashes = $.map(buffer, function (f) { return f.hash; });
                        } else {
                            cwdHashes = $.map(buffer, function (f) { return f.hash; });
                        }

                        bufferExt = {
                            renderd: 0,
                            attachTmbs: {},
                            getTmbs: [],
                            tmbLoading: {},
                            lazyOpts: { tm: 0 }
                        };

                        wz[(buffer.length < 1) ? 'addClass' : 'removeClass']('elfinder-cwd-wrapper-empty');
                        wrapper.off(scrollEvent, render).on(scrollEvent, render).trigger(scrollEvent);

                        // set droppable
                        if (!fm.cwd().write) {
                            wrapper.removeClass('native-droppable')
                                .droppable('disable')
                                .removeClass('ui-state-disabled'); // for old jQueryUI see https://bugs.jqueryui.com/ticket/5974
                        } else {
                            wrapper[fm.isCommandEnabled('upload') ? 'addClass' : 'removeClass']('native-droppable');
                            wrapper.droppable(fm.isCommandEnabled('paste') ? 'enable' : 'disable');
                        }
                    });
                },

                /**
                 * CWD node itself
                 *
                 * @type JQuery
                 **/
                cwd = $(this)
                    .addClass('ui-helper-clearfix elfinder-cwd')
                    .attr('unselectable', 'on')
                    // fix ui.selectable bugs and add shift+click support 
                    .on('click.' + fm.namespace, fileSelector, function (e) {
                        var p = this.id ? $(this) : $(this).parents('[id]:first'),
                            tgt = $(e.target),
                            prev,
                            next,
                            pl,
                            nl,
                            sib;

                        if (selectCheckbox && (tgt.is('input:checkbox.' + clSelChk) || tgt.hasClass('elfinder-cwd-select'))) {
                            e.stopPropagation();
                            e.preventDefault();
                            p.trigger(p.hasClass(clSelected) ? evtUnselect : evtSelect);
                            trigger();
                            requestAnimationFrame(function () {
                                tgt.prop('checked', p.hasClass(clSelected));
                            });
                            return;
                        }

                        if (cwd.data('longtap') || tgt.hasClass('elfinder-cwd-nonselect')) {
                            e.stopPropagation();
                            return;
                        }

                        if (!curClickId) {
                            curClickId = p.attr('id');
                            setTimeout(function () {
                                curClickId = '';
                            }, 500);
                        }

                        if (e.shiftKey) {
                            prev = p.prevAll(lastSelect || '.' + clSelected + ':first');
                            next = p.nextAll(lastSelect || '.' + clSelected + ':first');
                            pl = prev.length;
                            nl = next.length;
                        }
                        if (e.shiftKey && (pl || nl)) {
                            sib = pl ? p.prevUntil('#' + prev.attr('id')) : p.nextUntil('#' + next.attr('id'));
                            sib = sib.add(p);
                            if (!pl) {
                                sib = $(sib.get().reverse());
                            }
                            sib.trigger(evtSelect);
                        } else if (e.ctrlKey || e.metaKey) {
                            p.trigger(p.hasClass(clSelected) ? evtUnselect : evtSelect);
                        } else {
                            if (wrapper.data('touching') && p.hasClass(clSelected)) {
                                wrapper.data('touching', null);
                                fm.dblclick({ file: fm.cwdId2Hash(this.id) });
                                return;
                            } else {
                                unselectAll({ notrigger: true });
                                p.trigger(evtSelect);
                            }
                        }

                        trigger();
                    })
                    // call fm.open()
                    .on('dblclick.' + fm.namespace, fileSelector, function (e) {
                        if (curClickId) {
                            var hash = fm.cwdId2Hash(curClickId);
                            e.stopPropagation();
                            if (this.id !== curClickId) {
                                $(this).trigger(evtUnselect);
                                $('#' + curClickId).trigger(evtSelect);
                                trigger();
                            }
                            fm.dblclick({ file: hash });
                        }
                    })
                    // for touch device
                    .on('touchstart.' + fm.namespace, fileSelector, function (e) {
                        if (e.originalEvent.touches.length > 1) {
                            return;
                        }
                        var p = this.id ? $(this) : $(this).parents('[id]:first'),
                            tgt = $(e.target),
                            nodeName = e.target.nodeName,
                            sel;

                        if ((nodeName === 'INPUT' && e.target.type === 'text') || nodeName === 'TEXTAREA' || tgt.hasClass('elfinder-cwd-nonselect')) {
                            e.stopPropagation();
                            return;
                        }

                        // now name editing
                        if (p.find('input:text,textarea').length) {
                            e.stopPropagation();
                            e.preventDefault();
                            return;
                        }

                        wrapper.data('touching', { x: e.originalEvent.touches[0].pageX, y: e.originalEvent.touches[0].pageY });
                        if (selectCheckbox && (tgt.is('input:checkbox.' + clSelChk) || tgt.hasClass('elfinder-cwd-select'))) {
                            return;
                        }

                        sel = p.prevAll('.' + clSelected + ':first').length +
                            p.nextAll('.' + clSelected + ':first').length;
                        cwd.data('longtap', null);
                        if (Object.keys(selectedFiles).length
                            ||
                            (list && e.target.nodeName !== 'TD')
                            ||
                            (!list && this !== e.target)
                        ) {
                            cwd.data('longtap', false);
                            p.addClass(clHover);
                            p.data('tmlongtap', setTimeout(function () {
                                // long tap
                                cwd.data('longtap', true);
                                p.trigger(evtSelect);
                                trigger();
                                fm.trigger('contextmenu', {
                                    'type': 'files',
                                    'targets': fm.selected(),
                                    'x': e.originalEvent.touches[0].pageX,
                                    'y': e.originalEvent.touches[0].pageY
                                });
                            }, 500));
                        }
                    })
                    .on('touchmove.' + fm.namespace + ' touchend.' + fm.namespace, fileSelector, function (e) {
                        var tgt = $(e.target),
                            p;
                        if (selectCheckbox && (tgt.is('input:checkbox.' + clSelChk) || tgt.hasClass('elfinder-cwd-select'))) {
                            return;
                        }
                        if (e.target.nodeName == 'INPUT' || e.target.nodeName == 'TEXTAREA') {
                            e.stopPropagation();
                            return;
                        }
                        p = this.id ? $(this) : $(this).parents('[id]:first');
                        clearTimeout(p.data('tmlongtap'));
                        if (e.type === 'touchmove') {
                            wrapper.data('touching', null);
                            p.removeClass(clHover);
                        } else {
                            if (wrapper.data('touching') && !cwd.data('longtap') && p.hasClass(clSelected)) {
                                e.preventDefault();
                                wrapper.data('touching', null);
                                fm.dblclick({ file: fm.cwdId2Hash(this.id) });
                            }
                            setTimeout(function () {
                                cwd.removeData('longtap');
                            }, 80);
                        }
                    })
                    // attach draggable
                    .on('mouseenter.' + fm.namespace, fileSelector, function (e) {
                        if (scrolling) { return; }
                        var $this = $(this), helper = null;

                        if (!mobile && !$this.data('dragRegisted') && !$this.hasClass(clTmp) && !$this.hasClass(clDraggable) && !$this.hasClass(clDisabled)) {
                            $this.data('dragRegisted', true);
                            if (!fm.isCommandEnabled('copy', fm.searchStatus.state > 1 || $this.hasClass('isroot') ? fm.cwdId2Hash($this.attr('id')) : void 0) &&
                                !fm.isCommandEnabled('cut', fm.searchStatus.state > 1 || $this.hasClass('isroot') ? fm.cwdId2Hash($this.attr('id')) : void 0)) {
                                return;
                            }
                            $this.on('mousedown', function (e) {
                                // shiftKey or altKey + drag start for HTML5 native drag function
                                // Note: can no use shiftKey with the Google Chrome 
                                var metaKey = options.metakeyDragout && !fm.UA.IE && (e.shiftKey || e.altKey),
                                    disable = false;
                                if (metaKey && cwd.data('selectable')) {
                                    // destroy jQuery-ui selectable while trigger native drag
                                    cwd.selectable('disable').selectable('destroy').removeData('selectable');
                                    requestAnimationFrame(function () {
                                        cwd.selectable(selectableOption).selectable('option', { disabled: false }).selectable('refresh').data('selectable', true);
                                    });
                                }
                                $this.removeClass('ui-state-disabled');
                                if (metaKey) {
                                    $this.draggable('option', 'disabled', true).attr('draggable', 'true');
                                } else {
                                    if (!$this.hasClass(clSelected)) {
                                        if (list) {
                                            disable = $(e.target).closest('span,tr').is('tr');
                                        } else {
                                            disable = $(e.target).hasClass('elfinder-cwd-file');
                                        }
                                    }
                                    if (disable) {
                                        // removeClass('ui-state-disabled') for old version of jQueryUI
                                        $this.draggable('option', 'disabled', true).removeClass('ui-state-disabled');
                                    } else {
                                        $this.draggable('option', 'disabled', false)
                                            .removeAttr('draggable')
                                            .draggable('option', 'cursorAt', { left: 50 - parseInt($(e.currentTarget).css('margin-left')), top: 47 });
                                    }
                                }
                            })
                                .on('dragstart', function (e) {
                                    var dt = e.dataTransfer || e.originalEvent.dataTransfer || null;
                                    helper = null;
                                    if (dt && !fm.UA.IE) {
                                        var p = this.id ? $(this) : $(this).parents('[id]:first'),
                                            elm = $('<span>'),
                                            url = '',
                                            durl = null,
                                            murl = null,
                                            files = [],
                                            icon = function (f) {
                                                var mime = f.mime, i, tmb = fm.tmb(f);
                                                i = '<div class="elfinder-cwd-icon elfinder-cwd-icon-drag ' + fm.mime2class(mime) + ' ui-corner-all"></div>';
                                                if (tmb) {
                                                    i = $(i).addClass(tmb.className).css('background-image', "url('" + tmb.url + "')").get(0).outerHTML;
                                                }
                                                return i;
                                            }, l, geturl = [];
                                        p.trigger(evtSelect);
                                        trigger();
                                        $.each(selectedFiles, function (v) {
                                            var file = fm.file(v),
                                                furl = file.url;
                                            if (file && file.mime !== 'directory') {
                                                if (!furl) {
                                                    furl = fm.url(file.hash);
                                                } else if (furl == '1') {
                                                    geturl.push(v);
                                                    return true;
                                                }
                                                if (furl) {
                                                    furl = fm.convAbsUrl(furl);
                                                    files.push(v);
                                                    $('<a>').attr('href', furl).text(furl).appendTo(elm);
                                                    url += furl + "\n";
                                                    if (!durl) {
                                                        durl = file.mime + ':' + file.name + ':' + furl;
                                                    }
                                                    if (!murl) {
                                                        murl = furl + "\n" + file.name;
                                                    }
                                                }
                                            }
                                        });
                                        if (geturl.length) {
                                            $.each(geturl, function (i, v) {
                                                var rfile = fm.file(v);
                                                rfile.url = '';
                                                fm.request({
                                                    data: { cmd: 'url', target: v },
                                                    notify: { type: 'url', cnt: 1 },
                                                    preventDefault: true
                                                })
                                                    .always(function (data) {
                                                        rfile.url = data.url ? data.url : '1';
                                                    });
                                            });
                                            return false;
                                        } else if (url) {
                                            if (dt.setDragImage) {
                                                helper = $('<div class="elfinder-drag-helper html5-native"></div>').append(icon(fm.file(files[0]))).appendTo($(document.body));
                                                if ((l = files.length) > 1) {
                                                    helper.append(icon(fm.file(files[l - 1])) + '<span class="elfinder-drag-num">' + l + '</span>');
                                                }
                                                dt.setDragImage(helper.get(0), 50, 47);
                                            }
                                            dt.effectAllowed = 'copyLink';
                                            dt.setData('DownloadURL', durl);
                                            dt.setData('text/x-moz-url', murl);
                                            dt.setData('text/uri-list', url);
                                            dt.setData('text/plain', url);
                                            dt.setData('text/html', elm.html());
                                            dt.setData('elfinderfrom', window.location.href + fm.cwd().hash);
                                            dt.setData('elfinderfrom:' + dt.getData('elfinderfrom'), '');
                                        } else {
                                            return false;
                                        }
                                    }
                                })
                                .on('dragend', function (e) {
                                    unselectAll({ notrigger: true });
                                    helper && helper.remove();
                                })
                                .draggable(fm.draggable);
                        }
                    })
                    // add hover class to selected file
                    .on(evtSelect, fileSelector, function (e) {
                        var $this = $(this),
                            id = fm.cwdId2Hash($this.attr('id'));

                        if (!selectLock && !$this.hasClass(clDisabled)) {
                            lastSelect = '#' + this.id;
                            $this.addClass(clSelected).children().addClass(clHover).find('input:checkbox.' + clSelChk).prop('checked', true);
                            if (!selectedFiles[id]) {
                                selectedFiles[id] = true;
                            }
                            // will be selected next
                            selectedNext = cwd.find('[id].' + clSelected + ':last').next();
                        }
                    })
                    // remove hover class from unselected file
                    .on(evtUnselect, fileSelector, function (e) {
                        var $this = $(this),
                            id = fm.cwdId2Hash($this.attr('id'));

                        if (!selectLock) {
                            $this.removeClass(clSelected).children().removeClass(clHover).find('input:checkbox.' + clSelChk).prop('checked', false);
                            if (cwd.hasClass('elfinder-cwd-allselected')) {
                                selectCheckbox && selectAllCheckbox.children('input').prop('checked', false);
                                cwd.removeClass('elfinder-cwd-allselected');
                            }
                            selectedFiles[id] && delete selectedFiles[id];
                        }

                    })
                    // disable files wich removing or moving
                    .on(evtDisable, fileSelector, function () {
                        var $this = $(this).removeClass(clHover + ' ' + clSelected).addClass(clDisabled),
                            child = $this.children(),
                            target = (list ? $this : child.find('div.elfinder-cwd-file-wrapper,div.elfinder-cwd-filename'));

                        child.removeClass(clHover + ' ' + clSelected);

                        $this.hasClass(clDroppable) && $this.droppable('disable');
                        target.hasClass(clDraggable) && target.draggable('disable');
                    })
                    // if any files was not removed/moved - unlock its
                    .on(evtEnable, fileSelector, function () {
                        var $this = $(this).removeClass(clDisabled),
                            target = list ? $this : $this.children('div.elfinder-cwd-file-wrapper,div.elfinder-cwd-filename');

                        $this.hasClass(clDroppable) && $this.droppable('enable');
                        target.hasClass(clDraggable) && target.draggable('enable');
                    })
                    .on('scrolltoview', fileSelector, function (e, data) {
                        scrollToView($(this), (data && typeof data.blink !== 'undefined') ? data.blink : true);
                    })
                    .on('mouseenter.' + fm.namespace + ' mouseleave.' + fm.namespace, fileSelector, function (e) {
                        var enter = (e.type === 'mouseenter');
                        if (enter && (scrolling || fm.UA.Mobile)) { return; }
                        fm.trigger('hover', { hash: fm.cwdId2Hash($(this).attr('id')), type: e.type });
                        $(this).toggleClass(clHover, (e.type == 'mouseenter'));
                    })
                    // for file contextmenu
                    .on('mouseenter.' + fm.namespace + ' mouseleave.' + fm.namespace, '.elfinder-cwd-file-wrapper,.elfinder-cwd-filename', function (e) {
                        var enter = (e.type === 'mouseenter');
                        if (enter && scrolling) { return; }
                        $(this).closest(fileSelector).children('.elfinder-cwd-file-wrapper,.elfinder-cwd-filename').toggleClass(clActive, (e.type == 'mouseenter'));
                    })
                    .on('contextmenu.' + fm.namespace, function (e) {
                        var file = $(e.target).closest(fileSelector);

                        if (file.get(0) === e.target && !selectedFiles[fm.cwdId2Hash(file.get(0).id)]) {
                            return;
                        }

                        // now filename editing
                        if (file.find('input:text,textarea').length) {
                            e.stopPropagation();
                            return;
                        }

                        if (file.length && (e.target.nodeName != 'TD' || selectedFiles[fm.cwdId2Hash(file.get(0).id)])) {
                            e.stopPropagation();
                            e.preventDefault();
                            if (!file.hasClass(clDisabled) && !wrapper.data('touching')) {
                                if (!file.hasClass(clSelected)) {
                                    unselectAll({ notrigger: true });
                                    file.trigger(evtSelect);
                                    trigger();
                                }
                                fm.trigger('contextmenu', {
                                    'type': 'files',
                                    'targets': fm.selected(),
                                    'x': e.pageX,
                                    'y': e.pageY
                                });

                            }

                        }
                    })
                    // unselect all on cwd click
                    .on('click.' + fm.namespace, function (e) {
                        if (e.target === this && !cwd.data('longtap')) {
                            !e.shiftKey && !e.ctrlKey && !e.metaKey && unselectAll();
                        }
                    })
                    // prepend fake file/dir
                    .on('create.' + fm.namespace, function (e, f) {
                        var parent = list ? cwd.find('tbody') : cwd,
                            p = parent.find('.elfinder-cwd-parent'),
                            lock = f.move || false,
                            file = $(itemhtml(f)).addClass(clTmp),
                            selected = fm.selected();

                        if (selected.length) {
                            lock && fm.trigger('lockfiles', { files: selected });
                        } else {
                            unselectAll();
                        }

                        if (p.length) {
                            p.after(file);
                        } else {
                            parent.prepend(file);
                        }

                        setColwidth();
                        wrapper.scrollTop(0).scrollLeft(0);
                    })
                    // unselect all selected files
                    .on('unselectall', unselectAll)
                    .on('selectfile', function (e, id) {
                        fm.cwdHash2Elm(id).trigger(evtSelect);
                        trigger();
                    })
                    .on('colwidth', function () {
                        if (list) {
                            cwd.find('table').css('table-layout', '')
                                .find('td').css('width', '');
                            fixTableHeader({ fitWidth: true });
                            fm.storage('cwdColWidth', colWidth = null);
                        }
                    })
                    .on('iconpref', function (e, data) {
                        cwd.removeClass(function (i, cName) {
                            return (cName.match(/\belfinder-cwd-size\S+/g) || []).join(' ');
                        });
                        iconSize = data ? (parseInt(data.size) || 0) : 0;
                        if (!list) {
                            if (iconSize > 0) {
                                cwd.addClass('elfinder-cwd-size' + iconSize);
                            }
                            if (bufferExt.renderd) {
                                requestAnimationFrame(function () {
                                    itemBoxSize.icons = {};
                                    bufferExt.hpi = null;
                                    bottomMarkerShow(cwd, bufferExt.renderd);
                                    wrapperRepaint();
                                });
                            }
                        }
                    })
                    // Change icon size with mouse wheel event
                    .on('onwheel' in document ? 'wheel' : 'mousewheel', function (e) {
                        var tm, size, delta;
                        if (!list && ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey))) {
                            e.stopPropagation();
                            e.preventDefault();
                            tm = cwd.data('wheelTm');
                            if (typeof tm !== 'undefined') {
                                clearTimeout(tm);
                                cwd.data('wheelTm', setTimeout(function () {
                                    cwd.removeData('wheelTm');
                                }, 200));
                            } else {
                                cwd.data('wheelTm', false);
                                size = iconSize || 0;
                                delta = e.originalEvent.deltaY ? e.originalEvent.deltaY : -(e.originalEvent.wheelDelta);
                                if (delta > 0) {
                                    if (iconSize > 0) {
                                        size = iconSize - 1;
                                    }
                                } else {
                                    if (iconSize < options.iconsView.sizeMax) {
                                        size = iconSize + 1;
                                    }
                                }
                                if (size !== iconSize) {
                                    fm.storage('iconsize', size);
                                    cwd.trigger('iconpref', { size: size });
                                }
                            }
                        }
                    }),
                wrapper = $('<div class="elfinder-cwd-wrapper"></div>')
                    // make cwd itself droppable for folders from nav panel
                    .droppable(Object.assign({}, droppable, { autoDisable: false }))
                    .on('contextmenu.' + fm.namespace, wrapperContextMenu.contextmenu)
                    .on('touchstart.' + fm.namespace, wrapperContextMenu.touchstart)
                    .on('touchmove.' + fm.namespace + ' touchend.' + fm.namespace, wrapperContextMenu.touchend)
                    .on('click.' + fm.namespace, wrapperContextMenu.click)
                    .on('scroll.' + fm.namespace, function () {
                        if (!scrolling) {
                            cwd.data('selectable') && cwd.selectable('disable');
                            wrapper.trigger(scrollStartEvent);
                        }
                        scrolling = true;
                        bufferExt.scrtm && cancelAnimationFrame(bufferExt.scrtm);
                        if (bufferExt.scrtm && Math.abs((bufferExt.scrolltop || 0) - (bufferExt.scrolltop = (this.scrollTop || $(this).scrollTop()))) < 5) {
                            bufferExt.scrtm = 0;
                            wrapper.trigger(scrollEvent);
                        }
                        bufferExt.scrtm = requestAnimationFrame(function () {
                            bufferExt.scrtm = 0;
                            wrapper.trigger(scrollEvent);
                        });
                    })
                    .on(scrollEvent, function () {
                        scrolling = false;
                        wrapperRepaint();
                    }),

                bottomMarker = $('<div>&nbsp;</div>')
                    .css({ position: 'absolute', width: '1px', height: '1px' })
                    .hide(),

                selectAllCheckbox = selectCheckbox ? $('<div class="elfinder-cwd-selectall"><input type="checkbox"/></div>')
                    .attr('title', fm.i18n('selectall'))
                    .on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if ($(this).data('pending')) {
                            return false;
                        }
                        selectAllCheckbox.data('pending', true);
                        if (cwd.hasClass('elfinder-cwd-allselected')) {
                            selectAllCheckbox.find('input').prop('checked', false);
                            requestAnimationFrame(function () {
                                unselectAll();
                            });
                        } else {
                            selectAll();
                        }
                    }) : $(),

                restm = null,
                resize = function (init) {
                    var initHeight = function () {
                        if (typeof bufferExt.renderd !== 'undefined') {
                            var h = 0;
                            wrapper.siblings('div.elfinder-panel:visible').each(function () {
                                h += $(this).outerHeight(true);
                            });
                            wrapper.height(wz.height() - h - wrapper._padding);
                        }
                    };

                    init && initHeight();

                    restm && cancelAnimationFrame(restm);
                    restm = requestAnimationFrame(function () {
                        !init && initHeight();
                        var wph, cwdoh;
                        // fix cwd height if it less then wrapper
                        cwd.css('height', 'auto');
                        wph = wrapper[0].clientHeight - parseInt(wrapper.css('padding-top')) - parseInt(wrapper.css('padding-bottom')) - parseInt(cwd.css('margin-top')),
                            cwdoh = cwd.outerHeight(true);
                        if (cwdoh < wph) {
                            cwd.height(wph);
                        }
                    });

                    list && !colResizing && (init ? wrapper.trigger('resize.fixheader') : fixTableHeader());

                    wrapperRepaint();
                },

                // elfinder node
                parent = $(this).parent().on('resize', resize),

                // workzone node 
                wz = parent.children('.elfinder-workzone').append(wrapper.append(this).append(bottomMarker)),

                // message board
                mBoard = $('<div class="elfinder-cwd-message-board"></div>').insertAfter(cwd),

                // Volume expires
                vExpires = $('<div class="elfinder-cwd-expires" ></div>'),

                vExpiresTm,

                showVolumeExpires = function () {
                    var remain, sec, int;
                    vExpiresTm && clearTimeout(vExpiresTm);
                    if (curVolId && fm.volumeExpires[curVolId]) {
                        sec = fm.volumeExpires[curVolId] - ((+new Date()) / 1000);
                        int = (sec % 60) + 0.1;
                        remain = Math.floor(sec / 60);
                        vExpires.html(fm.i18n(['minsLeft', remain])).show();
                        if (remain) {
                            vExpiresTm = setTimeout(showVolumeExpires, int * 1000);
                        }
                    }
                },

                // each item box size
                itemBoxSize = {
                    icons: {},
                    list: {}
                },

                // has UI tree
                hasUiTree,

                // Icon size of icons view
                iconSize,

                // Current volume id
                curVolId,

                winScrTm;

            // IE < 11 not support CSS `pointer-events: none`
            if (!fm.UA.ltIE10) {
                mBoard.append($('<div class="elfinder-cwd-trash" ></div>').html(fm.i18n('volume_Trash')))
                    .append(vExpires);
            }

            // setup by options
            replacement = Object.assign(replacement, options.replacement || {});

            try {
                colWidth = fm.storage('cwdColWidth') ? fm.storage('cwdColWidth') : null;
            } catch (e) {
                colWidth = null;
            }

            // setup costomCols
            fm.bind('columnpref', function (e) {
                var opts = e.data || {};
                if (customCols = fm.storage('cwdCols')) {
                    customCols = $.grep(customCols, function (n) {
                        return (options.listView.columns.indexOf(n) !== -1) ? true : false;
                    });
                    if (options.listView.columns.length > customCols.length) {
                        $.each(options.listView.columns, function (i, n) {
                            if (customCols.indexOf(n) === -1) {
                                customCols.push(n);
                            }
                        });
                    }
                } else {
                    customCols = options.listView.columns;
                }
                // column names array that hidden
                var columnhides = fm.storage('columnhides') || null;
                if (columnhides && Object.keys(columnhides).length)
                    customCols = $.grep(customCols, function (n) {
                        return columnhides[n] ? false : true;
                    });
                // make template with customCols
                templates.row = makeTemplateRow();
                // repaint if need it
                list && opts.repaint && content();
            }).trigger('columnpref');

            if (mobile) {
                // for iOS5 bug
                $('body').on('touchstart touchmove touchend', function (e) { });
            }

            selectCheckbox && cwd.addClass('elfinder-has-checkbox');

            $(window).on('scroll.' + fm.namespace, function () {
                winScrTm && cancelAnimationFrame(winScrTm);
                winScrTm = requestAnimationFrame(function () {
                    wrapper.trigger(scrollEvent);
                });
            });

            $(document).on('keydown.' + fm.namespace, function (e) {
                if (e.keyCode == $.ui.keyCode.ESCAPE) {
                    if (!fm.getUI().find('.ui-widget:visible').length) {
                        unselectAll();
                    }
                }
            });

            fm
                .one('init', function () {
                    var style = document.createElement('style'),
                        sheet, node, base, resizeTm, iconSize, i = 0;
                    if (document.head) {
                        document.head.appendChild(style);
                        sheet = style.sheet;
                        sheet.insertRule('.elfinder-cwd-wrapper-empty .elfinder-cwd:not(.elfinder-table-header-sticky):after{ content:"' + fm.i18n('emptyFolder') + '" }', i++);
                        sheet.insertRule('.elfinder-cwd-wrapper-empty .native-droppable .elfinder-cwd:not(.elfinder-table-header-sticky):after{ content:"' + fm.i18n('emptyFolder' + (mobile ? 'LTap' : 'Drop')) + '" }', i++);
                        sheet.insertRule('.elfinder-cwd-wrapper-empty .ui-droppable-disabled .elfinder-cwd:not(.elfinder-table-header-sticky):after{ content:"' + fm.i18n('emptyFolder') + '" }', i++);
                        sheet.insertRule('.elfinder-cwd-wrapper-empty.elfinder-search-result .elfinder-cwd:not(.elfinder-table-header-sticky):after{ content:"' + fm.i18n('emptySearch') + '" }', i++);
                        sheet.insertRule('.elfinder-cwd-wrapper-empty.elfinder-search-result.elfinder-incsearch-result .elfinder-cwd:not(.elfinder-table-header-sticky):after{ content:"' + fm.i18n('emptyIncSearch') + '" }', i++);
                        sheet.insertRule('.elfinder-cwd-wrapper-empty.elfinder-search-result.elfinder-letsearch-result .elfinder-cwd:not(.elfinder-table-header-sticky):after{ content:"' + fm.i18n('emptyLetSearch') + '" }', i++);
                    }
                    if (iconSize = (fm.storage('iconsize') || options.iconsView.size || 0)) {
                        iconSize = Math.min(iconSize, options.iconsView.sizeMax);
                        cwd.trigger('iconpref', { size: iconSize });
                    }
                    if (!mobile) {
                        fm.one('open', function () {
                            sheet && fm.zIndex && sheet.insertRule('.ui-selectable-helper{z-index:' + fm.zIndex + ';}', i++);
                        });
                        base = $('<div style="position:absolute"></div>');
                        node = fm.getUI();
                        node.on('resize', function (e, data) {
                            var offset;
                            e.preventDefault();
                            e.stopPropagation();
                            if (data && data.fullscreen) {
                                offset = node.offset();
                                if (data.fullscreen === 'on') {
                                    base.css({ top: offset.top * -1, left: offset.left * -1 }).appendTo(node);
                                    selectableOption.appendTo = base;
                                } else {
                                    base.detach();
                                    selectableOption.appendTo = 'body';
                                }
                                cwd.data('selectable') && cwd.selectable('option', { appendTo: selectableOption.appendTo });
                            }
                        });
                    }
                    hasUiTree = fm.getUI('tree').length;
                })
                .bind('enable', function () {
                    resize();
                })
                .bind('request.open', function () {
                    bufferExt.getTmbs = [];
                })
                .one('open', function () {
                    if (fm.maxTargets) {
                        tmbNum = Math.min(fm.maxTargets, tmbNum);
                    }
                })
                .bind('open add remove searchend', function () {
                    var phash = fm.cwd().hash,
                        type = this.type;
                    if (type === 'open' || type === 'searchend' || fm.searchStatus.state < 2) {
                        cwdHashes = $.map(fm.files(phash), function (f) { return f.hash; });
                        fm.trigger('cwdhasheschange', cwdHashes);
                    }
                    if (type === 'open') {
                        var inTrash = function () {
                            var isIn = false;
                            $.each(cwdParents, function (i, h) {
                                if (fm.trashes[h]) {
                                    isIn = true;
                                    return false;
                                }
                            });
                            return isIn;
                        },
                            req = phash ?
                                (!fm.file(phash) || hasUiTree ?
                                    (!hasUiTree ?
                                        fm.request({
                                            data: {
                                                cmd: 'parents',
                                                target: fm.cwd().hash
                                            },
                                            preventFail: true
                                        }) : (function () {
                                            var dfd = $.Deferred();
                                            fm.one('treesync', function (e) {
                                                e.data.always(function () {
                                                    dfd.resolve();
                                                });
                                            });
                                            return dfd;
                                        })()
                                    ) : null
                                ) : null,
                            cwdObj = fm.cwd();
                        // add/remove volume id class
                        if (cwdObj.volumeid !== curVolId) {
                            vExpires.empty().hide();
                            if (curVolId) {
                                wrapper.removeClass('elfinder-cwd-wrapper-' + curVolId);
                            }
                            curVolId = cwdObj.volumeid;
                            showVolumeExpires();
                            wrapper.addClass('elfinder-cwd-wrapper-' + curVolId);
                        }
                        // add/remove trash class
                        $.when(req).done(function () {
                            cwdParents = fm.parents(cwdObj.hash);
                            wrapper[inTrash() ? 'addClass' : 'removeClass']('elfinder-cwd-wrapper-trash');
                        });
                        incHashes = void 0;
                        unselectAll({ notrigger: true });
                        content();
                    }
                })
                .bind('search', function (e) {
                    cwdHashes = $.map(e.data.files, function (f) { return f.hash; });
                    fm.trigger('cwdhasheschange', cwdHashes);
                    incHashes = void 0;
                    fm.searchStatus.ininc = false;
                    content();
                    fm.autoSync('stop');
                })
                .bind('searchend', function (e) {
                    if (query || incHashes) {
                        query = '';
                        if (incHashes) {
                            fm.trigger('incsearchend', e.data);
                        } else {
                            if (!e.data || !e.data.noupdate) {
                                content();
                            }
                        }
                    }
                    fm.autoSync();
                })
                .bind('searchstart', function (e) {
                    unselectAll();
                    query = e.data.query;
                })
                .bind('incsearchstart', function (e) {
                    var q = e.data.query || '',
                        type = e.data.type || 'SearchName',
                        searchTypes = fm.options.commandsOptions.search.searchTypes || {};

                    if ((searchTypes[type] && searchTypes[type].incsearch) || type === 'SearchName') {
                        selectedFiles = {};
                        fm.lazy(function () {
                            // incremental search
                            var regex, incSearch, fst = '';
                            query = q;
                            if (q) {
                                if (q.substr(0, 1) === '/') {
                                    q = q.substr(1);
                                    fst = '^';
                                }
                                regex = new RegExp(fst + q.replace(/([\\*\;\.\?\[\]\{\}\(\)\^\$\-\|])/g, '\\$1'), 'i');
                                if (type === 'SearchName') {
                                    incHashes = $.grep(cwdHashes, function (hash) {
                                        var file = fm.file(hash);
                                        return (file && (file.name.match(regex) || (file.i18 && file.i18.match(regex)))) ? true : false;
                                    });
                                } else {
                                    incSearch = searchTypes[type].incsearch;
                                    if (typeof incSearch === 'string') {
                                        incHashes = $.grep(cwdHashes, function (hash) {
                                            var file = fm.file(hash);
                                            return (file && file[incSearch] && (file[incSearch] + '').match(regex)) ? true : false;
                                        });
                                    } else if (typeof incSearch === 'function') {
                                        try {
                                            incHashes = $.grep(incSearch({ val: q, regex: regex }, cwdHashes, fm), function (hash) {
                                                return fm.file(hash) ? true : false;
                                            });
                                        } catch (e) {
                                            incHashes = [];
                                        }
                                    }
                                }
                                fm.trigger('incsearch', { hashes: incHashes, query: q })
                                    .searchStatus.ininc = true;
                                content();
                                fm.autoSync('stop');
                            } else {
                                fm.trigger('incsearchend');
                            }
                        });
                    }
                })
                .bind('incsearchend', function (e) {
                    query = '';
                    fm.searchStatus.ininc = false;
                    incHashes = void 0;
                    if (!e.data || !e.data.noupdate) {
                        content();
                    }
                    fm.autoSync();
                })
                .bind('sortchange', function () {
                    var lastScrollLeft = wrapper.scrollLeft(),
                        allsel = cwd.hasClass('elfinder-cwd-allselected');

                    content();
                    fm.one('cwdrender', function () {
                        wrapper.scrollLeft(lastScrollLeft);
                        if (allsel) {
                            selectedFiles = fm.arrayFlip(incHashes || cwdHashes, true);
                        }
                        (allsel || Object.keys(selectedFiles).length) && trigger();
                    });
                })
                .bind('viewchange', function () {
                    var l = fm.viewType != 'list',
                        allsel = cwd.hasClass('elfinder-cwd-allselected');

                    if (l != list) {
                        list = l;
                        fm.viewType = list ? 'list' : 'icons';
                        if (iconSize) {
                            fm.one('cwdinit', function () {
                                cwd.trigger('iconpref', { size: iconSize });
                            });
                        }
                        content();
                        resize();

                        if (allsel) {
                            cwd.addClass('elfinder-cwd-allselected');
                            selectAllCheckbox.find('input').prop('checked', true);
                        }
                        Object.keys(selectedFiles).length && trigger();
                    }
                })
                .bind('wzresize', function () {
                    var place = list ? cwd.find('tbody') : cwd,
                        cwdOffset;
                    resize(true);
                    if (bufferExt.hpi) {
                        bottomMarkerShow(place, place.find('[id]').length);
                    }

                    cwdOffset = cwd.offset();
                    wz.data('rectangle', Object.assign(
                        {
                            width: wz.width(),
                            height: wz.height(),
                            cwdEdge: (fm.direction === 'ltr') ? cwdOffset.left : cwdOffset.left + cwd.width()
                        },
                        wz.offset())
                    );

                    bufferExt.itemH = (list ? place.find('tr:first') : place.find('[id]:first')).outerHeight(true);
                })
                .bind('changeclipboard', function (e) {
                    clipCuts = {};
                    if (e.data && e.data.clipboard && e.data.clipboard.length) {
                        $.each(e.data.clipboard, function (i, f) {
                            if (f.cut) {
                                clipCuts[f.hash] = true;
                            }
                        });
                    }
                })
                .bind('resMixinMake', function () {
                    setColwidth();
                })
                .bind('tmbreload', function (e) {
                    var imgs = {},
                        files = (e.data && e.data.files) ? e.data.files : null;

                    $.each(files, function (i, f) {
                        if (f.tmb && f.tmb != '1') {
                            imgs[f.hash] = f.tmb;
                        }
                    });
                    if (Object.keys(imgs).length) {
                        attachThumbnails(imgs, true);
                    }
                })
                .add(function (e) {
                    var regex = query ? new RegExp(query.replace(/([\\*\;\.\?\[\]\{\}\(\)\^\$\-\|])/g, '\\$1'), 'i') : null,
                        mime = fm.searchStatus.mime,
                        inSearch = fm.searchStatus.state > 1,
                        phash = inSearch && fm.searchStatus.target ? fm.searchStatus.target : fm.cwd().hash,
                        curPath = fm.path(phash),
                        inTarget = function (f) {
                            var res, parents, path;
                            res = (f.phash === phash);
                            if (!res && inSearch) {
                                path = f.path || fm.path(f.hash);
                                res = (curPath && path.indexOf(curPath) === 0);
                                if (!res && fm.searchStatus.mixed) {
                                    res = $.grep(fm.searchStatus.mixed, function (vid) { return f.hash.indexOf(vid) === 0 ? true : false; }).length ? true : false;
                                }
                            }
                            if (res && inSearch) {
                                if (mime) {
                                    res = (f.mime.indexOf(mime) === 0);
                                } else {
                                    res = (f.name.match(regex) || (f.i18 && f.i18.match(regex))) ? true : false;
                                }
                            }
                            return res;
                        },
                        files = $.grep(e.data.added || [], function (f) { return inTarget(f) ? true : false; });
                    add(files);
                    if (fm.searchStatus.state === 2) {
                        $.each(files, function (i, f) {
                            if ($.inArray(f.hash, cwdHashes) === -1) {
                                cwdHashes.push(f.hash);
                            }
                        });
                        fm.trigger('cwdhasheschange', cwdHashes);
                    }
                    list && resize();
                    wrapper.trigger(scrollEvent);
                })
                .change(function (e) {
                    var phash = fm.cwd().hash,
                        sel = fm.selected(),
                        files, added;

                    if (query) {
                        $.each(e.data.changed || [], function (i, file) {
                            if (fm.cwdHash2Elm(file.hash).length) {
                                remove([file.hash]);
                                add([file], 'change');
                                $.inArray(file.hash, sel) !== -1 && selectFile(file.hash);
                                added = true;
                            }
                        });
                    } else {
                        $.each($.grep(e.data.changed || [], function (f) { return f.phash == phash ? true : false; }), function (i, file) {
                            if (fm.cwdHash2Elm(file.hash).length) {
                                remove([file.hash]);
                                add([file], 'change');
                                $.inArray(file.hash, sel) !== -1 && selectFile(file.hash);
                                added = true;
                            }
                        });
                    }

                    if (added) {
                        fm.trigger('cwdhasheschange', cwdHashes);
                        list && resize();
                        wrapper.trigger(scrollEvent);
                    }

                    trigger();
                })
                .remove(function (e) {
                    var place = list ? cwd.find('tbody') : cwd;
                    remove(e.data.removed || []);
                    trigger();
                    if (buffer.length < 1 && place.children(fileSelector + (options.oldSchool ? ':not(.elfinder-cwd-parent)' : '')).length < 1) {
                        wz.addClass('elfinder-cwd-wrapper-empty');
                        selectCheckbox && selectAllCheckbox.find('input').prop('checked', false);
                        bottomMarker.hide();
                        wrapper.off(scrollEvent, render);
                        resize();
                    } else {
                        bottomMarkerShow(place);
                        wrapper.trigger(scrollEvent);
                    }
                })
                // select dragged file if no selected, disable selectable
                .dragstart(function (e) {
                    var target = $(e.data.target),
                        oe = e.data.originalEvent;

                    if (target.hasClass(clFile)) {

                        if (!target.hasClass(clSelected)) {
                            !(oe.ctrlKey || oe.metaKey || oe.shiftKey) && unselectAll({ notrigger: true });
                            target.trigger(evtSelect);
                            trigger();
                        }
                    }

                    cwd.removeClass(clDisabled).data('selectable') && cwd.selectable('disable');
                    selectLock = true;
                })
                // enable selectable
                .dragstop(function () {
                    cwd.data('selectable') && cwd.selectable('enable');
                    selectLock = false;
                })
                .bind('lockfiles unlockfiles selectfiles unselectfiles', function (e) {
                    var events = {
                        lockfiles: evtDisable,
                        unlockfiles: evtEnable,
                        selectfiles: evtSelect,
                        unselectfiles: evtUnselect
                    },
                        event = events[e.type],
                        files = e.data.files || [],
                        l = files.length,
                        helper = e.data.helper || $(),
                        parents, ctr, add;

                    if (l > 0) {
                        parents = fm.parents(files[0]);
                    }
                    if (event === evtSelect || event === evtUnselect) {
                        add = (event === evtSelect),
                            $.each(files, function (i, hash) {
                                var all = cwd.hasClass('elfinder-cwd-allselected');
                                if (!selectedFiles[hash]) {
                                    add && (selectedFiles[hash] = true);
                                } else {
                                    if (all) {
                                        selectCheckbox && selectAllCheckbox.children('input').prop('checked', false);
                                        cwd.removeClass('elfinder-cwd-allselected');
                                        all = false;
                                    }
                                    !add && delete selectedFiles[hash];
                                }
                            });
                    }
                    if (!helper.data('locked')) {
                        while (l--) {
                            try {
                                fm.cwdHash2Elm(files[l]).trigger(event);
                            } catch (e) { }
                        }
                        !e.data.inselect && trigger();
                    }
                    if (wrapper.data('dropover') && parents.indexOf(wrapper.data('dropover')) !== -1) {
                        ctr = e.type !== 'lockfiles';
                        helper.toggleClass('elfinder-drag-helper-plus', ctr);
                        wrapper.toggleClass(clDropActive, ctr);
                    }
                })
                // select new files after some actions
                .bind('mkdir mkfile duplicate upload rename archive extract paste multiupload', function (e) {
                    if (e.type == 'upload' && e.data._multiupload) return;
                    var phash = fm.cwd().hash, files;

                    unselectAll({ notrigger: true });

                    $.each((e.data.added || []).concat(e.data.changed || []), function (i, file) {
                        file && file.phash == phash && selectFile(file.hash);
                    });
                    trigger();
                })
                .shortcut({
                    pattern: 'ctrl+a',
                    description: 'selectall',
                    callback: selectAll
                })
                .shortcut({
                    pattern: 'ctrl+shift+i',
                    description: 'selectinvert',
                    callback: selectInvert
                })
                .shortcut({
                    pattern: 'left right up down shift+left shift+right shift+up shift+down',
                    description: 'selectfiles',
                    type: 'keydown', //fm.UA.Firefox || fm.UA.Opera ? 'keypress' : 'keydown',
                    callback: function (e) { select(e.keyCode, e.shiftKey); }
                })
                .shortcut({
                    pattern: 'home',
                    description: 'selectffile',
                    callback: function (e) {
                        unselectAll({ notrigger: true });
                        scrollToView(cwd.find('[id]:first').trigger(evtSelect));
                        trigger();
                    }
                })
                .shortcut({
                    pattern: 'end',
                    description: 'selectlfile',
                    callback: function (e) {
                        unselectAll({ notrigger: true });
                        scrollToView(cwd.find('[id]:last').trigger(evtSelect));
                        trigger();
                    }
                })
                .shortcut({
                    pattern: 'page_up',
                    description: 'pageTurning',
                    callback: function (e) {
                        if (bufferExt.itemH) {
                            wrapper.scrollTop(
                                Math.round(
                                    wrapper.scrollTop()
                                    - (Math.floor((wrapper.height() + (list ? bufferExt.itemH * -1 : 16)) / bufferExt.itemH)) * bufferExt.itemH
                                )
                            );
                        }
                    }
                }).shortcut({
                    pattern: 'page_down',
                    description: 'pageTurning',
                    callback: function (e) {
                        if (bufferExt.itemH) {
                            wrapper.scrollTop(
                                Math.round(
                                    wrapper.scrollTop()
                                    + (Math.floor((wrapper.height() + (list ? bufferExt.itemH * -1 : 16)) / bufferExt.itemH)) * bufferExt.itemH
                                )
                            );
                        }
                    }
                });

        });

        // fm.timeEnd('cwdLoad')

        return this;
    };


    /*
     * File: /js/ui/dialog.js
     */

    /**
     * @class  elFinder dialog
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderdialog = function (opts, fm) {
        var platformWin = (window.navigator.platform.indexOf('Win') != -1),
            delta = {},
            syncSize = { enabled: false, width: false, height: false, defaultSize: null },
            fitSize = function (dialog) {
                var opts, node;
                if (syncSize.enabled) {
                    node = fm.options.dialogContained ? elfNode : $(window);
                    opts = {
                        maxWidth: syncSize.width ? node.width() - delta.width : null,
                        maxHeight: syncSize.height ? node.height() - delta.height : null
                    };
                    Object.assign(restoreStyle, opts);
                    dialog.css(opts).trigger('resize');
                    if (dialog.data('hasResizable') && (dialog.resizable('option', 'maxWidth') < opts.maxWidth || dialog.resizable('option', 'maxHeight') < opts.maxHeight)) {
                        dialog.resizable('option', opts);
                    }
                }
            },
            syncFunc = function (e) {
                var dialog = e.data;
                syncTm && cancelAnimationFrame(syncTm);
                syncTm = requestAnimationFrame(function () {
                    var opts, offset;
                    if (syncSize.enabled) {
                        fitSize(dialog);
                    }
                });
            },
            checkEditing = function () {
                var cldialog = 'elfinder-dialog',
                    dialogs = elfNode.children('.' + cldialog + '.' + fm.res('class', 'editing') + ':visible');
                fm[dialogs.length ? 'disable' : 'enable']();
            },
            propagationEvents = {},
            syncTm, dialog, elfNode, restoreStyle;

        if (fm && fm.ui) {
            elfNode = fm.getUI();
        } else {
            elfNode = this.closest('.elfinder');
            if (!fm) {
                fm = elfNode.elfinder('instance');
            }
        }

        if (typeof opts === 'string') {
            if ((dialog = this.closest('.ui-dialog')).length) {
                if (opts === 'open') {
                    if (dialog.css('display') === 'none') {
                        // Need dialog.show() and hide() to detect elements size in open() callbacks
                        dialog.trigger('posinit').show().trigger('open').hide();
                        dialog.fadeIn(120, function () {
                            fm.trigger('dialogopened', { dialog: dialog });
                        });
                    }
                } else if (opts === 'close' || opts === 'destroy') {
                    dialog.stop(true);
                    if (dialog.is(':visible') || elfNode.is(':hidden')) {
                        dialog.trigger('close');
                        fm.trigger('dialogclosed', { dialog: dialog });
                    }
                    if (opts === 'destroy') {
                        dialog.remove();
                        fm.trigger('dialogremoved', { dialog: dialog });
                    } else if (dialog.data('minimized')) {
                        dialog.data('minimized').close();
                    }
                } else if (opts === 'toTop') {
                    dialog.trigger('totop');
                    fm.trigger('dialogtotoped', { dialog: dialog });
                } else if (opts === 'posInit') {
                    dialog.trigger('posinit');
                    fm.trigger('dialogposinited', { dialog: dialog });
                } else if (opts === 'tabstopsInit') {
                    dialog.trigger('tabstopsInit');
                    fm.trigger('dialogtabstopsinited', { dialog: dialog });
                } else if (opts === 'checkEditing') {
                    checkEditing();
                }
            }
            return this;
        }

        opts = Object.assign({}, $.fn.elfinderdialog.defaults, opts);

        if (opts.allowMinimize && opts.allowMinimize === 'auto') {
            opts.allowMinimize = this.find('textarea,input').length ? true : false;
        }
        opts.openMaximized = opts.allowMinimize && opts.openMaximized;
        if (opts.headerBtnPos && opts.headerBtnPos === 'auto') {
            opts.headerBtnPos = platformWin ? 'right' : 'left';
        }
        if (opts.headerBtnOrder && opts.headerBtnOrder === 'auto') {
            opts.headerBtnOrder = platformWin ? 'close:maximize:minimize' : 'close:minimize:maximize';
        }

        if (opts.modal && opts.allowMinimize) {
            opts.allowMinimize = false;
        }

        if (fm.options.dialogContained) {
            syncSize.width = syncSize.height = syncSize.enabled = true;
        } else {
            syncSize.width = (opts.maxWidth === 'window');
            syncSize.height = (opts.maxHeight === 'window');
            if (syncSize.width || syncSize.height) {
                syncSize.enabled = true;
            }
        }

        propagationEvents = fm.arrayFlip(opts.propagationEvents, true);

        this.filter(':not(.ui-dialog-content)').each(function () {
            var self = $(this).addClass('ui-dialog-content ui-widget-content'),
                clactive = 'elfinder-dialog-active',
                cldialog = 'elfinder-dialog',
                clnotify = 'elfinder-dialog-notify',
                clhover = 'ui-state-hover',
                cltabstop = 'elfinder-tabstop',
                cl1stfocus = 'elfinder-focus',
                clmodal = 'elfinder-dialog-modal',
                id = parseInt(Math.random() * 1000000),
                titlebar = $('<div class="ui-dialog-titlebar ui-widget-header ui-corner-top ui-helper-clearfix"><span class="elfinder-dialog-title">' + opts.title + '</span></div>'),
                buttonset = $('<div class="ui-dialog-buttonset"></div>'),
                buttonpane = $('<div class=" ui-helper-clearfix ui-dialog-buttonpane ui-widget-content"></div>')
                    .append(buttonset),
                btnWidth = 0,
                btnCnt = 0,
                tabstops = $(),
                evCover = $('<div style="width:100%;height:100%;position:absolute;top:0px;left:0px;"></div>').hide(),
                numberToTel = function () {
                    if (opts.optimizeNumber) {
                        dialog.find('input[type=number]').each(function () {
                            $(this).attr('inputmode', 'numeric');
                            $(this).attr('pattern', '[0-9]*');
                        });
                    }
                },
                tabstopsInit = function () {
                    tabstops = dialog.find('.' + cltabstop);
                    if (tabstops.length) {
                        tabstops.attr('tabindex', '-1');
                        if (!tabstops.filter('.' + cl1stfocus).length) {
                            buttonset.children('.' + cltabstop + ':' + (platformWin ? 'first' : 'last')).addClass(cl1stfocus);
                        }
                    }
                },
                tabstopNext = function (cur) {
                    var elms = tabstops.filter(':visible:enabled'),
                        node = cur ? null : elms.filter('.' + cl1stfocus + ':first');

                    if (!node || !node.length) {
                        node = elms.first();
                    }
                    if (cur) {
                        $.each(elms, function (i, elm) {
                            if (elm === cur && elms[i + 1]) {
                                node = elms.eq(i + 1);
                                return false;
                            }
                        });
                    }
                    return node;
                },
                tabstopPrev = function (cur) {
                    var elms = tabstops.filter(':visible:enabled'),
                        node = elms.last();
                    $.each(elms, function (i, elm) {
                        if (elm === cur && elms[i - 1]) {
                            node = elms.eq(i - 1);
                            return false;
                        }
                    });
                    return node;
                },
                makeHeaderBtn = function () {
                    $.each(opts.headerBtnOrder.split(':').reverse(), function (i, v) {
                        headerBtns[v] && headerBtns[v]();
                    });
                    if (platformWin) {
                        titlebar.children('.elfinder-titlebar-button').addClass('elfinder-titlebar-button-right');
                    }
                },
                headerBtns = {
                    close: function () {
                        titlebar.prepend($('<span class="ui-widget-header ui-dialog-titlebar-close ui-corner-all elfinder-titlebar-button"><span class="ui-icon ui-icon-closethick"></span></span>')
                            .on('mousedown touchstart', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                self.elfinderdialog('close');
                            })
                        );
                    },
                    maximize: function () {
                        if (opts.allowMaximize) {
                            dialog.on('resize', function (e, data) {
                                var full, elm;
                                e.preventDefault();
                                e.stopPropagation();
                                if (data && data.maximize) {
                                    elm = titlebar.find('.elfinder-titlebar-full');
                                    full = (data.maximize === 'on');
                                    elm.children('span.ui-icon')
                                        .toggleClass('ui-icon-plusthick', !full)
                                        .toggleClass('ui-icon-arrowreturnthick-1-s', full);
                                    if (full) {
                                        try {
                                            dialog.hasClass('ui-draggable') && dialog.draggable('disable');
                                            dialog.hasClass('ui-resizable') && dialog.resizable('disable');
                                        } catch (e) { }
                                        self.css('width', '100%').css('height', dialog.height() - dialog.children('.ui-dialog-titlebar').outerHeight(true) - buttonpane.outerHeight(true));
                                    } else {
                                        self.attr('style', elm.data('style'));
                                        elm.removeData('style');
                                        posCheck();
                                        try {
                                            dialog.hasClass('ui-draggable') && dialog.draggable('enable');
                                            dialog.hasClass('ui-resizable') && dialog.resizable('enable');
                                        } catch (e) { }
                                    }
                                    dialog.trigger('resize', { init: true });
                                }
                            });
                            titlebar.prepend($('<span class="ui-widget-header ui-corner-all elfinder-titlebar-button elfinder-titlebar-full"><span class="ui-icon ui-icon-plusthick"></span></span>')
                                .on('mousedown touchstart', function (e) {
                                    var elm = $(this);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!dialog.hasClass('elfinder-maximized') && typeof elm.data('style') === 'undefined') {
                                        self.height(self.height());
                                        elm.data('style', self.attr('style') || '');
                                    }
                                    fm.toggleMaximize(dialog);
                                    typeof (opts.maximize) === 'function' && opts.maximize.call(self[0]);
                                })
                            );
                        }

                    },
                    minimize: function () {
                        var btn, mnode, doffset;
                        if (opts.allowMinimize) {
                            btn = $('<span class="ui-widget-header ui-corner-all elfinder-titlebar-button elfinder-titlebar-minimize"><span class="ui-icon ui-icon-minusthick"></span></span>')
                                .on('mousedown touchstart', function (e) {
                                    var $this = $(this),
                                        tray = fm.getUI('bottomtray'),
                                        dumStyle = { width: 70, height: 24 },
                                        dum = $('<div></div>').css(dumStyle).addClass(dialog.get(0).className + ' elfinder-dialog-minimized'),
                                        close = function () {
                                            mnode.remove();
                                            dialog.removeData('minimized').show();
                                            self.elfinderdialog('close');
                                        },
                                        pos = {};

                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!dialog.data('minimized')) {
                                        // minimize
                                        doffset = dialog.data('minimized', {
                                            dialog: function () { return mnode; },
                                            show: function () { mnode.show(); },
                                            hide: function () { mnode.hide(); },
                                            close: close,
                                            title: function (v) { mnode.children('.ui-dialog-titlebar').children('.elfinder-dialog-title').text(v); }
                                        }).position();
                                        mnode = dialog.clone().on('mousedown', function () {
                                            $this.trigger('mousedown');
                                        }).removeClass('ui-draggable ui-resizable elfinder-frontmost');
                                        tray.append(dum);
                                        Object.assign(pos, dum.offset(), dumStyle);
                                        dum.remove();
                                        mnode.height(dialog.height()).children('.ui-dialog-content:first').empty();
                                        fm.toHide(dialog.before(mnode));
                                        mnode.children('.ui-dialog-content:first,.ui-dialog-buttonpane,.ui-resizable-handle').remove();
                                        mnode.find('.elfinder-titlebar-minimize,.elfinder-titlebar-full').remove();
                                        mnode.find('.ui-dialog-titlebar-close').on('mousedown', function (e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            close();
                                        });
                                        mnode.animate(pos, function () {
                                            mnode.attr('style', '')
                                                .css({ maxWidth: dialog.width() })
                                                .addClass('elfinder-dialog-minimized')
                                                .appendTo(tray);
                                            checkEditing();
                                            typeof (opts.minimize) === 'function' && opts.minimize.call(self[0]);
                                        });
                                    } else {
                                        //restore
                                        dialog.removeData('minimized').before(mnode.css(Object.assign({ 'position': 'absolute' }, mnode.offset())));
                                        fm.toFront(mnode);
                                        mnode.animate(Object.assign({ width: dialog.width(), height: dialog.height() }, doffset), function () {
                                            dialog.show();
                                            fm.toFront(dialog);
                                            mnode.remove();
                                            posCheck();
                                            checkEditing();
                                            dialog.trigger('resize', { init: true });
                                            typeof (opts.minimize) === 'function' && opts.minimize.call(self[0]);
                                        });
                                    }
                                });
                            titlebar.on('dblclick', function (e) {
                                $(this).children('.elfinder-titlebar-minimize').trigger('mousedown');
                            }).prepend(btn);
                            dialog.on('togleminimize', function () {
                                btn.trigger('mousedown');
                            });
                        }
                    }
                },
                dialog = $('<div class="ui-front ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable std42-dialog touch-punch ' + cldialog + ' ' + opts.cssClass + '"></div>')
                    .hide()
                    .append(self)
                    .appendTo(elfNode)
                    .draggable({
                        containment: fm.options.dialogContained ? elfNode : null,
                        handle: '.ui-dialog-titlebar',
                        start: function () {
                            evCover.show();
                        },
                        drag: function (e, ui) {
                            var top = ui.offset.top,
                                left = ui.offset.left;
                            if (top < 0) {
                                ui.position.top = ui.position.top - top;
                            }
                            if (left < 0) {
                                ui.position.left = ui.position.left - left;
                            }
                            if (fm.options.dialogContained) {
                                ui.position.top < 0 && (ui.position.top = 0);
                                ui.position.left < 0 && (ui.position.left = 0);
                            }
                        },
                        stop: function (e, ui) {
                            evCover.hide();
                            dialog.css({ height: opts.height });
                            self.data('draged', true);
                        }
                    })
                    .css({
                        width: opts.width,
                        height: opts.height,
                        minWidth: opts.minWidth,
                        minHeight: opts.minHeight,
                        maxWidth: opts.maxWidth,
                        maxHeight: opts.maxHeight
                    })
                    .on('touchstart touchmove touchend click dblclick mouseup mouseenter mouseleave mouseout mouseover mousemove', function (e) {
                        // stopPropagation of user action events
                        !propagationEvents[e.type] && e.stopPropagation();
                    })
                    .on('mousedown', function (e) {
                        !propagationEvents[e.type] && e.stopPropagation();
                        requestAnimationFrame(function () {
                            if (dialog.is(':visible') && !dialog.hasClass('elfinder-frontmost')) {
                                toFocusNode = $(':focus');
                                if (!toFocusNode.length) {
                                    toFocusNode = void (0);
                                }
                                dialog.trigger('totop');
                            }
                        });
                    })
                    .on('open', function () {
                        dialog.data('margin-y', self.outerHeight(true) - self.height());
                        if (syncSize.enabled) {
                            if (opts.height && opts.height !== 'auto') {
                                dialog.trigger('resize', { init: true });
                            }
                            if (!syncSize.defaultSize) {
                                syncSize.defaultSize = { width: self.width(), height: self.height() };
                            }
                            fitSize(dialog);
                            dialog.trigger('resize').trigger('posinit');
                            elfNode.on('resize.' + fm.namespace, dialog, syncFunc);
                        }

                        if (!dialog.hasClass(clnotify)) {
                            elfNode.children('.' + cldialog + ':visible:not(.' + clnotify + ')').each(function () {
                                var d = $(this),
                                    top = parseInt(d.css('top')),
                                    left = parseInt(d.css('left')),
                                    _top = parseInt(dialog.css('top')),
                                    _left = parseInt(dialog.css('left')),
                                    ct = Math.abs(top - _top) < 10,
                                    cl = Math.abs(left - _left) < 10;

                                if (d[0] != dialog[0] && (ct || cl)) {
                                    dialog.css({
                                        top: ct ? (top + 10) : _top,
                                        left: cl ? (left + 10) : _left
                                    });
                                }
                            });
                        }

                        if (dialog.data('modal')) {
                            dialog.addClass(clmodal);
                            fm.getUI('overlay').elfinderoverlay('show');
                        }

                        dialog.trigger('totop');

                        opts.openMaximized && fm.toggleMaximize(dialog);

                        fm.trigger('dialogopen', { dialog: dialog });

                        typeof (opts.open) == 'function' && $.proxy(opts.open, self[0])();

                        if (opts.closeOnEscape) {
                            $(document).on('keydown.' + id, function (e) {
                                if (e.keyCode == $.ui.keyCode.ESCAPE && dialog.hasClass('elfinder-frontmost')) {
                                    self.elfinderdialog('close');
                                }
                            });
                        }
                        dialog.hasClass(fm.res('class', 'editing')) && checkEditing();
                    })
                    .on('close', function (e) {
                        var dialogs, dfd;

                        if (opts.beforeclose && typeof opts.beforeclose === 'function') {
                            dfd = opts.beforeclose();
                            if (!dfd || !dfd.promise) {
                                dfd = !dfd ? $.Deferred().reject() : $.Deferred().resolve();
                            }
                        } else {
                            dfd = $.Deferred().resolve();
                        }

                        dfd.done(function () {
                            syncSize.enabled && elfNode.off('resize.' + fm.namespace, syncFunc);

                            if (opts.closeOnEscape) {
                                $(document).off('keyup.' + id);
                            }

                            if (opts.allowMaximize) {
                                fm.toggleMaximize(dialog, false);
                            }

                            fm.toHide(dialog);
                            dialog.data('modal') && fm.getUI('overlay').elfinderoverlay('hide');

                            if (typeof (opts.close) == 'function') {
                                $.proxy(opts.close, self[0])();
                            }
                            if (opts.destroyOnClose && dialog.parent().length) {
                                dialog.hide().remove();
                            }

                            // get focus to next dialog
                            dialogs = elfNode.children('.' + cldialog + ':visible');

                            dialog.hasClass(fm.res('class', 'editing')) && checkEditing();
                        });
                    })
                    .on('totop frontmost', function () {
                        var s = fm.storage('autoFocusDialog');

                        dialog.data('focusOnMouseOver', s ? (s > 0) : fm.options.uiOptions.dialog.focusOnMouseOver);

                        if (dialog.data('minimized')) {
                            titlebar.children('.elfinder-titlebar-minimize').trigger('mousedown');
                        }

                        if (!dialog.data('modal') && fm.getUI('overlay').is(':visible')) {
                            fm.getUI('overlay').before(dialog);
                        } else {
                            fm.toFront(dialog);
                        }
                        elfNode.children('.' + cldialog + ':not(.' + clmodal + ')').removeClass(clactive);
                        dialog.addClass(clactive);

                        !fm.UA.Mobile && (toFocusNode || tabstopNext()).trigger('focus');

                        toFocusNode = void (0);
                    })
                    .on('posinit', function () {
                        var css = opts.position,
                            nodeOffset, minTop, minLeft, outerSize, win, winSize, nodeFull;
                        if (dialog.hasClass('elfinder-maximized')) {
                            return;
                        }
                        if (!css && !dialog.data('resizing')) {
                            nodeFull = elfNode.hasClass('elfinder-fullscreen') || fm.options.enableAlways;
                            dialog.css(nodeFull ? {
                                maxWidth: '100%',
                                maxHeight: '100%',
                                overflow: 'auto'
                            } : restoreStyle);
                            if (fm.UA.Mobile && !nodeFull && dialog.data('rotated') === fm.UA.Rotated) {
                                return;
                            }
                            dialog.data('rotated', fm.UA.Rotated);
                            win = $(window);
                            nodeOffset = elfNode.offset();
                            outerSize = {
                                width: dialog.outerWidth(true),
                                height: dialog.outerHeight(true)
                            };
                            outerSize.right = nodeOffset.left + outerSize.width;
                            outerSize.bottom = nodeOffset.top + outerSize.height;
                            winSize = {
                                scrLeft: win.scrollLeft(),
                                scrTop: win.scrollTop(),
                                width: win.width(),
                                height: win.height()
                            };
                            winSize.right = winSize.scrLeft + winSize.width;
                            winSize.bottom = winSize.scrTop + winSize.height;

                            if (fm.options.dialogContained || nodeFull) {
                                minTop = 0;
                                minLeft = 0;
                            } else {
                                minTop = nodeOffset.top * -1 + winSize.scrTop;
                                minLeft = nodeOffset.left * -1 + winSize.scrLeft;
                            }
                            css = {
                                top: outerSize.height >= winSize.height ? minTop : Math.max(minTop, parseInt((elfNode.height() - outerSize.height) / 2 - 42)),
                                left: outerSize.width >= winSize.width ? minLeft : Math.max(minLeft, parseInt((elfNode.width() - outerSize.width) / 2))
                            };
                            if (outerSize.right + css.left > winSize.right) {
                                css.left = Math.max(minLeft, winSize.right - outerSize.right);
                            }
                            if (outerSize.bottom + css.top > winSize.bottom) {
                                css.top = Math.max(minTop, winSize.bottom - outerSize.bottom);
                            }
                        }
                        if (opts.absolute) {
                            css.position = 'absolute';
                        }
                        css && dialog.css(css);
                    })
                    .on('resize', function (e, data) {
                        var oh = 0, init = data && data.init, h, minH, maxH, autoH;
                        if ((data && (data.minimize || data.maxmize)) || dialog.data('minimized')) {
                            return;
                        }
                        e.stopPropagation();
                        e.preventDefault();
                        dialog.children('.ui-widget-header,.ui-dialog-buttonpane').each(function () {
                            oh += $(this).outerHeight(true);
                        });
                        autoH = (opts.height === 'auto') ? true : false;
                        if (autoH) {
                            self.css({ 'max-height': '', 'height': 'auto' });
                        }
                        if (!init && syncSize.enabled && !e.originalEvent && !dialog.hasClass('elfinder-maximized')) {
                            h = dialog.height();
                            minH = dialog.css('min-height') || h;
                            maxH = dialog.css('max-height') || h;
                            if (minH.match(/%/)) {
                                minH = Math.floor((parseInt(minH) / 100) * dialog.parent().height());
                            } else {
                                minH = parseInt(minH);
                            }
                            if (maxH.match(/%/)) {
                                maxH = Math.floor((parseInt(maxH) / 100) * dialog.parent().height());
                            } else {
                                maxH = parseInt(maxH);
                            }
                            h = Math.min((autoH ? dialog.height() : syncSize.defaultSize.height), Math.max(maxH, minH) - oh - dialog.data('margin-y'));
                        } else {
                            h = dialog.height() - oh - dialog.data('margin-y');
                        }
                        self.css(autoH ? 'max-height' : 'height', h);
                        if (init) {
                            return;
                        }
                        posCheck();
                        minH = self.height();
                        minH = (h < minH) ? (minH + oh + dialog.data('margin-y')) : opts.minHeight;
                        dialog.css('min-height', minH);
                        dialog.data('hasResizable') && dialog.resizable('option', { minHeight: minH });
                        if (typeof (opts.resize) === 'function') {
                            $.proxy(opts.resize, self[0])(e, data);
                        }
                    })
                    .on('tabstopsInit', tabstopsInit)
                    .on('focus', '.' + cltabstop, function () {
                        $(this).addClass(clhover).parent('label').addClass(clhover);
                        this.id && $(this).parent().find('label[for=' + this.id + ']').addClass(clhover);
                    })
                    .on('click', 'select.' + cltabstop, function () {
                        var node = $(this);
                        node.data('keepFocus') ? node.removeData('keepFocus') : node.data('keepFocus', true);
                    })
                    .on('blur', '.' + cltabstop, function () {
                        $(this).removeClass(clhover).removeData('keepFocus').parent('label').removeClass(clhover);
                        this.id && $(this).parent().find('label[for=' + this.id + ']').removeClass(clhover);
                    })
                    .on('mouseenter mouseleave', '.' + cltabstop + ',label', function (e) {
                        var $this = $(this), labelfor;
                        if (this.nodeName === 'LABEL') {
                            if (!$this.children('.' + cltabstop).length && (!(labelfor = $this.attr('for')) || !$('#' + labelfor).hasClass(cltabstop))) {
                                return;
                            }
                        }
                        if (opts.btnHoverFocus && dialog.data('focusOnMouseOver')) {
                            if (e.type === 'mouseenter' && !$(':focus').data('keepFocus')) {
                                $this.trigger('focus');
                            }
                        } else {
                            $this.toggleClass(clhover, e.type == 'mouseenter');
                        }
                    })
                    .on('keydown', '.' + cltabstop, function (e) {
                        var $this = $(this),
                            esc, move, moveTo;
                        if ($this.is(':focus')) {
                            esc = e.keyCode === $.ui.keyCode.ESCAPE;
                            if (e.keyCode === $.ui.keyCode.ENTER) {
                                e.preventDefault();
                                $this.trigger('click');
                            } else if (((e.keyCode === $.ui.keyCode.TAB) && e.shiftKey) || e.keyCode === $.ui.keyCode.LEFT || e.keyCode == $.ui.keyCode.UP) {
                                move = 'prev';
                            } else if (e.keyCode === $.ui.keyCode.TAB || e.keyCode == $.ui.keyCode.RIGHT || e.keyCode == $.ui.keyCode.DOWN) {
                                move = 'next';
                            }
                            if (move
                                &&
                                (
                                    ($this.is('textarea') && !(e.ctrlKey || e.metaKey))
                                    ||
                                    ($this.is('select,span.ui-slider-handle') && e.keyCode !== $.ui.keyCode.TAB)
                                    ||
                                    ($this.is('input:not(:checkbox,:radio)') && (!(e.ctrlKey || e.metaKey) && e.keyCode === $.ui.keyCode[move === 'prev' ? 'LEFT' : 'RIGHT']))
                                )
                            ) {
                                e.stopPropagation();
                                return;
                            }
                            if (!esc) {
                                e.stopPropagation();
                            } else if ($this.is('input:not(:checkbox,:radio),textarea')) {
                                if ($this.val() !== '') {
                                    $this.val('');
                                    e.stopPropagation();
                                }
                            }
                            if (move) {
                                e.preventDefault();
                                (move === 'prev' ? tabstopPrev : tabstopNext)(this).trigger('focus');
                            }
                        }
                    })
                    .data({ modal: opts.modal }),
                posCheck = function () {
                    var node = fm.getUI(),
                        pos;
                    if (node.hasClass('elfinder-fullscreen')) {
                        pos = dialog.position();
                        dialog.css('top', Math.max(Math.min(Math.max(pos.top, 0), node.height() - 100), 0));
                        dialog.css('left', Math.max(Math.min(Math.max(pos.left, 0), node.width() - 200), 0));
                    }
                },
                maxSize, toFocusNode;

            dialog.prepend(titlebar);

            makeHeaderBtn();

            $.each(opts.buttons, function (name, cb) {
                var button = $('<button type="button" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only '
                    + 'elfinder-btncnt-' + (btnCnt++) + ' '
                    + cltabstop
                    + '"><span class="ui-button-text">' + name + '</span></button>')
                    .on('click', $.proxy(cb, self[0]));
                if (cb._cssClass) {
                    button.addClass(cb._cssClass);
                }
                if (platformWin) {
                    buttonset.append(button);
                } else {
                    buttonset.prepend(button);
                }
            });

            if (buttonset.children().length) {
                dialog.append(buttonpane);

                dialog.show();
                buttonpane.find('button').each(function (i, btn) {
                    btnWidth += $(btn).outerWidth(true);
                });
                dialog.hide();
                btnWidth += 20;

                if (dialog.width() < btnWidth) {
                    dialog.width(btnWidth);
                }
            }

            dialog.append(evCover);

            if (syncSize.enabled) {
                delta.width = dialog.outerWidth(true) - dialog.width() + ((dialog.outerWidth() - dialog.width()) / 2);
                delta.height = dialog.outerHeight(true) - dialog.height() + ((dialog.outerHeight() - dialog.height()) / 2);
            }

            if (fm.options.dialogContained) {
                maxSize = {
                    maxWidth: elfNode.width() - delta.width,
                    maxHeight: elfNode.height() - delta.height
                };
                opts.maxWidth = opts.maxWidth ? Math.min(maxSize.maxWidth, opts.maxWidth) : maxSize.maxWidth;
                opts.maxHeight = opts.maxHeight ? Math.min(maxSize.maxHeight, opts.maxHeight) : maxSize.maxHeight;
                dialog.css(maxSize);
            }

            restoreStyle = {
                maxWidth: dialog.css('max-width'),
                maxHeight: dialog.css('max-height'),
                overflow: dialog.css('overflow')
            };

            if (opts.resizable) {
                dialog.resizable({
                    minWidth: opts.minWidth,
                    minHeight: opts.minHeight,
                    maxWidth: opts.maxWidth,
                    maxHeight: opts.maxHeight,
                    start: function () {
                        evCover.show();
                        if (dialog.data('resizing') !== true && dialog.data('resizing')) {
                            clearTimeout(dialog.data('resizing'));
                        }
                        dialog.data('resizing', true);
                    },
                    stop: function (e, ui) {
                        evCover.hide();
                        dialog.data('resizing', setTimeout(function () {
                            dialog.data('resizing', false);
                        }, 200));
                        if (syncSize.enabled) {
                            syncSize.defaultSize = { width: self.width(), height: self.height() };
                        }
                    }
                }).data('hasResizable', true);
            }

            numberToTel();

            tabstopsInit();

            typeof (opts.create) == 'function' && $.proxy(opts.create, this)();

            if (opts.autoOpen) {
                if (opts.open) {
                    requestAnimationFrame(function () {
                        self.elfinderdialog('open');
                    });
                } else {
                    self.elfinderdialog('open');
                }
            }

            if (opts.resize) {
                fm.bind('themechange', function () {
                    setTimeout(function () {
                        dialog.data('margin-y', self.outerHeight(true) - self.height());
                        dialog.trigger('resize', { init: true });
                    }, 300);
                });
            }
        });

        return this;
    };

    $.fn.elfinderdialog.defaults = {
        cssClass: '',
        title: '',
        modal: false,
        resizable: true,
        autoOpen: true,
        closeOnEscape: true,
        destroyOnClose: false,
        buttons: {},
        btnHoverFocus: true,
        position: null,
        absolute: false,
        width: 320,
        height: 'auto',
        minWidth: 200,
        minHeight: 70,
        maxWidth: null,
        maxHeight: null,
        allowMinimize: 'auto',
        allowMaximize: false,
        openMaximized: false,
        headerBtnPos: 'auto',
        headerBtnOrder: 'auto',
        optimizeNumber: true,
        propagationEvents: ['mousemove', 'mouseup']
    };


    /*
     * File: /js/ui/fullscreenbutton.js
     */

    /**
     * @class  elFinder toolbar button to switch full scrren mode.
     *
     * @author Naoki Sawada
     **/

    $.fn.elfinderfullscreenbutton = function (cmd) {
        return this.each(function () {
            var button = $(this).elfinderbutton(cmd),
                icon = button.children('.elfinder-button-icon'),
                tm;
            cmd.change(function () {
                tm && cancelAnimationFrame(tm);
                tm = requestAnimationFrame(function () {
                    var fullscreen = cmd.value;
                    icon.addClass('elfinder-button-icon-fullscreen').toggleClass('elfinder-button-icon-unfullscreen', fullscreen);
                    cmd.className = fullscreen ? 'unfullscreen' : '';
                });
            });
        });
    };


    /*
     * File: /js/ui/navbar.js
     */

    /**
     * @class elfindernav - elFinder container for diretories tree and places
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindernavbar = function (fm, opts) {
        this.not('.elfinder-navbar').each(function () {
            var nav = $(this).hide().addClass('ui-state-default elfinder-navbar'),
                parent = nav.css('overflow', 'hidden').parent(),
                wz = parent.children('.elfinder-workzone').append(nav),
                ltr = fm.direction == 'ltr',
                delta, deltaW, handle, swipeHandle, autoHide, setWidth, navdock,
                setWzRect = function () {
                    var cwd = fm.getUI('cwd'),
                        wz = fm.getUI('workzone'),
                        wzRect = wz.data('rectangle'),
                        cwdOffset = cwd.offset();
                    wz.data('rectangle', Object.assign(wzRect, { cwdEdge: (fm.direction === 'ltr') ? cwdOffset.left : cwdOffset.left + cwd.width() }));
                },
                setDelta = function () {
                    nav.css('overflow', 'hidden');
                    delta = Math.round(nav.outerHeight() - nav.height());
                    deltaW = Math.round(navdock.outerWidth() - navdock.innerWidth());
                    nav.css('overflow', 'auto');
                };

            fm.one('init', function () {
                navdock = fm.getUI('navdock');
                var set = function () {
                    setDelta();
                    fm.bind('wzresize', function () {
                        var navdockH = 0;
                        navdock.width(nav.outerWidth() - deltaW);
                        if (navdock.children().length > 1) {
                            navdockH = navdock.outerHeight(true);
                        }
                        nav.height(wz.height() - navdockH - delta);
                    }).trigger('wzresize');
                };
                if (fm.cssloaded) {
                    set();
                } else {
                    fm.one('cssloaded', set);
                }
            })
                .one('opendone', function () {
                    handle && handle.trigger('resize');
                    nav.css('overflow', 'auto');
                }).bind('themechange', setDelta);

            if (fm.UA.Touch) {
                autoHide = fm.storage('autoHide') || {};
                if (typeof autoHide.navbar === 'undefined') {
                    autoHide.navbar = (opts.autoHideUA && opts.autoHideUA.length > 0 && $.grep(opts.autoHideUA, function (v) { return fm.UA[v] ? true : false; }).length);
                    fm.storage('autoHide', autoHide);
                }

                if (autoHide.navbar) {
                    fm.one('init', function () {
                        if (nav.children().length) {
                            fm.uiAutoHide.push(function () { nav.stop(true, true).trigger('navhide', { duration: 'slow', init: true }); });
                        }
                    });
                }

                fm.bind('load', function () {
                    if (nav.children().length) {
                        swipeHandle = $('<div class="elfinder-navbar-swipe-handle"></div>').hide().appendTo(wz);
                        if (swipeHandle.css('pointer-events') !== 'none') {
                            swipeHandle.remove();
                            swipeHandle = null;
                        }
                    }
                });

                nav.on('navshow navhide', function (e, data) {
                    var mode = (e.type === 'navshow') ? 'show' : 'hide',
                        duration = (data && data.duration) ? data.duration : 'fast',
                        handleW = (data && data.handleW) ? data.handleW : Math.max(50, fm.getUI().width() / 10);
                    nav.stop(true, true)[mode]({
                        duration: duration,
                        step: function () {
                            fm.trigger('wzresize');
                        },
                        complete: function () {
                            if (swipeHandle) {
                                if (mode === 'show') {
                                    swipeHandle.stop(true, true).hide();
                                } else {
                                    swipeHandle.width(handleW ? handleW : '');
                                    fm.resources.blink(swipeHandle, 'slowonce');
                                }
                            }
                            fm.trigger('navbar' + mode);
                            data.init && fm.trigger('uiautohide');
                            setWzRect();
                        }
                    });
                    autoHide.navbar = (mode !== 'show');
                    fm.storage('autoHide', Object.assign(fm.storage('autoHide'), { navbar: autoHide.navbar }));
                }).on('touchstart', function (e) {
                    if ($(this)['scroll' + (fm.direction === 'ltr' ? 'Right' : 'Left')]() > 5) {
                        e.originalEvent._preventSwipeX = true;
                    }
                });
            }

            if (!fm.UA.Mobile) {
                handle = nav.resizable({
                    handles: ltr ? 'e' : 'w',
                    minWidth: opts.minWidth || 150,
                    maxWidth: opts.maxWidth || 500,
                    resize: function () {
                        fm.trigger('wzresize');
                    },
                    stop: function (e, ui) {
                        fm.storage('navbarWidth', ui.size.width);
                        setWzRect();
                    }
                })
                    .on('resize scroll', function (e) {
                        var $this = $(this),
                            tm = $this.data('posinit');
                        e.preventDefault();
                        e.stopPropagation();
                        if (!ltr && e.type === 'resize') {
                            nav.css('left', 0);
                        }
                        tm && cancelAnimationFrame(tm);
                        $this.data('posinit', requestAnimationFrame(function () {
                            var offset = (fm.UA.Opera && nav.scrollLeft()) ? 20 : 2;
                            handle.css('top', 0).css({
                                top: parseInt(nav.scrollTop()) + 'px',
                                left: ltr ? 'auto' : parseInt(nav.scrollRight() - offset) * -1,
                                right: ltr ? parseInt(nav.scrollLeft() - offset) * -1 : 'auto'
                            });
                            if (e.type === 'resize') {
                                fm.getUI('cwd').trigger('resize');
                            }
                        }));
                    })
                    .children('.ui-resizable-handle').addClass('ui-front');
            }

            if (setWidth = fm.storage('navbarWidth')) {
                nav.width(setWidth);
            } else {
                if (fm.UA.Mobile) {
                    fm.one(fm.cssloaded ? 'init' : 'cssloaded', function () {
                        var set = function () {
                            setWidth = nav.parent().width() / 2;
                            if (nav.data('defWidth') > setWidth) {
                                nav.width(setWidth);
                            } else {
                                nav.width(nav.data('defWidth'));
                            }
                            nav.data('width', nav.width());
                            fm.trigger('wzresize');
                        };
                        nav.data('defWidth', nav.width());
                        $(window).on('resize.' + fm.namespace, set);
                        set();
                    });
                }
            }

        });

        return this;
    };


    /*
     * File: /js/ui/navdock.js
     */

    /**
     * @class elfindernavdock - elFinder container for preview etc at below the navbar
     *
     * @author Naoki Sawada
     **/
    $.fn.elfindernavdock = function (fm, opts) {
        this.not('.elfinder-navdock').each(function () {
            var self = $(this).hide().addClass('ui-state-default elfinder-navdock touch-punch'),
                node = self.parent(),
                wz = node.children('.elfinder-workzone').append(self),
                resize = function (to, h) {
                    var curH = h || self.height(),
                        diff = to - curH,
                        len = Object.keys(sizeSyncs).length,
                        calc = len ? diff / len : 0,
                        ovf;
                    if (diff) {
                        ovf = self.css('overflow');
                        self.css('overflow', 'hidden');
                        self.height(to);
                        $.each(sizeSyncs, function (id, n) {
                            n.height(n.height() + calc).trigger('resize.' + fm.namespace);
                        });
                        fm.trigger('wzresize');
                        self.css('overflow', ovf);
                    }
                },
                handle = $('<div class="ui-front ui-resizable-handle ui-resizable-n"></div>').appendTo(self),
                sizeSyncs = {},
                resizeFn = [],
                initMaxHeight = (parseInt(opts.initMaxHeight) || 50) / 100,
                maxHeight = (parseInt(opts.maxHeight) || 90) / 100,
                basicHeight, hasNode;


            self.data('addNode', function (cNode, opts) {
                var wzH = fm.getUI('workzone').height(),
                    imaxH = wzH * initMaxHeight,
                    curH, tH, mH;
                opts = Object.assign({
                    first: false,
                    sizeSync: true,
                    init: false
                }, opts);
                if (!cNode.attr('id')) {
                    cNode.attr('id', fm.namespace + '-navdock-' + (+new Date()));
                }
                opts.sizeSync && (sizeSyncs[cNode.attr('id')] = cNode);
                curH = self.height();
                tH = curH + cNode.outerHeight(true);

                if (opts.first) {
                    handle.after(cNode);
                } else {
                    self.append(cNode);
                }
                hasNode = true;
                self.resizable('enable').height(tH).show();

                fm.trigger('wzresize');

                if (opts.init) {
                    mH = fm.storage('navdockHeight');
                    if (mH) {
                        tH = mH;
                    } else {
                        tH = tH > imaxH ? imaxH : tH;
                    }
                    basicHeight = tH;
                }
                resize(Math.min(tH, wzH * maxHeight));

                return self;
            }).data('removeNode', function (nodeId, appendTo) {
                var cNode = $('#' + nodeId);
                delete sizeSyncs[nodeId];
                self.height(self.height() - $('#' + nodeId).outerHeight(true));
                if (appendTo) {
                    if (appendTo === 'detach') {
                        cNode = cNode.detach();
                    } else {
                        appendTo.append(cNode);
                    }
                } else {
                    cNode.remove();
                }
                if (self.children().length <= 1) {
                    hasNode = false;
                    self.resizable('disable').height(0).hide();
                }
                fm.trigger('wzresize');
                return cNode;
            });

            if (!opts.disabled) {
                fm.one('init', function () {
                    var ovf;
                    if (fm.getUI('navbar').children().not('.ui-resizable-handle').length) {
                        self.data('dockEnabled', true);
                        self.resizable({
                            maxHeight: fm.getUI('workzone').height() * maxHeight,
                            handles: { n: handle },
                            start: function (e, ui) {
                                ovf = self.css('overflow');
                                self.css('overflow', 'hidden');
                                fm.trigger('navdockresizestart', { event: e, ui: ui }, true);
                            },
                            resize: function (e, ui) {
                                self.css('top', '');
                                fm.trigger('wzresize', { inNavdockResize: true });
                            },
                            stop: function (e, ui) {
                                fm.trigger('navdockresizestop', { event: e, ui: ui }, true);
                                self.css('top', '');
                                basicHeight = ui.size.height;
                                fm.storage('navdockHeight', basicHeight);
                                resize(basicHeight, ui.originalSize.height);
                                self.css('overflow', ovf);
                            }
                        });
                        fm.bind('wzresize', function (e) {
                            var minH, maxH, h;
                            if (self.is(':visible')) {
                                maxH = fm.getUI('workzone').height() * maxHeight;
                                if (!e.data || !e.data.inNavdockResize) {
                                    h = self.height();
                                    if (maxH < basicHeight) {
                                        if (Math.abs(h - maxH) > 1) {
                                            resize(maxH);
                                        }
                                    } else {
                                        if (Math.abs(h - basicHeight) > 1) {
                                            resize(basicHeight);
                                        }
                                    }
                                }
                                self.resizable('option', 'maxHeight', maxH);
                            }
                        }).bind('themechange', function () {
                            var oldH = Math.round(self.height());
                            requestAnimationFrame(function () {
                                var curH = Math.round(self.height()),
                                    diff = oldH - curH;
                                if (diff !== 0) {
                                    resize(self.height(), curH - diff);
                                }
                            });
                        });
                    }
                    fm.bind('navbarshow navbarhide', function (e) {
                        self[hasNode && e.type === 'navbarshow' ? 'show' : 'hide']();
                    });
                });
            }
        });
        return this;
    };

    /*
     * File: /js/ui/overlay.js
     */


    $.fn.elfinderoverlay = function (opts) {
        var fm = this.parent().elfinder('instance'),
            o, cnt, show, hide;

        this.filter(':not(.elfinder-overlay)').each(function () {
            opts = Object.assign({}, opts);
            $(this).addClass('ui-front ui-widget-overlay elfinder-overlay')
                .hide()
                .on('mousedown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                })
                .data({
                    cnt: 0,
                    show: typeof (opts.show) == 'function' ? opts.show : function () { },
                    hide: typeof (opts.hide) == 'function' ? opts.hide : function () { }
                });
        });

        if (opts == 'show') {
            o = this.eq(0);
            cnt = o.data('cnt') + 1;
            show = o.data('show');

            fm.toFront(o);
            o.data('cnt', cnt);

            if (o.is(':hidden')) {
                o.show();
                show();
            }
        }

        if (opts == 'hide') {
            o = this.eq(0);
            cnt = o.data('cnt') - 1;
            hide = o.data('hide');

            o.data('cnt', cnt);

            if (cnt <= 0) {
                o.hide();
                hide();
            }
        }

        return this;
    };


    /*
     * File: /js/ui/panel.js
     */

    $.fn.elfinderpanel = function (fm) {
        return this.each(function () {
            var panel = $(this).addClass('elfinder-panel ui-state-default ui-corner-all'),
                margin = 'margin-' + (fm.direction == 'ltr' ? 'left' : 'right');

            fm.one('load', function (e) {
                var navbar = fm.getUI('navbar');

                panel.css(margin, parseInt(navbar.outerWidth(true)));
                navbar.on('resize', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    panel.is(':visible') && panel.css(margin, parseInt(navbar.outerWidth(true)));
                });
            });
        });
    };


    /*
     * File: /js/ui/path.js
     */

    /**
     * @class elFinder ui
     * Display current folder path in statusbar.
     * Click on folder name in path - open folder
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderpath = function (fm, options) {
        return this.each(function () {
            var query = '',
                target = '',
                mimes = [],
                place = 'statusbar',
                clHover = fm.res('class', 'hover'),
                prefix = 'path' + (elFinder.prototype.uniqueid ? elFinder.prototype.uniqueid : '') + '-',
                wzbase = $('<div class="ui-widget-header ui-helper-clearfix elfinder-workzone-path"></div>'),
                path = $(this).addClass('elfinder-path').html('&nbsp;')
                    .on('mousedown', 'span.elfinder-path-dir', function (e) {
                        var hash = $(this).attr('id').substr(prefix.length);
                        e.preventDefault();
                        if (hash != fm.cwd().hash) {
                            $(this).addClass(clHover);
                            if (query) {
                                fm.exec('search', query, { target: hash, mime: mimes.join(' ') });
                            } else {
                                fm.trigger('select', { selected: [hash] }).exec('open', hash);
                            }
                        }
                    })
                    .prependTo(fm.getUI('statusbar').show()),
                roots = $('<div class="elfinder-path-roots"></div>').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    var roots = $.map(fm.roots, function (h) { return fm.file(h); }),
                        raw = [];

                    $.each(roots, function (i, f) {
                        if (!f.phash && fm.root(fm.cwd().hash, true) !== f.hash) {
                            raw.push({
                                label: fm.escape(f.i18 || f.name),
                                icon: 'home',
                                callback: function () { fm.exec('open', f.hash); },
                                options: {
                                    iconClass: f.csscls || '',
                                    iconImg: f.icon || ''
                                }
                            });
                        }
                    });
                    fm.trigger('contextmenu', {
                        raw: raw,
                        x: e.pageX,
                        y: e.pageY
                    });
                }).append('<span class="elfinder-button-icon elfinder-button-icon-menu" ></span>').appendTo(wzbase),
                render = function (cwd) {
                    var dirs = [],
                        names = [];
                    $.each(fm.parents(cwd), function (i, hash) {
                        var c = (cwd === hash) ? 'elfinder-path-dir elfinder-path-cwd' : 'elfinder-path-dir',
                            f = fm.file(hash),
                            name = fm.escape(f.i18 || f.name);
                        names.push(name);
                        dirs.push('<span id="' + prefix + hash + '" class="' + c + '" title="' + names.join(fm.option('separator')) + '">' + name + '</span>');
                    });
                    return dirs.join('<span class="elfinder-path-other">' + fm.option('separator') + '</span>');
                },
                toWorkzone = function () {
                    var prev;
                    path.children('span.elfinder-path-dir').attr('style', '');
                    prev = fm.direction === 'ltr' ? $('#' + prefix + fm.cwd().hash).prevAll('span.elfinder-path-dir:first') : $();
                    path.scrollLeft(prev.length ? prev.position().left : 0);
                },
                fit = function () {
                    if (fm.UA.CSS.flex) {
                        return;
                    }
                    var dirs = path.children('span.elfinder-path-dir'),
                        cnt = dirs.length,
                        m, bg = 0, ids;

                    if (place === 'workzone' || cnt < 2) {
                        dirs.attr('style', '');
                        return;
                    }
                    path.width(path.css('max-width'));
                    dirs.css({ maxWidth: (100 / cnt) + '%', display: 'inline-block' });
                    m = path.width() - 9;
                    path.children('span.elfinder-path-other').each(function () {
                        m -= $(this).width();
                    });
                    ids = [];
                    dirs.each(function (i) {
                        var dir = $(this),
                            w = dir.width();
                        m -= w;
                        if (w < this.scrollWidth) {
                            ids.push(i);
                        }
                    });
                    path.width('');
                    if (ids.length) {
                        if (m > 0) {
                            m = m / ids.length;
                            $.each(ids, function (i, k) {
                                var d = $(dirs[k]);
                                d.css('max-width', d.width() + m);
                            });
                        }
                        dirs.last().attr('style', '');
                    } else {
                        dirs.attr('style', '');
                    }
                },
                hasUiTree, hasUiStat;

            fm.one('init', function () {
                hasUiTree = fm.getUI('tree').length;
                hasUiStat = fm.getUI('stat').length;
                if (!hasUiTree && options.toWorkzoneWithoutNavbar) {
                    wzbase.append(path).insertBefore(fm.getUI('workzone'));
                    place = 'workzone';
                    fm.bind('open', toWorkzone)
                        .one('opendone', function () {
                            fm.getUI().trigger('resize');
                        });
                }
            })
                .bind('open searchend parents', function () {
                    var dirs = [];

                    query = '';
                    target = '';
                    mimes = [];

                    path.html(render(fm.cwd().hash));
                    if (Object.keys(fm.roots).length > 1) {
                        path.css('margin', '');
                        roots.show();
                    } else {
                        path.css('margin', 0);
                        roots.hide();
                    }
                    !hasUiStat && fit();
                })
                .bind('searchstart', function (e) {
                    if (e.data) {
                        query = e.data.query || '';
                        target = e.data.target || '';
                        mimes = e.data.mimes || [];
                    }
                })
                .bind('search', function (e) {
                    var dirs = [],
                        html = '';
                    if (target) {
                        html = render(target);
                    } else {
                        html = fm.i18n('btnAll');
                    }
                    path.html('<span class="elfinder-path-other">' + fm.i18n('searcresult') + ': </span>' + html);
                    fit();
                })
                // on swipe to navbar show/hide
                .bind('navbarshow navbarhide', function () {
                    var wz = fm.getUI('workzone');
                    if (this.type === 'navbarshow') {
                        fm.unbind('open', toWorkzone);
                        path.prependTo(fm.getUI('statusbar'));
                        wzbase.detach();
                        place = 'statusbar';
                    } else {
                        wzbase.append(path).insertBefore(wz);
                        place = 'workzone';
                        toWorkzone();
                        fm.bind('open', toWorkzone);
                    }
                    fm.trigger('uiresize');
                })
                .bind('resize uistatchange', fit);
        });
    };


    /*
     * File: /js/ui/places.js
     */

    /**
     * @class elFinder places/favorites ui
     *
     * @author Dmitry (dio) Levashov
     * @author Naoki Sawada
     **/
    $.fn.elfinderplaces = function (fm, opts) {
        return this.each(function () {
            var dirs = {},
                c = 'class',
                navdir = fm.res(c, 'navdir'),
                collapsed = fm.res(c, 'navcollapse'),
                expanded = fm.res(c, 'navexpand'),
                hover = fm.res(c, 'hover'),
                clroot = fm.res(c, 'treeroot'),
                dropover = fm.res(c, 'adroppable'),
                tpl = fm.res('tpl', 'placedir'),
                ptpl = fm.res('tpl', 'perms'),
                spinner = $(fm.res('tpl', 'navspinner')),
                suffix = opts.suffix ? opts.suffix : '',
                key = 'places' + suffix,
                menuTimer = null,
                /**
                 * Convert places dir node into dir hash
                 *
                 * @param  String  directory id
                 * @return String
                 **/
                id2hash = function (id) { return id.substr(6); },
                /**
                 * Convert places dir hash into dir node id
                 *
                 * @param  String  directory id
                 * @return String
                 **/
                hash2id = function (hash) { return 'place-' + hash; },

                /**
                 * Convert places dir hash into dir node elment (jQuery object)
                 *
                 * @param  String  directory id
                 * @return Object
                 **/
                hash2elm = function (hash) { return $(document.getElementById(hash2id(hash))); },

                /**
                 * Save current places state
                 *
                 * @return void
                 **/
                save = function () {
                    var hashes = [], data = {};

                    hashes = $.map(subtree.children().find('[id]'), function (n) {
                        return id2hash(n.id);
                    });
                    if (hashes.length) {
                        $.each(hashes.reverse(), function (i, h) {
                            data[h] = dirs[h];
                        });
                    } else {
                        data = null;
                    }

                    fm.storage(key, data);
                },
                /**
                 * Init dir at places
                 *
                 * @return void
                 **/
                init = function () {
                    var dat, hashes;
                    key = 'places' + (opts.suffix ? opts.suffix : ''),
                        dirs = {};
                    dat = fm.storage(key);
                    if (typeof dat === 'string') {
                        // old data type elFinder <= 2.1.12
                        dat = $.grep(dat.split(','), function (hash) { return hash ? true : false; });
                        $.each(dat, function (i, d) {
                            var dir = d.split('#');
                            dirs[dir[0]] = dir[1] ? dir[1] : dir[0];
                        });
                    } else if ($.isPlainObject(dat)) {
                        dirs = dat;
                    }
                    // allow modify `dirs`
                    /**
                     * example for preset places
                     * 
                     * elfinderInstance.bind('placesload', function(e, fm) {
                     * 	//if (fm.storage(e.data.storageKey) === null) { // for first time only
                     * 	if (!fm.storage(e.data.storageKey)) {           // for empty places
                     * 		e.data.dirs[targetHash] = fallbackName;     // preset folder
                     * 	}
                     * }
                     **/
                    fm.trigger('placesload', { dirs: dirs, storageKey: key }, true);

                    hashes = Object.keys(dirs);
                    if (hashes.length) {
                        root.prepend(spinner);

                        fm.request({
                            data: { cmd: 'info', targets: hashes },
                            preventDefault: true
                        })
                            .done(function (data) {
                                var exists = {};

                                data.files && data.files.length && fm.cache(data.files);

                                $.each(data.files, function (i, f) {
                                    var hash = f.hash;
                                    exists[hash] = f;
                                });
                                $.each(dirs, function (h, f) {
                                    add(exists[h] || Object.assign({ notfound: true }, f));
                                });
                                if (fm.storage('placesState') > 0) {
                                    root.trigger('click');
                                }
                            })
                            .always(function () {
                                spinner.remove();
                            });
                    }
                },
                /**
                 * Return node for given dir object
                 *
                 * @param  Object  directory object
                 * @return jQuery
                 **/
                create = function (dir, hash) {
                    return $(tpl.replace(/\{id\}/, hash2id(dir ? dir.hash : hash))
                        .replace(/\{name\}/, fm.escape(dir ? dir.i18 || dir.name : hash))
                        .replace(/\{cssclass\}/, dir ? (fm.perms2class(dir) + (dir.notfound ? ' elfinder-na' : '') + (dir.csscls ? ' ' + dir.csscls : '')) : '')
                        .replace(/\{permissions\}/, (dir && (!dir.read || !dir.write || dir.notfound)) ? ptpl : '')
                        .replace(/\{title\}/, dir ? (' title="' + fm.escape(fm.path(dir.hash, true) || dir.i18 || dir.name) + '"') : '')
                        .replace(/\{symlink\}/, '')
                        .replace(/\{style\}/, (dir && dir.icon) ? fm.getIconStyle(dir) : ''));
                },
                /**
                 * Add new node into places
                 *
                 * @param  Object  directory object
                 * @return void
                 **/
                add = function (dir) {
                    var node, hash;

                    if (dir.mime !== 'directory') {
                        return false;
                    }
                    hash = dir.hash;
                    if (!fm.files().hasOwnProperty(hash)) {
                        // update cache
                        fm.trigger('tree', { tree: [dir] });
                    }

                    node = create(dir, hash);

                    dirs[hash] = dir;
                    subtree.prepend(node);
                    root.addClass(collapsed);
                    sortBtn.toggle(subtree.children().length > 1);

                    return true;
                },
                /**
                 * Remove dir from places
                 *
                 * @param  String  directory hash
                 * @return String  removed name
                 **/
                remove = function (hash) {
                    var name = null, tgt, cnt;

                    if (dirs[hash]) {
                        delete dirs[hash];
                        tgt = hash2elm(hash);
                        if (tgt.length) {
                            name = tgt.text();
                            tgt.parent().remove();
                            cnt = subtree.children().length;
                            sortBtn.toggle(cnt > 1);
                            if (!cnt) {
                                root.removeClass(collapsed);
                                places.removeClass(expanded);
                                subtree.slideToggle(false);
                            }
                        }
                    }

                    return name;
                },
                /**
                 * Move up dir on places
                 *
                 * @param  String  directory hash
                 * @return void
                 **/
                moveup = function (hash) {
                    var self = hash2elm(hash),
                        tgt = self.parent(),
                        prev = tgt.prev('div'),
                        cls = 'ui-state-hover',
                        ctm = fm.getUI('contextmenu');

                    menuTimer && clearTimeout(menuTimer);

                    if (prev.length) {
                        ctm.find(':first').data('placesHash', hash);
                        self.addClass(cls);
                        tgt.insertBefore(prev);
                        prev = tgt.prev('div');
                        menuTimer = setTimeout(function () {
                            self.removeClass(cls);
                            if (ctm.find(':first').data('placesHash') === hash) {
                                ctm.hide().empty();
                            }
                        }, 1500);
                    }

                    if (!prev.length) {
                        self.removeClass(cls);
                        ctm.hide().empty();
                    }
                },
                /**
                 * Update dir at places
                 *
                 * @param  Object   directory
                 * @param  String   previous hash
                 * @return Boolean
                 **/
                update = function (dir, preHash) {
                    var hash = dir.hash,
                        tgt = hash2elm(preHash || hash),
                        node = create(dir, hash);

                    if (tgt.length > 0) {
                        tgt.parent().replaceWith(node);
                        dirs[hash] = dir;
                        return true;
                    } else {
                        return false;
                    }
                },
                /**
                 * Remove all dir from places
                 *
                 * @return void
                 **/
                clear = function () {
                    subtree.empty();
                    root.removeClass(collapsed);
                    places.removeClass(expanded);
                    subtree.slideToggle(false);
                },
                /**
                 * Sort places dirs A-Z
                 *
                 * @return void
                 **/
                sort = function () {
                    $.each(dirs, function (h, f) {
                        var dir = fm.file(h) || f,
                            node = create(dir, h),
                            ret = null;
                        if (!dir) {
                            node.hide();
                        }
                        if (subtree.children().length) {
                            $.each(subtree.children(), function () {
                                var current = $(this);
                                if ((dir.i18 || dir.name).localeCompare(current.children('.' + navdir).text()) < 0) {
                                    ret = !node.insertBefore(current);
                                    return ret;
                                }
                            });
                            if (ret !== null) {
                                return true;
                            }
                        }
                        !hash2elm(h).length && subtree.append(node);
                    });
                    save();
                },
                // sort button
                sortBtn = $('<span class="elfinder-button-icon elfinder-button-icon-sort elfinder-places-root-icon" title="' + fm.i18n('cmdsort') + '"></span>')
                    .hide()
                    .on('click', function (e) {
                        e.stopPropagation();
                        subtree.empty();
                        sort();
                    }
                    ),
                /**
                 * Node - wrapper for places root
                 *
                 * @type jQuery
                 **/
                wrapper = create({
                    hash: 'root-' + fm.namespace,
                    name: fm.i18n(opts.name, 'places'),
                    read: true,
                    write: true
                }),
                /**
                 * Places root node
                 *
                 * @type jQuery
                 **/
                root = wrapper.children('.' + navdir)
                    .addClass(clroot)
                    .on('click', function (e) {
                        e.stopPropagation();
                        if (root.hasClass(collapsed)) {
                            places.toggleClass(expanded);
                            subtree.slideToggle();
                            fm.storage('placesState', places.hasClass(expanded) ? 1 : 0);
                        }
                    })
                    .append(sortBtn),
                /**
                 * Container for dirs
                 *
                 * @type jQuery
                 **/
                subtree = wrapper.children('.' + fm.res(c, 'navsubtree')),

                /**
                 * Main places container
                 *
                 * @type jQuery
                 **/
                places = $(this).addClass(fm.res(c, 'tree') + ' elfinder-places ui-corner-all')
                    .hide()
                    .append(wrapper)
                    .appendTo(fm.getUI('navbar'))
                    .on('mouseenter mouseleave', '.' + navdir, function (e) {
                        $(this).toggleClass('ui-state-hover', (e.type == 'mouseenter'));
                    })
                    .on('click', '.' + navdir, function (e) {
                        var p = $(this);
                        if (p.data('longtap')) {
                            e.stopPropagation();
                            return;
                        }
                        !p.hasClass('elfinder-na') && fm.exec('open', p.attr('id').substr(6));
                    })
                    .on('contextmenu', '.' + navdir + ':not(.' + clroot + ')', function (e) {
                        var self = $(this),
                            hash = self.attr('id').substr(6);

                        e.preventDefault();

                        fm.trigger('contextmenu', {
                            raw: [{
                                label: fm.i18n('moveUp'),
                                icon: 'up',
                                remain: true,
                                callback: function () { moveup(hash); save(); }
                            }, '|', {
                                label: fm.i18n('rmFromPlaces'),
                                icon: 'rm',
                                callback: function () { remove(hash); save(); }
                            }],
                            'x': e.pageX,
                            'y': e.pageY
                        });

                        self.addClass('ui-state-hover');

                        fm.getUI('contextmenu').children().on('mouseenter', function () {
                            self.addClass('ui-state-hover');
                        });

                        fm.bind('closecontextmenu', function () {
                            self.removeClass('ui-state-hover');
                        });
                    })
                    .droppable({
                        tolerance: 'pointer',
                        accept: '.elfinder-cwd-file-wrapper,.elfinder-tree-dir,.elfinder-cwd-file',
                        hoverClass: fm.res('class', 'adroppable'),
                        classes: { // Deprecated hoverClass jQueryUI>=1.12.0
                            'ui-droppable-hover': fm.res('class', 'adroppable')
                        },
                        over: function (e, ui) {
                            var helper = ui.helper,
                                dir = $.grep(helper.data('files'), function (h) { return (fm.file(h).mime === 'directory' && !dirs[h]) ? true : false; });
                            e.stopPropagation();
                            helper.data('dropover', helper.data('dropover') + 1);
                            if (fm.insideWorkzone(e.pageX, e.pageY)) {
                                if (dir.length > 0) {
                                    helper.addClass('elfinder-drag-helper-plus');
                                    fm.trigger('unlockfiles', { files: helper.data('files'), helper: helper });
                                } else {
                                    $(this).removeClass(dropover);
                                }
                            }
                        },
                        out: function (e, ui) {
                            var helper = ui.helper;
                            e.stopPropagation();
                            helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus').data('dropover', Math.max(helper.data('dropover') - 1, 0));
                            $(this).removeData('dropover')
                                .removeClass(dropover);
                        },
                        drop: function (e, ui) {
                            var helper = ui.helper,
                                resolve = true;

                            $.each(helper.data('files'), function (i, hash) {
                                var dir = fm.file(hash);

                                if (dir && dir.mime == 'directory' && !dirs[dir.hash]) {
                                    add(dir);
                                } else {
                                    resolve = false;
                                }
                            });
                            save();
                            resolve && helper.hide();
                        }
                    })
                    // for touch device
                    .on('touchstart', '.' + navdir + ':not(.' + clroot + ')', function (e) {
                        if (e.originalEvent.touches.length > 1) {
                            return;
                        }
                        var hash = $(this).attr('id').substr(6),
                            p = $(this)
                                .addClass(hover)
                                .data('longtap', null)
                                .data('tmlongtap', setTimeout(function () {
                                    // long tap
                                    p.data('longtap', true);
                                    fm.trigger('contextmenu', {
                                        raw: [{
                                            label: fm.i18n('rmFromPlaces'),
                                            icon: 'rm',
                                            callback: function () { remove(hash); save(); }
                                        }],
                                        'x': e.originalEvent.touches[0].pageX,
                                        'y': e.originalEvent.touches[0].pageY
                                    });
                                }, 500));
                    })
                    .on('touchmove touchend', '.' + navdir + ':not(.' + clroot + ')', function (e) {
                        clearTimeout($(this).data('tmlongtap'));
                        if (e.type == 'touchmove') {
                            $(this).removeClass(hover);
                        }
                    });

            if ($.fn.sortable) {
                subtree.addClass('touch-punch')
                    .sortable({
                        appendTo: fm.getUI(),
                        revert: false,
                        helper: function (e) {
                            var dir = $(e.target).parent();

                            dir.children().removeClass('ui-state-hover');

                            return $('<div class="ui-widget elfinder-place-drag elfinder-' + fm.direction + '"></div>')
                                .append($('<div class="elfinder-navbar"></div>').show().append(dir.clone()));

                        },
                        stop: function (e, ui) {
                            var target = $(ui.item[0]),
                                top = places.offset().top,
                                left = places.offset().left,
                                width = places.width(),
                                height = places.height(),
                                x = e.pageX,
                                y = e.pageY;

                            if (!(x > left && x < left + width && y > top && y < y + height)) {
                                remove(id2hash(target.children(':first').attr('id')));
                                save();
                            }
                        },
                        update: function (e, ui) {
                            save();
                        }
                    });
            }

            // "on regist" for command exec
            $(this).on('regist', function (e, files) {
                var added = false;
                $.each(files, function (i, dir) {
                    if (dir && dir.mime == 'directory' && !dirs[dir.hash]) {
                        if (add(dir)) {
                            added = true;
                        }
                    }
                });
                added && save();
            });


            // on fm load - show places and load files from backend
            fm.one('load', function () {
                var dat, hashes;

                if (fm.oldAPI) {
                    return;
                }

                places.show().parent().show();

                init();

                fm.change(function (e) {
                    var changed = false;
                    $.each(e.data.changed, function (i, file) {
                        if (dirs[file.hash]) {
                            if (file.mime !== 'directory') {
                                if (remove(file.hash)) {
                                    changed = true;
                                }
                            } else {
                                if (update(file)) {
                                    changed = true;
                                }
                            }
                        }
                    });
                    changed && save();
                })
                    .bind('rename', function (e) {
                        var changed = false;
                        if (e.data.removed) {
                            $.each(e.data.removed, function (i, hash) {
                                if (e.data.added[i]) {
                                    if (update(e.data.added[i], hash)) {
                                        changed = true;
                                    }
                                }
                            });
                        }
                        changed && save();
                    })
                    .bind('rm paste', function (e) {
                        var names = [],
                            changed = false;
                        if (e.data.removed) {
                            $.each(e.data.removed, function (i, hash) {
                                var name = remove(hash);
                                name && names.push(name);
                            });
                        }
                        if (names.length) {
                            changed = true;
                        }
                        if (e.data.added && names.length) {
                            $.each(e.data.added, function (i, file) {
                                if ($.inArray(file.name, names) !== 1) {
                                    file.mime == 'directory' && add(file);
                                }
                            });
                        }
                        changed && save();
                    })
                    .bind('sync netmount', function () {
                        var ev = this,
                            opSuffix = opts.suffix ? opts.suffix : '',
                            hashes;

                        if (ev.type === 'sync') {
                            // check is change of opts.suffix
                            if (suffix !== opSuffix) {
                                suffix = opSuffix;
                                clear();
                                init();
                                return;
                            }
                        }

                        hashes = Object.keys(dirs);
                        if (hashes.length) {
                            root.prepend(spinner);

                            fm.request({
                                data: { cmd: 'info', targets: hashes },
                                preventDefault: true
                            })
                                .done(function (data) {
                                    var exists = {},
                                        updated = false,
                                        cwd = fm.cwd().hash;
                                    $.each(data.files || [], function (i, file) {
                                        var hash = file.hash;
                                        exists[hash] = file;
                                        if (!fm.files().hasOwnProperty(file.hash)) {
                                            // update cache
                                            fm.updateCache({ tree: [file] });
                                        }
                                    });
                                    $.each(dirs, function (h, f) {
                                        if (Boolean(f.notfound) === Boolean(exists[h])) {
                                            if ((f.phash === cwd && ev.type !== 'netmount') || (exists[h] && exists[h].mime !== 'directory')) {
                                                if (remove(h)) {
                                                    updated = true;
                                                }
                                            } else {
                                                if (update(exists[h] || Object.assign({ notfound: true }, f))) {
                                                    updated = true;
                                                }
                                            }
                                        } else if (exists[h] && exists[h].phash != cwd) {
                                            // update permission of except cwd
                                            update(exists[h]);
                                        }
                                    });
                                    updated && save();
                                })
                                .always(function () {
                                    spinner.remove();
                                });
                        }
                    });

            });

        });
    };


    /*
     * File: /js/ui/searchbutton.js
     */

    /**
     * @class  elFinder toolbar search button widget.
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindersearchbutton = function (cmd) {
        return this.each(function () {
            var result = false,
                fm = cmd.fm,
                disabled = fm.res('class', 'disabled'),
                isopts = cmd.options.incsearch || { enable: false },
                sTypes = cmd.options.searchTypes,
                id = function (name) { return fm.namespace + fm.escape(name); },
                toolbar = fm.getUI('toolbar'),
                btnCls = fm.res('class', 'searchbtn'),
                button = $(this)
                    .hide()
                    .addClass('ui-widget-content elfinder-button ' + btnCls)
                    .on('click', function (e) {
                        e.stopPropagation();
                    }),
                getMenuOffset = function () {
                    var fmNode = fm.getUI(),
                        baseOffset = fmNode.offset(),
                        buttonOffset = button.offset();
                    return {
                        top: buttonOffset.top - baseOffset.top,
                        maxHeight: fmNode.height() - 40
                    };
                },
                search = function () {
                    input.data('inctm') && clearTimeout(input.data('inctm'));
                    var val = $.trim(input.val()),
                        from = !$('#' + id('SearchFromAll')).prop('checked'),
                        mime = $('#' + id('SearchMime')).prop('checked'),
                        type = '';
                    if (from) {
                        if ($('#' + id('SearchFromVol')).prop('checked')) {
                            from = fm.root(fm.cwd().hash);
                        } else {
                            from = fm.cwd().hash;
                        }
                    }
                    if (mime) {
                        mime = val;
                        val = '.';
                    }
                    if (typeSet) {
                        type = typeSet.children('input:checked').val();
                    }
                    if (val) {
                        input.trigger('focus');
                        cmd.exec(val, from, mime, type).done(function () {
                            result = true;
                        }).fail(function () {
                            abort();
                        });

                    } else {
                        fm.trigger('searchend');
                    }
                },
                abort = function () {
                    input.data('inctm') && clearTimeout(input.data('inctm'));
                    input.val('').trigger('blur');
                    if (result || incVal) {
                        result = false;
                        incVal = '';
                        fm.lazy(function () {
                            fm.trigger('searchend');
                        });
                    }
                },
                incVal = '',
                input = $('<input type="text" size="42"/>')
                    .on('focus', function () {
                        // close other menus
                        !button.hasClass('ui-state-active') && fm.getUI().click();
                        inFocus = true;
                        incVal = '';
                        button.addClass('ui-state-active');
                        fm.trigger('uiresize');
                        opts && opts.css(getMenuOffset()).slideDown(function () {
                            // Care for on browser window re-active
                            button.addClass('ui-state-active');
                            fm.toFront(opts);
                        });
                    })
                    .on('blur', function () {
                        inFocus = false;
                        if (opts) {
                            if (!opts.data('infocus')) {
                                opts.slideUp(function () {
                                    button.removeClass('ui-state-active');
                                    fm.trigger('uiresize');
                                    fm.toHide(opts);
                                });
                            } else {
                                opts.data('infocus', false);
                            }
                        } else {
                            button.removeClass('ui-state-active');
                        }
                    })
                    .appendTo(button)
                    // to avoid fm shortcuts on arrows
                    .on('keypress', function (e) {
                        e.stopPropagation();
                    })
                    .on('keydown', function (e) {
                        e.stopPropagation();
                        if (e.keyCode === $.ui.keyCode.ENTER) {
                            search();
                        } else if (e.keyCode === $.ui.keyCode.ESCAPE) {
                            e.preventDefault();
                            abort();
                        }
                    }),
                opts, typeSet, cwdReady, inFocus;

            if (isopts.enable) {
                isopts.minlen = isopts.minlen || 2;
                isopts.wait = isopts.wait || 500;
                input
                    .attr('title', fm.i18n('incSearchOnly'))
                    .on('compositionstart', function () {
                        input.data('composing', true);
                    })
                    .on('compositionend', function () {
                        input.removeData('composing');
                        input.trigger('input'); // for IE, edge
                    })
                    .on('input', function () {
                        if (!input.data('composing')) {
                            input.data('inctm') && clearTimeout(input.data('inctm'));
                            input.data('inctm', setTimeout(function () {
                                var val = input.val();
                                if (val.length === 0 || val.length >= isopts.minlen) {
                                    (incVal !== val) && fm.trigger('incsearchstart', {
                                        query: val,
                                        type: typeSet ? typeSet.children('input:checked').val() : 'searchName'
                                    });
                                    incVal = val;
                                    if (val === '' && fm.searchStatus.state > 1 && fm.searchStatus.query) {
                                        input.val(fm.searchStatus.query).trigger('select');
                                    }
                                }
                            }, isopts.wait));
                        }
                    });

                if (fm.UA.ltIE8) {
                    input.on('keydown', function (e) {
                        if (e.keyCode === 229) {
                            input.data('imetm') && clearTimeout(input.data('imetm'));
                            input.data('composing', true);
                            input.data('imetm', setTimeout(function () {
                                input.removeData('composing');
                            }, 100));
                        }
                    })
                        .on('keyup', function (e) {
                            input.data('imetm') && clearTimeout(input.data('imetm'));
                            if (input.data('composing')) {
                                e.keyCode === $.ui.keyCode.ENTER && input.trigger('compositionend');
                            } else {
                                input.trigger('input');
                            }
                        });
                }
            }

            $('<span class="ui-icon ui-icon-search" title="' + cmd.title + '"></span>')
                .appendTo(button)
                .on('mousedown', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (button.hasClass('ui-state-active')) {
                        search();
                    } else {
                        input.trigger('focus');
                    }
                });

            $('<span class="ui-icon ui-icon-close"></span>')
                .appendTo(button)
                .on('mousedown', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (input.val() === '' && !button.hasClass('ui-state-active')) {
                        input.trigger('focus');
                    } else {
                        abort();
                    }
                });

            // wait when button will be added to DOM
            fm.bind('toolbarload', function () {
                var parent = button.parent();
                if (parent.length) {
                    toolbar.prepend(button.show());
                    parent.remove();
                    // position icons for ie7
                    if (fm.UA.ltIE7) {
                        var icon = button.children(fm.direction == 'ltr' ? '.ui-icon-close' : '.ui-icon-search');
                        icon.css({
                            right: '',
                            left: parseInt(button.width()) - icon.outerWidth(true)
                        });
                    }
                }
            });

            fm
                .one('init', function () {
                    fm.getUI('cwd').on('touchstart click', function () {
                        inFocus && input.trigger('blur');
                    });
                })
                .one('open', function () {
                    opts = (fm.api < 2.1) ? null : $('<div class="ui-front ui-widget ui-widget-content elfinder-button-menu elfinder-button-search-menu ui-corner-all"></div>')
                        .append(
                            $('<div class="buttonset"></div>')
                                .append(
                                    $('<input id="' + id('SearchFromCwd') + '" name="serchfrom" type="radio" checked="checked"/><label for="' + id('SearchFromCwd') + '">' + fm.i18n('btnCwd') + '</label>'),
                                    $('<input id="' + id('SearchFromVol') + '" name="serchfrom" type="radio"/><label for="' + id('SearchFromVol') + '">' + fm.i18n('btnVolume') + '</label>'),
                                    $('<input id="' + id('SearchFromAll') + '" name="serchfrom" type="radio"/><label for="' + id('SearchFromAll') + '">' + fm.i18n('btnAll') + '</label>')
                                ),
                            $('<div class="buttonset elfinder-search-type"></div>')
                                .append(
                                    $('<input id="' + id('SearchName') + '" name="serchcol" type="radio" checked="checked" value="SearchName"/><label for="' + id('SearchName') + '">' + fm.i18n('btnFileName') + '</label>')
                                )
                        )
                        .hide()
                        .appendTo(fm.getUI());
                    if (opts) {
                        if (sTypes) {
                            typeSet = opts.find('.elfinder-search-type');
                            $.each(cmd.options.searchTypes, function (i, v) {
                                typeSet.append($('<input id="' + id(i) + '" name="serchcol" type="radio" value="' + fm.escape(i) + '"/><label for="' + id(i) + '">' + fm.i18n(v.name) + '</label>'));
                            });
                        }
                        opts.find('div.buttonset').buttonset();
                        $('#' + id('SearchFromAll')).next('label').attr('title', fm.i18n('searchTarget', fm.i18n('btnAll')));
                        if (sTypes) {
                            $.each(sTypes, function (i, v) {
                                if (v.title) {
                                    $('#' + id(i)).next('label').attr('title', fm.i18n(v.title));
                                }
                            });
                        }
                        opts.on('mousedown', 'div.buttonset', function (e) {
                            e.stopPropagation();
                            opts.data('infocus', true);
                        })
                            .on('click', 'input', function (e) {
                                e.stopPropagation();
                                $.trim(input.val()) ? search() : input.trigger('focus');
                            })
                            .on('close', function () {
                                input.trigger('blur');
                            });
                    }
                })
                .bind('searchend', function () {
                    input.val('');
                })
                .bind('open parents', function () {
                    var dirs = [],
                        volroot = fm.file(fm.root(fm.cwd().hash));

                    if (volroot) {
                        $.each(fm.parents(fm.cwd().hash), function (i, hash) {
                            dirs.push(fm.file(hash).name);
                        });

                        $('#' + id('SearchFromCwd')).next('label').attr('title', fm.i18n('searchTarget', dirs.join(fm.option('separator'))));
                        $('#' + id('SearchFromVol')).next('label').attr('title', fm.i18n('searchTarget', volroot.name));
                    }
                })
                .bind('open', function () {
                    incVal && abort();
                })
                .bind('cwdinit', function () {
                    cwdReady = false;
                })
                .bind('cwdrender', function () {
                    cwdReady = true;
                })
                .bind('keydownEsc', function () {
                    if (incVal && incVal.substr(0, 1) === '/') {
                        incVal = '';
                        input.val('');
                        fm.trigger('searchend');
                    }
                })
                .shortcut({
                    pattern: 'ctrl+f f3',
                    description: cmd.title,
                    callback: function () {
                        input.trigger('select').trigger('focus');
                    }
                })
                .shortcut({
                    pattern: 'a b c d e f g h i j k l m n o p q r s t u v w x y z dig0 dig1 dig2 dig3 dig4 dig5 dig6 dig7 dig8 dig9 num0 num1 num2 num3 num4 num5 num6 num7 num8 num9',
                    description: fm.i18n('firstLetterSearch'),
                    callback: function (e) {
                        if (!cwdReady) { return; }

                        var code = e.originalEvent.keyCode,
                            next = function () {
                                var sel = fm.selected(),
                                    key = $.ui.keyCode[(!sel.length || fm.cwdHash2Elm(sel[0]).next('[id]').length) ? 'RIGHT' : 'HOME'];
                                $(document).trigger($.Event('keydown', { keyCode: key, ctrlKey: false, shiftKey: false, altKey: false, metaKey: false }));
                            },
                            val;
                        if (code >= 96 && code <= 105) {
                            code -= 48;
                        }
                        val = '/' + String.fromCharCode(code);
                        if (incVal !== val) {
                            input.val(val);
                            incVal = val;
                            fm
                                .trigger('incsearchstart', { query: val })
                                .one('cwdrender', next);
                        } else {
                            next();
                        }
                    }
                });

        });
    };


    /*
     * File: /js/ui/sortbutton.js
     */

    /**
     * @class  elFinder toolbar button menu with sort variants.
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindersortbutton = function (cmd) {
        return this.each(function () {
            var fm = cmd.fm,
                name = cmd.name,
                c = 'class',
                disabled = fm.res(c, 'disabled'),
                hover = fm.res(c, 'hover'),
                item = 'elfinder-button-menu-item',
                selected = item + '-selected',
                asc = selected + '-asc',
                desc = selected + '-desc',
                text = $('<span class="elfinder-button-text">' + cmd.title + '</span>'),
                button = $(this).addClass('ui-state-default elfinder-button elfinder-menubutton elfiner-button-' + name)
                    .attr('title', cmd.title)
                    .append('<span class="elfinder-button-icon elfinder-button-icon-' + name + '"></span>', text)
                    .on('mouseenter mouseleave', function (e) { !button.hasClass(disabled) && button.toggleClass(hover, e.type === 'mouseenter'); })
                    .on('click', function (e) {
                        if (!button.hasClass(disabled)) {
                            e.stopPropagation();
                            menu.is(':hidden') && fm.getUI().click();
                            menu.css(getMenuOffset()).slideToggle({
                                duration: 100,
                                done: function (e) {
                                    fm[menu.is(':visible') ? 'toFront' : 'toHide'](menu);
                                }
                            });
                        }
                    }),
                hide = function () { fm.toHide(menu); },
                menu = $('<div class="ui-front ui-widget ui-widget-content elfinder-button-menu elfinder-button-sort-menu ui-corner-all"></div>')
                    .hide()
                    .appendTo(fm.getUI())
                    .on('mouseenter mouseleave', '.' + item, function (e) { $(this).toggleClass(hover, e.type === 'mouseenter'); })
                    .on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    })
                    .on('close', hide),
                update = function () {
                    menu.children('[rel]').removeClass(selected + ' ' + asc + ' ' + desc)
                        .filter('[rel="' + fm.sortType + '"]')
                        .addClass(selected + ' ' + (fm.sortOrder == 'asc' ? asc : desc));

                    menu.children('.elfinder-sort-stick').toggleClass(selected, fm.sortStickFolders);
                    menu.children('.elfinder-sort-tree').toggleClass(selected, fm.sortAlsoTreeview);
                },
                getMenuOffset = function () {
                    var baseOffset = fm.getUI().offset(),
                        buttonOffset = button.offset();
                    return {
                        top: buttonOffset.top - baseOffset.top,
                        left: buttonOffset.left - baseOffset.left
                    };
                },
                tm;

            text.hide();

            $.each(fm.sortRules, function (name, value) {
                menu.append($('<div class="' + item + '" rel="' + name + '"><span class="ui-icon ui-icon-arrowthick-1-n"></span><span class="ui-icon ui-icon-arrowthick-1-s"></span>' + fm.i18n('sort' + name) + '</div>').data('type', name));
            });

            menu.children().on('click', function (e) {
                cmd.exec([], $(this).removeClass(hover).attr('rel'));
            });

            $('<div class="' + item + ' ' + item + '-separated elfinder-sort-ext elfinder-sort-stick"><span class="ui-icon ui-icon-check"></span>' + fm.i18n('sortFoldersFirst') + '</div>')
                .appendTo(menu)
                .on('click', function () {
                    cmd.exec([], 'stick');
                });

            fm.one('init', function () {
                if (fm.ui.tree && fm.options.sortAlsoTreeview !== null) {
                    $('<div class="' + item + ' ' + item + '-separated elfinder-sort-ext elfinder-sort-tree"><span class="ui-icon ui-icon-check"></span>' + fm.i18n('sortAlsoTreeview') + '</div>')
                        .appendTo(menu)
                        .on('click', function () {
                            cmd.exec([], 'tree');
                        });
                }
            })
                .bind('disable select', hide)
                .bind('sortchange', update).getUI().on('click', hide);

            if (menu.children().length > 1) {
                cmd.change(function () {
                    tm && cancelAnimationFrame(tm);
                    tm = requestAnimationFrame(function () {
                        button.toggleClass(disabled, cmd.disabled());
                        update();
                    });
                })
                    .change();
            } else {
                button.addClass(disabled);
            }

        });

    };


    /*
     * File: /js/ui/stat.js
     */

    /**
     * @class elFinder ui
     * Display number of files/selected files and its size in statusbar
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderstat = function (fm) {
        return this.each(function () {
            var size = $(this).addClass('elfinder-stat-size'),
                sel = $('<div class="elfinder-stat-selected"></div>')
                    .on('click', 'a', function (e) {
                        var hash = $(this).data('hash');
                        e.preventDefault();
                        fm.exec('opendir', [hash]);
                    }),
                titleitems = fm.i18n('items'),
                titlesel = fm.i18n('selected'),
                titlesize = fm.i18n('size'),
                setstat = function (files) {
                    var c = 0,
                        s = 0,
                        cwd = fm.cwd(),
                        calc = true,
                        hasSize = true;

                    if (cwd.sizeInfo || cwd.size) {
                        s = cwd.size;
                        calc = false;
                    }
                    $.each(files, function (i, file) {
                        c++;
                        if (calc) {
                            s += parseInt(file.size) || 0;
                            if (hasSize === true && file.mime === 'directory' && !file.sizeInfo) {
                                hasSize = false;
                            }
                        }
                    });
                    size.html(titleitems + ': <span class="elfinder-stat-incsearch"></span>' + c + ',&nbsp;<span class="elfinder-stat-size' + (hasSize ? ' elfinder-stat-size-recursive' : '') + '">' + fm.i18n(hasSize ? 'sum' : 'size') + ': ' + fm.formatSize(s) + '</span>')
                        .attr('title', size.text());
                    fm.trigger('uistatchange');
                },
                setIncsearchStat = function (data) {
                    size.find('span.elfinder-stat-incsearch').html(data ? data.hashes.length + ' / ' : '');
                    size.attr('title', size.text());
                    fm.trigger('uistatchange');
                },
                setSelect = function (files) {
                    var s = 0,
                        c = 0,
                        dirs = [],
                        path, file;

                    if (files.length === 1) {
                        file = files[0];
                        s = file.size;
                        if (fm.searchStatus.state === 2) {
                            path = fm.escape(file.path ? file.path.replace(/\/[^\/]*$/, '') : '..');
                            dirs.push('<a href="#elf_' + file.phash + '" data-hash="' + file.hash + '" title="' + path + '">' + path + '</a>');
                        }
                        dirs.push(fm.escape(file.i18 || file.name));
                        sel.html(dirs.join('/') + (s > 0 ? ', ' + fm.formatSize(s) : ''));
                    } else if (files.length) {
                        $.each(files, function (i, file) {
                            c++;
                            s += parseInt(file.size) || 0;
                        });
                        sel.html(c ? titlesel + ': ' + c + ', ' + titlesize + ': ' + fm.formatSize(s) : '&nbsp;');
                    } else {
                        sel.html('');
                    }
                    sel.attr('title', sel.text());
                    fm.trigger('uistatchange');
                };

            fm.getUI('statusbar').prepend(size).append(sel).show();
            if (fm.UA.Mobile && $.fn.tooltip) {
                fm.getUI('statusbar').tooltip({
                    classes: {
                        'ui-tooltip': 'elfinder-ui-tooltip ui-widget-shadow'
                    },
                    tooltipClass: 'elfinder-ui-tooltip ui-widget-shadow',
                    track: true
                });
            }

            fm
                .bind('cwdhasheschange', function (e) {
                    setstat($.map(e.data, function (h) { return fm.file(h); }));
                })
                .change(function (e) {
                    var files = e.data.changed || [],
                        cwdHash = fm.cwd().hash;
                    $.each(files, function () {
                        if (this.hash === cwdHash) {
                            if (this.size) {
                                size.children('.elfinder-stat-size').addClass('elfinder-stat-size-recursive').html(fm.i18n('sum') + ': ' + fm.formatSize(this.size));
                                size.attr('title', size.text());
                            }
                            return false;
                        }
                    });
                })
                .select(function () {
                    setSelect(fm.selectedFiles());
                })
                .bind('open', function () {
                    setSelect([]);
                })
                .bind('incsearch', function (e) {
                    setIncsearchStat(e.data);
                })
                .bind('incsearchend', function () {
                    setIncsearchStat();
                })
                ;
        });
    };


    /*
     * File: /js/ui/toast.js
     */

    /**
     * @class  elFinder toast
     * 
     * This was created inspired by the toastr. Thanks to developers of toastr.
     * CodeSeven/toastr: http://johnpapa.net <https://github.com/CodeSeven/toastr>
     *
     * @author Naoki Sawada
     **/
    $.fn.elfindertoast = function (opts, fm) {
        var defOpts = Object.assign({
            mode: 'success', // or 'info', 'warning' and 'error'
            msg: '',
            showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
            showDuration: 300,
            showEasing: 'swing', //swing and linear are built into jQuery
            onShown: undefined,
            hideMethod: 'fadeOut',
            hideDuration: 1500,
            hideEasing: 'swing',
            onHidden: undefined,
            timeOut: 3000,
            extNode: undefined,
            button: undefined,
            width: undefined
        }, $.isPlainObject(fm.options.uiOptions.toast.defaults) ? fm.options.uiOptions.toast.defaults : {});
        return this.each(function () {
            opts = Object.assign({}, defOpts, opts || {});

            var self = $(this),
                show = function (notm) {
                    self.stop();
                    fm.toFront(self);
                    self[opts.showMethod]({
                        duration: opts.showDuration,
                        easing: opts.showEasing,
                        complete: function () {
                            opts.onShown && opts.onShown();
                            if (!notm && opts.timeOut) {
                                rmTm = setTimeout(rm, opts.timeOut);
                            }
                        }
                    });
                },
                rm = function () {
                    self[opts.hideMethod]({
                        duration: opts.hideDuration,
                        easing: opts.hideEasing,
                        complete: function () {
                            opts.onHidden && opts.onHidden();
                            self.remove();
                        }
                    });
                },
                rmTm;

            self.on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                rmTm && clearTimeout(rmTm);
                opts.onHidden && opts.onHidden();
                self.stop().remove();
            }).on('mouseenter mouseleave', function (e) {
                if (opts.timeOut) {
                    rmTm && clearTimeout(rmTm);
                    rmTm = null;
                    if (e.type === 'mouseenter') {
                        show(true);
                    } else {
                        rmTm = setTimeout(rm, opts.timeOut);
                    }
                }
            }).hide().addClass('toast-' + opts.mode).append($('<div class="elfinder-toast-msg"></div>').html(opts.msg.replace(/%([a-zA-Z0-9]+)%/g, function (m, m1) {
                return fm.i18n(m1);
            })));

            if (opts.extNode) {
                self.append(opts.extNode);
            }

            if (opts.button) {
                self.append(
                    $('<button class="ui-button ui-widget ui-state-default ui-corner-all elfinder-tabstop"></button>')
                        .append($('<span class="ui-button-text"></span>').text(fm.i18n(opts.button.text)))
                        .on('mouseenter mouseleave', function (e) {
                            $(this).toggleClass('ui-state-hover', e.type == 'mouseenter');
                        })
                        .on('click', opts.button.click || function () { })
                );
            }

            if (opts.width) {
                self.css('max-width', opts.width);
            }

            show();
        });
    };

    /*
     * File: /js/ui/toolbar.js
     */

    /**
     * @class  elFinder toolbar
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindertoolbar = function (fm, opts) {
        this.not('.elfinder-toolbar').each(function () {
            var commands = fm._commands,
                self = $(this).addClass('ui-helper-clearfix ui-widget-header elfinder-toolbar'),
                options = {
                    // default options
                    displayTextLabel: false,
                    labelExcludeUA: ['Mobile'],
                    autoHideUA: ['Mobile'],
                    showPreferenceButton: 'none'
                },
                filter = function (opts) {
                    return $.grep(opts, function (v) {
                        if ($.isPlainObject(v)) {
                            options = Object.assign(options, v);
                            return false;
                        }
                        return true;
                    });
                },
                render = function (disabled) {
                    var name, cmdPref;

                    $.each(buttons, function (i, b) { b.detach(); });
                    self.empty();
                    l = panels.length;
                    while (l--) {
                        if (panels[l]) {
                            panel = $('<div class="ui-widget-content ui-corner-all elfinder-buttonset"></div>');
                            i = panels[l].length;
                            while (i--) {
                                name = panels[l][i];
                                if ((!disabled || !disabled[name]) && (cmd = commands[name])) {
                                    button = 'elfinder' + cmd.options.ui;
                                    if (!buttons[name] && $.fn[button]) {
                                        buttons[name] = $('<div></div>')[button](cmd);
                                    }
                                    if (buttons[name]) {
                                        buttons[name].children('.elfinder-button-text')[textLabel ? 'show' : 'hide']();
                                        panel.prepend(buttons[name]);
                                    }
                                }
                            }

                            panel.children().length && self.prepend(panel);
                            panel.children(':gt(0)').before('<span class="ui-widget-content elfinder-toolbar-button-separator"></span>');

                        }
                    }

                    if (cmdPref = commands['preference']) {
                        //cmdPref.state = !self.children().length? 0 : -1;
                        if (options.showPreferenceButton === 'always' || (!self.children().length && options.showPreferenceButton === 'auto')) {
                            //cmdPref.state = 0;
                            panel = $('<div class="ui-widget-content ui-corner-all elfinder-buttonset"></div>');
                            name = 'preference';
                            button = 'elfinder' + cmd.options.ui;
                            buttons[name] = $('<div></div>')[button](cmdPref);
                            buttons[name].children('.elfinder-button-text')[textLabel ? 'show' : 'hide']();
                            panel.prepend(buttons[name]);
                            self.append(panel);
                        }
                    }

                    (!self.data('swipeClose') && self.children().length) ? self.show() : self.hide();
                    prevHeight = self[0].clientHeight;
                    fm.trigger('toolbarload').trigger('uiresize');
                },
                buttons = {},
                panels = filter(opts || []),
                dispre = null,
                uiCmdMapPrev = '',
                prevHeight = 0,
                contextRaw = [],
                l, i, cmd, panel, button, swipeHandle, autoHide, textLabel, resizeTm;

            // normalize options
            options.showPreferenceButton = options.showPreferenceButton.toLowerCase();

            if (options.displayTextLabel !== 'none') {
                // correction of options.displayTextLabel
                textLabel = fm.storage('toolbarTextLabel');
                if (textLabel === null) {
                    textLabel = (options.displayTextLabel && (!options.labelExcludeUA || !options.labelExcludeUA.length || !$.grep(options.labelExcludeUA, function (v) { return fm.UA[v] ? true : false; }).length));
                } else {
                    textLabel = (textLabel == 1);
                }
                contextRaw.push({
                    label: fm.i18n('textLabel'),
                    icon: 'text',
                    callback: function () {
                        textLabel = !textLabel;
                        self.css('height', '').find('.elfinder-button-text')[textLabel ? 'show' : 'hide']();
                        fm.trigger('uiresize').storage('toolbarTextLabel', textLabel ? '1' : '0');
                    },
                });
            }

            if (options.preferenceInContextmenu && commands['preference']) {
                contextRaw.push({
                    label: fm.i18n('toolbarPref'),
                    icon: 'preference',
                    callback: function () {
                        fm.exec('preference', void (0), { tab: 'toolbar' });
                    }
                });
            }

            // add contextmenu
            if (contextRaw.length) {
                self.on('contextmenu', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    fm.trigger('contextmenu', {
                        raw: contextRaw,
                        x: e.pageX,
                        y: e.pageY
                    });
                }).on('touchstart', function (e) {
                    if (e.originalEvent.touches.length > 1) {
                        return;
                    }
                    self.data('tmlongtap') && clearTimeout(self.data('tmlongtap'));
                    self.removeData('longtap')
                        .data('longtap', { x: e.originalEvent.touches[0].pageX, y: e.originalEvent.touches[0].pageY })
                        .data('tmlongtap', setTimeout(function () {
                            self.removeData('longtapTm')
                                .trigger({
                                    type: 'contextmenu',
                                    pageX: self.data('longtap').x,
                                    pageY: self.data('longtap').y
                                })
                                .data('longtap', { longtap: true });
                        }, 500));
                }).on('touchmove touchend', function (e) {
                    if (self.data('tmlongtap')) {
                        if (e.type === 'touchend' ||
                            (Math.abs(self.data('longtap').x - e.originalEvent.touches[0].pageX)
                                + Math.abs(self.data('longtap').y - e.originalEvent.touches[0].pageY)) > 4)
                            clearTimeout(self.data('tmlongtap'));
                        self.removeData('longtapTm');
                    }
                }).on('click', function (e) {
                    if (self.data('longtap') && self.data('longtap').longtap) {
                        e.stopImmediatePropagation();
                        e.preventDefault();
                    }
                }).on('touchend click', '.elfinder-button', function (e) {
                    if (self.data('longtap') && self.data('longtap').longtap) {
                        e.stopImmediatePropagation();
                        e.preventDefault();
                    }
                }
                );
            }

            self.prev().length && self.parent().prepend(this);

            render();

            fm.bind('open sync select toolbarpref', function () {
                var disabled = Object.assign({}, fm.option('disabledFlip')),
                    userHides = fm.storage('toolbarhides'),
                    doRender, sel, disabledKeys;

                if (!userHides && Array.isArray(options.defaultHides)) {
                    userHides = {};
                    $.each(options.defaultHides, function () {
                        userHides[this] = true;
                    });
                    fm.storage('toolbarhides', userHides);
                }
                if (this.type === 'select') {
                    if (fm.searchStatus.state < 2) {
                        return;
                    }
                    sel = fm.selected();
                    if (sel.length) {
                        disabled = fm.getDisabledCmds(sel, true);
                    }
                }

                $.each(userHides, function (n) {
                    if (!disabled[n]) {
                        disabled[n] = true;
                    }
                });

                if (Object.keys(fm.commandMap).length) {
                    $.each(fm.commandMap, function (from, to) {
                        if (to === 'hidden') {
                            disabled[from] = true;
                        }
                    });
                }

                disabledKeys = Object.keys(disabled);
                if (!dispre || dispre.toString() !== disabledKeys.sort().toString()) {
                    render(disabledKeys.length ? disabled : null);
                    doRender = true;
                }
                dispre = disabledKeys.sort();

                if (doRender || uiCmdMapPrev !== JSON.stringify(fm.commandMap)) {
                    uiCmdMapPrev = JSON.stringify(fm.commandMap);
                    if (!doRender) {
                        // reset toolbar
                        $.each($('div.elfinder-button'), function () {
                            var origin = $(this).data('origin');
                            if (origin) {
                                $(this).after(origin).detach();
                            }
                        });
                    }
                    if (Object.keys(fm.commandMap).length) {
                        $.each(fm.commandMap, function (from, to) {
                            var cmd = fm._commands[to],
                                button = cmd ? 'elfinder' + cmd.options.ui : null,
                                btn;
                            if (button && $.fn[button]) {
                                btn = buttons[from];
                                if (btn) {
                                    if (!buttons[to] && $.fn[button]) {
                                        buttons[to] = $('<div></div>')[button](cmd);
                                        if (buttons[to]) {
                                            buttons[to].children('.elfinder-button-text')[textLabel ? 'show' : 'hide']();
                                            if (cmd.extendsCmd) {
                                                buttons[to].children('span.elfinder-button-icon').addClass('elfinder-button-icon-' + cmd.extendsCmd);
                                            }
                                        }
                                    }
                                    if (buttons[to]) {
                                        btn.after(buttons[to]);
                                        buttons[to].data('origin', btn.detach());
                                    }
                                }
                            }
                        });
                    }
                }
            }).bind('resize', function (e) {
                resizeTm && cancelAnimationFrame(resizeTm);
                resizeTm = requestAnimationFrame(function () {
                    var h = self[0].clientHeight;
                    if (prevHeight !== h) {
                        prevHeight = h;
                        fm.trigger('uiresize');
                    }
                });
            });

            if (fm.UA.Touch) {
                autoHide = fm.storage('autoHide') || {};
                if (typeof autoHide.toolbar === 'undefined') {
                    autoHide.toolbar = (options.autoHideUA && options.autoHideUA.length > 0 && $.grep(options.autoHideUA, function (v) { return fm.UA[v] ? true : false; }).length);
                    fm.storage('autoHide', autoHide);
                }

                if (autoHide.toolbar) {
                    fm.one('init', function () {
                        fm.uiAutoHide.push(function () { self.stop(true, true).trigger('toggle', { duration: 500, init: true }); });
                    });
                }

                fm.bind('load', function () {
                    swipeHandle = $('<div class="elfinder-toolbar-swipe-handle"></div>').hide().appendTo(fm.getUI());
                    if (swipeHandle.css('pointer-events') !== 'none') {
                        swipeHandle.remove();
                        swipeHandle = null;
                    }
                });

                self.on('toggle', function (e, data) {
                    var wz = fm.getUI('workzone'),
                        toshow = self.is(':hidden'),
                        wzh = wz.height(),
                        h = self.height(),
                        tbh = self.outerHeight(true),
                        delta = tbh - h,
                        opt = Object.assign({
                            step: function (now) {
                                wz.height(wzh + (toshow ? (now + delta) * -1 : h - now));
                                fm.trigger('resize');
                            },
                            always: function () {
                                requestAnimationFrame(function () {
                                    self.css('height', '');
                                    fm.trigger('uiresize');
                                    if (swipeHandle) {
                                        if (toshow) {
                                            swipeHandle.stop(true, true).hide();
                                        } else {
                                            swipeHandle.height(data.handleH ? data.handleH : '');
                                            fm.resources.blink(swipeHandle, 'slowonce');
                                        }
                                    }
                                    toshow && self.scrollTop('0px');
                                    data.init && fm.trigger('uiautohide');
                                });
                            }
                        }, data);
                    self.data('swipeClose', !toshow).stop(true, true).animate({ height: 'toggle' }, opt);
                    autoHide.toolbar = !toshow;
                    fm.storage('autoHide', Object.assign(fm.storage('autoHide'), { toolbar: autoHide.toolbar }));
                }).on('touchstart', function (e) {
                    if (self.scrollBottom() > 5) {
                        e.originalEvent._preventSwipeY = true;
                    }
                });
            }
        });

        return this;
    };


    /*
     * File: /js/ui/tree.js
     */

    /**
     * @class  elFinder folders tree
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfindertree = function (fm, opts) {
        var treeclass = fm.res('class', 'tree');

        this.not('.' + treeclass).each(function () {

            var c = 'class', mobile = fm.UA.Mobile,

                /**
                 * Root directory class name
                 *
                 * @type String
                 */
                root = fm.res(c, 'treeroot'),

                /**
                 * Open root dir if not opened yet
                 *
                 * @type Boolean
                 */
                openRoot = opts.openRootOnLoad,

                /**
                 * Open current work dir if not opened yet
                 *
                 * @type Boolean
                 */
                openCwd = opts.openCwdOnOpen,


                /**
                 * Auto loading current directory parents and do expand their node
                 *
                 * @type Boolean
                 */
                syncTree = openCwd || opts.syncTree,

                /**
                 * Subtree class name
                 *
                 * @type String
                 */
                subtree = fm.res(c, 'navsubtree'),

                /**
                 * Directory class name
                 *
                 * @type String
                 */
                navdir = fm.res(c, 'treedir'),

                /**
                 * Directory CSS selector
                 *
                 * @type String
                 */
                selNavdir = 'span.' + navdir,

                /**
                 * Collapsed arrow class name
                 *
                 * @type String
                 */
                collapsed = fm.res(c, 'navcollapse'),

                /**
                 * Expanded arrow class name
                 *
                 * @type String
                 */
                expanded = fm.res(c, 'navexpand'),

                /**
                 * Class name to mark arrow for directory with already loaded children
                 *
                 * @type String
                 */
                loaded = 'elfinder-subtree-loaded',

                /**
                 * Class name to mark need subdirs request
                 *
                 * @type String
                 */
                chksubdir = 'elfinder-subtree-chksubdir',

                /**
                 * Arraw class name
                 *
                 * @type String
                 */
                arrow = fm.res(c, 'navarrow'),

                /**
                 * Current directory class name
                 *
                 * @type String
                 */
                active = fm.res(c, 'active'),

                /**
                 * Droppable dirs dropover class
                 *
                 * @type String
                 */
                dropover = fm.res(c, 'adroppable'),

                /**
                 * Hover class name
                 *
                 * @type String
                 */
                hover = fm.res(c, 'hover'),

                /**
                 * Disabled dir class name
                 *
                 * @type String
                 */
                disabled = fm.res(c, 'disabled'),

                /**
                 * Draggable dir class name
                 *
                 * @type String
                 */
                draggable = fm.res(c, 'draggable'),

                /**
                 * Droppable dir  class name
                 *
                 * @type String
                 */
                droppable = fm.res(c, 'droppable'),

                /**
                 * root wrapper class
                 * 
                 * @type String
                 */
                wrapperRoot = 'elfinder-navbar-wrapper-root',

                /**
                 * Un-disabled cmd `paste` volume's root wrapper class
                 * 
                 * @type String
                 */
                pastable = 'elfinder-navbar-wrapper-pastable',

                /**
                 * Un-disabled cmd `upload` volume's root wrapper class
                 * 
                 * @type String
                 */
                uploadable = 'elfinder-navbar-wrapper-uploadable',

                /**
                 * Is position x inside Navbar
                 * 
                 * @param x Numbar
                 * 
                 * @return
                 */
                insideNavbar = function (x) {
                    var left = navbar.offset().left;

                    return left <= x && x <= left + navbar.width();
                },

                /**
                 * To call subdirs elements queue
                 * 
                 * @type Object
                 */
                subdirsQue = {},

                /**
                 * To exec subdirs elements ids
                 * 
                 */
                subdirsExecQue = [],

                /**
                 * Request subdirs to backend
                 * 
                 * @param id String
                 * 
                 * @return Deferred
                 */
                subdirs = function (ids) {
                    var targets = [];
                    $.each(ids, function (i, id) {
                        subdirsQue[id] && targets.push(fm.navId2Hash(id));
                        delete subdirsQue[id];
                    });
                    if (targets.length) {
                        return fm.request({
                            data: {
                                cmd: 'subdirs',
                                targets: targets,
                                preventDefault: true
                            }
                        }).done(function (res) {
                            if (res && res.subdirs) {
                                $.each(res.subdirs, function (hash, subdirs) {
                                    var elm = fm.navHash2Elm(hash);
                                    elm.removeClass(chksubdir);
                                    elm[subdirs ? 'addClass' : 'removeClass'](collapsed);
                                });
                            }
                        });
                    }
                },

                subdirsJobRes = null,

                /**
                 * To check target element is in window of subdirs
                 * 
                 * @return void
                 */
                checkSubdirs = function () {
                    var ids = Object.keys(subdirsQue);
                    if (ids.length) {
                        subdirsJobRes && subdirsJobRes._abort();
                        execSubdirsTm && clearTimeout(execSubdirsTm);
                        subdirsExecQue = [];
                        subdirsJobRes = fm.asyncJob(function (id) {
                            return fm.isInWindow($('#' + id)) ? id : null;
                        }, ids, { numPerOnce: 200 })
                            .done(function (arr) {
                                if (arr.length) {
                                    subdirsExecQue = arr;
                                    execSubdirs();
                                }
                            });
                    }
                },

                subdirsPending = 0,
                execSubdirsTm,

                /**
                 * Exec subdirs as batch request
                 * 
                 * @return void
                 */
                execSubdirs = function () {
                    var cnt = opts.subdirsMaxConn - subdirsPending,
                        atOnce = fm.maxTargets ? Math.min(fm.maxTargets, opts.subdirsAtOnce) : opts.subdirsAtOnce,
                        i, ids;
                    execSubdirsTm && cancelAnimationFrame(execSubdirsTm);
                    if (subdirsExecQue.length) {
                        if (cnt > 0) {
                            for (i = 0; i < cnt; i++) {
                                if (subdirsExecQue.length) {
                                    subdirsPending++;
                                    subdirs(subdirsExecQue.splice(0, atOnce)).always(function () {
                                        subdirsPending--;
                                        execSubdirs();
                                    });
                                }
                            }
                        } else {
                            execSubdirsTm = requestAnimationFrame(function () {
                                subdirsExecQue.length && execSubdirs();
                            });
                        }
                    }
                },

                drop = fm.droppable.drop,

                /**
                 * Droppable options
                 *
                 * @type Object
                 */
                droppableopts = $.extend(true, {}, fm.droppable, {
                    // show subfolders on dropover
                    over: function (e, ui) {
                        var dst = $(this),
                            helper = ui.helper,
                            cl = hover + ' ' + dropover,
                            hash, status;
                        e.stopPropagation();
                        helper.data('dropover', helper.data('dropover') + 1);
                        dst.data('dropover', true);
                        if (ui.helper.data('namespace') !== fm.namespace || !fm.insideWorkzone(e.pageX, e.pageY)) {
                            dst.removeClass(cl);
                            helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus');
                            return;
                        }
                        if (!insideNavbar(e.clientX)) {
                            dst.removeClass(cl);
                            return;
                        }
                        helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus');
                        dst.addClass(hover);
                        if (dst.is('.' + collapsed + ':not(.' + expanded + ')')) {
                            dst.data('expandTimer', setTimeout(function () {
                                dst.is('.' + collapsed + '.' + hover) && dst.children('.' + arrow).trigger('click');
                            }, 500));
                        }
                        if (dst.is('.elfinder-ro,.elfinder-na')) {
                            dst.removeClass(dropover);
                            //helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus');
                            return;
                        }
                        hash = fm.navId2Hash(dst.attr('id'));
                        dst.data('dropover', hash);
                        $.each(ui.helper.data('files'), function (i, h) {
                            if (h === hash || (fm.file(h).phash === hash && !ui.helper.hasClass('elfinder-drag-helper-plus'))) {
                                dst.removeClass(cl);
                                return false; // break $.each
                            }
                        });
                        if (helper.data('locked')) {
                            status = 'elfinder-drag-helper-plus';
                        } else {
                            status = 'elfinder-drag-helper-move';
                            if (fm._commands.copy && (e.shiftKey || e.ctrlKey || e.metaKey)) {
                                status += ' elfinder-drag-helper-plus';
                            }
                        }
                        dst.hasClass(dropover) && helper.addClass(status);
                        requestAnimationFrame(function () { dst.hasClass(dropover) && helper.addClass(status); });
                    },
                    out: function (e, ui) {
                        var dst = $(this),
                            helper = ui.helper;
                        e.stopPropagation();
                        if (insideNavbar(e.clientX)) {
                            helper.removeClass('elfinder-drag-helper-move elfinder-drag-helper-plus');
                        }
                        helper.data('dropover', Math.max(helper.data('dropover') - 1, 0));
                        dst.data('expandTimer') && clearTimeout(dst.data('expandTimer'));
                        dst.removeData('dropover')
                            .removeClass(hover + ' ' + dropover);
                    },
                    deactivate: function () {
                        $(this).removeData('dropover')
                            .removeClass(hover + ' ' + dropover);
                    },
                    drop: function (e, ui) {
                        insideNavbar(e.clientX) && drop.call(this, e, ui);
                    }
                }),

                spinner = $(fm.res('tpl', 'navspinner')),

                /**
                 * Directory html template
                 *
                 * @type String
                 */
                tpl = fm.res('tpl', 'navdir'),

                /**
                 * Permissions marker html template
                 *
                 * @type String
                 */
                ptpl = fm.res('tpl', 'perms'),

                /**
                 * Lock marker html template
                 *
                 * @type String
                 */
                ltpl = fm.res('tpl', 'lock'),

                /**
                 * Symlink marker html template
                 *
                 * @type String
                 */
                stpl = fm.res('tpl', 'symlink'),

                /**
                 * Directory hashes that has more pages
                 * 
                 * @type Object
                 */
                hasMoreDirs = {},

                /**
                 * Html template replacement methods
                 *
                 * @type Object
                 */
                replace = {
                    id: function (dir) { return fm.navHash2Id(dir.hash); },
                    name: function (dir) { return fm.escape(dir.i18 || dir.name); },
                    cssclass: function (dir) {
                        var cname = (dir.phash && !dir.isroot ? '' : root) + ' ' + navdir + ' ' + fm.perms2class(dir);
                        dir.dirs && !dir.link && (cname += ' ' + collapsed) && dir.dirs == -1 && (cname += ' ' + chksubdir);
                        opts.getClass && (cname += ' ' + opts.getClass(dir));
                        dir.csscls && (cname += ' ' + fm.escape(dir.csscls));
                        return cname;
                    },
                    title: function (dir) { return opts.attrTitle ? (' title="' + fm.escape(fm.path(dir.hash, true) || dir.i18 || dir.name) + '"') : ''; },
                    root: function (dir) {
                        var cls = '';
                        if (!dir.phash || dir.isroot) {
                            cls += ' ' + wrapperRoot;
                            if (!dir.disabled || dir.disabled.length < 1) {
                                cls += ' ' + pastable + ' ' + uploadable;
                            } else {
                                if ($.inArray('paste', dir.disabled) === -1) {
                                    cls += ' ' + pastable;
                                }
                                if ($.inArray('upload', dir.disabled) === -1) {
                                    cls += ' ' + uploadable;
                                }
                            }
                            return cls;
                        } else {
                            return '';
                        }
                    },
                    permissions: function (dir) { return !dir.read || !dir.write ? ptpl : ''; },
                    symlink: function (dir) { return dir.alias ? stpl : ''; },
                    style: function (dir) { return dir.icon ? fm.getIconStyle(dir) : ''; }
                },

                /**
                 * Return html for given dir
                 *
                 * @param  Object  directory
                 * @return String
                 */
                itemhtml = function (dir) {
                    return tpl.replace(/(?:\{([a-z]+)\})/ig, function (m, key) {
                        var res = replace[key] ? replace[key](dir) : (dir[key] || '');
                        if (key === 'id' && dir.dirs == -1) {
                            subdirsQue[res] = res;
                        }
                        return res;
                    });
                },

                /**
                 * Return only dirs from files list
                 *
                 * @param  Array   files list
                 * @param  Boolean do check exists
                 * @return Array
                 */
                filter = function (files, checkExists) {
                    return $.map(files || [], function (f) {
                        return (f.mime === 'directory' && (!checkExists || fm.navHash2Elm(f.hash).length)) ? f : null;
                    });
                },

                /**
                 * Find parent subtree for required directory
                 *
                 * @param  String  dir hash
                 * @return jQuery
                 */
                findSubtree = function (hash) {
                    return hash ? fm.navHash2Elm(hash).next('.' + subtree) : tree;
                },

                /**
                 * Find directory (wrapper) in required node
                 * before which we can insert new directory
                 *
                 * @param  jQuery  parent directory
                 * @param  Object  new directory
                 * @return jQuery
                 */
                findSibling = function (subtree, dir) {
                    var node = subtree.children(':first'),
                        info;

                    while (node.length) {
                        info = fm.file(fm.navId2Hash(node.children('[id]').attr('id')));

                        if ((info = fm.file(fm.navId2Hash(node.children('[id]').attr('id'))))
                            && compare(dir, info) < 0) {
                            return node;
                        }
                        node = node.next();
                    }
                    return subtree.children('button.elfinder-navbar-pager-next');
                },

                /**
                 * Add new dirs in tree
                 *
                 * @param  Array  dirs list
                 * @return void
                 */
                updateTree = function (dirs) {
                    var length = dirs.length,
                        orphans = [],
                        i = length,
                        tgts = $(),
                        done = {},
                        cwd = fm.cwd(),
                        append = function (parent, dirs, start, direction) {
                            var hashes = {},
                                curStart = 0,
                                max = fm.newAPI ? Math.min(10000, Math.max(10, opts.subTreeMax)) : 10000,
                                setHashes = function () {
                                    hashes = {};
                                    $.each(dirs, function (i, d) {
                                        hashes[d.hash] = i;
                                    });
                                },
                                change = function (mode) {
                                    if (mode === 'prepare') {
                                        $.each(dirs, function (i, d) {
                                            d.node && parent.append(d.node.hide());
                                        });
                                    } else if (mode === 'done') {
                                        $.each(dirs, function (i, d) {
                                            d.node && d.node.detach().show();
                                        });
                                    }
                                },
                                update = function (e, data) {
                                    var i, changed;
                                    e.stopPropagation();

                                    if (data.select) {
                                        render(getStart(data.select));
                                        return;
                                    }

                                    if (data.change) {
                                        change(data.change);
                                        return;
                                    }

                                    if (data.removed && data.removed.length) {
                                        dirs = $.grep(dirs, function (d) {
                                            if (data.removed.indexOf(d.hash) === -1) {
                                                return true;
                                            } else {
                                                !changed && (changed = true);
                                                return false;
                                            }
                                        });
                                    }

                                    if (data.added && data.added.length) {
                                        dirs = dirs.concat($.grep(data.added, function (d) {
                                            if (hashes[d.hash] === void (0)) {
                                                !changed && (changed = true);
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }));
                                    }
                                    if (changed) {
                                        dirs.sort(compare);
                                        setHashes();
                                        render(curStart);
                                    }
                                },
                                getStart = function (target) {
                                    if (hashes[target] !== void (0)) {
                                        return Math.floor(hashes[target] / max) * max;
                                    }
                                    return void (0);
                                },
                                target = fm.navId2Hash(parent.prev('[id]').attr('id')),
                                render = function (start, direction) {
                                    var html = [],
                                        nodes = {},
                                        total, page, s, parts, prev, next, prevBtn, nextBtn;
                                    delete hasMoreDirs[target];
                                    curStart = start;
                                    parent.off('update.' + fm.namespace, update);
                                    if (dirs.length > max) {
                                        parent.on('update.' + fm.namespace, update);
                                        if (start === void (0)) {
                                            s = 0;
                                            setHashes();
                                            start = getStart(cwd.hash);
                                            if (start === void (0)) {
                                                start = 0;
                                            }
                                        }
                                        parts = dirs.slice(start, start + max);
                                        hasMoreDirs[target] = parent;
                                        prev = start ? Math.max(-1, start - max) : -1;
                                        next = (start + max >= dirs.length) ? 0 : start + max;
                                        total = Math.ceil(dirs.length / max);
                                        page = Math.ceil(start / max);
                                    }
                                    $.each(parts || dirs, function (i, d) {
                                        html.push(itemhtml(d));
                                        if (d.node) {
                                            nodes[d.hash] = d.node;
                                        }
                                    });
                                    if (prev > -1) {
                                        prevBtn = $('<button class="elfinder-navbar-pager elfinder-navbar-pager-prev"></button>')
                                            .text(fm.i18n('btnPrevious', page, total))
                                            .button({
                                                icons: {
                                                    primary: "ui-icon-caret-1-n"
                                                }
                                            })
                                            .on('click', function (e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                render(prev, 'up');
                                            });
                                    } else {
                                        prevBtn = $();
                                    }
                                    if (next) {
                                        nextBtn = $('<button class="elfinder-navbar-pager elfinder-navbar-pager-next"></button>')
                                            .text(fm.i18n('btnNext', page + 2, total))
                                            .button({
                                                icons: {
                                                    primary: "ui-icon-caret-1-s"
                                                }
                                            })
                                            .on('click', function (e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                render(next, 'down');
                                            });
                                    } else {
                                        nextBtn = $();
                                    }
                                    detach();
                                    parent.empty()[parts ? 'addClass' : 'removeClass']('elfinder-navbar-hasmore').append(prevBtn, html.join(''), nextBtn);
                                    $.each(nodes, function (h, n) {
                                        fm.navHash2Elm(h).parent().replaceWith(n);
                                    });
                                    if (direction) {
                                        autoScroll(fm.navHash2Id(parts[direction === 'up' ? parts.length - 1 : 0].hash));
                                    }
                                    !mobile && fm.lazy(function () { updateDroppable(null, parent); });
                                },
                                detach = function () {
                                    $.each(parent.children('.elfinder-navbar-wrapper'), function (i, elm) {
                                        var n = $(elm),
                                            ch = n.children('[id]:first'),
                                            h, c;
                                        if (ch.hasClass(loaded)) {
                                            h = fm.navId2Hash(ch.attr('id'));
                                            if (h && (c = hashes[h]) !== void (0)) {
                                                dirs[c].node = n.detach();
                                            }
                                        }
                                    });
                                };

                            render();
                        },
                        dir, html, parent, sibling, init, atonce = {}, updates = [], base, node,
                        lastKey, lastNodes = {};

                    while (i--) {
                        dir = dirs[i];

                        if (done[dir.hash] || fm.navHash2Elm(dir.hash).length) {
                            continue;
                        }
                        done[dir.hash] = true;

                        if ((parent = findSubtree(dir.phash)).length) {
                            lastKey = dir.phash || 'treeroot';
                            if (typeof lastNodes[lastKey] === 'undefined') {
                                lastNodes[lastKey] = parent.children(':last');
                            }
                            init = !lastNodes[lastKey].length;
                            if (dir.phash && (init || parent.hasClass('elfinder-navbar-hasmore') || (sibling = findSibling(parent, dir)).length)) {
                                if (init) {
                                    if (!atonce[dir.phash]) {
                                        atonce[dir.phash] = [];
                                    }
                                    atonce[dir.phash].push(dir);
                                } else {
                                    if (sibling) {
                                        node = itemhtml(dir);
                                        sibling.before(node);
                                        !mobile && (tgts = tgts.add(node));
                                    } else {
                                        updates.push(dir);
                                    }
                                }
                            } else {
                                node = itemhtml(dir);
                                if (init) {
                                    parent.prepend(node);
                                } else {
                                    lastNodes[lastKey].after(node);
                                }
                                if (!dir.phash || dir.isroot) {
                                    base = fm.navHash2Elm(dir.hash).parent();
                                }
                                !mobile && updateDroppable(null, base);
                            }
                        } else {
                            orphans.push(dir);
                        }
                    }

                    // When init, html append at once
                    if (Object.keys(atonce).length) {
                        $.each(atonce, function (p, dirs) {
                            var parent = findSubtree(p),
                                html = [];
                            dirs.sort(compare);
                            append(parent, dirs);
                        });
                    }

                    if (updates.length) {
                        parent.trigger('update.' + fm.namespace, { added: updates });
                    }

                    if (orphans.length && orphans.length < length) {
                        updateTree(orphans);
                        return;
                    }

                    !mobile && tgts.length && fm.lazy(function () { updateDroppable(tgts); });

                },

                /**
                 * sort function by dir.name
                 * 
                 */
                compare = function (dir1, dir2) {
                    if (!fm.sortAlsoTreeview) {
                        return fm.sortRules.name(dir1, dir2);
                    } else {
                        var asc = fm.sortOrder == 'asc',
                            type = fm.sortType,
                            rules = fm.sortRules,
                            res;

                        res = asc ? rules[fm.sortType](dir1, dir2) : rules[fm.sortType](dir2, dir1);

                        return type !== 'name' && res === 0
                            ? res = asc ? rules.name(dir1, dir2) : rules.name(dir2, dir1)
                            : res;
                    }
                },

                /**
                 * Timer ID of autoScroll
                 * 
                 * @type  Integer
                 */
                autoScrTm,

                /**
                 * Auto scroll to cwd
                 *
                 * @return Object  jQuery Deferred
                 */
                autoScroll = function (target) {
                    var dfrd = $.Deferred(),
                        current, parent, top, treeH, bottom, tgtTop;
                    autoScrTm && clearTimeout(autoScrTm);
                    autoScrTm = setTimeout(function () {
                        current = $(document.getElementById((target || fm.navHash2Id(fm.cwd().hash))));
                        if (current.length) {
                            // expand parents directory
                            (openCwd ? current : current.parent()).parents('.elfinder-navbar-wrapper').children('.' + loaded).addClass(expanded).next('.' + subtree).show();

                            parent = tree.parent().stop(false, true);
                            top = parent.offset().top;
                            treeH = parent.height();
                            bottom = top + treeH - current.outerHeight();
                            tgtTop = current.offset().top;

                            if (tgtTop < top || tgtTop > bottom) {
                                parent.animate({
                                    scrollTop: parent.scrollTop() + tgtTop - top - treeH / 3
                                }, {
                                    duration: opts.durations.autoScroll,
                                    complete: function () { dfrd.resolve(); }
                                });
                            } else {
                                dfrd.resolve();
                            }
                        } else {
                            dfrd.reject();
                        }
                    }, 100);
                    return dfrd;
                },
                /**
                 * Get hashes array of items of the bottom of the leaf root back from the target
                 * 
                 * @param Object elFinder item(directory) object
                 * @return Array hashes
                 */
                getEnds = function (d) {
                    var cur = d || fm.cwd(),
                        res = cur.hash ? [cur.hash] : [],
                        phash, root, dir;

                    root = fm.root(cur.hash);
                    dir = fm.file(root);
                    while (dir && (phash = dir.phash)) {
                        res.unshift(phash);
                        root = fm.root(phash);
                        dir = fm.file(root);
                        if (fm.navHash2Elm(dir.hash).hasClass(loaded)) {
                            break;
                        }
                    }

                    return res;
                },

                /**
                 * Select pages back in order to display the target
                 * 
                 * @param Object elFinder item(directory) object
                 * @return Object jQuery node object of target node
                 */
                selectPages = function (current) {
                    var cur = current || fm.cwd(),
                        curHash = cur.hash,
                        node = fm.navHash2Elm(curHash);

                    if (!node.length) {
                        while (cur && cur.phash) {
                            if (hasMoreDirs[cur.phash] && !fm.navHash2Elm(cur.hash).length) {
                                hasMoreDirs[cur.phash].trigger('update.' + fm.namespace, { select: cur.hash });
                            }
                            cur = fm.file(cur.phash);
                        }
                        node = fm.navHash2Elm(curHash);
                    }

                    return node;
                },

                /**
                 * Flag indicating that synchronization is currently in progress
                 * 
                 * @type Boolean
                 */
                syncing,

                /**
                 * Mark current directory as active
                 * If current directory is not in tree - load it and its parents
                 *
                 * @param Array directory objects of cwd
                 * @param Boolean do auto scroll
                 * @return Object jQuery Deferred
                 */
                sync = function (cwdDirs, aScr) {
                    var cwd = fm.cwd(),
                        cwdhash = cwd.hash,
                        autoScr = aScr === void (0) ? syncTree : aScr,
                        loadParents = function (dir) {
                            var dfd = $.Deferred(),
                                reqs = [],
                                ends = getEnds(dir),
                                makeReq = function (cmd, h, until) {
                                    var data = {
                                        cmd: cmd,
                                        target: h
                                    };
                                    if (until) {
                                        data.until = until;
                                    }
                                    return fm.request({
                                        data: data,
                                        preventFail: true
                                    });
                                },
                                baseHash, baseId;

                            reqs = $.map(ends, function (h) {
                                var d = fm.file(h),
                                    isRoot = d ? fm.isRoot(d) : false,
                                    node = fm.navHash2Elm(h),
                                    getPhash = function (h, dep) {
                                        var d, ph,
                                            depth = dep || 1;
                                        ph = (d = fm.file(h)) ? d.phash : false;
                                        if (ph && depth > 1) {
                                            return getPhash(ph, --depth);
                                        }
                                        return ph;
                                    },
                                    until,
                                    closest = (function () {
                                        var phash = getPhash(h);
                                        until = phash;
                                        while (phash) {
                                            if (fm.navHash2Elm(phash).hasClass(loaded)) {
                                                break;
                                            }
                                            until = phash;
                                            phash = getPhash(phash);
                                        }
                                        if (!phash) {
                                            until = void (0);
                                            phash = fm.root(h);
                                        }
                                        return phash;
                                    })(),
                                    cmd;

                                if (!node.hasClass(loaded) && (isRoot || !d || !fm.navHash2Elm(d.phash).hasClass(loaded))) {
                                    if (isRoot || closest === getPhash(h) || closest === getPhash(h, 2)) {
                                        until = void (0);
                                        cmd = 'tree';
                                        if (!isRoot) {
                                            h = getPhash(h);
                                        }
                                    } else {
                                        cmd = 'parents';
                                    }
                                    if (!baseHash) {
                                        baseHash = (cmd === 'tree') ? h : closest;
                                    }
                                    return makeReq(cmd, h, until);
                                }
                                return null;
                            });

                            if (reqs.length) {
                                selectPages(fm.file(baseHash));
                                baseId = fm.navHash2Id(baseHash);
                                autoScr && autoScroll(baseId);
                                baseNode = $('#' + baseId);
                                spinner = $(fm.res('tpl', 'navspinner')).insertBefore(baseNode.children('.' + arrow));
                                baseNode.removeClass(collapsed);

                                $.when.apply($, reqs)
                                    .done(function () {
                                        var res = {}, data, treeDirs, dirs, argLen, i;
                                        argLen = arguments.length;
                                        if (argLen > 0) {
                                            for (i = 0; i < argLen; i++) {
                                                data = arguments[i].tree || [];
                                                res[ends[i]] = Object.assign([], filter(data));
                                            }
                                        }
                                        dfd.resolve(res);
                                    })
                                    .fail(function () {
                                        dfd.reject();
                                    });

                                return dfd;
                            } else {
                                return dfd.resolve();
                            }
                        },
                        done = function (res, dfrd) {
                            var open = function () {
                                if (openRoot && baseNode) {
                                    findSubtree(baseNode.hash).show().prev(selNavdir).addClass(expanded);
                                    openRoot = false;
                                }
                                if (autoScr) {
                                    autoScroll().done(checkSubdirs);
                                } else {
                                    checkSubdirs();
                                }
                            },
                                current;

                            if (res) {
                                $.each(res, function (endHash, dirs) {
                                    dirs && updateTree(dirs);
                                    selectPages(fm.file(endHash));
                                    dirs && updateArrows(dirs, loaded);
                                });
                            }

                            if (cwdDirs) {
                                (fm.api < 2.1) && cwdDirs.push(cwd);
                                updateTree(cwdDirs);
                            }

                            // set current node
                            current = selectPages();

                            if (!current.hasClass(active)) {
                                tree.find(selNavdir + '.' + active).removeClass(active);
                                current.addClass(active);
                            }

                            // mark as loaded to cwd parents
                            current.parents('.elfinder-navbar-wrapper').children('.' + navdir).addClass(loaded);

                            if (res) {
                                fm.lazy(open).done(function () {
                                    dfrd.resolve();
                                });
                            } else {
                                open();
                                dfrd.resolve();
                            }
                        },
                        rmSpinner = function (fail) {
                            if (baseNode) {
                                spinner.remove();
                                baseNode.addClass(collapsed + (fail ? '' : (' ' + loaded)));
                            }
                        },
                        dfrd = $.Deferred(),
                        baseNode, spinner;

                    if (!fm.navHash2Elm(cwdhash).length) {
                        syncing = true;
                        loadParents()
                            .done(function (res) {
                                done(res, dfrd);
                                rmSpinner();
                            })
                            .fail(function () {
                                rmSpinner(true);
                                dfrd.reject();
                            })
                            .always(function () {
                                syncing = false;
                            });
                    } else {
                        done(void (0), dfrd);
                    }

                    // trigger 'treesync' with my $.Deferred
                    fm.trigger('treesync', dfrd);

                    return dfrd;
                },

                /**
                 * Make writable and not root dirs droppable
                 *
                 * @return void
                 */
                updateDroppable = function (target, node) {
                    var limit = 100,
                        next;

                    if (!target) {
                        if (!node || node.closest('div.' + wrapperRoot).hasClass(uploadable)) {
                            (node || tree.find('div.' + uploadable)).find(selNavdir + ':not(.elfinder-ro,.elfinder-na)').addClass('native-droppable');
                        }
                        if (!node || node.closest('div.' + wrapperRoot).hasClass(pastable)) {
                            target = (node || tree.find('div.' + pastable)).find(selNavdir + ':not(.' + droppable + ')');
                        } else {
                            target = $();
                        }
                        if (node) {
                            // check leaf roots
                            node.children('div.' + wrapperRoot).each(function () {
                                updateDroppable(null, $(this));
                            });
                        }
                    }

                    // make droppable on async
                    if (target.length) {
                        fm.asyncJob(function (elm) {
                            $(elm).droppable(droppableopts);
                        }, $.makeArray(target), {
                            interval: 20,
                            numPerOnce: 100
                        });
                    }
                },

                /**
                 * Check required folders for subfolders and update arrow classes
                 *
                 * @param  Array  folders to check
                 * @param  String css class 
                 * @return void
                 */
                updateArrows = function (dirs, cls) {
                    var sel = cls == loaded
                        ? '.' + collapsed + ':not(.' + loaded + ')'
                        : ':not(.' + collapsed + ')';

                    $.each(dirs, function (i, dir) {
                        fm.navHash2Elm(dir.phash).filter(sel)
                            .filter(function () {
                                return $.grep($(this).next('.' + subtree).children(), function (n) {
                                    return ($(n).children().hasClass(root)) ? false : true;
                                }).length > 0;
                            })
                            .addClass(cls);
                    });
                },



                /**
                 * Navigation tree
                 *
                 * @type JQuery
                 */
                tree = $(this).addClass(treeclass)
                    // make dirs draggable and toggle hover class
                    .on('mouseenter mouseleave', selNavdir, function (e) {
                        var enter = (e.type === 'mouseenter');
                        if (enter && scrolling) { return; }
                        var link = $(this),
                            hash, dir;

                        if (!link.hasClass(dropover + ' ' + disabled)) {
                            if (!mobile && enter && !link.data('dragRegisted') && !link.hasClass(root + ' ' + draggable + ' elfinder-na elfinder-wo')) {
                                link.data('dragRegisted', true);
                                if (fm.isCommandEnabled('copy', (hash = fm.navId2Hash(link.attr('id'))))) {
                                    link.draggable(fm.draggable);
                                }
                            }
                            link.toggleClass(hover, enter);
                        }
                        // update title attr if necessary
                        if (enter && opts.attrTitle) {
                            dir = fm.file(hash || fm.navId2Hash(link.attr('id')));
                            if (!dir.isroot && link.attr('title') === (dir.i18 || dir.name)) {
                                link.attr('title', fm.path(hash, true));
                            }
                        }
                    })
                    // native drag enter
                    .on('dragenter', selNavdir, function (e) {
                        if (e.originalEvent.dataTransfer) {
                            var dst = $(this);
                            dst.addClass(hover);
                            if (dst.is('.' + collapsed + ':not(.' + expanded + ')')) {
                                dst.data('expandTimer', setTimeout(function () {
                                    dst.is('.' + collapsed + '.' + hover) && dst.children('.' + arrow).trigger('click');
                                }, 500));
                            }
                        }
                    })
                    // native drag leave
                    .on('dragleave', selNavdir, function (e) {
                        if (e.originalEvent.dataTransfer) {
                            var dst = $(this);
                            dst.data('expandTimer') && clearTimeout(dst.data('expandTimer'));
                            dst.removeClass(hover);
                        }
                    })
                    // open dir or open subfolders in tree
                    .on('click', selNavdir, function (e) {
                        var link = $(this),
                            hash = fm.navId2Hash(link.attr('id')),
                            file = fm.file(hash);

                        if (link.data('longtap')) {
                            link.removeData('longtap');
                            e.stopPropagation();
                            return;
                        }

                        if (!link.hasClass(active)) {
                            tree.find(selNavdir + '.' + active).removeClass(active);
                            link.addClass(active);
                        }
                        if (hash != fm.cwd().hash && !link.hasClass(disabled)) {
                            fm.exec('open', hash).done(function () {
                                fm.one('opendone', function () {
                                    fm.select({ selected: [hash], origin: 'navbar' });
                                });
                            });
                        } else {
                            if (link.hasClass(collapsed)) {
                                link.children('.' + arrow).trigger('click');
                            }
                            fm.select({ selected: [hash], origin: 'navbar' });
                        }
                    })
                    // for touch device
                    .on('touchstart', selNavdir, function (e) {
                        if (e.originalEvent.touches.length > 1) {
                            return;
                        }
                        var evt = e.originalEvent,
                            p;

                        if (e.target.nodeName === 'INPUT') {
                            e.stopPropagation();
                            return;
                        }

                        p = $(this).addClass(hover)
                            .removeData('longtap')
                            .data('tmlongtap', setTimeout(function (e) {
                                // long tap
                                p.data('longtap', true);
                                fm.trigger('contextmenu', {
                                    'type': 'navbar',
                                    'targets': [fm.navId2Hash(p.attr('id'))],
                                    'x': evt.touches[0].pageX,
                                    'y': evt.touches[0].pageY
                                });
                            }, 500));
                    })
                    .on('touchmove touchend', selNavdir, function (e) {
                        if (e.target.nodeName === 'INPUT') {
                            e.stopPropagation();
                            return;
                        }
                        clearTimeout($(this).data('tmlongtap'));
                        $(this).removeData('tmlongtap');
                        if (e.type == 'touchmove') {
                            $(this).removeClass(hover);
                        }
                    })
                    // toggle subfolders in tree
                    .on('click', selNavdir + '.' + collapsed + ' .' + arrow, function (e) {
                        var arrow = $(this),
                            link = arrow.parent(selNavdir),
                            stree = link.next('.' + subtree),
                            dfrd = $.Deferred(),
                            slideTH = 30, cnt;

                        e.stopPropagation();

                        if (link.hasClass(loaded)) {
                            link.toggleClass(expanded);
                            fm.lazy(function () {
                                cnt = link.hasClass(expanded) ? stree.children().length + stree.find('div.elfinder-navbar-subtree[style*=block]').children().length : stree.find('div:visible').length;
                                if (cnt > slideTH) {
                                    stree.toggle();
                                    fm.draggingUiHelper && fm.draggingUiHelper.data('refreshPositions', 1);
                                    checkSubdirs();
                                } else {
                                    stree.stop(true, true)[link.hasClass(expanded) ? 'slideDown' : 'slideUp'](opts.durations.slideUpDown, function () {
                                        fm.draggingUiHelper && fm.draggingUiHelper.data('refreshPositions', 1);
                                        checkSubdirs();
                                    });
                                }
                            }).always(function () {
                                dfrd.resolve();
                            });
                        } else {
                            spinner.insertBefore(arrow);
                            link.removeClass(collapsed);

                            fm.request({ cmd: 'tree', target: fm.navId2Hash(link.attr('id')) })
                                .done(function (data) {
                                    updateTree(Object.assign([], filter(data.tree)));

                                    if (stree.children().length) {
                                        link.addClass(collapsed + ' ' + expanded);
                                        if (stree.children().length > slideTH) {
                                            stree.show();
                                            fm.draggingUiHelper && fm.draggingUiHelper.data('refreshPositions', 1);
                                            checkSubdirs();
                                        } else {
                                            stree.stop(true, true).slideDown(opts.durations.slideUpDown, function () {
                                                fm.draggingUiHelper && fm.draggingUiHelper.data('refreshPositions', 1);
                                                checkSubdirs();
                                            });
                                        }
                                    }
                                })
                                .always(function (data) {
                                    spinner.remove();
                                    link.addClass(loaded);
                                    fm.one('treedone', function () {
                                        dfrd.resolve();
                                    });
                                });
                        }
                        arrow.data('dfrd', dfrd);
                    })
                    .on('contextmenu', selNavdir, function (e) {
                        e.stopPropagation();
                        var self = $(this);

                        // now dirname editing
                        if (self.find('input:text').length) {
                            return;
                        }

                        e.preventDefault();

                        if (!self.data('tmlongtap')) {
                            fm.trigger('contextmenu', {
                                'type': 'navbar',
                                'targets': [fm.navId2Hash($(this).attr('id'))],
                                'x': e.pageX,
                                'y': e.pageY
                            });
                        }
                        self.addClass('ui-state-hover');

                        fm.getUI('contextmenu').children().on('mouseenter', function () {
                            self.addClass('ui-state-hover');
                        });

                        fm.bind('closecontextmenu', function () {
                            self.removeClass('ui-state-hover');
                        });
                    })
                    .on('scrolltoview', selNavdir, function (e, data) {
                        var self = $(this);
                        autoScroll(self.attr('id')).done(function () {
                            if (!data || data.blink === 'undefined' || data.blink) {
                                fm.resources.blink(self, 'lookme');
                            }
                        });
                    })
                    // prepend fake dir
                    .on('create.' + fm.namespace, function (e, item) {
                        var pdir = findSubtree(item.phash),
                            lock = item.move || false,
                            dir = $(itemhtml(item)).addClass('elfinder-navbar-wrapper-tmp'),
                            selected = fm.selected();

                        lock && selected.length && fm.trigger('lockfiles', { files: selected });
                        pdir.prepend(dir);
                    }),
                scrolling = false,
                navbarScrTm,
                // move tree into navbar
                navbar = fm.getUI('navbar').append(tree).show().on('scroll', function () {
                    scrolling = true;
                    navbarScrTm && cancelAnimationFrame(navbarScrTm);
                    navbarScrTm = requestAnimationFrame(function () {
                        scrolling = false;
                        checkSubdirs();
                    });
                }),

                prevSortTreeview = fm.sortAlsoTreeview;

            fm.open(function (e) {
                var data = e.data,
                    dirs = filter(data.files),
                    contextmenu = fm.getUI('contextmenu');

                data.init && tree.empty();

                if (fm.UA.iOS) {
                    navbar.removeClass('overflow-scrolling-touch').addClass('overflow-scrolling-touch');
                }

                if (dirs.length) {
                    fm.lazy(function () {
                        if (!contextmenu.data('cmdMaps')) {
                            contextmenu.data('cmdMaps', {});
                        }
                        updateTree(dirs);
                        updateArrows(dirs, loaded);
                        sync(dirs);
                    });
                } else {
                    sync();
                }
            })
                // add new dirs
                .add(function (e) {
                    var dirs = filter(e.data.added);

                    if (dirs.length) {
                        updateTree(dirs);
                        updateArrows(dirs, collapsed);
                    }
                })
                // update changed dirs
                .change(function (e) {
                    // do ot perfome while syncing
                    if (syncing) {
                        return;
                    }

                    var dirs = filter(e.data.changed, true),
                        length = dirs.length,
                        l = length,
                        tgts = $(),
                        changed = {},
                        dir, phash, node, tmp, realParent, reqParent, realSibling, reqSibling, isExpanded, isLoaded, parent, subdirs;

                    $.each(hasMoreDirs, function (h, node) {
                        node.trigger('update.' + fm.namespace, { change: 'prepare' });
                    });

                    while (l--) {
                        dir = dirs[l];
                        phash = dir.phash;
                        if ((node = fm.navHash2Elm(dir.hash)).length) {
                            parent = node.parent();
                            if (phash) {
                                realParent = node.closest('.' + subtree);
                                reqParent = findSubtree(phash);
                                realSibling = node.parent().next();
                                reqSibling = findSibling(reqParent, dir);

                                if (!reqParent.length) {
                                    continue;
                                }

                                if (reqParent[0] !== realParent[0] || realSibling.get(0) !== reqSibling.get(0)) {
                                    reqSibling.length ? reqSibling.before(parent) : reqParent.append(parent);
                                }
                            }
                            isExpanded = node.hasClass(expanded);
                            isLoaded = node.hasClass(loaded);
                            tmp = $(itemhtml(dir));
                            node.replaceWith(tmp.children(selNavdir));
                            !mobile && updateDroppable(null, parent);

                            if (dir.dirs
                                && (isExpanded || isLoaded)
                                && (node = fm.navHash2Elm(dir.hash))
                                && node.next('.' + subtree).children().length) {
                                isExpanded && node.addClass(expanded);
                                isLoaded && node.addClass(loaded);
                            }

                            subdirs |= dir.dirs == -1;
                        }
                    }

                    // to check subdirs
                    if (subdirs) {
                        checkSubdirs();
                    }

                    $.each(hasMoreDirs, function (h, node) {
                        node.trigger('update.' + fm.namespace, { change: 'done' });
                    });

                    length && sync(void (0), false);
                })
                // remove dirs
                .remove(function (e) {
                    var dirs = e.data.removed,
                        l = dirs.length,
                        node, stree, removed;

                    $.each(hasMoreDirs, function (h, node) {
                        node.trigger('update.' + fm.namespace, { removed: dirs });
                        node.trigger('update.' + fm.namespace, { change: 'prepare' });
                    });

                    while (l--) {
                        if ((node = fm.navHash2Elm(dirs[l])).length) {
                            removed = true;
                            stree = node.closest('.' + subtree);
                            node.parent().detach();
                            if (!stree.children().length) {
                                stree.hide().prev(selNavdir).removeClass(collapsed + ' ' + expanded + ' ' + loaded);
                            }
                        }
                    }

                    removed && fm.getUI('navbar').children('.ui-resizable-handle').trigger('resize');

                    $.each(hasMoreDirs, function (h, node) {
                        node.trigger('update.' + fm.namespace, { change: 'done' });
                    });
                })
                // lock/unlock dirs while moving
                .bind('lockfiles unlockfiles', function (e) {
                    var lock = e.type == 'lockfiles',
                        helperLocked = e.data.helper ? e.data.helper.data('locked') : false,
                        act = (lock && !helperLocked) ? 'disable' : 'enable',
                        dirs = $.grep(e.data.files || [], function (h) {
                            var dir = fm.file(h);
                            return dir && dir.mime == 'directory' ? true : false;
                        });

                    $.each(dirs, function (i, hash) {
                        var dir = fm.navHash2Elm(hash);

                        if (dir.length && !helperLocked) {
                            dir.hasClass(draggable) && dir.draggable(act);
                            dir.hasClass(droppable) && dir.droppable(act);
                            dir[lock ? 'addClass' : 'removeClass'](disabled);
                        }
                    });
                })
                .bind('sortchange', function () {
                    if (fm.sortAlsoTreeview || prevSortTreeview !== fm.sortAlsoTreeview) {
                        var dirs,
                            ends = [],
                            endsMap = {},
                            endsVid = {},
                            topVid = '',
                            single = false,
                            current;

                        fm.lazy(function () {
                            dirs = filter(fm.files());
                            prevSortTreeview = fm.sortAlsoTreeview;

                            tree.empty();

                            // append volume roots at first
                            updateTree($.map(fm.roots, function (h) {
                                var dir = fm.file(h);
                                return dir && !dir.phash ? dir : null;
                            }));

                            if (!Object.keys(hasMoreDirs).length) {
                                updateTree(dirs);
                                current = selectPages();
                                updateArrows(dirs, loaded);
                            } else {
                                ends = getEnds();
                                if (ends.length > 1) {
                                    $.each(ends, function (i, end) {
                                        var vid = fm.file(fm.root(end)).volumeid;
                                        if (i === 0) {
                                            topVid = vid;
                                        }
                                        endsVid[vid] = end;
                                        endsMap[end] = [];
                                    });
                                    $.each(dirs, function (i, d) {
                                        if (!d.volumeid) {
                                            single = true;
                                            return false;
                                        }
                                        endsMap[endsVid[d.volumeid] || endsVid[topVid]].push(d);
                                    });
                                } else {
                                    single = true;
                                }
                                if (single) {
                                    $.each(ends, function (i, endHash) {
                                        updateTree(dirs);
                                        current = selectPages(fm.file(endHash));
                                        updateArrows(dirs, loaded);
                                    });
                                } else {
                                    $.each(endsMap, function (endHash, dirs) {
                                        updateTree(dirs);
                                        current = selectPages(fm.file(endHash));
                                        updateArrows(dirs, loaded);
                                    });
                                }
                            }

                            sync();
                        }, 100);
                    }
                });

        });

        return this;
    };


    /*
     * File: /js/ui/uploadButton.js
     */

    /**
     * @class  elFinder toolbar's button tor upload file
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderuploadbutton = function (cmd) {
        return this.each(function () {
            var fm = cmd.fm,
                button = $(this).elfinderbutton(cmd)
                    .off('click'),
                form = $('<form></form>').appendTo(button),
                input = $('<input type="file" multiple="true" title="' + cmd.fm.i18n('selectForUpload') + '"/>')
                    .on('change', function () {
                        var _input = $(this);
                        if (_input.val()) {
                            fm.exec('upload', { input: _input.remove()[0] }, void (0), fm.cwd().hash);
                            input.clone(true).appendTo(form);
                        }
                    })
                    .on('dragover', function (e) {
                        e.originalEvent.dataTransfer.dropEffect = 'copy';
                    }),
                tm;

            form.append(input.clone(true));

            cmd.change(function () {
                tm && cancelAnimationFrame(tm);
                tm = requestAnimationFrame(function () {
                    var toShow = cmd.disabled();
                    if (form.is('visible')) {
                        !toShow && form.hide();
                    } else {
                        toShow && form.show();
                    }
                });
            })
                .change();
        });
    };


    /*
     * File: /js/ui/viewbutton.js
     */

    /**
     * @class  elFinder toolbar button to switch current directory view.
     *
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderviewbutton = function (cmd) {
        return this.each(function () {
            var button = $(this).elfinderbutton(cmd),
                icon = button.children('.elfinder-button-icon'),
                text = button.children('.elfinder-button-text'),
                tm;

            cmd.change(function () {
                tm && cancelAnimationFrame(tm);
                tm = requestAnimationFrame(function () {
                    var icons = cmd.value == 'icons';

                    icon.toggleClass('elfinder-button-icon-view-list', icons);
                    cmd.className = icons ? 'view-list' : '';
                    cmd.title = cmd.fm.i18n(icons ? 'viewlist' : 'viewicons');
                    button.attr('title', cmd.title);
                    text.html(cmd.title);
                });
            });
        });
    };


    /*
     * File: /js/ui/workzone.js
     */

    /**
     * @class elfinderworkzone - elFinder container for nav and current directory
     * @author Dmitry (dio) Levashov
     **/
    $.fn.elfinderworkzone = function (fm) {
        var cl = 'elfinder-workzone';

        this.not('.' + cl).each(function () {
            var wz = $(this).addClass(cl),
                prevH = Math.round(wz.height()),
                parent = wz.parent(),
                setDelta = function () {
                    wdelta = wz.outerHeight(true) - wz.height();
                },
                fitsize = function (e) {
                    var height = parent.height() - wdelta,
                        style = parent.attr('style'),
                        curH = Math.round(wz.height());

                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }

                    parent.css('overflow', 'hidden')
                        .children(':visible:not(.' + cl + ')').each(function () {
                            var ch = $(this);

                            if (ch.css('position') != 'absolute' && ch.css('position') != 'fixed') {
                                height -= ch.outerHeight(true);
                            }
                        });
                    parent.attr('style', style || '');

                    height = Math.max(0, Math.round(height));
                    if (prevH !== height || curH !== height) {
                        prevH = Math.round(wz.height());
                        wz.height(height);
                        fm.trigger('wzresize');
                    }
                },
                cssloaded = function () {
                    wdelta = wz.outerHeight(true) - wz.height();
                    fitsize();
                },
                wdelta;

            setDelta();
            parent.on('resize.' + fm.namespace, fitsize);
            fm.one('cssloaded', cssloaded)
                .bind('uiresize', fitsize)
                .bind('themechange', setDelta);
        });
        return this;
    };


    /*
     * File: /js/commands/archive.js
     */

    /**
     * @class  elFinder command "archive"
     * Archive selected files
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.archive = function () {
        var self = this,
            fm = self.fm,
            mimes = [],
            dfrd;

        this.variants = [];

        this.disableOnSearch = false;

        this.nextAction = {};

        /**
         * Update mimes on open/reload
         *
         * @return void
         **/
        fm.bind('open reload', function () {
            self.variants = [];
            $.each((mimes = fm.option('archivers')['create'] || []), function (i, mime) {
                self.variants.push([mime, fm.mime2kind(mime)]);
            });
            self.change();
        });

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                chk = (cnt && !fm.isRoot(sel[0]) && (fm.file(sel[0].phash) || {}).write),
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (f) {
                        fres = fres && f.read && f.hash.indexOf(cwdId) === 0 ? true : false;
                        return fres;
                    });
                },
                cwdId;

            if (chk && fm.searchStatus.state > 1) {
                if (chk = (cnt === filter(sel).length)) {
                    cwdId = fm.cwd().volumeid;
                }
            }

            return chk && !this._disabled && mimes.length && (cnt || (dfrd && dfrd.state() == 'pending')) ? 0 : -1;
        };

        this.exec = function (hashes, type) {
            var files = this.files(hashes),
                cnt = files.length,
                mime = type || mimes[0],
                cwd = fm.file(files[0].phash) || null,
                error = ['errArchive', 'errPerm', 'errCreatingTempDir', 'errFtpDownloadFile', 'errFtpUploadFile', 'errFtpMkdir', 'errArchiveExec', 'errExtractExec', 'errRm'],
                i, open;

            dfrd = $.Deferred().fail(function (error) {
                error && fm.error(error);
            });

            if (!(cnt && mimes.length && $.inArray(mime, mimes) !== -1)) {
                return dfrd.reject();
            }

            if (!cwd.write) {
                return dfrd.reject(error);
            }

            for (i = 0; i < cnt; i++) {
                if (!files[i].read) {
                    return dfrd.reject(error);
                }
            }

            self.mime = mime;
            self.prefix = ((cnt > 1) ? 'Archive' : files[0].name) + (fm.option('archivers')['createext'] ? '.' + fm.option('archivers')['createext'][mime] : '');
            self.data = { targets: self.hashes(hashes), type: mime };

            if (fm.cwd().hash !== cwd.hash) {
                open = fm.exec('open', cwd.hash).done(function () {
                    fm.one('cwdrender', function () {
                        fm.selectfiles({ files: hashes });
                        dfrd = $.proxy(fm.res('mixin', 'make'), self)();
                    });
                });
            } else {
                fm.selectfiles({ files: hashes });
                dfrd = $.proxy(fm.res('mixin', 'make'), self)();
            }

            return dfrd;
        };

    };


    /*
     * File: /js/commands/back.js
     */

    /**
     * @class  elFinder command "back"
     * Open last visited folder
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.back = function () {
        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.shortcuts = [{
            pattern: 'ctrl+left backspace'
        }];

        this.getstate = function () {
            return this.fm.history.canBack() ? 0 : -1;
        };

        this.exec = function () {
            return this.fm.history.back();
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/chmod.js
     */

    /**
     * @class elFinder command "chmod".
     * Chmod files.
     *
     * @type  elFinder.command
     * @author Naoki Sawada
     */
    elFinder.prototype.commands.chmod = function () {
        this.updateOnSelect = false;
        var fm = this.fm,
            level = {
                0: 'owner',
                1: 'group',
                2: 'other'
            },
            msg = {
                read: fm.i18n('read'),
                write: fm.i18n('write'),
                execute: fm.i18n('execute'),
                perm: fm.i18n('perm'),
                kind: fm.i18n('kind'),
                files: fm.i18n('files')
            },
            isPerm = function (perm) {
                return (!isNaN(parseInt(perm, 8)) && parseInt(perm, 8) <= 511) || perm.match(/^([r-][w-][x-]){3}$/i);
            };

        this.tpl = {
            main: '<div class="ui-helper-clearfix elfinder-info-title"><span class="elfinder-cwd-icon {class} ui-corner-all"></span>{title}</div>'
                + '{dataTable}',
            itemTitle: '<strong>{name}</strong><span id="elfinder-info-kind">{kind}</span>',
            groupTitle: '<strong>{items}: {num}</strong>',
            dataTable: '<table id="{id}-table-perm"><tr><td>{0}</td><td>{1}</td><td>{2}</td></tr></table>'
                + '<div class="">' + msg.perm + ': <input class="elfinder-tabstop elfinder-focus" id="{id}-perm" type="text" size="4" maxlength="3" value="{value}"></div>',
            fieldset: '<fieldset id="{id}-fieldset-{level}"><legend>{f_title}{name}</legend>'
                + '<input type="checkbox" value="4" class="elfinder-tabstop" id="{id}-read-{level}-perm"{checked-r}> <label for="{id}-read-{level}-perm">' + msg.read + '</label><br>'
                + '<input type="checkbox" value="6" class="elfinder-tabstop" id="{id}-write-{level}-perm"{checked-w}> <label for="{id}-write-{level}-perm">' + msg.write + '</label><br>'
                + '<input type="checkbox" value="5" class="elfinder-tabstop" id="{id}-execute-{level}-perm"{checked-x}> <label for="{id}-execute-{level}-perm">' + msg.execute + '</label><br>'
        };

        this.shortcuts = [{
            //pattern     : 'ctrl+p'
        }];

        this.getstate = function (sel) {
            var fm = this.fm;
            sel = sel || fm.selected();
            if (sel.length == 0) {
                sel = [fm.cwd().hash];
            }
            return this.checkstate(this.files(sel)) ? 0 : -1;
        };

        this.checkstate = function (sel) {
            var cnt = sel.length,
                filter = function (files) {
                    var fres = true;
                    return $.grep(sel, function (f) {
                        fres = fres && f.isowner && f.perm && isPerm(f.perm) && (cnt == 1 || f.mime != 'directory') ? true : false;
                        return fres;
                    });
                };
            return (cnt && cnt === filter(sel).length) ? true : false;
        };

        this.exec = function (select) {
            var hashes = this.hashes(select),
                files = this.files(hashes);
            if (!files.length) {
                hashes = [this.fm.cwd().hash];
                files = this.files(hashes);
            }
            var fm = this.fm,
                dfrd = $.Deferred().always(function () {
                    fm.enable();
                }),
                tpl = this.tpl,
                cnt = files.length,
                file = files[0],
                id = fm.namespace + '-perm-' + file.hash,
                view = tpl.main,
                checked = ' checked="checked"',
                buttons = function () {
                    var buttons = {};
                    buttons[fm.i18n('btnApply')] = save;
                    buttons[fm.i18n('btnCancel')] = function () { dialog.elfinderdialog('close'); };
                    return buttons;
                },
                save = function () {
                    var perm = $.trim($('#' + id + '-perm').val()),
                        reqData;

                    if (!isPerm(perm)) return false;

                    dialog.elfinderdialog('close');

                    reqData = {
                        cmd: 'chmod',
                        targets: hashes,
                        mode: perm
                    };
                    fm.request({
                        data: reqData,
                        notify: { type: 'chmod', cnt: cnt }
                    })
                        .fail(function (error) {
                            dfrd.reject(error);
                        })
                        .done(function (data) {
                            if (data.changed && data.changed.length) {
                                data.undo = {
                                    cmd: 'chmod',
                                    callback: function () {
                                        var reqs = [];
                                        $.each(prevVals, function (perm, hashes) {
                                            reqs.push(fm.request({
                                                data: { cmd: 'chmod', targets: hashes, mode: perm },
                                                notify: { type: 'undo', cnt: hashes.length }
                                            }));
                                        });
                                        return $.when.apply(null, reqs);
                                    }
                                };
                                data.redo = {
                                    cmd: 'chmod',
                                    callback: function () {
                                        return fm.request({
                                            data: reqData,
                                            notify: { type: 'redo', cnt: hashes.length }
                                        });
                                    }
                                };
                            }
                            dfrd.resolve(data);
                        });
                },
                setperm = function () {
                    var perm = '';
                    var _perm;
                    for (var i = 0; i < 3; i++) {
                        _perm = 0;
                        if ($("#" + id + "-read-" + level[i] + '-perm').is(':checked')) {
                            _perm = (_perm | 4);
                        }
                        if ($("#" + id + "-write-" + level[i] + '-perm').is(':checked')) {
                            _perm = (_perm | 2);
                        }
                        if ($("#" + id + "-execute-" + level[i] + '-perm').is(':checked')) {
                            _perm = (_perm | 1);
                        }
                        perm += _perm.toString(8);
                    }
                    $('#' + id + '-perm').val(perm);
                },
                setcheck = function (perm) {
                    var _perm;
                    for (var i = 0; i < 3; i++) {
                        _perm = parseInt(perm.slice(i, i + 1), 8);
                        $("#" + id + "-read-" + level[i] + '-perm').prop("checked", false);
                        $("#" + id + "-write-" + level[i] + '-perm').prop("checked", false);
                        $("#" + id + "-execute-" + level[i] + '-perm').prop("checked", false);
                        if ((_perm & 4) == 4) {
                            $("#" + id + "-read-" + level[i] + '-perm').prop("checked", true);
                        }
                        if ((_perm & 2) == 2) {
                            $("#" + id + "-write-" + level[i] + '-perm').prop("checked", true);
                        }
                        if ((_perm & 1) == 1) {
                            $("#" + id + "-execute-" + level[i] + '-perm').prop("checked", true);
                        }
                    }
                    setperm();
                },
                makeperm = function (files) {
                    var perm = '777', ret = '', chk, _chk, _perm;
                    var len = files.length;
                    for (var i2 = 0; i2 < len; i2++) {
                        chk = getPerm(files[i2].perm);
                        if (!prevVals[chk]) {
                            prevVals[chk] = [];
                        }
                        prevVals[chk].push(files[i2].hash);
                        ret = '';
                        for (var i = 0; i < 3; i++) {
                            _chk = parseInt(chk.slice(i, i + 1), 8);
                            _perm = parseInt(perm.slice(i, i + 1), 8);
                            if ((_chk & 4) != 4 && (_perm & 4) == 4) {
                                _perm -= 4;
                            }
                            if ((_chk & 2) != 2 && (_perm & 2) == 2) {
                                _perm -= 2;
                            }
                            if ((_chk & 1) != 1 && (_perm & 1) == 1) {
                                _perm -= 1;
                            }
                            ret += _perm.toString(8);
                        }
                        perm = ret;
                    }
                    return perm;
                },
                makeName = function (name) {
                    return name ? ':' + name : '';
                },
                makeDataTable = function (perm, f) {
                    var _perm, fieldset;
                    var value = '';
                    var dataTable = tpl.dataTable;
                    for (var i = 0; i < 3; i++) {
                        _perm = parseInt(perm.slice(i, i + 1), 8);
                        value += _perm.toString(8);
                        fieldset = tpl.fieldset.replace('{f_title}', fm.i18n(level[i])).replace('{name}', makeName(f[level[i]])).replace(/\{level\}/g, level[i]);
                        dataTable = dataTable.replace('{' + i + '}', fieldset)
                            .replace('{checked-r}', ((_perm & 4) == 4) ? checked : '')
                            .replace('{checked-w}', ((_perm & 2) == 2) ? checked : '')
                            .replace('{checked-x}', ((_perm & 1) == 1) ? checked : '');
                    }
                    dataTable = dataTable.replace('{value}', value).replace('{valueCaption}', msg['perm']);
                    return dataTable;
                },
                getPerm = function (perm) {
                    if (isNaN(parseInt(perm, 8))) {
                        var mode_array = perm.split('');
                        var a = [];

                        for (var i = 0, l = mode_array.length; i < l; i++) {
                            if (i === 0 || i === 3 || i === 6) {
                                if (mode_array[i].match(/[r]/i)) {
                                    a.push(1);
                                } else if (mode_array[i].match(/[-]/)) {
                                    a.push(0);
                                }
                            } else if (i === 1 || i === 4 || i === 7) {
                                if (mode_array[i].match(/[w]/i)) {
                                    a.push(1);
                                } else if (mode_array[i].match(/[-]/)) {
                                    a.push(0);
                                }
                            } else {
                                if (mode_array[i].match(/[x]/i)) {
                                    a.push(1);
                                } else if (mode_array[i].match(/[-]/)) {
                                    a.push(0);
                                }
                            }
                        }

                        a.splice(3, 0, ",");
                        a.splice(7, 0, ",");

                        var b = a.join("");
                        var b_array = b.split(",");
                        var c = [];

                        for (var j = 0, m = b_array.length; j < m; j++) {
                            var p = parseInt(b_array[j], 2).toString(8);
                            c.push(p);
                        }

                        perm = c.join('');
                    } else {
                        perm = parseInt(perm, 8).toString(8);
                    }
                    return perm;
                },
                opts = {
                    title: this.title,
                    width: 'auto',
                    buttons: buttons(),
                    close: function () { $(this).elfinderdialog('destroy'); }
                },
                dialog = fm.getUI().find('#' + id),
                prevVals = {},
                tmb = '', title, dataTable;

            if (dialog.length) {
                dialog.elfinderdialog('toTop');
                return $.Deferred().resolve();
            }

            view = view.replace('{class}', cnt > 1 ? 'elfinder-cwd-icon-group' : fm.mime2class(file.mime));
            if (cnt > 1) {
                title = tpl.groupTitle.replace('{items}', fm.i18n('items')).replace('{num}', cnt);
            } else {
                title = tpl.itemTitle.replace('{name}', file.name).replace('{kind}', fm.mime2kind(file));
                tmb = fm.tmb(file);
            }

            dataTable = makeDataTable(makeperm(files), files.length == 1 ? files[0] : {});

            view = view.replace('{title}', title).replace('{dataTable}', dataTable).replace(/{id}/g, id);

            dialog = this.fmDialog(view, opts);
            dialog.attr('id', id);

            // load thumbnail
            if (tmb) {
                $('<img/>')
                    .on('load', function () { dialog.find('.elfinder-cwd-icon').addClass(tmb.className).css('background-image', "url('" + tmb.url + "')"); })
                    .attr('src', tmb.url);
            }

            $('#' + id + '-table-perm :checkbox').on('click', function () { setperm('perm'); });
            $('#' + id + '-perm').on('keydown', function (e) {
                var c = e.keyCode;
                if (c == $.ui.keyCode.ENTER) {
                    e.stopPropagation();
                    save();
                    return;
                }
            }).on('focus', function (e) {
                $(this).trigger('select');
            }).on('keyup', function (e) {
                if ($(this).val().length == 3) {
                    $(this).trigger('select');
                    setcheck($(this).val());
                }
            });

            return dfrd;
        };
    };


    /*
     * File: /js/commands/colwidth.js
     */

    /**
     * @class  elFinder command "colwidth"
     * CWD list table columns width to auto
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.colwidth = function () {
        this.alwaysEnabled = true;
        this.updateOnSelect = false;

        this.getstate = function () {
            return this.fm.getUI('cwd').find('table').css('table-layout') === 'fixed' ? 0 : -1;
        };

        this.exec = function () {
            this.fm.getUI('cwd').trigger('colwidth');
            return $.Deferred().resolve();
        };

    };

    /*
     * File: /js/commands/copy.js
     */

    /**
     * @class elFinder command "copy".
     * Put files in filemanager clipboard.
     *
     * @type  elFinder.command
     * @author  Dmitry (dio) Levashov
     */
    elFinder.prototype.commands.copy = function () {
        this.shortcuts = [{
            pattern: 'ctrl+c ctrl+insert'
        }];

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (f) {
                        fres = fres && f.read ? true : false;
                        return fres;
                    });
                };

            return cnt && filter(sel).length == cnt ? 0 : -1;
        };

        this.exec = function (hashes) {
            var fm = this.fm,
                dfrd = $.Deferred()
                    .fail(function (error) {
                        fm.error(error);
                    });

            $.each(this.files(hashes), function (i, file) {
                if (!file.read) {
                    return !dfrd.reject(['errCopy', file.name, 'errPerm']);
                }
            });

            return dfrd.state() == 'rejected' ? dfrd : dfrd.resolve(fm.clipboard(this.hashes(hashes)));
        };

    };


    /*
     * File: /js/commands/cut.js
     */

    /**
     * @class elFinder command "copy".
     * Put files in filemanager clipboard.
     *
     * @type  elFinder.command
     * @author  Dmitry (dio) Levashov
     */
    elFinder.prototype.commands.cut = function () {
        var fm = this.fm;

        this.shortcuts = [{
            pattern: 'ctrl+x shift+insert'
        }];

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (f) {
                        fres = fres && f.read && !f.locked && !fm.isRoot(f) ? true : false;
                        return fres;
                    });
                };

            return cnt && filter(sel).length == cnt ? 0 : -1;
        };

        this.exec = function (hashes) {
            var dfrd = $.Deferred()
                .fail(function (error) {
                    fm.error(error);
                });

            $.each(this.files(hashes), function (i, file) {
                if (!(file.read && !file.locked && !fm.isRoot(file))) {
                    return !dfrd.reject(['errCopy', file.name, 'errPerm']);
                }
                if (file.locked) {
                    return !dfrd.reject(['errLocked', file.name]);
                }
            });

            return dfrd.state() == 'rejected' ? dfrd : dfrd.resolve(fm.clipboard(this.hashes(hashes), true));
        };

    };


    /*
     * File: /js/commands/download.js
     */

    /**
     * @class elFinder command "download". 
     * Download selected files.
     * Only for new api
     *
     * @author Dmitry (dio) Levashov, dio@std42.ru
     **/
    elFinder.prototype.commands.zipdl = function () { };
    elFinder.prototype.commands.download = function () {
        var self = this,
            fm = this.fm,
            czipdl = null,
            zipOn = false,
            mixed = false,
            dlntf = false,
            cpath = window.location.pathname || '/',
            filter = function (hashes, inExec) {
                var volumeid, mixedCmd;

                if (czipdl !== null) {
                    if (fm.searchStatus.state > 1) {
                        mixed = fm.searchStatus.mixed;
                    } else if (fm.leafRoots[fm.cwd().hash]) {
                        volumeid = fm.cwd().volumeid;
                        $.each(hashes, function (i, h) {
                            if (h.indexOf(volumeid) !== 0) {
                                mixed = true;
                                return false;
                            }
                        });
                    }
                    zipOn = (fm.isCommandEnabled('zipdl', hashes[0]));
                }

                if (mixed) {
                    mixedCmd = czipdl ? 'zipdl' : 'download';
                    hashes = $.grep(hashes, function (h) {
                        var f = fm.file(h),
                            res = (!f || (!czipdl && f.mime === 'directory') || !fm.isCommandEnabled(mixedCmd, h)) ? false : true;
                        if (f && inExec && !res) {
                            fm.cwdHash2Elm(f.hash).trigger('unselect');
                        }
                        return res;
                    });
                    if (!hashes.length) {
                        return [];
                    }
                } else {
                    if (!fm.isCommandEnabled('download', hashes[0])) {
                        return [];
                    }
                }

                return $.grep(self.files(hashes), function (f) {
                    var res = (!f.read || (!zipOn && f.mime == 'directory')) ? false : true;
                    if (inExec && !res) {
                        fm.cwdHash2Elm(f.hash).trigger('unselect');
                    }
                    return res;
                });
            };

        this.linkedCmds = ['zipdl'];

        this.shortcuts = [{
            pattern: 'shift+enter'
        }];

        this.getstate = function (select) {
            var sel = this.hashes(select),
                cnt = sel.length,
                maxReq = this.options.maxRequests || 10,
                mixed = false,
                croot = '';

            if (cnt < 1) {
                return -1;
            }
            cnt = filter(sel).length;

            return (cnt && (zipOn || (cnt <= maxReq && ((!fm.UA.IE && !fm.UA.Mobile) || cnt == 1))) ? 0 : -1);
        };

        fm.bind('contextmenu', function (e) {
            var fm = self.fm,
                helper = null,
                targets, file, link,
                getExtra = function (file) {
                    var link = file.url || fm.url(file.hash);
                    return {
                        icon: 'link',
                        node: $('<a></a>')
                            .attr({ href: link, target: '_blank', title: fm.i18n('link') })
                            .text(file.name)
                            .on('mousedown click touchstart touchmove touchend contextmenu', function (e) {
                                e.stopPropagation();
                            })
                            .on('dragstart', function (e) {
                                var dt = e.dataTransfer || e.originalEvent.dataTransfer || null;
                                helper = null;
                                if (dt) {
                                    var icon = function (f) {
                                        var mime = f.mime, i, tmb = fm.tmb(f);
                                        i = '<div class="elfinder-cwd-icon ' + fm.mime2class(mime) + ' ui-corner-all"></div>';
                                        if (tmb) {
                                            i = $(i).addClass(tmb.className).css('background-image', "url('" + tmb.url + "')").get(0).outerHTML;
                                        }
                                        return i;
                                    };
                                    dt.effectAllowed = 'copyLink';
                                    if (dt.setDragImage) {
                                        helper = $('<div class="elfinder-drag-helper html5-native">').append(icon(file)).appendTo($(document.body));
                                        dt.setDragImage(helper.get(0), 50, 47);
                                    }
                                    if (!fm.UA.IE) {
                                        dt.setData('elfinderfrom', window.location.href + file.phash);
                                        dt.setData('elfinderfrom:' + dt.getData('elfinderfrom'), '');
                                    }
                                }
                            })
                            .on('dragend', function (e) {
                                helper && helper.remove();
                            })
                    };
                };
            self.extra = null;
            if (e.data) {
                targets = e.data.targets || [];
                if (targets.length === 1 && (file = fm.file(targets[0])) && file.mime !== 'directory') {
                    if (file.url != '1') {
                        self.extra = getExtra(file);
                    } else {
                        // Get URL ondemand
                        var node;
                        self.extra = {
                            icon: 'link',
                            node: $('<a></a>')
                                .attr({ href: '#', title: fm.i18n('getLink'), draggable: 'false' })
                                .text(file.name)
                                .on('click touchstart', function (e) {
                                    if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                                        return;
                                    }
                                    var parent = node.parent();
                                    e.stopPropagation();
                                    e.preventDefault();
                                    parent.removeClass('ui-state-disabled').addClass('elfinder-button-icon-spinner');
                                    fm.request({
                                        data: { cmd: 'url', target: file.hash },
                                        preventDefault: true
                                    })
                                        .always(function (data) {
                                            parent.removeClass('elfinder-button-icon-spinner');
                                            if (data.url) {
                                                var rfile = fm.file(file.hash);
                                                rfile.url = data.url;
                                                node.replaceWith(getExtra(file).node);
                                            } else {
                                                parent.addClass('ui-state-disabled');
                                            }
                                        });

                                })
                        };
                        node = self.extra.node;
                        node.ready(function () {
                            requestAnimationFrame(function () {
                                node.parent().addClass('ui-state-disabled').css('pointer-events', 'auto');
                            });
                        });
                    }
                }
            }
        }).one('open', function () {
            if (fm.api >= 2.1012) {
                czipdl = fm.getCommand('zipdl');
            }
            dlntf = fm.cookieEnabled && fm.api > 2.1038 && !fm.isCORS;
        });

        this.exec = function (select) {
            var hashes = this.hashes(select),
                fm = this.fm,
                base = fm.options.url,
                files = filter(hashes, true),
                dfrd = $.Deferred(),
                iframes = '',
                cdata = '',
                targets = {},
                i, url,
                linkdl = false,
                getTask = function (hashes) {
                    return function () {
                        var dfd = $.Deferred(),
                            root = fm.file(fm.root(hashes[0])),
                            single = (hashes.length === 1),
                            volName = root ? (root.i18 || root.name) : null,
                            dir, dlName, phash;
                        if (single) {
                            if (dir = fm.file(hashes[0])) {
                                dlName = (dir.i18 || dir.name);
                            }
                        } else {
                            $.each(hashes, function () {
                                var d = fm.file(this);
                                if (d && (!phash || phash === d.phash)) {
                                    phash = d.phash;
                                } else {
                                    phash = null;
                                    return false;
                                }
                            });
                            if (phash && (dir = fm.file(phash))) {
                                dlName = (dir.i18 || dir.name) + '-' + hashes.length;
                            }
                        }
                        if (dlName) {
                            volName = dlName;
                        }
                        volName && (volName = ' (' + volName + ')');
                        fm.request({
                            data: { cmd: 'zipdl', targets: hashes },
                            notify: { type: 'zipdl', cnt: 1, hideCnt: true, msg: fm.i18n('ntfzipdl') + volName },
                            cancel: true,
                            eachCancel: true,
                            preventDefault: true
                        }).done(function (e) {
                            var zipdl, dialog, btn = {}, dllink, form, iframe, m,
                                uniq = 'dlw' + (+new Date()),
                                zipdlFn = function (url) {
                                    dllink = $('<a></a>')
                                        .attr('href', url)
                                        .attr('download', fm.escape(dlName))
                                        .on('click', function () {
                                            dfd.resolve();
                                            dialog && dialog.elfinderdialog('destroy');
                                        });
                                    if (linkdl) {
                                        dllink.attr('target', '_blank')
                                            .append('<span class="elfinder-button-icon elfinder-button-icon-download"></span>' + fm.escape(dlName));
                                        btn[fm.i18n('btnCancel')] = function () {
                                            dialog.elfinderdialog('destroy');
                                        };
                                        dialog = self.fmDialog(dllink, {
                                            title: fm.i18n('link'),
                                            buttons: btn,
                                            width: '200px',
                                            destroyOnClose: true,
                                            close: function () {
                                                (dfd.state() !== 'resolved') && dfd.resolve();
                                            }
                                        });
                                    } else {
                                        click(dllink.hide().appendTo('body').get(0));
                                        dllink.remove();
                                    }
                                };
                            if (e.error) {
                                fm.error(e.error);
                                dfd.resolve();
                            } else if (e.zipdl) {
                                zipdl = e.zipdl;
                                if (dlName) {
                                    m = fm.splitFileExtention(zipdl.name || '');
                                    dlName += m[1] ? ('.' + m[1]) : '.zip';
                                } else {
                                    dlName = zipdl.name;
                                }
                                if (html5dl || linkdl) {
                                    url = fm.options.url + (fm.options.url.indexOf('?') === -1 ? '?' : '&')
                                        + 'cmd=zipdl&download=1';
                                    $.each([hashes[0], zipdl.file, dlName, zipdl.mime], function (key, val) {
                                        url += '&targets%5B%5D=' + encodeURIComponent(val);
                                    });
                                    $.each(fm.customData, function (key, val) {
                                        url += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(val);
                                    });
                                    url += '&' + encodeURIComponent(dlName);
                                    if (fm.hasParrotHeaders()) {
                                        fm.getBinaryByUrl({ url: url }, function (blob) {
                                            if (blob instanceof Blob) {
                                                url = (window.URL || window.webkitURL).createObjectURL(blob);
                                                zipdlFn(url);
                                            } else {
                                                fm.error(['errUploadTransfer', fm.i18n('kindZIP')]);
                                            }
                                        });
                                    } else {
                                        zipdlFn(url);
                                    }
                                } else {
                                    form = $('<form action="' + fm.options.url + '" method="post" target="' + uniq + '" style="display:none"></form>')
                                        .append('<input type="hidden" name="cmd" value="zipdl"/>')
                                        .append('<input type="hidden" name="download" value="1"/>');
                                    $.each([hashes[0], zipdl.file, dlName, zipdl.mime], function (key, val) {
                                        form.append('<input type="hidden" name="targets[]" value="' + fm.escape(val) + '"/>');
                                    });
                                    $.each(fm.customData, function (key, val) {
                                        form.append('<input type="hidden" name="' + key + '" value="' + fm.escape(val) + '"/>');
                                    });
                                    form.attr('target', uniq).appendTo('body');
                                    iframe = $('<iframe style="display:none" name="' + uniq + '">')
                                        .appendTo('body')
                                        .ready(function () {
                                            form.submit().remove();
                                            dfd.resolve();
                                            setTimeout(function () {
                                                iframe.remove();
                                            }, 20000); // give 20 sec file to be saved
                                        });
                                }
                            }
                        }).fail(function (error) {
                            error && fm.error(error);
                            dfd.resolve();
                        });
                        return dfd.promise();
                    };
                },
                // use MouseEvent to click element for Safari etc
                click = function (a) {
                    var clickEv;
                    if (typeof MouseEvent === 'function') {
                        clickEv = new MouseEvent('click');
                    } else {
                        clickEv = document.createEvent('MouseEvents');
                        clickEv.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    }
                    fm.pauseUnloadCheck(true);
                    a.dispatchEvent(clickEv);
                },
                checkCookie = function (id) {
                    var name = 'elfdl' + id,
                        parts;
                    parts = document.cookie.split(name + "=");
                    if (parts.length === 2) {
                        ntftm && clearTimeout(ntftm);
                        document.cookie = name + '=; path=' + cpath + '; max-age=0';
                        closeNotify();
                    } else {
                        setTimeout(function () { checkCookie(id); }, 200);
                    }
                },
                closeNotify = function () {
                    if (fm.ui.notify.children('.elfinder-notify-download').length) {
                        fm.notify({
                            type: 'download',
                            cnt: -1
                        });
                    }
                },
                reqids = [],
                link, html5dl, fileCnt, clickEv, cid, ntftm, reqid, getUrlDfrd, urls;

            if (!files.length) {
                return dfrd.reject();
            }

            fileCnt = $.grep(files, function (f) { return f.mime === 'directory' ? false : true; }).length;
            link = $('<a>').hide().appendTo('body');
            html5dl = (typeof link.get(0).download === 'string');

            if (zipOn && (fileCnt !== files.length || fileCnt >= (this.options.minFilesZipdl || 1))) {
                link.remove();
                linkdl = (!html5dl && fm.UA.Mobile);
                if (mixed) {
                    targets = {};
                    $.each(files, function (i, f) {
                        var p = f.hash.split('_', 2);
                        if (!targets[p[0]]) {
                            targets[p[0]] = [f.hash];
                        } else {
                            targets[p[0]].push(f.hash);
                        }
                    });
                    if (!linkdl && fm.UA.Mobile && Object.keys(targets).length > 1) {
                        linkdl = true;
                    }
                } else {
                    targets = [$.map(files, function (f) { return f.hash; })];
                }
                dfrd = fm.sequence($.map(targets, function (t) { return getTask(t); })).always(
                    function () {
                        fm.trigger('download', { files: files });
                    }
                );
                return dfrd;
            } else {
                reqids = [];
                getUrlDfrd = $.Deferred().done(function (urls) {
                    for (i = 0; i < urls.length; i++) {
                        url = urls[i];
                        if (dlntf && url.substr(0, fm.options.url.length) === fm.options.url) {
                            reqid = fm.getRequestId();
                            reqids.push(reqid);
                            url += '&cpath=' + cpath + '&reqid=' + reqid;
                            ntftm = setTimeout(function () {
                                fm.notify({
                                    type: 'download',
                                    cnt: 1,
                                    cancel: (fm.UA.IE || fm.UA.Edge) ? void (0) : function () {
                                        if (reqids.length) {
                                            $.each(reqids, function () {
                                                fm.request({
                                                    data: {
                                                        cmd: 'abort',
                                                        id: this
                                                    },
                                                    preventDefault: true
                                                });
                                            });
                                        }
                                        reqids = [];
                                    }
                                });
                            }, fm.notifyDelay);
                            checkCookie(reqid);
                        }
                        if (html5dl) {
                            click(link.attr('href', url)
                                .attr('download', fm.escape(files[i].name))
                                .get(0)
                            );
                        } else {
                            if (fm.UA.Mobile) {
                                setTimeout(function () {
                                    if (!window.open(url)) {
                                        fm.error('errPopup');
                                        ntftm && cleaerTimeout(ntftm);
                                        closeNotify();
                                    }
                                }, 100);
                            } else {
                                iframes += '<iframe class="downloader" id="downloader-' + files[i].hash + '" style="display:none" src="' + url + '"></iframe>';
                            }
                        }
                    }
                    link.remove();
                    $(iframes)
                        .appendTo('body')
                        .ready(function () {
                            setTimeout(function () {
                                $(iframes).each(function () {
                                    $('#' + $(this).attr('id')).remove();
                                });
                            }, 20000 + (10000 * i)); // give 20 sec + 10 sec for each file to be saved
                        });
                    fm.trigger('download', { files: files });
                    dfrd.resolve();
                });
                fileCnt = files.length;
                urls = [];
                for (i = 0; i < files.length; i++) {
                    fm.openUrl(files[i].hash, true, function (v) {
                        v && urls.push(v);
                        if (--fileCnt < 1) {
                            getUrlDfrd.resolve(urls);
                        }
                    });
                }
                return dfrd;
            }
        };

    };


    /*
     * File: /js/commands/duplicate.js
     */

    /**
     * @class elFinder command "duplicate"
     * Create file/folder copy with suffix "copy Number"
     *
     * @type  elFinder.command
     * @author  Dmitry (dio) Levashov
     */
    elFinder.prototype.commands.duplicate = function () {
        var fm = this.fm;

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (f) {
                        fres = fres && f.read && f.phash === fm.cwd().hash && !fm.isRoot(f) ? true : false;
                        return fres;
                    });
                };

            return cnt && fm.cwd().write && filter(sel).length == cnt ? 0 : -1;
        };

        this.exec = function (hashes) {
            var fm = this.fm,
                files = this.files(hashes),
                cnt = files.length,
                dfrd = $.Deferred()
                    .fail(function (error) {
                        error && fm.error(error);
                    }),
                args = [];

            if (!cnt) {
                return dfrd.reject();
            }

            $.each(files, function (i, file) {
                if (!file.read || !fm.file(file.phash).write) {
                    return !dfrd.reject(['errCopy', file.name, 'errPerm']);
                }
            });

            if (dfrd.state() == 'rejected') {
                return dfrd;
            }

            return fm.request({
                data: { cmd: 'duplicate', targets: this.hashes(hashes) },
                notify: { type: 'copy', cnt: cnt },
                navigate: {
                    toast: {
                        inbuffer: { msg: fm.i18n(['complete', fm.i18n('cmdduplicate')]) }
                    }
                }
            });

        };

    };


    /*
     * File: /js/commands/edit.js
     */

    /**
     * @class elFinder command "edit". 
     * Edit text file in dialog window
     *
     * @author Dmitry (dio) Levashov, dio@std42.ru
     **/
    elFinder.prototype.commands.edit = function () {
        var self = this,
            fm = this.fm,
            clsEditing = fm.res('class', 'editing'),
            mimesSingle = [],
            mimes = [],
            allowAll = false,
            rtrim = function (str) {
                return str.replace(/\s+$/, '');
            },
            getEncSelect = function (heads) {
                var sel = $('<select class="ui-corner-all"></select>'),
                    hval;
                if (heads) {
                    $.each(heads, function (i, head) {
                        hval = fm.escape(head.value);
                        sel.append('<option value="' + hval + '">' + (head.caption ? fm.escape(head.caption) : hval) + '</option>');
                    });
                }
                $.each(self.options.encodings, function (i, v) {
                    sel.append('<option value="' + v + '">' + v + '</option>');
                });
                return sel;
            },
            getDlgWidth = function () {
                var win = fm.options.dialogContained ? fm.getUI() : $(window),
                    m, width;
                if (typeof self.options.dialogWidth === 'string' && (m = self.options.dialogWidth.match(/(\d+)%/))) {
                    width = parseInt(win.width() * (m[1] / 100));
                } else {
                    width = parseInt(self.options.dialogWidth || 650);
                }
                return Math.min(width, win.width());
            },
            getDlgHeight = function () {
                if (!self.options.dialogHeight) {
                    return void (0);
                }
                var win = fm.options.dialogContained ? fm.getUI() : $(window),
                    m, height;
                if (typeof self.options.dialogHeight === 'string' && (m = self.options.dialogHeight.match(/(\d+)%/))) {
                    height = parseInt(win.height() * (m[1] / 100));
                } else {
                    height = parseInt(self.options.dialogHeight || win.height());
                }
                return Math.min(height, win.height());
            },

            /**
             * Return files acceptable to edit
             *
             * @param  Array  files hashes
             * @return Array
             **/
            filter = function (files) {
                var cnt = files.length,
                    mime, ext, skip;

                if (cnt > 1) {
                    mime = files[0].mime;
                    ext = files[0].name.replace(/^.*(\.[^.]+)$/, '$1');
                }
                return $.grep(files, function (file) {
                    var res;
                    if (skip || file.mime === 'directory') {
                        return false;
                    }
                    res = file.read
                        && (allowAll || fm.mimeIsText(file.mime) || $.inArray(file.mime, cnt === 1 ? mimesSingle : mimes) !== -1)
                        && (!self.onlyMimes.length || $.inArray(file.mime, self.onlyMimes) !== -1)
                        && (cnt === 1 || (file.mime === mime && file.name.substr(ext.length * -1) === ext))
                        && (fm.uploadMimeCheck(file.mime, file.phash) ? true : false)
                        && setEditors(file, cnt)
                        && Object.keys(editors).length;
                    if (!res) {
                        skip = true;
                    }
                    return res;
                });
            },

            fileSync = function (hash) {
                var old = fm.file(hash),
                    f;
                fm.request({
                    cmd: 'info',
                    targets: [hash],
                    preventDefault: true
                }).done(function (data) {
                    var changed;
                    if (data && data.files && data.files.length) {
                        f = data.files[0];
                        if (old.ts != f.ts || old.size != f.size) {
                            changed = { changed: [f] };
                            fm.updateCache(changed);
                            fm.change(changed);
                        }
                    }
                });
            },

            /**
             * Open dialog with textarea to edit file
             *
             * @param  String  id       dialog id
             * @param  Object  file     file object
             * @param  String  content  file content
             * @return $.Deferred
             **/
            dialog = function (id, file, content, encoding, editor, toasts) {

                var dfrd = $.Deferred(),
                    _loaded = false,
                    loaded = function () {
                        if (!_loaded) {
                            fm.toast({
                                mode: 'warning',
                                msg: fm.i18n('nowLoading')
                            });
                            return false;
                        }
                        return true;
                    },
                    makeToasts = function () {
                        // make toast message
                        if (toasts && Array.isArray(toasts)) {
                            $.each(toasts, function () {
                                this.msg && fm.toast(this);
                            });
                        }
                    },
                    save = function () {
                        var encord = selEncoding ? selEncoding.val() : void (0),
                            saveDfd = $.Deferred().fail(function (err) {
                                dialogNode.show().find('button.elfinder-btncnt-0,button.elfinder-btncnt-1').hide();
                            }),
                            conf, res, tm;
                        if (!loaded()) {
                            return saveDfd.resolve();
                        }
                        if (ta.editor) {
                            ta.editor.save(ta[0], ta.editor.instance);
                            conf = ta.editor.confObj;
                            if (conf.info && (conf.info.schemeContent || conf.info.arrayBufferContent)) {
                                encord = 'scheme';
                            }
                        }
                        res = getContent();
                        setOld(res);
                        if (res.promise) {
                            tm = setTimeout(function () {
                                fm.notify({
                                    type: 'chkcontent',
                                    cnt: 1,
                                    hideCnt: true,
                                    cancel: function () {
                                        res.reject();
                                    }
                                });
                            }, 100);
                            res.always(function () {
                                tm && clearTimeout(tm);
                                fm.notify({ type: 'chkcontent', cnt: -1 });
                            }).done(function (data) {
                                dfrd.notifyWith(ta, [encord, ta.data('hash'), old, saveDfd]);
                            }).fail(function (err) {
                                saveDfd.reject(err);
                            });
                        } else {
                            dfrd.notifyWith(ta, [encord, ta.data('hash'), old, saveDfd]);
                        }
                        return saveDfd;
                    },
                    saveon = function () {
                        if (!loaded()) { return; }
                        save().fail(function (err) {
                            err && fm.error(err);
                        });
                    },
                    cancel = function () {
                        ta.elfinderdialog('close');
                    },
                    savecl = function () {
                        if (!loaded()) { return; }
                        dialogNode.hide();
                        save().done(function () {
                            _loaded = false;
                            dialogNode.show();
                            cancel();
                        }).fail(function (err) {
                            dialogNode.show();
                            err && fm.error(err);
                        });
                    },
                    saveAs = function () {
                        if (!loaded()) { return; }
                        var prevOld = old,
                            phash = file.phash,
                            fail = function (err) {
                                dialogs.addClass(clsEditing).fadeIn(function () {
                                    err && fm.error(err);
                                });
                                old = prevOld;
                                fm.disable();
                            },
                            make = function () {
                                self.mime = saveAsFile.mime || file.mime;
                                self.prefix = (saveAsFile.name || file.name).replace(/ \d+(\.[^.]+)?$/, '$1');
                                self.requestCmd = 'mkfile';
                                self.nextAction = {};
                                self.data = { target: phash };
                                $.proxy(fm.res('mixin', 'make'), self)()
                                    .done(function (data) {
                                        var oldHash;
                                        if (data.added && data.added.length) {
                                            oldHash = ta.data('hash');
                                            ta.data('hash', data.added[0].hash);
                                            save().done(function () {
                                                _loaded = false;
                                                dialogNode.show();
                                                cancel();
                                                dialogs.fadeIn();
                                            }).fail(function () {
                                                fm.exec('rm', [data.added[0].hash], { forceRm: true, quiet: true });
                                                ta.data('hash', oldHash);
                                                dialogNode.find('button.elfinder-btncnt-2').hide();
                                                fail();
                                            });
                                        } else {
                                            fail();
                                        }
                                    })
                                    .progress(function (err) {
                                        if (err && err === 'errUploadMime') {
                                            ta.trigger('saveAsFail');
                                        }
                                    })
                                    .fail(fail)
                                    .always(function () {
                                        delete self.mime;
                                        delete self.prefix;
                                        delete self.nextAction;
                                        delete self.data;
                                    });
                                fm.trigger('unselectfiles', { files: [file.hash] });
                            },
                            reqOpen = null,
                            reqInfo = null,
                            dialogs = fm.getUI().children('.' + self.dialogClass + ':visible');
                        if (dialogNode.is(':hidden')) {
                            dialogs = dialogs.add(dialogNode);
                        }
                        dialogs.removeClass(clsEditing).fadeOut();

                        fm.enable();

                        if (fm.searchStatus.state < 2 && phash !== fm.cwd().hash) {
                            reqOpen = fm.exec('open', [phash], { thash: phash });
                        } else if (!fm.file(phash)) {
                            reqInfo = fm.request({ cmd: 'info', targets: [phash] });
                        }

                        $.when([reqOpen, reqInfo]).done(function () {
                            if (reqInfo) {
                                fm.one('infodone', function () {
                                    fm.file(phash) ? make() : fail('errFolderNotFound');
                                });
                            } else {
                                reqOpen ? fm.one('cwdrender', make) : make();
                            }
                        }).fail(fail);
                    },
                    changed = function () {
                        var dfd = $.Deferred(),
                            res, tm;
                        if (!_loaded) {
                            return dfd.resolve(false);
                        }
                        ta.editor && ta.editor.save(ta[0], ta.editor.instance);
                        res = getContent();
                        if (res && res.promise) {
                            tm = setTimeout(function () {
                                fm.notify({
                                    type: 'chkcontent',
                                    cnt: 1,
                                    hideCnt: true,
                                    cancel: function () {
                                        res.reject();
                                    }
                                });
                            }, 100);
                            res.always(function () {
                                tm && clearTimeout(tm);
                                fm.notify({ type: 'chkcontent', cnt: -1 });
                            }).done(function (d) {
                                dfd.resolve(old !== d);
                            }).fail(function (err) {
                                dfd.resolve(err || (old === undefined ? false : true));
                            });
                        } else {
                            dfd.resolve(old !== res);
                        }
                        return dfd;
                    },
                    opts = {
                        title: fm.escape(file.name),
                        width: getDlgWidth(),
                        height: getDlgHeight(),
                        buttons: {},
                        cssClass: clsEditing,
                        maxWidth: 'window',
                        maxHeight: 'window',
                        allowMinimize: true,
                        allowMaximize: true,
                        openMaximized: editorMaximized() || (editor && editor.info && editor.info.openMaximized),
                        btnHoverFocus: false,
                        closeOnEscape: false,
                        propagationEvents: ['mousemove', 'mouseup', 'click'],
                        minimize: function () {
                            var conf;
                            if (ta.editor && dialogNode.closest('.ui-dialog').is(':hidden')) {
                                conf = ta.editor.confObj;
                                if (conf.info && conf.info.syncInterval) {
                                    fileSync(file.hash);
                                }
                            }
                        },
                        close: function () {
                            var close = function () {
                                var conf;
                                dfrd.resolve();
                                if (ta.editor) {
                                    ta.editor.close(ta[0], ta.editor.instance);
                                    conf = ta.editor.confObj;
                                    if (conf.info && conf.info.syncInterval) {
                                        fileSync(file.hash);
                                    }
                                }
                                ta.elfinderdialog('destroy');
                            },
                                onlySaveAs = (typeof saveAsFile.name !== 'undefined'),
                                accept = onlySaveAs ? {
                                    label: 'btnSaveAs',
                                    callback: function () {
                                        requestAnimationFrame(saveAs);
                                    }
                                } : {
                                    label: 'btnSaveClose',
                                    callback: function () {
                                        save().done(function () {
                                            close();
                                        });
                                    }
                                };
                            changed().done(function (change) {
                                var msgs = ['confirmNotSave'];
                                if (change) {
                                    if (typeof change === 'string') {
                                        msgs.unshift(change);
                                    }
                                    fm.confirm({
                                        title: self.title,
                                        text: msgs,
                                        accept: accept,
                                        cancel: {
                                            label: 'btnClose',
                                            callback: close
                                        },
                                        buttons: onlySaveAs ? null : [{
                                            label: 'btnSaveAs',
                                            callback: function () {
                                                requestAnimationFrame(saveAs);
                                            }
                                        }]
                                    });
                                } else {
                                    close();
                                }
                            });
                        },
                        open: function () {
                            var loadRes, conf, interval;
                            ta.initEditArea.call(ta, id, file, content, fm);
                            if (ta.editor) {
                                loadRes = ta.editor.load(ta[0]) || null;
                                if (loadRes && loadRes.done) {
                                    loadRes.always(function () {
                                        _loaded = true;
                                    }).done(function (instance) {
                                        ta.editor.instance = instance;
                                        ta.editor.focus(ta[0], ta.editor.instance);
                                        setOld(getContent());
                                        requestAnimationFrame(function () {
                                            dialogNode.trigger('resize');
                                        });
                                    }).fail(function (error) {
                                        error && fm.error(error);
                                        ta.elfinderdialog('destroy');
                                        return;
                                    }).always(makeToasts);
                                } else {
                                    _loaded = true;
                                    if (loadRes && (typeof loadRes === 'string' || Array.isArray(loadRes))) {
                                        fm.error(loadRes);
                                        ta.elfinderdialog('destroy');
                                        return;
                                    }
                                    ta.editor.instance = loadRes;
                                    ta.editor.focus(ta[0], ta.editor.instance);
                                    setOld(getContent());
                                    requestAnimationFrame(function () {
                                        dialogNode.trigger('resize');
                                    });
                                    makeToasts();
                                }
                                conf = ta.editor.confObj;
                                if (conf.info && conf.info.syncInterval) {
                                    if (interval = parseInt(conf.info.syncInterval)) {
                                        setTimeout(function () {
                                            autoSync(interval);
                                        }, interval);
                                    }
                                }
                            } else {
                                _loaded = true;
                                setOld(getContent());
                            }
                        },
                        resize: function (e, data) {
                            ta.editor && ta.editor.resize(ta[0], ta.editor.instance, e, data || {});
                        }
                    },
                    getContent = function () {
                        var res = ta.getContent.call(ta, ta[0]);
                        if (res === undefined || res === false || res === null) {
                            res = $.Deferred().reject();
                        }
                        return res;
                    },
                    setOld = function (res) {
                        if (res && res.promise) {
                            res.done(function (d) {
                                old = d;
                            });
                        } else {
                            old = res;
                        }
                    },
                    autoSync = function (interval) {
                        if (dialogNode.is(':visible')) {
                            fileSync(file.hash);
                            setTimeout(function () {
                                autoSync(interval);
                            }, interval);
                        }
                    },
                    stateChange = function () {
                        if (selEncoding) {
                            changed().done(function (change) {
                                if (change) {
                                    selEncoding.attr('title', fm.i18n('saveAsEncoding')).addClass('elfinder-edit-changed');
                                } else {
                                    selEncoding.attr('title', fm.i18n('openAsEncoding')).removeClass('elfinder-edit-changed');
                                }
                            });
                        }
                    },
                    saveAsFile = {},
                    ta, old, dialogNode, selEncoding, extEditor, maxW, syncInterval;

                if (editor) {
                    if (editor.html) {
                        ta = $(editor.html);
                    }
                    extEditor = {
                        init: editor.init || null,
                        load: editor.load,
                        getContent: editor.getContent || null,
                        save: editor.save,
                        beforeclose: typeof editor.beforeclose == 'function' ? editor.beforeclose : void 0,
                        close: typeof editor.close == 'function' ? editor.close : function () { },
                        focus: typeof editor.focus == 'function' ? editor.focus : function () { },
                        resize: typeof editor.resize == 'function' ? editor.resize : function () { },
                        instance: null,
                        doSave: saveon,
                        doCancel: cancel,
                        doClose: savecl,
                        file: file,
                        fm: fm,
                        confObj: editor,
                        trigger: function (evName, data) {
                            fm.trigger('editEditor' + evName, Object.assign({}, editor.info || {}, data));
                        }
                    };
                }

                if (!ta) {
                    if (!fm.mimeIsText(file.mime)) {
                        return dfrd.reject('errEditorNotFound');
                    }
                    (function () {
                        ta = $('<textarea class="elfinder-file-edit" rows="20" id="' + id + '-ta"></textarea>')
                            .on('input propertychange', stateChange);

                        if (!editor || !editor.info || editor.info.useTextAreaEvent) {
                            ta.on('keydown', function (e) {
                                var code = e.keyCode,
                                    value, start;

                                e.stopPropagation();
                                if (code == $.ui.keyCode.TAB) {
                                    e.preventDefault();
                                    // insert tab on tab press
                                    if (this.setSelectionRange) {
                                        value = this.value;
                                        start = this.selectionStart;
                                        this.value = value.substr(0, start) + "\t" + value.substr(this.selectionEnd);
                                        start += 1;
                                        this.setSelectionRange(start, start);
                                    }
                                }

                                if (e.ctrlKey || e.metaKey) {
                                    // close on ctrl+w/q
                                    if (code == 'Q'.charCodeAt(0) || code == 'W'.charCodeAt(0)) {
                                        e.preventDefault();
                                        cancel();
                                    }
                                    if (code == 'S'.charCodeAt(0)) {
                                        e.preventDefault();
                                        saveon();
                                    }
                                }

                            })
                                .on('mouseenter', function () { this.focus(); });
                        }

                        ta.initEditArea = function (id, file, content) {
                            // ta.hide() for performance tune. Need ta.show() in `load()` if use textarea node.
                            ta.hide().val(content);
                            this._setupSelEncoding(content);
                        };
                    })();
                }

                // extended function to setup selector of encoding for text editor
                ta._setupSelEncoding = function (content) {
                    var heads = (encoding && encoding !== 'unknown') ? [{ value: encoding }] : [],
                        wfake = $('<select></select>').hide(),
                        setSelW = function (init) {
                            init && wfake.appendTo(selEncoding.parent());
                            wfake.empty().append($('<option></option>').text(selEncoding.val()));
                            selEncoding.width(wfake.width());
                        };
                    if (content === '' || !encoding || encoding !== 'UTF-8') {
                        heads.push({ value: 'UTF-8' });
                    }
                    selEncoding = getEncSelect(heads).on('touchstart', function (e) {
                        // for touch punch event handler
                        e.stopPropagation();
                    }).on('change', function () {
                        // reload to change encoding if not edited
                        changed().done(function (change) {
                            if (!change && getContent() !== '') {
                                cancel();
                                edit(file, selEncoding.val(), editor).fail(function (err) { err && fm.error(err); });
                            }
                        });
                        setSelW();
                    }).on('mouseover', stateChange);
                    ta.parent().next().prepend($('<div class="ui-dialog-buttonset elfinder-edit-extras"></div>').append(selEncoding));
                    setSelW(true);
                };

                ta.data('hash', file.hash);

                if (extEditor) {
                    ta.editor = extEditor;

                    if (typeof extEditor.beforeclose === 'function') {
                        opts.beforeclose = function () {
                            return extEditor.beforeclose(ta[0], extEditor.instance);
                        };
                    }

                    if (typeof extEditor.init === 'function') {
                        ta.initEditArea = extEditor.init;
                    }

                    if (typeof extEditor.getContent === 'function') {
                        ta.getContent = extEditor.getContent;
                    }
                }

                if (!ta.initEditArea) {
                    ta.initEditArea = function () { };
                }

                if (!ta.getContent) {
                    ta.getContent = function () {
                        return rtrim(ta.val());
                    };
                }

                if (!editor || !editor.info || !editor.info.preventGet) {
                    opts.buttons[fm.i18n('btnSave')] = saveon;
                    opts.buttons[fm.i18n('btnSaveClose')] = savecl;
                    opts.buttons[fm.i18n('btnSaveAs')] = saveAs;
                    opts.buttons[fm.i18n('btnCancel')] = cancel;
                }

                if (editor && typeof editor.prepare === 'function') {
                    editor.prepare(ta, opts, file);
                }

                dialogNode = self.fmDialog(ta, opts)
                    .attr('id', id)
                    .on('keydown keyup keypress', function (e) {
                        e.stopPropagation();
                    })
                    .css({ overflow: 'hidden', minHeight: '7em' })
                    .addClass('elfinder-edit-editor')
                    .closest('.ui-dialog')
                    .on('changeType', function (e, data) {
                        if (data.extention && data.mime) {
                            var ext = data.extention,
                                mime = data.mime,
                                btnSet = $(this).children('.ui-dialog-buttonpane').children('.ui-dialog-buttonset');
                            btnSet.children('.elfinder-btncnt-0,.elfinder-btncnt-1').hide();
                            saveAsFile.name = fm.splitFileExtention(file.name)[0] + '.' + data.extention;
                            saveAsFile.mime = data.mime;
                            if (!data.keepEditor) {
                                btnSet.children('.elfinder-btncnt-2').trigger('click');
                            }
                        }
                    });

                // care to viewport scale change with mobile devices
                maxW = (fm.options.dialogContained ? fm.getUI() : $(window)).width();
                (dialogNode.width() > maxW) && dialogNode.width(maxW);

                return dfrd.promise();
            },

            /**
             * Get file content and
             * open dialog with textarea to edit file content
             *
             * @param  String  file hash
             * @return jQuery.Deferred
             **/
            edit = function (file, convert, editor) {
                var hash = file.hash,
                    opts = fm.options,
                    dfrd = $.Deferred(),
                    id = 'edit-' + fm.namespace + '-' + file.hash,
                    d = fm.getUI().find('#' + id),
                    conv = !convert ? 0 : convert,
                    noContent = false,
                    req, error, res;


                if (d.length) {
                    d.elfinderdialog('toTop');
                    return dfrd.resolve();
                }

                if (!file.read || (!file.write && (!editor.info || !editor.info.converter))) {
                    error = ['errOpen', file.name, 'errPerm'];
                    return dfrd.reject(error);
                }

                if (editor && editor.info) {
                    if (typeof editor.info.edit === 'function') {
                        res = editor.info.edit.call(fm, file, editor);
                        if (res.promise) {
                            res.done(function () {
                                dfrd.resolve();
                            }).fail(function (error) {
                                dfrd.reject(error);
                            });
                        } else {
                            res ? dfrd.resolve() : dfrd.reject();
                        }
                        return dfrd;
                    }

                    noContent = editor.info.preventGet || editor.info.noContent;
                    if (editor.info.urlAsContent || noContent) {
                        req = $.Deferred();
                        if (editor.info.urlAsContent) {
                            fm.url(hash, { async: true, onetime: true, temporary: true }).done(function (url) {
                                req.resolve({ content: url });
                            });
                        } else {
                            req.resolve({});
                        }
                    } else {
                        if (conv) {
                            file.encoding = conv;
                            fm.cache(file, 'change');
                        }
                        req = fm.request({
                            data: { cmd: 'get', target: hash, conv: conv, _t: file.ts },
                            options: { type: 'get', cache: true },
                            notify: { type: 'file', cnt: 1 },
                            preventDefault: true
                        });
                    }

                    req.done(function (data) {
                        var selEncoding, reg, m, res;
                        if (data.doconv) {
                            fm.confirm({
                                title: self.title,
                                text: data.doconv === 'unknown' ? 'confirmNonUTF8' : 'confirmConvUTF8',
                                accept: {
                                    label: 'btnConv',
                                    callback: function () {
                                        dfrd = edit(file, selEncoding.val(), editor);
                                    }
                                },
                                cancel: {
                                    label: 'btnCancel',
                                    callback: function () { dfrd.reject(); }
                                },
                                optionsCallback: function (options) {
                                    options.create = function () {
                                        var base = $('<div class="elfinder-dialog-confirm-encoding"></div>'),
                                            head = { value: data.doconv },
                                            detected;

                                        if (data.doconv === 'unknown') {
                                            head.caption = '-';
                                        }
                                        selEncoding = getEncSelect([head]);
                                        $(this).next().find('.ui-dialog-buttonset')
                                            .prepend(base.append($('<label>' + fm.i18n('encoding') + ' </label>').append(selEncoding)));
                                    };
                                }
                            });
                        } else {
                            if (!noContent && fm.mimeIsText(file.mime)) {
                                reg = new RegExp('^(data:' + file.mime.replace(/([.+])/g, '\\$1') + ';base64,)', 'i');
                                if (!editor.info.dataScheme) {
                                    if (window.atob && (m = data.content.match(reg))) {
                                        data.content = atob(data.content.substr(m[1].length));
                                    }
                                } else {
                                    if (window.btoa && !data.content.match(reg)) {
                                        data.content = 'data:' + file.mime + ';base64,' + btoa(data.content);
                                    }
                                }
                            }
                            dialog(id, file, data.content, data.encoding, editor, data.toasts)
                                .done(function (data) {
                                    dfrd.resolve(data);
                                })
                                .progress(function (encoding, newHash, data, saveDfd) {
                                    var ta = this;
                                    if (newHash) {
                                        hash = newHash;
                                    }
                                    fm.request({
                                        options: { type: 'post' },
                                        data: {
                                            cmd: 'put',
                                            target: hash,
                                            encoding: encoding || data.encoding,
                                            content: data
                                        },
                                        notify: { type: 'save', cnt: 1 },
                                        syncOnFail: true,
                                        preventFail: true,
                                        navigate: {
                                            target: 'changed',
                                            toast: {
                                                inbuffer: { msg: fm.i18n(['complete', fm.i18n('btnSave')]) }
                                            }
                                        }
                                    })
                                        .fail(function (error) {
                                            dfrd.reject(error);
                                            saveDfd.reject();
                                        })
                                        .done(function (data) {
                                            requestAnimationFrame(function () {
                                                ta.trigger('focus');
                                                ta.editor && ta.editor.focus(ta[0], ta.editor.instance);
                                            });
                                            saveDfd.resolve();
                                        });
                                })
                                .fail(function (error) {
                                    dfrd.reject(error);
                                });
                        }
                    })
                        .fail(function (error) {
                            var err = fm.parseError(error);
                            err = Array.isArray(err) ? err[0] : err;
                            if (file.encoding) {
                                file.encoding = '';
                                fm.cache(file, 'change');
                            }
                            (err !== 'errConvUTF8') && fm.sync();
                            dfrd.reject(error);
                        });
                }

                return dfrd.promise();
            },

            /**
             * Current editors of selected files
             * 
             * @type Object
             */
            editors = {},

            /**
             * Fallback editor (Simple text editor)
             * 
             * @type Object
             */
            fallbackEditor = {
                // Simple Text (basic textarea editor)
                info: {
                    id: 'textarea',
                    name: 'TextArea',
                    useTextAreaEvent: true
                },
                load: function (textarea) {
                    // trigger event 'editEditorPrepare'
                    this.trigger('Prepare', {
                        node: textarea,
                        editorObj: void (0),
                        instance: void (0),
                        opts: {}
                    });
                    textarea.setSelectionRange && textarea.setSelectionRange(0, 0);
                    $(textarea).trigger('focus').show();
                },
                save: function () { }
            },

            /**
             * Set current editors
             * 
             * @param  Object  file object
             * @param  Number  cnt  count of selected items
             * @return Void
             */
            setEditors = function (file, cnt) {
                var mimeMatch = function (fileMime, editorMimes) {
                    if (!editorMimes) {
                        return fm.mimeIsText(fileMime);
                    } else {
                        if (editorMimes[0] === '*' || $.inArray(fileMime, editorMimes) !== -1) {
                            return true;
                        }
                        var i, l;
                        l = editorMimes.length;
                        for (i = 0; i < l; i++) {
                            if (fileMime.indexOf(editorMimes[i]) === 0) {
                                return true;
                            }
                        }
                        return false;
                    }
                },
                    extMatch = function (fileName, editorExts) {
                        if (!editorExts || !editorExts.length) {
                            return true;
                        }
                        var ext = fileName.replace(/^.+\.([^.]+)|(.+)$/, '$1$2').toLowerCase(),
                            i, l;
                        l = editorExts.length;
                        for (i = 0; i < l; i++) {
                            if (ext === editorExts[i].toLowerCase()) {
                                return true;
                            }
                        }
                        return false;
                    },
                    optEditors = self.options.editors || [],
                    cwdWrite = fm.cwd().write;

                stored = fm.storage('storedEditors') || {};
                editors = {};
                if (!optEditors.length) {
                    optEditors = [fallbackEditor];
                }
                $.each(optEditors, function (i, editor) {
                    var name;
                    if ((cnt === 1 || !editor.info.single)
                        && ((!editor.info || !editor.info.converter) ? file.write : cwdWrite)
                        && (file.size > 0 || (!editor.info.converter && editor.info.canMakeEmpty !== false && fm.mimesCanMakeEmpty[file.mime]))
                        && (!editor.info.maxSize || file.size <= editor.info.maxSize)
                        && mimeMatch(file.mime, editor.mimes || null)
                        && extMatch(file.name, editor.exts || null)
                        && typeof editor.load == 'function'
                        && typeof editor.save == 'function') {

                        name = editor.info.name ? editor.info.name : ('Editor ' + i);
                        editor.id = editor.info.id ? editor.info.id : ('editor' + i),
                            editor.name = name;
                        editor.i18n = fm.i18n(name);
                        editors[editor.id] = editor;
                    }
                });
                return Object.keys(editors).length ? true : false;
            },
            store = function (mime, editor) {
                if (mime && editor) {
                    if (!$.isPlainObject(stored)) {
                        stored = {};
                    }
                    stored[mime] = editor.id;
                    fm.storage('storedEditors', stored);
                    fm.trigger('selectfiles', { files: fm.selected() });
                }
            },
            useStoredEditor = function () {
                var d = fm.storage('useStoredEditor');
                return d ? (d > 0) : self.options.useStoredEditor;
            },
            editorMaximized = function () {
                var d = fm.storage('editorMaximized');
                return d ? (d > 0) : self.options.editorMaximized;
            },
            getSubMenuRaw = function (files, callback) {
                var subMenuRaw = [];
                $.each(editors, function (id, ed) {
                    subMenuRaw.push(
                        {
                            label: fm.escape(ed.i18n),
                            icon: ed.info && ed.info.icon ? ed.info.icon : 'edit',
                            options: { iconImg: ed.info && ed.info.iconImg ? fm.baseUrl + ed.info.iconImg : void (0) },
                            callback: function () {
                                store(files[0].mime, ed);
                                callback && callback.call(ed);
                            }
                        }
                    );
                });
                return subMenuRaw;
            },
            getStoreId = function (name) {
                // for compatibility to previous version
                return name.toLowerCase().replace(/ +/g, '');
            },
            getStoredEditor = function (mime) {
                var name = stored[mime];
                return name && Object.keys(editors).length ? editors[getStoreId(name)] : void (0);
            },
            infoRequest = function () {

            },
            stored;

        // make public method
        this.getEncSelect = getEncSelect;

        this.shortcuts = [{
            pattern: 'ctrl+e'
        }];

        this.init = function () {
            var self = this,
                fm = this.fm,
                opts = this.options,
                cmdChecks = [],
                ccData, dfd;

            this.onlyMimes = this.options.mimes || [];

            fm.one('open', function () {
                // editors setup
                if (opts.editors && Array.isArray(opts.editors)) {
                    fm.trigger('canMakeEmptyFile', { mimes: Object.keys(fm.storage('mkfileTextMimes') || {}).concat(opts.makeTextMimes || ['text/plain']) });
                    $.each(opts.editors, function (i, editor) {
                        if (editor.info && editor.info.cmdCheck) {
                            cmdChecks.push(editor.info.cmdCheck);
                        }
                    });
                    if (cmdChecks.length) {
                        if (fm.api >= 2.1030) {
                            dfd = fm.request({
                                data: {
                                    cmd: 'editor',
                                    name: cmdChecks,
                                    method: 'enabled'
                                },
                                preventDefault: true
                            }).done(function (d) {
                                ccData = d;
                            }).fail(function () {
                                ccData = {};
                            });
                        } else {
                            ccData = {};
                            dfd = $.Deferred().resolve();
                        }
                    } else {
                        dfd = $.Deferred().resolve();
                    }

                    dfd.always(function () {
                        if (ccData) {
                            opts.editors = $.grep(opts.editors, function (e) {
                                if (e.info && e.info.cmdCheck) {
                                    return ccData[e.info.cmdCheck] ? true : false;
                                } else {
                                    return true;
                                }
                            });
                        }
                        $.each(opts.editors, function (i, editor) {
                            if (editor.setup && typeof editor.setup === 'function') {
                                editor.setup.call(editor, opts, fm);
                            }
                            if (!editor.disabled) {
                                if (editor.mimes && Array.isArray(editor.mimes)) {
                                    mimesSingle = mimesSingle.concat(editor.mimes);
                                    if (!editor.info || !editor.info.single) {
                                        mimes = mimes.concat(editor.mimes);
                                    }
                                }
                                if (!allowAll && editor.mimes && editor.mimes[0] === '*') {
                                    allowAll = true;
                                }
                                if (!editor.info) {
                                    editor.info = {};
                                }
                                if (editor.info.integrate) {
                                    fm.trigger('helpIntegration', Object.assign({ cmd: 'edit' }, editor.info.integrate));
                                }
                                if (editor.info.canMakeEmpty) {
                                    fm.trigger('canMakeEmptyFile', { mimes: Array.isArray(editor.info.canMakeEmpty) ? editor.info.canMakeEmpty : editor.mimes });
                                }
                            }
                        });

                        mimesSingle = ($.uniqueSort || $.unique)(mimesSingle);
                        mimes = ($.uniqueSort || $.unique)(mimes);

                        opts.editors = $.grep(opts.editors, function (e) {
                            return e.disabled ? false : true;
                        });
                    });
                }
            })
                .bind('select', function () {
                    editors = null;
                })
                .bind('contextmenucreate', function (e) {
                    var file, editor,
                        single = function (editor) {
                            var title = self.title;
                            fm.one('contextmenucreatedone', function () {
                                self.title = title;
                            });
                            self.title = fm.escape(editor.i18n);
                            if (editor.info && editor.info.iconImg) {
                                self.contextmenuOpts = {
                                    iconImg: fm.baseUrl + editor.info.iconImg
                                };
                            }
                            delete self.variants;
                        };

                    self.contextmenuOpts = void (0);
                    if (e.data.type === 'files' && self.enabled()) {
                        file = fm.file(e.data.targets[0]);
                        if (setEditors(file, e.data.targets.length)) {
                            if (Object.keys(editors).length > 1) {
                                if (!useStoredEditor() || !(editor = getStoredEditor(file.mime))) {
                                    delete self.extra;
                                    self.variants = [];
                                    $.each(editors, function (id, editor) {
                                        self.variants.push([{ editor: editor }, editor.i18n, editor.info && editor.info.iconImg ? fm.baseUrl + editor.info.iconImg : 'edit']);
                                    });
                                } else {
                                    single(editor);
                                    self.extra = {
                                        icon: 'menu',
                                        node: $('<span></span>')
                                            .attr({ title: fm.i18n('select') })
                                            .on('click touchstart', function (e) {
                                                if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                                                    return;
                                                }
                                                var node = $(this);
                                                e.stopPropagation();
                                                e.preventDefault();
                                                fm.trigger('contextmenu', {
                                                    raw: getSubMenuRaw(fm.selectedFiles(), function () {
                                                        var hashes = fm.selected();
                                                        fm.exec('edit', hashes, { editor: this });
                                                        fm.trigger('selectfiles', { files: hashes });
                                                    }),
                                                    x: node.offset().left,
                                                    y: node.offset().top
                                                });
                                            })
                                    };
                                }
                            } else {
                                single(editors[Object.keys(editors)[0]]);
                                delete self.extra;
                            }
                        }
                    }
                })
                .bind('canMakeEmptyFile', function (e) {
                    if (e.data && e.data.resetTexts) {
                        var defs = fm.arrayFlip(self.options.makeTextMimes || ['text/plain']),
                            hides = self.getMkfileHides();

                        $.each((fm.storage('mkfileTextMimes') || {}), function (mime, type) {
                            if (!defs[mime]) {
                                delete fm.mimesCanMakeEmpty[mime];
                                delete hides[mime];
                            }
                        });
                        fm.storage('mkfileTextMimes', null);
                        if (Object.keys(hides).length) {
                            fm.storage('mkfileHides', hides);
                        } else {
                            fm.storage('mkfileHides', null);
                        }
                    }
                });
        };

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length;

            return cnt && filter(sel).length == cnt ? 0 : -1;
        };

        this.exec = function (select, opts) {
            var fm = this.fm,
                files = filter(this.files(select)),
                hashes = $.map(files, function (f) { return f.hash; }),
                list = [],
                editor = opts && opts.editor ? opts.editor : null,
                node = $(opts && opts._currentNode ? opts._currentNode : fm.cwdHash2Elm(hashes[0])),
                getEditor = function () {
                    var dfd = $.Deferred(),
                        storedId;

                    if (!editor && Object.keys(editors).length > 1) {
                        if (useStoredEditor() && (editor = getStoredEditor(files[0].mime))) {
                            return dfd.resolve(editor);
                        }
                        fm.trigger('contextmenu', {
                            raw: getSubMenuRaw(files, function () {
                                dfd.resolve(this);
                            }),
                            x: node.offset().left,
                            y: node.offset().top + 22,
                            opened: function () {
                                fm.one('closecontextmenu', function () {
                                    requestAnimationFrame(function () {
                                        if (dfd.state() === 'pending') {
                                            dfd.reject();
                                        }
                                    });
                                });
                            }
                        });

                        fm.trigger('selectfiles', { files: hashes });

                        return dfd;
                    } else {
                        Object.keys(editors).length > 1 && editor && store(files[0].mime, editor);
                        return dfd.resolve(editor ? editor : (Object.keys(editors).length ? editors[Object.keys(editors)[0]] : null));
                    }
                },
                dfrd = $.Deferred(),
                file;

            if (editors === null) {
                setEditors(files[0], hashes.length);
            }

            if (!node.length) {
                node = fm.getUI('cwd');
            }

            getEditor().done(function (editor) {
                while ((file = files.shift())) {
                    list.push(edit(file, (file.encoding || void (0)), editor).fail(function (error) {
                        error && fm.error(error);
                    }));
                }

                if (list.length) {
                    $.when.apply(null, list).done(function () {
                        dfrd.resolve();
                    }).fail(function () {
                        dfrd.reject();
                    });
                } else {
                    dfrd.reject();
                }
            }).fail(function () {
                dfrd.reject();
            });

            return dfrd;
        };

        this.getMkfileHides = function () {
            return fm.storage('mkfileHides') || fm.arrayFlip(self.options.mkfileHideMimes || []);
        };

    };


    /*
     * File: /js/commands/empty.js
     */

    /**
     * @class elFinder command "empty".
     * Empty the folder
     *
     * @type  elFinder.command
     * @author  Naoki Sawada
     */
    elFinder.prototype.commands.empty = function () {
        var self, fm,
            selFiles = function (select) {
                var sel = self.files(select);
                if (!sel.length) {
                    sel = [fm.cwd()];
                }
                return sel;
            };

        this.linkedCmds = ['rm'];

        this.init = function () {
            // lazy assign to make possible to become superclass
            self = this;
            fm = this.fm;
        };

        this.getstate = function (select) {
            var sel = selFiles(select),
                cnt,
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (f) {
                        fres = fres && f.read && f.write && f.mime === 'directory' ? true : false;
                        return fres;
                    });
                };

            cnt = sel.length;
            return filter(sel).length == cnt ? 0 : -1;
        };

        this.exec = function (hashes) {
            var dirs = selFiles(hashes),
                cnt = dirs.length,
                dfrd = $.Deferred()
                    .done(function () {
                        var data = { changed: {} };
                        fm.toast({ msg: fm.i18n(['"' + success.join('", ') + '"', 'complete', fm.i18n('cmdempty')]) });
                        $.each(dirs, function (i, dir) {
                            data.changed[dir.hash] = dir;
                        });
                        fm.change(data);
                    })
                    .always(function () {
                        var cwd = fm.cwd().hash;
                        fm.trigger('selectfiles', { files: $.map(dirs, function (d) { return cwd === d.phash ? d.hash : null; }) });
                    }),
                success = [],
                done = function (res) {
                    if (typeof res === 'number') {
                        success.push(dirs[res].name);
                        delete dirs[res].dirs;
                    } else {
                        res && fm.error(res);
                    }
                    (--cnt < 1) && dfrd[success.length ? 'resolve' : 'reject']();
                };

            $.each(dirs, function (i, dir) {
                var tm;
                if (!(dir.write && dir.mime === 'directory')) {
                    done(['errEmpty', dir.name, 'errPerm']);
                    return null;
                }
                if (!fm.isCommandEnabled('rm', dir.hash)) {
                    done(['errCmdNoSupport', '"rm"']);
                    return null;
                }
                tm = setTimeout(function () {
                    fm.notify({ type: 'search', cnt: 1, hideCnt: cnt > 1 ? false : true });
                }, fm.notifyDelay);
                fm.request({
                    data: { cmd: 'open', target: dir.hash },
                    preventDefault: true,
                    asNotOpen: true
                }).done(function (data) {
                    var targets = [];
                    tm && clearTimeout(tm);
                    if (fm.ui.notify.children('.elfinder-notify-search').length) {
                        fm.notify({ type: 'search', cnt: -1, hideCnt: cnt > 1 ? false : true });
                    }
                    if (data && data.files && data.files.length) {
                        if (data.files.length > fm.maxTargets) {
                            done(['errEmpty', dir.name, 'errMaxTargets', fm.maxTargets]);
                        } else {
                            fm.updateCache(data);
                            $.each(data.files, function (i, f) {
                                if (!f.write || f.locked) {
                                    done(['errEmpty', dir.name, 'errRm', f.name, 'errPerm']);
                                    targets = [];
                                    return false;
                                }
                                targets.push(f.hash);
                            });
                            if (targets.length) {
                                fm.exec('rm', targets, { _userAction: true, addTexts: [fm.i18n('folderToEmpty', dir.name)] })
                                    .fail(function (error) {
                                        fm.trigger('unselectfiles', { files: fm.selected() });
                                        done(fm.parseError(error) || '');
                                    })
                                    .done(function () { done(i); });
                            }
                        }
                    } else {
                        fm.toast({ mode: 'warning', msg: fm.i18n('filderIsEmpty', dir.name) });
                        done('');
                    }
                }).fail(function (error) {
                    done(fm.parseError(error) || '');
                });
            });

            return dfrd;
        };

    };


    /*
     * File: /js/commands/extract.js
     */

    /**
     * @class  elFinder command "extract"
     * Extract files from archive
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.extract = function () {
        var self = this,
            fm = self.fm,
            mimes = [],
            filter = function (files) {
                var fres = true;
                return $.grep(files, function (file) {
                    fres = fres && file.read && $.inArray(file.mime, mimes) !== -1 ? true : false;
                    return fres;
                });
            };

        this.variants = [];
        this.disableOnSearch = true;

        // Update mimes list on open/reload
        fm.bind('open reload', function () {
            mimes = fm.option('archivers')['extract'] || [];
            if (fm.api > 2) {
                self.variants = [[{ makedir: true }, fm.i18n('cmdmkdir')], [{}, fm.i18n('btnCwd')]];
            } else {
                self.variants = [[{}, fm.i18n('btnCwd')]];
            }
            self.change();
        });

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                cwdHash, cwdChk;
            if (!cnt || filter(sel).length != cnt) {
                return -1;
            } else if (fm.searchStatus.state > 0) {
                cwdHash = this.fm.cwd().hash;
                $.each(sel, function (i, file) {
                    cwdChk = (file.phash === cwdHash);
                    return cwdChk;
                });
                return cwdChk ? 0 : -1;
            } else {
                return this.fm.cwd().write ? 0 : -1;
            }
        };

        this.exec = function (hashes, opts) {
            var files = this.files(hashes),
                dfrd = $.Deferred(),
                cnt = files.length,
                makedir = opts && opts.makedir ? 1 : 0,
                i, error,
                decision,

                overwriteAll = false,
                omitAll = false,
                mkdirAll = 0,
                siblings = fm.files(files[0].phash),

                names = [],
                map = {};

            $.each(siblings, function (id, file) {
                map[file.name] = file;
                names.push(file.name);
            });

            var decide = function (decision) {
                switch (decision) {
                    case 'overwrite_all':
                        overwriteAll = true;
                        break;
                    case 'omit_all':
                        omitAll = true;
                        break;
                }
            };

            var unpack = function (file) {
                if (!(file.read && fm.file(file.phash).write)) {
                    error = ['errExtract', file.name, 'errPerm'];
                    fm.error(error);
                    dfrd.reject(error);
                } else if ($.inArray(file.mime, mimes) === -1) {
                    error = ['errExtract', file.name, 'errNoArchive'];
                    fm.error(error);
                    dfrd.reject(error);
                } else {
                    fm.request({
                        data: { cmd: 'extract', target: file.hash, makedir: makedir },
                        notify: { type: 'extract', cnt: 1 },
                        syncOnFail: true,
                        navigate: {
                            toast: makedir ? {
                                incwd: { msg: fm.i18n(['complete', fm.i18n('cmdextract')]), action: { cmd: 'open', msg: 'cmdopen' } },
                                inbuffer: { msg: fm.i18n(['complete', fm.i18n('cmdextract')]), action: { cmd: 'open', msg: 'cmdopen' } }
                            } : {
                                inbuffer: { msg: fm.i18n(['complete', fm.i18n('cmdextract')]) }
                            }
                        }
                    })
                        .fail(function (error) {
                            if (dfrd.state() != 'rejected') {
                                dfrd.reject(error);
                            }
                        })
                        .done(function () {
                        });
                }
            };

            var confirm = function (files, index) {
                var file = files[index],
                    name = fm.splitFileExtention(file.name)[0],
                    existed = ($.inArray(name, names) >= 0),
                    next = function () {
                        if ((index + 1) < cnt) {
                            confirm(files, index + 1);
                        } else {
                            dfrd.resolve();
                        }
                    };
                if (!makedir && existed && map[name].mime != 'directory') {
                    fm.confirm(
                        {
                            title: fm.i18n('ntfextract'),
                            text: ['errExists', name, 'confirmRepl'],
                            accept: {
                                label: 'btnYes',
                                callback: function (all) {
                                    decision = all ? 'overwrite_all' : 'overwrite';
                                    decide(decision);
                                    if (!overwriteAll && !omitAll) {
                                        if ('overwrite' == decision) {
                                            unpack(file);
                                        }
                                        if ((index + 1) < cnt) {
                                            confirm(files, index + 1);
                                        } else {
                                            dfrd.resolve();
                                        }
                                    } else if (overwriteAll) {
                                        for (i = index; i < cnt; i++) {
                                            unpack(files[i]);
                                        }
                                        dfrd.resolve();
                                    }
                                }
                            },
                            reject: {
                                label: 'btnNo',
                                callback: function (all) {
                                    decision = all ? 'omit_all' : 'omit';
                                    decide(decision);
                                    if (!overwriteAll && !omitAll && (index + 1) < cnt) {
                                        confirm(files, index + 1);
                                    } else if (omitAll) {
                                        dfrd.resolve();
                                    }
                                }
                            },
                            cancel: {
                                label: 'btnCancel',
                                callback: function () {
                                    dfrd.resolve();
                                }
                            },
                            all: ((index + 1) < cnt)
                        }
                    );
                } else if (!makedir) {
                    if (mkdirAll == 0) {
                        fm.confirm({
                            title: fm.i18n('cmdextract'),
                            text: [fm.i18n('cmdextract') + ' "' + file.name + '"', 'confirmRepl'],
                            accept: {
                                label: 'btnYes',
                                callback: function (all) {
                                    all && (mkdirAll = 1);
                                    unpack(file);
                                    next();
                                }
                            },
                            reject: {
                                label: 'btnNo',
                                callback: function (all) {
                                    all && (mkdirAll = -1);
                                    next();
                                }
                            },
                            cancel: {
                                label: 'btnCancel',
                                callback: function () {
                                    dfrd.resolve();
                                }
                            },
                            all: ((index + 1) < cnt)
                        });
                    } else {
                        (mkdirAll > 0) && unpack(file);
                        next();
                    }
                } else {
                    unpack(file);
                    next();
                }
            };

            if (!(this.enabled() && cnt && mimes.length)) {
                return dfrd.reject();
            }

            if (cnt > 0) {
                confirm(files, 0);
            }

            return dfrd;
        };

    };


    /*
     * File: /js/commands/forward.js
     */

    /**
     * @class  elFinder command "forward"
     * Open next visited folder
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.forward = function () {
        this.alwaysEnabled = true;
        this.updateOnSelect = true;
        this.shortcuts = [{
            pattern: 'ctrl+right'
        }];

        this.getstate = function () {
            return this.fm.history.canForward() ? 0 : -1;
        };

        this.exec = function () {
            return this.fm.history.forward();
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/fullscreen.js
     */

    /**
     * @class  elFinder command "fullscreen"
     * elFinder node to full scrren mode
     *
     * @author Naoki Sawada
     **/

    elFinder.prototype.commands.fullscreen = function () {
        var self = this,
            fm = this.fm,
            update = function (e, data) {
                var full;
                e.preventDefault();
                e.stopPropagation();
                if (data && data.fullscreen) {
                    full = (data.fullscreen === 'on');
                    self.update(void (0), full);
                    self.title = fm.i18n(full ? 'reinstate' : 'cmdfullscreen');
                }
            };

        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.syncTitleOnChange = true;
        this.value = false;

        this.options = {
            ui: 'fullscreenbutton'
        };

        this.getstate = function () {
            return 0;
        };

        this.exec = function () {
            var node = fm.getUI().get(0),
                full = (node === fm.toggleFullscreen(node));
            self.title = fm.i18n(full ? 'reinstate' : 'cmdfullscreen');
            self.update(void (0), full);
            return $.Deferred().resolve();
        };

        fm.bind('init', function () {
            fm.getUI().off('resize.' + fm.namespace, update).on('resize.' + fm.namespace, update);
        });
    };


    /*
     * File: /js/commands/getfile.js
     */

    /**
     * @class elFinder command "getfile". 
     * Return selected files info into outer callback.
     * For use elFinder with wysiwyg editors etc.
     *
     * @author Dmitry (dio) Levashov, dio@std42.ru
     **/
    (elFinder.prototype.commands.getfile = function () {
        var self = this,
            fm = this.fm,
            filter = function (files) {
                var o = self.options,
                    fres = true;

                files = $.grep(files, function (file) {
                    fres = fres && (file.mime != 'directory' || o.folders) && file.read ? true : false;
                    return fres;
                });

                return o.multiple || files.length == 1 ? files : [];
            };

        this.alwaysEnabled = true;
        this.callback = fm.options.getFileCallback;
        this._disabled = typeof (this.callback) == 'function';

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length;

            return this.callback && cnt && filter(sel).length == cnt ? 0 : -1;
        };

        this.exec = function (hashes) {
            var fm = this.fm,
                opts = this.options,
                files = this.files(hashes),
                cnt = files.length,
                url = fm.option('url'),
                tmb = fm.option('tmbUrl'),
                dfrd = $.Deferred()
                    .done(function (data) {
                        var res,
                            done = function () {
                                if (opts.oncomplete == 'close') {
                                    fm.hide();
                                } else if (opts.oncomplete == 'destroy') {
                                    fm.destroy();
                                }
                            },
                            fail = function (error) {
                                if (opts.onerror == 'close') {
                                    fm.hide();
                                } else if (opts.onerror == 'destroy') {
                                    fm.destroy();
                                } else {
                                    error && fm.error(error);
                                }
                            };

                        fm.trigger('getfile', { files: data });

                        try {
                            res = self.callback(data, fm);
                        } catch (e) {
                            fail(['Error in `getFileCallback`.', e.message]);
                            return;
                        }

                        if (typeof res === 'object' && typeof res.done === 'function') {
                            res.done(done).fail(fail);
                        } else {
                            done();
                        }
                    }),
                result = function (file) {
                    return opts.onlyURL
                        ? opts.multiple ? $.map(files, function (f) { return f.url; }) : files[0].url
                        : opts.multiple ? files : files[0];
                },
                req = [],
                i, file, dim;

            for (i = 0; i < cnt; i++) {
                file = files[i];
                if (file.mime == 'directory' && !opts.folders) {
                    return dfrd.reject();
                }
                file.baseUrl = url;
                if (file.url == '1') {
                    req.push(fm.request({
                        data: { cmd: 'url', target: file.hash },
                        notify: { type: 'url', cnt: 1, hideCnt: true },
                        preventDefault: true
                    })
                        .done(function (data) {
                            if (data.url) {
                                var rfile = fm.file(this.hash);
                                rfile.url = this.url = data.url;
                            }
                        }.bind(file)));
                } else {
                    file.url = fm.url(file.hash);
                }
                if (!opts.onlyURL) {
                    if (opts.getPath) {
                        file.path = fm.path(file.hash);
                        if (file.path === '' && file.phash) {
                            // get parents
                            (function () {
                                var dfd = $.Deferred();
                                req.push(dfd);
                                fm.path(file.hash, false, {})
                                    .done(function (path) {
                                        file.path = path;
                                    })
                                    .fail(function () {
                                        file.path = '';
                                    })
                                    .always(function () {
                                        dfd.resolve();
                                    });
                            })();
                        }
                    }
                    if (file.tmb && file.tmb != 1) {
                        file.tmb = tmb + file.tmb;
                    }
                    if (!file.width && !file.height) {
                        if (file.dim) {
                            dim = file.dim.split('x');
                            file.width = dim[0];
                            file.height = dim[1];
                        } else if (opts.getImgSize && file.mime.indexOf('image') !== -1) {
                            req.push(fm.request({
                                data: { cmd: 'dim', target: file.hash },
                                notify: { type: 'dim', cnt: 1, hideCnt: true },
                                preventDefault: true
                            })
                                .done(function (data) {
                                    if (data.dim) {
                                        var dim = data.dim.split('x');
                                        var rfile = fm.file(this.hash);
                                        rfile.width = this.width = dim[0];
                                        rfile.height = this.height = dim[1];
                                    }
                                }.bind(file)));
                        }
                    }
                }
            }

            if (req.length) {
                $.when.apply(null, req).always(function () {
                    dfrd.resolve(result(files));
                });
                return dfrd;
            }

            return dfrd.resolve(result(files));
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/help.js
     */

    /**
     * @class  elFinder command "help"
     * "About" dialog
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.help = function () {
        var fm = this.fm,
            self = this,
            linktpl = '<div class="elfinder-help-link"> <a href="{url}">{link}</a></div>',
            linktpltgt = '<div class="elfinder-help-link"> <a href="{url}" target="_blank">{link}</a></div>',
            atpl = '<div class="elfinder-help-team"><div>{author}</div>{work}</div>',
            url = /\{url\}/,
            link = /\{link\}/,
            author = /\{author\}/,
            work = /\{work\}/,
            r = 'replace',
            prim = 'ui-priority-primary',
            sec = 'ui-priority-secondary',
            lic = 'elfinder-help-license',
            tab = '<li class="' + fm.res('class', 'tabstab') + ' elfinder-help-tab-{id}"><a href="#' + fm.namespace + '-help-{id}" class="ui-tabs-anchor">{title}</a></li>',
            html = ['<div class="ui-tabs ui-widget ui-widget-content ui-corner-all elfinder-help">',
                '<ul class="ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-top">'],
            stpl = '<div class="elfinder-help-shortcut"><div class="elfinder-help-shortcut-pattern">{pattern}</div> {descrip}</div>',
            sep = '<div class="elfinder-help-separator"></div>',
            selfUrl = $('base').length ? fm.escape(document.location.href.replace(/#.*$/, '')) : '',
            clTabActive = fm.res('class', 'tabsactive'),

            getTheme = function () {
                var src;
                if (fm.theme && fm.theme.author) {
                    src = atpl[r]('elfinder-help-team', 'elfinder-help-team elfinder-help-term-theme')[r](author, fm.i18n(fm.theme.author) + (fm.theme.email ? ' &lt;' + fm.theme.email + '&gt;' : ''))[r](work, fm.i18n('theme') + ' (' + fm.i18n(fm.theme.name) + ')');
                } else {
                    src = '<div class="elfinder-help-team elfinder-help-term-theme" style="display:none"></div>';
                }
                return src;
            },

            about = function () {
                html.push('<div id="' + fm.namespace + '-help-about" class="ui-tabs-panel ui-widget-content ui-corner-bottom"><div class="elfinder-help-logo"></div>');
                html.push('<h3>elFinder</h3>');
                html.push('<div class="' + prim + '">' + fm.i18n('webfm') + '</div>');
                html.push('<div class="' + sec + '">' + fm.i18n('ver') + ': ' + fm.version + '</div>');
                html.push('<div class="' + sec + '">' + fm.i18n('protocolver') + ': <span class="apiver"></span></div>');
                html.push('<div class="' + sec + '">jQuery/jQuery UI: ' + $().jquery + '/' + $.ui.version + '</div>');

                html.push(sep);

                html.push(linktpltgt[r](url, 'https://studio-42.github.io/elFinder/')[r](link, fm.i18n('homepage')));
                html.push(linktpltgt[r](url, 'https://github.com/Studio-42/elFinder/wiki')[r](link, fm.i18n('docs')));
                html.push(linktpltgt[r](url, 'https://github.com/Studio-42/elFinder')[r](link, fm.i18n('github')));
                //html.push(linktpltgt[r](url, 'http://twitter.com/elrte_elfinder')[r](link, fm.i18n('twitter')));

                html.push(sep);

                html.push('<div class="' + prim + '">' + fm.i18n('team') + '</div>');

                html.push(atpl[r](author, 'Dmitry "dio" Levashov &lt;dio@std42.ru&gt;')[r](work, fm.i18n('chiefdev')));
                html.push(atpl[r](author, 'Naoki Sawada (nao-pon)&lt;hypweb+elfinder@gmail.com&gt;')[r](work, fm.i18n('developer')));
                html.push(atpl[r](author, 'Troex Nevelin &lt;troex@fury.scancode.ru&gt;')[r](work, fm.i18n('maintainer')));
                html.push(atpl[r](author, 'Alexey Sukhotin &lt;strogg@yandex.ru&gt;')[r](work, fm.i18n('contributor')));

                if (fm.i18[fm.lang].translator) {
                    $.each(fm.i18[fm.lang].translator.split(', '), function () {
                        html.push(atpl[r](author, $.trim(this))[r](work, fm.i18n('translator') + ' (' + fm.i18[fm.lang].language + ')'));
                    });
                }

                html.push(getTheme());

                html.push(sep);
                html.push('<div class="' + lic + '">' + fm.i18n('icons') + ': Pixelmixer, <a href="http://p.yusukekamiyamane.com" target="_blank">Fugue</a>, <a href="https://icons8.com" target="_blank">Icons8</a></div>');

                html.push(sep);
                html.push('<div class="' + lic + '">Licence: 3-clauses BSD Licence</div>');
                html.push('<div class="' + lic + '">Copyright © 2009-2024, Studio 42 / nao-pon</div>');
                html.push('<div class="' + lic + '">„ …' + fm.i18n('dontforget') + ' ”</div>');
                html.push('</div>');
            },
            shortcuts = function () {
                var sh = fm.shortcuts();
                // shortcuts tab
                html.push('<div id="' + fm.namespace + '-help-shortcuts" class="ui-tabs-panel ui-widget-content ui-corner-bottom">');

                if (sh.length) {
                    html.push('<div class="ui-widget-content elfinder-help-shortcuts">');
                    $.each(sh, function (i, s) {
                        html.push(stpl.replace(/\{pattern\}/, s[0]).replace(/\{descrip\}/, s[1]));
                    });

                    html.push('</div>');
                } else {
                    html.push('<div class="elfinder-help-disabled">' + fm.i18n('shortcutsof') + '</div>');
                }


                html.push('</div>');

            },
            help = function () {
                // help tab
                html.push('<div id="' + fm.namespace + '-help-help" class="ui-tabs-panel ui-widget-content ui-corner-bottom">');
                html.push('<a href="https://github.com/Studio-42/elFinder/wiki" target="_blank" class="elfinder-dont-panic"><span>DON\'T PANIC</span></a>');
                html.push('</div>');
                // end help
            },
            useInteg = false,
            integrations = function () {
                useInteg = true;
                html.push('<div id="' + fm.namespace + '-help-integrations" class="ui-tabs-panel ui-widget-content ui-corner-bottom"></div>');
            },
            useDebug = false,
            debug = function () {
                useDebug = true;
                // debug tab
                html.push('<div id="' + fm.namespace + '-help-debug" class="ui-tabs-panel ui-widget-content ui-corner-bottom">');
                html.push('<div class="ui-widget-content elfinder-help-debug"><ul></ul></div>');
                html.push('</div>');
                // end debug
            },
            debugRender = function () {
                var render = function (elm, obj) {
                    $.each(obj, function (k, v) {
                        elm.append($('<dt></dt>').text(k));
                        if (typeof v === 'undefined') {
                            elm.append($('<dd></dd>').append($('<span></span>').text('undfined')));
                        } else if (typeof v === 'object' && !v) {
                            elm.append($('<dd></dd>').append($('<span></span>').text('null')));
                        } else if (typeof v === 'object' && ($.isPlainObject(v) || v.length)) {
                            elm.append($('<dd></dd>').append(render($('<dl></dl>'), v)));
                        } else {
                            elm.append($('<dd></dd>').append($('<span></span>').text((v && typeof v === 'object') ? '[]' : (v ? v : '""'))));
                        }
                    });
                    return elm;
                },
                    cnt = debugUL.children('li').length,
                    targetL, target, tabId,
                    info, lastUL, lastDIV;

                if (self.debug.options || self.debug.debug) {
                    if (cnt >= 5) {
                        lastUL = debugUL.children('li:last');
                        lastDIV = debugDIV.children('div:last');
                        if (lastDIV.is(':hidden')) {
                            lastUL.remove();
                            lastDIV.remove();
                        } else {
                            lastUL.prev().remove();
                            lastDIV.prev().remove();
                        }
                    }

                    tabId = fm.namespace + '-help-debug-' + (+new Date());
                    targetL = $('<li></li>').html('<a href="' + selfUrl + '#' + tabId + '">' + self.debug.debug.cmd + '</a>').prependTo(debugUL);
                    target = $('<div id="' + tabId + '"></div>').data('debug', self.debug);

                    targetL.on('click.debugrender', function () {
                        var debug = target.data('debug');
                        target.removeData('debug');
                        if (debug) {
                            target.hide();
                            if (debug.debug) {
                                info = $('<fieldset>').append($('<legend></legend>').text('debug'), render($('<dl></dl>'), debug.debug));
                                target.append(info);
                            }
                            if (debug.options) {
                                info = $('<fieldset>').append($('<legend></legend>').text('options'), render($('<dl></dl>'), debug.options));
                                target.append(info);
                            }
                            target.show();
                        }
                        targetL.off('click.debugrender');
                    });

                    debugUL.after(target);

                    opened && debugDIV.tabs('refresh');
                }
            },
            content = '',
            opened, tabInteg, integDIV, tabDebug, debugDIV, debugUL;

        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.state = -1;

        this.shortcuts = [{
            pattern: 'f1',
            description: this.title
        }];

        fm.bind('load', function () {
            var parts = self.options.view || ['about', 'shortcuts', 'help', 'integrations', 'debug'],
                i, helpSource, tabBase, tabNav, tabs, delta;

            // remove 'preference' tab, it moved to command 'preference'
            if ((i = $.inArray('preference', parts)) !== -1) {
                parts.splice(i, 1);
            }

            // debug tab require jQueryUI Tabs Widget
            if (!$.fn.tabs) {
                if ((i = $.inArray(parts, 'debug')) !== -1) {
                    parts.splice(i, 1);
                }
            }

            $.each(parts, function (i, title) {
                html.push(tab[r](/\{id\}/g, title)[r](/\{title\}/, fm.i18n(title)));
            });

            html.push('</ul>');

            $.inArray('about', parts) !== -1 && about();
            $.inArray('shortcuts', parts) !== -1 && shortcuts();
            if ($.inArray('help', parts) !== -1) {
                helpSource = fm.i18nBaseUrl + 'help/%s.html.js';
                help();
            }
            $.inArray('integrations', parts) !== -1 && integrations();
            $.inArray('debug', parts) !== -1 && debug();

            html.push('</div>');
            content = $(html.join(''));

            content.find('.ui-tabs-nav li')
                .on('mouseenter mouseleave', function (e) {
                    $(this).toggleClass('ui-state-hover', e.type === 'mouseenter');
                })
                .on('focus blur', 'a', function (e) {
                    $(e.delegateTarget).toggleClass('ui-state-focus', e.type === 'focusin');
                })
                .children()
                .on('click', function (e) {
                    var link = $(this);

                    e.preventDefault();
                    e.stopPropagation();

                    link.parent().addClass(clTabActive).siblings().removeClass(clTabActive);
                    content.children('.ui-tabs-panel').hide().filter(link.attr('href')).show();
                })
                .filter(':first').trigger('click');

            if (useInteg) {
                tabInteg = content.find('.elfinder-help-tab-integrations').hide();
                integDIV = content.find('#' + fm.namespace + '-help-integrations').hide().append($('<div class="elfinder-help-integrations-desc"></div>').html(fm.i18n('integrationWith')));
                fm.bind('helpIntegration', function (e) {
                    var ul = integDIV.children('ul:first'),
                        data, elm, cmdUL, cmdCls;
                    if (e.data) {
                        if ($.isPlainObject(e.data)) {
                            data = Object.assign({
                                link: '',
                                title: '',
                                banner: ''
                            }, e.data);
                            if (data.title || data.link) {
                                if (!data.title) {
                                    data.title = data.link;
                                }
                                if (data.link) {
                                    elm = $('<a></a>').attr('href', data.link).attr('target', '_blank').text(data.title);
                                } else {
                                    elm = $('<span></span>').text(data.title);
                                }
                                if (data.banner) {
                                    elm = $('<span></span>').append($('<img/>').attr(data.banner), elm);
                                }
                            }
                        } else {
                            elm = $(e.data);
                            elm.filter('a').each(function () {
                                var tgt = $(this);
                                if (!tgt.attr('target')) {
                                    tgt.attr('target', '_blank');;
                                }
                            });
                        }
                        if (elm) {
                            tabInteg.show();
                            if (!ul.length) {
                                ul = $('<ul class="elfinder-help-integrations"></ul>').appendTo(integDIV);
                            }
                            if (data && data.cmd) {
                                cmdCls = 'elfinder-help-integration-' + data.cmd;
                                cmdUL = ul.find('ul.' + cmdCls);
                                if (!cmdUL.length) {
                                    cmdUL = $('<ul class="' + cmdCls + '"></ul>');
                                    ul.append($('<li></li>').append($('<span></span>').html(fm.i18n('cmd' + data.cmd))).append(cmdUL));
                                }
                                elm = cmdUL.append($('<li></li>').append(elm));
                            } else {
                                ul.append($('<li></li>').append(elm));
                            }
                        }
                    }
                }).bind('themechange', function () {
                    content.find('div.elfinder-help-term-theme').replaceWith(getTheme());
                });
            }

            // debug
            if (useDebug) {
                tabDebug = content.find('.elfinder-help-tab-debug').hide();
                debugDIV = content.find('#' + fm.namespace + '-help-debug').children('div:first');
                debugUL = debugDIV.children('ul:first').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });

                self.debug = {};

                fm.bind('backenddebug', function (e) {
                    // CAUTION: DO NOT TOUCH `e.data`
                    if (useDebug && e.data && e.data.debug) {
                        self.debug = { options: e.data.options, debug: Object.assign({ cmd: fm.currentReqCmd }, e.data.debug) };
                        if (self.dialog) {
                            debugRender();
                        }
                    }
                });
            }

            content.find('#' + fm.namespace + '-help-about').find('.apiver').text(fm.api);
            self.dialog = self.fmDialog(content, {
                title: self.title,
                width: 530,
                maxWidth: 'window',
                maxHeight: 'window',
                autoOpen: false,
                destroyOnClose: false,
                close: function () {
                    if (useDebug) {
                        tabDebug.hide();
                        debugDIV.tabs('destroy');
                    }
                    opened = false;
                }
            })
                .on('click', function (e) {
                    e.stopPropagation();
                })
                .css({
                    overflow: 'hidden'
                });

            tabBase = self.dialog.children('.ui-tabs');
            tabNav = tabBase.children('.ui-tabs-nav:first');
            tabs = tabBase.children('.ui-tabs-panel');
            delta = self.dialog.outerHeight(true) - self.dialog.height();
            self.dialog.closest('.ui-dialog').on('resize', function () {
                tabs.height(self.dialog.height() - delta - tabNav.outerHeight(true) - 20);
            });

            if (helpSource) {
                self.dialog.one('initContents', function () {
                    $.ajax({
                        url: self.options.helpSource ? self.options.helpSource : helpSource.replace('%s', fm.lang),
                        dataType: 'html'
                    }).done(function (source) {
                        $('#' + fm.namespace + '-help-help').html(source);
                    }).fail(function () {
                        $.ajax({
                            url: helpSource.replace('%s', 'en'),
                            dataType: 'html'
                        }).done(function (source) {
                            $('#' + fm.namespace + '-help-help').html(source);
                        });
                    });
                });
            }

            self.state = 0;

            fm.trigger('helpBuilded', self.dialog);
        }).one('open', function () {
            var debug = false;
            fm.one('backenddebug', function () {
                debug = true;
            }).one('opendone', function () {
                requestAnimationFrame(function () {
                    if (!debug && useDebug) {
                        useDebug = false;
                        tabDebug.hide();
                        debugDIV.hide();
                        debugUL.hide();
                    }
                });
            });
        });

        this.getstate = function () {
            return 0;
        };

        this.exec = function (sel, opts) {
            var tab = opts ? opts.tab : void (0),
                debugShow = function () {
                    if (useDebug) {
                        debugDIV.tabs();
                        debugUL.find('a:first').trigger('click');
                        tabDebug.show();
                        opened = true;
                    }
                };
            debugShow();
            this.dialog.trigger('initContents').elfinderdialog('open').find((tab ? '.elfinder-help-tab-' + tab : '.ui-tabs-nav li') + ' a:first').trigger('click');
            return $.Deferred().resolve();
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/hidden.js
     */

    /**
     * @class  elFinder command "hidden"
     * Always hidden command for uiCmdMap
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.hidden = function () {
        this.hidden = true;
        this.updateOnSelect = false;
        this.getstate = function () {
            return -1;
        };
    };

    /*
     * File: /js/commands/hide.js
     */

    /**
     * @class elFinder command "hide".
     * folders/files to hide as personal setting.
     *
     * @type  elFinder.command
     * @author  Naoki Sawada
     */
    elFinder.prototype.commands.hide = function () {

        var self = this,
            nameCache = {},
            hideData, hideCnt, cMenuType, sOrigin;

        this.syncTitleOnChange = true;

        this.shortcuts = [{
            pattern: 'ctrl+shift+dot',
            description: this.fm.i18n('toggleHidden')
        }];

        this.init = function () {
            var fm = this.fm;

            hideData = fm.storage('hide') || { items: {} };
            hideCnt = Object.keys(hideData.items).length;

            this.title = fm.i18n(hideData.show ? 'hideHidden' : 'showHidden');
            self.update(void (0), self.title);
        };

        this.fm.bind('select contextmenucreate closecontextmenu', function (e, fm) {
            var sel = (e.data ? (e.data.selected || e.data.targets) : null) || fm.selected();
            if (e.type === 'select' && e.data) {
                sOrigin = e.data.origin;
            } else if (e.type === 'contextmenucreate') {
                cMenuType = e.data.type;
            }
            if (!sel.length || (((e.type !== 'contextmenucreate' && sOrigin !== 'navbar') || cMenuType === 'cwd') && sel[0] === fm.cwd().hash)) {
                self.title = fm.i18n(hideData.show ? 'hideHidden' : 'showHidden');
            } else {
                self.title = fm.i18n('cmdhide');
            }
            if (e.type !== 'closecontextmenu') {
                self.update(cMenuType === 'cwd' ? (hideCnt ? 0 : -1) : void (0), self.title);
            } else {
                cMenuType = '';
                requestAnimationFrame(function () {
                    self.update(void (0), self.title);
                });
            }
        });

        this.getstate = function (sel) {
            return (this.fm.cookieEnabled && cMenuType !== 'cwd' && (sel || this.fm.selected()).length) || hideCnt ? 0 : -1;
        };

        this.exec = function (hashes, opts) {
            var fm = this.fm,
                dfrd = $.Deferred()
                    .done(function () {
                        fm.trigger('hide', { items: items, opts: opts });
                    })
                    .fail(function (error) {
                        fm.error(error);
                    }),
                o = opts || {},
                items = o.targets ? o.targets : (hashes || fm.selected()),
                added = [],
                removed = [],
                notifyto, files, res;

            hideData = fm.storage('hide') || {};
            if (!$.isPlainObject(hideData)) {
                hideData = {};
            }
            if (!$.isPlainObject(hideData.items)) {
                hideData.items = {};
            }
            if (opts._currentType === 'shortcut' || !items.length || (opts._currentType !== 'navbar' && sOrigin !== 'navbar' && items[0] === fm.cwd().hash)) {
                if (hideData.show) {
                    o.hide = true;
                } else if (Object.keys(hideData.items).length) {
                    o.show = true;
                }
            }
            if (o.reset) {
                o.show = true;
                hideCnt = 0;
            }
            if (o.show || o.hide) {
                if (o.show) {
                    hideData.show = true;
                } else {
                    delete hideData.show;
                }
                if (o.show) {
                    fm.storage('hide', o.reset ? null : hideData);
                    self.title = fm.i18n('hideHidden');
                    self.update(o.reset ? -1 : void (0), self.title);
                    $.each(hideData.items, function (h) {
                        var f = fm.file(h, true);
                        if (f && (fm.searchStatus.state || !f.phash || fm.file(f.phash))) {
                            added.push(f);
                        }
                    });
                    if (added.length) {
                        fm.updateCache({ added: added });
                        fm.add({ added: added });
                    }
                    if (o.reset) {
                        hideData = { items: {} };
                    }
                    return dfrd.resolve();
                }
                items = Object.keys(hideData.items);
            }

            if (items.length) {
                $.each(items, function (i, h) {
                    var f;
                    if (!hideData.items[h]) {
                        f = fm.file(h);
                        if (f) {
                            nameCache[h] = f.i18 || f.name;
                        }
                        hideData.items[h] = nameCache[h] ? nameCache[h] : h;
                    }
                });
                hideCnt = Object.keys(hideData.items).length;
                files = this.files(items);
                fm.storage('hide', hideData);
                fm.remove({ removed: items });
                if (hideData.show) {
                    this.exec(void (0), { hide: true });
                }
                if (!o.hide) {
                    res = {};
                    res.undo = {
                        cmd: 'hide',
                        callback: function () {
                            var nData = fm.storage('hide');
                            if (nData) {
                                $.each(items, function (i, h) {
                                    delete nData.items[h];
                                });
                                hideCnt = Object.keys(nData.items).length;
                                fm.storage('hide', nData);
                                fm.trigger('hide', { items: items, opts: {} });
                                self.update(hideCnt ? 0 : -1);
                            }
                            fm.updateCache({ added: files });
                            fm.add({ added: files });
                        }
                    };
                    res.redo = {
                        cmd: 'hide',
                        callback: function () {
                            return fm.exec('hide', void (0), { targets: items });
                        }
                    };
                }
            }

            return dfrd.state() == 'rejected' ? dfrd : dfrd.resolve(res);
        };
    };


    /*
     * File: /js/commands/home.js
     */

    (elFinder.prototype.commands.home = function () {
        this.title = 'Home';
        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.shortcuts = [{
            pattern: 'ctrl+home ctrl+shift+up',
            description: 'Home'
        }];

        this.getstate = function () {
            var root = this.fm.root(),
                cwd = this.fm.cwd().hash;

            return root && cwd && root != cwd ? 0 : -1;
        };

        this.exec = function () {
            return this.fm.exec('open', this.fm.root());
        };


    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/info.js
     */

    /**
     * @class elFinder command "info". 
     * Display dialog with file properties.
     *
     * @author Dmitry (dio) Levashov, dio@std42.ru
     **/
    (elFinder.prototype.commands.info = function () {
        var m = 'msg',
            fm = this.fm,
            spclass = 'elfinder-spinner',
            btnclass = 'elfinder-info-button',
            msg = {
                calc: fm.i18n('calc'),
                size: fm.i18n('size'),
                unknown: fm.i18n('unknown'),
                path: fm.i18n('path'),
                aliasfor: fm.i18n('aliasfor'),
                modify: fm.i18n('modify'),
                perms: fm.i18n('perms'),
                locked: fm.i18n('locked'),
                dim: fm.i18n('dim'),
                kind: fm.i18n('kind'),
                files: fm.i18n('files'),
                folders: fm.i18n('folders'),
                roots: fm.i18n('volumeRoots'),
                items: fm.i18n('items'),
                yes: fm.i18n('yes'),
                no: fm.i18n('no'),
                link: fm.i18n('link'),
                owner: fm.i18n('owner'),
                group: fm.i18n('group'),
                perm: fm.i18n('perm'),
                getlink: fm.i18n('getLink')
            },
            applyZWSP = function (str, remove) {
                if (remove) {
                    return str.replace(/\u200B/g, '');
                } else {
                    return str.replace(/(\/|\\)/g, "$1\u200B");
                }
            };

        this.items = ['size', 'aliasfor', 'path', 'link', 'dim', 'modify', 'perms', 'locked', 'owner', 'group', 'perm'];
        if (this.options.custom && Object.keys(this.options.custom).length) {
            $.each(this.options.custom, function (name, details) {
                details.label && this.items.push(details.label);
            });
        }

        this.tpl = {
            main: '<div class="ui-helper-clearfix elfinder-info-title {dirclass}"><span class="elfinder-cwd-icon {class} ui-corner-all"{style}></span>{title}</div><table class="elfinder-info-tb">{content}</table>',
            itemTitle: '<strong>{name}</strong><span class="elfinder-info-kind">{kind}</span>',
            groupTitle: '<strong>{items}: {num}</strong>',
            row: '<tr><td class="elfinder-info-label">{label} : </td><td class="{class}">{value}</td></tr>',
            spinner: '<span>{text}</span> <span class="' + spclass + ' ' + spclass + '-{name}"></span>'
        };

        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.shortcuts = [{
            pattern: 'ctrl+i'
        }];

        this.init = function () {
            $.each(msg, function (k, v) {
                msg[k] = fm.i18n(v);
            });
        };

        this.getstate = function () {
            return 0;
        };

        this.exec = function (hashes) {
            var files = this.files(hashes);
            if (!files.length) {
                files = this.files([this.fm.cwd().hash]);
            }
            var self = this,
                fm = this.fm,
                o = this.options,
                tpl = this.tpl,
                row = tpl.row,
                cnt = files.length,
                content = [],
                view = tpl.main,
                l = '{label}',
                v = '{value}',
                reqs = [],
                reqDfrd = null,
                opts = {
                    title: fm.i18n('selectionInfo'),
                    width: 'auto',
                    close: function () {
                        $(this).elfinderdialog('destroy');
                        if (reqDfrd && reqDfrd.state() === 'pending') {
                            reqDfrd.reject();
                        }
                        $.grep(reqs, function (r) {
                            r && r.state() === 'pending' && r.reject();
                        });
                    }
                },
                count = [],
                replSpinner = function (msg, name, className) {
                    dialog.find('.' + spclass + '-' + name).parent().html(msg).addClass(className || '');
                },
                id = fm.namespace + '-info-' + $.map(files, function (f) { return f.hash; }).join('-'),
                dialog = fm.getUI().find('#' + id),
                customActions = [],
                style = '',
                hashClass = 'elfinder-font-mono elfinder-info-hash',
                getHashAlgorisms = [],
                ndialog = fm.ui.notify,
                size, tmb, file, title, dcnt, rdcnt, path, hideItems, hashProg;

            if (ndialog.is(':hidden') && ndialog.children('.elfinder-notify').length) {
                ndialog.elfinderdialog('open').height('auto');
            }

            if (!cnt) {
                return $.Deferred().reject();
            }

            if (dialog.length) {
                dialog.elfinderdialog('toTop');
                return $.Deferred().resolve();
            }

            hideItems = fm.storage('infohides') || fm.arrayFlip(o.hideItems, true);

            if (cnt === 1) {
                file = files[0];

                if (file.icon) {
                    style = ' ' + fm.getIconStyle(file);
                }

                view = view.replace('{dirclass}', file.csscls ? fm.escape(file.csscls) : '').replace('{class}', fm.mime2class(file.mime)).replace('{style}', style);
                title = tpl.itemTitle.replace('{name}', fm.escape(file.i18 || file.name)).replace('{kind}', '<span title="' + fm.escape(file.mime) + '">' + fm.mime2kind(file) + '</span>');

                tmb = fm.tmb(file);

                if (!file.read) {
                    size = msg.unknown;
                } else if (file.mime != 'directory' || file.alias) {
                    size = fm.formatSize(file.size);
                } else {
                    size = tpl.spinner.replace('{text}', msg.calc).replace('{name}', 'size');
                    count.push(file.hash);
                }

                !hideItems.size && content.push(row.replace(l, msg.size).replace(v, size));
                !hideItems.aleasfor && file.alias && content.push(row.replace(l, msg.aliasfor).replace(v, file.alias));
                if (!hideItems.path) {
                    if (path = fm.path(file.hash, true)) {
                        content.push(row.replace(l, msg.path).replace(v, applyZWSP(fm.escape(path))).replace('{class}', 'elfinder-info-path'));
                    } else {
                        content.push(row.replace(l, msg.path).replace(v, tpl.spinner.replace('{text}', msg.calc).replace('{name}', 'path')).replace('{class}', 'elfinder-info-path'));
                        reqs.push(fm.path(file.hash, true, { notify: null })
                            .fail(function () {
                                replSpinner(msg.unknown, 'path');
                            })
                            .done(function (path) {
                                replSpinner(applyZWSP(path), 'path');
                            }));
                    }
                }
                if (!hideItems.link && file.read) {
                    var href,
                        name_esc = fm.escape(file.name);
                    if (file.url == '1') {
                        content.push(row.replace(l, msg.link).replace(v, '<button class="' + btnclass + ' ' + spclass + '-url">' + msg.getlink + '</button>'));
                    } else {
                        if (file.url) {
                            href = file.url;
                        } else if (file.mime === 'directory') {
                            if (o.nullUrlDirLinkSelf && file.url === null) {
                                var loc = window.location;
                                href = loc.pathname + loc.search + '#elf_' + file.hash;
                            } else if (file.url !== '' && fm.option('url', (!fm.isRoot(file) && file.phash) || file.hash)) {
                                href = fm.url(file.hash);
                            }
                        } else {
                            href = fm.url(file.hash);
                        }
                        href && content.push(row.replace(l, msg.link).replace(v, '<a href="' + href + '" target="_blank">' + name_esc + '</a>'));
                    }
                }

                if (!hideItems.dim) {
                    if (file.dim) { // old api
                        content.push(row.replace(l, msg.dim).replace(v, file.dim));
                    } else if (file.mime.indexOf('image') !== -1) {
                        if (file.width && file.height) {
                            content.push(row.replace(l, msg.dim).replace(v, file.width + 'x' + file.height));
                        } else if (file.size && file.size !== '0') {
                            content.push(row.replace(l, msg.dim).replace(v, tpl.spinner.replace('{text}', msg.calc).replace('{name}', 'dim')));
                            reqs.push(fm.request({
                                data: { cmd: 'dim', target: file.hash },
                                preventDefault: true
                            })
                                .fail(function () {
                                    replSpinner(msg.unknown, 'dim');
                                })
                                .done(function (data) {
                                    replSpinner(data.dim || msg.unknown, 'dim');
                                    if (data.dim) {
                                        var dim = data.dim.split('x');
                                        var rfile = fm.file(file.hash);
                                        rfile.width = dim[0];
                                        rfile.height = dim[1];
                                    }
                                }));
                        }
                    }
                }

                !hideItems.modify && content.push(row.replace(l, msg.modify).replace(v, fm.formatDate(file)));
                !hideItems.perms && content.push(row.replace(l, msg.perms).replace(v, fm.formatPermissions(file)));
                !hideItems.locked && content.push(row.replace(l, msg.locked).replace(v, file.locked ? msg.yes : msg.no));
                !hideItems.owner && file.owner && content.push(row.replace(l, msg.owner).replace(v, file.owner));
                !hideItems.group && file.group && content.push(row.replace(l, msg.group).replace(v, file.group));
                !hideItems.perm && file.perm && content.push(row.replace(l, msg.perm).replace(v, fm.formatFileMode(file.perm)));

                // Get MD5, SHA hashes
                if (window.ArrayBuffer && (fm.options.cdns.sparkmd5 || fm.options.cdns.jssha) && file.mime !== 'directory' && file.size > 0 && (!o.showHashMaxsize || file.size <= o.showHashMaxsize)) {
                    getHashAlgorisms = [];
                    $.each(fm.storage('hashchekcer') || o.showHashAlgorisms, function (i, n) {
                        if (!file[n]) {
                            content.push(row.replace(l, fm.i18n(n)).replace(v, tpl.spinner.replace('{text}', msg.calc).replace('{name}', n)));
                            getHashAlgorisms.push(n);
                        } else {
                            content.push(row.replace(l, fm.i18n(n)).replace(v, file[n]).replace('{class}', hashClass));
                        }
                    });

                    if (getHashAlgorisms.length) {
                        hashProg = $('<div class="elfinder-quicklook-info-progress"></div>');
                        reqs.push(
                            fm.getContentsHashes(file.hash, getHashAlgorisms, o.showHashOpts, { progressBar: hashProg }).progress(function (hashes) {
                                $.each(getHashAlgorisms, function (i, n) {
                                    if (hashes[n]) {
                                        replSpinner(hashes[n], n, hashClass);
                                    }
                                });
                            }).always(function () {
                                $.each(getHashAlgorisms, function (i, n) {
                                    replSpinner(msg.unknown, n);
                                });
                            })
                        );
                    }
                }

                // Add custom info fields
                if (o.custom) {
                    $.each(o.custom, function (name, details) {
                        if (
                            !hideItems[details.label]
                            &&
                            (!details.mimes || $.grep(details.mimes, function (m) { return (file.mime === m || file.mime.indexOf(m + '/') === 0) ? true : false; }).length)
                            &&
                            (!details.hashRegex || file.hash.match(details.hashRegex))
                        ) {
                            // Add to the content
                            content.push(row.replace(l, fm.i18n(details.label)).replace(v, details.tpl.replace('{id}', id)));
                            // Register the action
                            if (details.action && (typeof details.action == 'function')) {
                                customActions.push(details.action);
                            }
                        }
                    });
                }
            } else {
                view = view.replace('{class}', 'elfinder-cwd-icon-group');
                title = tpl.groupTitle.replace('{items}', msg.items).replace('{num}', cnt);
                dcnt = $.grep(files, function (f) { return f.mime == 'directory' ? true : false; }).length;
                if (!dcnt) {
                    size = 0;
                    $.each(files, function (h, f) {
                        var s = parseInt(f.size);

                        if (s >= 0 && size >= 0) {
                            size += s;
                        } else {
                            size = 'unknown';
                        }
                    });
                    content.push(row.replace(l, msg.kind).replace(v, msg.files));
                    !hideItems.size && content.push(row.replace(l, msg.size).replace(v, fm.formatSize(size)));
                } else {
                    rdcnt = $.grep(files, function (f) { return f.mime === 'directory' && (!f.phash || f.isroot) ? true : false; }).length;
                    dcnt -= rdcnt;
                    content.push(row.replace(l, msg.kind).replace(v, (rdcnt === cnt || dcnt === cnt) ? msg[rdcnt ? 'roots' : 'folders'] : $.map({ roots: rdcnt, folders: dcnt, files: cnt - rdcnt - dcnt }, function (c, t) { return c ? msg[t] + ' ' + c : null; }).join(', ')));
                    !hideItems.size && content.push(row.replace(l, msg.size).replace(v, tpl.spinner.replace('{text}', msg.calc).replace('{name}', 'size')));
                    count = $.map(files, function (f) { return f.hash; });

                }
            }

            view = view.replace('{title}', title).replace('{content}', content.join('').replace(/{class}/g, ''));

            dialog = self.fmDialog(view, opts);
            dialog.attr('id', id).one('mousedown', '.elfinder-info-path', function () {
                $(this).html(applyZWSP($(this).html(), true));
            });

            if (getHashAlgorisms.length) {
                hashProg.appendTo(dialog.find('.' + spclass + '-' + getHashAlgorisms[0]).parent());
            }

            if (fm.UA.Mobile && $.fn.tooltip) {
                dialog.children('.ui-dialog-content .elfinder-info-title').tooltip({
                    classes: {
                        'ui-tooltip': 'elfinder-ui-tooltip ui-widget-shadow'
                    },
                    tooltipClass: 'elfinder-ui-tooltip ui-widget-shadow',
                    track: true
                });
            }

            if (file && file.url == '1') {
                dialog.on('click', '.' + spclass + '-url', function () {
                    $(this).parent().html(tpl.spinner.replace('{text}', fm.i18n('ntfurl')).replace('{name}', 'url'));
                    fm.request({
                        data: { cmd: 'url', target: file.hash },
                        preventDefault: true
                    })
                        .fail(function () {
                            replSpinner(name_esc, 'url');
                        })
                        .done(function (data) {
                            if (data.url) {
                                replSpinner('<a href="' + data.url + '" target="_blank">' + name_esc + '</a>' || name_esc, 'url');
                                var rfile = fm.file(file.hash);
                                rfile.url = data.url;
                            } else {
                                replSpinner(name_esc, 'url');
                            }
                        });
                });
            }

            // load thumbnail
            if (tmb) {
                $('<img/>')
                    .on('load', function () { dialog.find('.elfinder-cwd-icon').addClass(tmb.className).css('background-image', "url('" + tmb.url + "')"); })
                    .attr('src', tmb.url);
            }

            // send request to count total size
            if (count.length) {
                reqDfrd = fm.getSize(count).done(function (data) {
                    replSpinner(data.formated, 'size');
                }).fail(function () {
                    replSpinner(msg.unknown, 'size');
                });
            }

            // call custom actions
            if (customActions.length) {
                $.each(customActions, function (i, action) {
                    try {
                        action(file, fm, dialog);
                    } catch (e) {
                        fm.debug('error', e);
                    }
                });
            }

            return $.Deferred().resolve();
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/mkdir.js
     */

    /**
     * @class  elFinder command "mkdir"
     * Create new folder
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.mkdir = function () {
        var fm = this.fm,
            self = this,
            curOrg;

        this.value = '';
        this.disableOnSearch = true;
        this.updateOnSelect = false;
        this.syncTitleOnChange = true;
        this.mime = 'directory';
        this.prefix = 'untitled folder';
        this.exec = function (select, cOpts) {
            var onCwd;

            if (select && select.length && cOpts && cOpts._currentType && cOpts._currentType === 'navbar') {
                this.origin = cOpts._currentType;
                this.data = {
                    target: select[0]
                };
            } else {
                onCwd = fm.cwd().hash === select[0];
                this.origin = curOrg && !onCwd ? curOrg : 'cwd';
                delete this.data;
            }
            if (!select && !this.options.intoNewFolderToolbtn) {
                fm.getUI('cwd').trigger('unselectall');
            }
            //this.move = (!onCwd && curOrg !== 'navbar' && fm.selected().length)? true : false;
            this.move = this.value === fm.i18n('cmdmkdirin');
            return $.proxy(fm.res('mixin', 'make'), self)();
        };

        this.shortcuts = [{
            pattern: 'ctrl+shift+n'
        }];

        this.init = function () {
            if (this.options.intoNewFolderToolbtn) {
                this.syncTitleOnChange = true;
            }
        };

        fm.bind('select contextmenucreate closecontextmenu', function (e) {
            var sel = (e.data ? (e.data.selected || e.data.targets) : null) || fm.selected();

            self.className = 'mkdir';
            curOrg = e.data && sel.length ? (e.data.origin || e.data.type || '') : '';
            if (!self.options.intoNewFolderToolbtn && curOrg === '') {
                curOrg = 'cwd';
            }
            if (sel.length && curOrg !== 'navbar' && curOrg !== 'cwd' && fm.cwd().hash !== sel[0]) {
                self.title = fm.i18n('cmdmkdirin');
                self.className += ' elfinder-button-icon-mkdirin';
            } else {
                self.title = fm.i18n('cmdmkdir');
            }
            if (e.type !== 'closecontextmenu') {
                self.update(void (0), self.title);
            } else {
                requestAnimationFrame(function () {
                    self.update(void (0), self.title);
                });
            }
        });

        this.getstate = function (select) {
            var cwd = fm.cwd(),
                sel = (curOrg === 'navbar' || (select && select[0] !== cwd.hash)) ? this.files(select || fm.selected()) : [],
                cnt = sel.length,
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (f) {
                        fres = fres && f.read && !f.locked ? true : false;
                        return fres;
                    });
                };

            if (curOrg === 'navbar') {
                return cnt && sel[0].write && sel[0].read ? 0 : -1;
            } else {
                return cwd.write && (!cnt || filter(sel).length == cnt) ? 0 : -1;
            }
        };

    };


    /*
     * File: /js/commands/mkfile.js
     */

    /**
     * @class  elFinder command "mkfile"
     * Create new empty file
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.mkfile = function () {
        var self = this;

        this.disableOnSearch = true;
        this.updateOnSelect = false;
        this.mime = 'text/plain';
        this.prefix = 'untitled file.txt';
        this.variants = [];

        this.getTypeName = function (mime, type) {
            var fm = self.fm,
                name;
            if (name = fm.messages['kind' + fm.kinds[mime]]) {
                name = fm.i18n(['extentiontype', type.toUpperCase(), name]);
            } else {
                name = fm.i18n(['extentionfile', type.toUpperCase()]);
            }
            return name;
        };

        this.fm.bind('open reload canMakeEmptyFile', function () {
            var fm = self.fm,
                hides = fm.getCommand('edit').getMkfileHides();
            self.variants = [];
            if (fm.mimesCanMakeEmpty) {
                $.each(fm.mimesCanMakeEmpty, function (mime, type) {
                    type && !hides[mime] && fm.uploadMimeCheck(mime) && self.variants.push([mime, self.getTypeName(mime, type)]);
                });
            }
            self.change();
        });

        this.getstate = function () {
            return this.fm.cwd().write ? 0 : -1;
        };

        this.exec = function (_dum, mime) {
            var fm = self.fm,
                type, err;
            if (type = fm.mimesCanMakeEmpty[mime]) {
                if (fm.uploadMimeCheck(mime)) {
                    this.mime = mime;
                    this.prefix = fm.i18n(['untitled file', type]);
                    return $.proxy(fm.res('mixin', 'make'), self)();
                }
                err = ['errMkfile', self.getTypeName(mime, type)];
            }
            return $.Deferred().reject(err);
        };
    };


    /*
     * File: /js/commands/netmount.js
     */

    /**
     * @class  elFinder command "netmount"
     * Mount network volume with user credentials.
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.netmount = function () {
        var self = this,
            hasMenus = false,
            content;

        this.alwaysEnabled = true;
        this.updateOnSelect = false;

        this.drivers = [];

        this.handlers = {
            load: function () {
                var fm = self.fm;
                if (fm.cookieEnabled) {
                    fm.one('open', function () {
                        self.drivers = fm.netDrivers;
                        if (self.drivers.length) {
                            $.each(self.drivers, function () {
                                var d = self.options[this];
                                if (d) {
                                    hasMenus = true;
                                    if (d.integrateInfo) {
                                        fm.trigger('helpIntegration', Object.assign({ cmd: 'netmount' }, d.integrateInfo));
                                    }
                                }
                            });
                        }
                    });
                }
            }
        };

        this.getstate = function () {
            return hasMenus ? 0 : -1;
        };

        this.exec = function () {
            var fm = self.fm,
                dfrd = $.Deferred(),
                o = self.options,
                create = function () {
                    var winFocus = function () {
                        inputs.protocol.trigger('change', 'winfocus');
                    },
                        inputs = {
                            protocol: $('<select></select>')
                                .on('change', function (e, data) {
                                    var protocol = this.value;
                                    content.find('.elfinder-netmount-tr').hide();
                                    content.find('.elfinder-netmount-tr-' + protocol).show();
                                    dialogNode && dialogNode.children('.ui-dialog-buttonpane:first').find('button').show();
                                    if (typeof o[protocol].select == 'function') {
                                        o[protocol].select(fm, e, data);
                                    }
                                })
                                .addClass('ui-corner-all')
                        },
                        opts = {
                            title: fm.i18n('netMountDialogTitle'),
                            resizable: true,
                            modal: true,
                            destroyOnClose: false,
                            open: function () {
                                $(window).on('focus.' + fm.namespace, winFocus);
                                inputs.protocol.trigger('change');
                            },
                            close: function () {
                                dfrd.state() == 'pending' && dfrd.reject();
                                $(window).off('focus.' + fm.namespace, winFocus);
                            },
                            buttons: {}
                        },
                        doMount = function () {
                            var protocol = inputs.protocol.val(),
                                data = { cmd: 'netmount', protocol: protocol },
                                cur = o[protocol],
                                mnt2res;
                            $.each(content.find('input.elfinder-netmount-inputs-' + protocol), function (name, input) {
                                var val, elm;
                                elm = $(input);
                                if (elm.is(':radio,:checkbox')) {
                                    if (elm.is(':checked')) {
                                        val = $.trim(elm.val());
                                    }
                                } else {
                                    val = $.trim(elm.val());
                                }
                                if (val) {
                                    data[input.name] = val;
                                }
                            });

                            if (!data.host) {
                                return fm.trigger('error', { error: 'errNetMountHostReq', opts: { modal: true } });
                            }

                            if (data.mnt2res) {
                                mnt2res = true;
                            }

                            fm.request({ data: data, notify: { type: 'netmount', cnt: 1, hideCnt: true } })
                                .done(function (data) {
                                    var pdir;
                                    if (data.added && data.added.length) {
                                        mnt2res && inputs.protocol.trigger('change', 'reset');
                                        if (data.added[0].phash) {
                                            if (pdir = fm.file(data.added[0].phash)) {
                                                if (!pdir.dirs) {
                                                    pdir.dirs = 1;
                                                    fm.change({ changed: [pdir] });
                                                }
                                            }
                                        }
                                        fm.one('netmountdone', function () {
                                            fm.exec('open', data.added[0].hash);
                                        });
                                    }
                                    dfrd.resolve();
                                })
                                .fail(function (error) {
                                    if (cur.fail && typeof cur.fail == 'function') {
                                        cur.fail(fm, fm.parseError(error));
                                    }
                                    dfrd.reject(error);
                                });

                            self.dialog.elfinderdialog('close');
                        },
                        form = $('<form autocomplete="off"></form>').on('keydown', 'input', function (e) {
                            var comp = true,
                                next;
                            if (e.keyCode === $.ui.keyCode.ENTER) {
                                $.each(form.find('input:visible:not(.elfinder-input-optional)'), function () {
                                    if ($(this).val() === '') {
                                        comp = false;
                                        next = $(this);
                                        return false;
                                    }
                                });
                                if (comp) {
                                    doMount();
                                } else {
                                    next.trigger('focus');
                                }
                            }
                        }),
                        hidden = $('<div></div>'),
                        dialog;

                    content = $('<table class="elfinder-info-tb elfinder-netmount-tb"></table>')
                        .append($('<tr></tr>').append($('<td>' + fm.i18n('protocol') + '</td>')).append($('<td></td>').append(inputs.protocol)));

                    $.each(self.drivers, function (i, protocol) {
                        if (o[protocol]) {
                            inputs.protocol.append('<option value="' + protocol + '">' + fm.i18n(o[protocol].name || protocol) + '</option>');
                            $.each(o[protocol].inputs, function (name, input) {
                                input.attr('name', name);
                                if (input.attr('type') != 'hidden') {
                                    input.addClass('ui-corner-all elfinder-netmount-inputs-' + protocol);
                                    content.append($('<tr></tr>').addClass('elfinder-netmount-tr elfinder-netmount-tr-' + protocol).append($('<td>' + fm.i18n(name) + '</td>')).append($('<td></td>').append(input)));
                                } else {
                                    input.addClass('elfinder-netmount-inputs-' + protocol);
                                    hidden.append(input);
                                }
                            });
                            o[protocol].protocol = inputs.protocol;
                        }
                    });

                    content.append(hidden);

                    content.find('.elfinder-netmount-tr').hide();
                    content.find('.elfinder-netmount-tr-' + self.drivers[0]).show();

                    opts.buttons[fm.i18n('btnMount')] = doMount;

                    opts.buttons[fm.i18n('btnCancel')] = function () {
                        self.dialog.elfinderdialog('close');
                    };

                    content.find('select,input').addClass('elfinder-tabstop');

                    dialog = self.fmDialog(form.append(content), opts).ready(function () {
                        inputs.protocol.trigger('change');
                        dialog.elfinderdialog('posInit');
                    });
                    dialogNode = dialog.closest('.ui-dialog');
                    return dialog;
                },
                dialogNode;

            if (!self.dialog) {
                self.dialog = create();
            } else {
                self.dialog.elfinderdialog('open');
            }

            return dfrd.promise();
        };

        self.fm.bind('netmount', function (e) {
            var d = e.data || null,
                o = self.options,
                done = function () {
                    if (o[d.protocol] && typeof o[d.protocol].done == 'function') {
                        o[d.protocol].done(self.fm, d);
                        content.find('select,input').addClass('elfinder-tabstop');
                        self.dialog.elfinderdialog('tabstopsInit');
                    }
                };
            if (d && d.protocol) {
                if (d.mode && d.mode === 'redirect') {
                    // To support of third-party cookie blocking (ITP) on CORS
                    // On iOS and iPadOS 13.4 and Safari 13.1 on macOS, the session cannot be continued when redirecting OAuth in CORS mode
                    self.fm.request({
                        data: { cmd: 'netmount', protocol: d.protocol, host: d.host, user: 'init', pass: 'return', options: d.options },
                        preventDefault: true
                    }).done(function (data) {
                        d = JSON.parse(data.body);
                        done();
                    });
                } else {
                    done();
                }
            }
        });

    };

    elFinder.prototype.commands.netunmount = function () {
        var self = this;

        this.alwaysEnabled = true;
        this.updateOnSelect = false;

        this.drivers = [];

        this.handlers = {
            load: function () {
                this.drivers = this.fm.netDrivers;
            }
        };

        this.getstate = function (sel) {
            var fm = this.fm,
                file;
            return !!sel && this.drivers.length && !this._disabled && (file = fm.file(sel[0])) && file.netkey ? 0 : -1;
        };

        this.exec = function (hashes) {
            var self = this,
                fm = this.fm,
                dfrd = $.Deferred()
                    .fail(function (error) {
                        error && fm.error(error);
                    }),
                drive = fm.file(hashes[0]),
                childrenRoots = function (hash) {
                    var roots = [],
                        work;
                    if (fm.leafRoots) {
                        work = [];
                        $.each(fm.leafRoots, function (phash, hashes) {
                            var parents = fm.parents(phash),
                                idx, deep;
                            if ((idx = $.inArray(hash, parents)) !== -1) {
                                idx = parents.length - idx;
                                $.each(hashes, function (i, h) {
                                    work.push({ i: idx, hash: h });
                                });
                            }
                        });
                        if (work.length) {
                            work.sort(function (a, b) { return a.i < b.i; });
                            $.each(work, function (i, o) {
                                roots.push(o.hash);
                            });
                        }
                    }
                    return roots;
                };

            if (this._disabled) {
                return dfrd.reject();
            }

            if (dfrd.state() == 'pending') {
                fm.confirm({
                    title: self.title,
                    text: fm.i18n('confirmUnmount', drive.name),
                    accept: {
                        label: 'btnUnmount',
                        callback: function () {
                            var target = drive.hash,
                                roots = childrenRoots(target),
                                requests = [],
                                removed = [],
                                doUmount = function () {
                                    $.when(requests).done(function () {
                                        fm.request({
                                            data: { cmd: 'netmount', protocol: 'netunmount', host: drive.netkey, user: target, pass: 'dum' },
                                            notify: { type: 'netunmount', cnt: 1, hideCnt: true },
                                            preventFail: true
                                        })
                                            .fail(function (error) {
                                                dfrd.reject(error);
                                            })
                                            .done(function (data) {
                                                drive.volumeid && delete fm.volumeExpires[drive.volumeid];
                                                dfrd.resolve();
                                            });
                                    }).fail(function (error) {
                                        if (removed.length) {
                                            fm.remove({ removed: removed });
                                        }
                                        dfrd.reject(error);
                                    });
                                };

                            if (roots.length) {
                                fm.confirm({
                                    title: self.title,
                                    text: (function () {
                                        var msgs = ['unmountChildren'];
                                        $.each(roots, function (i, hash) {
                                            msgs.push([fm.file(hash).name]);
                                        });
                                        return msgs;
                                    })(),
                                    accept: {
                                        label: 'btnUnmount',
                                        callback: function () {
                                            $.each(roots, function (i, hash) {
                                                var d = fm.file(hash);
                                                if (d.netkey) {
                                                    requests.push(fm.request({
                                                        data: { cmd: 'netmount', protocol: 'netunmount', host: d.netkey, user: d.hash, pass: 'dum' },
                                                        notify: { type: 'netunmount', cnt: 1, hideCnt: true },
                                                        preventDefault: true
                                                    }).done(function (data) {
                                                        if (data.removed) {
                                                            d.volumeid && delete fm.volumeExpires[d.volumeid];
                                                            removed = removed.concat(data.removed);
                                                        }
                                                    }));
                                                }
                                            });
                                            doUmount();
                                        }
                                    },
                                    cancel: {
                                        label: 'btnCancel',
                                        callback: function () {
                                            dfrd.reject();
                                        }
                                    }
                                });
                            } else {
                                requests = null;
                                doUmount();
                            }
                        }
                    },
                    cancel: {
                        label: 'btnCancel',
                        callback: function () { dfrd.reject(); }
                    }
                });
            }

            return dfrd;
        };

    };


    /*
     * File: /js/commands/open.js
     */

    /**
     * @class  elFinder command "open"
     * Enter folder or open files in new windows
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.open = function () {
        var fm = this.fm,
            self = this;
        this.alwaysEnabled = true;
        this.noChangeDirOnRemovedCwd = true;

        this._handlers = {
            dblclick: function (e) {
                var arg = e.data && e.data.file ? [e.data.file] : void (0);
                if (self.getstate(arg) === 0) {
                    e.preventDefault();
                    fm.exec('open', arg);
                }
            },
            'select enable disable reload': function (e) { this.update(e.type == 'disable' ? -1 : void (0)); }
        };

        this.shortcuts = [{
            pattern: 'ctrl+down numpad_enter' + (fm.OS != 'mac' && ' enter')
        }];

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (file) {
                        fres = fres && file.mime == 'directory' || !file.read ? false : true;
                        return fres;
                    });
                };

            return cnt == 1
                ? (sel[0].read ? 0 : -1)
                : (cnt && !fm.UA.Mobile) ? ($.grep(sel, function (file) { return file.mime == 'directory' || !file.read ? false : true; }).length == cnt ? 0 : -1) : -1;
        };

        this.exec = function (hashes, cOpts) {
            var dfrd = $.Deferred().fail(function (error) { error && fm.error(error); }),
                files = this.files(hashes),
                cnt = files.length,
                thash = (typeof cOpts == 'object') ? cOpts.thash : false,
                opts = this.options,
                into = opts.into || 'window',
                file, url, s, w, imgW, imgH, winW, winH, reg, link, html5dl, inline,
                selAct, cmd;

            if (!cnt && !thash) {
                {
                    return dfrd.reject();
                }
            }

            // open folder
            if (thash || (cnt == 1 && (file = files[0]) && file.mime == 'directory')) {
                if (!thash && file && !file.read) {
                    return dfrd.reject(['errOpen', file.name, 'errPerm']);
                } else {
                    if (fm.keyState.ctrlKey && (fm.keyState.shiftKey || typeof fm.options.getFileCallback !== 'function')) {
                        if (fm.getCommand('opennew')) {
                            return fm.exec('opennew', [thash ? thash : file.hash]);
                        }
                    }

                    return fm.request({
                        data: { cmd: 'open', target: thash || file.hash },
                        notify: { type: 'open', cnt: 1, hideCnt: true },
                        syncOnFail: true,
                        lazy: false
                    });
                }
            }

            files = $.grep(files, function (file) { return file.mime != 'directory' ? true : false; });

            // nothing to open or files and folders selected - do nothing
            if (cnt != files.length) {
                return dfrd.reject();
            }

            var doOpen = function () {
                var openCB = function (url) {
                    var link = $('<a rel="noopener">').hide().appendTo($('body'));
                    if (fm.UA.Mobile || !inline) {
                        if (html5dl) {
                            if (!inline) {
                                link.attr('download', file.name);
                            } else {
                                link.attr('target', '_blank');
                            }
                            link.attr('href', url).get(0).click();
                        } else {
                            wnd = window.open(url);
                            if (!wnd) {
                                return dfrd.reject('errPopup');
                            }
                        }
                    } else {
                        getOnly = (typeof opts.method === 'string' && opts.method.toLowerCase() === 'get');
                        if (!getOnly
                            && url.indexOf(fm.options.url) === 0
                            && fm.customData
                            && Object.keys(fm.customData).length
                            // Since playback by POST request can not be done in Chrome, media allows GET request
                            && !file.mime.match(/^(?:video|audio)/)
                        ) {
                            // Send request as 'POST' method to hide custom data at location bar
                            url = '';
                        }
                        if (into === 'window') {
                            // set window size for image if set
                            imgW = winW = Math.round(2 * screen.availWidth / 3);
                            imgH = winH = Math.round(2 * screen.availHeight / 3);
                            if (parseInt(file.width) && parseInt(file.height)) {
                                imgW = parseInt(file.width);
                                imgH = parseInt(file.height);
                            } else if (file.dim) {
                                s = file.dim.split('x');
                                imgW = parseInt(s[0]);
                                imgH = parseInt(s[1]);
                            }
                            if (winW >= imgW && winH >= imgH) {
                                winW = imgW;
                                winH = imgH;
                            } else {
                                if ((imgW - winW) > (imgH - winH)) {
                                    winH = Math.round(imgH * (winW / imgW));
                                } else {
                                    winW = Math.round(imgW * (winH / imgH));
                                }
                            }
                            w = 'width=' + winW + ',height=' + winH;
                            wnd = window.open(url, target, w + ',top=50,left=50,scrollbars=yes,resizable=yes,titlebar=no');
                        } else {
                            if (into === 'tabs') {
                                target = file.hash;
                            }
                            wnd = window.open('about:blank', target);
                        }

                        if (!wnd) {
                            return dfrd.reject('errPopup');
                        }

                        if (url === '') {
                            var form = document.createElement("form");
                            form.action = fm.options.url;
                            form.method = 'POST';
                            form.target = target;
                            form.style.display = 'none';
                            var params = Object.assign({}, fm.customData, {
                                cmd: 'file',
                                target: file.hash,
                                _t: file.ts || parseInt(+new Date() / 1000)
                            });
                            $.each(params, function (key, val) {
                                var input = document.createElement("input");
                                input.name = key;
                                input.value = val;
                                form.appendChild(input);
                            });

                            document.body.appendChild(form);
                            form.submit();
                        } else if (into !== 'window') {
                            wnd.location = url;
                        }
                        $(wnd).trigger('focus');
                    }
                    link.remove();
                },
                    wnd, target, getOnly;

                try {
                    reg = new RegExp(fm.option('dispInlineRegex'), 'i');
                } catch (e) {
                    reg = false;
                }

                // open files
                html5dl = (typeof $('<a>').get(0).download === 'string');
                cnt = files.length;
                while (cnt--) {
                    target = 'elf_open_window';
                    file = files[cnt];

                    if (!file.read) {
                        return dfrd.reject(['errOpen', file.name, 'errPerm']);
                    }

                    inline = (reg && file.mime.match(reg));
                    fm.openUrl(file.hash, !inline, openCB);
                }
                return dfrd.resolve(hashes);
            };

            if (cnt > 1) {
                fm.confirm({
                    title: 'openMulti',
                    text: ['openMultiConfirm', cnt + ''],
                    accept: {
                        label: 'cmdopen',
                        callback: function () { doOpen(); }
                    },
                    cancel: {
                        label: 'btnCancel',
                        callback: function () {
                            dfrd.reject();
                        }
                    },
                    buttons: (fm.getCommand('zipdl') && fm.isCommandEnabled('zipdl', fm.cwd().hash)) ? [
                        {
                            label: 'cmddownload',
                            callback: function () {
                                fm.exec('download', hashes);
                                dfrd.reject();
                            }
                        }
                    ] : []
                });
            } else {
                selAct = fm.storage('selectAction') || opts.selectAction;
                if (selAct) {
                    $.each(selAct.split('/'), function () {
                        var cmdName = this.valueOf();
                        if (cmdName !== 'open' && (cmd = fm.getCommand(cmdName)) && cmd.enabled()) {
                            return false;
                        }
                        cmd = null;
                    });
                    if (cmd) {
                        return fm.exec(cmd.name);
                    }
                }
                doOpen();
            }

            return dfrd;
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/opendir.js
     */

    /**
     * @class  elFinder command "opendir"
     * Enter parent folder
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.opendir = function () {
        this.alwaysEnabled = true;

        this.getstate = function () {
            var sel = this.fm.selected(),
                cnt = sel.length,
                wz;
            if (cnt !== 1) {
                return -1;
            }
            wz = this.fm.getUI('workzone');
            return wz.hasClass('elfinder-search-result') ? 0 : -1;
        };

        this.exec = function (hashes) {
            var fm = this.fm,
                dfrd = $.Deferred(),
                files = this.files(hashes),
                cnt = files.length,
                hash, pcheck = null;

            if (!cnt || !files[0].phash) {
                return dfrd.reject();
            }

            hash = files[0].phash;
            fm.trigger('searchend', { noupdate: true });
            fm.request({
                data: { cmd: 'open', target: hash },
                notify: { type: 'open', cnt: 1, hideCnt: true },
                syncOnFail: false
            });

            return dfrd;
        };

    };


    /*
     * File: /js/commands/opennew.js
     */

    /**
     * @class  elFinder command "opennew"
     * Open folder in new window
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.opennew = function () {
        var fm = this.fm;

        this.shortcuts = [{
            pattern: (typeof (fm.options.getFileCallback) === 'function' ? 'shift+' : '') + 'ctrl+enter'
        }];

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length;

            return cnt === 1
                ? (sel[0].mime === 'directory' && sel[0].read ? 0 : -1)
                : -1;
        };

        this.exec = function (hashes) {
            var dfrd = $.Deferred(),
                files = this.files(hashes),
                cnt = files.length,
                opts = this.options,
                file, loc, url, win;

            // open folder to new tab (window)
            if (cnt === 1 && (file = files[0]) && file.mime === 'directory') {
                loc = window.location;
                if (opts.url) {
                    url = opts.url;
                } else {
                    url = loc.pathname;
                }
                if (opts.useOriginQuery) {
                    if (!url.match(/\?/)) {
                        url += loc.search;
                    } else if (loc.search) {
                        url += '&' + loc.search.substr(1);
                    }
                }
                url += '#elf_' + file.hash;
                win = window.open(url, '_blank');
                setTimeout(function () {
                    win.focus();
                }, 1000);
                return dfrd.resolve();
            } else {
                return dfrd.reject();
            }
        };
    };


    /*
     * File: /js/commands/paste.js
     */

    /**
     * @class  elFinder command "paste"
     * Paste filesfrom clipboard into directory.
     * If files pasted in its parent directory - files duplicates will created
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.paste = function () {
        this.updateOnSelect = false;

        this.handlers = {
            changeclipboard: function () { this.update(); }
        };

        this.shortcuts = [{
            pattern: 'ctrl+v shift+insert'
        }];

        this.getstate = function (dst) {
            if (this._disabled) {
                return -1;
            }
            if (dst) {
                if (Array.isArray(dst)) {
                    if (dst.length != 1) {
                        return -1;
                    }
                    dst = this.fm.file(dst[0]);
                }
            } else {
                dst = this.fm.cwd();
            }

            return this.fm.clipboard().length && dst.mime == 'directory' && dst.write ? 0 : -1;
        };

        this.exec = function (select, cOpts) {
            var self = this,
                fm = self.fm,
                opts = cOpts || {},
                dst = select ? this.files(select)[0] : fm.cwd(),
                files = fm.clipboard(),
                cnt = files.length,
                cut = cnt ? files[0].cut : false,
                cmd = opts._cmd ? opts._cmd : (cut ? 'move' : 'copy'),
                error = 'err' + cmd.charAt(0).toUpperCase() + cmd.substr(1),
                fpaste = [],
                fcopy = [],
                dfrd = $.Deferred()
                    .fail(function (error) {
                        error && fm.error(error);
                    })
                    .always(function () {
                        fm.unlockfiles({ files: $.map(files, function (f) { return f.hash; }) });
                    }),
                copy = function (files) {
                    return files.length && fm._commands.duplicate
                        ? fm.exec('duplicate', files)
                        : $.Deferred().resolve();
                },
                paste = function (files) {
                    var dfrd = $.Deferred(),
                        existed = [],
                        hashes = {},
                        intersect = function (files, names) {
                            var ret = [],
                                i = files.length;

                            while (i--) {
                                $.inArray(files[i].name, names) !== -1 && ret.unshift(i);
                            }
                            return ret;
                        },
                        confirm = function (ndx) {
                            var i = existed[ndx],
                                file = files[i],
                                last = ndx == existed.length - 1;

                            if (!file) {
                                return;
                            }

                            fm.confirm({
                                title: fm.i18n(cmd + 'Files'),
                                text: ['errExists', file.name, cmd === 'restore' ? 'confirmRest' : 'confirmRepl'],
                                all: !last,
                                accept: {
                                    label: 'btnYes',
                                    callback: function (all) {
                                        !last && !all
                                            ? confirm(++ndx)
                                            : paste(files);
                                    }
                                },
                                reject: {
                                    label: 'btnNo',
                                    callback: function (all) {
                                        var i;

                                        if (all) {
                                            i = existed.length;
                                            while (ndx < i--) {
                                                files[existed[i]].remove = true;
                                            }
                                        } else {
                                            files[existed[ndx]].remove = true;
                                        }

                                        !last && !all
                                            ? confirm(++ndx)
                                            : paste(files);
                                    }
                                },
                                cancel: {
                                    label: 'btnCancel',
                                    callback: function () {
                                        dfrd.resolve();
                                    }
                                },
                                buttons: [
                                    {
                                        label: 'btnBackup',
                                        callback: function (all) {
                                            var i;
                                            if (all) {
                                                i = existed.length;
                                                while (ndx < i--) {
                                                    files[existed[i]].rename = true;
                                                }
                                            } else {
                                                files[existed[ndx]].rename = true;
                                            }
                                            !last && !all
                                                ? confirm(++ndx)
                                                : paste(files);
                                        }
                                    }
                                ]
                            });
                        },
                        valid = function (names) {
                            var exists = {}, existedArr;
                            if (names) {
                                if (Array.isArray(names)) {
                                    if (names.length) {
                                        if (typeof names[0] == 'string') {
                                            // elFinder <= 2.1.6 command `is` results
                                            existed = intersect(files, names);
                                        } else {
                                            $.each(names, function (i, v) {
                                                exists[v.name] = v.hash;
                                            });
                                            existed = intersect(files, $.map(exists, function (h, n) { return n; }));
                                            $.each(files, function (i, file) {
                                                if (exists[file.name]) {
                                                    hashes[exists[file.name]] = file.name;
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    existedArr = [];
                                    existed = $.map(names, function (n) {
                                        if (typeof n === 'string') {
                                            return n;
                                        } else {
                                            // support to >=2.1.11 plugin Normalizer, Sanitizer
                                            existedArr = existedArr.concat(n);
                                            return false;
                                        }
                                    });
                                    if (existedArr.length) {
                                        existed = existed.concat(existedArr);
                                    }
                                    existed = intersect(files, existed);
                                    hashes = names;
                                }
                            }
                            existed.length ? confirm(0) : paste(files);
                        },
                        paste = function (selFiles) {
                            var renames = [],
                                files = $.grep(selFiles, function (file) {
                                    if (file.rename) {
                                        renames.push(file.name);
                                    }
                                    return !file.remove ? true : false;
                                }),
                                cnt = files.length,
                                groups = {},
                                args = [],
                                targets, reqData;

                            if (!cnt) {
                                return dfrd.resolve();
                            }

                            targets = $.map(files, function (f) { return f.hash; });

                            reqData = { cmd: 'paste', dst: dst.hash, targets: targets, cut: cut ? 1 : 0, renames: renames, hashes: hashes, suffix: fm.options.backupSuffix };
                            if (fm.api < 2.1) {
                                reqData.src = files[0].phash;
                            }

                            fm.request({
                                data: reqData,
                                notify: { type: cmd, cnt: cnt },
                                cancel: true,
                                navigate: {
                                    toast: opts.noToast ? {} : {
                                        inbuffer: {
                                            msg: fm.i18n(['complete', fm.i18n('cmd' + cmd)]), action: {
                                                cmd: 'open',
                                                msg: 'cmdopendir',
                                                data: [dst.hash],
                                                done: 'select',
                                                cwdNot: dst.hash
                                            }
                                        }
                                    }
                                }
                            })
                                .done(function (data) {
                                    var dsts = {},
                                        added = data.added && data.added.length ? data.added : null;
                                    if (cut && added) {
                                        // undo/redo
                                        $.each(files, function (i, f) {
                                            var phash = f.phash,
                                                srcHash = function (name) {
                                                    var hash;
                                                    $.each(added, function (i, f) {
                                                        if (f.name === name) {
                                                            hash = f.hash;
                                                            return false;
                                                        }
                                                    });
                                                    return hash;
                                                },
                                                shash = srcHash(f.name);
                                            if (shash) {
                                                if (dsts[phash]) {
                                                    dsts[phash].push(shash);
                                                } else {
                                                    dsts[phash] = [shash];
                                                }
                                            }
                                        });
                                        if (Object.keys(dsts).length) {
                                            data.undo = {
                                                cmd: 'move',
                                                callback: function () {
                                                    var reqs = [];
                                                    $.each(dsts, function (dst, targets) {
                                                        reqs.push(fm.request({
                                                            data: { cmd: 'paste', dst: dst, targets: targets, cut: 1 },
                                                            notify: { type: 'undo', cnt: targets.length }
                                                        }));
                                                    });
                                                    return $.when.apply(null, reqs);
                                                }
                                            };
                                            data.redo = {
                                                cmd: 'move',
                                                callback: function () {
                                                    return fm.request({
                                                        data: reqData,
                                                        notify: { type: 'redo', cnt: cnt }
                                                    });
                                                }
                                            };
                                        }
                                    }
                                    dfrd.resolve(data);
                                })
                                .fail(function (flg) {
                                    dfrd.reject();
                                    if (flg === 0) {
                                        // canceling
                                        fm.sync();
                                    }
                                })
                                .always(function () {
                                    fm.unlockfiles({ files: files });
                                });
                        },
                        internames;

                    if (!fm.isCommandEnabled(self.name, dst.hash) || !files.length) {
                        return dfrd.resolve();
                    }

                    if (fm.oldAPI) {
                        paste(files);
                    } else {

                        if (!fm.option('copyOverwrite', dst.hash)) {
                            paste(files);
                        } else {
                            internames = $.map(files, function (f) { return f.name; });
                            dst.hash == fm.cwd().hash
                                ? valid($.map(fm.files(), function (file) { return file.phash == dst.hash ? { hash: file.hash, name: file.name } : null; }))
                                : fm.request({
                                    data: { cmd: 'ls', target: dst.hash, intersect: internames },
                                    notify: { type: 'prepare', cnt: 1, hideCnt: true },
                                    preventFail: true
                                })
                                    .always(function (data) {
                                        valid(data.list);
                                    });
                        }
                    }

                    return dfrd;
                },
                parents, fparents, cutDfrd;


            if (!cnt || !dst || dst.mime != 'directory') {
                return dfrd.reject();
            }

            if (!dst.write) {
                return dfrd.reject([error, files[0].name, 'errPerm']);
            }

            parents = fm.parents(dst.hash);

            $.each(files, function (i, file) {
                if (!file.read) {
                    return !dfrd.reject([error, file.name, 'errPerm']);
                }

                if (cut && file.locked) {
                    return !dfrd.reject(['errLocked', file.name]);
                }

                if ($.inArray(file.hash, parents) !== -1) {
                    return !dfrd.reject(['errCopyInItself', file.name]);
                }

                if (file.mime && file.mime !== 'directory' && !fm.uploadMimeCheck(file.mime, dst.hash)) {
                    return !dfrd.reject([error, file.name, 'errUploadMime']);
                }

                fparents = fm.parents(file.hash);
                fparents.pop();
                if ($.inArray(dst.hash, fparents) !== -1) {

                    if ($.grep(fparents, function (h) { var d = fm.file(h); return d.phash == dst.hash && d.name == file.name ? true : false; }).length) {
                        return !dfrd.reject(['errReplByChild', file.name]);
                    }
                }

                if (file.phash == dst.hash) {
                    fcopy.push(file.hash);
                } else {
                    fpaste.push({
                        hash: file.hash,
                        phash: file.phash,
                        name: file.name
                    });
                }
            });

            if (dfrd.state() === 'rejected') {
                return dfrd;
            }

            cutDfrd = $.Deferred();
            if (cut && self.options.moveConfirm) {
                fm.confirm({
                    title: 'moveFiles',
                    text: fm.i18n('confirmMove', dst.i18 || dst.name),
                    accept: {
                        label: 'btnYes',
                        callback: function () {
                            cutDfrd.resolve();
                        }
                    },
                    cancel: {
                        label: 'btnCancel',
                        callback: function () {
                            cutDfrd.reject();
                        }
                    }
                });
            } else {
                cutDfrd.resolve();
            }

            cutDfrd.done(function () {
                $.when(
                    copy(fcopy),
                    paste(fpaste)
                )
                    .done(function (cr, pr) {
                        dfrd.resolve(pr && pr.undo ? pr : void (0));
                    })
                    .fail(function () {
                        dfrd.reject();
                    })
                    .always(function () {
                        cut && fm.clipboard([]);
                    });
            }).fail(function () {
                dfrd.reject();
            });

            return dfrd;
        };

    };


    /*
     * File: /js/commands/places.js
     */

    /**
     * @class  elFinder command "places"
     * Regist to Places
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.places = function () {
        var self = this,
            fm = this.fm,
            filter = function (hashes) {
                var fres = true;
                return $.grep(self.files(hashes), function (f) {
                    fres = fres && f.mime == 'directory' ? true : false;
                    return fres;
                });
            },
            places = null;

        this.getstate = function (select) {
            var sel = this.hashes(select),
                cnt = sel.length;

            return places && cnt && cnt == filter(sel).length ? 0 : -1;
        };

        this.exec = function (hashes) {
            var files = this.files(hashes);
            places.trigger('regist', [files]);
            return $.Deferred().resolve();
        };

        fm.one('load', function () {
            places = fm.ui.places;
        });

    };


    /*
     * File: /js/commands/preference.js
     */

    /**
     * @class  elFinder command "preference"
     * "Preference" dialog
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.preference = function () {
        var self = this,
            fm = this.fm,
            r = 'replace',
            tab = '<li class="' + fm.res('class', 'tabstab') + ' elfinder-preference-tab-{id}"><a href="#' + fm.namespace + '-preference-{id}" id="' + fm.namespace + '-preference-tab-{id}" class="ui-tabs-anchor {class}">{title}</a></li>',
            base = $('<div class="ui-tabs ui-widget ui-widget-content ui-corner-all elfinder-preference">'),
            ul = $('<ul class="ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-top">'),
            tabs = $('<div class="elfinder-preference-tabs ui-tabs-panel ui-widget-content ui-corner-bottom"></div>'),
            sep = '<div class="elfinder-preference-separator"></div>',
            selfUrl = $('base').length ? document.location.href.replace(/#.*$/, '') : '',
            selectTab = function (tab) {
                $('#' + fm.namespace + '-preference-tab-' + tab).trigger('mouseover').trigger('click');
                openTab = tab;
            },
            clTabActive = fm.res('class', 'tabsactive'),
            build = function () {
                var cats = self.options.categories || {
                    'language': ['language'],
                    'theme': ['theme'],
                    'toolbar': ['toolbarPref'],
                    'workspace': ['iconSize', 'columnPref', 'selectAction', 'makefileTypes', 'useStoredEditor', 'editorMaximized', 'useFullscreen', 'showHidden'],
                    'dialog': ['autoFocusDialog'],
                    'selectionInfo': ['infoItems', 'hashChecker'],
                    'reset': ['clearBrowserData'],
                    'all': true
                },
                    forms = self.options.prefs || ['language', 'theme', 'toolbarPref', 'iconSize', 'columnPref', 'selectAction', 'makefileTypes', 'useStoredEditor', 'editorMaximized', 'useFullscreen', 'showHidden', 'infoItems', 'hashChecker', 'autoFocusDialog', 'clearBrowserData'];

                if (!fm.cookieEnabled) {
                    delete cats.language;
                }

                forms = fm.arrayFlip(forms, true);

                if (fm.options.getFileCallback) {
                    delete forms.selectAction;
                }
                if (!fm.UA.Fullscreen) {
                    delete forms.useFullscreen;
                }

                forms.language && (forms.language = (function () {
                    var langSel = $('<select></select>').on('change', function () {
                        var lang = $(this).val();
                        fm.storage('lang', lang);
                        $('#' + fm.id).elfinder('reload');
                    }),
                        optTags = [],
                        langs = self.options.langs || {
                            ar: 'العربية',
                            bg: 'Български',
                            ca: 'Català',
                            cs: 'Čeština',
                            da: 'Dansk',
                            de: 'Deutsch',
                            el: 'Ελληνικά',
                            en: 'English',
                            es: 'Español',
                            fa: 'فارسی',
                            fo: 'Føroyskt',
                            fr: 'Français',
                            fr_CA: 'Français (Canada)',
                            he: 'עברית',
                            hr: 'Hrvatski',
                            hu: 'Magyar',
                            id: 'Bahasa Indonesia',
                            it: 'Italiano',
                            ja: '日本語',
                            ko: '한국어',
                            nl: 'Nederlands',
                            no: 'Norsk',
                            pl: 'Polski',
                            pt_BR: 'Português',
                            ro: 'Română',
                            ru: 'Pусский',
                            si: 'සිංහල',
                            sk: 'Slovenčina',
                            sl: 'Slovenščina',
                            sr: 'Srpski',
                            sv: 'Svenska',
                            tr: 'Türkçe',
                            ug_CN: 'ئۇيغۇرچە',
                            uk: 'Український',
                            vi: 'Tiếng Việt',
                            zh_CN: '简体中文',
                            zh_TW: '正體中文'
                        };
                    if (!fm.cookieEnabled) {
                        return $();
                    }
                    $.each(langs, function (lang, name) {
                        optTags.push('<option value="' + lang + '">' + name + '</option>');
                    });
                    return langSel.append(optTags.join('')).val(fm.lang);
                })());

                forms.theme && (forms.theme = (function () {
                    var cnt = fm.options.themes ? Object.keys(fm.options.themes).length : 0;
                    if (cnt === 0 || (cnt === 1 && fm.options.themes.default)) {
                        return null;
                    }
                    var themeSel = $('<select></select>').on('change', function () {
                        var theme = $(this).val();
                        fm.changeTheme(theme).storage('theme', theme);
                    }),
                        optTags = [],
                        tpl = {
                            image: '<img class="elfinder-preference-theme elfinder-preference-theme-image" src="$2" />',
                            link: '<a href="$1" target="_blank" title="$3">$2</a>',
                            data: '<dt>$1</dt><dd><span class="elfinder-preference-theme elfinder-preference-theme-$0">$2</span></dd>'
                        },
                        items = ['image', 'description', 'author', 'email', 'license'],
                        render = function (key, data) {
                        },
                        defBtn = $('<button class="ui-button ui-corner-all ui-widget elfinder-preference-theme-default"></button>').text(fm.i18n('default')).on('click', function (e) {
                            themeSel.val('default').trigger('change');
                        }),
                        list = $('<div class="elfinder-reference-hide-taball"></div>').on('click', 'button', function () {
                            var val = $(this).data('themeid');
                            themeSel.val(val).trigger('change');
                        });

                    if (!fm.options.themes.default) {
                        themeSel.append('<option value="default">' + fm.i18n('default') + '</option>');
                    }
                    $.each(fm.options.themes, function (id, val) {
                        var opt = $('<option class="elfinder-theme-option-' + id + '" value="' + id + '">' + fm.i18n(id) + '</option>'),
                            dsc = $('<fieldset class="ui-widget ui-widget-content ui-corner-all elfinder-theme-list-' + id + '"><legend>' + fm.i18n(id) + '</legend><div><span class="elfinder-spinner"></span></div></fieldset>'),
                            tm;
                        themeSel.append(opt);
                        list.append(dsc);
                        tm = setTimeout(function () {
                            dsc.find('span.elfinder-spinner').replaceWith(fm.i18n(['errRead', id]));
                        }, 10000);
                        fm.getTheme(id).always(function () {
                            tm && clearTimeout(tm);
                        }).done(function (data) {
                            var link, val = $(), dl = $('<dl></dl>');
                            link = data.link ? tpl.link.replace(/\$1/g, data.link).replace(/\$3/g, fm.i18n('website')) : '$2';
                            if (data.name) {
                                opt.html(fm.i18n(data.name));
                            }
                            dsc.children('legend').html(link.replace(/\$2/g, fm.i18n(data.name) || id));
                            $.each(items, function (i, key) {
                                var t = tpl[key] || tpl.data,
                                    elm;
                                if (data[key]) {
                                    elm = t.replace(/\$0/g, fm.escape(key)).replace(/\$1/g, fm.i18n(key)).replace(/\$2/g, fm.i18n(data[key]));
                                    if (key === 'image' && data.link) {
                                        elm = $(elm).on('click', function () {
                                            themeSel.val(id).trigger('change');
                                        }).attr('title', fm.i18n('select'));
                                    }
                                    dl.append(elm);
                                }
                            });
                            val = val.add(dl);
                            val = val.add($('<div class="elfinder-preference-theme-btn"></div>').append($('<button class="ui-button ui-corner-all ui-widget"></button>').data('themeid', id).html(fm.i18n('select'))));
                            dsc.find('span.elfinder-spinner').replaceWith(val);
                        }).fail(function () {
                            dsc.find('span.elfinder-spinner').replaceWith(fm.i18n(['errRead', id]));
                        });
                    });
                    return $('<div></div>').append(themeSel.val(fm.theme && fm.theme.id ? fm.theme.id : 'default'), defBtn, list);
                })());

                forms.toolbarPref && (forms.toolbarPref = (function () {
                    var pnls = $.map(fm.options.uiOptions.toolbar, function (v) {
                        return $.isArray(v) ? v : null;
                    }),
                        tags = [],
                        hides = fm.storage('toolbarhides') || {};
                    $.each(pnls, function () {
                        var cmd = this,
                            name = fm.i18n('cmd' + cmd);
                        if (name === 'cmd' + cmd) {
                            name = fm.i18n(cmd);
                        }
                        tags.push('<span class="elfinder-preference-toolbar-item"><label><input type="checkbox" value="' + cmd + '" ' + (hides[cmd] ? '' : 'checked') + '/>' + name + '</label></span>');
                    });
                    return $(tags.join(' ')).on('change', 'input', function () {
                        var v = $(this).val(),
                            o = $(this).is(':checked');
                        if (!o && !hides[v]) {
                            hides[v] = true;
                        } else if (o && hides[v]) {
                            delete hides[v];
                        }
                        fm.storage('toolbarhides', hides);
                        fm.trigger('toolbarpref');
                    });
                })());

                forms.iconSize && (forms.iconSize = (function () {
                    var max = fm.options.uiOptions.cwd.iconsView.sizeMax || 3,
                        size = fm.storage('iconsize') || fm.options.uiOptions.cwd.iconsView.size || 0,
                        sld = $('<div class="touch-punch"></div>').slider({
                            classes: {
                                'ui-slider-handle': 'elfinder-tabstop',
                            },
                            value: size,
                            max: max,
                            slide: function (e, ui) {
                                fm.getUI('cwd').trigger('iconpref', { size: ui.value });
                            },
                            change: function (e, ui) {
                                fm.storage('iconsize', ui.value);
                            }
                        });
                    fm.getUI('cwd').on('iconpref', function (e, data) {
                        sld.slider('option', 'value', data.size);
                    });
                    return sld;
                })());

                forms.columnPref && (forms.columnPref = (function () {
                    var cols = fm.options.uiOptions.cwd.listView.columns,
                        tags = [],
                        hides = fm.storage('columnhides') || {};
                    $.each(cols, function () {
                        var key = this,
                            name = fm.getColumnName(key);
                        tags.push('<span class="elfinder-preference-column-item"><label><input type="checkbox" value="' + key + '" ' + (hides[key] ? '' : 'checked') + '/>' + name + '</label></span>');
                    });
                    return $(tags.join(' ')).on('change', 'input', function () {
                        var v = $(this).val(),
                            o = $(this).is(':checked');
                        if (!o && !hides[v]) {
                            hides[v] = true;
                        } else if (o && hides[v]) {
                            delete hides[v];
                        }
                        fm.storage('columnhides', hides);
                        fm.trigger('columnpref', { repaint: true });
                    });
                })());

                forms.selectAction && (forms.selectAction = (function () {
                    var actSel = $('<select></select>').on('change', function () {
                        var act = $(this).val();
                        fm.storage('selectAction', act === 'default' ? null : act);
                    }),
                        optTags = [],
                        acts = self.options.selectActions,
                        defAct = fm.getCommand('open').options.selectAction || 'open';

                    if ($.inArray(defAct, acts) === -1) {
                        acts.unshift(defAct);
                    }
                    $.each(acts, function (i, act) {
                        var names = $.map(act.split('/'), function (cmd) {
                            var name = fm.i18n('cmd' + cmd);
                            if (name === 'cmd' + cmd) {
                                name = fm.i18n(cmd);
                            }
                            return name;
                        });
                        optTags.push('<option value="' + act + '">' + names.join('/') + '</option>');
                    });
                    return actSel.append(optTags.join('')).val(fm.storage('selectAction') || defAct);
                })());

                forms.makefileTypes && (forms.makefileTypes = (function () {
                    var hides = fm.getCommand('edit').getMkfileHides(),
                        getTag = function () {
                            var tags = [];
                            // re-assign hides
                            hides = fm.getCommand('edit').getMkfileHides();
                            $.each(fm.mimesCanMakeEmpty, function (mime, type) {
                                var name = fm.getCommand('mkfile').getTypeName(mime, type);
                                tags.push('<span class="elfinder-preference-column-item" title="' + fm.escape(name) + '"><label><input type="checkbox" value="' + mime + '" ' + (hides[mime] ? '' : 'checked') + '/>' + type + '</label></span>');
                            });
                            return tags.join(' ');
                        },
                        elm = $('<div></div>').on('change', 'input', function () {
                            var v = $(this).val(),
                                o = $(this).is(':checked');
                            if (!o && !hides[v]) {
                                hides[v] = true;
                            } else if (o && hides[v]) {
                                delete hides[v];
                            }
                            fm.storage('mkfileHides', hides);
                            fm.trigger('canMakeEmptyFile');
                        }).append(getTag()),
                        add = $('<div></div>').append(
                            $('<input type="text" placeholder="' + fm.i18n('typeOfTextfile') + '"/>').on('keydown', function (e) {
                                (e.keyCode === $.ui.keyCode.ENTER) && $(this).next().trigger('click');
                            }),
                            $('<button class="ui-button"></button>').html(fm.i18n('add')).on('click', function () {
                                var input = $(this).prev(),
                                    val = input.val(),
                                    uiToast = fm.getUI('toast'),
                                    err = function () {
                                        uiToast.appendTo(input.closest('.ui-dialog'));
                                        fm.toast({
                                            msg: fm.i18n('errUsupportType'),
                                            mode: 'warning',
                                            onHidden: function () {
                                                uiToast.children().length === 1 && uiToast.appendTo(fm.getUI());
                                            }
                                        });
                                        input.trigger('focus');
                                        return false;
                                    },
                                    tmpMimes;
                                if (!val.match(/\//)) {
                                    val = fm.arrayFlip(fm.mimeTypes)[val];
                                    if (!val) {
                                        return err();
                                    }
                                    input.val(val);
                                }
                                if (!fm.mimeIsText(val) || !fm.mimeTypes[val]) {
                                    return err();
                                }
                                fm.trigger('canMakeEmptyFile', { mimes: [val], unshift: true });
                                tmpMimes = {};
                                tmpMimes[val] = fm.mimeTypes[val];
                                fm.storage('mkfileTextMimes', Object.assign(tmpMimes, fm.storage('mkfileTextMimes') || {}));
                                input.val('');
                                uiToast.appendTo(input.closest('.ui-dialog'));
                                fm.toast({
                                    msg: fm.i18n(['complete', val + ' (' + tmpMimes[val] + ')']),
                                    onHidden: function () {
                                        uiToast.children().length === 1 && uiToast.appendTo(fm.getUI());
                                    }
                                });
                            }),
                            $('<button class="ui-button"></button>').html(fm.i18n('reset')).on('click', function () {
                                fm.one('canMakeEmptyFile', {
                                    done: function () {
                                        elm.empty().append(getTag());
                                    }
                                });
                                fm.trigger('canMakeEmptyFile', { resetTexts: true });
                            })
                        ),
                        tm;
                    fm.bind('canMakeEmptyFile', {
                        done: function (e) {
                            if (e.data && e.data.mimes && e.data.mimes.length) {
                                elm.empty().append(getTag());
                            }
                        }
                    });
                    return $('<div></div>').append(elm, add);
                })());

                forms.useStoredEditor && (forms.useStoredEditor = $('<input type="checkbox"/>').prop('checked', (function () {
                    var s = fm.storage('useStoredEditor');
                    return s ? (s > 0) : fm.options.commandsOptions.edit.useStoredEditor;
                })()).on('change', function (e) {
                    fm.storage('useStoredEditor', $(this).is(':checked') ? 1 : -1);
                }));

                forms.editorMaximized && (forms.editorMaximized = $('<input type="checkbox"/>').prop('checked', (function () {
                    var s = fm.storage('editorMaximized');
                    return s ? (s > 0) : fm.options.commandsOptions.edit.editorMaximized;
                })()).on('change', function (e) {
                    fm.storage('editorMaximized', $(this).is(':checked') ? 1 : -1);
                }));

                forms.useFullscreen && (forms.useFullscreen = $('<input type="checkbox"/>').prop('checked', (function () {
                    var s = fm.storage('useFullscreen');
                    return s ? (s > 0) : fm.options.commandsOptions.fullscreen.mode === 'screen';
                })()).on('change', function (e) {
                    fm.storage('useFullscreen', $(this).is(':checked') ? 1 : -1);
                }));

                if (forms.showHidden) {
                    (function () {
                        var setTitle = function () {
                            var s = fm.storage('hide'),
                                t = [],
                                v;
                            if (s && s.items) {
                                $.each(s.items, function (h, n) {
                                    t.push(fm.escape(n));
                                });
                            }
                            elms.prop('disabled', !t.length)[t.length ? 'removeClass' : 'addClass']('ui-state-disabled');
                            v = t.length ? t.join('\n') : '';
                            forms.showHidden.attr('title', v);
                            useTooltip && forms.showHidden.tooltip('option', 'content', v.replace(/\n/g, '<br>')).tooltip('close');
                        },
                            chk = $('<input type="checkbox"/>').prop('checked', (function () {
                                var s = fm.storage('hide');
                                return s && s.show;
                            })()).on('change', function (e) {
                                var o = {};
                                o[$(this).is(':checked') ? 'show' : 'hide'] = true;
                                fm.exec('hide', void (0), o);
                            }),
                            btn = $('<button class="ui-button ui-corner-all ui-widget"></button>').append(fm.i18n('reset')).on('click', function () {
                                fm.exec('hide', void (0), { reset: true });
                                $(this).parent().find('input:first').prop('checked', false);
                                setTitle();
                            }),
                            elms = $().add(chk).add(btn),
                            useTooltip;

                        forms.showHidden = $('<div></div>').append(chk, btn);
                        fm.bind('hide', function (e) {
                            var d = e.data;
                            if (!d.opts || (!d.opts.show && !d.opts.hide)) {
                                setTitle();
                            }
                        });
                        if (fm.UA.Mobile && $.fn.tooltip) {
                            useTooltip = true;
                            forms.showHidden.tooltip({
                                classes: {
                                    'ui-tooltip': 'elfinder-ui-tooltip ui-widget-shadow'
                                },
                                tooltipClass: 'elfinder-ui-tooltip ui-widget-shadow',
                                track: true
                            }).css('user-select', 'none');
                            btn.css('user-select', 'none');
                        }
                        setTitle();
                    })();
                }

                forms.infoItems && (forms.infoItems = (function () {
                    var items = fm.getCommand('info').items,
                        tags = [],
                        hides = fm.storage('infohides') || fm.arrayFlip(fm.options.commandsOptions.info.hideItems, true);
                    $.each(items, function () {
                        var key = this,
                            name = fm.i18n(key);
                        tags.push('<span class="elfinder-preference-info-item"><label><input type="checkbox" value="' + key + '" ' + (hides[key] ? '' : 'checked') + '/>' + name + '</label></span>');
                    });
                    return $(tags.join(' ')).on('change', 'input', function () {
                        var v = $(this).val(),
                            o = $(this).is(':checked');
                        if (!o && !hides[v]) {
                            hides[v] = true;
                        } else if (o && hides[v]) {
                            delete hides[v];
                        }
                        fm.storage('infohides', hides);
                        fm.trigger('infopref', { repaint: true });
                    });
                })());

                forms.hashChecker && fm.hashCheckers.length && (forms.hashChecker = (function () {
                    var tags = [],
                        enabled = fm.arrayFlip(fm.storage('hashchekcer') || fm.options.commandsOptions.info.showHashAlgorisms, true);
                    $.each(fm.hashCheckers, function () {
                        var cmd = this,
                            name = fm.i18n(cmd);
                        tags.push('<span class="elfinder-preference-hashchecker-item"><label><input type="checkbox" value="' + cmd + '" ' + (enabled[cmd] ? 'checked' : '') + '/>' + name + '</label></span>');
                    });
                    return $(tags.join(' ')).on('change', 'input', function () {
                        var v = $(this).val(),
                            o = $(this).is(':checked');
                        if (o) {
                            enabled[v] = true;
                        } else if (enabled[v]) {
                            delete enabled[v];
                        }
                        fm.storage('hashchekcer', $.grep(fm.hashCheckers, function (v) {
                            return enabled[v];
                        }));
                    });
                })());

                forms.autoFocusDialog && (forms.autoFocusDialog = $('<input type="checkbox"/>').prop('checked', (function () {
                    var s = fm.storage('autoFocusDialog');
                    return s ? (s > 0) : fm.options.uiOptions.dialog.focusOnMouseOver;
                })()).on('change', function (e) {
                    fm.storage('autoFocusDialog', $(this).is(':checked') ? 1 : -1);
                }));

                forms.clearBrowserData && (forms.clearBrowserData = $('<button></button>').text(fm.i18n('reset')).button().on('click', function (e) {
                    e.preventDefault();
                    fm.storage();
                    $('#' + fm.id).elfinder('reload');
                }));

                $.each(cats, function (id, prefs) {
                    var dls, found;
                    if (prefs === true) {
                        found = 1;
                    } else if (prefs) {
                        dls = $();
                        $.each(prefs, function (i, n) {
                            var f, title, chks = '', cbox;
                            if (f = forms[n]) {
                                found = 2;
                                title = fm.i18n(n);
                                cbox = $(f).filter('input[type="checkbox"]');
                                if (!cbox.length) {
                                    cbox = $(f).find('input[type="checkbox"]');
                                }
                                if (cbox.length === 1) {
                                    if (!cbox.attr('id')) {
                                        cbox.attr('id', 'elfinder-preference-' + n + '-checkbox');
                                    }
                                    title = '<label for="' + cbox.attr('id') + '">' + title + '</label>';
                                } else if (cbox.length > 1) {
                                    chks = ' elfinder-preference-checkboxes';
                                }
                                dls = dls.add($('<dt class="elfinder-preference-' + n + chks + '">' + title + '</dt>')).add($('<dd class="elfinder-preference-' + n + chks + '"></dd>').append(f));
                            }
                        });
                    }
                    if (found) {
                        ul.append(tab[r](/\{id\}/g, id)[r](/\{title\}/, fm.i18n(id))[r](/\{class\}/, openTab === id ? 'elfinder-focus' : ''));
                        if (found === 2) {
                            tabs.append(
                                $('<div id="' + fm.namespace + '-preference-' + id + '" class="elfinder-preference-content"></div>')
                                    .hide()
                                    .append($('<dl></dl>').append(dls))
                            );
                        }
                    }
                });

                ul.on('click', 'a', function (e) {
                    var t = $(e.target),
                        h = t.attr('href');
                    e.preventDefault();
                    e.stopPropagation();

                    ul.children().removeClass(clTabActive);
                    t.removeClass('ui-state-hover').parent().addClass(clTabActive);

                    if (h.match(/all$/)) {
                        tabs.addClass('elfinder-preference-taball').children().show();
                    } else {
                        tabs.removeClass('elfinder-preference-taball').children().hide();
                        $(h).show();
                    }
                }).on('focus blur', 'a', function (e) {
                    $(this).parent().toggleClass('ui-state-focus', e.type === 'focusin');
                }).on('mouseenter mouseleave', 'li', function (e) {
                    $(this).toggleClass('ui-state-hover', e.type === 'mouseenter');
                });

                tabs.find('a,input,select,button').addClass('elfinder-tabstop');
                base.append(ul, tabs);

                dialog = self.fmDialog(base, {
                    title: self.title,
                    width: self.options.width || 600,
                    height: self.options.height || 400,
                    maxWidth: 'window',
                    maxHeight: 'window',
                    autoOpen: false,
                    destroyOnClose: false,
                    allowMinimize: false,
                    open: function () {
                        openTab && selectTab(openTab);
                        openTab = null;
                    },
                    resize: function () {
                        tabs.height(dialog.height() - ul.outerHeight(true) - (tabs.outerHeight(true) - tabs.height()) - 5);
                    }
                })
                    .on('click', function (e) {
                        e.stopPropagation();
                    })
                    .css({
                        overflow: 'hidden'
                    });

                dialog.closest('.ui-dialog')
                    .css({
                        overflow: 'hidden'
                    })
                    .addClass('elfinder-bg-translucent');

                openTab = 'all';
            },
            dialog, openTab;

        this.shortcuts = [{
            pattern: 'ctrl+comma',
            description: this.title
        }];

        this.alwaysEnabled = true;

        this.getstate = function () {
            return 0;
        };

        this.exec = function (sel, cOpts) {
            !dialog && build();
            if (cOpts) {
                if (cOpts.tab) {
                    selectTab(cOpts.tab);
                } else if (cOpts._currentType === 'cwd') {
                    selectTab('workspace');
                }
            }
            dialog.elfinderdialog('open');
            return $.Deferred().resolve();
        };

    };

    /*
     * File: /js/commands/quicklook.js
     */

    /**
     * @class  elFinder command "quicklook"
     * Fast preview for some files types
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.quicklook = function () {
        var self = this,
            fm = self.fm,
            /**
             * window closed state
             *
             * @type Number
             **/
            closed = 0,
            /**
             * window animated state
             *
             * @type Number
             **/
            animated = 1,
            /**
             * window opened state
             *
             * @type Number
             **/
            opened = 2,
            /**
             * window docked state
             *
             * @type Number
             **/
            docked = 3,
            /**
             * window docked and hidden state
             *
             * @type Number
             **/
            dockedhidden = 4,
            /**
             * window state
             *
             * @type Number
             **/
            state = closed,
            /**
             * Event name of update
             * for fix conflicts with Prototype.JS
             * 
             * `@see https://github.com/Studio-42/elFinder/pull/2346
             * @type String
             **/
            evUpdate = Element.update ? 'quicklookupdate' : 'update',
            /**
             * navbar icon class
             *
             * @type String
             **/
            navicon = 'elfinder-quicklook-navbar-icon',
            /**
             * navbar "fullscreen" icon class
             *
             * @type String
             **/
            fullscreen = 'elfinder-quicklook-fullscreen',
            /**
             * info wrapper class
             * 
             * @type String
             */
            infocls = 'elfinder-quicklook-info-wrapper',
            /**
             * Triger keydown/keypress event with left/right arrow key code
             *
             * @param  Number  left/right arrow key code
             * @return void
             **/
            navtrigger = function (code) {
                $(document).trigger($.Event('keydown', { keyCode: code, ctrlKey: false, shiftKey: false, altKey: false, metaKey: false }));
            },
            /**
             * Return css for closed window
             *
             * @param  jQuery  file node in cwd
             * @return void
             **/
            closedCss = function (node) {
                var elf = fm.getUI().offset(),
                    base = (function () {
                        var target = node.find('.elfinder-cwd-file-wrapper');
                        return target.length ? target : node;
                    })(),
                    baseOffset = base.offset() || { top: 0, left: 0 };
                return {
                    opacity: 0,
                    width: base.width(),
                    height: base.height() - 30,
                    top: baseOffset.top - elf.top,
                    left: baseOffset.left - elf.left
                };
            },
            /**
             * Return css for opened window
             *
             * @return void
             **/
            openedCss = function () {
                var contain = self.options.contain || fm.options.dialogContained,
                    win = contain ? fm.getUI() : $(window),
                    elf = fm.getUI().offset(),
                    w = Math.min(width, win.width() - 10),
                    h = Math.min(height, win.height() - 80);
                return {
                    opacity: 1,
                    width: w,
                    height: h,
                    top: parseInt((win.height() - h - 60) / 2 + (contain ? 0 : win.scrollTop() - elf.top)),
                    left: parseInt((win.width() - w) / 2 + (contain ? 0 : win.scrollLeft() - elf.left))
                };
            },

            mediaNode = {},
            support = function (codec, name) {
                var node = name || codec.substr(0, codec.indexOf('/')),
                    media = mediaNode[node] ? mediaNode[node] : (mediaNode[node] = document.createElement(node)),
                    value = false;

                try {
                    value = media.canPlayType && media.canPlayType(codec);
                } catch (e) { }

                return (value && value !== '' && value != 'no') ? true : false;
            },

            platformWin = (window.navigator.platform.indexOf('Win') != -1),

            /**
             * Opened window width (from config)
             *
             * @type Number
             **/
            width,
            /**
             * Opened window height (from config)
             *
             * @type Number
             **/
            height,
            /**
             * Previous style before docked
             *
             * @type String
             **/
            prevStyle,
            /**
             * elFinder node
             *
             * @type jQuery
             **/
            parent,
            /**
             * elFinder current directory node
             *
             * @type jQuery
             **/
            cwd,
            /**
             * Current directory hash
             *
             * @type String
             **/
            cwdHash,
            dockEnabled = false,
            navdrag = false,
            navmove = false,
            navtm = null,
            leftKey = $.ui.keyCode.LEFT,
            rightKey = $.ui.keyCode.RIGHT,
            coverEv = 'mousemove touchstart ' + ('onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll'),
            title = $('<span class="elfinder-dialog-title elfinder-quicklook-title"></span>'),
            icon = $('<div></div>'),
            info = $('<div class="elfinder-quicklook-info"></div>'),//.hide(),
            cover = $('<div class="ui-front elfinder-quicklook-cover"></div>'),
            fsicon = $('<div class="' + navicon + ' ' + navicon + '-fullscreen"></div>')
                .on('click touchstart', function (e) {
                    if (navmove) {
                        return;
                    }

                    var win = self.window,
                        full = win.hasClass(fullscreen),
                        $window = $(window),
                        resize = function () { self.preview.trigger('changesize'); };

                    e.stopPropagation();
                    e.preventDefault();

                    if (full) {
                        navStyle = '';
                        navShow();
                        win.toggleClass(fullscreen)
                            .css(win.data('position'));
                        $window.trigger(self.resize).off(self.resize, resize);
                        navbar.off('mouseenter mouseleave');
                        cover.off(coverEv);
                    } else {
                        win.toggleClass(fullscreen)
                            .data('position', {
                                left: win.css('left'),
                                top: win.css('top'),
                                width: win.width(),
                                height: win.height(),
                                display: 'block'
                            })
                            .removeAttr('style');

                        $(window).on(self.resize, resize)
                            .trigger(self.resize);

                        cover.on(coverEv, function (e) {
                            if (!navdrag) {
                                if (e.type === 'mousemove' || e.type === 'touchstart') {
                                    navShow();
                                    navtm = setTimeout(function () {
                                        if (fm.UA.Mobile || navbar.parent().find('.elfinder-quicklook-navbar:hover').length < 1) {
                                            navbar.fadeOut('slow', function () {
                                                cover.show();
                                            });
                                        }
                                    }, 3000);
                                }
                                if (cover.is(':visible')) {
                                    coverHide();
                                    cover.data('tm', setTimeout(function () {
                                        cover.show();
                                    }, 3000));
                                }
                            }
                        }).show().trigger('mousemove');

                        navbar.on('mouseenter mouseleave', function (e) {
                            if (!navdrag) {
                                if (e.type === 'mouseenter') {
                                    navShow();
                                } else {
                                    cover.trigger('mousemove');
                                }
                            }
                        });
                    }
                    if (fm.zIndex) {
                        win.css('z-index', fm.zIndex + 1);
                    }
                    if (fm.UA.Mobile) {
                        navbar.attr('style', navStyle);
                    } else {
                        navbar.attr('style', navStyle).draggable(full ? 'destroy' : {
                            start: function () {
                                navdrag = true;
                                navmove = true;
                                cover.show();
                                navShow();
                            },
                            stop: function () {
                                navdrag = false;
                                navStyle = self.navbar.attr('style');
                                requestAnimationFrame(function () {
                                    navmove = false;
                                });
                            }
                        });
                    }
                    $(this).toggleClass(navicon + '-fullscreen-off');
                    var collection = win;
                    if (parent.is('.ui-resizable')) {
                        collection = collection.add(parent);
                    }
                    collection.resizable(full ? 'enable' : 'disable').removeClass('ui-state-disabled');

                    win.trigger('viewchange');
                }
                ),

            updateOnSel = function () {
                self.update(void (0), (function () {
                    var fm = self.fm,
                        files = fm.selectedFiles(),
                        cnt = files.length,
                        inDock = self.docked(),
                        getInfo = function () {
                            var ts = 0;
                            $.each(files, function (i, f) {
                                var t = parseInt(f.ts);
                                if (ts >= 0) {
                                    if (t > ts) {
                                        ts = t;
                                    }
                                } else {
                                    ts = 'unknown';
                                }
                            });
                            return {
                                hash: files[0].hash + '/' + (+new Date()),
                                name: fm.i18n('items') + ': ' + cnt,
                                mime: 'group',
                                size: spinner,
                                ts: ts,
                                files: $.map(files, function (f) { return f.hash; }),
                                getSize: true
                            };
                        };
                    if (!cnt) {
                        cnt = 1;
                        files = [fm.cwd()];
                    }
                    return (cnt === 1) ? files[0] : getInfo();
                })());
            },

            navShow = function () {
                if (self.window.hasClass(fullscreen)) {
                    navtm && clearTimeout(navtm);
                    navtm = null;
                    // if use `show()` it make infinite loop with old jQuery (jQuery/jQuery UI: 1.8.0/1.9.0)
                    // see #1478 https://github.com/Studio-42/elFinder/issues/1478
                    navbar.stop(true, true).css('display', 'block');
                    coverHide();
                }
            },

            coverHide = function () {
                cover.data('tm') && clearTimeout(cover.data('tm'));
                cover.removeData('tm');
                cover.hide();
            },

            prev = $('<div class="' + navicon + ' ' + navicon + '-prev"></div>').on('click touchstart', function (e) { !navmove && navtrigger(leftKey); return false; }),
            next = $('<div class="' + navicon + ' ' + navicon + '-next"></div>').on('click touchstart', function (e) { !navmove && navtrigger(rightKey); return false; }),
            navbar = $('<div class="elfinder-quicklook-navbar"></div>')
                .append(prev)
                .append(fsicon)
                .append(next)
                .append('<div class="elfinder-quicklook-navbar-separator"></div>')
                .append($('<div class="' + navicon + ' ' + navicon + '-close"></div>').on('click touchstart', function (e) { !navmove && self.window.trigger('close'); return false; }))
            ,
            titleClose = $('<span class="ui-front ui-icon elfinder-icon-close ui-icon-closethick"></span>').on('mousedown', function (e) {
                e.stopPropagation();
                self.window.trigger('close');
            }),
            titleDock = $('<span class="ui-front ui-icon elfinder-icon-minimize ui-icon-minusthick"></span>').on('mousedown', function (e) {
                e.stopPropagation();
                if (!self.docked()) {
                    self.window.trigger('navdockin');
                } else {
                    self.window.trigger('navdockout');
                }
            }),
            spinner = '<span class="elfinder-spinner-text">' + fm.i18n('calc') + '</span>' + '<span class="elfinder-spinner"></span>',
            navStyle = '',
            init = true,
            dockHeight, getSize, tm4cwd, dockedNode, selectTm;

        /**
         * Any flags for each plugin
         */
        this.flags = {};

        this.cover = cover;
        this.evUpdate = evUpdate;
        (this.navbar = navbar)._show = navShow;
        this.resize = 'resize.' + fm.namespace;
        this.info = $('<div></div>').addClass(infocls)
            .append(icon)
            .append(info);
        this.autoPlay = function () {
            if (self.opened()) {
                return !!self.options[self.docked() ? 'dockAutoplay' : 'autoplay'];
            }
            return false;
        };
        this.preview = $('<div class="elfinder-quicklook-preview ui-helper-clearfix"></div>')
            // clean info/icon
            .on('change', function () {
                navShow();
                navbar.attr('style', navStyle);
                self.docked() && navbar.hide();
                self.preview.attr('style', '').removeClass('elfinder-overflow-auto');
                self.info.attr('style', '').hide();
                self.cover.removeClass('elfinder-quicklook-coverbg');
                icon.removeAttr('class').attr('style', '');
                info.html('');
            })
            // update info/icon
            .on(evUpdate, function (e) {
                var preview = self.preview,
                    file = e.file,
                    tpl = '<div class="elfinder-quicklook-info-data">{value}</div>',
                    update = function () {
                        var win = self.window.css('overflow', 'hidden');
                        name = fm.escape(file.i18 || file.name);
                        !file.read && e.stopImmediatePropagation();
                        self.window.data('hash', file.hash);
                        self.preview.off('changesize').trigger('change').children().remove();
                        title.html(name);

                        prev.css('visibility', '');
                        next.css('visibility', '');
                        if (file.hash === fm.cwdId2Hash(cwd.find('[id]:not(.elfinder-cwd-parent):first').attr('id'))) {
                            prev.css('visibility', 'hidden');
                        }
                        if (file.hash === fm.cwdId2Hash(cwd.find('[id]:last').attr('id'))) {
                            next.css('visibility', 'hidden');
                        }

                        if (file.mime === 'directory') {
                            getSizeHashes = [file.hash];
                        } else if (file.mime === 'group' && file.getSize) {
                            getSizeHashes = file.files;
                        }

                        info.html(
                            tpl.replace(/\{value\}/, name)
                            + tpl.replace(/\{value\}/, fm.mime2kind(file))
                            + tpl.replace(/\{value\}/, getSizeHashes.length ? spinner : fm.formatSize(file.size))
                            + tpl.replace(/\{value\}/, fm.i18n('modify') + ': ' + fm.formatDate(file))
                        );

                        if (getSizeHashes.length) {
                            getSize = fm.getSize(getSizeHashes).done(function (data) {
                                info.find('span.elfinder-spinner').parent().html(data.formated);
                            }).fail(function () {
                                info.find('span.elfinder-spinner').parent().html(fm.i18n('unknown'));
                            }).always(function () {
                                getSize = null;
                            });
                            getSize._hash = file.hash;
                        }

                        icon.addClass('elfinder-cwd-icon ui-corner-all ' + fm.mime2class(file.mime));

                        if (file.icon) {
                            icon.css(fm.getIconStyle(file, true));
                        }

                        self.info.attr('class', infocls);
                        if (file.csscls) {
                            self.info.addClass(file.csscls);
                        }

                        if (file.read && (tmb = fm.tmb(file))) {
                            $('<img/>')
                                .hide()
                                .appendTo(self.preview)
                                .on('load', function () {
                                    icon.addClass(tmb.className).css('background-image', "url('" + tmb.url + "')");
                                    $(this).remove();
                                })
                                .attr('src', tmb.url);
                        }
                        self.info.delay(100).fadeIn(10);
                        if (self.window.hasClass(fullscreen)) {
                            cover.trigger('mousemove');
                        }
                        win.css('overflow', '');
                    },
                    tmb, name, getSizeHashes = [];

                if (file && !Object.keys(file).length) {
                    file = fm.cwd();
                }
                if (file && getSize && getSize.state() === 'pending' && getSize._hash !== file.hash) {
                    getSize.reject();
                }
                if (file && (e.forceUpdate || self.window.data('hash') !== file.hash)) {
                    update();
                } else {
                    e.stopImmediatePropagation();
                }
            });

        this.window = $('<div class="ui-front ui-helper-reset ui-widget elfinder-quicklook touch-punch" style="position:absolute"></div>')
            .hide()
            .addClass(fm.UA.Touch ? 'elfinder-touch' : '')
            .on('click', function (e) {
                var win = this;
                e.stopPropagation();
                if (state === opened) {
                    requestAnimationFrame(function () {
                        state === opened && fm.toFront(win);
                    });
                }
            })
            .append(
                $('<div class="ui-dialog-titlebar ui-widget-header ui-corner-top ui-helper-clearfix elfinder-quicklook-titlebar"></div>')
                    .append(
                        $('<span class="ui-widget-header ui-dialog-titlebar-close ui-corner-all elfinder-titlebar-button elfinder-quicklook-titlebar-icon' + (platformWin ? ' elfinder-titlebar-button-right' : '') + '"></span>').append(
                            titleClose, titleDock
                        ),
                        title
                    ),
                this.preview,
                self.info.hide(),
                cover.hide(),
                navbar
            )
            .draggable({ handle: 'div.elfinder-quicklook-titlebar' })
            .on('open', function (e, clcss) {
                var win = self.window,
                    file = self.value,
                    node = fm.getUI('cwd'),
                    open = function (status) {
                        state = status;
                        self.update(1, self.value);
                        self.change();
                        win.trigger('resize.' + fm.namespace);
                    };

                if (!init && state === closed) {
                    if (file && file.hash !== cwdHash) {
                        node = fm.cwdHash2Elm(file.hash.split('/', 2)[0]);
                    }
                    navStyle = '';
                    navbar.attr('style', '');
                    state = animated;
                    node.trigger('scrolltoview');
                    coverHide();
                    win.css(clcss || closedCss(node))
                        .show()
                        .animate(openedCss(), 550, function () {
                            open(opened);
                            navShow();
                        });
                    fm.toFront(win);
                } else if (state === dockedhidden) {
                    fm.getUI('navdock').data('addNode')(dockedNode);
                    open(docked);
                    self.preview.trigger('changesize');
                    fm.storage('previewDocked', '1');
                    if (fm.getUI('navdock').width() === 0) {
                        win.trigger('navdockout');
                    }
                }
            })
            .on('close', function (e, dfd) {
                var win = self.window,
                    preview = self.preview.trigger('change'),
                    file = self.value,
                    hash = (win.data('hash') || '').split('/', 2)[0],
                    close = function (status, winhide) {
                        state = status;
                        winhide && fm.toHide(win);
                        preview.children().remove();
                        self.update(0, self.value);
                        win.data('hash', '');
                        dfd && dfd.resolve();
                    },
                    node;

                if (self.opened()) {
                    getSize && getSize.state() === 'pending' && getSize.reject();
                    if (!self.docked()) {
                        state = animated;
                        win.hasClass(fullscreen) && fsicon.click();
                        (hash && (node = cwd.find('#' + hash)).length)
                            ? win.animate(closedCss(node), 500, function () {
                                preview.off('changesize');
                                close(closed, true);
                            })
                            : close(closed, true);
                    } else {
                        dockedNode = fm.getUI('navdock').data('removeNode')(self.window.attr('id'), 'detach');
                        close(dockedhidden);
                        fm.storage('previewDocked', '2');
                    }
                }
            })
            .on('navdockin', function (e, data) {
                var w = self.window,
                    box = fm.getUI('navdock'),
                    height = dockHeight || box.width(),
                    opts = data || {};

                if (init) {
                    opts.init = true;
                }
                state = docked;
                prevStyle = w.attr('style');
                w.toggleClass('ui-front').removeClass('ui-widget').draggable('disable').resizable('disable').removeAttr('style').css({
                    width: '100%',
                    height: height,
                    boxSizing: 'border-box',
                    paddingBottom: 0,
                    zIndex: 'unset'
                });
                navbar.hide();
                titleDock.toggleClass('ui-icon-plusthick ui-icon-minusthick elfinder-icon-full elfinder-icon-minimize');

                fm.toHide(w, true);
                box.data('addNode')(w, opts);

                self.preview.trigger('changesize');

                fm.storage('previewDocked', '1');
            })
            .on('navdockout', function (e) {
                var w = self.window,
                    box = fm.getUI('navdock'),
                    dfd = $.Deferred(),
                    clcss = closedCss(self.preview);

                dockHeight = w.outerHeight();
                box.data('removeNode')(w.attr('id'), fm.getUI());
                w.toggleClass('ui-front').addClass('ui-widget').draggable('enable').resizable('enable').attr('style', prevStyle);
                titleDock.toggleClass('ui-icon-plusthick ui-icon-minusthick elfinder-icon-full elfinder-icon-minimize');

                state = closed;
                w.trigger('open', clcss);

                fm.storage('previewDocked', '0');
            })
            .on('resize.' + fm.namespace, function () {
                self.preview.trigger('changesize');
            });

        /**
         * This command cannot be disable by backend
         *
         * @type Boolean
         **/
        this.alwaysEnabled = true;

        /**
         * Selected file
         *
         * @type Object
         **/
        this.value = null;

        this.handlers = {
            // save selected file
            select: function (e, d) {
                selectTm && cancelAnimationFrame(selectTm);
                if (!e.data || !e.data.selected || !e.data.selected.length) {
                    selectTm = requestAnimationFrame(function () {
                        self.opened() && updateOnSel();
                    });
                } else {
                    self.opened() && updateOnSel();
                }
            },
            error: function () { self.window.is(':visible') && self.window.trigger('close'); },
            'searchshow searchhide': function () { this.opened() && this.window.trigger('close'); },
            navbarshow: function () {
                requestAnimationFrame(function () {
                    self.docked() && self.preview.trigger('changesize');
                });
            },
            destroy: function () { self.window.remove(); }
        };

        this.shortcuts = [{
            pattern: 'space'
        }];

        this.support = {
            audio: {
                ogg: support('audio/ogg;'),
                webm: support('audio/webm;'),
                mp3: support('audio/mpeg;'),
                wav: support('audio/wav;'),
                m4a: support('audio/mp4;') || support('audio/x-m4a;') || support('audio/aac;'),
                flac: support('audio/flac;'),
                amr: support('audio/amr;')
            },
            video: {
                ogg: support('video/ogg;'),
                webm: support('video/webm;'),
                mp4: support('video/mp4;'),
                mkv: support('video/x-matroska;') || support('video/webm;'),
                '3gp': support('video/3gpp;') || support('video/mp4;'), // try as mp4
                m3u8: support('application/x-mpegURL', 'video') || support('application/vnd.apple.mpegURL', 'video'),
                mpd: support('application/dash+xml', 'video')
            }
        };
        // for GC
        mediaNode = {};

        /**
         * Return true if quickLoock window is hiddenReturn true if quickLoock window is visible and not animated
         *
         * @return Boolean
         **/
        this.closed = function () {
            return (state == closed || state == dockedhidden);
        };

        /**
         * Return true if quickLoock window is visible and not animated
         *
         * @return Boolean
         **/
        this.opened = function () {
            return state == opened || state == docked;
        };

        /**
         * Return true if quickLoock window is in NavDock
         *
         * @return Boolean
         **/
        this.docked = function () {
            return state == docked;
        };

        /**
         * Adds an integration into help dialog.
         *
         * @param Object opts  options
         */
        this.addIntegration = function (opts) {
            requestAnimationFrame(function () {
                fm.trigger('helpIntegration', Object.assign({ cmd: 'quicklook' }, opts));
            });
        };

        /**
         * Init command.
         * Add default plugins and init other plugins
         *
         * @return Object
         **/
        this.init = function () {
            var o = this.options,
                win = this.window,
                preview = this.preview,
                i, p, cwdDispInlineRegex;

            width = o.width > 0 ? parseInt(o.width) : 450;
            height = o.height > 0 ? parseInt(o.height) : 300;
            if (o.dockHeight !== 'auto') {
                dockHeight = parseInt(o.dockHeight);
                if (!dockHeight) {
                    dockHeight = void (0);
                }
            }

            fm.one('load', function () {

                dockEnabled = fm.getUI('navdock').data('dockEnabled');

                !dockEnabled && titleDock.hide();

                parent = fm.getUI();
                cwd = fm.getUI('cwd');

                if (fm.zIndex) {
                    win.css('z-index', fm.zIndex + 1);
                }

                win.appendTo(parent);

                // close window on escape
                $(document).on('keydown.' + fm.namespace, function (e) {
                    e.keyCode == $.ui.keyCode.ESCAPE && self.opened() && !self.docked() && win.hasClass('elfinder-frontmost') && win.trigger('close');
                });

                win.resizable({
                    handles: 'se',
                    minWidth: 350,
                    minHeight: 120,
                    resize: function () {
                        // use another event to avoid recursion in fullscreen mode
                        // may be there is clever solution, but i cant find it :(
                        preview.trigger('changesize');
                    }
                });

                self.change(function () {
                    if (self.opened()) {
                        if (self.value) {
                            if (self.value.tmb && self.value.tmb == 1) {
                                // try re-get file object
                                self.value = Object.assign({}, fm.file(self.value.hash));
                            }
                            preview.trigger($.Event(evUpdate, { file: self.value }));
                        }
                    }
                });

                preview.on(evUpdate, function (e) {
                    var file, hash, serach;

                    if (file = e.file) {
                        hash = file.hash;
                        serach = (fm.searchStatus.mixed && fm.searchStatus.state > 1);

                        if (file.mime !== 'directory') {
                            if (parseInt(file.size) || file.mime.match(o.mimeRegexNotEmptyCheck)) {
                                // set current dispInlineRegex
                                self.dispInlineRegex = cwdDispInlineRegex;
                                if (serach || fm.optionsByHashes[hash]) {
                                    try {
                                        self.dispInlineRegex = new RegExp(fm.option('dispInlineRegex', hash), 'i');
                                    } catch (e) {
                                        try {
                                            self.dispInlineRegex = new RegExp(!fm.isRoot(file) ? fm.option('dispInlineRegex', file.phash) : fm.options.dispInlineRegex, 'i');
                                        } catch (e) {
                                            self.dispInlineRegex = /^$/;
                                        }
                                    }
                                }
                            } else {
                                //  do not preview of file that size = 0
                                e.stopImmediatePropagation();
                            }
                        } else {
                            self.dispInlineRegex = /^$/;
                        }

                        self.info.show();
                    } else {
                        e.stopImmediatePropagation();
                    }
                });

                $.each(fm.commands.quicklook.plugins || [], function (i, plugin) {
                    if (typeof (plugin) == 'function') {
                        new plugin(self);
                    }
                });
            }).one('open', function () {
                var dock = Number(fm.storage('previewDocked') || o.docked),
                    win;
                if (dockEnabled && dock >= 1) {
                    win = self.window;
                    self.exec();
                    win.trigger('navdockin', { init: true });
                    if (dock === 2) {
                        win.trigger('close');
                    } else {
                        self.update(void (0), fm.cwd());
                        self.change();
                    }
                }
                init = false;
            }).bind('open', function () {
                cwdHash = fm.cwd().hash;
                self.value = fm.cwd();
                // set current volume dispInlineRegex
                try {
                    cwdDispInlineRegex = new RegExp(fm.option('dispInlineRegex'), 'i');
                } catch (e) {
                    cwdDispInlineRegex = /^$/;
                }
            }).bind('change', function (e) {
                if (e.data && e.data.changed && self.opened()) {
                    $.each(e.data.changed, function () {
                        if (self.window.data('hash') === this.hash) {
                            self.window.data('hash', null);
                            self.preview.trigger(evUpdate);
                            return false;
                        }
                    });
                }
            }).bind('navdockresizestart navdockresizestop', function (e) {
                cover[e.type === 'navdockresizestart' ? 'show' : 'hide']();
            });
        };

        this.getstate = function () {
            return self.opened() ? 1 : 0;
        };

        this.exec = function () {
            self.closed() && updateOnSel();
            self.enabled() && self.window.trigger(self.opened() ? 'close' : 'open');
            return $.Deferred().resolve();
        };

        this.hideinfo = function () {
            this.info.stop(true, true).hide();
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/quicklook.plugins.js
     */

    elFinder.prototype.commands.quicklook.plugins = [

        /**
         * Images preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var mimes = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/x-ms-bmp'],
                getDimSize = ql.fm.returnBytes((ql.options.getDimThreshold || 0)),
                preview = ql.preview,
                WebP, flipMime;

            // webp support
            WebP = new Image();
            WebP.onload = WebP.onerror = function () {
                if (WebP.height == 2) {
                    mimes.push('image/webp');
                }
            };
            WebP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';

            // what kind of images we can display
            $.each(navigator.mimeTypes, function (i, o) {
                var mime = o.type;

                if (mime.indexOf('image/') === 0 && $.inArray(mime, mimes)) {
                    mimes.push(mime);
                }
            });

            preview.on(ql.evUpdate, function (e) {
                var fm = ql.fm,
                    file = e.file,
                    showed = false,
                    dimreq = null,
                    setdim = function (dim) {
                        var rfile = fm.file(file.hash);
                        rfile.width = dim[0];
                        rfile.height = dim[1];
                    },
                    show = function () {
                        var elm, varelm, memSize, width, height, prop;

                        dimreq && dimreq.state && dimreq.state() === 'pending' && dimreq.reject();
                        if (showed) {
                            return;
                        }
                        showed = true;

                        elm = img.get(0);
                        memSize = file.width && file.height ? { w: file.width, h: file.height } : (elm.naturalWidth ? null : { w: img.width(), h: img.height() });

                        memSize && img.removeAttr('width').removeAttr('height');

                        width = file.width || elm.naturalWidth || elm.width || img.width();
                        height = file.height || elm.naturalHeight || elm.height || img.height();
                        if (!file.width || !file.height) {
                            setdim([width, height]);
                        }

                        memSize && img.width(memSize.w).height(memSize.h);

                        prop = (width / height).toFixed(2);
                        preview.on('changesize', function () {
                            var pw = parseInt(preview.width()),
                                ph = parseInt(preview.height()),
                                w, h;

                            if (prop < (pw / ph).toFixed(2)) {
                                h = ph;
                                w = Math.floor(h * prop);
                            } else {
                                w = pw;
                                h = Math.floor(w / prop);
                            }
                            img.width(w).height(h).css('margin-top', h < ph ? Math.floor((ph - h) / 2) : 0);

                        })
                            .trigger('changesize');

                        //show image
                        img.fadeIn(100);
                    },
                    hideInfo = function () {
                        loading.remove();
                        // hide info/icon
                        ql.hideinfo();
                    },
                    url, img, loading, prog, m, opDfd;

                if (!flipMime) {
                    flipMime = fm.arrayFlip(mimes);
                }
                if (flipMime[file.mime] && ql.dispInlineRegex.test(file.mime)) {
                    // this is our file - stop event propagation
                    e.stopImmediatePropagation();

                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                    img = $('<img/>')
                        .hide()
                        .appendTo(preview)
                        .on('load', function () {
                            hideInfo();
                            show();
                        })
                        .on('error', function () {
                            loading.remove();
                        });
                    opDfd = fm.openUrl(file.hash, false, function (url) {
                        img.attr('src', url);
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });

                    if (file.width && file.height) {
                        show();
                    } else if (file.size > getDimSize) {
                        dimreq = fm.request({
                            data: { cmd: 'dim', target: file.hash },
                            preventDefault: true
                        })
                            .done(function (data) {
                                if (data.dim) {
                                    var dim = data.dim.split('x');
                                    file.width = dim[0];
                                    file.height = dim[1];
                                    setdim(dim);
                                    show();
                                }
                            });
                    }
                }

            });
        },

        /**
         * TIFF image preview
         *
         * @param  object  ql  elFinder.commands.quicklook
         */
        function (ql) {
            var fm = ql.fm,
                mime = 'image/tiff',
                preview = ql.preview;
            if (window.Worker && window.Uint8Array) {
                preview.on(ql.evUpdate, function (e) {
                    var file = e.file,
                        err = function (e) {
                            wk && wk.terminate();
                            loading.remove();
                            fm.debug('error', e);
                        },
                        setdim = function (dim) {
                            var rfile = fm.file(file.hash);
                            rfile.width = dim[0];
                            rfile.height = dim[1];
                        },
                        loading, prog, url, base, wk, opDfd;
                    if (file.mime === mime) {
                        e.stopImmediatePropagation();

                        loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                        prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            wk && wk.terminate();
                            loading.remove();
                        });

                        opDfd = fm.getContents(file.hash, 'arraybuffer', { progressBar: prog }).done(function (data) {
                            if (data) {
                                base = $('<div></div>').css({ width: '100%', height: '100%' }).hide().appendTo(preview);
                                try {
                                    wk = fm.getWorker();
                                    wk.onmessage = function (res) {
                                        var data = res.data,
                                            cv, co, id, prop;
                                        wk && wk.terminate();
                                        cv = document.createElement('canvas');
                                        co = cv.getContext('2d');
                                        cv.width = data.width;
                                        cv.height = data.height;
                                        id = co.createImageData(data.width, data.height);
                                        (id).data.set(new Uint8Array(data.image));
                                        co.putImageData(id, 0, 0);
                                        base.append(cv).show();
                                        loading.remove();
                                        prop = (data.width / data.height).toFixed(2);
                                        preview.on('changesize', function () {
                                            var pw = parseInt(preview.width()),
                                                ph = parseInt(preview.height()),
                                                w, h;
                                            if (prop < (pw / ph).toFixed(2)) {
                                                h = ph;
                                                w = Math.floor(h * prop);
                                            } else {
                                                w = pw;
                                                h = Math.floor(w / prop);
                                            }
                                            $(cv).width(w).height(h).css('margin-top', h < ph ? Math.floor((ph - h) / 2) : 0);
                                        }).trigger('changesize');
                                        if (!file.width || !file.height) {
                                            setdim([data.width, data.height]);
                                        }
                                        ql.hideinfo();
                                    };
                                    wk.onerror = err;
                                    wk.postMessage({
                                        scripts: [fm.options.cdns.tiff, fm.getWorkerUrl('quicklook.tiff.js')],
                                        data: { data: data }
                                    });
                                } catch (e) {
                                    err(e);
                                }
                            } else {
                                err();
                            }
                        });
                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                        });
                    }
                });
            }
        },

        /**
         * PSD(Adobe Photoshop data) preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = fm.arrayFlip(['image/vnd.adobe.photoshop', 'image/x-photoshop']),
                preview = ql.preview,
                load = function (url, img, loading) {
                    try {
                        fm.replaceXhrSend();
                        PSD.fromURL(url).then(function (psd) {
                            var prop;
                            img.attr('src', psd.image.toBase64());
                            requestAnimationFrame(function () {
                                prop = (img.width() / img.height()).toFixed(2);
                                preview.on('changesize', function () {
                                    var pw = parseInt(preview.width()),
                                        ph = parseInt(preview.height()),
                                        w, h;

                                    if (prop < (pw / ph).toFixed(2)) {
                                        h = ph;
                                        w = Math.floor(h * prop);
                                    } else {
                                        w = pw;
                                        h = Math.floor(w / prop);
                                    }
                                    img.width(w).height(h).css('margin-top', h < ph ? Math.floor((ph - h) / 2) : 0);
                                }).trigger('changesize');

                                loading.remove();
                                // hide info/icon
                                ql.hideinfo();
                                //show image
                                img.fadeIn(100);
                            });
                        }, function () {
                            loading.remove();
                            img.remove();
                        });
                        fm.restoreXhrSend();
                    } catch (e) {
                        fm.restoreXhrSend();
                        loading.remove();
                        img.remove();
                    }
                },
                PSD;

            preview.on(ql.evUpdate, function (e) {
                var file = e.file,
                    url, img, loading, prog, m,
                    _define, _require, opDfd;

                if (mimes[file.mime] && fm.options.cdns.psd && !fm.UA.ltIE10 && ql.dispInlineRegex.test(file.mime)) {
                    // this is our file - stop event propagation
                    e.stopImmediatePropagation();

                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                    opDfd = fm.openUrl(file.hash, 'sameorigin', function (url) {
                        if (url) {
                            img = $('<img/>').hide().appendTo(preview);
                            if (PSD) {
                                load(url, img, loading);
                            } else {
                                _define = window.define;
                                _require = window.require;
                                window.require = null;
                                window.define = null;
                                fm.loadScript(
                                    [fm.options.cdns.psd],
                                    function () {
                                        PSD = require('psd');
                                        _define ? (window.define = _define) : (delete window.define);
                                        _require ? (window.require = _require) : (delete window.require);
                                        load(url, img, loading);
                                    }
                                );
                            }
                        }
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                }
            });
        },

        /**
         * HTML preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = fm.arrayFlip(['text/html', 'application/xhtml+xml']),
                preview = ql.preview;

            preview.on(ql.evUpdate, function (e) {
                var file = e.file, jqxhr, loading, prog;

                if (mimes[file.mime] && ql.dispInlineRegex.test(file.mime) && (!ql.options.getSizeMax || file.size <= ql.options.getSizeMax)) {
                    e.stopImmediatePropagation();

                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        jqxhr.state() == 'pending' && jqxhr.reject();
                    }).addClass('elfinder-overflow-auto');

                    jqxhr = fm.request({
                        data: { cmd: 'get', target: file.hash, conv: 1, _t: file.ts },
                        options: { type: 'get', cache: true },
                        preventDefault: true,
                        progressBar: prog
                    })
                        .done(function (data) {
                            ql.hideinfo();
                            var doc = $('<iframe class="elfinder-quicklook-preview-html"></iframe>').appendTo(preview)[0].contentWindow.document;
                            doc.open();
                            doc.write(data.content);
                            doc.close();
                        })
                        .always(function () {
                            loading.remove();
                        });
                }
            });
        },

        /**
         * MarkDown preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = fm.arrayFlip(['text/x-markdown']),
                preview = ql.preview,
                marked = null,
                show = function (data, loading) {
                    ql.hideinfo();
                    var doc = $('<iframe class="elfinder-quicklook-preview-html"></iframe>').appendTo(preview)[0].contentWindow.document;
                    doc.open();
                    doc.write((marked.parse || marked)(data.content));
                    doc.close();
                    loading.remove();
                },
                error = function (loading) {
                    marked = false;
                    loading.remove();
                };

            preview.on(ql.evUpdate, function (e) {
                var file = e.file, jqxhr, loading, prog;

                if (mimes[file.mime] && fm.options.cdns.marked && marked !== false && ql.dispInlineRegex.test(file.mime) && (!ql.options.getSizeMax || file.size <= ql.options.getSizeMax)) {
                    e.stopImmediatePropagation();

                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        jqxhr.state() == 'pending' && jqxhr.reject();
                    }).addClass('elfinder-overflow-auto');

                    jqxhr = fm.request({
                        data: { cmd: 'get', target: file.hash, conv: 1, _t: file.ts },
                        options: { type: 'get', cache: true },
                        preventDefault: true,
                        progressBar: prog
                    })
                        .done(function (data) {
                            if (marked || window.marked) {
                                if (!marked) {
                                    marked = window.marked;
                                }
                                show(data, loading);
                            } else {
                                fm.loadScript([fm.options.cdns.marked],
                                    function (res) {
                                        marked = res || window.marked || false;
                                        delete window.marked;
                                        if (marked) {
                                            show(data, loading);
                                        } else {
                                            error(loading);
                                        }
                                    },
                                    {
                                        tryRequire: true,
                                        error: function () {
                                            error(loading);
                                        }
                                    }
                                );
                            }
                        })
                        .fail(function () {
                            error(loading);
                        });
                }
            });
        },

        /**
         * PDF/ODT/ODS/ODP preview with ViewerJS
         * 
         * @param elFinder.commands.quicklook
         */
        function (ql) {
            if (ql.options.viewerjs) {
                var fm = ql.fm,
                    preview = ql.preview,
                    opts = ql.options.viewerjs,
                    mimes = opts.url ? fm.arrayFlip(opts.mimes || []) : [],
                    win = ql.window,
                    navi = ql.navbar,
                    setNavi = function () {
                        navi.css('bottom', win.hasClass('elfinder-quicklook-fullscreen') ? '30px' : '');
                    };

                if (opts.url) {
                    preview.on('update', function (e) {
                        var file = e.file, node, loading, prog, opDfd;

                        if (mimes[file.mime] && (file.mime !== 'application/pdf' || !opts.pdfNative || !ql.flags.pdfNative)) {
                            e.stopImmediatePropagation();
                            loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                            prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                            opDfd = fm.openUrl(file.hash, 'sameorigin', function (url) {
                                if (url) {
                                    node = $('<iframe class="elfinder-quicklook-preview-iframe"></iframe>')
                                        .css('background-color', 'transparent')
                                        .on('load', function () {
                                            ql.hideinfo();
                                            loading.remove();
                                            node.css('background-color', '#fff');
                                        })
                                        .on('error', function () {
                                            loading.remove();
                                            node.remove();
                                        })
                                        .appendTo(preview)
                                        .attr('src', opts.url + '#' + url);

                                    win.on('viewchange.viewerjs', setNavi);
                                    setNavi();

                                    preview.one('change', function () {
                                        win.off('viewchange.viewerjs');
                                        loading.remove();
                                        node.off('load').remove();
                                    });
                                }
                            }, { progressBar: prog });
                            // stop loading on change file if not loaded yet
                            preview.one('change', function () {
                                opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                            });
                        }
                    });
                }
            }
        },

        /**
         * PDF preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mime = 'application/pdf',
                preview = ql.preview,
                active = false,
                urlhash = '',
                firefox, toolbar;

            if ((fm.UA.Safari && fm.OS === 'mac' && !fm.UA.iOS) || fm.UA.IE || fm.UA.Firefox) {
                active = true;
            } else {
                $.each(navigator.plugins, function (i, plugins) {
                    $.each(plugins, function (i, plugin) {
                        if (plugin.type === mime) {
                            return !(active = true);
                        }
                    });
                });
            }

            ql.flags.pdfNative = active;
            if (active) {
                if (typeof ql.options.pdfToolbar !== 'undefined' && !ql.options.pdfToolbar) {
                    urlhash = '#toolbar=0';
                }
                preview.on(ql.evUpdate, function (e) {
                    var file = e.file,
                        opDfd;

                    if (active && file.mime === mime && ql.dispInlineRegex.test(file.mime)) {
                        e.stopImmediatePropagation();
                        opDfd = fm.openUrl(file.hash, false, function (url) {
                            if (url) {
                                ql.hideinfo();
                                ql.cover.addClass('elfinder-quicklook-coverbg');
                                $('<object class="elfinder-quicklook-preview-pdf" data="' + url + urlhash + '" type="application/pdf" ></object>')
                                    .on('error', function (e) {
                                        active = false;
                                        ql.update(void (0), fm.cwd());
                                        ql.update(void (0), file);
                                    })
                                    .appendTo(preview);
                            }
                        });
                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                        });
                    }

                });
            }
        },

        /**
         * Flash preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mime = 'application/x-shockwave-flash',
                preview = ql.preview,
                active = false;

            $.each(navigator.plugins, function (i, plugins) {
                $.each(plugins, function (i, plugin) {
                    if (plugin.type === mime) {
                        return !(active = true);
                    }
                });
            });

            active && preview.on(ql.evUpdate, function (e) {
                var file = e.file,
                    node, opDfd;

                if (file.mime === mime && ql.dispInlineRegex.test(file.mime)) {
                    e.stopImmediatePropagation();
                    opDfd = fm.openUrl(file.hash, false, function (url) {
                        if (url) {
                            ql.hideinfo();
                            node = $('<embed class="elfinder-quicklook-preview-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" src="' + url + '" quality="high" type="application/x-shockwave-flash" wmode="transparent" />')
                                .appendTo(preview);
                        }
                    });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                }
            });
        },

        /**
         * HTML5 audio preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                preview = ql.preview,
                mimes = {
                    'audio/mpeg': 'mp3',
                    'audio/mpeg3': 'mp3',
                    'audio/mp3': 'mp3',
                    'audio/x-mpeg3': 'mp3',
                    'audio/x-mp3': 'mp3',
                    'audio/x-wav': 'wav',
                    'audio/wav': 'wav',
                    'audio/x-m4a': 'm4a',
                    'audio/aac': 'm4a',
                    'audio/mp4': 'm4a',
                    'audio/x-mp4': 'm4a',
                    'audio/ogg': 'ogg',
                    'audio/webm': 'webm',
                    'audio/flac': 'flac',
                    'audio/x-flac': 'flac',
                    'audio/amr': 'amr'
                },
                node, curHash,
                win = ql.window,
                navi = ql.navbar,
                AMR, autoplay,
                controlsList = typeof ql.options.mediaControlsList === 'string' && ql.options.mediaControlsList ? ' controlsList="' + fm.escape(ql.options.mediaControlsList) + '"' : '',
                setNavi = function () {
                    navi.css('bottom', win.hasClass('elfinder-quicklook-fullscreen') ? '50px' : '');
                },
                getNode = function (src, hash) {
                    return $('<audio class="elfinder-quicklook-preview-audio ui-front" controls' + controlsList + ' preload="auto" autobuffer><source src="' + src + '" ></source></audio>')
                        .on('change', function (e) {
                            // Firefox fire change event on seek or volume change
                            e.stopPropagation();
                        })
                        .on('error', function (e) {
                            node && node.data('hash') === hash && reset();
                        })
                        .data('hash', hash)
                        .appendTo(preview);
                },
                amrToWavUrl = function (hash) {
                    var dfd = $.Deferred(),
                        loader = $.Deferred().done(function () {
                            var opDfd;
                            opDfd = fm.getContents(hash, 'arraybuffer', { progressBar: prog }).done(function (data) {
                                try {
                                    var buffer = AMR.toWAV(new Uint8Array(data));
                                    if (buffer) {
                                        dfd.resolve(URL.createObjectURL(new Blob([buffer], { type: 'audio/x-wav' })));
                                    } else {
                                        dfd.reject();
                                    }
                                } catch (e) {
                                    dfd.reject();
                                }
                            }).fail(function () {
                                dfd.reject();
                            });
                            // stop loading on change file if not loaded yet
                            preview.one('change', function () {
                                opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                            });
                        }).fail(function () {
                            AMR = false;
                            dfd.reject();
                        }),
                        _AMR;
                    if (window.TextEncoder && window.URL && URL.createObjectURL && typeof AMR === 'undefined') {
                        // previous window.AMR
                        _AMR = window.AMR;
                        delete window.AMR;
                        fm.loadScript(
                            [fm.options.cdns.amr],
                            function () {
                                AMR = window.AMR ? window.AMR : false;
                                // restore previous window.AMR
                                window.AMR = _AMR;
                                loader[AMR ? 'resolve' : 'reject']();
                            },
                            {
                                error: function () {
                                    loader.reject();
                                }
                            }
                        );
                    } else {
                        loader[AMR ? 'resolve' : 'reject']();
                    }
                    return dfd;
                },
                play = function (player) {
                    var hash = node.data('hash'),
                        playPromise;
                    autoplay && (playPromise = player.play());
                    // uses "playPromise['catch']" instead "playPromise.catch" to support Old IE
                    if (playPromise && playPromise['catch']) {
                        playPromise['catch'](function (e) {
                            if (!player.paused) {
                                node && node.data('hash') === hash && reset();
                            }
                        });
                    }
                },
                reset = function () {
                    if (node && node.parent().length) {
                        var elm = node[0],
                            url = node.children('source').attr('src');
                        win.off('viewchange.audio');
                        try {
                            elm.pause();
                            node.empty();
                            if (url.match(/^blob:/)) {
                                URL.revokeObjectURL(url);
                            }
                            elm.src = '';
                            elm.load();
                        } catch (e) { }
                        node.remove();
                        node = null;
                    }
                },
                loading, prog;

            preview.on(ql.evUpdate, function (e) {
                var file = e.file,
                    type = mimes[file.mime],
                    html5, opDfd;

                if (mimes[file.mime] && ql.dispInlineRegex.test(file.mime) && ((html5 = ql.support.audio[type]) || (type === 'amr'))) {
                    autoplay = ql.autoPlay();
                    curHash = file.hash;
                    if (!html5) {
                        if (fm.options.cdns.amr && type === 'amr' && AMR !== false) {
                            e.stopImmediatePropagation();
                            loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                            prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                            node = getNode('', curHash);
                            amrToWavUrl(file.hash).done(function (url) {
                                loading.remove();
                                if (curHash === file.hash) {
                                    var elm = node[0];
                                    try {
                                        node.children('source').attr('src', url);
                                        elm.pause();
                                        elm.load();
                                        play(elm);
                                        win.on('viewchange.audio', setNavi);
                                        setNavi();
                                    } catch (e) {
                                        URL.revokeObjectURL(url);
                                        node.remove();
                                    }
                                } else {
                                    URL.revokeObjectURL(url);
                                }
                            }).fail(function () {
                                node.remove();
                            });
                        }
                    } else {
                        e.stopImmediatePropagation();
                        loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                        prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                        opDfd = fm.openUrl(curHash, false, function (url) {
                            loading.remove();
                            if (url) {
                                node = getNode(url, curHash);
                                play(node[0]);
                                win.on('viewchange.audio', setNavi);
                                setNavi();
                            } else {
                                node.remove();
                            }
                        }, { progressBar: prog });
                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                        });
                    }
                }
            }).one('change', reset);
        },

        /**
         * HTML5 video preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                preview = ql.preview,
                mimes = {
                    'video/mp4': 'mp4',
                    'video/x-m4v': 'mp4',
                    'video/quicktime': 'mp4',
                    'video/mpeg': 'mpeg',
                    'video/ogg': 'ogg',
                    'application/ogg': 'ogg',
                    'video/webm': 'webm',
                    'video/x-matroska': 'mkv',
                    'video/3gpp': '3gp',
                    'application/vnd.apple.mpegurl': 'm3u8',
                    'application/x-mpegurl': 'm3u8',
                    'application/dash+xml': 'mpd',
                    'video/x-flv': 'flv',
                    'video/x-msvideo': 'avi'
                },
                node,
                win = ql.window,
                navi = ql.navbar,
                cHls, cDash, pDash, cFlv, cVideojs, autoplay, tm, loading, prog,
                controlsList = typeof ql.options.mediaControlsList === 'string' && ql.options.mediaControlsList ? ' controlsList="' + fm.escape(ql.options.mediaControlsList) + '"' : '',
                setNavi = function () {
                    if (fm.UA.iOS) {
                        if (win.hasClass('elfinder-quicklook-fullscreen')) {
                            preview.css('height', '-webkit-calc(100% - 50px)');
                            navi._show();
                        } else {
                            preview.css('height', '');
                        }
                    } else {
                        navi.css('bottom', win.hasClass('elfinder-quicklook-fullscreen') ? '50px' : '');
                    }
                },
                render = function (file, opts) {
                    var errTm = function (e) {
                        if (err > 1) {
                            tm && clearTimeout(tm);
                            tm = setTimeout(function () {
                                !canPlay && reset(true);
                            }, 800);
                        }
                    },
                        err = 0,
                        cssClass = '',
                        canPlay;
                    //reset();
                    pDash = null;
                    opts = opts || {};
                    if (opts.cssClass) {
                        cssClass = ' ' + opts.cssClass;
                    }
                    ql.hideinfo();
                    node = $('<video class="elfinder-quicklook-preview-video' + cssClass + '" controls' + controlsList + ' preload="auto" autobuffer playsinline>'
                        + '</video>')
                        .on('change', function (e) {
                            // Firefox fire change event on seek or volume change
                            e.stopPropagation();
                        })
                        .on('timeupdate progress', errTm)
                        .on('canplay', function () {
                            canPlay = true;
                        })
                        .data('hash', file.hash);
                    // can not handling error event with jQuery `on` event handler
                    node[0].addEventListener('error', function (e) {
                        if (opts.src && fm.convAbsUrl(opts.src) === fm.convAbsUrl(e.target.src)) {
                            ++err;
                            errTm();
                        }
                    }, true);

                    if (opts.src) {
                        node.append('<source src="' + opts.src + '" type="' + file.mime + '"></source><source src="' + opts.src + '"></source>');
                    }

                    node.appendTo(preview);

                    win.on('viewchange.video', setNavi);
                    setNavi();
                },
                loadHls = function (file) {
                    var hls, opDfd;
                    opDfd = fm.openUrl(file.hash, false, function (url) {
                        loading.remove();
                        if (url) {
                            render(file);
                            hls = new cHls();
                            hls.loadSource(url);
                            hls.attachMedia(node[0]);
                            if (autoplay) {
                                hls.on(cHls.Events.MANIFEST_PARSED, function () {
                                    play(node[0]);
                                });
                            }
                        }
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                },
                loadDash = function (file) {
                    var opDfd;
                    opDfd = fm.openUrl(file.hash, false, function (url) {
                        var debug;
                        loading.remove();
                        if (url) {
                            render(file);
                            pDash = window.dashjs.MediaPlayer().create();
                            debug = pDash.getDebug();
                            if (debug.setLogLevel) {
                                debug.setLogLevel(dashjs.Debug.LOG_LEVEL_FATAL);
                            } else if (debug.setLogToBrowserConsole) {
                                debug.setLogToBrowserConsole(false);
                            }
                            pDash.initialize(node[0], url, autoplay);
                            pDash.on('error', function (e) {
                                reset(true);
                            });
                        }
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                },
                loadFlv = function (file) {
                    var opDfd
                    if (!cFlv.isSupported()) {
                        cFlv = false;
                        return;
                    }
                    opDfd = fm.openUrl(file.hash, false, function (url) {
                        loading.remove();
                        if (url) {
                            var player = cFlv.createPlayer({
                                type: 'flv',
                                url: url
                            });
                            render(file);
                            player.on(cFlv.Events.ERROR, function () {
                                player.destroy();
                                reset(true);
                            });
                            player.attachMediaElement(node[0]);
                            player.load();
                            play(player);
                        }
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                },
                loadVideojs = function (file) {
                    var opDfd;
                    opDfd = fm.openUrl(file.hash, false, function (url) {
                        loading.remove();
                        if (url) {
                            render(file, {
                                src: url,
                                cssClass: 'video-js'
                            });
                            node[0].src = url;
                            cVideojs(node[0], {
                                autoplay: true
                            });
                        }
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                },
                play = function (player) {
                    var hash = node.data('hash'),
                        playPromise;
                    autoplay && (playPromise = player.play());
                    // uses "playPromise['catch']" instead "playPromise.catch" to support Old IE
                    if (playPromise && playPromise['catch']) {
                        playPromise['catch'](function (e) {
                            if (!player.paused) {
                                node && node.data('hash') === hash && reset(true);
                            }
                        });
                    }
                },
                reset = function (showInfo) {
                    tm && clearTimeout(tm);
                    if (node && node.parent().length) {
                        var elm = node[0];
                        win.off('viewchange.video');
                        pDash && pDash.reset();
                        try {
                            elm.pause();
                            node.empty();
                            elm.src = '';
                            elm.load();
                        } catch (e) { }
                        node.remove();
                        node = null;
                    }
                    showInfo && ql.info.show();
                };

            preview.on(ql.evUpdate, function (e) {
                var file = e.file,
                    mime = file.mime.toLowerCase(),
                    type = mimes[mime],
                    stock, playPromise, opDfd;

                if (mimes[mime] && ql.dispInlineRegex.test(file.mime) /*&& (((type === 'm3u8' || (type === 'mpd' && !fm.UA.iOS) || type === 'flv') && !fm.UA.ltIE10) || ql.support.video[type])*/) {
                    autoplay = ql.autoPlay();
                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>');
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                    if (ql.support.video[type] && (type !== 'm3u8' || fm.UA.Safari)) {
                        e.stopImmediatePropagation();
                        loading.appendTo(ql.info.find('.elfinder-quicklook-info'));
                        opDfd = fm.openUrl(file.hash, false, function (url) {
                            loading.remove();
                            if (url) {
                                render(file, { src: url });
                                play(node[0]);
                            }
                        }, { progressBar: prog });
                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                        });
                    } else {
                        if (cHls !== false && fm.options.cdns.hls && type === 'm3u8') {
                            e.stopImmediatePropagation();
                            loading.appendTo(ql.info.find('.elfinder-quicklook-info'));
                            if (cHls) {
                                loadHls(file);
                            } else {
                                stock = window.Hls;
                                delete window.Hls;
                                fm.loadScript(
                                    [fm.options.cdns.hls],
                                    function (res) {
                                        cHls = res || window.Hls || false;
                                        window.Hls = stock;
                                        cHls && loadHls(file);
                                    },
                                    {
                                        tryRequire: true,
                                        error: function () {
                                            cHls = false;
                                        }
                                    }
                                );
                            }
                        } else if (cDash !== false && fm.options.cdns.dash && type === 'mpd') {
                            e.stopImmediatePropagation();
                            loading.appendTo(ql.info.find('.elfinder-quicklook-info'));
                            if (cDash) {
                                loadDash(file);
                            } else {
                                fm.loadScript(
                                    [fm.options.cdns.dash],
                                    function () {
                                        // dashjs require window.dashjs in global scope
                                        cDash = window.dashjs ? true : false;
                                        cDash && loadDash(file);
                                    },
                                    {
                                        tryRequire: true,
                                        error: function () {
                                            cDash = false;
                                        }
                                    }
                                );
                            }
                        } else if (cFlv !== false && fm.options.cdns.flv && type === 'flv') {
                            e.stopImmediatePropagation();
                            loading.appendTo(ql.info.find('.elfinder-quicklook-info'));
                            if (cFlv) {
                                loadFlv(file);
                            } else {
                                stock = window.flvjs;
                                delete window.flvjs;
                                fm.loadScript(
                                    [fm.options.cdns.flv],
                                    function (res) {
                                        cFlv = res || window.flvjs || false;
                                        window.flvjs = stock;
                                        cFlv && loadFlv(file);
                                    },
                                    {
                                        tryRequire: true,
                                        error: function () {
                                            cFlv = false;
                                        }
                                    }
                                );
                            }
                        } else if (fm.options.cdns.videojs) {
                            e.stopImmediatePropagation();
                            loading.appendTo(ql.info.find('.elfinder-quicklook-info'));
                            if (cVideojs) {
                                loadVideojs(file);
                            } else {
                                fm.loadScript(
                                    [fm.options.cdns.videojs + '/video.min.js'],
                                    function (res) {
                                        cVideojs = res || window.videojs || false;
                                        //window.flvjs = stock;
                                        cVideojs && loadVideojs(file);
                                    },
                                    {
                                        tryRequire: true,
                                        error: function () {
                                            cVideojs = false;
                                        }
                                    }
                                ).loadCss([fm.options.cdns.videojs + '/video-js.min.css']);
                            }
                        }
                    }
                }
            }).one('change', reset);
        },

        /**
         * Audio/video preview plugin using browser plugins
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var preview = ql.preview,
                mimes = [],
                node,
                win = ql.window,
                navi = ql.navbar;

            $.each(navigator.plugins, function (i, plugins) {
                $.each(plugins, function (i, plugin) {
                    (plugin.type.indexOf('audio/') === 0 || plugin.type.indexOf('video/') === 0) && mimes.push(plugin.type);
                });
            });
            mimes = ql.fm.arrayFlip(mimes);

            preview.on(ql.evUpdate, function (e) {
                var file = e.file,
                    mime = file.mime,
                    video, opDfd, loading, prog,
                    setNavi = function () {
                        navi.css('bottom', win.hasClass('elfinder-quicklook-fullscreen') ? '50px' : '');
                    };

                if (mimes[file.mime] && ql.dispInlineRegex.test(file.mime)) {
                    e.stopImmediatePropagation();
                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                    opDfd = ql.fm.openUrl(file.hash, false, function (url) {
                        loading.remove();
                        if (url) {
                            (video = mime.indexOf('video/') === 0) && ql.hideinfo();
                            node = $('<embed src="' + url + '" type="' + mime + '" class="elfinder-quicklook-preview-' + (video ? 'video' : 'audio') + '"/>')
                                .appendTo(preview);

                            win.on('viewchange.embed', setNavi);
                            setNavi();
                        }
                    }, { progressBar: prog });
                    // stop loading on change file if not loaded yet
                    preview.one('change', function () {
                        opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                    });
                }
            }).one('change', function () {
                if (node && node.parent().length) {
                    win.off('viewchange.embed');
                    node.remove();
                    node = null;
                }
            });

        },

        /**
         * Archive(zip|gzip|tar|bz2) preview plugin using https://github.com/imaya/zlib.js
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = fm.arrayFlip(['application/zip', 'application/x-gzip', 'application/x-tar', 'application/x-bzip2']),
                preview = ql.preview,
                sizeMax = fm.returnBytes(ql.options.unzipMaxSize || 0),
                Zlib = (fm.options.cdns.zlibUnzip && fm.options.cdns.zlibGunzip) ? true : false,
                bzip2 = fm.options.cdns.bzip2 ? true : false;

            if (window.Worker && window.Uint8Array && window.DataView) {
                preview.on(ql.evUpdate, function (e) {
                    var file = e.file,
                        isTar = (file.mime === 'application/x-tar'),
                        isBzip2 = (file.mime === 'application/x-bzip2'),
                        isZlib = (file.mime === 'application/zip' || file.mime === 'application/x-gzip');
                    if (mimes[file.mime] && (!sizeMax || file.size <= sizeMax) && (
                        isTar
                        || (isBzip2 && bzip2)
                        || (isZlib && Zlib)
                    )) {
                        var jqxhr, wk, loading, prog, url,
                            req = function () {
                                jqxhr = fm.getContents(file.hash, 'arraybuffer', { progressBar: prog })
                                    .fail(function () {
                                        loading.remove();
                                    })
                                    .done(function (data) {
                                        var unzip, filenames,
                                            err = function (e) {
                                                wk && wk.terminate();
                                                loading.remove();
                                                if (isZlib) {
                                                    Zlib = false;
                                                } else if (isBzip2) {
                                                    bzip2 = false;
                                                }
                                                fm.debug('error', e);
                                            };
                                        try {
                                            wk = fm.getWorker();
                                            wk.onmessage = function (res) {
                                                wk && wk.terminate();
                                                loading.remove();
                                                if (!res.data || res.data.error) {
                                                    new Error(res.data && res.data.error ? res.data.error : '');
                                                } else {
                                                    makeList(res.data.files);
                                                }
                                            };
                                            wk.onerror = err;
                                            if (file.mime === 'application/x-tar') {
                                                wk.postMessage({
                                                    scripts: [fm.getWorkerUrl('quicklook.unzip.js')],
                                                    data: { type: 'tar', bin: data }
                                                });
                                            } else if (file.mime === 'application/zip') {
                                                wk.postMessage({
                                                    scripts: [fm.options.cdns.zlibUnzip, fm.getWorkerUrl('quicklook.unzip.js')],
                                                    data: { type: 'zip', bin: data }
                                                });
                                            } else if (file.mime === 'application/x-gzip') {
                                                wk.postMessage({
                                                    scripts: [fm.options.cdns.zlibGunzip, fm.getWorkerUrl('quicklook.unzip.js')],
                                                    data: { type: 'gzip', bin: data }
                                                });

                                            } else if (file.mime === 'application/x-bzip2') {
                                                wk.postMessage({
                                                    scripts: [fm.options.cdns.bzip2, fm.getWorkerUrl('quicklook.unzip.js')],
                                                    data: { type: 'bzip2', bin: data }
                                                });
                                            }
                                        } catch (e) {
                                            err(e);
                                        }
                                    });
                            },
                            makeList = function (filenames) {
                                var header, list, doc, tsize = 0;
                                if (filenames && filenames.length) {
                                    filenames = $.map(filenames, function (str) {
                                        return fm.decodeRawString(str);
                                    });
                                    filenames.sort();
                                    list = fm.escape(filenames.join("\n").replace(/\{formatSize\((\d+)\)\}/g, function (m, s) {
                                        tsize += parseInt(s);
                                        return fm.formatSize(s);
                                    }));
                                    header = '<strong>' + fm.escape(file.mime) + '</strong> (' + fm.formatSize(file.size) + ' / ' + fm.formatSize(tsize) + ')' + '<hr/>';
                                    doc = $('<div class="elfinder-quicklook-preview-archive-wrapper">' + header + '<pre class="elfinder-quicklook-preview-text">' + list + '</pre></div>')
                                        .on('touchstart', function (e) {
                                            if ($(this)['scroll' + (fm.direction === 'ltr' ? 'Right' : 'Left')]() > 5) {
                                                e.originalEvent._preventSwipeX = true;
                                            }
                                        })
                                        .appendTo(preview);
                                    ql.hideinfo();
                                }
                                loading.remove();
                            };

                        // this is our file - stop event propagation
                        e.stopImmediatePropagation();

                        loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                        prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            jqxhr.state() === 'pending' && jqxhr.reject();
                            wk && wk.terminate();
                            loading.remove();
                        });

                        req();
                    }
                });
            }
        },

        /**
         * RAR Archive preview plugin using https://github.com/43081j/rar.js
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = fm.arrayFlip(['application/x-rar']),
                preview = ql.preview,
                RAR;

            if (window.DataView) {
                preview.on(ql.evUpdate, function (e) {
                    var file = e.file;
                    if (mimes[file.mime] && fm.options.cdns.rar && RAR !== false) {
                        var loading, prog, url, archive, abort,
                            getList = function (url) {
                                if (abort) {
                                    loading.remove();
                                    return;
                                }
                                try {
                                    archive = RAR({
                                        file: url,
                                        type: 2,
                                        xhrHeaders: fm.customHeaders,
                                        xhrFields: fm.xhrFields
                                    }, function (err) {
                                        loading.remove();
                                        var filenames = [],
                                            header, doc;
                                        if (abort || err) {
                                            // An error occurred (not a rar, read error, etc)
                                            err && fm.debug('error', err);
                                            return;
                                        }
                                        $.each(archive.entries, function () {
                                            filenames.push(this.path + (this.size ? ' (' + fm.formatSize(this.size) + ')' : ''));
                                        });
                                        if (filenames.length) {
                                            filenames = $.map(filenames, function (str) {
                                                return fm.decodeRawString(str);
                                            });
                                            filenames.sort();
                                            header = '<strong>' + fm.escape(file.mime) + '</strong> (' + fm.formatSize(file.size) + ')' + '<hr/>';
                                            doc = $('<div class="elfinder-quicklook-preview-archive-wrapper">' + header + '<pre class="elfinder-quicklook-preview-text">' + fm.escape(filenames.join("\n")) + '</pre></div>')
                                                .on('touchstart', function (e) {
                                                    if ($(this)['scroll' + (fm.direction === 'ltr' ? 'Right' : 'Left')]() > 5) {
                                                        e.originalEvent._preventSwipeX = true;
                                                    }
                                                })
                                                .appendTo(preview);
                                            ql.hideinfo();
                                        }
                                    });
                                } catch (e) {
                                    loading.remove();
                                }
                            },
                            error = function () {
                                RAR = false;
                                loading.remove();
                            },
                            _RAR, opDfd;

                        // this is our file - stop event propagation
                        e.stopImmediatePropagation();

                        loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                        prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            archive && (archive.abort = true);
                            loading.remove();
                            abort = true;
                        });

                        opDfd = fm.openUrl(file.hash, 'sameorigin', function (url) {
                            if (url) {
                                if (RAR) {
                                    getList(url);
                                } else {
                                    if (window.RarArchive) {
                                        _RAR = window.RarArchive;
                                        delete window.RarArchive;
                                    }
                                    fm.loadScript(
                                        [fm.options.cdns.rar],
                                        function () {
                                            if (fm.hasRequire) {
                                                require(['rar'], function (RarArchive) {
                                                    RAR = RarArchive;
                                                    getList(url);
                                                }, error);
                                            } else {
                                                if (RAR = window.RarArchive) {
                                                    if (_RAR) {
                                                        window.RarArchive = _RAR;
                                                    } else {
                                                        delete window.RarArchive;
                                                    }
                                                    getList(url);
                                                } else {
                                                    error();
                                                }
                                            }
                                        },
                                        {
                                            tryRequire: true,
                                            error: error
                                        }
                                    );
                                }
                            }
                        }, { progressBar: prog, temporary: true });
                        // stop loading on change file if not loaded yet
                        preview.one('change', function () {
                            opDfd && opDfd.state && opDfd.state() === 'pending' && opDfd.reject();
                        });
                    }
                });
            }
        },

        /**
         * CAD-Files and 3D-Models online viewer on sharecad.org
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = fm.arrayFlip(ql.options.sharecadMimes || []),
                preview = ql.preview,
                win = ql.window,
                node;

            if (ql.options.sharecadMimes.length) {
                ql.addIntegration({
                    title: 'ShareCAD.org CAD and 3D-Models viewer',
                    link: 'https://sharecad.org/DWGOnlinePlugin'
                });
            }

            preview.on(ql.evUpdate, function (e) {
                var file = e.file;
                if (mimes[file.mime.toLowerCase()] && fm.option('onetimeUrl', file.hash)) {
                    var win = ql.window,
                        loading, prog, url;

                    e.stopImmediatePropagation();
                    if (file.url == '1') {
                        preview.hide();
                        $('<div class="elfinder-quicklook-info-data"><button class="elfinder-info-button">' + fm.i18n('getLink') + '</button></div>').appendTo(ql.info.find('.elfinder-quicklook-info'))
                            .on('click', function () {
                                var self = $(this);
                                self.html('<span class="elfinder-spinner">');
                                fm.request({
                                    data: { cmd: 'url', target: file.hash },
                                    preventDefault: true,
                                    progressBar: prog
                                })
                                    .always(function () {
                                        self.html('');
                                    })
                                    .done(function (data) {
                                        var rfile = fm.file(file.hash);
                                        file.url = rfile.url = data.url || '';
                                        if (file.url) {
                                            preview.trigger({
                                                type: ql.evUpdate,
                                                file: file,
                                                forceUpdate: true
                                            });
                                        }
                                    });
                            });
                    }
                    if (file.url !== '' && file.url != '1') {
                        preview.one('change', function () {
                            loading.remove();
                            node.off('load').remove();
                            node = null;
                        }).addClass('elfinder-overflow-auto');

                        loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                        prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                        url = fm.convAbsUrl(fm.url(file.hash));
                        node = $('<iframe class="elfinder-quicklook-preview-iframe" scrolling="no"></iframe>')
                            .css('background-color', 'transparent')
                            .appendTo(preview)
                            .on('load', function () {
                                ql.hideinfo();
                                loading.remove();
                                ql.preview.after(ql.info);
                                $(this).css('background-color', '#fff').show();
                            })
                            .on('error', function () {
                                loading.remove();
                                ql.preview.after(ql.info);
                            })
                            .attr('src', '//sharecad.org/cadframe/load?url=' + encodeURIComponent(url));

                        ql.info.after(ql.preview);
                    }
                }

            });
        },

        /**
         * KML preview with GoogleMaps API
         *
         * @param elFinder.commands.quicklook
         */
        function (ql) {
            var fm = ql.fm,
                mimes = {
                    'application/vnd.google-earth.kml+xml': true,
                    'application/vnd.google-earth.kmz': true
                },
                preview = ql.preview,
                gMaps, loadMap, wGmfail, fail, mapScr;

            if (ql.options.googleMapsApiKey) {
                ql.addIntegration({
                    title: 'Google Maps',
                    link: 'https://www.google.com/intl/' + fm.lang.replace('_', '-') + '/help/terms_maps.html'
                });
                gMaps = (window.google && google.maps);
                // start load maps
                loadMap = function (file, node, prog) {
                    var mapsOpts = ql.options.googleMapsOpts.maps;
                    fm.forExternalUrl(file.hash, { progressBar: prog }).done(function (url) {
                        if (url) {
                            try {
                                new gMaps.KmlLayer(url, Object.assign({
                                    map: new gMaps.Map(node.get(0), mapsOpts)
                                }, ql.options.googleMapsOpts.kml));
                                ql.hideinfo();
                            } catch (e) {
                                fail();
                            }
                        } else {
                            fail();
                        }
                    });
                };
                // keep stored error handler if exists
                wGmfail = window.gm_authFailure;
                // on error function
                fail = function () {
                    mapScr = null;
                };
                // API script url
                mapScr = 'https://maps.googleapis.com/maps/api/js?key=' + ql.options.googleMapsApiKey;
                // error handler
                window.gm_authFailure = function () {
                    fail();
                    wGmfail && wGmfail();
                };

                preview.on(ql.evUpdate, function (e) {
                    var file = e.file;
                    if (mapScr && mimes[file.mime.toLowerCase()]) {
                        var win = ql.window,
                            getLink = (file.url == '1' && !fm.option('onetimeUrl', file.hash)),
                            loading, prog, url, node;

                        e.stopImmediatePropagation();
                        loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                        prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);
                        if (getLink) {
                            preview.hide();
                            $('<div class="elfinder-quicklook-info-data"><button class="elfinder-info-button">' + fm.i18n('getLink') + '</button></div>').appendTo(ql.info.find('.elfinder-quicklook-info'))
                                .on('click', function () {
                                    var self = $(this);
                                    self.html('<span class="elfinder-spinner">');
                                    fm.request({
                                        data: { cmd: 'url', target: file.hash },
                                        preventDefault: true,
                                        progressBar: prog
                                    })
                                        .always(function () {
                                            loading.remove();
                                            self.html('');
                                        })
                                        .done(function (data) {
                                            var rfile = fm.file(file.hash);
                                            file.url = rfile.url = data.url || '';
                                            if (file.url) {
                                                preview.trigger({
                                                    type: ql.evUpdate,
                                                    file: file,
                                                    forceUpdate: true
                                                });
                                            }
                                        });
                                });
                        }
                        if (file.url !== '' && !getLink) {
                            node = $('<div style="width:100%;height:100%;"></div>').appendTo(preview);
                            preview.one('change', function () {
                                node.remove();
                                node = null;
                            });
                            if (!gMaps) {
                                fm.loadScript([mapScr], function () {
                                    gMaps = window.google && google.maps;
                                    gMaps && loadMap(file, node, prog);
                                });
                            } else {
                                loadMap(file, node, prog);
                            }
                        }
                    }
                });
            }
        },

        /**
         * Any supported files preview plugin using (Google docs | MS Office) online viewer
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            var fm = ql.fm,
                mimes = Object.assign(fm.arrayFlip(ql.options.googleDocsMimes || [], 'g'), fm.arrayFlip(ql.options.officeOnlineMimes || [], 'm')),
                preview = ql.preview,
                win = ql.window,
                navi = ql.navbar,
                urls = {
                    g: 'docs.google.com/gview?embedded=true&url=',
                    m: 'view.officeapps.live.com/op/embed.aspx?wdStartOn=0&src='
                },
                navBottom = {
                    g: '56px',
                    m: '24px'
                },
                mLimits = {
                    xls: 5242880, // 5MB
                    xlsb: 5242880,
                    xlsx: 5242880,
                    xlsm: 5242880,
                    other: 10485760 // 10MB
                },
                node, enable;

            if (ql.options.googleDocsMimes.length) {
                enable = true;
                ql.addIntegration({
                    title: 'Google Docs Viewer',
                    link: 'https://docs.google.com/'
                });
            }
            if (ql.options.officeOnlineMimes.length) {
                enable = true;
                ql.addIntegration({
                    title: 'MS Online Doc Viewer',
                    link: 'https://products.office.com/office-online/view-office-documents-online'
                });
            }

            if (enable) {
                preview.on(ql.evUpdate, function (e) {
                    var file = e.file,
                        type, dfd;
                    // 25MB is maximum filesize of Google Docs prevew
                    if (file.size <= 26214400 && (type = mimes[file.mime])) {
                        var win = ql.window,
                            setNavi = function () {
                                navi.css('bottom', win.hasClass('elfinder-quicklook-fullscreen') ? navBottom[type] : '');
                            },
                            ext = fm.mimeTypes[file.mime],
                            getLink = (file.url == '1' && !fm.option('onetimeUrl', file.hash)),
                            loading, prog, url, tm;

                        if (type === 'm') {
                            if ((mLimits[ext] && file.size > mLimits[ext]) || file.size > mLimits.other) {
                                type = 'g';
                            }
                        }
                        if (getLink) {
                            preview.hide();
                            $('<div class="elfinder-quicklook-info-data"><button class="elfinder-info-button">' + fm.i18n('getLink') + '</button></div>').appendTo(ql.info.find('.elfinder-quicklook-info'))
                                .on('click', function () {
                                    var self = $(this);
                                    self.html('<span class="elfinder-spinner">');
                                    fm.request({
                                        data: { cmd: 'url', target: file.hash },
                                        preventDefault: true
                                    })
                                        .always(function () {
                                            self.html('');
                                        })
                                        .done(function (data) {
                                            var rfile = fm.file(file.hash);
                                            file.url = rfile.url = data.url || '';
                                            if (file.url) {
                                                preview.trigger({
                                                    type: ql.evUpdate,
                                                    file: file,
                                                    forceUpdate: true
                                                });
                                            }
                                        });
                                });
                        }
                        if (file.url !== '' && !getLink) {
                            e.stopImmediatePropagation();
                            preview.one('change', function () {
                                dfd && dfd.status && dfd.status() === 'pending' && dfd.reject();
                                win.off('viewchange.googledocs');
                                loading.remove();
                                node.off('load').remove();
                                node = null;
                            }).addClass('elfinder-overflow-auto');

                            loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                            prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                            node = $('<iframe class="elfinder-quicklook-preview-iframe"></iframe>')
                                .css('background-color', 'transparent')
                                .appendTo(preview);

                            dfd = fm.forExternalUrl(file.hash, { progressBar: prog }).done(function (url) {
                                var load = function () {
                                    try {
                                        if (node && (!node.attr('src') || node.get(0).contentWindow.document/*maybe HTTP 204*/)) {
                                            node.attr('src', 'https://' + urls[type] + encodeURIComponent(url));
                                            // Retry because Google Docs viewer sometimes returns HTTP 204
                                            tm = setTimeout(load, 2000);
                                        }
                                    } catch (e) { }
                                };
                                if (url) {
                                    if (file.ts) {
                                        url += (url.match(/\?/) ? '&' : '?') + '_t=' + file.ts;
                                    }
                                    node.on('load', function () {
                                        tm && clearTimeout(tm);
                                        ql.hideinfo();
                                        loading.remove();
                                        ql.preview.after(ql.info);
                                        $(this).css('background-color', '#fff').show();
                                    })
                                        .on('error', function () {
                                            tm && clearTimeout(tm);
                                            loading.remove();
                                            ql.preview.after(ql.info);
                                        });
                                    load();
                                } else {
                                    loading.remove();
                                    node.remove();
                                }
                            });

                            win.on('viewchange.googledocs', setNavi);
                            setNavi();
                            ql.info.after(ql.preview);
                        }
                    }

                });
            }
        },

        /**
         * Texts preview plugin
         *
         * @param elFinder.commands.quicklook
         **/
        function (ql) {
            "use strict";
            var fm = ql.fm,
                preview = ql.preview,
                textLines = parseInt(ql.options.textInitialLines) || 150,
                prettifyLines = parseInt(ql.options.prettifyMaxLines) || 500,
                PR, _PR,
                error = function () {
                    prettify = function () { return false; };
                    _PR && (window.PR = _PR);
                    PR = false;
                },
                prettify = function (node) {
                    if (fm.options.cdns.prettify) {
                        prettify = function (node) {
                            setTimeout(function () {
                                PRcheck(node);
                            }, 100);
                            return 'pending';
                        };
                        if (window.PR) {
                            _PR = window.PR;
                        }
                        fm.loadScript([fm.options.cdns.prettify + (fm.options.cdns.prettify.match(/\?/) ? '&' : '?') + 'autorun=false'], function (wPR) {
                            PR = wPR || window.PR;
                            if (typeof PR === 'object') {
                                prettify = function () { return true; };
                                if (_PR) {
                                    window.PR = _PR;
                                } else {
                                    delete window.PR;
                                }
                                exec(node);
                            } else {
                                error();
                            }
                        }, {
                            tryRequire: true,
                            error: error
                        });
                    } else {
                        error();
                    }
                },
                exec = function (node) {
                    if (node && !node.hasClass('prettyprinted')) {
                        node.css('cursor', 'wait');
                        requestAnimationFrame(function () {
                            PR.prettyPrint && PR.prettyPrint(null, node.get(0));
                            node.css('cursor', '');
                        });
                    }
                },
                PRcheck = function (node) {
                    var status = prettify(node);
                    if (status === true) {
                        exec(node);
                    }
                };

            preview.on(ql.evUpdate, function (e) {
                var file = e.file,
                    mime = file.mime,
                    jqxhr, loading, prog, encSelect;

                if (fm.mimeIsText(file.mime) && (!ql.options.getSizeMax || file.size <= ql.options.getSizeMax) && PR !== false) {
                    e.stopImmediatePropagation();

                    loading = $('<div class="elfinder-quicklook-info-data"><span class="elfinder-spinner-text">' + fm.i18n('nowLoading') + '</span><span class="elfinder-spinner"></span></div>').appendTo(ql.info.find('.elfinder-quicklook-info'));
                    prog = $('<div class="elfinder-quicklook-info-progress"></div>').appendTo(loading);

                    // stop loading on change file if not loadin yet
                    preview.one('change', function () {
                        jqxhr.state() == 'pending' && jqxhr.reject();
                        encSelect && encSelect.remove();
                    });

                    jqxhr = fm.request({
                        data: { cmd: 'get', target: file.hash, conv: (file.encoding || 1), _t: file.ts },
                        options: { type: 'get', cache: true },
                        preventDefault: true,
                        progressBar: prog
                    })
                        .done(function (data) {
                            var reg = new RegExp('^(data:' + file.mime.replace(/([.+])/g, '\\$1') + ';base64,)', 'i'),
                                text = data.content,
                                part, more, node, lines, m;
                            if (typeof text !== 'string') {
                                return;
                            }
                            ql.hideinfo();
                            if (window.atob && (m = text.match(reg))) {
                                text = atob(text.substr(m[1].length));
                            }

                            lines = text.match(/([^\r\n]{1,100}[\r\n]*)/g);
                            more = lines.length - textLines;
                            if (more > 10) {
                                part = lines.splice(0, textLines).join('');
                            } else {
                                more = 0;
                            }

                            node = $('<div class="elfinder-quicklook-preview-text-wrapper"><pre class="elfinder-quicklook-preview-text prettyprint"></pre></div>');

                            if (more) {
                                node.append($('<div class="elfinder-quicklook-preview-charsleft"><hr/><span>' + fm.i18n('linesLeft', fm.toLocaleString(more)) + '</span></div>')
                                    .on('click', function () {
                                        var top = node.scrollTop();
                                        $(this).remove();
                                        node.children('pre').removeClass('prettyprinted').text(text).scrollTop(top);
                                        if (lines.length <= prettifyLines) {
                                            PRcheck(node);
                                        }
                                    })
                                );
                            }
                            node.children('pre').text(part || text);

                            node.on('touchstart', function (e) {
                                if ($(this)['scroll' + (fm.direction === 'ltr' ? 'Right' : 'Left')]() > 5) {
                                    e.originalEvent._preventSwipeX = true;
                                }
                            }).appendTo(preview);

                            // make toast message
                            if (data.toasts && Array.isArray(data.toasts)) {
                                $.each(data.toasts, function () {
                                    this.msg && fm.toast(this);
                                });
                            }

                            PRcheck(node);
                        })
                        .always(function (data) {
                            var cmdEdit, sel, head;
                            if (cmdEdit = fm.getCommand('edit')) {
                                head = [];
                                if (data && data.encoding) {
                                    head.push({ value: data.encoding });
                                }
                                head.push({ value: 'UTF-8' });
                                sel = cmdEdit.getEncSelect(head);
                                sel.on('change', function () {
                                    file.encoding = sel.val();
                                    fm.cache(file, 'change');
                                    preview.trigger({
                                        type: ql.evUpdate,
                                        file: file,
                                        forceUpdate: true
                                    });
                                });
                                encSelect = $('<div class="elfinder-quicklook-encoding"></div>').append(sel);
                                ql.window.append(encSelect);
                            }
                            loading.remove();
                        });
                }
            });
        }
    ];


    /*
     * File: /js/commands/reload.js
     */

    /**
     * @class  elFinder command "reload"
     * Sync files and folders
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.reload = function () {
        "use strict";
        var self = this,
            search = false;

        this.alwaysEnabled = true;
        this.updateOnSelect = true;

        this.shortcuts = [{
            pattern: 'ctrl+shift+r f5'
        }];

        this.getstate = function () {
            return 0;
        };

        this.init = function () {
            this.fm.bind('search searchend', function () {
                search = this.type == 'search';
            });
        };

        this.fm.bind('contextmenu', function () {
            var fm = self.fm;
            if (fm.options.sync >= 1000) {
                self.extra = {
                    icon: 'accept',
                    node: $('<span></span>')
                        .attr({ title: fm.i18n('autoSync') })
                        .on('click touchstart', function (e) {
                            if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                                return;
                            }
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).parent()
                                .toggleClass('ui-state-disabled', fm.options.syncStart)
                                .parent().removeClass('ui-state-hover');
                            fm.options.syncStart = !fm.options.syncStart;
                            fm.autoSync(fm.options.syncStart ? null : 'stop');
                        }).on('ready', function () {
                            $(this).parent().toggleClass('ui-state-disabled', !fm.options.syncStart).css('pointer-events', 'auto');
                        })
                };
            }
        });

        this.exec = function () {
            var fm = this.fm;
            if (!search) {
                var dfrd = fm.sync(),
                    timeout = setTimeout(function () {
                        fm.notify({ type: 'reload', cnt: 1, hideCnt: true });
                        dfrd.always(function () { fm.notify({ type: 'reload', cnt: -1 }); });
                    }, fm.notifyDelay);

                return dfrd.always(function () {
                    clearTimeout(timeout);
                    fm.trigger('reload');
                });
            } else {
                $('div.elfinder-toolbar > div.' + fm.res('class', 'searchbtn') + ' > span.ui-icon-search').click();
            }
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/rename.js
     */

    /**
     * @class elFinder command "rename". 
     * Rename selected file.
     *
     * @author Dmitry (dio) Levashov, dio@std42.ru
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.rename = function () {
        "use strict";

        // set alwaysEnabled to allow root rename on client size
        this.alwaysEnabled = true;

        this.syncTitleOnChange = true;

        var self = this,
            fm = self.fm,
            request = function (dfrd, targtes, file, name) {
                var sel = targtes ? [file.hash].concat(targtes) : [file.hash],
                    cnt = sel.length,
                    data = {}, rootNames;

                fm.lockfiles({ files: sel });

                if (fm.isRoot(file) && !file.netkey) {
                    if (!(rootNames = fm.storage('rootNames'))) {
                        rootNames = {};
                    }
                    if (name === '') {
                        if (rootNames[file.hash]) {
                            file.name = file._name;
                            file.i18 = file._i18;
                            delete rootNames[file.hash];
                            delete file._name;
                            delete file._i18;
                        } else {
                            dfrd && dfrd.reject();
                            fm.unlockfiles({ files: sel }).trigger('selectfiles', { files: sel });
                            return;
                        }
                    } else {
                        if (typeof file._name === 'undefined') {
                            file._name = file.name;
                            file._i18 = file.i18;
                        }
                        file.name = rootNames[file.hash] = name;
                        delete file.i18;
                    }
                    fm.storage('rootNames', rootNames);
                    data = { changed: [file] };
                    fm.updateCache(data);
                    fm.change(data);
                    dfrd && dfrd.resolve(data);
                    fm.unlockfiles({ files: sel }).trigger('selectfiles', { files: sel });
                    return;
                }

                data = {
                    cmd: 'rename',
                    name: name,
                    target: file.hash
                };

                if (cnt > 1) {
                    data['targets'] = targtes;
                    if (name.match(/\*/)) {
                        data['q'] = name;
                    }
                }

                fm.request({
                    data: data,
                    notify: { type: 'rename', cnt: cnt },
                    navigate: {}
                })
                    .fail(function (error) {
                        var err = fm.parseError(error);
                        dfrd && dfrd.reject();
                        if (!err || !Array.isArray(err) || err[0] !== 'errRename') {
                            fm.sync();
                        }
                    })
                    .done(function (data) {
                        var cwdHash;
                        if (data.added && data.added.length && cnt === 1) {
                            data.undo = {
                                cmd: 'rename',
                                callback: function () {
                                    return fm.request({
                                        data: { cmd: 'rename', target: data.added[0].hash, name: file.name },
                                        notify: { type: 'undo', cnt: 1 }
                                    });
                                }
                            };
                            data.redo = {
                                cmd: 'rename',
                                callback: function () {
                                    return fm.request({
                                        data: { cmd: 'rename', target: file.hash, name: name },
                                        notify: { type: 'rename', cnt: 1 }
                                    });
                                }
                            };
                        }
                        dfrd && dfrd.resolve(data);
                        if (!(cwdHash = fm.cwd().hash) || cwdHash === file.hash) {
                            fm.exec('open', $.map(data.added, function (f) {
                                return (f.mime === 'directory') ? f.hash : null;
                            })[0]);
                        }
                    })
                    .always(function () {
                        fm.unlockfiles({ files: sel }).trigger('selectfiles', { files: sel });
                    }
                    );
            },
            getHint = function (name, target) {
                var sel = target || fm.selected(),
                    splits = fm.splitFileExtention(name),
                    f1 = fm.file(sel[0]),
                    f2 = fm.file(sel[1]),
                    ext, hint, add;

                ext = splits[1] ? ('.' + splits[1]) : '';
                if (splits[1] && splits[0] === '*') {
                    // change extention
                    hint = '"' + fm.splitFileExtention(f1.name)[0] + ext + '", ';
                    hint += '"' + fm.splitFileExtention(f2.name)[0] + ext + '"';
                } else if (splits[0].length > 1) {
                    if (splits[0].substr(-1) === '*') {
                        // add prefix
                        add = splits[0].substr(0, splits[0].length - 1);
                        hint = '"' + add + f1.name + '", ';
                        hint += '"' + add + f2.name + '"';
                    } else if (splits[0].substr(0, 1) === '*') {
                        // add suffix
                        add = splits[0].substr(1);
                        hint = '"' + fm.splitFileExtention(f1.name)[0] + add + ext + '", ';
                        hint += '"' + fm.splitFileExtention(f2.name)[0] + add + ext + '"';
                    }
                }
                if (!hint) {
                    hint = '"' + splits[0] + '1' + ext + '", "' + splits[0] + '2' + ext + '"';
                }
                if (sel.length > 2) {
                    hint += ' ...';
                }
                return hint;
            },
            batchRename = function () {
                var sel = fm.selected(),
                    tplr = '<input name="type" type="radio" class="elfinder-tabstop">',
                    mkChk = function (node, label) {
                        return $('<label class="elfinder-rename-batch-checks">' + fm.i18n(label) + '</label>').prepend(node);
                    },
                    name = $('<input type="text" class="ui-corner-all elfinder-tabstop">'),
                    num = $(tplr),
                    prefix = $(tplr),
                    suffix = $(tplr),
                    extention = $(tplr),
                    checks = $('<div></div>').append(
                        mkChk(num, 'plusNumber'),
                        mkChk(prefix, 'asPrefix'),
                        mkChk(suffix, 'asSuffix'),
                        mkChk(extention, 'changeExtention')
                    ),
                    preview = $('<div class="elfinder-rename-batch-preview"></div>'),
                    node = $('<div class="elfinder-rename-batch"></div>').append(
                        $('<div class="elfinder-rename-batch-name"></div>').append(name),
                        $('<div class="elfinder-rename-batch-type"></div>').append(checks),
                        preview
                    ),
                    opts = {
                        title: fm.i18n('batchRename'),
                        modal: true,
                        destroyOnClose: true,
                        width: Math.min(380, fm.getUI().width() - 20),
                        buttons: {},
                        open: function () {
                            name.on('input', mkPrev).trigger('focus');
                        }
                    },
                    getName = function () {
                        var vName = name.val(),
                            ext = fm.splitFileExtention(fm.file(sel[0]).name)[1];
                        if (vName !== '' || num.is(':checked')) {
                            if (prefix.is(':checked')) {
                                vName += '*';
                            } else if (suffix.is(':checked')) {
                                vName = '*' + vName + '.' + ext;
                            } else if (extention.is(':checked')) {
                                vName = '*.' + vName;
                            } else if (ext) {
                                vName += '.' + ext;
                            }
                        }
                        return vName;
                    },
                    mkPrev = function () {
                        var vName = getName();
                        if (vName !== '') {
                            preview.html(fm.i18n(['renameMultiple', sel.length, getHint(vName)]));
                        } else {
                            preview.empty();
                        }
                    },
                    radios = checks.find('input:radio').on('change', mkPrev),
                    dialog;

                opts.buttons[fm.i18n('btnApply')] = function () {
                    var vName = getName(),
                        file, targets;
                    if (vName !== '') {
                        dialog.elfinderdialog('close');
                        targets = sel;
                        file = fm.file(targets.shift());
                        request(void (0), targets, file, vName);
                    }
                };
                opts.buttons[fm.i18n('btnCancel')] = function () {
                    dialog.elfinderdialog('close');
                };
                if ($.fn.checkboxradio) {
                    radios.checkboxradio({
                        create: function (e, ui) {
                            if (this === num.get(0)) {
                                num.prop('checked', true).change();
                            }
                        }
                    });
                } else {
                    checks.buttonset({
                        create: function (e, ui) {
                            num.prop('checked', true).change();
                        }
                    });
                }
                dialog = self.fmDialog(node, opts);
            };

        this.noChangeDirOnRemovedCwd = true;

        this.shortcuts = [{
            pattern: 'f2' + (fm.OS == 'mac' ? ' enter' : '')
        }, {
            pattern: 'shift+f2',
            description: 'batchRename',
            callback: function () {
                fm.selected().length > 1 && batchRename();
            }
        }];

        this.getstate = function (select) {
            var sel = this.files(select),
                cnt = sel.length,
                phash, ext, mime, brk, state, isRoot;

            if (!cnt) {
                return -1;
            }

            if (cnt > 1 && sel[0].phash) {
                phash = sel[0].phash;
                ext = fm.splitFileExtention(sel[0].name)[1].toLowerCase();
                mime = sel[0].mime;
            }
            if (cnt === 1) {
                isRoot = fm.isRoot(sel[0]);
            }

            state = (cnt === 1 && ((fm.cookieEnabled && isRoot) || !sel[0].locked) || (fm.api > 2.1030 && cnt === $.grep(sel, function (f) {
                if (!brk && !f.locked && f.phash === phash && !fm.isRoot(f) && (mime === f.mime || ext === fm.splitFileExtention(f.name)[1].toLowerCase())) {
                    return true;
                } else {
                    brk && (brk = true);
                    return false;
                }
            }).length)) ? 0 : -1;

            // because alwaysEnabled = true, it need check disabled on connector 
            if (!isRoot && state === 0 && fm.option('disabledFlip', sel[0].hash)['rename']) {
                state = -1;
            }

            if (state !== -1 && cnt > 1) {
                self.extra = {
                    icon: 'preference',
                    node: $('<span></span>')
                        .attr({ title: fm.i18n('batchRename') })
                        .on('click touchstart', function (e) {
                            if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                                return;
                            }
                            e.stopPropagation();
                            e.preventDefault();
                            fm.getUI().trigger('click'); // to close the context menu immediately
                            batchRename();
                        })
                };
            } else {
                delete self.extra;
            }

            return state;
        };

        this.exec = function (hashes, cOpts) {
            var cwd = fm.getUI('cwd'),
                sel = hashes || (fm.selected().length ? fm.selected() : false) || [fm.cwd().hash],
                cnt = sel.length,
                file = fm.file(sel.shift()),
                filename = '.elfinder-cwd-filename',
                opts = cOpts || {},
                incwd = (fm.cwd().hash == file.hash),
                type = (opts._currentType === 'navbar' || opts._currentType === 'files') ? opts._currentType : (incwd ? 'navbar' : 'files'),
                navbar = (type !== 'files'),
                target = fm[navbar ? 'navHash2Elm' : 'cwdHash2Elm'](file.hash),
                tarea = (!navbar && fm.storage('view') != 'list'),
                split = function (name) {
                    var ext = fm.splitFileExtention(name)[1];
                    return [name.substr(0, name.length - ext.length - 1), ext];
                },
                unselect = function () {
                    requestAnimationFrame(function () {
                        input && input.trigger('blur');
                    });
                },
                rest = function () {
                    if (!overlay.is(':hidden')) {
                        overlay.elfinderoverlay('hide').off('click close', cancel);
                    }
                    pnode.removeClass('ui-front')
                        .css('position', '')
                        .off('unselect.' + fm.namespace, unselect);
                    if (tarea) {
                        node && node.css('max-height', '');
                    } else if (!navbar) {
                        pnode.css('width', '')
                            .parent('td').css('overflow', '');
                    }
                }, colwidth,
                dfrd = $.Deferred()
                    .fail(function (error) {
                        var parent = input.parent(),
                            name = fm.escape(file.i18 || file.name);

                        input.off();
                        if (tarea) {
                            name = name.replace(/([_.])/g, '&#8203;$1');
                        }
                        requestAnimationFrame(function () {
                            if (navbar) {
                                input.replaceWith(name);
                            } else {
                                if (parent.length) {
                                    input.remove();
                                    parent.html(name);
                                } else {
                                    target.find(filename).html(name);
                                }
                            }
                        });
                        error && fm.error(error);
                    })
                    .always(function () {
                        rest();
                        fm.unbind('resize', resize);
                        fm.enable();
                    }),
                blur = function (e) {
                    var name = $.trim(input.val()),
                        splits = fm.splitFileExtention(name),
                        valid = true,
                        req = function () {
                            input.off();
                            rest();
                            if (navbar) {
                                input.replaceWith(fm.escape(name));
                            } else {
                                node.html(fm.escape(name));
                            }
                            request(dfrd, sel, file, name);
                        };

                    if (!overlay.is(':hidden')) {
                        pnode.css('z-index', '');
                    }
                    if (name === '') {
                        if (!fm.isRoot(file)) {
                            return cancel();
                        }
                        if (navbar) {
                            input.replaceWith(fm.escape(file.name));
                        } else {
                            node.html(fm.escape(file.name));
                        }
                    }
                    if (!inError && pnode.length) {

                        input.off('blur');

                        if (cnt === 1 && name === file.name) {
                            return dfrd.reject();
                        }
                        if (fm.options.validName && fm.options.validName.test) {
                            try {
                                valid = fm.options.validName.test(name);
                            } catch (e) {
                                valid = false;
                            }
                        }
                        if (name === '.' || name === '..' || !valid) {
                            inError = true;
                            fm.error(file.mime === 'directory' ? 'errInvDirname' : 'errInvName', { modal: true, close: function () { setTimeout(select, 120); } });
                            return false;
                        }
                        if (cnt === 1 && fm.fileByName(name, file.phash)) {
                            inError = true;
                            fm.error(['errExists', name], { modal: true, close: function () { setTimeout(select, 120); } });
                            return false;
                        }

                        if (cnt === 1) {
                            req();
                        } else {
                            fm.confirm({
                                title: 'cmdrename',
                                text: ['renameMultiple', cnt, getHint(name, [file.hash].concat(sel))],
                                accept: {
                                    label: 'btnYes',
                                    callback: req
                                },
                                cancel: {
                                    label: 'btnCancel',
                                    callback: function () {
                                        setTimeout(function () {
                                            inError = true;
                                            select();
                                        }, 120);
                                    }
                                }
                            });
                            setTimeout(function () {
                                fm.trigger('unselectfiles', { files: fm.selected() })
                                    .trigger('selectfiles', { files: [file.hash].concat(sel) });
                            }, 120);
                        }
                    }
                },
                input = $(tarea ? '<textarea></textarea>' : '<input type="text"/>')
                    .on('keyup text', function () {
                        if (tarea) {
                            this.style.height = '1px';
                            this.style.height = this.scrollHeight + 'px';
                        } else if (colwidth) {
                            this.style.width = colwidth + 'px';
                            if (this.scrollWidth > colwidth) {
                                this.style.width = this.scrollWidth + 10 + 'px';
                            }
                        }
                    })
                    .on('keydown', function (e) {
                        e.stopImmediatePropagation();
                        if (e.keyCode == $.ui.keyCode.ESCAPE) {
                            dfrd.reject();
                        } else if (e.keyCode == $.ui.keyCode.ENTER) {
                            e.preventDefault();
                            input.trigger('blur');
                        }
                    })
                    .on('mousedown click dblclick', function (e) {
                        e.stopPropagation();
                        if (e.type === 'dblclick') {
                            e.preventDefault();
                        }
                    })
                    .on('blur', blur)
                    .on('dragenter dragleave dragover drop', function (e) {
                        // stop bubbling to prevent upload with native drop event
                        e.stopPropagation();
                    }),
                select = function () {
                    var name = fm.splitFileExtention(input.val())[0];
                    if (!inError && fm.UA.Mobile && !fm.UA.iOS) { // since iOS has a bug? (z-index not effect) so disable it
                        overlay.on('click close', cancel).elfinderoverlay('show');
                        pnode.css('z-index', overlay.css('z-index') + 1);
                    }
                    !fm.enabled() && fm.enable();
                    if (inError) {
                        inError = false;
                        input.on('blur', blur);
                    }
                    input.trigger('focus').trigger('select');
                    input[0].setSelectionRange && input[0].setSelectionRange(0, name.length);
                },
                node = navbar ? target.contents().filter(function () { return this.nodeType == 3 && $(this).parent().attr('id') === fm.navHash2Id(file.hash); })
                    : target.find(filename),
                pnode = node.parent(),
                overlay = fm.getUI('overlay'),
                cancel = function (e) {
                    if (!overlay.is(':hidden')) {
                        pnode.css('z-index', '');
                    }
                    if (!inError) {
                        dfrd.reject();
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }
                },
                resize = function () {
                    target.trigger('scrolltoview', { blink: false });
                },
                inError = false;

            pnode.addClass('ui-front')
                .css('position', 'relative')
                .on('unselect.' + fm.namespace, unselect);
            fm.bind('resize', resize);
            if (navbar) {
                node.replaceWith(input.val(file.name));
            } else {
                if (tarea) {
                    node.css('max-height', 'none');
                } else if (!navbar) {
                    colwidth = pnode.width();
                    pnode.width(colwidth - 15)
                        .parent('td').css('overflow', 'visible');
                }
                node.empty().append(input.val(file.name));
            }

            if (cnt > 1 && fm.api <= 2.1030) {
                return dfrd.reject();
            }

            if (!file || !node.length) {
                return dfrd.reject('errCmdParams', this.title);
            }

            if (file.locked && !fm.isRoot(file)) {
                return dfrd.reject(['errLocked', file.name]);
            }

            fm.one('select', function () {
                input.parent().length && file && $.inArray(file.hash, fm.selected()) === -1 && input.trigger('blur');
            });

            input.trigger('keyup');

            select();

            return dfrd;
        };

        fm.bind('select contextmenucreate closecontextmenu', function (e) {
            var sel = (e.data ? (e.data.selected || e.data.targets) : null) || fm.selected(),
                file;
            if (sel && sel.length === 1 && (file = fm.file(sel[0])) && fm.isRoot(file)) {
                self.title = fm.i18n('kindAlias') + ' (' + fm.i18n('preference') + ')';
            } else {
                self.title = fm.i18n('cmdrename');
            }
            if (e.type !== 'closecontextmenu') {
                self.update(void (0), self.title);
            } else {
                requestAnimationFrame(function () {
                    self.update(void (0), self.title);
                });
            }
        }).remove(function (e) {
            var rootNames;
            if (e.data && e.data.removed && (rootNames = fm.storage('rootNames'))) {
                $.each(e.data.removed, function (i, h) {
                    if (rootNames[h]) {
                        delete rootNames[h];
                    }
                });
                fm.storage('rootNames', rootNames);
            }
        });
    };


    /*
     * File: /js/commands/resize.js
     */

    /**
     * @class  elFinder command "resize"
     * Open dialog to resize image
     *
     * @author Dmitry (dio) Levashov
     * @author Alexey Sukhotin
     * @author Naoki Sawada
     * @author Sergio Jovani
     **/
    elFinder.prototype.commands.resize = function () {
        "use strict";
        var fm = this.fm,
            losslessRotate = 0,
            getBounceBox = function (w, h, theta) {
                var srcPts = [
                    { x: w / 2, y: h / 2 },
                    { x: -w / 2, y: h / 2 },
                    { x: -w / 2, y: -h / 2 },
                    { x: w / 2, y: -h / 2 }
                ],
                    dstPts = [],
                    min = { x: Number.MAX_VALUE, y: Number.MAX_VALUE },
                    max = { x: Number.MIN_VALUE, y: Number.MIN_VALUE };
                $.each(srcPts, function (i, srcPt) {
                    dstPts.push({
                        x: srcPt.x * Math.cos(theta) - srcPt.y * Math.sin(theta),
                        y: srcPt.x * Math.sin(theta) + srcPt.y * Math.cos(theta)
                    });
                });
                $.each(dstPts, function (i, pt) {
                    min.x = Math.min(min.x, pt.x);
                    min.y = Math.min(min.y, pt.y);
                    max.x = Math.max(max.x, pt.x);
                    max.y = Math.max(max.y, pt.y);
                });
                return {
                    width: max.x - min.x, height: max.y - min.y
                };
            };

        this.updateOnSelect = false;

        this.getstate = function () {
            var sel = fm.selectedFiles();
            return sel.length == 1 && sel[0].read && sel[0].write && sel[0].mime.indexOf('image/') !== -1 ? 0 : -1;
        };

        this.resizeRequest = function (data, f, dfrd) {
            var file = f || fm.file(data.target),
                tmb = file ? file.tmb : null,
                enabled = fm.isCommandEnabled('resize', data.target);

            if (enabled && (!file || (file && file.read && file.write && file.mime.indexOf('image/') !== -1))) {
                return fm.request({
                    data: Object.assign(data, {
                        cmd: 'resize'
                    }),
                    notify: { type: 'resize', cnt: 1 }
                })
                    .fail(function (error) {
                        if (dfrd) {
                            dfrd.reject(error);
                        }
                    })
                    .done(function () {
                        if (data.quality) {
                            fm.storage('jpgQuality', data.quality === fm.option('jpgQuality') ? null : data.quality);
                        }
                        dfrd && dfrd.resolve();
                    });
            } else {
                var error;

                if (file) {
                    if (file.mime.indexOf('image/') === -1) {
                        error = ['errResize', file.name, 'errUsupportType'];
                    } else {
                        error = ['errResize', file.name, 'errPerm'];
                    }
                } else {
                    error = ['errResize', data.target, 'errPerm'];
                }

                if (dfrd) {
                    dfrd.reject(error);
                } else {
                    fm.error(error);
                }
                return $.Deferred().reject(error);
            }
        };

        this.exec = function (hashes) {
            var self = this,
                files = this.files(hashes),
                dfrd = $.Deferred(),
                api2 = (fm.api > 1),
                options = this.options,
                dialogWidth = 650,
                fmnode = fm.getUI(),
                ctrgrup = $().controlgroup ? 'controlgroup' : 'buttonset',
                grid8Def = typeof options.grid8px === 'undefined' || options.grid8px !== 'disable' ? true : false,
                presetSize = Array.isArray(options.presetSize) ? options.presetSize : [],
                clactive = 'elfinder-dialog-active',
                clsediting = fm.res('class', 'editing'),
                open = function (file, id, src) {
                    var isJpeg = (file.mime === 'image/jpeg'),
                        dialog = $('<div class="elfinder-resize-container"></div>'),
                        input = '<input type="number" class="ui-corner-all"/>',
                        row = '<div class="elfinder-resize-row"></div>',
                        label = '<div class="elfinder-resize-label"></div>',
                        changeTm = null,
                        operate = false,
                        opStart = function () { operate = true; },
                        opStop = function () {
                            if (operate) {
                                operate = false;
                                control.trigger('change');
                            }
                        },
                        control = $('<div class="elfinder-resize-control"></div>')
                            .on('focus', 'input[type=text],input[type=number]', function () {
                                $(this).trigger('select');
                            })
                            .on('change', function () {
                                changeTm && cancelAnimationFrame(changeTm);
                                changeTm = requestAnimationFrame(function () {
                                    var panel, quty, canvas, ctx, img, sx, sy, sw, sh, deg, theta, bb;
                                    if (sizeImg && !operate && (canvas = sizeImg.data('canvas'))) {
                                        panel = control.children('div.elfinder-resize-control-panel:visible');
                                        quty = panel.find('input.elfinder-resize-quality');
                                        if (quty.is(':visible')) {
                                            ctx = sizeImg.data('ctx');
                                            img = sizeImg.get(0);
                                            if (panel.hasClass('elfinder-resize-uiresize')) {
                                                // resize
                                                sw = canvas.width = width.val();
                                                sh = canvas.height = height.val();
                                                ctx.drawImage(img, 0, 0, sw, sh);
                                            } else if (panel.hasClass('elfinder-resize-uicrop')) {
                                                // crop
                                                sx = pointX.val();
                                                sy = pointY.val();
                                                sw = offsetX.val();
                                                sh = offsetY.val();
                                                canvas.width = sw;
                                                canvas.height = sh;
                                                ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
                                            } else {
                                                // rotate
                                                deg = degree.val();
                                                theta = (degree.val() * Math.PI) / 180;
                                                bb = getBounceBox(owidth, oheight, theta);
                                                sw = canvas.width = bb.width;
                                                sh = canvas.height = bb.height;
                                                ctx.save();
                                                if (deg % 90 !== 0) {
                                                    ctx.fillStyle = bg.val() || '#FFF';
                                                    ctx.fillRect(0, 0, sw, sh);
                                                }
                                                ctx.translate(sw / 2, sh / 2);
                                                ctx.rotate(theta);
                                                ctx.drawImage(img, -img.width / 2, -img.height / 2, owidth, oheight);
                                                ctx.restore();
                                            }
                                            canvas.toBlob(function (blob) {
                                                if (blob) {
                                                    size1 = blob.size;
                                                    quty.next('span').text(' (' + fm.formatSize(blob.size) + ')');
                                                }
                                            }, 'image/jpeg', Math.max(Math.min(quty.val(), 100), 1) / 100);
                                        }
                                    }
                                });
                            })
                            .on('mouseup', 'input', function (e) {
                                $(e.target).trigger('change');
                            }),
                        preview = $('<div class="elfinder-resize-preview"></div>')
                            .on('touchmove', function (e) {
                                if ($(e.target).hasClass('touch-punch')) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
                            }),
                        spinner = $('<div class="elfinder-resize-loading">' + fm.i18n('ntfloadimg') + '</div>'),
                        rhandle = $('<div class="elfinder-resize-handle touch-punch"></div>'),
                        rhandlec = $('<div class="elfinder-resize-handle touch-punch"></div>'),
                        uiresize = $('<div class="elfinder-resize-uiresize elfinder-resize-control-panel"></div>'),
                        uicrop = $('<div class="elfinder-resize-uicrop elfinder-resize-control-panel"></div>'),
                        uirotate = $('<div class="elfinder-resize-rotate elfinder-resize-control-panel"></div>'),
                        uideg270 = $('<button></button>').attr('title', fm.i18n('rotate-cw')).append($('<span class="elfinder-button-icon elfinder-button-icon-rotate-l"></span>')),
                        uideg90 = $('<button></button>').attr('title', fm.i18n('rotate-ccw')).append($('<span class="elfinder-button-icon elfinder-button-icon-rotate-r"></span>')),
                        uiprop = $('<span ></span>'),
                        reset = $('<button class="elfinder-resize-reset">').text(fm.i18n('reset'))
                            .on('click', function () {
                                resetView();
                            })
                            .button({
                                icons: {
                                    primary: 'ui-icon-arrowrefresh-1-n'
                                },
                                text: false
                            }),
                        uitype = $('<div class="elfinder-resize-type"></div>')
                            .append('<input type="radio" name="type" id="' + id + '-resize" value="resize" checked="checked" /><label for="' + id + '-resize">' + fm.i18n('resize') + '</label>',
                                '<input class="api2" type="radio" name="type" id="' + id + '-crop" value="crop" /><label class="api2" for="' + id + '-crop">' + fm.i18n('crop') + '</label>',
                                '<input class="api2" type="radio" name="type" id="' + id + '-rotate" value="rotate" /><label class="api2" for="' + id + '-rotate">' + fm.i18n('rotate') + '</label>'),
                        mode = 'resize',
                        type = uitype[ctrgrup]()[ctrgrup]('disable').find('input')
                            .on('change', function () {
                                mode = $(this).val();

                                resetView();
                                resizable(true);
                                croppable(true);
                                rotateable(true);

                                if (mode == 'resize') {
                                    uiresize.show();
                                    uirotate.hide();
                                    uicrop.hide();
                                    resizable();
                                    isJpeg && grid8px.insertAfter(uiresize.find('.elfinder-resize-grid8'));
                                }
                                else if (mode == 'crop') {
                                    uirotate.hide();
                                    uiresize.hide();
                                    uicrop.show();
                                    croppable();
                                    isJpeg && grid8px.insertAfter(uicrop.find('.elfinder-resize-grid8'));
                                } else if (mode == 'rotate') {
                                    uiresize.hide();
                                    uicrop.hide();
                                    uirotate.show();
                                    rotateable();
                                }
                            }),
                        width = $(input)
                            .on('change', function () {
                                var w = round(parseInt(width.val())),
                                    h = round(cratio ? w / ratio : parseInt(height.val()));

                                if (w > 0 && h > 0) {
                                    resize.updateView(w, h);
                                    width.val(w);
                                    height.val(h);
                                }
                            }).addClass('elfinder-focus'),
                        height = $(input)
                            .on('change', function () {
                                var h = round(parseInt(height.val())),
                                    w = round(cratio ? h * ratio : parseInt(width.val()));

                                if (w > 0 && h > 0) {
                                    resize.updateView(w, h);
                                    width.val(w);
                                    height.val(h);
                                }
                            }),
                        pointX = $(input).on('change', function () { crop.updateView(); }),
                        pointY = $(input).on('change', function () { crop.updateView(); }),
                        offsetX = $(input).on('change', function () { crop.updateView('w'); }),
                        offsetY = $(input).on('change', function () { crop.updateView('h'); }),
                        quality = isJpeg && api2 ?
                            $(input).val(fm.storage('jpgQuality') > 0 ? fm.storage('jpgQuality') : fm.option('jpgQuality'))
                                .addClass('elfinder-resize-quality')
                                .attr('min', '1').attr('max', '100').attr('title', '1 - 100')
                                .on('blur', function () {
                                    var q = Math.min(100, Math.max(1, parseInt(this.value)));
                                    control.find('input.elfinder-resize-quality').val(q);
                                })
                            : null,
                        degree = $('<input type="number" class="ui-corner-all" maxlength="3" value="0" />')
                            .on('change', function () {
                                rotate.update();
                            }),
                        uidegslider = $('<div class="elfinder-resize-rotate-slider touch-punch"></div>')
                            .slider({
                                min: 0,
                                max: 360,
                                value: degree.val(),
                                animate: true,
                                start: opStart,
                                stop: opStop,
                                change: function (event, ui) {
                                    if (ui.value != uidegslider.slider('value')) {
                                        rotate.update(ui.value);
                                    }
                                },
                                slide: function (event, ui) {
                                    rotate.update(ui.value, false);
                                }
                            }).find('.ui-slider-handle')
                            .addClass('elfinder-tabstop')
                            .off('keydown')
                            .on('keydown', function (e) {
                                if (e.keyCode == $.ui.keyCode.LEFT || e.keyCode == $.ui.keyCode.RIGHT) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    rotate.update(Number(degree.val()) + (e.keyCode == $.ui.keyCode.RIGHT ? 1 : -1), false);
                                }
                            })
                            .end(),
                        pickimg,
                        pickcanv,
                        pickctx,
                        pickc = {},
                        pick = function (e) {
                            var color, r, g, b, h, s, l;

                            try {
                                color = pickc[Math.round(e.offsetX)][Math.round(e.offsetY)];
                            } catch (e) { }
                            if (!color) return;

                            r = color[0]; g = color[1]; b = color[2];
                            h = color[3]; s = color[4]; l = color[5];

                            setbg(r, g, b, (e.type === 'click'));
                        },
                        palpick = function (e) {
                            setbg($(this).css('backgroundColor'), '', '', (e.type === 'click'));
                        },
                        setbg = function (r, g, b, off) {
                            var s, m, cc;
                            if (typeof r === 'string') {
                                g = '';
                                if (r && (s = $('<span>').css('backgroundColor', r).css('backgroundColor')) && (m = s.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i))) {
                                    r = Number(m[1]);
                                    g = Number(m[2]);
                                    b = Number(m[3]);
                                }
                            }
                            cc = (g === '') ? r : '#' + getColorCode(r, g, b);
                            bg.val(cc).css({ backgroundColor: cc, backgroundImage: 'none', color: (r + g + b < 384 ? '#fff' : '#000') });
                            preview.css('backgroundColor', cc);
                            if (off) {
                                imgr.off('.picker').removeClass('elfinder-resize-picking');
                                pallet.off('.picker').removeClass('elfinder-resize-picking');
                            }
                        },
                        getColorCode = function (r, g, b) {
                            return $.map([r, g, b], function (c) { return ('0' + parseInt(c).toString(16)).slice(-2); }).join('');
                        },
                        picker = $('<button>').text(fm.i18n('colorPicker'))
                            .on('click', function () {
                                imgr.on('mousemove.picker click.picker', pick).addClass('elfinder-resize-picking');
                                pallet.on('mousemove.picker click.picker', 'span', palpick).addClass('elfinder-resize-picking');
                            })
                            .button({
                                icons: {
                                    primary: 'ui-icon-pin-s'
                                },
                                text: false
                            }),
                        reseter = $('<button>').text(fm.i18n('reset'))
                            .on('click', function () {
                                setbg('', '', '', true);
                            })
                            .button({
                                icons: {
                                    primary: 'ui-icon-arrowrefresh-1-n'
                                },
                                text: false
                            }),
                        bg = $('<input class="ui-corner-all elfinder-resize-bg" type="text">')
                            .on('focus', function () {
                                $(this).attr('style', '');
                            })
                            .on('blur', function () {
                                setbg($(this).val());
                            }),
                        pallet = $('<div class="elfinder-resize-pallet">').on('click', 'span', function () {
                            setbg($(this).css('backgroundColor'));
                        }),
                        ratio = 1,
                        prop = 1,
                        owidth = 0,
                        oheight = 0,
                        cratio = true,
                        cratioc = false,
                        pwidth = 0,
                        pheight = 0,
                        rwidth = 0,
                        rheight = 0,
                        rdegree = 0,
                        grid8 = isJpeg ? grid8Def : false,
                        constr = $('<button>').html(fm.i18n('aspectRatio'))
                            .on('click', function () {
                                cratio = !cratio;
                                constr.button('option', {
                                    icons: { primary: cratio ? 'ui-icon-locked' : 'ui-icon-unlocked' }
                                });
                                resize.fixHeight();
                                rhandle.resizable('option', 'aspectRatio', cratio).data('uiResizable')._aspectRatio = cratio;
                            })
                            .button({
                                icons: {
                                    primary: cratio ? 'ui-icon-locked' : 'ui-icon-unlocked'
                                },
                                text: false
                            }),
                        constrc = $('<button>').html(fm.i18n('aspectRatio'))
                            .on('click', function () {
                                cratioc = !cratioc;
                                constrc.button('option', {
                                    icons: { primary: cratioc ? 'ui-icon-locked' : 'ui-icon-unlocked' }
                                });
                                rhandlec.resizable('option', 'aspectRatio', cratioc).data('uiResizable')._aspectRatio = cratioc;
                            })
                            .button({
                                icons: {
                                    primary: cratioc ? 'ui-icon-locked' : 'ui-icon-unlocked'
                                },
                                text: false
                            }),
                        grid8px = $('<button>').html(fm.i18n(grid8 ? 'enabled' : 'disabled')).toggleClass('ui-state-active', grid8)
                            .on('click', function () {
                                grid8 = !grid8;
                                grid8px.html(fm.i18n(grid8 ? 'enabled' : 'disabled')).toggleClass('ui-state-active', grid8);
                                setStep8();
                            })
                            .button(),
                        setStep8 = function () {
                            var step = grid8 ? 8 : 1;
                            $.each([width, height, offsetX, offsetY, pointX, pointY], function () {
                                this.attr('step', step);
                            });
                            if (grid8) {
                                width.val(round(width.val()));
                                height.val(round(height.val()));
                                offsetX.val(round(offsetX.val()));
                                offsetY.val(round(offsetY.val()));
                                pointX.val(round(pointX.val()));
                                pointY.val(round(pointY.val()));
                                if (uiresize.is(':visible')) {
                                    resize.updateView(width.val(), height.val());
                                } else if (uicrop.is(':visible')) {
                                    crop.updateView();
                                }
                            }
                        },
                        setuprimg = function () {
                            var r_scale,
                                fail = function () {
                                    bg.parent().hide();
                                    pallet.hide();
                                };
                            r_scale = Math.min(pwidth, pheight) / Math.sqrt(Math.pow(owidth, 2) + Math.pow(oheight, 2));
                            rwidth = Math.ceil(owidth * r_scale);
                            rheight = Math.ceil(oheight * r_scale);
                            imgr.width(rwidth)
                                .height(rheight)
                                .css('margin-top', (pheight - rheight) / 2 + 'px')
                                .css('margin-left', (pwidth - rwidth) / 2 + 'px');
                            if (imgr.is(':visible') && bg.is(':visible')) {
                                if (file.mime !== 'image/png') {
                                    preview.css('backgroundColor', bg.val());
                                    pickimg = $('<img>');
                                    if (fm.isCORS) {
                                        pickimg.attr('crossorigin', 'use-credentials');
                                    }
                                    pickimg.on('load', function () {
                                        if (pickcanv && pickcanv.width !== rwidth) {
                                            setColorData();
                                        }
                                    })
                                        .on('error', fail)
                                        .attr('src', canvSrc);
                                } else {
                                    fail();
                                }
                            }
                        },
                        setupimg = function () {
                            resize.updateView(owidth, oheight);
                            setuprimg();
                            basec
                                .width(img.width())
                                .height(img.height());
                            imgc
                                .width(img.width())
                                .height(img.height());
                            crop.updateView();
                            jpgCalc();
                        },
                        setColorData = function () {
                            if (pickctx) {
                                var n, w, h, r, g, b, a, s, l, hsl, hue,
                                    data, scale, tx1, tx2, ty1, ty2, rgb,
                                    domi = {},
                                    domic = [],
                                    domiv, palc,
                                    rgbToHsl = function (r, g, b) {
                                        var h, s, l,
                                            max = Math.max(Math.max(r, g), b),
                                            min = Math.min(Math.min(r, g), b);

                                        // Hue, 0 ~ 359
                                        if (max === min) {
                                            h = 0;
                                        } else if (r === max) {
                                            h = ((g - b) / (max - min) * 60 + 360) % 360;
                                        } else if (g === max) {
                                            h = (b - r) / (max - min) * 60 + 120;
                                        } else if (b === max) {
                                            h = (r - g) / (max - min) * 60 + 240;
                                        }
                                        // Saturation, 0 ~ 1
                                        s = (max - min) / max;
                                        // Lightness, 0 ~ 1
                                        l = (r * 0.3 + g * 0.59 + b * 0.11) / 255;

                                        return [h, s, l, 'hsl'];
                                    },
                                    rgbRound = function (c) {
                                        return Math.round(c / 8) * 8;
                                    };

                                calc:
                                try {
                                    w = pickcanv.width = imgr.width();
                                    h = pickcanv.height = imgr.height();
                                    scale = w / owidth;
                                    pickctx.scale(scale, scale);
                                    pickctx.drawImage(pickimg.get(0), 0, 0);

                                    data = pickctx.getImageData(0, 0, w, h).data;

                                    // Range to detect the dominant color
                                    tx1 = w * 0.1;
                                    tx2 = w * 0.9;
                                    ty1 = h * 0.1;
                                    ty2 = h * 0.9;

                                    for (var y = 0; y < h - 1; y++) {
                                        for (var x = 0; x < w - 1; x++) {
                                            n = x * 4 + y * w * 4;
                                            // RGB
                                            r = data[n]; g = data[n + 1]; b = data[n + 2]; a = data[n + 3];
                                            // check alpha ch
                                            if (a !== 255) {
                                                bg.parent().hide();
                                                pallet.hide();
                                                break calc;
                                            }
                                            // HSL
                                            hsl = rgbToHsl(r, g, b);
                                            hue = Math.round(hsl[0]); s = Math.round(hsl[1] * 100); l = Math.round(hsl[2] * 100);
                                            if (!pickc[x]) {
                                                pickc[x] = {};
                                            }
                                            // set pickc
                                            pickc[x][y] = [r, g, b, hue, s, l];
                                            // detect the dominant color
                                            if ((x < tx1 || x > tx2) && (y < ty1 || y > ty2)) {
                                                rgb = rgbRound(r) + ',' + rgbRound(g) + ',' + rgbRound(b);
                                                if (!domi[rgb]) {
                                                    domi[rgb] = 1;
                                                } else {
                                                    ++domi[rgb];
                                                }
                                            }
                                        }
                                    }

                                    if (!pallet.children(':first').length) {
                                        palc = 1;
                                        $.each(domi, function (c, v) {
                                            domic.push({ c: c, v: v });
                                        });
                                        $.each(domic.sort(function (a, b) {
                                            return (a.v > b.v) ? -1 : 1;
                                        }), function () {
                                            if (this.v < 2 || palc > 10) {
                                                return false;
                                            }
                                            pallet.append($('<span style="width:20px;height:20px;display:inline-block;background-color:rgb(' + this.c + ');">'));
                                            ++palc;
                                        });
                                    }
                                } catch (e) {
                                    picker.hide();
                                    pallet.hide();
                                }
                            }
                        },
                        setupPicker = function () {
                            try {
                                pickcanv = document.createElement('canvas');
                                pickctx = pickcanv.getContext('2d');
                            } catch (e) {
                                picker.hide();
                                pallet.hide();
                            }
                        },
                        setupPreset = function () {
                            preset.on('click', 'span.elfinder-resize-preset', function () {
                                var btn = $(this),
                                    w = btn.data('s')[0],
                                    h = btn.data('s')[1],
                                    r = owidth / oheight;
                                btn.data('s', [h, w]).text(h + 'x' + w);
                                if (owidth > w || oheight > h) {
                                    if (owidth <= w) {
                                        w = round(h * r);
                                    } else if (oheight <= h) {
                                        h = round(w / r);
                                    } else {
                                        if (owidth - w > oheight - h) {
                                            h = round(w / r);
                                        } else {
                                            w = round(h * r);
                                        }
                                    }
                                } else {
                                    w = owidth;
                                    h = oheight;
                                }
                                width.val(w);
                                height.val(h);
                                resize.updateView(w, h);
                                jpgCalc();
                            });
                            presetc.on('click', 'span.elfinder-resize-preset', function () {
                                var btn = $(this),
                                    w = btn.data('s')[0],
                                    h = btn.data('s')[1],
                                    x = pointX.val(),
                                    y = pointY.val();

                                btn.data('s', [h, w]).text(h + 'x' + w);
                                if (owidth >= w && oheight >= h) {
                                    if (owidth - w - x < 0) {
                                        x = owidth - w;
                                    }
                                    if (oheight - h - y < 0) {
                                        y = oheight - h;
                                    }
                                    pointX.val(x);
                                    pointY.val(y);
                                    offsetX.val(w);
                                    offsetY.val(h);
                                    crop.updateView();
                                    jpgCalc();
                                }
                            });
                            presetc.children('span.elfinder-resize-preset').each(function () {
                                var btn = $(this),
                                    w = btn.data('s')[0],
                                    h = btn.data('s')[1];

                                btn[(owidth >= w && oheight >= h) ? 'show' : 'hide']();
                            });
                        },
                        dimreq = null,
                        inited = false,
                        setdim = function (dim) {
                            var rfile = fm.file(file.hash);
                            rfile.width = dim[0];
                            rfile.height = dim[1];
                        },
                        init = function () {
                            var elm, memSize, r_scale, imgRatio;

                            if (inited) {
                                return;
                            }
                            inited = true;
                            dimreq && dimreq.state && dimreq.state() === 'pending' && dimreq.reject();

                            // check lossless rotete
                            if (fm.api >= 2.1030) {
                                if (losslessRotate === 0) {
                                    fm.request({
                                        data: {
                                            cmd: 'resize',
                                            target: file.hash,
                                            degree: 0,
                                            mode: 'rotate'
                                        },
                                        preventDefault: true
                                    }).done(function (data) {
                                        losslessRotate = data.losslessRotate ? 1 : -1;
                                        if (losslessRotate === 1 && (degree.val() % 90 === 0)) {
                                            uirotate.children('div.elfinder-resize-quality').hide();
                                        }
                                    }).fail(function () {
                                        losslessRotate = -1;
                                    });
                                }
                            } else {
                                losslessRotate = -1;
                            }

                            elm = img.get(0);
                            memSize = file.width && file.height ? { w: file.width, h: file.height } : (elm.naturalWidth ? null : { w: img.width(), h: img.height() });

                            memSize && img.removeAttr('width').removeAttr('height');

                            owidth = file.width || elm.naturalWidth || elm.width || img.width();
                            oheight = file.height || elm.naturalHeight || elm.height || img.height();
                            if (!file.width || !file.height) {
                                setdim([owidth, oheight]);
                            }

                            memSize && img.width(memSize.w).height(memSize.h);

                            dMinBtn.show();

                            imgRatio = oheight / owidth;

                            if (imgRatio < 1 && preview.height() > preview.width() * imgRatio) {
                                preview.height(preview.width() * imgRatio);
                            }

                            if (preview.height() > img.height() + 20) {
                                preview.height(img.height() + 20);
                            }

                            pheight = preview.height() - (rhandle.outerHeight() - rhandle.height());

                            spinner.remove();

                            ratio = owidth / oheight;

                            rhandle.append(img.show()).show();
                            width.val(owidth);
                            height.val(oheight);

                            setupPicker();
                            setupPreset();
                            setupimg();

                            uitype[ctrgrup]('enable');
                            control.find('input,select').prop('disabled', false)
                                .filter(':text').on('keydown', function (e) {
                                    var cOpts;
                                    if (e.keyCode == $.ui.keyCode.ENTER) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        cOpts = {
                                            title: $('input:checked', uitype).val(),
                                            text: 'confirmReq',
                                            accept: {
                                                label: 'btnApply',
                                                callback: function () {
                                                    save();
                                                }
                                            },
                                            cancel: {
                                                label: 'btnCancel',
                                                callback: function () {
                                                    $(this).trigger('focus');
                                                }
                                            }
                                        };

                                        if (useSaveAs) {
                                            cOpts['buttons'] = [{
                                                label: 'btnSaveAs',
                                                callback: function () {
                                                    requestAnimationFrame(saveAs);
                                                }
                                            }];
                                        }
                                        fm.confirm(cOpts);
                                        return;
                                    }
                                })
                                .on('keyup', function () {
                                    var $this = $(this);
                                    if (!$this.hasClass('elfinder-resize-bg')) {
                                        requestAnimationFrame(function () {
                                            $this.val($this.val().replace(/[^0-9]/g, ''));
                                        });
                                    }
                                })
                                .filter(':first');

                            setStep8();
                            !fm.UA.Mobile && width.trigger('focus');
                            resizable();
                        },
                        img = $('<img/>')
                            .on('load', init)
                            .on('error', function () {
                                spinner.html(fm.i18n('ntfsmth')).css('background', 'transparent');
                            }),
                        basec = $('<div></div>'),
                        imgc = $('<img/>'),
                        coverc = $('<div></div>'),
                        imgr = $('<img class="elfinder-resize-imgrotate" />'),
                        round = function (v, max) {
                            v = grid8 ? Math.round(v / 8) * 8 : Math.round(v);
                            v = Math.max(0, v);
                            if (max && v > max) {
                                v = grid8 ? Math.floor(max / 8) * 8 : max;
                            }
                            return v;
                        },
                        resetView = function () {
                            width.val(owidth);
                            height.val(oheight);
                            resize.updateView(owidth, oheight);
                            pointX.val(0);
                            pointY.val(0);
                            offsetX.val(owidth);
                            offsetY.val(oheight);
                            crop.updateView();
                            jpgCalc();
                        },
                        resize = {
                            update: function () {
                                width.val(round(img.width() / prop));
                                height.val(round(img.height() / prop));
                                jpgCalc();
                            },

                            updateView: function (w, h) {
                                if (w > pwidth || h > pheight) {
                                    if (w / pwidth > h / pheight) {
                                        prop = pwidth / w;
                                        img.width(pwidth).height(round(h * prop));
                                    } else {
                                        prop = pheight / h;
                                        img.height(pheight).width(round(w * prop));
                                    }
                                } else {
                                    img.width(round(w)).height(round(h));
                                }

                                prop = img.width() / w;
                                uiprop.text('1 : ' + (1 / prop).toFixed(2));
                                resize.updateHandle();
                            },

                            updateHandle: function () {
                                rhandle.width(img.width()).height(img.height());
                            },
                            fixHeight: function () {
                                var w, h;
                                if (cratio) {
                                    w = width.val();
                                    h = round(w / ratio);
                                    resize.updateView(w, h);
                                    height.val(h);
                                }
                            }
                        },
                        crop = {
                            update: function (change) {
                                pointX.val(round(((rhandlec.data('x') || rhandlec.position().left)) / prop, owidth));
                                pointY.val(round(((rhandlec.data('y') || rhandlec.position().top)) / prop, oheight));
                                if (change !== 'xy') {
                                    offsetX.val(round((rhandlec.data('w') || rhandlec.width()) / prop, owidth - pointX.val()));
                                    offsetY.val(round((rhandlec.data('h') || rhandlec.height()) / prop, oheight - pointY.val()));
                                }
                                jpgCalc();
                            },
                            updateView: function (change) {
                                var r, x, y, w, h;

                                pointX.val(round(pointX.val(), owidth - (grid8 ? 8 : 1)));
                                pointY.val(round(pointY.val(), oheight - (grid8 ? 8 : 1)));
                                offsetX.val(round(offsetX.val(), owidth - pointX.val()));
                                offsetY.val(round(offsetY.val(), oheight - pointY.val()));

                                if (cratioc) {
                                    r = coverc.width() / coverc.height();
                                    if (change === 'w') {
                                        offsetY.val(round(parseInt(offsetX.val()) / r));
                                    } else if (change === 'h') {
                                        offsetX.val(round(parseInt(offsetY.val()) * r));
                                    }
                                }
                                x = Math.round(parseInt(pointX.val()) * prop);
                                y = Math.round(parseInt(pointY.val()) * prop);
                                if (change !== 'xy') {
                                    w = Math.round(parseInt(offsetX.val()) * prop);
                                    h = Math.round(parseInt(offsetY.val()) * prop);
                                } else {
                                    w = rhandlec.data('w');
                                    h = rhandlec.data('h');
                                }
                                rhandlec.data({ x: x, y: y, w: w, h: h })
                                    .width(w)
                                    .height(h)
                                    .css({ left: x, top: y });
                                coverc.width(w)
                                    .height(h);
                            },
                            resize_update: function (e, ui) {
                                rhandlec.data({ x: ui.position.left, y: ui.position.top, w: ui.size.width, h: ui.size.height });
                                crop.update();
                                crop.updateView();
                            },
                            drag_update: function (e, ui) {
                                rhandlec.data({ x: ui.position.left, y: ui.position.top });
                                crop.update('xy');
                            }
                        },
                        rotate = {
                            mouseStartAngle: 0,
                            imageStartAngle: 0,
                            imageBeingRotated: false,

                            setQuality: function () {
                                uirotate.children('div.elfinder-resize-quality')[(losslessRotate > 0 && (degree.val() % 90) === 0) ? 'hide' : 'show']();
                            },

                            update: function (value, animate) {
                                if (typeof value == 'undefined') {
                                    rdegree = value = parseInt(degree.val());
                                }
                                if (typeof animate == 'undefined') {
                                    animate = true;
                                }
                                if (!animate || fm.UA.Opera || fm.UA.ltIE8) {
                                    imgr.rotate(value);
                                } else {
                                    imgr.animate({ rotate: value + (fm.UA.Chrome ? '' : 'deg') });
                                }
                                value = value % 360;
                                if (value < 0) {
                                    value += 360;
                                }
                                degree.val(parseInt(value));

                                uidegslider.slider('value', degree.val());

                                rotate.setQuality();
                            },

                            execute: function (e) {

                                if (!rotate.imageBeingRotated) return;

                                var imageCentre = rotate.getCenter(imgr);
                                var ev = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
                                var mouseXFromCentre = ev.pageX - imageCentre[0];
                                var mouseYFromCentre = ev.pageY - imageCentre[1];
                                var mouseAngle = Math.atan2(mouseYFromCentre, mouseXFromCentre);

                                var rotateAngle = mouseAngle - rotate.mouseStartAngle + rotate.imageStartAngle;
                                rotateAngle = Math.round(parseFloat(rotateAngle) * 180 / Math.PI);

                                if (e.shiftKey) {
                                    rotateAngle = Math.round((rotateAngle + 6) / 15) * 15;
                                }

                                imgr.rotate(rotateAngle);

                                rotateAngle = rotateAngle % 360;
                                if (rotateAngle < 0) {
                                    rotateAngle += 360;
                                }
                                degree.val(rotateAngle);

                                uidegslider.slider('value', degree.val());

                                rotate.setQuality();

                                return false;
                            },

                            start: function (e) {
                                if (imgr.hasClass('elfinder-resize-picking')) {
                                    return;
                                }

                                opStart();
                                rotate.imageBeingRotated = true;

                                var imageCentre = rotate.getCenter(imgr);
                                var ev = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
                                var mouseStartXFromCentre = ev.pageX - imageCentre[0];
                                var mouseStartYFromCentre = ev.pageY - imageCentre[1];
                                rotate.mouseStartAngle = Math.atan2(mouseStartYFromCentre, mouseStartXFromCentre);

                                rotate.imageStartAngle = parseFloat(imgr.rotate()) * Math.PI / 180.0;

                                $(document).on('mousemove', rotate.execute);
                                imgr.on('touchmove', rotate.execute);

                                return false;
                            },

                            stop: function (e) {

                                if (!rotate.imageBeingRotated) return;

                                $(document).off('mousemove', rotate.execute);
                                imgr.off('touchmove', rotate.execute);

                                requestAnimationFrame(function () { rotate.imageBeingRotated = false; });
                                opStop();

                                return false;
                            },

                            getCenter: function (image) {

                                var currentRotation = imgr.rotate();
                                imgr.rotate(0);

                                var imageOffset = imgr.offset();
                                var imageCentreX = imageOffset.left + imgr.width() / 2;
                                var imageCentreY = imageOffset.top + imgr.height() / 2;

                                imgr.rotate(currentRotation);

                                return Array(imageCentreX, imageCentreY);
                            }
                        },
                        resizable = function (destroy) {
                            if (destroy) {
                                rhandle.filter(':ui-resizable').resizable('destroy');
                                rhandle.hide();
                            }
                            else {
                                rhandle.show();
                                rhandle.resizable({
                                    alsoResize: img,
                                    aspectRatio: cratio,
                                    resize: resize.update,
                                    start: opStart,
                                    stop: function (e) {
                                        resize.fixHeight;
                                        resize.updateView(width.val(), height.val());
                                        opStop();
                                    }
                                });
                                dinit();
                            }
                        },
                        croppable = function (destroy) {
                            if (destroy) {
                                rhandlec.filter(':ui-resizable').resizable('destroy')
                                    .filter(':ui-draggable').draggable('destroy');
                                basec.hide();
                            }
                            else {
                                basec.show();

                                rhandlec
                                    .resizable({
                                        containment: basec,
                                        aspectRatio: cratioc,
                                        resize: crop.resize_update,
                                        start: opStart,
                                        stop: opStop,
                                        handles: 'all'
                                    })
                                    .draggable({
                                        handle: coverc,
                                        containment: imgc,
                                        drag: crop.drag_update,
                                        start: opStart,
                                        stop: function () {
                                            crop.updateView('xy');
                                            opStop();
                                        }
                                    });

                                dinit();
                                crop.update();
                            }
                        },
                        rotateable = function (destroy) {
                            if (destroy) {
                                imgr.hide();
                            }
                            else {
                                imgr.show();
                                dinit();
                            }
                        },
                        checkVals = function () {
                            var w, h, x, y, d, q, b = '';

                            if (mode == 'resize') {
                                w = parseInt(width.val()) || 0;
                                h = parseInt(height.val()) || 0;
                            } else if (mode == 'crop') {
                                w = parseInt(offsetX.val()) || 0;
                                h = parseInt(offsetY.val()) || 0;
                                x = parseInt(pointX.val()) || 0;
                                y = parseInt(pointY.val()) || 0;
                            } else if (mode == 'rotate') {
                                w = owidth;
                                h = oheight;
                                d = parseInt(degree.val()) || 0;
                                if (d < 0 || d > 360) {
                                    fm.error('Invalid rotate degree');
                                    return false;
                                }
                                if (d == 0 || d == 360) {
                                    fm.error('errResizeNoChange');
                                    return false;
                                }
                                b = bg.val();
                            }
                            q = quality ? parseInt(quality.val()) : 0;

                            if (mode != 'rotate') {
                                if (w <= 0 || h <= 0) {
                                    fm.error('Invalid image size');
                                    return false;
                                }
                                if (w == owidth && h == oheight && parseInt(size0 / 1000) === parseInt(size1 / 1000)) {
                                    fm.error('errResizeNoChange');
                                    return false;
                                }
                            }

                            return { w: w, h: h, x: x, y: y, d: d, q: q, b: b };
                        },
                        save = function () {
                            var vals;

                            if (vals = checkVals()) {
                                dialog.elfinderdialog('close');
                                self.resizeRequest({
                                    target: file.hash,
                                    width: vals.w,
                                    height: vals.h,
                                    x: vals.x,
                                    y: vals.y,
                                    degree: vals.d,
                                    quality: vals.q,
                                    bg: vals.b,
                                    mode: mode
                                }, file, dfrd);
                            }
                        },
                        saveAs = function () {
                            var fail = function () {
                                dialogs.addClass(clsediting).fadeIn(function () {
                                    base.addClass(clactive);
                                });
                                fm.disable();
                            },
                                make = function () {
                                    self.mime = file.mime;
                                    self.prefix = file.name.replace(/ \d+(\.[^.]+)?$/, '$1');
                                    self.requestCmd = 'mkfile';
                                    self.nextAction = {};
                                    self.data = { target: file.phash };
                                    $.proxy(fm.res('mixin', 'make'), self)()
                                        .done(function (data) {
                                            var hash, dfd;
                                            if (data.added && data.added.length) {
                                                hash = data.added[0].hash;
                                                dfd = fm.api < 2.1032 ? fm.url(file.hash, { async: true, temporary: true }) : null;
                                                $.when(dfd).done(function (url) {
                                                    fm.request({
                                                        options: { type: 'post' },
                                                        data: {
                                                            cmd: 'put',
                                                            target: hash,
                                                            encoding: dfd ? 'scheme' : 'hash',
                                                            content: dfd ? fm.convAbsUrl(url) : file.hash
                                                        },
                                                        notify: { type: 'copy', cnt: 1 },
                                                        syncOnFail: true
                                                    })
                                                        .fail(fail)
                                                        .done(function (data) {
                                                            data = fm.normalize(data);
                                                            fm.updateCache(data);
                                                            file = fm.file(hash);
                                                            data.changed && data.changed.length && fm.change(data);
                                                            base.show().find('.elfinder-dialog-title').html(fm.escape(file.name));
                                                            save();
                                                            dialogs.fadeIn();
                                                        });
                                                }).fail(fail);
                                            } else {
                                                fail();
                                            }
                                        })
                                        .fail(fail)
                                        .always(function () {
                                            delete self.mime;
                                            delete self.prefix;
                                            delete self.nextAction;
                                            delete self.data;
                                        });
                                    fm.trigger('unselectfiles', { files: [file.hash] });
                                },
                                reqOpen = null,
                                dialogs;

                            if (checkVals()) {
                                dialogs = fmnode.children('.' + self.dialogClass + ':visible').removeClass(clsediting).fadeOut();
                                base.removeClass(clactive);
                                fm.enable();
                                if (fm.searchStatus.state < 2 && file.phash !== fm.cwd().hash) {
                                    reqOpen = fm.exec('open', [file.phash], { thash: file.phash });
                                }

                                $.when([reqOpen]).done(function () {
                                    reqOpen ? fm.one('cwdrender', make) : make();
                                }).fail(fail);
                            }
                        },
                        buttons = {},
                        hline = 'elfinder-resize-handle-hline',
                        vline = 'elfinder-resize-handle-vline',
                        rpoint = 'elfinder-resize-handle-point',
                        canvSrc = src,
                        sizeImg = quality ? $('<img>').attr('crossorigin', fm.isCORS ? 'use-credentials' : '').attr('src', canvSrc).on('load', function () {
                            try {
                                var canv = document.createElement('canvas');
                                sizeImg.data('canvas', canv).data('ctx', canv.getContext('2d'));
                                jpgCalc();
                            } catch (e) {
                                sizeImg.removeData('canvas').removeData('ctx');
                            }
                        }) : null,
                        jpgCalc = function () {
                            control.find('input.elfinder-resize-quality:visible').trigger('change');
                        },
                        dinit = function (e) {
                            if (base.hasClass('elfinder-dialog-minimized') || base.is(':hidden')) {
                                return;
                            }

                            preset.hide();
                            presetc.hide();

                            var win = fm.options.dialogContained ? fmnode : $(window),
                                winH = win.height(),
                                winW = win.width(),
                                presW = 'auto',
                                presIn = true,
                                dw, ctrW, prvW;

                            base.width(Math.min(dialogWidth, winW - 30));
                            preview.attr('style', '');
                            if (owidth && oheight) {
                                pwidth = preview.width() - (rhandle.outerWidth() - rhandle.width());
                                pheight = preview.height() - (rhandle.outerHeight() - rhandle.height());
                                resize.updateView(owidth, oheight);
                            }
                            ctrW = dialog.find('div.elfinder-resize-control').width();
                            prvW = preview.width();

                            dw = dialog.width() - 20;
                            if (prvW > dw) {
                                preview.width(dw);
                                presIn = false;
                            } else if ((dw - prvW) < ctrW) {
                                if (winW > winH) {
                                    preview.width(dw - ctrW - 20);
                                } else {
                                    preview.css({ float: 'none', marginLeft: 'auto', marginRight: 'auto' });
                                    presIn = false;
                                }
                            }
                            if (presIn) {
                                presW = ctrW;
                            }
                            pwidth = preview.width() - (rhandle.outerWidth() - rhandle.width());
                            if (fmnode.hasClass('elfinder-fullscreen')) {
                                if (base.height() > winH) {
                                    winH -= 2;
                                    preview.height(winH - base.height() + preview.height());
                                    base.css('top', 0 - fmnode.offset().top);
                                }
                            } else {
                                winH -= 30;
                                (preview.height() > winH) && preview.height(winH);
                            }
                            pheight = preview.height() - (rhandle.outerHeight() - rhandle.height());
                            if (owidth && oheight) {
                                setupimg();
                            }
                            if (img.height() && preview.height() > img.height() + 20) {
                                preview.height(img.height() + 20);
                                pheight = preview.height() - (rhandle.outerHeight() - rhandle.height());
                                setuprimg();
                            }

                            preset.css('width', presW).show();
                            presetc.css('width', presW).show();
                            if (!presetc.children('span.elfinder-resize-preset:visible').length) {
                                presetc.hide();
                            }
                            dialog.elfinderdialog('posInit');
                        },
                        preset = (function () {
                            var sets = $('<fieldset class="elfinder-resize-preset-container">').append($('<legend>').html(fm.i18n('presets'))).css('box-sizing', 'border-box').hide(),
                                hasC;
                            $.each(presetSize, function (i, s) {
                                if (s.length === 2) {
                                    hasC = true;
                                    sets.append($('<span class="elfinder-resize-preset"></span>')
                                        .data('s', s)
                                        .text(s[0] + 'x' + s[1])
                                        .button()
                                    );
                                }
                            });
                            if (!hasC) {
                                return $();
                            } else {
                                return sets;
                            }
                        })(),
                        presetc = preset.clone(true),
                        useSaveAs = fm.uploadMimeCheck(file.mime, file.phash),
                        dMinBtn, base;

                    size0 = size1 = file.size;
                    uiresize.append(
                        $(row).append($(label).text(fm.i18n('width')), width),
                        $(row).append($(label).text(fm.i18n('height')), height, $('<div class="elfinder-resize-whctrls">').append(constr, reset)),
                        (quality ? $(row).append($(label).text(fm.i18n('quality')), quality, $('<span></span>')) : $()),
                        (isJpeg ? $(row).append($(label).text(fm.i18n('8pxgrid')).addClass('elfinder-resize-grid8'), grid8px) : $()),
                        $(row).append($(label).text(fm.i18n('scale')), uiprop),
                        $(row).append(preset)
                    );

                    if (api2) {
                        uicrop.append(
                            $(row).append($(label).text('X'), pointX),
                            $(row).append($(label).text('Y')).append(pointY),
                            $(row).append($(label).text(fm.i18n('width')), offsetX),
                            $(row).append($(label).text(fm.i18n('height')), offsetY, $('<div class="elfinder-resize-whctrls">').append(constrc, reset.clone(true))),
                            (quality ? $(row).append($(label).text(fm.i18n('quality')), quality.clone(true), $('<span></span>')) : $()),
                            (isJpeg ? $(row).append($(label).text(fm.i18n('8pxgrid')).addClass('elfinder-resize-grid8')) : $()),
                            $(row).append(presetc)
                        );

                        uirotate.append(
                            $(row).addClass('elfinder-resize-degree').append(
                                $(label).text(fm.i18n('rotate')),
                                degree,
                                $('<span></span>').text(fm.i18n('degree')),
                                $('<div></div>').append(uideg270, uideg90)[ctrgrup]()
                            ),
                            $(row).css('height', '20px').append(uidegslider),
                            ((quality) ? $(row)[losslessRotate < 1 ? 'show' : 'hide']().addClass('elfinder-resize-quality').append(
                                $(label).text(fm.i18n('quality')),
                                quality.clone(true),
                                $('<span></span>')) : $()
                            ),
                            $(row).append($(label).text(fm.i18n('bgcolor')), bg, picker, reseter),
                            $(row).css('height', '20px').append(pallet)
                        );
                        uideg270.on('click', function () {
                            rdegree = rdegree - 90;
                            rotate.update(rdegree);
                        });
                        uideg90.on('click', function () {
                            rdegree = rdegree + 90;
                            rotate.update(rdegree);
                        });
                    }

                    dialog.append(uitype).on('resize', function (e) {
                        e.stopPropagation();
                    });

                    if (api2) {
                        control.append(/*$(row), */uiresize, uicrop.hide(), uirotate.hide());
                    } else {
                        control.append(/*$(row), */uiresize);
                    }

                    rhandle.append('<div class="' + hline + ' ' + hline + '-top"></div>',
                        '<div class="' + hline + ' ' + hline + '-bottom"></div>',
                        '<div class="' + vline + ' ' + vline + '-left"></div>',
                        '<div class="' + vline + ' ' + vline + '-right"></div>',
                        '<div class="' + rpoint + ' ' + rpoint + '-e"></div>',
                        '<div class="' + rpoint + ' ' + rpoint + '-se"></div>',
                        '<div class="' + rpoint + ' ' + rpoint + '-s"></div>');

                    preview.append(spinner).append(rhandle.hide()).append(img.hide());

                    if (api2) {
                        rhandlec.css('position', 'absolute')
                            .append('<div class="' + hline + ' ' + hline + '-top"></div>',
                                '<div class="' + hline + ' ' + hline + '-bottom"></div>',
                                '<div class="' + vline + ' ' + vline + '-left"></div>',
                                '<div class="' + vline + ' ' + vline + '-right"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-n"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-e"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-s"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-w"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-ne"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-se"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-sw"></div>',
                                '<div class="' + rpoint + ' ' + rpoint + '-nw"></div>');

                        preview.append(basec.css('position', 'absolute').hide().append(imgc, rhandlec.append(coverc)));

                        preview.append(imgr.hide());
                    }

                    preview.css('overflow', 'hidden');

                    dialog.append(preview, control);

                    buttons[fm.i18n('btnApply')] = save;
                    if (useSaveAs) {
                        buttons[fm.i18n('btnSaveAs')] = function () { requestAnimationFrame(saveAs); };
                    }
                    buttons[fm.i18n('btnCancel')] = function () { dialog.elfinderdialog('close'); };

                    dialog.find('input,button').addClass('elfinder-tabstop');

                    base = self.fmDialog(dialog, {
                        title: fm.escape(file.name),
                        width: dialogWidth,
                        resizable: false,
                        buttons: buttons,
                        open: function () {
                            var doDimReq = function (force) {
                                dimreq = fm.request({
                                    data: { cmd: 'dim', target: file.hash, substitute: substituteImg ? 400 : '' },
                                    preventDefault: true
                                })
                                    .done(function (data) {
                                        if (!data.url && needPng) {
                                            dialog.elfinderdialog('close');
                                            fm.error(['errOpen', file.name]);
                                        } else {
                                            if (data.dim) {
                                                var dim = data.dim.split('x');
                                                file.width = dim[0];
                                                file.height = dim[1];
                                                setdim(dim);
                                                if (data.url) {
                                                    img.attr('src', data.url);
                                                    imgc.attr('src', data.url);
                                                    imgr.attr('src', data.url);
                                                }
                                                return init();
                                            }
                                        }
                                    });
                            },
                                needPng = !{ 'image/jpeg': true, 'image/png': true, 'image/gif': true, }[file.mime],
                                substituteImg = fm.option('substituteImg', file.hash) && (needPng || file.size > options.dimSubImgSize) ? true : false,
                                hasSize = (file.width && file.height) ? true : false;
                            dMinBtn = base.find('.ui-dialog-titlebar .elfinder-titlebar-minimize').hide();
                            fm.bind('resize', dinit);
                            img.attr('src', src).one('error.dimreq', function () {
                                doDimReq(true);
                            });
                            imgc.attr('src', src);
                            imgr.attr('src', src);
                            if (api2) {
                                imgr.on('mousedown touchstart', rotate.start)
                                    .on('touchend', rotate.stop);
                                base.on('mouseup', rotate.stop);
                            }
                            if (hasSize && !substituteImg) {
                                return init();
                            }
                            if (file.size > (options.getDimThreshold || 0)) {
                                img.off('error.dimreq');
                                doDimReq();
                            } else if (hasSize) {
                                return init();
                            }
                        },
                        close: function () {
                            if (api2) {
                                imgr.off('mousedown touchstart', rotate.start)
                                    .off('touchend', rotate.stop);
                                $(document).off('mouseup', rotate.stop);
                            }
                            fm.unbind('resize', dinit);
                            $(this).elfinderdialog('destroy');
                        },
                        resize: function (e, data) {
                            if (data && data.minimize === 'off') {
                                dinit();
                            }
                        }
                    }).attr('id', id).closest('.ui-dialog').addClass(clsediting);

                    // for IE < 9 dialog mising at open second+ time.
                    if (fm.UA.ltIE8) {
                        $('.elfinder-dialog').css('filter', '');
                    }

                    coverc.css({ 'opacity': 0.2, 'background-color': '#fff', 'position': 'absolute' }),
                        rhandlec.css('cursor', 'move');
                    rhandlec.find('.elfinder-resize-handle-point').css({
                        'background-color': '#fff',
                        'opacity': 0.5,
                        'border-color': '#000'
                    });

                    if (!api2) {
                        uitype.find('.api2').remove();
                    }

                    control.find('input,select').prop('disabled', true);
                    control.find('input.elfinder-resize-quality')
                        .next('span').addClass('elfinder-resize-jpgsize').attr('title', fm.i18n('roughFileSize'));

                },

                id, dialog, size0, size1
                ;


            if (!files.length || files[0].mime.indexOf('image/') === -1) {
                return dfrd.reject();
            }

            id = 'resize-' + fm.namespace + '-' + files[0].hash;
            dialog = fmnode.find('#' + id);

            if (dialog.length) {
                dialog.elfinderdialog('toTop');
                return dfrd.resolve();
            }


            fm.openUrl(files[0].hash, 'sameorigin', function (src) {
                open(files[0], id, src);
            });

            return dfrd;
        };

    };

    (function ($) {

        var findProperty = function (styleObject, styleArgs) {
            var i = 0;
            for (i in styleArgs) {
                if (typeof styleObject[styleArgs[i]] != 'undefined')
                    return styleArgs[i];
            }
            styleObject[styleArgs[i]] = '';
            return styleArgs[i];
        };

        $.cssHooks.rotate = {
            get: function (elem, computed, extra) {
                return $(elem).rotate();
            },
            set: function (elem, value) {
                $(elem).rotate(value);
                return value;
            }
        };
        $.cssHooks.transform = {
            get: function (elem, computed, extra) {
                var name = findProperty(elem.style,
                    ['WebkitTransform', 'MozTransform', 'OTransform', 'msTransform', 'transform']);
                return elem.style[name];
            },
            set: function (elem, value) {
                var name = findProperty(elem.style,
                    ['WebkitTransform', 'MozTransform', 'OTransform', 'msTransform', 'transform']);
                elem.style[name] = value;
                return value;
            }
        };

        $.fn.rotate = function (val) {
            var r;
            if (typeof val == 'undefined') {
                if (!!window.opera) {
                    r = this.css('transform').match(/rotate\((.*?)\)/);
                    return (r && r[1]) ?
                        Math.round(parseFloat(r[1]) * 180 / Math.PI) : 0;
                } else {
                    r = this.css('transform').match(/rotate\((.*?)\)/);
                    return (r && r[1]) ? parseInt(r[1]) : 0;
                }
            }
            this.css('transform',
                this.css('transform').replace(/none|rotate\(.*?\)/, '') + 'rotate(' + parseInt(val) + 'deg)');
            return this;
        };

        $.fx.step.rotate = function (fx) {
            if (fx.state == 0) {
                fx.start = $(fx.elem).rotate();
                fx.now = fx.start;
            }
            $(fx.elem).rotate(fx.now);
        };

        if (typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined") { // IE & IE<9
            var GetAbsoluteXY = function (element) {
                var pnode = element;
                var x = pnode.offsetLeft;
                var y = pnode.offsetTop;

                while (pnode.offsetParent) {
                    pnode = pnode.offsetParent;
                    if (pnode != document.body && pnode.currentStyle['position'] != 'static') {
                        break;
                    }
                    if (pnode != document.body && pnode != document.documentElement) {
                        x -= pnode.scrollLeft;
                        y -= pnode.scrollTop;
                    }
                    x += pnode.offsetLeft;
                    y += pnode.offsetTop;
                }

                return { x: x, y: y };
            };

            var StaticToAbsolute = function (element) {
                if (element.currentStyle['position'] != 'static') {
                    return;
                }

                var xy = GetAbsoluteXY(element);
                element.style.position = 'absolute';
                element.style.left = xy.x + 'px';
                element.style.top = xy.y + 'px';
            };

            var IETransform = function (element, transform) {

                var r;
                var m11 = 1;
                var m12 = 1;
                var m21 = 1;
                var m22 = 1;

                if (typeof element.style['msTransform'] != 'undefined') {
                    return true;
                }

                StaticToAbsolute(element);

                r = transform.match(/rotate\((.*?)\)/);
                var rotate = (r && r[1]) ? parseInt(r[1]) : 0;

                rotate = rotate % 360;
                if (rotate < 0) rotate = 360 + rotate;

                var radian = rotate * Math.PI / 180;
                var cosX = Math.cos(radian);
                var sinY = Math.sin(radian);

                m11 *= cosX;
                m12 *= -sinY;
                m21 *= sinY;
                m22 *= cosX;

                element.style.filter = (element.style.filter || '').replace(/progid:DXImageTransform\.Microsoft\.Matrix\([^)]*\)/, "") +
                    ("progid:DXImageTransform.Microsoft.Matrix(" +
                        "M11=" + m11 +
                        ",M12=" + m12 +
                        ",M21=" + m21 +
                        ",M22=" + m22 +
                        ",FilterType='bilinear',sizingMethod='auto expand')")
                    ;

                var ow = parseInt(element.style.width || element.width || 0);
                var oh = parseInt(element.style.height || element.height || 0);

                radian = rotate * Math.PI / 180;
                var absCosX = Math.abs(Math.cos(radian));
                var absSinY = Math.abs(Math.sin(radian));

                var dx = (ow - (ow * absCosX + oh * absSinY)) / 2;
                var dy = (oh - (ow * absSinY + oh * absCosX)) / 2;

                element.style.marginLeft = Math.floor(dx) + "px";
                element.style.marginTop = Math.floor(dy) + "px";

                return (true);
            };

            var transform_set = $.cssHooks.transform.set;
            $.cssHooks.transform.set = function (elem, value) {
                transform_set.apply(this, [elem, value]);
                IETransform(elem, value);
                return value;
            };
        }

    })(jQuery);


    /*
     * File: /js/commands/restore.js
     */

    /**
     * @class  elFinder command "restore"
     * Restore items from the trash
     *
     * @author Naoki Sawada
     **/
    (elFinder.prototype.commands.restore = function () {
        "use strict";
        var self = this,
            fm = this.fm,
            fakeCnt = 0,
            getFilesRecursively = function (files) {
                var dfd = $.Deferred(),
                    dirs = [],
                    results = [],
                    reqs = [],
                    phashes = [],
                    getFile;

                dfd._xhrReject = function () {
                    $.each(reqs, function () {
                        this && this.reject && this.reject();
                    });
                    getFile && getFile._xhrReject();
                };

                $.each(files, function (i, f) {
                    f.mime === 'directory' ? dirs.push(f) : results.push(f);
                });

                if (dirs.length) {
                    $.each(dirs, function (i, d) {
                        reqs.push(fm.request({
                            data: { cmd: 'open', target: d.hash },
                            preventDefault: true,
                            asNotOpen: true
                        }));
                        phashes[i] = d.hash;
                    });
                    $.when.apply($, reqs).fail(function () {
                        dfd.reject();
                    }).done(function () {
                        var items = [];
                        $.each(arguments, function (i, r) {
                            var files;
                            if (r.files) {
                                if (r.files.length) {
                                    items = items.concat(r.files);
                                } else {
                                    items.push({
                                        hash: 'fakefile_' + (fakeCnt++),
                                        phash: phashes[i],
                                        mime: 'fakefile',
                                        name: 'fakefile',
                                        ts: 0
                                    });
                                }
                            }
                        });
                        fm.cache(items);
                        getFile = getFilesRecursively(items).done(function (res) {
                            results = results.concat(res);
                            dfd.resolve(results);
                        });
                    });
                } else {
                    dfd.resolve(results);
                }

                return dfd;
            },
            restore = function (dfrd, files, targets, ops) {
                var rHashes = {},
                    others = [],
                    found = false,
                    dirs = [],
                    opts = ops || {},
                    id = +new Date(),
                    tm, getFile;

                fm.lockfiles({ files: targets });

                dirs = $.map(files, function (f) {
                    return f.mime === 'directory' ? f.hash : null;
                });

                dfrd.done(function () {
                    dirs && fm.exec('rm', dirs, { forceRm: true, quiet: true });
                }).always(function () {
                    fm.unlockfiles({ files: targets });
                });

                tm = setTimeout(function () {
                    fm.notify({
                        type: 'search', id: id, cnt: 1, hideCnt: true, cancel: function () {
                            getFile && getFile._xhrReject();
                            dfrd.reject();
                        }
                    });
                }, fm.notifyDelay);

                fakeCnt = 0;
                getFile = getFilesRecursively(files).always(function () {
                    tm && clearTimeout(tm);
                    fm.notify({ type: 'search', id: id, cnt: -1, hideCnt: true });
                }).fail(function () {
                    dfrd.reject('errRestore', 'errFileNotFound');
                }).done(function (res) {
                    var errFolderNotfound = ['errRestore', 'errFolderNotFound'],
                        dirTop = '';

                    if (res.length) {
                        $.each(res, function (i, f) {
                            var phash = f.phash,
                                pfile,
                                srcRoot, tPath;
                            while (phash) {
                                if (srcRoot = fm.trashes[phash]) {
                                    if (!rHashes[srcRoot]) {
                                        if (found) {
                                            // Keep items of other trash
                                            others.push(f.hash);
                                            return null; // continue $.each
                                        }
                                        rHashes[srcRoot] = {};
                                        found = true;
                                    }

                                    tPath = fm.path(f.hash).substr(fm.path(phash).length).replace(/\\/g, '/');
                                    tPath = tPath.replace(/\/[^\/]+?$/, '');
                                    if (tPath === '') {
                                        tPath = '/';
                                    }
                                    if (!rHashes[srcRoot][tPath]) {
                                        rHashes[srcRoot][tPath] = [];
                                    }
                                    if (f.mime === 'fakefile') {
                                        fm.updateCache({ removed: [f.hash] });
                                    } else {
                                        rHashes[srcRoot][tPath].push(f.hash);
                                    }
                                    if (!dirTop || dirTop.length > tPath.length) {
                                        dirTop = tPath;
                                    }
                                    break;
                                }

                                // Go up one level for next check
                                pfile = fm.file(phash);

                                if (!pfile) {
                                    phash = false;
                                    // Detection method for search results
                                    $.each(fm.trashes, function (ph) {
                                        var file = fm.file(ph),
                                            filePath = fm.path(ph);
                                        if ((!file.volumeid || f.hash.indexOf(file.volumeid) === 0) && fm.path(f.hash).indexOf(filePath) === 0) {
                                            phash = ph;
                                            return false;
                                        }
                                    });
                                } else {
                                    phash = pfile.phash;
                                }
                            }
                        });
                        if (found) {
                            $.each(rHashes, function (src, dsts) {
                                var dirs = Object.keys(dsts),
                                    cnt = dirs.length;
                                fm.request({
                                    data: { cmd: 'mkdir', target: src, dirs: dirs },
                                    notify: { type: 'chkdir', cnt: cnt },
                                    preventFail: true
                                }).fail(function (error) {
                                    dfrd.reject(error);
                                    fm.unlockfiles({ files: targets });
                                }).done(function (data) {
                                    var cmdPaste, hashes;

                                    if (hashes = data.hashes) {
                                        cmdPaste = fm.getCommand('paste');
                                        if (cmdPaste) {
                                            // wait until file cache made
                                            fm.one('mkdirdone', function () {
                                                var hasErr = false;
                                                $.each(dsts, function (dir, files) {
                                                    if (hashes[dir]) {
                                                        if (files.length) {
                                                            if (fm.file(hashes[dir])) {
                                                                fm.clipboard(files, true);
                                                                fm.exec('paste', [hashes[dir]], { _cmd: 'restore', noToast: (opts.noToast || dir !== dirTop) })
                                                                    .done(function (data) {
                                                                        if (data && (data.error || data.warning)) {
                                                                            hasErr = true;
                                                                        }
                                                                    })
                                                                    .fail(function () {
                                                                        hasErr = true;
                                                                    })
                                                                    .always(function () {
                                                                        if (--cnt < 1) {
                                                                            dfrd[hasErr ? 'reject' : 'resolve']();
                                                                            if (others.length) {
                                                                                // Restore items of other trash
                                                                                fm.exec('restore', others);
                                                                            }
                                                                        }
                                                                    });
                                                            } else {
                                                                dfrd.reject(errFolderNotfound);
                                                            }
                                                        } else {
                                                            if (--cnt < 1) {
                                                                dfrd.resolve();
                                                                if (others.length) {
                                                                    // Restore items of other trash
                                                                    fm.exec('restore', others);
                                                                }
                                                            }
                                                        }
                                                    }
                                                });
                                            });
                                        } else {
                                            dfrd.reject(['errRestore', 'errCmdNoSupport', '(paste)']);
                                        }
                                    } else {
                                        dfrd.reject(errFolderNotfound);
                                    }
                                });
                            });
                        } else {
                            dfrd.reject(errFolderNotfound);
                        }
                    } else {
                        dfrd.reject('errFileNotFound');
                        dirs && fm.exec('rm', dirs, { forceRm: true, quiet: true });
                    }
                });
            };

        // for to be able to overwrite
        this.restore = restore;

        this.linkedCmds = ['copy', 'paste', 'mkdir', 'rm'];
        this.updateOnSelect = false;

        this.init = function () {
            // re-assign for extended command
            self = this;
            fm = this.fm;
        };

        this.getstate = function (sel, e) {
            sel = sel || fm.selected();
            return sel.length && $.grep(sel, function (h) { var f = fm.file(h); return f && !f.locked && !fm.isRoot(f) ? true : false; }).length == sel.length
                ? 0 : -1;
        };

        this.exec = function (hashes, opts) {
            var dfrd = $.Deferred()
                .fail(function (error) {
                    error && fm.error(error);
                }),
                files = self.files(hashes);

            if (!files.length) {
                return dfrd.reject();
            }

            $.each(files, function (i, file) {
                if (fm.isRoot(file)) {
                    return !dfrd.reject(['errRestore', file.name]);
                }
                if (file.locked) {
                    return !dfrd.reject(['errLocked', file.name]);
                }
            });

            if (dfrd.state() === 'pending') {
                this.restore(dfrd, files, hashes, opts);
            }

            return dfrd;
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/rm.js
     */

    /**
     * @class  elFinder command "rm"
     * Delete files
     *
     * @author Dmitry (dio) Levashov
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.rm = function () {
        "use strict";
        var self = this,
            fm = this.fm,
            tpl = '<div class="ui-helper-clearfix elfinder-rm-title"><span class="elfinder-cwd-icon {class} ui-corner-all"></span>{title}<div class="elfinder-rm-desc">{desc}</div></div>',
            confirm = function (dfrd, targets, files, tHash, addTexts) {
                var cnt = targets.length,
                    cwd = fm.cwd().hash,
                    descs = [],
                    spinner = fm.i18n('calc') + '<span class="elfinder-spinner"></span>',
                    dialog, text, tmb, size, f, fname;

                if (cnt > 1) {
                    size = 0;
                    $.each(files, function (h, f) {
                        if (f.size && f.size != 'unknown' && f.mime !== 'directory') {
                            var s = parseInt(f.size);
                            if (s >= 0 && size >= 0) {
                                size += s;
                            }
                        } else {
                            size = 'unknown';
                            return false;
                        }
                    });
                    getSize = (size === 'unknown');
                    descs.push(fm.i18n('size') + ': ' + (getSize ? spinner : fm.formatSize(size)));
                    text = [$(tpl.replace('{class}', 'elfinder-cwd-icon-group').replace('{title}', '<strong>' + fm.i18n('items') + ': ' + cnt + '</strong>').replace('{desc}', descs.join('<br>')))];
                } else {
                    f = files[0];
                    tmb = fm.tmb(f);
                    getSize = (f.mime === 'directory');
                    descs.push(fm.i18n('size') + ': ' + (getSize ? spinner : fm.formatSize(f.size)));
                    descs.push(fm.i18n('modify') + ': ' + fm.formatDate(f));
                    fname = fm.escape(f.i18 || f.name).replace(/([_.])/g, '&#8203;$1');
                    text = [$(tpl.replace('{class}', fm.mime2class(f.mime)).replace('{title}', '<strong>' + fname + '</strong>').replace('{desc}', descs.join('<br>')))];
                }

                if (addTexts) {
                    text = text.concat(addTexts);
                }

                text.push(tHash ? 'confirmTrash' : 'confirmRm');

                dialog = fm.confirm({
                    title: self.title,
                    text: text,
                    accept: {
                        label: 'btnRm',
                        callback: function () {
                            if (tHash) {
                                self.toTrash(dfrd, targets, tHash);
                            } else {
                                remove(dfrd, targets);
                            }
                        }
                    },
                    cancel: {
                        label: 'btnCancel',
                        callback: function () {
                            fm.unlockfiles({ files: targets });
                            if (targets.length === 1 && fm.file(targets[0]).phash !== cwd) {
                                fm.select({ selected: targets });
                            } else {
                                fm.selectfiles({ files: targets });
                            }
                            dfrd.reject();
                        }
                    }
                });
                // load thumbnail
                if (tmb) {
                    $('<img/>')
                        .on('load', function () { dialog.find('.elfinder-cwd-icon').addClass(tmb.className).css('background-image', "url('" + tmb.url + "')"); })
                        .attr('src', tmb.url);
                }

                if (getSize) {
                    getSize = fm.getSize($.map(files, function (f) { return f.mime === 'directory' ? f.hash : null; })).done(function (data) {
                        dialog.find('span.elfinder-spinner').parent().html(fm.i18n('size') + ': ' + data.formated);
                    }).fail(function () {
                        dialog.find('span.elfinder-spinner').parent().html(fm.i18n('size') + ': ' + fm.i18n('unknown'));
                    }).always(function () {
                        getSize = false;
                    });
                }
            },
            toTrash = function (dfrd, targets, tHash) {
                var dsts = {},
                    itemCnt = targets.length,
                    maxCnt = self.options.toTrashMaxItems,
                    checkDirs = [],
                    reqDfd = $.Deferred(),
                    req, dirs, cnt;

                if (itemCnt > maxCnt) {
                    self.confirm(dfrd, targets, self.files(targets), null, [fm.i18n('tooManyToTrash')]);
                    return;
                }

                // Directory preparation preparation and directory enumeration
                $.each(targets, function (i, h) {
                    var file = fm.file(h),
                        path = fm.path(h).replace(/\\/g, '/'),
                        m = path.match(/^[^\/]+?(\/(?:[^\/]+?\/)*)[^\/]+?$/);

                    if (file) {
                        if (m) {
                            m[1] = m[1].replace(/(^\/.*?)\/?$/, '$1');
                            if (!dsts[m[1]]) {
                                dsts[m[1]] = [];
                            }
                            dsts[m[1]].push(h);
                        }
                        if (file.mime === 'directory') {
                            checkDirs.push(h);
                        }
                    }
                });

                // Check directory information
                if (checkDirs.length) {
                    req = fm.request({
                        data: { cmd: 'size', targets: checkDirs },
                        notify: { type: 'readdir', cnt: 1, hideCnt: true },
                        preventDefault: true
                    }).done(function (data) {
                        var cnt = 0;
                        data.fileCnt && (cnt += parseInt(data.fileCnt));
                        data.dirCnt && (cnt += parseInt(data.dirCnt));
                        reqDfd[cnt > maxCnt ? 'reject' : 'resolve']();
                    }).fail(function () {
                        reqDfd.reject();
                    });
                    setTimeout(function () {
                        var xhr = (req && req.xhr) ? req.xhr : null;
                        if (xhr && xhr.state() == 'pending') {
                            req.syncOnFail(false);
                            req.reject();
                            reqDfd.reject();
                        }
                    }, self.options.infoCheckWait * 1000);
                } else {
                    reqDfd.resolve();
                }

                // Directory creation and paste command execution
                reqDfd.done(function () {
                    dirs = Object.keys(dsts);
                    cnt = dirs.length;
                    if (cnt) {
                        fm.request({
                            data: { cmd: 'mkdir', target: tHash, dirs: dirs },
                            notify: { type: 'chkdir', cnt: cnt },
                            preventFail: true
                        })
                            .fail(function (error) {
                                dfrd.reject(error);
                                fm.unlockfiles({ files: targets });
                            })
                            .done(function (data) {
                                var margeRes = function (data, phash, reqData) {
                                    var undo, prevUndo, redo, prevRedo;
                                    $.each(data, function (k, v) {
                                        if (Array.isArray(v)) {
                                            if (res[k]) {
                                                res[k] = res[k].concat(v);
                                            } else {
                                                res[k] = v;
                                            }
                                        }
                                    });
                                    if (data.sync) {
                                        res.sync = 1;
                                    }
                                    if (data.added && data.added.length) {
                                        undo = function () {
                                            var targets = [],
                                                dirs = $.map(data.added, function (f) { return f.mime === 'directory' ? f.hash : null; });
                                            $.each(data.added, function (i, f) {
                                                if ($.inArray(f.phash, dirs) === -1) {
                                                    targets.push(f.hash);
                                                }
                                            });
                                            return fm.exec('restore', targets, { noToast: true });
                                        };
                                        redo = function () {
                                            return fm.request({
                                                data: reqData,
                                                notify: { type: 'redo', cnt: targets.length }
                                            });
                                        };
                                        if (res.undo) {
                                            prevUndo = res.undo;
                                            res.undo = function () {
                                                undo();
                                                prevUndo();
                                            };
                                        } else {
                                            res.undo = undo;
                                        }
                                        if (res.redo) {
                                            prevRedo = res.redo;
                                            res.redo = function () {
                                                redo();
                                                prevRedo();
                                            };
                                        } else {
                                            res.redo = redo;
                                        }
                                    }
                                },
                                    err = ['errTrash'],
                                    res = {},
                                    hasNtf = function () {
                                        return fm.ui.notify.children('.elfinder-notify-trash').length;
                                    },
                                    hashes, tm, prg, prgSt;

                                if (hashes = data.hashes) {
                                    prg = 1 / cnt * 100;
                                    prgSt = cnt === 1 ? 100 : 5;
                                    tm = setTimeout(function () {
                                        fm.notify({ type: 'trash', cnt: 1, hideCnt: true, progress: prgSt });
                                    }, fm.notifyDelay);
                                    $.each(dsts, function (dir, files) {
                                        var phash = fm.file(files[0]).phash,
                                            reqData;
                                        if (hashes[dir]) {
                                            reqData = { cmd: 'paste', dst: hashes[dir], targets: files, cut: 1 };
                                            fm.request({
                                                data: reqData,
                                                preventDefault: true
                                            })
                                                .fail(function (error) {
                                                    if (error) {
                                                        err = err.concat(error);
                                                    }
                                                })
                                                .done(function (data) {
                                                    data = fm.normalize(data);
                                                    fm.updateCache(data);
                                                    margeRes(data, phash, reqData);
                                                    if (data.warning) {
                                                        err = err.concat(data.warning);
                                                        delete data.warning;
                                                    }
                                                    // fire some event to update cache/ui
                                                    data.removed && data.removed.length && fm.remove(data);
                                                    data.added && data.added.length && fm.add(data);
                                                    data.changed && data.changed.length && fm.change(data);
                                                    // fire event with command name
                                                    fm.trigger('paste', data);
                                                    // fire event with command name + 'done'
                                                    fm.trigger('pastedone');
                                                    // force update content
                                                    data.sync && fm.sync();
                                                })
                                                .always(function () {
                                                    var hashes = [], addTexts, end = 2;
                                                    if (hasNtf()) {
                                                        fm.notify({ type: 'trash', cnt: 0, hideCnt: true, progress: prg });
                                                    } else {
                                                        prgSt += prg;
                                                    }
                                                    if (--cnt < 1) {
                                                        tm && clearTimeout(tm);
                                                        hasNtf() && fm.notify({ type: 'trash', cnt: -1 });
                                                        fm.unlockfiles({ files: targets });
                                                        if (Object.keys(res).length) {
                                                            if (err.length > 1) {
                                                                if (res.removed || res.removed.length) {
                                                                    hashes = $.grep(targets, function (h) {
                                                                        return $.inArray(h, res.removed) === -1 ? true : false;
                                                                    });
                                                                }
                                                                if (hashes.length) {
                                                                    if (err.length > end) {
                                                                        end = (fm.messages[err[end - 1]] || '').indexOf('$') === -1 ? end : end + 1;
                                                                    }
                                                                    dfrd.reject();
                                                                    fm.exec('rm', hashes, { addTexts: err.slice(0, end), forceRm: true });
                                                                } else {
                                                                    fm.error(err);
                                                                }
                                                            }
                                                            res._noSound = true;
                                                            if (res.undo && res.redo) {
                                                                res.undo = {
                                                                    cmd: 'trash',
                                                                    callback: res.undo,
                                                                };
                                                                res.redo = {
                                                                    cmd: 'trash',
                                                                    callback: res.redo
                                                                };
                                                            }
                                                            dfrd.resolve(res);
                                                        } else {
                                                            dfrd.reject(err);
                                                        }
                                                    }
                                                });
                                        }
                                    });
                                } else {
                                    dfrd.reject('errFolderNotFound');
                                    fm.unlockfiles({ files: targets });
                                }
                            });
                    } else {
                        dfrd.reject(['error', 'The folder hierarchy to be deleting can not be determined.']);
                        fm.unlockfiles({ files: targets });
                    }
                }).fail(function () {
                    self.confirm(dfrd, targets, self.files(targets), null, [fm.i18n('tooManyToTrash')]);
                });
            },
            remove = function (dfrd, targets, quiet) {
                var notify = quiet ? {} : { type: 'rm', cnt: targets.length };
                fm.request({
                    data: { cmd: 'rm', targets: targets },
                    notify: notify,
                    preventFail: true
                })
                    .fail(function (error) {
                        dfrd.reject(error);
                    })
                    .done(function (data) {
                        if (data.error || data.warning) {
                            data.sync = true;
                        }
                        dfrd.resolve(data);
                    })
                    .always(function () {
                        fm.unlockfiles({ files: targets });
                    });
            },
            getTHash = function (targets) {
                var thash = null,
                    root1st;

                if (targets && targets.length) {
                    if (targets.length > 1 && fm.searchStatus.state === 2) {
                        root1st = fm.file(fm.root(targets[0])).volumeid;
                        if (!$.grep(targets, function (h) { return h.indexOf(root1st) !== 0 ? true : false; }).length) {
                            thash = fm.option('trashHash', targets[0]);
                        }
                    } else {
                        thash = fm.option('trashHash', targets[0]);
                    }
                }
                return thash;
            },
            getSize = false;

        // for to be able to overwrite
        this.confirm = confirm;
        this.toTrash = toTrash;
        this.remove = remove;

        this.syncTitleOnChange = true;
        this.updateOnSelect = false;
        this.shortcuts = [{
            pattern: 'delete ctrl+backspace shift+delete'
        }];
        this.value = 'rm';

        this.init = function () {
            var update = function (origin) {
                var targets;
                delete self.extra;
                self.title = fm.i18n('cmd' + self.value);
                self.className = self.value;
                self.button && self.button.children('span.elfinder-button-icon')[self.value === 'trash' ? 'addClass' : 'removeClass']('elfinder-button-icon-trash');
                if (origin && origin !== 'cwd' && (self.state > -1 || origin === 'navbar')) {
                    if (self.value === 'trash') {
                        self.extra = {
                            icon: 'rm',
                            node: $('<span></span>')
                                .attr({ title: fm.i18n('cmdrm') })
                                .on('ready', function (e, data) {
                                    targets = data.targets;
                                })
                                .on('click touchstart', function (e) {
                                    if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                                        return;
                                    }
                                    e.stopPropagation();
                                    e.preventDefault();
                                    fm.getUI().trigger('click'); // to close the context menu immediately
                                    fm.exec('rm', targets, { _userAction: true, forceRm: true });
                                })
                        };
                    }
                }
            };
            // re-assign for extended command
            self = this;
            fm = this.fm;
            // bind function of change
            self.change(function () {
                update();
            });
            fm.bind('contextmenucreate', function (e) {
                update(e.data.type);
            });
        };

        this.getstate = function (select) {
            var sel = this.hashes(select),
                filter = function (files) {
                    var fres = true;
                    return $.grep(files, function (h) {
                        var f;
                        fres = fres && (f = fm.file(h)) && !f.locked && !fm.isRoot(f) ? true : false;
                        return fres;
                    });
                };

            return sel.length && filter(sel).length == sel.length ? 0 : -1;
        };

        this.exec = function (hashes, cOpts) {
            var opts = cOpts || {},
                dfrd = $.Deferred()
                    .always(function () {
                        if (getSize && getSize.state && getSize.state() === 'pending') {
                            getSize.reject();
                        }
                    })
                    .fail(function (error) {
                        error && fm.error(error);
                    }).done(function (data) {
                        !opts.quiet && !data._noSound && data.removed && data.removed.length && fm.trigger('playsound', { soundFile: 'rm.wav' });
                    }),
                files = self.files(hashes),
                cnt = files.length,
                tHash = null,
                addTexts = opts.addTexts ? opts.addTexts : null,
                forceRm = opts.forceRm,
                quiet = opts.quiet,
                targets;

            if (!cnt) {
                return dfrd.reject();
            }

            $.each(files, function (i, file) {
                if (fm.isRoot(file)) {
                    return !dfrd.reject(['errRm', file.name, 'errPerm']);
                }
                if (file.locked) {
                    return !dfrd.reject(['errLocked', file.name]);
                }
            });

            if (dfrd.state() === 'pending') {
                targets = self.hashes(hashes);
                cnt = files.length;

                if (forceRm || (self.event && self.event.originalEvent && self.event.originalEvent.shiftKey)) {
                    tHash = '';
                    self.title = fm.i18n('cmdrm');
                }

                if (tHash === null) {
                    tHash = getTHash(targets);
                }

                fm.lockfiles({ files: targets });

                if (tHash && self.options.quickTrash) {
                    self.toTrash(dfrd, targets, tHash);
                } else {
                    if (quiet) {
                        remove(dfrd, targets, quiet);
                    } else {
                        self.confirm(dfrd, targets, files, tHash, addTexts);
                    }
                }
            }

            return dfrd;
        };

        fm.bind('select contextmenucreate closecontextmenu', function (e) {
            var targets = (e.data ? (e.data.selected || e.data.targets) : null) || fm.selected();
            if (targets && targets.length) {
                self.update(void (0), (targets ? getTHash(targets) : fm.option('trashHash')) ? 'trash' : 'rm');
            }
        });

    };


    /*
     * File: /js/commands/search.js
     */

    /**
     * @class  elFinder command "search"
     * Find files
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.search = function () {
        "use strict";
        this.title = 'Find files';
        this.options = { ui: 'searchbutton' };
        this.alwaysEnabled = true;
        this.updateOnSelect = false;

        /**
         * Return command status.
         * Search does not support old api.
         *
         * @return Number
         **/
        this.getstate = function () {
            return 0;
        };

        /**
         * Send search request to backend.
         *
         * @param  String  search string
         * @return $.Deferred
         **/
        this.exec = function (q, target, mime, type) {
            var fm = this.fm,
                reqDef = [],
                sType = type || '',
                onlyMimes = fm.options.onlyMimes,
                phash, targetVolids = [],
                setType = function (data) {
                    if (sType && sType !== 'SearchName' && sType !== 'SearchMime') {
                        data.type = sType;
                    }
                    return data;
                },
                rootCnt;

            if (typeof q == 'string' && q) {
                if (typeof target == 'object') {
                    mime = target.mime || '';
                    target = target.target || '';
                }
                target = target ? target : '';
                if (mime) {
                    mime = $.trim(mime).replace(',', ' ').split(' ');
                    if (onlyMimes.length) {
                        mime = $.map(mime, function (m) {
                            m = $.trim(m);
                            return m && ($.inArray(m, onlyMimes) !== -1
                                || $.grep(onlyMimes, function (om) { return m.indexOf(om) === 0 ? true : false; }).length
                            ) ? m : null;
                        });
                    }
                } else {
                    mime = [].concat(onlyMimes);
                }

                fm.trigger('searchstart', setType({ query: q, target: target, mimes: mime }));

                if (!onlyMimes.length || mime.length) {
                    if (target === '' && fm.api >= 2.1) {
                        rootCnt = Object.keys(fm.roots).length;
                        $.each(fm.roots, function (id, hash) {
                            reqDef.push(fm.request({
                                data: setType({ cmd: 'search', q: q, target: hash, mimes: mime }),
                                notify: { type: 'search', cnt: 1, hideCnt: (rootCnt > 1 ? false : true) },
                                cancel: true,
                                preventDone: true
                            }));
                        });
                    } else {
                        reqDef.push(fm.request({
                            data: setType({ cmd: 'search', q: q, target: target, mimes: mime }),
                            notify: { type: 'search', cnt: 1, hideCnt: true },
                            cancel: true,
                            preventDone: true
                        }));
                        if (target !== '' && fm.api >= 2.1 && Object.keys(fm.leafRoots).length) {
                            $.each(fm.leafRoots, function (hash, roots) {
                                phash = hash;
                                while (phash) {
                                    if (target === phash) {
                                        $.each(roots, function () {
                                            var f = fm.file(this);
                                            f && f.volumeid && targetVolids.push(f.volumeid);
                                            reqDef.push(fm.request({
                                                data: setType({ cmd: 'search', q: q, target: this, mimes: mime }),
                                                notify: { type: 'search', cnt: 1, hideCnt: false },
                                                cancel: true,
                                                preventDone: true
                                            }));
                                        });
                                    }
                                    phash = (fm.file(phash) || {}).phash;
                                }
                            });
                        }
                    }
                } else {
                    reqDef = [$.Deferred().resolve({ files: [] })];
                }

                fm.searchStatus.mixed = (reqDef.length > 1) ? targetVolids : false;

                return $.when.apply($, reqDef).done(function (data) {
                    var argLen = arguments.length,
                        i;

                    data.warning && fm.error(data.warning);

                    if (argLen > 1) {
                        data.files = (data.files || []);
                        for (i = 1; i < argLen; i++) {
                            arguments[i].warning && fm.error(arguments[i].warning);

                            if (arguments[i].files) {
                                data.files.push.apply(data.files, arguments[i].files);
                            }
                        }
                    }

                    // because "preventDone : true" so update files cache
                    data.files && data.files.length && fm.cache(data.files);

                    fm.lazy(function () {
                        fm.trigger('search', data);
                    }).then(function () {
                        // fire event with command name + 'done'
                        return fm.lazy(function () {
                            fm.trigger('searchdone');
                        });
                    }).then(function () {
                        // force update content
                        data.sync && fm.sync();
                    });
                });
            }
            fm.getUI('toolbar').find('.' + fm.res('class', 'searchbtn') + ' :text').trigger('focus');
            return $.Deferred().reject();
        };

    };


    /*
     * File: /js/commands/selectall.js
     */

    /**
     * @class  elFinder command "selectall"
     * Select ALL of cwd items
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.selectall = function () {
        "use strict";
        var self = this,
            state = 0;

        this.fm.bind('select', function (e) {
            state = (e.data && e.data.selectall) ? -1 : 0;
        });

        this.state = 0;
        this.updateOnSelect = false;

        this.getstate = function () {
            return state;
        };

        this.exec = function () {
            $(document).trigger($.Event('keydown', { keyCode: 65, ctrlKey: true, shiftKey: false, altKey: false, metaKey: false }));
            return $.Deferred().resolve();
        };
    };


    /*
     * File: /js/commands/selectinvert.js
     */

    /**
     * @class  elFinder command "selectinvert"
     * Invert Selection of cwd items
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.selectinvert = function () {
        "use strict";
        this.updateOnSelect = false;

        this.getstate = function () {
            return 0;
        };

        this.exec = function () {
            $(document).trigger($.Event('keydown', { keyCode: 73, ctrlKey: true, shiftKey: true, altKey: false, metaKey: false }));
            return $.Deferred().resolve();
        };

    };


    /*
     * File: /js/commands/selectnone.js
     */

    /**
     * @class  elFinder command "selectnone"
     * Unselect ALL of cwd items
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.selectnone = function () {
        "use strict";
        var self = this,
            fm = this.fm,
            state = -1;

        fm.bind('select', function (e) {
            state = (e.data && e.data.unselectall) ? -1 : 0;
        });

        this.state = -1;
        this.updateOnSelect = false;

        this.getstate = function () {
            return state;
        };

        this.exec = function () {
            fm.getUI('cwd').trigger('unselectall');
            return $.Deferred().resolve();
        };
    };


    /*
     * File: /js/commands/sort.js
     */

    /**
     * @class  elFinder command "sort"
     * Change sort files rule
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.sort = function () {
        "use strict";
        var self = this,
            fm = self.fm,
            setVar = function () {
                self.variants = [];
                $.each(fm.sortRules, function (name, value) {
                    if (fm.sorters[name]) {
                        var arr = (name === fm.sortType) ? (fm.sortOrder === 'asc' ? 'n' : 's') : '';
                        self.variants.push([name, (arr ? '<span class="ui-icon ui-icon-arrowthick-1-' + arr + '"></span>' : '') + '&nbsp;' + fm.i18n('sort' + name)]);
                    }
                });
                self.variants.push('|');
                self.variants.push([
                    'stick',
                    (fm.sortStickFolders ? '<span class="ui-icon ui-icon-check"></span>' : '') + '&nbsp;' + fm.i18n('sortFoldersFirst')
                ]);
                if (fm.ui.tree && fm.options.sortAlsoTreeview !== null) {
                    self.variants.push('|');
                    self.variants.push([
                        'tree',
                        (fm.sortAlsoTreeview ? '<span class="ui-icon ui-icon-check"></span>' : '') + '&nbsp;' + fm.i18n('sortAlsoTreeview')
                    ]);
                }
                updateContextmenu();
            },
            updateContextmenu = function () {
                var cm = fm.getUI('contextmenu'),
                    icon, sub;
                if (cm.is(':visible')) {
                    icon = cm.find('span.elfinder-button-icon-sort');
                    sub = icon.siblings('div.elfinder-contextmenu-sub');
                    sub.find('span.ui-icon').remove();
                    sub.children('div.elfinder-contextsubmenu-item').each(function () {
                        var tgt = $(this).children('span'),
                            name = tgt.text().trim(),
                            arr;
                        if (name === (i18Name.stick || (i18Name.stick = fm.i18n('sortFoldersFirst')))) {
                            if (fm.sortStickFolders) {
                                tgt.prepend('<span class="ui-icon ui-icon-check"></span>');
                            }
                        } else if (name === (i18Name.tree || (i18Name.tree = fm.i18n('sortAlsoTreeview')))) {
                            if (fm.sortAlsoTreeview) {
                                tgt.prepend('<span class="ui-icon ui-icon-check"></span>');
                            }
                        } else if (name === (i18Name[fm.sortType] || (i18Name[fm.sortType] = fm.i18n('sort' + fm.sortType)))) {
                            arr = fm.sortOrder === 'asc' ? 'n' : 's';
                            tgt.prepend('<span class="ui-icon ui-icon-arrowthick-1-' + arr + '"></span>');
                        }
                    });
                }
            },
            i18Name = {};

        /**
         * Command options
         *
         * @type  Object
         */
        this.options = { ui: 'sortbutton' };

        this.keepContextmenu = true;

        fm.bind('sortchange', setVar)
            .bind('sorterupdate', function () {
                setVar();
                fm.getUI().children('.elfinder-button-sort-menu').children('.elfinder-button-menu-item').each(function () {
                    var tgt = $(this),
                        rel = tgt.attr('rel');
                    tgt.toggle(!!(!rel || fm.sorters[rel]));
                });
            })
            .bind('cwdrender', function () {
                var cols = $(fm.cwd).find('div.elfinder-cwd-wrapper-list table');
                if (cols.length) {
                    $.each(fm.sortRules, function (name, value) {
                        var td = cols.find('thead tr td.elfinder-cwd-view-th-' + name);
                        if (td.length) {
                            var current = (name == fm.sortType),
                                sort = {
                                    type: name,
                                    order: current ? fm.sortOrder == 'asc' ? 'desc' : 'asc' : fm.sortOrder
                                }, arr;
                            if (current) {
                                td.addClass('ui-state-active');
                                arr = fm.sortOrder == 'asc' ? 'n' : 's';
                                $('<span class="ui-icon ui-icon-triangle-1-' + arr + '"></span>').appendTo(td);
                            }
                            $(td).on('click', function (e) {
                                if (!$(this).data('dragging')) {
                                    e.stopPropagation();
                                    if (!fm.getUI('cwd').data('longtap')) {
                                        fm.exec('sort', [], sort);
                                    }
                                }
                            })
                                .on('mouseenter mouseleave', function (e) {
                                    $(this).toggleClass('ui-state-hover', e.type === 'mouseenter');
                                });
                        }

                    });
                }
            });

        this.getstate = function () {
            return 0;
        };

        this.exec = function (hashes, cOpt) {
            var fm = this.fm,
                sortopt = $.isPlainObject(cOpt) ? cOpt : (function () {
                    cOpt += '';
                    var sOpts = {};
                    if (cOpt === 'stick') {
                        sOpts.stick = !fm.sortStickFolders;
                    } else if (cOpt === 'tree') {
                        sOpts.tree = !fm.sortAlsoTreeview;
                    } else if (fm.sorters[cOpt]) {
                        if (fm.sortType === cOpt) {
                            sOpts.order = fm.sortOrder === 'asc' ? 'desc' : 'asc';
                        } else {
                            sOpts.type = cOpt;
                        }
                    }
                    return sOpts;
                })(),
                sort = Object.assign({
                    type: fm.sortType,
                    order: fm.sortOrder,
                    stick: fm.sortStickFolders,
                    tree: fm.sortAlsoTreeview
                }, sortopt);

            return fm.lazy(function () {
                fm.setSort(sort.type, sort.order, sort.stick, sort.tree);
                this.resolve();
            });
        };

    };


    /*
     * File: /js/commands/undo.js
     */

    /**
     * @class  elFinder command "undo"
     * Undo previous commands
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.undo = function () {
        "use strict";
        var self = this,
            fm = this.fm,
            setTitle = function (undo) {
                if (undo) {
                    self.title = fm.i18n('cmdundo') + ' ' + fm.i18n('cmd' + undo.cmd);
                    self.state = 0;
                } else {
                    self.title = fm.i18n('cmdundo');
                    self.state = -1;
                }
                self.change();
            },
            cmds = [];

        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.shortcuts = [{
            pattern: 'ctrl+z'
        }];
        this.syncTitleOnChange = true;

        this.getstate = function () {
            return cmds.length ? 0 : -1;
        };

        this.setUndo = function (undo, redo) {
            var _undo = {};
            if (undo) {
                if ($.isPlainObject(undo) && undo.cmd && undo.callback) {
                    Object.assign(_undo, undo);
                    if (redo) {
                        delete redo.undo;
                        _undo.redo = redo;
                    } else {
                        fm.getCommand('redo').setRedo(null);
                    }
                    cmds.push(_undo);
                    setTitle(_undo);
                }
            }
        };

        this.exec = function () {
            var redo = fm.getCommand('redo'),
                dfd = $.Deferred(),
                undo, res, _redo = {};
            if (cmds.length) {
                undo = cmds.pop();
                if (undo.redo) {
                    Object.assign(_redo, undo.redo);
                    delete undo.redo;
                } else {
                    _redo = null;
                }
                dfd.done(function () {
                    if (_redo) {
                        redo.setRedo(_redo, undo);
                    }
                });

                setTitle(cmds.length ? cmds[cmds.length - 1] : void (0));

                res = undo.callback();

                if (res && res.done) {
                    res.done(function () {
                        dfd.resolve();
                    }).fail(function () {
                        dfd.reject();
                    });
                } else {
                    dfd.resolve();
                }
                if (cmds.length) {
                    this.update(0, cmds[cmds.length - 1].name);
                } else {
                    this.update(-1, '');
                }
            } else {
                dfd.reject();
            }
            return dfd;
        };

        fm.bind('exec', function (e) {
            var data = e.data || {};
            if (data.opts && data.opts._userAction) {
                if (data.dfrd && data.dfrd.done) {
                    data.dfrd.done(function (res) {
                        if (res && res.undo && res.redo) {
                            res.undo.redo = res.redo;
                            self.setUndo(res.undo);
                        }
                    });
                }
            }
        });
    };

    /**
     * @class  elFinder command "redo"
     * Redo previous commands
     *
     * @author Naoki Sawada
     **/
    elFinder.prototype.commands.redo = function () {
        "use strict";
        var self = this,
            fm = this.fm,
            setTitle = function (redo) {
                if (redo && redo.callback) {
                    self.title = fm.i18n('cmdredo') + ' ' + fm.i18n('cmd' + redo.cmd);
                    self.state = 0;
                } else {
                    self.title = fm.i18n('cmdredo');
                    self.state = -1;
                }
                self.change();
            },
            cmds = [];

        this.alwaysEnabled = true;
        this.updateOnSelect = false;
        this.shortcuts = [{
            pattern: 'shift+ctrl+z ctrl+y'
        }];
        this.syncTitleOnChange = true;

        this.getstate = function () {
            return cmds.length ? 0 : -1;
        };

        this.setRedo = function (redo, undo) {
            if (redo === null) {
                cmds = [];
                setTitle();
            } else {
                if (redo && redo.cmd && redo.callback) {
                    if (undo) {
                        redo.undo = undo;
                    }
                    cmds.push(redo);
                    setTitle(redo);
                }
            }
        };

        this.exec = function () {
            var undo = fm.getCommand('undo'),
                dfd = $.Deferred(),
                redo, res, _undo = {}, _redo = {};
            if (cmds.length) {
                redo = cmds.pop();
                if (redo.undo) {
                    Object.assign(_undo, redo.undo);
                    Object.assign(_redo, redo);
                    delete _redo.undo;
                    dfd.done(function () {
                        undo.setUndo(_undo, _redo);
                    });
                }

                setTitle(cmds.length ? cmds[cmds.length - 1] : void (0));

                res = redo.callback();

                if (res && res.done) {
                    res.done(function () {
                        dfd.resolve();
                    }).fail(function () {
                        dfd.reject();
                    });
                } else {
                    dfd.resolve();
                }
                return dfd;
            } else {
                return dfd.reject();
            }
        };
    };


    /*
     * File: /js/commands/up.js
     */

    /**
     * @class  elFinder command "up"
     * Go into parent directory
     *
     * @author Dmitry (dio) Levashov
     **/
    (elFinder.prototype.commands.up = function () {
        "use strict";
        this.alwaysEnabled = true;
        this.updateOnSelect = false;

        this.shortcuts = [{
            pattern: 'ctrl+up'
        }];

        this.getstate = function () {
            return this.fm.cwd().phash ? 0 : -1;
        };

        this.exec = function () {
            var fm = this.fm,
                cwdhash = fm.cwd().hash;
            return this.fm.cwd().phash ? this.fm.exec('open', this.fm.cwd().phash).done(function () {
                fm.one('opendone', function () {
                    fm.selectfiles({ files: [cwdhash] });
                });
            }) : $.Deferred().reject();
        };

    }).prototype = { forceLoad: true }; // this is required command


    /*
     * File: /js/commands/upload.js
     */

    /**
     * @class elFinder command "upload"
     * Upload files using iframe or XMLHttpRequest & FormData.
     * Dialog allow to send files using drag and drop
     *
     * @type  elFinder.command
     * @author  Dmitry (dio) Levashov
     */
    elFinder.prototype.commands.upload = function () {
        "use strict";
        var hover = this.fm.res('class', 'hover');

        this.disableOnSearch = true;
        this.updateOnSelect = false;

        // Shortcut opens dialog
        this.shortcuts = [{
            pattern: 'ctrl+u'
        }];

        /**
         * Return command state
         *
         * @return Number
         **/
        this.getstate = function (select) {
            var fm = this.fm, f,
                sel = (select || [fm.cwd().hash]);
            if (!this._disabled && sel.length == 1) {
                f = fm.file(sel[0]);
            }
            return (f && f.mime == 'directory' && f.write) ? 0 : -1;
        };


        this.exec = function (data) {
            var fm = this.fm,
                cwdHash = fm.cwd().hash,
                getTargets = function () {
                    var tgts = data && (data instanceof Array) ? data : null,
                        sel;
                    if (!data || data instanceof Array) {
                        if (!tgts && (sel = fm.selected()).length === 1 && fm.file(sel[0]).mime === 'directory') {
                            tgts = sel;
                        } else if (!tgts || tgts.length !== 1 || fm.file(tgts[0]).mime !== 'directory') {
                            tgts = [cwdHash];
                        }
                    }
                    return tgts;
                },
                targets = getTargets(),
                check = targets ? targets[0] : (data && data.target ? data.target : null),
                targetDir = check ? fm.file(check) : fm.cwd(),
                fmUpload = function (data) {
                    fm.upload(data)
                        .fail(function (error) {
                            dfrd.reject(error);
                        })
                        .done(function (data) {
                            var cwd = fm.getUI('cwd'),
                                node;
                            dfrd.resolve(data);
                            if (data && data.added && data.added[0] && !fm.ui.notify.children('.elfinder-notify-upload').length) {
                                var newItem = fm.findCwdNodes(data.added);
                                if (newItem.length) {
                                    newItem.trigger('scrolltoview');
                                } else {
                                    if (targetDir.hash !== cwdHash) {
                                        node = $('<div></div>').append(
                                            $('<button type="button" class="ui-button ui-widget ui-state-default ui-corner-all elfinder-tabstop"><span class="ui-button-text">' + fm.i18n('cmdopendir') + '</span></button>')
                                                .on('mouseenter mouseleave', function (e) {
                                                    $(this).toggleClass('ui-state-hover', e.type == 'mouseenter');
                                                }).on('click', function () {
                                                    fm.exec('open', check).done(function () {
                                                        fm.one('opendone', function () {
                                                            fm.trigger('selectfiles', { files: $.map(data.added, function (f) { return f.hash; }) });
                                                        });
                                                    });
                                                })
                                        );
                                    } else {
                                        fm.trigger('selectfiles', { files: $.map(data.added, function (f) { return f.hash; }) });
                                    }
                                    fm.toast({ msg: fm.i18n(['complete', fm.i18n('cmdupload')]), extNode: node });
                                }
                            }
                        })
                        .progress(function () {
                            dfrd.notifyWith(this, Array.from(arguments));
                        });
                },
                upload = function (data) {
                    dialog.elfinderdialog('close');
                    if (targets) {
                        data.target = targets[0];
                    }
                    fmUpload(data);
                },
                getSelector = function () {
                    var hash = targetDir.hash,
                        dirs = $.map(fm.files(hash), function (f) {
                            return (f.mime === 'directory' && f.write) ? f : null;
                        });

                    if (!dirs.length) {
                        return $();
                    }

                    return $('<div class="elfinder-upload-dirselect elfinder-tabstop" title="' + fm.i18n('folders') + '"></div>')
                        .on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            dirs = fm.sortFiles(dirs);
                            var $this = $(this),
                                cwd = fm.cwd(),
                                base = dialog.closest('div.ui-dialog'),
                                getRaw = function (f, icon) {
                                    return {
                                        label: fm.escape(f.i18 || f.name),
                                        icon: icon,
                                        remain: false,
                                        callback: function () {
                                            var title = base.children('.ui-dialog-titlebar:first').find('span.elfinder-upload-target');
                                            targets = [f.hash];
                                            title.html(' - ' + fm.escape(f.i18 || f.name));
                                            $this.trigger('focus');
                                        },
                                        options: {
                                            className: (targets && targets.length && f.hash === targets[0]) ? 'ui-state-active' : '',
                                            iconClass: f.csscls || '',
                                            iconImg: f.icon || ''
                                        }
                                    };
                                },
                                raw = [getRaw(targetDir, 'opendir'), '|'];
                            $.each(dirs, function (i, f) {
                                raw.push(getRaw(f, 'dir'));
                            });
                            $this.trigger('blur');
                            fm.trigger('contextmenu', {
                                raw: raw,
                                x: e.pageX || $(this).offset().left,
                                y: e.pageY || $(this).offset().top,
                                prevNode: base,
                                fitHeight: true
                            });
                        }).append('<span class="elfinder-button-icon elfinder-button-icon-dir" ></span>');
                },
                inputButton = function (type, caption) {
                    var button,
                        input = $('<input type="file" ' + type + '/>')
                            .on('click', function () {
                                // for IE's bug
                                if (fm.UA.IE) {
                                    setTimeout(function () {
                                        form.css('display', 'none').css('position', 'relative');
                                        requestAnimationFrame(function () {
                                            form.css('display', '').css('position', '');
                                        });
                                    }, 100);
                                }
                            })
                            .on('change', function () {
                                upload({ input: input.get(0), type: 'files' });
                            })
                            .on('dragover', function (e) {
                                e.originalEvent.dataTransfer.dropEffect = 'copy';
                            }),
                        form = $('<form></form>').append(input).on('click', function (e) {
                            e.stopPropagation();
                        });

                    return $('<div class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only elfinder-tabstop elfinder-focus"><span class="ui-button-text">' + fm.i18n(caption) + '</span></div>')
                        .append(form)
                        .on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            input.trigger('click');
                        })
                        .on('mouseenter mouseleave', function (e) {
                            $(this).toggleClass(hover, e.type === 'mouseenter');
                        });
                },
                dfrd = $.Deferred(),
                dialog, dropbox, pastebox, dropUpload, paste, dirs, spinner, uidialog;

            dropUpload = function (e) {
                e.stopPropagation();
                e.preventDefault();
                var file = false,
                    type = '',
                    elfFrom = null,
                    mycwd = '',
                    data = null,
                    target = e._target || null,
                    trf = e.dataTransfer || null,
                    kind = '',
                    idx, errors;

                if (trf) {
                    if (trf.types && trf.types.length) {
                        if ((idx = $.inArray('application/x-moz-file', trf.types)) !== -1) {
                            kind = 'file';
                        } else if ((idx = $.inArray('Files', trf.types)) !== -1) {
                            kind = 'file';
                        }
                    }
                    else if (trf.items && trf.items.length && trf.items[0].kind) {
                        kind = trf.items[0].kind;
                    }

                    try {
                        elfFrom = trf.getData('elfinderfrom');
                        if (elfFrom) {
                            mycwd = window.location.href + fm.cwd().hash;
                            if ((!target && elfFrom === mycwd) || target === mycwd) {
                                dfrd.reject();
                                return;
                            }
                        }
                    } catch (e) { }

                    if (kind === 'file' && (trf.items[idx].getAsEntry || trf.items[idx].webkitGetAsEntry || trf.items[idx].getAsFile)) {
                        file = trf;
                        type = 'data';
                    } else if (kind !== 'string' && trf.files && trf.files.length && $.inArray('Text', trf.types) === -1) {
                        file = trf.files;
                        type = 'files';
                    } else {
                        try {
                            if ((data = trf.getData('text/html')) && data.match(/<(?:img|a)/i)) {
                                file = [data];
                                type = 'html';
                            }
                        } catch (e) { }
                        if (!file) {
                            if (data = trf.getData('text')) {
                                file = [data];
                                type = 'text';
                            } else if (trf && trf.files) {
                                // maybe folder uploading but this UA dose not support it
                                kind = 'file';
                            }
                        }
                    }
                }
                if (file) {
                    fmUpload({ files: file, type: type, target: target, dropEvt: e });
                } else {
                    errors = ['errUploadNoFiles'];
                    if (kind === 'file') {
                        errors.push('errFolderUpload');
                    }
                    fm.error(errors);
                    dfrd.reject();
                }
            };

            if (!targets && data) {
                if (data.input || data.files) {
                    data.type = 'files';
                    fmUpload(data);
                } else if (data.dropEvt) {
                    dropUpload(data.dropEvt);
                }
                return dfrd;
            }

            paste = function (ev) {
                var e = ev.originalEvent || ev;
                var files = [], items = [];
                var file;
                if (e.clipboardData) {
                    if (e.clipboardData.items && e.clipboardData.items.length) {
                        items = e.clipboardData.items;
                        for (var i = 0; i < items.length; i++) {
                            if (e.clipboardData.items[i].kind == 'file') {
                                file = e.clipboardData.items[i].getAsFile();
                                files.push(file);
                            }
                        }
                    } else if (e.clipboardData.files && e.clipboardData.files.length) {
                        files = e.clipboardData.files;
                    }
                    if (files.length) {
                        upload({ files: files, type: 'files', clipdata: true });
                        return;
                    }
                }
                var my = e.target || e.srcElement;
                requestAnimationFrame(function () {
                    var type = 'text',
                        src;
                    if (my.innerHTML) {
                        $(my).find('img').each(function (i, v) {
                            if (v.src.match(/^webkit-fake-url:\/\//)) {
                                // For Safari's bug.
                                // ref. https://bugs.webkit.org/show_bug.cgi?id=49141
                                //      https://dev.ckeditor.com/ticket/13029
                                $(v).remove();
                            }
                        });

                        if ($(my).find('a,img').length) {
                            type = 'html';
                        }
                        src = my.innerHTML;
                        my.innerHTML = '';
                        upload({ files: [src], type: type });
                    }
                });
            };

            dialog = $('<div class="elfinder-upload-dialog-wrapper"></div>')
                .append(inputButton('multiple', 'selectForUpload'));

            if (!fm.UA.Mobile && (function (input) {
                return (typeof input.webkitdirectory !== 'undefined' || typeof input.directory !== 'undefined');
            })(document.createElement('input'))) {
                dialog.append(inputButton('multiple webkitdirectory directory', 'selectFolder'));
            }

            if (targetDir.dirs) {

                if (targetDir.hash === cwdHash || fm.navHash2Elm(targetDir.hash).hasClass('elfinder-subtree-loaded')) {
                    getSelector().appendTo(dialog);
                } else {
                    spinner = $('<div class="elfinder-upload-dirselect" title="' + fm.i18n('nowLoading') + '"></div>')
                        .append('<span class="elfinder-button-icon elfinder-button-icon-spinner" ></span>')
                        .appendTo(dialog);
                    fm.request({ cmd: 'tree', target: targetDir.hash })
                        .done(function () {
                            fm.one('treedone', function () {
                                spinner.replaceWith(getSelector());
                                uidialog.elfinderdialog('tabstopsInit');
                            });
                        })
                        .fail(function () {
                            spinner.remove();
                        });
                }
            }

            if (fm.dragUpload) {
                dropbox = $('<div class="ui-corner-all elfinder-upload-dropbox elfinder-tabstop" contenteditable="true" data-ph="' + fm.i18n('dropPasteFiles') + '"></div>')
                    .on('paste', function (e) {
                        paste(e);
                    })
                    .on('mousedown click', function () {
                        $(this).trigger('focus');
                    })
                    .on('focus', function () {
                        this.innerHTML = '';
                    })
                    .on('mouseover', function () {
                        $(this).addClass(hover);
                    })
                    .on('mouseout', function () {
                        $(this).removeClass(hover);
                    })
                    .on('dragenter', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        $(this).addClass(hover);
                    })
                    .on('dragleave', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        $(this).removeClass(hover);
                    })
                    .on('dragover', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        e.originalEvent.dataTransfer.dropEffect = 'copy';
                        $(this).addClass(hover);
                    })
                    .on('drop', function (e) {
                        dialog.elfinderdialog('close');
                        targets && (e.originalEvent._target = targets[0]);
                        dropUpload(e.originalEvent);
                    })
                    .prependTo(dialog)
                    .after('<div class="elfinder-upload-dialog-or">' + fm.i18n('or') + '</div>')[0];

            } else {
                pastebox = $('<div class="ui-corner-all elfinder-upload-dropbox" contenteditable="true">' + fm.i18n('dropFilesBrowser') + '</div>')
                    .on('paste drop', function (e) {
                        paste(e);
                    })
                    .on('mousedown click', function () {
                        $(this).trigger('focus');
                    })
                    .on('focus', function () {
                        this.innerHTML = '';
                    })
                    .on('dragenter mouseover', function () {
                        $(this).addClass(hover);
                    })
                    .on('dragleave mouseout', function () {
                        $(this).removeClass(hover);
                    })
                    .prependTo(dialog)
                    .after('<div class="elfinder-upload-dialog-or">' + fm.i18n('or') + '</div>')[0];

            }

            uidialog = this.fmDialog(dialog, {
                title: this.title + '<span class="elfinder-upload-target">' + (targetDir ? ' - ' + fm.escape(targetDir.i18 || targetDir.name) : '') + '</span>',
                modal: true,
                resizable: false,
                destroyOnClose: true,
                propagationEvents: ['mousemove', 'mouseup', 'click'],
                close: function () {
                    var cm = fm.getUI('contextmenu');
                    if (cm.is(':visible')) {
                        cm.click();
                    }
                }
            });

            return dfrd;
        };

    };


    /*
     * File: /js/commands/view.js
     */

    /**
     * @class  elFinder command "view"
     * Change current directory view (icons/list)
     *
     * @author Dmitry (dio) Levashov
     **/
    elFinder.prototype.commands.view = function () {
        "use strict";
        var self = this,
            fm = this.fm,
            subMenuRaw;
        this.value = fm.viewType;
        this.alwaysEnabled = true;
        this.updateOnSelect = false;

        this.options = { ui: 'viewbutton' };

        this.getstate = function () {
            return 0;
        };

        this.extra = {
            icon: 'menu',
            node: $('<span></span>')
                .attr({ title: fm.i18n('viewtype') })
                .on('click touchstart', function (e) {
                    if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                        return;
                    }
                    var node = $(this);
                    e.stopPropagation();
                    e.preventDefault();
                    fm.trigger('contextmenu', {
                        raw: getSubMenuRaw(),
                        x: node.offset().left,
                        y: node.offset().top
                    });
                })
        };

        this.exec = function () {
            var self = this,
                value = this.value == 'list' ? 'icons' : 'list';

            fm.storage('view', value);
            return fm.lazy(function () {
                fm.viewchange();
                self.update(void (0), value);
                this.resolve();
            });
        };

        fm.bind('init', function () {
            subMenuRaw = (function () {
                var cwd = fm.getUI('cwd'),
                    raws = [],
                    sizeNames = fm.options.uiOptions.cwd.iconsView.sizeNames,
                    max = fm.options.uiOptions.cwd.iconsView.sizeMax,
                    i, size;
                for (i = 0; i <= max; i++) {
                    raws.push(
                        {
                            label: fm.i18n(sizeNames[i] || ('Size-' + i + ' icons')),
                            icon: 'view',
                            callback: (function (s) {
                                return function () {
                                    cwd.trigger('iconpref', { size: s });
                                    fm.storage('iconsize', s);
                                    if (self.value === 'list') {
                                        self.exec();
                                    }
                                };
                            })(i)
                        }
                    );
                }
                raws.push('|');
                raws.push(
                    {
                        label: fm.i18n('viewlist'),
                        icon: 'view-list',
                        callback: function () {
                            if (self.value !== 'list') {
                                self.exec();
                            }
                        }
                    }
                );
                return raws;
            })();
        }).bind('contextmenucreate', function () {
            self.extra = {
                icon: 'menu',
                node: $('<span></span>')
                    .attr({ title: fm.i18n('cmdview') })
                    .on('click touchstart', function (e) {
                        if (e.type === 'touchstart' && e.originalEvent.touches.length > 1) {
                            return;
                        }
                        var node = $(this),
                            raw = subMenuRaw.concat(),
                            idx, i;
                        if (self.value === 'list') {
                            idx = subMenuRaw.length - 1;
                        } else {
                            idx = parseInt(fm.storage('iconsize') || 0);
                        }
                        for (i = 0; i < subMenuRaw.length; i++) {
                            if (subMenuRaw[i] !== '|') {
                                subMenuRaw[i].options = (i === idx ? { 'className': 'ui-state-active' } : void (0))
                                    ;
                            }
                        }
                        e.stopPropagation();
                        e.preventDefault();
                        fm.trigger('contextmenu', {
                            raw: subMenuRaw,
                            x: node.offset().left,
                            y: node.offset().top
                        });
                    })
            };
        });

    };

    return elFinder;
}));